
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire536a"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire536a"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("cqI6A", function(module, exports) {

$parcel$export(module.exports, "Router", () => $90ca201d4100224c$export$55185c17a0fcbe46);
function $90ca201d4100224c$var$toArray(objectOrArray) {
    objectOrArray = objectOrArray || [];
    return Array.isArray(objectOrArray) ? objectOrArray : [
        objectOrArray
    ];
}
function $90ca201d4100224c$var$log(msg) {
    return `[Vaadin.Router] ${msg}`;
}
function $90ca201d4100224c$var$logValue(value) {
    if (typeof value !== 'object') return String(value);
    const stringType = Object.prototype.toString.call(value).match(/ (.*)\]$/)[1];
    if (stringType === 'Object' || stringType === 'Array') return `${stringType} ${JSON.stringify(value)}`;
    else return stringType;
}
const $90ca201d4100224c$var$MODULE = 'module';
const $90ca201d4100224c$var$NOMODULE = 'nomodule';
const $90ca201d4100224c$var$bundleKeys = [
    $90ca201d4100224c$var$MODULE,
    $90ca201d4100224c$var$NOMODULE
];
function $90ca201d4100224c$var$ensureBundle(src) {
    if (!src.match(/.+\.[m]?js$/)) throw new Error($90ca201d4100224c$var$log(`Unsupported type for bundle "${src}": .js or .mjs expected.`));
}
function $90ca201d4100224c$var$ensureRoute(route) {
    if (!route || !$90ca201d4100224c$var$isString(route.path)) throw new Error($90ca201d4100224c$var$log(`Expected route config to be an object with a "path" string property, or an array of such objects`));
    const bundle = route.bundle;
    const stringKeys = [
        'component',
        'redirect',
        'bundle'
    ];
    if (!$90ca201d4100224c$var$isFunction(route.action) && !Array.isArray(route.children) && !$90ca201d4100224c$var$isFunction(route.children) && !$90ca201d4100224c$var$isObject(bundle) && !stringKeys.some((key)=>$90ca201d4100224c$var$isString(route[key]))) throw new Error($90ca201d4100224c$var$log(`Expected route config "${route.path}" to include either "${stringKeys.join('", "')}" ` + `or "action" function but none found.`));
    if (bundle) {
        if ($90ca201d4100224c$var$isString(bundle)) $90ca201d4100224c$var$ensureBundle(bundle);
        else if (!$90ca201d4100224c$var$bundleKeys.some((key)=>key in bundle)) throw new Error($90ca201d4100224c$var$log('Expected route bundle to include either "' + $90ca201d4100224c$var$NOMODULE + '" or "' + $90ca201d4100224c$var$MODULE + '" keys, or both'));
        else $90ca201d4100224c$var$bundleKeys.forEach((key)=>key in bundle && $90ca201d4100224c$var$ensureBundle(bundle[key]));
    }
    if (route.redirect) [
        'bundle',
        'component'
    ].forEach((overriddenProp)=>{
        if (overriddenProp in route) console.warn($90ca201d4100224c$var$log(`Route config "${route.path}" has both "redirect" and "${overriddenProp}" properties, ` + `and "redirect" will always override the latter. Did you mean to only use "${overriddenProp}"?`));
    });
}
function $90ca201d4100224c$var$ensureRoutes(routes) {
    $90ca201d4100224c$var$toArray(routes).forEach((route)=>$90ca201d4100224c$var$ensureRoute(route));
}
function $90ca201d4100224c$var$loadScript(src, key) {
    let script = document.head.querySelector('script[src="' + src + '"][async]');
    if (!script) {
        script = document.createElement('script');
        script.setAttribute('src', src);
        if (key === $90ca201d4100224c$var$MODULE) script.setAttribute('type', $90ca201d4100224c$var$MODULE);
        else if (key === $90ca201d4100224c$var$NOMODULE) script.setAttribute($90ca201d4100224c$var$NOMODULE, '');
        script.async = true;
    }
    return new Promise((resolve, reject)=>{
        script.onreadystatechange = script.onload = (e)=>{
            script.__dynamicImportLoaded = true;
            resolve(e);
        };
        script.onerror = (e)=>{
            if (script.parentNode) script.parentNode.removeChild(script);
            reject(e);
        };
        if (script.parentNode === null) document.head.appendChild(script);
        else if (script.__dynamicImportLoaded) resolve();
    });
}
function $90ca201d4100224c$var$loadBundle(bundle) {
    if ($90ca201d4100224c$var$isString(bundle)) return $90ca201d4100224c$var$loadScript(bundle);
    else return Promise.race($90ca201d4100224c$var$bundleKeys.filter((key)=>key in bundle).map((key)=>$90ca201d4100224c$var$loadScript(bundle[key], key)));
}
function $90ca201d4100224c$var$fireRouterEvent(type, detail) {
    return !window.dispatchEvent(new CustomEvent(`vaadin-router-${type}`, {
        cancelable: type === 'go',
        detail: detail
    }));
}
function $90ca201d4100224c$var$isObject(o) {
    // guard against null passing the typeof check
    return typeof o === 'object' && !!o;
}
function $90ca201d4100224c$var$isFunction(f) {
    return typeof f === 'function';
}
function $90ca201d4100224c$var$isString(s) {
    return typeof s === 'string';
}
function $90ca201d4100224c$var$getNotFoundError(context) {
    const error = new Error($90ca201d4100224c$var$log(`Page not found (${context.pathname})`));
    error.context = context;
    error.code = 404;
    return error;
}
const $90ca201d4100224c$var$notFoundResult = new class NotFoundResult {
}();
/* istanbul ignore next: coverage is calculated in Chrome, this code is for IE */ function $90ca201d4100224c$var$getAnchorOrigin(anchor) {
    // IE11: on HTTP and HTTPS the default port is not included into
    // window.location.origin, so won't include it here either.
    const port = anchor.port;
    const protocol = anchor.protocol;
    const defaultHttp = protocol === 'http:' && port === '80';
    const defaultHttps = protocol === 'https:' && port === '443';
    const host = defaultHttp || defaultHttps ? anchor.hostname // does not include the port number (e.g. www.example.org)
     : anchor.host; // does include the port number (e.g. www.example.org:80)
    return `${protocol}//${host}`;
}
// The list of checks is not complete:
//  - SVG support is missing
//  - the 'rel' attribute is not considered
function $90ca201d4100224c$var$vaadinRouterGlobalClickHandler(event) {
    // ignore the click if the default action is prevented
    if (event.defaultPrevented) return;
    // ignore the click if not with the primary mouse button
    if (event.button !== 0) return;
    // ignore the click if a modifier key is pressed
    if (event.shiftKey || event.ctrlKey || event.altKey || event.metaKey) return;
    // find the <a> element that the click is at (or within)
    let anchor = event.target;
    const path = event.composedPath ? event.composedPath() : event.path || [];
    // FIXME(web-padawan): `Symbol.iterator` used by webcomponentsjs is broken for arrays
    // example to check: `for...of` loop here throws the "Not yet implemented" error
    for(let i = 0; i < path.length; i++){
        const target = path[i];
        if (target.nodeName && target.nodeName.toLowerCase() === 'a') {
            anchor = target;
            break;
        }
    }
    while(anchor && anchor.nodeName.toLowerCase() !== 'a')anchor = anchor.parentNode;
    // ignore the click if not at an <a> element
    if (!anchor || anchor.nodeName.toLowerCase() !== 'a') return;
    // ignore the click if the <a> element has a non-default target
    if (anchor.target && anchor.target.toLowerCase() !== '_self') return;
    // ignore the click if the <a> element has the 'download' attribute
    if (anchor.hasAttribute('download')) return;
    // ignore the click if the <a> element has the 'router-ignore' attribute
    if (anchor.hasAttribute('router-ignore')) return;
    // ignore the click if the target URL is a fragment on the current page
    if (anchor.pathname === window.location.pathname && anchor.hash !== '') return;
    // ignore the click if the target is external to the app
    // In IE11 HTMLAnchorElement does not have the `origin` property
    const origin = anchor.origin || $90ca201d4100224c$var$getAnchorOrigin(anchor);
    if (origin !== window.location.origin) return;
    // if none of the above, convert the click into a navigation event
    const { pathname: pathname, search: search, hash: hash } = anchor;
    if ($90ca201d4100224c$var$fireRouterEvent('go', {
        pathname: pathname,
        search: search,
        hash: hash
    })) {
        event.preventDefault();
        // for a click event, the scroll is reset to the top position.
        if (event && event.type === 'click') window.scrollTo(0, 0);
    }
}
/**
 * A navigation trigger for Vaadin Router that translated clicks on `<a>` links
 * into Vaadin Router navigation events.
 *
 * Only regular clicks on in-app links are translated (primary mouse button, no
 * modifier keys, the target href is within the app's URL space).
 *
 * @memberOf Router.NavigationTrigger
 * @type {NavigationTrigger}
 */ const $90ca201d4100224c$var$CLICK = {
    activate () {
        window.document.addEventListener('click', $90ca201d4100224c$var$vaadinRouterGlobalClickHandler);
    },
    inactivate () {
        window.document.removeEventListener('click', $90ca201d4100224c$var$vaadinRouterGlobalClickHandler);
    }
};
// PopStateEvent constructor shim
const $90ca201d4100224c$var$isIE = /Trident/.test(navigator.userAgent);
/* istanbul ignore next: coverage is calculated in Chrome, this code is for IE */ if ($90ca201d4100224c$var$isIE && !$90ca201d4100224c$var$isFunction(window.PopStateEvent)) {
    window.PopStateEvent = function(inType, params) {
        params = params || {};
        var e = document.createEvent('Event');
        e.initEvent(inType, Boolean(params.bubbles), Boolean(params.cancelable));
        e.state = params.state || null;
        return e;
    };
    window.PopStateEvent.prototype = window.Event.prototype;
}
function $90ca201d4100224c$var$vaadinRouterGlobalPopstateHandler(event) {
    if (event.state === 'vaadin-router-ignore') return;
    const { pathname: pathname, search: search, hash: hash } = window.location;
    $90ca201d4100224c$var$fireRouterEvent('go', {
        pathname: pathname,
        search: search,
        hash: hash
    });
}
/**
 * A navigation trigger for Vaadin Router that translates popstate events into
 * Vaadin Router navigation events.
 *
 * @memberOf Router.NavigationTrigger
 * @type {NavigationTrigger}
 */ const $90ca201d4100224c$var$POPSTATE = {
    activate () {
        window.addEventListener('popstate', $90ca201d4100224c$var$vaadinRouterGlobalPopstateHandler);
    },
    inactivate () {
        window.removeEventListener('popstate', $90ca201d4100224c$var$vaadinRouterGlobalPopstateHandler);
    }
};
/**
 * Expose `pathToRegexp`.
 */ var $90ca201d4100224c$var$pathToRegexp_1 = $90ca201d4100224c$var$pathToRegexp$1;
var $90ca201d4100224c$var$parse_1 = $90ca201d4100224c$var$parse;
var $90ca201d4100224c$var$compile_1 = $90ca201d4100224c$var$compile;
var $90ca201d4100224c$var$tokensToFunction_1 = $90ca201d4100224c$var$tokensToFunction;
var $90ca201d4100224c$var$tokensToRegExp_1 = $90ca201d4100224c$var$tokensToRegExp;
/**
 * Default configs.
 */ var $90ca201d4100224c$var$DEFAULT_DELIMITER = '/';
var $90ca201d4100224c$var$DEFAULT_DELIMITERS = './';
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var $90ca201d4100224c$var$PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    '(\\\\.)',
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // ":test(\\d+)?" => ["test", "\d+", undefined, "?"]
    // "(\\d+)"  => [undefined, undefined, "\d+", undefined]
    '(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?'
].join('|'), 'g');
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function $90ca201d4100224c$var$parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = '';
    var defaultDelimiter = options && options.delimiter || $90ca201d4100224c$var$DEFAULT_DELIMITER;
    var delimiters = options && options.delimiters || $90ca201d4100224c$var$DEFAULT_DELIMITERS;
    var pathEscaped = false;
    var res;
    while((res = $90ca201d4100224c$var$PATH_REGEXP.exec(str)) !== null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            pathEscaped = true;
            continue;
        }
        var prev = '';
        var next = str[index];
        var name = res[2];
        var capture = res[3];
        var group = res[4];
        var modifier = res[5];
        if (!pathEscaped && path.length) {
            var k = path.length - 1;
            if (delimiters.indexOf(path[k]) > -1) {
                prev = path[k];
                path = path.slice(0, k);
            }
        }
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = '';
            pathEscaped = false;
        }
        var partial = prev !== '' && next !== undefined && next !== prev;
        var repeat = modifier === '+' || modifier === '*';
        var optional = modifier === '?' || modifier === '*';
        var delimiter = prev || defaultDelimiter;
        var pattern = capture || group;
        tokens.push({
            name: name || key++,
            prefix: prev,
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            pattern: pattern ? $90ca201d4100224c$var$escapeGroup(pattern) : '[^' + $90ca201d4100224c$var$escapeString(delimiter) + ']+?'
        });
    }
    // Push any remaining characters.
    if (path || index < str.length) tokens.push(path + str.substr(index));
    return tokens;
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function $90ca201d4100224c$var$compile(str, options) {
    return $90ca201d4100224c$var$tokensToFunction($90ca201d4100224c$var$parse(str, options));
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function $90ca201d4100224c$var$tokensToFunction(tokens) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === 'object') matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    return function(data, options) {
        var path = '';
        var encode = options && options.encode || encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === 'string') {
                path += token;
                continue;
            }
            var value = data ? data[token.name] : undefined;
            var segment;
            if (Array.isArray(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but got array');
                if (value.length === 0) {
                    if (token.optional) continue;
                    throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j], token);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '"');
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
                segment = encode(String(value), token);
                if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but got "' + segment + '"');
                path += token.prefix + segment;
                continue;
            }
            if (token.optional) {
                // Prepend partial segment prefixes.
                if (token.partial) path += token.prefix;
                continue;
            }
            throw new TypeError('Expected "' + token.name + '" to be ' + (token.repeat ? 'an array' : 'a string'));
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function $90ca201d4100224c$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|/\\])/g, '\\$1');
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function $90ca201d4100224c$var$escapeGroup(group) {
    return group.replace(/([=!:$/()])/g, '\\$1');
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function $90ca201d4100224c$var$flags(options) {
    return options && options.sensitive ? '' : 'i';
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {Array=}  keys
 * @return {!RegExp}
 */ function $90ca201d4100224c$var$regexpToRegexp(path, keys) {
    if (!keys) return path;
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        pattern: null
    });
    return path;
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array=}  keys
 * @param  {Object=} options
 * @return {!RegExp}
 */ function $90ca201d4100224c$var$arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push($90ca201d4100224c$var$pathToRegexp$1(path[i], keys, options).source);
    return new RegExp('(?:' + parts.join('|') + ')', $90ca201d4100224c$var$flags(options));
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {Array=}  keys
 * @param  {Object=} options
 * @return {!RegExp}
 */ function $90ca201d4100224c$var$stringToRegexp(path, keys, options) {
    return $90ca201d4100224c$var$tokensToRegExp($90ca201d4100224c$var$parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}  tokens
 * @param  {Array=}  keys
 * @param  {Object=} options
 * @return {!RegExp}
 */ function $90ca201d4100224c$var$tokensToRegExp(tokens, keys, options) {
    options = options || {};
    var strict = options.strict;
    var start = options.start !== false;
    var end = options.end !== false;
    var delimiter = $90ca201d4100224c$var$escapeString(options.delimiter || $90ca201d4100224c$var$DEFAULT_DELIMITER);
    var delimiters = options.delimiters || $90ca201d4100224c$var$DEFAULT_DELIMITERS;
    var endsWith = [].concat(options.endsWith || []).map($90ca201d4100224c$var$escapeString).concat('$').join('|');
    var route = start ? '^' : '';
    var isEndDelimited = tokens.length === 0;
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === 'string') {
            route += $90ca201d4100224c$var$escapeString(token);
            isEndDelimited = i === tokens.length - 1 && delimiters.indexOf(token[token.length - 1]) > -1;
        } else {
            var capture = token.repeat ? '(?:' + token.pattern + ')(?:' + $90ca201d4100224c$var$escapeString(token.delimiter) + '(?:' + token.pattern + '))*' : token.pattern;
            if (keys) keys.push(token);
            if (token.optional) {
                if (token.partial) route += $90ca201d4100224c$var$escapeString(token.prefix) + '(' + capture + ')?';
                else route += '(?:' + $90ca201d4100224c$var$escapeString(token.prefix) + '(' + capture + '))?';
            } else route += $90ca201d4100224c$var$escapeString(token.prefix) + '(' + capture + ')';
        }
    }
    if (end) {
        if (!strict) route += '(?:' + delimiter + ')?';
        route += endsWith === '$' ? '$' : '(?=' + endsWith + ')';
    } else {
        if (!strict) route += '(?:' + delimiter + '(?=' + endsWith + '))?';
        if (!isEndDelimited) route += '(?=' + delimiter + '|' + endsWith + ')';
    }
    return new RegExp(route, $90ca201d4100224c$var$flags(options));
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {Array=}                keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function $90ca201d4100224c$var$pathToRegexp$1(path, keys, options) {
    if (path instanceof RegExp) return $90ca201d4100224c$var$regexpToRegexp(path, keys);
    if (Array.isArray(path)) return $90ca201d4100224c$var$arrayToRegexp(/** @type {!Array} */ path, keys, options);
    return $90ca201d4100224c$var$stringToRegexp(/** @type {string} */ path, keys, options);
}
$90ca201d4100224c$var$pathToRegexp_1.parse = $90ca201d4100224c$var$parse_1;
$90ca201d4100224c$var$pathToRegexp_1.compile = $90ca201d4100224c$var$compile_1;
$90ca201d4100224c$var$pathToRegexp_1.tokensToFunction = $90ca201d4100224c$var$tokensToFunction_1;
$90ca201d4100224c$var$pathToRegexp_1.tokensToRegExp = $90ca201d4100224c$var$tokensToRegExp_1;
/**
 * Universal Router (https://www.kriasoft.com/universal-router/)
 *
 * Copyright (c) 2015-present Kriasoft.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */ const { hasOwnProperty: $90ca201d4100224c$var$hasOwnProperty } = Object.prototype;
const $90ca201d4100224c$var$cache$1 = new Map();
// see https://github.com/pillarjs/path-to-regexp/issues/148
$90ca201d4100224c$var$cache$1.set('|false', {
    keys: [],
    pattern: /(?:)/
});
function $90ca201d4100224c$var$decodeParam(val) {
    try {
        return decodeURIComponent(val);
    } catch (err) {
        return val;
    }
}
function $90ca201d4100224c$var$matchPath(routepath, path, exact, parentKeys, parentParams) {
    exact = !!exact;
    const cacheKey = `${routepath}|${exact}`;
    let regexp = $90ca201d4100224c$var$cache$1.get(cacheKey);
    if (!regexp) {
        const keys = [];
        regexp = {
            keys: keys,
            pattern: $90ca201d4100224c$var$pathToRegexp_1(routepath, keys, {
                end: exact,
                strict: routepath === ''
            })
        };
        $90ca201d4100224c$var$cache$1.set(cacheKey, regexp);
    }
    const m = regexp.pattern.exec(path);
    if (!m) return null;
    const params = Object.assign({}, parentParams);
    for(let i = 1; i < m.length; i++){
        const key = regexp.keys[i - 1];
        const prop = key.name;
        const value = m[i];
        if (value !== undefined || !$90ca201d4100224c$var$hasOwnProperty.call(params, prop)) {
            if (key.repeat) params[prop] = value ? value.split(key.delimiter).map($90ca201d4100224c$var$decodeParam) : [];
            else params[prop] = value ? $90ca201d4100224c$var$decodeParam(value) : value;
        }
    }
    return {
        path: m[0],
        keys: (parentKeys || []).concat(regexp.keys),
        params: params
    };
}
/**
 * Universal Router (https://www.kriasoft.com/universal-router/)
 *
 * Copyright (c) 2015-present Kriasoft.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */ /**
 * Traverses the routes tree and matches its nodes to the given pathname from
 * the root down to the leaves. Each match consumes a part of the pathname and
 * the matching process continues for as long as there is a matching child
 * route for the remaining part of the pathname.
 *
 * The returned value is a lazily evaluated iterator.
 *
 * The leading "/" in a route path matters only for the root of the routes
 * tree (or if all parent routes are ""). In all other cases a leading "/" in
 * a child route path has no significance.
 *
 * The trailing "/" in a _route path_ matters only for the leaves of the
 * routes tree. A leaf route with a trailing "/" matches only a pathname that
 * also has a trailing "/".
 *
 * The trailing "/" in a route path does not affect matching of child routes
 * in any way.
 *
 * The trailing "/" in a _pathname_ generally does not matter (except for
 * the case of leaf nodes described above).
 *
 * The "" and "/" routes have special treatment:
 *  1. as a single route
 *     the "" and "/" routes match only the "" and "/" pathnames respectively
 *  2. as a parent in the routes tree
 *     the "" route matches any pathname without consuming any part of it
 *     the "/" route matches any absolute pathname consuming its leading "/"
 *  3. as a leaf in the routes tree
 *     the "" and "/" routes match only if the entire pathname is consumed by
 *         the parent routes chain. In this case "" and "/" are equivalent.
 *  4. several directly nested "" or "/" routes
 *     - directly nested "" or "/" routes are 'squashed' (i.e. nesting two
 *       "/" routes does not require a double "/" in the pathname to match)
 *     - if there are only "" in the parent routes chain, no part of the
 *       pathname is consumed, and the leading "/" in the child routes' paths
 *       remains significant
 *
 * Side effect:
 *   - the routes tree { path: '' } matches only the '' pathname
 *   - the routes tree { path: '', children: [ { path: '' } ] } matches any
 *     pathname (for the tree root)
 *
 * Prefix matching can be enabled also by `children: true`.
 */ function $90ca201d4100224c$var$matchRoute(route, pathname, ignoreLeadingSlash, parentKeys, parentParams) {
    let match;
    let childMatches;
    let childIndex = 0;
    let routepath = route.path || '';
    if (routepath.charAt(0) === '/') {
        if (ignoreLeadingSlash) routepath = routepath.substr(1);
        ignoreLeadingSlash = true;
    }
    return {
        next (routeToSkip) {
            if (route === routeToSkip) return {
                done: true
            };
            const children = route.__children = route.__children || route.children;
            if (!match) {
                match = $90ca201d4100224c$var$matchPath(routepath, pathname, !children, parentKeys, parentParams);
                if (match) return {
                    done: false,
                    value: {
                        route: route,
                        keys: match.keys,
                        params: match.params,
                        path: match.path
                    }
                };
            }
            if (match && children) while(childIndex < children.length){
                if (!childMatches) {
                    const childRoute = children[childIndex];
                    childRoute.parent = route;
                    let matchedLength = match.path.length;
                    if (matchedLength > 0 && pathname.charAt(matchedLength) === '/') matchedLength += 1;
                    childMatches = $90ca201d4100224c$var$matchRoute(childRoute, pathname.substr(matchedLength), ignoreLeadingSlash, match.keys, match.params);
                }
                const childMatch = childMatches.next(routeToSkip);
                if (!childMatch.done) return {
                    done: false,
                    value: childMatch.value
                };
                childMatches = null;
                childIndex++;
            }
            return {
                done: true
            };
        }
    };
}
/**
 * Universal Router (https://www.kriasoft.com/universal-router/)
 *
 * Copyright (c) 2015-present Kriasoft.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */ function $90ca201d4100224c$var$resolveRoute(context) {
    if ($90ca201d4100224c$var$isFunction(context.route.action)) return context.route.action(context);
    return undefined;
}
/**
 * Universal Router (https://www.kriasoft.com/universal-router/)
 *
 * Copyright (c) 2015-present Kriasoft.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */ function $90ca201d4100224c$var$isChildRoute(parentRoute, childRoute) {
    let route = childRoute;
    while(route){
        route = route.parent;
        if (route === parentRoute) return true;
    }
    return false;
}
function $90ca201d4100224c$var$generateErrorMessage(currentContext) {
    let errorMessage = `Path '${currentContext.pathname}' is not properly resolved due to an error.`;
    const routePath = (currentContext.route || {}).path;
    if (routePath) errorMessage += ` Resolution had failed on route: '${routePath}'`;
    return errorMessage;
}
function $90ca201d4100224c$var$updateChainForRoute(context, match) {
    const { route: route, path: path } = match;
    if (route && !route.__synthetic) {
        const item = {
            path: path,
            route: route
        };
        if (!context.chain) context.chain = [];
        else // Discard old items
        if (route.parent) {
            let i = context.chain.length;
            while(i-- && context.chain[i].route && context.chain[i].route !== route.parent)context.chain.pop();
        }
        context.chain.push(item);
    }
}
/**
 */ class $90ca201d4100224c$export$8b4c839865b08288 {
    constructor(routes, options = {}){
        if (Object(routes) !== routes) throw new TypeError('Invalid routes');
        this.baseUrl = options.baseUrl || '';
        this.errorHandler = options.errorHandler;
        this.resolveRoute = options.resolveRoute || $90ca201d4100224c$var$resolveRoute;
        this.context = Object.assign({
            resolver: this
        }, options.context);
        this.root = Array.isArray(routes) ? {
            path: '',
            __children: routes,
            parent: null,
            __synthetic: true
        } : routes;
        this.root.parent = null;
    }
    /**
   * Returns the current list of routes (as a shallow copy). Adding / removing
   * routes to / from the returned array does not affect the routing config,
   * but modifying the route objects does.
   *
   * @return {!Array<!Router.Route>}
   */ getRoutes() {
        return [
            ...this.root.__children
        ];
    }
    /**
   * Sets the routing config (replacing the existing one).
   *
   * @param {!Array<!Router.Route>|!Router.Route} routes a single route or an array of those
   *    (the array is shallow copied)
   */ setRoutes(routes) {
        $90ca201d4100224c$var$ensureRoutes(routes);
        const newRoutes = [
            ...$90ca201d4100224c$var$toArray(routes)
        ];
        this.root.__children = newRoutes;
    }
    /**
   * Appends one or several routes to the routing config and returns the
   * effective routing config after the operation.
   *
   * @param {!Array<!Router.Route>|!Router.Route} routes a single route or an array of those
   *    (the array is shallow copied)
   * @return {!Array<!Router.Route>}
   * @protected
   */ addRoutes(routes) {
        $90ca201d4100224c$var$ensureRoutes(routes);
        this.root.__children.push(...$90ca201d4100224c$var$toArray(routes));
        return this.getRoutes();
    }
    /**
   * Removes all existing routes from the routing config.
   */ removeRoutes() {
        this.setRoutes([]);
    }
    /**
   * Asynchronously resolves the given pathname, i.e. finds all routes matching
   * the pathname and tries resolving them one after another in the order they
   * are listed in the routes config until the first non-null result.
   *
   * Returns a promise that is fulfilled with the return value of an object that consists of the first
   * route handler result that returns something other than `null` or `undefined` and context used to get this result.
   *
   * If no route handlers return a non-null result, or if no route matches the
   * given pathname the returned promise is rejected with a 'page not found'
   * `Error`.
   *
   * @param {!string|!{pathname: !string}} pathnameOrContext the pathname to
   *    resolve or a context object with a `pathname` property and other
   *    properties to pass to the route resolver functions.
   * @return {!Promise<any>}
   */ resolve(pathnameOrContext) {
        const context = Object.assign({}, this.context, $90ca201d4100224c$var$isString(pathnameOrContext) ? {
            pathname: pathnameOrContext
        } : pathnameOrContext);
        const match = $90ca201d4100224c$var$matchRoute(this.root, this.__normalizePathname(context.pathname), this.baseUrl);
        const resolve = this.resolveRoute;
        let matches = null;
        let nextMatches = null;
        let currentContext = context;
        function next(resume, parent = matches.value.route, prevResult) {
            const routeToSkip = prevResult === null && matches.value.route;
            matches = nextMatches || match.next(routeToSkip);
            nextMatches = null;
            if (!resume) {
                if (matches.done || !$90ca201d4100224c$var$isChildRoute(parent, matches.value.route)) {
                    nextMatches = matches;
                    return Promise.resolve($90ca201d4100224c$var$notFoundResult);
                }
            }
            if (matches.done) return Promise.reject($90ca201d4100224c$var$getNotFoundError(context));
            currentContext = Object.assign(currentContext ? {
                chain: currentContext.chain ? currentContext.chain.slice(0) : []
            } : {}, context, matches.value);
            $90ca201d4100224c$var$updateChainForRoute(currentContext, matches.value);
            return Promise.resolve(resolve(currentContext)).then((resolution)=>{
                if (resolution !== null && resolution !== undefined && resolution !== $90ca201d4100224c$var$notFoundResult) {
                    currentContext.result = resolution.result || resolution;
                    return currentContext;
                }
                return next(resume, parent, resolution);
            });
        }
        context.next = next;
        return Promise.resolve().then(()=>next(true, this.root)).catch((error)=>{
            const errorMessage = $90ca201d4100224c$var$generateErrorMessage(currentContext);
            if (!error) error = new Error(errorMessage);
            else console.warn(errorMessage);
            error.context = error.context || currentContext;
            // DOMException has its own code which is read-only
            if (!(error instanceof DOMException)) error.code = error.code || 500;
            if (this.errorHandler) {
                currentContext.result = this.errorHandler(error);
                return currentContext;
            }
            throw error;
        });
    }
    /**
   * URL constructor polyfill hook. Creates and returns an URL instance.
   */ static __createUrl(url, base) {
        return new URL(url, base);
    }
    /**
   * If the baseUrl property is set, transforms the baseUrl and returns the full
   * actual `base` string for using in the `new URL(path, base);` and for
   * prepernding the paths with. The returned base ends with a trailing slash.
   *
   * Otherwise, returns empty string.
   */ get __effectiveBaseUrl() {
        return this.baseUrl ? this.constructor.__createUrl(this.baseUrl, document.baseURI || document.URL).href.replace(/[^\/]*$/, '') : '';
    }
    /**
   * If the baseUrl is set, matches the pathname with the router’s baseUrl,
   * and returns the local pathname with the baseUrl stripped out.
   *
   * If the pathname does not match the baseUrl, returns undefined.
   *
   * If the `baseUrl` is not set, returns the unmodified pathname argument.
   */ __normalizePathname(pathname) {
        if (!this.baseUrl) // No base URL, no need to transform the pathname.
        return pathname;
        const base = this.__effectiveBaseUrl;
        const normalizedUrl = this.constructor.__createUrl(pathname, base).href;
        if (normalizedUrl.slice(0, base.length) === base) return normalizedUrl.slice(base.length);
    }
}
$90ca201d4100224c$export$8b4c839865b08288.pathToRegexp = $90ca201d4100224c$var$pathToRegexp_1;
/**
 * Universal Router (https://www.kriasoft.com/universal-router/)
 *
 * Copyright (c) 2015-present Kriasoft.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */ const { pathToRegexp: $90ca201d4100224c$var$pathToRegexp } = $90ca201d4100224c$export$8b4c839865b08288;
const $90ca201d4100224c$var$cache = new Map();
function $90ca201d4100224c$var$cacheRoutes(routesByName, route, routes) {
    const name = route.name || route.component;
    if (name) {
        if (routesByName.has(name)) routesByName.get(name).push(route);
        else routesByName.set(name, [
            route
        ]);
    }
    if (Array.isArray(routes)) for(let i = 0; i < routes.length; i++){
        const childRoute = routes[i];
        childRoute.parent = route;
        $90ca201d4100224c$var$cacheRoutes(routesByName, childRoute, childRoute.__children || childRoute.children);
    }
}
function $90ca201d4100224c$var$getRouteByName(routesByName, routeName) {
    const routes = routesByName.get(routeName);
    if (routes && routes.length > 1) throw new Error(`Duplicate route with name "${routeName}".` + ` Try seting unique 'name' route properties.`);
    return routes && routes[0];
}
function $90ca201d4100224c$var$getRoutePath(route) {
    let path = route.path;
    path = Array.isArray(path) ? path[0] : path;
    return path !== undefined ? path : '';
}
function $90ca201d4100224c$var$generateUrls(router, options = {}) {
    if (!(router instanceof $90ca201d4100224c$export$8b4c839865b08288)) throw new TypeError('An instance of Resolver is expected');
    const routesByName = new Map();
    return (routeName, params)=>{
        let route = $90ca201d4100224c$var$getRouteByName(routesByName, routeName);
        if (!route) {
            routesByName.clear(); // clear cache
            $90ca201d4100224c$var$cacheRoutes(routesByName, router.root, router.root.__children);
            route = $90ca201d4100224c$var$getRouteByName(routesByName, routeName);
            if (!route) throw new Error(`Route "${routeName}" not found`);
        }
        let regexp = $90ca201d4100224c$var$cache.get(route.fullPath);
        if (!regexp) {
            let fullPath = $90ca201d4100224c$var$getRoutePath(route);
            let rt = route.parent;
            while(rt){
                const path = $90ca201d4100224c$var$getRoutePath(rt);
                if (path) fullPath = path.replace(/\/$/, '') + '/' + fullPath.replace(/^\//, '');
                rt = rt.parent;
            }
            const tokens = $90ca201d4100224c$var$pathToRegexp.parse(fullPath);
            const toPath = $90ca201d4100224c$var$pathToRegexp.tokensToFunction(tokens);
            const keys = Object.create(null);
            for(let i = 0; i < tokens.length; i++)if (!$90ca201d4100224c$var$isString(tokens[i])) keys[tokens[i].name] = true;
            regexp = {
                toPath: toPath,
                keys: keys
            };
            $90ca201d4100224c$var$cache.set(fullPath, regexp);
            route.fullPath = fullPath;
        }
        let url = regexp.toPath(params, options) || '/';
        if (options.stringifyQueryParams && params) {
            const queryParams = {};
            const keys = Object.keys(params);
            for(let i = 0; i < keys.length; i++){
                const key = keys[i];
                if (!regexp.keys[key]) queryParams[key] = params[key];
            }
            const query = options.stringifyQueryParams(queryParams);
            if (query) url += query.charAt(0) === '?' ? query : `?${query}`;
        }
        return url;
    };
}
/**
 * @typedef NavigationTrigger
 * @type {object}
 * @property {function()} activate
 * @property {function()} inactivate
 */ /** @type {Array<NavigationTrigger>} */ let $90ca201d4100224c$var$triggers = [];
function $90ca201d4100224c$var$setNavigationTriggers(newTriggers) {
    $90ca201d4100224c$var$triggers.forEach((trigger)=>trigger.inactivate());
    newTriggers.forEach((trigger)=>trigger.activate());
    $90ca201d4100224c$var$triggers = newTriggers;
}
const $90ca201d4100224c$var$willAnimate = (elem)=>{
    const name = getComputedStyle(elem).getPropertyValue('animation-name');
    return name && name !== 'none';
};
const $90ca201d4100224c$var$waitForAnimation = (elem, cb)=>{
    const listener = ()=>{
        elem.removeEventListener('animationend', listener);
        cb();
    };
    elem.addEventListener('animationend', listener);
};
function $90ca201d4100224c$var$animate(elem, className) {
    elem.classList.add(className);
    return new Promise((resolve)=>{
        if ($90ca201d4100224c$var$willAnimate(elem)) {
            const rect = elem.getBoundingClientRect();
            const size = `height: ${rect.bottom - rect.top}px; width: ${rect.right - rect.left}px`;
            elem.setAttribute('style', `position: absolute; ${size}`);
            $90ca201d4100224c$var$waitForAnimation(elem, ()=>{
                elem.classList.remove(className);
                elem.removeAttribute('style');
                resolve();
            });
        } else {
            elem.classList.remove(className);
            resolve();
        }
    });
}
const $90ca201d4100224c$var$MAX_REDIRECT_COUNT = 256;
function $90ca201d4100224c$var$isResultNotEmpty(result) {
    return result !== null && result !== undefined;
}
function $90ca201d4100224c$var$copyContextWithoutNext(context) {
    const copy = Object.assign({}, context);
    delete copy.next;
    return copy;
}
function $90ca201d4100224c$var$createLocation({ pathname: pathname = '', search: search = '', hash: hash = '', chain: chain = [], params: params = {}, redirectFrom: redirectFrom, resolver: resolver }, route) {
    const routes = chain.map((item)=>item.route);
    return {
        baseUrl: resolver && resolver.baseUrl || '',
        pathname: pathname,
        search: search,
        hash: hash,
        routes: routes,
        route: route || routes.length && routes[routes.length - 1] || null,
        params: params,
        redirectFrom: redirectFrom,
        getUrl: (userParams = {})=>$90ca201d4100224c$var$getPathnameForRouter($90ca201d4100224c$export$55185c17a0fcbe46.pathToRegexp.compile($90ca201d4100224c$var$getMatchedPath(routes))(Object.assign({}, params, userParams)), resolver)
    };
}
function $90ca201d4100224c$var$createRedirect(context, pathname) {
    const params = Object.assign({}, context.params);
    return {
        redirect: {
            pathname: pathname,
            from: context.pathname,
            params: params
        }
    };
}
function $90ca201d4100224c$var$renderElement(context, element) {
    element.location = $90ca201d4100224c$var$createLocation(context);
    const index = context.chain.map((item)=>item.route).indexOf(context.route);
    context.chain[index].element = element;
    return element;
}
function $90ca201d4100224c$var$runCallbackIfPossible(callback, args, thisArg) {
    if ($90ca201d4100224c$var$isFunction(callback)) return callback.apply(thisArg, args);
}
function $90ca201d4100224c$var$amend(amendmentFunction, args, element) {
    return (amendmentResult)=>{
        if (amendmentResult && (amendmentResult.cancel || amendmentResult.redirect)) return amendmentResult;
        if (element) return $90ca201d4100224c$var$runCallbackIfPossible(element[amendmentFunction], args, element);
    };
}
function $90ca201d4100224c$var$processNewChildren(newChildren, route) {
    if (!Array.isArray(newChildren) && !$90ca201d4100224c$var$isObject(newChildren)) throw new Error($90ca201d4100224c$var$log(`Incorrect "children" value for the route ${route.path}: expected array or object, but got ${newChildren}`));
    route.__children = [];
    const childRoutes = $90ca201d4100224c$var$toArray(newChildren);
    for(let i = 0; i < childRoutes.length; i++){
        $90ca201d4100224c$var$ensureRoute(childRoutes[i]);
        route.__children.push(childRoutes[i]);
    }
}
function $90ca201d4100224c$var$removeDomNodes(nodes) {
    if (nodes && nodes.length) {
        const parent = nodes[0].parentNode;
        for(let i = 0; i < nodes.length; i++)parent.removeChild(nodes[i]);
    }
}
function $90ca201d4100224c$var$getPathnameForRouter(pathname, router) {
    const base = router.__effectiveBaseUrl;
    return base ? router.constructor.__createUrl(pathname.replace(/^\//, ''), base).pathname : pathname;
}
function $90ca201d4100224c$var$getMatchedPath(chain) {
    return chain.map((item)=>item.path).reduce((a, b)=>{
        if (b.length) return a.replace(/\/$/, '') + '/' + b.replace(/^\//, '');
        return a;
    }, '');
}
/**
 * A simple client-side router for single-page applications. It uses
 * express-style middleware and has a first-class support for Web Components and
 * lazy-loading. Works great in Polymer and non-Polymer apps.
 *
 * Use `new Router(outlet, options)` to create a new Router instance.
 *
 * * The `outlet` parameter is a reference to the DOM node to render
 *   the content into.
 *
 * * The `options` parameter is an optional object with options. The following
 *   keys are supported:
 *   * `baseUrl` — the initial value for [
 *     the `baseUrl` property
 *   ](#/classes/Router#property-baseUrl)
 *
 * The Router instance is automatically subscribed to navigation events
 * on `window`.
 *
 * See [Live Examples](#/classes/Router/demos/demo/index.html) for the detailed usage demo and code snippets.
 *
 * See also detailed API docs for the following methods, for the advanced usage:
 *
 * * [setOutlet](#/classes/Router#method-setOutlet) – should be used to configure the outlet.
 * * [setTriggers](#/classes/Router#method-setTriggers) – should be used to configure the navigation events.
 * * [setRoutes](#/classes/Router#method-setRoutes) – should be used to configure the routes.
 *
 * Only `setRoutes` has to be called manually, others are automatically invoked when creating a new instance.
 *
 * @extends Resolver
 * @demo demo/index.html
 * @summary JavaScript class that renders different DOM content depending on
 *    a given path. It can re-render when triggered or automatically on
 *    'popstate' and / or 'click' events.
 */ class $90ca201d4100224c$export$55185c17a0fcbe46 extends $90ca201d4100224c$export$8b4c839865b08288 {
    /**
   * Creates a new Router instance with a given outlet, and
   * automatically subscribes it to navigation events on the `window`.
   * Using a constructor argument or a setter for outlet is equivalent:
   *
   * ```
   * const router = new Router();
   * router.setOutlet(outlet);
   * ```
   * @param {?Node=} outlet
   * @param {?RouterOptions=} options
   */ constructor(outlet, options){
        const baseElement = document.head.querySelector('base');
        const baseHref = baseElement && baseElement.getAttribute('href');
        super([], Object.assign({
            // Default options
            baseUrl: baseHref && $90ca201d4100224c$export$8b4c839865b08288.__createUrl(baseHref, document.URL).pathname.replace(/[^\/]*$/, '')
        }, options));
        this.resolveRoute = (context)=>this.__resolveRoute(context);
        const triggers = $90ca201d4100224c$export$55185c17a0fcbe46.NavigationTrigger;
        $90ca201d4100224c$export$55185c17a0fcbe46.setTriggers.apply($90ca201d4100224c$export$55185c17a0fcbe46, Object.keys(triggers).map((key)=>triggers[key]));
        /**
     * The base URL for all routes in the router instance. By default,
     * if the base element exists in the `<head>`, vaadin-router
     * takes the `<base href>` attribute value, resolves against current `document.URL`
     * and gets the `pathname` from the result.
     *
     * @public
     * @type {string}
     */ this.baseUrl;
        /**
     * A promise that is settled after the current render cycle completes. If
     * there is no render cycle in progress the promise is immediately settled
     * with the last render cycle result.
     *
     * @public
     * @type {!Promise<!RouterLocation>}
     */ this.ready;
        this.ready = Promise.resolve(outlet);
        /**
     * Contains read-only information about the current router location:
     * pathname, active routes, parameters. See the
     * [Location type declaration](#/classes/RouterLocation)
     * for more details.
     *
     * @public
     * @type {!RouterLocation}
     */ this.location;
        this.location = $90ca201d4100224c$var$createLocation({
            resolver: this
        });
        this.__lastStartedRenderId = 0;
        this.__navigationEventHandler = this.__onNavigationEvent.bind(this);
        this.setOutlet(outlet);
        this.subscribe();
        // Using WeakMap instead of WeakSet because WeakSet is not supported by IE11
        this.__createdByRouter = new WeakMap();
        this.__addedByRouter = new WeakMap();
    }
    __resolveRoute(context) {
        const route = context.route;
        let callbacks = Promise.resolve();
        if ($90ca201d4100224c$var$isFunction(route.children)) callbacks = callbacks.then(()=>route.children($90ca201d4100224c$var$copyContextWithoutNext(context))).then((children)=>{
            // The route.children() callback might have re-written the
            // route.children property instead of returning a value
            if (!$90ca201d4100224c$var$isResultNotEmpty(children) && !$90ca201d4100224c$var$isFunction(route.children)) children = route.children;
            $90ca201d4100224c$var$processNewChildren(children, route);
        });
        const commands = {
            redirect: (path)=>$90ca201d4100224c$var$createRedirect(context, path),
            component: (component)=>{
                const element = document.createElement(component);
                this.__createdByRouter.set(element, true);
                return element;
            }
        };
        return callbacks.then(()=>{
            if (this.__isLatestRender(context)) return $90ca201d4100224c$var$runCallbackIfPossible(route.action, [
                context,
                commands
            ], route);
        }).then((result)=>{
            if ($90ca201d4100224c$var$isResultNotEmpty(result)) {
                // Actions like `() => import('my-view.js')` are not expected to
                // end the resolution, despite the result is not empty. Checking
                // the result with a whitelist of values that end the resolution.
                if (result instanceof HTMLElement || result.redirect || result === $90ca201d4100224c$var$notFoundResult) return result;
            }
            if ($90ca201d4100224c$var$isString(route.redirect)) return commands.redirect(route.redirect);
            if (route.bundle) return $90ca201d4100224c$var$loadBundle(route.bundle).then(()=>{}, ()=>{
                throw new Error($90ca201d4100224c$var$log(`Bundle not found: ${route.bundle}. Check if the file name is correct`));
            });
        }).then((result)=>{
            if ($90ca201d4100224c$var$isResultNotEmpty(result)) return result;
            if ($90ca201d4100224c$var$isString(route.component)) return commands.component(route.component);
        });
    }
    /**
   * Sets the router outlet (the DOM node where the content for the current
   * route is inserted). Any content pre-existing in the router outlet is
   * removed at the end of each render pass.
   *
   * NOTE: this method is automatically invoked first time when creating a new Router instance.
   *
   * @param {?Node} outlet the DOM node where the content for the current route
   *     is inserted.
   */ setOutlet(outlet) {
        if (outlet) this.__ensureOutlet(outlet);
        this.__outlet = outlet;
    }
    /**
   * Returns the current router outlet. The initial value is `undefined`.
   *
   * @return {?Node} the current router outlet (or `undefined`)
   */ getOutlet() {
        return this.__outlet;
    }
    /**
   * Sets the routing config (replacing the existing one) and triggers a
   * navigation event so that the router outlet is refreshed according to the
   * current `window.location` and the new routing config.
   *
   * Each route object may have the following properties, listed here in the processing order:
   * * `path` – the route path (relative to the parent route if any) in the
   * [express.js syntax](https://expressjs.com/en/guide/routing.html#route-paths").
   *
   * * `children` – an array of nested routes or a function that provides this
   * array at the render time. The function can be synchronous or asynchronous:
   * in the latter case the render is delayed until the returned promise is
   * resolved. The `children` function is executed every time when this route is
   * being rendered. This allows for dynamic route structures (e.g. backend-defined),
   * but it might have a performance impact as well. In order to avoid calling
   * the function on subsequent renders, you can override the `children` property
   * of the route object and save the calculated array there
   * (via `context.route.children = [ route1, route2, ...];`).
   * Parent routes are fully resolved before resolving the children. Children
   * 'path' values are relative to the parent ones.
   *
   * * `action` – the action that is executed before the route is resolved.
   * The value for this property should be a function, accepting `context`
   * and `commands` parameters described below. If present, this function is
   * always invoked first, disregarding of the other properties' presence.
   * The action can return a result directly or within a `Promise`, which
   * resolves to the result. If the action result is an `HTMLElement` instance,
   * a `commands.component(name)` result, a `commands.redirect(path)` result,
   * or a `context.next()` result, the current route resolution is finished,
   * and other route config properties are ignored.
   * See also **Route Actions** section in [Live Examples](#/classes/Router/demos/demo/index.html).
   *
   * * `redirect` – other route's path to redirect to. Passes all route parameters to the redirect target.
   * The target route should also be defined.
   * See also **Redirects** section in [Live Examples](#/classes/Router/demos/demo/index.html).
   *
   * * `bundle` – string containing the path to `.js` or `.mjs` bundle to load before resolving the route,
   * or the object with "module" and "nomodule" keys referring to different bundles.
   * Each bundle is only loaded once. If "module" and "nomodule" are set, only one bundle is loaded,
   * depending on whether the browser supports ES modules or not.
   * The property is ignored when either an `action` returns the result or `redirect` property is present.
   * Any error, e.g. 404 while loading bundle will cause route resolution to throw.
   * See also **Code Splitting** section in [Live Examples](#/classes/Router/demos/demo/index.html).
   *
   * * `component` – the tag name of the Web Component to resolve the route to.
   * The property is ignored when either an `action` returns the result or `redirect` property is present.
   * If route contains the `component` property (or an action that return a component)
   * and its child route also contains the `component` property, child route's component
   * will be rendered as a light dom child of a parent component.
   *
   * * `name` – the string name of the route to use in the
   * [`router.urlForName(name, params)`](#/classes/Router#method-urlForName)
   * navigation helper method.
   *
   * For any route function (`action`, `children`) defined, the corresponding `route` object is available inside the callback
   * through the `this` reference. If you need to access it, make sure you define the callback as a non-arrow function
   * because arrow functions do not have their own `this` reference.
   *
   * `context` object that is passed to `action` function holds the following properties:
   * * `context.pathname` – string with the pathname being resolved
   *
   * * `context.search` – search query string
   *
   * * `context.hash` – hash string
   *
   * * `context.params` – object with route parameters
   *
   * * `context.route` – object that holds the route that is currently being rendered.
   *
   * * `context.next()` – function for asynchronously getting the next route
   * contents from the resolution chain (if any)
   *
   * `commands` object that is passed to `action` function has
   * the following methods:
   *
   * * `commands.redirect(path)` – function that creates a redirect data
   * for the path specified.
   *
   * * `commands.component(component)` – function that creates a new HTMLElement
   * with current context. Note: the component created by this function is reused if visiting the same path twice in row.
   *
   *
   * @param {!Array<!Route>|!Route} routes a single route or an array of those
   * @param {?boolean} skipRender configure the router but skip rendering the
   *     route corresponding to the current `window.location` values
   *
   * @return {!Promise<!Node>}
   */ setRoutes(routes, skipRender = false) {
        this.__previousContext = undefined;
        this.__urlForName = undefined;
        super.setRoutes(routes);
        if (!skipRender) this.__onNavigationEvent();
        return this.ready;
    }
    /**
   * Asynchronously resolves the given pathname and renders the resolved route
   * component into the router outlet. If no router outlet is set at the time of
   * calling this method, or at the time when the route resolution is completed,
   * a `TypeError` is thrown.
   *
   * Returns a promise that is fulfilled with the router outlet DOM Node after
   * the route component is created and inserted into the router outlet, or
   * rejected if no route matches the given path.
   *
   * If another render pass is started before the previous one is completed, the
   * result of the previous render pass is ignored.
   *
   * @param {!string|!{pathname: !string, search: ?string, hash: ?string}} pathnameOrContext
   *    the pathname to render or a context object with a `pathname` property,
   *    optional `search` and `hash` properties, and other properties
   *    to pass to the resolver.
   * @param {boolean=} shouldUpdateHistory
   *    update browser history with the rendered location
   * @return {!Promise<!Node>}
   */ render(pathnameOrContext, shouldUpdateHistory) {
        const renderId = ++this.__lastStartedRenderId;
        const context = Object.assign({
            search: '',
            hash: ''
        }, $90ca201d4100224c$var$isString(pathnameOrContext) ? {
            pathname: pathnameOrContext
        } : pathnameOrContext, {
            __renderId: renderId
        });
        // Find the first route that resolves to a non-empty result
        this.ready = this.resolve(context)// Process the result of this.resolve() and handle all special commands:
        // (redirect / prevent / component). If the result is a 'component',
        // then go deeper and build the entire chain of nested components matching
        // the pathname. Also call all 'on before' callbacks along the way.
        .then((context)=>this.__fullyResolveChain(context)).then((context)=>{
            if (this.__isLatestRender(context)) {
                const previousContext = this.__previousContext;
                // Check if the render was prevented and make an early return in that case
                if (context === previousContext) {
                    // Replace the history with the previous context
                    // to make sure the URL stays the same.
                    this.__updateBrowserHistory(previousContext, true);
                    return this.location;
                }
                this.location = $90ca201d4100224c$var$createLocation(context);
                if (shouldUpdateHistory) // Replace only if first render redirects, so that we don’t leave
                // the redirecting record in the history
                this.__updateBrowserHistory(context, renderId === 1);
                $90ca201d4100224c$var$fireRouterEvent('location-changed', {
                    router: this,
                    location: this.location
                });
                // Skip detaching/re-attaching there are no render changes
                if (context.__skipAttach) {
                    this.__copyUnchangedElements(context, previousContext);
                    this.__previousContext = context;
                    return this.location;
                }
                this.__addAppearingContent(context, previousContext);
                const animationDone = this.__animateIfNeeded(context);
                this.__runOnAfterEnterCallbacks(context);
                this.__runOnAfterLeaveCallbacks(context, previousContext);
                return animationDone.then(()=>{
                    if (this.__isLatestRender(context)) {
                        // If there is another render pass started after this one,
                        // the 'disappearing content' would be removed when the other
                        // render pass calls `this.__addAppearingContent()`
                        this.__removeDisappearingContent();
                        this.__previousContext = context;
                        return this.location;
                    }
                });
            }
        }).catch((error)=>{
            if (renderId === this.__lastStartedRenderId) {
                if (shouldUpdateHistory) this.__updateBrowserHistory(context);
                $90ca201d4100224c$var$removeDomNodes(this.__outlet && this.__outlet.children);
                this.location = $90ca201d4100224c$var$createLocation(Object.assign(context, {
                    resolver: this
                }));
                $90ca201d4100224c$var$fireRouterEvent('error', Object.assign({
                    router: this,
                    error: error
                }, context));
                throw error;
            }
        });
        return this.ready;
    }
    // `topOfTheChainContextBeforeRedirects` is a context coming from Resolver.resolve().
    // It would contain a 'redirect' route or the first 'component' route that
    // matched the pathname. There might be more child 'component' routes to be
    // resolved and added into the chain. This method would find and add them.
    // `contextBeforeRedirects` is the context containing such a child component
    // route. It's only necessary when this method is called recursively (otherwise
    // it's the same as the 'top of the chain' context).
    //
    // Apart from building the chain of child components, this method would also
    // handle 'redirect' routes, call 'onBefore' callbacks and handle 'prevent'
    // and 'redirect' callback results.
    __fullyResolveChain(topOfTheChainContextBeforeRedirects, contextBeforeRedirects = topOfTheChainContextBeforeRedirects) {
        return this.__findComponentContextAfterAllRedirects(contextBeforeRedirects)// `contextAfterRedirects` is always a context with an `HTMLElement` result
        // In other cases the promise gets rejected and .then() is not called
        .then((contextAfterRedirects)=>{
            const redirectsHappened = contextAfterRedirects !== contextBeforeRedirects;
            const topOfTheChainContextAfterRedirects = redirectsHappened ? contextAfterRedirects : topOfTheChainContextBeforeRedirects;
            const matchedPath = $90ca201d4100224c$var$getPathnameForRouter($90ca201d4100224c$var$getMatchedPath(contextAfterRedirects.chain), contextAfterRedirects.resolver);
            const isFound = matchedPath === contextAfterRedirects.pathname;
            // Recursive method to try matching more child and sibling routes
            const findNextContextIfAny = (context, parent = context.route, prevResult)=>{
                return context.next(undefined, parent, prevResult).then((nextContext)=>{
                    if (nextContext === null || nextContext === $90ca201d4100224c$var$notFoundResult) {
                        // Next context is not found in children, ...
                        if (isFound) // ...but original context is already fully matching - use it
                        return context;
                        else if (parent.parent !== null) // ...and there is no full match yet - step up to check siblings
                        return findNextContextIfAny(context, parent.parent, nextContext);
                        else return nextContext;
                    }
                    return nextContext;
                });
            };
            return findNextContextIfAny(contextAfterRedirects).then((nextContext)=>{
                if (nextContext === null || nextContext === $90ca201d4100224c$var$notFoundResult) throw $90ca201d4100224c$var$getNotFoundError(topOfTheChainContextAfterRedirects);
                return nextContext && nextContext !== $90ca201d4100224c$var$notFoundResult && nextContext !== contextAfterRedirects ? this.__fullyResolveChain(topOfTheChainContextAfterRedirects, nextContext) : this.__amendWithOnBeforeCallbacks(contextAfterRedirects);
            });
        });
    }
    __findComponentContextAfterAllRedirects(context) {
        const result = context.result;
        if (result instanceof HTMLElement) {
            $90ca201d4100224c$var$renderElement(context, result);
            return Promise.resolve(context);
        } else if (result.redirect) return this.__redirect(result.redirect, context.__redirectCount, context.__renderId).then((context)=>this.__findComponentContextAfterAllRedirects(context));
        else if (result instanceof Error) return Promise.reject(result);
        else return Promise.reject(new Error($90ca201d4100224c$var$log(`Invalid route resolution result for path "${context.pathname}". ` + `Expected redirect object or HTML element, but got: "${$90ca201d4100224c$var$logValue(result)}". ` + `Double check the action return value for the route.`)));
    }
    __amendWithOnBeforeCallbacks(contextWithFullChain) {
        return this.__runOnBeforeCallbacks(contextWithFullChain).then((amendedContext)=>{
            if (amendedContext === this.__previousContext || amendedContext === contextWithFullChain) return amendedContext;
            return this.__fullyResolveChain(amendedContext);
        });
    }
    __runOnBeforeCallbacks(newContext) {
        const previousContext = this.__previousContext || {};
        const previousChain = previousContext.chain || [];
        const newChain = newContext.chain;
        let callbacks = Promise.resolve();
        const prevent = ()=>({
                cancel: true
            });
        const redirect = (pathname)=>$90ca201d4100224c$var$createRedirect(newContext, pathname);
        newContext.__divergedChainIndex = 0;
        newContext.__skipAttach = false;
        if (previousChain.length) {
            for(let i = 0; i < Math.min(previousChain.length, newChain.length); i = ++newContext.__divergedChainIndex){
                if (previousChain[i].route !== newChain[i].route || previousChain[i].path !== newChain[i].path && previousChain[i].element !== newChain[i].element || !this.__isReusableElement(previousChain[i].element, newChain[i].element)) break;
            }
            // Skip re-attaching and notifications if element and chain do not change
            newContext.__skipAttach = // Same route chain
            newChain.length === previousChain.length && newContext.__divergedChainIndex == newChain.length && // Same element
            this.__isReusableElement(newContext.result, previousContext.result);
            if (newContext.__skipAttach) {
                // execute onBeforeLeave for changed segment element when skipping attach
                for(let i = newChain.length - 1; i >= 0; i--)callbacks = this.__runOnBeforeLeaveCallbacks(callbacks, newContext, {
                    prevent: prevent
                }, previousChain[i]);
                // execute onBeforeEnter for changed segment element when skipping attach
                for(let i = 0; i < newChain.length; i++){
                    callbacks = this.__runOnBeforeEnterCallbacks(callbacks, newContext, {
                        prevent: prevent,
                        redirect: redirect
                    }, newChain[i]);
                    previousChain[i].element.location = $90ca201d4100224c$var$createLocation(newContext, previousChain[i].route);
                }
            } else // execute onBeforeLeave when NOT skipping attach
            for(let i = previousChain.length - 1; i >= newContext.__divergedChainIndex; i--)callbacks = this.__runOnBeforeLeaveCallbacks(callbacks, newContext, {
                prevent: prevent
            }, previousChain[i]);
        }
        // execute onBeforeEnter when NOT skipping attach
        if (!newContext.__skipAttach) for(let i = 0; i < newChain.length; i++){
            if (i < newContext.__divergedChainIndex) {
                if (i < previousChain.length && previousChain[i].element) previousChain[i].element.location = $90ca201d4100224c$var$createLocation(newContext, previousChain[i].route);
            } else {
                callbacks = this.__runOnBeforeEnterCallbacks(callbacks, newContext, {
                    prevent: prevent,
                    redirect: redirect
                }, newChain[i]);
                if (newChain[i].element) newChain[i].element.location = $90ca201d4100224c$var$createLocation(newContext, newChain[i].route);
            }
        }
        return callbacks.then((amendmentResult)=>{
            if (amendmentResult) {
                if (amendmentResult.cancel) {
                    this.__previousContext.__renderId = newContext.__renderId;
                    return this.__previousContext;
                }
                if (amendmentResult.redirect) return this.__redirect(amendmentResult.redirect, newContext.__redirectCount, newContext.__renderId);
            }
            return newContext;
        });
    }
    __runOnBeforeLeaveCallbacks(callbacks, newContext, commands, chainElement) {
        const location = $90ca201d4100224c$var$createLocation(newContext);
        return callbacks.then((result)=>{
            if (this.__isLatestRender(newContext)) {
                const afterLeaveFunction = $90ca201d4100224c$var$amend('onBeforeLeave', [
                    location,
                    commands,
                    this
                ], chainElement.element);
                return afterLeaveFunction(result);
            }
        }).then((result)=>{
            if (!(result || {}).redirect) return result;
        });
    }
    __runOnBeforeEnterCallbacks(callbacks, newContext, commands, chainElement) {
        const location = $90ca201d4100224c$var$createLocation(newContext, chainElement.route);
        return callbacks.then((result)=>{
            if (this.__isLatestRender(newContext)) {
                const beforeEnterFunction = $90ca201d4100224c$var$amend('onBeforeEnter', [
                    location,
                    commands,
                    this
                ], chainElement.element);
                return beforeEnterFunction(result);
            }
        });
    }
    __isReusableElement(element, otherElement) {
        if (element && otherElement) return this.__createdByRouter.get(element) && this.__createdByRouter.get(otherElement) ? element.localName === otherElement.localName : element === otherElement;
        return false;
    }
    __isLatestRender(context) {
        return context.__renderId === this.__lastStartedRenderId;
    }
    __redirect(redirectData, counter, renderId) {
        if (counter > $90ca201d4100224c$var$MAX_REDIRECT_COUNT) throw new Error($90ca201d4100224c$var$log(`Too many redirects when rendering ${redirectData.from}`));
        return this.resolve({
            pathname: this.urlForPath(redirectData.pathname, redirectData.params),
            redirectFrom: redirectData.from,
            __redirectCount: (counter || 0) + 1,
            __renderId: renderId
        });
    }
    __ensureOutlet(outlet = this.__outlet) {
        if (!(outlet instanceof Node)) throw new TypeError($90ca201d4100224c$var$log(`Expected router outlet to be a valid DOM Node (but got ${outlet})`));
    }
    __updateBrowserHistory({ pathname: pathname, search: search = '', hash: hash = '' }, replace) {
        if (window.location.pathname !== pathname || window.location.search !== search || window.location.hash !== hash) {
            const changeState = replace ? 'replaceState' : 'pushState';
            window.history[changeState](null, document.title, pathname + search + hash);
            window.dispatchEvent(new PopStateEvent('popstate', {
                state: 'vaadin-router-ignore'
            }));
        }
    }
    __copyUnchangedElements(context, previousContext) {
        // Find the deepest common parent between the last and the new component
        // chains. Update references for the unchanged elements in the new chain
        let deepestCommonParent = this.__outlet;
        for(let i = 0; i < context.__divergedChainIndex; i++){
            const unchangedElement = previousContext && previousContext.chain[i].element;
            if (unchangedElement) {
                if (unchangedElement.parentNode === deepestCommonParent) {
                    context.chain[i].element = unchangedElement;
                    deepestCommonParent = unchangedElement;
                } else break;
            }
        }
        return deepestCommonParent;
    }
    __addAppearingContent(context, previousContext) {
        this.__ensureOutlet();
        // If the previous 'entering' animation has not completed yet,
        // stop it and remove that content from the DOM before adding new one.
        this.__removeAppearingContent();
        // Copy reusable elements from the previousContext to current
        const deepestCommonParent = this.__copyUnchangedElements(context, previousContext);
        // Keep two lists of DOM elements:
        //  - those that should be removed once the transition animation is over
        //  - and those that should remain
        this.__appearingContent = [];
        this.__disappearingContent = Array.from(deepestCommonParent.children).filter(// Only remove layout content that was added by router
        (e)=>this.__addedByRouter.get(e) && // Do not remove the result element to avoid flickering
            e !== context.result);
        // Add new elements (starting after the deepest common parent) to the DOM.
        // That way only the components that are actually different between the two
        // locations are added to the DOM (and those that are common remain in the
        // DOM without first removing and then adding them again).
        let parentElement = deepestCommonParent;
        for(let i = context.__divergedChainIndex; i < context.chain.length; i++){
            const elementToAdd = context.chain[i].element;
            if (elementToAdd) {
                parentElement.appendChild(elementToAdd);
                this.__addedByRouter.set(elementToAdd, true);
                if (parentElement === deepestCommonParent) this.__appearingContent.push(elementToAdd);
                parentElement = elementToAdd;
            }
        }
    }
    __removeDisappearingContent() {
        if (this.__disappearingContent) $90ca201d4100224c$var$removeDomNodes(this.__disappearingContent);
        this.__disappearingContent = null;
        this.__appearingContent = null;
    }
    __removeAppearingContent() {
        if (this.__disappearingContent && this.__appearingContent) {
            $90ca201d4100224c$var$removeDomNodes(this.__appearingContent);
            this.__disappearingContent = null;
            this.__appearingContent = null;
        }
    }
    __runOnAfterLeaveCallbacks(currentContext, targetContext) {
        if (!targetContext) return;
        // REVERSE iteration: from Z to A
        for(let i = targetContext.chain.length - 1; i >= currentContext.__divergedChainIndex; i--){
            if (!this.__isLatestRender(currentContext)) break;
            const currentComponent = targetContext.chain[i].element;
            if (!currentComponent) continue;
            try {
                const location = $90ca201d4100224c$var$createLocation(currentContext);
                $90ca201d4100224c$var$runCallbackIfPossible(currentComponent.onAfterLeave, [
                    location,
                    {},
                    targetContext.resolver
                ], currentComponent);
            } finally{
                if (this.__disappearingContent.indexOf(currentComponent) > -1) $90ca201d4100224c$var$removeDomNodes(currentComponent.children);
            }
        }
    }
    __runOnAfterEnterCallbacks(currentContext) {
        // forward iteration: from A to Z
        for(let i = currentContext.__divergedChainIndex; i < currentContext.chain.length; i++){
            if (!this.__isLatestRender(currentContext)) break;
            const currentComponent = currentContext.chain[i].element || {};
            const location = $90ca201d4100224c$var$createLocation(currentContext, currentContext.chain[i].route);
            $90ca201d4100224c$var$runCallbackIfPossible(currentComponent.onAfterEnter, [
                location,
                {},
                currentContext.resolver
            ], currentComponent);
        }
    }
    __animateIfNeeded(context) {
        const from = (this.__disappearingContent || [])[0];
        const to = (this.__appearingContent || [])[0];
        const promises = [];
        const chain = context.chain;
        let config;
        for(let i = chain.length; i > 0; i--)if (chain[i - 1].route.animate) {
            config = chain[i - 1].route.animate;
            break;
        }
        if (from && to && config) {
            const leave = $90ca201d4100224c$var$isObject(config) && config.leave || 'leaving';
            const enter = $90ca201d4100224c$var$isObject(config) && config.enter || 'entering';
            promises.push($90ca201d4100224c$var$animate(from, leave));
            promises.push($90ca201d4100224c$var$animate(to, enter));
        }
        return Promise.all(promises).then(()=>context);
    }
    /**
   * Subscribes this instance to navigation events on the `window`.
   *
   * NOTE: beware of resource leaks. For as long as a router instance is
   * subscribed to navigation events, it won't be garbage collected.
   */ subscribe() {
        window.addEventListener('vaadin-router-go', this.__navigationEventHandler);
    }
    /**
   * Removes the subscription to navigation events created in the `subscribe()`
   * method.
   */ unsubscribe() {
        window.removeEventListener('vaadin-router-go', this.__navigationEventHandler);
    }
    __onNavigationEvent(event) {
        const { pathname: pathname, search: search, hash: hash } = event ? event.detail : window.location;
        if ($90ca201d4100224c$var$isString(this.__normalizePathname(pathname))) {
            if (event && event.preventDefault) event.preventDefault();
            this.render({
                pathname: pathname,
                search: search,
                hash: hash
            }, true);
        }
    }
    /**
   * Configures what triggers Router navigation events:
   *  - `POPSTATE`: popstate events on the current `window`
   *  - `CLICK`: click events on `<a>` links leading to the current page
   *
   * This method is invoked with the pre-configured values when creating a new Router instance.
   * By default, both `POPSTATE` and `CLICK` are enabled. This setup is expected to cover most of the use cases.
   *
   * See the `router-config.js` for the default navigation triggers config. Based on it, you can
   * create the own one and only import the triggers you need, instead of pulling in all the code,
   * e.g. if you want to handle `click` differently.
   *
   * See also **Navigation Triggers** section in [Live Examples](#/classes/Router/demos/demo/index.html).
   *
   * @param {...NavigationTrigger} triggers
   */ static setTriggers(...triggers) {
        $90ca201d4100224c$var$setNavigationTriggers(triggers);
    }
    /**
   * Generates a URL for the route with the given name, optionally performing
   * substitution of parameters.
   *
   * The route is searched in all the Router instances subscribed to
   * navigation events.
   *
   * **Note:** For child route names, only array children are considered.
   * It is not possible to generate URLs using a name for routes set with
   * a children function.
   *
   * @function urlForName
   * @param {!string} name the route name or the route’s `component` name.
   * @param {Params=} params Optional object with route path parameters.
   * Named parameters are passed by name (`params[name] = value`), unnamed
   * parameters are passed by index (`params[index] = value`).
   *
   * @return {string}
   */ urlForName(name, params) {
        if (!this.__urlForName) this.__urlForName = $90ca201d4100224c$var$generateUrls(this);
        return $90ca201d4100224c$var$getPathnameForRouter(this.__urlForName(name, params), this);
    }
    /**
   * Generates a URL for the given route path, optionally performing
   * substitution of parameters.
   *
   * @param {!string} path string route path declared in [express.js syntax](https://expressjs.com/en/guide/routing.html#route-paths").
   * @param {Params=} params Optional object with route path parameters.
   * Named parameters are passed by name (`params[name] = value`), unnamed
   * parameters are passed by index (`params[index] = value`).
   *
   * @return {string}
   */ urlForPath(path, params) {
        return $90ca201d4100224c$var$getPathnameForRouter($90ca201d4100224c$export$55185c17a0fcbe46.pathToRegexp.compile(path)(params), this);
    }
    /**
   * Triggers navigation to a new path. Returns a boolean without waiting until
   * the navigation is complete. Returns `true` if at least one `Router`
   * has handled the navigation (was subscribed and had `baseUrl` matching
   * the `path` argument), otherwise returns `false`.
   *
   * @param {!string|!{pathname: !string, search: (string|undefined), hash: (string|undefined)}} path
   *   a new in-app path string, or an URL-like object with `pathname`
   *   string property, and optional `search` and `hash` string properties.
   * @return {boolean}
   */ static go(path) {
        const { pathname: pathname, search: search, hash: hash } = $90ca201d4100224c$var$isString(path) ? this.__createUrl(path, 'http://a') // some base to omit origin
         : path;
        return $90ca201d4100224c$var$fireRouterEvent('go', {
            pathname: pathname,
            search: search,
            hash: hash
        });
    }
}
const $90ca201d4100224c$var$DEV_MODE_CODE_REGEXP = /\/\*[\*!]\s+vaadin-dev-mode:start([\s\S]*)vaadin-dev-mode:end\s+\*\*\//i;
const $90ca201d4100224c$var$FlowClients = window.Vaadin && window.Vaadin.Flow && window.Vaadin.Flow.clients;
function $90ca201d4100224c$var$isMinified() {
    function test() {
        /** vaadin-dev-mode:start
    return false;
    vaadin-dev-mode:end **/ return true;
    }
    return $90ca201d4100224c$var$uncommentAndRun(test);
}
function $90ca201d4100224c$var$isDevelopmentMode() {
    try {
        if ($90ca201d4100224c$var$isForcedDevelopmentMode()) return true;
        if (!$90ca201d4100224c$var$isLocalhost()) return false;
        if ($90ca201d4100224c$var$FlowClients) return !$90ca201d4100224c$var$isFlowProductionMode();
        return !$90ca201d4100224c$var$isMinified();
    } catch (e) {
        // Some error in this code, assume production so no further actions will be taken
        return false;
    }
}
function $90ca201d4100224c$var$isForcedDevelopmentMode() {
    return localStorage.getItem("vaadin.developmentmode.force");
}
function $90ca201d4100224c$var$isLocalhost() {
    return [
        "localhost",
        "127.0.0.1"
    ].indexOf(window.location.hostname) >= 0;
}
function $90ca201d4100224c$var$isFlowProductionMode() {
    if ($90ca201d4100224c$var$FlowClients) {
        const productionModeApps = Object.keys($90ca201d4100224c$var$FlowClients).map((key)=>$90ca201d4100224c$var$FlowClients[key]).filter((client)=>client.productionMode);
        if (productionModeApps.length > 0) return true;
    }
    return false;
}
function $90ca201d4100224c$var$uncommentAndRun(callback, args) {
    if (typeof callback !== 'function') return;
    const match = $90ca201d4100224c$var$DEV_MODE_CODE_REGEXP.exec(callback.toString());
    if (match) try {
        // requires CSP: script-src 'unsafe-eval'
        callback = new Function(match[1]);
    } catch (e) {
        // eat the exception
        console.log('vaadin-development-mode-detector: uncommentAndRun() failed', e);
    }
    return callback(args);
}
// A guard against polymer-modulizer removing the window.Vaadin
// initialization above.
window['Vaadin'] = window['Vaadin'] || {};
/**
 * Inspects the source code of the given `callback` function for
 * specially-marked _commented_ code. If such commented code is found in the
 * callback source, uncomments and runs that code instead of the callback
 * itself. Otherwise runs the callback as is.
 *
 * The optional arguments are passed into the callback / uncommented code,
 * the result is returned.
 *
 * See the `isMinified()` function source code in this file for an example.
 *
 */ const $90ca201d4100224c$var$runIfDevelopmentMode = function(callback, args) {
    if (window.Vaadin.developmentMode) return $90ca201d4100224c$var$uncommentAndRun(callback, args);
};
if (window.Vaadin.developmentMode === undefined) window.Vaadin.developmentMode = $90ca201d4100224c$var$isDevelopmentMode();
/* This file is autogenerated from src/vaadin-usage-statistics.tpl.html */ function $90ca201d4100224c$var$maybeGatherAndSendStats() {
/** vaadin-dev-mode:start
  (function () {
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var getPolymerVersion = function getPolymerVersion() {
  return window.Polymer && window.Polymer.version;
};

var StatisticsGatherer = function () {
  function StatisticsGatherer(logger) {
    classCallCheck(this, StatisticsGatherer);

    this.now = new Date().getTime();
    this.logger = logger;
  }

  createClass(StatisticsGatherer, [{
    key: 'frameworkVersionDetectors',
    value: function frameworkVersionDetectors() {
      return {
        'Flow': function Flow() {
          if (window.Vaadin && window.Vaadin.Flow && window.Vaadin.Flow.clients) {
            var flowVersions = Object.keys(window.Vaadin.Flow.clients).map(function (key) {
              return window.Vaadin.Flow.clients[key];
            }).filter(function (client) {
              return client.getVersionInfo;
            }).map(function (client) {
              return client.getVersionInfo().flow;
            });
            if (flowVersions.length > 0) {
              return flowVersions[0];
            }
          }
        },
        'Vaadin Framework': function VaadinFramework() {
          if (window.vaadin && window.vaadin.clients) {
            var frameworkVersions = Object.values(window.vaadin.clients).filter(function (client) {
              return client.getVersionInfo;
            }).map(function (client) {
              return client.getVersionInfo().vaadinVersion;
            });
            if (frameworkVersions.length > 0) {
              return frameworkVersions[0];
            }
          }
        },
        'AngularJs': function AngularJs() {
          if (window.angular && window.angular.version && window.angular.version) {
            return window.angular.version.full;
          }
        },
        'Angular': function Angular() {
          if (window.ng) {
            var tags = document.querySelectorAll("[ng-version]");
            if (tags.length > 0) {
              return tags[0].getAttribute("ng-version");
            }
            return "Unknown";
          }
        },
        'Backbone.js': function BackboneJs() {
          if (window.Backbone) {
            return window.Backbone.VERSION;
          }
        },
        'React': function React() {
          var reactSelector = '[data-reactroot], [data-reactid]';
          if (!!document.querySelector(reactSelector)) {
            // React does not publish the version by default
            return "unknown";
          }
        },
        'Ember': function Ember() {
          if (window.Em && window.Em.VERSION) {
            return window.Em.VERSION;
          } else if (window.Ember && window.Ember.VERSION) {
            return window.Ember.VERSION;
          }
        },
        'jQuery': function (_jQuery) {
          function jQuery() {
            return _jQuery.apply(this, arguments);
          }

          jQuery.toString = function () {
            return _jQuery.toString();
          };

          return jQuery;
        }(function () {
          if (typeof jQuery === 'function' && jQuery.prototype.jquery !== undefined) {
            return jQuery.prototype.jquery;
          }
        }),
        'Polymer': function Polymer() {
          var version = getPolymerVersion();
          if (version) {
            return version;
          }
        },
        'LitElement': function LitElement() {
          var version = window.litElementVersions && window.litElementVersions[0];
          if (version) {
            return version;
          }
        },
        'LitHtml': function LitHtml() {
          var version = window.litHtmlVersions && window.litHtmlVersions[0];
          if (version) {
            return version;
          }
        },
        'Vue.js': function VueJs() {
          if (window.Vue) {
            return window.Vue.version;
          }
        }
      };
    }
  }, {
    key: 'getUsedVaadinElements',
    value: function getUsedVaadinElements(elements) {
      var version = getPolymerVersion();
      var elementClasses = void 0;
      // NOTE: In case you edit the code here, YOU MUST UPDATE any statistics reporting code in Flow.
      // Check all locations calling the method getEntries() in
      // https://github.com/vaadin/flow/blob/master/flow-server/src/main/java/com/vaadin/flow/internal/UsageStatistics.java#L106
      // Currently it is only used by BootstrapHandler.
      if (version && version.indexOf('2') === 0) {
        // Polymer 2: components classes are stored in window.Vaadin
        elementClasses = Object.keys(window.Vaadin).map(function (c) {
          return window.Vaadin[c];
        }).filter(function (c) {
          return c.is;
        });
      } else {
        // Polymer 3: components classes are stored in window.Vaadin.registrations
        elementClasses = window.Vaadin.registrations || [];
      }
      elementClasses.forEach(function (klass) {
        var version = klass.version ? klass.version : "0.0.0";
        elements[klass.is] = { version: version };
      });
    }
  }, {
    key: 'getUsedVaadinThemes',
    value: function getUsedVaadinThemes(themes) {
      ['Lumo', 'Material'].forEach(function (themeName) {
        var theme;
        var version = getPolymerVersion();
        if (version && version.indexOf('2') === 0) {
          // Polymer 2: themes are stored in window.Vaadin
          theme = window.Vaadin[themeName];
        } else {
          // Polymer 3: themes are stored in custom element registry
          theme = customElements.get('vaadin-' + themeName.toLowerCase() + '-styles');
        }
        if (theme && theme.version) {
          themes[themeName] = { version: theme.version };
        }
      });
    }
  }, {
    key: 'getFrameworks',
    value: function getFrameworks(frameworks) {
      var detectors = this.frameworkVersionDetectors();
      Object.keys(detectors).forEach(function (framework) {
        var detector = detectors[framework];
        try {
          var version = detector();
          if (version) {
            frameworks[framework] = { version: version };
          }
        } catch (e) {}
      });
    }
  }, {
    key: 'gather',
    value: function gather(storage) {
      var storedStats = storage.read();
      var gatheredStats = {};
      var types = ["elements", "frameworks", "themes"];

      types.forEach(function (type) {
        gatheredStats[type] = {};
        if (!storedStats[type]) {
          storedStats[type] = {};
        }
      });

      var previousStats = JSON.stringify(storedStats);

      this.getUsedVaadinElements(gatheredStats.elements);
      this.getFrameworks(gatheredStats.frameworks);
      this.getUsedVaadinThemes(gatheredStats.themes);

      var now = this.now;
      types.forEach(function (type) {
        var keys = Object.keys(gatheredStats[type]);
        keys.forEach(function (key) {
          if (!storedStats[type][key] || _typeof(storedStats[type][key]) != _typeof({})) {
            storedStats[type][key] = { firstUsed: now };
          }
          // Discards any previously logged version number
          storedStats[type][key].version = gatheredStats[type][key].version;
          storedStats[type][key].lastUsed = now;
        });
      });

      var newStats = JSON.stringify(storedStats);
      storage.write(newStats);
      if (newStats != previousStats && Object.keys(storedStats).length > 0) {
        this.logger.debug("New stats: " + newStats);
      }
    }
  }]);
  return StatisticsGatherer;
}();

var StatisticsStorage = function () {
  function StatisticsStorage(key) {
    classCallCheck(this, StatisticsStorage);

    this.key = key;
  }

  createClass(StatisticsStorage, [{
    key: 'read',
    value: function read() {
      var localStorageStatsString = localStorage.getItem(this.key);
      try {
        return JSON.parse(localStorageStatsString ? localStorageStatsString : '{}');
      } catch (e) {
        return {};
      }
    }
  }, {
    key: 'write',
    value: function write(data) {
      localStorage.setItem(this.key, data);
    }
  }, {
    key: 'clear',
    value: function clear() {
      localStorage.removeItem(this.key);
    }
  }, {
    key: 'isEmpty',
    value: function isEmpty() {
      var storedStats = this.read();
      var empty = true;
      Object.keys(storedStats).forEach(function (key) {
        if (Object.keys(storedStats[key]).length > 0) {
          empty = false;
        }
      });

      return empty;
    }
  }]);
  return StatisticsStorage;
}();

var StatisticsSender = function () {
  function StatisticsSender(url, logger) {
    classCallCheck(this, StatisticsSender);

    this.url = url;
    this.logger = logger;
  }

  createClass(StatisticsSender, [{
    key: 'send',
    value: function send(data, errorHandler) {
      var logger = this.logger;

      if (navigator.onLine === false) {
        logger.debug("Offline, can't send");
        errorHandler();
        return;
      }
      logger.debug("Sending data to " + this.url);

      var req = new XMLHttpRequest();
      req.withCredentials = true;
      req.addEventListener("load", function () {
        // Stats sent, nothing more to do
        logger.debug("Response: " + req.responseText);
      });
      req.addEventListener("error", function () {
        logger.debug("Send failed");
        errorHandler();
      });
      req.addEventListener("abort", function () {
        logger.debug("Send aborted");
        errorHandler();
      });
      req.open("POST", this.url);
      req.setRequestHeader("Content-Type", "application/json");
      req.send(data);
    }
  }]);
  return StatisticsSender;
}();

var StatisticsLogger = function () {
  function StatisticsLogger(id) {
    classCallCheck(this, StatisticsLogger);

    this.id = id;
  }

  createClass(StatisticsLogger, [{
    key: '_isDebug',
    value: function _isDebug() {
      return localStorage.getItem("vaadin." + this.id + ".debug");
    }
  }, {
    key: 'debug',
    value: function debug(msg) {
      if (this._isDebug()) {
        console.info(this.id + ": " + msg);
      }
    }
  }]);
  return StatisticsLogger;
}();

var UsageStatistics = function () {
  function UsageStatistics() {
    classCallCheck(this, UsageStatistics);

    this.now = new Date();
    this.timeNow = this.now.getTime();
    this.gatherDelay = 10; // Delay between loading this file and gathering stats
    this.initialDelay = 24 * 60 * 60;

    this.logger = new StatisticsLogger("statistics");
    this.storage = new StatisticsStorage("vaadin.statistics.basket");
    this.gatherer = new StatisticsGatherer(this.logger);
    this.sender = new StatisticsSender("https://tools.vaadin.com/usage-stats/submit", this.logger);
  }

  createClass(UsageStatistics, [{
    key: 'maybeGatherAndSend',
    value: function maybeGatherAndSend() {
      var _this = this;

      if (localStorage.getItem(UsageStatistics.optOutKey)) {
        return;
      }
      this.gatherer.gather(this.storage);
      setTimeout(function () {
        _this.maybeSend();
      }, this.gatherDelay * 1000);
    }
  }, {
    key: 'lottery',
    value: function lottery() {
      return true;
    }
  }, {
    key: 'currentMonth',
    value: function currentMonth() {
      return this.now.getYear() * 12 + this.now.getMonth();
    }
  }, {
    key: 'maybeSend',
    value: function maybeSend() {
      var firstUse = Number(localStorage.getItem(UsageStatistics.firstUseKey));
      var monthProcessed = Number(localStorage.getItem(UsageStatistics.monthProcessedKey));

      if (!firstUse) {
        // Use a grace period to avoid interfering with tests, incognito mode etc
        firstUse = this.timeNow;
        localStorage.setItem(UsageStatistics.firstUseKey, firstUse);
      }

      if (this.timeNow < firstUse + this.initialDelay * 1000) {
        this.logger.debug("No statistics will be sent until the initial delay of " + this.initialDelay + "s has passed");
        return;
      }
      if (this.currentMonth() <= monthProcessed) {
        this.logger.debug("This month has already been processed");
        return;
      }
      localStorage.setItem(UsageStatistics.monthProcessedKey, this.currentMonth());
      // Use random sampling
      if (this.lottery()) {
        this.logger.debug("Congratulations, we have a winner!");
      } else {
        this.logger.debug("Sorry, no stats from you this time");
        return;
      }

      this.send();
    }
  }, {
    key: 'send',
    value: function send() {
      // Ensure we have the latest data
      this.gatherer.gather(this.storage);

      // Read, send and clean up
      var data = this.storage.read();
      data["firstUse"] = Number(localStorage.getItem(UsageStatistics.firstUseKey));
      data["usageStatisticsVersion"] = UsageStatistics.version;
      var info = 'This request contains usage statistics gathered from the application running in development mode. \n\nStatistics gathering is automatically disabled and excluded from production builds.\n\nFor details and to opt-out, see https://github.com/vaadin/vaadin-usage-statistics.\n\n\n\n';
      var self = this;
      this.sender.send(info + JSON.stringify(data), function () {
        // Revert the 'month processed' flag
        localStorage.setItem(UsageStatistics.monthProcessedKey, self.currentMonth() - 1);
      });
    }
  }], [{
    key: 'version',
    get: function get$1() {
      return '2.1.2';
    }
  }, {
    key: 'firstUseKey',
    get: function get$1() {
      return 'vaadin.statistics.firstuse';
    }
  }, {
    key: 'monthProcessedKey',
    get: function get$1() {
      return 'vaadin.statistics.monthProcessed';
    }
  }, {
    key: 'optOutKey',
    get: function get$1() {
      return 'vaadin.statistics.optout';
    }
  }]);
  return UsageStatistics;
}();

try {
  window.Vaadin = window.Vaadin || {};
  window.Vaadin.usageStatsChecker = window.Vaadin.usageStatsChecker || new UsageStatistics();
  window.Vaadin.usageStatsChecker.maybeGatherAndSend();
} catch (e) {
  // Intentionally ignored as this is not a problem in the app being developed
}

}());

  vaadin-dev-mode:end **/ }
const $90ca201d4100224c$var$usageStatistics = function() {
    if (typeof $90ca201d4100224c$var$runIfDevelopmentMode === 'function') return $90ca201d4100224c$var$runIfDevelopmentMode($90ca201d4100224c$var$maybeGatherAndSendStats);
};
window.Vaadin = window.Vaadin || {};
window.Vaadin.registrations = window.Vaadin.registrations || [];
window.Vaadin.registrations.push({
    is: '@vaadin/router',
    version: '1.7.4'
});
$90ca201d4100224c$var$usageStatistics();
$90ca201d4100224c$export$55185c17a0fcbe46.NavigationTrigger = {
    POPSTATE: $90ca201d4100224c$var$POPSTATE,
    CLICK: $90ca201d4100224c$var$CLICK
};

});

parcelRegister("2eeCH", function(module, exports) {

$parcel$export(module.exports, "__extends", () => $19f83b74af78f632$export$a8ba968b8961cb8a);
$parcel$export(module.exports, "__assign", () => $19f83b74af78f632$export$18ce0697a983be9b);
$parcel$export(module.exports, "__decorate", () => $19f83b74af78f632$export$29e00dfd3077644b);
$parcel$export(module.exports, "__awaiter", () => $19f83b74af78f632$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $19f83b74af78f632$export$67ebef60e6f28a6);
$parcel$export(module.exports, "__read", () => $19f83b74af78f632$export$8d051b38c9118094);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $19f83b74af78f632$var$extendStatics = function(d, b) {
    $19f83b74af78f632$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $19f83b74af78f632$var$extendStatics(d, b);
};
function $19f83b74af78f632$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $19f83b74af78f632$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $19f83b74af78f632$export$18ce0697a983be9b = function() {
    $19f83b74af78f632$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $19f83b74af78f632$export$18ce0697a983be9b.apply(this, arguments);
};
function $19f83b74af78f632$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $19f83b74af78f632$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $19f83b74af78f632$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $19f83b74af78f632$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $19f83b74af78f632$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $19f83b74af78f632$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $19f83b74af78f632$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $19f83b74af78f632$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $19f83b74af78f632$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $19f83b74af78f632$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $19f83b74af78f632$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $19f83b74af78f632$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $19f83b74af78f632$export$45d3717a4c69092e(o, m, p);
}
function $19f83b74af78f632$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $19f83b74af78f632$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $19f83b74af78f632$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($19f83b74af78f632$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $19f83b74af78f632$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $19f83b74af78f632$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $19f83b74af78f632$export$10c90e4f7922046c(v) {
    return this instanceof $19f83b74af78f632$export$10c90e4f7922046c ? (this.v = v, this) : new $19f83b74af78f632$export$10c90e4f7922046c(v);
}
function $19f83b74af78f632$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $19f83b74af78f632$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $19f83b74af78f632$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $19f83b74af78f632$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $19f83b74af78f632$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $19f83b74af78f632$export$19a8beecd37a4c45 === "function" ? $19f83b74af78f632$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $19f83b74af78f632$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $19f83b74af78f632$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $19f83b74af78f632$var$ownKeys = function(o) {
    $19f83b74af78f632$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $19f83b74af78f632$var$ownKeys(o);
};
function $19f83b74af78f632$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $19f83b74af78f632$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $19f83b74af78f632$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $19f83b74af78f632$var$__setModuleDefault(result, mod);
    return result;
}
function $19f83b74af78f632$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $19f83b74af78f632$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $19f83b74af78f632$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $19f83b74af78f632$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $19f83b74af78f632$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $19f83b74af78f632$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $19f83b74af78f632$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $19f83b74af78f632$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $19f83b74af78f632$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $19f83b74af78f632$export$2e2bcd8739ae039 = {
    __extends: $19f83b74af78f632$export$a8ba968b8961cb8a,
    __assign: $19f83b74af78f632$export$18ce0697a983be9b,
    __rest: $19f83b74af78f632$export$3c9a16f847548506,
    __decorate: $19f83b74af78f632$export$29e00dfd3077644b,
    __param: $19f83b74af78f632$export$d5ad3fd78186038f,
    __esDecorate: $19f83b74af78f632$export$3a84e1ae4e97e9b0,
    __runInitializers: $19f83b74af78f632$export$d831c04e792af3d,
    __propKey: $19f83b74af78f632$export$6a2a36740a146cb8,
    __setFunctionName: $19f83b74af78f632$export$d1a06452d3489bc7,
    __metadata: $19f83b74af78f632$export$f1db080c865becb9,
    __awaiter: $19f83b74af78f632$export$1050f835b63b671e,
    __generator: $19f83b74af78f632$export$67ebef60e6f28a6,
    __createBinding: $19f83b74af78f632$export$45d3717a4c69092e,
    __exportStar: $19f83b74af78f632$export$f33643c0debef087,
    __values: $19f83b74af78f632$export$19a8beecd37a4c45,
    __read: $19f83b74af78f632$export$8d051b38c9118094,
    __spread: $19f83b74af78f632$export$afc72e2116322959,
    __spreadArrays: $19f83b74af78f632$export$6388937ca91ccae8,
    __spreadArray: $19f83b74af78f632$export$1216008129fb82ed,
    __await: $19f83b74af78f632$export$10c90e4f7922046c,
    __asyncGenerator: $19f83b74af78f632$export$e427f37a30a4de9b,
    __asyncDelegator: $19f83b74af78f632$export$bbd80228419bb833,
    __asyncValues: $19f83b74af78f632$export$e3b29a3d6162315f,
    __makeTemplateObject: $19f83b74af78f632$export$4fb47efe1390b86f,
    __importStar: $19f83b74af78f632$export$c21735bcef00d192,
    __importDefault: $19f83b74af78f632$export$da59b14a69baef04,
    __classPrivateFieldGet: $19f83b74af78f632$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $19f83b74af78f632$export$d40a35129aaff81f,
    __classPrivateFieldIn: $19f83b74af78f632$export$81fdc39f203e4e04,
    __addDisposableResource: $19f83b74af78f632$export$88ac25d8e944e405,
    __disposeResources: $19f83b74af78f632$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $19f83b74af78f632$export$889dfb5d17574b0b
};

});

parcelRegister("k6o0V", function(module, exports) {
$parcel$export(module.exports, "css", () => (parcelRequire("1EWBs")).css);
$parcel$export(module.exports, "html", () => (parcelRequire("2Vehe")).html);
$parcel$export(module.exports, "LitElement", () => (parcelRequire("l0Nlx")).LitElement);
parcelRequire("4ZnnD");
parcelRequire("2Vehe");
parcelRequire("l0Nlx");
parcelRequire("l4Cyq");

});
parcelRegister("4ZnnD", function(module, exports) {

$parcel$export(module.exports, "defaultConverter", () => $3a1efebd5b75669a$export$7312b35fbf521afb);
$parcel$export(module.exports, "notEqual", () => $3a1efebd5b75669a$export$53a6892c50694894);
$parcel$export(module.exports, "ReactiveElement", () => $3a1efebd5b75669a$export$c7c07a37856565d);
$parcel$export(module.exports, "css", () => (parcelRequire("1EWBs")).css);

var $1EWBs = parcelRequire("1EWBs");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { is: $3a1efebd5b75669a$var$i, defineProperty: $3a1efebd5b75669a$var$e, getOwnPropertyDescriptor: $3a1efebd5b75669a$var$h, getOwnPropertyNames: $3a1efebd5b75669a$var$r, getOwnPropertySymbols: $3a1efebd5b75669a$var$o, getPrototypeOf: $3a1efebd5b75669a$var$n } = Object, $3a1efebd5b75669a$var$a = globalThis, $3a1efebd5b75669a$var$c = $3a1efebd5b75669a$var$a.trustedTypes, $3a1efebd5b75669a$var$l = $3a1efebd5b75669a$var$c ? $3a1efebd5b75669a$var$c.emptyScript : "", $3a1efebd5b75669a$var$p = $3a1efebd5b75669a$var$a.reactiveElementPolyfillSupport, $3a1efebd5b75669a$var$d = (t, s)=>t, $3a1efebd5b75669a$export$7312b35fbf521afb = {
    toAttribute (t, s) {
        switch(s){
            case Boolean:
                t = t ? $3a1efebd5b75669a$var$l : null;
                break;
            case Object:
            case Array:
                t = null == t ? t : JSON.stringify(t);
        }
        return t;
    },
    fromAttribute (t, s) {
        let i = t;
        switch(s){
            case Boolean:
                i = null !== t;
                break;
            case Number:
                i = null === t ? null : Number(t);
                break;
            case Object:
            case Array:
                try {
                    i = JSON.parse(t);
                } catch (t) {
                    i = null;
                }
        }
        return i;
    }
}, $3a1efebd5b75669a$export$53a6892c50694894 = (t, s)=>!$3a1efebd5b75669a$var$i(t, s), $3a1efebd5b75669a$var$b = {
    attribute: !0,
    type: String,
    converter: $3a1efebd5b75669a$export$7312b35fbf521afb,
    reflect: !1,
    useDefault: !1,
    hasChanged: $3a1efebd5b75669a$export$53a6892c50694894
};
Symbol.metadata ??= Symbol("metadata"), $3a1efebd5b75669a$var$a.litPropertyMetadata ??= new WeakMap;
class $3a1efebd5b75669a$export$c7c07a37856565d extends HTMLElement {
    static addInitializer(t) {
        this._$Ei(), (this.l ??= []).push(t);
    }
    static get observedAttributes() {
        return this.finalize(), this._$Eh && [
            ...this._$Eh.keys()
        ];
    }
    static createProperty(t, s = $3a1efebd5b75669a$var$b) {
        if (s.state && (s.attribute = !1), this._$Ei(), this.prototype.hasOwnProperty(t) && ((s = Object.create(s)).wrapped = !0), this.elementProperties.set(t, s), !s.noAccessor) {
            const i = Symbol(), h = this.getPropertyDescriptor(t, i, s);
            void 0 !== h && $3a1efebd5b75669a$var$e(this.prototype, t, h);
        }
    }
    static getPropertyDescriptor(t, s, i) {
        const { get: e, set: r } = $3a1efebd5b75669a$var$h(this.prototype, t) ?? {
            get () {
                return this[s];
            },
            set (t) {
                this[s] = t;
            }
        };
        return {
            get: e,
            set (s) {
                const h = e?.call(this);
                r?.call(this, s), this.requestUpdate(t, h, i);
            },
            configurable: !0,
            enumerable: !0
        };
    }
    static getPropertyOptions(t) {
        return this.elementProperties.get(t) ?? $3a1efebd5b75669a$var$b;
    }
    static _$Ei() {
        if (this.hasOwnProperty($3a1efebd5b75669a$var$d("elementProperties"))) return;
        const t = $3a1efebd5b75669a$var$n(this);
        t.finalize(), void 0 !== t.l && (this.l = [
            ...t.l
        ]), this.elementProperties = new Map(t.elementProperties);
    }
    static finalize() {
        if (this.hasOwnProperty($3a1efebd5b75669a$var$d("finalized"))) return;
        if (this.finalized = !0, this._$Ei(), this.hasOwnProperty($3a1efebd5b75669a$var$d("properties"))) {
            const t = this.properties, s = [
                ...$3a1efebd5b75669a$var$r(t),
                ...$3a1efebd5b75669a$var$o(t)
            ];
            for (const i of s)this.createProperty(i, t[i]);
        }
        const t = this[Symbol.metadata];
        if (null !== t) {
            const s = litPropertyMetadata.get(t);
            if (void 0 !== s) for (const [t, i] of s)this.elementProperties.set(t, i);
        }
        this._$Eh = new Map;
        for (const [t, s] of this.elementProperties){
            const i = this._$Eu(t, s);
            void 0 !== i && this._$Eh.set(i, t);
        }
        this.elementStyles = this.finalizeStyles(this.styles);
    }
    static finalizeStyles(s) {
        const i = [];
        if (Array.isArray(s)) {
            const e = new Set(s.flat(1 / 0).reverse());
            for (const s of e)i.unshift((0, $1EWBs.getCompatibleStyle)(s));
        } else void 0 !== s && i.push((0, $1EWBs.getCompatibleStyle)(s));
        return i;
    }
    static _$Eu(t, s) {
        const i = s.attribute;
        return !1 === i ? void 0 : "string" == typeof i ? i : "string" == typeof t ? t.toLowerCase() : void 0;
    }
    constructor(){
        super(), this._$Ep = void 0, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Em = null, this._$Ev();
    }
    _$Ev() {
        this._$ES = new Promise((t)=>this.enableUpdating = t), this._$AL = new Map, this._$E_(), this.requestUpdate(), this.constructor.l?.forEach((t)=>t(this));
    }
    addController(t) {
        (this._$EO ??= new Set).add(t), void 0 !== this.renderRoot && this.isConnected && t.hostConnected?.();
    }
    removeController(t) {
        this._$EO?.delete(t);
    }
    _$E_() {
        const t = new Map, s = this.constructor.elementProperties;
        for (const i of s.keys())this.hasOwnProperty(i) && (t.set(i, this[i]), delete this[i]);
        t.size > 0 && (this._$Ep = t);
    }
    createRenderRoot() {
        const t = this.shadowRoot ?? this.attachShadow(this.constructor.shadowRootOptions);
        return (0, $1EWBs.adoptStyles)(t, this.constructor.elementStyles), t;
    }
    connectedCallback() {
        this.renderRoot ??= this.createRenderRoot(), this.enableUpdating(!0), this._$EO?.forEach((t)=>t.hostConnected?.());
    }
    enableUpdating(t) {}
    disconnectedCallback() {
        this._$EO?.forEach((t)=>t.hostDisconnected?.());
    }
    attributeChangedCallback(t, s, i) {
        this._$AK(t, i);
    }
    _$ET(t, s) {
        const i = this.constructor.elementProperties.get(t), e = this.constructor._$Eu(t, i);
        if (void 0 !== e && !0 === i.reflect) {
            const h = (void 0 !== i.converter?.toAttribute ? i.converter : $3a1efebd5b75669a$export$7312b35fbf521afb).toAttribute(s, i.type);
            this._$Em = t, null == h ? this.removeAttribute(e) : this.setAttribute(e, h), this._$Em = null;
        }
    }
    _$AK(t, s) {
        const i = this.constructor, e = i._$Eh.get(t);
        if (void 0 !== e && this._$Em !== e) {
            const t = i.getPropertyOptions(e), h = "function" == typeof t.converter ? {
                fromAttribute: t.converter
            } : void 0 !== t.converter?.fromAttribute ? t.converter : $3a1efebd5b75669a$export$7312b35fbf521afb;
            this._$Em = e;
            const r = h.fromAttribute(s, t.type);
            this[e] = r ?? this._$Ej?.get(e) ?? r, this._$Em = null;
        }
    }
    requestUpdate(t, s, i, e = !1, h) {
        if (void 0 !== t) {
            const r = this.constructor;
            if (!1 === e && (h = this[t]), i ??= r.getPropertyOptions(t), !((i.hasChanged ?? $3a1efebd5b75669a$export$53a6892c50694894)(h, s) || i.useDefault && i.reflect && h === this._$Ej?.get(t) && !this.hasAttribute(r._$Eu(t, i)))) return;
            this.C(t, s, i);
        }
        !1 === this.isUpdatePending && (this._$ES = this._$EP());
    }
    C(t, s, { useDefault: i, reflect: e, wrapped: h }, r) {
        i && !(this._$Ej ??= new Map).has(t) && (this._$Ej.set(t, r ?? s ?? this[t]), !0 !== h || void 0 !== r) || (this._$AL.has(t) || (this.hasUpdated || i || (s = void 0), this._$AL.set(t, s)), !0 === e && this._$Em !== t && (this._$Eq ??= new Set).add(t));
    }
    async _$EP() {
        this.isUpdatePending = !0;
        try {
            await this._$ES;
        } catch (t) {
            Promise.reject(t);
        }
        const t = this.scheduleUpdate();
        return null != t && await t, !this.isUpdatePending;
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        if (!this.isUpdatePending) return;
        if (!this.hasUpdated) {
            if (this.renderRoot ??= this.createRenderRoot(), this._$Ep) {
                for (const [t, s] of this._$Ep)this[t] = s;
                this._$Ep = void 0;
            }
            const t = this.constructor.elementProperties;
            if (t.size > 0) for (const [s, i] of t){
                const { wrapped: t } = i, e = this[s];
                !0 !== t || this._$AL.has(s) || void 0 === e || this.C(s, void 0, i, e);
            }
        }
        let t = !1;
        const s = this._$AL;
        try {
            t = this.shouldUpdate(s), t ? (this.willUpdate(s), this._$EO?.forEach((t)=>t.hostUpdate?.()), this.update(s)) : this._$EM();
        } catch (s) {
            throw t = !1, this._$EM(), s;
        }
        t && this._$AE(s);
    }
    willUpdate(t) {}
    _$AE(t) {
        this._$EO?.forEach((t)=>t.hostUpdated?.()), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
    }
    _$EM() {
        this._$AL = new Map, this.isUpdatePending = !1;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$ES;
    }
    shouldUpdate(t) {
        return !0;
    }
    update(t) {
        this._$Eq &&= this._$Eq.forEach((t)=>this._$ET(t, this[t])), this._$EM();
    }
    updated(t) {}
    firstUpdated(t) {}
}
$3a1efebd5b75669a$export$c7c07a37856565d.elementStyles = [], $3a1efebd5b75669a$export$c7c07a37856565d.shadowRootOptions = {
    mode: "open"
}, $3a1efebd5b75669a$export$c7c07a37856565d[$3a1efebd5b75669a$var$d("elementProperties")] = new Map, $3a1efebd5b75669a$export$c7c07a37856565d[$3a1efebd5b75669a$var$d("finalized")] = new Map, $3a1efebd5b75669a$var$p?.({
    ReactiveElement: $3a1efebd5b75669a$export$c7c07a37856565d
}), ($3a1efebd5b75669a$var$a.reactiveElementVersions ??= []).push("2.1.2");

});
parcelRegister("1EWBs", function(module, exports) {

$parcel$export(module.exports, "css", () => $1356fc3ea53d6235$export$dbf350e5966cf602);
$parcel$export(module.exports, "adoptStyles", () => $1356fc3ea53d6235$export$2ca4a66ec4cecb90);
$parcel$export(module.exports, "getCompatibleStyle", () => $1356fc3ea53d6235$export$ee69dfd951e24778);
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $1356fc3ea53d6235$var$t = globalThis, $1356fc3ea53d6235$export$b4d10f6001c083c2 = $1356fc3ea53d6235$var$t.ShadowRoot && (void 0 === $1356fc3ea53d6235$var$t.ShadyCSS || $1356fc3ea53d6235$var$t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, $1356fc3ea53d6235$var$s = Symbol(), $1356fc3ea53d6235$var$o = new WeakMap;
class $1356fc3ea53d6235$export$505d1e8739bad805 {
    constructor(t, e, o){
        if (this._$cssResult$ = !0, o !== $1356fc3ea53d6235$var$s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t, this.t = e;
    }
    get styleSheet() {
        let t = this.o;
        const s = this.t;
        if ($1356fc3ea53d6235$export$b4d10f6001c083c2 && void 0 === t) {
            const e = void 0 !== s && 1 === s.length;
            e && (t = $1356fc3ea53d6235$var$o.get(s)), void 0 === t && ((this.o = t = new CSSStyleSheet).replaceSync(this.cssText), e && $1356fc3ea53d6235$var$o.set(s, t));
        }
        return t;
    }
    toString() {
        return this.cssText;
    }
}
const $1356fc3ea53d6235$export$8d80f9cac07cdb3 = (t)=>new $1356fc3ea53d6235$export$505d1e8739bad805("string" == typeof t ? t : t + "", void 0, $1356fc3ea53d6235$var$s), $1356fc3ea53d6235$export$dbf350e5966cf602 = (t, ...e)=>{
    const o = 1 === t.length ? t[0] : e.reduce((e, s, o)=>e + ((t)=>{
            if (!0 === t._$cssResult$) return t.cssText;
            if ("number" == typeof t) return t;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + t + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        })(s) + t[o + 1], t[0]);
    return new $1356fc3ea53d6235$export$505d1e8739bad805(o, t, $1356fc3ea53d6235$var$s);
}, $1356fc3ea53d6235$export$2ca4a66ec4cecb90 = (s, o)=>{
    if ($1356fc3ea53d6235$export$b4d10f6001c083c2) s.adoptedStyleSheets = o.map((t)=>t instanceof CSSStyleSheet ? t : t.styleSheet);
    else for (const e of o){
        const o = document.createElement("style"), n = $1356fc3ea53d6235$var$t.litNonce;
        void 0 !== n && o.setAttribute("nonce", n), o.textContent = e.cssText, s.appendChild(o);
    }
}, $1356fc3ea53d6235$export$ee69dfd951e24778 = $1356fc3ea53d6235$export$b4d10f6001c083c2 ? (t)=>t : (t)=>t instanceof CSSStyleSheet ? ((t)=>{
        let e = "";
        for (const s of t.cssRules)e += s.cssText;
        return $1356fc3ea53d6235$export$8d80f9cac07cdb3(e);
    })(t) : t;

});


parcelRegister("2Vehe", function(module, exports) {

$parcel$export(module.exports, "html", () => $220bfac40b25302d$export$c0bb0b647f701bb5);
$parcel$export(module.exports, "noChange", () => $220bfac40b25302d$export$9c068ae9cc5db4e8);
$parcel$export(module.exports, "_$LH", () => $220bfac40b25302d$export$8613d1ca9052b22e);
$parcel$export(module.exports, "render", () => $220bfac40b25302d$export$b3890eb0ae9dca99);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $220bfac40b25302d$var$t = globalThis, $220bfac40b25302d$var$i = (t)=>t, $220bfac40b25302d$var$s = $220bfac40b25302d$var$t.trustedTypes, $220bfac40b25302d$var$e = $220bfac40b25302d$var$s ? $220bfac40b25302d$var$s.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, $220bfac40b25302d$var$h = "$lit$", $220bfac40b25302d$var$o = `lit$${Math.random().toFixed(9).slice(2)}$`, $220bfac40b25302d$var$n = "?" + $220bfac40b25302d$var$o, $220bfac40b25302d$var$r = `<${$220bfac40b25302d$var$n}>`, $220bfac40b25302d$var$l = document, $220bfac40b25302d$var$c = ()=>$220bfac40b25302d$var$l.createComment(""), $220bfac40b25302d$var$a = (t)=>null === t || "object" != typeof t && "function" != typeof t, $220bfac40b25302d$var$u = Array.isArray, $220bfac40b25302d$var$d = (t)=>$220bfac40b25302d$var$u(t) || "function" == typeof t?.[Symbol.iterator], $220bfac40b25302d$var$f = "[ \t\n\f\r]", $220bfac40b25302d$var$v = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $220bfac40b25302d$var$_ = /-->/g, $220bfac40b25302d$var$m = />/g, $220bfac40b25302d$var$p = RegExp(`>|${$220bfac40b25302d$var$f}(?:([^\\s"'>=/]+)(${$220bfac40b25302d$var$f}*=${$220bfac40b25302d$var$f}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), $220bfac40b25302d$var$g = /'/g, $220bfac40b25302d$var$$ = /"/g, $220bfac40b25302d$var$y = /^(?:script|style|textarea|title)$/i, $220bfac40b25302d$var$x = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), $220bfac40b25302d$export$c0bb0b647f701bb5 = $220bfac40b25302d$var$x(1), $220bfac40b25302d$export$7ed1367e7fa1ad68 = $220bfac40b25302d$var$x(2), $220bfac40b25302d$export$47d5b44d225be5b4 = $220bfac40b25302d$var$x(3), $220bfac40b25302d$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $220bfac40b25302d$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $220bfac40b25302d$var$C = new WeakMap, $220bfac40b25302d$var$P = $220bfac40b25302d$var$l.createTreeWalker($220bfac40b25302d$var$l, 129);
function $220bfac40b25302d$var$V(t, i) {
    if (!$220bfac40b25302d$var$u(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== $220bfac40b25302d$var$e ? $220bfac40b25302d$var$e.createHTML(i) : i;
}
const $220bfac40b25302d$var$N = (t, i)=>{
    const s = t.length - 1, e = [];
    let n, l = 2 === i ? "<svg>" : 3 === i ? "<math>" : "", c = $220bfac40b25302d$var$v;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let a, u, d = -1, f = 0;
        for(; f < s.length && (c.lastIndex = f, u = c.exec(s), null !== u);)f = c.lastIndex, c === $220bfac40b25302d$var$v ? "!--" === u[1] ? c = $220bfac40b25302d$var$_ : void 0 !== u[1] ? c = $220bfac40b25302d$var$m : void 0 !== u[2] ? ($220bfac40b25302d$var$y.test(u[2]) && (n = RegExp("</" + u[2], "g")), c = $220bfac40b25302d$var$p) : void 0 !== u[3] && (c = $220bfac40b25302d$var$p) : c === $220bfac40b25302d$var$p ? ">" === u[0] ? (c = n ?? $220bfac40b25302d$var$v, d = -1) : void 0 === u[1] ? d = -2 : (d = c.lastIndex - u[2].length, a = u[1], c = void 0 === u[3] ? $220bfac40b25302d$var$p : '"' === u[3] ? $220bfac40b25302d$var$$ : $220bfac40b25302d$var$g) : c === $220bfac40b25302d$var$$ || c === $220bfac40b25302d$var$g ? c = $220bfac40b25302d$var$p : c === $220bfac40b25302d$var$_ || c === $220bfac40b25302d$var$m ? c = $220bfac40b25302d$var$v : (c = $220bfac40b25302d$var$p, n = void 0);
        const x = c === $220bfac40b25302d$var$p && t[i + 1].startsWith("/>") ? " " : "";
        l += c === $220bfac40b25302d$var$v ? s + $220bfac40b25302d$var$r : d >= 0 ? (e.push(a), s.slice(0, d) + $220bfac40b25302d$var$h + s.slice(d) + $220bfac40b25302d$var$o + x) : s + $220bfac40b25302d$var$o + (-2 === d ? i : x);
    }
    return [
        $220bfac40b25302d$var$V(t, l + (t[s] || "<?>") + (2 === i ? "</svg>" : 3 === i ? "</math>" : "")),
        e
    ];
};
class $220bfac40b25302d$var$S {
    constructor({ strings: t, _$litType$: i }, e){
        let r;
        this.parts = [];
        let l = 0, a = 0;
        const u = t.length - 1, d = this.parts, [f, v] = $220bfac40b25302d$var$N(t, i);
        if (this.el = $220bfac40b25302d$var$S.createElement(f, e), $220bfac40b25302d$var$P.currentNode = this.el.content, 2 === i || 3 === i) {
            const t = this.el.content.firstChild;
            t.replaceWith(...t.childNodes);
        }
        for(; null !== (r = $220bfac40b25302d$var$P.nextNode()) && d.length < u;){
            if (1 === r.nodeType) {
                if (r.hasAttributes()) for (const t of r.getAttributeNames())if (t.endsWith($220bfac40b25302d$var$h)) {
                    const i = v[a++], s = r.getAttribute(t).split($220bfac40b25302d$var$o), e = /([.?@])?(.*)/.exec(i);
                    d.push({
                        type: 1,
                        index: l,
                        name: e[2],
                        strings: s,
                        ctor: "." === e[1] ? $220bfac40b25302d$var$I : "?" === e[1] ? $220bfac40b25302d$var$L : "@" === e[1] ? $220bfac40b25302d$var$z : $220bfac40b25302d$var$H
                    }), r.removeAttribute(t);
                } else t.startsWith($220bfac40b25302d$var$o) && (d.push({
                    type: 6,
                    index: l
                }), r.removeAttribute(t));
                if ($220bfac40b25302d$var$y.test(r.tagName)) {
                    const t = r.textContent.split($220bfac40b25302d$var$o), i = t.length - 1;
                    if (i > 0) {
                        r.textContent = $220bfac40b25302d$var$s ? $220bfac40b25302d$var$s.emptyScript : "";
                        for(let s = 0; s < i; s++)r.append(t[s], $220bfac40b25302d$var$c()), $220bfac40b25302d$var$P.nextNode(), d.push({
                            type: 2,
                            index: ++l
                        });
                        r.append(t[i], $220bfac40b25302d$var$c());
                    }
                }
            } else if (8 === r.nodeType) {
                if (r.data === $220bfac40b25302d$var$n) d.push({
                    type: 2,
                    index: l
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = r.data.indexOf($220bfac40b25302d$var$o, t + 1));)d.push({
                        type: 7,
                        index: l
                    }), t += $220bfac40b25302d$var$o.length - 1;
                }
            }
            l++;
        }
    }
    static createElement(t, i) {
        const s = $220bfac40b25302d$var$l.createElement("template");
        return s.innerHTML = t, s;
    }
}
function $220bfac40b25302d$var$M(t, i, s = t, e) {
    if (i === $220bfac40b25302d$export$9c068ae9cc5db4e8) return i;
    let h = void 0 !== e ? s._$Co?.[e] : s._$Cl;
    const o = $220bfac40b25302d$var$a(i) ? void 0 : i._$litDirective$;
    return h?.constructor !== o && (h?._$AO?.(!1), void 0 === o ? h = void 0 : (h = new o(t), h._$AT(t, s, e)), void 0 !== e ? (s._$Co ??= [])[e] = h : s._$Cl = h), void 0 !== h && (i = $220bfac40b25302d$var$M(t, h._$AS(t, i.values), h, e)), i;
}
class $220bfac40b25302d$var$R {
    constructor(t, i){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        const { el: { content: i }, parts: s } = this._$AD, e = (t?.creationScope ?? $220bfac40b25302d$var$l).importNode(i, !0);
        $220bfac40b25302d$var$P.currentNode = e;
        let h = $220bfac40b25302d$var$P.nextNode(), o = 0, n = 0, r = s[0];
        for(; void 0 !== r;){
            if (o === r.index) {
                let i;
                2 === r.type ? i = new $220bfac40b25302d$var$k(h, h.nextSibling, this, t) : 1 === r.type ? i = new r.ctor(h, r.name, r.strings, this, t) : 6 === r.type && (i = new $220bfac40b25302d$var$Z(h, this, t)), this._$AV.push(i), r = s[++n];
            }
            o !== r?.index && (h = $220bfac40b25302d$var$P.nextNode(), o++);
        }
        return $220bfac40b25302d$var$P.currentNode = $220bfac40b25302d$var$l, e;
    }
    p(t) {
        let i = 0;
        for (const s of this._$AV)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
}
class $220bfac40b25302d$var$k {
    get _$AU() {
        return this._$AM?._$AU ?? this._$Cv;
    }
    constructor(t, i, s, e){
        this.type = 2, this._$AH = $220bfac40b25302d$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this._$Cv = e?.isConnected ?? !0;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === t?.nodeType && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = $220bfac40b25302d$var$M(this, t, i), $220bfac40b25302d$var$a(t) ? t === $220bfac40b25302d$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $220bfac40b25302d$export$45b790e32b2810ee && this._$AR(), this._$AH = $220bfac40b25302d$export$45b790e32b2810ee) : t !== this._$AH && t !== $220bfac40b25302d$export$9c068ae9cc5db4e8 && this._(t) : void 0 !== t._$litType$ ? this.$(t) : void 0 !== t.nodeType ? this.T(t) : $220bfac40b25302d$var$d(t) ? this.k(t) : this._(t);
    }
    O(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    T(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.O(t));
    }
    _(t) {
        this._$AH !== $220bfac40b25302d$export$45b790e32b2810ee && $220bfac40b25302d$var$a(this._$AH) ? this._$AA.nextSibling.data = t : this.T($220bfac40b25302d$var$l.createTextNode(t)), this._$AH = t;
    }
    $(t) {
        const { values: i, _$litType$: s } = t, e = "number" == typeof s ? this._$AC(t) : (void 0 === s.el && (s.el = $220bfac40b25302d$var$S.createElement($220bfac40b25302d$var$V(s.h, s.h[0]), this.options)), s);
        if (this._$AH?._$AD === e) this._$AH.p(i);
        else {
            const t = new $220bfac40b25302d$var$R(e, this), s = t.u(this.options);
            t.p(i), this.T(s), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = $220bfac40b25302d$var$C.get(t.strings);
        return void 0 === i && $220bfac40b25302d$var$C.set(t.strings, i = new $220bfac40b25302d$var$S(t)), i;
    }
    k(t) {
        $220bfac40b25302d$var$u(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const h of t)e === i.length ? i.push(s = new $220bfac40b25302d$var$k(this.O($220bfac40b25302d$var$c()), this.O($220bfac40b25302d$var$c()), this, this.options)) : s = i[e], s._$AI(h), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, s) {
        for(this._$AP?.(!1, !0, s); t !== this._$AB;){
            const s = $220bfac40b25302d$var$i(t).nextSibling;
            $220bfac40b25302d$var$i(t).remove(), t = s;
        }
    }
    setConnected(t) {
        void 0 === this._$AM && (this._$Cv = t, this._$AP?.(t));
    }
}
class $220bfac40b25302d$var$H {
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    constructor(t, i, s, e, h){
        this.type = 1, this._$AH = $220bfac40b25302d$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = h, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $220bfac40b25302d$export$45b790e32b2810ee;
    }
    _$AI(t, i = this, s, e) {
        const h = this.strings;
        let o = !1;
        if (void 0 === h) t = $220bfac40b25302d$var$M(this, t, i, 0), o = !$220bfac40b25302d$var$a(t) || t !== this._$AH && t !== $220bfac40b25302d$export$9c068ae9cc5db4e8, o && (this._$AH = t);
        else {
            const e = t;
            let n, r;
            for(t = h[0], n = 0; n < h.length - 1; n++)r = $220bfac40b25302d$var$M(this, e[s + n], i, n), r === $220bfac40b25302d$export$9c068ae9cc5db4e8 && (r = this._$AH[n]), o ||= !$220bfac40b25302d$var$a(r) || r !== this._$AH[n], r === $220bfac40b25302d$export$45b790e32b2810ee ? t = $220bfac40b25302d$export$45b790e32b2810ee : t !== $220bfac40b25302d$export$45b790e32b2810ee && (t += (r ?? "") + h[n + 1]), this._$AH[n] = r;
        }
        o && !e && this.j(t);
    }
    j(t) {
        t === $220bfac40b25302d$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t ?? "");
    }
}
class $220bfac40b25302d$var$I extends $220bfac40b25302d$var$H {
    constructor(){
        super(...arguments), this.type = 3;
    }
    j(t) {
        this.element[this.name] = t === $220bfac40b25302d$export$45b790e32b2810ee ? void 0 : t;
    }
}
class $220bfac40b25302d$var$L extends $220bfac40b25302d$var$H {
    constructor(){
        super(...arguments), this.type = 4;
    }
    j(t) {
        this.element.toggleAttribute(this.name, !!t && t !== $220bfac40b25302d$export$45b790e32b2810ee);
    }
}
class $220bfac40b25302d$var$z extends $220bfac40b25302d$var$H {
    constructor(t, i, s, e, h){
        super(t, i, s, e, h), this.type = 5;
    }
    _$AI(t, i = this) {
        if ((t = $220bfac40b25302d$var$M(this, t, i, 0) ?? $220bfac40b25302d$export$45b790e32b2810ee) === $220bfac40b25302d$export$9c068ae9cc5db4e8) return;
        const s = this._$AH, e = t === $220bfac40b25302d$export$45b790e32b2810ee && s !== $220bfac40b25302d$export$45b790e32b2810ee || t.capture !== s.capture || t.once !== s.once || t.passive !== s.passive, h = t !== $220bfac40b25302d$export$45b790e32b2810ee && (s === $220bfac40b25302d$export$45b790e32b2810ee || e);
        e && this.element.removeEventListener(this.name, this, s), h && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        "function" == typeof this._$AH ? this._$AH.call(this.options?.host ?? this.element, t) : this._$AH.handleEvent(t);
    }
}
class $220bfac40b25302d$var$Z {
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        $220bfac40b25302d$var$M(this, t);
    }
}
const $220bfac40b25302d$export$8613d1ca9052b22e = {
    M: $220bfac40b25302d$var$h,
    P: $220bfac40b25302d$var$o,
    A: $220bfac40b25302d$var$n,
    C: 1,
    L: $220bfac40b25302d$var$N,
    R: $220bfac40b25302d$var$R,
    D: $220bfac40b25302d$var$d,
    V: $220bfac40b25302d$var$M,
    I: $220bfac40b25302d$var$k,
    H: $220bfac40b25302d$var$H,
    N: $220bfac40b25302d$var$L,
    U: $220bfac40b25302d$var$z,
    B: $220bfac40b25302d$var$I,
    F: $220bfac40b25302d$var$Z
}, $220bfac40b25302d$var$B = $220bfac40b25302d$var$t.litHtmlPolyfillSupport;
$220bfac40b25302d$var$B?.($220bfac40b25302d$var$S, $220bfac40b25302d$var$k), ($220bfac40b25302d$var$t.litHtmlVersions ??= []).push("3.3.2");
const $220bfac40b25302d$export$b3890eb0ae9dca99 = (t, i, s)=>{
    const e = s?.renderBefore ?? i;
    let h = e._$litPart$;
    if (void 0 === h) {
        const t = s?.renderBefore ?? null;
        e._$litPart$ = h = new $220bfac40b25302d$var$k(i.insertBefore($220bfac40b25302d$var$c(), t), t, void 0, s ?? {});
    }
    return h._$AI(t), h;
};

});

parcelRegister("l0Nlx", function(module, exports) {
$parcel$export(module.exports, "css", () => (parcelRequire("1EWBs")).css);
$parcel$export(module.exports, "ReactiveElement", () => (parcelRequire("4ZnnD")).ReactiveElement);
$parcel$export(module.exports, "html", () => (parcelRequire("2Vehe")).html);
$parcel$export(module.exports, "noChange", () => (parcelRequire("2Vehe")).noChange);
$parcel$export(module.exports, "render", () => (parcelRequire("2Vehe")).render);

$parcel$export(module.exports, "LitElement", () => $f4bfe0349ce87ffa$export$3f2f9f5909897157);

var $4ZnnD = parcelRequire("4ZnnD");

var $2Vehe = parcelRequire("2Vehe");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $f4bfe0349ce87ffa$var$s = globalThis;
class $f4bfe0349ce87ffa$export$3f2f9f5909897157 extends (0, $4ZnnD.ReactiveElement) {
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this._$Do = void 0;
    }
    createRenderRoot() {
        const t = super.createRenderRoot();
        return this.renderOptions.renderBefore ??= t.firstChild, t;
    }
    update(t) {
        const r = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Do = (0, $2Vehe.render)(r, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        super.connectedCallback(), this._$Do?.setConnected(!0);
    }
    disconnectedCallback() {
        super.disconnectedCallback(), this._$Do?.setConnected(!1);
    }
    render() {
        return 0, $2Vehe.noChange;
    }
}
$f4bfe0349ce87ffa$export$3f2f9f5909897157._$litElement$ = !0, $f4bfe0349ce87ffa$export$3f2f9f5909897157["finalized"] = !0, $f4bfe0349ce87ffa$var$s.litElementHydrateSupport?.({
    LitElement: $f4bfe0349ce87ffa$export$3f2f9f5909897157
});
const $f4bfe0349ce87ffa$var$o = $f4bfe0349ce87ffa$var$s.litElementPolyfillSupport;
$f4bfe0349ce87ffa$var$o?.({
    LitElement: $f4bfe0349ce87ffa$export$3f2f9f5909897157
});
const $f4bfe0349ce87ffa$export$f5c524615a7708d6 = {
    _$AK: (t, e, r)=>{
        t._$AK(e, r);
    },
    _$AL: (t)=>t._$AL
};
($f4bfe0349ce87ffa$var$s.litElementVersions ??= []).push("4.2.2");

});

parcelRegister("l4Cyq", function(module, exports) {
/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $f577e0c1af5039cc$export$6acf61af03e62db = !1;

});


parcelRegister("2NKH4", function(module, exports) {
$parcel$export(module.exports, "customElement", () => (parcelRequire("jZi7J")).customElement);
$parcel$export(module.exports, "property", () => (parcelRequire("lANGx")).property);
$parcel$export(module.exports, "state", () => (parcelRequire("ejp6K")).state);
parcelRequire("jZi7J");
parcelRequire("lANGx");
parcelRequire("ejp6K");
parcelRequire("kGC2V");
parcelRequire("f8EbF");
parcelRequire("lSujT");
parcelRequire("1dnoQ");
parcelRequire("3dKl1");
parcelRequire("bnqm1");

});
parcelRegister("jZi7J", function(module, exports) {

$parcel$export(module.exports, "customElement", () => $e8d1c5ce6ba73c35$export$da64fc29f17f9d0e);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $e8d1c5ce6ba73c35$export$da64fc29f17f9d0e = (t)=>(e, o)=>{
        void 0 !== o ? o.addInitializer(()=>{
            customElements.define(t, e);
        }) : customElements.define(t, e);
    };

});

parcelRegister("lANGx", function(module, exports) {

$parcel$export(module.exports, "property", () => $fb83802c602b9365$export$d541bacb2bda4494);

var $4ZnnD = parcelRequire("4ZnnD");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $fb83802c602b9365$var$o = {
    attribute: !0,
    type: String,
    converter: (0, $4ZnnD.defaultConverter),
    reflect: !1,
    hasChanged: (0, $4ZnnD.notEqual)
}, $fb83802c602b9365$export$8d623b1670eb40f4 = (t = $fb83802c602b9365$var$o, e, r)=>{
    const { kind: n, metadata: i } = r;
    let s = globalThis.litPropertyMetadata.get(i);
    if (void 0 === s && globalThis.litPropertyMetadata.set(i, s = new Map), "setter" === n && ((t = Object.create(t)).wrapped = !0), s.set(r.name, t), "accessor" === n) {
        const { name: o } = r;
        return {
            set (r) {
                const n = e.get.call(this);
                e.set.call(this, r), this.requestUpdate(o, n, t, !0, r);
            },
            init (e) {
                return void 0 !== e && this.C(o, void 0, t, e), e;
            }
        };
    }
    if ("setter" === n) {
        const { name: o } = r;
        return function(r) {
            const n = this[o];
            e.call(this, r), this.requestUpdate(o, n, t, !0, r);
        };
    }
    throw Error("Unsupported decorator location: " + n);
};
function $fb83802c602b9365$export$d541bacb2bda4494(t) {
    return (e, o)=>"object" == typeof o ? $fb83802c602b9365$export$8d623b1670eb40f4(t, e, o) : ((t, e, o)=>{
            const r = e.hasOwnProperty(o);
            return e.constructor.createProperty(o, t), r ? Object.getOwnPropertyDescriptor(e, o) : void 0;
        })(t, e, o);
}

});

parcelRegister("ejp6K", function(module, exports) {

$parcel$export(module.exports, "state", () => $a6b650eb129c48a5$export$ca000e230c0caa3e);

var $lANGx = parcelRequire("lANGx");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $a6b650eb129c48a5$export$ca000e230c0caa3e(r) {
    return (0, $lANGx.property)({
        ...r,
        state: !0,
        attribute: !1
    });
}

});

parcelRegister("kGC2V", function(module, exports) {
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $f0f53e0e40395ff5$export$b2b799818fbabcf3(t) {
    return (n, o)=>{
        const c = "function" == typeof n ? n : n[o];
        Object.assign(c, t);
    };
}

});

parcelRegister("f8EbF", function(module, exports) {

var $jsQe1 = parcelRequire("jsQe1");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $b056c6b3b1ac98ca$export$2fa187e846a241c4(e, r) {
    return (n, s, i)=>{
        const o = (t)=>t.renderRoot?.querySelector(e) ?? null;
        if (r) {
            const { get: e, set: r } = "object" == typeof s ? n : i ?? (()=>{
                const t = Symbol();
                return {
                    get () {
                        return this[t];
                    },
                    set (e) {
                        this[t] = e;
                    }
                };
            })();
            return (0, $jsQe1.desc)(n, s, {
                get () {
                    let t = e.call(this);
                    return void 0 === t && (t = o(this), (null !== t || this.hasUpdated) && r.call(this, t)), t;
                }
            });
        }
        return (0, $jsQe1.desc)(n, s, {
            get () {
                return o(this);
            }
        });
    };
}

});
parcelRegister("jsQe1", function(module, exports) {

$parcel$export(module.exports, "desc", () => $e2b924b170ffbcd9$export$51987bb50e1f6752);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $e2b924b170ffbcd9$export$51987bb50e1f6752 = (e, t, c)=>(c.configurable = !0, c.enumerable = !0, Reflect.decorate && "object" != typeof t && Object.defineProperty(e, t, c), c);

});


parcelRegister("lSujT", function(module, exports) {

var $jsQe1 = parcelRequire("jsQe1");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ let $fed629061fda5664$var$e;
function $fed629061fda5664$export$dcd0d083aa86c355(r) {
    return (n, o)=>(0, $jsQe1.desc)(n, o, {
            get () {
                return (this.renderRoot ?? ($fed629061fda5664$var$e ??= document.createDocumentFragment())).querySelectorAll(r);
            }
        });
}

});

parcelRegister("1dnoQ", function(module, exports) {

var $jsQe1 = parcelRequire("jsQe1");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $0e2928074ed875e3$export$163dfc35cc43f240(r) {
    return (n, e)=>(0, $jsQe1.desc)(n, e, {
            async get () {
                return await this.updateComplete, this.renderRoot?.querySelector(r) ?? null;
            }
        });
}

});

parcelRegister("3dKl1", function(module, exports) {

var $jsQe1 = parcelRequire("jsQe1");
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $258687c0e8f8121f$export$4682af2d9ee91415(o) {
    return (e, n)=>{
        const { slot: r, selector: s } = o ?? {}, c = "slot" + (r ? `[name=${r}]` : ":not([name])");
        return (0, $jsQe1.desc)(e, n, {
            get () {
                const t = this.renderRoot?.querySelector(c), e = t?.assignedElements(o) ?? [];
                return void 0 === s ? e : e.filter((t)=>t.matches(s));
            }
        });
    };
}

});

parcelRegister("bnqm1", function(module, exports) {

var $jsQe1 = parcelRequire("jsQe1");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $8486491512a44c7e$export$1bdbe53f9df1b8(n) {
    return (o, r)=>{
        const { slot: e } = n ?? {}, s = "slot" + (e ? `[name=${e}]` : ":not([name])");
        return (0, $jsQe1.desc)(o, r, {
            get () {
                const t = this.renderRoot?.querySelector(s);
                return t?.assignedNodes(n) ?? [];
            }
        });
    };
}

});


parcelRegister("hkQda", function(module, exports) {

$parcel$export(module.exports, "getLastError", () => $ae51195f0c3e233a$export$81653e03beef80d0);
$parcel$export(module.exports, "setLastError", () => $ae51195f0c3e233a$export$b1412c8bbe3eb596);
$parcel$export(module.exports, "getTempUnitCelsiusSelected", () => $ae51195f0c3e233a$export$625685512b0e0fe0);
$parcel$export(module.exports, "setTempUnitCelsiusSelected", () => $ae51195f0c3e233a$export$b83c41930b1450f5);
$parcel$export(module.exports, "clamp", () => $ae51195f0c3e233a$export$7d15b64cf5a3a4c4);
$parcel$export(module.exports, "getTimeElapsed", () => $ae51195f0c3e233a$export$7473b68664130e63);
$parcel$export(module.exports, "orderAirCurtains", () => $ae51195f0c3e233a$export$7c728272e6197682);
$parcel$export(module.exports, "isTimeStampLast24hrs", () => $ae51195f0c3e233a$export$492a7560d4a0cebb);
$parcel$export(module.exports, "LANDING_PAGE", () => $ae51195f0c3e233a$export$babdbb7ea7999cc6);
$parcel$export(module.exports, "ROLES", () => $ae51195f0c3e233a$export$d1cfdc29cbc61821);
$parcel$export(module.exports, "ROLES_TO_LABELS", () => $ae51195f0c3e233a$export$12bd2784b372792d);
$parcel$export(module.exports, "ORGANIZATION_TABS", () => $ae51195f0c3e233a$export$2cb9540fb5d7282a);
$parcel$export(module.exports, "MODAL_ACTIONS", () => $ae51195f0c3e233a$export$a3c7910768c19a6f);
$parcel$export(module.exports, "RANGE_VALUES_TO_LABELS", () => $ae51195f0c3e233a$export$6986fce0cf2d4b72);
$parcel$export(module.exports, "MEASUREMENT_VALUES_TO_LABELS", () => $ae51195f0c3e233a$export$4c0056c38403b703);
$parcel$export(module.exports, "UNITS_SPACE_PREFIX", () => $ae51195f0c3e233a$export$b1ffabc43e2bfe98);
$parcel$export(module.exports, "UNITS_PLURAL", () => $ae51195f0c3e233a$export$5ce8e17e098e4c4a);
$parcel$export(module.exports, "UNITS_PRECEDING_VALUE", () => $ae51195f0c3e233a$export$7495e0907199bd51);
$parcel$export(module.exports, "validatePasswordString", () => $ae51195f0c3e233a$export$fc90d7d67eafb9e5);
$parcel$export(module.exports, "validateEmailString", () => $ae51195f0c3e233a$export$92ddf8bc2eec6fd0);
$parcel$export(module.exports, "validateAddress", () => $ae51195f0c3e233a$export$f78173835dcde49f);
$parcel$export(module.exports, "APP_STATES", () => $ae51195f0c3e233a$export$83088745492308cf);
$parcel$export(module.exports, "EVENTS", () => $ae51195f0c3e233a$export$fa3d5b535a2458a1);
$parcel$export(module.exports, "POWER_CYCLES", () => $ae51195f0c3e233a$export$6d6184e613efd200);
$parcel$export(module.exports, "APPLICATION_TYPES", () => $ae51195f0c3e233a$export$ba32dcfc30108500);
$parcel$export(module.exports, "ENERGY_TYPES", () => $ae51195f0c3e233a$export$aa6a187e88fac841);
$parcel$export(module.exports, "closeDropdownMenus", () => $ae51195f0c3e233a$export$88d8fd4fec5c7c1e);
$parcel$export(module.exports, "inviteUser", () => $ae51195f0c3e233a$export$f5ec01bd6261fcdd);
$parcel$export(module.exports, "getLatLngByPlaceId", () => $ae51195f0c3e233a$export$6c8d89de51badc70);
$parcel$export(module.exports, "getAddressPredictions", () => $ae51195f0c3e233a$export$437076acd04a4d15);
$parcel$export(module.exports, "getCurrentIdentity", () => $ae51195f0c3e233a$export$c25cb62a427db7f4);
$parcel$export(module.exports, "getCurrentUser", () => $ae51195f0c3e233a$export$e5432d4c8eb97ea7);
$parcel$export(module.exports, "updateSiteCosts", () => $ae51195f0c3e233a$export$2365160311df4228);
$parcel$export(module.exports, "updateSite", () => $ae51195f0c3e233a$export$ef27de145f32175f);
$parcel$export(module.exports, "overwriteDefaultSite", () => $ae51195f0c3e233a$export$b4c8f45eb46eb3e8);
$parcel$export(module.exports, "createSite", () => $ae51195f0c3e233a$export$fa811a3abc776c3c);
$parcel$export(module.exports, "throttle", () => $ae51195f0c3e233a$export$de363e709c412c8a);
$parcel$export(module.exports, "loadStyle", () => $ae51195f0c3e233a$export$19ee74019545dfb9);
$parcel$export(module.exports, "tempUnitButtonClickHandler", () => $ae51195f0c3e233a$export$98b42e8bf1260c74);
$parcel$export(module.exports, "dropDownClickHandler", () => $ae51195f0c3e233a$export$7464dbd85cfc05bf);
$parcel$export(module.exports, "renderDropDown", () => $ae51195f0c3e233a$export$6d87b1245057018);
parcelRequire("hIPiC");
var $g0OFw = parcelRequire("g0OFw");

var $f9eUc = parcelRequire("f9eUc");

var $93EVF = parcelRequire("93EVF");

var $ifhNi = parcelRequire("ifhNi");
parcelRequire("k6o0V");
var $2Vehe = parcelRequire("2Vehe");
parcelRequire("2BCvg");
var $Txkvx = parcelRequire("Txkvx");
parcelRequire("jRqJ2");
var $3q9Vf = parcelRequire("3q9Vf");

var $ht1kU = parcelRequire("ht1kU");
const $ae51195f0c3e233a$var$googleMaps = globalThis.google.maps;
const $ae51195f0c3e233a$var$geocoder = new $ae51195f0c3e233a$var$googleMaps.Geocoder();
const $ae51195f0c3e233a$var$autocompleteService = new $ae51195f0c3e233a$var$googleMaps.places.AutocompleteService();
let $ae51195f0c3e233a$var$_lastError = undefined;
function $ae51195f0c3e233a$export$81653e03beef80d0() {
    return $ae51195f0c3e233a$var$_lastError;
}
function $ae51195f0c3e233a$export$b1412c8bbe3eb596(error) {
    $ae51195f0c3e233a$var$_lastError = error;
}
let $ae51195f0c3e233a$var$_tempUnitCelsiusSelected = (0, $ht1kU.getFromLocalStorage)('temperature-unit') === 'celsius';
function $ae51195f0c3e233a$export$625685512b0e0fe0() {
    return $ae51195f0c3e233a$var$_tempUnitCelsiusSelected;
}
function $ae51195f0c3e233a$export$b83c41930b1450f5(tempUnitCelsiusSelected) {
    (0, $ht1kU.saveToLocalStorage)('temperature-unit', tempUnitCelsiusSelected ? 'celsius' : 'fahrenheit');
    $ae51195f0c3e233a$var$_tempUnitCelsiusSelected = tempUnitCelsiusSelected;
}
function $ae51195f0c3e233a$export$7d15b64cf5a3a4c4(num, min, max) {
    return Math.min(Math.max(num, min), max);
}
const $ae51195f0c3e233a$export$7473b68664130e63 = (timeStamp)=>{
    const old = (0, $ifhNi.dateToUTCDate)(new Date(timeStamp * 1000)).getTime();
    const now = (0, $ifhNi.dateToUTCDate)(new Date()).getTime();
    const diffMS = now - old;
    const hours = Math.floor(diffMS / 3600000);
    const days = Math.floor(diffMS / 86400000);
    const weeks = Math.floor(diffMS / 604800000);
    const months = Math.floor(diffMS / 2592000000);
    const years = Math.floor(diffMS / 31536000000);
    let elapsed = '';
    if (years) elapsed = `${years} year${years > 1 ? 's' : ''} ago`;
    else if (months) elapsed = `${months} month${months > 1 ? 's' : ''} ago`;
    else if (weeks) elapsed = `${weeks} week${weeks > 1 ? 's' : ''} ago`;
    else if (days) elapsed = `${days} day${days > 1 ? 's' : ''} ago`;
    else if (hours) elapsed = `${hours} hour${hours > 1 ? 's' : ''} ago`;
    else elapsed = `minutes ago`;
    return elapsed;
};
const $ae51195f0c3e233a$export$7c728272e6197682 = (airCurtainsBySite)=>{
    const airCurtainSitePairs = [];
    for (const site of airCurtainsBySite.keys()){
        const siteCurtains = airCurtainsBySite.get(site);
        for (const curtain of siteCurtains)airCurtainSitePairs.push({
            curtain: curtain,
            site: site
        });
    }
    const connectedCurtainsNoTimeStamps = airCurtainSitePairs.filter((a)=>a.curtain.connected && !a.curtain.connectivityTimestamp);
    const connectedCurtainsWithTimeStamps = airCurtainSitePairs.filter((a)=>a.curtain.connected && a.curtain.connectivityTimestamp);
    const unConnectedCurtainsNoTimeStamps = airCurtainSitePairs.filter((a)=>!a.curtain.connected && !a.curtain.connectivityTimestamp);
    const unConnectedCurtainsWithTimeStamps = airCurtainSitePairs.filter((a)=>!a.curtain.connected && a.curtain.connectivityTimestamp);
    const sortbyLastConnected = (a, b)=>{
        return a.curtain.connectivityTimestamp > b.curtain.connectivityTimestamp ? -1 : 1;
    };
    const sortbyName = (a, b)=>{
        return a.curtain.name.toUpperCase() < b.curtain.name.toUpperCase() ? -1 : 1;
    };
    connectedCurtainsNoTimeStamps.sort(sortbyName);
    connectedCurtainsWithTimeStamps.sort(sortbyLastConnected);
    unConnectedCurtainsNoTimeStamps.sort(sortbyName);
    unConnectedCurtainsWithTimeStamps.sort(sortbyLastConnected);
    return connectedCurtainsWithTimeStamps.concat(connectedCurtainsNoTimeStamps).concat(unConnectedCurtainsWithTimeStamps).concat(unConnectedCurtainsNoTimeStamps);
};
function $ae51195f0c3e233a$export$492a7560d4a0cebb(timestamp) {
    const date = new Date();
    date.setTime(timestamp * 1000);
    const yesterday = (0, $ifhNi.getDateMinusRange)((0, $ifhNi.RANGES).ONE_DAY, (0, $ifhNi.dateToUTCDate)(new Date()));
    yesterday.setHours(0);
    return date > yesterday;
}
const $ae51195f0c3e233a$export$babdbb7ea7999cc6 = 'content/dashboard';
const $ae51195f0c3e233a$export$d1cfdc29cbc61821 = {
    OWNER: 'Owner',
    USER: 'User',
    REP: 'Rep'
};
const $ae51195f0c3e233a$export$12bd2784b372792d = new Map([
    [
        $ae51195f0c3e233a$export$d1cfdc29cbc61821.OWNER,
        'Owner'
    ],
    [
        $ae51195f0c3e233a$export$d1cfdc29cbc61821.USER,
        'User'
    ],
    [
        $ae51195f0c3e233a$export$d1cfdc29cbc61821.REP,
        'Representative'
    ]
]);
const $ae51195f0c3e233a$export$2cb9540fb5d7282a = {
    OVERVIEW: 'OVERVIEW',
    AIRCURTAINS: 'AIRCURTAINS'
};
const $ae51195f0c3e233a$export$a3c7910768c19a6f = {
    DELETE_CURTAIN: 'DELETE_CURTAIN',
    DELETE_SITE: 'DELETE_SITE',
    SEND_INVITE: 'SEND_INVITE'
};
const $ae51195f0c3e233a$export$6986fce0cf2d4b72 = new Map([
    [
        'one_day',
        '24 hours'
    ],
    [
        'two_days',
        '48 hours'
    ],
    [
        'weekly',
        'Weekly'
    ],
    [
        'monthly',
        'Monthly'
    ],
    [
        'yearly',
        'Yearly'
    ]
]);
const $ae51195f0c3e233a$export$4c0056c38403b703 = new Map([
    [
        'avgTemperature',
        'Average Temperature'
    ],
    [
        'maxTemperature',
        'Max Temperature'
    ],
    [
        'minTemperature',
        'Min Temperature'
    ],
    [
        'doorOpenCount',
        'Door Open Count'
    ],
    [
        'btu',
        'BTU'
    ],
    [
        'tonGainRate',
        'Ton Gain Rate'
    ],
    [
        'loss',
        'Loss'
    ],
    [
        'grossSaving',
        'Gross Saving'
    ],
    [
        'costToOperate',
        'Cost To Operate'
    ],
    [
        'savings',
        'Savings'
    ],
    [
        'doorOpenTime',
        'Door Open Time'
    ],
    [
        'efficiency',
        'Efficiency'
    ]
]);
const $ae51195f0c3e233a$export$b1ffabc43e2bfe98 = [
    "min",
    "hour",
    "Btu",
    "TR"
];
const $ae51195f0c3e233a$export$5ce8e17e098e4c4a = [
    "min",
    "hour"
];
const $ae51195f0c3e233a$export$7495e0907199bd51 = [
    "$"
];
const $ae51195f0c3e233a$export$fc90d7d67eafb9e5 = (passwordInput)=>{
    return Boolean(passwordInput.trim()) && passwordInput.trim().length > 6;
};
const $ae51195f0c3e233a$export$92ddf8bc2eec6fd0 = (emailInput)=>{
    if (!emailInput.trim()) return false;
    const mailFormat = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    return emailInput.match(mailFormat) !== null;
};
const $ae51195f0c3e233a$export$f78173835dcde49f = (inputText)=>{
    return Boolean(inputText?.trim()) && inputText?.trim().length >= 5;
};
const $ae51195f0c3e233a$export$83088745492308cf = {
    INITIAL_SIGNUP: 'INITIAL_SIGNUP',
    LOGGING_IN: 'LOGGING_IN',
    LOGGED_IN: 'LOGGED_IN',
    PASSWORD_RESET: 'PASSWORD_RESET',
    PASSWORD_RESET_VALIDATE: 'PASSWORD_RESET_VALIDATE',
    CREATE_ORG: 'CREATE_ORG'
};
const $ae51195f0c3e233a$export$fa3d5b535a2458a1 = {
    CLICK_OUT: 'CLICK_OUT',
    CLOSE_MODAL: 'CLOSE_MODAL',
    NAVIGATE: 'NAVIGATE',
    SITE_SELECTED: 'SITE_SELECTED',
    CURTAIN_SELECTED: 'CURTAIN_SELECTED',
    NAV_BAR_COLLAPSE_CHANGE: 'NAV_BAR_COLLAPSE_CHANGE',
    CHART_RENDERED: 'CHART_RENDERED',
    MINIMAL_DATA_CACHED: 'MINIMAL_DATA_CACHED',
    ALL_DATA_CACHED: 'ALL_DATA_CACHED',
    DATA_UPDATED: 'DATA_UPDATED',
    SHOW_REMOVE_CURTAIN: 'SHOW_REMOVE_CURTAIN',
    SHOW_UPDATE_CURTAIN: 'SHOW_UPDATE_CURTAIN',
    SHOW_CURTAIN_INFO: 'SHOW_CURTAIN_INFO',
    CHANGE_TEMP_UNIT: 'CHANGE_TEMP_UNIT'
};
var $ae51195f0c3e233a$export$6d6184e613efd200 = /*#__PURE__*/ function(POWER_CYCLES) {
    POWER_CYCLES[POWER_CYCLES["FIFTY_HZ"] = 0] = "FIFTY_HZ";
    POWER_CYCLES[POWER_CYCLES["SIXTY_HZ"] = 1] = "SIXTY_HZ";
    return POWER_CYCLES;
}({});
const $ae51195f0c3e233a$export$d4c8db9df56aeb7b = {
    ASCENDING: 'asc',
    DESCENDING: 'desc'
};
var $ae51195f0c3e233a$export$ba32dcfc30108500 = /*#__PURE__*/ function(APPLICATION_TYPES) {
    APPLICATION_TYPES[APPLICATION_TYPES["OUTSIDE"] = 1] = "OUTSIDE";
    APPLICATION_TYPES[APPLICATION_TYPES["UNCONDITIONED"] = 2] = "UNCONDITIONED";
    return APPLICATION_TYPES;
}({});
var $ae51195f0c3e233a$export$aa6a187e88fac841 = /*#__PURE__*/ function(ENERGY_TYPES) {
    ENERGY_TYPES["ELECTRIC"] = "e";
    ENERGY_TYPES["GAS"] = "g";
    ENERGY_TYPES["OIL"] = "o";
    return ENERGY_TYPES;
}({});
function $ae51195f0c3e233a$export$88d8fd4fec5c7c1e(shadowRoot) {
    const dropDownBtns = shadowRoot.querySelectorAll('.dropdown-toggle');
    for (const btn of dropDownBtns)btn.setAttribute('aria-expanded', 'false');
    const dropDownMenus = shadowRoot.querySelectorAll('.dropdown-menu');
    for (const menu of dropDownMenus)menu.classList.remove('show');
}
async function $ae51195f0c3e233a$export$f5ec01bd6261fcdd(userName, email, objectManager) {
    const siteGroup = objectManager.getSiteGroup();
    const site = objectManager.getSite(siteGroup.sites[0]);
    const user = objectManager.createUser(userName, '', '');
    const userGroup = objectManager.getUserGroup(site.userGroups[0]);
    const roles = objectManager.getAllRoles();
    const userRoleIndex = roles.findIndex((role)=>{
        return role.name == 'User';
    });
    // link role to user
    objectManager.addRoleToUser(user, roles[userRoleIndex]);
    // link user to user group
    objectManager.addUserToUserGroup(userGroup, user);
    // save modified objects
    const userSaved = await user.save();
    if (!userSaved) {
        console.error(user.lastError);
        await user.delete();
        return false;
    }
    const userGroupSaved = await userGroup.save();
    if (!userGroupSaved) {
        console.error(userGroup.lastError);
        await user.delete();
        return false;
    }
    user.headObjectID = site.siteID;
    user.headObjectType = 'site';
    const invitationResult = await objectManager.invite(user, email);
    if (!invitationResult.result) {
        objectManager.removeUserFromUserGroup(userGroup, user);
        await user.delete();
        await userGroup.save();
        $ae51195f0c3e233a$export$b1412c8bbe3eb596(invitationResult.error);
    }
    return invitationResult.result;
}
async function $ae51195f0c3e233a$export$6c8d89de51badc70(placeId) {
    let response;
    let errorMessage = undefined;
    try {
        response = await $ae51195f0c3e233a$var$geocoder.geocode({
            placeId: placeId
        });
    } catch (error) {
        errorMessage = error;
        console.error(error);
    }
    const result = response?.results[0];
    if (errorMessage || !result?.geometry?.location?.lat) return {
        error: errorMessage,
        lat_lng: {
            lat: undefined,
            lng: undefined
        }
    };
    else return {
        error: undefined,
        lat_lng: {
            lat: result.geometry.location.lat(),
            lng: result.geometry.location.lng()
        }
    };
}
async function $ae51195f0c3e233a$export$437076acd04a4d15(partialAddress) {
    let response;
    let errorMessage = undefined;
    try {
        response = await $ae51195f0c3e233a$var$autocompleteService.getPlacePredictions({
            input: partialAddress
        });
    } catch (error) {
        errorMessage = error;
        console.error(error);
    }
    if (errorMessage || !response?.predictions?.length) return {
        error: errorMessage,
        predictions: [
            {
                description: undefined,
                place_id: undefined
            }
        ]
    };
    else {
        const predictions = [];
        response.predictions.forEach((prediction)=>{
            predictions.push({
                description: prediction.description,
                place_id: prediction.place_id
            });
        });
        return {
            error: "",
            predictions: predictions
        };
    }
}
async function $ae51195f0c3e233a$export$c25cb62a427db7f4(objectManager) {
    const session = await (0, $g0OFw.Auth).currentSession();
    const identityID = session.getAccessToken().payload.sub;
    const identity = await objectManager.getIdentity(identityID);
    if (!identity) console.warn(objectManager.lastError);
    return identity;
}
async function $ae51195f0c3e233a$export$e5432d4c8eb97ea7(objectManager) {
    const identity = await $ae51195f0c3e233a$export$c25cb62a427db7f4(objectManager);
    if (identity) {
        // currently 1-1 identity to user
        const userId = identity.users[0];
        const user = await objectManager.getUser(userId);
        if (!user) console.warn(objectManager.lastError);
        return user;
    } else {
        console.warn(objectManager.lastError);
        return null;
    }
}
async function $ae51195f0c3e233a$export$2365160311df4228(objectManager, siteId, gasRate, electricityRate, oilRate, powerCycles) {
    const site = objectManager.getSite(siteId);
    const siteGroup = objectManager.getSiteGroup();
    const location = await objectManager.getLocation(site.siteID);
    location.naturalGasRate = gasRate;
    location.electricityRate = electricityRate;
    location.oilRate = oilRate;
    location.powerCycles = powerCycles === 0 ? 50 : 60;
    const locationSaved = await location.save();
    if (!locationSaved) {
        $ae51195f0c3e233a$var$_lastError = location.lastError;
        return false;
    }
    const siteSaved = await site.save();
    if (!siteSaved) {
        $ae51195f0c3e233a$var$_lastError = site.lastError;
        return false;
    }
    const siteGroupSaved = await siteGroup.save();
    if (!siteGroupSaved) {
        $ae51195f0c3e233a$var$_lastError = siteGroup.lastError;
        return false;
    }
    return true;
}
async function $ae51195f0c3e233a$export$ef27de145f32175f(objectManager, site, siteName, gasRate, electricityRate, oilRate, lat, lng, address, powerCycles) {
    site.name = siteName;
    const location = await objectManager.getLocation(site.siteID);
    location.naturalGasRate = gasRate;
    location.electricityRate = electricityRate;
    location.oilRate = oilRate;
    location.powerCycles = powerCycles === 0 ? 50 : 60;
    location.latitude = lat;
    location.longitude = lng;
    location.postalCode = address;
    const locationSaved = await location.save();
    if (!locationSaved) {
        $ae51195f0c3e233a$var$_lastError = location.lastError;
        return false;
    }
    const siteSaved = await site.save();
    if (!siteSaved) {
        $ae51195f0c3e233a$var$_lastError = site.lastError;
        return false;
    }
    return true;
}
async function $ae51195f0c3e233a$export$b4c8f45eb46eb3e8(objectManager, siteName, gasRate, electricityRate, oilRate, lat, lng, address, powerCycles) {
    const siteGroup = objectManager.getSiteGroup();
    const siteGroupLoaded = await siteGroup.load();
    if (!siteGroupLoaded) {
        $ae51195f0c3e233a$var$_lastError = siteGroup.lastError;
        return false;
    }
    let defaultSite;
    for (const siteId of siteGroup.sites){
        const site = objectManager.getSite(siteId);
        const siteLoaded = await site.load();
        if (!siteLoaded) {
            $ae51195f0c3e233a$var$_lastError = siteGroup.lastError;
            return false;
        }
        if (site.name === "default site") defaultSite = site;
    }
    if (defaultSite) {
        defaultSite.name = siteName;
        const defaultSiteLocation = objectManager.createLocation(defaultSite.siteID, lat, lng, gasRate, electricityRate, oilRate, 60, address);
        const savedLocation = await defaultSiteLocation.save();
        if (!savedLocation) {
            $ae51195f0c3e233a$var$_lastError = defaultSiteLocation.lastError;
            return false;
        }
        const savedSite = await defaultSite.save();
        if (!savedSite) {
            $ae51195f0c3e233a$var$_lastError = defaultSite.lastError;
            return false;
        }
        return true;
    } else return false;
}
async function $ae51195f0c3e233a$export$fa811a3abc776c3c(objectManager, siteName, gasRate, electricityRate, oilRate, lat, lng, address, powerCycles) {
    const airCurtainGroup = (0, $f9eUc.AirCurtainGroup).createNew();
    const userGroup = (0, $93EVF.UserGroup).createNew();
    const siteGroup = objectManager.getSiteGroup();
    const account = objectManager.getAccount();
    const site = objectManager.createSite(siteName);
    const organization = objectManager.getOrganization();
    airCurtainGroup.accountID = account.accountID;
    airCurtainGroup.name = 'Air Curtains';
    airCurtainGroup.parentObjectID = site.siteID;
    airCurtainGroup.parentObjectType = 'site';
    site.addAirCurtainGroup(airCurtainGroup);
    userGroup.accountID = account.accountID;
    userGroup.name = 'Users';
    userGroup.parentObjectID = site.siteID;
    userGroup.parentObjectType = 'site';
    site.addUserGroup(userGroup);
    // add new site to site group
    objectManager.addSiteToSiteGroup(siteGroup, site);
    const airCurtainGroupSaved = await airCurtainGroup.save();
    if (!airCurtainGroupSaved) {
        $ae51195f0c3e233a$var$_lastError = airCurtainGroup.lastError;
        return false;
    }
    const userGroupSaved = await userGroup.save();
    if (!userGroupSaved) {
        $ae51195f0c3e233a$var$_lastError = userGroup.lastError;
        return false;
    }
    const siteSaved = await site.save();
    if (!siteSaved) {
        $ae51195f0c3e233a$var$_lastError = site.lastError;
        return false;
    }
    const siteGroupSaved = await siteGroup.save();
    if (!siteGroupSaved) {
        $ae51195f0c3e233a$var$_lastError = siteGroup.lastError;
        return false;
    }
    const location = objectManager.createLocation(site.siteID, lat, lng, gasRate, electricityRate, oilRate, 60, address);
    const locationSaved = await location.save();
    if (!locationSaved) {
        $ae51195f0c3e233a$var$_lastError = location.lastError;
        return false;
    }
    const organizationSaved = await organization.save();
    if (!organizationSaved) {
        $ae51195f0c3e233a$var$_lastError = organization.lastError;
        return false;
    }
    const initObjectManager = await objectManager.initialize();
    if (!initObjectManager) console.error('failed to re-initialize object Manager');
    return true;
}
const $ae51195f0c3e233a$export$6bd2d967532977ea = (direction, data, slicedData, state, sortField)=>{
    // if no direction just present unsorted data
    if (direction) data.sort((a, b)=>{
        if (a[sortField] === b[sortField]) return 0;
        if (direction === $ae51195f0c3e233a$export$d4c8db9df56aeb7b.ASCENDING) return a[sortField] < b[sortField] ? -1 : 1;
        else return a[sortField] > b[sortField] ? -1 : 1;
    });
    slicedData = data.slice(0, state.linesPerPage);
    return {
        slicedData: slicedData,
        data: data
    };
};
let $ae51195f0c3e233a$var$lastTime = 0;
function $ae51195f0c3e233a$export$de363e709c412c8a(func, timeFrame) {
    return function() {
        const now = new Date().getTime();
        if (now - $ae51195f0c3e233a$var$lastTime >= timeFrame) {
            func();
            $ae51195f0c3e233a$var$lastTime = now;
        }
    };
}
function $ae51195f0c3e233a$export$19ee74019545dfb9(cssUrl, shadowRoot) {
    return new Promise((resolve)=>{
        const link = shadowRoot.getElementById('css-target');
        if (!link) {
            console.error(`failed to find link element when loading: ${cssUrl}`);
            resolve(false);
        }
        link.type = 'text/css';
        link.rel = 'stylesheet';
        link.onload = ()=>{
            shadowRoot.getElementById('root').classList.remove('css-loading');
            resolve(true);
        };
        link.onerror = ()=>{
            console.error('error loading: ', cssUrl);
            resolve(false);
        };
        link.href = cssUrl;
        const headScript = shadowRoot.getElementById('root');
        if (headScript) {
            // reset splash screen body image (np if already done)
            const body = document.body;
            body.style.backgroundColor = 'white';
            body.style.backgroundImage = '';
            body.style.backgroundSize = 'auto';
            body.style.backgroundPosition = '0% 0%';
            headScript.parentNode.insertBefore(link, headScript);
            const logo = document.getElementById('loading-berner-logo');
            if (logo) logo.remove();
        } else {
            console.error(`failed to find root element when loading: ${cssUrl}`);
            resolve(false);
        }
    });
}
function $ae51195f0c3e233a$export$98b42e8bf1260c74(e) {
    $ae51195f0c3e233a$export$b83c41930b1450f5(!$ae51195f0c3e233a$var$_tempUnitCelsiusSelected);
    e.stopPropagation();
}
function $ae51195f0c3e233a$export$7464dbd85cfc05bf(e, shadowRoot) {
    const targetDropDown = e.target.parentElement.querySelector('.dropdown-menu');
    const isShown = targetDropDown.classList.contains('show');
    const dropDowns = shadowRoot.querySelectorAll('.dropdown-menu');
    dropDowns.forEach((dropDown)=>{
        dropDown.classList.remove('show');
    });
    if (isShown) targetDropDown.classList.remove('show');
    else targetDropDown.classList.add('show');
    e.stopPropagation();
}
function $ae51195f0c3e233a$export$6d87b1245057018(_valuesToLabels, values, selected, hideCaret, forceOpen, id, onSelected, shadowRoot) {
    const itemClickHandler = (e)=>{
        const selection = e.target.id.split(/-(.+)/)[1];
        onSelected(selection);
        e.target.parentNode.classList.remove('show');
        e.stopPropagation();
    };
    const label = _valuesToLabels.get(selected);
    return (0, $2Vehe.html)`<div class="filter-item">
        <div class="btn-group ml-1">
            <button
                id=${id + "-button"}
                type="button"
                class=${(0, $Txkvx.classMap)({
        'btn': true,
        'btn-light': true,
        'dropdown-toggle': !hideCaret,
        'd-none': forceOpen
    })}
                data-toggle="dropdown"
                aria-expanded="false"
                @click="${(e)=>$ae51195f0c3e233a$export$7464dbd85cfc05bf(e, shadowRoot)}"
            >
                ${label} <span class="caret"></span>
            </button>
            <div class=${(0, $Txkvx.classMap)({
        "dropdown-menu": true
    })} id=${id}>
                ${(0, $2Vehe.html)`${(0, $3q9Vf.repeat)(values, (rangeValue)=>(0, $2Vehe.html)`<span
                            class="dropdown-item"
                            id=${'option-' + rangeValue}
                            @click=${itemClickHandler}
                            >${_valuesToLabels.get(rangeValue)}</span>`)}`}
            </div>
        </div>
    </div>`;
}

});
parcelRegister("hIPiC", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce6e56b2e875e699$export$2e2bcd8739ae039);
$parcel$export(module.exports, "Auth", () => (parcelRequire("g0OFw")).Auth);
/*
 * Copyright 2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ parcelRequire("8qWqv");
var $a16qJ = parcelRequire("a16qJ");
var $fveJK = parcelRequire("fveJK");
parcelRequire("i14CG");
var $g0OFw = parcelRequire("g0OFw");

var $8SrNO = parcelRequire("8SrNO");


var $iqXB7 = parcelRequire("iqXB7");
var $hnLpK = parcelRequire("hnLpK");
parcelRequire("atl0T");
var $cbbVi = parcelRequire("cbbVi");




var $5osCm = parcelRequire("5osCm");



/** Always importing Auth when users import Amplify such that
    for unauthenticated access (no sign in and sign up),
    users don't have to import Auth explicitly **/ (0, $a16qJ.Amplify).Auth = (0, $g0OFw.Auth);
(0, $a16qJ.Amplify).Cache = (0, $8SrNO.default);
(0, $a16qJ.Amplify).ServiceWorker = (0, $fveJK.ServiceWorkerClass);
var /**
 * @deprecated use named import
 */ $ce6e56b2e875e699$export$2e2bcd8739ae039 = (0, $a16qJ.Amplify);
$parcel$exportWildcard(module.exports, $5osCm);

});
parcelRegister("8qWqv", function(module, exports) {
$parcel$export(module.exports, "browserOrNode", () => (parcelRequire("9Mfkr")).browserOrNode);
$parcel$export(module.exports, "isWebWorker", () => (parcelRequire("9Mfkr")).isWebWorker);
$parcel$export(module.exports, "JS", () => (parcelRequire("9Mfkr")).JS);
$parcel$export(module.exports, "Parser", () => (parcelRequire("7XN1x")).Parser);
$parcel$export(module.exports, "INTERNAL_AWS_APPSYNC_PUBSUB_PROVIDER", () => (parcelRequire("6zWMj")).INTERNAL_AWS_APPSYNC_PUBSUB_PROVIDER);
$parcel$export(module.exports, "INTERNAL_AWS_APPSYNC_REALTIME_PUBSUB_PROVIDER", () => (parcelRequire("6zWMj")).INTERNAL_AWS_APPSYNC_REALTIME_PUBSUB_PROVIDER);
$parcel$export(module.exports, "USER_AGENT_HEADER", () => (parcelRequire("6zWMj")).USER_AGENT_HEADER);
$parcel$export(module.exports, "DateUtils", () => (parcelRequire("fsezd")).DateUtils);
$parcel$export(module.exports, "jitteredExponentialRetry", () => (parcelRequire("7TTzY")).jitteredExponentialRetry);
$parcel$export(module.exports, "NonRetryableError", () => (parcelRequire("7TTzY")).NonRetryableError);
$parcel$export(module.exports, "urlSafeDecode", () => (parcelRequire("7nP18")).urlSafeDecode);
$parcel$export(module.exports, "urlSafeEncode", () => (parcelRequire("7nP18")).urlSafeEncode);

$parcel$export(module.exports, "Constants", () => $623e12ba8cd5a98d$export$a002182e51710d39);
$parcel$export(module.exports, "Platform", () => (parcelRequire("kaH5c")).Platform);
$parcel$export(module.exports, "Amplify", () => (parcelRequire("a16qJ")).Amplify);
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $a16qJ = parcelRequire("a16qJ");

var $kaH5c = parcelRequire("kaH5c");

var $k8Uy9 = parcelRequire("k8Uy9");

var $7UO1b = parcelRequire("7UO1b");


var $kRjsJ = parcelRequire("kRjsJ");

var $bNDL2 = parcelRequire("bNDL2");
parcelRequire("9Mfkr");

var $ap2RT = parcelRequire("ap2RT");
parcelRequire("7XN1x");



var $29OQz = parcelRequire("29OQz");

var $fveJK = parcelRequire("fveJK");

var $4uQfD = parcelRequire("4uQfD");

var $1RES9 = parcelRequire("1RES9");
parcelRequire("6zWMj");
parcelRequire("fsezd");parcelRequire("7TTzY");
var $gIW81 = parcelRequire("gIW81");
var $a97Zu = parcelRequire("a97Zu");parcelRequire("7nP18");
var $623e12ba8cd5a98d$export$a002182e51710d39 = {
    userAgent: (0, $kaH5c.Platform).userAgent
};
var /**
 * @deprecated use named import
 */ $623e12ba8cd5a98d$export$2e2bcd8739ae039 = (0, $a16qJ.Amplify);

});
parcelRegister("a16qJ", function(module, exports) {

$parcel$export(module.exports, "Amplify", () => $74aefc4678cdcae3$export$a3858a9a153cffc7);

var $7UO1b = parcelRequire("7UO1b");
var $74aefc4678cdcae3$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $74aefc4678cdcae3$var$logger = new (0, $7UO1b.ConsoleLogger)('Amplify');
var $74aefc4678cdcae3$export$b412d755cfa0136 = /** @class */ function() {
    function AmplifyClass() {
        // Everything that is `register`ed is tracked here
        this._components = [];
        this._config = {};
        // All modules (with `getModuleName()`) are stored here for dependency injection
        this._modules = {};
        // for backward compatibility to avoid breaking change
        // if someone is using like Amplify.Auth
        this.Auth = null;
        this.Analytics = null;
        this.API = null;
        this.Credentials = null;
        this.Storage = null;
        this.I18n = null;
        this.Cache = null;
        this.PubSub = null;
        this.Interactions = null;
        this.Pushnotification = null;
        this.UI = null;
        this.XR = null;
        this.Predictions = null;
        this.DataStore = null;
        this.Logger = (0, $7UO1b.ConsoleLogger);
        this.ServiceWorker = null;
    }
    AmplifyClass.prototype.register = function(comp) {
        $74aefc4678cdcae3$var$logger.debug('component registered in amplify', comp);
        this._components.push(comp);
        if (typeof comp.getModuleName === 'function') {
            this._modules[comp.getModuleName()] = comp;
            this[comp.getModuleName()] = comp;
        } else $74aefc4678cdcae3$var$logger.debug('no getModuleName method for component', comp);
        // Finally configure this new component(category) loaded
        // With the new modularization changes in Amplify V3, all the Amplify
        // component are not loaded/registered right away but when they are
        // imported (and hence instantiated) in the client's app. This ensures
        // that all new components imported get correctly configured with the
        // configuration that Amplify.configure() was called with.
        comp.configure(this._config);
    };
    AmplifyClass.prototype.configure = function(config) {
        var _this = this;
        if (!config) return this._config;
        this._config = Object.assign(this._config, config);
        $74aefc4678cdcae3$var$logger.debug('amplify config', this._config);
        // Dependency Injection via property-setting.
        // This avoids introducing a public method/interface/setter that's difficult to remove later.
        // Plus, it reduces `if` statements within the `constructor` and `configure` of each module
        Object.entries(this._modules).forEach(function(_a) {
            var _b = $74aefc4678cdcae3$var$__read(_a, 2), Name = _b[0], comp = _b[1];
            // e.g. Auth.*
            Object.keys(comp).forEach(function(property) {
                // e.g. Auth["Credentials"] = this._modules["Credentials"] when set
                if (_this._modules[property]) comp[property] = _this._modules[property];
            });
        });
        this._components.map(function(comp) {
            comp.configure(_this._config);
        });
        return this._config;
    };
    AmplifyClass.prototype.addPluggable = function(pluggable) {
        if (pluggable && pluggable['getCategory'] && typeof pluggable['getCategory'] === 'function') this._components.map(function(comp) {
            if (comp['addPluggable'] && typeof comp['addPluggable'] === 'function') comp.addPluggable(pluggable);
        });
    };
    return AmplifyClass;
}();
var $74aefc4678cdcae3$export$a3858a9a153cffc7 = new $74aefc4678cdcae3$export$b412d755cfa0136();
var /**
 * @deprecated use named import
 */ $74aefc4678cdcae3$export$2e2bcd8739ae039 = $74aefc4678cdcae3$export$a3858a9a153cffc7;

});
parcelRegister("7UO1b", function(module, exports) {

$parcel$export(module.exports, "ConsoleLogger", () => $5c348ff0b9217b35$export$ba6a9c7ac8291f7f);
/*
 * Copyright 2017-2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ var $5c348ff0b9217b35$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $5c348ff0b9217b35$var$__spread = undefined && undefined.__spread || function() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c348ff0b9217b35$var$__read(arguments[i]));
    return ar;
};
var $5c348ff0b9217b35$var$LOG_LEVELS = {
    VERBOSE: 1,
    DEBUG: 2,
    INFO: 3,
    WARN: 4,
    ERROR: 5
};
/**
 * Write logs
 * @class Logger
 */ var $5c348ff0b9217b35$export$ba6a9c7ac8291f7f = /** @class */ function() {
    /**
     * @constructor
     * @param {string} name - Name of the logger
     */ function ConsoleLogger(name, level) {
        if (level === void 0) level = 'WARN';
        this.name = name;
        this.level = level;
    }
    ConsoleLogger.prototype._padding = function(n) {
        return n < 10 ? '0' + n : '' + n;
    };
    ConsoleLogger.prototype._ts = function() {
        var dt = new Date();
        return [
            this._padding(dt.getMinutes()),
            this._padding(dt.getSeconds())
        ].join(':') + '.' + dt.getMilliseconds();
    };
    /**
     * Write log
     * @method
     * @memeberof Logger
     * @param {string} type - log type, default INFO
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype._log = function(type) {
        var msg = [];
        for(var _i = 1; _i < arguments.length; _i++)msg[_i - 1] = arguments[_i];
        var logger_level_name = this.level;
        if (ConsoleLogger.LOG_LEVEL) logger_level_name = ConsoleLogger.LOG_LEVEL;
        if (typeof window !== 'undefined' && window.LOG_LEVEL) logger_level_name = window.LOG_LEVEL;
        var logger_level = $5c348ff0b9217b35$var$LOG_LEVELS[logger_level_name];
        var type_level = $5c348ff0b9217b35$var$LOG_LEVELS[type];
        if (!(type_level >= logger_level)) // Do nothing if type is not greater than or equal to logger level (handle undefined)
        return;
        var log = console.log.bind(console);
        if (type === 'ERROR' && console.error) log = console.error.bind(console);
        if (type === 'WARN' && console.warn) log = console.warn.bind(console);
        var prefix = "[" + type + "] " + this._ts() + " " + this.name;
        if (msg.length === 1 && typeof msg[0] === 'string') log(prefix + " - " + msg[0]);
        else if (msg.length === 1) log(prefix, msg[0]);
        else if (typeof msg[0] === 'string') {
            var obj = msg.slice(1);
            if (obj.length === 1) obj = obj[0];
            log(prefix + " - " + msg[0], obj);
        } else log(prefix, msg);
    };
    /**
     * Write General log. Default to INFO
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype.log = function() {
        var msg = [];
        for(var _i = 0; _i < arguments.length; _i++)msg[_i] = arguments[_i];
        this._log.apply(this, $5c348ff0b9217b35$var$__spread([
            'INFO'
        ], msg));
    };
    /**
     * Write INFO log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype.info = function() {
        var msg = [];
        for(var _i = 0; _i < arguments.length; _i++)msg[_i] = arguments[_i];
        this._log.apply(this, $5c348ff0b9217b35$var$__spread([
            'INFO'
        ], msg));
    };
    /**
     * Write WARN log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype.warn = function() {
        var msg = [];
        for(var _i = 0; _i < arguments.length; _i++)msg[_i] = arguments[_i];
        this._log.apply(this, $5c348ff0b9217b35$var$__spread([
            'WARN'
        ], msg));
    };
    /**
     * Write ERROR log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype.error = function() {
        var msg = [];
        for(var _i = 0; _i < arguments.length; _i++)msg[_i] = arguments[_i];
        this._log.apply(this, $5c348ff0b9217b35$var$__spread([
            'ERROR'
        ], msg));
    };
    /**
     * Write DEBUG log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype.debug = function() {
        var msg = [];
        for(var _i = 0; _i < arguments.length; _i++)msg[_i] = arguments[_i];
        this._log.apply(this, $5c348ff0b9217b35$var$__spread([
            'DEBUG'
        ], msg));
    };
    /**
     * Write VERBOSE log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype.verbose = function() {
        var msg = [];
        for(var _i = 0; _i < arguments.length; _i++)msg[_i] = arguments[_i];
        this._log.apply(this, $5c348ff0b9217b35$var$__spread([
            'VERBOSE'
        ], msg));
    };
    ConsoleLogger.LOG_LEVEL = null;
    return ConsoleLogger;
}();

});


parcelRegister("kaH5c", function(module, exports) {

$parcel$export(module.exports, "Platform", () => $eaf629280ecc05ab$export$2dffd0b5373a4389);
$parcel$export(module.exports, "getAmplifyUserAgent", () => $eaf629280ecc05ab$export$ede38edb26c0bfdf);
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $3yr38 = parcelRequire("3yr38");
var $eaf629280ecc05ab$var$BASE_USER_AGENT = "aws-amplify/" + (0, $3yr38.version);
var $eaf629280ecc05ab$export$2dffd0b5373a4389 = {
    userAgent: $eaf629280ecc05ab$var$BASE_USER_AGENT + " js",
    product: '',
    navigator: null,
    isReactNative: false
};
if (typeof navigator !== 'undefined' && navigator.product) {
    $eaf629280ecc05ab$export$2dffd0b5373a4389.product = navigator.product || '';
    $eaf629280ecc05ab$export$2dffd0b5373a4389.navigator = navigator || null;
    switch(navigator.product){
        case 'ReactNative':
            $eaf629280ecc05ab$export$2dffd0b5373a4389.userAgent = $eaf629280ecc05ab$var$BASE_USER_AGENT + " react-native";
            $eaf629280ecc05ab$export$2dffd0b5373a4389.isReactNative = true;
            break;
        default:
            $eaf629280ecc05ab$export$2dffd0b5373a4389.userAgent = $eaf629280ecc05ab$var$BASE_USER_AGENT + " js";
            $eaf629280ecc05ab$export$2dffd0b5373a4389.isReactNative = false;
            break;
    }
}
var $eaf629280ecc05ab$export$ede38edb26c0bfdf = function() {
    return $eaf629280ecc05ab$export$2dffd0b5373a4389.userAgent;
};
var /**
 * @deprecated use named import
 */ $eaf629280ecc05ab$export$2e2bcd8739ae039 = $eaf629280ecc05ab$export$2dffd0b5373a4389;

});
parcelRegister("3yr38", function(module, exports) {

$parcel$export(module.exports, "version", () => $2969878a5b7df9a8$export$83d89fbfd8236492);
// generated by genversion
var $2969878a5b7df9a8$export$83d89fbfd8236492 = '3.8.23';

});


parcelRegister("k8Uy9", function(module, exports) {

$parcel$export(module.exports, "ClientDevice", () => $eaa06ba47ed07355$export$11b7ab1da2ac1804);
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $03Enx = parcelRequire("03Enx");
var $eaa06ba47ed07355$export$11b7ab1da2ac1804 = /** @class */ function() {
    function ClientDevice() {}
    ClientDevice.clientInfo = function() {
        return (0, $03Enx.clientInfo)();
    };
    ClientDevice.dimension = function() {
        return (0, $03Enx.dimension)();
    };
    return ClientDevice;
}();
var /**
 * @deprecated use named import
 */ $eaa06ba47ed07355$export$2e2bcd8739ae039 = $eaa06ba47ed07355$export$11b7ab1da2ac1804;

});
parcelRegister("03Enx", function(module, exports) {

$parcel$export(module.exports, "clientInfo", () => $00af9a502e58b23d$export$a2e6d3a753e91268);
$parcel$export(module.exports, "dimension", () => $00af9a502e58b23d$export$edcd89beb969619a);
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $7UO1b = parcelRequire("7UO1b");
var $00af9a502e58b23d$var$logger = new (0, $7UO1b.ConsoleLogger)('ClientDevice_Browser');
function $00af9a502e58b23d$export$a2e6d3a753e91268() {
    if (typeof window === 'undefined') return {};
    return $00af9a502e58b23d$var$browserClientInfo();
}
function $00af9a502e58b23d$var$browserClientInfo() {
    if (typeof window === 'undefined') {
        $00af9a502e58b23d$var$logger.warn('No window object available to get browser client info');
        return {};
    }
    var nav = window.navigator;
    if (!nav) {
        $00af9a502e58b23d$var$logger.warn('No navigator object available to get browser client info');
        return {};
    }
    var platform = nav.platform, product = nav.product, vendor = nav.vendor, userAgent = nav.userAgent, language = nav.language;
    var type = $00af9a502e58b23d$export$80c0d0b601fd0789(userAgent);
    var timezone = $00af9a502e58b23d$var$browserTimezone();
    return {
        platform: platform,
        make: product || vendor,
        model: type.type,
        version: type.version,
        appVersion: [
            type.type,
            type.version
        ].join('/'),
        language: language,
        timezone: timezone
    };
}
function $00af9a502e58b23d$export$edcd89beb969619a() {
    if (typeof window === 'undefined') {
        $00af9a502e58b23d$var$logger.warn('No window object available to get browser client info');
        return {
            width: 320,
            height: 320
        };
    }
    return {
        width: window.innerWidth,
        height: window.innerHeight
    };
}
function $00af9a502e58b23d$var$browserTimezone() {
    var tzMatch = /\(([A-Za-z\s].*)\)/.exec(new Date().toString());
    return tzMatch ? tzMatch[1] || '' : '';
}
function $00af9a502e58b23d$export$80c0d0b601fd0789(userAgent) {
    var operaMatch = /.+(Opera[\s[A-Z]*|OPR[\sA-Z]*)\/([0-9\.]+).*/i.exec(userAgent);
    if (operaMatch) return {
        type: operaMatch[1],
        version: operaMatch[2]
    };
    var ieMatch = /.+(Trident|Edge)\/([0-9\.]+).*/i.exec(userAgent);
    if (ieMatch) return {
        type: ieMatch[1],
        version: ieMatch[2]
    };
    var cfMatch = /.+(Chrome|Firefox|FxiOS)\/([0-9\.]+).*/i.exec(userAgent);
    if (cfMatch) return {
        type: cfMatch[1],
        version: cfMatch[2]
    };
    var sMatch = /.+(Safari)\/([0-9\.]+).*/i.exec(userAgent);
    if (sMatch) return {
        type: sMatch[1],
        version: sMatch[2]
    };
    var awkMatch = /.+(AppleWebKit)\/([0-9\.]+).*/i.exec(userAgent);
    if (awkMatch) return {
        type: awkMatch[1],
        version: awkMatch[2]
    };
    var anyMatch = /.*([A-Z]+)\/([0-9\.]+).*/i.exec(userAgent);
    if (anyMatch) return {
        type: anyMatch[1],
        version: anyMatch[2]
    };
    return {
        type: '',
        version: ''
    };
}

});


parcelRegister("kRjsJ", function(module, exports) {

$parcel$export(module.exports, "Hub", () => $f2f7dabd7b8df6a3$export$8c41bb232f1008b1);
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $7UO1b = parcelRequire("7UO1b");
var $f2f7dabd7b8df6a3$var$__assign = undefined && undefined.__assign || function() {
    $f2f7dabd7b8df6a3$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f2f7dabd7b8df6a3$var$__assign.apply(this, arguments);
};
var $f2f7dabd7b8df6a3$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $f2f7dabd7b8df6a3$var$__spread = undefined && undefined.__spread || function() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($f2f7dabd7b8df6a3$var$__read(arguments[i]));
    return ar;
};
var $f2f7dabd7b8df6a3$var$logger = new (0, $7UO1b.ConsoleLogger)('Hub');
var $f2f7dabd7b8df6a3$var$AMPLIFY_SYMBOL = typeof Symbol !== 'undefined' && typeof Symbol.for === 'function' ? Symbol.for('amplify_default') : '@@amplify_default';
function $f2f7dabd7b8df6a3$var$isLegacyCallback(callback) {
    return callback.onHubCapsule !== undefined;
}
var $f2f7dabd7b8df6a3$export$6b38ef2be9abbbb9 = /** @class */ function() {
    function HubClass(name) {
        this.listeners = [];
        this.patterns = [];
        this.protectedChannels = [
            'core',
            'auth',
            'api',
            'analytics',
            'interactions',
            'pubsub',
            'storage',
            'xr'
        ];
        this.name = name;
    }
    // Note - Need to pass channel as a reference for removal to work and not anonymous function
    HubClass.prototype.remove = function(channel, listener) {
        if (channel instanceof RegExp) {
            var pattern_1 = this.patterns.find(function(_a) {
                var pattern = _a.pattern;
                return pattern.source === channel.source;
            });
            if (!pattern_1) {
                $f2f7dabd7b8df6a3$var$logger.warn("No listeners for " + channel);
                return;
            }
            this.patterns = $f2f7dabd7b8df6a3$var$__spread(this.patterns.filter(function(x) {
                return x !== pattern_1;
            }));
        } else {
            var holder = this.listeners[channel];
            if (!holder) {
                $f2f7dabd7b8df6a3$var$logger.warn("No listeners for " + channel);
                return;
            }
            this.listeners[channel] = $f2f7dabd7b8df6a3$var$__spread(holder.filter(function(_a) {
                var callback = _a.callback;
                return callback !== listener;
            }));
        }
    };
    HubClass.prototype.dispatch = function(channel, payload, source, ampSymbol) {
        if (source === void 0) source = '';
        if (this.protectedChannels.indexOf(channel) > -1) {
            var hasAccess = ampSymbol === $f2f7dabd7b8df6a3$var$AMPLIFY_SYMBOL;
            if (!hasAccess) $f2f7dabd7b8df6a3$var$logger.warn("WARNING: " + channel + " is protected and dispatching on it can have unintended consequences");
        }
        var capsule = {
            channel: channel,
            payload: $f2f7dabd7b8df6a3$var$__assign({}, payload),
            source: source,
            patternInfo: []
        };
        try {
            this._toListeners(capsule);
        } catch (e) {
            $f2f7dabd7b8df6a3$var$logger.error(e);
        }
    };
    HubClass.prototype.listen = function(channel, callback, listenerName) {
        var _this = this;
        if (listenerName === void 0) listenerName = 'noname';
        var cb;
        // Check for legacy onHubCapsule callback for backwards compatability
        if ($f2f7dabd7b8df6a3$var$isLegacyCallback(callback)) {
            $f2f7dabd7b8df6a3$var$logger.warn("WARNING onHubCapsule is Deprecated. Please pass in a callback.");
            cb = callback.onHubCapsule.bind(callback);
        } else if (typeof callback !== 'function') throw new Error('No callback supplied to Hub');
        else cb = callback;
        if (channel instanceof RegExp) this.patterns.push({
            pattern: channel,
            callback: cb
        });
        else {
            var holder = this.listeners[channel];
            if (!holder) {
                holder = [];
                this.listeners[channel] = holder;
            }
            holder.push({
                name: listenerName,
                callback: cb
            });
        }
        return function() {
            _this.remove(channel, cb);
        };
    };
    HubClass.prototype._toListeners = function(capsule) {
        var channel = capsule.channel, payload = capsule.payload;
        var holder = this.listeners[channel];
        if (holder) holder.forEach(function(listener) {
            $f2f7dabd7b8df6a3$var$logger.debug("Dispatching to " + channel + " with ", payload);
            try {
                listener.callback(capsule);
            } catch (e) {
                $f2f7dabd7b8df6a3$var$logger.error(e);
            }
        });
        if (this.patterns.length > 0) {
            if (!payload.message) {
                $f2f7dabd7b8df6a3$var$logger.warn("Cannot perform pattern matching without a message key");
                return;
            }
            var payloadStr_1 = payload.message;
            this.patterns.forEach(function(pattern) {
                var match = payloadStr_1.match(pattern.pattern);
                if (match) {
                    var _a = $f2f7dabd7b8df6a3$var$__read(match), groups = _a.slice(1);
                    var dispatchingCapsule = $f2f7dabd7b8df6a3$var$__assign($f2f7dabd7b8df6a3$var$__assign({}, capsule), {
                        patternInfo: groups
                    });
                    try {
                        pattern.callback(dispatchingCapsule);
                    } catch (e) {
                        $f2f7dabd7b8df6a3$var$logger.error(e);
                    }
                }
            });
        }
    };
    return HubClass;
}();
var $f2f7dabd7b8df6a3$export$8c41bb232f1008b1 = new $f2f7dabd7b8df6a3$export$6b38ef2be9abbbb9('__default__');
var /**
 * @deprecated use named import
 */ $f2f7dabd7b8df6a3$export$2e2bcd8739ae039 = $f2f7dabd7b8df6a3$export$8c41bb232f1008b1;

});

parcelRegister("bNDL2", function(module, exports) {
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $2XOZN = parcelRequire("2XOZN");

var $7UO1b = parcelRequire("7UO1b");

var $a16qJ = parcelRequire("a16qJ");
var $89731c6042fb3057$var$logger = new (0, $7UO1b.ConsoleLogger)('I18n');
var $89731c6042fb3057$var$_config = null;
var $89731c6042fb3057$var$_i18n = null;
/**
 * Export I18n APIs
 */ var $89731c6042fb3057$export$dbe3113d60765c1a = /** @class */ function() {
    function I18n() {}
    /**
     * @static
     * @method
     * Configure I18n part
     * @param {Object} config - Configuration of the I18n
     */ I18n.configure = function(config) {
        $89731c6042fb3057$var$logger.debug('configure I18n');
        if (!config) return $89731c6042fb3057$var$_config;
        $89731c6042fb3057$var$_config = Object.assign({}, $89731c6042fb3057$var$_config, config.I18n || config);
        I18n.createInstance();
        return $89731c6042fb3057$var$_config;
    };
    I18n.getModuleName = function() {
        return 'I18n';
    };
    /**
     * @static
     * @method
     * Create an instance of I18n for the library
     */ I18n.createInstance = function() {
        $89731c6042fb3057$var$logger.debug('create I18n instance');
        if ($89731c6042fb3057$var$_i18n) return;
        $89731c6042fb3057$var$_i18n = new (0, $2XOZN.I18n)($89731c6042fb3057$var$_config);
    };
    /**
     * @static @method
     * Explicitly setting language
     * @param {String} lang
     */ I18n.setLanguage = function(lang) {
        I18n.checkConfig();
        return $89731c6042fb3057$var$_i18n.setLanguage(lang);
    };
    /**
     * @static @method
     * Get value
     * @param {String} key
     * @param {String} defVal - Default value
     */ I18n.get = function(key, defVal) {
        if (!I18n.checkConfig()) return typeof defVal === 'undefined' ? key : defVal;
        return $89731c6042fb3057$var$_i18n.get(key, defVal);
    };
    /**
     * @static
     * @method
     * Add vocabularies for one language
     * @param {String} langurage - Language of the dictionary
     * @param {Object} vocabularies - Object that has key-value as dictionary entry
     */ I18n.putVocabulariesForLanguage = function(language, vocabularies) {
        I18n.checkConfig();
        return $89731c6042fb3057$var$_i18n.putVocabulariesForLanguage(language, vocabularies);
    };
    /**
     * @static
     * @method
     * Add vocabularies for one language
     * @param {Object} vocabularies - Object that has language as key,
     *                                vocabularies of each language as value
     */ I18n.putVocabularies = function(vocabularies) {
        I18n.checkConfig();
        return $89731c6042fb3057$var$_i18n.putVocabularies(vocabularies);
    };
    I18n.checkConfig = function() {
        if (!$89731c6042fb3057$var$_i18n) $89731c6042fb3057$var$_i18n = new (0, $2XOZN.I18n)($89731c6042fb3057$var$_config);
        return true;
    };
    return I18n;
}();
(0, $a16qJ.Amplify).register($89731c6042fb3057$export$dbe3113d60765c1a);
var /**
 * @deprecated use named import
 */ $89731c6042fb3057$export$2e2bcd8739ae039 = $89731c6042fb3057$export$dbe3113d60765c1a;

});
parcelRegister("2XOZN", function(module, exports) {

$parcel$export(module.exports, "I18n", () => $2288a61fe11643fa$export$dbe3113d60765c1a);
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $7UO1b = parcelRequire("7UO1b");
var $2288a61fe11643fa$var$logger = new (0, $7UO1b.ConsoleLogger)('I18n');
/**
 * Language transition class
 */ var $2288a61fe11643fa$export$dbe3113d60765c1a = /** @class */ function() {
    /**
     * @constructor
     * Initialize with configurations
     * @param {Object} options
     */ function I18n(options) {
        /**
         * @private
         */ this._options = null;
        /**
         * @private
         */ this._lang = null;
        /**
         * @private
         */ this._dict = {};
        this._options = Object.assign({}, options);
        this._lang = this._options.language;
        if (!this._lang && typeof window !== 'undefined' && window && window.navigator) this._lang = window.navigator.language;
        $2288a61fe11643fa$var$logger.debug(this._lang);
    }
    /**
     * @method
     * Explicitly setting language
     * @param {String} lang
     */ I18n.prototype.setLanguage = function(lang) {
        this._lang = lang;
    };
    /**
     * @method
     * Get value
     * @param {String} key
     * @param {String} defVal - Default value
     */ I18n.prototype.get = function(key, defVal) {
        if (defVal === void 0) defVal = undefined;
        if (!this._lang) return typeof defVal !== 'undefined' ? defVal : key;
        var lang = this._lang;
        var val = this.getByLanguage(key, lang);
        if (val) return val;
        if (lang.indexOf('-') > 0) val = this.getByLanguage(key, lang.split('-')[0]);
        if (val) return val;
        return typeof defVal !== 'undefined' ? defVal : key;
    };
    /**
     * @method
     * Get value according to specified language
     * @param {String} key
     * @param {String} language - Specified langurage to be used
     * @param {String} defVal - Default value
     */ I18n.prototype.getByLanguage = function(key, language, defVal) {
        if (defVal === void 0) defVal = null;
        if (!language) return defVal;
        var lang_dict = this._dict[language];
        if (!lang_dict) return defVal;
        return lang_dict[key];
    };
    /**
     * @method
     * Add vocabularies for one language
     * @param {String} language - Language of the dictionary
     * @param {Object} vocabularies - Object that has key-value as dictionary entry
     */ I18n.prototype.putVocabulariesForLanguage = function(language, vocabularies) {
        var lang_dict = this._dict[language];
        if (!lang_dict) lang_dict = this._dict[language] = {};
        Object.assign(lang_dict, vocabularies);
    };
    /**
     * @method
     * Add vocabularies for one language
     * @param {Object} vocabularies - Object that has language as key,
     *                                vocabularies of each language as value
     */ I18n.prototype.putVocabularies = function(vocabularies) {
        var _this = this;
        Object.keys(vocabularies).map(function(key) {
            _this.putVocabulariesForLanguage(key, vocabularies[key]);
        });
    };
    return I18n;
}();

});


parcelRegister("9Mfkr", function(module, exports) {

$parcel$export(module.exports, "makeQuerablePromise", () => $71e47cbab9581e42$export$8f33cb495ca11832);
$parcel$export(module.exports, "isWebWorker", () => $71e47cbab9581e42$export$97b87b8868ff7a3c);
$parcel$export(module.exports, "browserOrNode", () => $71e47cbab9581e42$export$a2708fdb45cd35f);
$parcel$export(module.exports, "JS", () => $71e47cbab9581e42$export$174a40858393256b);
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ var $71e47cbab9581e42$var$MIME_MAP = [
    {
        type: 'text/plain',
        ext: 'txt'
    },
    {
        type: 'text/html',
        ext: 'html'
    },
    {
        type: 'text/javascript',
        ext: 'js'
    },
    {
        type: 'text/css',
        ext: 'css'
    },
    {
        type: 'text/csv',
        ext: 'csv'
    },
    {
        type: 'text/yaml',
        ext: 'yml'
    },
    {
        type: 'text/yaml',
        ext: 'yaml'
    },
    {
        type: 'text/calendar',
        ext: 'ics'
    },
    {
        type: 'text/calendar',
        ext: 'ical'
    },
    {
        type: 'image/apng',
        ext: 'apng'
    },
    {
        type: 'image/bmp',
        ext: 'bmp'
    },
    {
        type: 'image/gif',
        ext: 'gif'
    },
    {
        type: 'image/x-icon',
        ext: 'ico'
    },
    {
        type: 'image/x-icon',
        ext: 'cur'
    },
    {
        type: 'image/jpeg',
        ext: 'jpg'
    },
    {
        type: 'image/jpeg',
        ext: 'jpeg'
    },
    {
        type: 'image/jpeg',
        ext: 'jfif'
    },
    {
        type: 'image/jpeg',
        ext: 'pjp'
    },
    {
        type: 'image/jpeg',
        ext: 'pjpeg'
    },
    {
        type: 'image/png',
        ext: 'png'
    },
    {
        type: 'image/svg+xml',
        ext: 'svg'
    },
    {
        type: 'image/tiff',
        ext: 'tif'
    },
    {
        type: 'image/tiff',
        ext: 'tiff'
    },
    {
        type: 'image/webp',
        ext: 'webp'
    },
    {
        type: 'application/json',
        ext: 'json'
    },
    {
        type: 'application/xml',
        ext: 'xml'
    },
    {
        type: 'application/x-sh',
        ext: 'sh'
    },
    {
        type: 'application/zip',
        ext: 'zip'
    },
    {
        type: 'application/x-rar-compressed',
        ext: 'rar'
    },
    {
        type: 'application/x-tar',
        ext: 'tar'
    },
    {
        type: 'application/x-bzip',
        ext: 'bz'
    },
    {
        type: 'application/x-bzip2',
        ext: 'bz2'
    },
    {
        type: 'application/pdf',
        ext: 'pdf'
    },
    {
        type: 'application/java-archive',
        ext: 'jar'
    },
    {
        type: 'application/msword',
        ext: 'doc'
    },
    {
        type: 'application/vnd.ms-excel',
        ext: 'xls'
    },
    {
        type: 'application/vnd.ms-excel',
        ext: 'xlsx'
    },
    {
        type: 'message/rfc822',
        ext: 'eml'
    }
];
var $71e47cbab9581e42$export$dd1bc94b04021eeb = function(obj) {
    if (obj === void 0) obj = {};
    return Object.keys(obj).length === 0;
};
var $71e47cbab9581e42$export$756e1e7707954007 = function(list, field, dir) {
    if (!list || !list.sort) return false;
    var dirX = dir && dir === 'desc' ? -1 : 1;
    list.sort(function(a, b) {
        var a_val = a[field];
        var b_val = b[field];
        if (typeof b_val === 'undefined') return typeof a_val === 'undefined' ? 0 : 1 * dirX;
        if (typeof a_val === 'undefined') return -1 * dirX;
        if (a_val < b_val) return -1 * dirX;
        if (a_val > b_val) return 1 * dirX;
        return 0;
    });
    return true;
};
var $71e47cbab9581e42$export$5e10ed067f63a9ea = function(obj, less) {
    var ret = Object.assign({}, obj);
    if (less) {
        if (typeof less === 'string') delete ret[less];
        else less.forEach(function(attr) {
            delete ret[attr];
        });
    }
    return ret;
};
var $71e47cbab9581e42$export$49cecb876bed446d = function(filename, defVal) {
    if (defVal === void 0) defVal = 'application/octet-stream';
    var name = filename.toLowerCase();
    var filtered = $71e47cbab9581e42$var$MIME_MAP.filter(function(mime) {
        return name.endsWith('.' + mime.ext);
    });
    return filtered.length > 0 ? filtered[0].type : defVal;
};
var $71e47cbab9581e42$export$689bea3eece53c0e = function(contentType) {
    var type = contentType.toLowerCase();
    if (type.startsWith('text/')) return true;
    return 'application/json' === type || 'application/xml' === type || 'application/sh' === type;
};
var $71e47cbab9581e42$export$9e15fb06e64c4810 = function() {
    var result = '';
    var chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    for(var i = 32; i > 0; i -= 1)result += chars[Math.floor(Math.random() * chars.length)];
    return result;
};
var $71e47cbab9581e42$export$8f33cb495ca11832 = function(promise) {
    if (promise.isResolved) return promise;
    var isPending = true;
    var isRejected = false;
    var isFullfilled = false;
    var result = promise.then(function(data) {
        isFullfilled = true;
        isPending = false;
        return data;
    }, function(e) {
        isRejected = true;
        isPending = false;
        throw e;
    });
    result.isFullfilled = function() {
        return isFullfilled;
    };
    result.isPending = function() {
        return isPending;
    };
    result.isRejected = function() {
        return isRejected;
    };
    return result;
};
var $71e47cbab9581e42$export$97b87b8868ff7a3c = function() {
    if (typeof self === 'undefined') return false;
    var selfContext = self;
    return typeof selfContext.WorkerGlobalScope !== 'undefined' && self instanceof selfContext.WorkerGlobalScope;
};
var $71e47cbab9581e42$export$a2708fdb45cd35f = function() {
    var isBrowser = typeof window !== 'undefined' && typeof window.document !== 'undefined';
    var isNode = false;
    return {
        isBrowser: isBrowser,
        isNode: isNode
    };
};
var $71e47cbab9581e42$export$6281ea8cfc59a49c = function(obj, whiteListForItself, whiteListForChildren) {
    if (whiteListForItself === void 0) whiteListForItself = [];
    if (whiteListForChildren === void 0) whiteListForChildren = [];
    if (!$71e47cbab9581e42$export$250974ab4f95003c(obj)) return obj;
    var ret = {};
    for(var key in obj)if (obj.hasOwnProperty(key)) {
        var transferedKey = whiteListForItself.includes(key) ? key : key[0].toLowerCase() + key.slice(1);
        ret[transferedKey] = whiteListForChildren.includes(key) ? obj[key] : $71e47cbab9581e42$export$6281ea8cfc59a49c(obj[key], whiteListForItself, whiteListForChildren);
    }
    return ret;
};
var $71e47cbab9581e42$export$f8790a3d3d35829c = function(obj, whiteListForItself, whiteListForChildren) {
    if (whiteListForItself === void 0) whiteListForItself = [];
    if (whiteListForChildren === void 0) whiteListForChildren = [];
    if (!$71e47cbab9581e42$export$250974ab4f95003c(obj)) return obj;
    var ret = {};
    for(var key in obj)if (obj.hasOwnProperty(key)) {
        var transferredKey = whiteListForItself.includes(key) ? key : key[0].toUpperCase() + key.slice(1);
        ret[transferredKey] = whiteListForChildren.includes(key) ? obj[key] : $71e47cbab9581e42$export$f8790a3d3d35829c(obj[key], whiteListForItself, whiteListForChildren);
    }
    return ret;
};
var $71e47cbab9581e42$export$250974ab4f95003c = function(obj) {
    return obj instanceof Object && !(obj instanceof Array) && !(obj instanceof Function) && !(obj instanceof Number) && !(obj instanceof String) && !(obj instanceof Boolean);
};
/**
 * @deprecated use per-function imports
 */ var $71e47cbab9581e42$export$174a40858393256b = /** @class */ function() {
    function JS() {}
    JS.isEmpty = $71e47cbab9581e42$export$dd1bc94b04021eeb;
    JS.sortByField = $71e47cbab9581e42$export$756e1e7707954007;
    JS.objectLessAttributes = $71e47cbab9581e42$export$5e10ed067f63a9ea;
    JS.filenameToContentType = $71e47cbab9581e42$export$49cecb876bed446d;
    JS.isTextFile = $71e47cbab9581e42$export$689bea3eece53c0e;
    JS.generateRandomString = $71e47cbab9581e42$export$9e15fb06e64c4810;
    JS.makeQuerablePromise = $71e47cbab9581e42$export$8f33cb495ca11832;
    JS.isWebWorker = $71e47cbab9581e42$export$97b87b8868ff7a3c;
    JS.browserOrNode = $71e47cbab9581e42$export$a2708fdb45cd35f;
    JS.transferKeyToLowerCase = $71e47cbab9581e42$export$6281ea8cfc59a49c;
    JS.transferKeyToUpperCase = $71e47cbab9581e42$export$f8790a3d3d35829c;
    JS.isStrictObject = $71e47cbab9581e42$export$250974ab4f95003c;
    return JS;
}();
var /**
 * @deprecated use per-function imports
 */ $71e47cbab9581e42$export$2e2bcd8739ae039 = $71e47cbab9581e42$export$174a40858393256b;

});

parcelRegister("ap2RT", function(module, exports) {

$parcel$export(module.exports, "Signer", () => $792e76c501526e83$export$fdf54fdde81cc9f0);
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $7UO1b = parcelRequire("7UO1b");

var $3gKbK = parcelRequire("3gKbK");

var $2YcGN = parcelRequire("2YcGN");

var $kcgTr = parcelRequire("kcgTr");

var $fsezd = parcelRequire("fsezd");
var $792e76c501526e83$var$__assign = undefined && undefined.__assign || function() {
    $792e76c501526e83$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $792e76c501526e83$var$__assign.apply(this, arguments);
};
var $792e76c501526e83$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $792e76c501526e83$var$logger = new (0, $7UO1b.ConsoleLogger)('Signer');
var $792e76c501526e83$var$DEFAULT_ALGORITHM = 'AWS4-HMAC-SHA256';
var $792e76c501526e83$var$IOT_SERVICE_NAME = 'iotdevicegateway';
var $792e76c501526e83$var$encrypt = function(key, src) {
    var hash = new (0, $3gKbK.Sha256)(key);
    hash.update(src);
    return hash.digestSync();
};
var $792e76c501526e83$var$hash = function(src) {
    var arg = src || '';
    var hash = new (0, $3gKbK.Sha256)();
    hash.update(arg);
    return (0, $2YcGN.toHex)(hash.digestSync());
};
/**
 * @private
 * RFC 3986 compliant version of encodeURIComponent
 */ var $792e76c501526e83$var$escape_RFC3986 = function(component) {
    return component.replace(/[!'()*]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
};
/**
 * @private
 * Create canonical query string
 *
 */ var $792e76c501526e83$var$canonical_query = function(query) {
    if (!query || query.length === 0) return '';
    return query.split('&').map(function(e) {
        var key_val = e.split('=');
        if (key_val.length === 1) return e;
        else {
            var reencoded_val = $792e76c501526e83$var$escape_RFC3986(key_val[1]);
            return key_val[0] + '=' + reencoded_val;
        }
    }).sort(function(a, b) {
        var key_a = a.split('=')[0];
        var key_b = b.split('=')[0];
        if (key_a === key_b) return a < b ? -1 : 1;
        else return key_a < key_b ? -1 : 1;
    }).join('&');
};
/**
* @private
* Create canonical headers
*
<pre>
CanonicalHeaders =
    CanonicalHeadersEntry0 + CanonicalHeadersEntry1 + ... + CanonicalHeadersEntryN
CanonicalHeadersEntry =
    Lowercase(HeaderName) + ':' + Trimall(HeaderValue) + '\n'
</pre>
*/ var $792e76c501526e83$var$canonical_headers = function(headers) {
    if (!headers || Object.keys(headers).length === 0) return '';
    return Object.keys(headers).map(function(key) {
        return {
            key: key.toLowerCase(),
            value: headers[key] ? headers[key].trim().replace(/\s+/g, ' ') : ''
        };
    }).sort(function(a, b) {
        return a.key < b.key ? -1 : 1;
    }).map(function(item) {
        return item.key + ':' + item.value;
    }).join('\n') + '\n';
};
/**
 * List of header keys included in the canonical headers.
 * @access private
 */ var $792e76c501526e83$var$signed_headers = function(headers) {
    return Object.keys(headers).map(function(key) {
        return key.toLowerCase();
    }).sort().join(';');
};
/**
* @private
* Create canonical request
* Refer to
* {@link http://docs.aws.amazon.com/general/latest/gr/sigv4-create-canonical-request.html|Create a Canonical Request}
*
<pre>
CanonicalRequest =
    HTTPRequestMethod + '\n' +
    CanonicalURI + '\n' +
    CanonicalQueryString + '\n' +
    CanonicalHeaders + '\n' +
    SignedHeaders + '\n' +
    HexEncode(Hash(RequestPayload))
</pre>
*/ var $792e76c501526e83$var$canonical_request = function(request) {
    var url_info = (0, $kcgTr.parse)(request.url);
    return [
        request.method || '/',
        encodeURIComponent(url_info.pathname).replace(/%2F/gi, '/'),
        $792e76c501526e83$var$canonical_query(url_info.query),
        $792e76c501526e83$var$canonical_headers(request.headers),
        $792e76c501526e83$var$signed_headers(request.headers),
        $792e76c501526e83$var$hash(request.data)
    ].join('\n');
};
var $792e76c501526e83$var$parse_service_info = function(request) {
    var url_info = (0, $kcgTr.parse)(request.url), host = url_info.host;
    var matched = host.match(/([^\.]+)\.(?:([^\.]*)\.)?amazonaws\.com$/);
    var parsed = (matched || []).slice(1, 3);
    if (parsed[1] === 'es') // Elastic Search
    parsed = parsed.reverse();
    return {
        service: request.service || parsed[0],
        region: request.region || parsed[1]
    };
};
var $792e76c501526e83$var$credential_scope = function(d_str, region, service) {
    return [
        d_str,
        region,
        service,
        'aws4_request'
    ].join('/');
};
/**
* @private
* Create a string to sign
* Refer to
* {@link http://docs.aws.amazon.com/general/latest/gr/sigv4-create-string-to-sign.html|Create String to Sign}
*
<pre>
StringToSign =
    Algorithm + \n +
    RequestDateTime + \n +
    CredentialScope + \n +
    HashedCanonicalRequest
</pre>
*/ var $792e76c501526e83$var$string_to_sign = function(algorithm, canonical_request, dt_str, scope) {
    return [
        algorithm,
        dt_str,
        scope,
        $792e76c501526e83$var$hash(canonical_request)
    ].join('\n');
};
/**
* @private
* Create signing key
* Refer to
* {@link http://docs.aws.amazon.com/general/latest/gr/sigv4-calculate-signature.html|Calculate Signature}
*
<pre>
kSecret = your secret access key
kDate = HMAC("AWS4" + kSecret, Date)
kRegion = HMAC(kDate, Region)
kService = HMAC(kRegion, Service)
kSigning = HMAC(kService, "aws4_request")
</pre>
*/ var $792e76c501526e83$var$get_signing_key = function(secret_key, d_str, service_info) {
    $792e76c501526e83$var$logger.debug(service_info);
    var k = 'AWS4' + secret_key, k_date = $792e76c501526e83$var$encrypt(k, d_str), k_region = $792e76c501526e83$var$encrypt(k_date, service_info.region), k_service = $792e76c501526e83$var$encrypt(k_region, service_info.service), k_signing = $792e76c501526e83$var$encrypt(k_service, 'aws4_request');
    return k_signing;
};
var $792e76c501526e83$var$get_signature = function(signing_key, str_to_sign) {
    return (0, $2YcGN.toHex)($792e76c501526e83$var$encrypt(signing_key, str_to_sign));
};
/**
 * @private
 * Create authorization header
 * Refer to
 * {@link http://docs.aws.amazon.com/general/latest/gr/sigv4-add-signature-to-request.html|Add the Signing Information}
 */ var $792e76c501526e83$var$get_authorization_header = function(algorithm, access_key, scope, signed_headers, signature) {
    return [
        algorithm + ' ' + 'Credential=' + access_key + '/' + scope,
        'SignedHeaders=' + signed_headers,
        'Signature=' + signature
    ].join(', ');
};
var $792e76c501526e83$export$fdf54fdde81cc9f0 = /** @class */ function() {
    function Signer() {}
    /**
    * Sign a HTTP request, add 'Authorization' header to request param
    * @method sign
    * @memberof Signer
    * @static
    *
    * @param {object} request - HTTP request object
    <pre>
    request: {
        method: GET | POST | PUT ...
        url: ...,
        headers: {
            header1: ...
        },
        data: data
    }
    </pre>
    * @param {object} access_info - AWS access credential info
    <pre>
    access_info: {
        access_key: ...,
        secret_key: ...,
        session_token: ...
    }
    </pre>
    * @param {object} [service_info] - AWS service type and region, optional,
    *                                  if not provided then parse out from url
    <pre>
    service_info: {
        service: ...,
        region: ...
    }
    </pre>
    *
    * @returns {object} Signed HTTP request
    */ Signer.sign = function(request, access_info, service_info) {
        if (service_info === void 0) service_info = null;
        request.headers = request.headers || {};
        // datetime string and date string
        var dt = (0, $fsezd.DateUtils).getDateWithClockOffset(), dt_str = dt.toISOString().replace(/[:\-]|\.\d{3}/g, ''), d_str = dt_str.substr(0, 8);
        var url_info = (0, $kcgTr.parse)(request.url);
        request.headers['host'] = url_info.host;
        request.headers['x-amz-date'] = dt_str;
        if (access_info.session_token) request.headers['X-Amz-Security-Token'] = access_info.session_token;
        // Task 1: Create a Canonical Request
        var request_str = $792e76c501526e83$var$canonical_request(request);
        $792e76c501526e83$var$logger.debug(request_str);
        // Task 2: Create a String to Sign
        var serviceInfo = service_info || $792e76c501526e83$var$parse_service_info(request), scope = $792e76c501526e83$var$credential_scope(d_str, serviceInfo.region, serviceInfo.service), str_to_sign = $792e76c501526e83$var$string_to_sign($792e76c501526e83$var$DEFAULT_ALGORITHM, request_str, dt_str, scope);
        // Task 3: Calculate the Signature
        var signing_key = $792e76c501526e83$var$get_signing_key(access_info.secret_key, d_str, serviceInfo), signature = $792e76c501526e83$var$get_signature(signing_key, str_to_sign);
        // Task 4: Adding the Signing information to the Request
        var authorization_header = $792e76c501526e83$var$get_authorization_header($792e76c501526e83$var$DEFAULT_ALGORITHM, access_info.access_key, scope, $792e76c501526e83$var$signed_headers(request.headers), signature);
        request.headers['Authorization'] = authorization_header;
        return request;
    };
    Signer.signUrl = function(urlOrRequest, accessInfo, serviceInfo, expiration) {
        var urlToSign = typeof urlOrRequest === 'object' ? urlOrRequest.url : urlOrRequest;
        var method = typeof urlOrRequest === 'object' ? urlOrRequest.method : 'GET';
        var body = typeof urlOrRequest === 'object' ? urlOrRequest.body : undefined;
        var now = (0, $fsezd.DateUtils).getDateWithClockOffset().toISOString().replace(/[:\-]|\.\d{3}/g, '');
        var today = now.substr(0, 8);
        // Intentionally discarding search
        var _a = (0, $kcgTr.parse)(urlToSign, true, true), search = _a.search, parsedUrl = $792e76c501526e83$var$__rest(_a, [
            "search"
        ]);
        var host = parsedUrl.host;
        var signedHeaders = {
            host: host
        };
        var _b = serviceInfo || $792e76c501526e83$var$parse_service_info({
            url: (0, $kcgTr.format)(parsedUrl)
        }), region = _b.region, service = _b.service;
        var credentialScope = $792e76c501526e83$var$credential_scope(today, region, service);
        // IoT service does not allow the session token in the canonical request
        // https://docs.aws.amazon.com/general/latest/gr/sigv4-add-signature-to-request.html
        var sessionTokenRequired = accessInfo.session_token && service !== $792e76c501526e83$var$IOT_SERVICE_NAME;
        var queryParams = $792e76c501526e83$var$__assign($792e76c501526e83$var$__assign($792e76c501526e83$var$__assign({
            'X-Amz-Algorithm': $792e76c501526e83$var$DEFAULT_ALGORITHM,
            'X-Amz-Credential': [
                accessInfo.access_key,
                credentialScope
            ].join('/'),
            'X-Amz-Date': now.substr(0, 16)
        }, sessionTokenRequired ? {
            'X-Amz-Security-Token': "" + accessInfo.session_token
        } : {}), expiration ? {
            'X-Amz-Expires': "" + expiration
        } : {}), {
            'X-Amz-SignedHeaders': Object.keys(signedHeaders).join(',')
        });
        var canonicalRequest = $792e76c501526e83$var$canonical_request({
            method: method,
            url: (0, $kcgTr.format)($792e76c501526e83$var$__assign($792e76c501526e83$var$__assign({}, parsedUrl), {
                query: $792e76c501526e83$var$__assign($792e76c501526e83$var$__assign({}, parsedUrl.query), queryParams)
            })),
            headers: signedHeaders,
            data: body
        });
        var stringToSign = $792e76c501526e83$var$string_to_sign($792e76c501526e83$var$DEFAULT_ALGORITHM, canonicalRequest, now, credentialScope);
        var signing_key = $792e76c501526e83$var$get_signing_key(accessInfo.secret_key, today, {
            region: region,
            service: service
        });
        var signature = $792e76c501526e83$var$get_signature(signing_key, stringToSign);
        var additionalQueryParams = $792e76c501526e83$var$__assign({
            'X-Amz-Signature': signature
        }, accessInfo.session_token && {
            'X-Amz-Security-Token': accessInfo.session_token
        });
        var result = (0, $kcgTr.format)({
            protocol: parsedUrl.protocol,
            slashes: true,
            hostname: parsedUrl.hostname,
            port: parsedUrl.port,
            pathname: parsedUrl.pathname,
            query: $792e76c501526e83$var$__assign($792e76c501526e83$var$__assign($792e76c501526e83$var$__assign({}, parsedUrl.query), queryParams), additionalQueryParams)
        });
        return result;
    };
    return Signer;
}();
var /**
 * @deprecated use per-function import
 */ $792e76c501526e83$export$2e2bcd8739ae039 = $792e76c501526e83$export$fdf54fdde81cc9f0;

});
parcelRegister("3gKbK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $87zMB = parcelRequire("87zMB");

$87zMB.__exportStar((parcelRequire("jt1h5")), module.exports);

});
parcelRegister("87zMB", function(module, exports) {

$parcel$export(module.exports, "__awaiter", () => $5e9abbea59b40a3a$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $5e9abbea59b40a3a$export$67ebef60e6f28a6);
$parcel$export(module.exports, "__exportStar", () => $5e9abbea59b40a3a$export$f33643c0debef087);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $5e9abbea59b40a3a$var$extendStatics = function(d, b) {
    $5e9abbea59b40a3a$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $5e9abbea59b40a3a$var$extendStatics(d, b);
};
function $5e9abbea59b40a3a$export$a8ba968b8961cb8a(d, b) {
    $5e9abbea59b40a3a$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5e9abbea59b40a3a$export$18ce0697a983be9b = function() {
    $5e9abbea59b40a3a$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5e9abbea59b40a3a$export$18ce0697a983be9b.apply(this, arguments);
};
function $5e9abbea59b40a3a$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5e9abbea59b40a3a$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5e9abbea59b40a3a$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5e9abbea59b40a3a$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5e9abbea59b40a3a$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5e9abbea59b40a3a$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $5e9abbea59b40a3a$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $5e9abbea59b40a3a$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $5e9abbea59b40a3a$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5e9abbea59b40a3a$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5e9abbea59b40a3a$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5e9abbea59b40a3a$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5e9abbea59b40a3a$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5e9abbea59b40a3a$export$10c90e4f7922046c(v) {
    return this instanceof $5e9abbea59b40a3a$export$10c90e4f7922046c ? (this.v = v, this) : new $5e9abbea59b40a3a$export$10c90e4f7922046c(v);
}
function $5e9abbea59b40a3a$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5e9abbea59b40a3a$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5e9abbea59b40a3a$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5e9abbea59b40a3a$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $5e9abbea59b40a3a$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5e9abbea59b40a3a$export$19a8beecd37a4c45 === "function" ? $5e9abbea59b40a3a$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5e9abbea59b40a3a$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $5e9abbea59b40a3a$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $5e9abbea59b40a3a$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5e9abbea59b40a3a$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $5e9abbea59b40a3a$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("jt1h5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $87zMB = parcelRequire("87zMB");

var $ft3RT = parcelRequire("ft3RT");

var $lB6JH = parcelRequire("lB6JH");

var $8hHBS = parcelRequire("8hHBS");
var $e2c1b6da55083e98$var$Sha256 = /** @class */ function() {
    function Sha256(secret) {
        this.hash = new $lB6JH.RawSha256();
        if (secret) {
            this.outer = new $lB6JH.RawSha256();
            var inner = $e2c1b6da55083e98$var$bufferFromSecret(secret);
            var outer = new Uint8Array($ft3RT.BLOCK_SIZE);
            outer.set(inner);
            for(var i = 0; i < $ft3RT.BLOCK_SIZE; i++){
                inner[i] ^= 0x36;
                outer[i] ^= 0x5c;
            }
            this.hash.update(inner);
            this.outer.update(outer);
            // overwrite the copied key in memory
            for(var i = 0; i < inner.byteLength; i++)inner[i] = 0;
        }
    }
    Sha256.prototype.update = function(toHash) {
        if ($e2c1b6da55083e98$var$isEmptyData(toHash) || this.error) return;
        try {
            this.hash.update($e2c1b6da55083e98$var$convertToBuffer(toHash));
        } catch (e) {
            this.error = e;
        }
    };
    /* This synchronous method keeps compatibility
     * with the v2 aws-sdk.
     */ Sha256.prototype.digestSync = function() {
        if (this.error) throw this.error;
        if (this.outer) {
            if (!this.outer.finished) this.outer.update(this.hash.digest());
            return this.outer.digest();
        }
        return this.hash.digest();
    };
    /* The underlying digest method here is synchronous.
     * To keep the same interface with the other hash functions
     * the default is to expose this as an async method.
     * However, it can sometimes be useful to have a sync method.
     */ Sha256.prototype.digest = function() {
        return $87zMB.__awaiter(this, void 0, void 0, function() {
            return $87zMB.__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.digestSync()
                ];
            });
        });
    };
    return Sha256;
}();
module.exports.Sha256 = $e2c1b6da55083e98$var$Sha256;
function $e2c1b6da55083e98$var$bufferFromSecret(secret) {
    var input = $e2c1b6da55083e98$var$convertToBuffer(secret);
    if (input.byteLength > $ft3RT.BLOCK_SIZE) {
        var bufferHash = new $lB6JH.RawSha256();
        bufferHash.update(input);
        input = bufferHash.digest();
    }
    var buffer = new Uint8Array($ft3RT.BLOCK_SIZE);
    buffer.set(input);
    return buffer;
}
function $e2c1b6da55083e98$var$isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
function $e2c1b6da55083e98$var$convertToBuffer(data) {
    if (typeof data === "string") return $8hHBS.fromUtf8(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}

});
parcelRegister("ft3RT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * @internal
 */ module.exports.BLOCK_SIZE = 64;
/**
 * @internal
 */ module.exports.DIGEST_LENGTH = 32;
/**
 * @internal
 */ module.exports.KEY = new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
/**
 * @internal
 */ module.exports.INIT = [
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
];
/**
 * @internal
 */ module.exports.MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;

});

parcelRegister("lB6JH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $ft3RT = parcelRequire("ft3RT");
/**
 * @internal
 */ var $fb92475389a21656$var$RawSha256 = /** @class */ function() {
    function RawSha256() {
        this.state = Int32Array.from($ft3RT.INIT);
        this.temp = new Int32Array(64);
        this.buffer = new Uint8Array(64);
        this.bufferLength = 0;
        this.bytesHashed = 0;
        /**
         * @internal
         */ this.finished = false;
    }
    RawSha256.prototype.update = function(data) {
        if (this.finished) throw new Error("Attempted to update an already finished hash.");
        var position = 0;
        var byteLength = data.byteLength;
        this.bytesHashed += byteLength;
        if (this.bytesHashed * 8 > $ft3RT.MAX_HASHABLE_LENGTH) throw new Error("Cannot hash more than 2^53 - 1 bits");
        while(byteLength > 0){
            this.buffer[this.bufferLength++] = data[position++];
            byteLength--;
            if (this.bufferLength === $ft3RT.BLOCK_SIZE) {
                this.hashBuffer();
                this.bufferLength = 0;
            }
        }
    };
    RawSha256.prototype.digest = function() {
        if (!this.finished) {
            var bitsHashed = this.bytesHashed * 8;
            var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
            var undecoratedLength = this.bufferLength;
            bufferView.setUint8(this.bufferLength++, 0x80);
            // Ensure the final block has enough room for the hashed length
            if (undecoratedLength % $ft3RT.BLOCK_SIZE >= $ft3RT.BLOCK_SIZE - 8) {
                for(var i = this.bufferLength; i < $ft3RT.BLOCK_SIZE; i++)bufferView.setUint8(i, 0);
                this.hashBuffer();
                this.bufferLength = 0;
            }
            for(var i = this.bufferLength; i < $ft3RT.BLOCK_SIZE - 8; i++)bufferView.setUint8(i, 0);
            bufferView.setUint32($ft3RT.BLOCK_SIZE - 8, Math.floor(bitsHashed / 0x100000000), true);
            bufferView.setUint32($ft3RT.BLOCK_SIZE - 4, bitsHashed);
            this.hashBuffer();
            this.finished = true;
        }
        // The value in state is little-endian rather than big-endian, so flip
        // each word into a new Uint8Array
        var out = new Uint8Array($ft3RT.DIGEST_LENGTH);
        for(var i = 0; i < 8; i++){
            out[i * 4] = this.state[i] >>> 24 & 0xff;
            out[i * 4 + 1] = this.state[i] >>> 16 & 0xff;
            out[i * 4 + 2] = this.state[i] >>> 8 & 0xff;
            out[i * 4 + 3] = this.state[i] >>> 0 & 0xff;
        }
        return out;
    };
    RawSha256.prototype.hashBuffer = function() {
        var _a = this, buffer = _a.buffer, state = _a.state;
        var state0 = state[0], state1 = state[1], state2 = state[2], state3 = state[3], state4 = state[4], state5 = state[5], state6 = state[6], state7 = state[7];
        for(var i = 0; i < $ft3RT.BLOCK_SIZE; i++){
            if (i < 16) this.temp[i] = (buffer[i * 4] & 0xff) << 24 | (buffer[i * 4 + 1] & 0xff) << 16 | (buffer[i * 4 + 2] & 0xff) << 8 | buffer[i * 4 + 3] & 0xff;
            else {
                var u = this.temp[i - 2];
                var t1_1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
                u = this.temp[i - 15];
                var t2_1 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
                this.temp[i] = (t1_1 + this.temp[i - 7] | 0) + (t2_1 + this.temp[i - 16] | 0);
            }
            var t1 = (((state4 >>> 6 | state4 << 26) ^ (state4 >>> 11 | state4 << 21) ^ (state4 >>> 25 | state4 << 7)) + (state4 & state5 ^ ~state4 & state6) | 0) + (state7 + ($ft3RT.KEY[i] + this.temp[i] | 0) | 0) | 0;
            var t2 = ((state0 >>> 2 | state0 << 30) ^ (state0 >>> 13 | state0 << 19) ^ (state0 >>> 22 | state0 << 10)) + (state0 & state1 ^ state0 & state2 ^ state1 & state2) | 0;
            state7 = state6;
            state6 = state5;
            state5 = state4;
            state4 = state3 + t1 | 0;
            state3 = state2;
            state2 = state1;
            state1 = state0;
            state0 = t1 + t2 | 0;
        }
        state[0] += state0;
        state[1] += state1;
        state[2] += state2;
        state[3] += state3;
        state[4] += state4;
        state[5] += state5;
        state[6] += state6;
        state[7] += state7;
    };
    return RawSha256;
}();
module.exports.RawSha256 = $fb92475389a21656$var$RawSha256;

});

parcelRegister("8hHBS", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", () => $6081bd4ceca123c7$export$c7c5cef950a4d2fc);

var $crjx8 = parcelRequire("crjx8");

var $2un3Y = parcelRequire("2un3Y");
var $6081bd4ceca123c7$export$c7c5cef950a4d2fc = function(input) {
    return typeof TextEncoder === "function" ? (0, $2un3Y.fromUtf8)(input) : (0, $crjx8.fromUtf8)(input);
};
var $6081bd4ceca123c7$export$b4b216764bb846eb = function(input) {
    return typeof TextDecoder === "function" ? (0, $2un3Y.toUtf8)(input) : (0, $crjx8.toUtf8)(input);
};

});
parcelRegister("crjx8", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", () => $90e7289b25997b37$export$c7c5cef950a4d2fc);
$parcel$export(module.exports, "toUtf8", () => $90e7289b25997b37$export$b4b216764bb846eb);
/**
 * Converts a JS string from its native UCS-2/UTF-16 representation into a
 * Uint8Array of the bytes used to represent the equivalent characters in UTF-8.
 *
 * Cribbed from the `goog.crypt.stringToUtf8ByteArray` function in the Google
 * Closure library, though updated to use typed arrays.
 */ var $90e7289b25997b37$export$c7c5cef950a4d2fc = function(input) {
    var bytes = [];
    for(var i = 0, len = input.length; i < len; i++){
        var value = input.charCodeAt(i);
        if (value < 0x80) bytes.push(value);
        else if (value < 0x800) bytes.push(value >> 6 | 192, value & 63 | 128);
        else if (i + 1 < input.length && (value & 0xfc00) === 0xd800 && (input.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            var surrogatePair = 0x10000 + ((value & 1023) << 10) + (input.charCodeAt(++i) & 1023);
            bytes.push(surrogatePair >> 18 | 240, surrogatePair >> 12 & 63 | 128, surrogatePair >> 6 & 63 | 128, surrogatePair & 63 | 128);
        } else bytes.push(value >> 12 | 224, value >> 6 & 63 | 128, value & 63 | 128);
    }
    return Uint8Array.from(bytes);
};
var $90e7289b25997b37$export$b4b216764bb846eb = function(input) {
    var decoded = "";
    for(var i = 0, len = input.length; i < len; i++){
        var byte = input[i];
        if (byte < 0x80) decoded += String.fromCharCode(byte);
        else if (192 <= byte && byte < 224) {
            var nextByte = input[++i];
            decoded += String.fromCharCode((byte & 31) << 6 | nextByte & 63);
        } else if (240 <= byte && byte < 365) {
            var surrogatePair = [
                byte,
                input[++i],
                input[++i],
                input[++i]
            ];
            var encoded = "%" + surrogatePair.map(function(byteValue) {
                return byteValue.toString(16);
            }).join("%");
            decoded += decodeURIComponent(encoded);
        } else decoded += String.fromCharCode((byte & 15) << 12 | (input[++i] & 63) << 6 | input[++i] & 63);
    }
    return decoded;
};

});

parcelRegister("2un3Y", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", () => $1d0045f39441152e$export$c7c5cef950a4d2fc);
$parcel$export(module.exports, "toUtf8", () => $1d0045f39441152e$export$b4b216764bb846eb);
function $1d0045f39441152e$export$c7c5cef950a4d2fc(input) {
    return new TextEncoder().encode(input);
}
function $1d0045f39441152e$export$b4b216764bb846eb(input) {
    return new TextDecoder("utf-8").decode(input);
}

});




parcelRegister("2YcGN", function(module, exports) {

$parcel$export(module.exports, "fromHex", () => $229b0731129b30d0$export$1a8ceedbd5845648);
$parcel$export(module.exports, "toHex", () => $229b0731129b30d0$export$7ea66e3774a60b67);
var $229b0731129b30d0$var$SHORT_TO_HEX = {};
var $229b0731129b30d0$var$HEX_TO_SHORT = {};
for(var $229b0731129b30d0$var$i = 0; $229b0731129b30d0$var$i < 256; $229b0731129b30d0$var$i++){
    var $229b0731129b30d0$var$encodedByte = $229b0731129b30d0$var$i.toString(16).toLowerCase();
    if ($229b0731129b30d0$var$encodedByte.length === 1) $229b0731129b30d0$var$encodedByte = "0" + $229b0731129b30d0$var$encodedByte;
    $229b0731129b30d0$var$SHORT_TO_HEX[$229b0731129b30d0$var$i] = $229b0731129b30d0$var$encodedByte;
    $229b0731129b30d0$var$HEX_TO_SHORT[$229b0731129b30d0$var$encodedByte] = $229b0731129b30d0$var$i;
}
function $229b0731129b30d0$export$1a8ceedbd5845648(encoded) {
    if (encoded.length % 2 !== 0) throw new Error("Hex encoded strings must have an even number length");
    var out = new Uint8Array(encoded.length / 2);
    for(var i = 0; i < encoded.length; i += 2){
        var encodedByte = encoded.substr(i, 2).toLowerCase();
        if (encodedByte in $229b0731129b30d0$var$HEX_TO_SHORT) out[i / 2] = $229b0731129b30d0$var$HEX_TO_SHORT[encodedByte];
        else throw new Error("Cannot decode unrecognized sequence " + encodedByte + " as hexadecimal");
    }
    return out;
}
function $229b0731129b30d0$export$7ea66e3774a60b67(bytes) {
    var out = "";
    for(var i = 0; i < bytes.byteLength; i++)out += $229b0731129b30d0$var$SHORT_TO_HEX[bytes[i]];
    return out;
}

});

parcelRegister("kcgTr", function(module, exports) {
/*
 * Copyright Joyent, Inc. and other Node contributors.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to permit
 * persons to whom the Software is furnished to do so, subject to the
 * following conditions:
 *
 * The above copyright notice and this permission notice shall be included
 * in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
 * OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
 * NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
 * DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
 * OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
 * USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ 'use strict';

var $bf7QZ = parcelRequire("bf7QZ");
function Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.host = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.query = null;
    this.pathname = null;
    this.path = null;
    this.href = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
/*
 * define these here so at least they only have to be
 * compiled once on the first module load.
 */ var protocolPattern = /^([a-z0-9.+-]+:)/i, portPattern = /:[0-9]*$/, // Special case for a simple path URL
simplePathPattern = /^(\/\/?(?!\/)[^?\s]*)(\?[^\s]*)?$/, /*
   * RFC 2396: characters reserved for delimiting URLs.
   * We actually just auto-escape these.
   */ delims = [
    '<',
    '>',
    '"',
    '`',
    ' ',
    '\r',
    '\n',
    '\t'
], // RFC 2396: characters not allowed for various reasons.
unwise = [
    '{',
    '}',
    '|',
    '\\',
    '^',
    '`'
].concat(delims), // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
autoEscape = [
    '\''
].concat(unwise), /*
   * Characters that are never ever allowed in a hostname.
   * Note that any invalid chars are also handled, but these
   * are the ones that are *expected* to be seen, so we fast-path
   * them.
   */ nonHostChars = [
    '%',
    '/',
    '?',
    ';',
    '#'
].concat(autoEscape), hostEndingChars = [
    '/',
    '?',
    '#'
], hostnameMaxLen = 255, hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/, hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, // protocols that can allow "unsafe" and "unwise" chars.
unsafeProtocol = {
    javascript: true,
    'javascript:': true
}, // protocols that never have a hostname.
hostlessProtocol = {
    javascript: true,
    'javascript:': true
}, // protocols that always contain a // bit.
slashedProtocol = {
    http: true,
    https: true,
    ftp: true,
    gopher: true,
    file: true,
    'http:': true,
    'https:': true,
    'ftp:': true,
    'gopher:': true,
    'file:': true
};

var $dyPSo = parcelRequire("dyPSo");
function urlParse(url, parseQueryString, slashesDenoteHost) {
    if (url && typeof url === 'object' && url instanceof Url) return url;
    var u = new Url();
    u.parse(url, parseQueryString, slashesDenoteHost);
    return u;
}
Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
    if (typeof url !== 'string') throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
    /*
   * Copy chrome, IE, opera backslash-handling behavior.
   * Back slashes before the query string get converted to forward slashes
   * See: https://code.google.com/p/chromium/issues/detail?id=25916
   */ var queryIndex = url.indexOf('?'), splitter = queryIndex !== -1 && queryIndex < url.indexOf('#') ? '?' : '#', uSplit = url.split(splitter), slashRegex = /\\/g;
    uSplit[0] = uSplit[0].replace(slashRegex, '/');
    url = uSplit.join(splitter);
    var rest = url;
    /*
   * trim before proceeding.
   * This is to support parse stuff like "  http://foo.com  \n"
   */ rest = rest.trim();
    if (!slashesDenoteHost && url.split('#').length === 1) {
        // Try fast path regexp
        var simplePath = simplePathPattern.exec(rest);
        if (simplePath) {
            this.path = rest;
            this.href = rest;
            this.pathname = simplePath[1];
            if (simplePath[2]) {
                this.search = simplePath[2];
                if (parseQueryString) this.query = $dyPSo.parse(this.search.substr(1));
                else this.query = this.search.substr(1);
            } else if (parseQueryString) {
                this.search = '';
                this.query = {};
            }
            return this;
        }
    }
    var proto = protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        var lowerProto = proto.toLowerCase();
        this.protocol = lowerProto;
        rest = rest.substr(proto.length);
    }
    /*
   * figure out if it's got a host
   * user@server is *always* interpreted as a hostname, and url
   * resolution will treat //foo/bar as host=foo,path=bar because that's
   * how the browser resolves relative URLs.
   */ if (slashesDenoteHost || proto || rest.match(/^\/\/[^@/]+@[^@/]+/)) {
        var slashes = rest.substr(0, 2) === '//';
        if (slashes && !(proto && hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!hostlessProtocol[proto] && (slashes || proto && !slashedProtocol[proto])) {
        /*
     * there's a hostname.
     * the first instance of /, ?, ;, or # ends the host.
     *
     * If there is an @ in the hostname, then non-host chars *are* allowed
     * to the left of the last @ sign, unless some host-ending character
     * comes *before* the @-sign.
     * URLs are obnoxious.
     *
     * ex:
     * http://a@b@c/ => user:a@b host:c
     * http://a@b?@c => user:a host:c path:/?@c
     */ /*
     * v0.12 TODO(isaacs): This is not quite how Chrome does things.
     * Review our test case against browsers more comprehensively.
     */ // find the first instance of any hostEndingChars
        var hostEnd = -1;
        for(var i = 0; i < hostEndingChars.length; i++){
            var hec = rest.indexOf(hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        /*
     * at this point, either we have an explicit point where the
     * auth portion cannot go past, or the last @ char is the decider.
     */ var auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf('@');
        else /*
       * atSign must be in auth portion.
       * http://a@b/c@d => host:b auth:a path:/c@d
       */ atSign = rest.lastIndexOf('@', hostEnd);
        /*
     * Now we have a portion which is definitely the auth.
     * Pull that off.
     */ if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = decodeURIComponent(auth);
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(var i = 0; i < nonHostChars.length; i++){
            var hec = rest.indexOf(nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        this.host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost();
        /*
     * we've indicated that there is a hostname,
     * so even if it's empty, it has to be present.
     */ this.hostname = this.hostname || '';
        /*
     * if hostname begins with [ and ends with ]
     * assume that it's an IPv6 address.
     */ var ipv6Hostname = this.hostname[0] === '[' && this.hostname[this.hostname.length - 1] === ']';
        // validate a little.
        if (!ipv6Hostname) {
            var hostparts = this.hostname.split(/\./);
            for(var i = 0, l = hostparts.length; i < l; i++){
                var part = hostparts[i];
                if (!part) continue;
                if (!part.match(hostnamePartPattern)) {
                    var newpart = '';
                    for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) /*
               * we replace non-ASCII char with a temporary placeholder
               * we need this to make sure size of hostname is not
               * broken by replacing non-ASCII by nothing
               */ newpart += 'x';
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match(hostnamePartPattern)) {
                        var validParts = hostparts.slice(0, i);
                        var notHost = hostparts.slice(i + 1);
                        var bit = part.match(hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = '/' + notHost.join('.') + rest;
                        this.hostname = validParts.join('.');
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > hostnameMaxLen) this.hostname = '';
        else // hostnames are always lower case.
        this.hostname = this.hostname.toLowerCase();
        if (!ipv6Hostname) /*
       * IDNA Support: Returns a punycoded representation of "domain".
       * It only converts parts of the domain name that
       * have non-ASCII characters, i.e. it doesn't matter if
       * you call it with a domain that already is ASCII-only.
       */ this.hostname = $bf7QZ.toASCII(this.hostname);
        var p = this.port ? ':' + this.port : '';
        var h = this.hostname || '';
        this.host = h + p;
        this.href += this.host;
        /*
     * strip [ and ] from the hostname
     * the host field still retains them, though
     */ if (ipv6Hostname) {
            this.hostname = this.hostname.substr(1, this.hostname.length - 2);
            if (rest[0] !== '/') rest = '/' + rest;
        }
    }
    /*
   * now rest is set to the post-host stuff.
   * chop off any delim chars.
   */ if (!unsafeProtocol[lowerProto]) /*
     * First, make 100% sure that any "autoEscape" chars get
     * escaped, even if encodeURIComponent doesn't think they
     * need to be.
     */ for(var i = 0, l = autoEscape.length; i < l; i++){
        var ae = autoEscape[i];
        if (rest.indexOf(ae) === -1) continue;
        var esc = encodeURIComponent(ae);
        if (esc === ae) esc = escape(ae);
        rest = rest.split(ae).join(esc);
    }
    // chop off from the tail first.
    var hash = rest.indexOf('#');
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    var qm = rest.indexOf('?');
    if (qm !== -1) {
        this.search = rest.substr(qm);
        this.query = rest.substr(qm + 1);
        if (parseQueryString) this.query = $dyPSo.parse(this.query);
        rest = rest.slice(0, qm);
    } else if (parseQueryString) {
        // no query string, but parseQueryString still requested
        this.search = '';
        this.query = {};
    }
    if (rest) this.pathname = rest;
    if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = '/';
    // to support http.request
    if (this.pathname || this.search) {
        var p = this.pathname || '';
        var s = this.search || '';
        this.path = p + s;
    }
    // finally, reconstruct the href based on what has been validated.
    this.href = this.format();
    return this;
};
// format a parsed object into a url string
function urlFormat(obj) {
    /*
   * ensure it's an object, and not a string url.
   * If it's an obj, this is a no-op.
   * this way, you can call url_format() on strings
   * to clean up potentially wonky urls.
   */ if (typeof obj === 'string') obj = urlParse(obj);
    if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
    return obj.format();
}
Url.prototype.format = function() {
    var auth = this.auth || '';
    if (auth) {
        auth = encodeURIComponent(auth);
        auth = auth.replace(/%3A/i, ':');
        auth += '@';
    }
    var protocol = this.protocol || '', pathname = this.pathname || '', hash = this.hash || '', host = false, query = '';
    if (this.host) host = auth + this.host;
    else if (this.hostname) {
        host = auth + (this.hostname.indexOf(':') === -1 ? this.hostname : '[' + this.hostname + ']');
        if (this.port) host += ':' + this.port;
    }
    if (this.query && typeof this.query === 'object' && Object.keys(this.query).length) query = $dyPSo.stringify(this.query, {
        arrayFormat: 'repeat',
        addQueryPrefix: false
    });
    var search = this.search || query && '?' + query || '';
    if (protocol && protocol.substr(-1) !== ':') protocol += ':';
    /*
   * only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
   * unless they had them to begin with.
   */ if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
        host = '//' + (host || '');
        if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
    } else if (!host) host = '';
    if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
    if (search && search.charAt(0) !== '?') search = '?' + search;
    pathname = pathname.replace(/[?#]/g, function(match) {
        return encodeURIComponent(match);
    });
    search = search.replace('#', '%23');
    return protocol + host + pathname + search + hash;
};
function urlResolve(source, relative) {
    return urlParse(source, false, true).resolve(relative);
}
Url.prototype.resolve = function(relative) {
    return this.resolveObject(urlParse(relative, false, true)).format();
};
function urlResolveObject(source, relative) {
    if (!source) return relative;
    return urlParse(source, false, true).resolveObject(relative);
}
Url.prototype.resolveObject = function(relative) {
    if (typeof relative === 'string') {
        var rel = new Url();
        rel.parse(relative, false, true);
        relative = rel;
    }
    var result = new Url();
    var tkeys = Object.keys(this);
    for(var tk = 0; tk < tkeys.length; tk++){
        var tkey = tkeys[tk];
        result[tkey] = this[tkey];
    }
    /*
   * hash is always overridden, no matter what.
   * even href="" will remove it.
   */ result.hash = relative.hash;
    // if the relative url is empty, then there's nothing left to do here.
    if (relative.href === '') {
        result.href = result.format();
        return result;
    }
    // hrefs like //foo/bar always cut to the protocol.
    if (relative.slashes && !relative.protocol) {
        // take everything except the protocol from relative
        var rkeys = Object.keys(relative);
        for(var rk = 0; rk < rkeys.length; rk++){
            var rkey = rkeys[rk];
            if (rkey !== 'protocol') result[rkey] = relative[rkey];
        }
        // urlParse appends trailing / to urls like http://www.example.com
        if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) {
            result.pathname = '/';
            result.path = result.pathname;
        }
        result.href = result.format();
        return result;
    }
    if (relative.protocol && relative.protocol !== result.protocol) {
        /*
     * if it's a known url protocol, then changing
     * the protocol does weird things
     * first, if it's not file:, then we MUST have a host,
     * and if there was a path
     * to begin with, then we MUST have a path.
     * if it is file:, then the host is dropped,
     * because that's known to be hostless.
     * anything else is assumed to be absolute.
     */ if (!slashedProtocol[relative.protocol]) {
            var keys = Object.keys(relative);
            for(var v = 0; v < keys.length; v++){
                var k = keys[v];
                result[k] = relative[k];
            }
            result.href = result.format();
            return result;
        }
        result.protocol = relative.protocol;
        if (!relative.host && !hostlessProtocol[relative.protocol]) {
            var relPath = (relative.pathname || '').split('/');
            while(relPath.length && !(relative.host = relPath.shift()));
            if (!relative.host) relative.host = '';
            if (!relative.hostname) relative.hostname = '';
            if (relPath[0] !== '') relPath.unshift('');
            if (relPath.length < 2) relPath.unshift('');
            result.pathname = relPath.join('/');
        } else result.pathname = relative.pathname;
        result.search = relative.search;
        result.query = relative.query;
        result.host = relative.host || '';
        result.auth = relative.auth;
        result.hostname = relative.hostname || relative.host;
        result.port = relative.port;
        // to support http.request
        if (result.pathname || result.search) {
            var p = result.pathname || '';
            var s = result.search || '';
            result.path = p + s;
        }
        result.slashes = result.slashes || relative.slashes;
        result.href = result.format();
        return result;
    }
    var isSourceAbs = result.pathname && result.pathname.charAt(0) === '/', isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === '/', mustEndAbs = isRelAbs || isSourceAbs || result.host && relative.pathname, removeAllDots = mustEndAbs, srcPath = result.pathname && result.pathname.split('/') || [], relPath = relative.pathname && relative.pathname.split('/') || [], psychotic = result.protocol && !slashedProtocol[result.protocol];
    /*
   * if the url is a non-slashed url, then relative
   * links like ../.. should be able
   * to crawl up to the hostname, as well.  This is strange.
   * result.protocol has already been set by now.
   * Later on, put the first path part into the host field.
   */ if (psychotic) {
        result.hostname = '';
        result.port = null;
        if (result.host) {
            if (srcPath[0] === '') srcPath[0] = result.host;
            else srcPath.unshift(result.host);
        }
        result.host = '';
        if (relative.protocol) {
            relative.hostname = null;
            relative.port = null;
            if (relative.host) {
                if (relPath[0] === '') relPath[0] = relative.host;
                else relPath.unshift(relative.host);
            }
            relative.host = null;
        }
        mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
    }
    if (isRelAbs) {
        // it's absolute.
        result.host = relative.host || relative.host === '' ? relative.host : result.host;
        result.hostname = relative.hostname || relative.hostname === '' ? relative.hostname : result.hostname;
        result.search = relative.search;
        result.query = relative.query;
        srcPath = relPath;
    // fall through to the dot-handling below.
    } else if (relPath.length) {
        /*
     * it's relative
     * throw away the existing file, and take the new path instead.
     */ if (!srcPath) srcPath = [];
        srcPath.pop();
        srcPath = srcPath.concat(relPath);
        result.search = relative.search;
        result.query = relative.query;
    } else if (relative.search != null) {
        /*
     * just pull out the search.
     * like href='?foo'.
     * Put this after the other two cases because it simplifies the booleans
     */ if (psychotic) {
            result.host = srcPath.shift();
            result.hostname = result.host;
            /*
       * occationaly the auth can get stuck only in host
       * this especially happens in cases like
       * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
       */ var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
            if (authInHost) {
                result.auth = authInHost.shift();
                result.hostname = authInHost.shift();
                result.host = result.hostname;
            }
        }
        result.search = relative.search;
        result.query = relative.query;
        // to support http.request
        if (result.pathname !== null || result.search !== null) result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
        result.href = result.format();
        return result;
    }
    if (!srcPath.length) {
        /*
     * no path at all.  easy.
     * we've already handled the other stuff above.
     */ result.pathname = null;
        // to support http.request
        if (result.search) result.path = '/' + result.search;
        else result.path = null;
        result.href = result.format();
        return result;
    }
    /*
   * if a url ENDs in . or .., then it must get a trailing slash.
   * however, if it ends in anything else non-slashy,
   * then it must NOT get a trailing slash.
   */ var last = srcPath.slice(-1)[0];
    var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === '.' || last === '..') || last === '';
    /*
   * strip single dots, resolve double dots to parent dir
   * if the path tries to go above the root, `up` ends up > 0
   */ var up = 0;
    for(var i = srcPath.length; i >= 0; i--){
        last = srcPath[i];
        if (last === '.') srcPath.splice(i, 1);
        else if (last === '..') {
            srcPath.splice(i, 1);
            up++;
        } else if (up) {
            srcPath.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (!mustEndAbs && !removeAllDots) for(; up--; up)srcPath.unshift('..');
    if (mustEndAbs && srcPath[0] !== '' && (!srcPath[0] || srcPath[0].charAt(0) !== '/')) srcPath.unshift('');
    if (hasTrailingSlash && srcPath.join('/').substr(-1) !== '/') srcPath.push('');
    var isAbsolute = srcPath[0] === '' || srcPath[0] && srcPath[0].charAt(0) === '/';
    // put the host back
    if (psychotic) {
        result.hostname = isAbsolute ? '' : srcPath.length ? srcPath.shift() : '';
        result.host = result.hostname;
        /*
     * occationaly the auth can get stuck only in host
     * this especially happens in cases like
     * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
     */ var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
        if (authInHost) {
            result.auth = authInHost.shift();
            result.hostname = authInHost.shift();
            result.host = result.hostname;
        }
    }
    mustEndAbs = mustEndAbs || result.host && srcPath.length;
    if (mustEndAbs && !isAbsolute) srcPath.unshift('');
    if (srcPath.length > 0) result.pathname = srcPath.join('/');
    else {
        result.pathname = null;
        result.path = null;
    }
    // to support request.http
    if (result.pathname !== null || result.search !== null) result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
    result.auth = relative.auth || result.auth;
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
};
Url.prototype.parseHost = function() {
    var host = this.host;
    var port = portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ':') this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};
exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;
exports.Url = Url;

});
parcelRegister("bf7QZ", function(module, exports) {
/*! https://mths.be/punycode v1.4.1 by @mathias */ (function(root) {
    /** Detect free variables */ var freeExports = exports && !exports.nodeType && exports;
    var freeModule = module && !module.nodeType && module;
    var freeGlobal = typeof $parcel$global == 'object' && $parcel$global;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) root = freeGlobal;
    /**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */ var punycode, /** Highest positive signed 32-bit float value */ maxInt = 2147483647, /** Bootstring parameters */ base = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, initialBias = 72, initialN = 128, delimiter = '-', /** Regular expressions */ regexPunycode = /^xn--/, regexNonASCII = /[^\x20-\x7E]/, regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, /** Error messages */ errors = {
        'overflow': 'Overflow: input needs wider integers to process',
        'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
        'invalid-input': 'Invalid input'
    }, /** Convenience shortcuts */ baseMinusTMin = base - tMin, floor = Math.floor, stringFromCharCode = String.fromCharCode, /** Temporary variable */ key;
    /*--------------------------------------------------------------------------*/ /**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */ function error(type) {
        throw new RangeError(errors[type]);
    }
    /**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */ function map(array, fn) {
        var length = array.length;
        var result = [];
        while(length--)result[length] = fn(array[length]);
        return result;
    }
    /**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */ function mapDomain(string, fn) {
        var parts = string.split('@');
        var result = '';
        if (parts.length > 1) {
            // In email addresses, only the domain name should be punycoded. Leave
            // the local part (i.e. everything up to `@`) intact.
            result = parts[0] + '@';
            string = parts[1];
        }
        // Avoid `split(regex)` for IE8 compatibility. See #17.
        string = string.replace(regexSeparators, '\x2E');
        var labels = string.split('.');
        var encoded = map(labels, fn).join('.');
        return result + encoded;
    }
    /**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */ function ucs2decode(string) {
        var output = [], counter = 0, length = string.length, value, extra;
        while(counter < length){
            value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // high surrogate, and there is a next character
                extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // unmatched surrogate; only append this code unit, in case the next
                    // code unit is the high surrogate of a surrogate pair
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    /**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */ function ucs2encode(array) {
        return map(array, function(value) {
            var output = '';
            if (value > 0xFFFF) {
                value -= 0x10000;
                output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                value = 0xDC00 | value & 0x3FF;
            }
            output += stringFromCharCode(value);
            return output;
        }).join('');
    }
    /**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */ function basicToDigit(codePoint) {
        if (codePoint - 48 < 10) return codePoint - 22;
        if (codePoint - 65 < 26) return codePoint - 65;
        if (codePoint - 97 < 26) return codePoint - 97;
        return base;
    }
    /**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */ function digitToBasic(digit, flag) {
        //  0..25 map to ASCII a..z or A..Z
        // 26..35 map to ASCII 0..9
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    }
    /**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */ function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
    }
    /**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */ function decode(input) {
        // Don't use UCS-2
        var output = [], inputLength = input.length, out, i = 0, n = initialN, bias = initialBias, basic, j, index, oldi, w, k, digit, t, /** Cached calculation results */ baseMinusT;
        // Handle the basic code points: let `basic` be the number of input code
        // points before the last delimiter, or `0` if there is none, then copy
        // the first basic code points to the output.
        basic = input.lastIndexOf(delimiter);
        if (basic < 0) basic = 0;
        for(j = 0; j < basic; ++j){
            // if it's not a basic code point
            if (input.charCodeAt(j) >= 0x80) error('not-basic');
            output.push(input.charCodeAt(j));
        }
        // Main decoding loop: start just after the last delimiter if any basic code
        // points were copied; start at the beginning otherwise.
        for(index = basic > 0 ? basic + 1 : 0; index < inputLength;){
            // `index` is the index of the next character to be consumed.
            // Decode a generalized variable-length integer into `delta`,
            // which gets added to `i`. The overflow checking is easier
            // if we increase `i` as we go, then subtract off its starting
            // value at the end to obtain `delta`.
            for(oldi = i, w = 1, k = base;; k += base){
                if (index >= inputLength) error('invalid-input');
                digit = basicToDigit(input.charCodeAt(index++));
                if (digit >= base || digit > floor((maxInt - i) / w)) error('overflow');
                i += digit * w;
                t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (digit < t) break;
                baseMinusT = base - t;
                if (w > floor(maxInt / baseMinusT)) error('overflow');
                w *= baseMinusT;
            }
            out = output.length + 1;
            bias = adapt(i - oldi, out, oldi == 0);
            // `i` was supposed to wrap around from `out` to `0`,
            // incrementing `n` each time, so we'll fix that now:
            if (floor(i / out) > maxInt - n) error('overflow');
            n += floor(i / out);
            i %= out;
            // Insert `n` at position `i` of the output
            output.splice(i++, 0, n);
        }
        return ucs2encode(output);
    }
    /**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */ function encode(input) {
        var n, delta, handledCPCount, basicLength, bias, j, m, q, k, t, currentValue, output = [], /** `inputLength` will hold the number of code points in `input`. */ inputLength, /** Cached calculation results */ handledCPCountPlusOne, baseMinusT, qMinusT;
        // Convert the input in UCS-2 to Unicode
        input = ucs2decode(input);
        // Cache the length
        inputLength = input.length;
        // Initialize the state
        n = initialN;
        delta = 0;
        bias = initialBias;
        // Handle the basic code points
        for(j = 0; j < inputLength; ++j){
            currentValue = input[j];
            if (currentValue < 0x80) output.push(stringFromCharCode(currentValue));
        }
        handledCPCount = basicLength = output.length;
        // `handledCPCount` is the number of code points that have been handled;
        // `basicLength` is the number of basic code points.
        // Finish the basic string - if it is not empty - with a delimiter
        if (basicLength) output.push(delimiter);
        // Main encoding loop:
        while(handledCPCount < inputLength){
            // All non-basic code points < n have been handled already. Find the next
            // larger one:
            for(m = maxInt, j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue >= n && currentValue < m) m = currentValue;
            }
            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
            // but guard against overflow
            handledCPCountPlusOne = handledCPCount + 1;
            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error('overflow');
            delta += (m - n) * handledCPCountPlusOne;
            n = m;
            for(j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue < n && ++delta > maxInt) error('overflow');
                if (currentValue == n) {
                    // Represent delta as a generalized variable-length integer
                    for(q = delta, k = base;; k += base){
                        t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                        if (q < t) break;
                        qMinusT = q - t;
                        baseMinusT = base - t;
                        output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                        q = floor(qMinusT / baseMinusT);
                    }
                    output.push(stringFromCharCode(digitToBasic(q, 0)));
                    bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                    delta = 0;
                    ++handledCPCount;
                }
            }
            ++delta;
            ++n;
        }
        return output.join('');
    }
    /**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */ function toUnicode(input) {
        return mapDomain(input, function(string) {
            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
    }
    /**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */ function toASCII(input) {
        return mapDomain(input, function(string) {
            return regexNonASCII.test(string) ? 'xn--' + encode(string) : string;
        });
    }
    /*--------------------------------------------------------------------------*/ /** Define the public API */ punycode = {
        /**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */ 'version': '1.4.1',
        /**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */ 'ucs2': {
            'decode': ucs2decode,
            'encode': ucs2encode
        },
        'decode': decode,
        'encode': encode,
        'toASCII': toASCII,
        'toUnicode': toUnicode
    };
    /** Expose `punycode` */ // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) define('punycode', function() {
        return punycode;
    });
    else if (freeExports && freeModule) {
        if (module.exports == freeExports) // in Node.js, io.js, or RingoJS v0.8.0+
        freeModule.exports = punycode;
        else // in Narwhal or RingoJS v0.7.0-
        for(key in punycode)punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
    } else // in Rhino or a web browser
    root.punycode = punycode;
})(this);

});

parcelRegister("dyPSo", function(module, exports) {
'use strict';

var $2IQdh = parcelRequire("2IQdh");

var $3wB6l = parcelRequire("3wB6l");

var $hMCV2 = parcelRequire("hMCV2");
module.exports = {
    formats: $hMCV2,
    parse: $3wB6l,
    stringify: $2IQdh
};

});
parcelRegister("2IQdh", function(module, exports) {
'use strict';

var $ece3R = parcelRequire("ece3R");

var $lxUc9 = parcelRequire("lxUc9");

var $hMCV2 = parcelRequire("hMCV2");
var $1fb8314eb32ac9e8$var$has = Object.prototype.hasOwnProperty;
var $1fb8314eb32ac9e8$var$arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var $1fb8314eb32ac9e8$var$isArray = Array.isArray;
var $1fb8314eb32ac9e8$var$push = Array.prototype.push;
var $1fb8314eb32ac9e8$var$pushToArray = function(arr, valueOrArray) {
    $1fb8314eb32ac9e8$var$push.apply(arr, $1fb8314eb32ac9e8$var$isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var $1fb8314eb32ac9e8$var$toISO = Date.prototype.toISOString;
var $1fb8314eb32ac9e8$var$defaultFormat = $hMCV2.default;
var $1fb8314eb32ac9e8$var$defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: 'indices',
    charset: 'utf-8',
    charsetSentinel: false,
    commaRoundTrip: false,
    delimiter: '&',
    encode: true,
    encodeDotInKeys: false,
    encoder: $lxUc9.encode,
    encodeValuesOnly: false,
    filter: void 0,
    format: $1fb8314eb32ac9e8$var$defaultFormat,
    formatter: $hMCV2.formatters[$1fb8314eb32ac9e8$var$defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return $1fb8314eb32ac9e8$var$toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var $1fb8314eb32ac9e8$var$isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean' || typeof v === 'symbol' || typeof v === 'bigint';
};
var $1fb8314eb32ac9e8$var$sentinel = {};
var $1fb8314eb32ac9e8$var$stringify = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel) {
    var obj = object;
    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while((tmpSc = tmpSc.get($1fb8314eb32ac9e8$var$sentinel)) !== void 0 && !findFlag){
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) throw new RangeError('Cyclic object value');
            else findFlag = true; // Break while
        }
        if (typeof tmpSc.get($1fb8314eb32ac9e8$var$sentinel) === 'undefined') step = 0;
    }
    if (typeof filter === 'function') obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === 'comma' && $1fb8314eb32ac9e8$var$isArray(obj)) obj = $lxUc9.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix, $1fb8314eb32ac9e8$var$defaults.encoder, charset, 'key', format) : prefix;
        obj = '';
    }
    if ($1fb8314eb32ac9e8$var$isNonNullishPrimitive(obj) || $lxUc9.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, $1fb8314eb32ac9e8$var$defaults.encoder, charset, 'key', format);
            return [
                formatter(keyValue) + '=' + formatter(encoder(obj, $1fb8314eb32ac9e8$var$defaults.encoder, charset, 'value', format))
            ];
        }
        return [
            formatter(prefix) + '=' + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === 'undefined') return values;
    var objKeys;
    if (generateArrayPrefix === 'comma' && $1fb8314eb32ac9e8$var$isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) obj = $lxUc9.maybeMap(obj, encoder);
        objKeys = [
            {
                value: obj.length > 0 ? obj.join(',') || null : void 0
            }
        ];
    } else if ($1fb8314eb32ac9e8$var$isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    var encodedPrefix = encodeDotInKeys ? String(prefix).replace(/\./g, '%2E') : String(prefix);
    var adjustedPrefix = commaRoundTrip && $1fb8314eb32ac9e8$var$isArray(obj) && obj.length === 1 ? encodedPrefix + '[]' : encodedPrefix;
    if (allowEmptyArrays && $1fb8314eb32ac9e8$var$isArray(obj) && obj.length === 0) return adjustedPrefix + '[]';
    for(var j = 0; j < objKeys.length; ++j){
        var key = objKeys[j];
        var value = typeof key === 'object' && key && typeof key.value !== 'undefined' ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var encodedKey = allowDots && encodeDotInKeys ? String(key).replace(/\./g, '%2E') : String(key);
        var keyPrefix = $1fb8314eb32ac9e8$var$isArray(obj) ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix : adjustedPrefix + (allowDots ? '.' + encodedKey : '[' + encodedKey + ']');
        sideChannel.set(object, step);
        var valueSideChannel = $ece3R();
        valueSideChannel.set($1fb8314eb32ac9e8$var$sentinel, sideChannel);
        $1fb8314eb32ac9e8$var$pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, generateArrayPrefix === 'comma' && encodeValuesOnly && $1fb8314eb32ac9e8$var$isArray(obj) ? null : encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
    }
    return values;
};
var $1fb8314eb32ac9e8$var$normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return $1fb8314eb32ac9e8$var$defaults;
    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    if (typeof opts.encodeDotInKeys !== 'undefined' && typeof opts.encodeDotInKeys !== 'boolean') throw new TypeError('`encodeDotInKeys` option can only be `true` or `false`, when provided');
    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') throw new TypeError('Encoder has to be a function.');
    var charset = opts.charset || $1fb8314eb32ac9e8$var$defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    var format = $hMCV2.default;
    if (typeof opts.format !== 'undefined') {
        if (!$1fb8314eb32ac9e8$var$has.call($hMCV2.formatters, opts.format)) throw new TypeError('Unknown format option provided.');
        format = opts.format;
    }
    var formatter = $hMCV2.formatters[format];
    var filter = $1fb8314eb32ac9e8$var$defaults.filter;
    if (typeof opts.filter === 'function' || $1fb8314eb32ac9e8$var$isArray(opts.filter)) filter = opts.filter;
    var arrayFormat;
    if (opts.arrayFormat in $1fb8314eb32ac9e8$var$arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
    else if ('indices' in opts) arrayFormat = opts.indices ? 'indices' : 'repeat';
    else arrayFormat = $1fb8314eb32ac9e8$var$defaults.arrayFormat;
    if ('commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    var allowDots = typeof opts.allowDots === 'undefined' ? opts.encodeDotInKeys === true ? true : $1fb8314eb32ac9e8$var$defaults.allowDots : !!opts.allowDots;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : $1fb8314eb32ac9e8$var$defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : $1fb8314eb32ac9e8$var$defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : $1fb8314eb32ac9e8$var$defaults.charsetSentinel,
        commaRoundTrip: !!opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === 'undefined' ? $1fb8314eb32ac9e8$var$defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : $1fb8314eb32ac9e8$var$defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === 'boolean' ? opts.encodeDotInKeys : $1fb8314eb32ac9e8$var$defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : $1fb8314eb32ac9e8$var$defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : $1fb8314eb32ac9e8$var$defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : $1fb8314eb32ac9e8$var$defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : $1fb8314eb32ac9e8$var$defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : $1fb8314eb32ac9e8$var$defaults.strictNullHandling
    };
};
module.exports = function(object, opts) {
    var obj = object;
    var options = $1fb8314eb32ac9e8$var$normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if ($1fb8314eb32ac9e8$var$isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== 'object' || obj === null) return '';
    var generateArrayPrefix = $1fb8314eb32ac9e8$var$arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === 'comma' && options.commaRoundTrip;
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    var sideChannel = $ece3R();
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        var value = obj[key];
        if (options.skipNulls && value === null) continue;
        $1fb8314eb32ac9e8$var$pushToArray(keys, $1fb8314eb32ac9e8$var$stringify(value, key, generateArrayPrefix, commaRoundTrip, options.allowEmptyArrays, options.strictNullHandling, options.skipNulls, options.encodeDotInKeys, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';
    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += 'utf8=%26%2310003%3B&';
        else // encodeURIComponent('✓')
        prefix += 'utf8=%E2%9C%93&';
    }
    return joined.length > 0 ? prefix + joined : '';
};

});
parcelRegister("ece3R", function(module, exports) {
'use strict';

var $czmiz = parcelRequire("czmiz");

var $3rnaW = parcelRequire("3rnaW");

var $3dqH0 = parcelRequire("3dqH0");

var $cKIyF = parcelRequire("cKIyF");

var $88cjV = parcelRequire("88cjV");
var $a55d17eddee532cc$var$makeChannel = $88cjV || $cKIyF || $3dqH0;
/** @type {import('.')} */ module.exports = function getSideChannel() {
    /** @typedef {ReturnType<typeof getSideChannel>} Channel */ /** @type {Channel | undefined} */ var $channelData;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $czmiz('Side channel does not contain ' + $3rnaW(key));
        },
        'delete': function(key) {
            return !!$channelData && $channelData['delete'](key);
        },
        get: function(key) {
            return $channelData && $channelData.get(key);
        },
        has: function(key) {
            return !!$channelData && $channelData.has(key);
        },
        set: function(key, value) {
            if (!$channelData) $channelData = $a55d17eddee532cc$var$makeChannel();
            $channelData.set(key, value);
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
};

});
parcelRegister("czmiz", function(module, exports) {
'use strict';
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("3rnaW", function(module, exports) {
var $2815dee4dd8498b4$var$hasMap = typeof Map === 'function' && Map.prototype;
var $2815dee4dd8498b4$var$mapSizeDescriptor = Object.getOwnPropertyDescriptor && $2815dee4dd8498b4$var$hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var $2815dee4dd8498b4$var$mapSize = $2815dee4dd8498b4$var$hasMap && $2815dee4dd8498b4$var$mapSizeDescriptor && typeof $2815dee4dd8498b4$var$mapSizeDescriptor.get === 'function' ? $2815dee4dd8498b4$var$mapSizeDescriptor.get : null;
var $2815dee4dd8498b4$var$mapForEach = $2815dee4dd8498b4$var$hasMap && Map.prototype.forEach;
var $2815dee4dd8498b4$var$hasSet = typeof Set === 'function' && Set.prototype;
var $2815dee4dd8498b4$var$setSizeDescriptor = Object.getOwnPropertyDescriptor && $2815dee4dd8498b4$var$hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var $2815dee4dd8498b4$var$setSize = $2815dee4dd8498b4$var$hasSet && $2815dee4dd8498b4$var$setSizeDescriptor && typeof $2815dee4dd8498b4$var$setSizeDescriptor.get === 'function' ? $2815dee4dd8498b4$var$setSizeDescriptor.get : null;
var $2815dee4dd8498b4$var$setForEach = $2815dee4dd8498b4$var$hasSet && Set.prototype.forEach;
var $2815dee4dd8498b4$var$hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var $2815dee4dd8498b4$var$weakMapHas = $2815dee4dd8498b4$var$hasWeakMap ? WeakMap.prototype.has : null;
var $2815dee4dd8498b4$var$hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var $2815dee4dd8498b4$var$weakSetHas = $2815dee4dd8498b4$var$hasWeakSet ? WeakSet.prototype.has : null;
var $2815dee4dd8498b4$var$hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var $2815dee4dd8498b4$var$weakRefDeref = $2815dee4dd8498b4$var$hasWeakRef ? WeakRef.prototype.deref : null;
var $2815dee4dd8498b4$var$booleanValueOf = Boolean.prototype.valueOf;
var $2815dee4dd8498b4$var$objectToString = Object.prototype.toString;
var $2815dee4dd8498b4$var$functionToString = Function.prototype.toString;
var $2815dee4dd8498b4$var$$match = String.prototype.match;
var $2815dee4dd8498b4$var$$slice = String.prototype.slice;
var $2815dee4dd8498b4$var$$replace = String.prototype.replace;
var $2815dee4dd8498b4$var$$toUpperCase = String.prototype.toUpperCase;
var $2815dee4dd8498b4$var$$toLowerCase = String.prototype.toLowerCase;
var $2815dee4dd8498b4$var$$test = RegExp.prototype.test;
var $2815dee4dd8498b4$var$$concat = Array.prototype.concat;
var $2815dee4dd8498b4$var$$join = Array.prototype.join;
var $2815dee4dd8498b4$var$$arrSlice = Array.prototype.slice;
var $2815dee4dd8498b4$var$$floor = Math.floor;
var $2815dee4dd8498b4$var$bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var $2815dee4dd8498b4$var$gOPS = Object.getOwnPropertySymbols;
var $2815dee4dd8498b4$var$symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var $2815dee4dd8498b4$var$hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var $2815dee4dd8498b4$var$toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === $2815dee4dd8498b4$var$hasShammedSymbols ? 'object' : 'symbol') ? Symbol.toStringTag : null;
var $2815dee4dd8498b4$var$isEnumerable = Object.prototype.propertyIsEnumerable;
var $2815dee4dd8498b4$var$gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
function $2815dee4dd8498b4$var$addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $2815dee4dd8498b4$var$$test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$2815dee4dd8498b4$var$$floor(-num) : $2815dee4dd8498b4$var$$floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $2815dee4dd8498b4$var$$slice.call(str, intStr.length + 1);
            return $2815dee4dd8498b4$var$$replace.call(intStr, sepRegex, '$&_') + '.' + $2815dee4dd8498b4$var$$replace.call($2815dee4dd8498b4$var$$replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $2815dee4dd8498b4$var$$replace.call(str, sepRegex, '$&_');
}

var $1r8ZG = parcelRequire("1r8ZG");
var $2815dee4dd8498b4$var$inspectCustom = $1r8ZG.custom;
var $2815dee4dd8498b4$var$inspectSymbol = $2815dee4dd8498b4$var$isSymbol($2815dee4dd8498b4$var$inspectCustom) ? $2815dee4dd8498b4$var$inspectCustom : null;
var $2815dee4dd8498b4$var$quotes = {
    __proto__: null,
    'double': '"',
    single: "'"
};
var $2815dee4dd8498b4$var$quoteREs = {
    __proto__: null,
    'double': /(["\\])/g,
    single: /(['\\])/g
};
module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if ($2815dee4dd8498b4$var$has(opts, 'quoteStyle') && !$2815dee4dd8498b4$var$has($2815dee4dd8498b4$var$quotes, opts.quoteStyle)) throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if ($2815dee4dd8498b4$var$has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number' ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = $2815dee4dd8498b4$var$has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    if ($2815dee4dd8498b4$var$has(opts, 'indent') && opts.indent !== null && opts.indent !== '\t' && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if ($2815dee4dd8498b4$var$has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === 'undefined') return 'undefined';
    if (obj === null) return 'null';
    if (typeof obj === 'boolean') return obj ? 'true' : 'false';
    if (typeof obj === 'string') return $2815dee4dd8498b4$var$inspectString(obj, opts);
    if (typeof obj === 'number') {
        if (obj === 0) return Infinity / obj > 0 ? '0' : '-0';
        var str = String(obj);
        return numericSeparator ? $2815dee4dd8498b4$var$addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? $2815dee4dd8498b4$var$addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') return $2815dee4dd8498b4$var$isArray(obj) ? '[Array]' : '[Object]';
    var indent = $2815dee4dd8498b4$var$getIndent(opts, depth);
    if (typeof seen === 'undefined') seen = [];
    else if ($2815dee4dd8498b4$var$indexOf(seen, obj) >= 0) return '[Circular]';
    function inspect(value, from, noIndent) {
        if (from) {
            seen = $2815dee4dd8498b4$var$$arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if ($2815dee4dd8498b4$var$has(opts, 'quoteStyle')) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === 'function' && !$2815dee4dd8498b4$var$isRegExp(obj)) {
        var name = $2815dee4dd8498b4$var$nameOf(obj);
        var keys = $2815dee4dd8498b4$var$arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $2815dee4dd8498b4$var$$join.call(keys, ', ') + ' }' : '');
    }
    if ($2815dee4dd8498b4$var$isSymbol(obj)) {
        var symString = $2815dee4dd8498b4$var$hasShammedSymbols ? $2815dee4dd8498b4$var$$replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : $2815dee4dd8498b4$var$symToString.call(obj);
        return typeof obj === 'object' && !$2815dee4dd8498b4$var$hasShammedSymbols ? $2815dee4dd8498b4$var$markBoxed(symString) : symString;
    }
    if ($2815dee4dd8498b4$var$isElement(obj)) {
        var s = '<' + $2815dee4dd8498b4$var$$toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += ' ' + attrs[i].name + '=' + $2815dee4dd8498b4$var$wrapQuotes($2815dee4dd8498b4$var$quote(attrs[i].value), 'double', opts);
        s += '>';
        if (obj.childNodes && obj.childNodes.length) s += '...';
        s += '</' + $2815dee4dd8498b4$var$$toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if ($2815dee4dd8498b4$var$isArray(obj)) {
        if (obj.length === 0) return '[]';
        var xs = $2815dee4dd8498b4$var$arrObjKeys(obj, inspect);
        if (indent && !$2815dee4dd8498b4$var$singleLineValues(xs)) return '[' + $2815dee4dd8498b4$var$indentedJoin(xs, indent) + ']';
        return '[ ' + $2815dee4dd8498b4$var$$join.call(xs, ', ') + ' ]';
    }
    if ($2815dee4dd8498b4$var$isError(obj)) {
        var parts = $2815dee4dd8498b4$var$arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !$2815dee4dd8498b4$var$isEnumerable.call(obj, 'cause')) return '{ [' + String(obj) + '] ' + $2815dee4dd8498b4$var$$join.call($2815dee4dd8498b4$var$$concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        if (parts.length === 0) return '[' + String(obj) + ']';
        return '{ [' + String(obj) + '] ' + $2815dee4dd8498b4$var$$join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if ($2815dee4dd8498b4$var$inspectSymbol && typeof obj[$2815dee4dd8498b4$var$inspectSymbol] === 'function' && $1r8ZG) return $1r8ZG(obj, {
            depth: maxDepth - depth
        });
        else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') return obj.inspect();
    }
    if ($2815dee4dd8498b4$var$isMap(obj)) {
        var mapParts = [];
        if ($2815dee4dd8498b4$var$mapForEach) $2815dee4dd8498b4$var$mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
        });
        return $2815dee4dd8498b4$var$collectionOf('Map', $2815dee4dd8498b4$var$mapSize.call(obj), mapParts, indent);
    }
    if ($2815dee4dd8498b4$var$isSet(obj)) {
        var setParts = [];
        if ($2815dee4dd8498b4$var$setForEach) $2815dee4dd8498b4$var$setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return $2815dee4dd8498b4$var$collectionOf('Set', $2815dee4dd8498b4$var$setSize.call(obj), setParts, indent);
    }
    if ($2815dee4dd8498b4$var$isWeakMap(obj)) return $2815dee4dd8498b4$var$weakCollectionOf('WeakMap');
    if ($2815dee4dd8498b4$var$isWeakSet(obj)) return $2815dee4dd8498b4$var$weakCollectionOf('WeakSet');
    if ($2815dee4dd8498b4$var$isWeakRef(obj)) return $2815dee4dd8498b4$var$weakCollectionOf('WeakRef');
    if ($2815dee4dd8498b4$var$isNumber(obj)) return $2815dee4dd8498b4$var$markBoxed(inspect(Number(obj)));
    if ($2815dee4dd8498b4$var$isBigInt(obj)) return $2815dee4dd8498b4$var$markBoxed(inspect($2815dee4dd8498b4$var$bigIntValueOf.call(obj)));
    if ($2815dee4dd8498b4$var$isBoolean(obj)) return $2815dee4dd8498b4$var$markBoxed($2815dee4dd8498b4$var$booleanValueOf.call(obj));
    if ($2815dee4dd8498b4$var$isString(obj)) return $2815dee4dd8498b4$var$markBoxed(inspect(String(obj)));
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */ if (typeof window !== 'undefined' && obj === window) return '{ [object Window] }';
    if (typeof globalThis !== 'undefined' && obj === globalThis || typeof $parcel$global !== 'undefined' && obj === $parcel$global) return '{ [object globalThis] }';
    if (!$2815dee4dd8498b4$var$isDate(obj) && !$2815dee4dd8498b4$var$isRegExp(obj)) {
        var ys = $2815dee4dd8498b4$var$arrObjKeys(obj, inspect);
        var isPlainObject = $2815dee4dd8498b4$var$gPO ? $2815dee4dd8498b4$var$gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && $2815dee4dd8498b4$var$toStringTag && Object(obj) === obj && $2815dee4dd8498b4$var$toStringTag in obj ? $2815dee4dd8498b4$var$$slice.call($2815dee4dd8498b4$var$toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $2815dee4dd8498b4$var$$join.call($2815dee4dd8498b4$var$$concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) return tag + '{}';
        if (indent) return tag + '{' + $2815dee4dd8498b4$var$indentedJoin(ys, indent) + '}';
        return tag + '{ ' + $2815dee4dd8498b4$var$$join.call(ys, ', ') + ' }';
    }
    return String(obj);
};
function $2815dee4dd8498b4$var$wrapQuotes(s, defaultStyle, opts) {
    var style = opts.quoteStyle || defaultStyle;
    var quoteChar = $2815dee4dd8498b4$var$quotes[style];
    return quoteChar + s + quoteChar;
}
function $2815dee4dd8498b4$var$quote(s) {
    return $2815dee4dd8498b4$var$$replace.call(String(s), /"/g, '&quot;');
}
function $2815dee4dd8498b4$var$canTrustToString(obj) {
    return !$2815dee4dd8498b4$var$toStringTag || !(typeof obj === 'object' && ($2815dee4dd8498b4$var$toStringTag in obj || typeof obj[$2815dee4dd8498b4$var$toStringTag] !== 'undefined'));
}
function $2815dee4dd8498b4$var$isArray(obj) {
    return $2815dee4dd8498b4$var$toStr(obj) === '[object Array]' && $2815dee4dd8498b4$var$canTrustToString(obj);
}
function $2815dee4dd8498b4$var$isDate(obj) {
    return $2815dee4dd8498b4$var$toStr(obj) === '[object Date]' && $2815dee4dd8498b4$var$canTrustToString(obj);
}
function $2815dee4dd8498b4$var$isRegExp(obj) {
    return $2815dee4dd8498b4$var$toStr(obj) === '[object RegExp]' && $2815dee4dd8498b4$var$canTrustToString(obj);
}
function $2815dee4dd8498b4$var$isError(obj) {
    return $2815dee4dd8498b4$var$toStr(obj) === '[object Error]' && $2815dee4dd8498b4$var$canTrustToString(obj);
}
function $2815dee4dd8498b4$var$isString(obj) {
    return $2815dee4dd8498b4$var$toStr(obj) === '[object String]' && $2815dee4dd8498b4$var$canTrustToString(obj);
}
function $2815dee4dd8498b4$var$isNumber(obj) {
    return $2815dee4dd8498b4$var$toStr(obj) === '[object Number]' && $2815dee4dd8498b4$var$canTrustToString(obj);
}
function $2815dee4dd8498b4$var$isBoolean(obj) {
    return $2815dee4dd8498b4$var$toStr(obj) === '[object Boolean]' && $2815dee4dd8498b4$var$canTrustToString(obj);
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function $2815dee4dd8498b4$var$isSymbol(obj) {
    if ($2815dee4dd8498b4$var$hasShammedSymbols) return obj && typeof obj === 'object' && obj instanceof Symbol;
    if (typeof obj === 'symbol') return true;
    if (!obj || typeof obj !== 'object' || !$2815dee4dd8498b4$var$symToString) return false;
    try {
        $2815dee4dd8498b4$var$symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function $2815dee4dd8498b4$var$isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !$2815dee4dd8498b4$var$bigIntValueOf) return false;
    try {
        $2815dee4dd8498b4$var$bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var $2815dee4dd8498b4$var$hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function $2815dee4dd8498b4$var$has(obj, key) {
    return $2815dee4dd8498b4$var$hasOwn.call(obj, key);
}
function $2815dee4dd8498b4$var$toStr(obj) {
    return $2815dee4dd8498b4$var$objectToString.call(obj);
}
function $2815dee4dd8498b4$var$nameOf(f) {
    if (f.name) return f.name;
    var m = $2815dee4dd8498b4$var$$match.call($2815dee4dd8498b4$var$functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function $2815dee4dd8498b4$var$indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function $2815dee4dd8498b4$var$isMap(x) {
    if (!$2815dee4dd8498b4$var$mapSize || !x || typeof x !== 'object') return false;
    try {
        $2815dee4dd8498b4$var$mapSize.call(x);
        try {
            $2815dee4dd8498b4$var$setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $2815dee4dd8498b4$var$isWeakMap(x) {
    if (!$2815dee4dd8498b4$var$weakMapHas || !x || typeof x !== 'object') return false;
    try {
        $2815dee4dd8498b4$var$weakMapHas.call(x, $2815dee4dd8498b4$var$weakMapHas);
        try {
            $2815dee4dd8498b4$var$weakSetHas.call(x, $2815dee4dd8498b4$var$weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $2815dee4dd8498b4$var$isWeakRef(x) {
    if (!$2815dee4dd8498b4$var$weakRefDeref || !x || typeof x !== 'object') return false;
    try {
        $2815dee4dd8498b4$var$weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function $2815dee4dd8498b4$var$isSet(x) {
    if (!$2815dee4dd8498b4$var$setSize || !x || typeof x !== 'object') return false;
    try {
        $2815dee4dd8498b4$var$setSize.call(x);
        try {
            $2815dee4dd8498b4$var$mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $2815dee4dd8498b4$var$isWeakSet(x) {
    if (!$2815dee4dd8498b4$var$weakSetHas || !x || typeof x !== 'object') return false;
    try {
        $2815dee4dd8498b4$var$weakSetHas.call(x, $2815dee4dd8498b4$var$weakSetHas);
        try {
            $2815dee4dd8498b4$var$weakMapHas.call(x, $2815dee4dd8498b4$var$weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $2815dee4dd8498b4$var$isElement(x) {
    if (!x || typeof x !== 'object') return false;
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) return true;
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}
function $2815dee4dd8498b4$var$inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return $2815dee4dd8498b4$var$inspectString($2815dee4dd8498b4$var$$slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    var quoteRE = $2815dee4dd8498b4$var$quoteREs[opts.quoteStyle || 'single'];
    quoteRE.lastIndex = 0;
    // eslint-disable-next-line no-control-regex
    var s = $2815dee4dd8498b4$var$$replace.call($2815dee4dd8498b4$var$$replace.call(str, quoteRE, '\\$1'), /[\x00-\x1f]/g, $2815dee4dd8498b4$var$lowbyte);
    return $2815dee4dd8498b4$var$wrapQuotes(s, 'single', opts);
}
function $2815dee4dd8498b4$var$lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) return '\\' + x;
    return '\\x' + (n < 0x10 ? '0' : '') + $2815dee4dd8498b4$var$$toUpperCase.call(n.toString(16));
}
function $2815dee4dd8498b4$var$markBoxed(str) {
    return 'Object(' + str + ')';
}
function $2815dee4dd8498b4$var$weakCollectionOf(type) {
    return type + ' { ? }';
}
function $2815dee4dd8498b4$var$collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? $2815dee4dd8498b4$var$indentedJoin(entries, indent) : $2815dee4dd8498b4$var$$join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}
function $2815dee4dd8498b4$var$singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if ($2815dee4dd8498b4$var$indexOf(xs[i], '\n') >= 0) return false;
    }
    return true;
}
function $2815dee4dd8498b4$var$getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') baseIndent = '\t';
    else if (typeof opts.indent === 'number' && opts.indent > 0) baseIndent = $2815dee4dd8498b4$var$$join.call(Array(opts.indent + 1), ' ');
    else return null;
    return {
        base: baseIndent,
        prev: $2815dee4dd8498b4$var$$join.call(Array(depth + 1), baseIndent)
    };
}
function $2815dee4dd8498b4$var$indentedJoin(xs, indent) {
    if (xs.length === 0) return '';
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $2815dee4dd8498b4$var$$join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}
function $2815dee4dd8498b4$var$arrObjKeys(obj, inspect) {
    var isArr = $2815dee4dd8498b4$var$isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = $2815dee4dd8498b4$var$has(obj, i) ? inspect(obj[i], obj) : '';
    }
    var syms = typeof $2815dee4dd8498b4$var$gOPS === 'function' ? $2815dee4dd8498b4$var$gOPS(obj) : [];
    var symMap;
    if ($2815dee4dd8498b4$var$hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap['$' + syms[k]] = syms[k];
    }
    for(var key in obj){
        if (!$2815dee4dd8498b4$var$has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if ($2815dee4dd8498b4$var$hasShammedSymbols && symMap['$' + key] instanceof Symbol) continue; // eslint-disable-line no-restricted-syntax, no-continue
        else if ($2815dee4dd8498b4$var$$test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        else xs.push(key + ': ' + inspect(obj[key], obj));
    }
    if (typeof $2815dee4dd8498b4$var$gOPS === 'function') {
        for(var j = 0; j < syms.length; j++)if ($2815dee4dd8498b4$var$isEnumerable.call(obj, syms[j])) xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
    }
    return xs;
}

});
parcelRegister("1r8ZG", function(module, exports) {
"use strict";

});


parcelRegister("3dqH0", function(module, exports) {
'use strict';

var $3rnaW = parcelRequire("3rnaW");

var $czmiz = parcelRequire("czmiz");
/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list.
* By doing so, all the recently used nodes can be accessed relatively quickly.
*/ /** @type {import('./list.d.ts').listGetNode} */ // eslint-disable-next-line consistent-return
var $25774a9fb2b538a3$var$listGetNode = function(list, key, isDelete) {
    /** @type {typeof list | NonNullable<(typeof list)['next']>} */ var prev = list;
    /** @type {(typeof list)['next']} */ var curr;
    // eslint-disable-next-line eqeqeq
    for(; (curr = prev.next) != null; prev = curr)if (curr.key === key) {
        prev.next = curr.next;
        if (!isDelete) {
            // eslint-disable-next-line no-extra-parens
            curr.next = /** @type {NonNullable<typeof list.next>} */ list.next;
            list.next = curr; // eslint-disable-line no-param-reassign
        }
        return curr;
    }
};
/** @type {import('./list.d.ts').listGet} */ var $25774a9fb2b538a3$var$listGet = function(objects, key) {
    if (!objects) return void 0;
    var node = $25774a9fb2b538a3$var$listGetNode(objects, key);
    return node && node.value;
};
/** @type {import('./list.d.ts').listSet} */ var $25774a9fb2b538a3$var$listSet = function(objects, key, value) {
    var node = $25774a9fb2b538a3$var$listGetNode(objects, key);
    if (node) node.value = value;
    else // Prepend the new node to the beginning of the list
    objects.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */ {
        key: key,
        next: objects.next,
        value: value
    };
};
/** @type {import('./list.d.ts').listHas} */ var $25774a9fb2b538a3$var$listHas = function(objects, key) {
    if (!objects) return false;
    return !!$25774a9fb2b538a3$var$listGetNode(objects, key);
};
/** @type {import('./list.d.ts').listDelete} */ // eslint-disable-next-line consistent-return
var $25774a9fb2b538a3$var$listDelete = function(objects, key) {
    if (objects) return $25774a9fb2b538a3$var$listGetNode(objects, key, true);
};
/** @type {import('.')} */ module.exports = function getSideChannelList() {
    /** @typedef {ReturnType<typeof getSideChannelList>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {import('./list.d.ts').RootNode<V, K> | undefined} */ var $o;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $czmiz('Side channel does not contain ' + $3rnaW(key));
        },
        'delete': function(key) {
            var root = $o && $o.next;
            var deletedNode = $25774a9fb2b538a3$var$listDelete($o, key);
            if (deletedNode && root && root === deletedNode) $o = void 0;
            return !!deletedNode;
        },
        get: function(key) {
            return $25774a9fb2b538a3$var$listGet($o, key);
        },
        has: function(key) {
            return $25774a9fb2b538a3$var$listHas($o, key);
        },
        set: function(key, value) {
            if (!$o) // Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
            $o = {
                next: void 0
            };
            // eslint-disable-next-line no-extra-parens
            $25774a9fb2b538a3$var$listSet(/** @type {NonNullable<typeof $o>} */ $o, key, value);
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
};

});

parcelRegister("cKIyF", function(module, exports) {
'use strict';

var $7wvbq = parcelRequire("7wvbq");

var $8BH9V = parcelRequire("8BH9V");

var $3rnaW = parcelRequire("3rnaW");

var $czmiz = parcelRequire("czmiz");
var $948c583d127877e6$var$$Map = $7wvbq('%Map%', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => V} */ var $948c583d127877e6$var$$mapGet = $8BH9V('Map.prototype.get', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K, value: V) => void} */ var $948c583d127877e6$var$$mapSet = $8BH9V('Map.prototype.set', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */ var $948c583d127877e6$var$$mapHas = $8BH9V('Map.prototype.has', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */ var $948c583d127877e6$var$$mapDelete = $8BH9V('Map.prototype.delete', true);
/** @type {<K, V>(thisArg: Map<K, V>) => number} */ var $948c583d127877e6$var$$mapSize = $8BH9V('Map.prototype.size', true);
/** @type {import('.')} */ module.exports = !!$948c583d127877e6$var$$Map && /** @type {Exclude<import('.'), false>} */ function getSideChannelMap() {
    /** @typedef {ReturnType<typeof getSideChannelMap>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {Map<K, V> | undefined} */ var $m;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $czmiz('Side channel does not contain ' + $3rnaW(key));
        },
        'delete': function(key) {
            if ($m) {
                var result = $948c583d127877e6$var$$mapDelete($m, key);
                if ($948c583d127877e6$var$$mapSize($m) === 0) $m = void 0;
                return result;
            }
            return false;
        },
        get: function(key) {
            if ($m) return $948c583d127877e6$var$$mapGet($m, key);
        },
        has: function(key) {
            if ($m) return $948c583d127877e6$var$$mapHas($m, key);
            return false;
        },
        set: function(key, value) {
            if (!$m) // @ts-expect-error TS can't handle narrowing a variable inside a closure
            $m = new $948c583d127877e6$var$$Map();
            $948c583d127877e6$var$$mapSet($m, key, value);
        }
    };
    // @ts-expect-error TODO: figure out why TS is erroring here
    return channel;
};

});
parcelRegister("7wvbq", function(module, exports) {
'use strict';
var $57a3b5efdeb72185$var$undefined1;

var $3i090 = parcelRequire("3i090");

var $7Pqui = parcelRequire("7Pqui");

var $862cL = parcelRequire("862cL");

var $oOVQ2 = parcelRequire("oOVQ2");

var $1Wnwt = parcelRequire("1Wnwt");

var $hMrR0 = parcelRequire("hMrR0");

var $czmiz = parcelRequire("czmiz");

var $7ALch = parcelRequire("7ALch");

var $7D09D = parcelRequire("7D09D");

var $iXf6z = parcelRequire("iXf6z");

var $2U3Lv = parcelRequire("2U3Lv");

var $6aSdz = parcelRequire("6aSdz");

var $kn1m1 = parcelRequire("kn1m1");

var $fqVy6 = parcelRequire("fqVy6");

var $18QDC = parcelRequire("18QDC");
var $57a3b5efdeb72185$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $57a3b5efdeb72185$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $57a3b5efdeb72185$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};

var $9HCYo = parcelRequire("9HCYo");

var $lrVYM = parcelRequire("lrVYM");
var $57a3b5efdeb72185$var$throwTypeError = function() {
    throw new $czmiz();
};
var $57a3b5efdeb72185$var$ThrowTypeError = $9HCYo ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $57a3b5efdeb72185$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $9HCYo(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $57a3b5efdeb72185$var$throwTypeError;
        }
    }
}() : $57a3b5efdeb72185$var$throwTypeError;

var $57a3b5efdeb72185$var$hasSymbols = (parcelRequire("aWElS"))();

var $lSGtw = parcelRequire("lSGtw");

var $ffgaT = parcelRequire("ffgaT");

var $kcd4Z = parcelRequire("kcd4Z");

var $axzup = parcelRequire("axzup");

var $6Gf3b = parcelRequire("6Gf3b");
var $57a3b5efdeb72185$var$needsEval = {};
var $57a3b5efdeb72185$var$TypedArray = typeof Uint8Array === 'undefined' || !$lSGtw ? undefined : $lSGtw(Uint8Array);
var $57a3b5efdeb72185$var$INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $57a3b5efdeb72185$var$hasSymbols && $lSGtw ? $lSGtw([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $57a3b5efdeb72185$var$needsEval,
    '%AsyncGenerator%': $57a3b5efdeb72185$var$needsEval,
    '%AsyncGeneratorFunction%': $57a3b5efdeb72185$var$needsEval,
    '%AsyncIteratorPrototype%': $57a3b5efdeb72185$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $7Pqui,
    '%eval%': eval,
    '%EvalError%': $862cL,
    '%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $57a3b5efdeb72185$var$$Function,
    '%GeneratorFunction%': $57a3b5efdeb72185$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $57a3b5efdeb72185$var$hasSymbols && $lSGtw ? $lSGtw($lSGtw([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$57a3b5efdeb72185$var$hasSymbols || !$lSGtw ? undefined : $lSGtw(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': $3i090,
    '%Object.getOwnPropertyDescriptor%': $9HCYo,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $oOVQ2,
    '%ReferenceError%': $1Wnwt,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$57a3b5efdeb72185$var$hasSymbols || !$lSGtw ? undefined : $lSGtw(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $57a3b5efdeb72185$var$hasSymbols && $lSGtw ? $lSGtw(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $57a3b5efdeb72185$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $hMrR0,
    '%ThrowTypeError%': $57a3b5efdeb72185$var$ThrowTypeError,
    '%TypedArray%': $57a3b5efdeb72185$var$TypedArray,
    '%TypeError%': $czmiz,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $7ALch,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
    '%Function.prototype.call%': $6Gf3b,
    '%Function.prototype.apply%': $axzup,
    '%Object.defineProperty%': $lrVYM,
    '%Object.getPrototypeOf%': $ffgaT,
    '%Math.abs%': $7D09D,
    '%Math.floor%': $iXf6z,
    '%Math.max%': $2U3Lv,
    '%Math.min%': $6aSdz,
    '%Math.pow%': $kn1m1,
    '%Math.round%': $fqVy6,
    '%Math.sign%': $18QDC,
    '%Reflect.getPrototypeOf%': $kcd4Z
};
if ($lSGtw) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $57a3b5efdeb72185$var$errorProto = $lSGtw($lSGtw(e));
    $57a3b5efdeb72185$var$INTRINSICS['%Error.prototype%'] = $57a3b5efdeb72185$var$errorProto;
}
var $57a3b5efdeb72185$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $57a3b5efdeb72185$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $57a3b5efdeb72185$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $57a3b5efdeb72185$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $lSGtw) value = $lSGtw(gen.prototype);
    }
    $57a3b5efdeb72185$var$INTRINSICS[name] = value;
    return value;
};
var $57a3b5efdeb72185$var$LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $8JerU = parcelRequire("8JerU");

var $iVRNR = parcelRequire("iVRNR");
var $57a3b5efdeb72185$var$$concat = $8JerU.call($6Gf3b, Array.prototype.concat);
var $57a3b5efdeb72185$var$$spliceApply = $8JerU.call($axzup, Array.prototype.splice);
var $57a3b5efdeb72185$var$$replace = $8JerU.call($6Gf3b, String.prototype.replace);
var $57a3b5efdeb72185$var$$strSlice = $8JerU.call($6Gf3b, String.prototype.slice);
var $57a3b5efdeb72185$var$$exec = $8JerU.call($6Gf3b, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $57a3b5efdeb72185$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $57a3b5efdeb72185$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $57a3b5efdeb72185$var$stringToPath = function stringToPath(string) {
    var first = $57a3b5efdeb72185$var$$strSlice(string, 0, 1);
    var last = $57a3b5efdeb72185$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $hMrR0('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $hMrR0('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $57a3b5efdeb72185$var$$replace(string, $57a3b5efdeb72185$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $57a3b5efdeb72185$var$$replace(subString, $57a3b5efdeb72185$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $57a3b5efdeb72185$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($iVRNR($57a3b5efdeb72185$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $57a3b5efdeb72185$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($iVRNR($57a3b5efdeb72185$var$INTRINSICS, intrinsicName)) {
        var value = $57a3b5efdeb72185$var$INTRINSICS[intrinsicName];
        if (value === $57a3b5efdeb72185$var$needsEval) value = $57a3b5efdeb72185$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $czmiz('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $hMrR0('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $czmiz('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $czmiz('"allowMissing" argument must be a boolean');
    if ($57a3b5efdeb72185$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $hMrR0('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $57a3b5efdeb72185$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $57a3b5efdeb72185$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $57a3b5efdeb72185$var$$spliceApply(parts, $57a3b5efdeb72185$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $57a3b5efdeb72185$var$$strSlice(part, 0, 1);
        var last = $57a3b5efdeb72185$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $hMrR0('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($iVRNR($57a3b5efdeb72185$var$INTRINSICS, intrinsicRealName)) value = $57a3b5efdeb72185$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $czmiz('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($9HCYo && i + 1 >= parts.length) {
                var desc = $9HCYo(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $iVRNR(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $57a3b5efdeb72185$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("3i090", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Object;

});

parcelRegister("7Pqui", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("862cL", function(module, exports) {
'use strict';
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("oOVQ2", function(module, exports) {
'use strict';
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("1Wnwt", function(module, exports) {
'use strict';
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("hMrR0", function(module, exports) {
'use strict';
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("7ALch", function(module, exports) {
'use strict';
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("7D09D", function(module, exports) {
'use strict';
/** @type {import('./abs')} */ module.exports = Math.abs;

});

parcelRegister("iXf6z", function(module, exports) {
'use strict';
/** @type {import('./floor')} */ module.exports = Math.floor;

});

parcelRegister("2U3Lv", function(module, exports) {
'use strict';
/** @type {import('./max')} */ module.exports = Math.max;

});

parcelRegister("6aSdz", function(module, exports) {
'use strict';
/** @type {import('./min')} */ module.exports = Math.min;

});

parcelRegister("kn1m1", function(module, exports) {
'use strict';
/** @type {import('./pow')} */ module.exports = Math.pow;

});

parcelRegister("fqVy6", function(module, exports) {
'use strict';
/** @type {import('./round')} */ module.exports = Math.round;

});

parcelRegister("18QDC", function(module, exports) {
'use strict';

var $89ez9 = parcelRequire("89ez9");
/** @type {import('./sign')} */ module.exports = function sign(number) {
    if ($89ez9(number) || number === 0) return number;
    return number < 0 ? -1 : 1;
};

});
parcelRegister("89ez9", function(module, exports) {
'use strict';
/** @type {import('./isNaN')} */ module.exports = Number.isNaN || function isNaN(a) {
    return a !== a;
};

});


parcelRegister("9HCYo", function(module, exports) {
'use strict';

var $fOsXQ = parcelRequire("fOsXQ");
var $71065c757f7f44af$require$$gOPD = $fOsXQ;
if ($71065c757f7f44af$require$$gOPD) try {
    $71065c757f7f44af$require$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $71065c757f7f44af$require$$gOPD = null;
}
module.exports = $71065c757f7f44af$require$$gOPD;

});
parcelRegister("fOsXQ", function(module, exports) {
'use strict';
/** @type {import('./gOPD')} */ module.exports = Object.getOwnPropertyDescriptor;

});


parcelRegister("lrVYM", function(module, exports) {
'use strict';
/** @type {import('.')} */ var $f9d9180fc1da6c6b$var$$defineProperty = Object.defineProperty || false;
if ($f9d9180fc1da6c6b$var$$defineProperty) try {
    $f9d9180fc1da6c6b$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $f9d9180fc1da6c6b$var$$defineProperty = false;
}
module.exports = $f9d9180fc1da6c6b$var$$defineProperty;

});

parcelRegister("aWElS", function(module, exports) {
'use strict';
var $7f7e9f381e40b474$var$origSymbol = typeof Symbol !== 'undefined' && Symbol;

var $2Ldag = parcelRequire("2Ldag");
/** @type {import('.')} */ module.exports = function hasNativeSymbols() {
    if (typeof $7f7e9f381e40b474$var$origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof $7f7e9f381e40b474$var$origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return $2Ldag();
};

});
parcelRegister("2Ldag", function(module, exports) {
'use strict';
/** @type {import('./shams')} */ /* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    /** @type {{ [k in symbol]?: unknown }} */ var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(var _ in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {PropertyDescriptor} */ Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("lSGtw", function(module, exports) {
'use strict';

var $kcd4Z = parcelRequire("kcd4Z");

var $ffgaT = parcelRequire("ffgaT");

var $8Df1S = parcelRequire("8Df1S");
/** @type {import('.')} */ module.exports = $kcd4Z ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $kcd4Z(O);
} : $ffgaT ? function getProto(O) {
    if (!O || typeof O !== 'object' && typeof O !== 'function') throw new TypeError('getProto: not an object');
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $ffgaT(O);
} : $8Df1S ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $8Df1S(O);
} : null;

});
parcelRegister("kcd4Z", function(module, exports) {
'use strict';
/** @type {import('./Reflect.getPrototypeOf')} */ module.exports = typeof Reflect !== 'undefined' && Reflect.getPrototypeOf || null;

});

parcelRegister("ffgaT", function(module, exports) {
'use strict';

var $3i090 = parcelRequire("3i090");
/** @type {import('./Object.getPrototypeOf')} */ module.exports = $3i090.getPrototypeOf || null;

});

parcelRegister("8Df1S", function(module, exports) {
'use strict';

var $425QM = parcelRequire("425QM");

var $9HCYo = parcelRequire("9HCYo");
var $648d9fc62b18f2c3$var$hasProtoAccessor;
try {
    // eslint-disable-next-line no-extra-parens, no-proto
    $648d9fc62b18f2c3$var$hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ [].__proto__ === Array.prototype;
} catch (e) {
    if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') throw e;
}
// eslint-disable-next-line no-extra-parens
var $648d9fc62b18f2c3$var$desc = !!$648d9fc62b18f2c3$var$hasProtoAccessor && $9HCYo && $9HCYo(Object.prototype, /** @type {keyof typeof Object.prototype} */ '__proto__');
var $648d9fc62b18f2c3$var$$Object = Object;
var $648d9fc62b18f2c3$var$$getPrototypeOf = $648d9fc62b18f2c3$var$$Object.getPrototypeOf;
/** @type {import('./get')} */ module.exports = $648d9fc62b18f2c3$var$desc && typeof $648d9fc62b18f2c3$var$desc.get === 'function' ? $425QM([
    $648d9fc62b18f2c3$var$desc.get
]) : typeof $648d9fc62b18f2c3$var$$getPrototypeOf === 'function' ? /** @type {import('./get')} */ function getDunder(value) {
    // eslint-disable-next-line eqeqeq
    return $648d9fc62b18f2c3$var$$getPrototypeOf(value == null ? value : $648d9fc62b18f2c3$var$$Object(value));
} : false;

});
parcelRegister("425QM", function(module, exports) {
'use strict';

var $8JerU = parcelRequire("8JerU");

var $czmiz = parcelRequire("czmiz");

var $6Gf3b = parcelRequire("6Gf3b");

var $cdgEB = parcelRequire("cdgEB");
/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */ module.exports = function callBindBasic(args) {
    if (args.length < 1 || typeof args[0] !== 'function') throw new $czmiz('a function is required');
    return $cdgEB($8JerU, $6Gf3b, args);
};

});
parcelRegister("8JerU", function(module, exports) {
'use strict';

var $bppev = parcelRequire("bppev");
module.exports = Function.prototype.bind || $bppev;

});
parcelRegister("bppev", function(module, exports) {
'use strict';
/* eslint no-invalid-this: 1 */ var $84e59a3c6964a935$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $84e59a3c6964a935$var$toStr = Object.prototype.toString;
var $84e59a3c6964a935$var$max = Math.max;
var $84e59a3c6964a935$var$funcType = '[object Function]';
var $84e59a3c6964a935$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $84e59a3c6964a935$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $84e59a3c6964a935$var$joiny = function(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $84e59a3c6964a935$var$toStr.apply(target) !== $84e59a3c6964a935$var$funcType) throw new TypeError($84e59a3c6964a935$var$ERROR_MESSAGE + target);
    var args = $84e59a3c6964a935$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $84e59a3c6964a935$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $84e59a3c6964a935$var$concatty(args, arguments));
    };
    var boundLength = $84e59a3c6964a935$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + $84e59a3c6964a935$var$joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("6Gf3b", function(module, exports) {
'use strict';
/** @type {import('./functionCall')} */ module.exports = Function.prototype.call;

});

parcelRegister("cdgEB", function(module, exports) {
'use strict';

var $8JerU = parcelRequire("8JerU");

var $axzup = parcelRequire("axzup");

var $6Gf3b = parcelRequire("6Gf3b");

var $3G1AI = parcelRequire("3G1AI");
/** @type {import('./actualApply')} */ module.exports = $3G1AI || $8JerU.call($6Gf3b, $axzup);

});
parcelRegister("axzup", function(module, exports) {
'use strict';
/** @type {import('./functionApply')} */ module.exports = Function.prototype.apply;

});

parcelRegister("3G1AI", function(module, exports) {
'use strict';
/** @type {import('./reflectApply')} */ module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;

});





parcelRegister("iVRNR", function(module, exports) {
'use strict';
var $dc87490d3003d624$var$call = Function.prototype.call;
var $dc87490d3003d624$var$$hasOwn = Object.prototype.hasOwnProperty;

var $8JerU = parcelRequire("8JerU");
/** @type {import('.')} */ module.exports = $8JerU.call($dc87490d3003d624$var$call, $dc87490d3003d624$var$$hasOwn);

});


parcelRegister("8BH9V", function(module, exports) {
'use strict';

var $7wvbq = parcelRequire("7wvbq");

var $425QM = parcelRequire("425QM");
/** @type {(thisArg: string, searchString: string, position?: number) => number} */ var $644341e94985384d$var$$indexOf = $425QM([
    $7wvbq('%String.prototype.indexOf%')
]);
/** @type {import('.')} */ module.exports = function callBoundIntrinsic(name, allowMissing) {
    /* eslint no-extra-parens: 0 */ var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ $7wvbq(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $644341e94985384d$var$$indexOf(name, '.prototype.') > -1) return $425QM(/** @type {const} */ [
        intrinsic
    ]);
    return intrinsic;
};

});


parcelRegister("88cjV", function(module, exports) {
'use strict';

var $7wvbq = parcelRequire("7wvbq");

var $8BH9V = parcelRequire("8BH9V");

var $3rnaW = parcelRequire("3rnaW");

var $cKIyF = parcelRequire("cKIyF");

var $czmiz = parcelRequire("czmiz");
var $5eb8a0a4f8cc81f6$var$$WeakMap = $7wvbq('%WeakMap%', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => V} */ var $5eb8a0a4f8cc81f6$var$$weakMapGet = $8BH9V('WeakMap.prototype.get', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K, value: V) => void} */ var $5eb8a0a4f8cc81f6$var$$weakMapSet = $8BH9V('WeakMap.prototype.set', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */ var $5eb8a0a4f8cc81f6$var$$weakMapHas = $8BH9V('WeakMap.prototype.has', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */ var $5eb8a0a4f8cc81f6$var$$weakMapDelete = $8BH9V('WeakMap.prototype.delete', true);
/** @type {import('.')} */ module.exports = $5eb8a0a4f8cc81f6$var$$WeakMap ? /** @type {Exclude<import('.'), false>} */ function getSideChannelWeakMap() {
    /** @typedef {ReturnType<typeof getSideChannelWeakMap>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {WeakMap<K & object, V> | undefined} */ var $wm;
    /** @type {Channel | undefined} */ var $m;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $czmiz('Side channel does not contain ' + $3rnaW(key));
        },
        'delete': function(key) {
            if ($5eb8a0a4f8cc81f6$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $5eb8a0a4f8cc81f6$var$$weakMapDelete($wm, key);
            } else if ($cKIyF) {
                if ($m) return $m['delete'](key);
            }
            return false;
        },
        get: function(key) {
            if ($5eb8a0a4f8cc81f6$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $5eb8a0a4f8cc81f6$var$$weakMapGet($wm, key);
            }
            return $m && $m.get(key);
        },
        has: function(key) {
            if ($5eb8a0a4f8cc81f6$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $5eb8a0a4f8cc81f6$var$$weakMapHas($wm, key);
            }
            return !!$m && $m.has(key);
        },
        set: function(key, value) {
            if ($5eb8a0a4f8cc81f6$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if (!$wm) $wm = new $5eb8a0a4f8cc81f6$var$$WeakMap();
                $5eb8a0a4f8cc81f6$var$$weakMapSet($wm, key, value);
            } else if ($cKIyF) {
                if (!$m) $m = $cKIyF();
                // eslint-disable-next-line no-extra-parens
                /** @type {NonNullable<typeof $m>} */ $m.set(key, value);
            }
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
} : $cKIyF;

});


parcelRegister("lxUc9", function(module, exports) {
'use strict';

var $hMCV2 = parcelRequire("hMCV2");

var $ece3R = parcelRequire("ece3R");
var $faf8453771b29920$var$has = Object.prototype.hasOwnProperty;
var $faf8453771b29920$var$isArray = Array.isArray;
// Track objects created from arrayLimit overflow using side-channel
// Stores the current max numeric index for O(1) lookup
var $faf8453771b29920$var$overflowChannel = $ece3R();
var $faf8453771b29920$var$markOverflow = function markOverflow(obj, maxIndex) {
    $faf8453771b29920$var$overflowChannel.set(obj, maxIndex);
    return obj;
};
var $faf8453771b29920$var$isOverflow = function isOverflow(obj) {
    return $faf8453771b29920$var$overflowChannel.has(obj);
};
var $faf8453771b29920$var$getMaxIndex = function getMaxIndex(obj) {
    return $faf8453771b29920$var$overflowChannel.get(obj);
};
var $faf8453771b29920$var$setMaxIndex = function setMaxIndex(obj, maxIndex) {
    $faf8453771b29920$var$overflowChannel.set(obj, maxIndex);
};
var $faf8453771b29920$var$hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array[array.length] = '%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase();
    return array;
}();
var $faf8453771b29920$var$compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if ($faf8453771b29920$var$isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== 'undefined') compacted[compacted.length] = obj[j];
            item.obj[item.prop] = compacted;
        }
    }
};
var $faf8453771b29920$var$arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? {
        __proto__: null
    } : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== 'undefined') obj[i] = source[i];
    return obj;
};
var $faf8453771b29920$var$merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== 'object' && typeof source !== 'function') {
        if ($faf8453771b29920$var$isArray(target)) {
            var nextIndex = target.length;
            if (options && typeof options.arrayLimit === 'number' && nextIndex > options.arrayLimit) return $faf8453771b29920$var$markOverflow($faf8453771b29920$var$arrayToObject(target.concat(source), options), nextIndex);
            target[nextIndex] = source;
        } else if (target && typeof target === 'object') {
            if ($faf8453771b29920$var$isOverflow(target)) {
                // Add at next numeric index for overflow objects
                var newIndex = $faf8453771b29920$var$getMaxIndex(target) + 1;
                target[newIndex] = source;
                $faf8453771b29920$var$setMaxIndex(target, newIndex);
            } else if (options && options.strictMerge) return [
                target,
                source
            ];
            else if (options && (options.plainObjects || options.allowPrototypes) || !$faf8453771b29920$var$has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== 'object') {
        if ($faf8453771b29920$var$isOverflow(source)) {
            // Create new object with target at 0, source values shifted by 1
            var sourceKeys = Object.keys(source);
            var result = options && options.plainObjects ? {
                __proto__: null,
                0: target
            } : {
                0: target
            };
            for(var m = 0; m < sourceKeys.length; m++){
                var oldKey = parseInt(sourceKeys[m], 10);
                result[oldKey + 1] = source[sourceKeys[m]];
            }
            return $faf8453771b29920$var$markOverflow(result, $faf8453771b29920$var$getMaxIndex(source) + 1);
        }
        var combined = [
            target
        ].concat(source);
        if (options && typeof options.arrayLimit === 'number' && combined.length > options.arrayLimit) return $faf8453771b29920$var$markOverflow($faf8453771b29920$var$arrayToObject(combined, options), combined.length - 1);
        return combined;
    }
    var mergeTarget = target;
    if ($faf8453771b29920$var$isArray(target) && !$faf8453771b29920$var$isArray(source)) mergeTarget = $faf8453771b29920$var$arrayToObject(target, options);
    if ($faf8453771b29920$var$isArray(target) && $faf8453771b29920$var$isArray(source)) {
        source.forEach(function(item, i) {
            if ($faf8453771b29920$var$has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') target[i] = merge(targetItem, item, options);
                else target[target.length] = item;
            } else target[i] = item;
        });
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if ($faf8453771b29920$var$has.call(acc, key)) acc[key] = merge(acc[key], value, options);
        else acc[key] = value;
        if ($faf8453771b29920$var$isOverflow(source) && !$faf8453771b29920$var$isOverflow(acc)) $faf8453771b29920$var$markOverflow(acc, $faf8453771b29920$var$getMaxIndex(source));
        if ($faf8453771b29920$var$isOverflow(acc)) {
            var keyNum = parseInt(key, 10);
            if (String(keyNum) === key && keyNum >= 0 && keyNum > $faf8453771b29920$var$getMaxIndex(acc)) $faf8453771b29920$var$setMaxIndex(acc, keyNum);
        }
        return acc;
    }, mergeTarget);
};
var $faf8453771b29920$var$assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};
var $faf8453771b29920$var$decode = function(str, defaultDecoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var $faf8453771b29920$var$limit = 1024;
/* eslint operator-linebreak: [2, "before"] */ var $faf8453771b29920$var$encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if (typeof str === 'symbol') string = Symbol.prototype.toString.call(str);
    else if (typeof str !== 'string') string = String(str);
    if (charset === 'iso-8859-1') return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
    });
    var out = '';
    for(var j = 0; j < string.length; j += $faf8453771b29920$var$limit){
        var segment = string.length >= $faf8453771b29920$var$limit ? string.slice(j, j + $faf8453771b29920$var$limit) : string;
        var arr = [];
        for(var i = 0; i < segment.length; ++i){
            var c = segment.charCodeAt(i);
            if (c === 0x2D // -
             || c === 0x2E // .
             || c === 0x5F // _
             || c === 0x7E // ~
             || c >= 0x30 && c <= 0x39 // 0-9
             || c >= 0x41 && c <= 0x5A // a-z
             || c >= 0x61 && c <= 0x7A // A-Z
             || format === $hMCV2.RFC1738 && (c === 0x28 || c === 0x29) // ( )
            ) {
                arr[arr.length] = segment.charAt(i);
                continue;
            }
            if (c < 0x80) {
                arr[arr.length] = $faf8453771b29920$var$hexTable[c];
                continue;
            }
            if (c < 0x800) {
                arr[arr.length] = $faf8453771b29920$var$hexTable[0xC0 | c >> 6] + $faf8453771b29920$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            if (c < 0xD800 || c >= 0xE000) {
                arr[arr.length] = $faf8453771b29920$var$hexTable[0xE0 | c >> 12] + $faf8453771b29920$var$hexTable[0x80 | c >> 6 & 0x3F] + $faf8453771b29920$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            i += 1;
            c = 0x10000 + ((c & 0x3FF) << 10 | segment.charCodeAt(i) & 0x3FF);
            arr[arr.length] = $faf8453771b29920$var$hexTable[0xF0 | c >> 18] + $faf8453771b29920$var$hexTable[0x80 | c >> 12 & 0x3F] + $faf8453771b29920$var$hexTable[0x80 | c >> 6 & 0x3F] + $faf8453771b29920$var$hexTable[0x80 | c & 0x3F];
        }
        out += arr.join('');
    }
    return out;
};
var $faf8453771b29920$var$compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: 'o'
        }
    ];
    var refs = [];
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue[queue.length] = {
                    obj: obj,
                    prop: key
                };
                refs[refs.length] = val;
            }
        }
    }
    $faf8453771b29920$var$compactQueue(queue);
    return value;
};
var $faf8453771b29920$var$isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};
var $faf8453771b29920$var$isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var $faf8453771b29920$var$combine = function combine(a, b, arrayLimit, plainObjects) {
    // If 'a' is already an overflow object, add to it
    if ($faf8453771b29920$var$isOverflow(a)) {
        var newIndex = $faf8453771b29920$var$getMaxIndex(a) + 1;
        a[newIndex] = b;
        $faf8453771b29920$var$setMaxIndex(a, newIndex);
        return a;
    }
    var result = [].concat(a, b);
    if (result.length > arrayLimit) return $faf8453771b29920$var$markOverflow($faf8453771b29920$var$arrayToObject(result, {
        plainObjects: plainObjects
    }), result.length - 1);
    return result;
};
var $faf8453771b29920$var$maybeMap = function maybeMap(val, fn) {
    if ($faf8453771b29920$var$isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped[mapped.length] = fn(val[i]);
        return mapped;
    }
    return fn(val);
};
module.exports = {
    arrayToObject: $faf8453771b29920$var$arrayToObject,
    assign: $faf8453771b29920$var$assign,
    combine: $faf8453771b29920$var$combine,
    compact: $faf8453771b29920$var$compact,
    decode: $faf8453771b29920$var$decode,
    encode: $faf8453771b29920$var$encode,
    isBuffer: $faf8453771b29920$var$isBuffer,
    isOverflow: $faf8453771b29920$var$isOverflow,
    isRegExp: $faf8453771b29920$var$isRegExp,
    markOverflow: $faf8453771b29920$var$markOverflow,
    maybeMap: $faf8453771b29920$var$maybeMap,
    merge: $faf8453771b29920$var$merge
};

});
parcelRegister("hMCV2", function(module, exports) {
'use strict';
var $cf251bdf4673fb6b$var$replace = String.prototype.replace;
var $cf251bdf4673fb6b$var$percentTwenties = /%20/g;
var $cf251bdf4673fb6b$var$Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};
module.exports = {
    'default': $cf251bdf4673fb6b$var$Format.RFC3986,
    formatters: {
        RFC1738: function(value) {
            return $cf251bdf4673fb6b$var$replace.call(value, $cf251bdf4673fb6b$var$percentTwenties, '+');
        },
        RFC3986: function(value) {
            return String(value);
        }
    },
    RFC1738: $cf251bdf4673fb6b$var$Format.RFC1738,
    RFC3986: $cf251bdf4673fb6b$var$Format.RFC3986
};

});



parcelRegister("3wB6l", function(module, exports) {
'use strict';

var $lxUc9 = parcelRequire("lxUc9");
var $291123d564e04389$var$has = Object.prototype.hasOwnProperty;
var $291123d564e04389$var$isArray = Array.isArray;
var $291123d564e04389$var$defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: false,
    decoder: $lxUc9.decode,
    delimiter: '&',
    depth: 5,
    duplicates: 'combine',
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictDepth: false,
    strictMerge: true,
    strictNullHandling: false,
    throwOnLimitExceeded: false
};
var $291123d564e04389$var$interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var $291123d564e04389$var$parseArrayValue = function(val, options, currentArrayLength) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) return val.split(',');
    if (options.throwOnLimitExceeded && currentArrayLength >= options.arrayLimit) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var $291123d564e04389$var$isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var $291123d564e04389$var$charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')
var $291123d564e04389$var$parseValues = function parseQueryStringValues(str, options) {
    var obj = {
        __proto__: null
    };
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    cleanStr = cleanStr.replace(/%5B/gi, '[').replace(/%5D/gi, ']');
    var limit = options.parameterLimit === Infinity ? void 0 : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, options.throwOnLimitExceeded ? limit + 1 : limit);
    if (options.throwOnLimitExceeded && parts.length > limit) throw new RangeError('Parameter limit exceeded. Only ' + limit + ' parameter' + (limit === 1 ? '' : 's') + ' allowed.');
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf('utf8=') === 0) {
            if (parts[i] === $291123d564e04389$var$charsetSentinel) charset = 'utf-8';
            else if (parts[i] === $291123d564e04389$var$isoSentinel) charset = 'iso-8859-1';
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;
        var key;
        var val;
        if (pos === -1) {
            key = options.decoder(part, $291123d564e04389$var$defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), $291123d564e04389$var$defaults.decoder, charset, 'key');
            if (key !== null) val = $lxUc9.maybeMap($291123d564e04389$var$parseArrayValue(part.slice(pos + 1), options, $291123d564e04389$var$isArray(obj[key]) ? obj[key].length : 0), function(encodedVal) {
                return options.decoder(encodedVal, $291123d564e04389$var$defaults.decoder, charset, 'value');
            });
        }
        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') val = $291123d564e04389$var$interpretNumericEntities(String(val));
        if (part.indexOf('[]=') > -1) val = $291123d564e04389$var$isArray(val) ? [
            val
        ] : val;
        if (options.comma && $291123d564e04389$var$isArray(val) && val.length > options.arrayLimit) {
            if (options.throwOnLimitExceeded) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
            val = $lxUc9.combine([], val, options.arrayLimit, options.plainObjects);
        }
        if (key !== null) {
            var existing = $291123d564e04389$var$has.call(obj, key);
            if (existing && (options.duplicates === 'combine' || part.indexOf('[]=') > -1)) obj[key] = $lxUc9.combine(obj[key], val, options.arrayLimit, options.plainObjects);
            else if (!existing || options.duplicates === 'last') obj[key] = val;
        }
    }
    return obj;
};
var $291123d564e04389$var$parseObject = function(chain, val, options, valuesParsed) {
    var currentArrayLength = 0;
    if (chain.length > 0 && chain[chain.length - 1] === '[]') {
        var parentKey = chain.slice(0, -1).join('');
        currentArrayLength = Array.isArray(val) && val[parentKey] ? val[parentKey].length : 0;
    }
    var leaf = valuesParsed ? val : $291123d564e04389$var$parseArrayValue(val, options, currentArrayLength);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === '[]' && options.parseArrays) {
            if ($lxUc9.isOverflow(leaf)) // leaf is already an overflow object, preserve it
            obj = leaf;
            else obj = options.allowEmptyArrays && (leaf === '' || options.strictNullHandling && leaf === null) ? [] : $lxUc9.combine([], leaf, options.arrayLimit, options.plainObjects);
        } else {
            obj = options.plainObjects ? {
                __proto__: null
            } : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, '.') : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            var isValidArrayIndex = !isNaN(index) && root !== decodedRoot && String(index) === decodedRoot && index >= 0 && options.parseArrays;
            if (!options.parseArrays && decodedRoot === '') obj = {
                0: leaf
            };
            else if (isValidArrayIndex && index < options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (isValidArrayIndex && options.throwOnLimitExceeded) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
            else if (isValidArrayIndex) {
                obj[index] = leaf;
                $lxUc9.markOverflow(obj, index);
            } else if (decodedRoot !== '__proto__') obj[decodedRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
var $291123d564e04389$var$splitKeyIntoSegments = function splitKeyIntoSegments(givenKey, options) {
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;
    if (options.depth <= 0) {
        if (!options.plainObjects && $291123d564e04389$var$has.call(Object.prototype, key)) {
            if (!options.allowPrototypes) return;
        }
        return [
            key
        ];
    }
    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;
    var segment = brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;
    var keys = [];
    if (parent) {
        if (!options.plainObjects && $291123d564e04389$var$has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        keys[keys.length] = parent;
    }
    var i = 0;
    while((segment = child.exec(key)) !== null && i < options.depth){
        i += 1;
        var segmentContent = segment[1].slice(1, -1);
        if (!options.plainObjects && $291123d564e04389$var$has.call(Object.prototype, segmentContent)) {
            if (!options.allowPrototypes) return;
        }
        keys[keys.length] = segment[1];
    }
    if (segment) {
        if (options.strictDepth === true) throw new RangeError('Input depth exceeded depth option of ' + options.depth + ' and strictDepth is true');
        keys[keys.length] = '[' + key.slice(segment.index) + ']';
    }
    return keys;
};
var $291123d564e04389$var$parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    var keys = $291123d564e04389$var$splitKeyIntoSegments(givenKey, options);
    if (!keys) return;
    return $291123d564e04389$var$parseObject(keys, val, options, valuesParsed);
};
var $291123d564e04389$var$normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return $291123d564e04389$var$defaults;
    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    if (typeof opts.decodeDotInKeys !== 'undefined' && typeof opts.decodeDotInKeys !== 'boolean') throw new TypeError('`decodeDotInKeys` option can only be `true` or `false`, when provided');
    if (opts.decoder !== null && typeof opts.decoder !== 'undefined' && typeof opts.decoder !== 'function') throw new TypeError('Decoder has to be a function.');
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    if (typeof opts.throwOnLimitExceeded !== 'undefined' && typeof opts.throwOnLimitExceeded !== 'boolean') throw new TypeError('`throwOnLimitExceeded` option must be a boolean');
    var charset = typeof opts.charset === 'undefined' ? $291123d564e04389$var$defaults.charset : opts.charset;
    var duplicates = typeof opts.duplicates === 'undefined' ? $291123d564e04389$var$defaults.duplicates : opts.duplicates;
    if (duplicates !== 'combine' && duplicates !== 'first' && duplicates !== 'last') throw new TypeError('The duplicates option must be either combine, first, or last');
    var allowDots = typeof opts.allowDots === 'undefined' ? opts.decodeDotInKeys === true ? true : $291123d564e04389$var$defaults.allowDots : !!opts.allowDots;
    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : $291123d564e04389$var$defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : $291123d564e04389$var$defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : $291123d564e04389$var$defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : $291123d564e04389$var$defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : $291123d564e04389$var$defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : $291123d564e04389$var$defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === 'boolean' ? opts.decodeDotInKeys : $291123d564e04389$var$defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : $291123d564e04389$var$defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || $lxUc9.isRegExp(opts.delimiter) ? opts.delimiter : $291123d564e04389$var$defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === 'number' || opts.depth === false ? +opts.depth : $291123d564e04389$var$defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : $291123d564e04389$var$defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : $291123d564e04389$var$defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : $291123d564e04389$var$defaults.plainObjects,
        strictDepth: typeof opts.strictDepth === 'boolean' ? !!opts.strictDepth : $291123d564e04389$var$defaults.strictDepth,
        strictMerge: typeof opts.strictMerge === 'boolean' ? !!opts.strictMerge : $291123d564e04389$var$defaults.strictMerge,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : $291123d564e04389$var$defaults.strictNullHandling,
        throwOnLimitExceeded: typeof opts.throwOnLimitExceeded === 'boolean' ? opts.throwOnLimitExceeded : false
    };
};
module.exports = function(str, opts) {
    var options = $291123d564e04389$var$normalizeParseOptions(opts);
    if (str === '' || str === null || typeof str === 'undefined') return options.plainObjects ? {
        __proto__: null
    } : {};
    var tempObj = typeof str === 'string' ? $291123d564e04389$var$parseValues(str, options) : str;
    var obj = options.plainObjects ? {
        __proto__: null
    } : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = $291123d564e04389$var$parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = $lxUc9.merge(obj, newObj, options);
    }
    if (options.allowSparse === true) return obj;
    return $lxUc9.compact(obj);
};

});



parcelRegister("fsezd", function(module, exports) {

$parcel$export(module.exports, "DateUtils", () => $b404c53bfeac5d9f$export$3e048df13f4eb60b);
/**
 * Date & time utility functions to abstract the `aws-sdk` away from users.
 * (v2 => v3 modularization is a breaking change)
 *
 * @see https://github.com/aws/aws-sdk-js/blob/6edf586dcc1de7fe8fbfbbd9a0d2b1847921e6e1/lib/util.js#L262
 */ var $b404c53bfeac5d9f$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
// Comment - TODO: remove
var $b404c53bfeac5d9f$var$FIVE_MINUTES_IN_MS = 300000;
var $b404c53bfeac5d9f$export$3e048df13f4eb60b = {
    /**
     * Milliseconds to offset the date to compensate for clock skew between device & services
     */ clockOffset: 0,
    getDateWithClockOffset: function() {
        if ($b404c53bfeac5d9f$export$3e048df13f4eb60b.clockOffset) return new Date(new Date().getTime() + $b404c53bfeac5d9f$export$3e048df13f4eb60b.clockOffset);
        else return new Date();
    },
    /**
     * @returns {number} Clock offset in milliseconds
     */ getClockOffset: function() {
        return $b404c53bfeac5d9f$export$3e048df13f4eb60b.clockOffset;
    },
    getHeaderStringFromDate: function(date) {
        if (date === void 0) date = $b404c53bfeac5d9f$export$3e048df13f4eb60b.getDateWithClockOffset();
        return date.toISOString().replace(/[:\-]|\.\d{3}/g, '');
    },
    getDateFromHeaderString: function(header) {
        var _a = $b404c53bfeac5d9f$var$__read(header.match(/^(\d{4})(\d{2})(\d{2})T(\d{2})(\d{2})(\d{2}).+/), 7), year = _a[1], month = _a[2], day = _a[3], hour = _a[4], minute = _a[5], second = _a[6];
        return new Date(Date.UTC(Number(year), Number(month) - 1, Number(day), Number(hour), Number(minute), Number(second)));
    },
    isClockSkewed: function(serverDate) {
        // API gateway permits client calls that are off by no more than ±5 minutes
        return Math.abs(serverDate.getTime() - $b404c53bfeac5d9f$export$3e048df13f4eb60b.getDateWithClockOffset().getTime()) >= $b404c53bfeac5d9f$var$FIVE_MINUTES_IN_MS;
    },
    isClockSkewError: function(error) {
        if (!error.response || !error.response.headers) return false;
        var headers = error.response.headers;
        return Boolean(headers['x-amzn-errortype'] === 'BadRequestException' && (headers.date || headers.Date));
    },
    /**
     * @param {number} offset Clock offset in milliseconds
     */ setClockOffset: function(offset) {
        $b404c53bfeac5d9f$export$3e048df13f4eb60b.clockOffset = offset;
    }
};

});


parcelRegister("7XN1x", function(module, exports) {

$parcel$export(module.exports, "Parser", () => $5cc41235272776d0$export$7acfa6ed01010e37);

var $7UO1b = parcelRequire("7UO1b");
var $5cc41235272776d0$var$logger = new (0, $7UO1b.ConsoleLogger)('Parser');
var $5cc41235272776d0$export$33f4f68299e2efa8 = function(config) {
    var amplifyConfig = {};
    // Analytics
    if (config['aws_mobile_analytics_app_id']) {
        var Analytics = {
            AWSPinpoint: {
                appId: config['aws_mobile_analytics_app_id'],
                region: config['aws_mobile_analytics_app_region']
            }
        };
        amplifyConfig.Analytics = Analytics;
    }
    // Auth
    if (config['aws_cognito_identity_pool_id'] || config['aws_user_pools_id']) amplifyConfig.Auth = {
        userPoolId: config['aws_user_pools_id'],
        userPoolWebClientId: config['aws_user_pools_web_client_id'],
        region: config['aws_cognito_region'],
        identityPoolId: config['aws_cognito_identity_pool_id'],
        identityPoolRegion: config['aws_cognito_region'],
        mandatorySignIn: config['aws_mandatory_sign_in'] === 'enable'
    };
    // Storage
    var storageConfig;
    if (config['aws_user_files_s3_bucket']) storageConfig = {
        AWSS3: {
            bucket: config['aws_user_files_s3_bucket'],
            region: config['aws_user_files_s3_bucket_region'],
            dangerouslyConnectToHttpEndpointForTesting: config['aws_user_files_s3_dangerously_connect_to_http_endpoint_for_testing']
        }
    };
    else storageConfig = config ? config.Storage || config : {};
    amplifyConfig.Analytics = Object.assign({}, amplifyConfig.Analytics, config.Analytics);
    amplifyConfig.Auth = Object.assign({}, amplifyConfig.Auth, config.Auth);
    amplifyConfig.Storage = Object.assign({}, storageConfig);
    $5cc41235272776d0$var$logger.debug('parse config', config, 'to amplifyconfig', amplifyConfig);
    return amplifyConfig;
};
/**
 * @deprecated use per-function export
 */ var $5cc41235272776d0$export$7acfa6ed01010e37 = /** @class */ function() {
    function Parser() {}
    Parser.parseMobilehubConfig = $5cc41235272776d0$export$33f4f68299e2efa8;
    return Parser;
}();
var /**
 * @deprecated use per-function export
 */ $5cc41235272776d0$export$2e2bcd8739ae039 = $5cc41235272776d0$export$7acfa6ed01010e37;

});

parcelRegister("29OQz", function(module, exports) {

$parcel$export(module.exports, "Credentials", () => $1923dd30b20ed5cb$export$a9627919734faa48);

var $7UO1b = parcelRequire("7UO1b");

var $4uQfD = parcelRequire("4uQfD");

var $9Mfkr = parcelRequire("9Mfkr");

var $dQWOh = parcelRequire("dQWOh");

var $7TTzY = parcelRequire("7TTzY");

var $kaH5c = parcelRequire("kaH5c");

var $a16qJ = parcelRequire("a16qJ");

var $gsz66 = parcelRequire("gsz66");
var $21jjT = parcelRequire("21jjT");

var $ksIf9 = parcelRequire("ksIf9");
var $01m9h = parcelRequire("01m9h");
var $1923dd30b20ed5cb$var$__assign = undefined && undefined.__assign || function() {
    $1923dd30b20ed5cb$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1923dd30b20ed5cb$var$__assign.apply(this, arguments);
};
var $1923dd30b20ed5cb$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $1923dd30b20ed5cb$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $1923dd30b20ed5cb$var$logger = new (0, $7UO1b.ConsoleLogger)('Credentials');
var $1923dd30b20ed5cb$var$CREDENTIALS_TTL = 3000000; // 50 min, can be modified on config if required in the future
var $1923dd30b20ed5cb$export$9be509043bd0c09a = /** @class */ function() {
    function CredentialsClass(config) {
        this._gettingCredPromise = null;
        this._refreshHandlers = {};
        // Allow `Auth` to be injected for SSR, but Auth isn't a required dependency for Credentials
        this.Auth = undefined;
        this.configure(config);
        this._refreshHandlers['google'] = (0, $dQWOh.GoogleOAuth).refreshGoogleToken;
        this._refreshHandlers['facebook'] = (0, $dQWOh.FacebookOAuth).refreshFacebookToken;
    }
    CredentialsClass.prototype.getModuleName = function() {
        return 'Credentials';
    };
    CredentialsClass.prototype.getCredSource = function() {
        return this._credentials_source;
    };
    CredentialsClass.prototype.configure = function(config) {
        if (!config) return this._config || {};
        this._config = Object.assign({}, this._config, config);
        var refreshHandlers = this._config.refreshHandlers;
        // If the developer has provided an object of refresh handlers,
        // then we can merge the provided handlers with the current handlers.
        if (refreshHandlers) this._refreshHandlers = $1923dd30b20ed5cb$var$__assign($1923dd30b20ed5cb$var$__assign({}, this._refreshHandlers), refreshHandlers);
        this._storage = this._config.storage;
        if (!this._storage) this._storage = new (0, $4uQfD.StorageHelper)().getStorage();
        this._storageSync = Promise.resolve();
        if (typeof this._storage['sync'] === 'function') this._storageSync = this._storage['sync']();
        return this._config;
    };
    CredentialsClass.prototype.get = function() {
        $1923dd30b20ed5cb$var$logger.debug('getting credentials');
        return this._pickupCredentials();
    };
    CredentialsClass.prototype._pickupCredentials = function() {
        $1923dd30b20ed5cb$var$logger.debug('picking up credentials');
        if (!this._gettingCredPromise || !this._gettingCredPromise.isPending()) {
            $1923dd30b20ed5cb$var$logger.debug('getting new cred promise');
            this._gettingCredPromise = (0, $9Mfkr.makeQuerablePromise)(this._keepAlive());
        } else $1923dd30b20ed5cb$var$logger.debug('getting old cred promise');
        return this._gettingCredPromise;
    };
    CredentialsClass.prototype._keepAlive = function() {
        return $1923dd30b20ed5cb$var$__awaiter(this, void 0, void 0, function() {
            var cred, _a, Auth, user_1, session, refreshToken_1, refreshRequest, err_1;
            return $1923dd30b20ed5cb$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        $1923dd30b20ed5cb$var$logger.debug('checking if credentials exists and not expired');
                        cred = this._credentials;
                        if (cred && !this._isExpired(cred) && !this._isPastTTL()) {
                            $1923dd30b20ed5cb$var$logger.debug('credentials not changed and not expired, directly return');
                            return [
                                2 /*return*/ ,
                                Promise.resolve(cred)
                            ];
                        }
                        $1923dd30b20ed5cb$var$logger.debug('need to get a new credential or refresh the existing one');
                        _a = this.Auth, Auth = _a === void 0 ? (0, $a16qJ.Amplify).Auth : _a;
                        if (!Auth || typeof Auth.currentUserCredentials !== 'function') return [
                            2 /*return*/ ,
                            Promise.reject('No Auth module registered in Amplify')
                        ];
                        if (!(!this._isExpired(cred) && this._isPastTTL())) return [
                            3 /*break*/ ,
                            6
                        ];
                        $1923dd30b20ed5cb$var$logger.debug('ttl has passed but token is not yet expired');
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        return [
                            4 /*yield*/ ,
                            Auth.currentUserPoolUser()
                        ];
                    case 2:
                        user_1 = _b.sent();
                        return [
                            4 /*yield*/ ,
                            Auth.currentSession()
                        ];
                    case 3:
                        session = _b.sent();
                        refreshToken_1 = session.refreshToken;
                        refreshRequest = new Promise(function(res, rej) {
                            user_1.refreshSession(refreshToken_1, function(err, data) {
                                return err ? rej(err) : res(data);
                            });
                        });
                        return [
                            4 /*yield*/ ,
                            refreshRequest
                        ];
                    case 4:
                        _b.sent(); // note that rejections will be caught and handled in the catch block.
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 5:
                        err_1 = _b.sent();
                        // should not throw because user might just be on guest access or is authenticated through federation
                        $1923dd30b20ed5cb$var$logger.debug('Error attempting to refreshing the session', err_1);
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 6:
                        return [
                            2 /*return*/ ,
                            Auth.currentUserCredentials()
                        ];
                }
            });
        });
    };
    CredentialsClass.prototype.refreshFederatedToken = function(federatedInfo) {
        $1923dd30b20ed5cb$var$logger.debug('Getting federated credentials');
        var provider = federatedInfo.provider, user = federatedInfo.user, token = federatedInfo.token, identity_id = federatedInfo.identity_id;
        var expires_at = federatedInfo.expires_at;
        // Make sure expires_at is in millis
        expires_at = new Date(expires_at).getFullYear() === 1970 ? expires_at * 1000 : expires_at;
        var that = this;
        $1923dd30b20ed5cb$var$logger.debug('checking if federated jwt token expired');
        if (expires_at > new Date().getTime()) {
            // if not expired
            $1923dd30b20ed5cb$var$logger.debug('token not expired');
            return this._setCredentialsFromFederation({
                provider: provider,
                token: token,
                user: user,
                identity_id: identity_id,
                expires_at: expires_at
            });
        } else // if refresh handler exists
        if (that._refreshHandlers[provider] && typeof that._refreshHandlers[provider] === 'function') {
            $1923dd30b20ed5cb$var$logger.debug('getting refreshed jwt token from federation provider');
            return this._providerRefreshWithRetry({
                refreshHandler: that._refreshHandlers[provider],
                provider: provider,
                user: user
            });
        } else {
            $1923dd30b20ed5cb$var$logger.debug('no refresh handler for provider:', provider);
            this.clear();
            return Promise.reject('no refresh handler for provider');
        }
    };
    CredentialsClass.prototype._providerRefreshWithRetry = function(_a) {
        var _this = this;
        var refreshHandler = _a.refreshHandler, provider = _a.provider, user = _a.user;
        var MAX_DELAY_MS = 10000;
        // refreshHandler will retry network errors, otherwise it will
        // return NonRetryableError to break out of jitteredExponentialRetry
        return (0, $7TTzY.jitteredExponentialRetry)(refreshHandler, [], MAX_DELAY_MS).then(function(data) {
            $1923dd30b20ed5cb$var$logger.debug('refresh federated token sucessfully', data);
            return _this._setCredentialsFromFederation({
                provider: provider,
                token: data.token,
                user: user,
                identity_id: data.identity_id,
                expires_at: data.expires_at
            });
        }).catch(function(e) {
            var isNetworkError = typeof e === 'string' && e.toLowerCase().lastIndexOf('network error', e.length) === 0;
            if (!isNetworkError) _this.clear();
            $1923dd30b20ed5cb$var$logger.debug('refresh federated token failed', e);
            return Promise.reject('refreshing federation token failed: ' + e);
        });
    };
    CredentialsClass.prototype._isExpired = function(credentials) {
        if (!credentials) {
            $1923dd30b20ed5cb$var$logger.debug('no credentials for expiration check');
            return true;
        }
        $1923dd30b20ed5cb$var$logger.debug('are these credentials expired?', credentials);
        var ts = Date.now();
        /* returns date object.
            https://github.com/aws/aws-sdk-js-v3/blob/v1.0.0-beta.1/packages/types/src/credentials.ts#L26
        */ var expiration = credentials.expiration;
        return expiration.getTime() <= ts;
    };
    CredentialsClass.prototype._isPastTTL = function() {
        return this._nextCredentialsRefresh <= Date.now();
    };
    CredentialsClass.prototype._setCredentialsForGuest = function() {
        return $1923dd30b20ed5cb$var$__awaiter(this, void 0, void 0, function() {
            var _a, identityPoolId, region, mandatorySignIn, identityId, e_1, cognitoClient, credentials, cognitoIdentityParams, credentialsProvider;
            var _this = this;
            return $1923dd30b20ed5cb$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        $1923dd30b20ed5cb$var$logger.debug('setting credentials for guest');
                        _a = this._config, identityPoolId = _a.identityPoolId, region = _a.region, mandatorySignIn = _a.mandatorySignIn;
                        if (mandatorySignIn) return [
                            2 /*return*/ ,
                            Promise.reject('cannot get guest credentials when mandatory signin enabled')
                        ];
                        if (!identityPoolId) {
                            $1923dd30b20ed5cb$var$logger.debug('No Cognito Identity pool provided for unauthenticated access');
                            return [
                                2 /*return*/ ,
                                Promise.reject('No Cognito Identity pool provided for unauthenticated access')
                            ];
                        }
                        if (!region) {
                            $1923dd30b20ed5cb$var$logger.debug('region is not configured for getting the credentials');
                            return [
                                2 /*return*/ ,
                                Promise.reject('region is not configured for getting the credentials')
                            ];
                        }
                        identityId = undefined;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._storageSync
                        ];
                    case 2:
                        _b.sent();
                        identityId = this._storage.getItem('CognitoIdentityId-' + identityPoolId);
                        this._identityId = identityId;
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_1 = _b.sent();
                        $1923dd30b20ed5cb$var$logger.debug('Failed to get the cached identityId', e_1);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        cognitoClient = new (0, $ksIf9.CognitoIdentityClient)({
                            region: region,
                            customUserAgent: (0, $kaH5c.getAmplifyUserAgent)()
                        });
                        credentials = undefined;
                        if (identityId) {
                            cognitoIdentityParams = {
                                identityId: identityId,
                                client: cognitoClient
                            };
                            credentials = (0, $gsz66.fromCognitoIdentity)(cognitoIdentityParams)();
                        } else {
                            credentialsProvider = function() {
                                return $1923dd30b20ed5cb$var$__awaiter(_this, void 0, void 0, function() {
                                    var IdentityId, cognitoIdentityParams, credentialsFromCognitoIdentity;
                                    return $1923dd30b20ed5cb$var$__generator(this, function(_a) {
                                        switch(_a.label){
                                            case 0:
                                                return [
                                                    4 /*yield*/ ,
                                                    cognitoClient.send(new (0, $01m9h.GetIdCommand)({
                                                        IdentityPoolId: identityPoolId
                                                    }))
                                                ];
                                            case 1:
                                                IdentityId = _a.sent().IdentityId;
                                                this._identityId = IdentityId;
                                                cognitoIdentityParams = {
                                                    client: cognitoClient,
                                                    identityId: IdentityId
                                                };
                                                credentialsFromCognitoIdentity = (0, $gsz66.fromCognitoIdentity)(cognitoIdentityParams);
                                                return [
                                                    2 /*return*/ ,
                                                    credentialsFromCognitoIdentity()
                                                ];
                                        }
                                    });
                                });
                            };
                            credentials = credentialsProvider().catch(function(err) {
                                return $1923dd30b20ed5cb$var$__awaiter(_this, void 0, void 0, function() {
                                    return $1923dd30b20ed5cb$var$__generator(this, function(_a) {
                                        throw err;
                                    });
                                });
                            });
                        }
                        return [
                            2 /*return*/ ,
                            this._loadCredentials(credentials, 'guest', false, null).then(function(res) {
                                return res;
                            }).catch(function(e) {
                                return $1923dd30b20ed5cb$var$__awaiter(_this, void 0, void 0, function() {
                                    var credentialsProvider;
                                    var _this = this;
                                    return $1923dd30b20ed5cb$var$__generator(this, function(_a) {
                                        // If identity id is deleted in the console, we make one attempt to recreate it
                                        // and remove existing id from cache.
                                        if (e.name === 'ResourceNotFoundException' && e.message === "Identity '" + identityId + "' not found.") {
                                            $1923dd30b20ed5cb$var$logger.debug('Failed to load guest credentials');
                                            this._storage.removeItem('CognitoIdentityId-' + identityPoolId);
                                            credentialsProvider = function() {
                                                return $1923dd30b20ed5cb$var$__awaiter(_this, void 0, void 0, function() {
                                                    var IdentityId, cognitoIdentityParams, credentialsFromCognitoIdentity;
                                                    return $1923dd30b20ed5cb$var$__generator(this, function(_a) {
                                                        switch(_a.label){
                                                            case 0:
                                                                return [
                                                                    4 /*yield*/ ,
                                                                    cognitoClient.send(new (0, $01m9h.GetIdCommand)({
                                                                        IdentityPoolId: identityPoolId
                                                                    }))
                                                                ];
                                                            case 1:
                                                                IdentityId = _a.sent().IdentityId;
                                                                this._identityId = IdentityId;
                                                                cognitoIdentityParams = {
                                                                    client: cognitoClient,
                                                                    identityId: IdentityId
                                                                };
                                                                credentialsFromCognitoIdentity = (0, $gsz66.fromCognitoIdentity)(cognitoIdentityParams);
                                                                return [
                                                                    2 /*return*/ ,
                                                                    credentialsFromCognitoIdentity()
                                                                ];
                                                        }
                                                    });
                                                });
                                            };
                                            credentials = credentialsProvider().catch(function(err) {
                                                return $1923dd30b20ed5cb$var$__awaiter(_this, void 0, void 0, function() {
                                                    return $1923dd30b20ed5cb$var$__generator(this, function(_a) {
                                                        throw err;
                                                    });
                                                });
                                            });
                                            return [
                                                2 /*return*/ ,
                                                this._loadCredentials(credentials, 'guest', false, null)
                                            ];
                                        } else return [
                                            2 /*return*/ ,
                                            e
                                        ];
                                        return [
                                            2 /*return*/ 
                                        ];
                                    });
                                });
                            })
                        ];
                }
            });
        });
    };
    CredentialsClass.prototype._setCredentialsFromFederation = function(params) {
        var provider = params.provider, token = params.token, identity_id = params.identity_id;
        var domains = {
            google: 'accounts.google.com',
            facebook: 'graph.facebook.com',
            amazon: 'www.amazon.com',
            developer: 'cognito-identity.amazonaws.com'
        };
        // Use custom provider url instead of the predefined ones
        var domain = domains[provider] || provider;
        if (!domain) return Promise.reject('You must specify a federated provider');
        var logins = {};
        logins[domain] = token;
        var _a = this._config, identityPoolId = _a.identityPoolId, region = _a.region;
        if (!identityPoolId) {
            $1923dd30b20ed5cb$var$logger.debug('No Cognito Federated Identity pool provided');
            return Promise.reject('No Cognito Federated Identity pool provided');
        }
        if (!region) {
            $1923dd30b20ed5cb$var$logger.debug('region is not configured for getting the credentials');
            return Promise.reject('region is not configured for getting the credentials');
        }
        var cognitoClient = new (0, $ksIf9.CognitoIdentityClient)({
            region: region,
            customUserAgent: (0, $kaH5c.getAmplifyUserAgent)()
        });
        var credentials = undefined;
        if (identity_id) {
            var cognitoIdentityParams = {
                identityId: identity_id,
                logins: logins,
                client: cognitoClient
            };
            credentials = (0, $gsz66.fromCognitoIdentity)(cognitoIdentityParams)();
        } else {
            var cognitoIdentityParams = {
                logins: logins,
                identityPoolId: identityPoolId,
                client: cognitoClient
            };
            credentials = (0, $21jjT.fromCognitoIdentityPool)(cognitoIdentityParams)();
        }
        return this._loadCredentials(credentials, 'federated', true, params);
    };
    CredentialsClass.prototype._setCredentialsFromSession = function(session) {
        var _this = this;
        $1923dd30b20ed5cb$var$logger.debug('set credentials from session');
        var idToken = session.getIdToken().getJwtToken();
        var _a = this._config, region = _a.region, userPoolId = _a.userPoolId, identityPoolId = _a.identityPoolId;
        if (!identityPoolId) {
            $1923dd30b20ed5cb$var$logger.debug('No Cognito Federated Identity pool provided');
            return Promise.reject('No Cognito Federated Identity pool provided');
        }
        if (!region) {
            $1923dd30b20ed5cb$var$logger.debug('region is not configured for getting the credentials');
            return Promise.reject('region is not configured for getting the credentials');
        }
        var key = 'cognito-idp.' + region + '.amazonaws.com/' + userPoolId;
        var logins = {};
        logins[key] = idToken;
        var cognitoClient = new (0, $ksIf9.CognitoIdentityClient)({
            region: region,
            customUserAgent: (0, $kaH5c.getAmplifyUserAgent)()
        });
        /*
            Retreiving identityId with GetIdCommand to mimic the behavior in the following code in aws-sdk-v3:
            https://git.io/JeDxU

            Note: Retreive identityId from CredentialsProvider once aws-sdk-js v3 supports this.
        */ var credentialsProvider = function() {
            return $1923dd30b20ed5cb$var$__awaiter(_this, void 0, void 0, function() {
                var IdentityId, cognitoIdentityParams, credentialsFromCognitoIdentity;
                return $1923dd30b20ed5cb$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                cognitoClient.send(new (0, $01m9h.GetIdCommand)({
                                    IdentityPoolId: identityPoolId,
                                    Logins: logins
                                }))
                            ];
                        case 1:
                            IdentityId = _a.sent().IdentityId;
                            this._identityId = IdentityId;
                            cognitoIdentityParams = {
                                client: cognitoClient,
                                logins: logins,
                                identityId: IdentityId
                            };
                            credentialsFromCognitoIdentity = (0, $gsz66.fromCognitoIdentity)(cognitoIdentityParams);
                            return [
                                2 /*return*/ ,
                                credentialsFromCognitoIdentity()
                            ];
                    }
                });
            });
        };
        var credentials = credentialsProvider().catch(function(err) {
            return $1923dd30b20ed5cb$var$__awaiter(_this, void 0, void 0, function() {
                return $1923dd30b20ed5cb$var$__generator(this, function(_a) {
                    throw err;
                });
            });
        });
        return this._loadCredentials(credentials, 'userPool', true, null);
    };
    CredentialsClass.prototype._loadCredentials = function(credentials, source, authenticated, info) {
        var _this = this;
        var that = this;
        var identityPoolId = this._config.identityPoolId;
        return new Promise(function(res, rej) {
            credentials.then(function(credentials) {
                return $1923dd30b20ed5cb$var$__awaiter(_this, void 0, void 0, function() {
                    var user, provider, token, expires_at, identity_id, e_2;
                    return $1923dd30b20ed5cb$var$__generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                $1923dd30b20ed5cb$var$logger.debug('Load credentials successfully', credentials);
                                if (this._identityId && !credentials.identityId) credentials['identityId'] = this._identityId;
                                that._credentials = credentials;
                                that._credentials.authenticated = authenticated;
                                that._credentials_source = source;
                                that._nextCredentialsRefresh = new Date().getTime() + $1923dd30b20ed5cb$var$CREDENTIALS_TTL;
                                if (source === 'federated') {
                                    user = Object.assign({
                                        id: this._credentials.identityId
                                    }, info.user);
                                    provider = info.provider, token = info.token, expires_at = info.expires_at, identity_id = info.identity_id;
                                    try {
                                        this._storage.setItem('aws-amplify-federatedInfo', JSON.stringify({
                                            provider: provider,
                                            token: token,
                                            user: user,
                                            expires_at: expires_at,
                                            identity_id: identity_id
                                        }));
                                    } catch (e) {
                                        $1923dd30b20ed5cb$var$logger.debug('Failed to put federated info into auth storage', e);
                                    }
                                }
                                if (!(source === 'guest')) return [
                                    3 /*break*/ ,
                                    4
                                ];
                                _a.label = 1;
                            case 1:
                                _a.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    this._storageSync
                                ];
                            case 2:
                                _a.sent();
                                this._storage.setItem('CognitoIdentityId-' + identityPoolId, credentials.identityId // TODO: IdentityId is currently not returned by fromCognitoIdentityPool()
                                );
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 3:
                                e_2 = _a.sent();
                                $1923dd30b20ed5cb$var$logger.debug('Failed to cache identityId', e_2);
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 4:
                                res(that._credentials);
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }).catch(function(err) {
                if (err) {
                    $1923dd30b20ed5cb$var$logger.debug('Failed to load credentials', credentials);
                    $1923dd30b20ed5cb$var$logger.debug('Error loading credentials', err);
                    rej(err);
                    return;
                }
            });
        });
    };
    CredentialsClass.prototype.set = function(params, source) {
        if (source === 'session') return this._setCredentialsFromSession(params);
        else if (source === 'federation') return this._setCredentialsFromFederation(params);
        else if (source === 'guest') return this._setCredentialsForGuest();
        else {
            $1923dd30b20ed5cb$var$logger.debug('no source specified for setting credentials');
            return Promise.reject('invalid source');
        }
    };
    CredentialsClass.prototype.clear = function() {
        return $1923dd30b20ed5cb$var$__awaiter(this, void 0, void 0, function() {
            return $1923dd30b20ed5cb$var$__generator(this, function(_a) {
                this._credentials = null;
                this._credentials_source = null;
                $1923dd30b20ed5cb$var$logger.debug('removing aws-amplify-federatedInfo from storage');
                this._storage.removeItem('aws-amplify-federatedInfo');
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    /**
     * Compact version of credentials
     * @param {Object} credentials
     * @return {Object} - Credentials
     */ CredentialsClass.prototype.shear = function(credentials) {
        return {
            accessKeyId: credentials.accessKeyId,
            sessionToken: credentials.sessionToken,
            secretAccessKey: credentials.secretAccessKey,
            identityId: credentials.identityId,
            authenticated: credentials.authenticated
        };
    };
    return CredentialsClass;
}();
var $1923dd30b20ed5cb$export$a9627919734faa48 = new $1923dd30b20ed5cb$export$9be509043bd0c09a(null);
(0, $a16qJ.Amplify).register($1923dd30b20ed5cb$export$a9627919734faa48);
var /**
 * @deprecated use named import
 */ $1923dd30b20ed5cb$export$2e2bcd8739ae039 = $1923dd30b20ed5cb$export$a9627919734faa48;

});
parcelRegister("4uQfD", function(module, exports) {

$parcel$export(module.exports, "StorageHelper", () => $34627ec7a3e6aa0e$export$a2bd19c49e4760e8);
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ var $34627ec7a3e6aa0e$var$dataMemory = {};
/** @class */ var $34627ec7a3e6aa0e$export$d7392285c701ecf5 = /** @class */ function() {
    function MemoryStorage() {}
    /**
     * This is used to set a specific item in storage
     * @param {string} key - the key for the item
     * @param {object} value - the value
     * @returns {string} value that was set
     */ MemoryStorage.setItem = function(key, value) {
        $34627ec7a3e6aa0e$var$dataMemory[key] = value;
        return $34627ec7a3e6aa0e$var$dataMemory[key];
    };
    /**
     * This is used to get a specific key from storage
     * @param {string} key - the key for the item
     * This is used to clear the storage
     * @returns {string} the data item
     */ MemoryStorage.getItem = function(key) {
        return Object.prototype.hasOwnProperty.call($34627ec7a3e6aa0e$var$dataMemory, key) ? $34627ec7a3e6aa0e$var$dataMemory[key] : undefined;
    };
    /**
     * This is used to remove an item from storage
     * @param {string} key - the key being set
     * @returns {string} value - value that was deleted
     */ MemoryStorage.removeItem = function(key) {
        return delete $34627ec7a3e6aa0e$var$dataMemory[key];
    };
    /**
     * This is used to clear the storage
     * @returns {string} nothing
     */ MemoryStorage.clear = function() {
        $34627ec7a3e6aa0e$var$dataMemory = {};
        return $34627ec7a3e6aa0e$var$dataMemory;
    };
    return MemoryStorage;
}();
var $34627ec7a3e6aa0e$export$a2bd19c49e4760e8 = /** @class */ function() {
    /**
     * This is used to get a storage object
     * @returns {object} the storage
     */ function StorageHelper() {
        try {
            this.storageWindow = window.localStorage;
            this.storageWindow.setItem('aws.amplify.test-ls', 1);
            this.storageWindow.removeItem('aws.amplify.test-ls');
        } catch (exception) {
            this.storageWindow = $34627ec7a3e6aa0e$export$d7392285c701ecf5;
        }
    }
    /**
     * This is used to return the storage
     * @returns {object} the storage
     */ StorageHelper.prototype.getStorage = function() {
        return this.storageWindow;
    };
    return StorageHelper;
}();
var /**
 * @deprecated use named import
 */ $34627ec7a3e6aa0e$export$2e2bcd8739ae039 = $34627ec7a3e6aa0e$export$a2bd19c49e4760e8;

});

parcelRegister("dQWOh", function(module, exports) {

$parcel$export(module.exports, "GoogleOAuth", () => $a15dc01d8dd8d7ca$export$75ace714083c1340);
$parcel$export(module.exports, "FacebookOAuth", () => $a15dc01d8dd8d7ca$export$1b6b8b5328e38349);
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $8WN0E = parcelRequire("8WN0E");

var $h7zMw = parcelRequire("h7zMw");
var $a15dc01d8dd8d7ca$export$75ace714083c1340 = new (0, $8WN0E.GoogleOAuth)();
var $a15dc01d8dd8d7ca$export$1b6b8b5328e38349 = new (0, $h7zMw.FacebookOAuth)();

});
parcelRegister("8WN0E", function(module, exports) {

$parcel$export(module.exports, "GoogleOAuth", () => $6839c1c08165a520$export$75ace714083c1340);

var $7UO1b = parcelRequire("7UO1b");

var $9Mfkr = parcelRequire("9Mfkr");

var $7TTzY = parcelRequire("7TTzY");
var $6839c1c08165a520$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $6839c1c08165a520$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $6839c1c08165a520$var$logger = new (0, $7UO1b.ConsoleLogger)('CognitoCredentials');
var $6839c1c08165a520$var$waitForInit = new Promise(function(res, rej) {
    if (!(0, $9Mfkr.browserOrNode)().isBrowser) {
        $6839c1c08165a520$var$logger.debug('not in the browser, directly resolved');
        return res();
    }
    var ga = window['gapi'] && window['gapi'].auth2 ? window['gapi'].auth2 : null;
    if (ga) {
        $6839c1c08165a520$var$logger.debug('google api already loaded');
        return res();
    } else setTimeout(function() {
        return res();
    }, 2000);
});
var $6839c1c08165a520$export$75ace714083c1340 = /** @class */ function() {
    function GoogleOAuth() {
        this.initialized = false;
        this.refreshGoogleToken = this.refreshGoogleToken.bind(this);
        this._refreshGoogleTokenImpl = this._refreshGoogleTokenImpl.bind(this);
    }
    GoogleOAuth.prototype.refreshGoogleToken = function() {
        return $6839c1c08165a520$var$__awaiter(this, void 0, void 0, function() {
            return $6839c1c08165a520$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!this.initialized) return [
                            3 /*break*/ ,
                            2
                        ];
                        $6839c1c08165a520$var$logger.debug('need to wait for the Google SDK loaded');
                        return [
                            4 /*yield*/ ,
                            $6839c1c08165a520$var$waitForInit
                        ];
                    case 1:
                        _a.sent();
                        this.initialized = true;
                        $6839c1c08165a520$var$logger.debug('finish waiting');
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ ,
                            this._refreshGoogleTokenImpl()
                        ];
                }
            });
        });
    };
    GoogleOAuth.prototype._refreshGoogleTokenImpl = function() {
        var ga = null;
        if ((0, $9Mfkr.browserOrNode)().isBrowser) ga = window['gapi'] && window['gapi'].auth2 ? window['gapi'].auth2 : null;
        if (!ga) {
            $6839c1c08165a520$var$logger.debug('no gapi auth2 available');
            return Promise.reject('no gapi auth2 available');
        }
        return new Promise(function(res, rej) {
            ga.getAuthInstance().then(function(googleAuth) {
                if (!googleAuth) {
                    $6839c1c08165a520$var$logger.debug('google Auth undefined');
                    rej(new (0, $7TTzY.NonRetryableError)('google Auth undefined'));
                }
                var googleUser = googleAuth.currentUser.get();
                // refresh the token
                if (googleUser.isSignedIn()) {
                    $6839c1c08165a520$var$logger.debug('refreshing the google access token');
                    googleUser.reloadAuthResponse().then(function(authResponse) {
                        var id_token = authResponse.id_token, expires_at = authResponse.expires_at;
                        res({
                            token: id_token,
                            expires_at: expires_at
                        });
                    }).catch(function(err) {
                        if (err && err.error === 'network_error') // Not using NonRetryableError so handler will be retried
                        rej('Network error reloading google auth response');
                        else rej(new (0, $7TTzY.NonRetryableError)('Failed to reload google auth response'));
                    });
                } else rej(new (0, $7TTzY.NonRetryableError)('User is not signed in with Google'));
            }).catch(function(err) {
                $6839c1c08165a520$var$logger.debug('Failed to refresh google token', err);
                rej(new (0, $7TTzY.NonRetryableError)('Failed to refresh google token'));
            });
        });
    };
    return GoogleOAuth;
}();
var /**
 * @deprecated use named import
 */ $6839c1c08165a520$export$2e2bcd8739ae039 = $6839c1c08165a520$export$75ace714083c1340;

});
parcelRegister("7TTzY", function(module, exports) {

$parcel$export(module.exports, "NonRetryableError", () => $5c08c8583fe5e729$export$1e38badc838ad384);
$parcel$export(module.exports, "jitteredExponentialRetry", () => $5c08c8583fe5e729$export$a24aa7705df9cf44);

var $7UO1b = parcelRequire("7UO1b");
var $5c08c8583fe5e729$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $5c08c8583fe5e729$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $5c08c8583fe5e729$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $5c08c8583fe5e729$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $5c08c8583fe5e729$var$__spread = undefined && undefined.__spread || function() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c08c8583fe5e729$var$__read(arguments[i]));
    return ar;
};
var $5c08c8583fe5e729$var$logger = new (0, $7UO1b.ConsoleLogger)('Util');
var $5c08c8583fe5e729$export$1e38badc838ad384 = /** @class */ function(_super) {
    $5c08c8583fe5e729$var$__extends(NonRetryableError, _super);
    function NonRetryableError(message) {
        var _this = _super.call(this, message) || this;
        _this.nonRetryable = true;
        return _this;
    }
    return NonRetryableError;
}(Error);
var $5c08c8583fe5e729$var$isNonRetryableError = function(obj) {
    var key = 'nonRetryable';
    return obj && obj[key];
};
function $5c08c8583fe5e729$export$9369b12211e1fce4(functionToRetry, args, delayFn, attempt) {
    if (attempt === void 0) attempt = 1;
    return $5c08c8583fe5e729$var$__awaiter(this, void 0, void 0, function() {
        var err_1, retryIn_1;
        return $5c08c8583fe5e729$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (typeof functionToRetry !== 'function') throw Error('functionToRetry must be a function');
                    $5c08c8583fe5e729$var$logger.debug(functionToRetry.name + " attempt #" + attempt + " with this vars: " + JSON.stringify(args));
                    _a.label = 1;
                case 1:
                    _a.trys.push([
                        1,
                        3,
                        ,
                        8
                    ]);
                    return [
                        4 /*yield*/ ,
                        functionToRetry.apply(void 0, $5c08c8583fe5e729$var$__spread(args))
                    ];
                case 2:
                    return [
                        2 /*return*/ ,
                        _a.sent()
                    ];
                case 3:
                    err_1 = _a.sent();
                    $5c08c8583fe5e729$var$logger.debug("error on " + functionToRetry.name, err_1);
                    if ($5c08c8583fe5e729$var$isNonRetryableError(err_1)) {
                        $5c08c8583fe5e729$var$logger.debug(functionToRetry.name + " non retryable error", err_1);
                        throw err_1;
                    }
                    retryIn_1 = delayFn(attempt, args, err_1);
                    $5c08c8583fe5e729$var$logger.debug(functionToRetry.name + " retrying in " + retryIn_1 + " ms");
                    if (!(retryIn_1 !== false)) return [
                        3 /*break*/ ,
                        6
                    ];
                    return [
                        4 /*yield*/ ,
                        new Promise(function(res) {
                            return setTimeout(res, retryIn_1);
                        })
                    ];
                case 4:
                    _a.sent();
                    return [
                        4 /*yield*/ ,
                        $5c08c8583fe5e729$export$9369b12211e1fce4(functionToRetry, args, delayFn, attempt + 1)
                    ];
                case 5:
                    return [
                        2 /*return*/ ,
                        _a.sent()
                    ];
                case 6:
                    throw err_1;
                case 7:
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 8:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
var $5c08c8583fe5e729$var$MAX_DELAY_MS = 300000;
function $5c08c8583fe5e729$var$jitteredBackoff(maxDelayMs) {
    var BASE_TIME_MS = 100;
    var JITTER_FACTOR = 100;
    return function(attempt) {
        var delay = Math.pow(2, attempt) * BASE_TIME_MS + JITTER_FACTOR * Math.random();
        return delay > maxDelayMs ? false : delay;
    };
}
var $5c08c8583fe5e729$export$a24aa7705df9cf44 = function(functionToRetry, args, maxDelayMs) {
    if (maxDelayMs === void 0) maxDelayMs = $5c08c8583fe5e729$var$MAX_DELAY_MS;
    return $5c08c8583fe5e729$export$9369b12211e1fce4(functionToRetry, args, $5c08c8583fe5e729$var$jitteredBackoff(maxDelayMs));
};

});


parcelRegister("h7zMw", function(module, exports) {

$parcel$export(module.exports, "FacebookOAuth", () => $c76ed892e443facb$export$1b6b8b5328e38349);

var $7UO1b = parcelRequire("7UO1b");

var $9Mfkr = parcelRequire("9Mfkr");

var $7TTzY = parcelRequire("7TTzY");
var $c76ed892e443facb$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $c76ed892e443facb$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $c76ed892e443facb$var$logger = new (0, $7UO1b.ConsoleLogger)('CognitoCredentials');
var $c76ed892e443facb$var$waitForInit = new Promise(function(res, rej) {
    if (!(0, $9Mfkr.browserOrNode)().isBrowser) {
        $c76ed892e443facb$var$logger.debug('not in the browser, directly resolved');
        return res();
    }
    var fb = window['FB'];
    if (fb) {
        $c76ed892e443facb$var$logger.debug('FB SDK already loaded');
        return res();
    } else setTimeout(function() {
        return res();
    }, 2000);
});
var $c76ed892e443facb$export$1b6b8b5328e38349 = /** @class */ function() {
    function FacebookOAuth() {
        this.initialized = false;
        this.refreshFacebookToken = this.refreshFacebookToken.bind(this);
        this._refreshFacebookTokenImpl = this._refreshFacebookTokenImpl.bind(this);
    }
    FacebookOAuth.prototype.refreshFacebookToken = function() {
        return $c76ed892e443facb$var$__awaiter(this, void 0, void 0, function() {
            return $c76ed892e443facb$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!this.initialized) return [
                            3 /*break*/ ,
                            2
                        ];
                        $c76ed892e443facb$var$logger.debug('need to wait for the Facebook SDK loaded');
                        return [
                            4 /*yield*/ ,
                            $c76ed892e443facb$var$waitForInit
                        ];
                    case 1:
                        _a.sent();
                        this.initialized = true;
                        $c76ed892e443facb$var$logger.debug('finish waiting');
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ ,
                            this._refreshFacebookTokenImpl()
                        ];
                }
            });
        });
    };
    FacebookOAuth.prototype._refreshFacebookTokenImpl = function() {
        var fb = null;
        if ((0, $9Mfkr.browserOrNode)().isBrowser) fb = window['FB'];
        if (!fb) {
            var errorMessage = 'no fb sdk available';
            $c76ed892e443facb$var$logger.debug(errorMessage);
            return Promise.reject(new (0, $7TTzY.NonRetryableError)(errorMessage));
        }
        return new Promise(function(res, rej) {
            fb.getLoginStatus(function(fbResponse) {
                if (!fbResponse || !fbResponse.authResponse) {
                    var errorMessage = 'no response from facebook when refreshing the jwt token';
                    $c76ed892e443facb$var$logger.debug(errorMessage);
                    // There is no definitive indication for a network error in
                    // fbResponse, so we are treating it as an invalid token.
                    rej(new (0, $7TTzY.NonRetryableError)(errorMessage));
                } else {
                    var response = fbResponse.authResponse;
                    var accessToken = response.accessToken, expiresIn = response.expiresIn;
                    var date = new Date();
                    var expires_at = expiresIn * 1000 + date.getTime();
                    if (!accessToken) {
                        var errorMessage = 'the jwtToken is undefined';
                        $c76ed892e443facb$var$logger.debug(errorMessage);
                        rej(new (0, $7TTzY.NonRetryableError)(errorMessage));
                    }
                    res({
                        token: accessToken,
                        expires_at: expires_at
                    });
                }
            }, {
                scope: 'public_profile,email'
            });
        });
    };
    return FacebookOAuth;
}();
var /**
 * @deprecated use named import
 */ $c76ed892e443facb$export$2e2bcd8739ae039 = $c76ed892e443facb$export$1b6b8b5328e38349;

});


parcelRegister("gsz66", function(module, exports) {

$parcel$export(module.exports, "fromCognitoIdentity", () => $bfba7c80c38c8c60$export$4d624d71eb462130);

var $7AHWw = parcelRequire("7AHWw");

var $ggKwC = parcelRequire("ggKwC");
parcelRequire("bCCSs");
var $i2yOq = parcelRequire("i2yOq");

var $944UQ = parcelRequire("944UQ");
function $bfba7c80c38c8c60$export$4d624d71eb462130(parameters) {
    var _this = this;
    return function() {
        return (0, $7AHWw.__awaiter)(_this, void 0, void 0, function() {
            var _a, _b, _c, AccessKeyId, Expiration, _d, SecretKey, SessionToken, _e, _f, _g, _h;
            var _j;
            return (0, $7AHWw.__generator)(this, function(_k) {
                switch(_k.label){
                    case 0:
                        _f = (_e = parameters.client).send;
                        _g = (0, $ggKwC.GetCredentialsForIdentityCommand).bind;
                        _j = {
                            CustomRoleArn: parameters.customRoleArn,
                            IdentityId: parameters.identityId
                        };
                        if (!parameters.logins) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $944UQ.resolveLogins)(parameters.logins)
                        ];
                    case 1:
                        _h = _k.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        _h = undefined;
                        _k.label = 3;
                    case 3:
                        return [
                            4 /*yield*/ ,
                            _f.apply(_e, [
                                new (_g.apply((0, $ggKwC.GetCredentialsForIdentityCommand), [
                                    void 0,
                                    (_j.Logins = _h, _j)
                                ]))()
                            ])
                        ];
                    case 4:
                        _a = _k.sent().Credentials, _b = _a === void 0 ? $bfba7c80c38c8c60$var$throwOnMissingCredentials() : _a, _c = _b.AccessKeyId, AccessKeyId = _c === void 0 ? $bfba7c80c38c8c60$var$throwOnMissingAccessKeyId() : _c, Expiration = _b.Expiration, _d = _b.SecretKey, SecretKey = _d === void 0 ? $bfba7c80c38c8c60$var$throwOnMissingSecretKey() : _d, SessionToken = _b.SessionToken;
                        return [
                            2 /*return*/ ,
                            {
                                identityId: parameters.identityId,
                                accessKeyId: AccessKeyId,
                                secretAccessKey: SecretKey,
                                sessionToken: SessionToken,
                                expiration: Expiration
                            }
                        ];
                }
            });
        });
    };
}
function $bfba7c80c38c8c60$var$throwOnMissingAccessKeyId() {
    throw new (0, $i2yOq.ProviderError)("Response from Amazon Cognito contained no access key ID");
}
function $bfba7c80c38c8c60$var$throwOnMissingCredentials() {
    throw new (0, $i2yOq.ProviderError)("Response from Amazon Cognito contained no credentials");
}
function $bfba7c80c38c8c60$var$throwOnMissingSecretKey() {
    throw new (0, $i2yOq.ProviderError)("Response from Amazon Cognito contained no secret key");
}

});
parcelRegister("7AHWw", function(module, exports) {

$parcel$export(module.exports, "__awaiter", () => $586dfb5a07baa2d8$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $586dfb5a07baa2d8$export$67ebef60e6f28a6);
$parcel$export(module.exports, "__read", () => $586dfb5a07baa2d8$export$8d051b38c9118094);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $586dfb5a07baa2d8$var$extendStatics = function(d, b) {
    $586dfb5a07baa2d8$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $586dfb5a07baa2d8$var$extendStatics(d, b);
};
function $586dfb5a07baa2d8$export$a8ba968b8961cb8a(d, b) {
    $586dfb5a07baa2d8$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $586dfb5a07baa2d8$export$18ce0697a983be9b = function() {
    $586dfb5a07baa2d8$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $586dfb5a07baa2d8$export$18ce0697a983be9b.apply(this, arguments);
};
function $586dfb5a07baa2d8$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $586dfb5a07baa2d8$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $586dfb5a07baa2d8$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $586dfb5a07baa2d8$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $586dfb5a07baa2d8$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $586dfb5a07baa2d8$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $586dfb5a07baa2d8$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $586dfb5a07baa2d8$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $586dfb5a07baa2d8$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $586dfb5a07baa2d8$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $586dfb5a07baa2d8$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($586dfb5a07baa2d8$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $586dfb5a07baa2d8$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $586dfb5a07baa2d8$export$10c90e4f7922046c(v) {
    return this instanceof $586dfb5a07baa2d8$export$10c90e4f7922046c ? (this.v = v, this) : new $586dfb5a07baa2d8$export$10c90e4f7922046c(v);
}
function $586dfb5a07baa2d8$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $586dfb5a07baa2d8$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $586dfb5a07baa2d8$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $586dfb5a07baa2d8$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $586dfb5a07baa2d8$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $586dfb5a07baa2d8$export$19a8beecd37a4c45 === "function" ? $586dfb5a07baa2d8$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $586dfb5a07baa2d8$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $586dfb5a07baa2d8$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $586dfb5a07baa2d8$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $586dfb5a07baa2d8$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $586dfb5a07baa2d8$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("ggKwC", function(module, exports) {

$parcel$export(module.exports, "GetCredentialsForIdentityCommand", () => $bd823ae49b056366$export$e08b3308c36761ec);

var $2eeCH = parcelRequire("2eeCH");

var $73Mvs = parcelRequire("73Mvs");

var $JCuPK = parcelRequire("JCuPK");
parcelRequire("6ZXPq");
var $dQtWs = parcelRequire("dQtWs");
parcelRequire("3vy9S");
var $5nbBf = parcelRequire("5nbBf");
/**
 * <p>Returns credentials for the provided identity ID. Any provided logins will be
 *          validated against supported login providers. If the token is for
 *          cognito-identity.amazonaws.com, it will be passed through to AWS Security Token Service
 *          with the appropriate role for the token.</p>
 *          <p>This is a public API. You do not need any credentials to call this API.</p>
 */ var $bd823ae49b056366$export$e08b3308c36761ec = /** @class */ function(_super) {
    (0, $2eeCH.__extends)(GetCredentialsForIdentityCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function GetCredentialsForIdentityCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    /**
     * @internal
     */ GetCredentialsForIdentityCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $dQtWs.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CognitoIdentityClient";
        var commandName = "GetCredentialsForIdentityCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $73Mvs.GetCredentialsForIdentityInput).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $73Mvs.GetCredentialsForIdentityResponse).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetCredentialsForIdentityCommand.prototype.serialize = function(input, context) {
        return (0, $JCuPK.serializeAws_json1_1GetCredentialsForIdentityCommand)(input, context);
    };
    GetCredentialsForIdentityCommand.prototype.deserialize = function(output, context) {
        return (0, $JCuPK.deserializeAws_json1_1GetCredentialsForIdentityCommand)(output, context);
    };
    return GetCredentialsForIdentityCommand;
}((0, $5nbBf.Command));

});
parcelRegister("73Mvs", function(module, exports) {

$parcel$export(module.exports, "GetCredentialsForIdentityInput", () => $523e708dbe590119$export$bb51e43959182308);
$parcel$export(module.exports, "GetCredentialsForIdentityResponse", () => $523e708dbe590119$export$ba56c4cb277a72f9);
$parcel$export(module.exports, "GetIdInput", () => $523e708dbe590119$export$badc3094716a9faa);
$parcel$export(module.exports, "GetIdResponse", () => $523e708dbe590119$export$c3ec238968a6e7ac);

var $2eeCH = parcelRequire("2eeCH");
var $523e708dbe590119$export$dc00db384271fff6;
(function(AmbiguousRoleResolutionType) {
    AmbiguousRoleResolutionType["AUTHENTICATED_ROLE"] = "AuthenticatedRole";
    AmbiguousRoleResolutionType["DENY"] = "Deny";
})($523e708dbe590119$export$dc00db384271fff6 || ($523e708dbe590119$export$dc00db384271fff6 = {}));
var $523e708dbe590119$export$8a7902a72d4cb6dd;
(function(CognitoIdentityProvider) {
    CognitoIdentityProvider.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($523e708dbe590119$export$8a7902a72d4cb6dd || ($523e708dbe590119$export$8a7902a72d4cb6dd = {}));
var $523e708dbe590119$export$2d7512435854af72;
(function(CreateIdentityPoolInput) {
    CreateIdentityPoolInput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($523e708dbe590119$export$2d7512435854af72 || ($523e708dbe590119$export$2d7512435854af72 = {}));
var $523e708dbe590119$export$8d556ce24d00472;
(function(IdentityPool) {
    IdentityPool.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($523e708dbe590119$export$8d556ce24d00472 || ($523e708dbe590119$export$8d556ce24d00472 = {}));
var $523e708dbe590119$export$8b0f706f4df56c63;
(function(InternalErrorException) {
    InternalErrorException.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($523e708dbe590119$export$8b0f706f4df56c63 || ($523e708dbe590119$export$8b0f706f4df56c63 = {}));
var $523e708dbe590119$export$fa781b52e13bf866;
(function(InvalidParameterException) {
    InvalidParameterException.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($523e708dbe590119$export$fa781b52e13bf866 || ($523e708dbe590119$export$fa781b52e13bf866 = {}));
var $523e708dbe590119$export$cd419aa7f32ec382;
(function(LimitExceededException) {
    LimitExceededException.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($523e708dbe590119$export$cd419aa7f32ec382 || ($523e708dbe590119$export$cd419aa7f32ec382 = {}));
var $523e708dbe590119$export$82cff5e5a0a874dd;
(function(NotAuthorizedException) {
    NotAuthorizedException.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($523e708dbe590119$export$82cff5e5a0a874dd || ($523e708dbe590119$export$82cff5e5a0a874dd = {}));
var $523e708dbe590119$export$cbdaf31887dd0603;
(function(ResourceConflictException) {
    ResourceConflictException.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($523e708dbe590119$export$cbdaf31887dd0603 || ($523e708dbe590119$export$cbdaf31887dd0603 = {}));
var $523e708dbe590119$export$4a67805ad445f61;
(function(TooManyRequestsException) {
    TooManyRequestsException.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($523e708dbe590119$export$4a67805ad445f61 || ($523e708dbe590119$export$4a67805ad445f61 = {}));
var $523e708dbe590119$export$6ce299b58e0ab8fe;
(function(DeleteIdentitiesInput) {
    DeleteIdentitiesInput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($523e708dbe590119$export$6ce299b58e0ab8fe || ($523e708dbe590119$export$6ce299b58e0ab8fe = {}));
var $523e708dbe590119$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    ErrorCode["ACCESS_DENIED"] = "AccessDenied";
    ErrorCode["INTERNAL_SERVER_ERROR"] = "InternalServerError";
})($523e708dbe590119$export$d4e71bc0b80dc0fb || ($523e708dbe590119$export$d4e71bc0b80dc0fb = {}));
var $523e708dbe590119$export$7235a8ee19d2bee3;
(function(UnprocessedIdentityId) {
    UnprocessedIdentityId.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($523e708dbe590119$export$7235a8ee19d2bee3 || ($523e708dbe590119$export$7235a8ee19d2bee3 = {}));
var $523e708dbe590119$export$2b5603236acc81d9;
(function(DeleteIdentitiesResponse) {
    DeleteIdentitiesResponse.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($523e708dbe590119$export$2b5603236acc81d9 || ($523e708dbe590119$export$2b5603236acc81d9 = {}));
var $523e708dbe590119$export$cb6981b8f9a703c2;
(function(DeleteIdentityPoolInput) {
    DeleteIdentityPoolInput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($523e708dbe590119$export$cb6981b8f9a703c2 || ($523e708dbe590119$export$cb6981b8f9a703c2 = {}));
var $523e708dbe590119$export$ecba565262f8bb2;
(function(ResourceNotFoundException) {
    ResourceNotFoundException.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($523e708dbe590119$export$ecba565262f8bb2 || ($523e708dbe590119$export$ecba565262f8bb2 = {}));
var $523e708dbe590119$export$46587acc7855d6e2;
(function(DescribeIdentityInput) {
    DescribeIdentityInput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($523e708dbe590119$export$46587acc7855d6e2 || ($523e708dbe590119$export$46587acc7855d6e2 = {}));
var $523e708dbe590119$export$16e1ea20d4f13fa7;
(function(IdentityDescription) {
    IdentityDescription.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($523e708dbe590119$export$16e1ea20d4f13fa7 || ($523e708dbe590119$export$16e1ea20d4f13fa7 = {}));
var $523e708dbe590119$export$4b5909fe2abc147d;
(function(DescribeIdentityPoolInput) {
    DescribeIdentityPoolInput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($523e708dbe590119$export$4b5909fe2abc147d || ($523e708dbe590119$export$4b5909fe2abc147d = {}));
var $523e708dbe590119$export$cb77a58cb7dbb17;
(function(ExternalServiceException) {
    ExternalServiceException.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($523e708dbe590119$export$cb77a58cb7dbb17 || ($523e708dbe590119$export$cb77a58cb7dbb17 = {}));
var $523e708dbe590119$export$bb51e43959182308;
(function(GetCredentialsForIdentityInput) {
    GetCredentialsForIdentityInput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($523e708dbe590119$export$bb51e43959182308 || ($523e708dbe590119$export$bb51e43959182308 = {}));
var $523e708dbe590119$export$a9627919734faa48;
(function(Credentials) {
    Credentials.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($523e708dbe590119$export$a9627919734faa48 || ($523e708dbe590119$export$a9627919734faa48 = {}));
var $523e708dbe590119$export$ba56c4cb277a72f9;
(function(GetCredentialsForIdentityResponse) {
    GetCredentialsForIdentityResponse.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($523e708dbe590119$export$ba56c4cb277a72f9 || ($523e708dbe590119$export$ba56c4cb277a72f9 = {}));
var $523e708dbe590119$export$90d12448d3766cda;
(function(InvalidIdentityPoolConfigurationException) {
    InvalidIdentityPoolConfigurationException.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($523e708dbe590119$export$90d12448d3766cda || ($523e708dbe590119$export$90d12448d3766cda = {}));
var $523e708dbe590119$export$badc3094716a9faa;
(function(GetIdInput) {
    GetIdInput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($523e708dbe590119$export$badc3094716a9faa || ($523e708dbe590119$export$badc3094716a9faa = {}));
var $523e708dbe590119$export$c3ec238968a6e7ac;
(function(GetIdResponse) {
    GetIdResponse.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($523e708dbe590119$export$c3ec238968a6e7ac || ($523e708dbe590119$export$c3ec238968a6e7ac = {}));
var $523e708dbe590119$export$f5f529c0b4e5eb30;
(function(GetIdentityPoolRolesInput) {
    GetIdentityPoolRolesInput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($523e708dbe590119$export$f5f529c0b4e5eb30 || ($523e708dbe590119$export$f5f529c0b4e5eb30 = {}));
var $523e708dbe590119$export$819b5ceb37e06be;
(function(MappingRuleMatchType) {
    MappingRuleMatchType["CONTAINS"] = "Contains";
    MappingRuleMatchType["EQUALS"] = "Equals";
    MappingRuleMatchType["NOT_EQUAL"] = "NotEqual";
    MappingRuleMatchType["STARTS_WITH"] = "StartsWith";
})($523e708dbe590119$export$819b5ceb37e06be || ($523e708dbe590119$export$819b5ceb37e06be = {}));
var $523e708dbe590119$export$3f8398961535c3a;
(function(MappingRule) {
    MappingRule.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($523e708dbe590119$export$3f8398961535c3a || ($523e708dbe590119$export$3f8398961535c3a = {}));
var $523e708dbe590119$export$269dcf2519324984;
(function(RulesConfigurationType) {
    RulesConfigurationType.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($523e708dbe590119$export$269dcf2519324984 || ($523e708dbe590119$export$269dcf2519324984 = {}));
var $523e708dbe590119$export$c726ef784882c23e;
(function(RoleMappingType) {
    RoleMappingType["RULES"] = "Rules";
    RoleMappingType["TOKEN"] = "Token";
})($523e708dbe590119$export$c726ef784882c23e || ($523e708dbe590119$export$c726ef784882c23e = {}));
var $523e708dbe590119$export$c8be61b857de8364;
(function(RoleMapping) {
    RoleMapping.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($523e708dbe590119$export$c8be61b857de8364 || ($523e708dbe590119$export$c8be61b857de8364 = {}));
var $523e708dbe590119$export$69a6cbc1a215fcdf;
(function(GetIdentityPoolRolesResponse) {
    GetIdentityPoolRolesResponse.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($523e708dbe590119$export$69a6cbc1a215fcdf || ($523e708dbe590119$export$69a6cbc1a215fcdf = {}));
var $523e708dbe590119$export$e31993063e9290fd;
(function(GetOpenIdTokenInput) {
    GetOpenIdTokenInput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($523e708dbe590119$export$e31993063e9290fd || ($523e708dbe590119$export$e31993063e9290fd = {}));
var $523e708dbe590119$export$c2cdb3ad9240cf7d;
(function(GetOpenIdTokenResponse) {
    GetOpenIdTokenResponse.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($523e708dbe590119$export$c2cdb3ad9240cf7d || ($523e708dbe590119$export$c2cdb3ad9240cf7d = {}));
var $523e708dbe590119$export$f9e8c5d2069aeea4;
(function(DeveloperUserAlreadyRegisteredException) {
    DeveloperUserAlreadyRegisteredException.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($523e708dbe590119$export$f9e8c5d2069aeea4 || ($523e708dbe590119$export$f9e8c5d2069aeea4 = {}));
var $523e708dbe590119$export$b30c26022c4ccb98;
(function(GetOpenIdTokenForDeveloperIdentityInput) {
    GetOpenIdTokenForDeveloperIdentityInput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($523e708dbe590119$export$b30c26022c4ccb98 || ($523e708dbe590119$export$b30c26022c4ccb98 = {}));
var $523e708dbe590119$export$39b050249a579e7b;
(function(GetOpenIdTokenForDeveloperIdentityResponse) {
    GetOpenIdTokenForDeveloperIdentityResponse.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($523e708dbe590119$export$39b050249a579e7b || ($523e708dbe590119$export$39b050249a579e7b = {}));
var $523e708dbe590119$export$8c1e5f4b8dc33aa1;
(function(ListIdentitiesInput) {
    ListIdentitiesInput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($523e708dbe590119$export$8c1e5f4b8dc33aa1 || ($523e708dbe590119$export$8c1e5f4b8dc33aa1 = {}));
var $523e708dbe590119$export$5270c3e17502575a;
(function(ListIdentitiesResponse) {
    ListIdentitiesResponse.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($523e708dbe590119$export$5270c3e17502575a || ($523e708dbe590119$export$5270c3e17502575a = {}));
var $523e708dbe590119$export$1d38161f8b62ad;
(function(ListIdentityPoolsInput) {
    ListIdentityPoolsInput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($523e708dbe590119$export$1d38161f8b62ad || ($523e708dbe590119$export$1d38161f8b62ad = {}));
var $523e708dbe590119$export$5a7a0c97755dcf8e;
(function(IdentityPoolShortDescription) {
    IdentityPoolShortDescription.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($523e708dbe590119$export$5a7a0c97755dcf8e || ($523e708dbe590119$export$5a7a0c97755dcf8e = {}));
var $523e708dbe590119$export$f862a07a4a7c6250;
(function(ListIdentityPoolsResponse) {
    ListIdentityPoolsResponse.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($523e708dbe590119$export$f862a07a4a7c6250 || ($523e708dbe590119$export$f862a07a4a7c6250 = {}));
var $523e708dbe590119$export$8eb1e3f42ea35fee;
(function(ListTagsForResourceInput) {
    ListTagsForResourceInput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($523e708dbe590119$export$8eb1e3f42ea35fee || ($523e708dbe590119$export$8eb1e3f42ea35fee = {}));
var $523e708dbe590119$export$6db0c8c0f26e7fec;
(function(ListTagsForResourceResponse) {
    ListTagsForResourceResponse.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($523e708dbe590119$export$6db0c8c0f26e7fec || ($523e708dbe590119$export$6db0c8c0f26e7fec = {}));
var $523e708dbe590119$export$1624698866821668;
(function(LookupDeveloperIdentityInput) {
    LookupDeveloperIdentityInput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($523e708dbe590119$export$1624698866821668 || ($523e708dbe590119$export$1624698866821668 = {}));
var $523e708dbe590119$export$fb0cf3531245501b;
(function(LookupDeveloperIdentityResponse) {
    LookupDeveloperIdentityResponse.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($523e708dbe590119$export$fb0cf3531245501b || ($523e708dbe590119$export$fb0cf3531245501b = {}));
var $523e708dbe590119$export$8f282934b0cfbc4a;
(function(MergeDeveloperIdentitiesInput) {
    MergeDeveloperIdentitiesInput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($523e708dbe590119$export$8f282934b0cfbc4a || ($523e708dbe590119$export$8f282934b0cfbc4a = {}));
var $523e708dbe590119$export$13aa23992eef667b;
(function(MergeDeveloperIdentitiesResponse) {
    MergeDeveloperIdentitiesResponse.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($523e708dbe590119$export$13aa23992eef667b || ($523e708dbe590119$export$13aa23992eef667b = {}));
var $523e708dbe590119$export$21f15e80c2bbca09;
(function(ConcurrentModificationException) {
    ConcurrentModificationException.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($523e708dbe590119$export$21f15e80c2bbca09 || ($523e708dbe590119$export$21f15e80c2bbca09 = {}));
var $523e708dbe590119$export$20f43a93eb8d3b02;
(function(SetIdentityPoolRolesInput) {
    SetIdentityPoolRolesInput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($523e708dbe590119$export$20f43a93eb8d3b02 || ($523e708dbe590119$export$20f43a93eb8d3b02 = {}));
var $523e708dbe590119$export$a5e7dff780e8dcb0;
(function(TagResourceInput) {
    TagResourceInput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($523e708dbe590119$export$a5e7dff780e8dcb0 || ($523e708dbe590119$export$a5e7dff780e8dcb0 = {}));
var $523e708dbe590119$export$2d5279802486e8b0;
(function(TagResourceResponse) {
    TagResourceResponse.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($523e708dbe590119$export$2d5279802486e8b0 || ($523e708dbe590119$export$2d5279802486e8b0 = {}));
var $523e708dbe590119$export$b977eb1c8f754bfa;
(function(UnlinkDeveloperIdentityInput) {
    UnlinkDeveloperIdentityInput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($523e708dbe590119$export$b977eb1c8f754bfa || ($523e708dbe590119$export$b977eb1c8f754bfa = {}));
var $523e708dbe590119$export$2415026a66f5e70b;
(function(UnlinkIdentityInput) {
    UnlinkIdentityInput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($523e708dbe590119$export$2415026a66f5e70b || ($523e708dbe590119$export$2415026a66f5e70b = {}));
var $523e708dbe590119$export$4dbbd8ede80c9c36;
(function(UntagResourceInput) {
    UntagResourceInput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($523e708dbe590119$export$4dbbd8ede80c9c36 || ($523e708dbe590119$export$4dbbd8ede80c9c36 = {}));
var $523e708dbe590119$export$2128f49a7cd2e47f;
(function(UntagResourceResponse) {
    UntagResourceResponse.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($523e708dbe590119$export$2128f49a7cd2e47f || ($523e708dbe590119$export$2128f49a7cd2e47f = {}));

});

parcelRegister("JCuPK", function(module, exports) {

$parcel$export(module.exports, "serializeAws_json1_1GetCredentialsForIdentityCommand", () => $089210a68d073055$export$88af91ae17f8527c);
$parcel$export(module.exports, "serializeAws_json1_1GetIdCommand", () => $089210a68d073055$export$83083ba13837129b);
$parcel$export(module.exports, "deserializeAws_json1_1GetCredentialsForIdentityCommand", () => $089210a68d073055$export$ebea9103431f9a50);
$parcel$export(module.exports, "deserializeAws_json1_1GetIdCommand", () => $089210a68d073055$export$9f5769abdc93f0b4);

var $2eeCH = parcelRequire("2eeCH");
parcelRequire("3uM9B");
var $dlqaT = parcelRequire("dlqaT");
var $089210a68d073055$export$44d8caf684388429 = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $2eeCH.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.CreateIdentityPool"
            };
            body = JSON.stringify($089210a68d073055$var$serializeAws_json1_1CreateIdentityPoolInput(input, context));
            return [
                2 /*return*/ ,
                $089210a68d073055$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $089210a68d073055$export$2f9133f6d812a2b4 = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $2eeCH.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.DeleteIdentities"
            };
            body = JSON.stringify($089210a68d073055$var$serializeAws_json1_1DeleteIdentitiesInput(input, context));
            return [
                2 /*return*/ ,
                $089210a68d073055$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $089210a68d073055$export$900e66311faca63a = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $2eeCH.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.DeleteIdentityPool"
            };
            body = JSON.stringify($089210a68d073055$var$serializeAws_json1_1DeleteIdentityPoolInput(input, context));
            return [
                2 /*return*/ ,
                $089210a68d073055$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $089210a68d073055$export$f0f695bb22170112 = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $2eeCH.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.DescribeIdentity"
            };
            body = JSON.stringify($089210a68d073055$var$serializeAws_json1_1DescribeIdentityInput(input, context));
            return [
                2 /*return*/ ,
                $089210a68d073055$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $089210a68d073055$export$24669e6016ff61f7 = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $2eeCH.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.DescribeIdentityPool"
            };
            body = JSON.stringify($089210a68d073055$var$serializeAws_json1_1DescribeIdentityPoolInput(input, context));
            return [
                2 /*return*/ ,
                $089210a68d073055$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $089210a68d073055$export$88af91ae17f8527c = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $2eeCH.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.GetCredentialsForIdentity"
            };
            body = JSON.stringify($089210a68d073055$var$serializeAws_json1_1GetCredentialsForIdentityInput(input, context));
            return [
                2 /*return*/ ,
                $089210a68d073055$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $089210a68d073055$export$83083ba13837129b = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $2eeCH.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.GetId"
            };
            body = JSON.stringify($089210a68d073055$var$serializeAws_json1_1GetIdInput(input, context));
            return [
                2 /*return*/ ,
                $089210a68d073055$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $089210a68d073055$export$291166950901964 = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $2eeCH.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.GetIdentityPoolRoles"
            };
            body = JSON.stringify($089210a68d073055$var$serializeAws_json1_1GetIdentityPoolRolesInput(input, context));
            return [
                2 /*return*/ ,
                $089210a68d073055$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $089210a68d073055$export$32ecbc22cb6e2bd8 = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $2eeCH.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.GetOpenIdToken"
            };
            body = JSON.stringify($089210a68d073055$var$serializeAws_json1_1GetOpenIdTokenInput(input, context));
            return [
                2 /*return*/ ,
                $089210a68d073055$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $089210a68d073055$export$ace1f9f6edceb0aa = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $2eeCH.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.GetOpenIdTokenForDeveloperIdentity"
            };
            body = JSON.stringify($089210a68d073055$var$serializeAws_json1_1GetOpenIdTokenForDeveloperIdentityInput(input, context));
            return [
                2 /*return*/ ,
                $089210a68d073055$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $089210a68d073055$export$dcc2b10f333c963c = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $2eeCH.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.ListIdentities"
            };
            body = JSON.stringify($089210a68d073055$var$serializeAws_json1_1ListIdentitiesInput(input, context));
            return [
                2 /*return*/ ,
                $089210a68d073055$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $089210a68d073055$export$dfc0836148ba7f7b = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $2eeCH.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.ListIdentityPools"
            };
            body = JSON.stringify($089210a68d073055$var$serializeAws_json1_1ListIdentityPoolsInput(input, context));
            return [
                2 /*return*/ ,
                $089210a68d073055$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $089210a68d073055$export$aea8c8426f72de9a = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $2eeCH.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.ListTagsForResource"
            };
            body = JSON.stringify($089210a68d073055$var$serializeAws_json1_1ListTagsForResourceInput(input, context));
            return [
                2 /*return*/ ,
                $089210a68d073055$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $089210a68d073055$export$3ddf979554ffe001 = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $2eeCH.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.LookupDeveloperIdentity"
            };
            body = JSON.stringify($089210a68d073055$var$serializeAws_json1_1LookupDeveloperIdentityInput(input, context));
            return [
                2 /*return*/ ,
                $089210a68d073055$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $089210a68d073055$export$5d3f7522269fe239 = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $2eeCH.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.MergeDeveloperIdentities"
            };
            body = JSON.stringify($089210a68d073055$var$serializeAws_json1_1MergeDeveloperIdentitiesInput(input, context));
            return [
                2 /*return*/ ,
                $089210a68d073055$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $089210a68d073055$export$50298d3eb327ab40 = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $2eeCH.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.SetIdentityPoolRoles"
            };
            body = JSON.stringify($089210a68d073055$var$serializeAws_json1_1SetIdentityPoolRolesInput(input, context));
            return [
                2 /*return*/ ,
                $089210a68d073055$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $089210a68d073055$export$be03555111349623 = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $2eeCH.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.TagResource"
            };
            body = JSON.stringify($089210a68d073055$var$serializeAws_json1_1TagResourceInput(input, context));
            return [
                2 /*return*/ ,
                $089210a68d073055$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $089210a68d073055$export$43e326e2b54f124a = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $2eeCH.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.UnlinkDeveloperIdentity"
            };
            body = JSON.stringify($089210a68d073055$var$serializeAws_json1_1UnlinkDeveloperIdentityInput(input, context));
            return [
                2 /*return*/ ,
                $089210a68d073055$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $089210a68d073055$export$4ee03f1a7a9d5800 = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $2eeCH.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.UnlinkIdentity"
            };
            body = JSON.stringify($089210a68d073055$var$serializeAws_json1_1UnlinkIdentityInput(input, context));
            return [
                2 /*return*/ ,
                $089210a68d073055$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $089210a68d073055$export$3f5f89d1d8515037 = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $2eeCH.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.UntagResource"
            };
            body = JSON.stringify($089210a68d073055$var$serializeAws_json1_1UntagResourceInput(input, context));
            return [
                2 /*return*/ ,
                $089210a68d073055$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $089210a68d073055$export$7a962066e209647 = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $2eeCH.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "AWSCognitoIdentityService.UpdateIdentityPool"
            };
            body = JSON.stringify($089210a68d073055$var$serializeAws_json1_1IdentityPool(input, context));
            return [
                2 /*return*/ ,
                $089210a68d073055$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $089210a68d073055$export$2065e670c73ee068 = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1CreateIdentityPoolCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $089210a68d073055$var$deserializeAws_json1_1IdentityPool(data, context);
                    response = (0, $2eeCH.__assign)({
                        $metadata: $089210a68d073055$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $089210a68d073055$var$deserializeAws_json1_1CreateIdentityPoolCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, parsedBody, message;
        var _j;
        return (0, $2eeCH.__generator)(this, function(_k) {
            switch(_k.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _j = {};
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_j.body = _k.sent(), _j)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $089210a68d073055$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        14
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _c.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _d.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _e.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _f.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _g.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _h.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 14:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $089210a68d073055$var$deserializeMetadata(output)
                    });
                    _k.label = 15;
                case 15:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $089210a68d073055$export$a14663734e0f26e7 = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1DeleteIdentitiesCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $089210a68d073055$var$deserializeAws_json1_1DeleteIdentitiesResponse(data, context);
                    response = (0, $2eeCH.__assign)({
                        $metadata: $089210a68d073055$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $089210a68d073055$var$deserializeAws_json1_1DeleteIdentitiesCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
        var _f;
        return (0, $2eeCH.__generator)(this, function(_g) {
            switch(_g.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _f = {};
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_f.body = _g.sent(), _f)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $089210a68d073055$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _c.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _d.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _e.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $089210a68d073055$var$deserializeMetadata(output)
                    });
                    _g.label = 9;
                case 9:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $089210a68d073055$export$77baf36526f7cd7e = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1DeleteIdentityPoolCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: $089210a68d073055$var$deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $089210a68d073055$var$deserializeAws_json1_1DeleteIdentityPoolCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, $2eeCH.__generator)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _h = {};
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $089210a68d073055$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $089210a68d073055$var$deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $089210a68d073055$export$1863cd4cff27fb2f = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1DescribeIdentityCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $089210a68d073055$var$deserializeAws_json1_1IdentityDescription(data, context);
                    response = (0, $2eeCH.__assign)({
                        $metadata: $089210a68d073055$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $089210a68d073055$var$deserializeAws_json1_1DescribeIdentityCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, $2eeCH.__generator)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _h = {};
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $089210a68d073055$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $089210a68d073055$var$deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $089210a68d073055$export$1457f79b69c648d1 = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1DescribeIdentityPoolCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $089210a68d073055$var$deserializeAws_json1_1IdentityPool(data, context);
                    response = (0, $2eeCH.__assign)({
                        $metadata: $089210a68d073055$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $089210a68d073055$var$deserializeAws_json1_1DescribeIdentityPoolCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, $2eeCH.__generator)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _h = {};
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $089210a68d073055$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $089210a68d073055$var$deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $089210a68d073055$export$ebea9103431f9a50 = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1GetCredentialsForIdentityCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $089210a68d073055$var$deserializeAws_json1_1GetCredentialsForIdentityResponse(data, context);
                    response = (0, $2eeCH.__assign)({
                        $metadata: $089210a68d073055$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $089210a68d073055$var$deserializeAws_json1_1GetCredentialsForIdentityCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, _j, _k, parsedBody, message;
        var _l;
        return (0, $2eeCH.__generator)(this, function(_m) {
            switch(_m.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _l = {};
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_l.body = _m.sent(), _l)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $089210a68d073055$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "ExternalServiceException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#ExternalServiceException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "InvalidIdentityPoolConfigurationException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidIdentityPoolConfigurationException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                16
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                16
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        18
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1ExternalServiceExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _c.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _d.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1InvalidIdentityPoolConfigurationExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _e.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _f.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _g.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _h.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 14:
                    _j = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _j.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 16:
                    _k = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 17:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _k.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 18:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $089210a68d073055$var$deserializeMetadata(output)
                    });
                    _m.label = 19;
                case 19:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $089210a68d073055$export$9f5769abdc93f0b4 = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1GetIdCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $089210a68d073055$var$deserializeAws_json1_1GetIdResponse(data, context);
                    response = (0, $2eeCH.__assign)({
                        $metadata: $089210a68d073055$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $089210a68d073055$var$deserializeAws_json1_1GetIdCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, _j, _k, parsedBody, message;
        var _l;
        return (0, $2eeCH.__generator)(this, function(_m) {
            switch(_m.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _l = {};
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_l.body = _m.sent(), _l)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $089210a68d073055$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "ExternalServiceException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#ExternalServiceException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                16
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                16
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        18
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1ExternalServiceExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _c.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _d.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _e.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _f.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _g.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _h.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 14:
                    _j = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _j.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 16:
                    _k = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 17:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _k.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 18:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $089210a68d073055$var$deserializeMetadata(output)
                    });
                    _m.label = 19;
                case 19:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $089210a68d073055$export$731e618e28a38bab = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1GetIdentityPoolRolesCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $089210a68d073055$var$deserializeAws_json1_1GetIdentityPoolRolesResponse(data, context);
                    response = (0, $2eeCH.__assign)({
                        $metadata: $089210a68d073055$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $089210a68d073055$var$deserializeAws_json1_1GetIdentityPoolRolesCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, parsedBody, message;
        var _j;
        return (0, $2eeCH.__generator)(this, function(_k) {
            switch(_k.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _j = {};
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_j.body = _k.sent(), _j)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $089210a68d073055$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        14
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _c.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _d.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _e.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _f.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _g.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _h.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 14:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $089210a68d073055$var$deserializeMetadata(output)
                    });
                    _k.label = 15;
                case 15:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $089210a68d073055$export$ccfef68aa75a7c47 = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1GetOpenIdTokenCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $089210a68d073055$var$deserializeAws_json1_1GetOpenIdTokenResponse(data, context);
                    response = (0, $2eeCH.__assign)({
                        $metadata: $089210a68d073055$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $089210a68d073055$var$deserializeAws_json1_1GetOpenIdTokenCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
        var _k;
        return (0, $2eeCH.__generator)(this, function(_l) {
            switch(_l.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _k = {};
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_k.body = _l.sent(), _k)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $089210a68d073055$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "ExternalServiceException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#ExternalServiceException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        16
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1ExternalServiceExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _c.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _d.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _e.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _f.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _g.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _h.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 14:
                    _j = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _j.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 16:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $089210a68d073055$var$deserializeMetadata(output)
                    });
                    _l.label = 17;
                case 17:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $089210a68d073055$export$c7916ef0d543f5e3 = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1GetOpenIdTokenForDeveloperIdentityCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $089210a68d073055$var$deserializeAws_json1_1GetOpenIdTokenForDeveloperIdentityResponse(data, context);
                    response = (0, $2eeCH.__assign)({
                        $metadata: $089210a68d073055$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $089210a68d073055$var$deserializeAws_json1_1GetOpenIdTokenForDeveloperIdentityCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
        var _k;
        return (0, $2eeCH.__generator)(this, function(_l) {
            switch(_l.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _k = {};
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_k.body = _l.sent(), _k)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $089210a68d073055$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "DeveloperUserAlreadyRegisteredException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#DeveloperUserAlreadyRegisteredException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        16
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1DeveloperUserAlreadyRegisteredExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _c.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _d.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _e.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _f.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _g.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _h.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 14:
                    _j = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _j.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 16:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $089210a68d073055$var$deserializeMetadata(output)
                    });
                    _l.label = 17;
                case 17:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $089210a68d073055$export$a2439911ac8089ba = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1ListIdentitiesCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $089210a68d073055$var$deserializeAws_json1_1ListIdentitiesResponse(data, context);
                    response = (0, $2eeCH.__assign)({
                        $metadata: $089210a68d073055$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $089210a68d073055$var$deserializeAws_json1_1ListIdentitiesCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, $2eeCH.__generator)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _h = {};
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $089210a68d073055$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $089210a68d073055$var$deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $089210a68d073055$export$36b32c966a7eefbd = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1ListIdentityPoolsCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $089210a68d073055$var$deserializeAws_json1_1ListIdentityPoolsResponse(data, context);
                    response = (0, $2eeCH.__assign)({
                        $metadata: $089210a68d073055$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $089210a68d073055$var$deserializeAws_json1_1ListIdentityPoolsCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, $2eeCH.__generator)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _h = {};
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $089210a68d073055$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $089210a68d073055$var$deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $089210a68d073055$export$efb57976dadbc12b = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1ListTagsForResourceCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $089210a68d073055$var$deserializeAws_json1_1ListTagsForResourceResponse(data, context);
                    response = (0, $2eeCH.__assign)({
                        $metadata: $089210a68d073055$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $089210a68d073055$var$deserializeAws_json1_1ListTagsForResourceCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, $2eeCH.__generator)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _h = {};
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $089210a68d073055$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $089210a68d073055$var$deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $089210a68d073055$export$6476ab94d95217ab = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1LookupDeveloperIdentityCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $089210a68d073055$var$deserializeAws_json1_1LookupDeveloperIdentityResponse(data, context);
                    response = (0, $2eeCH.__assign)({
                        $metadata: $089210a68d073055$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $089210a68d073055$var$deserializeAws_json1_1LookupDeveloperIdentityCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, parsedBody, message;
        var _j;
        return (0, $2eeCH.__generator)(this, function(_k) {
            switch(_k.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _j = {};
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_j.body = _k.sent(), _j)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $089210a68d073055$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        14
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _c.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _d.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _e.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _f.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _g.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _h.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 14:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $089210a68d073055$var$deserializeMetadata(output)
                    });
                    _k.label = 15;
                case 15:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $089210a68d073055$export$73edba62ad60e9b9 = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1MergeDeveloperIdentitiesCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $089210a68d073055$var$deserializeAws_json1_1MergeDeveloperIdentitiesResponse(data, context);
                    response = (0, $2eeCH.__assign)({
                        $metadata: $089210a68d073055$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $089210a68d073055$var$deserializeAws_json1_1MergeDeveloperIdentitiesCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, parsedBody, message;
        var _j;
        return (0, $2eeCH.__generator)(this, function(_k) {
            switch(_k.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _j = {};
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_j.body = _k.sent(), _j)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $089210a68d073055$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        14
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _c.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _d.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _e.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _f.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _g.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _h.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 14:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $089210a68d073055$var$deserializeMetadata(output)
                    });
                    _k.label = 15;
                case 15:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $089210a68d073055$export$4d01436d85148f27 = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1SetIdentityPoolRolesCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: $089210a68d073055$var$deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $089210a68d073055$var$deserializeAws_json1_1SetIdentityPoolRolesCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
        var _k;
        return (0, $2eeCH.__generator)(this, function(_l) {
            switch(_l.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _k = {};
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_k.body = _l.sent(), _k)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $089210a68d073055$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "ConcurrentModificationException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#ConcurrentModificationException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        16
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1ConcurrentModificationExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _c.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _d.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _e.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _f.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _g.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _h.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 14:
                    _j = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _j.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 16:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $089210a68d073055$var$deserializeMetadata(output)
                    });
                    _l.label = 17;
                case 17:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $089210a68d073055$export$2bbf6fe70d6779a6 = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1TagResourceCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $089210a68d073055$var$deserializeAws_json1_1TagResourceResponse(data, context);
                    response = (0, $2eeCH.__assign)({
                        $metadata: $089210a68d073055$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $089210a68d073055$var$deserializeAws_json1_1TagResourceCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, $2eeCH.__generator)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _h = {};
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $089210a68d073055$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $089210a68d073055$var$deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $089210a68d073055$export$d8ee329529310a85 = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1UnlinkDeveloperIdentityCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: $089210a68d073055$var$deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $089210a68d073055$var$deserializeAws_json1_1UnlinkDeveloperIdentityCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, parsedBody, message;
        var _j;
        return (0, $2eeCH.__generator)(this, function(_k) {
            switch(_k.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _j = {};
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_j.body = _k.sent(), _j)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $089210a68d073055$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        14
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _c.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _d.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _e.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _f.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _g.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _h.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 14:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $089210a68d073055$var$deserializeMetadata(output)
                    });
                    _k.label = 15;
                case 15:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $089210a68d073055$export$b3b4038b9cc6cf0c = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1UnlinkIdentityCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: $089210a68d073055$var$deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $089210a68d073055$var$deserializeAws_json1_1UnlinkIdentityCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
        var _k;
        return (0, $2eeCH.__generator)(this, function(_l) {
            switch(_l.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _k = {};
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_k.body = _l.sent(), _k)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $089210a68d073055$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "ExternalServiceException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#ExternalServiceException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        16
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1ExternalServiceExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _c.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _d.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _e.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _f.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _g.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _h.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 14:
                    _j = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _j.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 16:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $089210a68d073055$var$deserializeMetadata(output)
                    });
                    _l.label = 17;
                case 17:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $089210a68d073055$export$4e56caf614610ee8 = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1UntagResourceCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $089210a68d073055$var$deserializeAws_json1_1UntagResourceResponse(data, context);
                    response = (0, $2eeCH.__assign)({
                        $metadata: $089210a68d073055$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $089210a68d073055$var$deserializeAws_json1_1UntagResourceCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, $2eeCH.__generator)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _h = {};
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $089210a68d073055$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $089210a68d073055$var$deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $089210a68d073055$export$e9cc2af0cb85eeaa = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1UpdateIdentityPoolCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $089210a68d073055$var$deserializeAws_json1_1IdentityPool(data, context);
                    response = (0, $2eeCH.__assign)({
                        $metadata: $089210a68d073055$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $089210a68d073055$var$deserializeAws_json1_1UpdateIdentityPoolCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, _j, _k, parsedBody, message;
        var _l;
        return (0, $2eeCH.__generator)(this, function(_m) {
            switch(_m.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _l = {};
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_l.body = _m.sent(), _l)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $089210a68d073055$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "ConcurrentModificationException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#ConcurrentModificationException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                16
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                16
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        18
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1ConcurrentModificationExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _c.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _d.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _e.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _f.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _g.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _h.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 14:
                    _j = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _j.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 16:
                    _k = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $089210a68d073055$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 17:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _k.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $089210a68d073055$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 18:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $089210a68d073055$var$deserializeMetadata(output)
                    });
                    _m.label = 19;
                case 19:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $089210a68d073055$var$deserializeAws_json1_1ConcurrentModificationExceptionResponse = function(parsedOutput, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, $2eeCH.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $089210a68d073055$var$deserializeAws_json1_1ConcurrentModificationException(body, context);
            contents = (0, $2eeCH.__assign)({
                name: "ConcurrentModificationException",
                $fault: "client",
                $metadata: $089210a68d073055$var$deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $089210a68d073055$var$deserializeAws_json1_1DeveloperUserAlreadyRegisteredExceptionResponse = function(parsedOutput, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, $2eeCH.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $089210a68d073055$var$deserializeAws_json1_1DeveloperUserAlreadyRegisteredException(body, context);
            contents = (0, $2eeCH.__assign)({
                name: "DeveloperUserAlreadyRegisteredException",
                $fault: "client",
                $metadata: $089210a68d073055$var$deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $089210a68d073055$var$deserializeAws_json1_1ExternalServiceExceptionResponse = function(parsedOutput, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, $2eeCH.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $089210a68d073055$var$deserializeAws_json1_1ExternalServiceException(body, context);
            contents = (0, $2eeCH.__assign)({
                name: "ExternalServiceException",
                $fault: "client",
                $metadata: $089210a68d073055$var$deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $089210a68d073055$var$deserializeAws_json1_1InternalErrorExceptionResponse = function(parsedOutput, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, $2eeCH.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $089210a68d073055$var$deserializeAws_json1_1InternalErrorException(body, context);
            contents = (0, $2eeCH.__assign)({
                name: "InternalErrorException",
                $fault: "server",
                $metadata: $089210a68d073055$var$deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $089210a68d073055$var$deserializeAws_json1_1InvalidIdentityPoolConfigurationExceptionResponse = function(parsedOutput, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, $2eeCH.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $089210a68d073055$var$deserializeAws_json1_1InvalidIdentityPoolConfigurationException(body, context);
            contents = (0, $2eeCH.__assign)({
                name: "InvalidIdentityPoolConfigurationException",
                $fault: "client",
                $metadata: $089210a68d073055$var$deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $089210a68d073055$var$deserializeAws_json1_1InvalidParameterExceptionResponse = function(parsedOutput, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, $2eeCH.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $089210a68d073055$var$deserializeAws_json1_1InvalidParameterException(body, context);
            contents = (0, $2eeCH.__assign)({
                name: "InvalidParameterException",
                $fault: "client",
                $metadata: $089210a68d073055$var$deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $089210a68d073055$var$deserializeAws_json1_1LimitExceededExceptionResponse = function(parsedOutput, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, $2eeCH.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $089210a68d073055$var$deserializeAws_json1_1LimitExceededException(body, context);
            contents = (0, $2eeCH.__assign)({
                name: "LimitExceededException",
                $fault: "client",
                $metadata: $089210a68d073055$var$deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $089210a68d073055$var$deserializeAws_json1_1NotAuthorizedExceptionResponse = function(parsedOutput, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, $2eeCH.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $089210a68d073055$var$deserializeAws_json1_1NotAuthorizedException(body, context);
            contents = (0, $2eeCH.__assign)({
                name: "NotAuthorizedException",
                $fault: "client",
                $metadata: $089210a68d073055$var$deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $089210a68d073055$var$deserializeAws_json1_1ResourceConflictExceptionResponse = function(parsedOutput, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, $2eeCH.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $089210a68d073055$var$deserializeAws_json1_1ResourceConflictException(body, context);
            contents = (0, $2eeCH.__assign)({
                name: "ResourceConflictException",
                $fault: "client",
                $metadata: $089210a68d073055$var$deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $089210a68d073055$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse = function(parsedOutput, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, $2eeCH.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $089210a68d073055$var$deserializeAws_json1_1ResourceNotFoundException(body, context);
            contents = (0, $2eeCH.__assign)({
                name: "ResourceNotFoundException",
                $fault: "client",
                $metadata: $089210a68d073055$var$deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $089210a68d073055$var$deserializeAws_json1_1TooManyRequestsExceptionResponse = function(parsedOutput, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, $2eeCH.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $089210a68d073055$var$deserializeAws_json1_1TooManyRequestsException(body, context);
            contents = (0, $2eeCH.__assign)({
                name: "TooManyRequestsException",
                $fault: "client",
                $metadata: $089210a68d073055$var$deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $089210a68d073055$var$serializeAws_json1_1CognitoIdentityProvider = function(input, context) {
    return (0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, input.ClientId !== undefined && input.ClientId !== null && {
        ClientId: input.ClientId
    }), input.ProviderName !== undefined && input.ProviderName !== null && {
        ProviderName: input.ProviderName
    }), input.ServerSideTokenCheck !== undefined && input.ServerSideTokenCheck !== null && {
        ServerSideTokenCheck: input.ServerSideTokenCheck
    });
};
var $089210a68d073055$var$serializeAws_json1_1CognitoIdentityProviderList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $089210a68d073055$var$serializeAws_json1_1CognitoIdentityProvider(entry, context);
    });
};
var $089210a68d073055$var$serializeAws_json1_1CreateIdentityPoolInput = function(input, context) {
    return (0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, input.AllowClassicFlow !== undefined && input.AllowClassicFlow !== null && {
        AllowClassicFlow: input.AllowClassicFlow
    }), input.AllowUnauthenticatedIdentities !== undefined && input.AllowUnauthenticatedIdentities !== null && {
        AllowUnauthenticatedIdentities: input.AllowUnauthenticatedIdentities
    }), input.CognitoIdentityProviders !== undefined && input.CognitoIdentityProviders !== null && {
        CognitoIdentityProviders: $089210a68d073055$var$serializeAws_json1_1CognitoIdentityProviderList(input.CognitoIdentityProviders, context)
    }), input.DeveloperProviderName !== undefined && input.DeveloperProviderName !== null && {
        DeveloperProviderName: input.DeveloperProviderName
    }), input.IdentityPoolName !== undefined && input.IdentityPoolName !== null && {
        IdentityPoolName: input.IdentityPoolName
    }), input.IdentityPoolTags !== undefined && input.IdentityPoolTags !== null && {
        IdentityPoolTags: $089210a68d073055$var$serializeAws_json1_1IdentityPoolTagsType(input.IdentityPoolTags, context)
    }), input.OpenIdConnectProviderARNs !== undefined && input.OpenIdConnectProviderARNs !== null && {
        OpenIdConnectProviderARNs: $089210a68d073055$var$serializeAws_json1_1OIDCProviderList(input.OpenIdConnectProviderARNs, context)
    }), input.SamlProviderARNs !== undefined && input.SamlProviderARNs !== null && {
        SamlProviderARNs: $089210a68d073055$var$serializeAws_json1_1SAMLProviderList(input.SamlProviderARNs, context)
    }), input.SupportedLoginProviders !== undefined && input.SupportedLoginProviders !== null && {
        SupportedLoginProviders: $089210a68d073055$var$serializeAws_json1_1IdentityProviders(input.SupportedLoginProviders, context)
    });
};
var $089210a68d073055$var$serializeAws_json1_1DeleteIdentitiesInput = function(input, context) {
    return (0, $2eeCH.__assign)({}, input.IdentityIdsToDelete !== undefined && input.IdentityIdsToDelete !== null && {
        IdentityIdsToDelete: $089210a68d073055$var$serializeAws_json1_1IdentityIdList(input.IdentityIdsToDelete, context)
    });
};
var $089210a68d073055$var$serializeAws_json1_1DeleteIdentityPoolInput = function(input, context) {
    return (0, $2eeCH.__assign)({}, input.IdentityPoolId !== undefined && input.IdentityPoolId !== null && {
        IdentityPoolId: input.IdentityPoolId
    });
};
var $089210a68d073055$var$serializeAws_json1_1DescribeIdentityInput = function(input, context) {
    return (0, $2eeCH.__assign)({}, input.IdentityId !== undefined && input.IdentityId !== null && {
        IdentityId: input.IdentityId
    });
};
var $089210a68d073055$var$serializeAws_json1_1DescribeIdentityPoolInput = function(input, context) {
    return (0, $2eeCH.__assign)({}, input.IdentityPoolId !== undefined && input.IdentityPoolId !== null && {
        IdentityPoolId: input.IdentityPoolId
    });
};
var $089210a68d073055$var$serializeAws_json1_1GetCredentialsForIdentityInput = function(input, context) {
    return (0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, input.CustomRoleArn !== undefined && input.CustomRoleArn !== null && {
        CustomRoleArn: input.CustomRoleArn
    }), input.IdentityId !== undefined && input.IdentityId !== null && {
        IdentityId: input.IdentityId
    }), input.Logins !== undefined && input.Logins !== null && {
        Logins: $089210a68d073055$var$serializeAws_json1_1LoginsMap(input.Logins, context)
    });
};
var $089210a68d073055$var$serializeAws_json1_1GetIdentityPoolRolesInput = function(input, context) {
    return (0, $2eeCH.__assign)({}, input.IdentityPoolId !== undefined && input.IdentityPoolId !== null && {
        IdentityPoolId: input.IdentityPoolId
    });
};
var $089210a68d073055$var$serializeAws_json1_1GetIdInput = function(input, context) {
    return (0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, input.AccountId !== undefined && input.AccountId !== null && {
        AccountId: input.AccountId
    }), input.IdentityPoolId !== undefined && input.IdentityPoolId !== null && {
        IdentityPoolId: input.IdentityPoolId
    }), input.Logins !== undefined && input.Logins !== null && {
        Logins: $089210a68d073055$var$serializeAws_json1_1LoginsMap(input.Logins, context)
    });
};
var $089210a68d073055$var$serializeAws_json1_1GetOpenIdTokenForDeveloperIdentityInput = function(input, context) {
    return (0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, input.IdentityId !== undefined && input.IdentityId !== null && {
        IdentityId: input.IdentityId
    }), input.IdentityPoolId !== undefined && input.IdentityPoolId !== null && {
        IdentityPoolId: input.IdentityPoolId
    }), input.Logins !== undefined && input.Logins !== null && {
        Logins: $089210a68d073055$var$serializeAws_json1_1LoginsMap(input.Logins, context)
    }), input.TokenDuration !== undefined && input.TokenDuration !== null && {
        TokenDuration: input.TokenDuration
    });
};
var $089210a68d073055$var$serializeAws_json1_1GetOpenIdTokenInput = function(input, context) {
    return (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, input.IdentityId !== undefined && input.IdentityId !== null && {
        IdentityId: input.IdentityId
    }), input.Logins !== undefined && input.Logins !== null && {
        Logins: $089210a68d073055$var$serializeAws_json1_1LoginsMap(input.Logins, context)
    });
};
var $089210a68d073055$var$serializeAws_json1_1IdentityIdList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var $089210a68d073055$var$serializeAws_json1_1IdentityPool = function(input, context) {
    return (0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, input.AllowClassicFlow !== undefined && input.AllowClassicFlow !== null && {
        AllowClassicFlow: input.AllowClassicFlow
    }), input.AllowUnauthenticatedIdentities !== undefined && input.AllowUnauthenticatedIdentities !== null && {
        AllowUnauthenticatedIdentities: input.AllowUnauthenticatedIdentities
    }), input.CognitoIdentityProviders !== undefined && input.CognitoIdentityProviders !== null && {
        CognitoIdentityProviders: $089210a68d073055$var$serializeAws_json1_1CognitoIdentityProviderList(input.CognitoIdentityProviders, context)
    }), input.DeveloperProviderName !== undefined && input.DeveloperProviderName !== null && {
        DeveloperProviderName: input.DeveloperProviderName
    }), input.IdentityPoolId !== undefined && input.IdentityPoolId !== null && {
        IdentityPoolId: input.IdentityPoolId
    }), input.IdentityPoolName !== undefined && input.IdentityPoolName !== null && {
        IdentityPoolName: input.IdentityPoolName
    }), input.IdentityPoolTags !== undefined && input.IdentityPoolTags !== null && {
        IdentityPoolTags: $089210a68d073055$var$serializeAws_json1_1IdentityPoolTagsType(input.IdentityPoolTags, context)
    }), input.OpenIdConnectProviderARNs !== undefined && input.OpenIdConnectProviderARNs !== null && {
        OpenIdConnectProviderARNs: $089210a68d073055$var$serializeAws_json1_1OIDCProviderList(input.OpenIdConnectProviderARNs, context)
    }), input.SamlProviderARNs !== undefined && input.SamlProviderARNs !== null && {
        SamlProviderARNs: $089210a68d073055$var$serializeAws_json1_1SAMLProviderList(input.SamlProviderARNs, context)
    }), input.SupportedLoginProviders !== undefined && input.SupportedLoginProviders !== null && {
        SupportedLoginProviders: $089210a68d073055$var$serializeAws_json1_1IdentityProviders(input.SupportedLoginProviders, context)
    });
};
var $089210a68d073055$var$serializeAws_json1_1IdentityPoolTagsListType = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var $089210a68d073055$var$serializeAws_json1_1IdentityPoolTagsType = function(input, context) {
    return Object.entries(input).reduce(function(acc, _a) {
        var _b;
        var _c = (0, $2eeCH.__read)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var $089210a68d073055$var$serializeAws_json1_1IdentityProviders = function(input, context) {
    return Object.entries(input).reduce(function(acc, _a) {
        var _b;
        var _c = (0, $2eeCH.__read)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var $089210a68d073055$var$serializeAws_json1_1ListIdentitiesInput = function(input, context) {
    return (0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, input.HideDisabled !== undefined && input.HideDisabled !== null && {
        HideDisabled: input.HideDisabled
    }), input.IdentityPoolId !== undefined && input.IdentityPoolId !== null && {
        IdentityPoolId: input.IdentityPoolId
    }), input.MaxResults !== undefined && input.MaxResults !== null && {
        MaxResults: input.MaxResults
    }), input.NextToken !== undefined && input.NextToken !== null && {
        NextToken: input.NextToken
    });
};
var $089210a68d073055$var$serializeAws_json1_1ListIdentityPoolsInput = function(input, context) {
    return (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, input.MaxResults !== undefined && input.MaxResults !== null && {
        MaxResults: input.MaxResults
    }), input.NextToken !== undefined && input.NextToken !== null && {
        NextToken: input.NextToken
    });
};
var $089210a68d073055$var$serializeAws_json1_1ListTagsForResourceInput = function(input, context) {
    return (0, $2eeCH.__assign)({}, input.ResourceArn !== undefined && input.ResourceArn !== null && {
        ResourceArn: input.ResourceArn
    });
};
var $089210a68d073055$var$serializeAws_json1_1LoginsList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var $089210a68d073055$var$serializeAws_json1_1LoginsMap = function(input, context) {
    return Object.entries(input).reduce(function(acc, _a) {
        var _b;
        var _c = (0, $2eeCH.__read)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var $089210a68d073055$var$serializeAws_json1_1LookupDeveloperIdentityInput = function(input, context) {
    return (0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, input.DeveloperUserIdentifier !== undefined && input.DeveloperUserIdentifier !== null && {
        DeveloperUserIdentifier: input.DeveloperUserIdentifier
    }), input.IdentityId !== undefined && input.IdentityId !== null && {
        IdentityId: input.IdentityId
    }), input.IdentityPoolId !== undefined && input.IdentityPoolId !== null && {
        IdentityPoolId: input.IdentityPoolId
    }), input.MaxResults !== undefined && input.MaxResults !== null && {
        MaxResults: input.MaxResults
    }), input.NextToken !== undefined && input.NextToken !== null && {
        NextToken: input.NextToken
    });
};
var $089210a68d073055$var$serializeAws_json1_1MappingRule = function(input, context) {
    return (0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, input.Claim !== undefined && input.Claim !== null && {
        Claim: input.Claim
    }), input.MatchType !== undefined && input.MatchType !== null && {
        MatchType: input.MatchType
    }), input.RoleARN !== undefined && input.RoleARN !== null && {
        RoleARN: input.RoleARN
    }), input.Value !== undefined && input.Value !== null && {
        Value: input.Value
    });
};
var $089210a68d073055$var$serializeAws_json1_1MappingRulesList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $089210a68d073055$var$serializeAws_json1_1MappingRule(entry, context);
    });
};
var $089210a68d073055$var$serializeAws_json1_1MergeDeveloperIdentitiesInput = function(input, context) {
    return (0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, input.DestinationUserIdentifier !== undefined && input.DestinationUserIdentifier !== null && {
        DestinationUserIdentifier: input.DestinationUserIdentifier
    }), input.DeveloperProviderName !== undefined && input.DeveloperProviderName !== null && {
        DeveloperProviderName: input.DeveloperProviderName
    }), input.IdentityPoolId !== undefined && input.IdentityPoolId !== null && {
        IdentityPoolId: input.IdentityPoolId
    }), input.SourceUserIdentifier !== undefined && input.SourceUserIdentifier !== null && {
        SourceUserIdentifier: input.SourceUserIdentifier
    });
};
var $089210a68d073055$var$serializeAws_json1_1OIDCProviderList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var $089210a68d073055$var$serializeAws_json1_1RoleMapping = function(input, context) {
    return (0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, input.AmbiguousRoleResolution !== undefined && input.AmbiguousRoleResolution !== null && {
        AmbiguousRoleResolution: input.AmbiguousRoleResolution
    }), input.RulesConfiguration !== undefined && input.RulesConfiguration !== null && {
        RulesConfiguration: $089210a68d073055$var$serializeAws_json1_1RulesConfigurationType(input.RulesConfiguration, context)
    }), input.Type !== undefined && input.Type !== null && {
        Type: input.Type
    });
};
var $089210a68d073055$var$serializeAws_json1_1RoleMappingMap = function(input, context) {
    return Object.entries(input).reduce(function(acc, _a) {
        var _b;
        var _c = (0, $2eeCH.__read)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, acc), (_b = {}, _b[key] = $089210a68d073055$var$serializeAws_json1_1RoleMapping(value, context), _b));
    }, {});
};
var $089210a68d073055$var$serializeAws_json1_1RolesMap = function(input, context) {
    return Object.entries(input).reduce(function(acc, _a) {
        var _b;
        var _c = (0, $2eeCH.__read)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var $089210a68d073055$var$serializeAws_json1_1RulesConfigurationType = function(input, context) {
    return (0, $2eeCH.__assign)({}, input.Rules !== undefined && input.Rules !== null && {
        Rules: $089210a68d073055$var$serializeAws_json1_1MappingRulesList(input.Rules, context)
    });
};
var $089210a68d073055$var$serializeAws_json1_1SAMLProviderList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var $089210a68d073055$var$serializeAws_json1_1SetIdentityPoolRolesInput = function(input, context) {
    return (0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, input.IdentityPoolId !== undefined && input.IdentityPoolId !== null && {
        IdentityPoolId: input.IdentityPoolId
    }), input.RoleMappings !== undefined && input.RoleMappings !== null && {
        RoleMappings: $089210a68d073055$var$serializeAws_json1_1RoleMappingMap(input.RoleMappings, context)
    }), input.Roles !== undefined && input.Roles !== null && {
        Roles: $089210a68d073055$var$serializeAws_json1_1RolesMap(input.Roles, context)
    });
};
var $089210a68d073055$var$serializeAws_json1_1TagResourceInput = function(input, context) {
    return (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, input.ResourceArn !== undefined && input.ResourceArn !== null && {
        ResourceArn: input.ResourceArn
    }), input.Tags !== undefined && input.Tags !== null && {
        Tags: $089210a68d073055$var$serializeAws_json1_1IdentityPoolTagsType(input.Tags, context)
    });
};
var $089210a68d073055$var$serializeAws_json1_1UnlinkDeveloperIdentityInput = function(input, context) {
    return (0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, input.DeveloperProviderName !== undefined && input.DeveloperProviderName !== null && {
        DeveloperProviderName: input.DeveloperProviderName
    }), input.DeveloperUserIdentifier !== undefined && input.DeveloperUserIdentifier !== null && {
        DeveloperUserIdentifier: input.DeveloperUserIdentifier
    }), input.IdentityId !== undefined && input.IdentityId !== null && {
        IdentityId: input.IdentityId
    }), input.IdentityPoolId !== undefined && input.IdentityPoolId !== null && {
        IdentityPoolId: input.IdentityPoolId
    });
};
var $089210a68d073055$var$serializeAws_json1_1UnlinkIdentityInput = function(input, context) {
    return (0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, input.IdentityId !== undefined && input.IdentityId !== null && {
        IdentityId: input.IdentityId
    }), input.Logins !== undefined && input.Logins !== null && {
        Logins: $089210a68d073055$var$serializeAws_json1_1LoginsMap(input.Logins, context)
    }), input.LoginsToRemove !== undefined && input.LoginsToRemove !== null && {
        LoginsToRemove: $089210a68d073055$var$serializeAws_json1_1LoginsList(input.LoginsToRemove, context)
    });
};
var $089210a68d073055$var$serializeAws_json1_1UntagResourceInput = function(input, context) {
    return (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, input.ResourceArn !== undefined && input.ResourceArn !== null && {
        ResourceArn: input.ResourceArn
    }), input.TagKeys !== undefined && input.TagKeys !== null && {
        TagKeys: $089210a68d073055$var$serializeAws_json1_1IdentityPoolTagsListType(input.TagKeys, context)
    });
};
var $089210a68d073055$var$deserializeAws_json1_1CognitoIdentityProvider = function(output, context) {
    return {
        ClientId: output.ClientId !== undefined && output.ClientId !== null ? output.ClientId : undefined,
        ProviderName: output.ProviderName !== undefined && output.ProviderName !== null ? output.ProviderName : undefined,
        ServerSideTokenCheck: output.ServerSideTokenCheck !== undefined && output.ServerSideTokenCheck !== null ? output.ServerSideTokenCheck : undefined
    };
};
var $089210a68d073055$var$deserializeAws_json1_1CognitoIdentityProviderList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $089210a68d073055$var$deserializeAws_json1_1CognitoIdentityProvider(entry, context);
    });
};
var $089210a68d073055$var$deserializeAws_json1_1ConcurrentModificationException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var $089210a68d073055$var$deserializeAws_json1_1Credentials = function(output, context) {
    return {
        AccessKeyId: output.AccessKeyId !== undefined && output.AccessKeyId !== null ? output.AccessKeyId : undefined,
        Expiration: output.Expiration !== undefined && output.Expiration !== null ? new Date(Math.round(output.Expiration * 1000)) : undefined,
        SecretKey: output.SecretKey !== undefined && output.SecretKey !== null ? output.SecretKey : undefined,
        SessionToken: output.SessionToken !== undefined && output.SessionToken !== null ? output.SessionToken : undefined
    };
};
var $089210a68d073055$var$deserializeAws_json1_1DeleteIdentitiesResponse = function(output, context) {
    return {
        UnprocessedIdentityIds: output.UnprocessedIdentityIds !== undefined && output.UnprocessedIdentityIds !== null ? $089210a68d073055$var$deserializeAws_json1_1UnprocessedIdentityIdList(output.UnprocessedIdentityIds, context) : undefined
    };
};
var $089210a68d073055$var$deserializeAws_json1_1DeveloperUserAlreadyRegisteredException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var $089210a68d073055$var$deserializeAws_json1_1DeveloperUserIdentifierList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var $089210a68d073055$var$deserializeAws_json1_1ExternalServiceException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var $089210a68d073055$var$deserializeAws_json1_1GetCredentialsForIdentityResponse = function(output, context) {
    return {
        Credentials: output.Credentials !== undefined && output.Credentials !== null ? $089210a68d073055$var$deserializeAws_json1_1Credentials(output.Credentials, context) : undefined,
        IdentityId: output.IdentityId !== undefined && output.IdentityId !== null ? output.IdentityId : undefined
    };
};
var $089210a68d073055$var$deserializeAws_json1_1GetIdentityPoolRolesResponse = function(output, context) {
    return {
        IdentityPoolId: output.IdentityPoolId !== undefined && output.IdentityPoolId !== null ? output.IdentityPoolId : undefined,
        RoleMappings: output.RoleMappings !== undefined && output.RoleMappings !== null ? $089210a68d073055$var$deserializeAws_json1_1RoleMappingMap(output.RoleMappings, context) : undefined,
        Roles: output.Roles !== undefined && output.Roles !== null ? $089210a68d073055$var$deserializeAws_json1_1RolesMap(output.Roles, context) : undefined
    };
};
var $089210a68d073055$var$deserializeAws_json1_1GetIdResponse = function(output, context) {
    return {
        IdentityId: output.IdentityId !== undefined && output.IdentityId !== null ? output.IdentityId : undefined
    };
};
var $089210a68d073055$var$deserializeAws_json1_1GetOpenIdTokenForDeveloperIdentityResponse = function(output, context) {
    return {
        IdentityId: output.IdentityId !== undefined && output.IdentityId !== null ? output.IdentityId : undefined,
        Token: output.Token !== undefined && output.Token !== null ? output.Token : undefined
    };
};
var $089210a68d073055$var$deserializeAws_json1_1GetOpenIdTokenResponse = function(output, context) {
    return {
        IdentityId: output.IdentityId !== undefined && output.IdentityId !== null ? output.IdentityId : undefined,
        Token: output.Token !== undefined && output.Token !== null ? output.Token : undefined
    };
};
var $089210a68d073055$var$deserializeAws_json1_1IdentitiesList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $089210a68d073055$var$deserializeAws_json1_1IdentityDescription(entry, context);
    });
};
var $089210a68d073055$var$deserializeAws_json1_1IdentityDescription = function(output, context) {
    return {
        CreationDate: output.CreationDate !== undefined && output.CreationDate !== null ? new Date(Math.round(output.CreationDate * 1000)) : undefined,
        IdentityId: output.IdentityId !== undefined && output.IdentityId !== null ? output.IdentityId : undefined,
        LastModifiedDate: output.LastModifiedDate !== undefined && output.LastModifiedDate !== null ? new Date(Math.round(output.LastModifiedDate * 1000)) : undefined,
        Logins: output.Logins !== undefined && output.Logins !== null ? $089210a68d073055$var$deserializeAws_json1_1LoginsList(output.Logins, context) : undefined
    };
};
var $089210a68d073055$var$deserializeAws_json1_1IdentityPool = function(output, context) {
    return {
        AllowClassicFlow: output.AllowClassicFlow !== undefined && output.AllowClassicFlow !== null ? output.AllowClassicFlow : undefined,
        AllowUnauthenticatedIdentities: output.AllowUnauthenticatedIdentities !== undefined && output.AllowUnauthenticatedIdentities !== null ? output.AllowUnauthenticatedIdentities : undefined,
        CognitoIdentityProviders: output.CognitoIdentityProviders !== undefined && output.CognitoIdentityProviders !== null ? $089210a68d073055$var$deserializeAws_json1_1CognitoIdentityProviderList(output.CognitoIdentityProviders, context) : undefined,
        DeveloperProviderName: output.DeveloperProviderName !== undefined && output.DeveloperProviderName !== null ? output.DeveloperProviderName : undefined,
        IdentityPoolId: output.IdentityPoolId !== undefined && output.IdentityPoolId !== null ? output.IdentityPoolId : undefined,
        IdentityPoolName: output.IdentityPoolName !== undefined && output.IdentityPoolName !== null ? output.IdentityPoolName : undefined,
        IdentityPoolTags: output.IdentityPoolTags !== undefined && output.IdentityPoolTags !== null ? $089210a68d073055$var$deserializeAws_json1_1IdentityPoolTagsType(output.IdentityPoolTags, context) : undefined,
        OpenIdConnectProviderARNs: output.OpenIdConnectProviderARNs !== undefined && output.OpenIdConnectProviderARNs !== null ? $089210a68d073055$var$deserializeAws_json1_1OIDCProviderList(output.OpenIdConnectProviderARNs, context) : undefined,
        SamlProviderARNs: output.SamlProviderARNs !== undefined && output.SamlProviderARNs !== null ? $089210a68d073055$var$deserializeAws_json1_1SAMLProviderList(output.SamlProviderARNs, context) : undefined,
        SupportedLoginProviders: output.SupportedLoginProviders !== undefined && output.SupportedLoginProviders !== null ? $089210a68d073055$var$deserializeAws_json1_1IdentityProviders(output.SupportedLoginProviders, context) : undefined
    };
};
var $089210a68d073055$var$deserializeAws_json1_1IdentityPoolShortDescription = function(output, context) {
    return {
        IdentityPoolId: output.IdentityPoolId !== undefined && output.IdentityPoolId !== null ? output.IdentityPoolId : undefined,
        IdentityPoolName: output.IdentityPoolName !== undefined && output.IdentityPoolName !== null ? output.IdentityPoolName : undefined
    };
};
var $089210a68d073055$var$deserializeAws_json1_1IdentityPoolsList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $089210a68d073055$var$deserializeAws_json1_1IdentityPoolShortDescription(entry, context);
    });
};
var $089210a68d073055$var$deserializeAws_json1_1IdentityPoolTagsType = function(output, context) {
    return Object.entries(output).reduce(function(acc, _a) {
        var _b;
        var _c = (0, $2eeCH.__read)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var $089210a68d073055$var$deserializeAws_json1_1IdentityProviders = function(output, context) {
    return Object.entries(output).reduce(function(acc, _a) {
        var _b;
        var _c = (0, $2eeCH.__read)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var $089210a68d073055$var$deserializeAws_json1_1InternalErrorException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var $089210a68d073055$var$deserializeAws_json1_1InvalidIdentityPoolConfigurationException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var $089210a68d073055$var$deserializeAws_json1_1InvalidParameterException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var $089210a68d073055$var$deserializeAws_json1_1LimitExceededException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var $089210a68d073055$var$deserializeAws_json1_1ListIdentitiesResponse = function(output, context) {
    return {
        Identities: output.Identities !== undefined && output.Identities !== null ? $089210a68d073055$var$deserializeAws_json1_1IdentitiesList(output.Identities, context) : undefined,
        IdentityPoolId: output.IdentityPoolId !== undefined && output.IdentityPoolId !== null ? output.IdentityPoolId : undefined,
        NextToken: output.NextToken !== undefined && output.NextToken !== null ? output.NextToken : undefined
    };
};
var $089210a68d073055$var$deserializeAws_json1_1ListIdentityPoolsResponse = function(output, context) {
    return {
        IdentityPools: output.IdentityPools !== undefined && output.IdentityPools !== null ? $089210a68d073055$var$deserializeAws_json1_1IdentityPoolsList(output.IdentityPools, context) : undefined,
        NextToken: output.NextToken !== undefined && output.NextToken !== null ? output.NextToken : undefined
    };
};
var $089210a68d073055$var$deserializeAws_json1_1ListTagsForResourceResponse = function(output, context) {
    return {
        Tags: output.Tags !== undefined && output.Tags !== null ? $089210a68d073055$var$deserializeAws_json1_1IdentityPoolTagsType(output.Tags, context) : undefined
    };
};
var $089210a68d073055$var$deserializeAws_json1_1LoginsList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var $089210a68d073055$var$deserializeAws_json1_1LookupDeveloperIdentityResponse = function(output, context) {
    return {
        DeveloperUserIdentifierList: output.DeveloperUserIdentifierList !== undefined && output.DeveloperUserIdentifierList !== null ? $089210a68d073055$var$deserializeAws_json1_1DeveloperUserIdentifierList(output.DeveloperUserIdentifierList, context) : undefined,
        IdentityId: output.IdentityId !== undefined && output.IdentityId !== null ? output.IdentityId : undefined,
        NextToken: output.NextToken !== undefined && output.NextToken !== null ? output.NextToken : undefined
    };
};
var $089210a68d073055$var$deserializeAws_json1_1MappingRule = function(output, context) {
    return {
        Claim: output.Claim !== undefined && output.Claim !== null ? output.Claim : undefined,
        MatchType: output.MatchType !== undefined && output.MatchType !== null ? output.MatchType : undefined,
        RoleARN: output.RoleARN !== undefined && output.RoleARN !== null ? output.RoleARN : undefined,
        Value: output.Value !== undefined && output.Value !== null ? output.Value : undefined
    };
};
var $089210a68d073055$var$deserializeAws_json1_1MappingRulesList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $089210a68d073055$var$deserializeAws_json1_1MappingRule(entry, context);
    });
};
var $089210a68d073055$var$deserializeAws_json1_1MergeDeveloperIdentitiesResponse = function(output, context) {
    return {
        IdentityId: output.IdentityId !== undefined && output.IdentityId !== null ? output.IdentityId : undefined
    };
};
var $089210a68d073055$var$deserializeAws_json1_1NotAuthorizedException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var $089210a68d073055$var$deserializeAws_json1_1OIDCProviderList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var $089210a68d073055$var$deserializeAws_json1_1ResourceConflictException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var $089210a68d073055$var$deserializeAws_json1_1ResourceNotFoundException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var $089210a68d073055$var$deserializeAws_json1_1RoleMapping = function(output, context) {
    return {
        AmbiguousRoleResolution: output.AmbiguousRoleResolution !== undefined && output.AmbiguousRoleResolution !== null ? output.AmbiguousRoleResolution : undefined,
        RulesConfiguration: output.RulesConfiguration !== undefined && output.RulesConfiguration !== null ? $089210a68d073055$var$deserializeAws_json1_1RulesConfigurationType(output.RulesConfiguration, context) : undefined,
        Type: output.Type !== undefined && output.Type !== null ? output.Type : undefined
    };
};
var $089210a68d073055$var$deserializeAws_json1_1RoleMappingMap = function(output, context) {
    return Object.entries(output).reduce(function(acc, _a) {
        var _b;
        var _c = (0, $2eeCH.__read)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, acc), (_b = {}, _b[key] = $089210a68d073055$var$deserializeAws_json1_1RoleMapping(value, context), _b));
    }, {});
};
var $089210a68d073055$var$deserializeAws_json1_1RolesMap = function(output, context) {
    return Object.entries(output).reduce(function(acc, _a) {
        var _b;
        var _c = (0, $2eeCH.__read)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var $089210a68d073055$var$deserializeAws_json1_1RulesConfigurationType = function(output, context) {
    return {
        Rules: output.Rules !== undefined && output.Rules !== null ? $089210a68d073055$var$deserializeAws_json1_1MappingRulesList(output.Rules, context) : undefined
    };
};
var $089210a68d073055$var$deserializeAws_json1_1SAMLProviderList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var $089210a68d073055$var$deserializeAws_json1_1TagResourceResponse = function(output, context) {
    return {};
};
var $089210a68d073055$var$deserializeAws_json1_1TooManyRequestsException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var $089210a68d073055$var$deserializeAws_json1_1UnprocessedIdentityId = function(output, context) {
    return {
        ErrorCode: output.ErrorCode !== undefined && output.ErrorCode !== null ? output.ErrorCode : undefined,
        IdentityId: output.IdentityId !== undefined && output.IdentityId !== null ? output.IdentityId : undefined
    };
};
var $089210a68d073055$var$deserializeAws_json1_1UnprocessedIdentityIdList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $089210a68d073055$var$deserializeAws_json1_1UnprocessedIdentityId(entry, context);
    });
};
var $089210a68d073055$var$deserializeAws_json1_1UntagResourceResponse = function(output, context) {
    return {};
};
var $089210a68d073055$var$deserializeMetadata = function(output) {
    var _a;
    return {
        httpStatusCode: output.statusCode,
        requestId: (_a = output.headers["x-amzn-requestid"]) !== null && _a !== void 0 ? _a : output.headers["x-amzn-request-id"],
        extendedRequestId: output.headers["x-amz-id-2"],
        cfId: output.headers["x-amz-cf-id"]
    };
};
// Collect low-level response body stream to Uint8Array.
var $089210a68d073055$var$collectBody = function(streamBody, context) {
    if (streamBody === void 0) streamBody = new Uint8Array();
    if (streamBody instanceof Uint8Array) return Promise.resolve(streamBody);
    return context.streamCollector(streamBody) || Promise.resolve(new Uint8Array());
};
// Encode Uint8Array data into string with utf-8.
var $089210a68d073055$var$collectBodyString = function(streamBody, context) {
    return $089210a68d073055$var$collectBody(streamBody, context).then(function(body) {
        return context.utf8Encoder(body);
    });
};
var $089210a68d073055$var$buildHttpRpcRequest = function(context, headers, path, resolvedHostname, body) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, contents;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    contents = {
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        path: path,
                        headers: headers
                    };
                    if (resolvedHostname !== undefined) contents.hostname = resolvedHostname;
                    if (body !== undefined) contents.body = body;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)(contents)
                    ];
            }
        });
    });
};
var $089210a68d073055$var$parseBody = function(streamBody, context) {
    return $089210a68d073055$var$collectBodyString(streamBody, context).then(function(encoded) {
        if (encoded.length) return JSON.parse(encoded);
        return {};
    });
};
/**
 * Load an error code for the aws.rest-json-1.1 protocol.
 */ var $089210a68d073055$var$loadRestJsonErrorCode = function(output, data) {
    var findKey = function(object, key) {
        return Object.keys(object).find(function(k) {
            return k.toLowerCase() === key.toLowerCase();
        });
    };
    var sanitizeErrorCode = function(rawValue) {
        var cleanValue = rawValue;
        if (cleanValue.indexOf(":") >= 0) cleanValue = cleanValue.split(":")[0];
        if (cleanValue.indexOf("#") >= 0) cleanValue = cleanValue.split("#")[1];
        return cleanValue;
    };
    var headerKey = findKey(output.headers, "x-amzn-errortype");
    if (headerKey !== undefined) return sanitizeErrorCode(output.headers[headerKey]);
    if (data.code !== undefined) return sanitizeErrorCode(data.code);
    if (data["__type"] !== undefined) return sanitizeErrorCode(data["__type"]);
    return "";
};

});
parcelRegister("3uM9B", function(module, exports) {
$parcel$export(module.exports, "HttpResponse", () => (parcelRequire("d4VAq")).HttpResponse);
$parcel$export(module.exports, "HttpRequest", () => (parcelRequire("dlqaT")).HttpRequest);
parcelRequire("d4VAq");
parcelRequire("dlqaT");
parcelRequire("26uqk");
parcelRequire("gFNpi");

});
parcelRegister("d4VAq", function(module, exports) {

$parcel$export(module.exports, "HttpResponse", () => $9858518d962d1410$export$1d94dfe0d9d1f1e7);
var $9858518d962d1410$export$1d94dfe0d9d1f1e7 = /** @class */ function() {
    function HttpResponse(options) {
        this.statusCode = options.statusCode;
        this.headers = options.headers || {};
        this.body = options.body;
    }
    HttpResponse.isInstance = function(response) {
        //determine if response is a valid HttpResponse
        if (!response) return false;
        var resp = response;
        return typeof resp.statusCode === "number" && typeof resp.headers === "object";
    };
    return HttpResponse;
}();

});

parcelRegister("dlqaT", function(module, exports) {

$parcel$export(module.exports, "HttpRequest", () => $9b718a477ee147b6$export$7587955500404ec3);

var $k4xRR = parcelRequire("k4xRR");
var $9b718a477ee147b6$export$7587955500404ec3 = /** @class */ function() {
    function HttpRequest(options) {
        this.method = options.method || "GET";
        this.hostname = options.hostname || "localhost";
        this.port = options.port;
        this.query = options.query || {};
        this.headers = options.headers || {};
        this.body = options.body;
        this.protocol = options.protocol ? options.protocol.substr(-1) !== ":" ? options.protocol + ":" : options.protocol : "https:";
        this.path = options.path ? options.path.charAt(0) !== "/" ? "/" + options.path : options.path : "/";
    }
    HttpRequest.isInstance = function(request) {
        //determine if request is a valid httpRequest
        if (!request) return false;
        var req = request;
        return "method" in req && "protocol" in req && "hostname" in req && "path" in req && typeof req["query"] === "object" && typeof req["headers"] === "object";
    };
    HttpRequest.prototype.clone = function() {
        var cloned = new HttpRequest((0, $k4xRR.__assign)((0, $k4xRR.__assign)({}, this), {
            headers: (0, $k4xRR.__assign)({}, this.headers)
        }));
        if (cloned.query) cloned.query = $9b718a477ee147b6$var$cloneQuery(cloned.query);
        return cloned;
    };
    return HttpRequest;
}();
function $9b718a477ee147b6$var$cloneQuery(query) {
    return Object.keys(query).reduce(function(carry, paramName) {
        var _a;
        var param = query[paramName];
        return (0, $k4xRR.__assign)((0, $k4xRR.__assign)({}, carry), (_a = {}, _a[paramName] = Array.isArray(param) ? (0, $k4xRR.__spread)(param) : param, _a));
    }, {});
}

});
parcelRegister("k4xRR", function(module, exports) {

$parcel$export(module.exports, "__assign", () => $e9ce73ce909484ce$export$18ce0697a983be9b);
$parcel$export(module.exports, "__spread", () => $e9ce73ce909484ce$export$afc72e2116322959);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $e9ce73ce909484ce$var$extendStatics = function(d, b) {
    $e9ce73ce909484ce$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $e9ce73ce909484ce$var$extendStatics(d, b);
};
function $e9ce73ce909484ce$export$a8ba968b8961cb8a(d, b) {
    $e9ce73ce909484ce$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $e9ce73ce909484ce$export$18ce0697a983be9b = function() {
    $e9ce73ce909484ce$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e9ce73ce909484ce$export$18ce0697a983be9b.apply(this, arguments);
};
function $e9ce73ce909484ce$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $e9ce73ce909484ce$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $e9ce73ce909484ce$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $e9ce73ce909484ce$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $e9ce73ce909484ce$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $e9ce73ce909484ce$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $e9ce73ce909484ce$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $e9ce73ce909484ce$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $e9ce73ce909484ce$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $e9ce73ce909484ce$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $e9ce73ce909484ce$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($e9ce73ce909484ce$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $e9ce73ce909484ce$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $e9ce73ce909484ce$export$10c90e4f7922046c(v) {
    return this instanceof $e9ce73ce909484ce$export$10c90e4f7922046c ? (this.v = v, this) : new $e9ce73ce909484ce$export$10c90e4f7922046c(v);
}
function $e9ce73ce909484ce$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $e9ce73ce909484ce$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $e9ce73ce909484ce$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $e9ce73ce909484ce$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $e9ce73ce909484ce$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $e9ce73ce909484ce$export$19a8beecd37a4c45 === "function" ? $e9ce73ce909484ce$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $e9ce73ce909484ce$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $e9ce73ce909484ce$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $e9ce73ce909484ce$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $e9ce73ce909484ce$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $e9ce73ce909484ce$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});


parcelRegister("26uqk", function(module, exports) {

});

parcelRegister("gFNpi", function(module, exports) {
function $c236cce6cf8338d1$export$e024c793399bdd01(hostname) {
    var hostPattern = /^[a-z0-9][a-z0-9\.\-]*[a-z0-9]$/;
    return hostPattern.test(hostname);
}

});



parcelRegister("6ZXPq", function(module, exports) {
$parcel$export(module.exports, "getSerdePlugin", () => (parcelRequire("dQtWs")).getSerdePlugin);
parcelRequire("j7qLt");
parcelRequire("kFmug");
parcelRequire("dQtWs");

});
parcelRegister("j7qLt", function(module, exports) {

$parcel$export(module.exports, "deserializerMiddleware", () => $deb36eb45280d85d$export$d10196e291075f95);

var $h6dQv = parcelRequire("h6dQv");
var $deb36eb45280d85d$export$d10196e291075f95 = function(options, deserializer) {
    return function(next, context) {
        return function(args) {
            return (0, $h6dQv.__awaiter)(void 0, void 0, void 0, function() {
                var response, parsed;
                return (0, $h6dQv.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                next(args)
                            ];
                        case 1:
                            response = _a.sent().response;
                            return [
                                4 /*yield*/ ,
                                deserializer(response, options)
                            ];
                        case 2:
                            parsed = _a.sent();
                            return [
                                2 /*return*/ ,
                                {
                                    response: response,
                                    output: parsed
                                }
                            ];
                    }
                });
            });
        };
    };
};

});
parcelRegister("h6dQv", function(module, exports) {

$parcel$export(module.exports, "__assign", () => $c72dbcb6dc8f4b06$export$18ce0697a983be9b);
$parcel$export(module.exports, "__awaiter", () => $c72dbcb6dc8f4b06$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $c72dbcb6dc8f4b06$export$67ebef60e6f28a6);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $c72dbcb6dc8f4b06$var$extendStatics = function(d, b) {
    $c72dbcb6dc8f4b06$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $c72dbcb6dc8f4b06$var$extendStatics(d, b);
};
function $c72dbcb6dc8f4b06$export$a8ba968b8961cb8a(d, b) {
    $c72dbcb6dc8f4b06$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $c72dbcb6dc8f4b06$export$18ce0697a983be9b = function() {
    $c72dbcb6dc8f4b06$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c72dbcb6dc8f4b06$export$18ce0697a983be9b.apply(this, arguments);
};
function $c72dbcb6dc8f4b06$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $c72dbcb6dc8f4b06$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $c72dbcb6dc8f4b06$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $c72dbcb6dc8f4b06$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $c72dbcb6dc8f4b06$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $c72dbcb6dc8f4b06$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $c72dbcb6dc8f4b06$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $c72dbcb6dc8f4b06$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $c72dbcb6dc8f4b06$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $c72dbcb6dc8f4b06$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $c72dbcb6dc8f4b06$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($c72dbcb6dc8f4b06$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $c72dbcb6dc8f4b06$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $c72dbcb6dc8f4b06$export$10c90e4f7922046c(v) {
    return this instanceof $c72dbcb6dc8f4b06$export$10c90e4f7922046c ? (this.v = v, this) : new $c72dbcb6dc8f4b06$export$10c90e4f7922046c(v);
}
function $c72dbcb6dc8f4b06$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $c72dbcb6dc8f4b06$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $c72dbcb6dc8f4b06$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $c72dbcb6dc8f4b06$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $c72dbcb6dc8f4b06$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $c72dbcb6dc8f4b06$export$19a8beecd37a4c45 === "function" ? $c72dbcb6dc8f4b06$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $c72dbcb6dc8f4b06$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $c72dbcb6dc8f4b06$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $c72dbcb6dc8f4b06$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $c72dbcb6dc8f4b06$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $c72dbcb6dc8f4b06$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});


parcelRegister("kFmug", function(module, exports) {

$parcel$export(module.exports, "serializerMiddleware", () => $f0b9147ad492eff3$export$125a23d36094c5de);

var $h6dQv = parcelRequire("h6dQv");
var $f0b9147ad492eff3$export$125a23d36094c5de = function(options, serializer) {
    return function(next, context) {
        return function(args) {
            return (0, $h6dQv.__awaiter)(void 0, void 0, void 0, function() {
                var request;
                return (0, $h6dQv.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                serializer(args.input, options)
                            ];
                        case 1:
                            request = _a.sent();
                            return [
                                2 /*return*/ ,
                                next((0, $h6dQv.__assign)((0, $h6dQv.__assign)({}, args), {
                                    request: request
                                }))
                            ];
                    }
                });
            });
        };
    };
};

});

parcelRegister("dQtWs", function(module, exports) {

$parcel$export(module.exports, "getSerdePlugin", () => $a1475b8974a54ea8$export$53fdc69654553fd4);

var $j7qLt = parcelRequire("j7qLt");

var $kFmug = parcelRequire("kFmug");
var $a1475b8974a54ea8$export$f5d82b333b4f39c9 = {
    name: "deserializerMiddleware",
    step: "deserialize",
    tags: [
        "DESERIALIZER"
    ],
    override: true
};
var $a1475b8974a54ea8$export$1bd449976e9c484d = {
    name: "serializerMiddleware",
    step: "serialize",
    tags: [
        "SERIALIZER"
    ],
    override: true
};
function $a1475b8974a54ea8$export$53fdc69654553fd4(config, serializer, deserializer) {
    return {
        applyToStack: function(commandStack) {
            commandStack.add((0, $j7qLt.deserializerMiddleware)(config, deserializer), $a1475b8974a54ea8$export$f5d82b333b4f39c9);
            commandStack.add((0, $kFmug.serializerMiddleware)(config, serializer), $a1475b8974a54ea8$export$1bd449976e9c484d);
        }
    };
}

});


parcelRegister("3vy9S", function(module, exports) {
$parcel$export(module.exports, "Client", () => (parcelRequire("faPkI")).Client);
$parcel$export(module.exports, "Command", () => (parcelRequire("5nbBf")).Command);
$parcel$export(module.exports, "extendedEncodeURIComponent", () => (parcelRequire("9Nvib")).extendedEncodeURIComponent);
$parcel$export(module.exports, "getArrayIfSingleItem", () => (parcelRequire("bgM88")).getArrayIfSingleItem);
$parcel$export(module.exports, "getValueFromTextNode", () => (parcelRequire("bvxsW")).getValueFromTextNode);
$parcel$export(module.exports, "LazyJsonString", () => (parcelRequire("bs8lj")).LazyJsonString);
$parcel$export(module.exports, "dateToUtcString", () => (parcelRequire("hGFsd")).dateToUtcString);
$parcel$export(module.exports, "SENSITIVE_STRING", () => (parcelRequire("IsgKV")).SENSITIVE_STRING);
parcelRequire("faPkI");
parcelRequire("5nbBf");
parcelRequire("f9Cgw");
parcelRequire("2SP7P");
parcelRequire("9Nvib");
parcelRequire("bgM88");
parcelRequire("bvxsW");
parcelRequire("bs8lj");
parcelRequire("hGFsd");
parcelRequire("9S3iC");
parcelRequire("IsgKV");
parcelRequire("fIfaC");
parcelRequire("bbdMr");

});
parcelRegister("faPkI", function(module, exports) {

$parcel$export(module.exports, "Client", () => $b0bf9bdb309e42cf$export$1f2bb630327ac4b6);
parcelRequire("7ckcJ");
var $eDA33 = parcelRequire("eDA33");
var $b0bf9bdb309e42cf$export$1f2bb630327ac4b6 = /** @class */ function() {
    function Client(config) {
        this.middlewareStack = (0, $eDA33.constructStack)();
        this.config = config;
    }
    Client.prototype.send = function(command, optionsOrCb, cb) {
        var options = typeof optionsOrCb !== "function" ? optionsOrCb : undefined;
        var callback = typeof optionsOrCb === "function" ? optionsOrCb : cb;
        var handler = command.resolveMiddleware(this.middlewareStack, this.config, options);
        if (callback) handler(command).then(function(result) {
            return callback(null, result.output);
        }, function(err) {
            return callback(err);
        }).catch(// prevent any errors thrown in the callback from triggering an
        // unhandled promise rejection
        function() {});
        else return handler(command).then(function(result) {
            return result.output;
        });
    };
    Client.prototype.destroy = function() {
        if (this.config.requestHandler.destroy) this.config.requestHandler.destroy();
    };
    return Client;
}();

});
parcelRegister("7ckcJ", function(module, exports) {
$parcel$export(module.exports, "constructStack", () => (parcelRequire("eDA33")).constructStack);
parcelRequire("eDA33");

});
parcelRegister("eDA33", function(module, exports) {

$parcel$export(module.exports, "constructStack", () => $aa80aba660773575$export$73604a93307363d8);

var $k2kLj = parcelRequire("k2kLj");
var $aa80aba660773575$export$73604a93307363d8 = function() {
    var absoluteEntries = [];
    var relativeEntries = [];
    var entriesNameSet = new Set();
    var sort = function(entries) {
        return entries.sort(function(a, b) {
            return $aa80aba660773575$var$stepWeights[b.step] - $aa80aba660773575$var$stepWeights[a.step] || $aa80aba660773575$var$priorityWeights[b.priority || "normal"] - $aa80aba660773575$var$priorityWeights[a.priority || "normal"];
        });
    };
    var removeByName = function(toRemove) {
        var isRemoved = false;
        var filterCb = function(entry) {
            if (entry.name && entry.name === toRemove) {
                isRemoved = true;
                entriesNameSet.delete(toRemove);
                return false;
            }
            return true;
        };
        absoluteEntries = absoluteEntries.filter(filterCb);
        relativeEntries = relativeEntries.filter(filterCb);
        return isRemoved;
    };
    var removeByReference = function(toRemove) {
        var isRemoved = false;
        var filterCb = function(entry) {
            if (entry.middleware === toRemove) {
                isRemoved = true;
                if (entry.name) entriesNameSet.delete(entry.name);
                return false;
            }
            return true;
        };
        absoluteEntries = absoluteEntries.filter(filterCb);
        relativeEntries = relativeEntries.filter(filterCb);
        return isRemoved;
    };
    var cloneTo = function(toStack) {
        absoluteEntries.forEach(function(entry) {
            //@ts-ignore
            toStack.add(entry.middleware, (0, $k2kLj.__assign)({}, entry));
        });
        relativeEntries.forEach(function(entry) {
            //@ts-ignore
            toStack.addRelativeTo(entry.middleware, (0, $k2kLj.__assign)({}, entry));
        });
        return toStack;
    };
    var expandRelativeMiddlewareList = function(from) {
        var expandedMiddlewareList = [];
        from.before.forEach(function(entry) {
            if (entry.before.length === 0 && entry.after.length === 0) expandedMiddlewareList.push(entry);
            else expandedMiddlewareList.push.apply(expandedMiddlewareList, (0, $k2kLj.__spread)(expandRelativeMiddlewareList(entry)));
        });
        expandedMiddlewareList.push(from);
        from.after.reverse().forEach(function(entry) {
            if (entry.before.length === 0 && entry.after.length === 0) expandedMiddlewareList.push(entry);
            else expandedMiddlewareList.push.apply(expandedMiddlewareList, (0, $k2kLj.__spread)(expandRelativeMiddlewareList(entry)));
        });
        return expandedMiddlewareList;
    };
    /**
     * Get a final list of middleware in the order of being executed in the resolved handler.
     */ var getMiddlewareList = function() {
        var normalizedAbsoluteEntries = [];
        var normalizedRelativeEntries = [];
        var normalizedEntriesNameMap = {};
        absoluteEntries.forEach(function(entry) {
            var normalizedEntry = (0, $k2kLj.__assign)((0, $k2kLj.__assign)({}, entry), {
                before: [],
                after: []
            });
            if (normalizedEntry.name) normalizedEntriesNameMap[normalizedEntry.name] = normalizedEntry;
            normalizedAbsoluteEntries.push(normalizedEntry);
        });
        relativeEntries.forEach(function(entry) {
            var normalizedEntry = (0, $k2kLj.__assign)((0, $k2kLj.__assign)({}, entry), {
                before: [],
                after: []
            });
            if (normalizedEntry.name) normalizedEntriesNameMap[normalizedEntry.name] = normalizedEntry;
            normalizedRelativeEntries.push(normalizedEntry);
        });
        normalizedRelativeEntries.forEach(function(entry) {
            if (entry.toMiddleware) {
                var toMiddleware = normalizedEntriesNameMap[entry.toMiddleware];
                if (toMiddleware === undefined) throw new Error(entry.toMiddleware + " is not found when adding " + (entry.name || "anonymous") + " middleware " + entry.relation + " " + entry.toMiddleware);
                if (entry.relation === "after") toMiddleware.after.push(entry);
                if (entry.relation === "before") toMiddleware.before.push(entry);
            }
        });
        var mainChain = sort(normalizedAbsoluteEntries).map(expandRelativeMiddlewareList).reduce(function(wholeList, expendedMiddlewareList) {
            // TODO: Replace it with Array.flat();
            wholeList.push.apply(wholeList, (0, $k2kLj.__spread)(expendedMiddlewareList));
            return wholeList;
        }, []);
        return mainChain.map(function(entry) {
            return entry.middleware;
        });
    };
    var stack = {
        add: function(middleware, options) {
            if (options === void 0) options = {};
            var name = options.name, override = options.override;
            var entry = (0, $k2kLj.__assign)({
                step: "initialize",
                priority: "normal",
                middleware: middleware
            }, options);
            if (name) {
                if (entriesNameSet.has(name)) {
                    if (!override) throw new Error("Duplicate middleware name '" + name + "'");
                    var toOverrideIndex = absoluteEntries.findIndex(function(entry) {
                        return entry.name === name;
                    });
                    var toOverride = absoluteEntries[toOverrideIndex];
                    if (toOverride.step !== entry.step || toOverride.priority !== entry.priority) throw new Error("\"" + name + "\" middleware with " + toOverride.priority + " priority in " + toOverride.step + " step cannot be " + ("overridden by same-name middleware with " + entry.priority + " priority in " + entry.step + " step."));
                    absoluteEntries.splice(toOverrideIndex, 1);
                }
                entriesNameSet.add(name);
            }
            absoluteEntries.push(entry);
        },
        addRelativeTo: function(middleware, options) {
            var name = options.name, override = options.override;
            var entry = (0, $k2kLj.__assign)({
                middleware: middleware
            }, options);
            if (name) {
                if (entriesNameSet.has(name)) {
                    if (!override) throw new Error("Duplicate middleware name '" + name + "'");
                    var toOverrideIndex = relativeEntries.findIndex(function(entry) {
                        return entry.name === name;
                    });
                    var toOverride = relativeEntries[toOverrideIndex];
                    if (toOverride.toMiddleware !== entry.toMiddleware || toOverride.relation !== entry.relation) throw new Error("\"" + name + "\" middleware " + toOverride.relation + " \"" + toOverride.toMiddleware + "\" middleware cannot be overridden " + ("by same-name middleware " + entry.relation + " \"" + entry.toMiddleware + "\" middleware."));
                    relativeEntries.splice(toOverrideIndex, 1);
                }
                entriesNameSet.add(name);
            }
            relativeEntries.push(entry);
        },
        clone: function() {
            return cloneTo($aa80aba660773575$export$73604a93307363d8());
        },
        use: function(plugin) {
            plugin.applyToStack(stack);
        },
        remove: function(toRemove) {
            if (typeof toRemove === "string") return removeByName(toRemove);
            else return removeByReference(toRemove);
        },
        removeByTag: function(toRemove) {
            var isRemoved = false;
            var filterCb = function(entry) {
                var tags = entry.tags, name = entry.name;
                if (tags && tags.includes(toRemove)) {
                    if (name) entriesNameSet.delete(name);
                    isRemoved = true;
                    return false;
                }
                return true;
            };
            absoluteEntries = absoluteEntries.filter(filterCb);
            relativeEntries = relativeEntries.filter(filterCb);
            return isRemoved;
        },
        concat: function(from) {
            var cloned = cloneTo($aa80aba660773575$export$73604a93307363d8());
            cloned.use(from);
            return cloned;
        },
        applyToStack: cloneTo,
        resolve: function(handler, context) {
            var e_1, _a;
            try {
                for(var _b = (0, $k2kLj.__values)(getMiddlewareList().reverse()), _c = _b.next(); !_c.done; _c = _b.next()){
                    var middleware = _c.value;
                    handler = middleware(handler, context);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            return handler;
        }
    };
    return stack;
};
var $aa80aba660773575$var$stepWeights = {
    initialize: 5,
    serialize: 4,
    build: 3,
    finalizeRequest: 2,
    deserialize: 1
};
var $aa80aba660773575$var$priorityWeights = {
    high: 3,
    normal: 2,
    low: 1
};

});
parcelRegister("k2kLj", function(module, exports) {

$parcel$export(module.exports, "__assign", () => $e96419767e9eb516$export$18ce0697a983be9b);
$parcel$export(module.exports, "__values", () => $e96419767e9eb516$export$19a8beecd37a4c45);
$parcel$export(module.exports, "__spread", () => $e96419767e9eb516$export$afc72e2116322959);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $e96419767e9eb516$var$extendStatics = function(d, b) {
    $e96419767e9eb516$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $e96419767e9eb516$var$extendStatics(d, b);
};
function $e96419767e9eb516$export$a8ba968b8961cb8a(d, b) {
    $e96419767e9eb516$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $e96419767e9eb516$export$18ce0697a983be9b = function() {
    $e96419767e9eb516$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e96419767e9eb516$export$18ce0697a983be9b.apply(this, arguments);
};
function $e96419767e9eb516$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $e96419767e9eb516$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $e96419767e9eb516$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $e96419767e9eb516$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $e96419767e9eb516$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $e96419767e9eb516$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $e96419767e9eb516$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $e96419767e9eb516$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $e96419767e9eb516$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $e96419767e9eb516$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $e96419767e9eb516$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($e96419767e9eb516$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $e96419767e9eb516$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $e96419767e9eb516$export$10c90e4f7922046c(v) {
    return this instanceof $e96419767e9eb516$export$10c90e4f7922046c ? (this.v = v, this) : new $e96419767e9eb516$export$10c90e4f7922046c(v);
}
function $e96419767e9eb516$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $e96419767e9eb516$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $e96419767e9eb516$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $e96419767e9eb516$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $e96419767e9eb516$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $e96419767e9eb516$export$19a8beecd37a4c45 === "function" ? $e96419767e9eb516$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $e96419767e9eb516$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $e96419767e9eb516$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $e96419767e9eb516$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $e96419767e9eb516$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $e96419767e9eb516$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});




parcelRegister("5nbBf", function(module, exports) {

$parcel$export(module.exports, "Command", () => $3e981932b601ebec$export$cc7e12c76513e857);
parcelRequire("7ckcJ");
var $eDA33 = parcelRequire("eDA33");
var $3e981932b601ebec$export$cc7e12c76513e857 = /** @class */ function() {
    function Command() {
        this.middlewareStack = (0, $eDA33.constructStack)();
    }
    return Command;
}();

});

parcelRegister("f9Cgw", function(module, exports) {

});

parcelRegister("2SP7P", function(module, exports) {

});

parcelRegister("9Nvib", function(module, exports) {

$parcel$export(module.exports, "extendedEncodeURIComponent", () => $7220f6aa6f9ee497$export$7640f3c16fe7f54b);
/**
 * Function that wraps encodeURIComponent to encode additional characters
 * to fully adhere to RFC 3986.
 */ function $7220f6aa6f9ee497$export$7640f3c16fe7f54b(str) {
    return encodeURIComponent(str).replace(/[!'()*]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16);
    });
}

});

parcelRegister("bgM88", function(module, exports) {

$parcel$export(module.exports, "getArrayIfSingleItem", () => $834685fe24c2dd76$export$52272e038712c64e);
/**
 * The XML parser will set one K:V for a member that could
 * return multiple entries but only has one.
 */ var $834685fe24c2dd76$export$52272e038712c64e = function(mayBeArray) {
    return Array.isArray(mayBeArray) ? mayBeArray : [
        mayBeArray
    ];
};

});

parcelRegister("bvxsW", function(module, exports) {

$parcel$export(module.exports, "getValueFromTextNode", () => $860c8c8b97546376$export$113d90026b452881);
/**
 * Recursively parses object and populates value is node from
 * "#text" key if it's available
 */ var $860c8c8b97546376$export$113d90026b452881 = function(obj) {
    var textNodeName = "#text";
    for(var key in obj){
        if (obj.hasOwnProperty(key) && obj[key][textNodeName] !== undefined) obj[key] = obj[key][textNodeName];
        else if (typeof obj[key] === "object" && obj[key] !== null) obj[key] = $860c8c8b97546376$export$113d90026b452881(obj[key]);
    }
    return obj;
};

});

parcelRegister("bs8lj", function(module, exports) {

$parcel$export(module.exports, "LazyJsonString", () => $8568c7f364086ab4$export$494ed5148690ecaf);
/**
 * Lazy String holder for JSON typed contents.
 */ 
var $ioK8B = parcelRequire("ioK8B");
var $8568c7f364086ab4$export$40e2db4f1ce24b10 = function() {
    //@ts-ignore 'this' cannot be assigned to any, but Object.getPrototypeOf accepts any
    var Class = Object.getPrototypeOf(this).constructor;
    var Constructor = Function.bind.apply(String, (0, $ioK8B.__spread)([
        null
    ], arguments));
    //@ts-ignore Call wrapped String constructor directly, don't bother typing it.
    var instance = new Constructor();
    Object.setPrototypeOf(instance, Class.prototype);
    return instance;
};
$8568c7f364086ab4$export$40e2db4f1ce24b10.prototype = Object.create(String.prototype, {
    constructor: {
        value: $8568c7f364086ab4$export$40e2db4f1ce24b10,
        enumerable: false,
        writable: true,
        configurable: true
    }
});
Object.setPrototypeOf($8568c7f364086ab4$export$40e2db4f1ce24b10, String);
var $8568c7f364086ab4$export$494ed5148690ecaf = /** @class */ function(_super) {
    (0, $ioK8B.__extends)(LazyJsonString, _super);
    function LazyJsonString() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LazyJsonString.prototype.deserializeJSON = function() {
        return JSON.parse(_super.prototype.toString.call(this));
    };
    LazyJsonString.prototype.toJSON = function() {
        return _super.prototype.toString.call(this);
    };
    LazyJsonString.fromObject = function(object) {
        if (object instanceof LazyJsonString) return object;
        else if (object instanceof String || typeof object === "string") return new LazyJsonString(object);
        return new LazyJsonString(JSON.stringify(object));
    };
    return LazyJsonString;
}($8568c7f364086ab4$export$40e2db4f1ce24b10);

});
parcelRegister("ioK8B", function(module, exports) {

$parcel$export(module.exports, "__extends", () => $d64e41e59114db26$export$a8ba968b8961cb8a);
$parcel$export(module.exports, "__spread", () => $d64e41e59114db26$export$afc72e2116322959);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $d64e41e59114db26$var$extendStatics = function(d, b) {
    $d64e41e59114db26$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $d64e41e59114db26$var$extendStatics(d, b);
};
function $d64e41e59114db26$export$a8ba968b8961cb8a(d, b) {
    $d64e41e59114db26$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $d64e41e59114db26$export$18ce0697a983be9b = function() {
    $d64e41e59114db26$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d64e41e59114db26$export$18ce0697a983be9b.apply(this, arguments);
};
function $d64e41e59114db26$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $d64e41e59114db26$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $d64e41e59114db26$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $d64e41e59114db26$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $d64e41e59114db26$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $d64e41e59114db26$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $d64e41e59114db26$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $d64e41e59114db26$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $d64e41e59114db26$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $d64e41e59114db26$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $d64e41e59114db26$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($d64e41e59114db26$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $d64e41e59114db26$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $d64e41e59114db26$export$10c90e4f7922046c(v) {
    return this instanceof $d64e41e59114db26$export$10c90e4f7922046c ? (this.v = v, this) : new $d64e41e59114db26$export$10c90e4f7922046c(v);
}
function $d64e41e59114db26$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $d64e41e59114db26$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $d64e41e59114db26$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $d64e41e59114db26$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $d64e41e59114db26$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $d64e41e59114db26$export$19a8beecd37a4c45 === "function" ? $d64e41e59114db26$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $d64e41e59114db26$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $d64e41e59114db26$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $d64e41e59114db26$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $d64e41e59114db26$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $d64e41e59114db26$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});


parcelRegister("hGFsd", function(module, exports) {

$parcel$export(module.exports, "dateToUtcString", () => $ce0683d421a9d6c5$export$5b50865171ed23a9);
/**
 * Builds a proper UTC HttpDate timestamp from a Date object
 * since not all environments will have this as the expected
 * format.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toUTCString
 * > Prior to ECMAScript 2018, the format of the return value
 * > varied according to the platform. The most common return
 * > value was an RFC-1123 formatted date stamp, which is a
 * > slightly updated version of RFC-822 date stamps.
 */ // Build indexes outside so we allocate them once.
var $ce0683d421a9d6c5$var$days = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat"
];
// prettier-ignore
var $ce0683d421a9d6c5$var$months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
function $ce0683d421a9d6c5$export$5b50865171ed23a9(date) {
    var year = date.getUTCFullYear();
    var month = date.getUTCMonth();
    var dayOfWeek = date.getUTCDay();
    var dayOfMonthInt = date.getUTCDate();
    var hoursInt = date.getUTCHours();
    var minutesInt = date.getUTCMinutes();
    var secondsInt = date.getUTCSeconds();
    // Build 0 prefixed strings for contents that need to be
    // two digits and where we get an integer back.
    var dayOfMonthString = dayOfMonthInt < 10 ? "0" + dayOfMonthInt : "" + dayOfMonthInt;
    var hoursString = hoursInt < 10 ? "0" + hoursInt : "" + hoursInt;
    var minutesString = minutesInt < 10 ? "0" + minutesInt : "" + minutesInt;
    var secondsString = secondsInt < 10 ? "0" + secondsInt : "" + secondsInt;
    return $ce0683d421a9d6c5$var$days[dayOfWeek] + ", " + dayOfMonthString + " " + $ce0683d421a9d6c5$var$months[month] + " " + year + " " + hoursString + ":" + minutesString + ":" + secondsString + " GMT";
}

});

parcelRegister("9S3iC", function(module, exports) {
/**
 * Given an input string, splits based on the delimiter after a given
 * number of delimiters has been encountered.
 *
 * @param value The input string to split.
 * @param delimiter The delimiter to split on.
 * @param numDelimiters The number of delimiters to have encountered to split.
 */ function $72fbb764b4559000$export$b0cd0cd33296db41(value, delimiter, numDelimiters) {
    // Fail if we don't have a clear number to split on.
    if (numDelimiters <= 0 || !Number.isInteger(numDelimiters)) throw new Error("Invalid number of delimiters (" + numDelimiters + ") for splitEvery.");
    var segments = value.split(delimiter);
    // Short circuit extra logic for the simple case.
    if (numDelimiters === 1) return segments;
    var compoundSegments = [];
    var currentSegment = "";
    for(var i = 0; i < segments.length; i++){
        if (currentSegment === "") // Start a new segment.
        currentSegment = segments[i];
        else // Compound the current segment with the delimiter.
        currentSegment += delimiter + segments[i];
        if ((i + 1) % numDelimiters === 0) {
            // We encountered the right number of delimiters, so add the entry.
            compoundSegments.push(currentSegment);
            // And reset the current segment.
            currentSegment = "";
        }
    }
    // Handle any leftover segment portion.
    if (currentSegment !== "") compoundSegments.push(currentSegment);
    return compoundSegments;
}

});

parcelRegister("IsgKV", function(module, exports) {

$parcel$export(module.exports, "SENSITIVE_STRING", () => $085a09dc6e15782b$export$17127055dc9ac067);
var $085a09dc6e15782b$export$17127055dc9ac067 = "***SensitiveInformation***";

});

parcelRegister("fIfaC", function(module, exports) {

});

parcelRegister("bbdMr", function(module, exports) {

});



parcelRegister("bCCSs", function(module, exports) {
$parcel$export(module.exports, "ProviderError", () => (parcelRequire("i2yOq")).ProviderError);
parcelRequire("7GnuJ");
parcelRequire("2J2hH");
parcelRequire("5MDBU");
parcelRequire("i2yOq");

});
parcelRegister("7GnuJ", function(module, exports) {

var $mHGMO = parcelRequire("mHGMO");

var $i2yOq = parcelRequire("i2yOq");
function $597eae315c287cc4$export$e08e3b67e392101e() {
    var providers = [];
    for(var _i = 0; _i < arguments.length; _i++)providers[_i] = arguments[_i];
    return function() {
        var e_1, _a;
        var promise = Promise.reject(new (0, $i2yOq.ProviderError)("No providers in chain"));
        var _loop_1 = function(provider) {
            promise = promise.catch(function(err) {
                if (err === null || err === void 0 ? void 0 : err.tryNextLink) return provider();
                throw err;
            });
        };
        try {
            for(var providers_1 = (0, $mHGMO.__values)(providers), providers_1_1 = providers_1.next(); !providers_1_1.done; providers_1_1 = providers_1.next()){
                var provider = providers_1_1.value;
                _loop_1(provider);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (providers_1_1 && !providers_1_1.done && (_a = providers_1.return)) _a.call(providers_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return promise;
    };
}

});
parcelRegister("mHGMO", function(module, exports) {

$parcel$export(module.exports, "__extends", () => $0443f1ef10ef828d$export$a8ba968b8961cb8a);
$parcel$export(module.exports, "__awaiter", () => $0443f1ef10ef828d$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $0443f1ef10ef828d$export$67ebef60e6f28a6);
$parcel$export(module.exports, "__values", () => $0443f1ef10ef828d$export$19a8beecd37a4c45);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $0443f1ef10ef828d$var$extendStatics = function(d, b) {
    $0443f1ef10ef828d$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $0443f1ef10ef828d$var$extendStatics(d, b);
};
function $0443f1ef10ef828d$export$a8ba968b8961cb8a(d, b) {
    $0443f1ef10ef828d$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $0443f1ef10ef828d$export$18ce0697a983be9b = function() {
    $0443f1ef10ef828d$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0443f1ef10ef828d$export$18ce0697a983be9b.apply(this, arguments);
};
function $0443f1ef10ef828d$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $0443f1ef10ef828d$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $0443f1ef10ef828d$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $0443f1ef10ef828d$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $0443f1ef10ef828d$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $0443f1ef10ef828d$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $0443f1ef10ef828d$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $0443f1ef10ef828d$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $0443f1ef10ef828d$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $0443f1ef10ef828d$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $0443f1ef10ef828d$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($0443f1ef10ef828d$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $0443f1ef10ef828d$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $0443f1ef10ef828d$export$10c90e4f7922046c(v) {
    return this instanceof $0443f1ef10ef828d$export$10c90e4f7922046c ? (this.v = v, this) : new $0443f1ef10ef828d$export$10c90e4f7922046c(v);
}
function $0443f1ef10ef828d$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $0443f1ef10ef828d$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $0443f1ef10ef828d$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $0443f1ef10ef828d$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $0443f1ef10ef828d$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $0443f1ef10ef828d$export$19a8beecd37a4c45 === "function" ? $0443f1ef10ef828d$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $0443f1ef10ef828d$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $0443f1ef10ef828d$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $0443f1ef10ef828d$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $0443f1ef10ef828d$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $0443f1ef10ef828d$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("i2yOq", function(module, exports) {

$parcel$export(module.exports, "ProviderError", () => $d2236ae14e1e7cfd$export$478ec1fdae99aa79);

var $mHGMO = parcelRequire("mHGMO");
/**
 * An error representing a failure of an individual credential provider.
 *
 * This error class has special meaning to the {@link chain} method. If a
 * provider in the chain is rejected with an error, the chain will only proceed
 * to the next provider if the value of the `tryNextLink` property on the error
 * is truthy. This allows individual providers to halt the chain and also
 * ensures the chain will stop if an entirely unexpected error is encountered.
 */ var $d2236ae14e1e7cfd$export$478ec1fdae99aa79 = /** @class */ function(_super) {
    (0, $mHGMO.__extends)(ProviderError, _super);
    function ProviderError(message, tryNextLink) {
        if (tryNextLink === void 0) tryNextLink = true;
        var _this = _super.call(this, message) || this;
        _this.tryNextLink = tryNextLink;
        return _this;
    }
    return ProviderError;
}(Error);

});


parcelRegister("2J2hH", function(module, exports) {
var $1fc18e607a6ad1c0$export$294ab423a8f4a426 = function(staticValue) {
    return function() {
        return Promise.resolve(staticValue);
    };
};

});

parcelRegister("5MDBU", function(module, exports) {

var $mHGMO = parcelRequire("mHGMO");
var $43602945bf01cb82$export$fc10aeed3a532e2a = function(provider, isExpired, requiresRefresh) {
    var result;
    var hasResult;
    if (isExpired === undefined) // This is a static memoization; no need to incorporate refreshing
    return function() {
        if (!hasResult) {
            result = provider();
            hasResult = true;
        }
        return result;
    };
    var isConstant = false;
    return function() {
        return (0, $mHGMO.__awaiter)(void 0, void 0, void 0, function() {
            var resolved;
            return (0, $mHGMO.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!hasResult) {
                            result = provider();
                            hasResult = true;
                        }
                        if (isConstant) return [
                            2 /*return*/ ,
                            result
                        ];
                        return [
                            4 /*yield*/ ,
                            result
                        ];
                    case 1:
                        resolved = _a.sent();
                        if (requiresRefresh && !requiresRefresh(resolved)) {
                            isConstant = true;
                            return [
                                2 /*return*/ ,
                                resolved
                            ];
                        }
                        if (isExpired(resolved)) return [
                            2 /*return*/ ,
                            result = provider()
                        ];
                        return [
                            2 /*return*/ ,
                            resolved
                        ];
                }
            });
        });
    };
};

});


parcelRegister("944UQ", function(module, exports) {

$parcel$export(module.exports, "resolveLogins", () => $69984cf268988947$export$fb1e896f6704b6a6);

var $7AHWw = parcelRequire("7AHWw");
function $69984cf268988947$export$fb1e896f6704b6a6(logins) {
    return Promise.all(Object.keys(logins).reduce(function(arr, name) {
        var tokenOrProvider = logins[name];
        if (typeof tokenOrProvider === "string") arr.push([
            name,
            tokenOrProvider
        ]);
        else arr.push(tokenOrProvider().then(function(token) {
            return [
                name,
                token
            ];
        }));
        return arr;
    }, [])).then(function(resolvedPairs) {
        return resolvedPairs.reduce(function(logins, _a) {
            var _b = (0, $7AHWw.__read)(_a, 2), key = _b[0], value = _b[1];
            logins[key] = value;
            return logins;
        }, {});
    });
}

});


parcelRegister("21jjT", function(module, exports) {

$parcel$export(module.exports, "fromCognitoIdentityPool", () => $178aa94834a99d4f$export$6c7d622e9507a2e);

var $7AHWw = parcelRequire("7AHWw");

var $01m9h = parcelRequire("01m9h");
parcelRequire("bCCSs");
var $i2yOq = parcelRequire("i2yOq");

var $gsz66 = parcelRequire("gsz66");

var $3oRYA = parcelRequire("3oRYA");

var $944UQ = parcelRequire("944UQ");
function $178aa94834a99d4f$export$6c7d622e9507a2e(_a) {
    var _this = this;
    var accountId = _a.accountId, _b = _a.cache, cache = _b === void 0 ? (0, $3oRYA.localStorage)() : _b, client = _a.client, customRoleArn = _a.customRoleArn, identityPoolId = _a.identityPoolId, logins = _a.logins, _c = _a.userIdentifier, userIdentifier = _c === void 0 ? !logins || Object.keys(logins).length === 0 ? "ANONYMOUS" : undefined : _c;
    var cacheKey = userIdentifier ? "aws:cognito-identity-credentials:" + identityPoolId + ":" + userIdentifier : undefined;
    var provider = function() {
        return (0, $7AHWw.__awaiter)(_this, void 0, void 0, function() {
            var identityId, _a, _b, IdentityId, _c, _d, _e, _f;
            var _g;
            return (0, $7AHWw.__generator)(this, function(_h) {
                switch(_h.label){
                    case 0:
                        _a = cacheKey;
                        if (!_a) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            cache.getItem(cacheKey)
                        ];
                    case 1:
                        _a = _h.sent();
                        _h.label = 2;
                    case 2:
                        identityId = _a;
                        if (!!identityId) return [
                            3 /*break*/ ,
                            7
                        ];
                        _d = (_c = client).send;
                        _e = (0, $01m9h.GetIdCommand).bind;
                        _g = {
                            AccountId: accountId,
                            IdentityPoolId: identityPoolId
                        };
                        if (!logins) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $944UQ.resolveLogins)(logins)
                        ];
                    case 3:
                        _f = _h.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        _f = undefined;
                        _h.label = 5;
                    case 5:
                        return [
                            4 /*yield*/ ,
                            _d.apply(_c, [
                                new (_e.apply((0, $01m9h.GetIdCommand), [
                                    void 0,
                                    (_g.Logins = _f, _g)
                                ]))()
                            ])
                        ];
                    case 6:
                        _b = _h.sent().IdentityId, IdentityId = _b === void 0 ? $178aa94834a99d4f$var$throwOnMissingId() : _b;
                        identityId = IdentityId;
                        if (cacheKey) Promise.resolve(cache.setItem(cacheKey, identityId)).catch(function() {});
                        _h.label = 7;
                    case 7:
                        provider = (0, $gsz66.fromCognitoIdentity)({
                            client: client,
                            customRoleArn: customRoleArn,
                            logins: logins,
                            identityId: identityId
                        });
                        return [
                            2 /*return*/ ,
                            provider()
                        ];
                }
            });
        });
    };
    return function() {
        return provider().catch(function(err) {
            return (0, $7AHWw.__awaiter)(_this, void 0, void 0, function() {
                return (0, $7AHWw.__generator)(this, function(_a) {
                    if (cacheKey) Promise.resolve(cache.removeItem(cacheKey)).catch(function() {});
                    throw err;
                });
            });
        });
    };
}
function $178aa94834a99d4f$var$throwOnMissingId() {
    throw new (0, $i2yOq.ProviderError)("Response from Amazon Cognito contained no identity ID");
}

});
parcelRegister("01m9h", function(module, exports) {

$parcel$export(module.exports, "GetIdCommand", () => $0041465d837571fa$export$41ceb4ced4f97a44);

var $2eeCH = parcelRequire("2eeCH");

var $73Mvs = parcelRequire("73Mvs");

var $JCuPK = parcelRequire("JCuPK");
parcelRequire("6ZXPq");
var $dQtWs = parcelRequire("dQtWs");
parcelRequire("3vy9S");
var $5nbBf = parcelRequire("5nbBf");
/**
 * <p>Generates (or retrieves) a Cognito ID. Supplying multiple logins will create an
 *          implicit linked account.</p>
 *          <p>This is a public API. You do not need any credentials to call this API.</p>
 */ var $0041465d837571fa$export$41ceb4ced4f97a44 = /** @class */ function(_super) {
    (0, $2eeCH.__extends)(GetIdCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function GetIdCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    /**
     * @internal
     */ GetIdCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $dQtWs.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CognitoIdentityClient";
        var commandName = "GetIdCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $73Mvs.GetIdInput).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $73Mvs.GetIdResponse).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetIdCommand.prototype.serialize = function(input, context) {
        return (0, $JCuPK.serializeAws_json1_1GetIdCommand)(input, context);
    };
    GetIdCommand.prototype.deserialize = function(output, context) {
        return (0, $JCuPK.deserializeAws_json1_1GetIdCommand)(output, context);
    };
    return GetIdCommand;
}((0, $5nbBf.Command));

});

parcelRegister("3oRYA", function(module, exports) {

$parcel$export(module.exports, "localStorage", () => $279d7b884901243d$export$c2ed3351cac403d1);

var $6vOGJ = parcelRequire("6vOGJ");

var $68Um5 = parcelRequire("68Um5");
var $279d7b884901243d$var$inMemoryStorage = new (0, $68Um5.InMemoryStorage)();
function $279d7b884901243d$export$c2ed3351cac403d1() {
    if (typeof self === "object" && self.indexedDB) return new (0, $6vOGJ.IndexedDbStorage)();
    if (typeof window === "object" && window.localStorage) return window.localStorage;
    return $279d7b884901243d$var$inMemoryStorage;
}

});
parcelRegister("6vOGJ", function(module, exports) {

$parcel$export(module.exports, "IndexedDbStorage", () => $4bdcf4f0b126c983$export$55d38e5384f402);
var $4bdcf4f0b126c983$var$STORE_NAME = "IdentityIds";
var $4bdcf4f0b126c983$export$55d38e5384f402 = /** @class */ function() {
    function IndexedDbStorage(dbName) {
        if (dbName === void 0) dbName = "aws:cognito-identity-ids";
        this.dbName = dbName;
    }
    IndexedDbStorage.prototype.getItem = function(key) {
        return this.withObjectStore("readonly", function(store) {
            var req = store.get(key);
            return new Promise(function(resolve) {
                req.onerror = function() {
                    return resolve(null);
                };
                req.onsuccess = function() {
                    return resolve(req.result ? req.result.value : null);
                };
            });
        }).catch(function() {
            return null;
        });
    };
    IndexedDbStorage.prototype.removeItem = function(key) {
        return this.withObjectStore("readwrite", function(store) {
            var req = store.delete(key);
            return new Promise(function(resolve, reject) {
                req.onerror = function() {
                    return reject(req.error);
                };
                req.onsuccess = function() {
                    return resolve();
                };
            });
        });
    };
    IndexedDbStorage.prototype.setItem = function(id, value) {
        return this.withObjectStore("readwrite", function(store) {
            var req = store.put({
                id: id,
                value: value
            });
            return new Promise(function(resolve, reject) {
                req.onerror = function() {
                    return reject(req.error);
                };
                req.onsuccess = function() {
                    return resolve();
                };
            });
        });
    };
    IndexedDbStorage.prototype.getDb = function() {
        var openDbRequest = self.indexedDB.open(this.dbName, 1);
        return new Promise(function(resolve, reject) {
            openDbRequest.onsuccess = function() {
                resolve(openDbRequest.result);
            };
            openDbRequest.onerror = function() {
                reject(openDbRequest.error);
            };
            openDbRequest.onblocked = function() {
                reject(new Error("Unable to access DB"));
            };
            openDbRequest.onupgradeneeded = function() {
                var db = openDbRequest.result;
                db.onerror = function() {
                    reject(new Error("Failed to create object store"));
                };
                db.createObjectStore($4bdcf4f0b126c983$var$STORE_NAME, {
                    keyPath: "id"
                });
            };
        });
    };
    IndexedDbStorage.prototype.withObjectStore = function(mode, action) {
        return this.getDb().then(function(db) {
            var tx = db.transaction($4bdcf4f0b126c983$var$STORE_NAME, mode);
            tx.oncomplete = function() {
                return db.close();
            };
            return new Promise(function(resolve, reject) {
                tx.onerror = function() {
                    return reject(tx.error);
                };
                resolve(action(tx.objectStore($4bdcf4f0b126c983$var$STORE_NAME)));
            }).catch(function(err) {
                db.close();
                throw err;
            });
        });
    };
    return IndexedDbStorage;
}();

});

parcelRegister("68Um5", function(module, exports) {

$parcel$export(module.exports, "InMemoryStorage", () => $478f3468f1087dba$export$e4315e25b840a0ea);
var $478f3468f1087dba$export$e4315e25b840a0ea = /** @class */ function() {
    function InMemoryStorage(store) {
        if (store === void 0) store = {};
        this.store = store;
    }
    InMemoryStorage.prototype.getItem = function(key) {
        if (key in this.store) return this.store[key];
        return null;
    };
    InMemoryStorage.prototype.removeItem = function(key) {
        delete this.store[key];
    };
    InMemoryStorage.prototype.setItem = function(key, value) {
        this.store[key] = value;
    };
    return InMemoryStorage;
}();

});



parcelRegister("ksIf9", function(module, exports) {

$parcel$export(module.exports, "CognitoIdentityClient", () => $ee58bdfac8003fde$export$e576def690e850f7);

var $2eeCH = parcelRequire("2eeCH");

var $dv5NN = parcelRequire("dv5NN");
parcelRequire("efaVN");
var $gqVgN = parcelRequire("gqVgN");
var $l59xh = parcelRequire("l59xh");

var $d5DYF = parcelRequire("d5DYF");

var $e80zq = parcelRequire("e80zq");
parcelRequire("9FJYQ");
var $8Hvpq = parcelRequire("8Hvpq");
parcelRequire("3dE54");
var $3fI9X = parcelRequire("3fI9X");
var $efUMf = parcelRequire("efUMf");
parcelRequire("5jjeh");
var $6KIbI = parcelRequire("6KIbI");
parcelRequire("6VCaQ");
var $fAUAY = parcelRequire("fAUAY");
var $9YwGy = parcelRequire("9YwGy");
parcelRequire("3vy9S");
var $faPkI = parcelRequire("faPkI");
/**
 * <fullname>Amazon Cognito Federated Identities</fullname>
 *          <p>Amazon Cognito Federated Identities is a web service that delivers scoped temporary
 *          credentials to mobile devices and other untrusted environments. It uniquely identifies a
 *          device and supplies the user with a consistent identity over the lifetime of an
 *          application.</p>
 *          <p>Using Amazon Cognito Federated Identities, you can enable authentication with one or
 *          more third-party identity providers (Facebook, Google, or Login with Amazon) or an Amazon
 *          Cognito user pool, and you can also choose to support unauthenticated access from your app.
 *          Cognito delivers a unique identifier for each user and acts as an OpenID token provider
 *          trusted by AWS Security Token Service (STS) to access temporary, limited-privilege AWS
 *          credentials.</p>
 *          <p>For a description of the authentication flow from the Amazon Cognito Developer Guide
 *          see <a href="https://docs.aws.amazon.com/cognito/latest/developerguide/authentication-flow.html">Authentication Flow</a>.</p>
 *          <p>For more information see <a href="https://docs.aws.amazon.com/cognito/latest/developerguide/cognito-identity.html">Amazon Cognito Federated Identities</a>.</p>
 */ var $ee58bdfac8003fde$export$e576def690e850f7 = /** @class */ function(_super) {
    (0, $2eeCH.__extends)(CognitoIdentityClient, _super);
    function CognitoIdentityClient(configuration) {
        var _this = this;
        var _config_0 = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, (0, $dv5NN.ClientDefaultValues)), configuration);
        var _config_1 = (0, $l59xh.resolveRegionConfig)(_config_0);
        var _config_2 = (0, $gqVgN.resolveEndpointsConfig)(_config_1);
        var _config_3 = (0, $6KIbI.resolveAwsAuthConfig)(_config_2);
        var _config_4 = (0, $efUMf.resolveRetryConfig)(_config_3);
        var _config_5 = (0, $e80zq.resolveHostHeaderConfig)(_config_4);
        var _config_6 = (0, $9YwGy.resolveUserAgentConfig)(_config_5);
        _this = _super.call(this, _config_6) || this;
        _this.config = _config_6;
        _this.middlewareStack.use((0, $3fI9X.getRetryPlugin)(_this.config));
        _this.middlewareStack.use((0, $d5DYF.getContentLengthPlugin)(_this.config));
        _this.middlewareStack.use((0, $e80zq.getHostHeaderPlugin)(_this.config));
        _this.middlewareStack.use((0, $8Hvpq.getLoggerPlugin)(_this.config));
        _this.middlewareStack.use((0, $fAUAY.getUserAgentPlugin)(_this.config));
        return _this;
    }
    CognitoIdentityClient.prototype.destroy = function() {
        _super.prototype.destroy.call(this);
    };
    return CognitoIdentityClient;
}((0, $faPkI.Client));

});
parcelRegister("dv5NN", function(module, exports) {

$parcel$export(module.exports, "ClientDefaultValues", () => $9d42abc7c32900ad$export$b1f2d721b555a243);

var $2eeCH = parcelRequire("2eeCH");

var $h1JL1 = parcelRequire("h1JL1");

var $kIeHp = parcelRequire("kIeHp");
parcelRequire("lRt6C");
var $en8nh = parcelRequire("en8nh");
var $krpM4 = parcelRequire("krpM4");
parcelRequire("cEJWE");
var $ecitQ = parcelRequire("ecitQ");
parcelRequire("3dE54");
var $9EGMS = parcelRequire("9EGMS");

var $hZ4ci = parcelRequire("hZ4ci");

var $a6ye5 = parcelRequire("a6ye5");

var $b9Yj9 = parcelRequire("b9Yj9");

var $jJ4yr = parcelRequire("jJ4yr");

var $01k4l = parcelRequire("01k4l");
var $9d42abc7c32900ad$export$b1f2d721b555a243 = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, (0, $01k4l.ClientSharedValues)), {
    runtime: "browser",
    base64Decoder: (0, $hZ4ci.fromBase64),
    base64Encoder: (0, $hZ4ci.toBase64),
    bodyLengthChecker: (0, $a6ye5.calculateBodyLength),
    credentialDefaultProvider: function(_) {
        return function() {
            return Promise.reject(new Error("Credential is missing"));
        };
    },
    defaultUserAgentProvider: (0, $b9Yj9.defaultUserAgent)({
        serviceId: (0, $01k4l.ClientSharedValues).serviceId,
        clientVersion: (0, (/*@__PURE__*/$parcel$interopDefault($h1JL1))).version
    }),
    maxAttempts: (0, $9EGMS.DEFAULT_MAX_ATTEMPTS),
    region: (0, $ecitQ.invalidProvider)("Region is missing"),
    requestHandler: new (0, $en8nh.FetchHttpHandler)(),
    sha256: (0, $kIeHp.Sha256),
    streamCollector: (0, $krpM4.streamCollector),
    utf8Decoder: (0, $jJ4yr.fromUtf8),
    utf8Encoder: (0, $jJ4yr.toUtf8)
});

});
parcelRegister("h1JL1", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"@aws-sdk/client-cognito-identity\",\"description\":\"AWS SDK for JavaScript Cognito Identity Client for Node.js, Browser and React Native\",\"version\":\"3.6.1\",\"scripts\":{\"clean\":\"yarn remove-definitions && yarn remove-dist && yarn remove-documentation\",\"build-documentation\":\"yarn remove-documentation && typedoc ./\",\"prepublishOnly\":\"yarn build\",\"pretest\":\"yarn build:cjs\",\"remove-definitions\":\"rimraf ./types\",\"remove-dist\":\"rimraf ./dist\",\"remove-documentation\":\"rimraf ./docs\",\"test:unit\":\"mocha **/cjs/**/*.spec.js\",\"test:e2e\":\"mocha **/cjs/**/*.ispec.js && karma start karma.conf.js\",\"test\":\"yarn test:unit\",\"build:cjs\":\"tsc -p tsconfig.json\",\"build:es\":\"tsc -p tsconfig.es.json\",\"build\":\"yarn build:cjs && yarn build:es\",\"postbuild\":\"downlevel-dts types types/ts3.4\"},\"main\":\"./dist/cjs/index.js\",\"types\":\"./types/index.d.ts\",\"module\":\"./dist/es/index.js\",\"browser\":{\"./runtimeConfig\":\"./runtimeConfig.browser\"},\"react-native\":{\"./runtimeConfig\":\"./runtimeConfig.native\"},\"sideEffects\":false,\"dependencies\":{\"@aws-crypto/sha256-browser\":\"^1.0.0\",\"@aws-crypto/sha256-js\":\"^1.0.0\",\"@aws-sdk/config-resolver\":\"3.6.1\",\"@aws-sdk/credential-provider-node\":\"3.6.1\",\"@aws-sdk/fetch-http-handler\":\"3.6.1\",\"@aws-sdk/hash-node\":\"3.6.1\",\"@aws-sdk/invalid-dependency\":\"3.6.1\",\"@aws-sdk/middleware-content-length\":\"3.6.1\",\"@aws-sdk/middleware-host-header\":\"3.6.1\",\"@aws-sdk/middleware-logger\":\"3.6.1\",\"@aws-sdk/middleware-retry\":\"3.6.1\",\"@aws-sdk/middleware-serde\":\"3.6.1\",\"@aws-sdk/middleware-signing\":\"3.6.1\",\"@aws-sdk/middleware-stack\":\"3.6.1\",\"@aws-sdk/middleware-user-agent\":\"3.6.1\",\"@aws-sdk/node-config-provider\":\"3.6.1\",\"@aws-sdk/node-http-handler\":\"3.6.1\",\"@aws-sdk/protocol-http\":\"3.6.1\",\"@aws-sdk/smithy-client\":\"3.6.1\",\"@aws-sdk/types\":\"3.6.1\",\"@aws-sdk/url-parser\":\"3.6.1\",\"@aws-sdk/url-parser-native\":\"3.6.1\",\"@aws-sdk/util-base64-browser\":\"3.6.1\",\"@aws-sdk/util-base64-node\":\"3.6.1\",\"@aws-sdk/util-body-length-browser\":\"3.6.1\",\"@aws-sdk/util-body-length-node\":\"3.6.1\",\"@aws-sdk/util-user-agent-browser\":\"3.6.1\",\"@aws-sdk/util-user-agent-node\":\"3.6.1\",\"@aws-sdk/util-utf8-browser\":\"3.6.1\",\"@aws-sdk/util-utf8-node\":\"3.6.1\",\"tslib\":\"^2.0.0\"},\"devDependencies\":{\"@aws-sdk/client-documentation-generator\":\"3.6.1\",\"@aws-sdk/client-iam\":\"3.6.1\",\"@types/chai\":\"^4.2.11\",\"@types/mocha\":\"^8.0.4\",\"@types/node\":\"^12.7.5\",\"downlevel-dts\":\"0.7.0\",\"jest\":\"^26.1.0\",\"rimraf\":\"^3.0.0\",\"typedoc\":\"^0.19.2\",\"typescript\":\"~4.1.2\"},\"engines\":{\"node\":\">=10.0.0\"},\"typesVersions\":{\"<4.0\":{\"types/*\":[\"types/ts3.4/*\"]}},\"author\":{\"name\":\"AWS SDK for JavaScript Team\",\"url\":\"https://aws.amazon.com/javascript/\"},\"license\":\"Apache-2.0\",\"homepage\":\"https://github.com/aws/aws-sdk-js-v3/tree/main/clients/client-cognito-identity\",\"repository\":{\"type\":\"git\",\"url\":\"https://github.com/aws/aws-sdk-js-v3.git\",\"directory\":\"clients/client-cognito-identity\"}}");

});

parcelRegister("kIeHp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WebCryptoSha256 = module.exports.Ie11Sha256 = void 0;

var $iMVHR = parcelRequire("iMVHR");

(0, $iMVHR.__exportStar)((parcelRequire("l2PqA")), module.exports);

var $3lsNB = parcelRequire("3lsNB");
Object.defineProperty(module.exports, "Ie11Sha256", {
    enumerable: true,
    get: function() {
        return $3lsNB.Sha256;
    }
});

var $jJO61 = parcelRequire("jJO61");
Object.defineProperty(module.exports, "WebCryptoSha256", {
    enumerable: true,
    get: function() {
        return $jJO61.Sha256;
    }
});

});
parcelRegister("iMVHR", function(module, exports) {

$parcel$export(module.exports, "__awaiter", () => $dad978f951534c1b$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $dad978f951534c1b$export$67ebef60e6f28a6);
$parcel$export(module.exports, "__exportStar", () => $dad978f951534c1b$export$f33643c0debef087);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $dad978f951534c1b$var$extendStatics = function(d, b) {
    $dad978f951534c1b$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $dad978f951534c1b$var$extendStatics(d, b);
};
function $dad978f951534c1b$export$a8ba968b8961cb8a(d, b) {
    $dad978f951534c1b$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $dad978f951534c1b$export$18ce0697a983be9b = function() {
    $dad978f951534c1b$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $dad978f951534c1b$export$18ce0697a983be9b.apply(this, arguments);
};
function $dad978f951534c1b$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $dad978f951534c1b$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $dad978f951534c1b$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $dad978f951534c1b$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $dad978f951534c1b$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $dad978f951534c1b$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $dad978f951534c1b$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $dad978f951534c1b$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $dad978f951534c1b$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $dad978f951534c1b$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $dad978f951534c1b$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($dad978f951534c1b$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $dad978f951534c1b$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $dad978f951534c1b$export$10c90e4f7922046c(v) {
    return this instanceof $dad978f951534c1b$export$10c90e4f7922046c ? (this.v = v, this) : new $dad978f951534c1b$export$10c90e4f7922046c(v);
}
function $dad978f951534c1b$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $dad978f951534c1b$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $dad978f951534c1b$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $dad978f951534c1b$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $dad978f951534c1b$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $dad978f951534c1b$export$19a8beecd37a4c45 === "function" ? $dad978f951534c1b$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $dad978f951534c1b$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $dad978f951534c1b$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $dad978f951534c1b$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $dad978f951534c1b$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $dad978f951534c1b$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("l2PqA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Sha256 = void 0;

var $3lsNB = parcelRequire("3lsNB");

var $jJO61 = parcelRequire("jJO61");

var $9xch1 = parcelRequire("9xch1");

var $gccJn = parcelRequire("gccJn");

var $1k5an = parcelRequire("1k5an");

var $mnEtn = parcelRequire("mnEtn");
var $f521ad5932afcc31$var$Sha256 = /** @class */ function() {
    function Sha256(secret) {
        if ((0, $gccJn.supportsWebCrypto)((0, $mnEtn.locateWindow)())) this.hash = new $jJO61.Sha256(secret);
        else if ((0, $1k5an.isMsWindow)((0, $mnEtn.locateWindow)())) this.hash = new $3lsNB.Sha256(secret);
        else this.hash = new $9xch1.Sha256(secret);
    }
    Sha256.prototype.update = function(data, encoding) {
        this.hash.update(data, encoding);
    };
    Sha256.prototype.digest = function() {
        return this.hash.digest();
    };
    return Sha256;
}();
module.exports.Sha256 = $f521ad5932afcc31$var$Sha256;

});
parcelRegister("3lsNB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Sha256 = void 0;

var $iuLoM = parcelRequire("iuLoM");

var $4uotu = parcelRequire("4uotu");

var $jJ4yr = parcelRequire("jJ4yr");

var $mnEtn = parcelRequire("mnEtn");
var $26f9ac26dfbc0bba$var$Sha256 = /** @class */ function() {
    function Sha256(secret) {
        if (secret) {
            this.operation = $26f9ac26dfbc0bba$var$getKeyPromise(secret).then(function(keyData) {
                return (0, $mnEtn.locateWindow)().msCrypto.subtle.sign($4uotu.SHA_256_HMAC_ALGO, keyData);
            });
            this.operation.catch(function() {});
        } else this.operation = Promise.resolve((0, $mnEtn.locateWindow)().msCrypto.subtle.digest("SHA-256"));
    }
    Sha256.prototype.update = function(toHash) {
        var _this = this;
        if ((0, $iuLoM.isEmptyData)(toHash)) return;
        this.operation = this.operation.then(function(operation) {
            operation.onerror = function() {
                _this.operation = Promise.reject(new Error("Error encountered updating hash"));
            };
            operation.process($26f9ac26dfbc0bba$var$toArrayBufferView(toHash));
            return operation;
        });
        this.operation.catch(function() {});
    };
    Sha256.prototype.digest = function() {
        return this.operation.then(function(operation) {
            return new Promise(function(resolve, reject) {
                operation.onerror = function() {
                    reject(new Error("Error encountered finalizing hash"));
                };
                operation.oncomplete = function() {
                    if (operation.result) resolve(new Uint8Array(operation.result));
                    reject(new Error("Error encountered finalizing hash"));
                };
                operation.finish();
            });
        });
    };
    return Sha256;
}();
module.exports.Sha256 = $26f9ac26dfbc0bba$var$Sha256;
function $26f9ac26dfbc0bba$var$getKeyPromise(secret) {
    return new Promise(function(resolve, reject) {
        var keyOperation = (0, $mnEtn.locateWindow)().msCrypto.subtle.importKey("raw", $26f9ac26dfbc0bba$var$toArrayBufferView(secret), $4uotu.SHA_256_HMAC_ALGO, false, [
            "sign"
        ]);
        keyOperation.oncomplete = function() {
            if (keyOperation.result) resolve(keyOperation.result);
            reject(new Error("ImportKey completed without importing key."));
        };
        keyOperation.onerror = function() {
            reject(new Error("ImportKey failed to import key."));
        };
    });
}
function $26f9ac26dfbc0bba$var$toArrayBufferView(data) {
    if (typeof data === "string") return (0, $jJ4yr.fromUtf8)(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}

});
parcelRegister("iuLoM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isEmptyData = void 0;
function $d76fcbbffd380f37$var$isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
module.exports.isEmptyData = $d76fcbbffd380f37$var$isEmptyData;

});

parcelRegister("4uotu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EMPTY_DATA_SHA_256 = module.exports.SHA_256_HMAC_ALGO = module.exports.SHA_256_HASH = void 0;
module.exports.SHA_256_HASH = {
    name: "SHA-256"
};
module.exports.SHA_256_HMAC_ALGO = {
    name: "HMAC",
    hash: module.exports.SHA_256_HASH
};
module.exports.EMPTY_DATA_SHA_256 = new Uint8Array([
    227,
    176,
    196,
    66,
    152,
    252,
    28,
    20,
    154,
    251,
    244,
    200,
    153,
    111,
    185,
    36,
    39,
    174,
    65,
    228,
    100,
    155,
    147,
    76,
    164,
    149,
    153,
    27,
    120,
    82,
    184,
    85
]);

});

parcelRegister("jJ4yr", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", () => $e5c5c0b1e659fb9e$export$c7c5cef950a4d2fc);
$parcel$export(module.exports, "toUtf8", () => $e5c5c0b1e659fb9e$export$b4b216764bb846eb);

var $gsibH = parcelRequire("gsibH");

var $6CBNn = parcelRequire("6CBNn");
var $e5c5c0b1e659fb9e$export$c7c5cef950a4d2fc = function(input) {
    return typeof TextEncoder === "function" ? (0, $6CBNn.fromUtf8)(input) : (0, $gsibH.fromUtf8)(input);
};
var $e5c5c0b1e659fb9e$export$b4b216764bb846eb = function(input) {
    return typeof TextDecoder === "function" ? (0, $6CBNn.toUtf8)(input) : (0, $gsibH.toUtf8)(input);
};

});
parcelRegister("gsibH", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", () => $bfad5e8b28cde3ef$export$c7c5cef950a4d2fc);
$parcel$export(module.exports, "toUtf8", () => $bfad5e8b28cde3ef$export$b4b216764bb846eb);
/**
 * Converts a JS string from its native UCS-2/UTF-16 representation into a
 * Uint8Array of the bytes used to represent the equivalent characters in UTF-8.
 *
 * Cribbed from the `goog.crypt.stringToUtf8ByteArray` function in the Google
 * Closure library, though updated to use typed arrays.
 */ var $bfad5e8b28cde3ef$export$c7c5cef950a4d2fc = function(input) {
    var bytes = [];
    for(var i = 0, len = input.length; i < len; i++){
        var value = input.charCodeAt(i);
        if (value < 0x80) bytes.push(value);
        else if (value < 0x800) bytes.push(value >> 6 | 192, value & 63 | 128);
        else if (i + 1 < input.length && (value & 0xfc00) === 0xd800 && (input.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            var surrogatePair = 0x10000 + ((value & 1023) << 10) + (input.charCodeAt(++i) & 1023);
            bytes.push(surrogatePair >> 18 | 240, surrogatePair >> 12 & 63 | 128, surrogatePair >> 6 & 63 | 128, surrogatePair & 63 | 128);
        } else bytes.push(value >> 12 | 224, value >> 6 & 63 | 128, value & 63 | 128);
    }
    return Uint8Array.from(bytes);
};
var $bfad5e8b28cde3ef$export$b4b216764bb846eb = function(input) {
    var decoded = "";
    for(var i = 0, len = input.length; i < len; i++){
        var byte = input[i];
        if (byte < 0x80) decoded += String.fromCharCode(byte);
        else if (192 <= byte && byte < 224) {
            var nextByte = input[++i];
            decoded += String.fromCharCode((byte & 31) << 6 | nextByte & 63);
        } else if (240 <= byte && byte < 365) {
            var surrogatePair = [
                byte,
                input[++i],
                input[++i],
                input[++i]
            ];
            var encoded = "%" + surrogatePair.map(function(byteValue) {
                return byteValue.toString(16);
            }).join("%");
            decoded += decodeURIComponent(encoded);
        } else decoded += String.fromCharCode((byte & 15) << 12 | (input[++i] & 63) << 6 | input[++i] & 63);
    }
    return decoded;
};

});

parcelRegister("6CBNn", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", () => $4d239c0b9e96d1dc$export$c7c5cef950a4d2fc);
$parcel$export(module.exports, "toUtf8", () => $4d239c0b9e96d1dc$export$b4b216764bb846eb);
function $4d239c0b9e96d1dc$export$c7c5cef950a4d2fc(input) {
    return new TextEncoder().encode(input);
}
function $4d239c0b9e96d1dc$export$b4b216764bb846eb(input) {
    return new TextDecoder("utf-8").decode(input);
}

});


parcelRegister("mnEtn", function(module, exports) {

$parcel$export(module.exports, "locateWindow", () => $043466f0ff5d9b95$export$2a77db4d0e0dd1ff);
const $043466f0ff5d9b95$var$fallbackWindow = {};
function $043466f0ff5d9b95$export$2a77db4d0e0dd1ff() {
    if (typeof window !== "undefined") return window;
    else if (typeof self !== "undefined") return self;
    return $043466f0ff5d9b95$var$fallbackWindow;
}

});


parcelRegister("jJO61", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Sha256 = void 0;

var $ezR3Y = parcelRequire("ezR3Y");

var $4uotu = parcelRequire("4uotu");

var $mnEtn = parcelRequire("mnEtn");
var $e5e914558e044bf6$var$Sha256 = /** @class */ function() {
    function Sha256(secret) {
        this.toHash = new Uint8Array(0);
        if (secret !== void 0) {
            this.key = new Promise(function(resolve, reject) {
                (0, $mnEtn.locateWindow)().crypto.subtle.importKey("raw", (0, $ezR3Y.convertToBuffer)(secret), $4uotu.SHA_256_HMAC_ALGO, false, [
                    "sign"
                ]).then(resolve, reject);
            });
            this.key.catch(function() {});
        }
    }
    Sha256.prototype.update = function(data) {
        if ((0, $ezR3Y.isEmptyData)(data)) return;
        var update = (0, $ezR3Y.convertToBuffer)(data);
        var typedArray = new Uint8Array(this.toHash.byteLength + update.byteLength);
        typedArray.set(this.toHash, 0);
        typedArray.set(update, this.toHash.byteLength);
        this.toHash = typedArray;
    };
    Sha256.prototype.digest = function() {
        var _this = this;
        if (this.key) return this.key.then(function(key) {
            return (0, $mnEtn.locateWindow)().crypto.subtle.sign($4uotu.SHA_256_HMAC_ALGO, key, _this.toHash).then(function(data) {
                return new Uint8Array(data);
            });
        });
        if ((0, $ezR3Y.isEmptyData)(this.toHash)) return Promise.resolve($4uotu.EMPTY_DATA_SHA_256);
        return Promise.resolve().then(function() {
            return (0, $mnEtn.locateWindow)().crypto.subtle.digest($4uotu.SHA_256_HASH, _this.toHash);
        }).then(function(data) {
            return Promise.resolve(new Uint8Array(data));
        });
    };
    return Sha256;
}();
module.exports.Sha256 = $e5e914558e044bf6$var$Sha256;

});
parcelRegister("ezR3Y", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.uint32ArrayFrom = module.exports.numToUint8 = module.exports.isEmptyData = module.exports.convertToBuffer = void 0;

var $l8JSx = parcelRequire("l8JSx");
Object.defineProperty(module.exports, "convertToBuffer", {
    enumerable: true,
    get: function() {
        return $l8JSx.convertToBuffer;
    }
});

var $bYJDc = parcelRequire("bYJDc");
Object.defineProperty(module.exports, "isEmptyData", {
    enumerable: true,
    get: function() {
        return $bYJDc.isEmptyData;
    }
});

var $kyYFf = parcelRequire("kyYFf");
Object.defineProperty(module.exports, "numToUint8", {
    enumerable: true,
    get: function() {
        return $kyYFf.numToUint8;
    }
});

var $hGQmZ = parcelRequire("hGQmZ");
Object.defineProperty(module.exports, "uint32ArrayFrom", {
    enumerable: true,
    get: function() {
        return $hGQmZ.uint32ArrayFrom;
    }
});

});
parcelRegister("l8JSx", function(module, exports) {

var $j4MAF = parcelRequire("j4MAF");
var $f63deed99187ad9f$require$Buffer = $j4MAF.Buffer;
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.convertToBuffer = void 0;

var $jJ4yr = parcelRequire("jJ4yr");
// Quick polyfill
var $f63deed99187ad9f$var$fromUtf8 = typeof $f63deed99187ad9f$require$Buffer !== "undefined" && $f63deed99187ad9f$require$Buffer.from ? function(input) {
    return $f63deed99187ad9f$require$Buffer.from(input, "utf8");
} : $jJ4yr.fromUtf8;
function $f63deed99187ad9f$var$convertToBuffer(data) {
    // Already a Uint8, do nothing
    if (data instanceof Uint8Array) return data;
    if (typeof data === "string") return $f63deed99187ad9f$var$fromUtf8(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}
module.exports.convertToBuffer = $f63deed99187ad9f$var$convertToBuffer;

});
parcelRegister("j4MAF", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $de341515c1cf3eef$export$a143d493d941bafc, (v) => $de341515c1cf3eef$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $de341515c1cf3eef$export$f99ded8fe4b79145, (v) => $de341515c1cf3eef$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $de341515c1cf3eef$export$a143d493d941bafc;
var $de341515c1cf3eef$export$e4cf37d7f6fb9e0a;
var $de341515c1cf3eef$export$f99ded8fe4b79145;
var $de341515c1cf3eef$export$599f31c3813fae4d;
'use strict';

var $16jlG = parcelRequire("16jlG");

var $aSYRj = parcelRequire("aSYRj");
const $de341515c1cf3eef$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$de341515c1cf3eef$export$a143d493d941bafc = $de341515c1cf3eef$var$Buffer;
$de341515c1cf3eef$export$e4cf37d7f6fb9e0a = $de341515c1cf3eef$var$SlowBuffer;
$de341515c1cf3eef$export$f99ded8fe4b79145 = 50;
const $de341515c1cf3eef$var$K_MAX_LENGTH = 0x7fffffff;
$de341515c1cf3eef$export$599f31c3813fae4d = $de341515c1cf3eef$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $de341515c1cf3eef$var$Buffer.TYPED_ARRAY_SUPPORT = $de341515c1cf3eef$var$typedArraySupport();
if (!$de341515c1cf3eef$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $de341515c1cf3eef$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($de341515c1cf3eef$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$de341515c1cf3eef$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($de341515c1cf3eef$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$de341515c1cf3eef$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $de341515c1cf3eef$var$createBuffer(length) {
    if (length > $de341515c1cf3eef$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $de341515c1cf3eef$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $de341515c1cf3eef$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $de341515c1cf3eef$var$allocUnsafe(arg);
    }
    return $de341515c1cf3eef$var$from(arg, encodingOrOffset, length);
}
$de341515c1cf3eef$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $de341515c1cf3eef$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $de341515c1cf3eef$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $de341515c1cf3eef$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($de341515c1cf3eef$var$isInstance(value, ArrayBuffer) || value && $de341515c1cf3eef$var$isInstance(value.buffer, ArrayBuffer)) return $de341515c1cf3eef$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($de341515c1cf3eef$var$isInstance(value, SharedArrayBuffer) || value && $de341515c1cf3eef$var$isInstance(value.buffer, SharedArrayBuffer))) return $de341515c1cf3eef$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $de341515c1cf3eef$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $de341515c1cf3eef$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $de341515c1cf3eef$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $de341515c1cf3eef$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $de341515c1cf3eef$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($de341515c1cf3eef$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($de341515c1cf3eef$var$Buffer, Uint8Array);
function $de341515c1cf3eef$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $de341515c1cf3eef$var$alloc(size, fill, encoding) {
    $de341515c1cf3eef$var$assertSize(size);
    if (size <= 0) return $de341515c1cf3eef$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $de341515c1cf3eef$var$createBuffer(size).fill(fill, encoding) : $de341515c1cf3eef$var$createBuffer(size).fill(fill);
    return $de341515c1cf3eef$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $de341515c1cf3eef$var$Buffer.alloc = function(size, fill, encoding) {
    return $de341515c1cf3eef$var$alloc(size, fill, encoding);
};
function $de341515c1cf3eef$var$allocUnsafe(size) {
    $de341515c1cf3eef$var$assertSize(size);
    return $de341515c1cf3eef$var$createBuffer(size < 0 ? 0 : $de341515c1cf3eef$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $de341515c1cf3eef$var$Buffer.allocUnsafe = function(size) {
    return $de341515c1cf3eef$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $de341515c1cf3eef$var$Buffer.allocUnsafeSlow = function(size) {
    return $de341515c1cf3eef$var$allocUnsafe(size);
};
function $de341515c1cf3eef$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$de341515c1cf3eef$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $de341515c1cf3eef$var$byteLength(string, encoding) | 0;
    let buf = $de341515c1cf3eef$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $de341515c1cf3eef$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $de341515c1cf3eef$var$checked(array.length) | 0;
    const buf = $de341515c1cf3eef$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $de341515c1cf3eef$var$fromArrayView(arrayView) {
    if ($de341515c1cf3eef$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $de341515c1cf3eef$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $de341515c1cf3eef$var$fromArrayLike(arrayView);
}
function $de341515c1cf3eef$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $de341515c1cf3eef$var$Buffer.prototype);
    return buf;
}
function $de341515c1cf3eef$var$fromObject(obj) {
    if ($de341515c1cf3eef$var$Buffer.isBuffer(obj)) {
        const len = $de341515c1cf3eef$var$checked(obj.length) | 0;
        const buf = $de341515c1cf3eef$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $de341515c1cf3eef$var$numberIsNaN(obj.length)) return $de341515c1cf3eef$var$createBuffer(0);
        return $de341515c1cf3eef$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $de341515c1cf3eef$var$fromArrayLike(obj.data);
}
function $de341515c1cf3eef$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $de341515c1cf3eef$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $de341515c1cf3eef$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $de341515c1cf3eef$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $de341515c1cf3eef$var$Buffer.alloc(+length);
}
$de341515c1cf3eef$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $de341515c1cf3eef$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$de341515c1cf3eef$var$Buffer.compare = function compare(a, b) {
    if ($de341515c1cf3eef$var$isInstance(a, Uint8Array)) a = $de341515c1cf3eef$var$Buffer.from(a, a.offset, a.byteLength);
    if ($de341515c1cf3eef$var$isInstance(b, Uint8Array)) b = $de341515c1cf3eef$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$de341515c1cf3eef$var$Buffer.isBuffer(a) || !$de341515c1cf3eef$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$de341515c1cf3eef$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$de341515c1cf3eef$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $de341515c1cf3eef$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $de341515c1cf3eef$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($de341515c1cf3eef$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$de341515c1cf3eef$var$Buffer.isBuffer(buf)) buf = $de341515c1cf3eef$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$de341515c1cf3eef$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $de341515c1cf3eef$var$byteLength(string, encoding) {
    if ($de341515c1cf3eef$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $de341515c1cf3eef$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $de341515c1cf3eef$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $de341515c1cf3eef$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $de341515c1cf3eef$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$de341515c1cf3eef$var$Buffer.byteLength = $de341515c1cf3eef$var$byteLength;
function $de341515c1cf3eef$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $de341515c1cf3eef$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $de341515c1cf3eef$var$utf8Slice(this, start, end);
        case 'ascii':
            return $de341515c1cf3eef$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $de341515c1cf3eef$var$latin1Slice(this, start, end);
        case 'base64':
            return $de341515c1cf3eef$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $de341515c1cf3eef$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$de341515c1cf3eef$var$Buffer.prototype._isBuffer = true;
function $de341515c1cf3eef$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$de341515c1cf3eef$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$de341515c1cf3eef$var$swap(this, i, i + 1);
    return this;
};
$de341515c1cf3eef$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $de341515c1cf3eef$var$swap(this, i, i + 3);
        $de341515c1cf3eef$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$de341515c1cf3eef$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $de341515c1cf3eef$var$swap(this, i, i + 7);
        $de341515c1cf3eef$var$swap(this, i + 1, i + 6);
        $de341515c1cf3eef$var$swap(this, i + 2, i + 5);
        $de341515c1cf3eef$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$de341515c1cf3eef$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $de341515c1cf3eef$var$utf8Slice(this, 0, length);
    return $de341515c1cf3eef$var$slowToString.apply(this, arguments);
};
$de341515c1cf3eef$var$Buffer.prototype.toLocaleString = $de341515c1cf3eef$var$Buffer.prototype.toString;
$de341515c1cf3eef$var$Buffer.prototype.equals = function equals(b) {
    if (!$de341515c1cf3eef$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $de341515c1cf3eef$var$Buffer.compare(this, b) === 0;
};
$de341515c1cf3eef$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $de341515c1cf3eef$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($de341515c1cf3eef$var$customInspectSymbol) $de341515c1cf3eef$var$Buffer.prototype[$de341515c1cf3eef$var$customInspectSymbol] = $de341515c1cf3eef$var$Buffer.prototype.inspect;
$de341515c1cf3eef$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($de341515c1cf3eef$var$isInstance(target, Uint8Array)) target = $de341515c1cf3eef$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$de341515c1cf3eef$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $de341515c1cf3eef$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($de341515c1cf3eef$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $de341515c1cf3eef$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($de341515c1cf3eef$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $de341515c1cf3eef$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $de341515c1cf3eef$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $de341515c1cf3eef$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$de341515c1cf3eef$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$de341515c1cf3eef$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $de341515c1cf3eef$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$de341515c1cf3eef$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $de341515c1cf3eef$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $de341515c1cf3eef$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($de341515c1cf3eef$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $de341515c1cf3eef$var$utf8Write(buf, string, offset, length) {
    return $de341515c1cf3eef$var$blitBuffer($de341515c1cf3eef$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $de341515c1cf3eef$var$asciiWrite(buf, string, offset, length) {
    return $de341515c1cf3eef$var$blitBuffer($de341515c1cf3eef$var$asciiToBytes(string), buf, offset, length);
}
function $de341515c1cf3eef$var$base64Write(buf, string, offset, length) {
    return $de341515c1cf3eef$var$blitBuffer($de341515c1cf3eef$var$base64ToBytes(string), buf, offset, length);
}
function $de341515c1cf3eef$var$ucs2Write(buf, string, offset, length) {
    return $de341515c1cf3eef$var$blitBuffer($de341515c1cf3eef$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$de341515c1cf3eef$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $de341515c1cf3eef$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $de341515c1cf3eef$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $de341515c1cf3eef$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $de341515c1cf3eef$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $de341515c1cf3eef$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$de341515c1cf3eef$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $de341515c1cf3eef$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $16jlG.fromByteArray(buf);
    else return $16jlG.fromByteArray(buf.slice(start, end));
}
function $de341515c1cf3eef$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $de341515c1cf3eef$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $de341515c1cf3eef$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $de341515c1cf3eef$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $de341515c1cf3eef$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $de341515c1cf3eef$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $de341515c1cf3eef$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $de341515c1cf3eef$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $de341515c1cf3eef$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $de341515c1cf3eef$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $de341515c1cf3eef$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$de341515c1cf3eef$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $de341515c1cf3eef$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $de341515c1cf3eef$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$de341515c1cf3eef$var$Buffer.prototype.readUintLE = $de341515c1cf3eef$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $de341515c1cf3eef$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$de341515c1cf3eef$var$Buffer.prototype.readUintBE = $de341515c1cf3eef$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $de341515c1cf3eef$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$de341515c1cf3eef$var$Buffer.prototype.readUint8 = $de341515c1cf3eef$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $de341515c1cf3eef$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$de341515c1cf3eef$var$Buffer.prototype.readUint16LE = $de341515c1cf3eef$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $de341515c1cf3eef$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$de341515c1cf3eef$var$Buffer.prototype.readUint16BE = $de341515c1cf3eef$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $de341515c1cf3eef$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$de341515c1cf3eef$var$Buffer.prototype.readUint32LE = $de341515c1cf3eef$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $de341515c1cf3eef$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$de341515c1cf3eef$var$Buffer.prototype.readUint32BE = $de341515c1cf3eef$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $de341515c1cf3eef$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$de341515c1cf3eef$var$Buffer.prototype.readBigUInt64LE = $de341515c1cf3eef$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $de341515c1cf3eef$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $de341515c1cf3eef$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$de341515c1cf3eef$var$Buffer.prototype.readBigUInt64BE = $de341515c1cf3eef$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $de341515c1cf3eef$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $de341515c1cf3eef$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$de341515c1cf3eef$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $de341515c1cf3eef$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$de341515c1cf3eef$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $de341515c1cf3eef$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$de341515c1cf3eef$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $de341515c1cf3eef$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$de341515c1cf3eef$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $de341515c1cf3eef$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$de341515c1cf3eef$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $de341515c1cf3eef$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$de341515c1cf3eef$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $de341515c1cf3eef$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$de341515c1cf3eef$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $de341515c1cf3eef$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$de341515c1cf3eef$var$Buffer.prototype.readBigInt64LE = $de341515c1cf3eef$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $de341515c1cf3eef$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $de341515c1cf3eef$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$de341515c1cf3eef$var$Buffer.prototype.readBigInt64BE = $de341515c1cf3eef$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $de341515c1cf3eef$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $de341515c1cf3eef$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$de341515c1cf3eef$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $de341515c1cf3eef$var$checkOffset(offset, 4, this.length);
    return $aSYRj.read(this, offset, true, 23, 4);
};
$de341515c1cf3eef$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $de341515c1cf3eef$var$checkOffset(offset, 4, this.length);
    return $aSYRj.read(this, offset, false, 23, 4);
};
$de341515c1cf3eef$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $de341515c1cf3eef$var$checkOffset(offset, 8, this.length);
    return $aSYRj.read(this, offset, true, 52, 8);
};
$de341515c1cf3eef$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $de341515c1cf3eef$var$checkOffset(offset, 8, this.length);
    return $aSYRj.read(this, offset, false, 52, 8);
};
function $de341515c1cf3eef$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$de341515c1cf3eef$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$de341515c1cf3eef$var$Buffer.prototype.writeUintLE = $de341515c1cf3eef$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $de341515c1cf3eef$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$de341515c1cf3eef$var$Buffer.prototype.writeUintBE = $de341515c1cf3eef$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $de341515c1cf3eef$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$de341515c1cf3eef$var$Buffer.prototype.writeUint8 = $de341515c1cf3eef$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $de341515c1cf3eef$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$de341515c1cf3eef$var$Buffer.prototype.writeUint16LE = $de341515c1cf3eef$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $de341515c1cf3eef$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$de341515c1cf3eef$var$Buffer.prototype.writeUint16BE = $de341515c1cf3eef$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $de341515c1cf3eef$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$de341515c1cf3eef$var$Buffer.prototype.writeUint32LE = $de341515c1cf3eef$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $de341515c1cf3eef$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$de341515c1cf3eef$var$Buffer.prototype.writeUint32BE = $de341515c1cf3eef$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $de341515c1cf3eef$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $de341515c1cf3eef$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $de341515c1cf3eef$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $de341515c1cf3eef$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $de341515c1cf3eef$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$de341515c1cf3eef$var$Buffer.prototype.writeBigUInt64LE = $de341515c1cf3eef$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $de341515c1cf3eef$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$de341515c1cf3eef$var$Buffer.prototype.writeBigUInt64BE = $de341515c1cf3eef$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $de341515c1cf3eef$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$de341515c1cf3eef$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $de341515c1cf3eef$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$de341515c1cf3eef$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $de341515c1cf3eef$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$de341515c1cf3eef$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $de341515c1cf3eef$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$de341515c1cf3eef$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $de341515c1cf3eef$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$de341515c1cf3eef$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $de341515c1cf3eef$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$de341515c1cf3eef$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $de341515c1cf3eef$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$de341515c1cf3eef$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $de341515c1cf3eef$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$de341515c1cf3eef$var$Buffer.prototype.writeBigInt64LE = $de341515c1cf3eef$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $de341515c1cf3eef$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$de341515c1cf3eef$var$Buffer.prototype.writeBigInt64BE = $de341515c1cf3eef$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $de341515c1cf3eef$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $de341515c1cf3eef$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $de341515c1cf3eef$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $de341515c1cf3eef$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $aSYRj.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$de341515c1cf3eef$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $de341515c1cf3eef$var$writeFloat(this, value, offset, true, noAssert);
};
$de341515c1cf3eef$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $de341515c1cf3eef$var$writeFloat(this, value, offset, false, noAssert);
};
function $de341515c1cf3eef$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $de341515c1cf3eef$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $aSYRj.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$de341515c1cf3eef$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $de341515c1cf3eef$var$writeDouble(this, value, offset, true, noAssert);
};
$de341515c1cf3eef$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $de341515c1cf3eef$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$de341515c1cf3eef$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$de341515c1cf3eef$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$de341515c1cf3eef$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$de341515c1cf3eef$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $de341515c1cf3eef$var$Buffer.isBuffer(val) ? val : $de341515c1cf3eef$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $de341515c1cf3eef$var$errors = {};
function $de341515c1cf3eef$var$E(sym, getMessage, Base) {
    $de341515c1cf3eef$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$de341515c1cf3eef$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$de341515c1cf3eef$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$de341515c1cf3eef$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $de341515c1cf3eef$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $de341515c1cf3eef$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $de341515c1cf3eef$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $de341515c1cf3eef$var$checkBounds(buf, offset, byteLength) {
    $de341515c1cf3eef$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $de341515c1cf3eef$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $de341515c1cf3eef$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $de341515c1cf3eef$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $de341515c1cf3eef$var$checkBounds(buf, offset, byteLength);
}
function $de341515c1cf3eef$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $de341515c1cf3eef$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $de341515c1cf3eef$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $de341515c1cf3eef$var$validateNumber(value, type);
        throw new $de341515c1cf3eef$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $de341515c1cf3eef$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $de341515c1cf3eef$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $de341515c1cf3eef$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $de341515c1cf3eef$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($de341515c1cf3eef$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $de341515c1cf3eef$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $de341515c1cf3eef$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $de341515c1cf3eef$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $de341515c1cf3eef$var$base64ToBytes(str) {
    return $16jlG.toByteArray($de341515c1cf3eef$var$base64clean(str));
}
function $de341515c1cf3eef$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $de341515c1cf3eef$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $de341515c1cf3eef$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $de341515c1cf3eef$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $de341515c1cf3eef$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $de341515c1cf3eef$var$BufferBigIntNotDefined : fn;
}
function $de341515c1cf3eef$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("16jlG", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $0cd55c3e4b693fcf$export$d622b2ad8d90c771, (v) => $0cd55c3e4b693fcf$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $0cd55c3e4b693fcf$export$6100ba28696e12de, (v) => $0cd55c3e4b693fcf$export$6100ba28696e12de = v);
var $0cd55c3e4b693fcf$export$a48f0734ac7c2329;
var $0cd55c3e4b693fcf$export$d622b2ad8d90c771;
var $0cd55c3e4b693fcf$export$6100ba28696e12de;
'use strict';
$0cd55c3e4b693fcf$export$a48f0734ac7c2329 = $0cd55c3e4b693fcf$var$byteLength;
$0cd55c3e4b693fcf$export$d622b2ad8d90c771 = $0cd55c3e4b693fcf$var$toByteArray;
$0cd55c3e4b693fcf$export$6100ba28696e12de = $0cd55c3e4b693fcf$var$fromByteArray;
var $0cd55c3e4b693fcf$var$lookup = [];
var $0cd55c3e4b693fcf$var$revLookup = [];
var $0cd55c3e4b693fcf$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $0cd55c3e4b693fcf$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $0cd55c3e4b693fcf$var$i = 0, $0cd55c3e4b693fcf$var$len = $0cd55c3e4b693fcf$var$code.length; $0cd55c3e4b693fcf$var$i < $0cd55c3e4b693fcf$var$len; ++$0cd55c3e4b693fcf$var$i){
    $0cd55c3e4b693fcf$var$lookup[$0cd55c3e4b693fcf$var$i] = $0cd55c3e4b693fcf$var$code[$0cd55c3e4b693fcf$var$i];
    $0cd55c3e4b693fcf$var$revLookup[$0cd55c3e4b693fcf$var$code.charCodeAt($0cd55c3e4b693fcf$var$i)] = $0cd55c3e4b693fcf$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$0cd55c3e4b693fcf$var$revLookup['-'.charCodeAt(0)] = 62;
$0cd55c3e4b693fcf$var$revLookup['_'.charCodeAt(0)] = 63;
function $0cd55c3e4b693fcf$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $0cd55c3e4b693fcf$var$byteLength(b64) {
    var lens = $0cd55c3e4b693fcf$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $0cd55c3e4b693fcf$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $0cd55c3e4b693fcf$var$toByteArray(b64) {
    var tmp;
    var lens = $0cd55c3e4b693fcf$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $0cd55c3e4b693fcf$var$Arr($0cd55c3e4b693fcf$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $0cd55c3e4b693fcf$var$revLookup[b64.charCodeAt(i)] << 18 | $0cd55c3e4b693fcf$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $0cd55c3e4b693fcf$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $0cd55c3e4b693fcf$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $0cd55c3e4b693fcf$var$revLookup[b64.charCodeAt(i)] << 2 | $0cd55c3e4b693fcf$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $0cd55c3e4b693fcf$var$revLookup[b64.charCodeAt(i)] << 10 | $0cd55c3e4b693fcf$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $0cd55c3e4b693fcf$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $0cd55c3e4b693fcf$var$tripletToBase64(num) {
    return $0cd55c3e4b693fcf$var$lookup[num >> 18 & 0x3F] + $0cd55c3e4b693fcf$var$lookup[num >> 12 & 0x3F] + $0cd55c3e4b693fcf$var$lookup[num >> 6 & 0x3F] + $0cd55c3e4b693fcf$var$lookup[num & 0x3F];
}
function $0cd55c3e4b693fcf$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($0cd55c3e4b693fcf$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $0cd55c3e4b693fcf$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($0cd55c3e4b693fcf$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($0cd55c3e4b693fcf$var$lookup[tmp >> 2] + $0cd55c3e4b693fcf$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($0cd55c3e4b693fcf$var$lookup[tmp >> 10] + $0cd55c3e4b693fcf$var$lookup[tmp >> 4 & 0x3F] + $0cd55c3e4b693fcf$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("aSYRj", function(module, exports) {

$parcel$export(module.exports, "read", () => $7ece27d709b3fea6$export$aafa59e2e03f2942, (v) => $7ece27d709b3fea6$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7ece27d709b3fea6$export$68d8715fc104d294, (v) => $7ece27d709b3fea6$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7ece27d709b3fea6$export$aafa59e2e03f2942;
var $7ece27d709b3fea6$export$68d8715fc104d294;
$7ece27d709b3fea6$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7ece27d709b3fea6$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});



parcelRegister("bYJDc", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isEmptyData = void 0;
function $8b88b1bd942c8bc5$var$isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
module.exports.isEmptyData = $8b88b1bd942c8bc5$var$isEmptyData;

});

parcelRegister("kyYFf", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.numToUint8 = void 0;
function $ef860a494f846229$var$numToUint8(num) {
    return new Uint8Array([
        (num & 0xff000000) >> 24,
        (num & 0x00ff0000) >> 16,
        (num & 0x0000ff00) >> 8,
        num & 0x000000ff
    ]);
}
module.exports.numToUint8 = $ef860a494f846229$var$numToUint8;

});

parcelRegister("hGQmZ", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.uint32ArrayFrom = void 0;
// IE 11 does not support Array.from, so we do it manually
function $ce0efb7239065a97$var$uint32ArrayFrom(a_lookUpTable) {
    if (!Array.from) {
        var return_array = new Uint32Array(a_lookUpTable.length);
        var a_index = 0;
        while(a_index < a_lookUpTable.length)return_array[a_index] = a_lookUpTable[a_index];
        return return_array;
    }
    return Uint32Array.from(a_lookUpTable);
}
module.exports.uint32ArrayFrom = $ce0efb7239065a97$var$uint32ArrayFrom;

});



parcelRegister("9xch1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $iMVHR = parcelRequire("iMVHR");

(0, $iMVHR.__exportStar)((parcelRequire("2F5Gk")), module.exports);

});
parcelRegister("2F5Gk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Sha256 = void 0;

var $iMVHR = parcelRequire("iMVHR");

var $9BI86 = parcelRequire("9BI86");

var $fU3Zt = parcelRequire("fU3Zt");

var $ezR3Y = parcelRequire("ezR3Y");
var $1f03d1648c928440$var$Sha256 = /** @class */ function() {
    function Sha256(secret) {
        this.hash = new $fU3Zt.RawSha256();
        if (secret) {
            this.outer = new $fU3Zt.RawSha256();
            var inner = $1f03d1648c928440$var$bufferFromSecret(secret);
            var outer = new Uint8Array($9BI86.BLOCK_SIZE);
            outer.set(inner);
            for(var i = 0; i < $9BI86.BLOCK_SIZE; i++){
                inner[i] ^= 0x36;
                outer[i] ^= 0x5c;
            }
            this.hash.update(inner);
            this.outer.update(outer);
            // overwrite the copied key in memory
            for(var i = 0; i < inner.byteLength; i++)inner[i] = 0;
        }
    }
    Sha256.prototype.update = function(toHash) {
        if ((0, $ezR3Y.isEmptyData)(toHash) || this.error) return;
        try {
            this.hash.update((0, $ezR3Y.convertToBuffer)(toHash));
        } catch (e) {
            this.error = e;
        }
    };
    /* This synchronous method keeps compatibility
     * with the v2 aws-sdk.
     */ Sha256.prototype.digestSync = function() {
        if (this.error) throw this.error;
        if (this.outer) {
            if (!this.outer.finished) this.outer.update(this.hash.digest());
            return this.outer.digest();
        }
        return this.hash.digest();
    };
    /* The underlying digest method here is synchronous.
     * To keep the same interface with the other hash functions
     * the default is to expose this as an async method.
     * However, it can sometimes be useful to have a sync method.
     */ Sha256.prototype.digest = function() {
        return (0, $iMVHR.__awaiter)(this, void 0, void 0, function() {
            return (0, $iMVHR.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.digestSync()
                ];
            });
        });
    };
    return Sha256;
}();
module.exports.Sha256 = $1f03d1648c928440$var$Sha256;
function $1f03d1648c928440$var$bufferFromSecret(secret) {
    var input = (0, $ezR3Y.convertToBuffer)(secret);
    if (input.byteLength > $9BI86.BLOCK_SIZE) {
        var bufferHash = new $fU3Zt.RawSha256();
        bufferHash.update(input);
        input = bufferHash.digest();
    }
    var buffer = new Uint8Array($9BI86.BLOCK_SIZE);
    buffer.set(input);
    return buffer;
}

});
parcelRegister("9BI86", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MAX_HASHABLE_LENGTH = module.exports.INIT = module.exports.KEY = module.exports.DIGEST_LENGTH = module.exports.BLOCK_SIZE = void 0;
/**
 * @internal
 */ module.exports.BLOCK_SIZE = 64;
/**
 * @internal
 */ module.exports.DIGEST_LENGTH = 32;
/**
 * @internal
 */ module.exports.KEY = new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
/**
 * @internal
 */ module.exports.INIT = [
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
];
/**
 * @internal
 */ module.exports.MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;

});

parcelRegister("fU3Zt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RawSha256 = void 0;

var $9BI86 = parcelRequire("9BI86");
/**
 * @internal
 */ var $b93f2e67c778a3fe$var$RawSha256 = /** @class */ function() {
    function RawSha256() {
        this.state = Int32Array.from($9BI86.INIT);
        this.temp = new Int32Array(64);
        this.buffer = new Uint8Array(64);
        this.bufferLength = 0;
        this.bytesHashed = 0;
        /**
         * @internal
         */ this.finished = false;
    }
    RawSha256.prototype.update = function(data) {
        if (this.finished) throw new Error("Attempted to update an already finished hash.");
        var position = 0;
        var byteLength = data.byteLength;
        this.bytesHashed += byteLength;
        if (this.bytesHashed * 8 > $9BI86.MAX_HASHABLE_LENGTH) throw new Error("Cannot hash more than 2^53 - 1 bits");
        while(byteLength > 0){
            this.buffer[this.bufferLength++] = data[position++];
            byteLength--;
            if (this.bufferLength === $9BI86.BLOCK_SIZE) {
                this.hashBuffer();
                this.bufferLength = 0;
            }
        }
    };
    RawSha256.prototype.digest = function() {
        if (!this.finished) {
            var bitsHashed = this.bytesHashed * 8;
            var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
            var undecoratedLength = this.bufferLength;
            bufferView.setUint8(this.bufferLength++, 0x80);
            // Ensure the final block has enough room for the hashed length
            if (undecoratedLength % $9BI86.BLOCK_SIZE >= $9BI86.BLOCK_SIZE - 8) {
                for(var i = this.bufferLength; i < $9BI86.BLOCK_SIZE; i++)bufferView.setUint8(i, 0);
                this.hashBuffer();
                this.bufferLength = 0;
            }
            for(var i = this.bufferLength; i < $9BI86.BLOCK_SIZE - 8; i++)bufferView.setUint8(i, 0);
            bufferView.setUint32($9BI86.BLOCK_SIZE - 8, Math.floor(bitsHashed / 0x100000000), true);
            bufferView.setUint32($9BI86.BLOCK_SIZE - 4, bitsHashed);
            this.hashBuffer();
            this.finished = true;
        }
        // The value in state is little-endian rather than big-endian, so flip
        // each word into a new Uint8Array
        var out = new Uint8Array($9BI86.DIGEST_LENGTH);
        for(var i = 0; i < 8; i++){
            out[i * 4] = this.state[i] >>> 24 & 0xff;
            out[i * 4 + 1] = this.state[i] >>> 16 & 0xff;
            out[i * 4 + 2] = this.state[i] >>> 8 & 0xff;
            out[i * 4 + 3] = this.state[i] >>> 0 & 0xff;
        }
        return out;
    };
    RawSha256.prototype.hashBuffer = function() {
        var _a = this, buffer = _a.buffer, state = _a.state;
        var state0 = state[0], state1 = state[1], state2 = state[2], state3 = state[3], state4 = state[4], state5 = state[5], state6 = state[6], state7 = state[7];
        for(var i = 0; i < $9BI86.BLOCK_SIZE; i++){
            if (i < 16) this.temp[i] = (buffer[i * 4] & 0xff) << 24 | (buffer[i * 4 + 1] & 0xff) << 16 | (buffer[i * 4 + 2] & 0xff) << 8 | buffer[i * 4 + 3] & 0xff;
            else {
                var u = this.temp[i - 2];
                var t1_1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
                u = this.temp[i - 15];
                var t2_1 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
                this.temp[i] = (t1_1 + this.temp[i - 7] | 0) + (t2_1 + this.temp[i - 16] | 0);
            }
            var t1 = (((state4 >>> 6 | state4 << 26) ^ (state4 >>> 11 | state4 << 21) ^ (state4 >>> 25 | state4 << 7)) + (state4 & state5 ^ ~state4 & state6) | 0) + (state7 + ($9BI86.KEY[i] + this.temp[i] | 0) | 0) | 0;
            var t2 = ((state0 >>> 2 | state0 << 30) ^ (state0 >>> 13 | state0 << 19) ^ (state0 >>> 22 | state0 << 10)) + (state0 & state1 ^ state0 & state2 ^ state1 & state2) | 0;
            state7 = state6;
            state6 = state5;
            state5 = state4;
            state4 = state3 + t1 | 0;
            state3 = state2;
            state2 = state1;
            state1 = state0;
            state0 = t1 + t2 | 0;
        }
        state[0] += state0;
        state[1] += state1;
        state[2] += state2;
        state[3] += state3;
        state[4] += state4;
        state[5] += state5;
        state[6] += state6;
        state[7] += state7;
    };
    return RawSha256;
}();
module.exports.RawSha256 = $b93f2e67c778a3fe$var$RawSha256;

});



parcelRegister("gccJn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $bHlav = parcelRequire("bHlav");

$bHlav.__exportStar((parcelRequire("81cRv")), module.exports);

});
parcelRegister("bHlav", function(module, exports) {

$parcel$export(module.exports, "__awaiter", () => $88442176cc5ad79e$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $88442176cc5ad79e$export$67ebef60e6f28a6);
$parcel$export(module.exports, "__exportStar", () => $88442176cc5ad79e$export$f33643c0debef087);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $88442176cc5ad79e$var$extendStatics = function(d, b) {
    $88442176cc5ad79e$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $88442176cc5ad79e$var$extendStatics(d, b);
};
function $88442176cc5ad79e$export$a8ba968b8961cb8a(d, b) {
    $88442176cc5ad79e$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $88442176cc5ad79e$export$18ce0697a983be9b = function() {
    $88442176cc5ad79e$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $88442176cc5ad79e$export$18ce0697a983be9b.apply(this, arguments);
};
function $88442176cc5ad79e$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $88442176cc5ad79e$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $88442176cc5ad79e$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $88442176cc5ad79e$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $88442176cc5ad79e$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $88442176cc5ad79e$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $88442176cc5ad79e$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $88442176cc5ad79e$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $88442176cc5ad79e$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $88442176cc5ad79e$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $88442176cc5ad79e$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($88442176cc5ad79e$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $88442176cc5ad79e$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $88442176cc5ad79e$export$10c90e4f7922046c(v) {
    return this instanceof $88442176cc5ad79e$export$10c90e4f7922046c ? (this.v = v, this) : new $88442176cc5ad79e$export$10c90e4f7922046c(v);
}
function $88442176cc5ad79e$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $88442176cc5ad79e$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $88442176cc5ad79e$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $88442176cc5ad79e$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $88442176cc5ad79e$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $88442176cc5ad79e$export$19a8beecd37a4c45 === "function" ? $88442176cc5ad79e$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $88442176cc5ad79e$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $88442176cc5ad79e$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $88442176cc5ad79e$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $88442176cc5ad79e$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $88442176cc5ad79e$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("81cRv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.supportsZeroByteGCM = module.exports.supportsSubtleCrypto = module.exports.supportsSecureRandom = module.exports.supportsWebCrypto = void 0;

var $bHlav = parcelRequire("bHlav");
var $5d6864dd4212c2b2$var$subtleCryptoMethods = [
    "decrypt",
    "digest",
    "encrypt",
    "exportKey",
    "generateKey",
    "importKey",
    "sign",
    "verify"
];
function $5d6864dd4212c2b2$var$supportsWebCrypto(window) {
    if ($5d6864dd4212c2b2$var$supportsSecureRandom(window) && typeof window.crypto.subtle === "object") {
        var subtle = window.crypto.subtle;
        return $5d6864dd4212c2b2$var$supportsSubtleCrypto(subtle);
    }
    return false;
}
module.exports.supportsWebCrypto = $5d6864dd4212c2b2$var$supportsWebCrypto;
function $5d6864dd4212c2b2$var$supportsSecureRandom(window) {
    if (typeof window === "object" && typeof window.crypto === "object") {
        var getRandomValues = window.crypto.getRandomValues;
        return typeof getRandomValues === "function";
    }
    return false;
}
module.exports.supportsSecureRandom = $5d6864dd4212c2b2$var$supportsSecureRandom;
function $5d6864dd4212c2b2$var$supportsSubtleCrypto(subtle) {
    return subtle && $5d6864dd4212c2b2$var$subtleCryptoMethods.every(function(methodName) {
        return typeof subtle[methodName] === "function";
    });
}
module.exports.supportsSubtleCrypto = $5d6864dd4212c2b2$var$supportsSubtleCrypto;
function $5d6864dd4212c2b2$var$supportsZeroByteGCM(subtle) {
    return $bHlav.__awaiter(this, void 0, void 0, function() {
        var key, zeroByteAuthTag, _a;
        return $bHlav.__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    if (!$5d6864dd4212c2b2$var$supportsSubtleCrypto(subtle)) return [
                        2 /*return*/ ,
                        false
                    ];
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4 /*yield*/ ,
                        subtle.generateKey({
                            name: "AES-GCM",
                            length: 128
                        }, false, [
                            "encrypt"
                        ])
                    ];
                case 2:
                    key = _b.sent();
                    return [
                        4 /*yield*/ ,
                        subtle.encrypt({
                            name: "AES-GCM",
                            iv: new Uint8Array(Array(12)),
                            additionalData: new Uint8Array(Array(16)),
                            tagLength: 128
                        }, key, new Uint8Array(0))
                    ];
                case 3:
                    zeroByteAuthTag = _b.sent();
                    return [
                        2 /*return*/ ,
                        zeroByteAuthTag.byteLength === 16
                    ];
                case 4:
                    _a = _b.sent();
                    return [
                        2 /*return*/ ,
                        false
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
module.exports.supportsZeroByteGCM = $5d6864dd4212c2b2$var$supportsZeroByteGCM;

});


parcelRegister("1k5an", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1uqEc = parcelRequire("1uqEc");

$1uqEc.__exportStar((parcelRequire("d8LuD")), module.exports);

$1uqEc.__exportStar((parcelRequire("6Bv3X")), module.exports);

$1uqEc.__exportStar((parcelRequire("jiiaf")), module.exports);

$1uqEc.__exportStar((parcelRequire("l7anL")), module.exports);

$1uqEc.__exportStar((parcelRequire("andT2")), module.exports);

});
parcelRegister("1uqEc", function(module, exports) {

$parcel$export(module.exports, "__exportStar", () => $115d436d0f7f22ea$export$f33643c0debef087);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $115d436d0f7f22ea$var$extendStatics = function(d, b) {
    $115d436d0f7f22ea$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $115d436d0f7f22ea$var$extendStatics(d, b);
};
function $115d436d0f7f22ea$export$a8ba968b8961cb8a(d, b) {
    $115d436d0f7f22ea$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $115d436d0f7f22ea$export$18ce0697a983be9b = function() {
    $115d436d0f7f22ea$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $115d436d0f7f22ea$export$18ce0697a983be9b.apply(this, arguments);
};
function $115d436d0f7f22ea$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $115d436d0f7f22ea$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $115d436d0f7f22ea$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $115d436d0f7f22ea$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $115d436d0f7f22ea$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $115d436d0f7f22ea$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $115d436d0f7f22ea$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $115d436d0f7f22ea$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $115d436d0f7f22ea$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $115d436d0f7f22ea$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $115d436d0f7f22ea$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($115d436d0f7f22ea$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $115d436d0f7f22ea$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $115d436d0f7f22ea$export$10c90e4f7922046c(v) {
    return this instanceof $115d436d0f7f22ea$export$10c90e4f7922046c ? (this.v = v, this) : new $115d436d0f7f22ea$export$10c90e4f7922046c(v);
}
function $115d436d0f7f22ea$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $115d436d0f7f22ea$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $115d436d0f7f22ea$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $115d436d0f7f22ea$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $115d436d0f7f22ea$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $115d436d0f7f22ea$export$19a8beecd37a4c45 === "function" ? $115d436d0f7f22ea$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $115d436d0f7f22ea$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $115d436d0f7f22ea$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $115d436d0f7f22ea$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $115d436d0f7f22ea$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $115d436d0f7f22ea$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("d8LuD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("6Bv3X", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("jiiaf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("l7anL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("andT2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isMsWindow = void 0;
var $78d6d2f5a4784fe3$var$msSubtleCryptoMethods = [
    "decrypt",
    "digest",
    "encrypt",
    "exportKey",
    "generateKey",
    "importKey",
    "sign",
    "verify"
];
function $78d6d2f5a4784fe3$var$quacksLikeAnMsWindow(window) {
    return "MSInputMethodContext" in window && "msCrypto" in window;
}
/**
 * Determines if the provided window is (or is like) the window object one would
 * expect to encounter in Internet Explorer 11.
 */ function $78d6d2f5a4784fe3$var$isMsWindow(window) {
    if ($78d6d2f5a4784fe3$var$quacksLikeAnMsWindow(window) && window.msCrypto.subtle !== undefined) {
        var _a = window.msCrypto, getRandomValues = _a.getRandomValues, subtle_1 = _a.subtle;
        return $78d6d2f5a4784fe3$var$msSubtleCryptoMethods.map(function(methodName) {
            return subtle_1[methodName];
        }).concat(getRandomValues).every(function(method) {
            return typeof method === "function";
        });
    }
    return false;
}
module.exports.isMsWindow = $78d6d2f5a4784fe3$var$isMsWindow;

});




parcelRegister("lRt6C", function(module, exports) {
$parcel$export(module.exports, "FetchHttpHandler", () => (parcelRequire("en8nh")).FetchHttpHandler);
$parcel$export(module.exports, "streamCollector", () => (parcelRequire("krpM4")).streamCollector);
parcelRequire("en8nh");
parcelRequire("krpM4");

});
parcelRegister("en8nh", function(module, exports) {

$parcel$export(module.exports, "FetchHttpHandler", () => $a769b5a687c28c89$export$83588b87edbfa7e0);

var $jpMHV = parcelRequire("jpMHV");
parcelRequire("3uM9B");
var $d4VAq = parcelRequire("d4VAq");

var $gbly0 = parcelRequire("gbly0");

var $l8XrV = parcelRequire("l8XrV");
var $a769b5a687c28c89$export$83588b87edbfa7e0 = /** @class */ function() {
    function FetchHttpHandler(_a) {
        var _b = _a === void 0 ? {} : _a, requestTimeout = _b.requestTimeout;
        this.requestTimeout = requestTimeout;
    }
    FetchHttpHandler.prototype.destroy = function() {
    // Do nothing. TLS and HTTP/2 connection pooling is handled by the browser.
    };
    FetchHttpHandler.prototype.handle = function(request, _a) {
        var _b = _a === void 0 ? {} : _a, abortSignal = _b.abortSignal;
        var requestTimeoutInMs = this.requestTimeout;
        // if the request was already aborted, prevent doing extra work
        if (abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted) {
            var abortError = new Error("Request aborted");
            abortError.name = "AbortError";
            return Promise.reject(abortError);
        }
        var path = request.path;
        if (request.query) {
            var queryString = (0, $gbly0.buildQueryString)(request.query);
            if (queryString) path += "?" + queryString;
        }
        var port = request.port, method = request.method;
        var url = request.protocol + "//" + request.hostname + (port ? ":" + port : "") + path;
        // Request constructor doesn't allow GET/HEAD request with body
        // ref: https://github.com/whatwg/fetch/issues/551
        var body = method === "GET" || method === "HEAD" ? undefined : request.body;
        var requestOptions = {
            body: body,
            headers: new Headers(request.headers),
            method: method
        };
        // some browsers support abort signal
        if (typeof AbortController !== "undefined") requestOptions["signal"] = abortSignal;
        var fetchRequest = new Request(url, requestOptions);
        var raceOfPromises = [
            fetch(fetchRequest).then(function(response) {
                var e_1, _a;
                var fetchHeaders = response.headers;
                var transformedHeaders = {};
                try {
                    for(var _b = (0, $jpMHV.__values)(fetchHeaders.entries()), _c = _b.next(); !_c.done; _c = _b.next()){
                        var pair = _c.value;
                        transformedHeaders[pair[0]] = pair[1];
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
                var hasReadableStream = response.body !== undefined;
                // Return the response with buffered body
                if (!hasReadableStream) return response.blob().then(function(body) {
                    return {
                        response: new (0, $d4VAq.HttpResponse)({
                            headers: transformedHeaders,
                            statusCode: response.status,
                            body: body
                        })
                    };
                });
                // Return the response with streaming body
                return {
                    response: new (0, $d4VAq.HttpResponse)({
                        headers: transformedHeaders,
                        statusCode: response.status,
                        body: response.body
                    })
                };
            }),
            (0, $l8XrV.requestTimeout)(requestTimeoutInMs)
        ];
        if (abortSignal) raceOfPromises.push(new Promise(function(resolve, reject) {
            abortSignal.onabort = function() {
                var abortError = new Error("Request aborted");
                abortError.name = "AbortError";
                reject(abortError);
            };
        }));
        return Promise.race(raceOfPromises);
    };
    return FetchHttpHandler;
}();

});
parcelRegister("jpMHV", function(module, exports) {

$parcel$export(module.exports, "__awaiter", () => $e226226db0996b0f$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $e226226db0996b0f$export$67ebef60e6f28a6);
$parcel$export(module.exports, "__values", () => $e226226db0996b0f$export$19a8beecd37a4c45);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $e226226db0996b0f$var$extendStatics = function(d, b) {
    $e226226db0996b0f$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $e226226db0996b0f$var$extendStatics(d, b);
};
function $e226226db0996b0f$export$a8ba968b8961cb8a(d, b) {
    $e226226db0996b0f$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $e226226db0996b0f$export$18ce0697a983be9b = function() {
    $e226226db0996b0f$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e226226db0996b0f$export$18ce0697a983be9b.apply(this, arguments);
};
function $e226226db0996b0f$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $e226226db0996b0f$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $e226226db0996b0f$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $e226226db0996b0f$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $e226226db0996b0f$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $e226226db0996b0f$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $e226226db0996b0f$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $e226226db0996b0f$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $e226226db0996b0f$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $e226226db0996b0f$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $e226226db0996b0f$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($e226226db0996b0f$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $e226226db0996b0f$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $e226226db0996b0f$export$10c90e4f7922046c(v) {
    return this instanceof $e226226db0996b0f$export$10c90e4f7922046c ? (this.v = v, this) : new $e226226db0996b0f$export$10c90e4f7922046c(v);
}
function $e226226db0996b0f$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $e226226db0996b0f$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $e226226db0996b0f$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $e226226db0996b0f$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $e226226db0996b0f$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $e226226db0996b0f$export$19a8beecd37a4c45 === "function" ? $e226226db0996b0f$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $e226226db0996b0f$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $e226226db0996b0f$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $e226226db0996b0f$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $e226226db0996b0f$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $e226226db0996b0f$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("gbly0", function(module, exports) {

$parcel$export(module.exports, "buildQueryString", () => $bc7e634e3e1811f0$export$6b17a39e52c8ee53);

var $kUYPZ = parcelRequire("kUYPZ");
parcelRequire("9xnH3");
var $ktmlg = parcelRequire("ktmlg");
function $bc7e634e3e1811f0$export$6b17a39e52c8ee53(query) {
    var e_1, _a;
    var parts = [];
    try {
        for(var _b = (0, $kUYPZ.__values)(Object.keys(query).sort()), _c = _b.next(); !_c.done; _c = _b.next()){
            var key = _c.value;
            var value = query[key];
            key = (0, $ktmlg.escapeUri)(key);
            if (Array.isArray(value)) for(var i = 0, iLen = value.length; i < iLen; i++)parts.push(key + "=" + (0, $ktmlg.escapeUri)(value[i]));
            else {
                var qsEntry = key;
                if (value || typeof value === "string") qsEntry += "=" + (0, $ktmlg.escapeUri)(value);
                parts.push(qsEntry);
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return parts.join("&");
}

});
parcelRegister("kUYPZ", function(module, exports) {

$parcel$export(module.exports, "__values", () => $f3a83aadf6a23e47$export$19a8beecd37a4c45);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $f3a83aadf6a23e47$var$extendStatics = function(d, b) {
    $f3a83aadf6a23e47$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $f3a83aadf6a23e47$var$extendStatics(d, b);
};
function $f3a83aadf6a23e47$export$a8ba968b8961cb8a(d, b) {
    $f3a83aadf6a23e47$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $f3a83aadf6a23e47$export$18ce0697a983be9b = function() {
    $f3a83aadf6a23e47$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f3a83aadf6a23e47$export$18ce0697a983be9b.apply(this, arguments);
};
function $f3a83aadf6a23e47$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $f3a83aadf6a23e47$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $f3a83aadf6a23e47$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $f3a83aadf6a23e47$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $f3a83aadf6a23e47$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $f3a83aadf6a23e47$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $f3a83aadf6a23e47$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $f3a83aadf6a23e47$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $f3a83aadf6a23e47$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $f3a83aadf6a23e47$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $f3a83aadf6a23e47$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($f3a83aadf6a23e47$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $f3a83aadf6a23e47$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $f3a83aadf6a23e47$export$10c90e4f7922046c(v) {
    return this instanceof $f3a83aadf6a23e47$export$10c90e4f7922046c ? (this.v = v, this) : new $f3a83aadf6a23e47$export$10c90e4f7922046c(v);
}
function $f3a83aadf6a23e47$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $f3a83aadf6a23e47$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $f3a83aadf6a23e47$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $f3a83aadf6a23e47$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $f3a83aadf6a23e47$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $f3a83aadf6a23e47$export$19a8beecd37a4c45 === "function" ? $f3a83aadf6a23e47$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $f3a83aadf6a23e47$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $f3a83aadf6a23e47$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $f3a83aadf6a23e47$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $f3a83aadf6a23e47$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $f3a83aadf6a23e47$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("9xnH3", function(module, exports) {
$parcel$export(module.exports, "escapeUri", () => (parcelRequire("ktmlg")).escapeUri);
parcelRequire("ktmlg");
parcelRequire("65N4K");

});
parcelRegister("ktmlg", function(module, exports) {

$parcel$export(module.exports, "escapeUri", () => $ee77d8b76b447a7f$export$c3b4775ad75a73db);
var $ee77d8b76b447a7f$export$c3b4775ad75a73db = function(uri) {
    // AWS percent-encodes some extra non-standard characters in a URI
    return encodeURIComponent(uri).replace(/[!'()*]/g, $ee77d8b76b447a7f$var$hexEncode);
};
var $ee77d8b76b447a7f$var$hexEncode = function(c) {
    return "%" + c.charCodeAt(0).toString(16).toUpperCase();
};

});

parcelRegister("65N4K", function(module, exports) {

var $ktmlg = parcelRequire("ktmlg");
var $46f947146d75c8ad$export$547c045505a754ef = function(uri) {
    return uri.split("/").map((0, $ktmlg.escapeUri)).join("/");
};

});



parcelRegister("l8XrV", function(module, exports) {

$parcel$export(module.exports, "requestTimeout", () => $f64875c1586d6875$export$363ac302bdbd807b);
function $f64875c1586d6875$export$363ac302bdbd807b(timeoutInMs) {
    if (timeoutInMs === void 0) timeoutInMs = 0;
    return new Promise(function(resolve, reject) {
        if (timeoutInMs) setTimeout(function() {
            var timeoutError = new Error("Request did not complete within " + timeoutInMs + " ms");
            timeoutError.name = "TimeoutError";
            reject(timeoutError);
        }, timeoutInMs);
    });
}

});


parcelRegister("krpM4", function(module, exports) {

$parcel$export(module.exports, "streamCollector", () => $ee1a52814c7b228f$export$17bf97b72e307d52);

var $jpMHV = parcelRequire("jpMHV");

var $hZ4ci = parcelRequire("hZ4ci");
var $ee1a52814c7b228f$export$17bf97b72e307d52 = function(stream) {
    if (typeof Blob === "function" && stream instanceof Blob) return $ee1a52814c7b228f$var$collectBlob(stream);
    return $ee1a52814c7b228f$var$collectStream(stream);
};
function $ee1a52814c7b228f$var$collectBlob(blob) {
    return (0, $jpMHV.__awaiter)(this, void 0, void 0, function() {
        var base64, arrayBuffer;
        return (0, $jpMHV.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        $ee1a52814c7b228f$var$readToBase64(blob)
                    ];
                case 1:
                    base64 = _a.sent();
                    arrayBuffer = (0, $hZ4ci.fromBase64)(base64);
                    return [
                        2 /*return*/ ,
                        new Uint8Array(arrayBuffer)
                    ];
            }
        });
    });
}
function $ee1a52814c7b228f$var$collectStream(stream) {
    return (0, $jpMHV.__awaiter)(this, void 0, void 0, function() {
        var res, reader, isDone, _a, done, value, prior;
        return (0, $jpMHV.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    res = new Uint8Array(0);
                    reader = stream.getReader();
                    isDone = false;
                    _b.label = 1;
                case 1:
                    if (!!isDone) return [
                        3 /*break*/ ,
                        3
                    ];
                    return [
                        4 /*yield*/ ,
                        reader.read()
                    ];
                case 2:
                    _a = _b.sent(), done = _a.done, value = _a.value;
                    if (value) {
                        prior = res;
                        res = new Uint8Array(prior.length + value.length);
                        res.set(prior);
                        res.set(value, prior.length);
                    }
                    isDone = done;
                    return [
                        3 /*break*/ ,
                        1
                    ];
                case 3:
                    return [
                        2 /*return*/ ,
                        res
                    ];
            }
        });
    });
}
function $ee1a52814c7b228f$var$readToBase64(blob) {
    return new Promise(function(resolve, reject) {
        var reader = new FileReader();
        reader.onloadend = function() {
            var _a;
            // reference: https://developer.mozilla.org/en-US/docs/Web/API/FileReader/readAsDataURL
            // response from readAsDataURL is always prepended with "data:*/*;base64,"
            if (reader.readyState !== 2) return reject(new Error("Reader aborted too early"));
            var result = (_a = reader.result) !== null && _a !== void 0 ? _a : "";
            // Response can include only 'data:' for empty blob, return empty string in this case.
            // Otherwise, return the string after ','
            var commaIndex = result.indexOf(",");
            var dataOffset = commaIndex > -1 ? commaIndex + 1 : result.length;
            resolve(result.substring(dataOffset));
        };
        reader.onabort = function() {
            return reject(new Error("Read aborted"));
        };
        reader.onerror = function() {
            return reject(reader.error);
        };
        // reader.readAsArrayBuffer is not always available
        reader.readAsDataURL(blob);
    });
}

});
parcelRegister("hZ4ci", function(module, exports) {

$parcel$export(module.exports, "fromBase64", () => $d17b63af1a7cb250$export$c537b38001c583b7);
$parcel$export(module.exports, "toBase64", () => $d17b63af1a7cb250$export$37cc283d8fbd3462);
var $d17b63af1a7cb250$var$alphabetByEncoding = {};
var $d17b63af1a7cb250$var$alphabetByValue = new Array(64);
for(var $d17b63af1a7cb250$var$i = 0, $d17b63af1a7cb250$var$start = "A".charCodeAt(0), $d17b63af1a7cb250$var$limit = "Z".charCodeAt(0); $d17b63af1a7cb250$var$i + $d17b63af1a7cb250$var$start <= $d17b63af1a7cb250$var$limit; $d17b63af1a7cb250$var$i++){
    var $d17b63af1a7cb250$var$char = String.fromCharCode($d17b63af1a7cb250$var$i + $d17b63af1a7cb250$var$start);
    $d17b63af1a7cb250$var$alphabetByEncoding[$d17b63af1a7cb250$var$char] = $d17b63af1a7cb250$var$i;
    $d17b63af1a7cb250$var$alphabetByValue[$d17b63af1a7cb250$var$i] = $d17b63af1a7cb250$var$char;
}
for(var $d17b63af1a7cb250$var$i = 0, $d17b63af1a7cb250$var$start = "a".charCodeAt(0), $d17b63af1a7cb250$var$limit = "z".charCodeAt(0); $d17b63af1a7cb250$var$i + $d17b63af1a7cb250$var$start <= $d17b63af1a7cb250$var$limit; $d17b63af1a7cb250$var$i++){
    var $d17b63af1a7cb250$var$char = String.fromCharCode($d17b63af1a7cb250$var$i + $d17b63af1a7cb250$var$start);
    var $d17b63af1a7cb250$var$index = $d17b63af1a7cb250$var$i + 26;
    $d17b63af1a7cb250$var$alphabetByEncoding[$d17b63af1a7cb250$var$char] = $d17b63af1a7cb250$var$index;
    $d17b63af1a7cb250$var$alphabetByValue[$d17b63af1a7cb250$var$index] = $d17b63af1a7cb250$var$char;
}
for(var $d17b63af1a7cb250$var$i = 0; $d17b63af1a7cb250$var$i < 10; $d17b63af1a7cb250$var$i++){
    $d17b63af1a7cb250$var$alphabetByEncoding[$d17b63af1a7cb250$var$i.toString(10)] = $d17b63af1a7cb250$var$i + 52;
    var $d17b63af1a7cb250$var$char = $d17b63af1a7cb250$var$i.toString(10);
    var $d17b63af1a7cb250$var$index = $d17b63af1a7cb250$var$i + 52;
    $d17b63af1a7cb250$var$alphabetByEncoding[$d17b63af1a7cb250$var$char] = $d17b63af1a7cb250$var$index;
    $d17b63af1a7cb250$var$alphabetByValue[$d17b63af1a7cb250$var$index] = $d17b63af1a7cb250$var$char;
}
$d17b63af1a7cb250$var$alphabetByEncoding["+"] = 62;
$d17b63af1a7cb250$var$alphabetByValue[62] = "+";
$d17b63af1a7cb250$var$alphabetByEncoding["/"] = 63;
$d17b63af1a7cb250$var$alphabetByValue[63] = "/";
var $d17b63af1a7cb250$var$bitsPerLetter = 6;
var $d17b63af1a7cb250$var$bitsPerByte = 8;
var $d17b63af1a7cb250$var$maxLetterValue = 63;
function $d17b63af1a7cb250$export$c537b38001c583b7(input) {
    var totalByteLength = input.length / 4 * 3;
    if (input.substr(-2) === "==") totalByteLength -= 2;
    else if (input.substr(-1) === "=") totalByteLength--;
    var out = new ArrayBuffer(totalByteLength);
    var dataView = new DataView(out);
    for(var i = 0; i < input.length; i += 4){
        var bits = 0;
        var bitLength = 0;
        for(var j = i, limit = i + 3; j <= limit; j++)if (input[j] !== "=") {
            bits |= $d17b63af1a7cb250$var$alphabetByEncoding[input[j]] << (limit - j) * $d17b63af1a7cb250$var$bitsPerLetter;
            bitLength += $d17b63af1a7cb250$var$bitsPerLetter;
        } else bits >>= $d17b63af1a7cb250$var$bitsPerLetter;
        var chunkOffset = i / 4 * 3;
        bits >>= bitLength % $d17b63af1a7cb250$var$bitsPerByte;
        var byteLength = Math.floor(bitLength / $d17b63af1a7cb250$var$bitsPerByte);
        for(var k = 0; k < byteLength; k++){
            var offset = (byteLength - k - 1) * $d17b63af1a7cb250$var$bitsPerByte;
            dataView.setUint8(chunkOffset + k, (bits & 255 << offset) >> offset);
        }
    }
    return new Uint8Array(out);
}
function $d17b63af1a7cb250$export$37cc283d8fbd3462(input) {
    var str = "";
    for(var i = 0; i < input.length; i += 3){
        var bits = 0;
        var bitLength = 0;
        for(var j = i, limit = Math.min(i + 3, input.length); j < limit; j++){
            bits |= input[j] << (limit - j - 1) * $d17b63af1a7cb250$var$bitsPerByte;
            bitLength += $d17b63af1a7cb250$var$bitsPerByte;
        }
        var bitClusterCount = Math.ceil(bitLength / $d17b63af1a7cb250$var$bitsPerLetter);
        bits <<= bitClusterCount * $d17b63af1a7cb250$var$bitsPerLetter - bitLength;
        for(var k = 1; k <= bitClusterCount; k++){
            var offset = (bitClusterCount - k) * $d17b63af1a7cb250$var$bitsPerLetter;
            str += $d17b63af1a7cb250$var$alphabetByValue[(bits & $d17b63af1a7cb250$var$maxLetterValue << offset) >> offset];
        }
        str += "==".slice(0, 4 - bitClusterCount);
    }
    return str;
}

});



parcelRegister("cEJWE", function(module, exports) {
$parcel$export(module.exports, "invalidProvider", () => (parcelRequire("ecitQ")).invalidProvider);
parcelRequire("2fdMo");
parcelRequire("ecitQ");

});
parcelRegister("2fdMo", function(module, exports) {
var $1a27abd3897aea96$export$8b6362171c4dfa64 = function(message) {
    return function() {
        throw new Error(message);
    };
};

});

parcelRegister("ecitQ", function(module, exports) {

$parcel$export(module.exports, "invalidProvider", () => $a5608584ae4a201c$export$d59dd53963f8f3d5);
var $a5608584ae4a201c$export$d59dd53963f8f3d5 = function(message) {
    return function() {
        return Promise.reject(message);
    };
};

});


parcelRegister("3dE54", function(module, exports) {
$parcel$export(module.exports, "getRetryPlugin", () => (parcelRequire("3fI9X")).getRetryPlugin);
$parcel$export(module.exports, "DEFAULT_MAX_ATTEMPTS", () => (parcelRequire("9EGMS")).DEFAULT_MAX_ATTEMPTS);
$parcel$export(module.exports, "resolveRetryConfig", () => (parcelRequire("efUMf")).resolveRetryConfig);
parcelRequire("3fI9X");
parcelRequire("vXhAX");
parcelRequire("9EGMS");
parcelRequire("efUMf");
parcelRequire("b3kn4");
parcelRequire("9FSOy");

});
parcelRegister("3fI9X", function(module, exports) {

$parcel$export(module.exports, "getRetryPlugin", () => $25e506fb4c5b6c5e$export$c73199e2b1df9340);

var $huTyO = parcelRequire("huTyO");
var $25e506fb4c5b6c5e$export$a3922aa5f87bae85 = function(options) {
    return function(next, context) {
        return function(args) {
            return (0, $huTyO.__awaiter)(void 0, void 0, void 0, function() {
                var _a;
                return (0, $huTyO.__generator)(this, function(_b) {
                    if ((_a = options === null || options === void 0 ? void 0 : options.retryStrategy) === null || _a === void 0 ? void 0 : _a.mode) context.userAgent = (0, $huTyO.__spread)(context.userAgent || [], [
                        [
                            "cfg/retry-mode",
                            options.retryStrategy.mode
                        ]
                    ]);
                    return [
                        2 /*return*/ ,
                        options.retryStrategy.retry(next, args)
                    ];
                });
            });
        };
    };
};
var $25e506fb4c5b6c5e$export$44d3d03587957ce9 = {
    name: "retryMiddleware",
    tags: [
        "RETRY"
    ],
    step: "finalizeRequest",
    priority: "high",
    override: true
};
var $25e506fb4c5b6c5e$export$c73199e2b1df9340 = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add($25e506fb4c5b6c5e$export$a3922aa5f87bae85(options), $25e506fb4c5b6c5e$export$44d3d03587957ce9);
        }
    };
};

});
parcelRegister("huTyO", function(module, exports) {

$parcel$export(module.exports, "__assign", () => $cbd0562b13d83523$export$18ce0697a983be9b);
$parcel$export(module.exports, "__awaiter", () => $cbd0562b13d83523$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $cbd0562b13d83523$export$67ebef60e6f28a6);
$parcel$export(module.exports, "__spread", () => $cbd0562b13d83523$export$afc72e2116322959);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $cbd0562b13d83523$var$extendStatics = function(d, b) {
    $cbd0562b13d83523$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $cbd0562b13d83523$var$extendStatics(d, b);
};
function $cbd0562b13d83523$export$a8ba968b8961cb8a(d, b) {
    $cbd0562b13d83523$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $cbd0562b13d83523$export$18ce0697a983be9b = function() {
    $cbd0562b13d83523$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $cbd0562b13d83523$export$18ce0697a983be9b.apply(this, arguments);
};
function $cbd0562b13d83523$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $cbd0562b13d83523$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $cbd0562b13d83523$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $cbd0562b13d83523$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $cbd0562b13d83523$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $cbd0562b13d83523$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $cbd0562b13d83523$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $cbd0562b13d83523$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $cbd0562b13d83523$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $cbd0562b13d83523$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $cbd0562b13d83523$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($cbd0562b13d83523$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $cbd0562b13d83523$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $cbd0562b13d83523$export$10c90e4f7922046c(v) {
    return this instanceof $cbd0562b13d83523$export$10c90e4f7922046c ? (this.v = v, this) : new $cbd0562b13d83523$export$10c90e4f7922046c(v);
}
function $cbd0562b13d83523$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $cbd0562b13d83523$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $cbd0562b13d83523$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $cbd0562b13d83523$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $cbd0562b13d83523$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $cbd0562b13d83523$export$19a8beecd37a4c45 === "function" ? $cbd0562b13d83523$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $cbd0562b13d83523$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $cbd0562b13d83523$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $cbd0562b13d83523$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $cbd0562b13d83523$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $cbd0562b13d83523$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});


parcelRegister("vXhAX", function(module, exports) {

var $huTyO = parcelRequire("huTyO");
parcelRequire("3uM9B");
var $dlqaT = parcelRequire("dlqaT");

var $7BGLI = parcelRequire("7BGLI");
var $0600e1b146decaf0$export$536b11ee0b9c4a95 = function() {
    return function(next) {
        return function(args) {
            return (0, $huTyO.__awaiter)(void 0, void 0, void 0, function() {
                var request;
                return (0, $huTyO.__generator)(this, function(_a) {
                    request = args.request;
                    if ((0, $dlqaT.HttpRequest).isInstance(request)) {
                        delete request.headers[0, $7BGLI.INVOCATION_ID_HEADER];
                        delete request.headers[0, $7BGLI.REQUEST_HEADER];
                    }
                    return [
                        2 /*return*/ ,
                        next(args)
                    ];
                });
            });
        };
    };
};
var $0600e1b146decaf0$export$3ec587d8f35e7a2c = {
    name: "omitRetryHeadersMiddleware",
    tags: [
        "RETRY",
        "HEADERS",
        "OMIT_RETRY_HEADERS"
    ],
    relation: "before",
    toMiddleware: "awsAuthMiddleware",
    override: true
};
var $0600e1b146decaf0$export$fa165e6edc16c2a2 = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.addRelativeTo($0600e1b146decaf0$export$536b11ee0b9c4a95(), $0600e1b146decaf0$export$3ec587d8f35e7a2c);
        }
    };
};

});
parcelRegister("7BGLI", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_RETRY_DELAY_BASE", () => $589d2a14aac6aa9d$export$7067ba90effbd789);
$parcel$export(module.exports, "MAXIMUM_RETRY_DELAY", () => $589d2a14aac6aa9d$export$2412c80d04e902c6);
$parcel$export(module.exports, "THROTTLING_RETRY_DELAY_BASE", () => $589d2a14aac6aa9d$export$4af31f8250b48e23);
$parcel$export(module.exports, "INITIAL_RETRY_TOKENS", () => $589d2a14aac6aa9d$export$f8c3d11675a1153);
$parcel$export(module.exports, "RETRY_COST", () => $589d2a14aac6aa9d$export$797febae1136bc84);
$parcel$export(module.exports, "TIMEOUT_RETRY_COST", () => $589d2a14aac6aa9d$export$b643545eaf9af837);
$parcel$export(module.exports, "NO_RETRY_INCREMENT", () => $589d2a14aac6aa9d$export$a25da3406dc148e4);
$parcel$export(module.exports, "INVOCATION_ID_HEADER", () => $589d2a14aac6aa9d$export$197fd517bf66ccb2);
$parcel$export(module.exports, "REQUEST_HEADER", () => $589d2a14aac6aa9d$export$d4f764f0ec4f52f);
/**
 * The base number of milliseconds to use in calculating a suitable cool-down
 * time when a retryable error is encountered.
 */ var $589d2a14aac6aa9d$export$7067ba90effbd789 = 100;
var $589d2a14aac6aa9d$export$2412c80d04e902c6 = 20000;
var $589d2a14aac6aa9d$export$4af31f8250b48e23 = 500;
var $589d2a14aac6aa9d$export$f8c3d11675a1153 = 500;
var $589d2a14aac6aa9d$export$797febae1136bc84 = 5;
var $589d2a14aac6aa9d$export$b643545eaf9af837 = 10;
var $589d2a14aac6aa9d$export$a25da3406dc148e4 = 1;
var $589d2a14aac6aa9d$export$197fd517bf66ccb2 = "amz-sdk-invocation-id";
var $589d2a14aac6aa9d$export$d4f764f0ec4f52f = "amz-sdk-request";

});


parcelRegister("9EGMS", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_MAX_ATTEMPTS", () => $70790a28133d1f40$export$2c7e51f38ba5a406);
$parcel$export(module.exports, "DEFAULT_RETRY_MODE", () => $70790a28133d1f40$export$41315747b7c5d042);
$parcel$export(module.exports, "StandardRetryStrategy", () => $70790a28133d1f40$export$64af437cce00eae8);

var $huTyO = parcelRequire("huTyO");
parcelRequire("3uM9B");
var $dlqaT = parcelRequire("dlqaT");

var $5WzrF = parcelRequire("5WzrF");

var $1D6rP = parcelRequire("1D6rP");

var $7BGLI = parcelRequire("7BGLI");

var $gn1Eo = parcelRequire("gn1Eo");

var $b3kn4 = parcelRequire("b3kn4");

var $9FSOy = parcelRequire("9FSOy");
var $70790a28133d1f40$export$2c7e51f38ba5a406 = 3;
var $70790a28133d1f40$export$41315747b7c5d042 = "standard";
var $70790a28133d1f40$export$64af437cce00eae8 = /** @class */ function() {
    function StandardRetryStrategy(maxAttemptsProvider, options) {
        var _a, _b, _c;
        this.maxAttemptsProvider = maxAttemptsProvider;
        this.mode = $70790a28133d1f40$export$41315747b7c5d042;
        this.retryDecider = (_a = options === null || options === void 0 ? void 0 : options.retryDecider) !== null && _a !== void 0 ? _a : (0, $9FSOy.defaultRetryDecider);
        this.delayDecider = (_b = options === null || options === void 0 ? void 0 : options.delayDecider) !== null && _b !== void 0 ? _b : (0, $b3kn4.defaultDelayDecider);
        this.retryQuota = (_c = options === null || options === void 0 ? void 0 : options.retryQuota) !== null && _c !== void 0 ? _c : (0, $gn1Eo.getDefaultRetryQuota)((0, $7BGLI.INITIAL_RETRY_TOKENS));
    }
    StandardRetryStrategy.prototype.shouldRetry = function(error, attempts, maxAttempts) {
        return attempts < maxAttempts && this.retryDecider(error) && this.retryQuota.hasRetryTokens(error);
    };
    StandardRetryStrategy.prototype.getMaxAttempts = function() {
        return (0, $huTyO.__awaiter)(this, void 0, void 0, function() {
            var maxAttempts, error_1;
            return (0, $huTyO.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.maxAttemptsProvider()
                        ];
                    case 1:
                        maxAttempts = _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        error_1 = _a.sent();
                        maxAttempts = $70790a28133d1f40$export$2c7e51f38ba5a406;
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 3:
                        return [
                            2 /*return*/ ,
                            maxAttempts
                        ];
                }
            });
        });
    };
    StandardRetryStrategy.prototype.retry = function(next, args) {
        return (0, $huTyO.__awaiter)(this, void 0, void 0, function() {
            var retryTokenAmount, attempts, totalDelay, maxAttempts, request, _loop_1, this_1, state_1;
            return (0, $huTyO.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        attempts = 0;
                        totalDelay = 0;
                        return [
                            4 /*yield*/ ,
                            this.getMaxAttempts()
                        ];
                    case 1:
                        maxAttempts = _a.sent();
                        request = args.request;
                        if ((0, $dlqaT.HttpRequest).isInstance(request)) request.headers[0, $7BGLI.INVOCATION_ID_HEADER] = (0, $1D6rP.v4)();
                        _loop_1 = function() {
                            var _a, response, output, err_1, delay_1;
                            return (0, $huTyO.__generator)(this, function(_b) {
                                switch(_b.label){
                                    case 0:
                                        _b.trys.push([
                                            0,
                                            2,
                                            ,
                                            5
                                        ]);
                                        if ((0, $dlqaT.HttpRequest).isInstance(request)) request.headers[0, $7BGLI.REQUEST_HEADER] = "attempt=" + (attempts + 1) + "; max=" + maxAttempts;
                                        return [
                                            4 /*yield*/ ,
                                            next(args)
                                        ];
                                    case 1:
                                        _a = _b.sent(), response = _a.response, output = _a.output;
                                        this_1.retryQuota.releaseRetryTokens(retryTokenAmount);
                                        output.$metadata.attempts = attempts + 1;
                                        output.$metadata.totalRetryDelay = totalDelay;
                                        return [
                                            2 /*return*/ ,
                                            {
                                                value: {
                                                    response: response,
                                                    output: output
                                                }
                                            }
                                        ];
                                    case 2:
                                        err_1 = _b.sent();
                                        attempts++;
                                        if (!this_1.shouldRetry(err_1, attempts, maxAttempts)) return [
                                            3 /*break*/ ,
                                            4
                                        ];
                                        retryTokenAmount = this_1.retryQuota.retrieveRetryTokens(err_1);
                                        delay_1 = this_1.delayDecider((0, $5WzrF.isThrottlingError)(err_1) ? (0, $7BGLI.THROTTLING_RETRY_DELAY_BASE) : (0, $7BGLI.DEFAULT_RETRY_DELAY_BASE), attempts);
                                        totalDelay += delay_1;
                                        return [
                                            4 /*yield*/ ,
                                            new Promise(function(resolve) {
                                                return setTimeout(resolve, delay_1);
                                            })
                                        ];
                                    case 3:
                                        _b.sent();
                                        return [
                                            2 /*return*/ ,
                                            "continue"
                                        ];
                                    case 4:
                                        if (!err_1.$metadata) err_1.$metadata = {};
                                        err_1.$metadata.attempts = attempts;
                                        err_1.$metadata.totalRetryDelay = totalDelay;
                                        throw err_1;
                                    case 5:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        };
                        this_1 = this;
                        _a.label = 2;
                    case 2:
                        return [
                            5 /*yield**/ ,
                            _loop_1()
                        ];
                    case 3:
                        state_1 = _a.sent();
                        if (typeof state_1 === "object") return [
                            2 /*return*/ ,
                            state_1.value
                        ];
                        return [
                            3 /*break*/ ,
                            2
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return StandardRetryStrategy;
}();

});
parcelRegister("5WzrF", function(module, exports) {

$parcel$export(module.exports, "isRetryableByTrait", () => $453ddd3df6c7c29a$export$46428803f4bd8a0c);
$parcel$export(module.exports, "isClockSkewError", () => $453ddd3df6c7c29a$export$7b87435661177a94);
$parcel$export(module.exports, "isThrottlingError", () => $453ddd3df6c7c29a$export$cbecb89f6256ccc8);
$parcel$export(module.exports, "isTransientError", () => $453ddd3df6c7c29a$export$31778435da988512);

var $ealsx = parcelRequire("ealsx");
var $453ddd3df6c7c29a$export$46428803f4bd8a0c = function(error) {
    return error.$retryable !== undefined;
};
var $453ddd3df6c7c29a$export$7b87435661177a94 = function(error) {
    return (0, $ealsx.CLOCK_SKEW_ERROR_CODES).includes(error.name);
};
var $453ddd3df6c7c29a$export$cbecb89f6256ccc8 = function(error) {
    var _a, _b;
    return ((_a = error.$metadata) === null || _a === void 0 ? void 0 : _a.httpStatusCode) === 429 || (0, $ealsx.THROTTLING_ERROR_CODES).includes(error.name) || ((_b = error.$retryable) === null || _b === void 0 ? void 0 : _b.throttling) == true;
};
var $453ddd3df6c7c29a$export$31778435da988512 = function(error) {
    var _a;
    return (0, $ealsx.TRANSIENT_ERROR_CODES).includes(error.name) || (0, $ealsx.TRANSIENT_ERROR_STATUS_CODES).includes(((_a = error.$metadata) === null || _a === void 0 ? void 0 : _a.httpStatusCode) || 0);
};

});
parcelRegister("ealsx", function(module, exports) {

$parcel$export(module.exports, "CLOCK_SKEW_ERROR_CODES", () => $a502a53be9875570$export$9fde012b8b2a10ca);
$parcel$export(module.exports, "THROTTLING_ERROR_CODES", () => $a502a53be9875570$export$89cd1b0ccfcb99d);
$parcel$export(module.exports, "TRANSIENT_ERROR_CODES", () => $a502a53be9875570$export$18bd3bfe89ded398);
$parcel$export(module.exports, "TRANSIENT_ERROR_STATUS_CODES", () => $a502a53be9875570$export$38bf589d26009e4f);
/**
 * Errors encountered when the client clock and server clock cannot agree on the
 * current time.
 *
 * These errors are retryable, assuming the SDK has enabled clock skew
 * correction.
 */ var $a502a53be9875570$export$9fde012b8b2a10ca = [
    "AuthFailure",
    "InvalidSignatureException",
    "RequestExpired",
    "RequestInTheFuture",
    "RequestTimeTooSkewed",
    "SignatureDoesNotMatch"
];
var $a502a53be9875570$export$89cd1b0ccfcb99d = [
    "BandwidthLimitExceeded",
    "EC2ThrottledException",
    "LimitExceededException",
    "PriorRequestNotComplete",
    "ProvisionedThroughputExceededException",
    "RequestLimitExceeded",
    "RequestThrottled",
    "RequestThrottledException",
    "SlowDown",
    "ThrottledException",
    "Throttling",
    "ThrottlingException",
    "TooManyRequestsException",
    "TransactionInProgressException"
];
var $a502a53be9875570$export$18bd3bfe89ded398 = [
    "AbortError",
    "TimeoutError",
    "RequestTimeout",
    "RequestTimeoutException"
];
var $a502a53be9875570$export$38bf589d26009e4f = [
    500,
    502,
    503,
    504
];

});


parcelRegister("1D6rP", function(module, exports) {

var $ikPn6 = parcelRequire("ikPn6");

var $ayBFc = parcelRequire("ayBFc");
var $12fe6f64e53b5cd3$var$uuid = $ayBFc;
$12fe6f64e53b5cd3$var$uuid.v1 = $ikPn6;
$12fe6f64e53b5cd3$var$uuid.v4 = $ayBFc;
module.exports = $12fe6f64e53b5cd3$var$uuid;

});
parcelRegister("ikPn6", function(module, exports) {

var $55aBr = parcelRequire("55aBr");

var $cliuY = parcelRequire("cliuY");
// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var $d591f1987f965138$var$_nodeId;
var $d591f1987f965138$var$_clockseq;
// Previous uuid creation time
var $d591f1987f965138$var$_lastMSecs = 0;
var $d591f1987f965138$var$_lastNSecs = 0;
// See https://github.com/uuidjs/uuid for API details
function $d591f1987f965138$var$v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || $d591f1987f965138$var$_nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : $d591f1987f965138$var$_clockseq;
    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = $55aBr();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = $d591f1987f965138$var$_nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = $d591f1987f965138$var$_clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : $d591f1987f965138$var$_lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - $d591f1987f965138$var$_lastMSecs + (nsecs - $d591f1987f965138$var$_lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > $d591f1987f965138$var$_lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
    $d591f1987f965138$var$_lastMSecs = msecs;
    $d591f1987f965138$var$_lastNSecs = nsecs;
    $d591f1987f965138$var$_clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf ? buf : $cliuY(b);
}
module.exports = $d591f1987f965138$var$v1;

});
parcelRegister("55aBr", function(module, exports) {
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var $3b35a4ea63724497$var$getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto);
if ($3b35a4ea63724497$var$getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var $3b35a4ea63724497$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    module.exports = function whatwgRNG() {
        $3b35a4ea63724497$var$getRandomValues($3b35a4ea63724497$var$rnds8);
        return $3b35a4ea63724497$var$rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var $3b35a4ea63724497$var$rnds = new Array(16);
    module.exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            $3b35a4ea63724497$var$rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return $3b35a4ea63724497$var$rnds;
    };
}

});

parcelRegister("cliuY", function(module, exports) {
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $8fc5cba6b6df6535$var$byteToHex = [];
for(var $8fc5cba6b6df6535$var$i = 0; $8fc5cba6b6df6535$var$i < 256; ++$8fc5cba6b6df6535$var$i)$8fc5cba6b6df6535$var$byteToHex[$8fc5cba6b6df6535$var$i] = ($8fc5cba6b6df6535$var$i + 0x100).toString(16).substr(1);
function $8fc5cba6b6df6535$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $8fc5cba6b6df6535$var$byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join('');
}
module.exports = $8fc5cba6b6df6535$var$bytesToUuid;

});


parcelRegister("ayBFc", function(module, exports) {

var $55aBr = parcelRequire("55aBr");

var $cliuY = parcelRequire("cliuY");
function $7afa4b8b4ffaebe6$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == 'string') {
        buf = options === 'binary' ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || $55aBr)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || $cliuY(rnds);
}
module.exports = $7afa4b8b4ffaebe6$var$v4;

});


parcelRegister("gn1Eo", function(module, exports) {

$parcel$export(module.exports, "getDefaultRetryQuota", () => $beb013198fb71522$export$2ebe7988802fc284);

var $7BGLI = parcelRequire("7BGLI");
var $beb013198fb71522$export$2ebe7988802fc284 = function(initialRetryTokens) {
    var MAX_CAPACITY = initialRetryTokens;
    var availableCapacity = initialRetryTokens;
    var getCapacityAmount = function(error) {
        return error.name === "TimeoutError" ? (0, $7BGLI.TIMEOUT_RETRY_COST) : (0, $7BGLI.RETRY_COST);
    };
    var hasRetryTokens = function(error) {
        return getCapacityAmount(error) <= availableCapacity;
    };
    var retrieveRetryTokens = function(error) {
        if (!hasRetryTokens(error)) // retryStrategy should stop retrying, and return last error
        throw new Error("No retry token available");
        var capacityAmount = getCapacityAmount(error);
        availableCapacity -= capacityAmount;
        return capacityAmount;
    };
    var releaseRetryTokens = function(capacityReleaseAmount) {
        availableCapacity += capacityReleaseAmount !== null && capacityReleaseAmount !== void 0 ? capacityReleaseAmount : (0, $7BGLI.NO_RETRY_INCREMENT);
        availableCapacity = Math.min(availableCapacity, MAX_CAPACITY);
    };
    return Object.freeze({
        hasRetryTokens: hasRetryTokens,
        retrieveRetryTokens: retrieveRetryTokens,
        releaseRetryTokens: releaseRetryTokens
    });
};

});

parcelRegister("b3kn4", function(module, exports) {

$parcel$export(module.exports, "defaultDelayDecider", () => $80bfc6c9783efd77$export$1cddd42598a3b1f6);

var $7BGLI = parcelRequire("7BGLI");
var $80bfc6c9783efd77$export$1cddd42598a3b1f6 = function(delayBase, attempts) {
    return Math.floor(Math.min((0, $7BGLI.MAXIMUM_RETRY_DELAY), Math.random() * Math.pow(2, attempts) * delayBase));
};

});

parcelRegister("9FSOy", function(module, exports) {

$parcel$export(module.exports, "defaultRetryDecider", () => $70b27661c39f4e78$export$3839fd261f89ec2);

var $5WzrF = parcelRequire("5WzrF");
var $70b27661c39f4e78$export$3839fd261f89ec2 = function(error) {
    if (!error) return false;
    return (0, $5WzrF.isRetryableByTrait)(error) || (0, $5WzrF.isClockSkewError)(error) || (0, $5WzrF.isThrottlingError)(error) || (0, $5WzrF.isTransientError)(error);
};

});


parcelRegister("efUMf", function(module, exports) {

$parcel$export(module.exports, "resolveRetryConfig", () => $a60e822578354711$export$ca7f6138f2c98476);

var $huTyO = parcelRequire("huTyO");

var $9EGMS = parcelRequire("9EGMS");
var $a60e822578354711$export$a19952f9e421517c = "AWS_MAX_ATTEMPTS";
var $a60e822578354711$export$9ae8a04532f798bc = "max_attempts";
var $a60e822578354711$export$8023fdddb2ca30e0 = {
    environmentVariableSelector: function(env) {
        var value = env[$a60e822578354711$export$a19952f9e421517c];
        if (!value) return undefined;
        var maxAttempt = parseInt(value);
        if (Number.isNaN(maxAttempt)) throw new Error("Environment variable " + $a60e822578354711$export$a19952f9e421517c + " mast be a number, got \"" + value + "\"");
        return maxAttempt;
    },
    configFileSelector: function(profile) {
        var value = profile[$a60e822578354711$export$9ae8a04532f798bc];
        if (!value) return undefined;
        var maxAttempt = parseInt(value);
        if (Number.isNaN(maxAttempt)) throw new Error("Shared config file entry " + $a60e822578354711$export$9ae8a04532f798bc + " mast be a number, got \"" + value + "\"");
        return maxAttempt;
    },
    default: (0, $9EGMS.DEFAULT_MAX_ATTEMPTS)
};
var $a60e822578354711$export$ca7f6138f2c98476 = function(input) {
    var maxAttempts = $a60e822578354711$var$normalizeMaxAttempts(input.maxAttempts);
    return (0, $huTyO.__assign)((0, $huTyO.__assign)({}, input), {
        maxAttempts: maxAttempts,
        retryStrategy: input.retryStrategy || new (0, $9EGMS.StandardRetryStrategy)(maxAttempts)
    });
};
var $a60e822578354711$var$normalizeMaxAttempts = function(maxAttempts) {
    if (maxAttempts === void 0) maxAttempts = (0, $9EGMS.DEFAULT_MAX_ATTEMPTS);
    if (typeof maxAttempts === "number") {
        var promisified_1 = Promise.resolve(maxAttempts);
        return function() {
            return promisified_1;
        };
    }
    return maxAttempts;
};
var $a60e822578354711$export$4728af91ff39ef3b = "AWS_RETRY_MODE";
var $a60e822578354711$export$c5c0171a17765aea = "retry_mode";
var $a60e822578354711$export$972bf2bb01959ff5 = {
    environmentVariableSelector: function(env) {
        return env[$a60e822578354711$export$4728af91ff39ef3b];
    },
    configFileSelector: function(profile) {
        return profile[$a60e822578354711$export$c5c0171a17765aea];
    },
    default: (0, $9EGMS.DEFAULT_RETRY_MODE)
};

});


parcelRegister("a6ye5", function(module, exports) {

$parcel$export(module.exports, "calculateBodyLength", () => $75b50387e01cc2d4$export$967f3527bf233bc0);
function $75b50387e01cc2d4$export$967f3527bf233bc0(body) {
    if (typeof body === "string") {
        var len = body.length;
        for(var i = len - 1; i >= 0; i--){
            var code = body.charCodeAt(i);
            if (code > 0x7f && code <= 0x7ff) len++;
            else if (code > 0x7ff && code <= 0xffff) len += 2;
        }
        return len;
    } else if (typeof body.byteLength === "number") // handles Uint8Array, ArrayBuffer, Buffer, and ArrayBufferView
    return body.byteLength;
    else if (typeof body.size === "number") // handles browser File object
    return body.size;
}

});

parcelRegister("b9Yj9", function(module, exports) {

$parcel$export(module.exports, "defaultUserAgent", () => $81ff50e06fb4dace$export$69d579f32876892f);

var $dLKI3 = parcelRequire("dLKI3");

var $lukPG = parcelRequire("lukPG");
var $81ff50e06fb4dace$export$69d579f32876892f = function(_a) {
    var serviceId = _a.serviceId, clientVersion = _a.clientVersion;
    return function() {
        return (0, $dLKI3.__awaiter)(void 0, void 0, void 0, function() {
            var parsedUA, sections;
            var _a, _b, _c, _d, _e, _f, _g;
            return (0, $dLKI3.__generator)(this, function(_h) {
                parsedUA = ((_a = window === null || window === void 0 ? void 0 : window.navigator) === null || _a === void 0 ? void 0 : _a.userAgent) ? (0, (/*@__PURE__*/$parcel$interopDefault($lukPG))).parse(window.navigator.userAgent) : undefined;
                sections = [
                    // sdk-metadata
                    [
                        "aws-sdk-js",
                        clientVersion
                    ],
                    // os-metadata
                    [
                        "os/" + (((_b = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.os) === null || _b === void 0 ? void 0 : _b.name) || "other"),
                        (_c = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.os) === null || _c === void 0 ? void 0 : _c.version
                    ],
                    // language-metadata
                    // ECMAScript edition doesn't matter in JS.
                    [
                        "lang/js"
                    ],
                    // browser vendor and version.
                    [
                        "md/browser",
                        ((_e = (_d = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.browser) === null || _d === void 0 ? void 0 : _d.name) !== null && _e !== void 0 ? _e : "unknown") + "_" + ((_g = (_f = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.browser) === null || _f === void 0 ? void 0 : _f.version) !== null && _g !== void 0 ? _g : "unknown")
                    ]
                ];
                if (serviceId) // api-metadata
                // service Id may not appear in non-AWS clients
                sections.push([
                    "api/" + serviceId,
                    clientVersion
                ]);
                return [
                    2 /*return*/ ,
                    sections
                ];
            });
        });
    };
};

});
parcelRegister("dLKI3", function(module, exports) {

$parcel$export(module.exports, "__awaiter", () => $a063e5b40f6d3607$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $a063e5b40f6d3607$export$67ebef60e6f28a6);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $a063e5b40f6d3607$var$extendStatics = function(d, b) {
    $a063e5b40f6d3607$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $a063e5b40f6d3607$var$extendStatics(d, b);
};
function $a063e5b40f6d3607$export$a8ba968b8961cb8a(d, b) {
    $a063e5b40f6d3607$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $a063e5b40f6d3607$export$18ce0697a983be9b = function() {
    $a063e5b40f6d3607$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a063e5b40f6d3607$export$18ce0697a983be9b.apply(this, arguments);
};
function $a063e5b40f6d3607$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $a063e5b40f6d3607$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $a063e5b40f6d3607$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $a063e5b40f6d3607$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $a063e5b40f6d3607$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $a063e5b40f6d3607$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $a063e5b40f6d3607$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $a063e5b40f6d3607$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $a063e5b40f6d3607$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $a063e5b40f6d3607$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $a063e5b40f6d3607$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($a063e5b40f6d3607$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $a063e5b40f6d3607$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $a063e5b40f6d3607$export$10c90e4f7922046c(v) {
    return this instanceof $a063e5b40f6d3607$export$10c90e4f7922046c ? (this.v = v, this) : new $a063e5b40f6d3607$export$10c90e4f7922046c(v);
}
function $a063e5b40f6d3607$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $a063e5b40f6d3607$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $a063e5b40f6d3607$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $a063e5b40f6d3607$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $a063e5b40f6d3607$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $a063e5b40f6d3607$export$19a8beecd37a4c45 === "function" ? $a063e5b40f6d3607$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $a063e5b40f6d3607$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $a063e5b40f6d3607$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $a063e5b40f6d3607$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $a063e5b40f6d3607$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $a063e5b40f6d3607$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("lukPG", function(module, exports) {
!function(e, t) {
    module.exports = t();
}(module.exports, function() {
    return function(e) {
        var t = {};
        function r(i) {
            if (t[i]) return t[i].exports;
            var n = t[i] = {
                i: i,
                l: !1,
                exports: {}
            };
            return e[i].call(n.exports, n, n.exports, r), n.l = !0, n.exports;
        }
        return r.m = e, r.c = t, r.d = function(e, t, i) {
            r.o(e, t) || Object.defineProperty(e, t, {
                enumerable: !0,
                get: i
            });
        }, r.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, r.t = function(e, t) {
            if (1 & t && (e = r(e)), 8 & t) return e;
            if (4 & t && "object" == typeof e && e && e.__esModule) return e;
            var i = Object.create(null);
            if (r.r(i), Object.defineProperty(i, "default", {
                enumerable: !0,
                value: e
            }), 2 & t && "string" != typeof e) for(var n in e)r.d(i, n, (function(t) {
                return e[t];
            }).bind(null, n));
            return i;
        }, r.n = function(e) {
            var t = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return r.d(t, "a", t), t;
        }, r.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, r.p = "", r(r.s = 90);
    }({
        17: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var i = r(18), n = function() {
                function e() {}
                return e.getFirstMatch = function(e, t) {
                    var r = t.match(e);
                    return r && r.length > 0 && r[1] || "";
                }, e.getSecondMatch = function(e, t) {
                    var r = t.match(e);
                    return r && r.length > 1 && r[2] || "";
                }, e.matchAndReturnConst = function(e, t, r) {
                    if (e.test(t)) return r;
                }, e.getWindowsVersionName = function(e) {
                    switch(e){
                        case "NT":
                            return "NT";
                        case "XP":
                            return "XP";
                        case "NT 5.0":
                            return "2000";
                        case "NT 5.1":
                            return "XP";
                        case "NT 5.2":
                            return "2003";
                        case "NT 6.0":
                            return "Vista";
                        case "NT 6.1":
                            return "7";
                        case "NT 6.2":
                            return "8";
                        case "NT 6.3":
                            return "8.1";
                        case "NT 10.0":
                            return "10";
                        default:
                            return;
                    }
                }, e.getMacOSVersionName = function(e) {
                    var t = e.split(".").splice(0, 2).map(function(e) {
                        return parseInt(e, 10) || 0;
                    });
                    t.push(0);
                    var r = t[0], i = t[1];
                    if (10 === r) switch(i){
                        case 5:
                            return "Leopard";
                        case 6:
                            return "Snow Leopard";
                        case 7:
                            return "Lion";
                        case 8:
                            return "Mountain Lion";
                        case 9:
                            return "Mavericks";
                        case 10:
                            return "Yosemite";
                        case 11:
                            return "El Capitan";
                        case 12:
                            return "Sierra";
                        case 13:
                            return "High Sierra";
                        case 14:
                            return "Mojave";
                        case 15:
                            return "Catalina";
                        default:
                            return;
                    }
                    switch(r){
                        case 11:
                            return "Big Sur";
                        case 12:
                            return "Monterey";
                        case 13:
                            return "Ventura";
                        case 14:
                            return "Sonoma";
                        case 15:
                            return "Sequoia";
                        default:
                            return;
                    }
                }, e.getAndroidVersionName = function(e) {
                    var t = e.split(".").splice(0, 2).map(function(e) {
                        return parseInt(e, 10) || 0;
                    });
                    if (t.push(0), !(1 === t[0] && t[1] < 5)) return 1 === t[0] && t[1] < 6 ? "Cupcake" : 1 === t[0] && t[1] >= 6 ? "Donut" : 2 === t[0] && t[1] < 2 ? "Eclair" : 2 === t[0] && 2 === t[1] ? "Froyo" : 2 === t[0] && t[1] > 2 ? "Gingerbread" : 3 === t[0] ? "Honeycomb" : 4 === t[0] && t[1] < 1 ? "Ice Cream Sandwich" : 4 === t[0] && t[1] < 4 ? "Jelly Bean" : 4 === t[0] && t[1] >= 4 ? "KitKat" : 5 === t[0] ? "Lollipop" : 6 === t[0] ? "Marshmallow" : 7 === t[0] ? "Nougat" : 8 === t[0] ? "Oreo" : 9 === t[0] ? "Pie" : void 0;
                }, e.getVersionPrecision = function(e) {
                    return e.split(".").length;
                }, e.compareVersions = function(t, r, i) {
                    void 0 === i && (i = !1);
                    var n = e.getVersionPrecision(t), a = e.getVersionPrecision(r), o = Math.max(n, a), s = 0, u = e.map([
                        t,
                        r
                    ], function(t) {
                        var r = o - e.getVersionPrecision(t), i = t + new Array(r + 1).join(".0");
                        return e.map(i.split("."), function(e) {
                            return new Array(20 - e.length).join("0") + e;
                        }).reverse();
                    });
                    for(i && (s = o - Math.min(n, a)), o -= 1; o >= s;){
                        if (u[0][o] > u[1][o]) return 1;
                        if (u[0][o] === u[1][o]) {
                            if (o === s) return 0;
                            o -= 1;
                        } else if (u[0][o] < u[1][o]) return -1;
                    }
                }, e.map = function(e, t) {
                    var r, i = [];
                    if (Array.prototype.map) return Array.prototype.map.call(e, t);
                    for(r = 0; r < e.length; r += 1)i.push(t(e[r]));
                    return i;
                }, e.find = function(e, t) {
                    var r, i;
                    if (Array.prototype.find) return Array.prototype.find.call(e, t);
                    for(r = 0, i = e.length; r < i; r += 1){
                        var n = e[r];
                        if (t(n, r)) return n;
                    }
                }, e.assign = function(e) {
                    for(var t, r, i = e, n = arguments.length, a = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++)a[o - 1] = arguments[o];
                    if (Object.assign) return Object.assign.apply(Object, [
                        e
                    ].concat(a));
                    var s = function() {
                        var e = a[t];
                        "object" == typeof e && null !== e && Object.keys(e).forEach(function(t) {
                            i[t] = e[t];
                        });
                    };
                    for(t = 0, r = a.length; t < r; t += 1)s();
                    return e;
                }, e.getBrowserAlias = function(e) {
                    return i.BROWSER_ALIASES_MAP[e];
                }, e.getBrowserTypeByAlias = function(e) {
                    return i.BROWSER_MAP[e] || "";
                }, e;
            }();
            t.default = n, e.exports = t.default;
        },
        18: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.ENGINE_MAP = t.OS_MAP = t.PLATFORMS_MAP = t.BROWSER_MAP = t.BROWSER_ALIASES_MAP = void 0;
            t.BROWSER_ALIASES_MAP = {
                AmazonBot: "amazonbot",
                "Amazon Silk": "amazon_silk",
                "Android Browser": "android",
                BaiduSpider: "baiduspider",
                Bada: "bada",
                BingCrawler: "bingcrawler",
                Brave: "brave",
                BlackBerry: "blackberry",
                "ChatGPT-User": "chatgpt_user",
                Chrome: "chrome",
                ClaudeBot: "claudebot",
                Chromium: "chromium",
                Diffbot: "diffbot",
                DuckDuckBot: "duckduckbot",
                DuckDuckGo: "duckduckgo",
                Electron: "electron",
                Epiphany: "epiphany",
                FacebookExternalHit: "facebookexternalhit",
                Firefox: "firefox",
                Focus: "focus",
                Generic: "generic",
                "Google Search": "google_search",
                Googlebot: "googlebot",
                GPTBot: "gptbot",
                "Internet Explorer": "ie",
                InternetArchiveCrawler: "internetarchivecrawler",
                "K-Meleon": "k_meleon",
                LibreWolf: "librewolf",
                Linespider: "linespider",
                Maxthon: "maxthon",
                "Meta-ExternalAds": "meta_externalads",
                "Meta-ExternalAgent": "meta_externalagent",
                "Meta-ExternalFetcher": "meta_externalfetcher",
                "Meta-WebIndexer": "meta_webindexer",
                "Microsoft Edge": "edge",
                "MZ Browser": "mz",
                "NAVER Whale Browser": "naver",
                "OAI-SearchBot": "oai_searchbot",
                Omgilibot: "omgilibot",
                Opera: "opera",
                "Opera Coast": "opera_coast",
                "Pale Moon": "pale_moon",
                PerplexityBot: "perplexitybot",
                "Perplexity-User": "perplexity_user",
                PhantomJS: "phantomjs",
                PingdomBot: "pingdombot",
                Puffin: "puffin",
                QQ: "qq",
                QQLite: "qqlite",
                QupZilla: "qupzilla",
                Roku: "roku",
                Safari: "safari",
                Sailfish: "sailfish",
                "Samsung Internet for Android": "samsung_internet",
                SlackBot: "slackbot",
                SeaMonkey: "seamonkey",
                Sleipnir: "sleipnir",
                "Sogou Browser": "sogou",
                Swing: "swing",
                Tizen: "tizen",
                "UC Browser": "uc",
                Vivaldi: "vivaldi",
                "WebOS Browser": "webos",
                WeChat: "wechat",
                YahooSlurp: "yahooslurp",
                "Yandex Browser": "yandex",
                YandexBot: "yandexbot",
                YouBot: "youbot"
            };
            t.BROWSER_MAP = {
                amazonbot: "AmazonBot",
                amazon_silk: "Amazon Silk",
                android: "Android Browser",
                baiduspider: "BaiduSpider",
                bada: "Bada",
                bingcrawler: "BingCrawler",
                blackberry: "BlackBerry",
                brave: "Brave",
                chatgpt_user: "ChatGPT-User",
                chrome: "Chrome",
                claudebot: "ClaudeBot",
                chromium: "Chromium",
                diffbot: "Diffbot",
                duckduckbot: "DuckDuckBot",
                duckduckgo: "DuckDuckGo",
                edge: "Microsoft Edge",
                electron: "Electron",
                epiphany: "Epiphany",
                facebookexternalhit: "FacebookExternalHit",
                firefox: "Firefox",
                focus: "Focus",
                generic: "Generic",
                google_search: "Google Search",
                googlebot: "Googlebot",
                gptbot: "GPTBot",
                ie: "Internet Explorer",
                internetarchivecrawler: "InternetArchiveCrawler",
                k_meleon: "K-Meleon",
                librewolf: "LibreWolf",
                linespider: "Linespider",
                maxthon: "Maxthon",
                meta_externalads: "Meta-ExternalAds",
                meta_externalagent: "Meta-ExternalAgent",
                meta_externalfetcher: "Meta-ExternalFetcher",
                meta_webindexer: "Meta-WebIndexer",
                mz: "MZ Browser",
                naver: "NAVER Whale Browser",
                oai_searchbot: "OAI-SearchBot",
                omgilibot: "Omgilibot",
                opera: "Opera",
                opera_coast: "Opera Coast",
                pale_moon: "Pale Moon",
                perplexitybot: "PerplexityBot",
                perplexity_user: "Perplexity-User",
                phantomjs: "PhantomJS",
                pingdombot: "PingdomBot",
                puffin: "Puffin",
                qq: "QQ Browser",
                qqlite: "QQ Browser Lite",
                qupzilla: "QupZilla",
                roku: "Roku",
                safari: "Safari",
                sailfish: "Sailfish",
                samsung_internet: "Samsung Internet for Android",
                seamonkey: "SeaMonkey",
                slackbot: "SlackBot",
                sleipnir: "Sleipnir",
                sogou: "Sogou Browser",
                swing: "Swing",
                tizen: "Tizen",
                uc: "UC Browser",
                vivaldi: "Vivaldi",
                webos: "WebOS Browser",
                wechat: "WeChat",
                yahooslurp: "YahooSlurp",
                yandex: "Yandex Browser",
                yandexbot: "YandexBot",
                youbot: "YouBot"
            };
            t.PLATFORMS_MAP = {
                bot: "bot",
                desktop: "desktop",
                mobile: "mobile",
                tablet: "tablet",
                tv: "tv"
            };
            t.OS_MAP = {
                Android: "Android",
                Bada: "Bada",
                BlackBerry: "BlackBerry",
                ChromeOS: "Chrome OS",
                HarmonyOS: "HarmonyOS",
                iOS: "iOS",
                Linux: "Linux",
                MacOS: "macOS",
                PlayStation4: "PlayStation 4",
                Roku: "Roku",
                Tizen: "Tizen",
                WebOS: "WebOS",
                Windows: "Windows",
                WindowsPhone: "Windows Phone"
            };
            t.ENGINE_MAP = {
                Blink: "Blink",
                EdgeHTML: "EdgeHTML",
                Gecko: "Gecko",
                Presto: "Presto",
                Trident: "Trident",
                WebKit: "WebKit"
            };
        },
        90: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var i, n = (i = r(91)) && i.__esModule ? i : {
                default: i
            }, a = r(18);
            function o(e, t) {
                for(var r = 0; r < t.length; r++){
                    var i = t[r];
                    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
                }
            }
            var s = function() {
                function e() {}
                var t, r, i;
                return e.getParser = function(e, t, r) {
                    if (void 0 === t && (t = !1), void 0 === r && (r = null), "string" != typeof e) throw new Error("UserAgent should be a string");
                    return new n.default(e, t, r);
                }, e.parse = function(e, t) {
                    return void 0 === t && (t = null), new n.default(e, t).getResult();
                }, t = e, i = [
                    {
                        key: "BROWSER_MAP",
                        get: function() {
                            return a.BROWSER_MAP;
                        }
                    },
                    {
                        key: "ENGINE_MAP",
                        get: function() {
                            return a.ENGINE_MAP;
                        }
                    },
                    {
                        key: "OS_MAP",
                        get: function() {
                            return a.OS_MAP;
                        }
                    },
                    {
                        key: "PLATFORMS_MAP",
                        get: function() {
                            return a.PLATFORMS_MAP;
                        }
                    }
                ], r = null, i && o(t, i), e;
            }();
            t.default = s, e.exports = t.default;
        },
        91: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var i = u(r(92)), n = u(r(93)), a = u(r(94)), o = u(r(95)), s = u(r(17));
            function u(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }
            var d = function() {
                function e(e, t, r) {
                    if (void 0 === t && (t = !1), void 0 === r && (r = null), null == e || "" === e) throw new Error("UserAgent parameter can't be empty");
                    this._ua = e;
                    var i = !1;
                    "boolean" == typeof t ? (i = t, this._hints = r) : this._hints = null != t && "object" == typeof t ? t : null, this.parsedResult = {}, !0 !== i && this.parse();
                }
                var t = e.prototype;
                return t.getHints = function() {
                    return this._hints;
                }, t.hasBrand = function(e) {
                    if (!this._hints || !Array.isArray(this._hints.brands)) return !1;
                    var t = e.toLowerCase();
                    return this._hints.brands.some(function(e) {
                        return e.brand && e.brand.toLowerCase() === t;
                    });
                }, t.getBrandVersion = function(e) {
                    if (this._hints && Array.isArray(this._hints.brands)) {
                        var t = e.toLowerCase(), r = this._hints.brands.find(function(e) {
                            return e.brand && e.brand.toLowerCase() === t;
                        });
                        return r ? r.version : void 0;
                    }
                }, t.getUA = function() {
                    return this._ua;
                }, t.test = function(e) {
                    return e.test(this._ua);
                }, t.parseBrowser = function() {
                    var e = this;
                    this.parsedResult.browser = {};
                    var t = s.default.find(i.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (Array.isArray(t.test)) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.browser = t.describe(this.getUA(), this)), this.parsedResult.browser;
                }, t.getBrowser = function() {
                    return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
                }, t.getBrowserName = function(e) {
                    return e ? String(this.getBrowser().name).toLowerCase() || "" : this.getBrowser().name || "";
                }, t.getBrowserVersion = function() {
                    return this.getBrowser().version;
                }, t.getOS = function() {
                    return this.parsedResult.os ? this.parsedResult.os : this.parseOS();
                }, t.parseOS = function() {
                    var e = this;
                    this.parsedResult.os = {};
                    var t = s.default.find(n.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (Array.isArray(t.test)) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.os = t.describe(this.getUA())), this.parsedResult.os;
                }, t.getOSName = function(e) {
                    var t = this.getOS().name;
                    return e ? String(t).toLowerCase() || "" : t || "";
                }, t.getOSVersion = function() {
                    return this.getOS().version;
                }, t.getPlatform = function() {
                    return this.parsedResult.platform ? this.parsedResult.platform : this.parsePlatform();
                }, t.getPlatformType = function(e) {
                    void 0 === e && (e = !1);
                    var t = this.getPlatform().type;
                    return e ? String(t).toLowerCase() || "" : t || "";
                }, t.parsePlatform = function() {
                    var e = this;
                    this.parsedResult.platform = {};
                    var t = s.default.find(a.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (Array.isArray(t.test)) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.platform = t.describe(this.getUA())), this.parsedResult.platform;
                }, t.getEngine = function() {
                    return this.parsedResult.engine ? this.parsedResult.engine : this.parseEngine();
                }, t.getEngineName = function(e) {
                    return e ? String(this.getEngine().name).toLowerCase() || "" : this.getEngine().name || "";
                }, t.parseEngine = function() {
                    var e = this;
                    this.parsedResult.engine = {};
                    var t = s.default.find(o.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (Array.isArray(t.test)) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.engine = t.describe(this.getUA())), this.parsedResult.engine;
                }, t.parse = function() {
                    return this.parseBrowser(), this.parseOS(), this.parsePlatform(), this.parseEngine(), this;
                }, t.getResult = function() {
                    return s.default.assign({}, this.parsedResult);
                }, t.satisfies = function(e) {
                    var t = this, r = {}, i = 0, n = {}, a = 0;
                    if (Object.keys(e).forEach(function(t) {
                        var o = e[t];
                        "string" == typeof o ? (n[t] = o, a += 1) : "object" == typeof o && (r[t] = o, i += 1);
                    }), i > 0) {
                        var o = Object.keys(r), u = s.default.find(o, function(e) {
                            return t.isOS(e);
                        });
                        if (u) {
                            var d = this.satisfies(r[u]);
                            if (void 0 !== d) return d;
                        }
                        var c = s.default.find(o, function(e) {
                            return t.isPlatform(e);
                        });
                        if (c) {
                            var f = this.satisfies(r[c]);
                            if (void 0 !== f) return f;
                        }
                    }
                    if (a > 0) {
                        var l = Object.keys(n), b = s.default.find(l, function(e) {
                            return t.isBrowser(e, !0);
                        });
                        if (void 0 !== b) return this.compareVersion(n[b]);
                    }
                }, t.isBrowser = function(e, t) {
                    void 0 === t && (t = !1);
                    var r = this.getBrowserName().toLowerCase(), i = e.toLowerCase(), n = s.default.getBrowserTypeByAlias(i);
                    return t && n && (i = n.toLowerCase()), i === r;
                }, t.compareVersion = function(e) {
                    var t = [
                        0
                    ], r = e, i = !1, n = this.getBrowserVersion();
                    if ("string" == typeof n) return ">" === e[0] || "<" === e[0] ? (r = e.substr(1), "=" === e[1] ? (i = !0, r = e.substr(2)) : t = [], ">" === e[0] ? t.push(1) : t.push(-1)) : "=" === e[0] ? r = e.substr(1) : "~" === e[0] && (i = !0, r = e.substr(1)), t.indexOf(s.default.compareVersions(n, r, i)) > -1;
                }, t.isOS = function(e) {
                    return this.getOSName(!0) === String(e).toLowerCase();
                }, t.isPlatform = function(e) {
                    return this.getPlatformType(!0) === String(e).toLowerCase();
                }, t.isEngine = function(e) {
                    return this.getEngineName(!0) === String(e).toLowerCase();
                }, t.is = function(e, t) {
                    return void 0 === t && (t = !1), this.isBrowser(e, t) || this.isOS(e) || this.isPlatform(e);
                }, t.some = function(e) {
                    var t = this;
                    return void 0 === e && (e = []), e.some(function(e) {
                        return t.is(e);
                    });
                }, e;
            }();
            t.default = d, e.exports = t.default;
        },
        92: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var i, n = (i = r(17)) && i.__esModule ? i : {
                default: i
            };
            var a = /version\/(\d+(\.?_?\d+)+)/i, o = [
                {
                    test: [
                        /gptbot/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "GPTBot"
                        }, r = n.default.getFirstMatch(/gptbot\/(\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /chatgpt-user/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "ChatGPT-User"
                        }, r = n.default.getFirstMatch(/chatgpt-user\/(\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /oai-searchbot/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "OAI-SearchBot"
                        }, r = n.default.getFirstMatch(/oai-searchbot\/(\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /claudebot/i,
                        /claude-web/i,
                        /claude-user/i,
                        /claude-searchbot/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "ClaudeBot"
                        }, r = n.default.getFirstMatch(/(?:claudebot|claude-web|claude-user|claude-searchbot)\/(\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /omgilibot/i,
                        /webzio-extended/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Omgilibot"
                        }, r = n.default.getFirstMatch(/(?:omgilibot|webzio-extended)\/(\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /diffbot/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Diffbot"
                        }, r = n.default.getFirstMatch(/diffbot\/(\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /perplexitybot/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "PerplexityBot"
                        }, r = n.default.getFirstMatch(/perplexitybot\/(\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /perplexity-user/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Perplexity-User"
                        }, r = n.default.getFirstMatch(/perplexity-user\/(\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /youbot/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "YouBot"
                        }, r = n.default.getFirstMatch(/youbot\/(\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /meta-webindexer/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Meta-WebIndexer"
                        }, r = n.default.getFirstMatch(/meta-webindexer\/(\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /meta-externalads/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Meta-ExternalAds"
                        }, r = n.default.getFirstMatch(/meta-externalads\/(\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /meta-externalagent/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Meta-ExternalAgent"
                        }, r = n.default.getFirstMatch(/meta-externalagent\/(\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /meta-externalfetcher/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Meta-ExternalFetcher"
                        }, r = n.default.getFirstMatch(/meta-externalfetcher\/(\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Googlebot"
                        }, r = n.default.getFirstMatch(/googlebot\/(\d+(\.\d+))/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /linespider/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Linespider"
                        }, r = n.default.getFirstMatch(/(?:linespider)(?:-[-\w]+)?[\s/](\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /amazonbot/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "AmazonBot"
                        }, r = n.default.getFirstMatch(/amazonbot\/(\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /bingbot/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "BingCrawler"
                        }, r = n.default.getFirstMatch(/bingbot\/(\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /baiduspider/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "BaiduSpider"
                        }, r = n.default.getFirstMatch(/baiduspider\/(\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /duckduckbot/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "DuckDuckBot"
                        }, r = n.default.getFirstMatch(/duckduckbot\/(\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /ia_archiver/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "InternetArchiveCrawler"
                        }, r = n.default.getFirstMatch(/ia_archiver\/(\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /facebookexternalhit/i,
                        /facebookcatalog/i
                    ],
                    describe: function() {
                        return {
                            name: "FacebookExternalHit"
                        };
                    }
                },
                {
                    test: [
                        /slackbot/i,
                        /slack-imgProxy/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "SlackBot"
                        }, r = n.default.getFirstMatch(/(?:slackbot|slack-imgproxy)(?:-[-\w]+)?[\s/](\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /yahoo!?[\s/]*slurp/i
                    ],
                    describe: function() {
                        return {
                            name: "YahooSlurp"
                        };
                    }
                },
                {
                    test: [
                        /yandexbot/i,
                        /yandexmobilebot/i
                    ],
                    describe: function() {
                        return {
                            name: "YandexBot"
                        };
                    }
                },
                {
                    test: [
                        /pingdom/i
                    ],
                    describe: function() {
                        return {
                            name: "PingdomBot"
                        };
                    }
                },
                {
                    test: [
                        /opera/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera"
                        }, r = n.default.getFirstMatch(a, e) || n.default.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opr\/|opios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera"
                        }, r = n.default.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /SamsungBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Samsung Internet for Android"
                        }, r = n.default.getFirstMatch(a, e) || n.default.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /Whale/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "NAVER Whale Browser"
                        }, r = n.default.getFirstMatch(a, e) || n.default.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /PaleMoon/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Pale Moon"
                        }, r = n.default.getFirstMatch(a, e) || n.default.getFirstMatch(/(?:PaleMoon)[\s/](\d+(?:\.\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /MZBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "MZ Browser"
                        }, r = n.default.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /focus/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Focus"
                        }, r = n.default.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /swing/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Swing"
                        }, r = n.default.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /coast/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera Coast"
                        }, r = n.default.getFirstMatch(a, e) || n.default.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opt\/\d+(?:.?_?\d+)+/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera Touch"
                        }, r = n.default.getFirstMatch(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /yabrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Yandex Browser"
                        }, r = n.default.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /ucbrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "UC Browser"
                        }, r = n.default.getFirstMatch(a, e) || n.default.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /Maxthon|mxios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Maxthon"
                        }, r = n.default.getFirstMatch(a, e) || n.default.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /epiphany/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Epiphany"
                        }, r = n.default.getFirstMatch(a, e) || n.default.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /puffin/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Puffin"
                        }, r = n.default.getFirstMatch(a, e) || n.default.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /sleipnir/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Sleipnir"
                        }, r = n.default.getFirstMatch(a, e) || n.default.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /k-meleon/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "K-Meleon"
                        }, r = n.default.getFirstMatch(a, e) || n.default.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /micromessenger/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "WeChat"
                        }, r = n.default.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /qqbrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: /qqbrowserlite/i.test(e) ? "QQ Browser Lite" : "QQ Browser"
                        }, r = n.default.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /msie|trident/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Internet Explorer"
                        }, r = n.default.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /\sedg\//i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Microsoft Edge"
                        }, r = n.default.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /edg([ea]|ios)/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Microsoft Edge"
                        }, r = n.default.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /vivaldi/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Vivaldi"
                        }, r = n.default.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /seamonkey/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "SeaMonkey"
                        }, r = n.default.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /sailfish/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Sailfish"
                        }, r = n.default.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /silk/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Amazon Silk"
                        }, r = n.default.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /phantom/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "PhantomJS"
                        }, r = n.default.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /slimerjs/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "SlimerJS"
                        }, r = n.default.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /blackberry|\bbb\d+/i,
                        /rim\stablet/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "BlackBerry"
                        }, r = n.default.getFirstMatch(a, e) || n.default.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /(web|hpw)[o0]s/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "WebOS Browser"
                        }, r = n.default.getFirstMatch(a, e) || n.default.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /bada/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Bada"
                        }, r = n.default.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Tizen"
                        }, r = n.default.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /qupzilla/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "QupZilla"
                        }, r = n.default.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /librewolf/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "LibreWolf"
                        }, r = n.default.getFirstMatch(/(?:librewolf)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /firefox|iceweasel|fxios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Firefox"
                        }, r = n.default.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /electron/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Electron"
                        }, r = n.default.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /sogoumobilebrowser/i,
                        /metasr/i,
                        /se 2\.[x]/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Sogou Browser"
                        }, r = n.default.getFirstMatch(/(?:sogoumobilebrowser)[\s/](\d+(\.?_?\d+)+)/i, e), i = n.default.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i, e), a = n.default.getFirstMatch(/se ([\d.]+)x/i, e), o = r || i || a;
                        return o && (t.version = o), t;
                    }
                },
                {
                    test: [
                        /MiuiBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Miui"
                        }, r = n.default.getFirstMatch(/(?:MiuiBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        return !!e.hasBrand("DuckDuckGo") || e.test(/\sDdg\/[\d.]+$/i);
                    },
                    describe: function(e, t) {
                        var r = {
                            name: "DuckDuckGo"
                        };
                        if (t) {
                            var i = t.getBrandVersion("DuckDuckGo");
                            if (i) return r.version = i, r;
                        }
                        var a = n.default.getFirstMatch(/\sDdg\/([\d.]+)$/i, e);
                        return a && (r.version = a), r;
                    }
                },
                {
                    test: function(e) {
                        return e.hasBrand("Brave");
                    },
                    describe: function(e, t) {
                        var r = {
                            name: "Brave"
                        };
                        if (t) {
                            var i = t.getBrandVersion("Brave");
                            if (i) return r.version = i, r;
                        }
                        return r;
                    }
                },
                {
                    test: [
                        /chromium/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Chromium"
                        }, r = n.default.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /chrome|crios|crmo/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Chrome"
                        }, r = n.default.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /GSA/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Google Search"
                        }, r = n.default.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        var t = !e.test(/like android/i), r = e.test(/android/i);
                        return t && r;
                    },
                    describe: function(e) {
                        var t = {
                            name: "Android Browser"
                        }, r = n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /playstation 4/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "PlayStation 4"
                        }, r = n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /safari|applewebkit/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Safari"
                        }, r = n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /.*/i
                    ],
                    describe: function(e) {
                        var t = -1 !== e.search("\\(") ? /^(.*)\/(.*)[ \t]\((.*)/ : /^(.*)\/(.*) /;
                        return {
                            name: n.default.getFirstMatch(t, e),
                            version: n.default.getSecondMatch(t, e)
                        };
                    }
                }
            ];
            t.default = o, e.exports = t.default;
        },
        93: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var i, n = (i = r(17)) && i.__esModule ? i : {
                default: i
            }, a = r(18);
            var o = [
                {
                    test: [
                        /Roku\/DVP/
                    ],
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i, e);
                        return {
                            name: a.OS_MAP.Roku,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /windows phone/i
                    ],
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i, e);
                        return {
                            name: a.OS_MAP.WindowsPhone,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /windows /i
                    ],
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i, e), r = n.default.getWindowsVersionName(t);
                        return {
                            name: a.OS_MAP.Windows,
                            version: t,
                            versionName: r
                        };
                    }
                },
                {
                    test: [
                        /Macintosh(.*?) FxiOS(.*?)\//
                    ],
                    describe: function(e) {
                        var t = {
                            name: a.OS_MAP.iOS
                        }, r = n.default.getSecondMatch(/(Version\/)(\d[\d.]+)/, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /macintosh/i
                    ],
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i, e).replace(/[_\s]/g, "."), r = n.default.getMacOSVersionName(t), i = {
                            name: a.OS_MAP.MacOS,
                            version: t
                        };
                        return r && (i.versionName = r), i;
                    }
                },
                {
                    test: [
                        /(ipod|iphone|ipad)/i
                    ],
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i, e).replace(/[_\s]/g, ".");
                        return {
                            name: a.OS_MAP.iOS,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /OpenHarmony/i
                    ],
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/OpenHarmony\s+(\d+(\.\d+)*)/i, e);
                        return {
                            name: a.OS_MAP.HarmonyOS,
                            version: t
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = !e.test(/like android/i), r = e.test(/android/i);
                        return t && r;
                    },
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i, e), r = n.default.getAndroidVersionName(t), i = {
                            name: a.OS_MAP.Android,
                            version: t
                        };
                        return r && (i.versionName = r), i;
                    }
                },
                {
                    test: [
                        /(web|hpw)[o0]s/i
                    ],
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i, e), r = {
                            name: a.OS_MAP.WebOS
                        };
                        return t && t.length && (r.version = t), r;
                    }
                },
                {
                    test: [
                        /blackberry|\bbb\d+/i,
                        /rim\stablet/i
                    ],
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i, e) || n.default.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i, e) || n.default.getFirstMatch(/\bbb(\d+)/i, e);
                        return {
                            name: a.OS_MAP.BlackBerry,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /bada/i
                    ],
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/bada\/(\d+(\.\d+)*)/i, e);
                        return {
                            name: a.OS_MAP.Bada,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i, e);
                        return {
                            name: a.OS_MAP.Tizen,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /linux/i
                    ],
                    describe: function() {
                        return {
                            name: a.OS_MAP.Linux
                        };
                    }
                },
                {
                    test: [
                        /CrOS/
                    ],
                    describe: function() {
                        return {
                            name: a.OS_MAP.ChromeOS
                        };
                    }
                },
                {
                    test: [
                        /PlayStation 4/
                    ],
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i, e);
                        return {
                            name: a.OS_MAP.PlayStation4,
                            version: t
                        };
                    }
                }
            ];
            t.default = o, e.exports = t.default;
        },
        94: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var i, n = (i = r(17)) && i.__esModule ? i : {
                default: i
            }, a = r(18);
            var o = [
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Google"
                        };
                    }
                },
                {
                    test: [
                        /linespider/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Line"
                        };
                    }
                },
                {
                    test: [
                        /amazonbot/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Amazon"
                        };
                    }
                },
                {
                    test: [
                        /gptbot/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "OpenAI"
                        };
                    }
                },
                {
                    test: [
                        /chatgpt-user/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "OpenAI"
                        };
                    }
                },
                {
                    test: [
                        /oai-searchbot/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "OpenAI"
                        };
                    }
                },
                {
                    test: [
                        /baiduspider/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Baidu"
                        };
                    }
                },
                {
                    test: [
                        /bingbot/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Bing"
                        };
                    }
                },
                {
                    test: [
                        /duckduckbot/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "DuckDuckGo"
                        };
                    }
                },
                {
                    test: [
                        /claudebot/i,
                        /claude-web/i,
                        /claude-user/i,
                        /claude-searchbot/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Anthropic"
                        };
                    }
                },
                {
                    test: [
                        /omgilibot/i,
                        /webzio-extended/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Webz.io"
                        };
                    }
                },
                {
                    test: [
                        /diffbot/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Diffbot"
                        };
                    }
                },
                {
                    test: [
                        /perplexitybot/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Perplexity AI"
                        };
                    }
                },
                {
                    test: [
                        /perplexity-user/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Perplexity AI"
                        };
                    }
                },
                {
                    test: [
                        /youbot/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "You.com"
                        };
                    }
                },
                {
                    test: [
                        /ia_archiver/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Internet Archive"
                        };
                    }
                },
                {
                    test: [
                        /meta-webindexer/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Meta"
                        };
                    }
                },
                {
                    test: [
                        /meta-externalads/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Meta"
                        };
                    }
                },
                {
                    test: [
                        /meta-externalagent/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Meta"
                        };
                    }
                },
                {
                    test: [
                        /meta-externalfetcher/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Meta"
                        };
                    }
                },
                {
                    test: [
                        /facebookexternalhit/i,
                        /facebookcatalog/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Meta"
                        };
                    }
                },
                {
                    test: [
                        /slackbot/i,
                        /slack-imgProxy/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Slack"
                        };
                    }
                },
                {
                    test: [
                        /yahoo/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Yahoo"
                        };
                    }
                },
                {
                    test: [
                        /yandexbot/i,
                        /yandexmobilebot/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Yandex"
                        };
                    }
                },
                {
                    test: [
                        /pingdom/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Pingdom"
                        };
                    }
                },
                {
                    test: [
                        /huawei/i
                    ],
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/(can-l01)/i, e) && "Nova", r = {
                            type: a.PLATFORMS_MAP.mobile,
                            vendor: "Huawei"
                        };
                        return t && (r.model = t), r;
                    }
                },
                {
                    test: [
                        /nexus\s*(?:7|8|9|10).*/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.tablet,
                            vendor: "Nexus"
                        };
                    }
                },
                {
                    test: [
                        /ipad/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.tablet,
                            vendor: "Apple",
                            model: "iPad"
                        };
                    }
                },
                {
                    test: [
                        /Macintosh(.*?) FxiOS(.*?)\//
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.tablet,
                            vendor: "Apple",
                            model: "iPad"
                        };
                    }
                },
                {
                    test: [
                        /kftt build/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.tablet,
                            vendor: "Amazon",
                            model: "Kindle Fire HD 7"
                        };
                    }
                },
                {
                    test: [
                        /silk/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.tablet,
                            vendor: "Amazon"
                        };
                    }
                },
                {
                    test: [
                        /tablet(?! pc)/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.tablet
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = e.test(/ipod|iphone/i), r = e.test(/like (ipod|iphone)/i);
                        return t && !r;
                    },
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/(ipod|iphone)/i, e);
                        return {
                            type: a.PLATFORMS_MAP.mobile,
                            vendor: "Apple",
                            model: t
                        };
                    }
                },
                {
                    test: [
                        /nexus\s*[0-6].*/i,
                        /galaxy nexus/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.mobile,
                            vendor: "Nexus"
                        };
                    }
                },
                {
                    test: [
                        /Nokia/i
                    ],
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/Nokia\s+([0-9]+(\.[0-9]+)?)/i, e), r = {
                            type: a.PLATFORMS_MAP.mobile,
                            vendor: "Nokia"
                        };
                        return t && (r.model = t), r;
                    }
                },
                {
                    test: [
                        /[^-]mobi/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "blackberry" === e.getBrowserName(!0);
                    },
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.mobile,
                            vendor: "BlackBerry"
                        };
                    }
                },
                {
                    test: function(e) {
                        return "bada" === e.getBrowserName(!0);
                    },
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "windows phone" === e.getBrowserName();
                    },
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.mobile,
                            vendor: "Microsoft"
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = Number(String(e.getOSVersion()).split(".")[0]);
                        return "android" === e.getOSName(!0) && t >= 3;
                    },
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.tablet
                        };
                    }
                },
                {
                    test: function(e) {
                        return "android" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: [
                        /smart-?tv|smarttv/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.tv
                        };
                    }
                },
                {
                    test: [
                        /netcast/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.tv
                        };
                    }
                },
                {
                    test: function(e) {
                        return "macos" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.desktop,
                            vendor: "Apple"
                        };
                    }
                },
                {
                    test: function(e) {
                        return "windows" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.desktop
                        };
                    }
                },
                {
                    test: function(e) {
                        return "linux" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.desktop
                        };
                    }
                },
                {
                    test: function(e) {
                        return "playstation 4" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.tv
                        };
                    }
                },
                {
                    test: function(e) {
                        return "roku" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.tv
                        };
                    }
                }
            ];
            t.default = o, e.exports = t.default;
        },
        95: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var i, n = (i = r(17)) && i.__esModule ? i : {
                default: i
            }, a = r(18);
            var o = [
                {
                    test: function(e) {
                        return "microsoft edge" === e.getBrowserName(!0);
                    },
                    describe: function(e) {
                        if (/\sedg\//i.test(e)) return {
                            name: a.ENGINE_MAP.Blink
                        };
                        var t = n.default.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i, e);
                        return {
                            name: a.ENGINE_MAP.EdgeHTML,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /trident/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: a.ENGINE_MAP.Trident
                        }, r = n.default.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        return e.test(/presto/i);
                    },
                    describe: function(e) {
                        var t = {
                            name: a.ENGINE_MAP.Presto
                        }, r = n.default.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        var t = e.test(/gecko/i), r = e.test(/like gecko/i);
                        return t && !r;
                    },
                    describe: function(e) {
                        var t = {
                            name: a.ENGINE_MAP.Gecko
                        }, r = n.default.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /(apple)?webkit\/537\.36/i
                    ],
                    describe: function() {
                        return {
                            name: a.ENGINE_MAP.Blink
                        };
                    }
                },
                {
                    test: [
                        /(apple)?webkit/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: a.ENGINE_MAP.WebKit
                        }, r = n.default.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                }
            ];
            t.default = o, e.exports = t.default;
        }
    });
});

});


parcelRegister("01k4l", function(module, exports) {

$parcel$export(module.exports, "ClientSharedValues", () => $003fa96effb85fe6$export$608864383388f904);

var $amcBk = parcelRequire("amcBk");

var $bYLXw = parcelRequire("bYLXw");
var $003fa96effb85fe6$export$608864383388f904 = {
    apiVersion: "2014-06-30",
    disableHostPrefix: false,
    logger: {},
    regionInfoProvider: (0, $amcBk.defaultRegionInfoProvider),
    serviceId: "Cognito Identity",
    urlParser: (0, $bYLXw.parseUrl)
};

});
parcelRegister("amcBk", function(module, exports) {

$parcel$export(module.exports, "defaultRegionInfoProvider", () => $78a5bbc3149a1baf$export$2e4318bf13462aa2);

var $2eeCH = parcelRequire("2eeCH");
// Partition default templates
var $78a5bbc3149a1baf$var$AWS_TEMPLATE = "cognito-identity.{region}.amazonaws.com";
var $78a5bbc3149a1baf$var$AWS_CN_TEMPLATE = "cognito-identity.{region}.amazonaws.com.cn";
var $78a5bbc3149a1baf$var$AWS_ISO_TEMPLATE = "cognito-identity.{region}.c2s.ic.gov";
var $78a5bbc3149a1baf$var$AWS_ISO_B_TEMPLATE = "cognito-identity.{region}.sc2s.sgov.gov";
var $78a5bbc3149a1baf$var$AWS_US_GOV_TEMPLATE = "cognito-identity.{region}.amazonaws.com";
// Partition regions
var $78a5bbc3149a1baf$var$AWS_REGIONS = new Set([
    "af-south-1",
    "ap-east-1",
    "ap-northeast-1",
    "ap-northeast-2",
    "ap-south-1",
    "ap-southeast-1",
    "ap-southeast-2",
    "ca-central-1",
    "eu-central-1",
    "eu-north-1",
    "eu-south-1",
    "eu-west-1",
    "eu-west-2",
    "eu-west-3",
    "me-south-1",
    "sa-east-1",
    "us-east-1",
    "us-east-2",
    "us-west-1",
    "us-west-2"
]);
var $78a5bbc3149a1baf$var$AWS_CN_REGIONS = new Set([
    "cn-north-1",
    "cn-northwest-1"
]);
var $78a5bbc3149a1baf$var$AWS_ISO_REGIONS = new Set([
    "us-iso-east-1"
]);
var $78a5bbc3149a1baf$var$AWS_ISO_B_REGIONS = new Set([
    "us-isob-east-1"
]);
var $78a5bbc3149a1baf$var$AWS_US_GOV_REGIONS = new Set([
    "us-gov-east-1",
    "us-gov-west-1"
]);
var $78a5bbc3149a1baf$export$2e4318bf13462aa2 = function(region, options) {
    var regionInfo = undefined;
    switch(region){
        // First, try to match exact region names.
        case "ap-northeast-1":
            regionInfo = {
                hostname: "cognito-identity.ap-northeast-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-northeast-2":
            regionInfo = {
                hostname: "cognito-identity.ap-northeast-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-south-1":
            regionInfo = {
                hostname: "cognito-identity.ap-south-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-southeast-1":
            regionInfo = {
                hostname: "cognito-identity.ap-southeast-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-southeast-2":
            regionInfo = {
                hostname: "cognito-identity.ap-southeast-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ca-central-1":
            regionInfo = {
                hostname: "cognito-identity.ca-central-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "cn-north-1":
            regionInfo = {
                hostname: "cognito-identity.cn-north-1.amazonaws.com.cn",
                partition: "aws-cn"
            };
            break;
        case "eu-central-1":
            regionInfo = {
                hostname: "cognito-identity.eu-central-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-north-1":
            regionInfo = {
                hostname: "cognito-identity.eu-north-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-west-1":
            regionInfo = {
                hostname: "cognito-identity.eu-west-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-west-2":
            regionInfo = {
                hostname: "cognito-identity.eu-west-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-west-3":
            regionInfo = {
                hostname: "cognito-identity.eu-west-3.amazonaws.com",
                partition: "aws"
            };
            break;
        case "fips-us-east-1":
            regionInfo = {
                hostname: "cognito-identity-fips.us-east-1.amazonaws.com",
                partition: "aws",
                signingRegion: "us-east-1"
            };
            break;
        case "fips-us-east-2":
            regionInfo = {
                hostname: "cognito-identity-fips.us-east-2.amazonaws.com",
                partition: "aws",
                signingRegion: "us-east-2"
            };
            break;
        case "fips-us-gov-west-1":
            regionInfo = {
                hostname: "cognito-identity-fips.us-gov-west-1.amazonaws.com",
                partition: "aws-us-gov",
                signingRegion: "us-gov-west-1"
            };
            break;
        case "fips-us-west-2":
            regionInfo = {
                hostname: "cognito-identity-fips.us-west-2.amazonaws.com",
                partition: "aws",
                signingRegion: "us-west-2"
            };
            break;
        case "sa-east-1":
            regionInfo = {
                hostname: "cognito-identity.sa-east-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "us-east-1":
            regionInfo = {
                hostname: "cognito-identity.us-east-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "us-east-2":
            regionInfo = {
                hostname: "cognito-identity.us-east-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "us-gov-west-1":
            regionInfo = {
                hostname: "cognito-identity.us-gov-west-1.amazonaws.com",
                partition: "aws-us-gov"
            };
            break;
        case "us-west-1":
            regionInfo = {
                hostname: "cognito-identity.us-west-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "us-west-2":
            regionInfo = {
                hostname: "cognito-identity.us-west-2.amazonaws.com",
                partition: "aws"
            };
            break;
        // Next, try to match partition endpoints.
        default:
            if ($78a5bbc3149a1baf$var$AWS_REGIONS.has(region)) regionInfo = {
                hostname: $78a5bbc3149a1baf$var$AWS_TEMPLATE.replace("{region}", region),
                partition: "aws"
            };
            if ($78a5bbc3149a1baf$var$AWS_CN_REGIONS.has(region)) regionInfo = {
                hostname: $78a5bbc3149a1baf$var$AWS_CN_TEMPLATE.replace("{region}", region),
                partition: "aws-cn"
            };
            if ($78a5bbc3149a1baf$var$AWS_ISO_REGIONS.has(region)) regionInfo = {
                hostname: $78a5bbc3149a1baf$var$AWS_ISO_TEMPLATE.replace("{region}", region),
                partition: "aws-iso"
            };
            if ($78a5bbc3149a1baf$var$AWS_ISO_B_REGIONS.has(region)) regionInfo = {
                hostname: $78a5bbc3149a1baf$var$AWS_ISO_B_TEMPLATE.replace("{region}", region),
                partition: "aws-iso-b"
            };
            if ($78a5bbc3149a1baf$var$AWS_US_GOV_REGIONS.has(region)) regionInfo = {
                hostname: $78a5bbc3149a1baf$var$AWS_US_GOV_TEMPLATE.replace("{region}", region),
                partition: "aws-us-gov"
            };
            // Finally, assume it's an AWS partition endpoint.
            if (regionInfo === undefined) regionInfo = {
                hostname: $78a5bbc3149a1baf$var$AWS_TEMPLATE.replace("{region}", region),
                partition: "aws"
            };
    }
    return Promise.resolve((0, $2eeCH.__assign)({
        signingService: "cognito-identity"
    }, regionInfo));
};

});

parcelRegister("bYLXw", function(module, exports) {

$parcel$export(module.exports, "parseUrl", () => $8b8a7ffb84842de9$export$7a5253c0f62e0150);

var $cjZFl = parcelRequire("cjZFl");
var $8b8a7ffb84842de9$export$7a5253c0f62e0150 = function(url) {
    var _a = new URL(url), hostname = _a.hostname, pathname = _a.pathname, port = _a.port, protocol = _a.protocol, search = _a.search;
    var query;
    if (search) query = (0, $cjZFl.parseQueryString)(search);
    return {
        hostname: hostname,
        port: port ? parseInt(port) : undefined,
        protocol: protocol,
        path: pathname,
        query: query
    };
};

});
parcelRegister("cjZFl", function(module, exports) {

$parcel$export(module.exports, "parseQueryString", () => $8f8717f0f6678f0c$export$66256f83798e5415);

var $3uziQ = parcelRequire("3uziQ");
function $8f8717f0f6678f0c$export$66256f83798e5415(querystring) {
    var e_1, _a;
    var query = {};
    querystring = querystring.replace(/^\?/, "");
    if (querystring) try {
        for(var _b = (0, $3uziQ.__values)(querystring.split("&")), _c = _b.next(); !_c.done; _c = _b.next()){
            var pair = _c.value;
            var _d = (0, $3uziQ.__read)(pair.split("="), 2), key = _d[0], _e = _d[1], value = _e === void 0 ? null : _e;
            key = decodeURIComponent(key);
            if (value) value = decodeURIComponent(value);
            if (!(key in query)) query[key] = value;
            else if (Array.isArray(query[key])) query[key].push(value);
            else query[key] = [
                query[key],
                value
            ];
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return query;
}

});
parcelRegister("3uziQ", function(module, exports) {

$parcel$export(module.exports, "__values", () => $28af8edc469f821c$export$19a8beecd37a4c45);
$parcel$export(module.exports, "__read", () => $28af8edc469f821c$export$8d051b38c9118094);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $28af8edc469f821c$var$extendStatics = function(d, b) {
    $28af8edc469f821c$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $28af8edc469f821c$var$extendStatics(d, b);
};
function $28af8edc469f821c$export$a8ba968b8961cb8a(d, b) {
    $28af8edc469f821c$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $28af8edc469f821c$export$18ce0697a983be9b = function() {
    $28af8edc469f821c$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $28af8edc469f821c$export$18ce0697a983be9b.apply(this, arguments);
};
function $28af8edc469f821c$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $28af8edc469f821c$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $28af8edc469f821c$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $28af8edc469f821c$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $28af8edc469f821c$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $28af8edc469f821c$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $28af8edc469f821c$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $28af8edc469f821c$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $28af8edc469f821c$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $28af8edc469f821c$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $28af8edc469f821c$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($28af8edc469f821c$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $28af8edc469f821c$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $28af8edc469f821c$export$10c90e4f7922046c(v) {
    return this instanceof $28af8edc469f821c$export$10c90e4f7922046c ? (this.v = v, this) : new $28af8edc469f821c$export$10c90e4f7922046c(v);
}
function $28af8edc469f821c$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $28af8edc469f821c$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $28af8edc469f821c$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $28af8edc469f821c$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $28af8edc469f821c$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $28af8edc469f821c$export$19a8beecd37a4c45 === "function" ? $28af8edc469f821c$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $28af8edc469f821c$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $28af8edc469f821c$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $28af8edc469f821c$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $28af8edc469f821c$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $28af8edc469f821c$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});





parcelRegister("efaVN", function(module, exports) {
$parcel$export(module.exports, "resolveEndpointsConfig", () => (parcelRequire("gqVgN")).resolveEndpointsConfig);
$parcel$export(module.exports, "resolveRegionConfig", () => (parcelRequire("l59xh")).resolveRegionConfig);
parcelRequire("gqVgN");
parcelRequire("l59xh");

});
parcelRegister("gqVgN", function(module, exports) {

$parcel$export(module.exports, "resolveEndpointsConfig", () => $bf6b7faa7f56cfe1$export$24f352b1bd1e2f8b);

var $j8K9Q = parcelRequire("j8K9Q");
var $bf6b7faa7f56cfe1$export$24f352b1bd1e2f8b = function(input) {
    var _a;
    return (0, $j8K9Q.__assign)((0, $j8K9Q.__assign)({}, input), {
        tls: (_a = input.tls) !== null && _a !== void 0 ? _a : true,
        endpoint: input.endpoint ? $bf6b7faa7f56cfe1$var$normalizeEndpoint(input) : function() {
            return $bf6b7faa7f56cfe1$var$getEndPointFromRegion(input);
        },
        isCustomEndpoint: input.endpoint ? true : false
    });
};
var $bf6b7faa7f56cfe1$var$normalizeEndpoint = function(input) {
    var endpoint = input.endpoint, urlParser = input.urlParser;
    if (typeof endpoint === "string") {
        var promisified_1 = Promise.resolve(urlParser(endpoint));
        return function() {
            return promisified_1;
        };
    } else if (typeof endpoint === "object") {
        var promisified_2 = Promise.resolve(endpoint);
        return function() {
            return promisified_2;
        };
    }
    return endpoint;
};
var $bf6b7faa7f56cfe1$var$getEndPointFromRegion = function(input) {
    return (0, $j8K9Q.__awaiter)(void 0, void 0, void 0, function() {
        var _a, tls, region, dnsHostRegex, hostname;
        var _b;
        return (0, $j8K9Q.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = input.tls, tls = _a === void 0 ? true : _a;
                    return [
                        4 /*yield*/ ,
                        input.region()
                    ];
                case 1:
                    region = _c.sent();
                    dnsHostRegex = new RegExp(/^([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9])$/);
                    if (!dnsHostRegex.test(region)) throw new Error("Invalid region in client config");
                    return [
                        4 /*yield*/ ,
                        input.regionInfoProvider(region)
                    ];
                case 2:
                    hostname = ((_b = _c.sent()) !== null && _b !== void 0 ? _b : {}).hostname;
                    if (!hostname) throw new Error("Cannot resolve hostname from client config");
                    return [
                        2 /*return*/ ,
                        input.urlParser((tls ? "https:" : "http:") + "//" + hostname)
                    ];
            }
        });
    });
};

});
parcelRegister("j8K9Q", function(module, exports) {

$parcel$export(module.exports, "__assign", () => $def291a63a1f12a2$export$18ce0697a983be9b);
$parcel$export(module.exports, "__awaiter", () => $def291a63a1f12a2$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $def291a63a1f12a2$export$67ebef60e6f28a6);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $def291a63a1f12a2$var$extendStatics = function(d, b) {
    $def291a63a1f12a2$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $def291a63a1f12a2$var$extendStatics(d, b);
};
function $def291a63a1f12a2$export$a8ba968b8961cb8a(d, b) {
    $def291a63a1f12a2$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $def291a63a1f12a2$export$18ce0697a983be9b = function() {
    $def291a63a1f12a2$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $def291a63a1f12a2$export$18ce0697a983be9b.apply(this, arguments);
};
function $def291a63a1f12a2$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $def291a63a1f12a2$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $def291a63a1f12a2$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $def291a63a1f12a2$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $def291a63a1f12a2$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $def291a63a1f12a2$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $def291a63a1f12a2$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $def291a63a1f12a2$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $def291a63a1f12a2$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $def291a63a1f12a2$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $def291a63a1f12a2$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($def291a63a1f12a2$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $def291a63a1f12a2$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $def291a63a1f12a2$export$10c90e4f7922046c(v) {
    return this instanceof $def291a63a1f12a2$export$10c90e4f7922046c ? (this.v = v, this) : new $def291a63a1f12a2$export$10c90e4f7922046c(v);
}
function $def291a63a1f12a2$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $def291a63a1f12a2$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $def291a63a1f12a2$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $def291a63a1f12a2$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $def291a63a1f12a2$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $def291a63a1f12a2$export$19a8beecd37a4c45 === "function" ? $def291a63a1f12a2$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $def291a63a1f12a2$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $def291a63a1f12a2$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $def291a63a1f12a2$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $def291a63a1f12a2$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $def291a63a1f12a2$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});


parcelRegister("l59xh", function(module, exports) {

$parcel$export(module.exports, "resolveRegionConfig", () => $f591763821b56133$export$7696ef37558bd0ec);

var $j8K9Q = parcelRequire("j8K9Q");
var $f591763821b56133$export$26513716e2900bad = "AWS_REGION";
var $f591763821b56133$export$8afb1c306a7d01b = "region";
var $f591763821b56133$export$1509d3ea54119a08 = {
    environmentVariableSelector: function(env) {
        return env[$f591763821b56133$export$26513716e2900bad];
    },
    configFileSelector: function(profile) {
        return profile[$f591763821b56133$export$8afb1c306a7d01b];
    },
    default: function() {
        throw new Error("Region is missing");
    }
};
var $f591763821b56133$export$9a37503ca194454d = {
    preferredFile: "credentials"
};
var $f591763821b56133$export$7696ef37558bd0ec = function(input) {
    if (!input.region) throw new Error("Region is missing");
    return (0, $j8K9Q.__assign)((0, $j8K9Q.__assign)({}, input), {
        region: $f591763821b56133$var$normalizeRegion(input.region)
    });
};
var $f591763821b56133$var$normalizeRegion = function(region) {
    if (typeof region === "string") {
        var promisified_1 = Promise.resolve(region);
        return function() {
            return promisified_1;
        };
    }
    return region;
};

});


parcelRegister("d5DYF", function(module, exports) {

$parcel$export(module.exports, "getContentLengthPlugin", () => $987ac0ab8a18a67e$export$7e6ddf9365a30fe9);

var $kTILB = parcelRequire("kTILB");
parcelRequire("3uM9B");
var $dlqaT = parcelRequire("dlqaT");
var $987ac0ab8a18a67e$var$CONTENT_LENGTH_HEADER = "content-length";
function $987ac0ab8a18a67e$export$940b29eb2788b975(bodyLengthChecker) {
    var _this = this;
    return function(next) {
        return function(args) {
            return (0, $kTILB.__awaiter)(_this, void 0, void 0, function() {
                var request, body, headers, length;
                var _a;
                return (0, $kTILB.__generator)(this, function(_b) {
                    request = args.request;
                    if ((0, $dlqaT.HttpRequest).isInstance(request)) {
                        body = request.body, headers = request.headers;
                        if (body && Object.keys(headers).map(function(str) {
                            return str.toLowerCase();
                        }).indexOf($987ac0ab8a18a67e$var$CONTENT_LENGTH_HEADER) === -1) {
                            length = bodyLengthChecker(body);
                            if (length !== undefined) request.headers = (0, $kTILB.__assign)((0, $kTILB.__assign)({}, request.headers), (_a = {}, _a[$987ac0ab8a18a67e$var$CONTENT_LENGTH_HEADER] = String(length), _a));
                        }
                    }
                    return [
                        2 /*return*/ ,
                        next((0, $kTILB.__assign)((0, $kTILB.__assign)({}, args), {
                            request: request
                        }))
                    ];
                });
            });
        };
    };
}
var $987ac0ab8a18a67e$export$1f7816f8f350b2f5 = {
    step: "build",
    tags: [
        "SET_CONTENT_LENGTH",
        "CONTENT_LENGTH"
    ],
    name: "contentLengthMiddleware",
    override: true
};
var $987ac0ab8a18a67e$export$7e6ddf9365a30fe9 = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add($987ac0ab8a18a67e$export$940b29eb2788b975(options.bodyLengthChecker), $987ac0ab8a18a67e$export$1f7816f8f350b2f5);
        }
    };
};

});
parcelRegister("kTILB", function(module, exports) {

$parcel$export(module.exports, "__assign", () => $f36bab71e5c788ed$export$18ce0697a983be9b);
$parcel$export(module.exports, "__awaiter", () => $f36bab71e5c788ed$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $f36bab71e5c788ed$export$67ebef60e6f28a6);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $f36bab71e5c788ed$var$extendStatics = function(d, b) {
    $f36bab71e5c788ed$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $f36bab71e5c788ed$var$extendStatics(d, b);
};
function $f36bab71e5c788ed$export$a8ba968b8961cb8a(d, b) {
    $f36bab71e5c788ed$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $f36bab71e5c788ed$export$18ce0697a983be9b = function() {
    $f36bab71e5c788ed$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f36bab71e5c788ed$export$18ce0697a983be9b.apply(this, arguments);
};
function $f36bab71e5c788ed$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $f36bab71e5c788ed$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $f36bab71e5c788ed$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $f36bab71e5c788ed$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $f36bab71e5c788ed$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $f36bab71e5c788ed$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $f36bab71e5c788ed$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $f36bab71e5c788ed$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $f36bab71e5c788ed$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $f36bab71e5c788ed$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $f36bab71e5c788ed$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($f36bab71e5c788ed$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $f36bab71e5c788ed$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $f36bab71e5c788ed$export$10c90e4f7922046c(v) {
    return this instanceof $f36bab71e5c788ed$export$10c90e4f7922046c ? (this.v = v, this) : new $f36bab71e5c788ed$export$10c90e4f7922046c(v);
}
function $f36bab71e5c788ed$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $f36bab71e5c788ed$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $f36bab71e5c788ed$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $f36bab71e5c788ed$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $f36bab71e5c788ed$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $f36bab71e5c788ed$export$19a8beecd37a4c45 === "function" ? $f36bab71e5c788ed$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $f36bab71e5c788ed$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $f36bab71e5c788ed$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $f36bab71e5c788ed$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $f36bab71e5c788ed$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $f36bab71e5c788ed$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});


parcelRegister("e80zq", function(module, exports) {

$parcel$export(module.exports, "resolveHostHeaderConfig", () => $a492414c61ef9c88$export$c1625bf0b32b4481);
$parcel$export(module.exports, "getHostHeaderPlugin", () => $a492414c61ef9c88$export$23d3b647211be53a);

var $exApS = parcelRequire("exApS");
parcelRequire("3uM9B");
var $dlqaT = parcelRequire("dlqaT");
function $a492414c61ef9c88$export$c1625bf0b32b4481(input) {
    return input;
}
var $a492414c61ef9c88$export$858685d7aeef192d = function(options) {
    return function(next) {
        return function(args) {
            return (0, $exApS.__awaiter)(void 0, void 0, void 0, function() {
                var request, _a, handlerProtocol;
                return (0, $exApS.__generator)(this, function(_b) {
                    if (!(0, $dlqaT.HttpRequest).isInstance(args.request)) return [
                        2 /*return*/ ,
                        next(args)
                    ];
                    request = args.request;
                    _a = (options.requestHandler.metadata || {}).handlerProtocol, handlerProtocol = _a === void 0 ? "" : _a;
                    //For H2 request, remove 'host' header and use ':authority' header instead
                    //reference: https://nodejs.org/dist/latest-v13.x/docs/api/errors.html#ERR_HTTP2_INVALID_CONNECTION_HEADERS
                    if (handlerProtocol.indexOf("h2") >= 0 && !request.headers[":authority"]) {
                        delete request.headers["host"];
                        request.headers[":authority"] = "";
                    //non-H2 request and 'host' header is not set, set the 'host' header to request's hostname.
                    } else if (!request.headers["host"]) request.headers["host"] = request.hostname;
                    return [
                        2 /*return*/ ,
                        next(args)
                    ];
                });
            });
        };
    };
};
var $a492414c61ef9c88$export$696d244ba96181e8 = {
    name: "hostHeaderMiddleware",
    step: "build",
    priority: "low",
    tags: [
        "HOST"
    ],
    override: true
};
var $a492414c61ef9c88$export$23d3b647211be53a = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add($a492414c61ef9c88$export$858685d7aeef192d(options), $a492414c61ef9c88$export$696d244ba96181e8);
        }
    };
};

});
parcelRegister("exApS", function(module, exports) {

$parcel$export(module.exports, "__awaiter", () => $a9606549e9374770$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $a9606549e9374770$export$67ebef60e6f28a6);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $a9606549e9374770$var$extendStatics = function(d, b) {
    $a9606549e9374770$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $a9606549e9374770$var$extendStatics(d, b);
};
function $a9606549e9374770$export$a8ba968b8961cb8a(d, b) {
    $a9606549e9374770$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $a9606549e9374770$export$18ce0697a983be9b = function() {
    $a9606549e9374770$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a9606549e9374770$export$18ce0697a983be9b.apply(this, arguments);
};
function $a9606549e9374770$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $a9606549e9374770$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $a9606549e9374770$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $a9606549e9374770$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $a9606549e9374770$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $a9606549e9374770$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $a9606549e9374770$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $a9606549e9374770$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $a9606549e9374770$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $a9606549e9374770$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $a9606549e9374770$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($a9606549e9374770$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $a9606549e9374770$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $a9606549e9374770$export$10c90e4f7922046c(v) {
    return this instanceof $a9606549e9374770$export$10c90e4f7922046c ? (this.v = v, this) : new $a9606549e9374770$export$10c90e4f7922046c(v);
}
function $a9606549e9374770$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $a9606549e9374770$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $a9606549e9374770$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $a9606549e9374770$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $a9606549e9374770$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $a9606549e9374770$export$19a8beecd37a4c45 === "function" ? $a9606549e9374770$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $a9606549e9374770$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $a9606549e9374770$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $a9606549e9374770$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $a9606549e9374770$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $a9606549e9374770$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});


parcelRegister("9FJYQ", function(module, exports) {
$parcel$export(module.exports, "getLoggerPlugin", () => (parcelRequire("8Hvpq")).getLoggerPlugin);
parcelRequire("8Hvpq");

});
parcelRegister("8Hvpq", function(module, exports) {

$parcel$export(module.exports, "getLoggerPlugin", () => $655ab4188a378743$export$f6ef65d7766fc255);

var $goV4u = parcelRequire("goV4u");
var $655ab4188a378743$export$fe0e777ee4f58cde = function() {
    return function(next, context) {
        return function(args) {
            return (0, $goV4u.__awaiter)(void 0, void 0, void 0, function() {
                var clientName, commandName, inputFilterSensitiveLog, logger, outputFilterSensitiveLog, response, _a, $metadata, outputWithoutMetadata;
                return (0, $goV4u.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            clientName = context.clientName, commandName = context.commandName, inputFilterSensitiveLog = context.inputFilterSensitiveLog, logger = context.logger, outputFilterSensitiveLog = context.outputFilterSensitiveLog;
                            return [
                                4 /*yield*/ ,
                                next(args)
                            ];
                        case 1:
                            response = _b.sent();
                            if (!logger) return [
                                2 /*return*/ ,
                                response
                            ];
                            if (typeof logger.info === "function") {
                                _a = response.output, $metadata = _a.$metadata, outputWithoutMetadata = (0, $goV4u.__rest)(_a, [
                                    "$metadata"
                                ]);
                                logger.info({
                                    clientName: clientName,
                                    commandName: commandName,
                                    input: inputFilterSensitiveLog(args.input),
                                    output: outputFilterSensitiveLog(outputWithoutMetadata),
                                    metadata: $metadata
                                });
                            }
                            return [
                                2 /*return*/ ,
                                response
                            ];
                    }
                });
            });
        };
    };
};
var $655ab4188a378743$export$877c148ab4ad0722 = {
    name: "loggerMiddleware",
    tags: [
        "LOGGER"
    ],
    step: "initialize",
    override: true
};
var $655ab4188a378743$export$f6ef65d7766fc255 = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add($655ab4188a378743$export$fe0e777ee4f58cde(), $655ab4188a378743$export$877c148ab4ad0722);
        }
    };
};

});
parcelRegister("goV4u", function(module, exports) {

$parcel$export(module.exports, "__rest", () => $bf0b286e8ca51fd8$export$3c9a16f847548506);
$parcel$export(module.exports, "__awaiter", () => $bf0b286e8ca51fd8$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $bf0b286e8ca51fd8$export$67ebef60e6f28a6);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $bf0b286e8ca51fd8$var$extendStatics = function(d, b) {
    $bf0b286e8ca51fd8$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $bf0b286e8ca51fd8$var$extendStatics(d, b);
};
function $bf0b286e8ca51fd8$export$a8ba968b8961cb8a(d, b) {
    $bf0b286e8ca51fd8$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $bf0b286e8ca51fd8$export$18ce0697a983be9b = function() {
    $bf0b286e8ca51fd8$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $bf0b286e8ca51fd8$export$18ce0697a983be9b.apply(this, arguments);
};
function $bf0b286e8ca51fd8$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $bf0b286e8ca51fd8$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $bf0b286e8ca51fd8$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $bf0b286e8ca51fd8$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $bf0b286e8ca51fd8$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $bf0b286e8ca51fd8$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $bf0b286e8ca51fd8$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $bf0b286e8ca51fd8$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $bf0b286e8ca51fd8$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $bf0b286e8ca51fd8$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $bf0b286e8ca51fd8$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($bf0b286e8ca51fd8$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $bf0b286e8ca51fd8$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $bf0b286e8ca51fd8$export$10c90e4f7922046c(v) {
    return this instanceof $bf0b286e8ca51fd8$export$10c90e4f7922046c ? (this.v = v, this) : new $bf0b286e8ca51fd8$export$10c90e4f7922046c(v);
}
function $bf0b286e8ca51fd8$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $bf0b286e8ca51fd8$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $bf0b286e8ca51fd8$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $bf0b286e8ca51fd8$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $bf0b286e8ca51fd8$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $bf0b286e8ca51fd8$export$19a8beecd37a4c45 === "function" ? $bf0b286e8ca51fd8$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $bf0b286e8ca51fd8$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $bf0b286e8ca51fd8$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $bf0b286e8ca51fd8$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $bf0b286e8ca51fd8$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $bf0b286e8ca51fd8$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});



parcelRegister("5jjeh", function(module, exports) {
$parcel$export(module.exports, "resolveAwsAuthConfig", () => (parcelRequire("6KIbI")).resolveAwsAuthConfig);
$parcel$export(module.exports, "getAwsAuthPlugin", () => (parcelRequire("aP5Uo")).getAwsAuthPlugin);
parcelRequire("6KIbI");
parcelRequire("aP5Uo");

});
parcelRegister("6KIbI", function(module, exports) {

$parcel$export(module.exports, "resolveAwsAuthConfig", () => $4ea950bff733636f$export$1dd62920de1feabb);

var $fa7vX = parcelRequire("fa7vX");
parcelRequire("2f1qr");
var $6Wqud = parcelRequire("6Wqud");
function $4ea950bff733636f$export$1dd62920de1feabb(input) {
    var _this = this;
    var credentials = input.credentials || input.credentialDefaultProvider(input);
    var normalizedCreds = $4ea950bff733636f$var$normalizeProvider(credentials);
    var _a = input.signingEscapePath, signingEscapePath = _a === void 0 ? true : _a, _b = input.systemClockOffset, systemClockOffset = _b === void 0 ? input.systemClockOffset || 0 : _b, sha256 = input.sha256;
    var signer;
    if (input.signer) //if signer is supplied by user, normalize it to a function returning a promise for signer.
    signer = $4ea950bff733636f$var$normalizeProvider(input.signer);
    else //construct a provider inferring signing from region.
    signer = function() {
        return $4ea950bff733636f$var$normalizeProvider(input.region)().then(function(region) {
            return (0, $fa7vX.__awaiter)(_this, void 0, void 0, function() {
                return (0, $fa7vX.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                input.regionInfoProvider(region)
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                [
                                    _a.sent() || {},
                                    region
                                ]
                            ];
                    }
                });
            });
        }).then(function(_a) {
            var _b = (0, $fa7vX.__read)(_a, 2), regionInfo = _b[0], region = _b[1];
            var signingRegion = regionInfo.signingRegion, signingService = regionInfo.signingService;
            //update client's singing region and signing service config if they are resolved.
            //signing region resolving order: user supplied signingRegion -> endpoints.json inferred region -> client region
            input.signingRegion = input.signingRegion || signingRegion || region;
            //signing name resolving order:
            //user supplied signingName -> endpoints.json inferred (credential scope -> model arnNamespace) -> model service id
            input.signingName = input.signingName || signingService || input.serviceId;
            return new (0, $6Wqud.SignatureV4)({
                credentials: normalizedCreds,
                region: input.signingRegion,
                service: input.signingName,
                sha256: sha256,
                uriEscapePath: signingEscapePath
            });
        });
    };
    return (0, $fa7vX.__assign)((0, $fa7vX.__assign)({}, input), {
        systemClockOffset: systemClockOffset,
        signingEscapePath: signingEscapePath,
        credentials: normalizedCreds,
        signer: signer
    });
}
function $4ea950bff733636f$var$normalizeProvider(input) {
    if (typeof input === "object") {
        var promisified_1 = Promise.resolve(input);
        return function() {
            return promisified_1;
        };
    }
    return input;
}

});
parcelRegister("fa7vX", function(module, exports) {

$parcel$export(module.exports, "__assign", () => $02d9407d95adc90e$export$18ce0697a983be9b);
$parcel$export(module.exports, "__awaiter", () => $02d9407d95adc90e$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $02d9407d95adc90e$export$67ebef60e6f28a6);
$parcel$export(module.exports, "__read", () => $02d9407d95adc90e$export$8d051b38c9118094);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $02d9407d95adc90e$var$extendStatics = function(d, b) {
    $02d9407d95adc90e$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $02d9407d95adc90e$var$extendStatics(d, b);
};
function $02d9407d95adc90e$export$a8ba968b8961cb8a(d, b) {
    $02d9407d95adc90e$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $02d9407d95adc90e$export$18ce0697a983be9b = function() {
    $02d9407d95adc90e$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $02d9407d95adc90e$export$18ce0697a983be9b.apply(this, arguments);
};
function $02d9407d95adc90e$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $02d9407d95adc90e$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $02d9407d95adc90e$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $02d9407d95adc90e$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $02d9407d95adc90e$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $02d9407d95adc90e$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $02d9407d95adc90e$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $02d9407d95adc90e$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $02d9407d95adc90e$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $02d9407d95adc90e$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $02d9407d95adc90e$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($02d9407d95adc90e$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $02d9407d95adc90e$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $02d9407d95adc90e$export$10c90e4f7922046c(v) {
    return this instanceof $02d9407d95adc90e$export$10c90e4f7922046c ? (this.v = v, this) : new $02d9407d95adc90e$export$10c90e4f7922046c(v);
}
function $02d9407d95adc90e$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $02d9407d95adc90e$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $02d9407d95adc90e$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $02d9407d95adc90e$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $02d9407d95adc90e$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $02d9407d95adc90e$export$19a8beecd37a4c45 === "function" ? $02d9407d95adc90e$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $02d9407d95adc90e$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $02d9407d95adc90e$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $02d9407d95adc90e$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $02d9407d95adc90e$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $02d9407d95adc90e$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("2f1qr", function(module, exports) {
$parcel$export(module.exports, "SignatureV4", () => (parcelRequire("6Wqud")).SignatureV4);
parcelRequire("2sk7M");
parcelRequire("6Wqud");

});
parcelRegister("2sk7M", function(module, exports) {

$parcel$export(module.exports, "createScope", () => $1c9dce9a669bbe3d$export$41a9651decfe2bde);
$parcel$export(module.exports, "getSigningKey", () => $1c9dce9a669bbe3d$export$8b95a069d16dd783);

var $2MK7s = parcelRequire("2MK7s");

var $2YcGN = parcelRequire("2YcGN");

var $jXuZF = parcelRequire("jXuZF");
var $1c9dce9a669bbe3d$var$signingKeyCache = {};
var $1c9dce9a669bbe3d$var$cacheQueue = [];
function $1c9dce9a669bbe3d$export$41a9651decfe2bde(shortDate, region, service) {
    return shortDate + "/" + region + "/" + service + "/" + (0, $jXuZF.KEY_TYPE_IDENTIFIER);
}
var $1c9dce9a669bbe3d$export$8b95a069d16dd783 = function(sha256Constructor, credentials, shortDate, region, service) {
    return (0, $2MK7s.__awaiter)(void 0, void 0, void 0, function() {
        var credsHash, cacheKey, key, _a, _b, signable, e_1_1;
        var e_1, _c;
        return (0, $2MK7s.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        $1c9dce9a669bbe3d$var$hmac(sha256Constructor, credentials.secretAccessKey, credentials.accessKeyId)
                    ];
                case 1:
                    credsHash = _d.sent();
                    cacheKey = shortDate + ":" + region + ":" + service + ":" + (0, $2YcGN.toHex)(credsHash) + ":" + credentials.sessionToken;
                    if (cacheKey in $1c9dce9a669bbe3d$var$signingKeyCache) return [
                        2 /*return*/ ,
                        $1c9dce9a669bbe3d$var$signingKeyCache[cacheKey]
                    ];
                    $1c9dce9a669bbe3d$var$cacheQueue.push(cacheKey);
                    while($1c9dce9a669bbe3d$var$cacheQueue.length > (0, $jXuZF.MAX_CACHE_SIZE))delete $1c9dce9a669bbe3d$var$signingKeyCache[$1c9dce9a669bbe3d$var$cacheQueue.shift()];
                    key = "AWS4" + credentials.secretAccessKey;
                    _d.label = 2;
                case 2:
                    _d.trys.push([
                        2,
                        7,
                        8,
                        9
                    ]);
                    _a = (0, $2MK7s.__values)([
                        shortDate,
                        region,
                        service,
                        (0, $jXuZF.KEY_TYPE_IDENTIFIER)
                    ]), _b = _a.next();
                    _d.label = 3;
                case 3:
                    if (!!_b.done) return [
                        3 /*break*/ ,
                        6
                    ];
                    signable = _b.value;
                    return [
                        4 /*yield*/ ,
                        $1c9dce9a669bbe3d$var$hmac(sha256Constructor, key, signable)
                    ];
                case 4:
                    key = _d.sent();
                    _d.label = 5;
                case 5:
                    _b = _a.next();
                    return [
                        3 /*break*/ ,
                        3
                    ];
                case 6:
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 7:
                    e_1_1 = _d.sent();
                    e_1 = {
                        error: e_1_1
                    };
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    try {
                        if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                    return [
                        7 /*endfinally*/ 
                    ];
                case 9:
                    return [
                        2 /*return*/ ,
                        $1c9dce9a669bbe3d$var$signingKeyCache[cacheKey] = key
                    ];
            }
        });
    });
};
function $1c9dce9a669bbe3d$export$a31b95746ea0a30a() {
    $1c9dce9a669bbe3d$var$cacheQueue.length = 0;
    Object.keys($1c9dce9a669bbe3d$var$signingKeyCache).forEach(function(cacheKey) {
        delete $1c9dce9a669bbe3d$var$signingKeyCache[cacheKey];
    });
}
function $1c9dce9a669bbe3d$var$hmac(ctor, secret, data) {
    var hash = new ctor(secret);
    hash.update(data);
    return hash.digest();
}

});
parcelRegister("2MK7s", function(module, exports) {

$parcel$export(module.exports, "__assign", () => $2073d6c958e2e391$export$18ce0697a983be9b);
$parcel$export(module.exports, "__rest", () => $2073d6c958e2e391$export$3c9a16f847548506);
$parcel$export(module.exports, "__awaiter", () => $2073d6c958e2e391$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $2073d6c958e2e391$export$67ebef60e6f28a6);
$parcel$export(module.exports, "__values", () => $2073d6c958e2e391$export$19a8beecd37a4c45);
$parcel$export(module.exports, "__spread", () => $2073d6c958e2e391$export$afc72e2116322959);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $2073d6c958e2e391$var$extendStatics = function(d, b) {
    $2073d6c958e2e391$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $2073d6c958e2e391$var$extendStatics(d, b);
};
function $2073d6c958e2e391$export$a8ba968b8961cb8a(d, b) {
    $2073d6c958e2e391$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $2073d6c958e2e391$export$18ce0697a983be9b = function() {
    $2073d6c958e2e391$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2073d6c958e2e391$export$18ce0697a983be9b.apply(this, arguments);
};
function $2073d6c958e2e391$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $2073d6c958e2e391$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $2073d6c958e2e391$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $2073d6c958e2e391$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $2073d6c958e2e391$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $2073d6c958e2e391$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $2073d6c958e2e391$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $2073d6c958e2e391$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $2073d6c958e2e391$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $2073d6c958e2e391$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $2073d6c958e2e391$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($2073d6c958e2e391$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $2073d6c958e2e391$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $2073d6c958e2e391$export$10c90e4f7922046c(v) {
    return this instanceof $2073d6c958e2e391$export$10c90e4f7922046c ? (this.v = v, this) : new $2073d6c958e2e391$export$10c90e4f7922046c(v);
}
function $2073d6c958e2e391$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $2073d6c958e2e391$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $2073d6c958e2e391$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $2073d6c958e2e391$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $2073d6c958e2e391$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $2073d6c958e2e391$export$19a8beecd37a4c45 === "function" ? $2073d6c958e2e391$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $2073d6c958e2e391$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $2073d6c958e2e391$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $2073d6c958e2e391$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $2073d6c958e2e391$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $2073d6c958e2e391$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("jXuZF", function(module, exports) {

$parcel$export(module.exports, "ALGORITHM_QUERY_PARAM", () => $e87b91ad4d845af2$export$186cd8495ba0377d);
$parcel$export(module.exports, "CREDENTIAL_QUERY_PARAM", () => $e87b91ad4d845af2$export$5c8e6dd7758f59d6);
$parcel$export(module.exports, "AMZ_DATE_QUERY_PARAM", () => $e87b91ad4d845af2$export$6e114beec37430d7);
$parcel$export(module.exports, "SIGNED_HEADERS_QUERY_PARAM", () => $e87b91ad4d845af2$export$2dcbb254f883c238);
$parcel$export(module.exports, "EXPIRES_QUERY_PARAM", () => $e87b91ad4d845af2$export$a0afe6f3bbfaf76e);
$parcel$export(module.exports, "SIGNATURE_QUERY_PARAM", () => $e87b91ad4d845af2$export$41ae838dc1e0f082);
$parcel$export(module.exports, "TOKEN_QUERY_PARAM", () => $e87b91ad4d845af2$export$8e1383b7eea7bee);
$parcel$export(module.exports, "AUTH_HEADER", () => $e87b91ad4d845af2$export$9924a64a4b8b0d58);
$parcel$export(module.exports, "AMZ_DATE_HEADER", () => $e87b91ad4d845af2$export$acf4b8bdf24aab34);
$parcel$export(module.exports, "GENERATED_HEADERS", () => $e87b91ad4d845af2$export$20d6a73fd0b10982);
$parcel$export(module.exports, "SIGNATURE_HEADER", () => $e87b91ad4d845af2$export$29961f34c719157e);
$parcel$export(module.exports, "SHA256_HEADER", () => $e87b91ad4d845af2$export$eaef12179141669a);
$parcel$export(module.exports, "TOKEN_HEADER", () => $e87b91ad4d845af2$export$fdc81b663012a8d2);
$parcel$export(module.exports, "ALWAYS_UNSIGNABLE_HEADERS", () => $e87b91ad4d845af2$export$8ffdcd58c4092560);
$parcel$export(module.exports, "PROXY_HEADER_PATTERN", () => $e87b91ad4d845af2$export$8085db98abbe0597);
$parcel$export(module.exports, "SEC_HEADER_PATTERN", () => $e87b91ad4d845af2$export$758380400526c39);
$parcel$export(module.exports, "ALGORITHM_IDENTIFIER", () => $e87b91ad4d845af2$export$863a63fba5b2ddf5);
$parcel$export(module.exports, "EVENT_ALGORITHM_IDENTIFIER", () => $e87b91ad4d845af2$export$9a1f6cf06ac56167);
$parcel$export(module.exports, "UNSIGNED_PAYLOAD", () => $e87b91ad4d845af2$export$91f7321b40d9fd07);
$parcel$export(module.exports, "MAX_CACHE_SIZE", () => $e87b91ad4d845af2$export$bf665777b4a1722f);
$parcel$export(module.exports, "KEY_TYPE_IDENTIFIER", () => $e87b91ad4d845af2$export$c4bf0942098f6bb);
$parcel$export(module.exports, "MAX_PRESIGNED_TTL", () => $e87b91ad4d845af2$export$274df788bdcca184);
var $e87b91ad4d845af2$export$186cd8495ba0377d = "X-Amz-Algorithm";
var $e87b91ad4d845af2$export$5c8e6dd7758f59d6 = "X-Amz-Credential";
var $e87b91ad4d845af2$export$6e114beec37430d7 = "X-Amz-Date";
var $e87b91ad4d845af2$export$2dcbb254f883c238 = "X-Amz-SignedHeaders";
var $e87b91ad4d845af2$export$a0afe6f3bbfaf76e = "X-Amz-Expires";
var $e87b91ad4d845af2$export$41ae838dc1e0f082 = "X-Amz-Signature";
var $e87b91ad4d845af2$export$8e1383b7eea7bee = "X-Amz-Security-Token";
var $e87b91ad4d845af2$export$9924a64a4b8b0d58 = "authorization";
var $e87b91ad4d845af2$export$acf4b8bdf24aab34 = $e87b91ad4d845af2$export$6e114beec37430d7.toLowerCase();
var $e87b91ad4d845af2$export$c65c8c9f514da472 = "date";
var $e87b91ad4d845af2$export$20d6a73fd0b10982 = [
    $e87b91ad4d845af2$export$9924a64a4b8b0d58,
    $e87b91ad4d845af2$export$acf4b8bdf24aab34,
    $e87b91ad4d845af2$export$c65c8c9f514da472
];
var $e87b91ad4d845af2$export$29961f34c719157e = $e87b91ad4d845af2$export$41ae838dc1e0f082.toLowerCase();
var $e87b91ad4d845af2$export$eaef12179141669a = "x-amz-content-sha256";
var $e87b91ad4d845af2$export$fdc81b663012a8d2 = $e87b91ad4d845af2$export$8e1383b7eea7bee.toLowerCase();
var $e87b91ad4d845af2$export$96307741595055fc = "host";
var $e87b91ad4d845af2$export$8ffdcd58c4092560 = {
    authorization: true,
    "cache-control": true,
    connection: true,
    expect: true,
    from: true,
    "keep-alive": true,
    "max-forwards": true,
    pragma: true,
    referer: true,
    te: true,
    trailer: true,
    "transfer-encoding": true,
    upgrade: true,
    "user-agent": true,
    "x-amzn-trace-id": true
};
var $e87b91ad4d845af2$export$8085db98abbe0597 = /^proxy-/;
var $e87b91ad4d845af2$export$758380400526c39 = /^sec-/;
var $e87b91ad4d845af2$export$94e2b626bfa803e0 = [
    /^proxy-/i,
    /^sec-/i
];
var $e87b91ad4d845af2$export$863a63fba5b2ddf5 = "AWS4-HMAC-SHA256";
var $e87b91ad4d845af2$export$9a1f6cf06ac56167 = "AWS4-HMAC-SHA256-PAYLOAD";
var $e87b91ad4d845af2$export$91f7321b40d9fd07 = "UNSIGNED-PAYLOAD";
var $e87b91ad4d845af2$export$bf665777b4a1722f = 50;
var $e87b91ad4d845af2$export$c4bf0942098f6bb = "aws4_request";
var $e87b91ad4d845af2$export$274df788bdcca184 = 604800;

});


parcelRegister("6Wqud", function(module, exports) {

$parcel$export(module.exports, "SignatureV4", () => $50dcb4827b6d4dc4$export$20baf4d3f65eb30c);

var $2MK7s = parcelRequire("2MK7s");

var $2YcGN = parcelRequire("2YcGN");

var $jXuZF = parcelRequire("jXuZF");

var $2sk7M = parcelRequire("2sk7M");

var $7u20F = parcelRequire("7u20F");

var $5a3mc = parcelRequire("5a3mc");

var $86qVa = parcelRequire("86qVa");

var $01cVP = parcelRequire("01cVP");

var $4zuK3 = parcelRequire("4zuK3");

var $kOoP8 = parcelRequire("kOoP8");

var $1egDh = parcelRequire("1egDh");
var $50dcb4827b6d4dc4$export$20baf4d3f65eb30c = /** @class */ function() {
    function SignatureV4(_a) {
        var applyChecksum = _a.applyChecksum, credentials = _a.credentials, region = _a.region, service = _a.service, sha256 = _a.sha256, _b = _a.uriEscapePath, uriEscapePath = _b === void 0 ? true : _b;
        this.service = service;
        this.sha256 = sha256;
        this.uriEscapePath = uriEscapePath;
        // default to true if applyChecksum isn't set
        this.applyChecksum = typeof applyChecksum === "boolean" ? applyChecksum : true;
        this.regionProvider = $50dcb4827b6d4dc4$var$normalizeRegionProvider(region);
        this.credentialProvider = $50dcb4827b6d4dc4$var$normalizeCredentialsProvider(credentials);
    }
    SignatureV4.prototype.presign = function(originalRequest, options) {
        if (options === void 0) options = {};
        return (0, $2MK7s.__awaiter)(this, void 0, void 0, function() {
            var _a, signingDate, _b, expiresIn, unsignableHeaders, unhoistableHeaders, signableHeaders, signingRegion, signingService, credentials, region, _c, _d, longDate, shortDate, scope, request, canonicalHeaders, _e, _f, _g, _h, _j, _k;
            return (0, $2MK7s.__generator)(this, function(_l) {
                switch(_l.label){
                    case 0:
                        _a = options.signingDate, signingDate = _a === void 0 ? new Date() : _a, _b = options.expiresIn, expiresIn = _b === void 0 ? 3600 : _b, unsignableHeaders = options.unsignableHeaders, unhoistableHeaders = options.unhoistableHeaders, signableHeaders = options.signableHeaders, signingRegion = options.signingRegion, signingService = options.signingService;
                        return [
                            4 /*yield*/ ,
                            this.credentialProvider()
                        ];
                    case 1:
                        credentials = _l.sent();
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [
                            3 /*break*/ ,
                            2
                        ];
                        _c = signingRegion;
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 2:
                        return [
                            4 /*yield*/ ,
                            this.regionProvider()
                        ];
                    case 3:
                        _c = _l.sent();
                        _l.label = 4;
                    case 4:
                        region = _c;
                        _d = $50dcb4827b6d4dc4$var$formatDate(signingDate), longDate = _d.longDate, shortDate = _d.shortDate;
                        if (expiresIn > (0, $jXuZF.MAX_PRESIGNED_TTL)) return [
                            2 /*return*/ ,
                            Promise.reject("Signature version 4 presigned URLs must have an expiration date less than one week in the future")
                        ];
                        scope = (0, $2sk7M.createScope)(shortDate, region, signingService !== null && signingService !== void 0 ? signingService : this.service);
                        request = (0, $4zuK3.moveHeadersToQuery)((0, $kOoP8.prepareRequest)(originalRequest), {
                            unhoistableHeaders: unhoistableHeaders
                        });
                        if (credentials.sessionToken) request.query[0, $jXuZF.TOKEN_QUERY_PARAM] = credentials.sessionToken;
                        request.query[0, $jXuZF.ALGORITHM_QUERY_PARAM] = (0, $jXuZF.ALGORITHM_IDENTIFIER);
                        request.query[0, $jXuZF.CREDENTIAL_QUERY_PARAM] = credentials.accessKeyId + "/" + scope;
                        request.query[0, $jXuZF.AMZ_DATE_QUERY_PARAM] = longDate;
                        request.query[0, $jXuZF.EXPIRES_QUERY_PARAM] = expiresIn.toString(10);
                        canonicalHeaders = (0, $7u20F.getCanonicalHeaders)(request, unsignableHeaders, signableHeaders);
                        request.query[0, $jXuZF.SIGNED_HEADERS_QUERY_PARAM] = $50dcb4827b6d4dc4$var$getCanonicalHeaderList(canonicalHeaders);
                        _e = request.query;
                        _f = (0, $jXuZF.SIGNATURE_QUERY_PARAM);
                        _g = this.getSignature;
                        _h = [
                            longDate,
                            scope,
                            this.getSigningKey(credentials, region, shortDate, signingService)
                        ];
                        _j = this.createCanonicalRequest;
                        _k = [
                            request,
                            canonicalHeaders
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $86qVa.getPayloadHash)(originalRequest, this.sha256)
                        ];
                    case 5:
                        return [
                            4 /*yield*/ ,
                            _g.apply(this, _h.concat([
                                _j.apply(this, _k.concat([
                                    _l.sent()
                                ]))
                            ]))
                        ];
                    case 6:
                        _e[_f] = _l.sent();
                        return [
                            2 /*return*/ ,
                            request
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.sign = function(toSign, options) {
        return (0, $2MK7s.__awaiter)(this, void 0, void 0, function() {
            return (0, $2MK7s.__generator)(this, function(_a) {
                if (typeof toSign === "string") return [
                    2 /*return*/ ,
                    this.signString(toSign, options)
                ];
                else if (toSign.headers && toSign.payload) return [
                    2 /*return*/ ,
                    this.signEvent(toSign, options)
                ];
                else return [
                    2 /*return*/ ,
                    this.signRequest(toSign, options)
                ];
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    SignatureV4.prototype.signEvent = function(_a, _b) {
        var headers = _a.headers, payload = _a.payload;
        var _c = _b.signingDate, signingDate = _c === void 0 ? new Date() : _c, priorSignature = _b.priorSignature, signingRegion = _b.signingRegion, signingService = _b.signingService;
        return (0, $2MK7s.__awaiter)(this, void 0, void 0, function() {
            var region, _d, _e, shortDate, longDate, scope, hashedPayload, hash, hashedHeaders, _f, stringToSign;
            return (0, $2MK7s.__generator)(this, function(_g) {
                switch(_g.label){
                    case 0:
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [
                            3 /*break*/ ,
                            1
                        ];
                        _d = signingRegion;
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 1:
                        return [
                            4 /*yield*/ ,
                            this.regionProvider()
                        ];
                    case 2:
                        _d = _g.sent();
                        _g.label = 3;
                    case 3:
                        region = _d;
                        _e = $50dcb4827b6d4dc4$var$formatDate(signingDate), shortDate = _e.shortDate, longDate = _e.longDate;
                        scope = (0, $2sk7M.createScope)(shortDate, region, signingService !== null && signingService !== void 0 ? signingService : this.service);
                        return [
                            4 /*yield*/ ,
                            (0, $86qVa.getPayloadHash)({
                                headers: {},
                                body: payload
                            }, this.sha256)
                        ];
                    case 4:
                        hashedPayload = _g.sent();
                        hash = new this.sha256();
                        hash.update(headers);
                        _f = (0, $2YcGN.toHex);
                        return [
                            4 /*yield*/ ,
                            hash.digest()
                        ];
                    case 5:
                        hashedHeaders = _f.apply(void 0, [
                            _g.sent()
                        ]);
                        stringToSign = [
                            (0, $jXuZF.EVENT_ALGORITHM_IDENTIFIER),
                            longDate,
                            scope,
                            priorSignature,
                            hashedHeaders,
                            hashedPayload
                        ].join("\n");
                        return [
                            2 /*return*/ ,
                            this.signString(stringToSign, {
                                signingDate: signingDate,
                                signingRegion: region,
                                signingService: signingService
                            })
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.signString = function(stringToSign, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.signingDate, signingDate = _c === void 0 ? new Date() : _c, signingRegion = _b.signingRegion, signingService = _b.signingService;
        return (0, $2MK7s.__awaiter)(this, void 0, void 0, function() {
            var credentials, region, _d, shortDate, hash, _e, _f, _g;
            return (0, $2MK7s.__generator)(this, function(_h) {
                switch(_h.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.credentialProvider()
                        ];
                    case 1:
                        credentials = _h.sent();
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [
                            3 /*break*/ ,
                            2
                        ];
                        _d = signingRegion;
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 2:
                        return [
                            4 /*yield*/ ,
                            this.regionProvider()
                        ];
                    case 3:
                        _d = _h.sent();
                        _h.label = 4;
                    case 4:
                        region = _d;
                        shortDate = $50dcb4827b6d4dc4$var$formatDate(signingDate).shortDate;
                        _f = (_e = this.sha256).bind;
                        return [
                            4 /*yield*/ ,
                            this.getSigningKey(credentials, region, shortDate, signingService)
                        ];
                    case 5:
                        hash = new (_f.apply(_e, [
                            void 0,
                            _h.sent()
                        ]))();
                        hash.update(stringToSign);
                        _g = (0, $2YcGN.toHex);
                        return [
                            4 /*yield*/ ,
                            hash.digest()
                        ];
                    case 6:
                        return [
                            2 /*return*/ ,
                            _g.apply(void 0, [
                                _h.sent()
                            ])
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.signRequest = function(requestToSign, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.signingDate, signingDate = _c === void 0 ? new Date() : _c, signableHeaders = _b.signableHeaders, unsignableHeaders = _b.unsignableHeaders, signingRegion = _b.signingRegion, signingService = _b.signingService;
        return (0, $2MK7s.__awaiter)(this, void 0, void 0, function() {
            var credentials, region, _d, request, _e, longDate, shortDate, scope, payloadHash, canonicalHeaders, signature;
            return (0, $2MK7s.__generator)(this, function(_f) {
                switch(_f.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.credentialProvider()
                        ];
                    case 1:
                        credentials = _f.sent();
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [
                            3 /*break*/ ,
                            2
                        ];
                        _d = signingRegion;
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 2:
                        return [
                            4 /*yield*/ ,
                            this.regionProvider()
                        ];
                    case 3:
                        _d = _f.sent();
                        _f.label = 4;
                    case 4:
                        region = _d;
                        request = (0, $kOoP8.prepareRequest)(requestToSign);
                        _e = $50dcb4827b6d4dc4$var$formatDate(signingDate), longDate = _e.longDate, shortDate = _e.shortDate;
                        scope = (0, $2sk7M.createScope)(shortDate, region, signingService !== null && signingService !== void 0 ? signingService : this.service);
                        request.headers[0, $jXuZF.AMZ_DATE_HEADER] = longDate;
                        if (credentials.sessionToken) request.headers[0, $jXuZF.TOKEN_HEADER] = credentials.sessionToken;
                        return [
                            4 /*yield*/ ,
                            (0, $86qVa.getPayloadHash)(request, this.sha256)
                        ];
                    case 5:
                        payloadHash = _f.sent();
                        if (!(0, $01cVP.hasHeader)((0, $jXuZF.SHA256_HEADER), request.headers) && this.applyChecksum) request.headers[0, $jXuZF.SHA256_HEADER] = payloadHash;
                        canonicalHeaders = (0, $7u20F.getCanonicalHeaders)(request, unsignableHeaders, signableHeaders);
                        return [
                            4 /*yield*/ ,
                            this.getSignature(longDate, scope, this.getSigningKey(credentials, region, shortDate, signingService), this.createCanonicalRequest(request, canonicalHeaders, payloadHash))
                        ];
                    case 6:
                        signature = _f.sent();
                        request.headers[0, $jXuZF.AUTH_HEADER] = (0, $jXuZF.ALGORITHM_IDENTIFIER) + " " + ("Credential=" + credentials.accessKeyId + "/" + scope + ", ") + ("SignedHeaders=" + $50dcb4827b6d4dc4$var$getCanonicalHeaderList(canonicalHeaders) + ", ") + ("Signature=" + signature);
                        return [
                            2 /*return*/ ,
                            request
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.createCanonicalRequest = function(request, canonicalHeaders, payloadHash) {
        var sortedHeaders = Object.keys(canonicalHeaders).sort();
        return request.method + "\n" + this.getCanonicalPath(request) + "\n" + (0, $5a3mc.getCanonicalQuery)(request) + "\n" + sortedHeaders.map(function(name) {
            return name + ":" + canonicalHeaders[name];
        }).join("\n") + "\n\n" + sortedHeaders.join(";") + "\n" + payloadHash;
    };
    SignatureV4.prototype.createStringToSign = function(longDate, credentialScope, canonicalRequest) {
        return (0, $2MK7s.__awaiter)(this, void 0, void 0, function() {
            var hash, hashedRequest;
            return (0, $2MK7s.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        hash = new this.sha256();
                        hash.update(canonicalRequest);
                        return [
                            4 /*yield*/ ,
                            hash.digest()
                        ];
                    case 1:
                        hashedRequest = _a.sent();
                        return [
                            2 /*return*/ ,
                            (0, $jXuZF.ALGORITHM_IDENTIFIER) + "\n" + longDate + "\n" + credentialScope + "\n" + (0, $2YcGN.toHex)(hashedRequest)
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.getCanonicalPath = function(_a) {
        var path = _a.path;
        if (this.uriEscapePath) {
            var doubleEncoded = encodeURIComponent(path.replace(/^\//, ""));
            return "/" + doubleEncoded.replace(/%2F/g, "/");
        }
        return path;
    };
    SignatureV4.prototype.getSignature = function(longDate, credentialScope, keyPromise, canonicalRequest) {
        return (0, $2MK7s.__awaiter)(this, void 0, void 0, function() {
            var stringToSign, hash, _a, _b, _c;
            return (0, $2MK7s.__generator)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.createStringToSign(longDate, credentialScope, canonicalRequest)
                        ];
                    case 1:
                        stringToSign = _d.sent();
                        _b = (_a = this.sha256).bind;
                        return [
                            4 /*yield*/ ,
                            keyPromise
                        ];
                    case 2:
                        hash = new (_b.apply(_a, [
                            void 0,
                            _d.sent()
                        ]))();
                        hash.update(stringToSign);
                        _c = (0, $2YcGN.toHex);
                        return [
                            4 /*yield*/ ,
                            hash.digest()
                        ];
                    case 3:
                        return [
                            2 /*return*/ ,
                            _c.apply(void 0, [
                                _d.sent()
                            ])
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.getSigningKey = function(credentials, region, shortDate, service) {
        return (0, $2sk7M.getSigningKey)(this.sha256, credentials, shortDate, region, service || this.service);
    };
    return SignatureV4;
}();
var $50dcb4827b6d4dc4$var$formatDate = function(now) {
    var longDate = (0, $1egDh.iso8601)(now).replace(/[\-:]/g, "");
    return {
        longDate: longDate,
        shortDate: longDate.substr(0, 8)
    };
};
var $50dcb4827b6d4dc4$var$getCanonicalHeaderList = function(headers) {
    return Object.keys(headers).sort().join(";");
};
var $50dcb4827b6d4dc4$var$normalizeRegionProvider = function(region) {
    if (typeof region === "string") {
        var promisified_1 = Promise.resolve(region);
        return function() {
            return promisified_1;
        };
    } else return region;
};
var $50dcb4827b6d4dc4$var$normalizeCredentialsProvider = function(credentials) {
    if (typeof credentials === "object") {
        var promisified_2 = Promise.resolve(credentials);
        return function() {
            return promisified_2;
        };
    } else return credentials;
};

});
parcelRegister("7u20F", function(module, exports) {

$parcel$export(module.exports, "getCanonicalHeaders", () => $572ce4d40ea27c10$export$859d7f1bb55e2914);

var $2MK7s = parcelRequire("2MK7s");

var $jXuZF = parcelRequire("jXuZF");
function $572ce4d40ea27c10$export$859d7f1bb55e2914(_a, unsignableHeaders, signableHeaders) {
    var e_1, _b;
    var headers = _a.headers;
    var canonical = {};
    try {
        for(var _c = (0, $2MK7s.__values)(Object.keys(headers).sort()), _d = _c.next(); !_d.done; _d = _c.next()){
            var headerName = _d.value;
            var canonicalHeaderName = headerName.toLowerCase();
            if (canonicalHeaderName in (0, $jXuZF.ALWAYS_UNSIGNABLE_HEADERS) || (unsignableHeaders === null || unsignableHeaders === void 0 ? void 0 : unsignableHeaders.has(canonicalHeaderName)) || (0, $jXuZF.PROXY_HEADER_PATTERN).test(canonicalHeaderName) || (0, $jXuZF.SEC_HEADER_PATTERN).test(canonicalHeaderName)) {
                if (!signableHeaders || signableHeaders && !signableHeaders.has(canonicalHeaderName)) continue;
            }
            canonical[canonicalHeaderName] = headers[headerName].trim().replace(/\s+/g, " ");
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return canonical;
}

});

parcelRegister("5a3mc", function(module, exports) {

$parcel$export(module.exports, "getCanonicalQuery", () => $3c207d8ac04434b8$export$8fea7e63ecd1ddbb);

var $2MK7s = parcelRequire("2MK7s");
parcelRequire("9xnH3");
var $ktmlg = parcelRequire("ktmlg");

var $jXuZF = parcelRequire("jXuZF");
function $3c207d8ac04434b8$export$8fea7e63ecd1ddbb(_a) {
    var e_1, _b;
    var _c = _a.query, query = _c === void 0 ? {} : _c;
    var keys = [];
    var serialized = {};
    var _loop_1 = function(key) {
        if (key.toLowerCase() === (0, $jXuZF.SIGNATURE_HEADER)) return "continue";
        keys.push(key);
        var value = query[key];
        if (typeof value === "string") serialized[key] = (0, $ktmlg.escapeUri)(key) + "=" + (0, $ktmlg.escapeUri)(value);
        else if (Array.isArray(value)) serialized[key] = value.slice(0).sort().reduce(function(encoded, value) {
            return encoded.concat([
                (0, $ktmlg.escapeUri)(key) + "=" + (0, $ktmlg.escapeUri)(value)
            ]);
        }, []).join("&");
    };
    try {
        for(var _d = (0, $2MK7s.__values)(Object.keys(query).sort()), _e = _d.next(); !_e.done; _e = _d.next()){
            var key = _e.value;
            _loop_1(key);
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_e && !_e.done && (_b = _d.return)) _b.call(_d);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return keys.map(function(key) {
        return serialized[key];
    }).filter(function(serialized) {
        return serialized;
    }) // omit any falsy values
    .join("&");
}

});

parcelRegister("86qVa", function(module, exports) {

$parcel$export(module.exports, "getPayloadHash", () => $5e63c434e37e34cc$export$a46a74202b0efd71);

var $2MK7s = parcelRequire("2MK7s");

var $73ShX = parcelRequire("73ShX");

var $2YcGN = parcelRequire("2YcGN");

var $jXuZF = parcelRequire("jXuZF");
function $5e63c434e37e34cc$export$a46a74202b0efd71(_a, hashConstructor) {
    var headers = _a.headers, body = _a.body;
    return (0, $2MK7s.__awaiter)(this, void 0, void 0, function() {
        var _b, _c, headerName, hashCtor, _d;
        var e_1, _e;
        return (0, $2MK7s.__generator)(this, function(_f) {
            switch(_f.label){
                case 0:
                    try {
                        for(_b = (0, $2MK7s.__values)(Object.keys(headers)), _c = _b.next(); !_c.done; _c = _b.next()){
                            headerName = _c.value;
                            if (headerName.toLowerCase() === (0, $jXuZF.SHA256_HEADER)) return [
                                2 /*return*/ ,
                                headers[headerName]
                            ];
                        }
                    } catch (e_1_1) {
                        e_1 = {
                            error: e_1_1
                        };
                    } finally{
                        try {
                            if (_c && !_c.done && (_e = _b.return)) _e.call(_b);
                        } finally{
                            if (e_1) throw e_1.error;
                        }
                    }
                    if (!(body == undefined)) return [
                        3 /*break*/ ,
                        1
                    ];
                    return [
                        2 /*return*/ ,
                        "e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855"
                    ];
                case 1:
                    if (!(typeof body === "string" || ArrayBuffer.isView(body) || (0, $73ShX.isArrayBuffer)(body))) return [
                        3 /*break*/ ,
                        3
                    ];
                    hashCtor = new hashConstructor();
                    hashCtor.update(body);
                    _d = (0, $2YcGN.toHex);
                    return [
                        4 /*yield*/ ,
                        hashCtor.digest()
                    ];
                case 2:
                    return [
                        2 /*return*/ ,
                        _d.apply(void 0, [
                            _f.sent()
                        ])
                    ];
                case 3:
                    // As any defined body that is not a string or binary data is a stream, this
                    // body is unsignable. Attempt to send the request with an unsigned payload,
                    // which may or may not be accepted by the service.
                    return [
                        2 /*return*/ ,
                        (0, $jXuZF.UNSIGNED_PAYLOAD)
                    ];
            }
        });
    });
}

});
parcelRegister("73ShX", function(module, exports) {

$parcel$export(module.exports, "isArrayBuffer", () => $5242eccf4ec8356b$export$9dd3754ae86f0017);
var $5242eccf4ec8356b$export$9dd3754ae86f0017 = function(arg) {
    return typeof ArrayBuffer === "function" && arg instanceof ArrayBuffer || Object.prototype.toString.call(arg) === "[object ArrayBuffer]";
};

});


parcelRegister("01cVP", function(module, exports) {

$parcel$export(module.exports, "hasHeader", () => $003a20137c140950$export$17944590be865217);

var $2MK7s = parcelRequire("2MK7s");
function $003a20137c140950$export$17944590be865217(soughtHeader, headers) {
    var e_1, _a;
    soughtHeader = soughtHeader.toLowerCase();
    try {
        for(var _b = (0, $2MK7s.__values)(Object.keys(headers)), _c = _b.next(); !_c.done; _c = _b.next()){
            var headerName = _c.value;
            if (soughtHeader === headerName.toLowerCase()) return true;
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return false;
}

});

parcelRegister("4zuK3", function(module, exports) {

$parcel$export(module.exports, "moveHeadersToQuery", () => $3542470103c45b4e$export$bfc08a76d4bd60f6);

var $2MK7s = parcelRequire("2MK7s");

var $a68si = parcelRequire("a68si");
function $3542470103c45b4e$export$bfc08a76d4bd60f6(request, options) {
    var e_1, _a;
    var _b;
    if (options === void 0) options = {};
    var _c = typeof request.clone === "function" ? request.clone() : (0, $a68si.cloneRequest)(request), headers = _c.headers, _d = _c.query, query = _d === void 0 ? {} : _d;
    try {
        for(var _e = (0, $2MK7s.__values)(Object.keys(headers)), _f = _e.next(); !_f.done; _f = _e.next()){
            var name = _f.value;
            var lname = name.toLowerCase();
            if (lname.substr(0, 6) === "x-amz-" && !((_b = options.unhoistableHeaders) === null || _b === void 0 ? void 0 : _b.has(lname))) {
                query[name] = headers[name];
                delete headers[name];
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return (0, $2MK7s.__assign)((0, $2MK7s.__assign)({}, request), {
        headers: headers,
        query: query
    });
}

});
parcelRegister("a68si", function(module, exports) {

$parcel$export(module.exports, "cloneRequest", () => $75a10601ba5fba54$export$d043aa0bf7223286);

var $2MK7s = parcelRequire("2MK7s");
function $75a10601ba5fba54$export$d043aa0bf7223286(_a) {
    var headers = _a.headers, query = _a.query, rest = (0, $2MK7s.__rest)(_a, [
        "headers",
        "query"
    ]);
    return (0, $2MK7s.__assign)((0, $2MK7s.__assign)({}, rest), {
        headers: (0, $2MK7s.__assign)({}, headers),
        query: query ? $75a10601ba5fba54$var$cloneQuery(query) : undefined
    });
}
function $75a10601ba5fba54$var$cloneQuery(query) {
    return Object.keys(query).reduce(function(carry, paramName) {
        var _a;
        var param = query[paramName];
        return (0, $2MK7s.__assign)((0, $2MK7s.__assign)({}, carry), (_a = {}, _a[paramName] = Array.isArray(param) ? (0, $2MK7s.__spread)(param) : param, _a));
    }, {});
}

});


parcelRegister("kOoP8", function(module, exports) {

$parcel$export(module.exports, "prepareRequest", () => $f26bbba2360023ee$export$a7cfe9131aa06be4);

var $2MK7s = parcelRequire("2MK7s");

var $a68si = parcelRequire("a68si");

var $jXuZF = parcelRequire("jXuZF");
function $f26bbba2360023ee$export$a7cfe9131aa06be4(request) {
    var e_1, _a;
    // Create a clone of the request object that does not clone the body
    request = typeof request.clone === "function" ? request.clone() : (0, $a68si.cloneRequest)(request);
    try {
        for(var _b = (0, $2MK7s.__values)(Object.keys(request.headers)), _c = _b.next(); !_c.done; _c = _b.next()){
            var headerName = _c.value;
            if ((0, $jXuZF.GENERATED_HEADERS).indexOf(headerName.toLowerCase()) > -1) delete request.headers[headerName];
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return request;
}

});

parcelRegister("1egDh", function(module, exports) {

$parcel$export(module.exports, "iso8601", () => $0e54001c93836a1d$export$b65d57190c224ef2);
function $0e54001c93836a1d$export$b65d57190c224ef2(time) {
    return $0e54001c93836a1d$export$e67a095c620b86fe(time).toISOString().replace(/\.\d{3}Z$/, "Z");
}
function $0e54001c93836a1d$export$e67a095c620b86fe(time) {
    if (typeof time === "number") return new Date(time * 1000);
    if (typeof time === "string") {
        if (Number(time)) return new Date(Number(time) * 1000);
        return new Date(time);
    }
    return time;
}

});




parcelRegister("aP5Uo", function(module, exports) {

$parcel$export(module.exports, "getAwsAuthPlugin", () => $7e134022b9b783c7$export$59c2b7ad30ed4046);

var $fa7vX = parcelRequire("fa7vX");
parcelRequire("3uM9B");
var $dlqaT = parcelRequire("dlqaT");
var $7e134022b9b783c7$var$isClockSkewed = function(newServerTime, systemClockOffset) {
    return Math.abs($7e134022b9b783c7$var$getSkewCorrectedDate(systemClockOffset).getTime() - newServerTime) >= 300000;
};
var $7e134022b9b783c7$var$getSkewCorrectedDate = function(systemClockOffset) {
    return new Date(Date.now() + systemClockOffset);
};
function $7e134022b9b783c7$export$78af9708f8cf3422(options) {
    return function(next, context) {
        return function(args) {
            return (0, $fa7vX.__awaiter)(this, void 0, void 0, function() {
                var signer, _a, output, _b, _c, headers, dateHeader, serverTime;
                var _d;
                return (0, $fa7vX.__generator)(this, function(_e) {
                    switch(_e.label){
                        case 0:
                            if (!(0, $dlqaT.HttpRequest).isInstance(args.request)) return [
                                2 /*return*/ ,
                                next(args)
                            ];
                            if (!(typeof options.signer === "function")) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                options.signer()
                            ];
                        case 1:
                            _a = _e.sent();
                            return [
                                3 /*break*/ ,
                                3
                            ];
                        case 2:
                            _a = options.signer;
                            _e.label = 3;
                        case 3:
                            signer = _a;
                            _b = next;
                            _c = [
                                (0, $fa7vX.__assign)({}, args)
                            ];
                            _d = {};
                            return [
                                4 /*yield*/ ,
                                signer.sign(args.request, {
                                    signingDate: new Date(Date.now() + options.systemClockOffset),
                                    signingRegion: context["signing_region"],
                                    signingService: context["signing_service"]
                                })
                            ];
                        case 4:
                            return [
                                4 /*yield*/ ,
                                _b.apply(void 0, [
                                    (0, $fa7vX.__assign).apply(void 0, _c.concat([
                                        (_d.request = _e.sent(), _d)
                                    ]))
                                ])
                            ];
                        case 5:
                            output = _e.sent();
                            headers = output.response.headers;
                            dateHeader = headers && (headers.date || headers.Date);
                            if (dateHeader) {
                                serverTime = Date.parse(dateHeader);
                                if ($7e134022b9b783c7$var$isClockSkewed(serverTime, options.systemClockOffset)) options.systemClockOffset = serverTime - Date.now();
                            }
                            return [
                                2 /*return*/ ,
                                output
                            ];
                    }
                });
            });
        };
    };
}
var $7e134022b9b783c7$export$29f4b3a6e94017d3 = {
    name: "awsAuthMiddleware",
    tags: [
        "SIGNATURE",
        "AWSAUTH"
    ],
    relation: "after",
    toMiddleware: "retryMiddleware",
    override: true
};
var $7e134022b9b783c7$export$59c2b7ad30ed4046 = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.addRelativeTo($7e134022b9b783c7$export$78af9708f8cf3422(options), $7e134022b9b783c7$export$29f4b3a6e94017d3);
        }
    };
};

});


parcelRegister("6VCaQ", function(module, exports) {
$parcel$export(module.exports, "resolveUserAgentConfig", () => (parcelRequire("9YwGy")).resolveUserAgentConfig);
$parcel$export(module.exports, "getUserAgentPlugin", () => (parcelRequire("fAUAY")).getUserAgentPlugin);
parcelRequire("9YwGy");
parcelRequire("fAUAY");

});
parcelRegister("9YwGy", function(module, exports) {

$parcel$export(module.exports, "resolveUserAgentConfig", () => $7433124994de46d5$export$ec9a2d5663958cb);

var $aqvLG = parcelRequire("aqvLG");
function $7433124994de46d5$export$ec9a2d5663958cb(input) {
    return (0, $aqvLG.__assign)((0, $aqvLG.__assign)({}, input), {
        customUserAgent: typeof input.customUserAgent === "string" ? [
            [
                input.customUserAgent
            ]
        ] : input.customUserAgent
    });
}

});
parcelRegister("aqvLG", function(module, exports) {

$parcel$export(module.exports, "__assign", () => $7974f994fd47d4b2$export$18ce0697a983be9b);
$parcel$export(module.exports, "__awaiter", () => $7974f994fd47d4b2$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $7974f994fd47d4b2$export$67ebef60e6f28a6);
$parcel$export(module.exports, "__read", () => $7974f994fd47d4b2$export$8d051b38c9118094);
$parcel$export(module.exports, "__spread", () => $7974f994fd47d4b2$export$afc72e2116322959);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $7974f994fd47d4b2$var$extendStatics = function(d, b) {
    $7974f994fd47d4b2$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $7974f994fd47d4b2$var$extendStatics(d, b);
};
function $7974f994fd47d4b2$export$a8ba968b8961cb8a(d, b) {
    $7974f994fd47d4b2$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $7974f994fd47d4b2$export$18ce0697a983be9b = function() {
    $7974f994fd47d4b2$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7974f994fd47d4b2$export$18ce0697a983be9b.apply(this, arguments);
};
function $7974f994fd47d4b2$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $7974f994fd47d4b2$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $7974f994fd47d4b2$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $7974f994fd47d4b2$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $7974f994fd47d4b2$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $7974f994fd47d4b2$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $7974f994fd47d4b2$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $7974f994fd47d4b2$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $7974f994fd47d4b2$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $7974f994fd47d4b2$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $7974f994fd47d4b2$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($7974f994fd47d4b2$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $7974f994fd47d4b2$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $7974f994fd47d4b2$export$10c90e4f7922046c(v) {
    return this instanceof $7974f994fd47d4b2$export$10c90e4f7922046c ? (this.v = v, this) : new $7974f994fd47d4b2$export$10c90e4f7922046c(v);
}
function $7974f994fd47d4b2$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $7974f994fd47d4b2$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $7974f994fd47d4b2$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $7974f994fd47d4b2$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $7974f994fd47d4b2$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $7974f994fd47d4b2$export$19a8beecd37a4c45 === "function" ? $7974f994fd47d4b2$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $7974f994fd47d4b2$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $7974f994fd47d4b2$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $7974f994fd47d4b2$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $7974f994fd47d4b2$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $7974f994fd47d4b2$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});


parcelRegister("fAUAY", function(module, exports) {

$parcel$export(module.exports, "getUserAgentPlugin", () => $b5a61e74596aac97$export$5393c0d2d7f4f5f0);

var $aqvLG = parcelRequire("aqvLG");
parcelRequire("3uM9B");
var $dlqaT = parcelRequire("dlqaT");

var $86ABH = parcelRequire("86ABH");
var $b5a61e74596aac97$export$62c460923941c0b0 = function(options) {
    return function(next, context) {
        return function(args) {
            return (0, $aqvLG.__awaiter)(void 0, void 0, void 0, function() {
                var request, headers, userAgent, defaultUserAgent, customUserAgent, normalUAValue;
                var _a, _b;
                return (0, $aqvLG.__generator)(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            request = args.request;
                            if (!(0, $dlqaT.HttpRequest).isInstance(request)) return [
                                2 /*return*/ ,
                                next(args)
                            ];
                            headers = request.headers;
                            userAgent = ((_a = context === null || context === void 0 ? void 0 : context.userAgent) === null || _a === void 0 ? void 0 : _a.map($b5a61e74596aac97$var$escapeUserAgent)) || [];
                            return [
                                4 /*yield*/ ,
                                options.defaultUserAgentProvider()
                            ];
                        case 1:
                            defaultUserAgent = _c.sent().map($b5a61e74596aac97$var$escapeUserAgent);
                            customUserAgent = ((_b = options === null || options === void 0 ? void 0 : options.customUserAgent) === null || _b === void 0 ? void 0 : _b.map($b5a61e74596aac97$var$escapeUserAgent)) || [];
                            // Set value to AWS-specific user agent header
                            headers[0, $86ABH.X_AMZ_USER_AGENT] = (0, $aqvLG.__spread)(defaultUserAgent, userAgent, customUserAgent).join((0, $86ABH.SPACE));
                            normalUAValue = (0, $aqvLG.__spread)(defaultUserAgent.filter(function(section) {
                                return section.startsWith("aws-sdk-");
                            }), customUserAgent).join((0, $86ABH.SPACE));
                            if (options.runtime !== "browser" && normalUAValue) headers[0, $86ABH.USER_AGENT] = headers[0, $86ABH.USER_AGENT] ? headers[0, $86ABH.USER_AGENT] + " " + normalUAValue : normalUAValue;
                            return [
                                2 /*return*/ ,
                                next((0, $aqvLG.__assign)((0, $aqvLG.__assign)({}, args), {
                                    request: request
                                }))
                            ];
                    }
                });
            });
        };
    };
};
/**
 * Escape the each pair according to https://tools.ietf.org/html/rfc5234 and join the pair with pattern `name/version`.
 * User agent name may include prefix like `md/`, `api/`, `os/` etc., we should not escape the `/` after the prefix.
 * @private
 */ var $b5a61e74596aac97$var$escapeUserAgent = function(_a) {
    var _b = (0, $aqvLG.__read)(_a, 2), name = _b[0], version = _b[1];
    var prefixSeparatorIndex = name.indexOf("/");
    var prefix = name.substring(0, prefixSeparatorIndex); // If no prefix, prefix is just ""
    var uaName = name.substring(prefixSeparatorIndex + 1);
    if (prefix === "api") uaName = uaName.toLowerCase();
    return [
        prefix,
        uaName,
        version
    ].filter(function(item) {
        return item && item.length > 0;
    }).map(function(item) {
        return item === null || item === void 0 ? void 0 : item.replace((0, $86ABH.UA_ESCAPE_REGEX), "_");
    }).join("/");
};
var $b5a61e74596aac97$export$29eb04da6afef73f = {
    name: "getUserAgentMiddleware",
    step: "build",
    priority: "low",
    tags: [
        "SET_USER_AGENT",
        "USER_AGENT"
    ],
    override: true
};
var $b5a61e74596aac97$export$5393c0d2d7f4f5f0 = function(config) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add($b5a61e74596aac97$export$62c460923941c0b0(config), $b5a61e74596aac97$export$29eb04da6afef73f);
        }
    };
};

});
parcelRegister("86ABH", function(module, exports) {

$parcel$export(module.exports, "USER_AGENT", () => $0185dbfe9121ee14$export$97a08a1bb7ee0545);
$parcel$export(module.exports, "X_AMZ_USER_AGENT", () => $0185dbfe9121ee14$export$e010e3d6246262a3);
$parcel$export(module.exports, "SPACE", () => $0185dbfe9121ee14$export$27b7b95a5fde2b31);
$parcel$export(module.exports, "UA_ESCAPE_REGEX", () => $0185dbfe9121ee14$export$92df4a8c4ea32a70);
var $0185dbfe9121ee14$export$97a08a1bb7ee0545 = "user-agent";
var $0185dbfe9121ee14$export$e010e3d6246262a3 = "x-amz-user-agent";
var $0185dbfe9121ee14$export$27b7b95a5fde2b31 = " ";
var $0185dbfe9121ee14$export$92df4a8c4ea32a70 = /[^\!\#\$\%\&\'\*\+\-\.\^\_\`\|\~\d\w]/g;

});





parcelRegister("fveJK", function(module, exports) {

$parcel$export(module.exports, "ServiceWorkerClass", () => $b4952eb5b25db93a$export$efa87b877bb98f58);
/**
 * Copyright 2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $7UO1b = parcelRequire("7UO1b");

var $9Mfkr = parcelRequire("9Mfkr");

var $a16qJ = parcelRequire("a16qJ");
/**
 * Provides a means to registering a service worker in the browser
 * and communicating with it via postMessage events.
 * https://developer.mozilla.org/en-US/docs/Web/API/Service_Worker_API/
 *
 * postMessage events are currently not supported in all browsers. See:
 * https://developer.mozilla.org/en-US/docs/Web/API/Service_Worker_API
 *
 * At the minmum this class will register the service worker and listen
 * and attempt to dispatch messages on state change and record analytics
 * events based on the service worker lifecycle.
 */ var $b4952eb5b25db93a$export$efa87b877bb98f58 = /** @class */ function() {
    function ServiceWorkerClass() {
        // The AWS Amplify logger
        this._logger = new (0, $7UO1b.ConsoleLogger)('ServiceWorker');
    }
    Object.defineProperty(ServiceWorkerClass.prototype, "serviceWorker", {
        /**
         * Get the currently active service worker
         */ get: function() {
            return this._serviceWorker;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Register the service-worker.js file in the browser
     * Make sure the service-worker.js is part of the build
     * for example with Angular, modify the angular-cli.json file
     * and add to "assets" array "service-worker.js"
     * @param {string} - (optional) Service worker file. Defaults to "/service-worker.js"
     * @param {string} - (optional) The service worker scope. Defaults to "/"
     *  - API Doc: https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerContainer/register
     * @returns {Promise}
     *	- resolve(ServiceWorkerRegistration)
     *	- reject(Error)
     **/ ServiceWorkerClass.prototype.register = function(filePath, scope) {
        var _this = this;
        if (filePath === void 0) filePath = '/service-worker.js';
        if (scope === void 0) scope = '/';
        this._logger.debug("registering " + filePath);
        this._logger.debug("registering service worker with scope " + scope);
        return new Promise(function(resolve, reject) {
            if (navigator && 'serviceWorker' in navigator) navigator.serviceWorker.register(filePath, {
                scope: scope
            }).then(function(registration) {
                if (registration.installing) _this._serviceWorker = registration.installing;
                else if (registration.waiting) _this._serviceWorker = registration.waiting;
                else if (registration.active) _this._serviceWorker = registration.active;
                _this._registration = registration;
                _this._setupListeners();
                _this._logger.debug("Service Worker Registration Success: " + registration);
                return resolve(registration);
            }).catch(function(error) {
                _this._logger.debug("Service Worker Registration Failed " + error);
                return reject(error);
            });
            else return reject(new Error('Service Worker not available'));
        });
    };
    /**
     * Enable web push notifications. If not subscribed, a new subscription will
     * be created and registered.
     * 	Test Push Server: https://web-push-codelab.glitch.me/
     * 	Push Server Libraries: https://github.com/web-push-libs/
     * 	API Doc: https://developers.google.com/web/fundamentals/codelabs/push-notifications/
     * @param publicKey
     * @returns {Promise}
     * 	- resolve(PushSubscription)
     *  - reject(Error)
     */ ServiceWorkerClass.prototype.enablePush = function(publicKey) {
        var _this = this;
        if (!this._registration) throw new Error('Service Worker not registered');
        this._publicKey = publicKey;
        return new Promise(function(resolve, reject) {
            if ((0, $9Mfkr.browserOrNode)().isBrowser) _this._registration.pushManager.getSubscription().then(function(subscription) {
                if (subscription) {
                    _this._subscription = subscription;
                    _this._logger.debug("User is subscribed to push: " + JSON.stringify(subscription));
                    resolve(subscription);
                } else {
                    _this._logger.debug("User is NOT subscribed to push");
                    return _this._registration.pushManager.subscribe({
                        userVisibleOnly: true,
                        applicationServerKey: _this._urlB64ToUint8Array(publicKey)
                    }).then(function(subscription) {
                        _this._subscription = subscription;
                        _this._logger.debug("User subscribed: " + JSON.stringify(subscription));
                        resolve(subscription);
                    }).catch(function(error) {
                        _this._logger.error(error);
                    });
                }
            });
            else return reject(new Error('Service Worker not available'));
        });
    };
    /**
     * Convert a base64 encoded string to a Uint8 array for the push server key
     * @param base64String
     */ ServiceWorkerClass.prototype._urlB64ToUint8Array = function(base64String) {
        var padding = '='.repeat((4 - base64String.length % 4) % 4);
        var base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/');
        var rawData = window.atob(base64);
        var outputArray = new Uint8Array(rawData.length);
        for(var i = 0; i < rawData.length; ++i)outputArray[i] = rawData.charCodeAt(i);
        return outputArray;
    };
    /**
     * Send a message to the service worker. The service worker needs
     * to implement `self.addEventListener('message') to handle the
     * message. This ***currently*** does not work in Safari or IE.
     * @param {object | string} - An arbitrary JSON object or string message to send to the service worker
     *	- see: https://developer.mozilla.org/en-US/docs/Web/API/Transferable
     * @returns {Promise}
     **/ ServiceWorkerClass.prototype.send = function(message) {
        if (this._serviceWorker) this._serviceWorker.postMessage(typeof message === 'object' ? JSON.stringify(message) : message);
    };
    /**
     * Listen for service worker state change and message events
     * https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorker/state
     **/ ServiceWorkerClass.prototype._setupListeners = function() {
        var _this = this;
        this._serviceWorker.addEventListener('statechange', function(event) {
            var currentState = _this._serviceWorker.state;
            _this._logger.debug("ServiceWorker statechange: " + currentState);
            if ((0, $a16qJ.Amplify).Analytics && typeof (0, $a16qJ.Amplify).Analytics.record === 'function') (0, $a16qJ.Amplify).Analytics.record({
                name: 'ServiceWorker',
                attributes: {
                    state: currentState
                }
            });
        });
        this._serviceWorker.addEventListener('message', function(event) {
            _this._logger.debug("ServiceWorker message event: " + event);
        });
    };
    return ServiceWorkerClass;
}();
var /**
 * @deprecated use named import
 */ $b4952eb5b25db93a$export$2e2bcd8739ae039 = $b4952eb5b25db93a$export$efa87b877bb98f58;

});

parcelRegister("1RES9", function(module, exports) {

$parcel$export(module.exports, "UniversalStorage", () => $15ba7214925ab0bc$export$ded9c57084144144);

var $1dL5u = parcelRequire("1dL5u");

var $9Mfkr = parcelRequire("9Mfkr");
var $15ba7214925ab0bc$var$isBrowser = (0, $9Mfkr.browserOrNode)().isBrowser;
var $15ba7214925ab0bc$export$ded9c57084144144 = /** @class */ function() {
    function UniversalStorage(context) {
        if (context === void 0) context = {};
        this.cookies = new (0, $1dL5u.default)();
        this.store = $15ba7214925ab0bc$var$isBrowser ? window.localStorage : Object.create(null);
        this.cookies = context.req ? new (0, $1dL5u.default)(context.req.headers.cookie) : new (0, $1dL5u.default)();
        Object.assign(this.store, this.cookies.getAll());
    }
    Object.defineProperty(UniversalStorage.prototype, "length", {
        get: function() {
            return Object.entries(this.store).length;
        },
        enumerable: true,
        configurable: true
    });
    UniversalStorage.prototype.clear = function() {
        var _this = this;
        Array.from(new Array(this.length)).map(function(_, i) {
            return _this.key(i);
        }).forEach(function(key) {
            return _this.removeItem(key);
        });
    };
    UniversalStorage.prototype.getItem = function(key) {
        return this.getLocalItem(key);
    };
    UniversalStorage.prototype.getLocalItem = function(key) {
        return Object.prototype.hasOwnProperty.call(this.store, key) ? this.store[key] : null;
    };
    UniversalStorage.prototype.getUniversalItem = function(key) {
        return this.cookies.get(key);
    };
    UniversalStorage.prototype.key = function(index) {
        return Object.keys(this.store)[index];
    };
    UniversalStorage.prototype.removeItem = function(key) {
        this.removeLocalItem(key);
        this.removeUniversalItem(key);
    };
    UniversalStorage.prototype.removeLocalItem = function(key) {
        delete this.store[key];
    };
    UniversalStorage.prototype.removeUniversalItem = function(key) {
        this.cookies.remove(key, {
            path: '/'
        });
    };
    UniversalStorage.prototype.setItem = function(key, value) {
        this.setLocalItem(key, value);
        // keys take the shape:
        //  1. `${ProviderPrefix}.${userPoolClientId}.${username}.${tokenType}
        //  2. `${ProviderPrefix}.${userPoolClientId}.LastAuthUser
        var tokenType = key.split('.').pop();
        switch(tokenType){
            // LastAuthUser is needed for computing other key names
            case 'LastAuthUser':
            // accessToken is required for CognitoUserSession
            case 'accessToken':
            // Required for CognitoUserSession
            case 'idToken':
                this.setUniversalItem(key, value);
        }
    };
    UniversalStorage.prototype.setLocalItem = function(key, value) {
        this.store[key] = value;
    };
    UniversalStorage.prototype.setUniversalItem = function(key, value) {
        this.cookies.set(key, value, {
            path: '/',
            // `httpOnly` cannot be set via JavaScript: https://developer.mozilla.org/en-US/docs/Web/HTTP/Cookies#JavaScript_access_using_Document.cookie
            sameSite: true,
            // Allow unsecure requests to http://localhost:3000/ when in development.
            secure: window.location.hostname === 'localhost' ? false : true
        });
    };
    return UniversalStorage;
}();

});
parcelRegister("1dL5u", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e3b87f028459685$export$2e2bcd8739ae039);

var $dKjUV = parcelRequire("dKjUV");
var $0e3b87f028459685$export$2e2bcd8739ae039 = (0, $dKjUV.default);

});
parcelRegister("dKjUV", function(module, exports) {

$parcel$export(module.exports, "default", () => $a01f0560b3e8a3ac$export$2e2bcd8739ae039);

var $gGfuh = parcelRequire("gGfuh");

var $4Y16U = parcelRequire("4Y16U");
var $a01f0560b3e8a3ac$var$__assign = undefined && undefined.__assign || function() {
    $a01f0560b3e8a3ac$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a01f0560b3e8a3ac$var$__assign.apply(this, arguments);
};
var $a01f0560b3e8a3ac$var$Cookies = /** @class */ function() {
    function Cookies(cookies, options) {
        var _this = this;
        this.changeListeners = [];
        this.HAS_DOCUMENT_COOKIE = false;
        this.cookies = (0, $4Y16U.parseCookies)(cookies, options);
        new Promise(function() {
            _this.HAS_DOCUMENT_COOKIE = (0, $4Y16U.hasDocumentCookie)();
        }).catch(function() {});
    }
    Cookies.prototype._updateBrowserValues = function(parseOptions) {
        if (!this.HAS_DOCUMENT_COOKIE) return;
        this.cookies = $gGfuh.parse(document.cookie, parseOptions);
    };
    Cookies.prototype._emitChange = function(params) {
        for(var i = 0; i < this.changeListeners.length; ++i)this.changeListeners[i](params);
    };
    Cookies.prototype.get = function(name, options, parseOptions) {
        if (options === void 0) options = {};
        this._updateBrowserValues(parseOptions);
        return (0, $4Y16U.readCookie)(this.cookies[name], options);
    };
    Cookies.prototype.getAll = function(options, parseOptions) {
        if (options === void 0) options = {};
        this._updateBrowserValues(parseOptions);
        var result = {};
        for(var name_1 in this.cookies)result[name_1] = (0, $4Y16U.readCookie)(this.cookies[name_1], options);
        return result;
    };
    Cookies.prototype.set = function(name, value, options) {
        var _a;
        if (typeof value === 'object') value = JSON.stringify(value);
        this.cookies = $a01f0560b3e8a3ac$var$__assign($a01f0560b3e8a3ac$var$__assign({}, this.cookies), (_a = {}, _a[name] = value, _a));
        if (this.HAS_DOCUMENT_COOKIE) document.cookie = $gGfuh.serialize(name, value, options);
        this._emitChange({
            name: name,
            value: value,
            options: options
        });
    };
    Cookies.prototype.remove = function(name, options) {
        var finalOptions = options = $a01f0560b3e8a3ac$var$__assign($a01f0560b3e8a3ac$var$__assign({}, options), {
            expires: new Date(1970, 1, 1, 0, 0, 1),
            maxAge: 0
        });
        this.cookies = $a01f0560b3e8a3ac$var$__assign({}, this.cookies);
        delete this.cookies[name];
        if (this.HAS_DOCUMENT_COOKIE) document.cookie = $gGfuh.serialize(name, '', finalOptions);
        this._emitChange({
            name: name,
            value: undefined,
            options: options
        });
    };
    Cookies.prototype.addChangeListener = function(callback) {
        this.changeListeners.push(callback);
    };
    Cookies.prototype.removeChangeListener = function(callback) {
        var idx = this.changeListeners.indexOf(callback);
        if (idx >= 0) this.changeListeners.splice(idx, 1);
    };
    return Cookies;
}();
var $a01f0560b3e8a3ac$export$2e2bcd8739ae039 = $a01f0560b3e8a3ac$var$Cookies;

});
parcelRegister("gGfuh", function(module, exports) {

$parcel$export(module.exports, "parse", () => $c24c950f95478e97$export$98e6a39c04603d36, (v) => $c24c950f95478e97$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "serialize", () => $c24c950f95478e97$export$dfdc1655ccc5b9cb, (v) => $c24c950f95478e97$export$dfdc1655ccc5b9cb = v);
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */ /**
 * Module exports.
 * @public
 */ var $c24c950f95478e97$export$98e6a39c04603d36;
var $c24c950f95478e97$export$dfdc1655ccc5b9cb;
'use strict';
$c24c950f95478e97$export$98e6a39c04603d36 = $c24c950f95478e97$var$parse;
$c24c950f95478e97$export$dfdc1655ccc5b9cb = $c24c950f95478e97$var$serialize;
/**
 * Module variables.
 * @private
 */ var $c24c950f95478e97$var$decode = decodeURIComponent;
var $c24c950f95478e97$var$encode = encodeURIComponent;
/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */ var $c24c950f95478e97$var$fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */ function $c24c950f95478e97$var$parse(str, options) {
    if (typeof str !== 'string') throw new TypeError('argument str must be a string');
    var obj = {};
    var opt = options || {};
    var pairs = str.split(';');
    var dec = opt.decode || $c24c950f95478e97$var$decode;
    for(var i = 0; i < pairs.length; i++){
        var pair = pairs[i];
        var index = pair.indexOf('=');
        // skip things that don't look like key=value
        if (index < 0) continue;
        var key = pair.substring(0, index).trim();
        // only assign once
        if (undefined == obj[key]) {
            var val = pair.substring(index + 1, pair.length).trim();
            // quoted values
            if (val[0] === '"') val = val.slice(1, -1);
            obj[key] = $c24c950f95478e97$var$tryDecode(val, dec);
        }
    }
    return obj;
}
/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */ function $c24c950f95478e97$var$serialize(name, val, options) {
    var opt = options || {};
    var enc = opt.encode || $c24c950f95478e97$var$encode;
    if (typeof enc !== 'function') throw new TypeError('option encode is invalid');
    if (!$c24c950f95478e97$var$fieldContentRegExp.test(name)) throw new TypeError('argument name is invalid');
    var value = enc(val);
    if (value && !$c24c950f95478e97$var$fieldContentRegExp.test(value)) throw new TypeError('argument val is invalid');
    var str = name + '=' + value;
    if (null != opt.maxAge) {
        var maxAge = opt.maxAge - 0;
        if (isNaN(maxAge) || !isFinite(maxAge)) throw new TypeError('option maxAge is invalid');
        str += '; Max-Age=' + Math.floor(maxAge);
    }
    if (opt.domain) {
        if (!$c24c950f95478e97$var$fieldContentRegExp.test(opt.domain)) throw new TypeError('option domain is invalid');
        str += '; Domain=' + opt.domain;
    }
    if (opt.path) {
        if (!$c24c950f95478e97$var$fieldContentRegExp.test(opt.path)) throw new TypeError('option path is invalid');
        str += '; Path=' + opt.path;
    }
    if (opt.expires) {
        if (typeof opt.expires.toUTCString !== 'function') throw new TypeError('option expires is invalid');
        str += '; Expires=' + opt.expires.toUTCString();
    }
    if (opt.httpOnly) str += '; HttpOnly';
    if (opt.secure) str += '; Secure';
    if (opt.sameSite) {
        var sameSite = typeof opt.sameSite === 'string' ? opt.sameSite.toLowerCase() : opt.sameSite;
        switch(sameSite){
            case true:
                str += '; SameSite=Strict';
                break;
            case 'lax':
                str += '; SameSite=Lax';
                break;
            case 'strict':
                str += '; SameSite=Strict';
                break;
            case 'none':
                str += '; SameSite=None';
                break;
            default:
                throw new TypeError('option sameSite is invalid');
        }
    }
    return str;
}
/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */ function $c24c950f95478e97$var$tryDecode(str, decode) {
    try {
        return decode(str);
    } catch (e) {
        return str;
    }
}

});

parcelRegister("4Y16U", function(module, exports) {

$parcel$export(module.exports, "hasDocumentCookie", () => $39dda08d1c7a24d6$export$56232575010ba89);
$parcel$export(module.exports, "parseCookies", () => $39dda08d1c7a24d6$export$d2e637738f5e6ae8);
$parcel$export(module.exports, "readCookie", () => $39dda08d1c7a24d6$export$bead674655ff515d);

var $gGfuh = parcelRequire("gGfuh");
function $39dda08d1c7a24d6$export$56232575010ba89() {
    // Can we get/set cookies on document.cookie?
    return typeof document === 'object' && typeof document.cookie === 'string';
}
function $39dda08d1c7a24d6$export$bfce569af136abdc() {
    document.cookie.split(';').forEach(function(c) {
        document.cookie = c.replace(/^ +/, '').replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
    });
}
function $39dda08d1c7a24d6$export$d2e637738f5e6ae8(cookies, options) {
    if (typeof cookies === 'string') return $gGfuh.parse(cookies, options);
    else if (typeof cookies === 'object' && cookies !== null) return cookies;
    else return {};
}
function $39dda08d1c7a24d6$export$9f55e081dbb22cd9(value, doNotParse) {
    if (typeof doNotParse === 'undefined') // We guess if the cookie start with { or [, it has been serialized
    doNotParse = !value || value[0] !== '{' && value[0] !== '[' && value[0] !== '"';
    return !doNotParse;
}
function $39dda08d1c7a24d6$export$bead674655ff515d(value, options) {
    if (options === void 0) options = {};
    var cleanValue = $39dda08d1c7a24d6$var$cleanupCookieValue(value);
    if ($39dda08d1c7a24d6$export$9f55e081dbb22cd9(cleanValue, options.doNotParse)) try {
        return JSON.parse(cleanValue);
    } catch (e) {
    // At least we tried
    }
    // Ignore clean value if we failed the deserialization
    // It is not relevant anymore to trim those values
    return value;
}
function $39dda08d1c7a24d6$var$cleanupCookieValue(value) {
    // express prepend j: before serializing a cookie
    if (value && value[0] === 'j' && value[1] === ':') return value.substr(2);
    return value;
}

});




parcelRegister("6zWMj", function(module, exports) {

$parcel$export(module.exports, "INTERNAL_AWS_APPSYNC_PUBSUB_PROVIDER", () => $4ca39b1d3aca095d$export$36df2663cc7faf97);
$parcel$export(module.exports, "INTERNAL_AWS_APPSYNC_REALTIME_PUBSUB_PROVIDER", () => $4ca39b1d3aca095d$export$ea26e09ecef8d08d);
$parcel$export(module.exports, "USER_AGENT_HEADER", () => $4ca39b1d3aca095d$export$16032fc466434892);
/*
 * Copyright 2018-2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ /**
 * This Symbol is used to reference an internal-only PubSub provider that
 * is used for AppSync/GraphQL subscriptions in the API category.
 */ var $4ca39b1d3aca095d$var$hasSymbol = typeof Symbol !== 'undefined' && typeof Symbol.for === 'function';
var $4ca39b1d3aca095d$export$36df2663cc7faf97 = $4ca39b1d3aca095d$var$hasSymbol ? Symbol.for('INTERNAL_AWS_APPSYNC_PUBSUB_PROVIDER') : '@@INTERNAL_AWS_APPSYNC_PUBSUB_PROVIDER';
var $4ca39b1d3aca095d$export$ea26e09ecef8d08d = $4ca39b1d3aca095d$var$hasSymbol ? Symbol.for('INTERNAL_AWS_APPSYNC_REALTIME_PUBSUB_PROVIDER') : '@@INTERNAL_AWS_APPSYNC_REALTIME_PUBSUB_PROVIDER';
var $4ca39b1d3aca095d$export$16032fc466434892 = 'x-amz-user-agent';

});

parcelRegister("gIW81", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2cdd8802d295bde$export$2e2bcd8739ae039);
/*!
 * The MIT License (MIT)
 *
 * Copyright (c) 2016 Christian Speckner <cnspeckn@googlemail.com>
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $c2cdd8802d295bde$var$Mutex = /** @class */ function() {
    function Mutex() {
        this._queue = [];
        this._pending = false;
    }
    Mutex.prototype.isLocked = function() {
        return this._pending;
    };
    Mutex.prototype.acquire = function() {
        var _this = this;
        var ticket = new Promise(function(resolve) {
            return _this._queue.push(resolve);
        });
        if (!this._pending) this._dispatchNext();
        return ticket;
    };
    Mutex.prototype.runExclusive = function(callback) {
        return this.acquire().then(function(release) {
            var result;
            try {
                result = callback();
            } catch (e) {
                release();
                throw e;
            }
            return Promise.resolve(result).then(function(x) {
                return release(), x;
            }, function(e) {
                release();
                throw e;
            });
        });
    };
    Mutex.prototype._dispatchNext = function() {
        if (this._queue.length > 0) {
            this._pending = true;
            this._queue.shift()(this._dispatchNext.bind(this));
        } else this._pending = false;
    };
    return Mutex;
}();
var $c2cdd8802d295bde$export$2e2bcd8739ae039 = $c2cdd8802d295bde$var$Mutex;

});

parcelRegister("a97Zu", function(module, exports) {

$parcel$export(module.exports, "default", () => $7630f1764c109627$export$2e2bcd8739ae039);

var $9Mfkr = parcelRequire("9Mfkr");

var $fi57Q = parcelRequire("fi57Q");
var $7630f1764c109627$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $7630f1764c109627$var$ReachabilityNavigator = /** @class */ function() {
    function ReachabilityNavigator() {}
    ReachabilityNavigator.prototype.networkMonitor = function(netInfo) {
        if ((0, $9Mfkr.browserOrNode)().isNode) return (0, $fi57Q.default).from([
            {
                online: true
            }
        ]);
        var globalObj = (0, $9Mfkr.isWebWorker)() ? self : window;
        return new (0, $fi57Q.default)(function(observer) {
            observer.next({
                online: globalObj.navigator.onLine
            });
            var notifyOnline = function() {
                return observer.next({
                    online: true
                });
            };
            var notifyOffline = function() {
                return observer.next({
                    online: false
                });
            };
            globalObj.addEventListener('online', notifyOnline);
            globalObj.addEventListener('offline', notifyOffline);
            ReachabilityNavigator._observers.push(observer);
            return function() {
                globalObj.removeEventListener('online', notifyOnline);
                globalObj.removeEventListener('offline', notifyOffline);
                ReachabilityNavigator._observers = ReachabilityNavigator._observers.filter(function(_observer) {
                    return _observer !== observer;
                });
            };
        });
    };
    // expose observers to simulate offline mode for integration testing
    ReachabilityNavigator._observerOverride = function(status) {
        var e_1, _a;
        var _loop_1 = function(observer) {
            if (observer.closed) {
                ReachabilityNavigator._observers = ReachabilityNavigator._observers.filter(function(_observer) {
                    return _observer !== observer;
                });
                return "continue";
            }
            observer.next(status);
        };
        try {
            for(var _b = $7630f1764c109627$var$__values(ReachabilityNavigator._observers), _c = _b.next(); !_c.done; _c = _b.next()){
                var observer = _c.value;
                _loop_1(observer);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    };
    ReachabilityNavigator._observers = [];
    return ReachabilityNavigator;
}();
var $7630f1764c109627$export$2e2bcd8739ae039 = $7630f1764c109627$var$ReachabilityNavigator;

});
parcelRegister("fi57Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $b21c8346524dc970$export$2e2bcd8739ae039);

var $jXhcB = parcelRequire("jXhcB");
var $b21c8346524dc970$export$77cea355fa80b5f4 = (0, (/*@__PURE__*/$parcel$interopDefault($jXhcB)));
var $b21c8346524dc970$export$2e2bcd8739ae039 = $b21c8346524dc970$export$77cea355fa80b5f4;

});
parcelRegister("jXhcB", function(module, exports) {

module.exports = (parcelRequire("fqS7X")).Observable;

});
parcelRegister("fqS7X", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Observable = void 0;
function $b3c3454385bad6bf$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $b3c3454385bad6bf$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $b3c3454385bad6bf$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $b3c3454385bad6bf$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $b3c3454385bad6bf$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
// === Symbol Support ===
var $b3c3454385bad6bf$var$hasSymbols = function() {
    return typeof Symbol === 'function';
};
var $b3c3454385bad6bf$var$hasSymbol = function(name) {
    return $b3c3454385bad6bf$var$hasSymbols() && Boolean(Symbol[name]);
};
var $b3c3454385bad6bf$var$getSymbol = function(name) {
    return $b3c3454385bad6bf$var$hasSymbol(name) ? Symbol[name] : '@@' + name;
};
if ($b3c3454385bad6bf$var$hasSymbols() && !$b3c3454385bad6bf$var$hasSymbol('observable')) Symbol.observable = Symbol('observable');
var $b3c3454385bad6bf$var$SymbolIterator = $b3c3454385bad6bf$var$getSymbol('iterator');
var $b3c3454385bad6bf$var$SymbolObservable = $b3c3454385bad6bf$var$getSymbol('observable');
var $b3c3454385bad6bf$var$SymbolSpecies = $b3c3454385bad6bf$var$getSymbol('species'); // === Abstract Operations ===
function $b3c3454385bad6bf$var$getMethod(obj, key) {
    var value = obj[key];
    if (value == null) return undefined;
    if (typeof value !== 'function') throw new TypeError(value + ' is not a function');
    return value;
}
function $b3c3454385bad6bf$var$getSpecies(obj) {
    var ctor = obj.constructor;
    if (ctor !== undefined) {
        ctor = ctor[$b3c3454385bad6bf$var$SymbolSpecies];
        if (ctor === null) ctor = undefined;
    }
    return ctor !== undefined ? ctor : $b3c3454385bad6bf$var$Observable;
}
function $b3c3454385bad6bf$var$isObservable(x) {
    return x instanceof $b3c3454385bad6bf$var$Observable; // SPEC: Brand check
}
function $b3c3454385bad6bf$var$hostReportError(e) {
    if ($b3c3454385bad6bf$var$hostReportError.log) $b3c3454385bad6bf$var$hostReportError.log(e);
    else setTimeout(function() {
        throw e;
    });
}
function $b3c3454385bad6bf$var$enqueue(fn) {
    Promise.resolve().then(function() {
        try {
            fn();
        } catch (e) {
            $b3c3454385bad6bf$var$hostReportError(e);
        }
    });
}
function $b3c3454385bad6bf$var$cleanupSubscription(subscription) {
    var cleanup = subscription._cleanup;
    if (cleanup === undefined) return;
    subscription._cleanup = undefined;
    if (!cleanup) return;
    try {
        if (typeof cleanup === 'function') cleanup();
        else {
            var unsubscribe = $b3c3454385bad6bf$var$getMethod(cleanup, 'unsubscribe');
            if (unsubscribe) unsubscribe.call(cleanup);
        }
    } catch (e) {
        $b3c3454385bad6bf$var$hostReportError(e);
    }
}
function $b3c3454385bad6bf$var$closeSubscription(subscription) {
    subscription._observer = undefined;
    subscription._queue = undefined;
    subscription._state = 'closed';
}
function $b3c3454385bad6bf$var$flushSubscription(subscription) {
    var queue = subscription._queue;
    if (!queue) return;
    subscription._queue = undefined;
    subscription._state = 'ready';
    for(var i = 0; i < queue.length; ++i){
        $b3c3454385bad6bf$var$notifySubscription(subscription, queue[i].type, queue[i].value);
        if (subscription._state === 'closed') break;
    }
}
function $b3c3454385bad6bf$var$notifySubscription(subscription, type, value) {
    subscription._state = 'running';
    var observer = subscription._observer;
    try {
        var m = $b3c3454385bad6bf$var$getMethod(observer, type);
        switch(type){
            case 'next':
                if (m) m.call(observer, value);
                break;
            case 'error':
                $b3c3454385bad6bf$var$closeSubscription(subscription);
                if (m) m.call(observer, value);
                else throw value;
                break;
            case 'complete':
                $b3c3454385bad6bf$var$closeSubscription(subscription);
                if (m) m.call(observer);
                break;
        }
    } catch (e) {
        $b3c3454385bad6bf$var$hostReportError(e);
    }
    if (subscription._state === 'closed') $b3c3454385bad6bf$var$cleanupSubscription(subscription);
    else if (subscription._state === 'running') subscription._state = 'ready';
}
function $b3c3454385bad6bf$var$onNotify(subscription, type, value) {
    if (subscription._state === 'closed') return;
    if (subscription._state === 'buffering') {
        subscription._queue.push({
            type: type,
            value: value
        });
        return;
    }
    if (subscription._state !== 'ready') {
        subscription._state = 'buffering';
        subscription._queue = [
            {
                type: type,
                value: value
            }
        ];
        $b3c3454385bad6bf$var$enqueue(function() {
            return $b3c3454385bad6bf$var$flushSubscription(subscription);
        });
        return;
    }
    $b3c3454385bad6bf$var$notifySubscription(subscription, type, value);
}
var $b3c3454385bad6bf$var$Subscription = /*#__PURE__*/ function() {
    function Subscription(observer, subscriber) {
        $b3c3454385bad6bf$var$_classCallCheck(this, Subscription);
        // ASSERT: observer is an object
        // ASSERT: subscriber is callable
        this._cleanup = undefined;
        this._observer = observer;
        this._queue = undefined;
        this._state = 'initializing';
        var subscriptionObserver = new $b3c3454385bad6bf$var$SubscriptionObserver(this);
        try {
            this._cleanup = subscriber.call(undefined, subscriptionObserver);
        } catch (e) {
            subscriptionObserver.error(e);
        }
        if (this._state === 'initializing') this._state = 'ready';
    }
    $b3c3454385bad6bf$var$_createClass(Subscription, [
        {
            key: "unsubscribe",
            value: function unsubscribe() {
                if (this._state !== 'closed') {
                    $b3c3454385bad6bf$var$closeSubscription(this);
                    $b3c3454385bad6bf$var$cleanupSubscription(this);
                }
            }
        },
        {
            key: "closed",
            get: function() {
                return this._state === 'closed';
            }
        }
    ]);
    return Subscription;
}();
var $b3c3454385bad6bf$var$SubscriptionObserver = /*#__PURE__*/ function() {
    function SubscriptionObserver(subscription) {
        $b3c3454385bad6bf$var$_classCallCheck(this, SubscriptionObserver);
        this._subscription = subscription;
    }
    $b3c3454385bad6bf$var$_createClass(SubscriptionObserver, [
        {
            key: "next",
            value: function next(value) {
                $b3c3454385bad6bf$var$onNotify(this._subscription, 'next', value);
            }
        },
        {
            key: "error",
            value: function error(value) {
                $b3c3454385bad6bf$var$onNotify(this._subscription, 'error', value);
            }
        },
        {
            key: "complete",
            value: function complete() {
                $b3c3454385bad6bf$var$onNotify(this._subscription, 'complete');
            }
        },
        {
            key: "closed",
            get: function() {
                return this._subscription._state === 'closed';
            }
        }
    ]);
    return SubscriptionObserver;
}();
var $b3c3454385bad6bf$var$Observable = /*#__PURE__*/ function() {
    function Observable(subscriber) {
        $b3c3454385bad6bf$var$_classCallCheck(this, Observable);
        if (!(this instanceof Observable)) throw new TypeError('Observable cannot be called as a function');
        if (typeof subscriber !== 'function') throw new TypeError('Observable initializer must be a function');
        this._subscriber = subscriber;
    }
    $b3c3454385bad6bf$var$_createClass(Observable, [
        {
            key: "subscribe",
            value: function subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) observer = {
                    next: observer,
                    error: arguments[1],
                    complete: arguments[2]
                };
                return new $b3c3454385bad6bf$var$Subscription(observer, this._subscriber);
            }
        },
        {
            key: "forEach",
            value: function forEach(fn) {
                var _this = this;
                return new Promise(function(resolve, reject) {
                    if (typeof fn !== 'function') {
                        reject(new TypeError(fn + ' is not a function'));
                        return;
                    }
                    function done() {
                        subscription.unsubscribe();
                        resolve();
                    }
                    var subscription = _this.subscribe({
                        next: function(value) {
                            try {
                                fn(value, done);
                            } catch (e) {
                                reject(e);
                                subscription.unsubscribe();
                            }
                        },
                        error: reject,
                        complete: resolve
                    });
                });
            }
        },
        {
            key: "map",
            value: function map(fn) {
                var _this2 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $b3c3454385bad6bf$var$getSpecies(this);
                return new C(function(observer) {
                    return _this2.subscribe({
                        next: function(value) {
                            try {
                                value = fn(value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "filter",
            value: function filter(fn) {
                var _this3 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $b3c3454385bad6bf$var$getSpecies(this);
                return new C(function(observer) {
                    return _this3.subscribe({
                        next: function(value) {
                            try {
                                if (!fn(value)) return;
                            } catch (e) {
                                return observer.error(e);
                            }
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "reduce",
            value: function reduce(fn) {
                var _this4 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $b3c3454385bad6bf$var$getSpecies(this);
                var hasSeed = arguments.length > 1;
                var hasValue = false;
                var seed = arguments[1];
                var acc = seed;
                return new C(function(observer) {
                    return _this4.subscribe({
                        next: function(value) {
                            var first = !hasValue;
                            hasValue = true;
                            if (!first || hasSeed) try {
                                acc = fn(acc, value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            else acc = value;
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            if (!hasValue && !hasSeed) return observer.error(new TypeError('Cannot reduce an empty sequence'));
                            observer.next(acc);
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "concat",
            value: function concat() {
                var _this5 = this;
                for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
                var C = $b3c3454385bad6bf$var$getSpecies(this);
                return new C(function(observer) {
                    var subscription;
                    var index = 0;
                    function startNext(next) {
                        subscription = next.subscribe({
                            next: function(v) {
                                observer.next(v);
                            },
                            error: function(e) {
                                observer.error(e);
                            },
                            complete: function() {
                                if (index === sources.length) {
                                    subscription = undefined;
                                    observer.complete();
                                } else startNext(C.from(sources[index++]));
                            }
                        });
                    }
                    startNext(_this5);
                    return function() {
                        if (subscription) {
                            subscription.unsubscribe();
                            subscription = undefined;
                        }
                    };
                });
            }
        },
        {
            key: "flatMap",
            value: function flatMap(fn) {
                var _this6 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $b3c3454385bad6bf$var$getSpecies(this);
                return new C(function(observer) {
                    var subscriptions = [];
                    var outer = _this6.subscribe({
                        next: function(value) {
                            if (fn) try {
                                value = fn(value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            var inner = C.from(value).subscribe({
                                next: function(value) {
                                    observer.next(value);
                                },
                                error: function(e) {
                                    observer.error(e);
                                },
                                complete: function() {
                                    var i = subscriptions.indexOf(inner);
                                    if (i >= 0) subscriptions.splice(i, 1);
                                    completeIfDone();
                                }
                            });
                            subscriptions.push(inner);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            completeIfDone();
                        }
                    });
                    function completeIfDone() {
                        if (outer.closed && subscriptions.length === 0) observer.complete();
                    }
                    return function() {
                        subscriptions.forEach(function(s) {
                            return s.unsubscribe();
                        });
                        outer.unsubscribe();
                    };
                });
            }
        },
        {
            key: $b3c3454385bad6bf$var$SymbolObservable,
            value: function() {
                return this;
            }
        }
    ], [
        {
            key: "from",
            value: function from(x) {
                var C = typeof this === 'function' ? this : Observable;
                if (x == null) throw new TypeError(x + ' is not an object');
                var method = $b3c3454385bad6bf$var$getMethod(x, $b3c3454385bad6bf$var$SymbolObservable);
                if (method) {
                    var observable = method.call(x);
                    if (Object(observable) !== observable) throw new TypeError(observable + ' is not an object');
                    if ($b3c3454385bad6bf$var$isObservable(observable) && observable.constructor === C) return observable;
                    return new C(function(observer) {
                        return observable.subscribe(observer);
                    });
                }
                if ($b3c3454385bad6bf$var$hasSymbol('iterator')) {
                    method = $b3c3454385bad6bf$var$getMethod(x, $b3c3454385bad6bf$var$SymbolIterator);
                    if (method) return new C(function(observer) {
                        $b3c3454385bad6bf$var$enqueue(function() {
                            if (observer.closed) return;
                            var _iteratorNormalCompletion = true;
                            var _didIteratorError = false;
                            var _iteratorError = undefined;
                            try {
                                for(var _iterator = method.call(x)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _item = _step.value;
                                    observer.next(_item);
                                    if (observer.closed) return;
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) _iterator.return();
                                } finally{
                                    if (_didIteratorError) throw _iteratorError;
                                }
                            }
                            observer.complete();
                        });
                    });
                }
                if (Array.isArray(x)) return new C(function(observer) {
                    $b3c3454385bad6bf$var$enqueue(function() {
                        if (observer.closed) return;
                        for(var i = 0; i < x.length; ++i){
                            observer.next(x[i]);
                            if (observer.closed) return;
                        }
                        observer.complete();
                    });
                });
                throw new TypeError(x + ' is not observable');
            }
        },
        {
            key: "of",
            value: function of() {
                for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
                var C = typeof this === 'function' ? this : Observable;
                return new C(function(observer) {
                    $b3c3454385bad6bf$var$enqueue(function() {
                        if (observer.closed) return;
                        for(var i = 0; i < items.length; ++i){
                            observer.next(items[i]);
                            if (observer.closed) return;
                        }
                        observer.complete();
                    });
                });
            }
        },
        {
            key: $b3c3454385bad6bf$var$SymbolSpecies,
            get: function() {
                return this;
            }
        }
    ]);
    return Observable;
}();
module.exports.Observable = $b3c3454385bad6bf$var$Observable;
if ($b3c3454385bad6bf$var$hasSymbols()) Object.defineProperty($b3c3454385bad6bf$var$Observable, Symbol('extensions'), {
    value: {
        symbol: $b3c3454385bad6bf$var$SymbolObservable,
        hostReportError: $b3c3454385bad6bf$var$hostReportError
    },
    configurable: true
});

});




parcelRegister("7nP18", function(module, exports) {

$parcel$export(module.exports, "urlSafeEncode", () => $5602415d519d0982$export$b855308a44508212);
$parcel$export(module.exports, "urlSafeDecode", () => $5602415d519d0982$export$a7ea17e93539f9a5);
function $5602415d519d0982$export$b855308a44508212(str) {
    return str.split('').map(function(char) {
        return char.charCodeAt(0).toString(16).padStart(2, '0');
    }).join('');
}
function $5602415d519d0982$export$a7ea17e93539f9a5(hex) {
    return hex.match(/.{2}/g).map(function(char) {
        return String.fromCharCode(parseInt(char, 16));
    }).join('');
}

});


parcelRegister("i14CG", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1dbe80755c5cb51$export$2e2bcd8739ae039);
$parcel$export(module.exports, "Auth", () => (parcelRequire("g0OFw")).Auth);
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $g0OFw = parcelRequire("g0OFw");

parcelRequire("7R5Xx");
var $fEY0G = parcelRequire("fEY0G");
var $lQunR = parcelRequire("lQunR");
var $fntmR = parcelRequire("fntmR");

var /**
 * @deprecated use named import
 */ $d1dbe80755c5cb51$export$2e2bcd8739ae039 = (0, $g0OFw.Auth);

});
parcelRegister("g0OFw", function(module, exports) {

$parcel$export(module.exports, "Auth", () => $ba83f3289cc079bd$export$334c29725a78c21d);
/*
 * Copyright 2017-2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *	 http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $fNaWC = parcelRequire("fNaWC");
parcelRequire("8qWqv");
var $a16qJ = parcelRequire("a16qJ");
var $7UO1b = parcelRequire("7UO1b");
var $29OQz = parcelRequire("29OQz");
var $kRjsJ = parcelRequire("kRjsJ");
var $9Mfkr = parcelRequire("9Mfkr");
var $7XN1x = parcelRequire("7XN1x");
var $4uQfD = parcelRequire("4uQfD");
var $1RES9 = parcelRequire("1RES9");
var $7nP18 = parcelRequire("7nP18");
parcelRequire("7R5Xx");
var $dRGMf = parcelRequire("dRGMf");
var $5KyOf = parcelRequire("5KyOf");
var $erxFS = parcelRequire("erxFS");
var $4avyf = parcelRequire("4avyf");
var $fEY0G = parcelRequire("fEY0G");
var $kDaVl = parcelRequire("kDaVl");
var $9ZqzK = parcelRequire("9ZqzK");
var $fVSyU = parcelRequire("fVSyU");
var $lQunR = parcelRequire("lQunR");

var $kcgTr = parcelRequire("kcgTr");

var $hXL0m = parcelRequire("hXL0m");

var $015h2 = parcelRequire("015h2");

var $1j1w1 = parcelRequire("1j1w1");

var $fNaWC = parcelRequire("fNaWC");
var $ba83f3289cc079bd$var$__assign = undefined && undefined.__assign || function() {
    $ba83f3289cc079bd$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ba83f3289cc079bd$var$__assign.apply(this, arguments);
};
var $ba83f3289cc079bd$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $ba83f3289cc079bd$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $ba83f3289cc079bd$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $ba83f3289cc079bd$var$logger = new (0, $7UO1b.ConsoleLogger)('AuthClass');
var $ba83f3289cc079bd$var$USER_ADMIN_SCOPE = 'aws.cognito.signin.user.admin';
// 10 sec, following this guide https://www.nngroup.com/articles/response-times-3-important-limits/
var $ba83f3289cc079bd$var$OAUTH_FLOW_MS_TIMEOUT = 10000;
var $ba83f3289cc079bd$var$AMPLIFY_SYMBOL = typeof Symbol !== 'undefined' && typeof Symbol.for === 'function' ? Symbol.for('amplify_default') : '@@amplify_default';
var $ba83f3289cc079bd$var$dispatchAuthEvent = function(event, data, message) {
    (0, $kRjsJ.Hub).dispatch('auth', {
        event: event,
        data: data,
        message: message
    }, 'Auth', $ba83f3289cc079bd$var$AMPLIFY_SYMBOL);
};
/**
 * Provide authentication steps
 */ var $ba83f3289cc079bd$export$eeff9d1a8b8c057b = /** @class */ function() {
    /**
     * Initialize Auth with AWS configurations
     * @param {Object} config - Configuration of the Auth
     */ function AuthClass(config) {
        var _this = this;
        this.userPool = null;
        this.user = null;
        this.oAuthFlowInProgress = false;
        this.Credentials = (0, $29OQz.Credentials);
        this.wrapRefreshSessionCallback = function(callback) {
            var wrapped = function(error, data) {
                if (data) $ba83f3289cc079bd$var$dispatchAuthEvent('tokenRefresh', undefined, "New token retrieved");
                else $ba83f3289cc079bd$var$dispatchAuthEvent('tokenRefresh_failure', error, "Failed to retrieve new token");
                return callback(error, data);
            };
            return wrapped;
        }; // prettier-ignore
        this.configure(config);
        this.currentCredentials = this.currentCredentials.bind(this);
        this.currentUserCredentials = this.currentUserCredentials.bind(this);
        (0, $kRjsJ.Hub).listen('auth', function(_a) {
            var payload = _a.payload;
            var event = payload.event;
            switch(event){
                case 'signIn':
                    _this._storage.setItem('amplify-signin-with-hostedUI', 'false');
                    break;
                case 'signOut':
                    _this._storage.removeItem('amplify-signin-with-hostedUI');
                    break;
                case 'cognitoHostedUI':
                    _this._storage.setItem('amplify-signin-with-hostedUI', 'true');
                    break;
            }
        });
    }
    AuthClass.prototype.getModuleName = function() {
        return 'Auth';
    };
    AuthClass.prototype.configure = function(config) {
        var _this = this;
        if (!config) return this._config || {};
        $ba83f3289cc079bd$var$logger.debug('configure Auth');
        var conf = Object.assign({}, this._config, (0, $7XN1x.Parser).parseMobilehubConfig(config).Auth, config);
        this._config = conf;
        var _a = this._config, userPoolId = _a.userPoolId, userPoolWebClientId = _a.userPoolWebClientId, cookieStorage = _a.cookieStorage, oauth = _a.oauth, region = _a.region, identityPoolId = _a.identityPoolId, mandatorySignIn = _a.mandatorySignIn, refreshHandlers = _a.refreshHandlers, identityPoolRegion = _a.identityPoolRegion, clientMetadata = _a.clientMetadata, endpoint = _a.endpoint;
        if (!this._config.storage) {
            // backward compatability
            if (cookieStorage) this._storage = new (0, $lQunR.default)(cookieStorage);
            else this._storage = config.ssr ? new (0, $1RES9.UniversalStorage)() : new (0, $4uQfD.StorageHelper)().getStorage();
        } else {
            if (!this._isValidAuthStorage(this._config.storage)) {
                $ba83f3289cc079bd$var$logger.error('The storage in the Auth config is not valid!');
                throw new Error('Empty storage object');
            }
            this._storage = this._config.storage;
        }
        this._storageSync = Promise.resolve();
        if (typeof this._storage['sync'] === 'function') this._storageSync = this._storage['sync']();
        if (userPoolId) {
            var userPoolData = {
                UserPoolId: userPoolId,
                ClientId: userPoolWebClientId,
                endpoint: endpoint
            };
            userPoolData.Storage = this._storage;
            this.userPool = new (0, $9ZqzK.default)(userPoolData, this.wrapRefreshSessionCallback);
        }
        this.Credentials.configure({
            mandatorySignIn: mandatorySignIn,
            region: identityPoolRegion || region,
            userPoolId: userPoolId,
            identityPoolId: identityPoolId,
            refreshHandlers: refreshHandlers,
            storage: this._storage
        });
        // initialize cognitoauth client if hosted ui options provided
        // to keep backward compatibility:
        var cognitoHostedUIConfig = oauth ? (0, $fNaWC.isCognitoHostedOpts)(this._config.oauth) ? oauth : oauth.awsCognito : undefined;
        if (cognitoHostedUIConfig) {
            var cognitoAuthParams = Object.assign({
                cognitoClientId: userPoolWebClientId,
                UserPoolId: userPoolId,
                domain: cognitoHostedUIConfig['domain'],
                scopes: cognitoHostedUIConfig['scope'],
                redirectSignIn: cognitoHostedUIConfig['redirectSignIn'],
                redirectSignOut: cognitoHostedUIConfig['redirectSignOut'],
                responseType: cognitoHostedUIConfig['responseType'],
                Storage: this._storage,
                urlOpener: cognitoHostedUIConfig['urlOpener'],
                clientMetadata: clientMetadata
            }, cognitoHostedUIConfig['options']);
            this._oAuthHandler = new (0, $hXL0m.default)({
                scopes: cognitoAuthParams.scopes,
                config: cognitoAuthParams,
                cognitoClientId: cognitoAuthParams.cognitoClientId
            });
            // **NOTE** - Remove this in a future major release as it is a breaking change
            // Prevents _handleAuthResponse from being called multiple times in Expo
            // See https://github.com/aws-amplify/amplify-js/issues/4388
            var usedResponseUrls_1 = {};
            (0, $015h2.default)(function(_a) {
                var url = _a.url;
                if (usedResponseUrls_1[url]) return;
                usedResponseUrls_1[url] = true;
                _this._handleAuthResponse(url);
            });
        }
        $ba83f3289cc079bd$var$dispatchAuthEvent('configured', null, "The Auth category has been configured successfully");
        return this._config;
    };
    /**
     * Sign up with username, password and other attributes like phone, email
     * @param {String | object} params - The user attributes used for signin
     * @param {String[]} restOfAttrs - for the backward compatability
     * @return - A promise resolves callback data if success
     */ AuthClass.prototype.signUp = function(params) {
        var _this = this;
        var restOfAttrs = [];
        for(var _i = 1; _i < arguments.length; _i++)restOfAttrs[_i - 1] = arguments[_i];
        if (!this.userPool) return this.rejectNoUserPool();
        var username = null;
        var password = null;
        var attributes = [];
        var validationData = null;
        var clientMetadata;
        if (params && typeof params === 'string') {
            username = params;
            password = restOfAttrs ? restOfAttrs[0] : null;
            var email = restOfAttrs ? restOfAttrs[1] : null;
            var phone_number = restOfAttrs ? restOfAttrs[2] : null;
            if (email) attributes.push(new (0, $kDaVl.default)({
                Name: 'email',
                Value: email
            }));
            if (phone_number) attributes.push(new (0, $kDaVl.default)({
                Name: 'phone_number',
                Value: phone_number
            }));
        } else if (params && typeof params === 'object') {
            username = params['username'];
            password = params['password'];
            if (params && params.clientMetadata) clientMetadata = params.clientMetadata;
            else if (this._config.clientMetadata) clientMetadata = this._config.clientMetadata;
            var attrs_1 = params['attributes'];
            if (attrs_1) Object.keys(attrs_1).map(function(key) {
                attributes.push(new (0, $kDaVl.default)({
                    Name: key,
                    Value: attrs_1[key]
                }));
            });
            var validationDataObject_1 = params['validationData'];
            if (validationDataObject_1) {
                validationData = [];
                Object.keys(validationDataObject_1).map(function(key) {
                    validationData.push(new (0, $kDaVl.default)({
                        Name: key,
                        Value: validationDataObject_1[key]
                    }));
                });
            }
        } else return this.rejectAuthError((0, $fNaWC.AuthErrorTypes).SignUpError);
        if (!username) return this.rejectAuthError((0, $fNaWC.AuthErrorTypes).EmptyUsername);
        if (!password) return this.rejectAuthError((0, $fNaWC.AuthErrorTypes).EmptyPassword);
        $ba83f3289cc079bd$var$logger.debug('signUp attrs:', attributes);
        $ba83f3289cc079bd$var$logger.debug('signUp validation data:', validationData);
        return new Promise(function(resolve, reject) {
            _this.userPool.signUp(username, password, attributes, validationData, function(err, data) {
                if (err) {
                    $ba83f3289cc079bd$var$dispatchAuthEvent('signUp_failure', err, username + " failed to signup");
                    reject(err);
                } else {
                    $ba83f3289cc079bd$var$dispatchAuthEvent('signUp', data, username + " has signed up successfully");
                    resolve(data);
                }
            }, clientMetadata);
        });
    };
    /**
     * Send the verification code to confirm sign up
     * @param {String} username - The username to be confirmed
     * @param {String} code - The verification code
     * @param {ConfirmSignUpOptions} options - other options for confirm signup
     * @return - A promise resolves callback data if success
     */ AuthClass.prototype.confirmSignUp = function(username, code, options) {
        if (!this.userPool) return this.rejectNoUserPool();
        if (!username) return this.rejectAuthError((0, $fNaWC.AuthErrorTypes).EmptyUsername);
        if (!code) return this.rejectAuthError((0, $fNaWC.AuthErrorTypes).EmptyCode);
        var user = this.createCognitoUser(username);
        var forceAliasCreation = options && typeof options.forceAliasCreation === 'boolean' ? options.forceAliasCreation : true;
        var clientMetadata;
        if (options && options.clientMetadata) clientMetadata = options.clientMetadata;
        else if (this._config.clientMetadata) clientMetadata = this._config.clientMetadata;
        return new Promise(function(resolve, reject) {
            user.confirmRegistration(code, forceAliasCreation, function(err, data) {
                if (err) reject(err);
                else resolve(data);
            }, clientMetadata);
        });
    };
    /**
     * Resend the verification code
     * @param {String} username - The username to be confirmed
     * @param {ClientMetadata} clientMetadata - Metadata to be passed to Cognito Lambda triggers
     * @return - A promise resolves code delivery details if successful
     */ AuthClass.prototype.resendSignUp = function(username, clientMetadata) {
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!this.userPool) return this.rejectNoUserPool();
        if (!username) return this.rejectAuthError((0, $fNaWC.AuthErrorTypes).EmptyUsername);
        var user = this.createCognitoUser(username);
        return new Promise(function(resolve, reject) {
            user.resendConfirmationCode(function(err, data) {
                if (err) reject(err);
                else resolve(data);
            }, clientMetadata);
        });
    };
    /**
     * Sign in
     * @param {String | SignInOpts} usernameOrSignInOpts - The username to be signed in or the sign in options
     * @param {String} password - The password of the username
     * @return - A promise resolves the CognitoUser
     */ AuthClass.prototype.signIn = function(usernameOrSignInOpts, pw, clientMetadata) {
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!this.userPool) return this.rejectNoUserPool();
        var username = null;
        var password = null;
        var validationData = {};
        // for backward compatibility
        if (typeof usernameOrSignInOpts === 'string') {
            username = usernameOrSignInOpts;
            password = pw;
        } else if ((0, $fNaWC.isUsernamePasswordOpts)(usernameOrSignInOpts)) {
            if (typeof pw !== 'undefined') $ba83f3289cc079bd$var$logger.warn('The password should be defined under the first parameter object!');
            username = usernameOrSignInOpts.username;
            password = usernameOrSignInOpts.password;
            validationData = usernameOrSignInOpts.validationData;
        } else return this.rejectAuthError((0, $fNaWC.AuthErrorTypes).InvalidUsername);
        if (!username) return this.rejectAuthError((0, $fNaWC.AuthErrorTypes).EmptyUsername);
        var authDetails = new (0, $dRGMf.default)({
            Username: username,
            Password: password,
            ValidationData: validationData,
            ClientMetadata: clientMetadata
        });
        if (password) return this.signInWithPassword(authDetails);
        else return this.signInWithoutPassword(authDetails);
    };
    /**
     * Return an object with the authentication callbacks
     * @param {CognitoUser} user - the cognito user object
     * @param {} resolve - function called when resolving the current step
     * @param {} reject - function called when rejecting the current step
     * @return - an object with the callback methods for user authentication
     */ AuthClass.prototype.authCallbacks = function(user, resolve, reject) {
        var _this = this;
        var that = this;
        return {
            onSuccess: function(session) {
                return $ba83f3289cc079bd$var$__awaiter(_this, void 0, void 0, function() {
                    var cred, e_1, currentUser, e_2;
                    return $ba83f3289cc079bd$var$__generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                $ba83f3289cc079bd$var$logger.debug(session);
                                delete user['challengeName'];
                                delete user['challengeParam'];
                                _a.label = 1;
                            case 1:
                                _a.trys.push([
                                    1,
                                    4,
                                    5,
                                    9
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    this.Credentials.clear()
                                ];
                            case 2:
                                _a.sent();
                                return [
                                    4 /*yield*/ ,
                                    this.Credentials.set(session, 'session')
                                ];
                            case 3:
                                cred = _a.sent();
                                $ba83f3289cc079bd$var$logger.debug('succeed to get cognito credentials', cred);
                                return [
                                    3 /*break*/ ,
                                    9
                                ];
                            case 4:
                                e_1 = _a.sent();
                                $ba83f3289cc079bd$var$logger.debug('cannot get cognito credentials', e_1);
                                return [
                                    3 /*break*/ ,
                                    9
                                ];
                            case 5:
                                _a.trys.push([
                                    5,
                                    7,
                                    ,
                                    8
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    this.currentUserPoolUser()
                                ];
                            case 6:
                                currentUser = _a.sent();
                                that.user = currentUser;
                                $ba83f3289cc079bd$var$dispatchAuthEvent('signIn', currentUser, "A user " + user.getUsername() + " has been signed in");
                                resolve(currentUser);
                                return [
                                    3 /*break*/ ,
                                    8
                                ];
                            case 7:
                                e_2 = _a.sent();
                                $ba83f3289cc079bd$var$logger.error('Failed to get the signed in user', e_2);
                                reject(e_2);
                                return [
                                    3 /*break*/ ,
                                    8
                                ];
                            case 8:
                                return [
                                    7 /*endfinally*/ 
                                ];
                            case 9:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            },
            onFailure: function(err) {
                $ba83f3289cc079bd$var$logger.debug('signIn failure', err);
                $ba83f3289cc079bd$var$dispatchAuthEvent('signIn_failure', err, user.getUsername() + " failed to signin");
                reject(err);
            },
            customChallenge: function(challengeParam) {
                $ba83f3289cc079bd$var$logger.debug('signIn custom challenge answer required');
                user['challengeName'] = 'CUSTOM_CHALLENGE';
                user['challengeParam'] = challengeParam;
                resolve(user);
            },
            mfaRequired: function(challengeName, challengeParam) {
                $ba83f3289cc079bd$var$logger.debug('signIn MFA required');
                user['challengeName'] = challengeName;
                user['challengeParam'] = challengeParam;
                resolve(user);
            },
            mfaSetup: function(challengeName, challengeParam) {
                $ba83f3289cc079bd$var$logger.debug('signIn mfa setup', challengeName);
                user['challengeName'] = challengeName;
                user['challengeParam'] = challengeParam;
                resolve(user);
            },
            newPasswordRequired: function(userAttributes, requiredAttributes) {
                $ba83f3289cc079bd$var$logger.debug('signIn new password');
                user['challengeName'] = 'NEW_PASSWORD_REQUIRED';
                user['challengeParam'] = {
                    userAttributes: userAttributes,
                    requiredAttributes: requiredAttributes
                };
                resolve(user);
            },
            totpRequired: function(challengeName, challengeParam) {
                $ba83f3289cc079bd$var$logger.debug('signIn totpRequired');
                user['challengeName'] = challengeName;
                user['challengeParam'] = challengeParam;
                resolve(user);
            },
            selectMFAType: function(challengeName, challengeParam) {
                $ba83f3289cc079bd$var$logger.debug('signIn selectMFAType', challengeName);
                user['challengeName'] = challengeName;
                user['challengeParam'] = challengeParam;
                resolve(user);
            }
        };
    };
    /**
     * Sign in with a password
     * @private
     * @param {AuthenticationDetails} authDetails - the user sign in data
     * @return - A promise resolves the CognitoUser object if success or mfa required
     */ AuthClass.prototype.signInWithPassword = function(authDetails) {
        var _this = this;
        if (this.pendingSignIn) throw new Error('Pending sign-in attempt already in progress');
        var user = this.createCognitoUser(authDetails.getUsername());
        this.pendingSignIn = new Promise(function(resolve, reject) {
            user.authenticateUser(authDetails, _this.authCallbacks(user, function(value) {
                _this.pendingSignIn = null;
                resolve(value);
            }, function(error) {
                _this.pendingSignIn = null;
                reject(error);
            }));
        });
        return this.pendingSignIn;
    };
    /**
     * Sign in without a password
     * @private
     * @param {AuthenticationDetails} authDetails - the user sign in data
     * @return - A promise resolves the CognitoUser object if success or mfa required
     */ AuthClass.prototype.signInWithoutPassword = function(authDetails) {
        var _this = this;
        var user = this.createCognitoUser(authDetails.getUsername());
        user.setAuthenticationFlowType('CUSTOM_AUTH');
        return new Promise(function(resolve, reject) {
            user.initiateAuth(authDetails, _this.authCallbacks(user, resolve, reject));
        });
    };
    /**
     * This was previously used by an authenticated user to get MFAOptions,
     * but no longer returns a meaningful response. Refer to the documentation for
     * how to setup and use MFA: https://docs.amplify.aws/lib/auth/mfa/q/platform/js
     * @deprecated
     * @param {CognitoUser} user - the current user
     * @return - A promise resolves the current preferred mfa option if success
     */ AuthClass.prototype.getMFAOptions = function(user) {
        return new Promise(function(res, rej) {
            user.getMFAOptions(function(err, mfaOptions) {
                if (err) {
                    $ba83f3289cc079bd$var$logger.debug('get MFA Options failed', err);
                    rej(err);
                    return;
                }
                $ba83f3289cc079bd$var$logger.debug('get MFA options success', mfaOptions);
                res(mfaOptions);
                return;
            });
        });
    };
    /**
     * get preferred mfa method
     * @param {CognitoUser} user - the current cognito user
     * @param {GetPreferredMFAOpts} params - options for getting the current user preferred MFA
     */ AuthClass.prototype.getPreferredMFA = function(user, params) {
        var _this = this;
        var that = this;
        return new Promise(function(res, rej) {
            var clientMetadata = _this._config.clientMetadata; // TODO: verify behavior if this is override during signIn
            var bypassCache = params ? params.bypassCache : false;
            user.getUserData(function(err, data) {
                if (err) {
                    $ba83f3289cc079bd$var$logger.debug('getting preferred mfa failed', err);
                    rej(err);
                    return;
                }
                var mfaType = that._getMfaTypeFromUserData(data);
                if (!mfaType) {
                    rej('invalid MFA Type');
                    return;
                } else {
                    res(mfaType);
                    return;
                }
            }, {
                bypassCache: bypassCache,
                clientMetadata: clientMetadata
            });
        });
    };
    AuthClass.prototype._getMfaTypeFromUserData = function(data) {
        var ret = null;
        var preferredMFA = data.PreferredMfaSetting;
        // if the user has used Auth.setPreferredMFA() to setup the mfa type
        // then the "PreferredMfaSetting" would exist in the response
        if (preferredMFA) ret = preferredMFA;
        else {
            // if mfaList exists but empty, then its noMFA
            var mfaList = data.UserMFASettingList;
            if (!mfaList) {
                // if SMS was enabled by using Auth.enableSMS(),
                // the response would contain MFAOptions
                // as for now Cognito only supports for SMS, so we will say it is 'SMS_MFA'
                // if it does not exist, then it should be NOMFA
                var MFAOptions = data.MFAOptions;
                if (MFAOptions) ret = 'SMS_MFA';
                else ret = 'NOMFA';
            } else if (mfaList.length === 0) ret = 'NOMFA';
            else $ba83f3289cc079bd$var$logger.debug('invalid case for getPreferredMFA', data);
        }
        return ret;
    };
    AuthClass.prototype._getUserData = function(user, params) {
        return new Promise(function(res, rej) {
            user.getUserData(function(err, data) {
                if (err) {
                    $ba83f3289cc079bd$var$logger.debug('getting user data failed', err);
                    rej(err);
                    return;
                } else {
                    res(data);
                    return;
                }
            }, params);
        });
    };
    /**
     * set preferred MFA method
     * @param {CognitoUser} user - the current Cognito user
     * @param {string} mfaMethod - preferred mfa method
     * @return - A promise resolve if success
     */ AuthClass.prototype.setPreferredMFA = function(user, mfaMethod) {
        return $ba83f3289cc079bd$var$__awaiter(this, void 0, void 0, function() {
            var clientMetadata, userData, smsMfaSettings, totpMfaSettings, _a, mfaList, currentMFAType, that;
            return $ba83f3289cc079bd$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        clientMetadata = this._config.clientMetadata;
                        return [
                            4 /*yield*/ ,
                            this._getUserData(user, {
                                bypassCache: true,
                                clientMetadata: clientMetadata
                            })
                        ];
                    case 1:
                        userData = _b.sent();
                        smsMfaSettings = null;
                        totpMfaSettings = null;
                        _a = mfaMethod;
                        switch(_a){
                            case 'TOTP':
                                return [
                                    3 /*break*/ ,
                                    2
                                ];
                            case 'SMS':
                                return [
                                    3 /*break*/ ,
                                    3
                                ];
                            case 'NOMFA':
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                        }
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 2:
                        totpMfaSettings = {
                            PreferredMfa: true,
                            Enabled: true
                        };
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 3:
                        smsMfaSettings = {
                            PreferredMfa: true,
                            Enabled: true
                        };
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 4:
                        mfaList = userData['UserMFASettingList'];
                        return [
                            4 /*yield*/ ,
                            this._getMfaTypeFromUserData(userData)
                        ];
                    case 5:
                        currentMFAType = _b.sent();
                        if (currentMFAType === 'NOMFA') return [
                            2 /*return*/ ,
                            Promise.resolve('No change for mfa type')
                        ];
                        else if (currentMFAType === 'SMS_MFA') smsMfaSettings = {
                            PreferredMfa: false,
                            Enabled: false
                        };
                        else if (currentMFAType === 'SOFTWARE_TOKEN_MFA') totpMfaSettings = {
                            PreferredMfa: false,
                            Enabled: false
                        };
                        else return [
                            2 /*return*/ ,
                            this.rejectAuthError((0, $fNaWC.AuthErrorTypes).InvalidMFA)
                        ];
                        // if there is a UserMFASettingList in the response
                        // we need to disable every mfa type in that list
                        if (mfaList && mfaList.length !== 0) // to disable SMS or TOTP if exists in that list
                        mfaList.forEach(function(mfaType) {
                            if (mfaType === 'SMS_MFA') smsMfaSettings = {
                                PreferredMfa: false,
                                Enabled: false
                            };
                            else if (mfaType === 'SOFTWARE_TOKEN_MFA') totpMfaSettings = {
                                PreferredMfa: false,
                                Enabled: false
                            };
                        });
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 6:
                        $ba83f3289cc079bd$var$logger.debug('no validmfa method provided');
                        return [
                            2 /*return*/ ,
                            this.rejectAuthError((0, $fNaWC.AuthErrorTypes).NoMFA)
                        ];
                    case 7:
                        that = this;
                        return [
                            2 /*return*/ ,
                            new Promise(function(res, rej) {
                                user.setUserMfaPreference(smsMfaSettings, totpMfaSettings, function(err, result) {
                                    if (err) {
                                        $ba83f3289cc079bd$var$logger.debug('Set user mfa preference error', err);
                                        return rej(err);
                                    }
                                    $ba83f3289cc079bd$var$logger.debug('Set user mfa success', result);
                                    $ba83f3289cc079bd$var$logger.debug('Caching the latest user data into local');
                                    // cache the latest result into user data
                                    user.getUserData(function(err, data) {
                                        if (err) {
                                            $ba83f3289cc079bd$var$logger.debug('getting user data failed', err);
                                            return rej(err);
                                        } else return res(result);
                                    }, {
                                        bypassCache: true,
                                        clientMetadata: clientMetadata
                                    });
                                });
                            })
                        ];
                }
            });
        });
    };
    /**
     * diable SMS
     * @deprecated
     * @param {CognitoUser} user - the current user
     * @return - A promise resolves is success
     */ AuthClass.prototype.disableSMS = function(user) {
        return new Promise(function(res, rej) {
            user.disableMFA(function(err, data) {
                if (err) {
                    $ba83f3289cc079bd$var$logger.debug('disable mfa failed', err);
                    rej(err);
                    return;
                }
                $ba83f3289cc079bd$var$logger.debug('disable mfa succeed', data);
                res(data);
                return;
            });
        });
    };
    /**
     * enable SMS
     * @deprecated
     * @param {CognitoUser} user - the current user
     * @return - A promise resolves is success
     */ AuthClass.prototype.enableSMS = function(user) {
        return new Promise(function(res, rej) {
            user.enableMFA(function(err, data) {
                if (err) {
                    $ba83f3289cc079bd$var$logger.debug('enable mfa failed', err);
                    rej(err);
                    return;
                }
                $ba83f3289cc079bd$var$logger.debug('enable mfa succeed', data);
                res(data);
                return;
            });
        });
    };
    /**
     * Setup TOTP
     * @param {CognitoUser} user - the current user
     * @return - A promise resolves with the secret code if success
     */ AuthClass.prototype.setupTOTP = function(user) {
        return new Promise(function(res, rej) {
            user.associateSoftwareToken({
                onFailure: function(err) {
                    $ba83f3289cc079bd$var$logger.debug('associateSoftwareToken failed', err);
                    rej(err);
                    return;
                },
                associateSecretCode: function(secretCode) {
                    $ba83f3289cc079bd$var$logger.debug('associateSoftwareToken sucess', secretCode);
                    res(secretCode);
                    return;
                }
            });
        });
    };
    /**
     * verify TOTP setup
     * @param {CognitoUser} user - the current user
     * @param {string} challengeAnswer - challenge answer
     * @return - A promise resolves is success
     */ AuthClass.prototype.verifyTotpToken = function(user, challengeAnswer) {
        $ba83f3289cc079bd$var$logger.debug('verification totp token', user, challengeAnswer);
        return new Promise(function(res, rej) {
            user.verifySoftwareToken(challengeAnswer, 'My TOTP device', {
                onFailure: function(err) {
                    $ba83f3289cc079bd$var$logger.debug('verifyTotpToken failed', err);
                    rej(err);
                    return;
                },
                onSuccess: function(data) {
                    $ba83f3289cc079bd$var$dispatchAuthEvent('signIn', user, "A user " + user.getUsername() + " has been signed in");
                    $ba83f3289cc079bd$var$logger.debug('verifyTotpToken success', data);
                    res(data);
                    return;
                }
            });
        });
    };
    /**
     * Send MFA code to confirm sign in
     * @param {Object} user - The CognitoUser object
     * @param {String} code - The confirmation code
     */ AuthClass.prototype.confirmSignIn = function(user, code, mfaType, clientMetadata) {
        var _this = this;
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!code) return this.rejectAuthError((0, $fNaWC.AuthErrorTypes).EmptyCode);
        var that = this;
        return new Promise(function(resolve, reject) {
            user.sendMFACode(code, {
                onSuccess: function(session) {
                    return $ba83f3289cc079bd$var$__awaiter(_this, void 0, void 0, function() {
                        var cred, e_3;
                        return $ba83f3289cc079bd$var$__generator(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    $ba83f3289cc079bd$var$logger.debug(session);
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([
                                        1,
                                        4,
                                        5,
                                        6
                                    ]);
                                    return [
                                        4 /*yield*/ ,
                                        this.Credentials.clear()
                                    ];
                                case 2:
                                    _a.sent();
                                    return [
                                        4 /*yield*/ ,
                                        this.Credentials.set(session, 'session')
                                    ];
                                case 3:
                                    cred = _a.sent();
                                    $ba83f3289cc079bd$var$logger.debug('succeed to get cognito credentials', cred);
                                    return [
                                        3 /*break*/ ,
                                        6
                                    ];
                                case 4:
                                    e_3 = _a.sent();
                                    $ba83f3289cc079bd$var$logger.debug('cannot get cognito credentials', e_3);
                                    return [
                                        3 /*break*/ ,
                                        6
                                    ];
                                case 5:
                                    that.user = user;
                                    $ba83f3289cc079bd$var$dispatchAuthEvent('signIn', user, "A user " + user.getUsername() + " has been signed in");
                                    resolve(user);
                                    return [
                                        7 /*endfinally*/ 
                                    ];
                                case 6:
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                },
                onFailure: function(err) {
                    $ba83f3289cc079bd$var$logger.debug('confirm signIn failure', err);
                    reject(err);
                }
            }, mfaType, clientMetadata);
        });
    };
    AuthClass.prototype.completeNewPassword = function(user, password, requiredAttributes, clientMetadata) {
        var _this = this;
        if (requiredAttributes === void 0) requiredAttributes = {};
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!password) return this.rejectAuthError((0, $fNaWC.AuthErrorTypes).EmptyPassword);
        var that = this;
        return new Promise(function(resolve, reject) {
            user.completeNewPasswordChallenge(password, requiredAttributes, {
                onSuccess: function(session) {
                    return $ba83f3289cc079bd$var$__awaiter(_this, void 0, void 0, function() {
                        var cred, e_4;
                        return $ba83f3289cc079bd$var$__generator(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    $ba83f3289cc079bd$var$logger.debug(session);
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([
                                        1,
                                        4,
                                        5,
                                        6
                                    ]);
                                    return [
                                        4 /*yield*/ ,
                                        this.Credentials.clear()
                                    ];
                                case 2:
                                    _a.sent();
                                    return [
                                        4 /*yield*/ ,
                                        this.Credentials.set(session, 'session')
                                    ];
                                case 3:
                                    cred = _a.sent();
                                    $ba83f3289cc079bd$var$logger.debug('succeed to get cognito credentials', cred);
                                    return [
                                        3 /*break*/ ,
                                        6
                                    ];
                                case 4:
                                    e_4 = _a.sent();
                                    $ba83f3289cc079bd$var$logger.debug('cannot get cognito credentials', e_4);
                                    return [
                                        3 /*break*/ ,
                                        6
                                    ];
                                case 5:
                                    that.user = user;
                                    $ba83f3289cc079bd$var$dispatchAuthEvent('signIn', user, "A user " + user.getUsername() + " has been signed in");
                                    resolve(user);
                                    return [
                                        7 /*endfinally*/ 
                                    ];
                                case 6:
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                },
                onFailure: function(err) {
                    $ba83f3289cc079bd$var$logger.debug('completeNewPassword failure', err);
                    $ba83f3289cc079bd$var$dispatchAuthEvent('completeNewPassword_failure', err, _this.user + " failed to complete the new password flow");
                    reject(err);
                },
                mfaRequired: function(challengeName, challengeParam) {
                    $ba83f3289cc079bd$var$logger.debug('signIn MFA required');
                    user['challengeName'] = challengeName;
                    user['challengeParam'] = challengeParam;
                    resolve(user);
                },
                mfaSetup: function(challengeName, challengeParam) {
                    $ba83f3289cc079bd$var$logger.debug('signIn mfa setup', challengeName);
                    user['challengeName'] = challengeName;
                    user['challengeParam'] = challengeParam;
                    resolve(user);
                },
                totpRequired: function(challengeName, challengeParam) {
                    $ba83f3289cc079bd$var$logger.debug('signIn mfa setup', challengeName);
                    user['challengeName'] = challengeName;
                    user['challengeParam'] = challengeParam;
                    resolve(user);
                }
            }, clientMetadata);
        });
    };
    /**
     * Send the answer to a custom challenge
     * @param {CognitoUser} user - The CognitoUser object
     * @param {String} challengeResponses - The confirmation code
     */ AuthClass.prototype.sendCustomChallengeAnswer = function(user, challengeResponses, clientMetadata) {
        var _this = this;
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!this.userPool) return this.rejectNoUserPool();
        if (!challengeResponses) return this.rejectAuthError((0, $fNaWC.AuthErrorTypes).EmptyChallengeResponse);
        var that = this;
        return new Promise(function(resolve, reject) {
            user.sendCustomChallengeAnswer(challengeResponses, _this.authCallbacks(user, resolve, reject), clientMetadata);
        });
    };
    /**
     * Update an authenticated users' attributes
     * @param {CognitoUser} - The currently logged in user object
     * @return {Promise}
     **/ AuthClass.prototype.updateUserAttributes = function(user, attributes, clientMetadata) {
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        var attributeList = [];
        var that = this;
        return new Promise(function(resolve, reject) {
            that.userSession(user).then(function(session) {
                for(var key in attributes)if (key !== 'sub' && key.indexOf('_verified') < 0) {
                    var attr = {
                        Name: key,
                        Value: attributes[key]
                    };
                    attributeList.push(attr);
                }
                user.updateAttributes(attributeList, function(err, result) {
                    if (err) return reject(err);
                    else return resolve(result);
                }, clientMetadata);
            });
        });
    };
    /**
     * Return user attributes
     * @param {Object} user - The CognitoUser object
     * @return - A promise resolves to user attributes if success
     */ AuthClass.prototype.userAttributes = function(user) {
        var _this = this;
        return new Promise(function(resolve, reject) {
            _this.userSession(user).then(function(session) {
                user.getUserAttributes(function(err, attributes) {
                    if (err) reject(err);
                    else resolve(attributes);
                });
            });
        });
    };
    AuthClass.prototype.verifiedContact = function(user) {
        var that = this;
        return this.userAttributes(user).then(function(attributes) {
            var attrs = that.attributesToObject(attributes);
            var unverified = {};
            var verified = {};
            if (attrs['email']) {
                if (attrs['email_verified']) verified['email'] = attrs['email'];
                else unverified['email'] = attrs['email'];
            }
            if (attrs['phone_number']) {
                if (attrs['phone_number_verified']) verified['phone_number'] = attrs['phone_number'];
                else unverified['phone_number'] = attrs['phone_number'];
            }
            return {
                verified: verified,
                unverified: unverified
            };
        });
    };
    /**
     * Get current authenticated user
     * @return - A promise resolves to current authenticated CognitoUser if success
     */ AuthClass.prototype.currentUserPoolUser = function(params) {
        var _this = this;
        if (!this.userPool) return this.rejectNoUserPool();
        return new Promise(function(res, rej) {
            _this._storageSync.then(function() {
                return $ba83f3289cc079bd$var$__awaiter(_this, void 0, void 0, function() {
                    var user, clientMetadata;
                    var _this = this;
                    return $ba83f3289cc079bd$var$__generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                if (!this.isOAuthInProgress()) return [
                                    3 /*break*/ ,
                                    2
                                ];
                                $ba83f3289cc079bd$var$logger.debug('OAuth signIn in progress, waiting for resolution...');
                                return [
                                    4 /*yield*/ ,
                                    new Promise(function(res) {
                                        var timeoutId = setTimeout(function() {
                                            $ba83f3289cc079bd$var$logger.debug('OAuth signIn in progress timeout');
                                            (0, $kRjsJ.Hub).remove('auth', hostedUISignCallback);
                                            res();
                                        }, $ba83f3289cc079bd$var$OAUTH_FLOW_MS_TIMEOUT);
                                        (0, $kRjsJ.Hub).listen('auth', hostedUISignCallback);
                                        function hostedUISignCallback(_a) {
                                            var payload = _a.payload;
                                            var event = payload.event;
                                            if (event === 'cognitoHostedUI' || event === 'cognitoHostedUI_failure') {
                                                $ba83f3289cc079bd$var$logger.debug("OAuth signIn resolved: " + event);
                                                clearTimeout(timeoutId);
                                                (0, $kRjsJ.Hub).remove('auth', hostedUISignCallback);
                                                res();
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2:
                                user = this.userPool.getCurrentUser();
                                if (!user) {
                                    $ba83f3289cc079bd$var$logger.debug('Failed to get user from user pool');
                                    rej('No current user');
                                    return [
                                        2 /*return*/ 
                                    ];
                                }
                                clientMetadata = this._config.clientMetadata;
                                // refresh the session if the session expired.
                                user.getSession(function(err, session) {
                                    return $ba83f3289cc079bd$var$__awaiter(_this, void 0, void 0, function() {
                                        var bypassCache, clientMetadata, _a, scope;
                                        var _this = this;
                                        return $ba83f3289cc079bd$var$__generator(this, function(_b) {
                                            switch(_b.label){
                                                case 0:
                                                    if (err) {
                                                        $ba83f3289cc079bd$var$logger.debug('Failed to get the user session', err);
                                                        rej(err);
                                                        return [
                                                            2 /*return*/ 
                                                        ];
                                                    }
                                                    bypassCache = params ? params.bypassCache : false;
                                                    if (!bypassCache) return [
                                                        3 /*break*/ ,
                                                        2
                                                    ];
                                                    return [
                                                        4 /*yield*/ ,
                                                        this.Credentials.clear()
                                                    ];
                                                case 1:
                                                    _b.sent();
                                                    _b.label = 2;
                                                case 2:
                                                    clientMetadata = this._config.clientMetadata;
                                                    _a = session.getAccessToken().decodePayload().scope, scope = _a === void 0 ? '' : _a;
                                                    if (scope.split(' ').includes($ba83f3289cc079bd$var$USER_ADMIN_SCOPE)) user.getUserData(function(err, data) {
                                                        if (err) {
                                                            $ba83f3289cc079bd$var$logger.debug('getting user data failed', err);
                                                            // Make sure the user is still valid
                                                            if (err.message === 'User is disabled.' || err.message === 'User does not exist.' || err.message === 'Access Token has been revoked' // Session revoked by another app
                                                            ) rej(err);
                                                            else // the error may also be thrown when lack of permissions to get user info etc
                                                            // in that case we just bypass the error
                                                            res(user);
                                                            return;
                                                        }
                                                        var preferredMFA = data.PreferredMfaSetting || 'NOMFA';
                                                        var attributeList = [];
                                                        for(var i = 0; i < data.UserAttributes.length; i++){
                                                            var attribute = {
                                                                Name: data.UserAttributes[i].Name,
                                                                Value: data.UserAttributes[i].Value
                                                            };
                                                            var userAttribute = new (0, $kDaVl.default)(attribute);
                                                            attributeList.push(userAttribute);
                                                        }
                                                        var attributes = _this.attributesToObject(attributeList);
                                                        Object.assign(user, {
                                                            attributes: attributes,
                                                            preferredMFA: preferredMFA
                                                        });
                                                        return res(user);
                                                    }, {
                                                        bypassCache: bypassCache,
                                                        clientMetadata: clientMetadata
                                                    });
                                                    else {
                                                        $ba83f3289cc079bd$var$logger.debug("Unable to get the user data because the " + $ba83f3289cc079bd$var$USER_ADMIN_SCOPE + " " + "is not in the scopes of the access token");
                                                        return [
                                                            2 /*return*/ ,
                                                            res(user)
                                                        ];
                                                    }
                                                    return [
                                                        2 /*return*/ 
                                                    ];
                                            }
                                        });
                                    });
                                }, {
                                    clientMetadata: clientMetadata
                                });
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }).catch(function(e) {
                $ba83f3289cc079bd$var$logger.debug('Failed to sync cache info into memory', e);
                return rej(e);
            });
        });
    };
    AuthClass.prototype.isOAuthInProgress = function() {
        return this.oAuthFlowInProgress;
    };
    /**
     * Get current authenticated user
     * @param {CurrentUserOpts} - options for getting the current user
     * @return - A promise resolves to current authenticated CognitoUser if success
     */ AuthClass.prototype.currentAuthenticatedUser = function(params) {
        return $ba83f3289cc079bd$var$__awaiter(this, void 0, void 0, function() {
            var federatedUser, e_5, federatedInfo, user, e_6;
            return $ba83f3289cc079bd$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        $ba83f3289cc079bd$var$logger.debug('getting current authenticated user');
                        federatedUser = null;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._storageSync
                        ];
                    case 2:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_5 = _a.sent();
                        $ba83f3289cc079bd$var$logger.debug('Failed to sync cache info into memory', e_5);
                        throw e_5;
                    case 4:
                        try {
                            federatedInfo = JSON.parse(this._storage.getItem('aws-amplify-federatedInfo'));
                            if (federatedInfo) federatedUser = $ba83f3289cc079bd$var$__assign($ba83f3289cc079bd$var$__assign({}, federatedInfo.user), {
                                token: federatedInfo.token
                            });
                        } catch (e) {
                            $ba83f3289cc079bd$var$logger.debug('cannot load federated user from auth storage');
                        }
                        if (!federatedUser) return [
                            3 /*break*/ ,
                            5
                        ];
                        this.user = federatedUser;
                        $ba83f3289cc079bd$var$logger.debug('get current authenticated federated user', this.user);
                        return [
                            2 /*return*/ ,
                            this.user
                        ];
                    case 5:
                        $ba83f3289cc079bd$var$logger.debug('get current authenticated userpool user');
                        user = null;
                        _a.label = 6;
                    case 6:
                        _a.trys.push([
                            6,
                            8,
                            ,
                            9
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.currentUserPoolUser(params)
                        ];
                    case 7:
                        user = _a.sent();
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 8:
                        e_6 = _a.sent();
                        if (e_6 === 'No userPool') $ba83f3289cc079bd$var$logger.error("Cannot get the current user because the user pool is missing. Please make sure the Auth module is configured with a valid Cognito User Pool ID");
                        $ba83f3289cc079bd$var$logger.debug('The user is not authenticated by the error', e_6);
                        return [
                            2 /*return*/ ,
                            Promise.reject('The user is not authenticated')
                        ];
                    case 9:
                        this.user = user;
                        return [
                            2 /*return*/ ,
                            this.user
                        ];
                }
            });
        });
    };
    /**
     * Get current user's session
     * @return - A promise resolves to session object if success
     */ AuthClass.prototype.currentSession = function() {
        var that = this;
        $ba83f3289cc079bd$var$logger.debug('Getting current session');
        // Purposely not calling the reject method here because we don't need a console error
        if (!this.userPool) return Promise.reject();
        return new Promise(function(res, rej) {
            that.currentUserPoolUser().then(function(user) {
                that.userSession(user).then(function(session) {
                    res(session);
                    return;
                }).catch(function(e) {
                    $ba83f3289cc079bd$var$logger.debug('Failed to get the current session', e);
                    rej(e);
                    return;
                });
            }).catch(function(e) {
                $ba83f3289cc079bd$var$logger.debug('Failed to get the current user', e);
                rej(e);
                return;
            });
        });
    };
    /**
     * Get the corresponding user session
     * @param {Object} user - The CognitoUser object
     * @return - A promise resolves to the session
     */ AuthClass.prototype.userSession = function(user) {
        if (!user) {
            $ba83f3289cc079bd$var$logger.debug('the user is null');
            return this.rejectAuthError((0, $fNaWC.AuthErrorTypes).NoUserSession);
        }
        var clientMetadata = this._config.clientMetadata; // TODO: verify behavior if this is override during signIn
        return new Promise(function(resolve, reject) {
            $ba83f3289cc079bd$var$logger.debug('Getting the session from this user:', user);
            user.getSession(function(err, session) {
                if (err) {
                    $ba83f3289cc079bd$var$logger.debug('Failed to get the session from user', user);
                    reject(err);
                    return;
                } else {
                    $ba83f3289cc079bd$var$logger.debug('Succeed to get the user session', session);
                    resolve(session);
                    return;
                }
            }, {
                clientMetadata: clientMetadata
            });
        });
    };
    /**
     * Get authenticated credentials of current user.
     * @return - A promise resolves to be current user's credentials
     */ AuthClass.prototype.currentUserCredentials = function() {
        return $ba83f3289cc079bd$var$__awaiter(this, void 0, void 0, function() {
            var e_7, federatedInfo;
            var _this = this;
            return $ba83f3289cc079bd$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        $ba83f3289cc079bd$var$logger.debug('Getting current user credentials');
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._storageSync
                        ];
                    case 2:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_7 = _a.sent();
                        $ba83f3289cc079bd$var$logger.debug('Failed to sync cache info into memory', e_7);
                        throw e_7;
                    case 4:
                        federatedInfo = null;
                        try {
                            federatedInfo = JSON.parse(this._storage.getItem('aws-amplify-federatedInfo'));
                        } catch (e) {
                            $ba83f3289cc079bd$var$logger.debug('failed to get or parse item aws-amplify-federatedInfo', e);
                        }
                        if (federatedInfo) // refresh the jwt token here if necessary
                        return [
                            2 /*return*/ ,
                            this.Credentials.refreshFederatedToken(federatedInfo)
                        ];
                        else return [
                            2 /*return*/ ,
                            this.currentSession().then(function(session) {
                                $ba83f3289cc079bd$var$logger.debug('getting session success', session);
                                return _this.Credentials.set(session, 'session');
                            }).catch(function(error) {
                                $ba83f3289cc079bd$var$logger.debug('getting session failed', error);
                                return _this.Credentials.set(null, 'guest');
                            })
                        ];
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AuthClass.prototype.currentCredentials = function() {
        $ba83f3289cc079bd$var$logger.debug('getting current credentials');
        return this.Credentials.get();
    };
    /**
     * Initiate an attribute confirmation request
     * @param {Object} user - The CognitoUser
     * @param {Object} attr - The attributes to be verified
     * @return - A promise resolves to callback data if success
     */ AuthClass.prototype.verifyUserAttribute = function(user, attr, clientMetadata) {
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        return new Promise(function(resolve, reject) {
            user.getAttributeVerificationCode(attr, {
                onSuccess: function() {
                    return resolve();
                },
                onFailure: function(err) {
                    return reject(err);
                }
            }, clientMetadata);
        });
    };
    /**
     * Confirm an attribute using a confirmation code
     * @param {Object} user - The CognitoUser
     * @param {Object} attr - The attribute to be verified
     * @param {String} code - The confirmation code
     * @return - A promise resolves to callback data if success
     */ AuthClass.prototype.verifyUserAttributeSubmit = function(user, attr, code) {
        if (!code) return this.rejectAuthError((0, $fNaWC.AuthErrorTypes).EmptyCode);
        return new Promise(function(resolve, reject) {
            user.verifyAttribute(attr, code, {
                onSuccess: function(data) {
                    resolve(data);
                    return;
                },
                onFailure: function(err) {
                    reject(err);
                    return;
                }
            });
        });
    };
    AuthClass.prototype.verifyCurrentUserAttribute = function(attr) {
        var that = this;
        return that.currentUserPoolUser().then(function(user) {
            return that.verifyUserAttribute(user, attr);
        });
    };
    /**
     * Confirm current user's attribute using a confirmation code
     * @param {Object} attr - The attribute to be verified
     * @param {String} code - The confirmation code
     * @return - A promise resolves to callback data if success
     */ AuthClass.prototype.verifyCurrentUserAttributeSubmit = function(attr, code) {
        var that = this;
        return that.currentUserPoolUser().then(function(user) {
            return that.verifyUserAttributeSubmit(user, attr, code);
        });
    };
    AuthClass.prototype.cognitoIdentitySignOut = function(opts, user) {
        return $ba83f3289cc079bd$var$__awaiter(this, void 0, void 0, function() {
            var e_8, isSignedInHostedUI;
            var _this = this;
            return $ba83f3289cc079bd$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._storageSync
                        ];
                    case 1:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        e_8 = _a.sent();
                        $ba83f3289cc079bd$var$logger.debug('Failed to sync cache info into memory', e_8);
                        throw e_8;
                    case 3:
                        isSignedInHostedUI = this._oAuthHandler && this._storage.getItem('amplify-signin-with-hostedUI') === 'true';
                        return [
                            2 /*return*/ ,
                            new Promise(function(res, rej) {
                                if (opts && opts.global) {
                                    $ba83f3289cc079bd$var$logger.debug('user global sign out', user);
                                    // in order to use global signout
                                    // we must validate the user as an authenticated user by using getSession
                                    var clientMetadata = _this._config.clientMetadata; // TODO: verify behavior if this is override during signIn
                                    user.getSession(function(err, result) {
                                        if (err) {
                                            $ba83f3289cc079bd$var$logger.debug('failed to get the user session', err);
                                            return rej(err);
                                        }
                                        user.globalSignOut({
                                            onSuccess: function(data) {
                                                $ba83f3289cc079bd$var$logger.debug('global sign out success');
                                                if (isSignedInHostedUI) _this.oAuthSignOutRedirect(res, rej);
                                                else return res();
                                            },
                                            onFailure: function(err) {
                                                $ba83f3289cc079bd$var$logger.debug('global sign out failed', err);
                                                return rej(err);
                                            }
                                        });
                                    }, {
                                        clientMetadata: clientMetadata
                                    });
                                } else {
                                    $ba83f3289cc079bd$var$logger.debug('user sign out', user);
                                    user.signOut();
                                    if (isSignedInHostedUI) _this.oAuthSignOutRedirect(res, rej);
                                    else return res();
                                }
                            })
                        ];
                }
            });
        });
    };
    AuthClass.prototype.oAuthSignOutRedirect = function(resolve, reject) {
        var isBrowser = (0, $9Mfkr.JS).browserOrNode().isBrowser;
        if (isBrowser) this.oAuthSignOutRedirectOrReject(reject);
        else this.oAuthSignOutAndResolve(resolve);
    };
    AuthClass.prototype.oAuthSignOutAndResolve = function(resolve) {
        this._oAuthHandler.signOut();
        resolve();
    };
    AuthClass.prototype.oAuthSignOutRedirectOrReject = function(reject) {
        this._oAuthHandler.signOut(); // this method redirects url
        // App should be redirected to another url otherwise it will reject
        setTimeout(function() {
            return reject('Signout timeout fail');
        }, 3000);
    };
    /**
     * Sign out method
     * @
     * @return - A promise resolved if success
     */ AuthClass.prototype.signOut = function(opts) {
        return $ba83f3289cc079bd$var$__awaiter(this, void 0, void 0, function() {
            var e_9, user;
            return $ba83f3289cc079bd$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.cleanCachedItems()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        e_9 = _a.sent();
                        $ba83f3289cc079bd$var$logger.debug('failed to clear cached items');
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 3:
                        if (!this.userPool) return [
                            3 /*break*/ ,
                            7
                        ];
                        user = this.userPool.getCurrentUser();
                        if (!user) return [
                            3 /*break*/ ,
                            5
                        ];
                        return [
                            4 /*yield*/ ,
                            this.cognitoIdentitySignOut(opts, user)
                        ];
                    case 4:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 5:
                        $ba83f3289cc079bd$var$logger.debug('no current Cognito user');
                        _a.label = 6;
                    case 6:
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 7:
                        $ba83f3289cc079bd$var$logger.debug('no Congito User pool');
                        _a.label = 8;
                    case 8:
                        /**
                         * Note for future refactor - no reliable way to get username with
                         * Cognito User Pools vs Identity when federating with Social Providers
                         * This is why we need a well structured session object that can be inspected
                         * and information passed back in the message below for Hub dispatch
                         */ $ba83f3289cc079bd$var$dispatchAuthEvent('signOut', this.user, "A user has been signed out");
                        this.user = null;
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AuthClass.prototype.cleanCachedItems = function() {
        return $ba83f3289cc079bd$var$__awaiter(this, void 0, void 0, function() {
            return $ba83f3289cc079bd$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        // clear cognito cached item
                        return [
                            4 /*yield*/ ,
                            this.Credentials.clear()
                        ];
                    case 1:
                        // clear cognito cached item
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Change a password for an authenticated user
     * @param {Object} user - The CognitoUser object
     * @param {String} oldPassword - the current password
     * @param {String} newPassword - the requested new password
     * @return - A promise resolves if success
     */ AuthClass.prototype.changePassword = function(user, oldPassword, newPassword, clientMetadata) {
        var _this = this;
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        return new Promise(function(resolve, reject) {
            _this.userSession(user).then(function(session) {
                user.changePassword(oldPassword, newPassword, function(err, data) {
                    if (err) {
                        $ba83f3289cc079bd$var$logger.debug('change password failure', err);
                        return reject(err);
                    } else return resolve(data);
                }, clientMetadata);
            });
        });
    };
    /**
     * Initiate a forgot password request
     * @param {String} username - the username to change password
     * @return - A promise resolves if success
     */ AuthClass.prototype.forgotPassword = function(username, clientMetadata) {
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!this.userPool) return this.rejectNoUserPool();
        if (!username) return this.rejectAuthError((0, $fNaWC.AuthErrorTypes).EmptyUsername);
        var user = this.createCognitoUser(username);
        return new Promise(function(resolve, reject) {
            user.forgotPassword({
                onSuccess: function() {
                    resolve();
                    return;
                },
                onFailure: function(err) {
                    $ba83f3289cc079bd$var$logger.debug('forgot password failure', err);
                    $ba83f3289cc079bd$var$dispatchAuthEvent('forgotPassword_failure', err, username + " forgotPassword failed");
                    reject(err);
                    return;
                },
                inputVerificationCode: function(data) {
                    $ba83f3289cc079bd$var$dispatchAuthEvent('forgotPassword', user, username + " has initiated forgot password flow");
                    resolve(data);
                    return;
                }
            }, clientMetadata);
        });
    };
    /**
     * Confirm a new password using a confirmation Code
     * @param {String} username - The username
     * @param {String} code - The confirmation code
     * @param {String} password - The new password
     * @return - A promise that resolves if success
     */ AuthClass.prototype.forgotPasswordSubmit = function(username, code, password, clientMetadata) {
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!this.userPool) return this.rejectNoUserPool();
        if (!username) return this.rejectAuthError((0, $fNaWC.AuthErrorTypes).EmptyUsername);
        if (!code) return this.rejectAuthError((0, $fNaWC.AuthErrorTypes).EmptyCode);
        if (!password) return this.rejectAuthError((0, $fNaWC.AuthErrorTypes).EmptyPassword);
        var user = this.createCognitoUser(username);
        return new Promise(function(resolve, reject) {
            user.confirmPassword(code, password, {
                onSuccess: function() {
                    $ba83f3289cc079bd$var$dispatchAuthEvent('forgotPasswordSubmit', user, username + " forgotPasswordSubmit successful");
                    resolve();
                    return;
                },
                onFailure: function(err) {
                    $ba83f3289cc079bd$var$dispatchAuthEvent('forgotPasswordSubmit_failure', err, username + " forgotPasswordSubmit failed");
                    reject(err);
                    return;
                }
            }, clientMetadata);
        });
    };
    /**
     * Get user information
     * @async
     * @return {Object }- current User's information
     */ AuthClass.prototype.currentUserInfo = function() {
        return $ba83f3289cc079bd$var$__awaiter(this, void 0, void 0, function() {
            var source, user, attributes, userAttrs, credentials, e_10, info, err_1, user;
            return $ba83f3289cc079bd$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        source = this.Credentials.getCredSource();
                        if (!(!source || source === 'aws' || source === 'userPool')) return [
                            3 /*break*/ ,
                            9
                        ];
                        return [
                            4 /*yield*/ ,
                            this.currentUserPoolUser().catch(function(err) {
                                return $ba83f3289cc079bd$var$logger.debug(err);
                            })
                        ];
                    case 1:
                        user = _a.sent();
                        if (!user) return [
                            2 /*return*/ ,
                            null
                        ];
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            8,
                            ,
                            9
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.userAttributes(user)
                        ];
                    case 3:
                        attributes = _a.sent();
                        userAttrs = this.attributesToObject(attributes);
                        credentials = null;
                        _a.label = 4;
                    case 4:
                        _a.trys.push([
                            4,
                            6,
                            ,
                            7
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.currentCredentials()
                        ];
                    case 5:
                        credentials = _a.sent();
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 6:
                        e_10 = _a.sent();
                        $ba83f3289cc079bd$var$logger.debug('Failed to retrieve credentials while getting current user info', e_10);
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 7:
                        info = {
                            id: credentials ? credentials.identityId : undefined,
                            username: user.getUsername(),
                            attributes: userAttrs
                        };
                        return [
                            2 /*return*/ ,
                            info
                        ];
                    case 8:
                        err_1 = _a.sent();
                        $ba83f3289cc079bd$var$logger.debug('currentUserInfo error', err_1);
                        return [
                            2 /*return*/ ,
                            {}
                        ];
                    case 9:
                        if (source === 'federated') {
                            user = this.user;
                            return [
                                2 /*return*/ ,
                                user ? user : {}
                            ];
                        }
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AuthClass.prototype.federatedSignIn = function(providerOrOptions, response, user) {
        return $ba83f3289cc079bd$var$__awaiter(this, void 0, void 0, function() {
            var options, provider, customState, client_id, redirect_uri, provider, loggedInUser, token, identity_id, expires_at, credentials, currentUser;
            return $ba83f3289cc079bd$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this._config.identityPoolId && !this._config.userPoolId) throw new Error("Federation requires either a User Pool or Identity Pool in config");
                        // Ensure backwards compatability
                        if (typeof providerOrOptions === 'undefined') {
                            if (this._config.identityPoolId && !this._config.userPoolId) throw new Error("Federation with Identity Pools requires tokens passed as arguments");
                        }
                        if (!((0, $fNaWC.isFederatedSignInOptions)(providerOrOptions) || (0, $fNaWC.isFederatedSignInOptionsCustom)(providerOrOptions) || (0, $fNaWC.hasCustomState)(providerOrOptions) || typeof providerOrOptions === 'undefined')) return [
                            3 /*break*/ ,
                            1
                        ];
                        options = providerOrOptions || {
                            provider: (0, $fNaWC.CognitoHostedUIIdentityProvider).Cognito
                        };
                        provider = (0, $fNaWC.isFederatedSignInOptions)(options) ? options.provider : options.customProvider;
                        customState = (0, $fNaWC.isFederatedSignInOptions)(options) ? options.customState : options.customState;
                        if (this._config.userPoolId) {
                            client_id = (0, $fNaWC.isCognitoHostedOpts)(this._config.oauth) ? this._config.userPoolWebClientId : this._config.oauth.clientID;
                            redirect_uri = (0, $fNaWC.isCognitoHostedOpts)(this._config.oauth) ? this._config.oauth.redirectSignIn : this._config.oauth.redirectUri;
                            this._oAuthHandler.oauthSignIn(this._config.oauth.responseType, this._config.oauth.domain, redirect_uri, client_id, provider, customState);
                        }
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 1:
                        provider = providerOrOptions;
                        // To check if the user is already logged in
                        try {
                            loggedInUser = JSON.stringify(JSON.parse(this._storage.getItem('aws-amplify-federatedInfo')).user);
                            if (loggedInUser) $ba83f3289cc079bd$var$logger.warn("There is already a signed in user: " + loggedInUser + " in your app.\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tYou should not call Auth.federatedSignIn method again as it may cause unexpected behavior.");
                        } catch (e) {}
                        token = response.token, identity_id = response.identity_id, expires_at = response.expires_at;
                        return [
                            4 /*yield*/ ,
                            this.Credentials.set({
                                provider: provider,
                                token: token,
                                identity_id: identity_id,
                                user: user,
                                expires_at: expires_at
                            }, 'federation')
                        ];
                    case 2:
                        credentials = _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.currentAuthenticatedUser()
                        ];
                    case 3:
                        currentUser = _a.sent();
                        $ba83f3289cc079bd$var$dispatchAuthEvent('signIn', currentUser, "A user " + currentUser.username + " has been signed in");
                        $ba83f3289cc079bd$var$logger.debug('federated sign in credentials', credentials);
                        return [
                            2 /*return*/ ,
                            credentials
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Used to complete the OAuth flow with or without the Cognito Hosted UI
     * @param {String} URL - optional parameter for customers to pass in the response URL
     */ AuthClass.prototype._handleAuthResponse = function(URL) {
        return $ba83f3289cc079bd$var$__awaiter(this, void 0, void 0, function() {
            var currentUrl, hasCodeOrError, hasTokenOrError, _a, accessToken, idToken, refreshToken, state, session, credentials, isCustomStateIncluded, currentUser, customState, err_2;
            return $ba83f3289cc079bd$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (this.oAuthFlowInProgress) {
                            $ba83f3289cc079bd$var$logger.debug("Skipping URL " + URL + " current flow in progress");
                            return [
                                2 /*return*/ 
                            ];
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            ,
                            8,
                            9
                        ]);
                        this.oAuthFlowInProgress = true;
                        if (!this._config.userPoolId) throw new Error("OAuth responses require a User Pool defined in config");
                        $ba83f3289cc079bd$var$dispatchAuthEvent('parsingCallbackUrl', {
                            url: URL
                        }, "The callback url is being parsed");
                        currentUrl = URL || ((0, $9Mfkr.JS).browserOrNode().isBrowser ? window.location.href : '');
                        hasCodeOrError = !!((0, $kcgTr.parse)(currentUrl).query || '').split('&').map(function(entry) {
                            return entry.split('=');
                        }).find(function(_a) {
                            var _b = $ba83f3289cc079bd$var$__read(_a, 1), k = _b[0];
                            return k === 'code' || k === 'error';
                        });
                        hasTokenOrError = !!((0, $kcgTr.parse)(currentUrl).hash || '#').substr(1).split('&').map(function(entry) {
                            return entry.split('=');
                        }).find(function(_a) {
                            var _b = $ba83f3289cc079bd$var$__read(_a, 1), k = _b[0];
                            return k === 'access_token' || k === 'error';
                        });
                        if (!(hasCodeOrError || hasTokenOrError)) return [
                            3 /*break*/ ,
                            7
                        ];
                        this._storage.setItem('amplify-redirected-from-hosted-ui', 'true');
                        _b.label = 2;
                    case 2:
                        _b.trys.push([
                            2,
                            6,
                            ,
                            7
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._oAuthHandler.handleAuthResponse(currentUrl)
                        ];
                    case 3:
                        _a = _b.sent(), accessToken = _a.accessToken, idToken = _a.idToken, refreshToken = _a.refreshToken, state = _a.state;
                        session = new (0, $fVSyU.default)({
                            IdToken: new (0, $erxFS.default)({
                                IdToken: idToken
                            }),
                            RefreshToken: new (0, $4avyf.default)({
                                RefreshToken: refreshToken
                            }),
                            AccessToken: new (0, $5KyOf.default)({
                                AccessToken: accessToken
                            })
                        });
                        credentials = void 0;
                        if (!this._config.identityPoolId) return [
                            3 /*break*/ ,
                            5
                        ];
                        return [
                            4 /*yield*/ ,
                            this.Credentials.set(session, 'session')
                        ];
                    case 4:
                        credentials = _b.sent();
                        $ba83f3289cc079bd$var$logger.debug('AWS credentials', credentials);
                        _b.label = 5;
                    case 5:
                        isCustomStateIncluded = /-/.test(state);
                        currentUser = this.createCognitoUser(session.getIdToken().decodePayload()['cognito:username']);
                        // This calls cacheTokens() in Cognito SDK
                        currentUser.setSignInUserSession(session);
                        if (window && typeof window.history !== 'undefined') window.history.replaceState({}, null, this._config.oauth.redirectSignIn);
                        $ba83f3289cc079bd$var$dispatchAuthEvent('signIn', currentUser, "A user " + currentUser.getUsername() + " has been signed in");
                        $ba83f3289cc079bd$var$dispatchAuthEvent('cognitoHostedUI', currentUser, "A user " + currentUser.getUsername() + " has been signed in via Cognito Hosted UI");
                        if (isCustomStateIncluded) {
                            customState = state.split('-').splice(1).join('-');
                            $ba83f3289cc079bd$var$dispatchAuthEvent('customOAuthState', (0, $7nP18.urlSafeDecode)(customState), "State for user " + currentUser.getUsername());
                        }
                        //#endregion
                        return [
                            2 /*return*/ ,
                            credentials
                        ];
                    case 6:
                        err_2 = _b.sent();
                        $ba83f3289cc079bd$var$logger.debug('Error in cognito hosted auth response', err_2);
                        $ba83f3289cc079bd$var$dispatchAuthEvent('signIn_failure', err_2, "The OAuth response flow failed");
                        $ba83f3289cc079bd$var$dispatchAuthEvent('cognitoHostedUI_failure', err_2, "A failure occurred when returning to the Cognito Hosted UI");
                        $ba83f3289cc079bd$var$dispatchAuthEvent('customState_failure', err_2, "A failure occurred when returning state");
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 7:
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 8:
                        this.oAuthFlowInProgress = false;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 9:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Compact version of credentials
     * @param {Object} credentials
     * @return {Object} - Credentials
     */ AuthClass.prototype.essentialCredentials = function(credentials) {
        return {
            accessKeyId: credentials.accessKeyId,
            sessionToken: credentials.sessionToken,
            secretAccessKey: credentials.secretAccessKey,
            identityId: credentials.identityId,
            authenticated: credentials.authenticated
        };
    };
    AuthClass.prototype.attributesToObject = function(attributes) {
        var _this = this;
        var obj = {};
        if (attributes) attributes.map(function(attribute) {
            if (attribute.Name === 'email_verified' || attribute.Name === 'phone_number_verified') obj[attribute.Name] = _this.isTruthyString(attribute.Value) || attribute.Value === true;
            else obj[attribute.Name] = attribute.Value;
        });
        return obj;
    };
    AuthClass.prototype.isTruthyString = function(value) {
        return typeof value.toLowerCase === 'function' && value.toLowerCase() === 'true';
    };
    AuthClass.prototype.createCognitoUser = function(username) {
        var userData = {
            Username: username,
            Pool: this.userPool
        };
        userData.Storage = this._storage;
        var authenticationFlowType = this._config.authenticationFlowType;
        var user = new (0, $fEY0G.default)(userData);
        if (authenticationFlowType) user.setAuthenticationFlowType(authenticationFlowType);
        return user;
    };
    AuthClass.prototype._isValidAuthStorage = function(obj) {
        // We need to check if the obj has the functions of Storage
        return !!obj && typeof obj.getItem === 'function' && typeof obj.setItem === 'function' && typeof obj.removeItem === 'function' && typeof obj.clear === 'function';
    };
    AuthClass.prototype.noUserPoolErrorHandler = function(config) {
        if (config) {
            if (!config.userPoolId || !config.identityPoolId) return (0, $fNaWC.AuthErrorTypes).MissingAuthConfig;
        }
        return (0, $fNaWC.AuthErrorTypes).NoConfig;
    };
    AuthClass.prototype.rejectAuthError = function(type) {
        return Promise.reject(new (0, $1j1w1.AuthError)(type));
    };
    AuthClass.prototype.rejectNoUserPool = function() {
        var type = this.noUserPoolErrorHandler(this._config);
        return Promise.reject(new (0, $1j1w1.NoUserPoolError)(type));
    };
    return AuthClass;
}();
var $ba83f3289cc079bd$export$334c29725a78c21d = new $ba83f3289cc079bd$export$eeff9d1a8b8c057b(null);
(0, $a16qJ.Amplify).register($ba83f3289cc079bd$export$334c29725a78c21d);

});
parcelRegister("fNaWC", function(module, exports) {

$parcel$export(module.exports, "CognitoHostedUIIdentityProvider", () => $b7f3ebf4b0c94129$export$eeb013770cb92342);
$parcel$export(module.exports, "isFederatedSignInOptions", () => $b7f3ebf4b0c94129$export$9b905d6895bdc426);
$parcel$export(module.exports, "isFederatedSignInOptionsCustom", () => $b7f3ebf4b0c94129$export$828f8efbdf71714b);
$parcel$export(module.exports, "hasCustomState", () => $b7f3ebf4b0c94129$export$6bae5520ca265d22);
$parcel$export(module.exports, "isCognitoHostedOpts", () => $b7f3ebf4b0c94129$export$b380f8ec78ef17c8);
$parcel$export(module.exports, "AuthErrorTypes", () => $b7f3ebf4b0c94129$export$edb367c0a140d3db);
$parcel$export(module.exports, "isUsernamePasswordOpts", () => $b7f3ebf4b0c94129$export$ad34f09783c4cb16);
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ var $b7f3ebf4b0c94129$export$eeb013770cb92342;
(function(CognitoHostedUIIdentityProvider) {
    CognitoHostedUIIdentityProvider["Cognito"] = "COGNITO";
    CognitoHostedUIIdentityProvider["Google"] = "Google";
    CognitoHostedUIIdentityProvider["Facebook"] = "Facebook";
    CognitoHostedUIIdentityProvider["Amazon"] = "LoginWithAmazon";
    CognitoHostedUIIdentityProvider["Apple"] = "SignInWithApple";
})($b7f3ebf4b0c94129$export$eeb013770cb92342 || ($b7f3ebf4b0c94129$export$eeb013770cb92342 = {}));
function $b7f3ebf4b0c94129$export$9b905d6895bdc426(obj) {
    var keys = [
        'provider'
    ];
    return obj && !!keys.find(function(k) {
        return obj.hasOwnProperty(k);
    });
}
function $b7f3ebf4b0c94129$export$828f8efbdf71714b(obj) {
    var keys = [
        'customProvider'
    ];
    return obj && !!keys.find(function(k) {
        return obj.hasOwnProperty(k);
    });
}
function $b7f3ebf4b0c94129$export$6bae5520ca265d22(obj) {
    var keys = [
        'customState'
    ];
    return obj && !!keys.find(function(k) {
        return obj.hasOwnProperty(k);
    });
}
function $b7f3ebf4b0c94129$export$b380f8ec78ef17c8(oauth) {
    return oauth.redirectSignIn !== undefined;
}
var $b7f3ebf4b0c94129$export$edb367c0a140d3db;
(function(AuthErrorTypes) {
    AuthErrorTypes["NoConfig"] = "noConfig";
    AuthErrorTypes["MissingAuthConfig"] = "missingAuthConfig";
    AuthErrorTypes["EmptyUsername"] = "emptyUsername";
    AuthErrorTypes["InvalidUsername"] = "invalidUsername";
    AuthErrorTypes["EmptyPassword"] = "emptyPassword";
    AuthErrorTypes["EmptyCode"] = "emptyCode";
    AuthErrorTypes["SignUpError"] = "signUpError";
    AuthErrorTypes["NoMFA"] = "noMFA";
    AuthErrorTypes["InvalidMFA"] = "invalidMFA";
    AuthErrorTypes["EmptyChallengeResponse"] = "emptyChallengeResponse";
    AuthErrorTypes["NoUserSession"] = "noUserSession";
    AuthErrorTypes["Default"] = "default";
})($b7f3ebf4b0c94129$export$edb367c0a140d3db || ($b7f3ebf4b0c94129$export$edb367c0a140d3db = {}));
function $b7f3ebf4b0c94129$export$ad34f09783c4cb16(obj) {
    return !!obj.username;
}

});

parcelRegister("7R5Xx", function(module, exports) {

$parcel$export(module.exports, "AuthenticationDetails", () => (parcelRequire("dRGMf")).default);
$parcel$export(module.exports, "CognitoAccessToken", () => (parcelRequire("5KyOf")).default);
$parcel$export(module.exports, "CognitoIdToken", () => (parcelRequire("erxFS")).default);
$parcel$export(module.exports, "CognitoRefreshToken", () => (parcelRequire("4avyf")).default);
$parcel$export(module.exports, "CognitoUser", () => (parcelRequire("fEY0G")).default);
$parcel$export(module.exports, "CognitoUserAttribute", () => (parcelRequire("kDaVl")).default);
$parcel$export(module.exports, "CognitoUserPool", () => (parcelRequire("9ZqzK")).default);
$parcel$export(module.exports, "CognitoUserSession", () => (parcelRequire("fVSyU")).default);
$parcel$export(module.exports, "CookieStorage", () => (parcelRequire("lQunR")).default);
$parcel$export(module.exports, "WordArray", () => (parcelRequire("cpmKt")).default);
/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */ 
var $dRGMf = parcelRequire("dRGMf");

var $eLHeA = parcelRequire("eLHeA");

var $5KyOf = parcelRequire("5KyOf");

var $erxFS = parcelRequire("erxFS");

var $4avyf = parcelRequire("4avyf");

var $fEY0G = parcelRequire("fEY0G");

var $kDaVl = parcelRequire("kDaVl");

var $9ZqzK = parcelRequire("9ZqzK");

var $fVSyU = parcelRequire("fVSyU");

var $lQunR = parcelRequire("lQunR");

var $5PlTV = parcelRequire("5PlTV");

var $fntmR = parcelRequire("fntmR");

var $cpmKt = parcelRequire("cpmKt");

});
parcelRegister("dRGMf", function(module, exports) {

$parcel$export(module.exports, "default", () => $a181683feda4814e$export$2e2bcd8739ae039);
/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */ /** @class */ var $a181683feda4814e$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new AuthenticationDetails object
   * @param {object=} data Creation options.
   * @param {string} data.Username User being authenticated.
   * @param {string} data.Password Plain-text password to authenticate with.
   * @param {(AttributeArg[])?} data.ValidationData Application extra metadata.
   * @param {(AttributeArg[])?} data.AuthParamaters Authentication paramaters for custom auth.
   */ function AuthenticationDetails(data) {
        var _ref = data || {}, ValidationData = _ref.ValidationData, Username = _ref.Username, Password = _ref.Password, AuthParameters = _ref.AuthParameters, ClientMetadata = _ref.ClientMetadata;
        this.validationData = ValidationData || {};
        this.authParameters = AuthParameters || {};
        this.clientMetadata = ClientMetadata || {};
        this.username = Username;
        this.password = Password;
    }
    /**
   * @returns {string} the record's username
   */ var _proto = AuthenticationDetails.prototype;
    _proto.getUsername = function getUsername() {
        return this.username;
    };
    _proto.getPassword = function getPassword() {
        return this.password;
    };
    _proto.getValidationData = function getValidationData() {
        return this.validationData;
    };
    _proto.getAuthParameters = function getAuthParameters() {
        return this.authParameters;
    };
    _proto.getClientMetadata = function getClientMetadata() {
        return this.clientMetadata;
    };
    return AuthenticationDetails;
}();

});

parcelRegister("eLHeA", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac06fde609204ad5$export$2e2bcd8739ae039);
/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */ 
var $f6qki = parcelRequire("f6qki");

var $jXGrH = parcelRequire("jXGrH");
parcelRequire("immlP");

var $eCc9K = parcelRequire("eCc9K");

var $9rQ6G = parcelRequire("9rQ6G");

var $cpmKt = parcelRequire("cpmKt");

var $9qeOO = parcelRequire("9qeOO");
/**
 * Returns a Buffer with a sequence of random nBytes
 *
 * @param {number} nBytes
 * @returns {Buffer} fixed-length sequence of random bytes
 */ function $ac06fde609204ad5$var$randomBytes(nBytes) {
    return (0, $f6qki.Buffer).from(new (0, $cpmKt.default)().random(nBytes).toString(), 'hex');
}
/**
 * Tests if a hex string has it most significant bit set (case-insensitive regex)
 */ var $ac06fde609204ad5$var$HEX_MSB_REGEX = /^[89a-f]/i;
var $ac06fde609204ad5$var$initN = "FFFFFFFFFFFFFFFFC90FDAA22168C234C4C6628B80DC1CD129024E088A67CC74020BBEA63B139B22514A08798E3404DDEF9519B3CD3A431B302B0A6DF25F14374FE1356D6D51C245E485B576625E7EC6F44C42E9A637ED6B0BFF5CB6F406B7EDEE386BFB5A899FA5AE9F24117C4B1FE649286651ECE45B3DC2007CB8A163BF0598DA48361C55D39A69163FA8FD24CF5F83655D23DCA3AD961C62F356208552BB9ED529077096966D670C354E4ABC9804F1746C08CA18217C32905E462E36CE3BE39E772C180E86039B2783A2EC07A28FB5C55DF06F4C52C9DE2BCBF6955817183995497CEA956AE515D2261898FA051015728E5A8AAAC42DAD33170D04507A33A85521ABDF1CBA64ECFB850458DBEF0A8AEA71575D060C7DB3970F85A6E1E4C7ABF5AE8CDB0933D71E8C94E04A25619DCEE3D2261AD2EE6BF12FFA06D98A0864D87602733EC86A64521F2B18177B200CBBE117577A615D6C770988C0BAD946E208E24FA074E5AB3143DB5BFCE0FD108E4B82D120A93AD2CAFFFFFFFFFFFFFFFF";
var $ac06fde609204ad5$var$newPasswordRequiredChallengeUserAttributePrefix = 'userAttributes.';
/** @class */ var $ac06fde609204ad5$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new AuthenticationHelper object
   * @param {string} PoolName Cognito user pool name.
   */ function AuthenticationHelper(PoolName) {
        this.N = new (0, $9qeOO.default)($ac06fde609204ad5$var$initN, 16);
        this.g = new (0, $9qeOO.default)('2', 16);
        this.k = new (0, $9qeOO.default)(this.hexHash("" + this.padHex(this.N) + this.padHex(this.g)), 16);
        this.smallAValue = this.generateRandomSmallA();
        this.getLargeAValue(function() {});
        this.infoBits = (0, $f6qki.Buffer).from('Caldera Derived Key', 'utf8');
        this.poolName = PoolName;
    }
    /**
   * @returns {BigInteger} small A, a random number
   */ var _proto = AuthenticationHelper.prototype;
    _proto.getSmallAValue = function getSmallAValue() {
        return this.smallAValue;
    };
    _proto.getLargeAValue = function getLargeAValue(callback) {
        var _this = this;
        if (this.largeAValue) callback(null, this.largeAValue);
        else this.calculateA(this.smallAValue, function(err, largeAValue) {
            if (err) callback(err, null);
            _this.largeAValue = largeAValue;
            callback(null, _this.largeAValue);
        });
    };
    _proto.generateRandomSmallA = function generateRandomSmallA() {
        // This will be interpreted as a postive 128-bit integer
        var hexRandom = $ac06fde609204ad5$var$randomBytes(128).toString('hex');
        var randomBigInt = new (0, $9qeOO.default)(hexRandom, 16); // There is no need to do randomBigInt.mod(this.N - 1) as N (3072-bit) is > 128 bytes (1024-bit)
        return randomBigInt;
    };
    _proto.generateRandomString = function generateRandomString() {
        return $ac06fde609204ad5$var$randomBytes(40).toString('base64');
    };
    _proto.getRandomPassword = function getRandomPassword() {
        return this.randomPassword;
    };
    _proto.getSaltDevices = function getSaltDevices() {
        return this.SaltToHashDevices;
    };
    _proto.getVerifierDevices = function getVerifierDevices() {
        return this.verifierDevices;
    };
    _proto.generateHashDevice = function generateHashDevice(deviceGroupKey, username, callback) {
        var _this2 = this;
        this.randomPassword = this.generateRandomString();
        var combinedString = "" + deviceGroupKey + username + ":" + this.randomPassword;
        var hashedString = this.hash(combinedString);
        var hexRandom = $ac06fde609204ad5$var$randomBytes(16).toString('hex'); // The random hex will be unambiguously represented as a postive integer
        this.SaltToHashDevices = this.padHex(new (0, $9qeOO.default)(hexRandom, 16));
        this.g.modPow(new (0, $9qeOO.default)(this.hexHash(this.SaltToHashDevices + hashedString), 16), this.N, function(err, verifierDevicesNotPadded) {
            if (err) callback(err, null);
            _this2.verifierDevices = _this2.padHex(verifierDevicesNotPadded);
            callback(null, null);
        });
    };
    _proto.calculateA = function calculateA(a, callback) {
        var _this3 = this;
        this.g.modPow(a, this.N, function(err, A) {
            if (err) callback(err, null);
            if (A.mod(_this3.N).equals((0, $9qeOO.default).ZERO)) callback(new Error('Illegal paramater. A mod N cannot be 0.'), null);
            callback(null, A);
        });
    };
    _proto.calculateU = function calculateU(A, B) {
        this.UHexHash = this.hexHash(this.padHex(A) + this.padHex(B));
        var finalU = new (0, $9qeOO.default)(this.UHexHash, 16);
        return finalU;
    };
    _proto.hash = function hash(buf) {
        var str = buf instanceof (0, $f6qki.Buffer) ? (0, (/*@__PURE__*/$parcel$interopDefault($jXGrH))).lib.WordArray.create(buf) : buf;
        var hashHex = (0, (/*@__PURE__*/$parcel$interopDefault($eCc9K)))(str).toString();
        return new Array(64 - hashHex.length).join('0') + hashHex;
    };
    _proto.hexHash = function hexHash(hexStr) {
        return this.hash((0, $f6qki.Buffer).from(hexStr, 'hex'));
    };
    _proto.computehkdf = function computehkdf(ikm, salt) {
        var infoBitsWordArray = (0, (/*@__PURE__*/$parcel$interopDefault($jXGrH))).lib.WordArray.create((0, $f6qki.Buffer).concat([
            this.infoBits,
            (0, $f6qki.Buffer).from(String.fromCharCode(1), 'utf8')
        ]));
        var ikmWordArray = ikm instanceof (0, $f6qki.Buffer) ? (0, (/*@__PURE__*/$parcel$interopDefault($jXGrH))).lib.WordArray.create(ikm) : ikm;
        var saltWordArray = salt instanceof (0, $f6qki.Buffer) ? (0, (/*@__PURE__*/$parcel$interopDefault($jXGrH))).lib.WordArray.create(salt) : salt;
        var prk = (0, (/*@__PURE__*/$parcel$interopDefault($9rQ6G)))(ikmWordArray, saltWordArray);
        var hmac = (0, (/*@__PURE__*/$parcel$interopDefault($9rQ6G)))(infoBitsWordArray, prk);
        return (0, $f6qki.Buffer).from(hmac.toString(), 'hex').slice(0, 16);
    };
    _proto.getPasswordAuthenticationKey = function getPasswordAuthenticationKey(username, password, serverBValue, salt, callback) {
        var _this4 = this;
        if (serverBValue.mod(this.N).equals((0, $9qeOO.default).ZERO)) throw new Error('B cannot be zero.');
        this.UValue = this.calculateU(this.largeAValue, serverBValue);
        if (this.UValue.equals((0, $9qeOO.default).ZERO)) throw new Error('U cannot be zero.');
        var usernamePassword = "" + this.poolName + username + ":" + password;
        var usernamePasswordHash = this.hash(usernamePassword);
        var xValue = new (0, $9qeOO.default)(this.hexHash(this.padHex(salt) + usernamePasswordHash), 16);
        this.calculateS(xValue, serverBValue, function(err, sValue) {
            if (err) callback(err, null);
            var hkdf = _this4.computehkdf((0, $f6qki.Buffer).from(_this4.padHex(sValue), 'hex'), (0, $f6qki.Buffer).from(_this4.padHex(_this4.UValue), 'hex'));
            callback(null, hkdf);
        });
    };
    _proto.calculateS = function calculateS(xValue, serverBValue, callback) {
        var _this5 = this;
        this.g.modPow(xValue, this.N, function(err, gModPowXN) {
            if (err) callback(err, null);
            var intValue2 = serverBValue.subtract(_this5.k.multiply(gModPowXN));
            intValue2.modPow(_this5.smallAValue.add(_this5.UValue.multiply(xValue)), _this5.N, function(err2, result) {
                if (err2) callback(err2, null);
                callback(null, result.mod(_this5.N));
            });
        });
    };
    _proto.getNewPasswordRequiredChallengeUserAttributePrefix = function getNewPasswordRequiredChallengeUserAttributePrefix() {
        return $ac06fde609204ad5$var$newPasswordRequiredChallengeUserAttributePrefix;
    };
    _proto.padHex = function padHex(bigInt) {
        if (!(bigInt instanceof (0, $9qeOO.default))) throw new Error('Not a BigInteger');
        var isNegative = bigInt.compareTo((0, $9qeOO.default).ZERO) < 0;
        /* Get a hex string for abs(bigInt) */ var hexStr = bigInt.abs().toString(16);
        /* Pad hex to even length if needed */ hexStr = hexStr.length % 2 !== 0 ? "0" + hexStr : hexStr;
        /* Prepend "00" if the most significant bit is set */ hexStr = $ac06fde609204ad5$var$HEX_MSB_REGEX.test(hexStr) ? "00" + hexStr : hexStr;
        if (isNegative) {
            /* Flip the bits of the representation */ var invertedNibbles = hexStr.split('').map(function(x) {
                var invertedNibble = ~parseInt(x, 16) & 0xf;
                return '0123456789ABCDEF'.charAt(invertedNibble);
            }).join('');
            /* After flipping the bits, add one to get the 2's complement representation */ var flippedBitsBI = new (0, $9qeOO.default)(invertedNibbles, 16).add((0, $9qeOO.default).ONE);
            hexStr = flippedBitsBI.toString(16);
            /*
      For hex strings starting with 'FF8', 'FF' can be dropped, e.g. 0xFFFF80=0xFF80=0x80=-128
      		Any sequence of '1' bits on the left can always be substituted with a single '1' bit
      without changing the represented value.
      		This only happens in the case when the input is 80...00
      */ if (hexStr.toUpperCase().startsWith('FF8')) hexStr = hexStr.substring(2);
        }
        return hexStr;
    };
    return AuthenticationHelper;
}();

});
parcelRegister("f6qki", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $afebd66cc91f60fa$export$a143d493d941bafc, (v) => $afebd66cc91f60fa$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $afebd66cc91f60fa$export$f99ded8fe4b79145, (v) => $afebd66cc91f60fa$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $afebd66cc91f60fa$export$a143d493d941bafc;
var $afebd66cc91f60fa$export$e4cf37d7f6fb9e0a;
var $afebd66cc91f60fa$export$f99ded8fe4b79145;
/*
 * Export kMaxLength after typed array support is determined.
 */ var $afebd66cc91f60fa$export$599f31c3813fae4d;
'use strict';

var $16jlG = parcelRequire("16jlG");

var $aSYRj = parcelRequire("aSYRj");

var $1mmrd = parcelRequire("1mmrd");
$afebd66cc91f60fa$export$a143d493d941bafc = $afebd66cc91f60fa$var$Buffer;
$afebd66cc91f60fa$export$e4cf37d7f6fb9e0a = $afebd66cc91f60fa$var$SlowBuffer;
$afebd66cc91f60fa$export$f99ded8fe4b79145 = 50;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */ $afebd66cc91f60fa$var$Buffer.TYPED_ARRAY_SUPPORT = $parcel$global.TYPED_ARRAY_SUPPORT !== undefined ? $parcel$global.TYPED_ARRAY_SUPPORT : $afebd66cc91f60fa$var$typedArraySupport();
$afebd66cc91f60fa$export$599f31c3813fae4d = $afebd66cc91f60fa$var$kMaxLength();
function $afebd66cc91f60fa$var$typedArraySupport() {
    try {
        var arr = new Uint8Array(1);
        arr.__proto__ = {
            __proto__: Uint8Array.prototype,
            foo: function() {
                return 42;
            }
        };
        return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
        ;
    } catch (e) {
        return false;
    }
}
function $afebd66cc91f60fa$var$kMaxLength() {
    return $afebd66cc91f60fa$var$Buffer.TYPED_ARRAY_SUPPORT ? 0x7fffffff : 0x3fffffff;
}
function $afebd66cc91f60fa$var$createBuffer(that, length) {
    if ($afebd66cc91f60fa$var$kMaxLength() < length) throw new RangeError('Invalid typed array length');
    if ($afebd66cc91f60fa$var$Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = new Uint8Array(length);
        that.__proto__ = $afebd66cc91f60fa$var$Buffer.prototype;
    } else {
        // Fallback: Return an object instance of the Buffer class
        if (that === null) that = new $afebd66cc91f60fa$var$Buffer(length);
        that.length = length;
    }
    return that;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $afebd66cc91f60fa$var$Buffer(arg, encodingOrOffset, length) {
    if (!$afebd66cc91f60fa$var$Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof $afebd66cc91f60fa$var$Buffer)) return new $afebd66cc91f60fa$var$Buffer(arg, encodingOrOffset, length);
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new Error('If encoding is specified then the first argument must be a string');
        return $afebd66cc91f60fa$var$allocUnsafe(this, arg);
    }
    return $afebd66cc91f60fa$var$from(this, arg, encodingOrOffset, length);
}
$afebd66cc91f60fa$var$Buffer.poolSize = 8192 // not used by this implementation
;
// TODO: Legacy, not needed anymore. Remove in next major version.
$afebd66cc91f60fa$var$Buffer._augment = function(arr) {
    arr.__proto__ = $afebd66cc91f60fa$var$Buffer.prototype;
    return arr;
};
function $afebd66cc91f60fa$var$from(that, value, encodingOrOffset, length) {
    if (typeof value === 'number') throw new TypeError('"value" argument must not be a number');
    if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) return $afebd66cc91f60fa$var$fromArrayBuffer(that, value, encodingOrOffset, length);
    if (typeof value === 'string') return $afebd66cc91f60fa$var$fromString(that, value, encodingOrOffset);
    return $afebd66cc91f60fa$var$fromObject(that, value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $afebd66cc91f60fa$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $afebd66cc91f60fa$var$from(null, value, encodingOrOffset, length);
};
if ($afebd66cc91f60fa$var$Buffer.TYPED_ARRAY_SUPPORT) {
    $afebd66cc91f60fa$var$Buffer.prototype.__proto__ = Uint8Array.prototype;
    $afebd66cc91f60fa$var$Buffer.__proto__ = Uint8Array;
    if (typeof Symbol !== 'undefined' && Symbol.species && $afebd66cc91f60fa$var$Buffer[Symbol.species] === $afebd66cc91f60fa$var$Buffer) // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty($afebd66cc91f60fa$var$Buffer, Symbol.species, {
        value: null,
        configurable: true
    });
}
function $afebd66cc91f60fa$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be a number');
    else if (size < 0) throw new RangeError('"size" argument must not be negative');
}
function $afebd66cc91f60fa$var$alloc(that, size, fill, encoding) {
    $afebd66cc91f60fa$var$assertSize(size);
    if (size <= 0) return $afebd66cc91f60fa$var$createBuffer(that, size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string' ? $afebd66cc91f60fa$var$createBuffer(that, size).fill(fill, encoding) : $afebd66cc91f60fa$var$createBuffer(that, size).fill(fill);
    return $afebd66cc91f60fa$var$createBuffer(that, size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $afebd66cc91f60fa$var$Buffer.alloc = function(size, fill, encoding) {
    return $afebd66cc91f60fa$var$alloc(null, size, fill, encoding);
};
function $afebd66cc91f60fa$var$allocUnsafe(that, size) {
    $afebd66cc91f60fa$var$assertSize(size);
    that = $afebd66cc91f60fa$var$createBuffer(that, size < 0 ? 0 : $afebd66cc91f60fa$var$checked(size) | 0);
    if (!$afebd66cc91f60fa$var$Buffer.TYPED_ARRAY_SUPPORT) for(var i = 0; i < size; ++i)that[i] = 0;
    return that;
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $afebd66cc91f60fa$var$Buffer.allocUnsafe = function(size) {
    return $afebd66cc91f60fa$var$allocUnsafe(null, size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $afebd66cc91f60fa$var$Buffer.allocUnsafeSlow = function(size) {
    return $afebd66cc91f60fa$var$allocUnsafe(null, size);
};
function $afebd66cc91f60fa$var$fromString(that, string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$afebd66cc91f60fa$var$Buffer.isEncoding(encoding)) throw new TypeError('"encoding" must be a valid string encoding');
    var length = $afebd66cc91f60fa$var$byteLength(string, encoding) | 0;
    that = $afebd66cc91f60fa$var$createBuffer(that, length);
    var actual = that.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual);
    return that;
}
function $afebd66cc91f60fa$var$fromArrayLike(that, array) {
    var length = array.length < 0 ? 0 : $afebd66cc91f60fa$var$checked(array.length) | 0;
    that = $afebd66cc91f60fa$var$createBuffer(that, length);
    for(var i = 0; i < length; i += 1)that[i] = array[i] & 255;
    return that;
}
function $afebd66cc91f60fa$var$fromArrayBuffer(that, array, byteOffset, length) {
    array.byteLength // this throws if `array` is not a valid ArrayBuffer
    ;
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('\'offset\' is out of bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('\'length\' is out of bounds');
    if (byteOffset === undefined && length === undefined) array = new Uint8Array(array);
    else if (length === undefined) array = new Uint8Array(array, byteOffset);
    else array = new Uint8Array(array, byteOffset, length);
    if ($afebd66cc91f60fa$var$Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = array;
        that.__proto__ = $afebd66cc91f60fa$var$Buffer.prototype;
    } else // Fallback: Return an object instance of the Buffer class
    that = $afebd66cc91f60fa$var$fromArrayLike(that, array);
    return that;
}
function $afebd66cc91f60fa$var$fromObject(that, obj) {
    if ($afebd66cc91f60fa$var$Buffer.isBuffer(obj)) {
        var len = $afebd66cc91f60fa$var$checked(obj.length) | 0;
        that = $afebd66cc91f60fa$var$createBuffer(that, len);
        if (that.length === 0) return that;
        obj.copy(that, 0, 0, len);
        return that;
    }
    if (obj) {
        if (typeof ArrayBuffer !== 'undefined' && obj.buffer instanceof ArrayBuffer || 'length' in obj) {
            if (typeof obj.length !== 'number' || $afebd66cc91f60fa$var$isnan(obj.length)) return $afebd66cc91f60fa$var$createBuffer(that, 0);
            return $afebd66cc91f60fa$var$fromArrayLike(that, obj);
        }
        if (obj.type === 'Buffer' && $1mmrd(obj.data)) return $afebd66cc91f60fa$var$fromArrayLike(that, obj.data);
    }
    throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.');
}
function $afebd66cc91f60fa$var$checked(length) {
    // Note: cannot use `length < kMaxLength()` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $afebd66cc91f60fa$var$kMaxLength()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $afebd66cc91f60fa$var$kMaxLength().toString(16) + ' bytes');
    return length | 0;
}
function $afebd66cc91f60fa$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $afebd66cc91f60fa$var$Buffer.alloc(+length);
}
$afebd66cc91f60fa$var$Buffer.isBuffer = function isBuffer(b) {
    return !!(b != null && b._isBuffer);
};
$afebd66cc91f60fa$var$Buffer.compare = function compare(a, b) {
    if (!$afebd66cc91f60fa$var$Buffer.isBuffer(a) || !$afebd66cc91f60fa$var$Buffer.isBuffer(b)) throw new TypeError('Arguments must be Buffers');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$afebd66cc91f60fa$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$afebd66cc91f60fa$var$Buffer.concat = function concat(list, length) {
    if (!$1mmrd(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $afebd66cc91f60fa$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $afebd66cc91f60fa$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if (!$afebd66cc91f60fa$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $afebd66cc91f60fa$var$byteLength(string, encoding) {
    if ($afebd66cc91f60fa$var$Buffer.isBuffer(string)) return string.length;
    if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' && (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') string = '' + string;
    var len = string.length;
    if (len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
        case undefined:
            return $afebd66cc91f60fa$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $afebd66cc91f60fa$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return $afebd66cc91f60fa$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$afebd66cc91f60fa$var$Buffer.byteLength = $afebd66cc91f60fa$var$byteLength;
function $afebd66cc91f60fa$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $afebd66cc91f60fa$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $afebd66cc91f60fa$var$utf8Slice(this, start, end);
        case 'ascii':
            return $afebd66cc91f60fa$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $afebd66cc91f60fa$var$latin1Slice(this, start, end);
        case 'base64':
            return $afebd66cc91f60fa$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $afebd66cc91f60fa$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
$afebd66cc91f60fa$var$Buffer.prototype._isBuffer = true;
function $afebd66cc91f60fa$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$afebd66cc91f60fa$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$afebd66cc91f60fa$var$swap(this, i, i + 1);
    return this;
};
$afebd66cc91f60fa$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $afebd66cc91f60fa$var$swap(this, i, i + 3);
        $afebd66cc91f60fa$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$afebd66cc91f60fa$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $afebd66cc91f60fa$var$swap(this, i, i + 7);
        $afebd66cc91f60fa$var$swap(this, i + 1, i + 6);
        $afebd66cc91f60fa$var$swap(this, i + 2, i + 5);
        $afebd66cc91f60fa$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$afebd66cc91f60fa$var$Buffer.prototype.toString = function toString() {
    var length = this.length | 0;
    if (length === 0) return '';
    if (arguments.length === 0) return $afebd66cc91f60fa$var$utf8Slice(this, 0, length);
    return $afebd66cc91f60fa$var$slowToString.apply(this, arguments);
};
$afebd66cc91f60fa$var$Buffer.prototype.equals = function equals(b) {
    if (!$afebd66cc91f60fa$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $afebd66cc91f60fa$var$Buffer.compare(this, b) === 0;
};
$afebd66cc91f60fa$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $afebd66cc91f60fa$export$f99ded8fe4b79145;
    if (this.length > 0) {
        str = this.toString('hex', 0, max).match(/.{2}/g).join(' ');
        if (this.length > max) str += ' ... ';
    }
    return '<Buffer ' + str + '>';
};
$afebd66cc91f60fa$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (!$afebd66cc91f60fa$var$Buffer.isBuffer(target)) throw new TypeError('Argument must be a Buffer');
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $afebd66cc91f60fa$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if (isNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $afebd66cc91f60fa$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($afebd66cc91f60fa$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $afebd66cc91f60fa$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if ($afebd66cc91f60fa$var$Buffer.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $afebd66cc91f60fa$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $afebd66cc91f60fa$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$afebd66cc91f60fa$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$afebd66cc91f60fa$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $afebd66cc91f60fa$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$afebd66cc91f60fa$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $afebd66cc91f60fa$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $afebd66cc91f60fa$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    // must be an even number of digits
    var strLen = string.length;
    if (strLen % 2 !== 0) throw new TypeError('Invalid hex string');
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if (isNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $afebd66cc91f60fa$var$utf8Write(buf, string, offset, length) {
    return $afebd66cc91f60fa$var$blitBuffer($afebd66cc91f60fa$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $afebd66cc91f60fa$var$asciiWrite(buf, string, offset, length) {
    return $afebd66cc91f60fa$var$blitBuffer($afebd66cc91f60fa$var$asciiToBytes(string), buf, offset, length);
}
function $afebd66cc91f60fa$var$latin1Write(buf, string, offset, length) {
    return $afebd66cc91f60fa$var$asciiWrite(buf, string, offset, length);
}
function $afebd66cc91f60fa$var$base64Write(buf, string, offset, length) {
    return $afebd66cc91f60fa$var$blitBuffer($afebd66cc91f60fa$var$base64ToBytes(string), buf, offset, length);
}
function $afebd66cc91f60fa$var$ucs2Write(buf, string, offset, length) {
    return $afebd66cc91f60fa$var$blitBuffer($afebd66cc91f60fa$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$afebd66cc91f60fa$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset | 0;
        if (isFinite(length)) {
            length = length | 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    // legacy write(string, encoding, offset, length) - remove in v0.13
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $afebd66cc91f60fa$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $afebd66cc91f60fa$var$utf8Write(this, string, offset, length);
        case 'ascii':
            return $afebd66cc91f60fa$var$asciiWrite(this, string, offset, length);
        case 'latin1':
        case 'binary':
            return $afebd66cc91f60fa$var$latin1Write(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $afebd66cc91f60fa$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $afebd66cc91f60fa$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$afebd66cc91f60fa$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $afebd66cc91f60fa$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $16jlG.fromByteArray(buf);
    else return $16jlG.fromByteArray(buf.slice(start, end));
}
function $afebd66cc91f60fa$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $afebd66cc91f60fa$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $afebd66cc91f60fa$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $afebd66cc91f60fa$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $afebd66cc91f60fa$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $afebd66cc91f60fa$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $afebd66cc91f60fa$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $afebd66cc91f60fa$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $afebd66cc91f60fa$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $afebd66cc91f60fa$var$toHex(buf[i]);
    return out;
}
function $afebd66cc91f60fa$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    for(var i = 0; i < bytes.length; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$afebd66cc91f60fa$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf;
    if ($afebd66cc91f60fa$var$Buffer.TYPED_ARRAY_SUPPORT) {
        newBuf = this.subarray(start, end);
        newBuf.__proto__ = $afebd66cc91f60fa$var$Buffer.prototype;
    } else {
        var sliceLen = end - start;
        newBuf = new $afebd66cc91f60fa$var$Buffer(sliceLen, undefined);
        for(var i = 0; i < sliceLen; ++i)newBuf[i] = this[i + start];
    }
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $afebd66cc91f60fa$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$afebd66cc91f60fa$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $afebd66cc91f60fa$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$afebd66cc91f60fa$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $afebd66cc91f60fa$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$afebd66cc91f60fa$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    if (!noAssert) $afebd66cc91f60fa$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$afebd66cc91f60fa$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    if (!noAssert) $afebd66cc91f60fa$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$afebd66cc91f60fa$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    if (!noAssert) $afebd66cc91f60fa$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$afebd66cc91f60fa$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    if (!noAssert) $afebd66cc91f60fa$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$afebd66cc91f60fa$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    if (!noAssert) $afebd66cc91f60fa$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$afebd66cc91f60fa$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $afebd66cc91f60fa$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$afebd66cc91f60fa$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $afebd66cc91f60fa$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$afebd66cc91f60fa$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    if (!noAssert) $afebd66cc91f60fa$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$afebd66cc91f60fa$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    if (!noAssert) $afebd66cc91f60fa$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$afebd66cc91f60fa$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    if (!noAssert) $afebd66cc91f60fa$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$afebd66cc91f60fa$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    if (!noAssert) $afebd66cc91f60fa$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$afebd66cc91f60fa$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    if (!noAssert) $afebd66cc91f60fa$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$afebd66cc91f60fa$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    if (!noAssert) $afebd66cc91f60fa$var$checkOffset(offset, 4, this.length);
    return $aSYRj.read(this, offset, true, 23, 4);
};
$afebd66cc91f60fa$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    if (!noAssert) $afebd66cc91f60fa$var$checkOffset(offset, 4, this.length);
    return $aSYRj.read(this, offset, false, 23, 4);
};
$afebd66cc91f60fa$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    if (!noAssert) $afebd66cc91f60fa$var$checkOffset(offset, 8, this.length);
    return $aSYRj.read(this, offset, true, 52, 8);
};
$afebd66cc91f60fa$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    if (!noAssert) $afebd66cc91f60fa$var$checkOffset(offset, 8, this.length);
    return $aSYRj.read(this, offset, false, 52, 8);
};
function $afebd66cc91f60fa$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$afebd66cc91f60fa$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$afebd66cc91f60fa$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $afebd66cc91f60fa$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$afebd66cc91f60fa$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $afebd66cc91f60fa$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$afebd66cc91f60fa$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $afebd66cc91f60fa$var$checkInt(this, value, offset, 1, 0xff, 0);
    if (!$afebd66cc91f60fa$var$Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    this[offset] = value & 0xff;
    return offset + 1;
};
function $afebd66cc91f60fa$var$objectWriteUInt16(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i)buf[offset + i] = (value & 0xff << 8 * (littleEndian ? i : 1 - i)) >>> (littleEndian ? i : 1 - i) * 8;
}
$afebd66cc91f60fa$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $afebd66cc91f60fa$var$checkInt(this, value, offset, 2, 0xffff, 0);
    if ($afebd66cc91f60fa$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else $afebd66cc91f60fa$var$objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
$afebd66cc91f60fa$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $afebd66cc91f60fa$var$checkInt(this, value, offset, 2, 0xffff, 0);
    if ($afebd66cc91f60fa$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else $afebd66cc91f60fa$var$objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
function $afebd66cc91f60fa$var$objectWriteUInt32(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffffffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i)buf[offset + i] = value >>> (littleEndian ? i : 3 - i) * 8 & 0xff;
}
$afebd66cc91f60fa$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $afebd66cc91f60fa$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    if ($afebd66cc91f60fa$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset + 3] = value >>> 24;
        this[offset + 2] = value >>> 16;
        this[offset + 1] = value >>> 8;
        this[offset] = value & 0xff;
    } else $afebd66cc91f60fa$var$objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
$afebd66cc91f60fa$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $afebd66cc91f60fa$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    if ($afebd66cc91f60fa$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else $afebd66cc91f60fa$var$objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
$afebd66cc91f60fa$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $afebd66cc91f60fa$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$afebd66cc91f60fa$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $afebd66cc91f60fa$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$afebd66cc91f60fa$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $afebd66cc91f60fa$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (!$afebd66cc91f60fa$var$Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$afebd66cc91f60fa$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $afebd66cc91f60fa$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    if ($afebd66cc91f60fa$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else $afebd66cc91f60fa$var$objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
$afebd66cc91f60fa$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $afebd66cc91f60fa$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    if ($afebd66cc91f60fa$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else $afebd66cc91f60fa$var$objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
$afebd66cc91f60fa$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $afebd66cc91f60fa$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if ($afebd66cc91f60fa$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
        this[offset + 2] = value >>> 16;
        this[offset + 3] = value >>> 24;
    } else $afebd66cc91f60fa$var$objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
$afebd66cc91f60fa$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $afebd66cc91f60fa$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    if ($afebd66cc91f60fa$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else $afebd66cc91f60fa$var$objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
function $afebd66cc91f60fa$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $afebd66cc91f60fa$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) $afebd66cc91f60fa$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $aSYRj.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$afebd66cc91f60fa$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $afebd66cc91f60fa$var$writeFloat(this, value, offset, true, noAssert);
};
$afebd66cc91f60fa$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $afebd66cc91f60fa$var$writeFloat(this, value, offset, false, noAssert);
};
function $afebd66cc91f60fa$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) $afebd66cc91f60fa$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $aSYRj.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$afebd66cc91f60fa$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $afebd66cc91f60fa$var$writeDouble(this, value, offset, true, noAssert);
};
$afebd66cc91f60fa$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $afebd66cc91f60fa$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$afebd66cc91f60fa$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    var i;
    if (this === target && start < targetStart && targetStart < end) // descending copy from end
    for(i = len - 1; i >= 0; --i)target[i + targetStart] = this[i + start];
    else if (len < 1000 || !$afebd66cc91f60fa$var$Buffer.TYPED_ARRAY_SUPPORT) // ascending copy from start
    for(i = 0; i < len; ++i)target[i + targetStart] = this[i + start];
    else Uint8Array.prototype.set.call(target, this.subarray(start, start + len), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$afebd66cc91f60fa$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (code < 256) val = code;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$afebd66cc91f60fa$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    } else if (typeof val === 'number') val = val & 255;
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $afebd66cc91f60fa$var$Buffer.isBuffer(val) ? val : $afebd66cc91f60fa$var$utf8ToBytes(new $afebd66cc91f60fa$var$Buffer(val, encoding).toString());
        var len = bytes.length;
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $afebd66cc91f60fa$var$INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;
function $afebd66cc91f60fa$var$base64clean(str) {
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = $afebd66cc91f60fa$var$stringtrim(str).replace($afebd66cc91f60fa$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $afebd66cc91f60fa$var$stringtrim(str) {
    if (str.trim) return str.trim();
    return str.replace(/^\s+|\s+$/g, '');
}
function $afebd66cc91f60fa$var$toHex(n) {
    if (n < 16) return '0' + n.toString(16);
    return n.toString(16);
}
function $afebd66cc91f60fa$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $afebd66cc91f60fa$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $afebd66cc91f60fa$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $afebd66cc91f60fa$var$base64ToBytes(str) {
    return $16jlG.toByteArray($afebd66cc91f60fa$var$base64clean(str));
}
function $afebd66cc91f60fa$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
function $afebd66cc91f60fa$var$isnan(val) {
    return val !== val // eslint-disable-line no-self-compare
    ;
}

});
parcelRegister("1mmrd", function(module, exports) {
var $0fd94040cac8319f$var$toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return $0fd94040cac8319f$var$toString.call(arr) == '[object Array]';
};

});


parcelRegister("jXGrH", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory();
})(this, function() {
    /*globals window, global, require*/ /**
	 * CryptoJS core components.
	 */ var CryptoJS = CryptoJS || function(Math1, undefined) {
        var crypto;
        // Native crypto from window (Browser)
        if (typeof window !== 'undefined' && window.crypto) crypto = window.crypto;
        // Native crypto in web worker (Browser)
        if (typeof self !== 'undefined' && self.crypto) crypto = self.crypto;
        // Native crypto from worker
        if (typeof globalThis !== 'undefined' && globalThis.crypto) crypto = globalThis.crypto;
        // Native (experimental IE 11) crypto from window (Browser)
        if (!crypto && typeof window !== 'undefined' && window.msCrypto) crypto = window.msCrypto;
        // Native crypto from global (NodeJS)
        if (!crypto && typeof $parcel$global !== 'undefined' && $parcel$global.crypto) crypto = $parcel$global.crypto;
        // Native crypto import via require (NodeJS)
        if (!crypto && true) try {
            crypto = (parcelRequire("1r8ZG"));
        } catch (err) {}
        /*
	     * Cryptographically secure pseudorandom number generator
	     *
	     * As Math.random() is cryptographically not safe to use
	     */ var cryptoSecureRandomInt = function() {
            if (crypto) {
                // Use getRandomValues method (Browser)
                if (typeof crypto.getRandomValues === 'function') try {
                    return crypto.getRandomValues(new Uint32Array(1))[0];
                } catch (err) {}
                // Use randomBytes method (NodeJS)
                if (typeof crypto.randomBytes === 'function') try {
                    return crypto.randomBytes(4).readInt32LE();
                } catch (err) {}
            }
            throw new Error('Native crypto module could not be used to get secure random number.');
        };
        /*
	     * Local polyfill of Object.create

	     */ var create = Object.create || function() {
            function F() {}
            return function(obj) {
                var subtype;
                F.prototype = obj;
                subtype = new F();
                F.prototype = null;
                return subtype;
            };
        }();
        /**
	     * CryptoJS namespace.
	     */ var C = {};
        /**
	     * Library namespace.
	     */ var C_lib = C.lib = {};
        /**
	     * Base object for prototypal inheritance.
	     */ var Base = C_lib.Base = function() {
            return {
                /**
	             * Creates a new object that inherits from this object.
	             *
	             * @param {Object} overrides Properties to copy into the new object.
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         field: 'value',
	             *
	             *         method: function () {
	             *         }
	             *     });
	             */ extend: function(overrides) {
                    // Spawn
                    var subtype = create(this);
                    // Augment
                    if (overrides) subtype.mixIn(overrides);
                    // Create default initializer
                    if (!subtype.hasOwnProperty('init') || this.init === subtype.init) subtype.init = function() {
                        subtype.$super.init.apply(this, arguments);
                    };
                    // Initializer's prototype is the subtype object
                    subtype.init.prototype = subtype;
                    // Reference supertype
                    subtype.$super = this;
                    return subtype;
                },
                /**
	             * Extends this object and runs the init method.
	             * Arguments to create() will be passed to init().
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var instance = MyType.create();
	             */ create: function() {
                    var instance = this.extend();
                    instance.init.apply(instance, arguments);
                    return instance;
                },
                /**
	             * Initializes a newly created object.
	             * Override this method to add some logic when your objects are created.
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         init: function () {
	             *             // ...
	             *         }
	             *     });
	             */ init: function() {},
                /**
	             * Copies properties into this object.
	             *
	             * @param {Object} properties The properties to mix in.
	             *
	             * @example
	             *
	             *     MyType.mixIn({
	             *         field: 'value'
	             *     });
	             */ mixIn: function(properties) {
                    for(var propertyName in properties)if (properties.hasOwnProperty(propertyName)) this[propertyName] = properties[propertyName];
                    // IE won't copy toString using the loop above
                    if (properties.hasOwnProperty('toString')) this.toString = properties.toString;
                },
                /**
	             * Creates a copy of this object.
	             *
	             * @return {Object} The clone.
	             *
	             * @example
	             *
	             *     var clone = instance.clone();
	             */ clone: function() {
                    return this.init.prototype.extend(this);
                }
            };
        }();
        /**
	     * An array of 32-bit words.
	     *
	     * @property {Array} words The array of 32-bit words.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */ var WordArray = C_lib.WordArray = Base.extend({
            /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of 32-bit words.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.create();
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	         */ init: function(words, sigBytes) {
                words = this.words = words || [];
                if (sigBytes != undefined) this.sigBytes = sigBytes;
                else this.sigBytes = words.length * 4;
            },
            /**
	         * Converts this word array to a string.
	         *
	         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	         *
	         * @return {string} The stringified word array.
	         *
	         * @example
	         *
	         *     var string = wordArray + '';
	         *     var string = wordArray.toString();
	         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	         */ toString: function(encoder) {
                return (encoder || Hex).stringify(this);
            },
            /**
	         * Concatenates a word array to this word array.
	         *
	         * @param {WordArray} wordArray The word array to append.
	         *
	         * @return {WordArray} This word array.
	         *
	         * @example
	         *
	         *     wordArray1.concat(wordArray2);
	         */ concat: function(wordArray) {
                // Shortcuts
                var thisWords = this.words;
                var thatWords = wordArray.words;
                var thisSigBytes = this.sigBytes;
                var thatSigBytes = wordArray.sigBytes;
                // Clamp excess bits
                this.clamp();
                // Concat
                if (thisSigBytes % 4) // Copy one byte at a time
                for(var i = 0; i < thatSigBytes; i++){
                    var thatByte = thatWords[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    thisWords[thisSigBytes + i >>> 2] |= thatByte << 24 - (thisSigBytes + i) % 4 * 8;
                }
                else // Copy one word at a time
                for(var j = 0; j < thatSigBytes; j += 4)thisWords[thisSigBytes + j >>> 2] = thatWords[j >>> 2];
                this.sigBytes += thatSigBytes;
                // Chainable
                return this;
            },
            /**
	         * Removes insignificant bits.
	         *
	         * @example
	         *
	         *     wordArray.clamp();
	         */ clamp: function() {
                // Shortcuts
                var words = this.words;
                var sigBytes = this.sigBytes;
                // Clamp
                words[sigBytes >>> 2] &= 0xffffffff << 32 - sigBytes % 4 * 8;
                words.length = Math1.ceil(sigBytes / 4);
            },
            /**
	         * Creates a copy of this word array.
	         *
	         * @return {WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = wordArray.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                clone.words = this.words.slice(0);
                return clone;
            },
            /**
	         * Creates a word array filled with random bytes.
	         *
	         * @param {number} nBytes The number of random bytes to generate.
	         *
	         * @return {WordArray} The random word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.random(16);
	         */ random: function(nBytes) {
                var words = [];
                for(var i = 0; i < nBytes; i += 4)words.push(cryptoSecureRandomInt());
                return new WordArray.init(words, nBytes);
            }
        });
        /**
	     * Encoder namespace.
	     */ var C_enc = C.enc = {};
        /**
	     * Hex encoding strategy.
	     */ var Hex = C_enc.Hex = {
            /**
	         * Converts a word array to a hex string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The hex string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var hexChars = [];
                for(var i = 0; i < sigBytes; i++){
                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    hexChars.push((bite >>> 4).toString(16));
                    hexChars.push((bite & 0x0f).toString(16));
                }
                return hexChars.join('');
            },
            /**
	         * Converts a hex string to a word array.
	         *
	         * @param {string} hexStr The hex string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	         */ parse: function(hexStr) {
                // Shortcut
                var hexStrLength = hexStr.length;
                // Convert
                var words = [];
                for(var i = 0; i < hexStrLength; i += 2)words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << 24 - i % 8 * 4;
                return new WordArray.init(words, hexStrLength / 2);
            }
        };
        /**
	     * Latin1 encoding strategy.
	     */ var Latin1 = C_enc.Latin1 = {
            /**
	         * Converts a word array to a Latin1 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Latin1 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var latin1Chars = [];
                for(var i = 0; i < sigBytes; i++){
                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    latin1Chars.push(String.fromCharCode(bite));
                }
                return latin1Chars.join('');
            },
            /**
	         * Converts a Latin1 string to a word array.
	         *
	         * @param {string} latin1Str The Latin1 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	         */ parse: function(latin1Str) {
                // Shortcut
                var latin1StrLength = latin1Str.length;
                // Convert
                var words = [];
                for(var i = 0; i < latin1StrLength; i++)words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << 24 - i % 4 * 8;
                return new WordArray.init(words, latin1StrLength);
            }
        };
        /**
	     * UTF-8 encoding strategy.
	     */ var Utf8 = C_enc.Utf8 = {
            /**
	         * Converts a word array to a UTF-8 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-8 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	         */ stringify: function(wordArray) {
                try {
                    return decodeURIComponent(escape(Latin1.stringify(wordArray)));
                } catch (e) {
                    throw new Error('Malformed UTF-8 data');
                }
            },
            /**
	         * Converts a UTF-8 string to a word array.
	         *
	         * @param {string} utf8Str The UTF-8 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	         */ parse: function(utf8Str) {
                return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
            }
        };
        /**
	     * Abstract buffered block algorithm template.
	     *
	     * The property blockSize must be implemented in a concrete subtype.
	     *
	     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	     */ var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
            /**
	         * Resets this block algorithm's data buffer to its initial state.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm.reset();
	         */ reset: function() {
                // Initial values
                this._data = new WordArray.init();
                this._nDataBytes = 0;
            },
            /**
	         * Adds new data to this block algorithm's buffer.
	         *
	         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm._append('data');
	         *     bufferedBlockAlgorithm._append(wordArray);
	         */ _append: function(data) {
                // Convert string to WordArray, else assume WordArray already
                if (typeof data == 'string') data = Utf8.parse(data);
                // Append
                this._data.concat(data);
                this._nDataBytes += data.sigBytes;
            },
            /**
	         * Processes available data blocks.
	         *
	         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	         *
	         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	         *
	         * @return {WordArray} The processed data.
	         *
	         * @example
	         *
	         *     var processedData = bufferedBlockAlgorithm._process();
	         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	         */ _process: function(doFlush) {
                var processedWords;
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var dataSigBytes = data.sigBytes;
                var blockSize = this.blockSize;
                var blockSizeBytes = blockSize * 4;
                // Count blocks ready
                var nBlocksReady = dataSigBytes / blockSizeBytes;
                if (doFlush) // Round up to include partial blocks
                nBlocksReady = Math1.ceil(nBlocksReady);
                else // Round down to include only full blocks,
                // less the number of blocks that must remain in the buffer
                nBlocksReady = Math1.max((nBlocksReady | 0) - this._minBufferSize, 0);
                // Count words ready
                var nWordsReady = nBlocksReady * blockSize;
                // Count bytes ready
                var nBytesReady = Math1.min(nWordsReady * 4, dataSigBytes);
                // Process blocks
                if (nWordsReady) {
                    for(var offset = 0; offset < nWordsReady; offset += blockSize)// Perform concrete-algorithm logic
                    this._doProcessBlock(dataWords, offset);
                    // Remove processed words
                    processedWords = dataWords.splice(0, nWordsReady);
                    data.sigBytes -= nBytesReady;
                }
                // Return processed words
                return new WordArray.init(processedWords, nBytesReady);
            },
            /**
	         * Creates a copy of this object.
	         *
	         * @return {Object} The clone.
	         *
	         * @example
	         *
	         *     var clone = bufferedBlockAlgorithm.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                clone._data = this._data.clone();
                return clone;
            },
            _minBufferSize: 0
        });
        /**
	     * Abstract hasher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	     */ var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
            /**
	         * Configuration options.
	         */ cfg: Base.extend(),
            /**
	         * Initializes a newly created hasher.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	         *
	         * @example
	         *
	         *     var hasher = CryptoJS.algo.SHA256.create();
	         */ init: function(cfg) {
                // Apply config defaults
                this.cfg = this.cfg.extend(cfg);
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this hasher to its initial state.
	         *
	         * @example
	         *
	         *     hasher.reset();
	         */ reset: function() {
                // Reset data buffer
                BufferedBlockAlgorithm.reset.call(this);
                // Perform concrete-hasher logic
                this._doReset();
            },
            /**
	         * Updates this hasher with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {Hasher} This hasher.
	         *
	         * @example
	         *
	         *     hasher.update('message');
	         *     hasher.update(wordArray);
	         */ update: function(messageUpdate) {
                // Append
                this._append(messageUpdate);
                // Update the hash
                this._process();
                // Chainable
                return this;
            },
            /**
	         * Finalizes the hash computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The hash.
	         *
	         * @example
	         *
	         *     var hash = hasher.finalize();
	         *     var hash = hasher.finalize('message');
	         *     var hash = hasher.finalize(wordArray);
	         */ finalize: function(messageUpdate) {
                // Final message update
                if (messageUpdate) this._append(messageUpdate);
                // Perform concrete-hasher logic
                var hash = this._doFinalize();
                return hash;
            },
            blockSize: 16,
            /**
	         * Creates a shortcut function to a hasher's object interface.
	         *
	         * @param {Hasher} hasher The hasher to create a helper for.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	         */ _createHelper: function(hasher) {
                return function(message, cfg) {
                    return new hasher.init(cfg).finalize(message);
                };
            },
            /**
	         * Creates a shortcut function to the HMAC's object interface.
	         *
	         * @param {Hasher} hasher The hasher to use in this HMAC helper.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	         */ _createHmacHelper: function(hasher) {
                return function(message, key) {
                    return new C_algo.HMAC.init(hasher, key).finalize(message);
                };
            }
        });
        /**
	     * Algorithm namespace.
	     */ var C_algo = C.algo = {};
        return C;
    }(Math);
    return CryptoJS;
});

});

parcelRegister("immlP", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("jXGrH")));
})(this, function(CryptoJS) {
    (function() {
        // Check if typed arrays are supported
        if (typeof ArrayBuffer != 'function') return;
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        // Reference original init
        var superInit = WordArray.init;
        // Augment WordArray.init to handle typed arrays
        var subInit = WordArray.init = function(typedArray) {
            // Convert buffers to uint8
            if (typedArray instanceof ArrayBuffer) typedArray = new Uint8Array(typedArray);
            // Convert other array views to uint8
            if (typedArray instanceof Int8Array || typeof Uint8ClampedArray !== "undefined" && typedArray instanceof Uint8ClampedArray || typedArray instanceof Int16Array || typedArray instanceof Uint16Array || typedArray instanceof Int32Array || typedArray instanceof Uint32Array || typedArray instanceof Float32Array || typedArray instanceof Float64Array) typedArray = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
            // Handle Uint8Array
            if (typedArray instanceof Uint8Array) {
                // Shortcut
                var typedArrayByteLength = typedArray.byteLength;
                // Extract bytes
                var words = [];
                for(var i = 0; i < typedArrayByteLength; i++)words[i >>> 2] |= typedArray[i] << 24 - i % 4 * 8;
                // Initialize this word array
                superInit.call(this, words, typedArrayByteLength);
            } else // Else call normal init
            superInit.apply(this, arguments);
        };
        subInit.prototype = WordArray;
    })();
    return CryptoJS.lib.WordArray;
});

});

parcelRegister("eCc9K", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("jXGrH")));
})(this, function(CryptoJS) {
    (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Initialization and round constants tables
        var H = [];
        var K = [];
        // Compute constants
        (function() {
            function isPrime(n) {
                var sqrtN = Math1.sqrt(n);
                for(var factor = 2; factor <= sqrtN; factor++){
                    if (!(n % factor)) return false;
                }
                return true;
            }
            function getFractionalBits(n) {
                return (n - (n | 0)) * 0x100000000 | 0;
            }
            var n = 2;
            var nPrime = 0;
            while(nPrime < 64){
                if (isPrime(n)) {
                    if (nPrime < 8) H[nPrime] = getFractionalBits(Math1.pow(n, 0.5));
                    K[nPrime] = getFractionalBits(Math1.pow(n, 1 / 3));
                    nPrime++;
                }
                n++;
            }
        })();
        // Reusable object
        var W = [];
        /**
	     * SHA-256 hash algorithm.
	     */ var SHA256 = C_algo.SHA256 = Hasher.extend({
            _doReset: function() {
                this._hash = new WordArray.init(H.slice(0));
            },
            _doProcessBlock: function(M, offset) {
                // Shortcut
                var H = this._hash.words;
                // Working variables
                var a = H[0];
                var b = H[1];
                var c = H[2];
                var d = H[3];
                var e = H[4];
                var f = H[5];
                var g = H[6];
                var h = H[7];
                // Computation
                for(var i = 0; i < 64; i++){
                    if (i < 16) W[i] = M[offset + i] | 0;
                    else {
                        var gamma0x = W[i - 15];
                        var gamma0 = (gamma0x << 25 | gamma0x >>> 7) ^ (gamma0x << 14 | gamma0x >>> 18) ^ gamma0x >>> 3;
                        var gamma1x = W[i - 2];
                        var gamma1 = (gamma1x << 15 | gamma1x >>> 17) ^ (gamma1x << 13 | gamma1x >>> 19) ^ gamma1x >>> 10;
                        W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
                    }
                    var ch = e & f ^ ~e & g;
                    var maj = a & b ^ a & c ^ b & c;
                    var sigma0 = (a << 30 | a >>> 2) ^ (a << 19 | a >>> 13) ^ (a << 10 | a >>> 22);
                    var sigma1 = (e << 26 | e >>> 6) ^ (e << 21 | e >>> 11) ^ (e << 7 | e >>> 25);
                    var t1 = h + sigma1 + ch + K[i] + W[i];
                    var t2 = sigma0 + maj;
                    h = g;
                    g = f;
                    f = e;
                    e = d + t1 | 0;
                    d = c;
                    c = b;
                    b = a;
                    a = t1 + t2 | 0;
                }
                // Intermediate hash value
                H[0] = H[0] + a | 0;
                H[1] = H[1] + b | 0;
                H[2] = H[2] + c | 0;
                H[3] = H[3] + d | 0;
                H[4] = H[4] + e | 0;
                H[5] = H[5] + f | 0;
                H[6] = H[6] + g | 0;
                H[7] = H[7] + h | 0;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math1.floor(nBitsTotal / 0x100000000);
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Return final computed hash
                return this._hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA256('message');
	     *     var hash = CryptoJS.SHA256(wordArray);
	     */ C.SHA256 = Hasher._createHelper(SHA256);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA256(message, key);
	     */ C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
    })(Math);
    return CryptoJS.SHA256;
});

});

parcelRegister("9rQ6G", function(module, exports) {



(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("jXGrH")), (parcelRequire("eCc9K")), (parcelRequire("9F5mI")));
})(this, function(CryptoJS) {
    return CryptoJS.HmacSHA256;
});

});
parcelRegister("9F5mI", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("jXGrH")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var C_enc = C.enc;
        var Utf8 = C_enc.Utf8;
        var C_algo = C.algo;
        /**
	     * HMAC algorithm.
	     */ var HMAC = C_algo.HMAC = Base.extend({
            /**
	         * Initializes a newly created HMAC.
	         *
	         * @param {Hasher} hasher The hash algorithm to use.
	         * @param {WordArray|string} key The secret key.
	         *
	         * @example
	         *
	         *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
	         */ init: function(hasher, key) {
                // Init hasher
                hasher = this._hasher = new hasher.init();
                // Convert string to WordArray, else assume WordArray already
                if (typeof key == 'string') key = Utf8.parse(key);
                // Shortcuts
                var hasherBlockSize = hasher.blockSize;
                var hasherBlockSizeBytes = hasherBlockSize * 4;
                // Allow arbitrary length keys
                if (key.sigBytes > hasherBlockSizeBytes) key = hasher.finalize(key);
                // Clamp excess bits
                key.clamp();
                // Clone key for inner and outer pads
                var oKey = this._oKey = key.clone();
                var iKey = this._iKey = key.clone();
                // Shortcuts
                var oKeyWords = oKey.words;
                var iKeyWords = iKey.words;
                // XOR keys with pad constants
                for(var i = 0; i < hasherBlockSize; i++){
                    oKeyWords[i] ^= 0x5c5c5c5c;
                    iKeyWords[i] ^= 0x36363636;
                }
                oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this HMAC to its initial state.
	         *
	         * @example
	         *
	         *     hmacHasher.reset();
	         */ reset: function() {
                // Shortcut
                var hasher = this._hasher;
                // Reset
                hasher.reset();
                hasher.update(this._iKey);
            },
            /**
	         * Updates this HMAC with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {HMAC} This HMAC instance.
	         *
	         * @example
	         *
	         *     hmacHasher.update('message');
	         *     hmacHasher.update(wordArray);
	         */ update: function(messageUpdate) {
                this._hasher.update(messageUpdate);
                // Chainable
                return this;
            },
            /**
	         * Finalizes the HMAC computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The HMAC.
	         *
	         * @example
	         *
	         *     var hmac = hmacHasher.finalize();
	         *     var hmac = hmacHasher.finalize('message');
	         *     var hmac = hmacHasher.finalize(wordArray);
	         */ finalize: function(messageUpdate) {
                // Shortcut
                var hasher = this._hasher;
                // Compute HMAC
                var innerHash = hasher.finalize(messageUpdate);
                hasher.reset();
                var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));
                return hmac;
            }
        });
    })();
});

});


parcelRegister("cpmKt", function(module, exports) {

$parcel$export(module.exports, "default", () => $90897737ddcb0bec$export$2e2bcd8739ae039);

var $am04d = parcelRequire("am04d");
/**
 * Hex encoding strategy.
 * Converts a word array to a hex string.
 * @param {WordArray} wordArray The word array.
 * @return {string} The hex string.
 * @static
 */ function $90897737ddcb0bec$var$hexStringify(wordArray) {
    // Shortcuts
    var words = wordArray.words;
    var sigBytes = wordArray.sigBytes; // Convert
    var hexChars = [];
    for(var i = 0; i < sigBytes; i++){
        var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
        hexChars.push((bite >>> 4).toString(16));
        hexChars.push((bite & 0x0f).toString(16));
    }
    return hexChars.join('');
}
var $90897737ddcb0bec$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function WordArray(words, sigBytes) {
        words = this.words = words || [];
        if (sigBytes != undefined) this.sigBytes = sigBytes;
        else this.sigBytes = words.length * 4;
    }
    var _proto = WordArray.prototype;
    _proto.random = function random(nBytes) {
        var words = [];
        for(var i = 0; i < nBytes; i += 4)words.push((0, $am04d.default)());
        return new WordArray(words, nBytes);
    };
    _proto.toString = function toString() {
        return $90897737ddcb0bec$var$hexStringify(this);
    };
    return WordArray;
}();

});
parcelRegister("am04d", function(module, exports) {

$parcel$export(module.exports, "default", () => $789c02c4635d08e3$export$2e2bcd8739ae039);
var $789c02c4635d08e3$var$crypto; // Native crypto from window (Browser)
if (typeof window !== 'undefined' && window.crypto) $789c02c4635d08e3$var$crypto = window.crypto;
 // Native (experimental IE 11) crypto from window (Browser)
if (!$789c02c4635d08e3$var$crypto && typeof window !== 'undefined' && window.msCrypto) $789c02c4635d08e3$var$crypto = window.msCrypto;
 // Native crypto from global (NodeJS)
if (!$789c02c4635d08e3$var$crypto && typeof $parcel$global !== 'undefined' && $parcel$global.crypto) $789c02c4635d08e3$var$crypto = $parcel$global.crypto;
 // Native crypto import via require (NodeJS)

if (!$789c02c4635d08e3$var$crypto && true) try {
    $789c02c4635d08e3$var$crypto = (parcelRequire("1r8ZG"));
} catch (err) {}
function $789c02c4635d08e3$export$2e2bcd8739ae039() {
    if ($789c02c4635d08e3$var$crypto) {
        // Use getRandomValues method (Browser)
        if (typeof $789c02c4635d08e3$var$crypto.getRandomValues === 'function') try {
            return $789c02c4635d08e3$var$crypto.getRandomValues(new Uint32Array(1))[0];
        } catch (err) {}
         // Use randomBytes method (NodeJS)
        if (typeof $789c02c4635d08e3$var$crypto.randomBytes === 'function') try {
            return $789c02c4635d08e3$var$crypto.randomBytes(4).readInt32LE();
        } catch (err) {}
    }
    throw new Error('Native crypto module could not be used to get secure random number.');
}

});


parcelRegister("9qeOO", function(module, exports) {

$parcel$export(module.exports, "default", () => $6dc2096ef416b624$export$2e2bcd8739ae039);
// A small implementation of BigInteger based on http://www-cs-students.stanford.edu/~tjw/jsbn/
//
// All public methods have been removed except the following:
//   new BigInteger(a, b) (only radix 2, 4, 8, 16 and 32 supported)
//   toString (only radix 2, 4, 8, 16 and 32 supported)
//   negate
//   abs
//   compareTo
//   bitLength
//   mod
//   equals
//   add
//   subtract
//   multiply
//   divide
//   modPow
var $6dc2096ef416b624$export$2e2bcd8739ae039 = $6dc2096ef416b624$var$BigInteger;
/*
 * Copyright (c) 2003-2005  Tom Wu
 * All Rights Reserved.
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS-IS" AND WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS, IMPLIED OR OTHERWISE, INCLUDING WITHOUT LIMITATION, ANY
 * WARRANTY OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE.
 *
 * IN NO EVENT SHALL TOM WU BE LIABLE FOR ANY SPECIAL, INCIDENTAL,
 * INDIRECT OR CONSEQUENTIAL DAMAGES OF ANY KIND, OR ANY DAMAGES WHATSOEVER
 * RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER OR NOT ADVISED OF
 * THE POSSIBILITY OF DAMAGE, AND ON ANY THEORY OF LIABILITY, ARISING OUT
 * OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 *
 * In addition, the following condition applies:
 *
 * All redistributions must retain an intact copy of this copyright notice
 * and disclaimer.
 */ // (public) Constructor
function $6dc2096ef416b624$var$BigInteger(a, b) {
    if (a != null) this.fromString(a, b);
} // return new, unset BigInteger
function $6dc2096ef416b624$var$nbi() {
    return new $6dc2096ef416b624$var$BigInteger(null);
} // Bits per digit
var $6dc2096ef416b624$var$dbits; // JavaScript engine analysis
var $6dc2096ef416b624$var$canary = 0xdeadbeefcafe;
var $6dc2096ef416b624$var$j_lm = ($6dc2096ef416b624$var$canary & 0xffffff) == 0xefcafe; // am: Compute w_j += (x*this_i), propagate carries,
// c is initial carry, returns final carry.
// c < 3*dvalue, x < 2*dvalue, this_i < dvalue
// We need to select the fastest one that works in this environment.
// am1: use a single mult and divide to get the high bits,
// max digit bits should be 26 because
// max internal value = 2*dvalue^2-2*dvalue (< 2^53)
function $6dc2096ef416b624$var$am1(i, x, w, j, c, n) {
    while(--n >= 0){
        var v = x * this[i++] + w[j] + c;
        c = Math.floor(v / 0x4000000);
        w[j++] = v & 0x3ffffff;
    }
    return c;
} // am2 avoids a big mult-and-extract completely.
// Max digit bits should be <= 30 because we do bitwise ops
// on values up to 2*hdvalue^2-hdvalue-1 (< 2^31)
function $6dc2096ef416b624$var$am2(i, x, w, j, c, n) {
    var xl = x & 0x7fff, xh = x >> 15;
    while(--n >= 0){
        var l = this[i] & 0x7fff;
        var h = this[i++] >> 15;
        var m = xh * l + h * xl;
        l = xl * l + ((m & 0x7fff) << 15) + w[j] + (c & 0x3fffffff);
        c = (l >>> 30) + (m >>> 15) + xh * h + (c >>> 30);
        w[j++] = l & 0x3fffffff;
    }
    return c;
} // Alternately, set max digit bits to 28 since some
// browsers slow down when dealing with 32-bit numbers.
function $6dc2096ef416b624$var$am3(i, x, w, j, c, n) {
    var xl = x & 0x3fff, xh = x >> 14;
    while(--n >= 0){
        var l = this[i] & 0x3fff;
        var h = this[i++] >> 14;
        var m = xh * l + h * xl;
        l = xl * l + ((m & 0x3fff) << 14) + w[j] + c;
        c = (l >> 28) + (m >> 14) + xh * h;
        w[j++] = l & 0xfffffff;
    }
    return c;
}
var $6dc2096ef416b624$var$inBrowser = typeof navigator !== 'undefined';
if ($6dc2096ef416b624$var$inBrowser && $6dc2096ef416b624$var$j_lm && navigator.appName == 'Microsoft Internet Explorer') {
    $6dc2096ef416b624$var$BigInteger.prototype.am = $6dc2096ef416b624$var$am2;
    $6dc2096ef416b624$var$dbits = 30;
} else if ($6dc2096ef416b624$var$inBrowser && $6dc2096ef416b624$var$j_lm && navigator.appName != 'Netscape') {
    $6dc2096ef416b624$var$BigInteger.prototype.am = $6dc2096ef416b624$var$am1;
    $6dc2096ef416b624$var$dbits = 26;
} else {
    // Mozilla/Netscape seems to prefer am3
    $6dc2096ef416b624$var$BigInteger.prototype.am = $6dc2096ef416b624$var$am3;
    $6dc2096ef416b624$var$dbits = 28;
}
$6dc2096ef416b624$var$BigInteger.prototype.DB = $6dc2096ef416b624$var$dbits;
$6dc2096ef416b624$var$BigInteger.prototype.DM = (1 << $6dc2096ef416b624$var$dbits) - 1;
$6dc2096ef416b624$var$BigInteger.prototype.DV = 1 << $6dc2096ef416b624$var$dbits;
var $6dc2096ef416b624$var$BI_FP = 52;
$6dc2096ef416b624$var$BigInteger.prototype.FV = Math.pow(2, $6dc2096ef416b624$var$BI_FP);
$6dc2096ef416b624$var$BigInteger.prototype.F1 = $6dc2096ef416b624$var$BI_FP - $6dc2096ef416b624$var$dbits;
$6dc2096ef416b624$var$BigInteger.prototype.F2 = 2 * $6dc2096ef416b624$var$dbits - $6dc2096ef416b624$var$BI_FP; // Digit conversions
var $6dc2096ef416b624$var$BI_RM = '0123456789abcdefghijklmnopqrstuvwxyz';
var $6dc2096ef416b624$var$BI_RC = new Array();
var $6dc2096ef416b624$var$rr, $6dc2096ef416b624$var$vv;
$6dc2096ef416b624$var$rr = '0'.charCodeAt(0);
for($6dc2096ef416b624$var$vv = 0; $6dc2096ef416b624$var$vv <= 9; ++$6dc2096ef416b624$var$vv)$6dc2096ef416b624$var$BI_RC[$6dc2096ef416b624$var$rr++] = $6dc2096ef416b624$var$vv;
$6dc2096ef416b624$var$rr = 'a'.charCodeAt(0);
for($6dc2096ef416b624$var$vv = 10; $6dc2096ef416b624$var$vv < 36; ++$6dc2096ef416b624$var$vv)$6dc2096ef416b624$var$BI_RC[$6dc2096ef416b624$var$rr++] = $6dc2096ef416b624$var$vv;
$6dc2096ef416b624$var$rr = 'A'.charCodeAt(0);
for($6dc2096ef416b624$var$vv = 10; $6dc2096ef416b624$var$vv < 36; ++$6dc2096ef416b624$var$vv)$6dc2096ef416b624$var$BI_RC[$6dc2096ef416b624$var$rr++] = $6dc2096ef416b624$var$vv;
function $6dc2096ef416b624$var$int2char(n) {
    return $6dc2096ef416b624$var$BI_RM.charAt(n);
}
function $6dc2096ef416b624$var$intAt(s, i) {
    var c = $6dc2096ef416b624$var$BI_RC[s.charCodeAt(i)];
    return c == null ? -1 : c;
} // (protected) copy this to r
function $6dc2096ef416b624$var$bnpCopyTo(r) {
    for(var i = this.t - 1; i >= 0; --i)r[i] = this[i];
    r.t = this.t;
    r.s = this.s;
} // (protected) set from integer value x, -DV <= x < DV
function $6dc2096ef416b624$var$bnpFromInt(x) {
    this.t = 1;
    this.s = x < 0 ? -1 : 0;
    if (x > 0) this[0] = x;
    else if (x < -1) this[0] = x + this.DV;
    else this.t = 0;
} // return bigint initialized to value
function $6dc2096ef416b624$var$nbv(i) {
    var r = $6dc2096ef416b624$var$nbi();
    r.fromInt(i);
    return r;
} // (protected) set from string and radix
function $6dc2096ef416b624$var$bnpFromString(s, b) {
    var k;
    if (b == 16) k = 4;
    else if (b == 8) k = 3;
    else if (b == 2) k = 1;
    else if (b == 32) k = 5;
    else if (b == 4) k = 2;
    else throw new Error('Only radix 2, 4, 8, 16, 32 are supported');
    this.t = 0;
    this.s = 0;
    var i = s.length, mi = false, sh = 0;
    while(--i >= 0){
        var x = $6dc2096ef416b624$var$intAt(s, i);
        if (x < 0) {
            if (s.charAt(i) == '-') mi = true;
            continue;
        }
        mi = false;
        if (sh == 0) this[this.t++] = x;
        else if (sh + k > this.DB) {
            this[this.t - 1] |= (x & (1 << this.DB - sh) - 1) << sh;
            this[this.t++] = x >> this.DB - sh;
        } else this[this.t - 1] |= x << sh;
        sh += k;
        if (sh >= this.DB) sh -= this.DB;
    }
    this.clamp();
    if (mi) $6dc2096ef416b624$var$BigInteger.ZERO.subTo(this, this);
} // (protected) clamp off excess high words
function $6dc2096ef416b624$var$bnpClamp() {
    var c = this.s & this.DM;
    while(this.t > 0 && this[this.t - 1] == c)--this.t;
} // (public) return string representation in given radix
function $6dc2096ef416b624$var$bnToString(b) {
    if (this.s < 0) return '-' + this.negate().toString(b);
    var k;
    if (b == 16) k = 4;
    else if (b == 8) k = 3;
    else if (b == 2) k = 1;
    else if (b == 32) k = 5;
    else if (b == 4) k = 2;
    else throw new Error('Only radix 2, 4, 8, 16, 32 are supported');
    var km = (1 << k) - 1, d, m = false, r = '', i = this.t;
    var p = this.DB - i * this.DB % k;
    if (i-- > 0) {
        if (p < this.DB && (d = this[i] >> p) > 0) {
            m = true;
            r = $6dc2096ef416b624$var$int2char(d);
        }
        while(i >= 0){
            if (p < k) {
                d = (this[i] & (1 << p) - 1) << k - p;
                d |= this[--i] >> (p += this.DB - k);
            } else {
                d = this[i] >> (p -= k) & km;
                if (p <= 0) {
                    p += this.DB;
                    --i;
                }
            }
            if (d > 0) m = true;
            if (m) r += $6dc2096ef416b624$var$int2char(d);
        }
    }
    return m ? r : '0';
} // (public) -this
function $6dc2096ef416b624$var$bnNegate() {
    var r = $6dc2096ef416b624$var$nbi();
    $6dc2096ef416b624$var$BigInteger.ZERO.subTo(this, r);
    return r;
} // (public) |this|
function $6dc2096ef416b624$var$bnAbs() {
    return this.s < 0 ? this.negate() : this;
} // (public) return + if this > a, - if this < a, 0 if equal
function $6dc2096ef416b624$var$bnCompareTo(a) {
    var r = this.s - a.s;
    if (r != 0) return r;
    var i = this.t;
    r = i - a.t;
    if (r != 0) return this.s < 0 ? -r : r;
    while(--i >= 0){
        if ((r = this[i] - a[i]) != 0) return r;
    }
    return 0;
} // returns bit length of the integer x
function $6dc2096ef416b624$var$nbits(x) {
    var r = 1, t;
    if ((t = x >>> 16) != 0) {
        x = t;
        r += 16;
    }
    if ((t = x >> 8) != 0) {
        x = t;
        r += 8;
    }
    if ((t = x >> 4) != 0) {
        x = t;
        r += 4;
    }
    if ((t = x >> 2) != 0) {
        x = t;
        r += 2;
    }
    if ((t = x >> 1) != 0) {
        x = t;
        r += 1;
    }
    return r;
} // (public) return the number of bits in "this"
function $6dc2096ef416b624$var$bnBitLength() {
    if (this.t <= 0) return 0;
    return this.DB * (this.t - 1) + $6dc2096ef416b624$var$nbits(this[this.t - 1] ^ this.s & this.DM);
} // (protected) r = this << n*DB
function $6dc2096ef416b624$var$bnpDLShiftTo(n, r) {
    var i;
    for(i = this.t - 1; i >= 0; --i)r[i + n] = this[i];
    for(i = n - 1; i >= 0; --i)r[i] = 0;
    r.t = this.t + n;
    r.s = this.s;
} // (protected) r = this >> n*DB
function $6dc2096ef416b624$var$bnpDRShiftTo(n, r) {
    for(var i = n; i < this.t; ++i)r[i - n] = this[i];
    r.t = Math.max(this.t - n, 0);
    r.s = this.s;
} // (protected) r = this << n
function $6dc2096ef416b624$var$bnpLShiftTo(n, r) {
    var bs = n % this.DB;
    var cbs = this.DB - bs;
    var bm = (1 << cbs) - 1;
    var ds = Math.floor(n / this.DB), c = this.s << bs & this.DM, i;
    for(i = this.t - 1; i >= 0; --i){
        r[i + ds + 1] = this[i] >> cbs | c;
        c = (this[i] & bm) << bs;
    }
    for(i = ds - 1; i >= 0; --i)r[i] = 0;
    r[ds] = c;
    r.t = this.t + ds + 1;
    r.s = this.s;
    r.clamp();
} // (protected) r = this >> n
function $6dc2096ef416b624$var$bnpRShiftTo(n, r) {
    r.s = this.s;
    var ds = Math.floor(n / this.DB);
    if (ds >= this.t) {
        r.t = 0;
        return;
    }
    var bs = n % this.DB;
    var cbs = this.DB - bs;
    var bm = (1 << bs) - 1;
    r[0] = this[ds] >> bs;
    for(var i = ds + 1; i < this.t; ++i){
        r[i - ds - 1] |= (this[i] & bm) << cbs;
        r[i - ds] = this[i] >> bs;
    }
    if (bs > 0) r[this.t - ds - 1] |= (this.s & bm) << cbs;
    r.t = this.t - ds;
    r.clamp();
} // (protected) r = this - a
function $6dc2096ef416b624$var$bnpSubTo(a, r) {
    var i = 0, c = 0, m = Math.min(a.t, this.t);
    while(i < m){
        c += this[i] - a[i];
        r[i++] = c & this.DM;
        c >>= this.DB;
    }
    if (a.t < this.t) {
        c -= a.s;
        while(i < this.t){
            c += this[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += this.s;
    } else {
        c += this.s;
        while(i < a.t){
            c -= a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c -= a.s;
    }
    r.s = c < 0 ? -1 : 0;
    if (c < -1) r[i++] = this.DV + c;
    else if (c > 0) r[i++] = c;
    r.t = i;
    r.clamp();
} // (protected) r = this * a, r != this,a (HAC 14.12)
// "this" should be the larger one if appropriate.
function $6dc2096ef416b624$var$bnpMultiplyTo(a, r) {
    var x = this.abs(), y = a.abs();
    var i = x.t;
    r.t = i + y.t;
    while(--i >= 0)r[i] = 0;
    for(i = 0; i < y.t; ++i)r[i + x.t] = x.am(0, y[i], r, i, 0, x.t);
    r.s = 0;
    r.clamp();
    if (this.s != a.s) $6dc2096ef416b624$var$BigInteger.ZERO.subTo(r, r);
} // (protected) r = this^2, r != this (HAC 14.16)
function $6dc2096ef416b624$var$bnpSquareTo(r) {
    var x = this.abs();
    var i = r.t = 2 * x.t;
    while(--i >= 0)r[i] = 0;
    for(i = 0; i < x.t - 1; ++i){
        var c = x.am(i, x[i], r, 2 * i, 0, 1);
        if ((r[i + x.t] += x.am(i + 1, 2 * x[i], r, 2 * i + 1, c, x.t - i - 1)) >= x.DV) {
            r[i + x.t] -= x.DV;
            r[i + x.t + 1] = 1;
        }
    }
    if (r.t > 0) r[r.t - 1] += x.am(i, x[i], r, 2 * i, 0, 1);
    r.s = 0;
    r.clamp();
} // (protected) divide this by m, quotient and remainder to q, r (HAC 14.20)
// r != q, this != m.  q or r may be null.
function $6dc2096ef416b624$var$bnpDivRemTo(m, q, r) {
    var pm = m.abs();
    if (pm.t <= 0) return;
    var pt = this.abs();
    if (pt.t < pm.t) {
        if (q != null) q.fromInt(0);
        if (r != null) this.copyTo(r);
        return;
    }
    if (r == null) r = $6dc2096ef416b624$var$nbi();
    var y = $6dc2096ef416b624$var$nbi(), ts = this.s, ms = m.s;
    var nsh = this.DB - $6dc2096ef416b624$var$nbits(pm[pm.t - 1]); // normalize modulus
    if (nsh > 0) {
        pm.lShiftTo(nsh, y);
        pt.lShiftTo(nsh, r);
    } else {
        pm.copyTo(y);
        pt.copyTo(r);
    }
    var ys = y.t;
    var y0 = y[ys - 1];
    if (y0 == 0) return;
    var yt = y0 * (1 << this.F1) + (ys > 1 ? y[ys - 2] >> this.F2 : 0);
    var d1 = this.FV / yt, d2 = (1 << this.F1) / yt, e = 1 << this.F2;
    var i = r.t, j = i - ys, t = q == null ? $6dc2096ef416b624$var$nbi() : q;
    y.dlShiftTo(j, t);
    if (r.compareTo(t) >= 0) {
        r[r.t++] = 1;
        r.subTo(t, r);
    }
    $6dc2096ef416b624$var$BigInteger.ONE.dlShiftTo(ys, t);
    t.subTo(y, y); // "negative" y so we can replace sub with am later
    while(y.t < ys)y[y.t++] = 0;
    while(--j >= 0){
        // Estimate quotient digit
        var qd = r[--i] == y0 ? this.DM : Math.floor(r[i] * d1 + (r[i - 1] + e) * d2);
        if ((r[i] += y.am(0, qd, r, j, 0, ys)) < qd) {
            // Try it out
            y.dlShiftTo(j, t);
            r.subTo(t, r);
            while(r[i] < --qd)r.subTo(t, r);
        }
    }
    if (q != null) {
        r.drShiftTo(ys, q);
        if (ts != ms) $6dc2096ef416b624$var$BigInteger.ZERO.subTo(q, q);
    }
    r.t = ys;
    r.clamp();
    if (nsh > 0) r.rShiftTo(nsh, r); // Denormalize remainder
    if (ts < 0) $6dc2096ef416b624$var$BigInteger.ZERO.subTo(r, r);
} // (public) this mod a
function $6dc2096ef416b624$var$bnMod(a) {
    var r = $6dc2096ef416b624$var$nbi();
    this.abs().divRemTo(a, null, r);
    if (this.s < 0 && r.compareTo($6dc2096ef416b624$var$BigInteger.ZERO) > 0) a.subTo(r, r);
    return r;
} // (protected) return "-1/this % 2^DB"; useful for Mont. reduction
// justification:
//         xy == 1 (mod m)
//         xy =  1+km
//   xy(2-xy) = (1+km)(1-km)
// x[y(2-xy)] = 1-k^2m^2
// x[y(2-xy)] == 1 (mod m^2)
// if y is 1/x mod m, then y(2-xy) is 1/x mod m^2
// should reduce x and y(2-xy) by m^2 at each step to keep size bounded.
// JS multiply "overflows" differently from C/C++, so care is needed here.
function $6dc2096ef416b624$var$bnpInvDigit() {
    if (this.t < 1) return 0;
    var x = this[0];
    if ((x & 1) == 0) return 0;
    var y = x & 3; // y == 1/x mod 2^2
    y = y * (2 - (x & 0xf) * y) & 0xf; // y == 1/x mod 2^4
    y = y * (2 - (x & 0xff) * y) & 0xff; // y == 1/x mod 2^8
    y = y * (2 - ((x & 0xffff) * y & 0xffff)) & 0xffff; // y == 1/x mod 2^16
    // last step - calculate inverse mod DV directly;
    // assumes 16 < DB <= 32 and assumes ability to handle 48-bit ints
    y = y * (2 - x * y % this.DV) % this.DV; // y == 1/x mod 2^dbits
    // we really want the negative inverse, and -DV < y < DV
    return y > 0 ? this.DV - y : -y;
}
function $6dc2096ef416b624$var$bnEquals(a) {
    return this.compareTo(a) == 0;
} // (protected) r = this + a
function $6dc2096ef416b624$var$bnpAddTo(a, r) {
    var i = 0, c = 0, m = Math.min(a.t, this.t);
    while(i < m){
        c += this[i] + a[i];
        r[i++] = c & this.DM;
        c >>= this.DB;
    }
    if (a.t < this.t) {
        c += a.s;
        while(i < this.t){
            c += this[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += this.s;
    } else {
        c += this.s;
        while(i < a.t){
            c += a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += a.s;
    }
    r.s = c < 0 ? -1 : 0;
    if (c > 0) r[i++] = c;
    else if (c < -1) r[i++] = this.DV + c;
    r.t = i;
    r.clamp();
} // (public) this + a
function $6dc2096ef416b624$var$bnAdd(a) {
    var r = $6dc2096ef416b624$var$nbi();
    this.addTo(a, r);
    return r;
} // (public) this - a
function $6dc2096ef416b624$var$bnSubtract(a) {
    var r = $6dc2096ef416b624$var$nbi();
    this.subTo(a, r);
    return r;
} // (public) this * a
function $6dc2096ef416b624$var$bnMultiply(a) {
    var r = $6dc2096ef416b624$var$nbi();
    this.multiplyTo(a, r);
    return r;
} // (public) this / a
function $6dc2096ef416b624$var$bnDivide(a) {
    var r = $6dc2096ef416b624$var$nbi();
    this.divRemTo(a, r, null);
    return r;
} // Montgomery reduction
function $6dc2096ef416b624$var$Montgomery(m) {
    this.m = m;
    this.mp = m.invDigit();
    this.mpl = this.mp & 0x7fff;
    this.mph = this.mp >> 15;
    this.um = (1 << m.DB - 15) - 1;
    this.mt2 = 2 * m.t;
} // xR mod m
function $6dc2096ef416b624$var$montConvert(x) {
    var r = $6dc2096ef416b624$var$nbi();
    x.abs().dlShiftTo(this.m.t, r);
    r.divRemTo(this.m, null, r);
    if (x.s < 0 && r.compareTo($6dc2096ef416b624$var$BigInteger.ZERO) > 0) this.m.subTo(r, r);
    return r;
} // x/R mod m
function $6dc2096ef416b624$var$montRevert(x) {
    var r = $6dc2096ef416b624$var$nbi();
    x.copyTo(r);
    this.reduce(r);
    return r;
} // x = x/R mod m (HAC 14.32)
function $6dc2096ef416b624$var$montReduce(x) {
    while(x.t <= this.mt2)// pad x so am has enough room later
    x[x.t++] = 0;
    for(var i = 0; i < this.m.t; ++i){
        // faster way of calculating u0 = x[i]*mp mod DV
        var j = x[i] & 0x7fff;
        var u0 = j * this.mpl + ((j * this.mph + (x[i] >> 15) * this.mpl & this.um) << 15) & x.DM; // use am to combine the multiply-shift-add into one call
        j = i + this.m.t;
        x[j] += this.m.am(0, u0, x, i, 0, this.m.t); // propagate carry
        while(x[j] >= x.DV){
            x[j] -= x.DV;
            x[++j]++;
        }
    }
    x.clamp();
    x.drShiftTo(this.m.t, x);
    if (x.compareTo(this.m) >= 0) x.subTo(this.m, x);
} // r = "x^2/R mod m"; x != r
function $6dc2096ef416b624$var$montSqrTo(x, r) {
    x.squareTo(r);
    this.reduce(r);
} // r = "xy/R mod m"; x,y != r
function $6dc2096ef416b624$var$montMulTo(x, y, r) {
    x.multiplyTo(y, r);
    this.reduce(r);
}
$6dc2096ef416b624$var$Montgomery.prototype.convert = $6dc2096ef416b624$var$montConvert;
$6dc2096ef416b624$var$Montgomery.prototype.revert = $6dc2096ef416b624$var$montRevert;
$6dc2096ef416b624$var$Montgomery.prototype.reduce = $6dc2096ef416b624$var$montReduce;
$6dc2096ef416b624$var$Montgomery.prototype.mulTo = $6dc2096ef416b624$var$montMulTo;
$6dc2096ef416b624$var$Montgomery.prototype.sqrTo = $6dc2096ef416b624$var$montSqrTo; // (public) this^e % m (HAC 14.85)
function $6dc2096ef416b624$var$bnModPow(e, m, callback) {
    var i = e.bitLength(), k, r = $6dc2096ef416b624$var$nbv(1), z = new $6dc2096ef416b624$var$Montgomery(m);
    if (i <= 0) return r;
    else if (i < 18) k = 1;
    else if (i < 48) k = 3;
    else if (i < 144) k = 4;
    else if (i < 768) k = 5;
    else k = 6; // precomputation
    var g = new Array(), n = 3, k1 = k - 1, km = (1 << k) - 1;
    g[1] = z.convert(this);
    if (k > 1) {
        var g2 = $6dc2096ef416b624$var$nbi();
        z.sqrTo(g[1], g2);
        while(n <= km){
            g[n] = $6dc2096ef416b624$var$nbi();
            z.mulTo(g2, g[n - 2], g[n]);
            n += 2;
        }
    }
    var j = e.t - 1, w, is1 = true, r2 = $6dc2096ef416b624$var$nbi(), t;
    i = $6dc2096ef416b624$var$nbits(e[j]) - 1;
    while(j >= 0){
        if (i >= k1) w = e[j] >> i - k1 & km;
        else {
            w = (e[j] & (1 << i + 1) - 1) << k1 - i;
            if (j > 0) w |= e[j - 1] >> this.DB + i - k1;
        }
        n = k;
        while((w & 1) == 0){
            w >>= 1;
            --n;
        }
        if ((i -= n) < 0) {
            i += this.DB;
            --j;
        }
        if (is1) {
            // ret == 1, don't bother squaring or multiplying it
            g[w].copyTo(r);
            is1 = false;
        } else {
            while(n > 1){
                z.sqrTo(r, r2);
                z.sqrTo(r2, r);
                n -= 2;
            }
            if (n > 0) z.sqrTo(r, r2);
            else {
                t = r;
                r = r2;
                r2 = t;
            }
            z.mulTo(r2, g[w], r);
        }
        while(j >= 0 && (e[j] & 1 << i) == 0){
            z.sqrTo(r, r2);
            t = r;
            r = r2;
            r2 = t;
            if (--i < 0) {
                i = this.DB - 1;
                --j;
            }
        }
    }
    var result = z.revert(r);
    callback(null, result);
    return result;
} // protected
$6dc2096ef416b624$var$BigInteger.prototype.copyTo = $6dc2096ef416b624$var$bnpCopyTo;
$6dc2096ef416b624$var$BigInteger.prototype.fromInt = $6dc2096ef416b624$var$bnpFromInt;
$6dc2096ef416b624$var$BigInteger.prototype.fromString = $6dc2096ef416b624$var$bnpFromString;
$6dc2096ef416b624$var$BigInteger.prototype.clamp = $6dc2096ef416b624$var$bnpClamp;
$6dc2096ef416b624$var$BigInteger.prototype.dlShiftTo = $6dc2096ef416b624$var$bnpDLShiftTo;
$6dc2096ef416b624$var$BigInteger.prototype.drShiftTo = $6dc2096ef416b624$var$bnpDRShiftTo;
$6dc2096ef416b624$var$BigInteger.prototype.lShiftTo = $6dc2096ef416b624$var$bnpLShiftTo;
$6dc2096ef416b624$var$BigInteger.prototype.rShiftTo = $6dc2096ef416b624$var$bnpRShiftTo;
$6dc2096ef416b624$var$BigInteger.prototype.subTo = $6dc2096ef416b624$var$bnpSubTo;
$6dc2096ef416b624$var$BigInteger.prototype.multiplyTo = $6dc2096ef416b624$var$bnpMultiplyTo;
$6dc2096ef416b624$var$BigInteger.prototype.squareTo = $6dc2096ef416b624$var$bnpSquareTo;
$6dc2096ef416b624$var$BigInteger.prototype.divRemTo = $6dc2096ef416b624$var$bnpDivRemTo;
$6dc2096ef416b624$var$BigInteger.prototype.invDigit = $6dc2096ef416b624$var$bnpInvDigit;
$6dc2096ef416b624$var$BigInteger.prototype.addTo = $6dc2096ef416b624$var$bnpAddTo; // public
$6dc2096ef416b624$var$BigInteger.prototype.toString = $6dc2096ef416b624$var$bnToString;
$6dc2096ef416b624$var$BigInteger.prototype.negate = $6dc2096ef416b624$var$bnNegate;
$6dc2096ef416b624$var$BigInteger.prototype.abs = $6dc2096ef416b624$var$bnAbs;
$6dc2096ef416b624$var$BigInteger.prototype.compareTo = $6dc2096ef416b624$var$bnCompareTo;
$6dc2096ef416b624$var$BigInteger.prototype.bitLength = $6dc2096ef416b624$var$bnBitLength;
$6dc2096ef416b624$var$BigInteger.prototype.mod = $6dc2096ef416b624$var$bnMod;
$6dc2096ef416b624$var$BigInteger.prototype.equals = $6dc2096ef416b624$var$bnEquals;
$6dc2096ef416b624$var$BigInteger.prototype.add = $6dc2096ef416b624$var$bnAdd;
$6dc2096ef416b624$var$BigInteger.prototype.subtract = $6dc2096ef416b624$var$bnSubtract;
$6dc2096ef416b624$var$BigInteger.prototype.multiply = $6dc2096ef416b624$var$bnMultiply;
$6dc2096ef416b624$var$BigInteger.prototype.divide = $6dc2096ef416b624$var$bnDivide;
$6dc2096ef416b624$var$BigInteger.prototype.modPow = $6dc2096ef416b624$var$bnModPow; // "constants"
$6dc2096ef416b624$var$BigInteger.ZERO = $6dc2096ef416b624$var$nbv(0);
$6dc2096ef416b624$var$BigInteger.ONE = $6dc2096ef416b624$var$nbv(1);

});


parcelRegister("5KyOf", function(module, exports) {

$parcel$export(module.exports, "default", () => $42fc400eaf33d76d$export$2e2bcd8739ae039);

var $3UplZ = parcelRequire("3UplZ");
function $42fc400eaf33d76d$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $42fc400eaf33d76d$var$_setPrototypeOf(subClass, superClass);
}
function $42fc400eaf33d76d$var$_setPrototypeOf(o, p) {
    $42fc400eaf33d76d$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $42fc400eaf33d76d$var$_setPrototypeOf(o, p);
}
/** @class */ var $42fc400eaf33d76d$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_CognitoJwtToken) {
    $42fc400eaf33d76d$var$_inheritsLoose(CognitoAccessToken, _CognitoJwtToken);
    /**
   * Constructs a new CognitoAccessToken object
   * @param {string=} AccessToken The JWT access token.
   */ function CognitoAccessToken(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, AccessToken = _ref.AccessToken;
        return _CognitoJwtToken.call(this, AccessToken || '') || this;
    }
    return CognitoAccessToken;
}((0, $3UplZ.default));

});
parcelRegister("3UplZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d8a44c9940d02b9$export$2e2bcd8739ae039);
/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */ 
var $f6qki = parcelRequire("f6qki");
/** @class */ var $2d8a44c9940d02b9$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoJwtToken object
   * @param {string=} token The JWT token.
   */ function CognitoJwtToken(token) {
        // Assign object
        this.jwtToken = token || '';
        this.payload = this.decodePayload();
    }
    /**
   * @returns {string} the record's token.
   */ var _proto = CognitoJwtToken.prototype;
    _proto.getJwtToken = function getJwtToken() {
        return this.jwtToken;
    };
    _proto.getExpiration = function getExpiration() {
        return this.payload.exp;
    };
    _proto.getIssuedAt = function getIssuedAt() {
        return this.payload.iat;
    };
    _proto.decodePayload = function decodePayload() {
        var payload = this.jwtToken.split('.')[1];
        try {
            return JSON.parse((0, $f6qki.Buffer).from(payload, 'base64').toString('utf8'));
        } catch (err) {
            return {};
        }
    };
    return CognitoJwtToken;
}();

});


parcelRegister("erxFS", function(module, exports) {

$parcel$export(module.exports, "default", () => $a83db55f39508975$export$2e2bcd8739ae039);

var $3UplZ = parcelRequire("3UplZ");
function $a83db55f39508975$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $a83db55f39508975$var$_setPrototypeOf(subClass, superClass);
}
function $a83db55f39508975$var$_setPrototypeOf(o, p) {
    $a83db55f39508975$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $a83db55f39508975$var$_setPrototypeOf(o, p);
}
/** @class */ var $a83db55f39508975$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_CognitoJwtToken) {
    $a83db55f39508975$var$_inheritsLoose(CognitoIdToken, _CognitoJwtToken);
    /**
   * Constructs a new CognitoIdToken object
   * @param {string=} IdToken The JWT Id token
   */ function CognitoIdToken(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, IdToken = _ref.IdToken;
        return _CognitoJwtToken.call(this, IdToken || '') || this;
    }
    return CognitoIdToken;
}((0, $3UplZ.default));

});

parcelRegister("4avyf", function(module, exports) {

$parcel$export(module.exports, "default", () => $309092105c0df1e6$export$2e2bcd8739ae039);
/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */ /** @class */ var $309092105c0df1e6$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoRefreshToken object
   * @param {string=} RefreshToken The JWT refresh token.
   */ function CognitoRefreshToken(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, RefreshToken = _ref.RefreshToken;
        // Assign object
        this.token = RefreshToken || '';
    }
    /**
   * @returns {string} the record's token.
   */ var _proto = CognitoRefreshToken.prototype;
    _proto.getToken = function getToken() {
        return this.token;
    };
    return CognitoRefreshToken;
}();

});

parcelRegister("fEY0G", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6692433153cf6f8$export$2e2bcd8739ae039);
/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */ 
var $f6qki = parcelRequire("f6qki");

var $jXGrH = parcelRequire("jXGrH");
parcelRequire("immlP");

var $5T3DJ = parcelRequire("5T3DJ");

var $9rQ6G = parcelRequire("9rQ6G");

var $9qeOO = parcelRequire("9qeOO");

var $eLHeA = parcelRequire("eLHeA");

var $5KyOf = parcelRequire("5KyOf");

var $erxFS = parcelRequire("erxFS");

var $4avyf = parcelRequire("4avyf");

var $fVSyU = parcelRequire("fVSyU");

var $5PlTV = parcelRequire("5PlTV");

var $kDaVl = parcelRequire("kDaVl");

var $9Jbga = parcelRequire("9Jbga");
/**
 * @callback nodeCallback
 * @template T result
 * @param {*} err The operation failure reason, or null.
 * @param {T} result The operation result.
 */ /**
 * @callback onFailure
 * @param {*} err Failure reason.
 */ /**
 * @callback onSuccess
 * @template T result
 * @param {T} result The operation result.
 */ /**
 * @callback mfaRequired
 * @param {*} details MFA challenge details.
 */ /**
 * @callback customChallenge
 * @param {*} details Custom challenge details.
 */ /**
 * @callback inputVerificationCode
 * @param {*} data Server response.
 */ /**
 * @callback authSuccess
 * @param {CognitoUserSession} session The new session.
 * @param {bool=} userConfirmationNecessary User must be confirmed.
 */ var $b6692433153cf6f8$var$isBrowser = typeof navigator !== 'undefined';
var $b6692433153cf6f8$var$userAgent = $b6692433153cf6f8$var$isBrowser ? navigator.userAgent : 'nodejs';
/** @class */ var $b6692433153cf6f8$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUser object
   * @param {object} data Creation options
   * @param {string} data.Username The user's username.
   * @param {CognitoUserPool} data.Pool Pool containing the user.
   * @param {object} data.Storage Optional storage object.
   */ function CognitoUser(data) {
        if (data == null || data.Username == null || data.Pool == null) throw new Error('Username and Pool information are required.');
        this.username = data.Username || '';
        this.pool = data.Pool;
        this.Session = null;
        this.client = data.Pool.client;
        this.signInUserSession = null;
        this.authenticationFlowType = 'USER_SRP_AUTH';
        this.storage = data.Storage || new (0, $9Jbga.default)().getStorage();
        this.keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        this.userDataKey = this.keyPrefix + "." + this.username + ".userData";
    }
    /**
   * Sets the session for this user
   * @param {CognitoUserSession} signInUserSession the session
   * @returns {void}
   */ var _proto = CognitoUser.prototype;
    _proto.setSignInUserSession = function setSignInUserSession(signInUserSession) {
        this.clearCachedUserData();
        this.signInUserSession = signInUserSession;
        this.cacheTokens();
    };
    _proto.getSignInUserSession = function getSignInUserSession() {
        return this.signInUserSession;
    };
    _proto.getUsername = function getUsername() {
        return this.username;
    };
    _proto.getAuthenticationFlowType = function getAuthenticationFlowType() {
        return this.authenticationFlowType;
    };
    _proto.setAuthenticationFlowType = function setAuthenticationFlowType(authenticationFlowType) {
        this.authenticationFlowType = authenticationFlowType;
    };
    _proto.initiateAuth = function initiateAuth(authDetails, callback) {
        var _this = this;
        var authParameters = authDetails.getAuthParameters();
        authParameters.USERNAME = this.username;
        var clientMetaData = Object.keys(authDetails.getValidationData()).length !== 0 ? authDetails.getValidationData() : authDetails.getClientMetadata();
        var jsonReq = {
            AuthFlow: 'CUSTOM_AUTH',
            ClientId: this.pool.getClientId(),
            AuthParameters: authParameters,
            ClientMetadata: clientMetaData
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request('InitiateAuth', jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            var challengeName = data.ChallengeName;
            var challengeParameters = data.ChallengeParameters;
            if (challengeName === 'CUSTOM_CHALLENGE') {
                _this.Session = data.Session;
                return callback.customChallenge(challengeParameters);
            }
            _this.signInUserSession = _this.getCognitoUserSession(data.AuthenticationResult);
            _this.cacheTokens();
            return callback.onSuccess(_this.signInUserSession);
        });
    };
    _proto.authenticateUser = function authenticateUser(authDetails, callback) {
        if (this.authenticationFlowType === 'USER_PASSWORD_AUTH') return this.authenticateUserPlainUsernamePassword(authDetails, callback);
        else if (this.authenticationFlowType === 'USER_SRP_AUTH' || this.authenticationFlowType === 'CUSTOM_AUTH') return this.authenticateUserDefaultAuth(authDetails, callback);
        return callback.onFailure(new Error('Authentication flow type is invalid.'));
    };
    _proto.authenticateUserDefaultAuth = function authenticateUserDefaultAuth(authDetails, callback) {
        var _this2 = this;
        var authenticationHelper = new (0, $eLHeA.default)(this.pool.getUserPoolId().split('_')[1]);
        var dateHelper = new (0, $5PlTV.default)();
        var serverBValue;
        var salt;
        var authParameters = {};
        if (this.deviceKey != null) authParameters.DEVICE_KEY = this.deviceKey;
        authParameters.USERNAME = this.username;
        authenticationHelper.getLargeAValue(function(errOnAValue, aValue) {
            // getLargeAValue callback start
            if (errOnAValue) callback.onFailure(errOnAValue);
            authParameters.SRP_A = aValue.toString(16);
            if (_this2.authenticationFlowType === 'CUSTOM_AUTH') authParameters.CHALLENGE_NAME = 'SRP_A';
            var clientMetaData = Object.keys(authDetails.getValidationData()).length !== 0 ? authDetails.getValidationData() : authDetails.getClientMetadata();
            var jsonReq = {
                AuthFlow: _this2.authenticationFlowType,
                ClientId: _this2.pool.getClientId(),
                AuthParameters: authParameters,
                ClientMetadata: clientMetaData
            };
            if (_this2.getUserContextData(_this2.username)) jsonReq.UserContextData = _this2.getUserContextData(_this2.username);
            _this2.client.request('InitiateAuth', jsonReq, function(err, data) {
                if (err) return callback.onFailure(err);
                var challengeParameters = data.ChallengeParameters;
                _this2.username = challengeParameters.USER_ID_FOR_SRP;
                _this2.userDataKey = _this2.keyPrefix + "." + _this2.username + ".userData";
                serverBValue = new (0, $9qeOO.default)(challengeParameters.SRP_B, 16);
                salt = new (0, $9qeOO.default)(challengeParameters.SALT, 16);
                _this2.getCachedDeviceKeyAndPassword();
                authenticationHelper.getPasswordAuthenticationKey(_this2.username, authDetails.getPassword(), serverBValue, salt, function(errOnHkdf, hkdf) {
                    // getPasswordAuthenticationKey callback start
                    if (errOnHkdf) callback.onFailure(errOnHkdf);
                    var dateNow = dateHelper.getNowString();
                    var message = (0, (/*@__PURE__*/$parcel$interopDefault($jXGrH))).lib.WordArray.create((0, $f6qki.Buffer).concat([
                        (0, $f6qki.Buffer).from(_this2.pool.getUserPoolId().split('_')[1], 'utf8'),
                        (0, $f6qki.Buffer).from(_this2.username, 'utf8'),
                        (0, $f6qki.Buffer).from(challengeParameters.SECRET_BLOCK, 'base64'),
                        (0, $f6qki.Buffer).from(dateNow, 'utf8')
                    ]));
                    var key = (0, (/*@__PURE__*/$parcel$interopDefault($jXGrH))).lib.WordArray.create(hkdf);
                    var signatureString = (0, (/*@__PURE__*/$parcel$interopDefault($5T3DJ))).stringify((0, (/*@__PURE__*/$parcel$interopDefault($9rQ6G)))(message, key));
                    var challengeResponses = {};
                    challengeResponses.USERNAME = _this2.username;
                    challengeResponses.PASSWORD_CLAIM_SECRET_BLOCK = challengeParameters.SECRET_BLOCK;
                    challengeResponses.TIMESTAMP = dateNow;
                    challengeResponses.PASSWORD_CLAIM_SIGNATURE = signatureString;
                    if (_this2.deviceKey != null) challengeResponses.DEVICE_KEY = _this2.deviceKey;
                    var respondToAuthChallenge = function respondToAuthChallenge(challenge, challengeCallback) {
                        return _this2.client.request('RespondToAuthChallenge', challenge, function(errChallenge, dataChallenge) {
                            if (errChallenge && errChallenge.code === 'ResourceNotFoundException' && errChallenge.message.toLowerCase().indexOf('device') !== -1) {
                                challengeResponses.DEVICE_KEY = null;
                                _this2.deviceKey = null;
                                _this2.randomPassword = null;
                                _this2.deviceGroupKey = null;
                                _this2.clearCachedDeviceKeyAndPassword();
                                return respondToAuthChallenge(challenge, challengeCallback);
                            }
                            return challengeCallback(errChallenge, dataChallenge);
                        });
                    };
                    var jsonReqResp = {
                        ChallengeName: 'PASSWORD_VERIFIER',
                        ClientId: _this2.pool.getClientId(),
                        ChallengeResponses: challengeResponses,
                        Session: data.Session,
                        ClientMetadata: clientMetaData
                    };
                    if (_this2.getUserContextData()) jsonReqResp.UserContextData = _this2.getUserContextData();
                    respondToAuthChallenge(jsonReqResp, function(errAuthenticate, dataAuthenticate) {
                        if (errAuthenticate) return callback.onFailure(errAuthenticate);
                        return _this2.authenticateUserInternal(dataAuthenticate, authenticationHelper, callback);
                    });
                    return undefined; // getPasswordAuthenticationKey callback end
                });
                return undefined;
            }); // getLargeAValue callback end
        });
    };
    _proto.authenticateUserPlainUsernamePassword = function authenticateUserPlainUsernamePassword(authDetails, callback) {
        var _this3 = this;
        var authParameters = {};
        authParameters.USERNAME = this.username;
        authParameters.PASSWORD = authDetails.getPassword();
        if (!authParameters.PASSWORD) {
            callback.onFailure(new Error('PASSWORD parameter is required'));
            return;
        }
        var authenticationHelper = new (0, $eLHeA.default)(this.pool.getUserPoolId().split('_')[1]);
        this.getCachedDeviceKeyAndPassword();
        if (this.deviceKey != null) authParameters.DEVICE_KEY = this.deviceKey;
        var clientMetaData = Object.keys(authDetails.getValidationData()).length !== 0 ? authDetails.getValidationData() : authDetails.getClientMetadata();
        var jsonReq = {
            AuthFlow: 'USER_PASSWORD_AUTH',
            ClientId: this.pool.getClientId(),
            AuthParameters: authParameters,
            ClientMetadata: clientMetaData
        };
        if (this.getUserContextData(this.username)) jsonReq.UserContextData = this.getUserContextData(this.username);
         // USER_PASSWORD_AUTH happens in a single round-trip: client sends userName and password,
        // Cognito UserPools verifies password and returns tokens.
        this.client.request('InitiateAuth', jsonReq, function(err, authResult) {
            if (err) return callback.onFailure(err);
            return _this3.authenticateUserInternal(authResult, authenticationHelper, callback);
        });
    };
    _proto.authenticateUserInternal = function authenticateUserInternal(dataAuthenticate, authenticationHelper, callback) {
        var _this4 = this;
        var challengeName = dataAuthenticate.ChallengeName;
        var challengeParameters = dataAuthenticate.ChallengeParameters;
        if (challengeName === 'SMS_MFA') {
            this.Session = dataAuthenticate.Session;
            return callback.mfaRequired(challengeName, challengeParameters);
        }
        if (challengeName === 'SELECT_MFA_TYPE') {
            this.Session = dataAuthenticate.Session;
            return callback.selectMFAType(challengeName, challengeParameters);
        }
        if (challengeName === 'MFA_SETUP') {
            this.Session = dataAuthenticate.Session;
            return callback.mfaSetup(challengeName, challengeParameters);
        }
        if (challengeName === 'SOFTWARE_TOKEN_MFA') {
            this.Session = dataAuthenticate.Session;
            return callback.totpRequired(challengeName, challengeParameters);
        }
        if (challengeName === 'CUSTOM_CHALLENGE') {
            this.Session = dataAuthenticate.Session;
            return callback.customChallenge(challengeParameters);
        }
        if (challengeName === 'NEW_PASSWORD_REQUIRED') {
            this.Session = dataAuthenticate.Session;
            var userAttributes = null;
            var rawRequiredAttributes = null;
            var requiredAttributes = [];
            var userAttributesPrefix = authenticationHelper.getNewPasswordRequiredChallengeUserAttributePrefix();
            if (challengeParameters) {
                userAttributes = JSON.parse(dataAuthenticate.ChallengeParameters.userAttributes);
                rawRequiredAttributes = JSON.parse(dataAuthenticate.ChallengeParameters.requiredAttributes);
            }
            if (rawRequiredAttributes) for(var i = 0; i < rawRequiredAttributes.length; i++)requiredAttributes[i] = rawRequiredAttributes[i].substr(userAttributesPrefix.length);
            return callback.newPasswordRequired(userAttributes, requiredAttributes);
        }
        if (challengeName === 'DEVICE_SRP_AUTH') {
            this.getDeviceResponse(callback);
            return undefined;
        }
        this.signInUserSession = this.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
        this.challengeName = challengeName;
        this.cacheTokens();
        var newDeviceMetadata = dataAuthenticate.AuthenticationResult.NewDeviceMetadata;
        if (newDeviceMetadata == null) return callback.onSuccess(this.signInUserSession);
        authenticationHelper.generateHashDevice(dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey, dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey, function(errGenHash) {
            if (errGenHash) return callback.onFailure(errGenHash);
            var deviceSecretVerifierConfig = {
                Salt: (0, $f6qki.Buffer).from(authenticationHelper.getSaltDevices(), 'hex').toString('base64'),
                PasswordVerifier: (0, $f6qki.Buffer).from(authenticationHelper.getVerifierDevices(), 'hex').toString('base64')
            };
            _this4.verifierDevices = deviceSecretVerifierConfig.PasswordVerifier;
            _this4.deviceGroupKey = newDeviceMetadata.DeviceGroupKey;
            _this4.randomPassword = authenticationHelper.getRandomPassword();
            _this4.client.request('ConfirmDevice', {
                DeviceKey: newDeviceMetadata.DeviceKey,
                AccessToken: _this4.signInUserSession.getAccessToken().getJwtToken(),
                DeviceSecretVerifierConfig: deviceSecretVerifierConfig,
                DeviceName: $b6692433153cf6f8$var$userAgent
            }, function(errConfirm, dataConfirm) {
                if (errConfirm) return callback.onFailure(errConfirm);
                _this4.deviceKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey;
                _this4.cacheDeviceKeyAndPassword();
                if (dataConfirm.UserConfirmationNecessary === true) return callback.onSuccess(_this4.signInUserSession, dataConfirm.UserConfirmationNecessary);
                return callback.onSuccess(_this4.signInUserSession);
            });
            return undefined;
        });
        return undefined;
    };
    _proto.completeNewPasswordChallenge = function completeNewPasswordChallenge(newPassword, requiredAttributeData, callback, clientMetadata) {
        var _this5 = this;
        if (!newPassword) return callback.onFailure(new Error('New password is required.'));
        var authenticationHelper = new (0, $eLHeA.default)(this.pool.getUserPoolId().split('_')[1]);
        var userAttributesPrefix = authenticationHelper.getNewPasswordRequiredChallengeUserAttributePrefix();
        var finalUserAttributes = {};
        if (requiredAttributeData) Object.keys(requiredAttributeData).forEach(function(key) {
            finalUserAttributes[userAttributesPrefix + key] = requiredAttributeData[key];
        });
        finalUserAttributes.NEW_PASSWORD = newPassword;
        finalUserAttributes.USERNAME = this.username;
        var jsonReq = {
            ChallengeName: 'NEW_PASSWORD_REQUIRED',
            ClientId: this.pool.getClientId(),
            ChallengeResponses: finalUserAttributes,
            Session: this.Session,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request('RespondToAuthChallenge', jsonReq, function(errAuthenticate, dataAuthenticate) {
            if (errAuthenticate) return callback.onFailure(errAuthenticate);
            return _this5.authenticateUserInternal(dataAuthenticate, authenticationHelper, callback);
        });
        return undefined;
    };
    _proto.getDeviceResponse = function getDeviceResponse(callback, clientMetadata) {
        var _this6 = this;
        var authenticationHelper = new (0, $eLHeA.default)(this.deviceGroupKey);
        var dateHelper = new (0, $5PlTV.default)();
        var authParameters = {};
        authParameters.USERNAME = this.username;
        authParameters.DEVICE_KEY = this.deviceKey;
        authenticationHelper.getLargeAValue(function(errAValue, aValue) {
            // getLargeAValue callback start
            if (errAValue) callback.onFailure(errAValue);
            authParameters.SRP_A = aValue.toString(16);
            var jsonReq = {
                ChallengeName: 'DEVICE_SRP_AUTH',
                ClientId: _this6.pool.getClientId(),
                ChallengeResponses: authParameters,
                ClientMetadata: clientMetadata
            };
            if (_this6.getUserContextData()) jsonReq.UserContextData = _this6.getUserContextData();
            _this6.client.request('RespondToAuthChallenge', jsonReq, function(err, data) {
                if (err) return callback.onFailure(err);
                var challengeParameters = data.ChallengeParameters;
                var serverBValue = new (0, $9qeOO.default)(challengeParameters.SRP_B, 16);
                var salt = new (0, $9qeOO.default)(challengeParameters.SALT, 16);
                authenticationHelper.getPasswordAuthenticationKey(_this6.deviceKey, _this6.randomPassword, serverBValue, salt, function(errHkdf, hkdf) {
                    // getPasswordAuthenticationKey callback start
                    if (errHkdf) return callback.onFailure(errHkdf);
                    var dateNow = dateHelper.getNowString();
                    var message = (0, (/*@__PURE__*/$parcel$interopDefault($jXGrH))).lib.WordArray.create((0, $f6qki.Buffer).concat([
                        (0, $f6qki.Buffer).from(_this6.deviceGroupKey, 'utf8'),
                        (0, $f6qki.Buffer).from(_this6.deviceKey, 'utf8'),
                        (0, $f6qki.Buffer).from(challengeParameters.SECRET_BLOCK, 'base64'),
                        (0, $f6qki.Buffer).from(dateNow, 'utf8')
                    ]));
                    var key = (0, (/*@__PURE__*/$parcel$interopDefault($jXGrH))).lib.WordArray.create(hkdf);
                    var signatureString = (0, (/*@__PURE__*/$parcel$interopDefault($5T3DJ))).stringify((0, (/*@__PURE__*/$parcel$interopDefault($9rQ6G)))(message, key));
                    var challengeResponses = {};
                    challengeResponses.USERNAME = _this6.username;
                    challengeResponses.PASSWORD_CLAIM_SECRET_BLOCK = challengeParameters.SECRET_BLOCK;
                    challengeResponses.TIMESTAMP = dateNow;
                    challengeResponses.PASSWORD_CLAIM_SIGNATURE = signatureString;
                    challengeResponses.DEVICE_KEY = _this6.deviceKey;
                    var jsonReqResp = {
                        ChallengeName: 'DEVICE_PASSWORD_VERIFIER',
                        ClientId: _this6.pool.getClientId(),
                        ChallengeResponses: challengeResponses,
                        Session: data.Session
                    };
                    if (_this6.getUserContextData()) jsonReqResp.UserContextData = _this6.getUserContextData();
                    _this6.client.request('RespondToAuthChallenge', jsonReqResp, function(errAuthenticate, dataAuthenticate) {
                        if (errAuthenticate) return callback.onFailure(errAuthenticate);
                        _this6.signInUserSession = _this6.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
                        _this6.cacheTokens();
                        return callback.onSuccess(_this6.signInUserSession);
                    });
                    return undefined; // getPasswordAuthenticationKey callback end
                });
                return undefined;
            }); // getLargeAValue callback end
        });
    };
    _proto.confirmRegistration = function confirmRegistration(confirmationCode, forceAliasCreation, callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            ConfirmationCode: confirmationCode,
            Username: this.username,
            ForceAliasCreation: forceAliasCreation,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request('ConfirmSignUp', jsonReq, function(err) {
            if (err) return callback(err, null);
            return callback(null, 'SUCCESS');
        });
    };
    _proto.sendCustomChallengeAnswer = function sendCustomChallengeAnswer(answerChallenge, callback, clientMetadata) {
        var _this7 = this;
        var challengeResponses = {};
        challengeResponses.USERNAME = this.username;
        challengeResponses.ANSWER = answerChallenge;
        var authenticationHelper = new (0, $eLHeA.default)(this.pool.getUserPoolId().split('_')[1]);
        this.getCachedDeviceKeyAndPassword();
        if (this.deviceKey != null) challengeResponses.DEVICE_KEY = this.deviceKey;
        var jsonReq = {
            ChallengeName: 'CUSTOM_CHALLENGE',
            ChallengeResponses: challengeResponses,
            ClientId: this.pool.getClientId(),
            Session: this.Session,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request('RespondToAuthChallenge', jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            return _this7.authenticateUserInternal(data, authenticationHelper, callback);
        });
    };
    _proto.sendMFACode = function sendMFACode(confirmationCode, callback, mfaType, clientMetadata) {
        var _this8 = this;
        var challengeResponses = {};
        challengeResponses.USERNAME = this.username;
        challengeResponses.SMS_MFA_CODE = confirmationCode;
        var mfaTypeSelection = mfaType || 'SMS_MFA';
        if (mfaTypeSelection === 'SOFTWARE_TOKEN_MFA') challengeResponses.SOFTWARE_TOKEN_MFA_CODE = confirmationCode;
        if (this.deviceKey != null) challengeResponses.DEVICE_KEY = this.deviceKey;
        var jsonReq = {
            ChallengeName: mfaTypeSelection,
            ChallengeResponses: challengeResponses,
            ClientId: this.pool.getClientId(),
            Session: this.Session,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request('RespondToAuthChallenge', jsonReq, function(err, dataAuthenticate) {
            if (err) return callback.onFailure(err);
            var challengeName = dataAuthenticate.ChallengeName;
            if (challengeName === 'DEVICE_SRP_AUTH') {
                _this8.getDeviceResponse(callback);
                return undefined;
            }
            _this8.signInUserSession = _this8.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
            _this8.cacheTokens();
            if (dataAuthenticate.AuthenticationResult.NewDeviceMetadata == null) return callback.onSuccess(_this8.signInUserSession);
            var authenticationHelper = new (0, $eLHeA.default)(_this8.pool.getUserPoolId().split('_')[1]);
            authenticationHelper.generateHashDevice(dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey, dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey, function(errGenHash) {
                if (errGenHash) return callback.onFailure(errGenHash);
                var deviceSecretVerifierConfig = {
                    Salt: (0, $f6qki.Buffer).from(authenticationHelper.getSaltDevices(), 'hex').toString('base64'),
                    PasswordVerifier: (0, $f6qki.Buffer).from(authenticationHelper.getVerifierDevices(), 'hex').toString('base64')
                };
                _this8.verifierDevices = deviceSecretVerifierConfig.PasswordVerifier;
                _this8.deviceGroupKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey;
                _this8.randomPassword = authenticationHelper.getRandomPassword();
                _this8.client.request('ConfirmDevice', {
                    DeviceKey: dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey,
                    AccessToken: _this8.signInUserSession.getAccessToken().getJwtToken(),
                    DeviceSecretVerifierConfig: deviceSecretVerifierConfig,
                    DeviceName: $b6692433153cf6f8$var$userAgent
                }, function(errConfirm, dataConfirm) {
                    if (errConfirm) return callback.onFailure(errConfirm);
                    _this8.deviceKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey;
                    _this8.cacheDeviceKeyAndPassword();
                    if (dataConfirm.UserConfirmationNecessary === true) return callback.onSuccess(_this8.signInUserSession, dataConfirm.UserConfirmationNecessary);
                    return callback.onSuccess(_this8.signInUserSession);
                });
                return undefined;
            });
            return undefined;
        });
    };
    _proto.changePassword = function changePassword(oldUserPassword, newUserPassword, callback, clientMetadata) {
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error('User is not authenticated'), null);
        this.client.request('ChangePassword', {
            PreviousPassword: oldUserPassword,
            ProposedPassword: newUserPassword,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            ClientMetadata: clientMetadata
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, 'SUCCESS');
        });
        return undefined;
    };
    _proto.enableMFA = function enableMFA(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error('User is not authenticated'), null);
        var mfaOptions = [];
        var mfaEnabled = {
            DeliveryMedium: 'SMS',
            AttributeName: 'phone_number'
        };
        mfaOptions.push(mfaEnabled);
        this.client.request('SetUserSettings', {
            MFAOptions: mfaOptions,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, 'SUCCESS');
        });
        return undefined;
    };
    _proto.setUserMfaPreference = function setUserMfaPreference(smsMfaSettings, softwareTokenMfaSettings, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error('User is not authenticated'), null);
        this.client.request('SetUserMFAPreference', {
            SMSMfaSettings: smsMfaSettings,
            SoftwareTokenMfaSettings: softwareTokenMfaSettings,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, 'SUCCESS');
        });
        return undefined;
    };
    _proto.disableMFA = function disableMFA(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error('User is not authenticated'), null);
        var mfaOptions = [];
        this.client.request('SetUserSettings', {
            MFAOptions: mfaOptions,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, 'SUCCESS');
        });
        return undefined;
    };
    _proto.deleteUser = function deleteUser(callback, clientMetadata) {
        var _this9 = this;
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error('User is not authenticated'), null);
        this.client.request('DeleteUser', {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            ClientMetadata: clientMetadata
        }, function(err) {
            if (err) return callback(err, null);
            _this9.clearCachedUser();
            return callback(null, 'SUCCESS');
        });
        return undefined;
    };
    _proto.updateAttributes = function updateAttributes(attributes, callback, clientMetadata) {
        var _this10 = this;
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error('User is not authenticated'), null);
        this.client.request('UpdateUserAttributes', {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            UserAttributes: attributes,
            ClientMetadata: clientMetadata
        }, function(err) {
            if (err) return callback(err, null);
             // update cached user
            return _this10.getUserData(function() {
                return callback(null, 'SUCCESS');
            }, {
                bypassCache: true
            });
        });
        return undefined;
    };
    _proto.getUserAttributes = function getUserAttributes(callback) {
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error('User is not authenticated'), null);
        this.client.request('GetUser', {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err, userData) {
            if (err) return callback(err, null);
            var attributeList = [];
            for(var i = 0; i < userData.UserAttributes.length; i++){
                var attribute = {
                    Name: userData.UserAttributes[i].Name,
                    Value: userData.UserAttributes[i].Value
                };
                var userAttribute = new (0, $kDaVl.default)(attribute);
                attributeList.push(userAttribute);
            }
            return callback(null, attributeList);
        });
        return undefined;
    };
    _proto.getMFAOptions = function getMFAOptions(callback) {
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error('User is not authenticated'), null);
        this.client.request('GetUser', {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err, userData) {
            if (err) return callback(err, null);
            return callback(null, userData.MFAOptions);
        });
        return undefined;
    };
    _proto.createGetUserRequest = function createGetUserRequest() {
        return this.client.promisifyRequest('GetUser', {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        });
    };
    _proto.refreshSessionIfPossible = function refreshSessionIfPossible(options) {
        var _this11 = this;
        if (options === void 0) options = {};
        // best effort, if not possible
        return new Promise(function(resolve) {
            var refresh = _this11.signInUserSession.getRefreshToken();
            if (refresh && refresh.getToken()) _this11.refreshSession(refresh, resolve, options.clientMetadata);
            else resolve();
        });
    };
    _proto.getUserData = function getUserData(callback, params) {
        var _this12 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) {
            this.clearCachedUserData();
            return callback(new Error('User is not authenticated'), null);
        }
        var userData = this.getUserDataFromCache();
        if (!userData) {
            this.fetchUserData().then(function(data) {
                callback(null, data);
            })["catch"](callback);
            return;
        }
        if (this.isFetchUserDataAndTokenRequired(params)) {
            this.fetchUserData().then(function(data) {
                return _this12.refreshSessionIfPossible(params).then(function() {
                    return data;
                });
            }).then(function(data) {
                return callback(null, data);
            })["catch"](callback);
            return;
        }
        try {
            callback(null, JSON.parse(userData));
            return;
        } catch (err) {
            this.clearCachedUserData();
            callback(err, null);
            return;
        }
    };
    _proto.getUserDataFromCache = function getUserDataFromCache() {
        var userData = this.storage.getItem(this.userDataKey);
        return userData;
    };
    _proto.isFetchUserDataAndTokenRequired = function isFetchUserDataAndTokenRequired(params) {
        var _ref = params || {}, _ref$bypassCache = _ref.bypassCache, bypassCache = _ref$bypassCache === void 0 ? false : _ref$bypassCache;
        return bypassCache;
    };
    _proto.fetchUserData = function fetchUserData() {
        var _this13 = this;
        return this.createGetUserRequest().then(function(data) {
            _this13.cacheUserData(data);
            return data;
        });
    };
    _proto.deleteAttributes = function deleteAttributes(attributeList, callback) {
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error('User is not authenticated'), null);
        this.client.request('DeleteUserAttributes', {
            UserAttributeNames: attributeList,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, 'SUCCESS');
        });
        return undefined;
    };
    _proto.resendConfirmationCode = function resendConfirmationCode(callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            Username: this.username,
            ClientMetadata: clientMetadata
        };
        this.client.request('ResendConfirmationCode', jsonReq, function(err, result) {
            if (err) return callback(err, null);
            return callback(null, result);
        });
    };
    _proto.getSession = function getSession(callback, options) {
        if (options === void 0) options = {};
        if (this.username == null) return callback(new Error('Username is null. Cannot retrieve a new session'), null);
        if (this.signInUserSession != null && this.signInUserSession.isValid()) return callback(null, this.signInUserSession);
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var idTokenKey = keyPrefix + ".idToken";
        var accessTokenKey = keyPrefix + ".accessToken";
        var refreshTokenKey = keyPrefix + ".refreshToken";
        var clockDriftKey = keyPrefix + ".clockDrift";
        if (this.storage.getItem(idTokenKey)) {
            var idToken = new (0, $erxFS.default)({
                IdToken: this.storage.getItem(idTokenKey)
            });
            var accessToken = new (0, $5KyOf.default)({
                AccessToken: this.storage.getItem(accessTokenKey)
            });
            var refreshToken = new (0, $4avyf.default)({
                RefreshToken: this.storage.getItem(refreshTokenKey)
            });
            var clockDrift = parseInt(this.storage.getItem(clockDriftKey), 0) || 0;
            var sessionData = {
                IdToken: idToken,
                AccessToken: accessToken,
                RefreshToken: refreshToken,
                ClockDrift: clockDrift
            };
            var cachedSession = new (0, $fVSyU.default)(sessionData);
            if (cachedSession.isValid()) {
                this.signInUserSession = cachedSession;
                return callback(null, this.signInUserSession);
            }
            if (!refreshToken.getToken()) return callback(new Error('Cannot retrieve a new session. Please authenticate.'), null);
            this.refreshSession(refreshToken, callback, options.clientMetadata);
        } else callback(new Error('Local storage is missing an ID Token, Please authenticate'), null);
        return undefined;
    };
    _proto.refreshSession = function refreshSession(refreshToken, callback, clientMetadata) {
        var _this14 = this;
        var wrappedCallback = this.pool.wrapRefreshSessionCallback ? this.pool.wrapRefreshSessionCallback(callback) : callback;
        var authParameters = {};
        authParameters.REFRESH_TOKEN = refreshToken.getToken();
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        var lastUserKey = keyPrefix + ".LastAuthUser";
        if (this.storage.getItem(lastUserKey)) {
            this.username = this.storage.getItem(lastUserKey);
            var deviceKeyKey = keyPrefix + "." + this.username + ".deviceKey";
            this.deviceKey = this.storage.getItem(deviceKeyKey);
            authParameters.DEVICE_KEY = this.deviceKey;
        }
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            AuthFlow: 'REFRESH_TOKEN_AUTH',
            AuthParameters: authParameters,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request('InitiateAuth', jsonReq, function(err, authResult) {
            if (err) {
                if (err.code === 'NotAuthorizedException') _this14.clearCachedUser();
                return wrappedCallback(err, null);
            }
            if (authResult) {
                var authenticationResult = authResult.AuthenticationResult;
                if (!Object.prototype.hasOwnProperty.call(authenticationResult, 'RefreshToken')) authenticationResult.RefreshToken = refreshToken.getToken();
                _this14.signInUserSession = _this14.getCognitoUserSession(authenticationResult);
                _this14.cacheTokens();
                return wrappedCallback(null, _this14.signInUserSession);
            }
            return undefined;
        });
    };
    _proto.cacheTokens = function cacheTokens() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        var idTokenKey = keyPrefix + "." + this.username + ".idToken";
        var accessTokenKey = keyPrefix + "." + this.username + ".accessToken";
        var refreshTokenKey = keyPrefix + "." + this.username + ".refreshToken";
        var clockDriftKey = keyPrefix + "." + this.username + ".clockDrift";
        var lastUserKey = keyPrefix + ".LastAuthUser";
        this.storage.setItem(idTokenKey, this.signInUserSession.getIdToken().getJwtToken());
        this.storage.setItem(accessTokenKey, this.signInUserSession.getAccessToken().getJwtToken());
        this.storage.setItem(refreshTokenKey, this.signInUserSession.getRefreshToken().getToken());
        this.storage.setItem(clockDriftKey, "" + this.signInUserSession.getClockDrift());
        this.storage.setItem(lastUserKey, this.username);
    };
    _proto.cacheUserData = function cacheUserData(userData) {
        this.storage.setItem(this.userDataKey, JSON.stringify(userData));
    };
    _proto.clearCachedUserData = function clearCachedUserData() {
        this.storage.removeItem(this.userDataKey);
    };
    _proto.clearCachedUser = function clearCachedUser() {
        this.clearCachedTokens();
        this.clearCachedUserData();
    };
    _proto.cacheDeviceKeyAndPassword = function cacheDeviceKeyAndPassword() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var deviceKeyKey = keyPrefix + ".deviceKey";
        var randomPasswordKey = keyPrefix + ".randomPasswordKey";
        var deviceGroupKeyKey = keyPrefix + ".deviceGroupKey";
        this.storage.setItem(deviceKeyKey, this.deviceKey);
        this.storage.setItem(randomPasswordKey, this.randomPassword);
        this.storage.setItem(deviceGroupKeyKey, this.deviceGroupKey);
    };
    _proto.getCachedDeviceKeyAndPassword = function getCachedDeviceKeyAndPassword() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var deviceKeyKey = keyPrefix + ".deviceKey";
        var randomPasswordKey = keyPrefix + ".randomPasswordKey";
        var deviceGroupKeyKey = keyPrefix + ".deviceGroupKey";
        if (this.storage.getItem(deviceKeyKey)) {
            this.deviceKey = this.storage.getItem(deviceKeyKey);
            this.randomPassword = this.storage.getItem(randomPasswordKey);
            this.deviceGroupKey = this.storage.getItem(deviceGroupKeyKey);
        }
    };
    _proto.clearCachedDeviceKeyAndPassword = function clearCachedDeviceKeyAndPassword() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var deviceKeyKey = keyPrefix + ".deviceKey";
        var randomPasswordKey = keyPrefix + ".randomPasswordKey";
        var deviceGroupKeyKey = keyPrefix + ".deviceGroupKey";
        this.storage.removeItem(deviceKeyKey);
        this.storage.removeItem(randomPasswordKey);
        this.storage.removeItem(deviceGroupKeyKey);
    };
    _proto.clearCachedTokens = function clearCachedTokens() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        var idTokenKey = keyPrefix + "." + this.username + ".idToken";
        var accessTokenKey = keyPrefix + "." + this.username + ".accessToken";
        var refreshTokenKey = keyPrefix + "." + this.username + ".refreshToken";
        var lastUserKey = keyPrefix + ".LastAuthUser";
        var clockDriftKey = keyPrefix + "." + this.username + ".clockDrift";
        this.storage.removeItem(idTokenKey);
        this.storage.removeItem(accessTokenKey);
        this.storage.removeItem(refreshTokenKey);
        this.storage.removeItem(lastUserKey);
        this.storage.removeItem(clockDriftKey);
    };
    _proto.getCognitoUserSession = function getCognitoUserSession(authResult) {
        var idToken = new (0, $erxFS.default)(authResult);
        var accessToken = new (0, $5KyOf.default)(authResult);
        var refreshToken = new (0, $4avyf.default)(authResult);
        var sessionData = {
            IdToken: idToken,
            AccessToken: accessToken,
            RefreshToken: refreshToken
        };
        return new (0, $fVSyU.default)(sessionData);
    };
    _proto.forgotPassword = function forgotPassword(callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            Username: this.username,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request('ForgotPassword', jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            if (typeof callback.inputVerificationCode === 'function') return callback.inputVerificationCode(data);
            return callback.onSuccess(data);
        });
    };
    _proto.confirmPassword = function confirmPassword(confirmationCode, newPassword, callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            Username: this.username,
            ConfirmationCode: confirmationCode,
            Password: newPassword,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request('ConfirmForgotPassword', jsonReq, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess();
        });
    };
    _proto.getAttributeVerificationCode = function getAttributeVerificationCode(attributeName, callback, clientMetadata) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error('User is not authenticated'));
        this.client.request('GetUserAttributeVerificationCode', {
            AttributeName: attributeName,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            ClientMetadata: clientMetadata
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            if (typeof callback.inputVerificationCode === 'function') return callback.inputVerificationCode(data);
            return callback.onSuccess();
        });
        return undefined;
    };
    _proto.verifyAttribute = function verifyAttribute(attributeName, confirmationCode, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error('User is not authenticated'));
        this.client.request('VerifyUserAttribute', {
            AttributeName: attributeName,
            Code: confirmationCode,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess('SUCCESS');
        });
        return undefined;
    };
    _proto.getDevice = function getDevice(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error('User is not authenticated'));
        this.client.request('GetDevice', {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: this.deviceKey
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess(data);
        });
        return undefined;
    };
    _proto.forgetSpecificDevice = function forgetSpecificDevice(deviceKey, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error('User is not authenticated'));
        this.client.request('ForgetDevice', {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: deviceKey
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess('SUCCESS');
        });
        return undefined;
    };
    _proto.forgetDevice = function forgetDevice(callback) {
        var _this15 = this;
        this.forgetSpecificDevice(this.deviceKey, {
            onFailure: callback.onFailure,
            onSuccess: function onSuccess(result) {
                _this15.deviceKey = null;
                _this15.deviceGroupKey = null;
                _this15.randomPassword = null;
                _this15.clearCachedDeviceKeyAndPassword();
                return callback.onSuccess(result);
            }
        });
    };
    _proto.setDeviceStatusRemembered = function setDeviceStatusRemembered(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error('User is not authenticated'));
        this.client.request('UpdateDeviceStatus', {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: this.deviceKey,
            DeviceRememberedStatus: 'remembered'
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess('SUCCESS');
        });
        return undefined;
    };
    _proto.setDeviceStatusNotRemembered = function setDeviceStatusNotRemembered(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error('User is not authenticated'));
        this.client.request('UpdateDeviceStatus', {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: this.deviceKey,
            DeviceRememberedStatus: 'not_remembered'
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess('SUCCESS');
        });
        return undefined;
    };
    _proto.listDevices = function listDevices(limit, paginationToken, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error('User is not authenticated'));
        var requestParams = {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            Limit: limit
        };
        if (paginationToken) requestParams.PaginationToken = paginationToken;
        this.client.request('ListDevices', requestParams, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess(data);
        });
        return undefined;
    };
    _proto.globalSignOut = function globalSignOut(callback) {
        var _this16 = this;
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error('User is not authenticated'));
        this.client.request('GlobalSignOut', {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback.onFailure(err);
            _this16.clearCachedUser();
            return callback.onSuccess('SUCCESS');
        });
        return undefined;
    };
    _proto.signOut = function signOut() {
        this.signInUserSession = null;
        this.clearCachedUser();
    };
    _proto.sendMFASelectionAnswer = function sendMFASelectionAnswer(answerChallenge, callback) {
        var _this17 = this;
        var challengeResponses = {};
        challengeResponses.USERNAME = this.username;
        challengeResponses.ANSWER = answerChallenge;
        var jsonReq = {
            ChallengeName: 'SELECT_MFA_TYPE',
            ChallengeResponses: challengeResponses,
            ClientId: this.pool.getClientId(),
            Session: this.Session
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request('RespondToAuthChallenge', jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            _this17.Session = data.Session;
            if (answerChallenge === 'SMS_MFA') return callback.mfaRequired(data.ChallengeName, data.ChallengeParameters);
            if (answerChallenge === 'SOFTWARE_TOKEN_MFA') return callback.totpRequired(data.ChallengeName, data.ChallengeParameters);
            return undefined;
        });
    };
    _proto.getUserContextData = function getUserContextData() {
        var pool = this.pool;
        return pool.getUserContextData(this.username);
    };
    _proto.associateSoftwareToken = function associateSoftwareToken(callback) {
        var _this18 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) this.client.request('AssociateSoftwareToken', {
            Session: this.Session
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            _this18.Session = data.Session;
            return callback.associateSecretCode(data.SecretCode);
        });
        else this.client.request('AssociateSoftwareToken', {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.associateSecretCode(data.SecretCode);
        });
    };
    _proto.verifySoftwareToken = function verifySoftwareToken(totpCode, friendlyDeviceName, callback) {
        var _this19 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) this.client.request('VerifySoftwareToken', {
            Session: this.Session,
            UserCode: totpCode,
            FriendlyDeviceName: friendlyDeviceName
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            _this19.Session = data.Session;
            var challengeResponses = {};
            challengeResponses.USERNAME = _this19.username;
            var jsonReq = {
                ChallengeName: 'MFA_SETUP',
                ClientId: _this19.pool.getClientId(),
                ChallengeResponses: challengeResponses,
                Session: _this19.Session
            };
            if (_this19.getUserContextData()) jsonReq.UserContextData = _this19.getUserContextData();
            _this19.client.request('RespondToAuthChallenge', jsonReq, function(errRespond, dataRespond) {
                if (errRespond) return callback.onFailure(errRespond);
                _this19.signInUserSession = _this19.getCognitoUserSession(dataRespond.AuthenticationResult);
                _this19.cacheTokens();
                return callback.onSuccess(_this19.signInUserSession);
            });
            return undefined;
        });
        else this.client.request('VerifySoftwareToken', {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            UserCode: totpCode,
            FriendlyDeviceName: friendlyDeviceName
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess(data);
        });
    };
    return CognitoUser;
}();

});
parcelRegister("5T3DJ", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("jXGrH")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_enc = C.enc;
        /**
	     * Base64 encoding strategy.
	     */ var Base64 = C_enc.Base64 = {
            /**
	         * Converts a word array to a Base64 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Base64 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                var map = this._map;
                // Clamp excess bits
                wordArray.clamp();
                // Convert
                var base64Chars = [];
                for(var i = 0; i < sigBytes; i += 3){
                    var byte1 = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    var byte2 = words[i + 1 >>> 2] >>> 24 - (i + 1) % 4 * 8 & 0xff;
                    var byte3 = words[i + 2 >>> 2] >>> 24 - (i + 2) % 4 * 8 & 0xff;
                    var triplet = byte1 << 16 | byte2 << 8 | byte3;
                    for(var j = 0; j < 4 && i + j * 0.75 < sigBytes; j++)base64Chars.push(map.charAt(triplet >>> 6 * (3 - j) & 0x3f));
                }
                // Add padding
                var paddingChar = map.charAt(64);
                if (paddingChar) while(base64Chars.length % 4)base64Chars.push(paddingChar);
                return base64Chars.join('');
            },
            /**
	         * Converts a Base64 string to a word array.
	         *
	         * @param {string} base64Str The Base64 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
	         */ parse: function(base64Str) {
                // Shortcuts
                var base64StrLength = base64Str.length;
                var map = this._map;
                var reverseMap = this._reverseMap;
                if (!reverseMap) {
                    reverseMap = this._reverseMap = [];
                    for(var j = 0; j < map.length; j++)reverseMap[map.charCodeAt(j)] = j;
                }
                // Ignore padding
                var paddingChar = map.charAt(64);
                if (paddingChar) {
                    var paddingIndex = base64Str.indexOf(paddingChar);
                    if (paddingIndex !== -1) base64StrLength = paddingIndex;
                }
                // Convert
                return parseLoop(base64Str, base64StrLength, reverseMap);
            },
            _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
        };
        function parseLoop(base64Str, base64StrLength, reverseMap) {
            var words = [];
            var nBytes = 0;
            for(var i = 0; i < base64StrLength; i++)if (i % 4) {
                var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << i % 4 * 2;
                var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> 6 - i % 4 * 2;
                var bitsCombined = bits1 | bits2;
                words[nBytes >>> 2] |= bitsCombined << 24 - nBytes % 4 * 8;
                nBytes++;
            }
            return WordArray.create(words, nBytes);
        }
    })();
    return CryptoJS.enc.Base64;
});

});

parcelRegister("fVSyU", function(module, exports) {

$parcel$export(module.exports, "default", () => $b99680cb6e49c5ec$export$2e2bcd8739ae039);
/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */ /** @class */ var $b99680cb6e49c5ec$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUserSession object
   * @param {CognitoIdToken} IdToken The session's Id token.
   * @param {CognitoRefreshToken=} RefreshToken The session's refresh token.
   * @param {CognitoAccessToken} AccessToken The session's access token.
   * @param {int} ClockDrift The saved computer's clock drift or undefined to force calculation.
   */ function CognitoUserSession(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, IdToken = _ref.IdToken, RefreshToken = _ref.RefreshToken, AccessToken = _ref.AccessToken, ClockDrift = _ref.ClockDrift;
        if (AccessToken == null || IdToken == null) throw new Error('Id token and Access Token must be present.');
        this.idToken = IdToken;
        this.refreshToken = RefreshToken;
        this.accessToken = AccessToken;
        this.clockDrift = ClockDrift === undefined ? this.calculateClockDrift() : ClockDrift;
    }
    /**
   * @returns {CognitoIdToken} the session's Id token
   */ var _proto = CognitoUserSession.prototype;
    _proto.getIdToken = function getIdToken() {
        return this.idToken;
    };
    _proto.getRefreshToken = function getRefreshToken() {
        return this.refreshToken;
    };
    _proto.getAccessToken = function getAccessToken() {
        return this.accessToken;
    };
    _proto.getClockDrift = function getClockDrift() {
        return this.clockDrift;
    };
    _proto.calculateClockDrift = function calculateClockDrift() {
        var now = Math.floor(new Date() / 1000);
        var iat = Math.min(this.accessToken.getIssuedAt(), this.idToken.getIssuedAt());
        return now - iat;
    };
    _proto.isValid = function isValid() {
        var now = Math.floor(new Date() / 1000);
        var adjusted = now - this.clockDrift;
        return adjusted < this.accessToken.getExpiration() && adjusted < this.idToken.getExpiration();
    };
    return CognitoUserSession;
}();

});

parcelRegister("5PlTV", function(module, exports) {

$parcel$export(module.exports, "default", () => $43e2b43d74b8f68d$export$2e2bcd8739ae039);
/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */ var $43e2b43d74b8f68d$var$monthNames = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];
var $43e2b43d74b8f68d$var$weekNames = [
    'Sun',
    'Mon',
    'Tue',
    'Wed',
    'Thu',
    'Fri',
    'Sat'
];
/** @class */ var $43e2b43d74b8f68d$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function DateHelper() {}
    var _proto = DateHelper.prototype;
    /**
   * @returns {string} The current time in "ddd MMM D HH:mm:ss UTC YYYY" format.
   */ _proto.getNowString = function getNowString() {
        var now = new Date();
        var weekDay = $43e2b43d74b8f68d$var$weekNames[now.getUTCDay()];
        var month = $43e2b43d74b8f68d$var$monthNames[now.getUTCMonth()];
        var day = now.getUTCDate();
        var hours = now.getUTCHours();
        if (hours < 10) hours = "0" + hours;
        var minutes = now.getUTCMinutes();
        if (minutes < 10) minutes = "0" + minutes;
        var seconds = now.getUTCSeconds();
        if (seconds < 10) seconds = "0" + seconds;
        var year = now.getUTCFullYear(); // ddd MMM D HH:mm:ss UTC YYYY
        var dateNow = weekDay + " " + month + " " + day + " " + hours + ":" + minutes + ":" + seconds + " UTC " + year;
        return dateNow;
    };
    return DateHelper;
}();

});

parcelRegister("kDaVl", function(module, exports) {

$parcel$export(module.exports, "default", () => $f04fec6700f971db$export$2e2bcd8739ae039);
/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */ /** @class */ var $f04fec6700f971db$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUserAttribute object
   * @param {string=} Name The record's name
   * @param {string=} Value The record's value
   */ function CognitoUserAttribute(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, Name = _ref.Name, Value = _ref.Value;
        this.Name = Name || '';
        this.Value = Value || '';
    }
    /**
   * @returns {string} the record's value.
   */ var _proto = CognitoUserAttribute.prototype;
    _proto.getValue = function getValue() {
        return this.Value;
    };
    _proto.setValue = function setValue(value) {
        this.Value = value;
        return this;
    };
    _proto.getName = function getName() {
        return this.Name;
    };
    _proto.setName = function setName(name) {
        this.Name = name;
        return this;
    };
    _proto.toString = function toString() {
        return JSON.stringify(this);
    };
    _proto.toJSON = function toJSON() {
        return {
            Name: this.Name,
            Value: this.Value
        };
    };
    return CognitoUserAttribute;
}();

});

parcelRegister("9Jbga", function(module, exports) {

$parcel$export(module.exports, "default", () => $71510d01173c1deb$export$2e2bcd8739ae039);
/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */ var $71510d01173c1deb$var$dataMemory = {};
var $71510d01173c1deb$export$d7392285c701ecf5 = /*#__PURE__*/ function() {
    function MemoryStorage() {}
    /**
   * This is used to set a specific item in storage
   * @param {string} key - the key for the item
   * @param {object} value - the value
   * @returns {string} value that was set
   */ MemoryStorage.setItem = function setItem(key, value) {
        $71510d01173c1deb$var$dataMemory[key] = value;
        return $71510d01173c1deb$var$dataMemory[key];
    };
    MemoryStorage.getItem = function getItem(key) {
        return Object.prototype.hasOwnProperty.call($71510d01173c1deb$var$dataMemory, key) ? $71510d01173c1deb$var$dataMemory[key] : undefined;
    };
    MemoryStorage.removeItem = function removeItem(key) {
        return delete $71510d01173c1deb$var$dataMemory[key];
    };
    MemoryStorage.clear = function clear() {
        $71510d01173c1deb$var$dataMemory = {};
        return $71510d01173c1deb$var$dataMemory;
    };
    return MemoryStorage;
}();
/** @class */ var $71510d01173c1deb$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * This is used to get a storage object
   * @returns {object} the storage
   */ function StorageHelper() {
        try {
            this.storageWindow = window.localStorage;
            this.storageWindow.setItem('aws.cognito.test-ls', 1);
            this.storageWindow.removeItem('aws.cognito.test-ls');
        } catch (exception) {
            this.storageWindow = $71510d01173c1deb$export$d7392285c701ecf5;
        }
    }
    /**
   * This is used to return the storage
   * @returns {object} the storage
   */ var _proto = StorageHelper.prototype;
    _proto.getStorage = function getStorage() {
        return this.storageWindow;
    };
    return StorageHelper;
}();

});


parcelRegister("9ZqzK", function(module, exports) {

$parcel$export(module.exports, "default", () => $745e6cef63fcb5b4$export$2e2bcd8739ae039);
/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */ 
var $jL23d = parcelRequire("jL23d");

var $fEY0G = parcelRequire("fEY0G");

var $9Jbga = parcelRequire("9Jbga");
/** @class */ var $745e6cef63fcb5b4$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUserPool object
   * @param {object} data Creation options.
   * @param {string} data.UserPoolId Cognito user pool id.
   * @param {string} data.ClientId User pool application client id.
   * @param {string} data.endpoint Optional custom service endpoint.
   * @param {object} data.fetchOptions Optional options for fetch API.
   *        (only credentials option is supported)
   * @param {object} data.Storage Optional storage object.
   * @param {boolean} data.AdvancedSecurityDataCollectionFlag Optional:
   *        boolean flag indicating if the data collection is enabled
   *        to support cognito advanced security features. By default, this
   *        flag is set to true.
   */ function CognitoUserPool(data, wrapRefreshSessionCallback) {
        var _ref = data || {}, UserPoolId = _ref.UserPoolId, ClientId = _ref.ClientId, endpoint = _ref.endpoint, fetchOptions = _ref.fetchOptions, AdvancedSecurityDataCollectionFlag = _ref.AdvancedSecurityDataCollectionFlag;
        if (!UserPoolId || !ClientId) throw new Error('Both UserPoolId and ClientId are required.');
        if (!/^[\w-]+_.+$/.test(UserPoolId)) throw new Error('Invalid UserPoolId format.');
        var region = UserPoolId.split('_')[0];
        this.userPoolId = UserPoolId;
        this.clientId = ClientId;
        this.client = new (0, $jL23d.default)(region, endpoint, fetchOptions);
        /**
     * By default, AdvancedSecurityDataCollectionFlag is set to true,
     * if no input value is provided.
     */ this.advancedSecurityDataCollectionFlag = AdvancedSecurityDataCollectionFlag !== false;
        this.storage = data.Storage || new (0, $9Jbga.default)().getStorage();
        if (wrapRefreshSessionCallback) this.wrapRefreshSessionCallback = wrapRefreshSessionCallback;
    }
    /**
   * @returns {string} the user pool id
   */ var _proto = CognitoUserPool.prototype;
    _proto.getUserPoolId = function getUserPoolId() {
        return this.userPoolId;
    };
    _proto.getClientId = function getClientId() {
        return this.clientId;
    };
    _proto.signUp = function signUp(username, password, userAttributes, validationData, callback, clientMetadata) {
        var _this = this;
        var jsonReq = {
            ClientId: this.clientId,
            Username: username,
            Password: password,
            UserAttributes: userAttributes,
            ValidationData: validationData,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData(username)) jsonReq.UserContextData = this.getUserContextData(username);
        this.client.request('SignUp', jsonReq, function(err, data) {
            if (err) return callback(err, null);
            var cognitoUser = {
                Username: username,
                Pool: _this,
                Storage: _this.storage
            };
            var returnData = {
                user: new (0, $fEY0G.default)(cognitoUser),
                userConfirmed: data.UserConfirmed,
                userSub: data.UserSub,
                codeDeliveryDetails: data.CodeDeliveryDetails
            };
            return callback(null, returnData);
        });
    };
    _proto.getCurrentUser = function getCurrentUser() {
        var lastUserKey = "CognitoIdentityServiceProvider." + this.clientId + ".LastAuthUser";
        var lastAuthUser = this.storage.getItem(lastUserKey);
        if (lastAuthUser) {
            var cognitoUser = {
                Username: lastAuthUser,
                Pool: this,
                Storage: this.storage
            };
            return new (0, $fEY0G.default)(cognitoUser);
        }
        return null;
    };
    _proto.getUserContextData = function getUserContextData(username) {
        if (typeof AmazonCognitoAdvancedSecurityData === 'undefined') return undefined;
        /* eslint-disable */ var amazonCognitoAdvancedSecurityDataConst = AmazonCognitoAdvancedSecurityData;
        /* eslint-enable */ if (this.advancedSecurityDataCollectionFlag) {
            var advancedSecurityData = amazonCognitoAdvancedSecurityDataConst.getData(username, this.userPoolId, this.clientId);
            if (advancedSecurityData) {
                var userContextData = {
                    EncodedData: advancedSecurityData
                };
                return userContextData;
            }
        }
        return {};
    };
    return CognitoUserPool;
}();

});
parcelRegister("jL23d", function(module, exports) {

$parcel$export(module.exports, "default", () => $e623ff63b9dccf54$export$2e2bcd8739ae039);
parcelRequire("i1Lg4");

var $fntmR = parcelRequire("fntmR");
function $e623ff63b9dccf54$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $e623ff63b9dccf54$var$_setPrototypeOf(subClass, superClass);
}
function $e623ff63b9dccf54$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $e623ff63b9dccf54$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$e623ff63b9dccf54$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $e623ff63b9dccf54$var$_construct(Class, arguments, $e623ff63b9dccf54$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $e623ff63b9dccf54$var$_setPrototypeOf(Wrapper, Class);
    };
    return $e623ff63b9dccf54$var$_wrapNativeSuper(Class);
}
function $e623ff63b9dccf54$var$_construct(Parent, args, Class) {
    if ($e623ff63b9dccf54$var$_isNativeReflectConstruct()) $e623ff63b9dccf54$var$_construct = Reflect.construct;
    else $e623ff63b9dccf54$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $e623ff63b9dccf54$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $e623ff63b9dccf54$var$_construct.apply(null, arguments);
}
function $e623ff63b9dccf54$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $e623ff63b9dccf54$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $e623ff63b9dccf54$var$_setPrototypeOf(o, p) {
    $e623ff63b9dccf54$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $e623ff63b9dccf54$var$_setPrototypeOf(o, p);
}
function $e623ff63b9dccf54$var$_getPrototypeOf(o) {
    $e623ff63b9dccf54$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $e623ff63b9dccf54$var$_getPrototypeOf(o);
}
var $e623ff63b9dccf54$var$CognitoError = /*#__PURE__*/ function(_Error) {
    $e623ff63b9dccf54$var$_inheritsLoose(CognitoError, _Error);
    function CognitoError(message, code, name, statusCode) {
        var _this;
        _this = _Error.call(this, message) || this;
        _this.code = code;
        _this.name = name;
        _this.statusCode = statusCode;
        return _this;
    }
    return CognitoError;
}(/*#__PURE__*/ $e623ff63b9dccf54$var$_wrapNativeSuper(Error));
/** @class */ var $e623ff63b9dccf54$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new AWS Cognito Identity Provider client object
   * @param {string} region AWS region
   * @param {string} endpoint endpoint
   * @param {object} fetchOptions options for fetch API (only credentials is supported)
   */ function Client(region, endpoint, fetchOptions) {
        this.endpoint = endpoint || "https://cognito-idp." + region + ".amazonaws.com/";
        var _ref = fetchOptions || {}, credentials = _ref.credentials;
        this.fetchOptions = credentials ? {
            credentials: credentials
        } : {};
    }
    /**
   * Makes an unauthenticated request on AWS Cognito Identity Provider API
   * using fetch
   * @param {string} operation API operation
   * @param {object} params Input parameters
   * @returns Promise<object>
   */ var _proto = Client.prototype;
    _proto.promisifyRequest = function promisifyRequest(operation, params) {
        var _this2 = this;
        return new Promise(function(resolve, reject) {
            _this2.request(operation, params, function(err, data) {
                if (err) reject(new $e623ff63b9dccf54$var$CognitoError(err.message, err.code, err.name, err.statusCode));
                else resolve(data);
            });
        });
    };
    _proto.request = function request(operation, params, callback) {
        var headers = {
            'Content-Type': 'application/x-amz-json-1.1',
            'X-Amz-Target': "AWSCognitoIdentityProviderService." + operation,
            'X-Amz-User-Agent': (0, $fntmR.default).prototype.userAgent
        };
        var options = Object.assign({}, this.fetchOptions, {
            headers: headers,
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            body: JSON.stringify(params)
        });
        var response;
        var responseJsonData;
        fetch(this.endpoint, options).then(function(resp) {
            response = resp;
            return resp;
        }, function(err) {
            // If error happens here, the request failed
            // if it is TypeError throw network error
            if (err instanceof TypeError) throw new Error('Network error');
            throw err;
        }).then(function(resp) {
            return resp.json()["catch"](function() {
                return {};
            });
        }).then(function(data) {
            // return parsed body stream
            if (response.ok) return callback(null, data);
            responseJsonData = data; // Taken from aws-sdk-js/lib/protocol/json.js
            // eslint-disable-next-line no-underscore-dangle
            var code = (data.__type || data.code).split('#').pop();
            var error = {
                code: code,
                name: code,
                message: data.message || data.Message || null
            };
            return callback(error);
        })["catch"](function(err) {
            // first check if we have a service error
            if (response && response.headers && response.headers.get('x-amzn-errortype')) try {
                var code = response.headers.get('x-amzn-errortype').split(':')[0];
                var error = {
                    code: code,
                    name: code,
                    statusCode: response.status,
                    message: response.status ? response.status.toString() : null
                };
                return callback(error);
            } catch (ex) {
                return callback(err);
            } // otherwise check if error is Network error
            else if (err instanceof Error && err.message === 'Network error') {
                var _error = {
                    code: 'NetworkError',
                    name: err.name,
                    message: err.message
                };
                return callback(_error);
            } else return callback(err);
        });
    };
    return Client;
}();

});
parcelRegister("i1Lg4", function(module, exports) {


module.exports = self.fetch || (self.fetch = (parcelRequire("hcusM")).default || (parcelRequire("hcusM")));

});
parcelRegister("hcusM", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $c85b3008487ea4fd$export$2e2bcd8739ae039);
function $c85b3008487ea4fd$export$2e2bcd8739ae039(e, n) {
    return n = n || {}, new Promise(function(t, r) {
        var s = new XMLHttpRequest, o = [], u = [], i = {}, a = function() {
            return {
                ok: 2 == (s.status / 100 | 0),
                statusText: s.statusText,
                status: s.status,
                url: s.responseURL,
                text: function() {
                    return Promise.resolve(s.responseText);
                },
                json: function() {
                    return Promise.resolve(s.responseText).then(JSON.parse);
                },
                blob: function() {
                    return Promise.resolve(new Blob([
                        s.response
                    ]));
                },
                clone: a,
                headers: {
                    keys: function() {
                        return o;
                    },
                    entries: function() {
                        return u;
                    },
                    get: function(e) {
                        return i[e.toLowerCase()];
                    },
                    has: function(e) {
                        return e.toLowerCase() in i;
                    }
                }
            };
        };
        for(var l in s.open(n.method || "get", e, !0), s.onload = function() {
            s.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function(e, n, t) {
                o.push(n = n.toLowerCase()), u.push([
                    n,
                    t
                ]), i[n] = i[n] ? i[n] + "," + t : t;
            }), t(a());
        }, s.onerror = r, s.withCredentials = "include" == n.credentials, n.headers)s.setRequestHeader(l, n.headers[l]);
        s.send(n.body || null);
    });
}

});


parcelRegister("fntmR", function(module, exports) {

$parcel$export(module.exports, "default", () => $b31fc8cc20ed5401$export$2e2bcd8739ae039);
// constructor
function $b31fc8cc20ed5401$var$UserAgent() {} // public
$b31fc8cc20ed5401$var$UserAgent.prototype.userAgent = 'aws-amplify/0.1.x js';
var $b31fc8cc20ed5401$export$ad34c5a3baecdb02 = function appendToCognitoUserAgent(content) {
    if (!content) return;
    if ($b31fc8cc20ed5401$var$UserAgent.prototype.userAgent && !$b31fc8cc20ed5401$var$UserAgent.prototype.userAgent.includes(content)) $b31fc8cc20ed5401$var$UserAgent.prototype.userAgent = $b31fc8cc20ed5401$var$UserAgent.prototype.userAgent.concat(' ', content);
    if (!$b31fc8cc20ed5401$var$UserAgent.prototype.userAgent || $b31fc8cc20ed5401$var$UserAgent.prototype.userAgent === '') $b31fc8cc20ed5401$var$UserAgent.prototype.userAgent = content;
}; // class for defining the amzn user-agent
var $b31fc8cc20ed5401$export$2e2bcd8739ae039 = $b31fc8cc20ed5401$var$UserAgent;

});



parcelRegister("lQunR", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe7605e9ada90a91$export$2e2bcd8739ae039);

var $bNyLS = parcelRequire("bNyLS");
/** @class */ var $fe7605e9ada90a91$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CookieStorage object
   * @param {object} data Creation options.
   * @param {string} data.domain Cookies domain (mandatory).
   * @param {string} data.path Cookies path (default: '/')
   * @param {integer} data.expires Cookie expiration (in days, default: 365)
   * @param {boolean} data.secure Cookie secure flag (default: true)
   * @param {string} data.sameSite Cookie request behaviour (default: null)
   */ function CookieStorage(data) {
        if (data.domain) this.domain = data.domain;
        else throw new Error('The domain of cookieStorage can not be undefined.');
        if (data.path) this.path = data.path;
        else this.path = '/';
        if (Object.prototype.hasOwnProperty.call(data, 'expires')) this.expires = data.expires;
        else this.expires = 365;
        if (Object.prototype.hasOwnProperty.call(data, 'secure')) this.secure = data.secure;
        else this.secure = true;
        if (Object.prototype.hasOwnProperty.call(data, 'sameSite')) {
            if (![
                'strict',
                'lax',
                'none'
            ].includes(data.sameSite)) throw new Error('The sameSite value of cookieStorage must be "lax", "strict" or "none".');
            if (data.sameSite === 'none' && !this.secure) throw new Error('sameSite = None requires the Secure attribute in latest browser versions.');
            this.sameSite = data.sameSite;
        } else this.sameSite = null;
    }
    /**
   * This is used to set a specific item in storage
   * @param {string} key - the key for the item
   * @param {object} value - the value
   * @returns {string} value that was set
   */ var _proto = CookieStorage.prototype;
    _proto.setItem = function setItem(key, value) {
        var options = {
            path: this.path,
            expires: this.expires,
            domain: this.domain,
            secure: this.secure
        };
        if (this.sameSite) options.sameSite = this.sameSite;
        $bNyLS.set(key, value, options);
        return $bNyLS.get(key);
    };
    _proto.getItem = function getItem(key) {
        return $bNyLS.get(key);
    };
    _proto.removeItem = function removeItem(key) {
        var options = {
            path: this.path,
            expires: this.expires,
            domain: this.domain,
            secure: this.secure
        };
        if (this.sameSite) options.sameSite = this.sameSite;
        return $bNyLS.remove(key, options);
    };
    _proto.clear = function clear() {
        var cookies = $bNyLS.get();
        var numKeys = Object.keys(cookies).length;
        for(var index = 0; index < numKeys; ++index)this.removeItem(Object.keys(cookies)[index]);
        return {};
    };
    return CookieStorage;
}();

});
parcelRegister("bNyLS", function(module, exports) {
/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */ (function(factory) {
    var registeredInModuleLoader;
    if (typeof define === 'function' && define.amd) {
        define(factory);
        registeredInModuleLoader = true;
    }
    module.exports = factory();
    registeredInModuleLoader = true;
    if (!registeredInModuleLoader) {
        var OldCookies = window.Cookies;
        var api = window.Cookies = factory();
        api.noConflict = function() {
            window.Cookies = OldCookies;
            return api;
        };
    }
})(function() {
    function extend() {
        var i = 0;
        var result = {};
        for(; i < arguments.length; i++){
            var attributes = arguments[i];
            for(var key in attributes)result[key] = attributes[key];
        }
        return result;
    }
    function decode(s) {
        return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
    }
    function init(converter) {
        function api() {}
        function set(key, value, attributes) {
            if (typeof document === 'undefined') return;
            attributes = extend({
                path: '/'
            }, api.defaults, attributes);
            if (typeof attributes.expires === 'number') attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
            // We're using "expires" because "max-age" is not supported by IE
            attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';
            try {
                var result = JSON.stringify(value);
                if (/^[\{\[]/.test(result)) value = result;
            } catch (e) {}
            value = converter.write ? converter.write(value, key) : encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
            key = encodeURIComponent(String(key)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
            var stringifiedAttributes = '';
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += '; ' + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
            }
            return document.cookie = key + '=' + value + stringifiedAttributes;
        }
        function get(key, json) {
            if (typeof document === 'undefined') return;
            var jar = {};
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split('; ') : [];
            var i = 0;
            for(; i < cookies.length; i++){
                var parts = cookies[i].split('=');
                var cookie = parts.slice(1).join('=');
                if (!json && cookie.charAt(0) === '"') cookie = cookie.slice(1, -1);
                try {
                    var name = decode(parts[0]);
                    cookie = (converter.read || converter)(cookie, name) || decode(cookie);
                    if (json) try {
                        cookie = JSON.parse(cookie);
                    } catch (e) {}
                    jar[name] = cookie;
                    if (key === name) break;
                } catch (e) {}
            }
            return key ? jar[key] : jar;
        }
        api.set = set;
        api.get = function(key) {
            return get(key, false);
        };
        api.getJSON = function(key) {
            return get(key, true);
        };
        api.remove = function(key, attributes) {
            set(key, '', extend(attributes, {
                expires: -1
            }));
        };
        api.defaults = {};
        api.withConverter = init;
        return api;
    }
    return init(function() {});
});

});



parcelRegister("hXL0m", function(module, exports) {

$parcel$export(module.exports, "default", () => $d13c6882ab33443e$export$2e2bcd8739ae039);
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $kcgTr = parcelRequire("kcgTr");

var $dK5zu = parcelRequire("dK5zu");

var $br9if = parcelRequire("br9if");

var $fNaWC = parcelRequire("fNaWC");

var $7UO1b = parcelRequire("7UO1b");
var $kRjsJ = parcelRequire("kRjsJ");
var $7nP18 = parcelRequire("7nP18");

var $eCc9K = parcelRequire("eCc9K");

var $5T3DJ = parcelRequire("5T3DJ");
var $d13c6882ab33443e$var$__assign = undefined && undefined.__assign || function() {
    $d13c6882ab33443e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d13c6882ab33443e$var$__assign.apply(this, arguments);
};
var $d13c6882ab33443e$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $d13c6882ab33443e$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $d13c6882ab33443e$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $d13c6882ab33443e$var$AMPLIFY_SYMBOL = typeof Symbol !== 'undefined' && typeof Symbol.for === 'function' ? Symbol.for('amplify_default') : '@@amplify_default';
var $d13c6882ab33443e$var$dispatchAuthEvent = function(event, data, message) {
    (0, $kRjsJ.Hub).dispatch('auth', {
        event: event,
        data: data,
        message: message
    }, 'Auth', $d13c6882ab33443e$var$AMPLIFY_SYMBOL);
};
var $d13c6882ab33443e$var$logger = new (0, $7UO1b.ConsoleLogger)('OAuth');
var $d13c6882ab33443e$var$OAuth = /** @class */ function() {
    function OAuth(_a) {
        var config = _a.config, cognitoClientId = _a.cognitoClientId, _b = _a.scopes, scopes = _b === void 0 ? [] : _b;
        this._urlOpener = config.urlOpener || (0, $dK5zu.launchUri);
        this._config = config;
        this._cognitoClientId = cognitoClientId;
        if (!this.isValidScopes(scopes)) throw Error('scopes must be a String Array');
        this._scopes = scopes;
    }
    OAuth.prototype.isValidScopes = function(scopes) {
        return Array.isArray(scopes) && scopes.every(function(scope) {
            return typeof scope === 'string';
        });
    };
    OAuth.prototype.oauthSignIn = function(responseType, domain, redirectSignIn, clientId, provider, customState) {
        if (responseType === void 0) responseType = 'code';
        if (provider === void 0) provider = (0, $fNaWC.CognitoHostedUIIdentityProvider).Cognito;
        var generatedState = this._generateState(32);
        /* encodeURIComponent is not URL safe, use urlSafeEncode instead. Cognito
        single-encodes/decodes url on first sign in and double-encodes/decodes url
        when user already signed in. Using encodeURIComponent, Base32, Base64 add
        characters % or = which on further encoding becomes unsafe. '=' create issue
        for parsing query params.
        Refer: https://github.com/aws-amplify/amplify-js/issues/5218 */ var state = customState ? generatedState + "-" + (0, $7nP18.urlSafeEncode)(customState) : generatedState;
        $br9if.setState(state);
        var pkce_key = this._generateRandom(128);
        $br9if.setPKCE(pkce_key);
        var code_challenge = this._generateChallenge(pkce_key);
        var code_challenge_method = 'S256';
        var scopesString = this._scopes.join(' ');
        var queryString = Object.entries($d13c6882ab33443e$var$__assign($d13c6882ab33443e$var$__assign({
            redirect_uri: redirectSignIn,
            response_type: responseType,
            client_id: clientId,
            identity_provider: provider,
            scope: scopesString,
            state: state
        }, responseType === 'code' ? {
            code_challenge: code_challenge
        } : {}), responseType === 'code' ? {
            code_challenge_method: code_challenge_method
        } : {})).map(function(_a) {
            var _b = $d13c6882ab33443e$var$__read(_a, 2), k = _b[0], v = _b[1];
            return encodeURIComponent(k) + "=" + encodeURIComponent(v);
        }).join('&');
        var URL = "https://" + domain + "/oauth2/authorize?" + queryString;
        $d13c6882ab33443e$var$logger.debug("Redirecting to " + URL);
        this._urlOpener(URL, redirectSignIn);
    };
    OAuth.prototype._handleCodeFlow = function(currentUrl) {
        return $d13c6882ab33443e$var$__awaiter(this, void 0, void 0, function() {
            var code, currentUrlPathname, redirectSignInPathname, oAuthTokenEndpoint, client_id, redirect_uri, code_verifier, oAuthTokenBody, body, _a, access_token, refresh_token, id_token, error;
            return $d13c6882ab33443e$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        code = ((0, $kcgTr.parse)(currentUrl).query || '').split('&').map(function(pairings) {
                            return pairings.split('=');
                        }).reduce(function(accum, _a) {
                            var _b;
                            var _c = $d13c6882ab33443e$var$__read(_a, 2), k = _c[0], v = _c[1];
                            return $d13c6882ab33443e$var$__assign($d13c6882ab33443e$var$__assign({}, accum), (_b = {}, _b[k] = v, _b));
                        }, {
                            code: undefined
                        }).code;
                        currentUrlPathname = (0, $kcgTr.parse)(currentUrl).pathname || '/';
                        redirectSignInPathname = (0, $kcgTr.parse)(this._config.redirectSignIn).pathname || '/';
                        if (!code || currentUrlPathname !== redirectSignInPathname) return [
                            2 /*return*/ 
                        ];
                        oAuthTokenEndpoint = 'https://' + this._config.domain + '/oauth2/token';
                        $d13c6882ab33443e$var$dispatchAuthEvent('codeFlow', {}, "Retrieving tokens from " + oAuthTokenEndpoint);
                        client_id = (0, $fNaWC.isCognitoHostedOpts)(this._config) ? this._cognitoClientId : this._config.clientID;
                        redirect_uri = (0, $fNaWC.isCognitoHostedOpts)(this._config) ? this._config.redirectSignIn : this._config.redirectUri;
                        code_verifier = $br9if.getPKCE();
                        oAuthTokenBody = $d13c6882ab33443e$var$__assign({
                            grant_type: 'authorization_code',
                            code: code,
                            client_id: client_id,
                            redirect_uri: redirect_uri
                        }, code_verifier ? {
                            code_verifier: code_verifier
                        } : {});
                        $d13c6882ab33443e$var$logger.debug("Calling token endpoint: " + oAuthTokenEndpoint + " with", oAuthTokenBody);
                        body = Object.entries(oAuthTokenBody).map(function(_a) {
                            var _b = $d13c6882ab33443e$var$__read(_a, 2), k = _b[0], v = _b[1];
                            return encodeURIComponent(k) + "=" + encodeURIComponent(v);
                        }).join('&');
                        return [
                            4 /*yield*/ ,
                            fetch(oAuthTokenEndpoint, {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/x-www-form-urlencoded'
                                },
                                body: body
                            })
                        ];
                    case 1:
                        return [
                            4 /*yield*/ ,
                            _b.sent().json()
                        ];
                    case 2:
                        _a = _b.sent(), access_token = _a.access_token, refresh_token = _a.refresh_token, id_token = _a.id_token, error = _a.error;
                        if (error) throw new Error(error);
                        return [
                            2 /*return*/ ,
                            {
                                accessToken: access_token,
                                refreshToken: refresh_token,
                                idToken: id_token
                            }
                        ];
                }
            });
        });
    };
    OAuth.prototype._handleImplicitFlow = function(currentUrl) {
        return $d13c6882ab33443e$var$__awaiter(this, void 0, void 0, function() {
            var _a, id_token, access_token;
            return $d13c6882ab33443e$var$__generator(this, function(_b) {
                _a = ((0, $kcgTr.parse)(currentUrl).hash || '#').substr(1) // Remove # from returned code
                .split('&').map(function(pairings) {
                    return pairings.split('=');
                }).reduce(function(accum, _a) {
                    var _b;
                    var _c = $d13c6882ab33443e$var$__read(_a, 2), k = _c[0], v = _c[1];
                    return $d13c6882ab33443e$var$__assign($d13c6882ab33443e$var$__assign({}, accum), (_b = {}, _b[k] = v, _b));
                }, {
                    id_token: undefined,
                    access_token: undefined
                }), id_token = _a.id_token, access_token = _a.access_token;
                $d13c6882ab33443e$var$dispatchAuthEvent('implicitFlow', {}, "Got tokens from " + currentUrl);
                $d13c6882ab33443e$var$logger.debug("Retrieving implicit tokens from " + currentUrl + " with");
                return [
                    2 /*return*/ ,
                    {
                        accessToken: access_token,
                        idToken: id_token,
                        refreshToken: null
                    }
                ];
            });
        });
    };
    OAuth.prototype.handleAuthResponse = function(currentUrl) {
        return $d13c6882ab33443e$var$__awaiter(this, void 0, void 0, function() {
            var urlParams, error, error_description, state, _a, _b, e_1;
            return $d13c6882ab33443e$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _c.trys.push([
                            0,
                            5,
                            ,
                            6
                        ]);
                        urlParams = currentUrl ? $d13c6882ab33443e$var$__assign($d13c6882ab33443e$var$__assign({}, ((0, $kcgTr.parse)(currentUrl).hash || '#').substr(1).split('&').map(function(entry) {
                            return entry.split('=');
                        }).reduce(function(acc, _a) {
                            var _b = $d13c6882ab33443e$var$__read(_a, 2), k = _b[0], v = _b[1];
                            return acc[k] = v, acc;
                        }, {})), ((0, $kcgTr.parse)(currentUrl).query || '').split('&').map(function(entry) {
                            return entry.split('=');
                        }).reduce(function(acc, _a) {
                            var _b = $d13c6882ab33443e$var$__read(_a, 2), k = _b[0], v = _b[1];
                            return acc[k] = v, acc;
                        }, {})) : {};
                        error = urlParams.error, error_description = urlParams.error_description;
                        if (error) throw new Error(error_description);
                        state = this._validateState(urlParams);
                        $d13c6882ab33443e$var$logger.debug("Starting " + this._config.responseType + " flow with " + currentUrl);
                        if (!(this._config.responseType === 'code')) return [
                            3 /*break*/ ,
                            2
                        ];
                        _a = [
                            {}
                        ];
                        return [
                            4 /*yield*/ ,
                            this._handleCodeFlow(currentUrl)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            $d13c6882ab33443e$var$__assign.apply(void 0, [
                                $d13c6882ab33443e$var$__assign.apply(void 0, _a.concat([
                                    _c.sent()
                                ])),
                                {
                                    state: state
                                }
                            ])
                        ];
                    case 2:
                        _b = [
                            {}
                        ];
                        return [
                            4 /*yield*/ ,
                            this._handleImplicitFlow(currentUrl)
                        ];
                    case 3:
                        return [
                            2 /*return*/ ,
                            $d13c6882ab33443e$var$__assign.apply(void 0, [
                                $d13c6882ab33443e$var$__assign.apply(void 0, _b.concat([
                                    _c.sent()
                                ])),
                                {
                                    state: state
                                }
                            ])
                        ];
                    case 4:
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 5:
                        e_1 = _c.sent();
                        $d13c6882ab33443e$var$logger.error("Error handling auth response.", e_1);
                        throw e_1;
                    case 6:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    OAuth.prototype._validateState = function(urlParams) {
        if (!urlParams) return;
        var savedState = $br9if.getState();
        var returnedState = urlParams.state;
        // This is because savedState only exists if the flow was initiated by Amplify
        if (savedState && savedState !== returnedState) throw new Error('Invalid state in OAuth flow');
        return returnedState;
    };
    OAuth.prototype.signOut = function() {
        return $d13c6882ab33443e$var$__awaiter(this, void 0, void 0, function() {
            var oAuthLogoutEndpoint, client_id, signout_uri;
            return $d13c6882ab33443e$var$__generator(this, function(_a) {
                oAuthLogoutEndpoint = 'https://' + this._config.domain + '/logout?';
                client_id = (0, $fNaWC.isCognitoHostedOpts)(this._config) ? this._cognitoClientId : this._config.oauth.clientID;
                signout_uri = (0, $fNaWC.isCognitoHostedOpts)(this._config) ? this._config.redirectSignOut : this._config.returnTo;
                oAuthLogoutEndpoint += Object.entries({
                    client_id: client_id,
                    logout_uri: encodeURIComponent(signout_uri)
                }).map(function(_a) {
                    var _b = $d13c6882ab33443e$var$__read(_a, 2), k = _b[0], v = _b[1];
                    return k + "=" + v;
                }).join('&');
                $d13c6882ab33443e$var$dispatchAuthEvent('oAuthSignOut', {
                    oAuth: 'signOut'
                }, "Signing out from " + oAuthLogoutEndpoint);
                $d13c6882ab33443e$var$logger.debug("Signing out from " + oAuthLogoutEndpoint);
                return [
                    2 /*return*/ ,
                    this._urlOpener(oAuthLogoutEndpoint)
                ];
            });
        });
    };
    OAuth.prototype._generateState = function(length) {
        var result = '';
        var i = length;
        var chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
        for(; i > 0; --i)result += chars[Math.round(Math.random() * (chars.length - 1))];
        return result;
    };
    OAuth.prototype._generateChallenge = function(code) {
        return this._base64URL((0, (/*@__PURE__*/$parcel$interopDefault($eCc9K)))(code));
    };
    OAuth.prototype._base64URL = function(string) {
        return string.toString((0, (/*@__PURE__*/$parcel$interopDefault($5T3DJ)))).replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
    };
    OAuth.prototype._generateRandom = function(size) {
        var CHARSET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
        var buffer = new Uint8Array(size);
        if (typeof window !== 'undefined' && !!window.crypto) window.crypto.getRandomValues(buffer);
        else for(var i = 0; i < size; i += 1)buffer[i] = Math.random() * CHARSET.length | 0;
        return this._bufferToString(buffer);
    };
    OAuth.prototype._bufferToString = function(buffer) {
        var CHARSET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var state = [];
        for(var i = 0; i < buffer.byteLength; i += 1){
            var index = buffer[i] % CHARSET.length;
            state.push(CHARSET[index]);
        }
        return state.join('');
    };
    return OAuth;
}();
var $d13c6882ab33443e$export$2e2bcd8739ae039 = $d13c6882ab33443e$var$OAuth;

});
parcelRegister("dK5zu", function(module, exports) {

$parcel$export(module.exports, "launchUri", () => $a013e49f3156e42a$export$9b38228bd9928080);
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ var $a013e49f3156e42a$var$SELF = '_self';
var $a013e49f3156e42a$export$9b38228bd9928080 = function(url) {
    var windowProxy = window.open(url, $a013e49f3156e42a$var$SELF);
    if (windowProxy) return Promise.resolve(windowProxy);
    else return Promise.reject();
};

});

parcelRegister("br9if", function(module, exports) {

$parcel$export(module.exports, "setState", () => $85396ccf515bff41$export$42fffed799c298bb);
$parcel$export(module.exports, "getState", () => $85396ccf515bff41$export$50fdfeece43146fd);
$parcel$export(module.exports, "setPKCE", () => $85396ccf515bff41$export$14934cb45d589fa1);
$parcel$export(module.exports, "getPKCE", () => $85396ccf515bff41$export$742ac7ded61fbfce);
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ var $85396ccf515bff41$export$42fffed799c298bb = function(state) {
    window.sessionStorage.setItem('oauth_state', state);
};
var $85396ccf515bff41$export$50fdfeece43146fd = function() {
    var oauth_state = window.sessionStorage.getItem('oauth_state');
    window.sessionStorage.removeItem('oauth_state');
    return oauth_state;
};
var $85396ccf515bff41$export$14934cb45d589fa1 = function(private_key) {
    window.sessionStorage.setItem('ouath_pkce_key', private_key);
};
var $85396ccf515bff41$export$742ac7ded61fbfce = function() {
    var ouath_pkce_key = window.sessionStorage.getItem('ouath_pkce_key');
    window.sessionStorage.removeItem('ouath_pkce_key');
    return ouath_pkce_key;
};
var $85396ccf515bff41$export$1042faa6df30c26 = function() {
    window.sessionStorage.removeItem('ouath_pkce_key');
    window.sessionStorage.removeItem('oauth_state');
};

});


parcelRegister("015h2", function(module, exports) {

$parcel$export(module.exports, "default", () => $00342f5ff3947e81$export$2e2bcd8739ae039);
/*
 * Copyright 2017-2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $9Mfkr = parcelRequire("9Mfkr");
var $00342f5ff3947e81$export$2e2bcd8739ae039 = function(callback) {
    if ((0, $9Mfkr.JS).browserOrNode().isBrowser && window.location) {
        var url = window.location.href;
        callback({
            url: url
        });
    } else if ((0, $9Mfkr.JS).browserOrNode().isNode) ;
    else throw new Error('Not supported');
};

});

parcelRegister("1j1w1", function(module, exports) {

$parcel$export(module.exports, "AuthError", () => $0f38bdb83a62a730$export$145273558d58e0ac);
$parcel$export(module.exports, "NoUserPoolError", () => $0f38bdb83a62a730$export$71192787e041818c);
/*
 * Copyright 2019-2020 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $7UO1b = parcelRequire("7UO1b");

var $dVO7t = parcelRequire("dVO7t");
var $0f38bdb83a62a730$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $0f38bdb83a62a730$var$logger = new (0, $7UO1b.ConsoleLogger)('AuthError');
var $0f38bdb83a62a730$export$145273558d58e0ac = /** @class */ function(_super) {
    $0f38bdb83a62a730$var$__extends(AuthError, _super);
    function AuthError(type) {
        var _this = this;
        var _a = $0f38bdb83a62a730$export$d8113b8d790509a4[type], message = _a.message, log = _a.log;
        _this = _super.call(this, message) || this;
        // Hack for making the custom error class work when transpiled to es5
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        _this.constructor = AuthError;
        Object.setPrototypeOf(_this, AuthError.prototype);
        _this.name = 'AuthError';
        _this.log = log || message;
        $0f38bdb83a62a730$var$logger.error(_this.log);
        return _this;
    }
    return AuthError;
}(Error);
var $0f38bdb83a62a730$export$71192787e041818c = /** @class */ function(_super) {
    $0f38bdb83a62a730$var$__extends(NoUserPoolError, _super);
    function NoUserPoolError(type) {
        var _this = _super.call(this, type) || this;
        // Hack for making the custom error class work when transpiled to es5
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        _this.constructor = NoUserPoolError;
        Object.setPrototypeOf(_this, NoUserPoolError.prototype);
        _this.name = 'NoUserPoolError';
        return _this;
    }
    return NoUserPoolError;
}($0f38bdb83a62a730$export$145273558d58e0ac);
var $0f38bdb83a62a730$export$d8113b8d790509a4 = {
    noConfig: {
        message: (0, $dVO7t.AuthErrorStrings).DEFAULT_MSG,
        log: "\n            Error: Amplify has not been configured correctly.\n            This error is typically caused by one of the following scenarios:\n\n            1. Make sure you're passing the awsconfig object to Amplify.configure() in your app's entry point\n                See https://aws-amplify.github.io/docs/js/authentication#configure-your-app for more information\n            \n            2. There might be multiple conflicting versions of amplify packages in your node_modules.\n\t\t\t\tRefer to our docs site for help upgrading Amplify packages (https://docs.amplify.aws/lib/troubleshooting/upgrading/q/platform/js)\n        "
    },
    missingAuthConfig: {
        message: (0, $dVO7t.AuthErrorStrings).DEFAULT_MSG,
        log: "\n            Error: Amplify has not been configured correctly. \n            The configuration object is missing required auth properties.\n            This error is typically caused by one of the following scenarios:\n\n            1. Did you run `amplify push` after adding auth via `amplify add auth`?\n                See https://aws-amplify.github.io/docs/js/authentication#amplify-project-setup for more information\n\n            2. This could also be caused by multiple conflicting versions of amplify packages, see (https://docs.amplify.aws/lib/troubleshooting/upgrading/q/platform/js) for help upgrading Amplify packages.\n        "
    },
    emptyUsername: {
        message: (0, $dVO7t.AuthErrorStrings).EMPTY_USERNAME
    },
    // TODO: should include a list of valid sign-in types
    invalidUsername: {
        message: (0, $dVO7t.AuthErrorStrings).INVALID_USERNAME
    },
    emptyPassword: {
        message: (0, $dVO7t.AuthErrorStrings).EMPTY_PASSWORD
    },
    emptyCode: {
        message: (0, $dVO7t.AuthErrorStrings).EMPTY_CODE
    },
    signUpError: {
        message: (0, $dVO7t.AuthErrorStrings).SIGN_UP_ERROR,
        log: 'The first parameter should either be non-null string or object'
    },
    noMFA: {
        message: (0, $dVO7t.AuthErrorStrings).NO_MFA
    },
    invalidMFA: {
        message: (0, $dVO7t.AuthErrorStrings).INVALID_MFA
    },
    emptyChallengeResponse: {
        message: (0, $dVO7t.AuthErrorStrings).EMPTY_CHALLENGE
    },
    noUserSession: {
        message: (0, $dVO7t.AuthErrorStrings).NO_USER_SESSION
    },
    default: {
        message: (0, $dVO7t.AuthErrorStrings).DEFAULT_MSG
    }
};

});
parcelRegister("dVO7t", function(module, exports) {

$parcel$export(module.exports, "AuthErrorStrings", () => $a24779f347337381$export$c3070468b9d65120);
var $a24779f347337381$export$c3070468b9d65120;
(function(AuthErrorStrings) {
    AuthErrorStrings["DEFAULT_MSG"] = "Authentication Error";
    AuthErrorStrings["EMPTY_USERNAME"] = "Username cannot be empty";
    AuthErrorStrings["INVALID_USERNAME"] = "The username should either be a string or one of the sign in types";
    AuthErrorStrings["EMPTY_PASSWORD"] = "Password cannot be empty";
    AuthErrorStrings["EMPTY_CODE"] = "Confirmation code cannot be empty";
    AuthErrorStrings["SIGN_UP_ERROR"] = "Error creating account";
    AuthErrorStrings["NO_MFA"] = "No valid MFA method provided";
    AuthErrorStrings["INVALID_MFA"] = "Invalid MFA type";
    AuthErrorStrings["EMPTY_CHALLENGE"] = "Challenge response cannot be empty";
    AuthErrorStrings["NO_USER_SESSION"] = "Failed to get the session because the user is empty";
})($a24779f347337381$export$c3070468b9d65120 || ($a24779f347337381$export$c3070468b9d65120 = {}));

});




parcelRegister("8SrNO", function(module, exports) {

$parcel$export(module.exports, "default", () => $6768eedb0ba65213$export$2e2bcd8739ae039);
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ parcelRequire("8qWqv");
var $a16qJ = parcelRequire("a16qJ");

var $188n6 = parcelRequire("188n6");

var /**
 * @deprecated use named import
 */ $6768eedb0ba65213$export$2e2bcd8739ae039 = (0, $188n6.BrowserStorageCache);
(0, $a16qJ.Amplify).register((0, $188n6.BrowserStorageCache));

});
parcelRegister("188n6", function(module, exports) {

$parcel$export(module.exports, "BrowserStorageCache", () => $0d2d083a8657c158$export$2a9787695d97e2c4);
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $33OP4 = parcelRequire("33OP4");

var $1BEUu = parcelRequire("1BEUu");

var $7UO1b = parcelRequire("7UO1b");
var $0d2d083a8657c158$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $0d2d083a8657c158$var$logger = new (0, $7UO1b.ConsoleLogger)('Cache');
/**
 * Customized storage based on the SessionStorage or LocalStorage with LRU implemented
 */ var $0d2d083a8657c158$export$e6fda0405fa98d6d = /** @class */ function(_super) {
    $0d2d083a8657c158$var$__extends(BrowserStorageCacheClass, _super);
    /**
     * initialize the cache
     * @param config - the configuration of the cache
     */ function BrowserStorageCacheClass(config) {
        var _this = this;
        var cacheConfig = config ? Object.assign({}, (0, $33OP4.defaultConfig), config) : (0, $33OP4.defaultConfig);
        _this = _super.call(this, cacheConfig) || this;
        _this.config.storage = cacheConfig.storage;
        _this.getItem = _this.getItem.bind(_this);
        _this.setItem = _this.setItem.bind(_this);
        _this.removeItem = _this.removeItem.bind(_this);
        return _this;
    }
    /**
     * decrease current size of the cache
     *
     * @private
     * @param amount - the amount of the cache size which needs to be decreased
     */ BrowserStorageCacheClass.prototype._decreaseCurSizeInBytes = function(amount) {
        var curSize = this.getCacheCurSize();
        this.config.storage.setItem(this.cacheCurSizeKey, (curSize - amount).toString());
    };
    /**
     * increase current size of the cache
     *
     * @private
     * @param amount - the amount of the cache szie which need to be increased
     */ BrowserStorageCacheClass.prototype._increaseCurSizeInBytes = function(amount) {
        var curSize = this.getCacheCurSize();
        this.config.storage.setItem(this.cacheCurSizeKey, (curSize + amount).toString());
    };
    /**
     * update the visited time if item has been visited
     *
     * @private
     * @param item - the item which need to be refreshed
     * @param prefixedKey - the key of the item
     *
     * @return the refreshed item
     */ BrowserStorageCacheClass.prototype._refreshItem = function(item, prefixedKey) {
        item.visitedTime = (0, $33OP4.getCurrTime)();
        this.config.storage.setItem(prefixedKey, JSON.stringify(item));
        return item;
    };
    /**
     * check wether item is expired
     *
     * @private
     * @param key - the key of the item
     *
     * @return true if the item is expired.
     */ BrowserStorageCacheClass.prototype._isExpired = function(key) {
        var text = this.config.storage.getItem(key);
        var item = JSON.parse(text);
        if ((0, $33OP4.getCurrTime)() >= item.expires) return true;
        return false;
    };
    /**
     * delete item from cache
     *
     * @private
     * @param prefixedKey - the key of the item
     * @param size - optional, the byte size of the item
     */ BrowserStorageCacheClass.prototype._removeItem = function(prefixedKey, size) {
        var itemSize = size ? size : JSON.parse(this.config.storage.getItem(prefixedKey)).byteSize;
        this._decreaseCurSizeInBytes(itemSize);
        // remove the cache item
        this.config.storage.removeItem(prefixedKey);
    };
    /**
     * put item into cache
     *
     * @private
     * @param prefixedKey - the key of the item
     * @param itemData - the value of the item
     * @param itemSizeInBytes - the byte size of the item
     */ BrowserStorageCacheClass.prototype._setItem = function(prefixedKey, item) {
        // update the cache size
        this._increaseCurSizeInBytes(item.byteSize);
        try {
            this.config.storage.setItem(prefixedKey, JSON.stringify(item));
        } catch (setItemErr) {
            // if failed, we need to rollback the cache size
            this._decreaseCurSizeInBytes(item.byteSize);
            $0d2d083a8657c158$var$logger.error("Failed to set item " + setItemErr);
        }
    };
    /**
     * total space needed when poping out items
     *
     * @private
     * @param itemSize
     *
     * @return total space needed
     */ BrowserStorageCacheClass.prototype._sizeToPop = function(itemSize) {
        var spaceItemNeed = this.getCacheCurSize() + itemSize - this.config.capacityInBytes;
        var cacheThresholdSpace = (1 - this.config.warningThreshold) * this.config.capacityInBytes;
        return spaceItemNeed > cacheThresholdSpace ? spaceItemNeed : cacheThresholdSpace;
    };
    /**
     * see whether cache is full
     *
     * @private
     * @param itemSize
     *
     * @return true if cache is full
     */ BrowserStorageCacheClass.prototype._isCacheFull = function(itemSize) {
        return itemSize + this.getCacheCurSize() > this.config.capacityInBytes;
    };
    /**
     * scan the storage and find out all the keys owned by this cache
     * also clean the expired keys while scanning
     *
     * @private
     *
     * @return array of keys
     */ BrowserStorageCacheClass.prototype._findValidKeys = function() {
        var keys = [];
        var keyInCache = [];
        // get all keys in Storage
        for(var i = 0; i < this.config.storage.length; i += 1)keyInCache.push(this.config.storage.key(i));
        // find those items which belong to our cache and also clean those expired items
        for(var i = 0; i < keyInCache.length; i += 1){
            var key = keyInCache[i];
            if (key.indexOf(this.config.keyPrefix) === 0 && key !== this.cacheCurSizeKey) {
                if (this._isExpired(key)) this._removeItem(key);
                else keys.push(key);
            }
        }
        return keys;
    };
    /**
     * get all the items we have, sort them by their priority,
     * if priority is same, sort them by their last visited time
     * pop out items from the low priority (5 is the lowest)
     *
     * @private
     * @param keys - all the keys in this cache
     * @param sizeToPop - the total size of the items which needed to be poped out
     */ BrowserStorageCacheClass.prototype._popOutItems = function(keys, sizeToPop) {
        var items = [];
        var remainedSize = sizeToPop;
        // get the items from Storage
        for(var i = 0; i < keys.length; i += 1){
            var val = this.config.storage.getItem(keys[i]);
            if (val != null) {
                var item = JSON.parse(val);
                items.push(item);
            }
        }
        // first compare priority
        // then compare visited time
        items.sort(function(a, b) {
            if (a.priority > b.priority) return -1;
            else if (a.priority < b.priority) return 1;
            else {
                if (a.visitedTime < b.visitedTime) return -1;
                else return 1;
            }
        });
        for(var i = 0; i < items.length; i += 1){
            // pop out items until we have enough room for new item
            this._removeItem(items[i].key, items[i].byteSize);
            remainedSize -= items[i].byteSize;
            if (remainedSize <= 0) return;
        }
    };
    /**
     * Set item into cache. You can put number, string, boolean or object.
     * The cache will first check whether has the same key.
     * If it has, it will delete the old item and then put the new item in
     * The cache will pop out items if it is full
     * You can specify the cache item options. The cache will abort and output a warning:
     * If the key is invalid
     * If the size of the item exceeds itemMaxSize.
     * If the value is undefined
     * If incorrect cache item configuration
     * If error happened with browser storage
     *
     * @param key - the key of the item
     * @param value - the value of the item
     * @param {Object} [options] - optional, the specified meta-data
     */ BrowserStorageCacheClass.prototype.setItem = function(key, value, options) {
        $0d2d083a8657c158$var$logger.log("Set item: key is " + key + ", value is " + value + " with options: " + options);
        var prefixedKey = this.config.keyPrefix + key;
        // invalid keys
        if (prefixedKey === this.config.keyPrefix || prefixedKey === this.cacheCurSizeKey) {
            $0d2d083a8657c158$var$logger.warn("Invalid key: should not be empty or 'CurSize'");
            return;
        }
        if (typeof value === 'undefined') {
            $0d2d083a8657c158$var$logger.warn("The value of item should not be undefined!");
            return;
        }
        var cacheItemOptions = {
            priority: options && options.priority !== undefined ? options.priority : this.config.defaultPriority,
            expires: options && options.expires !== undefined ? options.expires : this.config.defaultTTL + (0, $33OP4.getCurrTime)()
        };
        if (cacheItemOptions.priority < 1 || cacheItemOptions.priority > 5) {
            $0d2d083a8657c158$var$logger.warn("Invalid parameter: priority due to out or range. It should be within 1 and 5.");
            return;
        }
        var item = this.fillCacheItem(prefixedKey, value, cacheItemOptions);
        // check wether this item is too big;
        if (item.byteSize > this.config.itemMaxSize) {
            $0d2d083a8657c158$var$logger.warn("Item with key: " + key + " you are trying to put into is too big!");
            return;
        }
        try {
            // first look into the storage, if it exists, delete it.
            var val = this.config.storage.getItem(prefixedKey);
            if (val) this._removeItem(prefixedKey, JSON.parse(val).byteSize);
            // check whether the cache is full
            if (this._isCacheFull(item.byteSize)) {
                var validKeys = this._findValidKeys();
                // check again and then pop out items
                if (this._isCacheFull(item.byteSize)) {
                    var sizeToPop = this._sizeToPop(item.byteSize);
                    this._popOutItems(validKeys, sizeToPop);
                }
            }
            // put item in the cache
            // may failed due to storage full
            this._setItem(prefixedKey, item);
        } catch (e) {
            $0d2d083a8657c158$var$logger.warn("setItem failed! " + e);
        }
    };
    /**
     * Get item from cache. It will return null if item doesn’t exist or it has been expired.
     * If you specified callback function in the options,
     * then the function will be executed if no such item in the cache
     * and finally put the return value into cache.
     * Please make sure the callback function will return the value you want to put into the cache.
     * The cache will abort output a warning:
     * If the key is invalid
     * If error happened with browser storage
     *
     * @param key - the key of the item
     * @param {Object} [options] - the options of callback function
     *
     * @return - return the value of the item
     */ BrowserStorageCacheClass.prototype.getItem = function(key, options) {
        $0d2d083a8657c158$var$logger.log("Get item: key is " + key + " with options " + options);
        var ret = null;
        var prefixedKey = this.config.keyPrefix + key;
        if (prefixedKey === this.config.keyPrefix || prefixedKey === this.cacheCurSizeKey) {
            $0d2d083a8657c158$var$logger.warn("Invalid key: should not be empty or 'CurSize'");
            return null;
        }
        try {
            ret = this.config.storage.getItem(prefixedKey);
            if (ret != null) {
                if (this._isExpired(prefixedKey)) {
                    // if expired, remove that item and return null
                    this._removeItem(prefixedKey, JSON.parse(ret).byteSize);
                    ret = null;
                } else {
                    // if not expired, great, return the value and refresh it
                    var item = JSON.parse(ret);
                    item = this._refreshItem(item, prefixedKey);
                    return item.data;
                }
            }
            if (options && options.callback !== undefined) {
                var val = options.callback();
                if (val !== null) this.setItem(key, val, options);
                return val;
            }
            return null;
        } catch (e) {
            $0d2d083a8657c158$var$logger.warn("getItem failed! " + e);
            return null;
        }
    };
    /**
     * remove item from the cache
     * The cache will abort output a warning:
     * If error happened with browser storage
     * @param key - the key of the item
     */ BrowserStorageCacheClass.prototype.removeItem = function(key) {
        $0d2d083a8657c158$var$logger.log("Remove item: key is " + key);
        var prefixedKey = this.config.keyPrefix + key;
        if (prefixedKey === this.config.keyPrefix || prefixedKey === this.cacheCurSizeKey) return;
        try {
            var val = this.config.storage.getItem(prefixedKey);
            if (val) this._removeItem(prefixedKey, JSON.parse(val).byteSize);
        } catch (e) {
            $0d2d083a8657c158$var$logger.warn("removeItem failed! " + e);
        }
    };
    /**
     * clear the entire cache
     * The cache will abort output a warning:
     * If error happened with browser storage
     */ BrowserStorageCacheClass.prototype.clear = function() {
        $0d2d083a8657c158$var$logger.log("Clear Cache");
        var keysToRemove = [];
        for(var i = 0; i < this.config.storage.length; i += 1){
            var key = this.config.storage.key(i);
            if (key.indexOf(this.config.keyPrefix) === 0) keysToRemove.push(key);
        }
        try {
            for(var i = 0; i < keysToRemove.length; i += 1)this.config.storage.removeItem(keysToRemove[i]);
        } catch (e) {
            $0d2d083a8657c158$var$logger.warn("clear failed! " + e);
        }
    };
    /**
     * Return all the keys in the cache.
     *
     * @return - all keys in the cache
     */ BrowserStorageCacheClass.prototype.getAllKeys = function() {
        var keys = [];
        for(var i = 0; i < this.config.storage.length; i += 1){
            var key = this.config.storage.key(i);
            if (key.indexOf(this.config.keyPrefix) === 0 && key !== this.cacheCurSizeKey) keys.push(key.substring(this.config.keyPrefix.length));
        }
        return keys;
    };
    /**
     * return the current size of the cache
     *
     * @return - current size of the cache
     */ BrowserStorageCacheClass.prototype.getCacheCurSize = function() {
        var ret = this.config.storage.getItem(this.cacheCurSizeKey);
        if (!ret) {
            this.config.storage.setItem(this.cacheCurSizeKey, '0');
            ret = '0';
        }
        return Number(ret);
    };
    /**
     * Return a new instance of cache with customized configuration.
     * @param config - the customized configuration
     *
     * @return - new instance of Cache
     */ BrowserStorageCacheClass.prototype.createInstance = function(config) {
        if (!config.keyPrefix || config.keyPrefix === (0, $33OP4.defaultConfig).keyPrefix) {
            $0d2d083a8657c158$var$logger.error('invalid keyPrefix, setting keyPrefix with timeStamp');
            config.keyPrefix = (0, $33OP4.getCurrTime).toString();
        }
        return new BrowserStorageCacheClass(config);
    };
    return BrowserStorageCacheClass;
}((0, $1BEUu.StorageCache));
var $0d2d083a8657c158$export$2a9787695d97e2c4 = new $0d2d083a8657c158$export$e6fda0405fa98d6d();
var /**
 * @deprecated use named import
 */ $0d2d083a8657c158$export$2e2bcd8739ae039 = $0d2d083a8657c158$export$2a9787695d97e2c4;

});
parcelRegister("33OP4", function(module, exports) {

$parcel$export(module.exports, "defaultConfig", () => $23a91337b082def3$export$f84bd70098573c5c);
$parcel$export(module.exports, "getByteLength", () => $23a91337b082def3$export$cc8c3b705bb8e6e2);
$parcel$export(module.exports, "getCurrTime", () => $23a91337b082def3$export$dd144842d7b22d3a);
$parcel$export(module.exports, "isInteger", () => $23a91337b082def3$export$a287f47fed4544b8);
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $4uQfD = parcelRequire("4uQfD");
var $23a91337b082def3$export$f84bd70098573c5c = {
    keyPrefix: 'aws-amplify-cache',
    capacityInBytes: 1048576,
    itemMaxSize: 210000,
    defaultTTL: 259200000,
    defaultPriority: 5,
    warningThreshold: 0.8,
    // the storage helper will check if localStorage exists,
    // if not, will use a in-memory object instead
    storage: new (0, $4uQfD.StorageHelper)().getStorage()
};
function $23a91337b082def3$export$cc8c3b705bb8e6e2(str) {
    var ret = 0;
    ret = str.length;
    for(var i = str.length; i >= 0; i -= 1){
        var charCode = str.charCodeAt(i);
        if (charCode > 0x7f && charCode <= 0x7ff) ret += 1;
        else if (charCode > 0x7ff && charCode <= 0xffff) ret += 2;
        // trail surrogate
        if (charCode >= 0xdc00 && charCode <= 0xdfff) i -= 1;
    }
    return ret;
}
function $23a91337b082def3$export$dd144842d7b22d3a() {
    var currTime = new Date();
    return currTime.getTime();
}
function $23a91337b082def3$export$a287f47fed4544b8(value) {
    if (Number.isInteger) return Number.isInteger(value);
    return $23a91337b082def3$var$_isInteger(value);
}
function $23a91337b082def3$var$_isInteger(value) {
    return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
}
/**
 * provide an object as the in-memory cache
 */ var $23a91337b082def3$var$store = {};
var $23a91337b082def3$export$2dd5b9e5ba192a1a = /** @class */ function() {
    function CacheObject() {}
    CacheObject.clear = function() {
        $23a91337b082def3$var$store = {};
    };
    CacheObject.getItem = function(key) {
        return $23a91337b082def3$var$store[key] || null;
    };
    CacheObject.setItem = function(key, value) {
        $23a91337b082def3$var$store[key] = value;
    };
    CacheObject.removeItem = function(key) {
        delete $23a91337b082def3$var$store[key];
    };
    return CacheObject;
}();

});

parcelRegister("1BEUu", function(module, exports) {

$parcel$export(module.exports, "StorageCache", () => $12b8fb10f06410c2$export$947ed1997bd112b4);
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $33OP4 = parcelRequire("33OP4");

var $7UO1b = parcelRequire("7UO1b");
var $12b8fb10f06410c2$var$logger = new (0, $7UO1b.ConsoleLogger)('StorageCache');
/**
 * Initialization of the cache
 *
 */ var $12b8fb10f06410c2$export$947ed1997bd112b4 = /** @class */ function() {
    /**
     * Initialize the cache
     * @param config - the configuration of the cache
     */ function StorageCache(config) {
        this.config = Object.assign({}, config);
        this.cacheCurSizeKey = this.config.keyPrefix + 'CurSize';
        this.checkConfig();
    }
    StorageCache.prototype.getModuleName = function() {
        return 'Cache';
    };
    StorageCache.prototype.checkConfig = function() {
        // check configuration
        if (!(0, $33OP4.isInteger)(this.config.capacityInBytes)) {
            $12b8fb10f06410c2$var$logger.error('Invalid parameter: capacityInBytes. It should be an Integer. Setting back to default.');
            this.config.capacityInBytes = (0, $33OP4.defaultConfig).capacityInBytes;
        }
        if (!(0, $33OP4.isInteger)(this.config.itemMaxSize)) {
            $12b8fb10f06410c2$var$logger.error('Invalid parameter: itemMaxSize. It should be an Integer. Setting back to default.');
            this.config.itemMaxSize = (0, $33OP4.defaultConfig).itemMaxSize;
        }
        if (!(0, $33OP4.isInteger)(this.config.defaultTTL)) {
            $12b8fb10f06410c2$var$logger.error('Invalid parameter: defaultTTL. It should be an Integer. Setting back to default.');
            this.config.defaultTTL = (0, $33OP4.defaultConfig).defaultTTL;
        }
        if (!(0, $33OP4.isInteger)(this.config.defaultPriority)) {
            $12b8fb10f06410c2$var$logger.error('Invalid parameter: defaultPriority. It should be an Integer. Setting back to default.');
            this.config.defaultPriority = (0, $33OP4.defaultConfig).defaultPriority;
        }
        if (this.config.itemMaxSize > this.config.capacityInBytes) {
            $12b8fb10f06410c2$var$logger.error('Invalid parameter: itemMaxSize. It should be smaller than capacityInBytes. Setting back to default.');
            this.config.itemMaxSize = (0, $33OP4.defaultConfig).itemMaxSize;
        }
        if (this.config.defaultPriority > 5 || this.config.defaultPriority < 1) {
            $12b8fb10f06410c2$var$logger.error('Invalid parameter: defaultPriority. It should be between 1 and 5. Setting back to default.');
            this.config.defaultPriority = (0, $33OP4.defaultConfig).defaultPriority;
        }
        if (Number(this.config.warningThreshold) > 1 || Number(this.config.warningThreshold) < 0) {
            $12b8fb10f06410c2$var$logger.error('Invalid parameter: warningThreshold. It should be between 0 and 1. Setting back to default.');
            this.config.warningThreshold = (0, $33OP4.defaultConfig).warningThreshold;
        }
        // set 5MB limit
        var cacheLimit = 5242880;
        if (this.config.capacityInBytes > cacheLimit) {
            $12b8fb10f06410c2$var$logger.error('Cache Capacity should be less than 5MB. Setting back to default. Setting back to default.');
            this.config.capacityInBytes = (0, $33OP4.defaultConfig).capacityInBytes;
        }
    };
    /**
     * produce a JSON object with meta-data and data value
     * @param value - the value of the item
     * @param options - optional, the specified meta-data
     *
     * @return - the item which has the meta-data and the value
     */ StorageCache.prototype.fillCacheItem = function(key, value, options) {
        var ret = {
            key: key,
            data: value,
            timestamp: (0, $33OP4.getCurrTime)(),
            visitedTime: (0, $33OP4.getCurrTime)(),
            priority: options.priority,
            expires: options.expires,
            type: typeof value,
            byteSize: 0
        };
        ret.byteSize = (0, $33OP4.getByteLength)(JSON.stringify(ret));
        // for accurate size
        ret.byteSize = (0, $33OP4.getByteLength)(JSON.stringify(ret));
        return ret;
    };
    /**
     * set cache with customized configuration
     * @param config - customized configuration
     *
     * @return - the current configuration
     */ StorageCache.prototype.configure = function(config) {
        if (!config) return this.config;
        if (config.keyPrefix) $12b8fb10f06410c2$var$logger.warn("Don't try to configure keyPrefix!");
        this.config = Object.assign({}, this.config, config, config.Cache);
        this.checkConfig();
        return this.config;
    };
    return StorageCache;
}();
var /**
 * @deprecated use named import
 */ $12b8fb10f06410c2$export$2e2bcd8739ae039 = $12b8fb10f06410c2$export$947ed1997bd112b4;

});



parcelRegister("iqXB7", function(module, exports) {
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $hnLpK = parcelRequire("hnLpK");
parcelRequire("8qWqv");
var $a16qJ = parcelRequire("a16qJ");
var $7UO1b = parcelRequire("7UO1b");

var $d6b8e295d05dbedd$var$__assign = undefined && undefined.__assign || function() {
    $d6b8e295d05dbedd$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d6b8e295d05dbedd$var$__assign.apply(this, arguments);
};
var $d6b8e295d05dbedd$var$logger = new (0, $7UO1b.ConsoleLogger)('Storage');
var $d6b8e295d05dbedd$var$_instance = null;
var $d6b8e295d05dbedd$var$getInstance = function() {
    if ($d6b8e295d05dbedd$var$_instance) return $d6b8e295d05dbedd$var$_instance;
    $d6b8e295d05dbedd$var$logger.debug('Create Storage Instance, debug');
    $d6b8e295d05dbedd$var$_instance = new (0, $hnLpK.Storage)();
    $d6b8e295d05dbedd$var$_instance.vault = new (0, $hnLpK.Storage)();
    var old_configure = $d6b8e295d05dbedd$var$_instance.configure;
    $d6b8e295d05dbedd$var$_instance.configure = function(options) {
        $d6b8e295d05dbedd$var$logger.debug('storage configure called');
        var vaultConfig = $d6b8e295d05dbedd$var$__assign({}, old_configure.call($d6b8e295d05dbedd$var$_instance, options));
        // set level private for each provider for the vault
        Object.keys(vaultConfig).forEach(function(providerName) {
            if (typeof vaultConfig[providerName] !== 'string') vaultConfig[providerName] = $d6b8e295d05dbedd$var$__assign($d6b8e295d05dbedd$var$__assign({}, vaultConfig[providerName]), {
                level: 'private'
            });
        });
        $d6b8e295d05dbedd$var$logger.debug('storage vault configure called');
        $d6b8e295d05dbedd$var$_instance.vault.configure(vaultConfig);
    };
    return $d6b8e295d05dbedd$var$_instance;
};
var $d6b8e295d05dbedd$export$bf2a15d34f3c441c = $d6b8e295d05dbedd$var$getInstance();
(0, $a16qJ.Amplify).register($d6b8e295d05dbedd$export$bf2a15d34f3c441c);
var /**
 * @deprecated use named import
 */ $d6b8e295d05dbedd$export$2e2bcd8739ae039 = $d6b8e295d05dbedd$export$bf2a15d34f3c441c;

});
parcelRegister("hnLpK", function(module, exports) {

$parcel$export(module.exports, "Storage", () => $ca795d204689dac3$export$bf2a15d34f3c441c);
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $7UO1b = parcelRequire("7UO1b");
var $7XN1x = parcelRequire("7XN1x");

var $lKEWW = parcelRequire("lKEWW");

var $iFJFJ = parcelRequire("iFJFJ");
var $ca795d204689dac3$var$__assign = undefined && undefined.__assign || function() {
    $ca795d204689dac3$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ca795d204689dac3$var$__assign.apply(this, arguments);
};
var $ca795d204689dac3$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $ca795d204689dac3$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $ca795d204689dac3$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $ca795d204689dac3$var$logger = new (0, $7UO1b.ConsoleLogger)('StorageClass');
var $ca795d204689dac3$var$DEFAULT_PROVIDER = 'AWSS3';
/**
 * Provide storage methods to use AWS S3
 */ var $ca795d204689dac3$export$bf2a15d34f3c441c = /** @class */ function() {
    /**
     * Initialize Storage
     * @param {Object} config - Configuration object for storage
     */ function Storage() {
        this._config = {};
        this._pluggables = [];
        this._cancelTokenSourceMap = new WeakMap();
        $ca795d204689dac3$var$logger.debug('Storage Options', this._config);
        this.get = this.get.bind(this);
        this.put = this.put.bind(this);
        this.remove = this.remove.bind(this);
        this.list = this.list.bind(this);
    }
    Storage.prototype.getModuleName = function() {
        return 'Storage';
    };
    /**
     * add plugin into Storage category
     * @param {Object} pluggable - an instance of the plugin
     */ Storage.prototype.addPluggable = function(pluggable) {
        if (pluggable && pluggable.getCategory() === 'Storage') {
            this._pluggables.push(pluggable);
            var config = {};
            config = pluggable.configure(this._config[pluggable.getProviderName()]);
            return config;
        }
    };
    /**
     * Get the plugin object
     * @param providerName - the name of the plugin
     */ Storage.prototype.getPluggable = function(providerName) {
        var pluggable = this._pluggables.find(function(pluggable) {
            return pluggable.getProviderName() === providerName;
        });
        if (pluggable === undefined) {
            $ca795d204689dac3$var$logger.debug('No plugin found with providerName', providerName);
            return null;
        } else return pluggable;
    };
    /**
     * Remove the plugin object
     * @param providerName - the name of the plugin
     */ Storage.prototype.removePluggable = function(providerName) {
        this._pluggables = this._pluggables.filter(function(pluggable) {
            return pluggable.getProviderName() !== providerName;
        });
        return;
    };
    /**
     * Configure Storage
     * @param {Object} config - Configuration object for storage
     * @return {Object} - Current configuration
     */ Storage.prototype.configure = function(config) {
        var _this = this;
        $ca795d204689dac3$var$logger.debug('configure Storage');
        if (!config) return this._config;
        var amplifyConfig = (0, $7XN1x.Parser).parseMobilehubConfig(config);
        var storageKeysFromConfig = Object.keys(amplifyConfig.Storage);
        var storageArrayKeys = [
            'bucket',
            'region',
            'level',
            'track',
            'customPrefix',
            'serverSideEncryption',
            'SSECustomerAlgorithm',
            'SSECustomerKey',
            'SSECustomerKeyMD5',
            'SSEKMSKeyId'
        ];
        var isInStorageArrayKeys = function(k) {
            return storageArrayKeys.some(function(x) {
                return x === k;
            });
        };
        var checkConfigKeysFromArray = function(k) {
            return k.find(function(k) {
                return isInStorageArrayKeys(k);
            });
        };
        if (storageKeysFromConfig && checkConfigKeysFromArray(storageKeysFromConfig) && !amplifyConfig.Storage[$ca795d204689dac3$var$DEFAULT_PROVIDER]) amplifyConfig.Storage[$ca795d204689dac3$var$DEFAULT_PROVIDER] = {};
        Object.entries(amplifyConfig.Storage).map(function(_a) {
            var _b = $ca795d204689dac3$var$__read(_a, 2), key = _b[0], value = _b[1];
            if (key && isInStorageArrayKeys(key) && value !== undefined) {
                amplifyConfig.Storage[$ca795d204689dac3$var$DEFAULT_PROVIDER][key] = value;
                delete amplifyConfig.Storage[key];
            }
        });
        // only update new values for each provider
        Object.keys(amplifyConfig.Storage).forEach(function(providerName) {
            if (typeof amplifyConfig.Storage[providerName] !== 'string') _this._config[providerName] = $ca795d204689dac3$var$__assign($ca795d204689dac3$var$__assign({}, _this._config[providerName]), amplifyConfig.Storage[providerName]);
        });
        this._pluggables.forEach(function(pluggable) {
            pluggable.configure(_this._config[pluggable.getProviderName()]);
        });
        if (this._pluggables.length === 0) this.addPluggable(new (0, $lKEWW.AWSS3Provider)());
        return this._config;
    };
    Storage.prototype.getCancellableTokenSource = function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($iFJFJ))).CancelToken.source();
    };
    Storage.prototype.updateRequestToBeCancellable = function(request, cancelTokenSource) {
        this._cancelTokenSourceMap.set(request, cancelTokenSource);
    };
    /**
     * Cancels an inflight request
     *
     * @param {Promise<any>} request - The request to cancel
     * @param {string} [message] - A message to include in the cancelation exception
     */ Storage.prototype.cancel = function(request, message) {
        var cancelTokenSource = this._cancelTokenSourceMap.get(request);
        if (cancelTokenSource) cancelTokenSource.cancel(message);
        else $ca795d204689dac3$var$logger.debug('The request does not map to any cancel token');
    };
    /**
     * Get a presigned URL of the file or the object data when download:true
     *
     * @param {string} key - key of the object
     * @param {Object} [config] - { level : private|protected|public, download: true|false }
     * @return - A promise resolves to either a presigned url or the object
     */ Storage.prototype.get = function(key, config) {
        var _a = (config || {}).provider, provider = _a === void 0 ? $ca795d204689dac3$var$DEFAULT_PROVIDER : _a;
        var prov = this._pluggables.find(function(pluggable) {
            return pluggable.getProviderName() === provider;
        });
        if (prov === undefined) {
            $ca795d204689dac3$var$logger.debug('No plugin found with providerName', provider);
            return Promise.reject('No plugin found in Storage for the provider');
        }
        var cancelTokenSource = this.getCancellableTokenSource();
        var responsePromise = prov.get(key, $ca795d204689dac3$var$__assign($ca795d204689dac3$var$__assign({}, config), {
            cancelTokenSource: cancelTokenSource
        }));
        this.updateRequestToBeCancellable(responsePromise, cancelTokenSource);
        return responsePromise;
    };
    Storage.prototype.isCancelError = function(error) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($iFJFJ))).isCancel(error);
    };
    /**
     * Put a file in storage bucket specified to configure method
     * @param {string} key - key of the object
     * @param {Object} object - File to be put in bucket
     * @param {Object} [config] - { level : private|protected|public, contentType: MIME Types,
     *  progressCallback: function }
     * @return - promise resolves to object on success
     */ Storage.prototype.put = function(key, object, config) {
        var _a = (config || {}).provider, provider = _a === void 0 ? $ca795d204689dac3$var$DEFAULT_PROVIDER : _a;
        var prov = this._pluggables.find(function(pluggable) {
            return pluggable.getProviderName() === provider;
        });
        if (prov === undefined) {
            $ca795d204689dac3$var$logger.debug('No plugin found with providerName', provider);
            return Promise.reject('No plugin found in Storage for the provider');
        }
        var cancelTokenSource = this.getCancellableTokenSource();
        var responsePromise = prov.put(key, object, $ca795d204689dac3$var$__assign($ca795d204689dac3$var$__assign({}, config), {
            cancelTokenSource: cancelTokenSource
        }));
        this.updateRequestToBeCancellable(responsePromise, cancelTokenSource);
        return responsePromise;
    };
    /**
     * Remove the object for specified key
     * @param {string} key - key of the object
     * @param {Object} [config] - { level : private|protected|public }
     * @return - Promise resolves upon successful removal of the object
     */ Storage.prototype.remove = function(key, config) {
        return $ca795d204689dac3$var$__awaiter(this, void 0, void 0, function() {
            var _a, provider, prov;
            return $ca795d204689dac3$var$__generator(this, function(_b) {
                _a = (config || {}).provider, provider = _a === void 0 ? $ca795d204689dac3$var$DEFAULT_PROVIDER : _a;
                prov = this._pluggables.find(function(pluggable) {
                    return pluggable.getProviderName() === provider;
                });
                if (prov === undefined) {
                    $ca795d204689dac3$var$logger.debug('No plugin found with providerName', provider);
                    return [
                        2 /*return*/ ,
                        Promise.reject('No plugin found in Storage for the provider')
                    ];
                }
                return [
                    2 /*return*/ ,
                    prov.remove(key, config)
                ];
            });
        });
    };
    /**
     * List bucket objects relative to the level and prefix specified
     * @param {String} path - the path that contains objects
     * @param {Object} [config] - { level : private|protected|public, maxKeys: NUMBER }
     * @return - Promise resolves to list of keys for all objects in path
     */ Storage.prototype.list = function(path, config) {
        return $ca795d204689dac3$var$__awaiter(this, void 0, void 0, function() {
            var _a, provider, prov;
            return $ca795d204689dac3$var$__generator(this, function(_b) {
                _a = (config || {}).provider, provider = _a === void 0 ? $ca795d204689dac3$var$DEFAULT_PROVIDER : _a;
                prov = this._pluggables.find(function(pluggable) {
                    return pluggable.getProviderName() === provider;
                });
                if (prov === undefined) {
                    $ca795d204689dac3$var$logger.debug('No plugin found with providerName', provider);
                    return [
                        2 /*return*/ ,
                        Promise.reject('No plugin found in Storage for the provider')
                    ];
                }
                return [
                    2 /*return*/ ,
                    prov.list(path, config)
                ];
            });
        });
    };
    return Storage;
}();
var /**
 * @deprecated use named import
 */ $ca795d204689dac3$export$2e2bcd8739ae039 = $ca795d204689dac3$export$bf2a15d34f3c441c;

});
parcelRegister("lKEWW", function(module, exports) {

$parcel$export(module.exports, "AWSS3Provider", () => $041627e17e5847aa$export$a8628d9eb315b139);

var $7UO1b = parcelRequire("7UO1b");
var $29OQz = parcelRequire("29OQz");
var $kaH5c = parcelRequire("kaH5c");
var $kRjsJ = parcelRequire("kRjsJ");
var $7XN1x = parcelRequire("7XN1x");

var $7cT3T = parcelRequire("7cT3T");
var $i0M77 = parcelRequire("i0M77");
var $edxX9 = parcelRequire("edxX9");
var $dpead = parcelRequire("dpead");

var $fM9Kx = parcelRequire("fM9Kx");

var $6Ogql = parcelRequire("6Ogql");
parcelRequire("kIQg0");
var $6kQzE = parcelRequire("6kQzE");

var $eMxaO = parcelRequire("eMxaO");

var $daywO = parcelRequire("daywO");

var $hepb8 = parcelRequire("hepb8");
var $041627e17e5847aa$var$__assign = undefined && undefined.__assign || function() {
    $041627e17e5847aa$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $041627e17e5847aa$var$__assign.apply(this, arguments);
};
var $041627e17e5847aa$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $041627e17e5847aa$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $041627e17e5847aa$var$logger = new (0, $7UO1b.ConsoleLogger)('AWSS3Provider');
var $041627e17e5847aa$var$AMPLIFY_SYMBOL = typeof Symbol !== 'undefined' && typeof Symbol.for === 'function' ? Symbol.for('amplify_default') : '@@amplify_default';
var $041627e17e5847aa$var$dispatchStorageEvent = function(track, event, attrs, metrics, message) {
    if (track) {
        var data = {
            attrs: attrs
        };
        if (metrics) data['metrics'] = metrics;
        (0, $kRjsJ.Hub).dispatch('storage', {
            event: event,
            data: data,
            message: message
        }, 'Storage', $041627e17e5847aa$var$AMPLIFY_SYMBOL);
    }
};
var $041627e17e5847aa$var$localTestingStorageEndpoint = 'http://localhost:20005';
/**
 * Provide storage methods to use AWS S3
 */ var $041627e17e5847aa$export$a8628d9eb315b139 = /** @class */ function() {
    /**
     * Initialize Storage with AWS configurations
     * @param {Object} config - Configuration object for storage
     */ function AWSS3Provider(config) {
        this._config = config ? config : {};
        $041627e17e5847aa$var$logger.debug('Storage Options', this._config);
    }
    /**
     * get the category of the plugin
     */ AWSS3Provider.prototype.getCategory = function() {
        return AWSS3Provider.CATEGORY;
    };
    /**
     * get provider name of the plugin
     */ AWSS3Provider.prototype.getProviderName = function() {
        return AWSS3Provider.PROVIDER_NAME;
    };
    /**
     * Configure Storage part with aws configuration
     * @param {Object} config - Configuration of the Storage
     * @return {Object} - Current configuration
     */ AWSS3Provider.prototype.configure = function(config) {
        $041627e17e5847aa$var$logger.debug('configure Storage', config);
        if (!config) return this._config;
        var amplifyConfig = (0, $7XN1x.Parser).parseMobilehubConfig(config);
        this._config = Object.assign({}, this._config, amplifyConfig.Storage);
        if (!this._config.bucket) $041627e17e5847aa$var$logger.debug('Do not have bucket yet');
        return this._config;
    };
    /**
     * Get a presigned URL of the file or the object data when download:true
     *
     * @param {string} key - key of the object
     * @param {Object} [config] - { level : private|protected|public, download: true|false }
     * @return - A promise resolves to Amazon S3 presigned URL on success
     */ AWSS3Provider.prototype.get = function(key, config) {
        return $041627e17e5847aa$var$__awaiter(this, void 0, void 0, function() {
            var credentialsOK, opt, bucket, download, cacheControl, contentDisposition, contentEncoding, contentLanguage, contentType, expires, track, prefix, final_key, s3, params, getObjectCommand, response, error_1, signer, request, url, _a, error_2;
            return $041627e17e5847aa$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _b.sent();
                        if (!credentialsOK) return [
                            2 /*return*/ ,
                            Promise.reject('No credentials')
                        ];
                        opt = Object.assign({}, this._config, config);
                        bucket = opt.bucket, download = opt.download, cacheControl = opt.cacheControl, contentDisposition = opt.contentDisposition, contentEncoding = opt.contentEncoding, contentLanguage = opt.contentLanguage, contentType = opt.contentType, expires = opt.expires, track = opt.track;
                        prefix = this._prefix(opt);
                        final_key = prefix + key;
                        s3 = this._createNewS3Client(opt);
                        $041627e17e5847aa$var$logger.debug('get ' + key + ' from ' + final_key);
                        params = {
                            Bucket: bucket,
                            Key: final_key
                        };
                        // See: https://docs.aws.amazon.com/AWSJavaScriptSDK/latest/AWS/S3.html#getObject-property
                        if (cacheControl) params.ResponseCacheControl = cacheControl;
                        if (contentDisposition) params.ResponseContentDisposition = contentDisposition;
                        if (contentEncoding) params.ResponseContentEncoding = contentEncoding;
                        if (contentLanguage) params.ResponseContentLanguage = contentLanguage;
                        if (contentType) params.ResponseContentType = contentType;
                        if (!(download === true)) return [
                            3 /*break*/ ,
                            5
                        ];
                        getObjectCommand = new (0, $i0M77.GetObjectCommand)(params);
                        _b.label = 2;
                    case 2:
                        _b.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            s3.send(getObjectCommand)
                        ];
                    case 3:
                        response = _b.sent();
                        $041627e17e5847aa$var$dispatchStorageEvent(track, 'download', {
                            method: 'get',
                            result: 'success'
                        }, {
                            fileSize: Number(response.Body['size'] || response.Body['length'])
                        }, "Download success for " + key);
                        return [
                            2 /*return*/ ,
                            response
                        ];
                    case 4:
                        error_1 = _b.sent();
                        $041627e17e5847aa$var$dispatchStorageEvent(track, 'download', {
                            method: 'get',
                            result: 'failed'
                        }, null, "Download failed with " + error_1.message);
                        throw error_1;
                    case 5:
                        params.Expires = expires || 900; // Default is 15 mins as defined in V2 AWS SDK
                        _b.label = 6;
                    case 6:
                        _b.trys.push([
                            6,
                            9,
                            ,
                            10
                        ]);
                        signer = new (0, $6kQzE.S3RequestPresigner)($041627e17e5847aa$var$__assign({}, s3.config));
                        return [
                            4 /*yield*/ ,
                            (0, $6Ogql.createRequest)(s3, new (0, $i0M77.GetObjectCommand)(params))
                        ];
                    case 7:
                        request = _b.sent();
                        _a = (0, $fM9Kx.formatUrl);
                        return [
                            4 /*yield*/ ,
                            signer.presign(request, {
                                expiresIn: params.Expires
                            })
                        ];
                    case 8:
                        url = _a.apply(void 0, [
                            _b.sent()
                        ]);
                        $041627e17e5847aa$var$dispatchStorageEvent(track, 'getSignedUrl', {
                            method: 'get',
                            result: 'success'
                        }, null, "Signed URL: " + url);
                        return [
                            2 /*return*/ ,
                            url
                        ];
                    case 9:
                        error_2 = _b.sent();
                        $041627e17e5847aa$var$logger.warn('get signed url error', error_2);
                        $041627e17e5847aa$var$dispatchStorageEvent(track, 'getSignedUrl', {
                            method: 'get',
                            result: 'failed'
                        }, null, "Could not get a signed URL for " + key);
                        throw error_2;
                    case 10:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Put a file in S3 bucket specified to configure method
     * @param {string} key - key of the object
     * @param {Object} object - File to be put in Amazon S3 bucket
     * @param {Object} [config] - { level : private|protected|public, contentType: MIME Types,
     *  progressCallback: function }
     * @return - promise resolves to object on success
     */ AWSS3Provider.prototype.put = function(key, object, config) {
        return $041627e17e5847aa$var$__awaiter(this, void 0, void 0, function() {
            var credentialsOK, opt, bucket, track, progressCallback, contentType, contentDisposition, cacheControl, expires, metadata, tagging, acl, serverSideEncryption, SSECustomerAlgorithm, SSECustomerKey, SSECustomerKeyMD5, SSEKMSKeyId, type, prefix, final_key, params, emitter, uploader, response, error_3;
            return $041627e17e5847aa$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _a.sent();
                        if (!credentialsOK) return [
                            2 /*return*/ ,
                            Promise.reject('No credentials')
                        ];
                        opt = Object.assign({}, this._config, config);
                        bucket = opt.bucket, track = opt.track, progressCallback = opt.progressCallback;
                        contentType = opt.contentType, contentDisposition = opt.contentDisposition, cacheControl = opt.cacheControl, expires = opt.expires, metadata = opt.metadata, tagging = opt.tagging, acl = opt.acl;
                        serverSideEncryption = opt.serverSideEncryption, SSECustomerAlgorithm = opt.SSECustomerAlgorithm, SSECustomerKey = opt.SSECustomerKey, SSECustomerKeyMD5 = opt.SSECustomerKeyMD5, SSEKMSKeyId = opt.SSEKMSKeyId;
                        type = contentType ? contentType : 'binary/octet-stream';
                        prefix = this._prefix(opt);
                        final_key = prefix + key;
                        $041627e17e5847aa$var$logger.debug('put ' + key + ' to ' + final_key);
                        params = {
                            Bucket: bucket,
                            Key: final_key,
                            Body: object,
                            ContentType: type
                        };
                        if (cacheControl) params.CacheControl = cacheControl;
                        if (contentDisposition) params.ContentDisposition = contentDisposition;
                        if (expires) params.Expires = expires;
                        if (metadata) params.Metadata = metadata;
                        if (tagging) params.Tagging = tagging;
                        if (serverSideEncryption) {
                            params.ServerSideEncryption = serverSideEncryption;
                            if (SSECustomerAlgorithm) params.SSECustomerAlgorithm = SSECustomerAlgorithm;
                            if (SSECustomerKey) params.SSECustomerKey = SSECustomerKey;
                            if (SSECustomerKeyMD5) params.SSECustomerKeyMD5 = SSECustomerKeyMD5;
                            if (SSEKMSKeyId) params.SSEKMSKeyId = SSEKMSKeyId;
                        }
                        emitter = new $hepb8.EventEmitter();
                        uploader = new (0, $daywO.AWSS3ProviderManagedUpload)(params, opt, emitter);
                        if (acl) params.ACL = acl;
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        emitter.on('sendProgress', function(progress) {
                            if (progressCallback) {
                                if (typeof progressCallback === 'function') progressCallback(progress);
                                else $041627e17e5847aa$var$logger.warn('progressCallback should be a function, not a ' + typeof progressCallback);
                            }
                        });
                        return [
                            4 /*yield*/ ,
                            uploader.upload()
                        ];
                    case 3:
                        response = _a.sent();
                        $041627e17e5847aa$var$logger.debug('upload result', response);
                        $041627e17e5847aa$var$dispatchStorageEvent(track, 'upload', {
                            method: 'put',
                            result: 'success'
                        }, null, "Upload success for " + key);
                        return [
                            2 /*return*/ ,
                            {
                                key: key
                            }
                        ];
                    case 4:
                        error_3 = _a.sent();
                        $041627e17e5847aa$var$logger.warn('error uploading', error_3);
                        $041627e17e5847aa$var$dispatchStorageEvent(track, 'upload', {
                            method: 'put',
                            result: 'failed'
                        }, null, "Error uploading " + key);
                        throw error_3;
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Remove the object for specified key
     * @param {string} key - key of the object
     * @param {Object} [config] - { level : private|protected|public }
     * @return - Promise resolves upon successful removal of the object
     */ AWSS3Provider.prototype.remove = function(key, config) {
        return $041627e17e5847aa$var$__awaiter(this, void 0, void 0, function() {
            var credentialsOK, opt, bucket, track, prefix, final_key, s3, params, deleteObjectCommand, response, error_4;
            return $041627e17e5847aa$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _a.sent();
                        if (!credentialsOK) return [
                            2 /*return*/ ,
                            Promise.reject('No credentials')
                        ];
                        opt = Object.assign({}, this._config, config);
                        bucket = opt.bucket, track = opt.track;
                        prefix = this._prefix(opt);
                        final_key = prefix + key;
                        s3 = this._createNewS3Client(opt);
                        $041627e17e5847aa$var$logger.debug('remove ' + key + ' from ' + final_key);
                        params = {
                            Bucket: bucket,
                            Key: final_key
                        };
                        deleteObjectCommand = new (0, $7cT3T.DeleteObjectCommand)(params);
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            s3.send(deleteObjectCommand)
                        ];
                    case 3:
                        response = _a.sent();
                        $041627e17e5847aa$var$dispatchStorageEvent(track, 'delete', {
                            method: 'remove',
                            result: 'success'
                        }, null, "Deleted " + key + " successfully");
                        return [
                            2 /*return*/ ,
                            response
                        ];
                    case 4:
                        error_4 = _a.sent();
                        $041627e17e5847aa$var$dispatchStorageEvent(track, 'delete', {
                            method: 'remove',
                            result: 'failed'
                        }, null, "Deletion of " + key + " failed with " + error_4);
                        throw error_4;
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * List bucket objects relative to the level and prefix specified
     * @param {string} path - the path that contains objects
     * @param {Object} [config] - { level : private|protected|public }
     * @return - Promise resolves to list of keys for all objects in path
     */ AWSS3Provider.prototype.list = function(path, config) {
        return $041627e17e5847aa$var$__awaiter(this, void 0, void 0, function() {
            var credentialsOK, opt, bucket, track, maxKeys, prefix, final_path, s3, params, listObjectsCommand, response, list, error_5;
            return $041627e17e5847aa$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _a.sent();
                        if (!credentialsOK) return [
                            2 /*return*/ ,
                            Promise.reject('No credentials')
                        ];
                        opt = Object.assign({}, this._config, config);
                        bucket = opt.bucket, track = opt.track, maxKeys = opt.maxKeys;
                        prefix = this._prefix(opt);
                        final_path = prefix + path;
                        s3 = this._createNewS3Client(opt);
                        $041627e17e5847aa$var$logger.debug('list ' + path + ' from ' + final_path);
                        params = {
                            Bucket: bucket,
                            Prefix: final_path,
                            MaxKeys: maxKeys
                        };
                        listObjectsCommand = new (0, $edxX9.ListObjectsCommand)(params);
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            s3.send(listObjectsCommand)
                        ];
                    case 3:
                        response = _a.sent();
                        list = [];
                        if (response && response.Contents) list = response.Contents.map(function(item) {
                            return {
                                key: item.Key.substr(prefix.length),
                                eTag: item.ETag,
                                lastModified: item.LastModified,
                                size: item.Size
                            };
                        });
                        $041627e17e5847aa$var$dispatchStorageEvent(track, 'list', {
                            method: 'list',
                            result: 'success'
                        }, null, list.length + " items returned from list operation");
                        $041627e17e5847aa$var$logger.debug('list', list);
                        return [
                            2 /*return*/ ,
                            list
                        ];
                    case 4:
                        error_5 = _a.sent();
                        $041627e17e5847aa$var$logger.warn('list error', error_5);
                        $041627e17e5847aa$var$dispatchStorageEvent(track, 'list', {
                            method: 'list',
                            result: 'failed'
                        }, null, "Listing items failed: " + error_5.message);
                        throw error_5;
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * @private
     */ AWSS3Provider.prototype._ensureCredentials = function() {
        var _this = this;
        return (0, $29OQz.Credentials).get().then(function(credentials) {
            if (!credentials) return false;
            var cred = (0, $29OQz.Credentials).shear(credentials);
            $041627e17e5847aa$var$logger.debug('set credentials for storage', cred);
            _this._config.credentials = cred;
            return true;
        }).catch(function(error) {
            $041627e17e5847aa$var$logger.warn('ensure credentials error', error);
            return false;
        });
    };
    /**
     * @private
     */ AWSS3Provider.prototype._prefix = function(config) {
        var credentials = config.credentials, level = config.level;
        var customPrefix = config.customPrefix || {};
        var identityId = config.identityId || credentials.identityId;
        var privatePath = (customPrefix.private !== undefined ? customPrefix.private : 'private/') + identityId + '/';
        var protectedPath = (customPrefix.protected !== undefined ? customPrefix.protected : 'protected/') + identityId + '/';
        var publicPath = customPrefix.public !== undefined ? customPrefix.public : 'public/';
        switch(level){
            case 'private':
                return privatePath;
            case 'protected':
                return protectedPath;
            default:
                return publicPath;
        }
    };
    /**
     * @private creates an S3 client with new V3 aws sdk
     */ AWSS3Provider.prototype._createNewS3Client = function(config, emitter) {
        var region = config.region, credentials = config.credentials, cancelTokenSource = config.cancelTokenSource, dangerouslyConnectToHttpEndpointForTesting = config.dangerouslyConnectToHttpEndpointForTesting;
        var localTestingConfig = {};
        if (dangerouslyConnectToHttpEndpointForTesting) localTestingConfig = {
            endpoint: $041627e17e5847aa$var$localTestingStorageEndpoint,
            tls: false,
            bucketEndpoint: false,
            forcePathStyle: true
        };
        var s3client = new (0, $dpead.S3Client)($041627e17e5847aa$var$__assign($041627e17e5847aa$var$__assign({
            region: region,
            credentials: credentials,
            customUserAgent: (0, $kaH5c.getAmplifyUserAgent)()
        }, localTestingConfig), {
            requestHandler: new (0, $eMxaO.AxiosHttpHandler)({}, emitter, cancelTokenSource)
        }));
        return s3client;
    };
    AWSS3Provider.CATEGORY = 'Storage';
    AWSS3Provider.PROVIDER_NAME = 'AWSS3';
    return AWSS3Provider;
}();
var /**
 * @deprecated use named import
 */ $041627e17e5847aa$export$2e2bcd8739ae039 = $041627e17e5847aa$export$a8628d9eb315b139;

});
parcelRegister("7cT3T", function(module, exports) {

$parcel$export(module.exports, "DeleteObjectCommand", () => $53f45d80d7fbf9f2$export$d60592d05571c4ef);

var $2eeCH = parcelRequire("2eeCH");

var $g4BTM = parcelRequire("g4BTM");

var $jhZvA = parcelRequire("jhZvA");
parcelRequire("dLiz3");
var $ifNwy = parcelRequire("ifNwy");
parcelRequire("6ZXPq");
var $dQtWs = parcelRequire("dQtWs");
parcelRequire("3vy9S");
var $5nbBf = parcelRequire("5nbBf");
/**
 * <p>Removes the null version (if there is one) of an object and inserts a delete marker,
 *          which becomes the latest version of the object. If there isn't a null version, Amazon S3 does
 *          not remove any objects.</p>
 *
 *          <p>To remove a specific version, you must be the bucket owner and you must use the version
 *          Id subresource. Using this subresource permanently deletes the version. If the object
 *          deleted is a delete marker, Amazon S3 sets the response header,
 *          <code>x-amz-delete-marker</code>, to true. </p>
 *
 *          <p>If the object you want to delete is in a bucket where the bucket versioning
 *          configuration is MFA Delete enabled, you must include the <code>x-amz-mfa</code> request
 *          header in the DELETE <code>versionId</code> request. Requests that include
 *             <code>x-amz-mfa</code> must use HTTPS. </p>
 *
 *          <p> For more information about MFA Delete, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/UsingMFADelete.html">Using MFA Delete</a>. To see sample requests that use versioning, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/RESTObjectDELETE.html#ExampleVersionObjectDelete">Sample Request</a>. </p>
 *
 *          <p>You can delete objects by explicitly calling the DELETE Object API or configure its
 *          lifecycle (<a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_PutBucketLifecycle.html">PutBucketLifecycle</a>) to
 *          enable Amazon S3 to remove them for you. If you want to block users or accounts from removing or
 *          deleting objects from your bucket, you must deny them the <code>s3:DeleteObject</code>,
 *             <code>s3:DeleteObjectVersion</code>, and <code>s3:PutLifeCycleConfiguration</code>
 *          actions. </p>
 *
 *          <p>The following operation is related to <code>DeleteObject</code>:</p>
 *          <ul>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_PutObject.html">PutObject</a>
 *                </p>
 *             </li>
 *          </ul>
 */ var $53f45d80d7fbf9f2$export$d60592d05571c4ef = /** @class */ function(_super) {
    (0, $2eeCH.__extends)(DeleteObjectCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function DeleteObjectCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    /**
     * @internal
     */ DeleteObjectCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $dQtWs.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use((0, $ifNwy.getBucketEndpointPlugin)(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "S3Client";
        var commandName = "DeleteObjectCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $g4BTM.DeleteObjectRequest).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $g4BTM.DeleteObjectOutput).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DeleteObjectCommand.prototype.serialize = function(input, context) {
        return (0, $jhZvA.serializeAws_restXmlDeleteObjectCommand)(input, context);
    };
    DeleteObjectCommand.prototype.deserialize = function(output, context) {
        return (0, $jhZvA.deserializeAws_restXmlDeleteObjectCommand)(output, context);
    };
    return DeleteObjectCommand;
}((0, $5nbBf.Command));

});
parcelRegister("g4BTM", function(module, exports) {

$parcel$export(module.exports, "AbortMultipartUploadOutput", () => $bb3a6aefff166c77$export$80a5621784397e06);
$parcel$export(module.exports, "AbortMultipartUploadRequest", () => $bb3a6aefff166c77$export$2509116d04cdd782);
$parcel$export(module.exports, "CompleteMultipartUploadOutput", () => $bb3a6aefff166c77$export$edcc5df28126c9bc);
$parcel$export(module.exports, "CompleteMultipartUploadRequest", () => $bb3a6aefff166c77$export$2998881f143b41ec);
$parcel$export(module.exports, "CreateMultipartUploadOutput", () => $bb3a6aefff166c77$export$196bb0482ff68428);
$parcel$export(module.exports, "CreateMultipartUploadRequest", () => $bb3a6aefff166c77$export$f65faae2a46e45c2);
$parcel$export(module.exports, "DeleteObjectOutput", () => $bb3a6aefff166c77$export$64d4f4fac943bc25);
$parcel$export(module.exports, "DeleteObjectRequest", () => $bb3a6aefff166c77$export$7d123f24a24f15cf);
$parcel$export(module.exports, "AnalyticsFilter", () => $bb3a6aefff166c77$export$c9ec61557dcb764a);
$parcel$export(module.exports, "LifecycleRuleFilter", () => $bb3a6aefff166c77$export$4338dba1e93ddaf4);
$parcel$export(module.exports, "MetricsFilter", () => $bb3a6aefff166c77$export$564a1f9c338cae45);
$parcel$export(module.exports, "ReplicationRuleFilter", () => $bb3a6aefff166c77$export$c5652b893758d9eb);
$parcel$export(module.exports, "GetObjectOutput", () => $bb3a6aefff166c77$export$9fb6bec1a5c954d6);
$parcel$export(module.exports, "GetObjectRequest", () => $bb3a6aefff166c77$export$3373ea9743883feb);
$parcel$export(module.exports, "ListObjectsOutput", () => $bb3a6aefff166c77$export$bd5de99c03e50bdf);
$parcel$export(module.exports, "ListObjectsRequest", () => $bb3a6aefff166c77$export$b17e2bd91a04aa76);
$parcel$export(module.exports, "ListPartsOutput", () => $bb3a6aefff166c77$export$8c83b46649a5c089);
$parcel$export(module.exports, "ListPartsRequest", () => $bb3a6aefff166c77$export$756cf37efa2403e6);
$parcel$export(module.exports, "PutObjectOutput", () => $bb3a6aefff166c77$export$792cedced515bdbd);
$parcel$export(module.exports, "PutObjectRequest", () => $bb3a6aefff166c77$export$90c5c1bf0f634d21);
$parcel$export(module.exports, "Encryption", () => $bb3a6aefff166c77$export$d60a27d0da10cee5);

var $2eeCH = parcelRequire("2eeCH");
parcelRequire("3vy9S");
var $IsgKV = parcelRequire("IsgKV");
var $bb3a6aefff166c77$export$ff1e75b1e93a2588;
(function(AbortIncompleteMultipartUpload) {
    AbortIncompleteMultipartUpload.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$ff1e75b1e93a2588 || ($bb3a6aefff166c77$export$ff1e75b1e93a2588 = {}));
var $bb3a6aefff166c77$export$80a5621784397e06;
(function(AbortMultipartUploadOutput) {
    AbortMultipartUploadOutput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$80a5621784397e06 || ($bb3a6aefff166c77$export$80a5621784397e06 = {}));
var $bb3a6aefff166c77$export$2509116d04cdd782;
(function(AbortMultipartUploadRequest) {
    AbortMultipartUploadRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$2509116d04cdd782 || ($bb3a6aefff166c77$export$2509116d04cdd782 = {}));
var $bb3a6aefff166c77$export$1de06065cff890a8;
(function(NoSuchUpload) {
    NoSuchUpload.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$1de06065cff890a8 || ($bb3a6aefff166c77$export$1de06065cff890a8 = {}));
var $bb3a6aefff166c77$export$b73224f1e3e6ea55;
(function(AccelerateConfiguration) {
    AccelerateConfiguration.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$b73224f1e3e6ea55 || ($bb3a6aefff166c77$export$b73224f1e3e6ea55 = {}));
var $bb3a6aefff166c77$export$4882adf346b33e1a;
(function(Grantee) {
    Grantee.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$4882adf346b33e1a || ($bb3a6aefff166c77$export$4882adf346b33e1a = {}));
var $bb3a6aefff166c77$export$16844950929e022f;
(function(Grant) {
    Grant.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$16844950929e022f || ($bb3a6aefff166c77$export$16844950929e022f = {}));
var $bb3a6aefff166c77$export$25fb39c3824c9c44;
(function(Owner) {
    Owner.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$25fb39c3824c9c44 || ($bb3a6aefff166c77$export$25fb39c3824c9c44 = {}));
var $bb3a6aefff166c77$export$6a42fa102a072c77;
(function(AccessControlPolicy) {
    AccessControlPolicy.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$6a42fa102a072c77 || ($bb3a6aefff166c77$export$6a42fa102a072c77 = {}));
var $bb3a6aefff166c77$export$3db5322b6b5badd4;
(function(AccessControlTranslation) {
    AccessControlTranslation.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$3db5322b6b5badd4 || ($bb3a6aefff166c77$export$3db5322b6b5badd4 = {}));
var $bb3a6aefff166c77$export$edcc5df28126c9bc;
(function(CompleteMultipartUploadOutput) {
    CompleteMultipartUploadOutput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, obj), obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $IsgKV.SENSITIVE_STRING)
        });
    };
})($bb3a6aefff166c77$export$edcc5df28126c9bc || ($bb3a6aefff166c77$export$edcc5df28126c9bc = {}));
var $bb3a6aefff166c77$export$76f56660c9039ec5;
(function(CompletedPart) {
    CompletedPart.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$76f56660c9039ec5 || ($bb3a6aefff166c77$export$76f56660c9039ec5 = {}));
var $bb3a6aefff166c77$export$394f3a16361c2a83;
(function(CompletedMultipartUpload) {
    CompletedMultipartUpload.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$394f3a16361c2a83 || ($bb3a6aefff166c77$export$394f3a16361c2a83 = {}));
var $bb3a6aefff166c77$export$2998881f143b41ec;
(function(CompleteMultipartUploadRequest) {
    CompleteMultipartUploadRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$2998881f143b41ec || ($bb3a6aefff166c77$export$2998881f143b41ec = {}));
var $bb3a6aefff166c77$export$32f1916074d2607f;
(function(CopyObjectResult) {
    CopyObjectResult.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$32f1916074d2607f || ($bb3a6aefff166c77$export$32f1916074d2607f = {}));
var $bb3a6aefff166c77$export$a9f99871811ebc49;
(function(CopyObjectOutput) {
    CopyObjectOutput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, obj), obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $IsgKV.SENSITIVE_STRING)
        }), obj.SSEKMSEncryptionContext && {
            SSEKMSEncryptionContext: (0, $IsgKV.SENSITIVE_STRING)
        });
    };
})($bb3a6aefff166c77$export$a9f99871811ebc49 || ($bb3a6aefff166c77$export$a9f99871811ebc49 = {}));
var $bb3a6aefff166c77$export$e84f0e76c8b259eb;
(function(CopyObjectRequest) {
    CopyObjectRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, obj), obj.SSECustomerKey && {
            SSECustomerKey: (0, $IsgKV.SENSITIVE_STRING)
        }), obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $IsgKV.SENSITIVE_STRING)
        }), obj.SSEKMSEncryptionContext && {
            SSEKMSEncryptionContext: (0, $IsgKV.SENSITIVE_STRING)
        }), obj.CopySourceSSECustomerKey && {
            CopySourceSSECustomerKey: (0, $IsgKV.SENSITIVE_STRING)
        });
    };
})($bb3a6aefff166c77$export$e84f0e76c8b259eb || ($bb3a6aefff166c77$export$e84f0e76c8b259eb = {}));
var $bb3a6aefff166c77$export$77615b2f7cde9dd7;
(function(ObjectNotInActiveTierError) {
    ObjectNotInActiveTierError.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$77615b2f7cde9dd7 || ($bb3a6aefff166c77$export$77615b2f7cde9dd7 = {}));
var $bb3a6aefff166c77$export$b6b374c2bfd60422;
(function(BucketAlreadyExists) {
    BucketAlreadyExists.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$b6b374c2bfd60422 || ($bb3a6aefff166c77$export$b6b374c2bfd60422 = {}));
var $bb3a6aefff166c77$export$3d44152d602e5b07;
(function(BucketAlreadyOwnedByYou) {
    BucketAlreadyOwnedByYou.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$3d44152d602e5b07 || ($bb3a6aefff166c77$export$3d44152d602e5b07 = {}));
var $bb3a6aefff166c77$export$b9395efd4905ea2f;
(function(CreateBucketOutput) {
    CreateBucketOutput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$b9395efd4905ea2f || ($bb3a6aefff166c77$export$b9395efd4905ea2f = {}));
var $bb3a6aefff166c77$export$80fb9034e13a84f5;
(function(CreateBucketConfiguration) {
    CreateBucketConfiguration.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$80fb9034e13a84f5 || ($bb3a6aefff166c77$export$80fb9034e13a84f5 = {}));
var $bb3a6aefff166c77$export$8aca1806c1d8d130;
(function(CreateBucketRequest) {
    CreateBucketRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$8aca1806c1d8d130 || ($bb3a6aefff166c77$export$8aca1806c1d8d130 = {}));
var $bb3a6aefff166c77$export$196bb0482ff68428;
(function(CreateMultipartUploadOutput) {
    CreateMultipartUploadOutput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, obj), obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $IsgKV.SENSITIVE_STRING)
        }), obj.SSEKMSEncryptionContext && {
            SSEKMSEncryptionContext: (0, $IsgKV.SENSITIVE_STRING)
        });
    };
})($bb3a6aefff166c77$export$196bb0482ff68428 || ($bb3a6aefff166c77$export$196bb0482ff68428 = {}));
var $bb3a6aefff166c77$export$f65faae2a46e45c2;
(function(CreateMultipartUploadRequest) {
    CreateMultipartUploadRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, obj), obj.SSECustomerKey && {
            SSECustomerKey: (0, $IsgKV.SENSITIVE_STRING)
        }), obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $IsgKV.SENSITIVE_STRING)
        }), obj.SSEKMSEncryptionContext && {
            SSEKMSEncryptionContext: (0, $IsgKV.SENSITIVE_STRING)
        });
    };
})($bb3a6aefff166c77$export$f65faae2a46e45c2 || ($bb3a6aefff166c77$export$f65faae2a46e45c2 = {}));
var $bb3a6aefff166c77$export$8b74a2c46a921740;
(function(DeleteBucketRequest) {
    DeleteBucketRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$8b74a2c46a921740 || ($bb3a6aefff166c77$export$8b74a2c46a921740 = {}));
var $bb3a6aefff166c77$export$c5ab088f35618173;
(function(DeleteBucketAnalyticsConfigurationRequest) {
    DeleteBucketAnalyticsConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$c5ab088f35618173 || ($bb3a6aefff166c77$export$c5ab088f35618173 = {}));
var $bb3a6aefff166c77$export$eedf1d80102f9cff;
(function(DeleteBucketCorsRequest) {
    DeleteBucketCorsRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$eedf1d80102f9cff || ($bb3a6aefff166c77$export$eedf1d80102f9cff = {}));
var $bb3a6aefff166c77$export$67cbcb88080a155a;
(function(DeleteBucketEncryptionRequest) {
    DeleteBucketEncryptionRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$67cbcb88080a155a || ($bb3a6aefff166c77$export$67cbcb88080a155a = {}));
var $bb3a6aefff166c77$export$301f370253f11f3b;
(function(DeleteBucketIntelligentTieringConfigurationRequest) {
    DeleteBucketIntelligentTieringConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$301f370253f11f3b || ($bb3a6aefff166c77$export$301f370253f11f3b = {}));
var $bb3a6aefff166c77$export$3603c2e1b3558471;
(function(DeleteBucketInventoryConfigurationRequest) {
    DeleteBucketInventoryConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$3603c2e1b3558471 || ($bb3a6aefff166c77$export$3603c2e1b3558471 = {}));
var $bb3a6aefff166c77$export$6c38b78c3c77b60c;
(function(DeleteBucketLifecycleRequest) {
    DeleteBucketLifecycleRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$6c38b78c3c77b60c || ($bb3a6aefff166c77$export$6c38b78c3c77b60c = {}));
var $bb3a6aefff166c77$export$ff4b8fc3fb36fbd;
(function(DeleteBucketMetricsConfigurationRequest) {
    DeleteBucketMetricsConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$ff4b8fc3fb36fbd || ($bb3a6aefff166c77$export$ff4b8fc3fb36fbd = {}));
var $bb3a6aefff166c77$export$4c49e000fa5b0b86;
(function(DeleteBucketOwnershipControlsRequest) {
    DeleteBucketOwnershipControlsRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$4c49e000fa5b0b86 || ($bb3a6aefff166c77$export$4c49e000fa5b0b86 = {}));
var $bb3a6aefff166c77$export$cce16146386a1316;
(function(DeleteBucketPolicyRequest) {
    DeleteBucketPolicyRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$cce16146386a1316 || ($bb3a6aefff166c77$export$cce16146386a1316 = {}));
var $bb3a6aefff166c77$export$238256546e65e80f;
(function(DeleteBucketReplicationRequest) {
    DeleteBucketReplicationRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$238256546e65e80f || ($bb3a6aefff166c77$export$238256546e65e80f = {}));
var $bb3a6aefff166c77$export$e9cefd124b305be3;
(function(DeleteBucketTaggingRequest) {
    DeleteBucketTaggingRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$e9cefd124b305be3 || ($bb3a6aefff166c77$export$e9cefd124b305be3 = {}));
var $bb3a6aefff166c77$export$15e654f934b26a7b;
(function(DeleteBucketWebsiteRequest) {
    DeleteBucketWebsiteRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$15e654f934b26a7b || ($bb3a6aefff166c77$export$15e654f934b26a7b = {}));
var $bb3a6aefff166c77$export$64d4f4fac943bc25;
(function(DeleteObjectOutput) {
    DeleteObjectOutput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$64d4f4fac943bc25 || ($bb3a6aefff166c77$export$64d4f4fac943bc25 = {}));
var $bb3a6aefff166c77$export$7d123f24a24f15cf;
(function(DeleteObjectRequest) {
    DeleteObjectRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$7d123f24a24f15cf || ($bb3a6aefff166c77$export$7d123f24a24f15cf = {}));
var $bb3a6aefff166c77$export$d17347461b0f9a2b;
(function(DeletedObject) {
    DeletedObject.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$d17347461b0f9a2b || ($bb3a6aefff166c77$export$d17347461b0f9a2b = {}));
var $bb3a6aefff166c77$export$afd90478dc782af0;
(function(_Error) {
    _Error.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$afd90478dc782af0 || ($bb3a6aefff166c77$export$afd90478dc782af0 = {}));
var $bb3a6aefff166c77$export$e1c86a39185a896f;
(function(DeleteObjectsOutput) {
    DeleteObjectsOutput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$e1c86a39185a896f || ($bb3a6aefff166c77$export$e1c86a39185a896f = {}));
var $bb3a6aefff166c77$export$84d9d258efc6700d;
(function(ObjectIdentifier) {
    ObjectIdentifier.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$84d9d258efc6700d || ($bb3a6aefff166c77$export$84d9d258efc6700d = {}));
var $bb3a6aefff166c77$export$bfadae053a633538;
(function(Delete) {
    Delete.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$bfadae053a633538 || ($bb3a6aefff166c77$export$bfadae053a633538 = {}));
var $bb3a6aefff166c77$export$c19f81fd3ccd8fc2;
(function(DeleteObjectsRequest) {
    DeleteObjectsRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$c19f81fd3ccd8fc2 || ($bb3a6aefff166c77$export$c19f81fd3ccd8fc2 = {}));
var $bb3a6aefff166c77$export$4d816bf2553d6082;
(function(DeleteObjectTaggingOutput) {
    DeleteObjectTaggingOutput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$4d816bf2553d6082 || ($bb3a6aefff166c77$export$4d816bf2553d6082 = {}));
var $bb3a6aefff166c77$export$2d561b57455087e8;
(function(DeleteObjectTaggingRequest) {
    DeleteObjectTaggingRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$2d561b57455087e8 || ($bb3a6aefff166c77$export$2d561b57455087e8 = {}));
var $bb3a6aefff166c77$export$cac29ea1b5d93b5d;
(function(DeletePublicAccessBlockRequest) {
    DeletePublicAccessBlockRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$cac29ea1b5d93b5d || ($bb3a6aefff166c77$export$cac29ea1b5d93b5d = {}));
var $bb3a6aefff166c77$export$d592399f8c69d061;
(function(GetBucketAccelerateConfigurationOutput) {
    GetBucketAccelerateConfigurationOutput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$d592399f8c69d061 || ($bb3a6aefff166c77$export$d592399f8c69d061 = {}));
var $bb3a6aefff166c77$export$c2ed0589b585987a;
(function(GetBucketAccelerateConfigurationRequest) {
    GetBucketAccelerateConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$c2ed0589b585987a || ($bb3a6aefff166c77$export$c2ed0589b585987a = {}));
var $bb3a6aefff166c77$export$1e656ec1fa0dbccd;
(function(GetBucketAclOutput) {
    GetBucketAclOutput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$1e656ec1fa0dbccd || ($bb3a6aefff166c77$export$1e656ec1fa0dbccd = {}));
var $bb3a6aefff166c77$export$5543bf3f517c214;
(function(GetBucketAclRequest) {
    GetBucketAclRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$5543bf3f517c214 || ($bb3a6aefff166c77$export$5543bf3f517c214 = {}));
var $bb3a6aefff166c77$export$3288d34c523a1192;
(function(Tag) {
    Tag.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$3288d34c523a1192 || ($bb3a6aefff166c77$export$3288d34c523a1192 = {}));
var $bb3a6aefff166c77$export$b9ae9bceb2811d5d;
(function(AnalyticsAndOperator) {
    AnalyticsAndOperator.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$b9ae9bceb2811d5d || ($bb3a6aefff166c77$export$b9ae9bceb2811d5d = {}));
var $bb3a6aefff166c77$export$c9ec61557dcb764a;
(function(AnalyticsFilter) {
    AnalyticsFilter.visit = function(value, visitor) {
        if (value.Prefix !== undefined) return visitor.Prefix(value.Prefix);
        if (value.Tag !== undefined) return visitor.Tag(value.Tag);
        if (value.And !== undefined) return visitor.And(value.And);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
    AnalyticsFilter.filterSensitiveLog = function(obj) {
        var _a;
        if (obj.Prefix !== undefined) return {
            Prefix: obj.Prefix
        };
        if (obj.Tag !== undefined) return {
            Tag: $bb3a6aefff166c77$export$3288d34c523a1192.filterSensitiveLog(obj.Tag)
        };
        if (obj.And !== undefined) return {
            And: $bb3a6aefff166c77$export$b9ae9bceb2811d5d.filterSensitiveLog(obj.And)
        };
        if (obj.$unknown !== undefined) return _a = {}, _a[obj.$unknown[0]] = "UNKNOWN", _a;
    };
})($bb3a6aefff166c77$export$c9ec61557dcb764a || ($bb3a6aefff166c77$export$c9ec61557dcb764a = {}));
var $bb3a6aefff166c77$export$fc566d9f8f854701;
(function(AnalyticsS3BucketDestination) {
    AnalyticsS3BucketDestination.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$fc566d9f8f854701 || ($bb3a6aefff166c77$export$fc566d9f8f854701 = {}));
var $bb3a6aefff166c77$export$20f751b8dcd24833;
(function(AnalyticsExportDestination) {
    AnalyticsExportDestination.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$20f751b8dcd24833 || ($bb3a6aefff166c77$export$20f751b8dcd24833 = {}));
var $bb3a6aefff166c77$export$a14156deb587d512;
(function(StorageClassAnalysisDataExport) {
    StorageClassAnalysisDataExport.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$a14156deb587d512 || ($bb3a6aefff166c77$export$a14156deb587d512 = {}));
var $bb3a6aefff166c77$export$13f5184561469c95;
(function(StorageClassAnalysis) {
    StorageClassAnalysis.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$13f5184561469c95 || ($bb3a6aefff166c77$export$13f5184561469c95 = {}));
var $bb3a6aefff166c77$export$15f94404a081a771;
(function(AnalyticsConfiguration) {
    AnalyticsConfiguration.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, obj), obj.Filter && {
            Filter: $bb3a6aefff166c77$export$c9ec61557dcb764a.filterSensitiveLog(obj.Filter)
        });
    };
})($bb3a6aefff166c77$export$15f94404a081a771 || ($bb3a6aefff166c77$export$15f94404a081a771 = {}));
var $bb3a6aefff166c77$export$32ac99bb59e9ea35;
(function(GetBucketAnalyticsConfigurationOutput) {
    GetBucketAnalyticsConfigurationOutput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, obj), obj.AnalyticsConfiguration && {
            AnalyticsConfiguration: $bb3a6aefff166c77$export$15f94404a081a771.filterSensitiveLog(obj.AnalyticsConfiguration)
        });
    };
})($bb3a6aefff166c77$export$32ac99bb59e9ea35 || ($bb3a6aefff166c77$export$32ac99bb59e9ea35 = {}));
var $bb3a6aefff166c77$export$a4b635f541d39c02;
(function(GetBucketAnalyticsConfigurationRequest) {
    GetBucketAnalyticsConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$a4b635f541d39c02 || ($bb3a6aefff166c77$export$a4b635f541d39c02 = {}));
var $bb3a6aefff166c77$export$483798435237259b;
(function(CORSRule) {
    CORSRule.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$483798435237259b || ($bb3a6aefff166c77$export$483798435237259b = {}));
var $bb3a6aefff166c77$export$3ff8c9c489aa7ab5;
(function(GetBucketCorsOutput) {
    GetBucketCorsOutput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$3ff8c9c489aa7ab5 || ($bb3a6aefff166c77$export$3ff8c9c489aa7ab5 = {}));
var $bb3a6aefff166c77$export$cdc36c4a20d66833;
(function(GetBucketCorsRequest) {
    GetBucketCorsRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$cdc36c4a20d66833 || ($bb3a6aefff166c77$export$cdc36c4a20d66833 = {}));
var $bb3a6aefff166c77$export$5e055b8b357210fd;
(function(ServerSideEncryptionByDefault) {
    ServerSideEncryptionByDefault.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, obj), obj.KMSMasterKeyID && {
            KMSMasterKeyID: (0, $IsgKV.SENSITIVE_STRING)
        });
    };
})($bb3a6aefff166c77$export$5e055b8b357210fd || ($bb3a6aefff166c77$export$5e055b8b357210fd = {}));
var $bb3a6aefff166c77$export$614e3b57594b8702;
(function(ServerSideEncryptionRule) {
    ServerSideEncryptionRule.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, obj), obj.ApplyServerSideEncryptionByDefault && {
            ApplyServerSideEncryptionByDefault: $bb3a6aefff166c77$export$5e055b8b357210fd.filterSensitiveLog(obj.ApplyServerSideEncryptionByDefault)
        });
    };
})($bb3a6aefff166c77$export$614e3b57594b8702 || ($bb3a6aefff166c77$export$614e3b57594b8702 = {}));
var $bb3a6aefff166c77$export$d53e5f9e3c3507bf;
(function(ServerSideEncryptionConfiguration) {
    ServerSideEncryptionConfiguration.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, obj), obj.Rules && {
            Rules: obj.Rules.map(function(item) {
                return $bb3a6aefff166c77$export$614e3b57594b8702.filterSensitiveLog(item);
            })
        });
    };
})($bb3a6aefff166c77$export$d53e5f9e3c3507bf || ($bb3a6aefff166c77$export$d53e5f9e3c3507bf = {}));
var $bb3a6aefff166c77$export$a5d815db4065bb4e;
(function(GetBucketEncryptionOutput) {
    GetBucketEncryptionOutput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, obj), obj.ServerSideEncryptionConfiguration && {
            ServerSideEncryptionConfiguration: $bb3a6aefff166c77$export$d53e5f9e3c3507bf.filterSensitiveLog(obj.ServerSideEncryptionConfiguration)
        });
    };
})($bb3a6aefff166c77$export$a5d815db4065bb4e || ($bb3a6aefff166c77$export$a5d815db4065bb4e = {}));
var $bb3a6aefff166c77$export$3871e35cee114580;
(function(GetBucketEncryptionRequest) {
    GetBucketEncryptionRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$3871e35cee114580 || ($bb3a6aefff166c77$export$3871e35cee114580 = {}));
var $bb3a6aefff166c77$export$538012949ecb1f02;
(function(IntelligentTieringAndOperator) {
    IntelligentTieringAndOperator.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$538012949ecb1f02 || ($bb3a6aefff166c77$export$538012949ecb1f02 = {}));
var $bb3a6aefff166c77$export$ee31c5d57e861da9;
(function(IntelligentTieringFilter) {
    IntelligentTieringFilter.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$ee31c5d57e861da9 || ($bb3a6aefff166c77$export$ee31c5d57e861da9 = {}));
var $bb3a6aefff166c77$export$45a8dbc307fd1b69;
(function(Tiering) {
    Tiering.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$45a8dbc307fd1b69 || ($bb3a6aefff166c77$export$45a8dbc307fd1b69 = {}));
var $bb3a6aefff166c77$export$a9d6845d45635cd6;
(function(IntelligentTieringConfiguration) {
    IntelligentTieringConfiguration.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$a9d6845d45635cd6 || ($bb3a6aefff166c77$export$a9d6845d45635cd6 = {}));
var $bb3a6aefff166c77$export$a5c98daa4e4d0978;
(function(GetBucketIntelligentTieringConfigurationOutput) {
    GetBucketIntelligentTieringConfigurationOutput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$a5c98daa4e4d0978 || ($bb3a6aefff166c77$export$a5c98daa4e4d0978 = {}));
var $bb3a6aefff166c77$export$2bc70aedd92acdd9;
(function(GetBucketIntelligentTieringConfigurationRequest) {
    GetBucketIntelligentTieringConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$2bc70aedd92acdd9 || ($bb3a6aefff166c77$export$2bc70aedd92acdd9 = {}));
var $bb3a6aefff166c77$export$51ca0161a096cac2;
(function(SSEKMS) {
    SSEKMS.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, obj), obj.KeyId && {
            KeyId: (0, $IsgKV.SENSITIVE_STRING)
        });
    };
})($bb3a6aefff166c77$export$51ca0161a096cac2 || ($bb3a6aefff166c77$export$51ca0161a096cac2 = {}));
var $bb3a6aefff166c77$export$e6fda754462bc5e9;
(function(SSES3) {
    SSES3.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$e6fda754462bc5e9 || ($bb3a6aefff166c77$export$e6fda754462bc5e9 = {}));
var $bb3a6aefff166c77$export$4507106f7965dad8;
(function(InventoryEncryption) {
    InventoryEncryption.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, obj), obj.SSEKMS && {
            SSEKMS: $bb3a6aefff166c77$export$51ca0161a096cac2.filterSensitiveLog(obj.SSEKMS)
        });
    };
})($bb3a6aefff166c77$export$4507106f7965dad8 || ($bb3a6aefff166c77$export$4507106f7965dad8 = {}));
var $bb3a6aefff166c77$export$dbf61758afa382d2;
(function(InventoryS3BucketDestination) {
    InventoryS3BucketDestination.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, obj), obj.Encryption && {
            Encryption: $bb3a6aefff166c77$export$4507106f7965dad8.filterSensitiveLog(obj.Encryption)
        });
    };
})($bb3a6aefff166c77$export$dbf61758afa382d2 || ($bb3a6aefff166c77$export$dbf61758afa382d2 = {}));
var $bb3a6aefff166c77$export$95a07687ea92cc86;
(function(InventoryDestination) {
    InventoryDestination.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, obj), obj.S3BucketDestination && {
            S3BucketDestination: $bb3a6aefff166c77$export$dbf61758afa382d2.filterSensitiveLog(obj.S3BucketDestination)
        });
    };
})($bb3a6aefff166c77$export$95a07687ea92cc86 || ($bb3a6aefff166c77$export$95a07687ea92cc86 = {}));
var $bb3a6aefff166c77$export$9cab1f8eb4898ac3;
(function(InventoryFilter) {
    InventoryFilter.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$9cab1f8eb4898ac3 || ($bb3a6aefff166c77$export$9cab1f8eb4898ac3 = {}));
var $bb3a6aefff166c77$export$80a40dd3d0e79f33;
(function(InventorySchedule) {
    InventorySchedule.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$80a40dd3d0e79f33 || ($bb3a6aefff166c77$export$80a40dd3d0e79f33 = {}));
var $bb3a6aefff166c77$export$e13e8ea2fe7b5717;
(function(InventoryConfiguration) {
    InventoryConfiguration.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, obj), obj.Destination && {
            Destination: $bb3a6aefff166c77$export$95a07687ea92cc86.filterSensitiveLog(obj.Destination)
        });
    };
})($bb3a6aefff166c77$export$e13e8ea2fe7b5717 || ($bb3a6aefff166c77$export$e13e8ea2fe7b5717 = {}));
var $bb3a6aefff166c77$export$4b7c0b968f94593a;
(function(GetBucketInventoryConfigurationOutput) {
    GetBucketInventoryConfigurationOutput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, obj), obj.InventoryConfiguration && {
            InventoryConfiguration: $bb3a6aefff166c77$export$e13e8ea2fe7b5717.filterSensitiveLog(obj.InventoryConfiguration)
        });
    };
})($bb3a6aefff166c77$export$4b7c0b968f94593a || ($bb3a6aefff166c77$export$4b7c0b968f94593a = {}));
var $bb3a6aefff166c77$export$2bcb6519092e8dbf;
(function(GetBucketInventoryConfigurationRequest) {
    GetBucketInventoryConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$2bcb6519092e8dbf || ($bb3a6aefff166c77$export$2bcb6519092e8dbf = {}));
var $bb3a6aefff166c77$export$87e69778058ef73d;
(function(LifecycleExpiration) {
    LifecycleExpiration.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$87e69778058ef73d || ($bb3a6aefff166c77$export$87e69778058ef73d = {}));
var $bb3a6aefff166c77$export$70a8e907770d2a36;
(function(LifecycleRuleAndOperator) {
    LifecycleRuleAndOperator.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$70a8e907770d2a36 || ($bb3a6aefff166c77$export$70a8e907770d2a36 = {}));
var $bb3a6aefff166c77$export$4338dba1e93ddaf4;
(function(LifecycleRuleFilter) {
    LifecycleRuleFilter.visit = function(value, visitor) {
        if (value.Prefix !== undefined) return visitor.Prefix(value.Prefix);
        if (value.Tag !== undefined) return visitor.Tag(value.Tag);
        if (value.And !== undefined) return visitor.And(value.And);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
    LifecycleRuleFilter.filterSensitiveLog = function(obj) {
        var _a;
        if (obj.Prefix !== undefined) return {
            Prefix: obj.Prefix
        };
        if (obj.Tag !== undefined) return {
            Tag: $bb3a6aefff166c77$export$3288d34c523a1192.filterSensitiveLog(obj.Tag)
        };
        if (obj.And !== undefined) return {
            And: $bb3a6aefff166c77$export$70a8e907770d2a36.filterSensitiveLog(obj.And)
        };
        if (obj.$unknown !== undefined) return _a = {}, _a[obj.$unknown[0]] = "UNKNOWN", _a;
    };
})($bb3a6aefff166c77$export$4338dba1e93ddaf4 || ($bb3a6aefff166c77$export$4338dba1e93ddaf4 = {}));
var $bb3a6aefff166c77$export$a99742a437d0fdf9;
(function(NoncurrentVersionExpiration) {
    NoncurrentVersionExpiration.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$a99742a437d0fdf9 || ($bb3a6aefff166c77$export$a99742a437d0fdf9 = {}));
var $bb3a6aefff166c77$export$9250e73c985ce931;
(function(NoncurrentVersionTransition) {
    NoncurrentVersionTransition.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$9250e73c985ce931 || ($bb3a6aefff166c77$export$9250e73c985ce931 = {}));
var $bb3a6aefff166c77$export$be58926105124dd4;
(function(Transition) {
    Transition.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$be58926105124dd4 || ($bb3a6aefff166c77$export$be58926105124dd4 = {}));
var $bb3a6aefff166c77$export$1ac30bbe41f1f9ef;
(function(LifecycleRule) {
    LifecycleRule.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, obj), obj.Filter && {
            Filter: $bb3a6aefff166c77$export$4338dba1e93ddaf4.filterSensitiveLog(obj.Filter)
        });
    };
})($bb3a6aefff166c77$export$1ac30bbe41f1f9ef || ($bb3a6aefff166c77$export$1ac30bbe41f1f9ef = {}));
var $bb3a6aefff166c77$export$f2f23f80c8c1c7c4;
(function(GetBucketLifecycleConfigurationOutput) {
    GetBucketLifecycleConfigurationOutput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, obj), obj.Rules && {
            Rules: obj.Rules.map(function(item) {
                return $bb3a6aefff166c77$export$1ac30bbe41f1f9ef.filterSensitiveLog(item);
            })
        });
    };
})($bb3a6aefff166c77$export$f2f23f80c8c1c7c4 || ($bb3a6aefff166c77$export$f2f23f80c8c1c7c4 = {}));
var $bb3a6aefff166c77$export$86e3489ab08ca98d;
(function(GetBucketLifecycleConfigurationRequest) {
    GetBucketLifecycleConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$86e3489ab08ca98d || ($bb3a6aefff166c77$export$86e3489ab08ca98d = {}));
var $bb3a6aefff166c77$export$ed9828a2500d585f;
(function(GetBucketLocationOutput) {
    GetBucketLocationOutput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$ed9828a2500d585f || ($bb3a6aefff166c77$export$ed9828a2500d585f = {}));
var $bb3a6aefff166c77$export$4109a69a89893a5d;
(function(GetBucketLocationRequest) {
    GetBucketLocationRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$4109a69a89893a5d || ($bb3a6aefff166c77$export$4109a69a89893a5d = {}));
var $bb3a6aefff166c77$export$cf4abd6ae8fde913;
(function(TargetGrant) {
    TargetGrant.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$cf4abd6ae8fde913 || ($bb3a6aefff166c77$export$cf4abd6ae8fde913 = {}));
var $bb3a6aefff166c77$export$a1484d354b9c56b2;
(function(LoggingEnabled) {
    LoggingEnabled.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$a1484d354b9c56b2 || ($bb3a6aefff166c77$export$a1484d354b9c56b2 = {}));
var $bb3a6aefff166c77$export$f9d2a0e32a2aa91f;
(function(GetBucketLoggingOutput) {
    GetBucketLoggingOutput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$f9d2a0e32a2aa91f || ($bb3a6aefff166c77$export$f9d2a0e32a2aa91f = {}));
var $bb3a6aefff166c77$export$182d23383f8b69bd;
(function(GetBucketLoggingRequest) {
    GetBucketLoggingRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$182d23383f8b69bd || ($bb3a6aefff166c77$export$182d23383f8b69bd = {}));
var $bb3a6aefff166c77$export$4774797e6eda832;
(function(MetricsAndOperator) {
    MetricsAndOperator.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$4774797e6eda832 || ($bb3a6aefff166c77$export$4774797e6eda832 = {}));
var $bb3a6aefff166c77$export$564a1f9c338cae45;
(function(MetricsFilter) {
    MetricsFilter.visit = function(value, visitor) {
        if (value.Prefix !== undefined) return visitor.Prefix(value.Prefix);
        if (value.Tag !== undefined) return visitor.Tag(value.Tag);
        if (value.And !== undefined) return visitor.And(value.And);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
    MetricsFilter.filterSensitiveLog = function(obj) {
        var _a;
        if (obj.Prefix !== undefined) return {
            Prefix: obj.Prefix
        };
        if (obj.Tag !== undefined) return {
            Tag: $bb3a6aefff166c77$export$3288d34c523a1192.filterSensitiveLog(obj.Tag)
        };
        if (obj.And !== undefined) return {
            And: $bb3a6aefff166c77$export$4774797e6eda832.filterSensitiveLog(obj.And)
        };
        if (obj.$unknown !== undefined) return _a = {}, _a[obj.$unknown[0]] = "UNKNOWN", _a;
    };
})($bb3a6aefff166c77$export$564a1f9c338cae45 || ($bb3a6aefff166c77$export$564a1f9c338cae45 = {}));
var $bb3a6aefff166c77$export$908bafa154008a5e;
(function(MetricsConfiguration) {
    MetricsConfiguration.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, obj), obj.Filter && {
            Filter: $bb3a6aefff166c77$export$564a1f9c338cae45.filterSensitiveLog(obj.Filter)
        });
    };
})($bb3a6aefff166c77$export$908bafa154008a5e || ($bb3a6aefff166c77$export$908bafa154008a5e = {}));
var $bb3a6aefff166c77$export$a52baffc56d738d2;
(function(GetBucketMetricsConfigurationOutput) {
    GetBucketMetricsConfigurationOutput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, obj), obj.MetricsConfiguration && {
            MetricsConfiguration: $bb3a6aefff166c77$export$908bafa154008a5e.filterSensitiveLog(obj.MetricsConfiguration)
        });
    };
})($bb3a6aefff166c77$export$a52baffc56d738d2 || ($bb3a6aefff166c77$export$a52baffc56d738d2 = {}));
var $bb3a6aefff166c77$export$af907f7627ae4ae9;
(function(GetBucketMetricsConfigurationRequest) {
    GetBucketMetricsConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$af907f7627ae4ae9 || ($bb3a6aefff166c77$export$af907f7627ae4ae9 = {}));
var $bb3a6aefff166c77$export$f00ac87a35076252;
(function(GetBucketNotificationConfigurationRequest) {
    GetBucketNotificationConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$f00ac87a35076252 || ($bb3a6aefff166c77$export$f00ac87a35076252 = {}));
var $bb3a6aefff166c77$export$74fc6120f048b9bc;
(function(FilterRule) {
    FilterRule.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$74fc6120f048b9bc || ($bb3a6aefff166c77$export$74fc6120f048b9bc = {}));
var $bb3a6aefff166c77$export$46101b74c47ec83a;
(function(S3KeyFilter) {
    S3KeyFilter.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$46101b74c47ec83a || ($bb3a6aefff166c77$export$46101b74c47ec83a = {}));
var $bb3a6aefff166c77$export$c3d4fc0e09105ced;
(function(NotificationConfigurationFilter) {
    NotificationConfigurationFilter.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$c3d4fc0e09105ced || ($bb3a6aefff166c77$export$c3d4fc0e09105ced = {}));
var $bb3a6aefff166c77$export$4916e52bc544d4ef;
(function(LambdaFunctionConfiguration) {
    LambdaFunctionConfiguration.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$4916e52bc544d4ef || ($bb3a6aefff166c77$export$4916e52bc544d4ef = {}));
var $bb3a6aefff166c77$export$b48f9efe98802c25;
(function(QueueConfiguration) {
    QueueConfiguration.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$b48f9efe98802c25 || ($bb3a6aefff166c77$export$b48f9efe98802c25 = {}));
var $bb3a6aefff166c77$export$c98b07f3d2e31343;
(function(TopicConfiguration) {
    TopicConfiguration.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$c98b07f3d2e31343 || ($bb3a6aefff166c77$export$c98b07f3d2e31343 = {}));
var $bb3a6aefff166c77$export$165cf006a6abc4b3;
(function(NotificationConfiguration) {
    NotificationConfiguration.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$165cf006a6abc4b3 || ($bb3a6aefff166c77$export$165cf006a6abc4b3 = {}));
var $bb3a6aefff166c77$export$403b2dc6ec5b8d13;
(function(OwnershipControlsRule) {
    OwnershipControlsRule.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$403b2dc6ec5b8d13 || ($bb3a6aefff166c77$export$403b2dc6ec5b8d13 = {}));
var $bb3a6aefff166c77$export$ae516ccf061cd7d1;
(function(OwnershipControls) {
    OwnershipControls.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$ae516ccf061cd7d1 || ($bb3a6aefff166c77$export$ae516ccf061cd7d1 = {}));
var $bb3a6aefff166c77$export$bb1e71315d618124;
(function(GetBucketOwnershipControlsOutput) {
    GetBucketOwnershipControlsOutput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$bb1e71315d618124 || ($bb3a6aefff166c77$export$bb1e71315d618124 = {}));
var $bb3a6aefff166c77$export$55fbc6554b27a2f6;
(function(GetBucketOwnershipControlsRequest) {
    GetBucketOwnershipControlsRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$55fbc6554b27a2f6 || ($bb3a6aefff166c77$export$55fbc6554b27a2f6 = {}));
var $bb3a6aefff166c77$export$29a8c95926d10996;
(function(GetBucketPolicyOutput) {
    GetBucketPolicyOutput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$29a8c95926d10996 || ($bb3a6aefff166c77$export$29a8c95926d10996 = {}));
var $bb3a6aefff166c77$export$fde59d57a80f46c6;
(function(GetBucketPolicyRequest) {
    GetBucketPolicyRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$fde59d57a80f46c6 || ($bb3a6aefff166c77$export$fde59d57a80f46c6 = {}));
var $bb3a6aefff166c77$export$77c4d21e3fd2b633;
(function(PolicyStatus) {
    PolicyStatus.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$77c4d21e3fd2b633 || ($bb3a6aefff166c77$export$77c4d21e3fd2b633 = {}));
var $bb3a6aefff166c77$export$c9cb93f92e1c4228;
(function(GetBucketPolicyStatusOutput) {
    GetBucketPolicyStatusOutput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$c9cb93f92e1c4228 || ($bb3a6aefff166c77$export$c9cb93f92e1c4228 = {}));
var $bb3a6aefff166c77$export$2e3b292047386a35;
(function(GetBucketPolicyStatusRequest) {
    GetBucketPolicyStatusRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$2e3b292047386a35 || ($bb3a6aefff166c77$export$2e3b292047386a35 = {}));
var $bb3a6aefff166c77$export$594f35c535ed76a3;
(function(DeleteMarkerReplication) {
    DeleteMarkerReplication.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$594f35c535ed76a3 || ($bb3a6aefff166c77$export$594f35c535ed76a3 = {}));
var $bb3a6aefff166c77$export$949641a4ad7f11d4;
(function(EncryptionConfiguration) {
    EncryptionConfiguration.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$949641a4ad7f11d4 || ($bb3a6aefff166c77$export$949641a4ad7f11d4 = {}));
var $bb3a6aefff166c77$export$d9823a04d7ef0d38;
(function(ReplicationTimeValue) {
    ReplicationTimeValue.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$d9823a04d7ef0d38 || ($bb3a6aefff166c77$export$d9823a04d7ef0d38 = {}));
var $bb3a6aefff166c77$export$ed9166ec0f465b5e;
(function(Metrics) {
    Metrics.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$ed9166ec0f465b5e || ($bb3a6aefff166c77$export$ed9166ec0f465b5e = {}));
var $bb3a6aefff166c77$export$666325b7ed44b812;
(function(ReplicationTime) {
    ReplicationTime.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$666325b7ed44b812 || ($bb3a6aefff166c77$export$666325b7ed44b812 = {}));
var $bb3a6aefff166c77$export$5c4bdf44e1e9cea1;
(function(Destination) {
    Destination.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$5c4bdf44e1e9cea1 || ($bb3a6aefff166c77$export$5c4bdf44e1e9cea1 = {}));
var $bb3a6aefff166c77$export$18e0c6d9cc0aaef5;
(function(ExistingObjectReplication) {
    ExistingObjectReplication.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$18e0c6d9cc0aaef5 || ($bb3a6aefff166c77$export$18e0c6d9cc0aaef5 = {}));
var $bb3a6aefff166c77$export$f149404143b7fc4f;
(function(ReplicationRuleAndOperator) {
    ReplicationRuleAndOperator.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$f149404143b7fc4f || ($bb3a6aefff166c77$export$f149404143b7fc4f = {}));
var $bb3a6aefff166c77$export$c5652b893758d9eb;
(function(ReplicationRuleFilter) {
    ReplicationRuleFilter.visit = function(value, visitor) {
        if (value.Prefix !== undefined) return visitor.Prefix(value.Prefix);
        if (value.Tag !== undefined) return visitor.Tag(value.Tag);
        if (value.And !== undefined) return visitor.And(value.And);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
    ReplicationRuleFilter.filterSensitiveLog = function(obj) {
        var _a;
        if (obj.Prefix !== undefined) return {
            Prefix: obj.Prefix
        };
        if (obj.Tag !== undefined) return {
            Tag: $bb3a6aefff166c77$export$3288d34c523a1192.filterSensitiveLog(obj.Tag)
        };
        if (obj.And !== undefined) return {
            And: $bb3a6aefff166c77$export$f149404143b7fc4f.filterSensitiveLog(obj.And)
        };
        if (obj.$unknown !== undefined) return _a = {}, _a[obj.$unknown[0]] = "UNKNOWN", _a;
    };
})($bb3a6aefff166c77$export$c5652b893758d9eb || ($bb3a6aefff166c77$export$c5652b893758d9eb = {}));
var $bb3a6aefff166c77$export$79ea81eaeed7f3c8;
(function(ReplicaModifications) {
    ReplicaModifications.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$79ea81eaeed7f3c8 || ($bb3a6aefff166c77$export$79ea81eaeed7f3c8 = {}));
var $bb3a6aefff166c77$export$d6dbaa0624096385;
(function(SseKmsEncryptedObjects) {
    SseKmsEncryptedObjects.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$d6dbaa0624096385 || ($bb3a6aefff166c77$export$d6dbaa0624096385 = {}));
var $bb3a6aefff166c77$export$8f4bdf07a780e3ac;
(function(SourceSelectionCriteria) {
    SourceSelectionCriteria.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$8f4bdf07a780e3ac || ($bb3a6aefff166c77$export$8f4bdf07a780e3ac = {}));
var $bb3a6aefff166c77$export$4ef0a2a837294f64;
(function(ReplicationRule) {
    ReplicationRule.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, obj), obj.Filter && {
            Filter: $bb3a6aefff166c77$export$c5652b893758d9eb.filterSensitiveLog(obj.Filter)
        });
    };
})($bb3a6aefff166c77$export$4ef0a2a837294f64 || ($bb3a6aefff166c77$export$4ef0a2a837294f64 = {}));
var $bb3a6aefff166c77$export$74f8efd37d5209b2;
(function(ReplicationConfiguration) {
    ReplicationConfiguration.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, obj), obj.Rules && {
            Rules: obj.Rules.map(function(item) {
                return $bb3a6aefff166c77$export$4ef0a2a837294f64.filterSensitiveLog(item);
            })
        });
    };
})($bb3a6aefff166c77$export$74f8efd37d5209b2 || ($bb3a6aefff166c77$export$74f8efd37d5209b2 = {}));
var $bb3a6aefff166c77$export$8ec47a87cc54e339;
(function(GetBucketReplicationOutput) {
    GetBucketReplicationOutput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, obj), obj.ReplicationConfiguration && {
            ReplicationConfiguration: $bb3a6aefff166c77$export$74f8efd37d5209b2.filterSensitiveLog(obj.ReplicationConfiguration)
        });
    };
})($bb3a6aefff166c77$export$8ec47a87cc54e339 || ($bb3a6aefff166c77$export$8ec47a87cc54e339 = {}));
var $bb3a6aefff166c77$export$e8f64af8ca33bbfd;
(function(GetBucketReplicationRequest) {
    GetBucketReplicationRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$e8f64af8ca33bbfd || ($bb3a6aefff166c77$export$e8f64af8ca33bbfd = {}));
var $bb3a6aefff166c77$export$8b846c4a43a75e9e;
(function(GetBucketRequestPaymentOutput) {
    GetBucketRequestPaymentOutput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$8b846c4a43a75e9e || ($bb3a6aefff166c77$export$8b846c4a43a75e9e = {}));
var $bb3a6aefff166c77$export$a3b6600fe888f873;
(function(GetBucketRequestPaymentRequest) {
    GetBucketRequestPaymentRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$a3b6600fe888f873 || ($bb3a6aefff166c77$export$a3b6600fe888f873 = {}));
var $bb3a6aefff166c77$export$b794c693046ccc37;
(function(GetBucketTaggingOutput) {
    GetBucketTaggingOutput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$b794c693046ccc37 || ($bb3a6aefff166c77$export$b794c693046ccc37 = {}));
var $bb3a6aefff166c77$export$4cb4643c20453b75;
(function(GetBucketTaggingRequest) {
    GetBucketTaggingRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$4cb4643c20453b75 || ($bb3a6aefff166c77$export$4cb4643c20453b75 = {}));
var $bb3a6aefff166c77$export$6f458e80d9a168b;
(function(GetBucketVersioningOutput) {
    GetBucketVersioningOutput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$6f458e80d9a168b || ($bb3a6aefff166c77$export$6f458e80d9a168b = {}));
var $bb3a6aefff166c77$export$199936fd6251213c;
(function(GetBucketVersioningRequest) {
    GetBucketVersioningRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$199936fd6251213c || ($bb3a6aefff166c77$export$199936fd6251213c = {}));
var $bb3a6aefff166c77$export$4afca95d558fb444;
(function(ErrorDocument) {
    ErrorDocument.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$4afca95d558fb444 || ($bb3a6aefff166c77$export$4afca95d558fb444 = {}));
var $bb3a6aefff166c77$export$c07750ef20ad8d6c;
(function(IndexDocument) {
    IndexDocument.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$c07750ef20ad8d6c || ($bb3a6aefff166c77$export$c07750ef20ad8d6c = {}));
var $bb3a6aefff166c77$export$98dc4d8bbaac5b7c;
(function(RedirectAllRequestsTo) {
    RedirectAllRequestsTo.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$98dc4d8bbaac5b7c || ($bb3a6aefff166c77$export$98dc4d8bbaac5b7c = {}));
var $bb3a6aefff166c77$export$fcea0b2db26e6b18;
(function(Condition) {
    Condition.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$fcea0b2db26e6b18 || ($bb3a6aefff166c77$export$fcea0b2db26e6b18 = {}));
var $bb3a6aefff166c77$export$2d8d895a0a0f636e;
(function(Redirect) {
    Redirect.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$2d8d895a0a0f636e || ($bb3a6aefff166c77$export$2d8d895a0a0f636e = {}));
var $bb3a6aefff166c77$export$6464c2c4399038e2;
(function(RoutingRule) {
    RoutingRule.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$6464c2c4399038e2 || ($bb3a6aefff166c77$export$6464c2c4399038e2 = {}));
var $bb3a6aefff166c77$export$4632dcd1018fd6bd;
(function(GetBucketWebsiteOutput) {
    GetBucketWebsiteOutput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$4632dcd1018fd6bd || ($bb3a6aefff166c77$export$4632dcd1018fd6bd = {}));
var $bb3a6aefff166c77$export$b51e2df1df27d690;
(function(GetBucketWebsiteRequest) {
    GetBucketWebsiteRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$b51e2df1df27d690 || ($bb3a6aefff166c77$export$b51e2df1df27d690 = {}));
var $bb3a6aefff166c77$export$9fb6bec1a5c954d6;
(function(GetObjectOutput) {
    GetObjectOutput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, obj), obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $IsgKV.SENSITIVE_STRING)
        });
    };
})($bb3a6aefff166c77$export$9fb6bec1a5c954d6 || ($bb3a6aefff166c77$export$9fb6bec1a5c954d6 = {}));
var $bb3a6aefff166c77$export$3373ea9743883feb;
(function(GetObjectRequest) {
    GetObjectRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, obj), obj.SSECustomerKey && {
            SSECustomerKey: (0, $IsgKV.SENSITIVE_STRING)
        });
    };
})($bb3a6aefff166c77$export$3373ea9743883feb || ($bb3a6aefff166c77$export$3373ea9743883feb = {}));
var $bb3a6aefff166c77$export$6424f05126e7daf8;
(function(InvalidObjectState) {
    InvalidObjectState.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$6424f05126e7daf8 || ($bb3a6aefff166c77$export$6424f05126e7daf8 = {}));
var $bb3a6aefff166c77$export$1f6f8c73c651f3ca;
(function(NoSuchKey) {
    NoSuchKey.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$1f6f8c73c651f3ca || ($bb3a6aefff166c77$export$1f6f8c73c651f3ca = {}));
var $bb3a6aefff166c77$export$7c40a2227fecdc12;
(function(GetObjectAclOutput) {
    GetObjectAclOutput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$7c40a2227fecdc12 || ($bb3a6aefff166c77$export$7c40a2227fecdc12 = {}));
var $bb3a6aefff166c77$export$cb1a4ad2e0f38f95;
(function(GetObjectAclRequest) {
    GetObjectAclRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$cb1a4ad2e0f38f95 || ($bb3a6aefff166c77$export$cb1a4ad2e0f38f95 = {}));
var $bb3a6aefff166c77$export$f3dff23941310d9;
(function(ObjectLockLegalHold) {
    ObjectLockLegalHold.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$f3dff23941310d9 || ($bb3a6aefff166c77$export$f3dff23941310d9 = {}));
var $bb3a6aefff166c77$export$9939dc80bbea1acd;
(function(GetObjectLegalHoldOutput) {
    GetObjectLegalHoldOutput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$9939dc80bbea1acd || ($bb3a6aefff166c77$export$9939dc80bbea1acd = {}));
var $bb3a6aefff166c77$export$5f8862ba76850511;
(function(GetObjectLegalHoldRequest) {
    GetObjectLegalHoldRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$5f8862ba76850511 || ($bb3a6aefff166c77$export$5f8862ba76850511 = {}));
var $bb3a6aefff166c77$export$705dac3c9e25f673;
(function(DefaultRetention) {
    DefaultRetention.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$705dac3c9e25f673 || ($bb3a6aefff166c77$export$705dac3c9e25f673 = {}));
var $bb3a6aefff166c77$export$62ac1d02f31163e0;
(function(ObjectLockRule) {
    ObjectLockRule.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$62ac1d02f31163e0 || ($bb3a6aefff166c77$export$62ac1d02f31163e0 = {}));
var $bb3a6aefff166c77$export$262d239426342c96;
(function(ObjectLockConfiguration) {
    ObjectLockConfiguration.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$262d239426342c96 || ($bb3a6aefff166c77$export$262d239426342c96 = {}));
var $bb3a6aefff166c77$export$486dc804d3714e8e;
(function(GetObjectLockConfigurationOutput) {
    GetObjectLockConfigurationOutput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$486dc804d3714e8e || ($bb3a6aefff166c77$export$486dc804d3714e8e = {}));
var $bb3a6aefff166c77$export$43efa1cb9cbd5c84;
(function(GetObjectLockConfigurationRequest) {
    GetObjectLockConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$43efa1cb9cbd5c84 || ($bb3a6aefff166c77$export$43efa1cb9cbd5c84 = {}));
var $bb3a6aefff166c77$export$a0bcf720e4ebfa6b;
(function(ObjectLockRetention) {
    ObjectLockRetention.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$a0bcf720e4ebfa6b || ($bb3a6aefff166c77$export$a0bcf720e4ebfa6b = {}));
var $bb3a6aefff166c77$export$5a061f69fa492eee;
(function(GetObjectRetentionOutput) {
    GetObjectRetentionOutput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$5a061f69fa492eee || ($bb3a6aefff166c77$export$5a061f69fa492eee = {}));
var $bb3a6aefff166c77$export$bd618fd4d0be1150;
(function(GetObjectRetentionRequest) {
    GetObjectRetentionRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$bd618fd4d0be1150 || ($bb3a6aefff166c77$export$bd618fd4d0be1150 = {}));
var $bb3a6aefff166c77$export$21e84ade4ffc813f;
(function(GetObjectTaggingOutput) {
    GetObjectTaggingOutput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$21e84ade4ffc813f || ($bb3a6aefff166c77$export$21e84ade4ffc813f = {}));
var $bb3a6aefff166c77$export$e8c3f2a82ba22432;
(function(GetObjectTaggingRequest) {
    GetObjectTaggingRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$e8c3f2a82ba22432 || ($bb3a6aefff166c77$export$e8c3f2a82ba22432 = {}));
var $bb3a6aefff166c77$export$c7be7807f0a3eea;
(function(GetObjectTorrentOutput) {
    GetObjectTorrentOutput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$c7be7807f0a3eea || ($bb3a6aefff166c77$export$c7be7807f0a3eea = {}));
var $bb3a6aefff166c77$export$93e32e1b0e5460eb;
(function(GetObjectTorrentRequest) {
    GetObjectTorrentRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$93e32e1b0e5460eb || ($bb3a6aefff166c77$export$93e32e1b0e5460eb = {}));
var $bb3a6aefff166c77$export$d5abbb05d727be20;
(function(PublicAccessBlockConfiguration) {
    PublicAccessBlockConfiguration.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$d5abbb05d727be20 || ($bb3a6aefff166c77$export$d5abbb05d727be20 = {}));
var $bb3a6aefff166c77$export$3606af58a9ffe87;
(function(GetPublicAccessBlockOutput) {
    GetPublicAccessBlockOutput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$3606af58a9ffe87 || ($bb3a6aefff166c77$export$3606af58a9ffe87 = {}));
var $bb3a6aefff166c77$export$f768b28d574460bb;
(function(GetPublicAccessBlockRequest) {
    GetPublicAccessBlockRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$f768b28d574460bb || ($bb3a6aefff166c77$export$f768b28d574460bb = {}));
var $bb3a6aefff166c77$export$ce473fe6d5e62bdd;
(function(HeadBucketRequest) {
    HeadBucketRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$ce473fe6d5e62bdd || ($bb3a6aefff166c77$export$ce473fe6d5e62bdd = {}));
var $bb3a6aefff166c77$export$bbe89283205bd874;
(function(NoSuchBucket) {
    NoSuchBucket.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$bbe89283205bd874 || ($bb3a6aefff166c77$export$bbe89283205bd874 = {}));
var $bb3a6aefff166c77$export$fd185f7330520684;
(function(HeadObjectOutput) {
    HeadObjectOutput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, obj), obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $IsgKV.SENSITIVE_STRING)
        });
    };
})($bb3a6aefff166c77$export$fd185f7330520684 || ($bb3a6aefff166c77$export$fd185f7330520684 = {}));
var $bb3a6aefff166c77$export$e9eaca65791fc4c;
(function(HeadObjectRequest) {
    HeadObjectRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, obj), obj.SSECustomerKey && {
            SSECustomerKey: (0, $IsgKV.SENSITIVE_STRING)
        });
    };
})($bb3a6aefff166c77$export$e9eaca65791fc4c || ($bb3a6aefff166c77$export$e9eaca65791fc4c = {}));
var $bb3a6aefff166c77$export$cccced7f72820034;
(function(ListBucketAnalyticsConfigurationsOutput) {
    ListBucketAnalyticsConfigurationsOutput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, obj), obj.AnalyticsConfigurationList && {
            AnalyticsConfigurationList: obj.AnalyticsConfigurationList.map(function(item) {
                return $bb3a6aefff166c77$export$15f94404a081a771.filterSensitiveLog(item);
            })
        });
    };
})($bb3a6aefff166c77$export$cccced7f72820034 || ($bb3a6aefff166c77$export$cccced7f72820034 = {}));
var $bb3a6aefff166c77$export$397b8f33cb9cfc07;
(function(ListBucketAnalyticsConfigurationsRequest) {
    ListBucketAnalyticsConfigurationsRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$397b8f33cb9cfc07 || ($bb3a6aefff166c77$export$397b8f33cb9cfc07 = {}));
var $bb3a6aefff166c77$export$b33d88b03a3d62f7;
(function(ListBucketIntelligentTieringConfigurationsOutput) {
    ListBucketIntelligentTieringConfigurationsOutput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$b33d88b03a3d62f7 || ($bb3a6aefff166c77$export$b33d88b03a3d62f7 = {}));
var $bb3a6aefff166c77$export$8bc390bdd26b4fe7;
(function(ListBucketIntelligentTieringConfigurationsRequest) {
    ListBucketIntelligentTieringConfigurationsRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$8bc390bdd26b4fe7 || ($bb3a6aefff166c77$export$8bc390bdd26b4fe7 = {}));
var $bb3a6aefff166c77$export$9e6dae27db161fe4;
(function(ListBucketInventoryConfigurationsOutput) {
    ListBucketInventoryConfigurationsOutput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, obj), obj.InventoryConfigurationList && {
            InventoryConfigurationList: obj.InventoryConfigurationList.map(function(item) {
                return $bb3a6aefff166c77$export$e13e8ea2fe7b5717.filterSensitiveLog(item);
            })
        });
    };
})($bb3a6aefff166c77$export$9e6dae27db161fe4 || ($bb3a6aefff166c77$export$9e6dae27db161fe4 = {}));
var $bb3a6aefff166c77$export$443f8cd22179a9b7;
(function(ListBucketInventoryConfigurationsRequest) {
    ListBucketInventoryConfigurationsRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$443f8cd22179a9b7 || ($bb3a6aefff166c77$export$443f8cd22179a9b7 = {}));
var $bb3a6aefff166c77$export$a94e91ae224bc393;
(function(ListBucketMetricsConfigurationsOutput) {
    ListBucketMetricsConfigurationsOutput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, obj), obj.MetricsConfigurationList && {
            MetricsConfigurationList: obj.MetricsConfigurationList.map(function(item) {
                return $bb3a6aefff166c77$export$908bafa154008a5e.filterSensitiveLog(item);
            })
        });
    };
})($bb3a6aefff166c77$export$a94e91ae224bc393 || ($bb3a6aefff166c77$export$a94e91ae224bc393 = {}));
var $bb3a6aefff166c77$export$18bea5a661e91351;
(function(ListBucketMetricsConfigurationsRequest) {
    ListBucketMetricsConfigurationsRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$18bea5a661e91351 || ($bb3a6aefff166c77$export$18bea5a661e91351 = {}));
var $bb3a6aefff166c77$export$356eb44c374cfc19;
(function(Bucket) {
    Bucket.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$356eb44c374cfc19 || ($bb3a6aefff166c77$export$356eb44c374cfc19 = {}));
var $bb3a6aefff166c77$export$fb68aea51fc1aaa8;
(function(ListBucketsOutput) {
    ListBucketsOutput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$fb68aea51fc1aaa8 || ($bb3a6aefff166c77$export$fb68aea51fc1aaa8 = {}));
var $bb3a6aefff166c77$export$70a8419756bd30c7;
(function(CommonPrefix) {
    CommonPrefix.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$70a8419756bd30c7 || ($bb3a6aefff166c77$export$70a8419756bd30c7 = {}));
var $bb3a6aefff166c77$export$f2cea2a27584e4aa;
(function(Initiator) {
    Initiator.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$f2cea2a27584e4aa || ($bb3a6aefff166c77$export$f2cea2a27584e4aa = {}));
var $bb3a6aefff166c77$export$60e639cfe2512bff;
(function(MultipartUpload) {
    MultipartUpload.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$60e639cfe2512bff || ($bb3a6aefff166c77$export$60e639cfe2512bff = {}));
var $bb3a6aefff166c77$export$ed83d15740b9f76d;
(function(ListMultipartUploadsOutput) {
    ListMultipartUploadsOutput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$ed83d15740b9f76d || ($bb3a6aefff166c77$export$ed83d15740b9f76d = {}));
var $bb3a6aefff166c77$export$d96c3e2cf9803f5e;
(function(ListMultipartUploadsRequest) {
    ListMultipartUploadsRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$d96c3e2cf9803f5e || ($bb3a6aefff166c77$export$d96c3e2cf9803f5e = {}));
var $bb3a6aefff166c77$export$dcacc4a8f6015c36;
(function(_Object) {
    _Object.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$dcacc4a8f6015c36 || ($bb3a6aefff166c77$export$dcacc4a8f6015c36 = {}));
var $bb3a6aefff166c77$export$bd5de99c03e50bdf;
(function(ListObjectsOutput) {
    ListObjectsOutput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$bd5de99c03e50bdf || ($bb3a6aefff166c77$export$bd5de99c03e50bdf = {}));
var $bb3a6aefff166c77$export$b17e2bd91a04aa76;
(function(ListObjectsRequest) {
    ListObjectsRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$b17e2bd91a04aa76 || ($bb3a6aefff166c77$export$b17e2bd91a04aa76 = {}));
var $bb3a6aefff166c77$export$6fb2827b4fe28be3;
(function(ListObjectsV2Output) {
    ListObjectsV2Output.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$6fb2827b4fe28be3 || ($bb3a6aefff166c77$export$6fb2827b4fe28be3 = {}));
var $bb3a6aefff166c77$export$32fa6adfa8e5165a;
(function(ListObjectsV2Request) {
    ListObjectsV2Request.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$32fa6adfa8e5165a || ($bb3a6aefff166c77$export$32fa6adfa8e5165a = {}));
var $bb3a6aefff166c77$export$a834fe68df71f671;
(function(DeleteMarkerEntry) {
    DeleteMarkerEntry.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$a834fe68df71f671 || ($bb3a6aefff166c77$export$a834fe68df71f671 = {}));
var $bb3a6aefff166c77$export$3288b5b55ddbb34f;
(function(ObjectVersion) {
    ObjectVersion.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$3288b5b55ddbb34f || ($bb3a6aefff166c77$export$3288b5b55ddbb34f = {}));
var $bb3a6aefff166c77$export$4037923dade2a143;
(function(ListObjectVersionsOutput) {
    ListObjectVersionsOutput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$4037923dade2a143 || ($bb3a6aefff166c77$export$4037923dade2a143 = {}));
var $bb3a6aefff166c77$export$7420470087543a24;
(function(ListObjectVersionsRequest) {
    ListObjectVersionsRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$7420470087543a24 || ($bb3a6aefff166c77$export$7420470087543a24 = {}));
var $bb3a6aefff166c77$export$7b5bf7981d51054e;
(function(Part) {
    Part.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$7b5bf7981d51054e || ($bb3a6aefff166c77$export$7b5bf7981d51054e = {}));
var $bb3a6aefff166c77$export$8c83b46649a5c089;
(function(ListPartsOutput) {
    ListPartsOutput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$8c83b46649a5c089 || ($bb3a6aefff166c77$export$8c83b46649a5c089 = {}));
var $bb3a6aefff166c77$export$756cf37efa2403e6;
(function(ListPartsRequest) {
    ListPartsRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$756cf37efa2403e6 || ($bb3a6aefff166c77$export$756cf37efa2403e6 = {}));
var $bb3a6aefff166c77$export$95f02e50cfd87383;
(function(PutBucketAccelerateConfigurationRequest) {
    PutBucketAccelerateConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$95f02e50cfd87383 || ($bb3a6aefff166c77$export$95f02e50cfd87383 = {}));
var $bb3a6aefff166c77$export$15919ea85d7751db;
(function(PutBucketAclRequest) {
    PutBucketAclRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$15919ea85d7751db || ($bb3a6aefff166c77$export$15919ea85d7751db = {}));
var $bb3a6aefff166c77$export$b29e71de1c43092d;
(function(PutBucketAnalyticsConfigurationRequest) {
    PutBucketAnalyticsConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, obj), obj.AnalyticsConfiguration && {
            AnalyticsConfiguration: $bb3a6aefff166c77$export$15f94404a081a771.filterSensitiveLog(obj.AnalyticsConfiguration)
        });
    };
})($bb3a6aefff166c77$export$b29e71de1c43092d || ($bb3a6aefff166c77$export$b29e71de1c43092d = {}));
var $bb3a6aefff166c77$export$4efc44a8f577c4c6;
(function(CORSConfiguration) {
    CORSConfiguration.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$4efc44a8f577c4c6 || ($bb3a6aefff166c77$export$4efc44a8f577c4c6 = {}));
var $bb3a6aefff166c77$export$48388c72802bf3b4;
(function(PutBucketCorsRequest) {
    PutBucketCorsRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$48388c72802bf3b4 || ($bb3a6aefff166c77$export$48388c72802bf3b4 = {}));
var $bb3a6aefff166c77$export$b9464fee92783639;
(function(PutBucketEncryptionRequest) {
    PutBucketEncryptionRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, obj), obj.ServerSideEncryptionConfiguration && {
            ServerSideEncryptionConfiguration: $bb3a6aefff166c77$export$d53e5f9e3c3507bf.filterSensitiveLog(obj.ServerSideEncryptionConfiguration)
        });
    };
})($bb3a6aefff166c77$export$b9464fee92783639 || ($bb3a6aefff166c77$export$b9464fee92783639 = {}));
var $bb3a6aefff166c77$export$8ecc19836abd960;
(function(PutBucketIntelligentTieringConfigurationRequest) {
    PutBucketIntelligentTieringConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$8ecc19836abd960 || ($bb3a6aefff166c77$export$8ecc19836abd960 = {}));
var $bb3a6aefff166c77$export$7bce979f7abe4f73;
(function(PutBucketInventoryConfigurationRequest) {
    PutBucketInventoryConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, obj), obj.InventoryConfiguration && {
            InventoryConfiguration: $bb3a6aefff166c77$export$e13e8ea2fe7b5717.filterSensitiveLog(obj.InventoryConfiguration)
        });
    };
})($bb3a6aefff166c77$export$7bce979f7abe4f73 || ($bb3a6aefff166c77$export$7bce979f7abe4f73 = {}));
var $bb3a6aefff166c77$export$2bad5a8856023522;
(function(BucketLifecycleConfiguration) {
    BucketLifecycleConfiguration.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, obj), obj.Rules && {
            Rules: obj.Rules.map(function(item) {
                return $bb3a6aefff166c77$export$1ac30bbe41f1f9ef.filterSensitiveLog(item);
            })
        });
    };
})($bb3a6aefff166c77$export$2bad5a8856023522 || ($bb3a6aefff166c77$export$2bad5a8856023522 = {}));
var $bb3a6aefff166c77$export$b1f1a3c5136805f6;
(function(PutBucketLifecycleConfigurationRequest) {
    PutBucketLifecycleConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, obj), obj.LifecycleConfiguration && {
            LifecycleConfiguration: $bb3a6aefff166c77$export$2bad5a8856023522.filterSensitiveLog(obj.LifecycleConfiguration)
        });
    };
})($bb3a6aefff166c77$export$b1f1a3c5136805f6 || ($bb3a6aefff166c77$export$b1f1a3c5136805f6 = {}));
var $bb3a6aefff166c77$export$c183b06f38322f46;
(function(BucketLoggingStatus) {
    BucketLoggingStatus.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$c183b06f38322f46 || ($bb3a6aefff166c77$export$c183b06f38322f46 = {}));
var $bb3a6aefff166c77$export$b7513dc0595a23bf;
(function(PutBucketLoggingRequest) {
    PutBucketLoggingRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$b7513dc0595a23bf || ($bb3a6aefff166c77$export$b7513dc0595a23bf = {}));
var $bb3a6aefff166c77$export$848d3e19e2b6526f;
(function(PutBucketMetricsConfigurationRequest) {
    PutBucketMetricsConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, obj), obj.MetricsConfiguration && {
            MetricsConfiguration: $bb3a6aefff166c77$export$908bafa154008a5e.filterSensitiveLog(obj.MetricsConfiguration)
        });
    };
})($bb3a6aefff166c77$export$848d3e19e2b6526f || ($bb3a6aefff166c77$export$848d3e19e2b6526f = {}));
var $bb3a6aefff166c77$export$832249f88bdec051;
(function(PutBucketNotificationConfigurationRequest) {
    PutBucketNotificationConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$832249f88bdec051 || ($bb3a6aefff166c77$export$832249f88bdec051 = {}));
var $bb3a6aefff166c77$export$dd5b80748bfa876c;
(function(PutBucketOwnershipControlsRequest) {
    PutBucketOwnershipControlsRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$dd5b80748bfa876c || ($bb3a6aefff166c77$export$dd5b80748bfa876c = {}));
var $bb3a6aefff166c77$export$a3745e522d5251e6;
(function(PutBucketPolicyRequest) {
    PutBucketPolicyRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$a3745e522d5251e6 || ($bb3a6aefff166c77$export$a3745e522d5251e6 = {}));
var $bb3a6aefff166c77$export$80d3d606687bccbe;
(function(PutBucketReplicationRequest) {
    PutBucketReplicationRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, obj), obj.ReplicationConfiguration && {
            ReplicationConfiguration: $bb3a6aefff166c77$export$74f8efd37d5209b2.filterSensitiveLog(obj.ReplicationConfiguration)
        });
    };
})($bb3a6aefff166c77$export$80d3d606687bccbe || ($bb3a6aefff166c77$export$80d3d606687bccbe = {}));
var $bb3a6aefff166c77$export$5b5564785205c8b6;
(function(RequestPaymentConfiguration) {
    RequestPaymentConfiguration.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$5b5564785205c8b6 || ($bb3a6aefff166c77$export$5b5564785205c8b6 = {}));
var $bb3a6aefff166c77$export$efe882c45e4d54c5;
(function(PutBucketRequestPaymentRequest) {
    PutBucketRequestPaymentRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$efe882c45e4d54c5 || ($bb3a6aefff166c77$export$efe882c45e4d54c5 = {}));
var $bb3a6aefff166c77$export$2c6436847badca04;
(function(Tagging) {
    Tagging.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$2c6436847badca04 || ($bb3a6aefff166c77$export$2c6436847badca04 = {}));
var $bb3a6aefff166c77$export$907025fe881c3d35;
(function(PutBucketTaggingRequest) {
    PutBucketTaggingRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$907025fe881c3d35 || ($bb3a6aefff166c77$export$907025fe881c3d35 = {}));
var $bb3a6aefff166c77$export$12496b4e466310a9;
(function(VersioningConfiguration) {
    VersioningConfiguration.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$12496b4e466310a9 || ($bb3a6aefff166c77$export$12496b4e466310a9 = {}));
var $bb3a6aefff166c77$export$b342a4ff3cacc8f6;
(function(PutBucketVersioningRequest) {
    PutBucketVersioningRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$b342a4ff3cacc8f6 || ($bb3a6aefff166c77$export$b342a4ff3cacc8f6 = {}));
var $bb3a6aefff166c77$export$aec172fe960d640d;
(function(WebsiteConfiguration) {
    WebsiteConfiguration.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$aec172fe960d640d || ($bb3a6aefff166c77$export$aec172fe960d640d = {}));
var $bb3a6aefff166c77$export$98e48334698c13d8;
(function(PutBucketWebsiteRequest) {
    PutBucketWebsiteRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$98e48334698c13d8 || ($bb3a6aefff166c77$export$98e48334698c13d8 = {}));
var $bb3a6aefff166c77$export$792cedced515bdbd;
(function(PutObjectOutput) {
    PutObjectOutput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, obj), obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $IsgKV.SENSITIVE_STRING)
        }), obj.SSEKMSEncryptionContext && {
            SSEKMSEncryptionContext: (0, $IsgKV.SENSITIVE_STRING)
        });
    };
})($bb3a6aefff166c77$export$792cedced515bdbd || ($bb3a6aefff166c77$export$792cedced515bdbd = {}));
var $bb3a6aefff166c77$export$90c5c1bf0f634d21;
(function(PutObjectRequest) {
    PutObjectRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, obj), obj.SSECustomerKey && {
            SSECustomerKey: (0, $IsgKV.SENSITIVE_STRING)
        }), obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $IsgKV.SENSITIVE_STRING)
        }), obj.SSEKMSEncryptionContext && {
            SSEKMSEncryptionContext: (0, $IsgKV.SENSITIVE_STRING)
        });
    };
})($bb3a6aefff166c77$export$90c5c1bf0f634d21 || ($bb3a6aefff166c77$export$90c5c1bf0f634d21 = {}));
var $bb3a6aefff166c77$export$e533775617728d56;
(function(PutObjectAclOutput) {
    PutObjectAclOutput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$e533775617728d56 || ($bb3a6aefff166c77$export$e533775617728d56 = {}));
var $bb3a6aefff166c77$export$3dc01ad48475bf08;
(function(PutObjectAclRequest) {
    PutObjectAclRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$3dc01ad48475bf08 || ($bb3a6aefff166c77$export$3dc01ad48475bf08 = {}));
var $bb3a6aefff166c77$export$d9144478e705d522;
(function(PutObjectLegalHoldOutput) {
    PutObjectLegalHoldOutput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$d9144478e705d522 || ($bb3a6aefff166c77$export$d9144478e705d522 = {}));
var $bb3a6aefff166c77$export$71c3c7a041df44ca;
(function(PutObjectLegalHoldRequest) {
    PutObjectLegalHoldRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$71c3c7a041df44ca || ($bb3a6aefff166c77$export$71c3c7a041df44ca = {}));
var $bb3a6aefff166c77$export$93f296cba8bc1760;
(function(PutObjectLockConfigurationOutput) {
    PutObjectLockConfigurationOutput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$93f296cba8bc1760 || ($bb3a6aefff166c77$export$93f296cba8bc1760 = {}));
var $bb3a6aefff166c77$export$693145724507a617;
(function(PutObjectLockConfigurationRequest) {
    PutObjectLockConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$693145724507a617 || ($bb3a6aefff166c77$export$693145724507a617 = {}));
var $bb3a6aefff166c77$export$edd40f596f5fa31e;
(function(PutObjectRetentionOutput) {
    PutObjectRetentionOutput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$edd40f596f5fa31e || ($bb3a6aefff166c77$export$edd40f596f5fa31e = {}));
var $bb3a6aefff166c77$export$117e9cab66df5006;
(function(PutObjectRetentionRequest) {
    PutObjectRetentionRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$117e9cab66df5006 || ($bb3a6aefff166c77$export$117e9cab66df5006 = {}));
var $bb3a6aefff166c77$export$d9e3a7e4f51c31d5;
(function(PutObjectTaggingOutput) {
    PutObjectTaggingOutput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$d9e3a7e4f51c31d5 || ($bb3a6aefff166c77$export$d9e3a7e4f51c31d5 = {}));
var $bb3a6aefff166c77$export$f5517f211c9a0baf;
(function(PutObjectTaggingRequest) {
    PutObjectTaggingRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$f5517f211c9a0baf || ($bb3a6aefff166c77$export$f5517f211c9a0baf = {}));
var $bb3a6aefff166c77$export$11868106b24a9ab0;
(function(PutPublicAccessBlockRequest) {
    PutPublicAccessBlockRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$11868106b24a9ab0 || ($bb3a6aefff166c77$export$11868106b24a9ab0 = {}));
var $bb3a6aefff166c77$export$a97e3c65be291319;
(function(ObjectAlreadyInActiveTierError) {
    ObjectAlreadyInActiveTierError.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$a97e3c65be291319 || ($bb3a6aefff166c77$export$a97e3c65be291319 = {}));
var $bb3a6aefff166c77$export$ee3cf9307c2a87ae;
(function(RestoreObjectOutput) {
    RestoreObjectOutput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$ee3cf9307c2a87ae || ($bb3a6aefff166c77$export$ee3cf9307c2a87ae = {}));
var $bb3a6aefff166c77$export$e9e40009732846c;
(function(GlacierJobParameters) {
    GlacierJobParameters.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($bb3a6aefff166c77$export$e9e40009732846c || ($bb3a6aefff166c77$export$e9e40009732846c = {}));
var $bb3a6aefff166c77$export$d60a27d0da10cee5;
(function(Encryption) {
    Encryption.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, obj), obj.KMSKeyId && {
            KMSKeyId: (0, $IsgKV.SENSITIVE_STRING)
        });
    };
})($bb3a6aefff166c77$export$d60a27d0da10cee5 || ($bb3a6aefff166c77$export$d60a27d0da10cee5 = {}));

});

parcelRegister("jhZvA", function(module, exports) {

$parcel$export(module.exports, "serializeAws_restXmlAbortMultipartUploadCommand", () => $e0af51232e7b34d9$export$a7d2d025c66f9235);
$parcel$export(module.exports, "serializeAws_restXmlCompleteMultipartUploadCommand", () => $e0af51232e7b34d9$export$2a09fb9495f08c55);
$parcel$export(module.exports, "serializeAws_restXmlCreateMultipartUploadCommand", () => $e0af51232e7b34d9$export$4730de34492fdc2);
$parcel$export(module.exports, "serializeAws_restXmlDeleteObjectCommand", () => $e0af51232e7b34d9$export$400c19cbac9616f7);
$parcel$export(module.exports, "serializeAws_restXmlGetObjectCommand", () => $e0af51232e7b34d9$export$713ae52666bf2204);
$parcel$export(module.exports, "serializeAws_restXmlListObjectsCommand", () => $e0af51232e7b34d9$export$acd8b176cbc51cb9);
$parcel$export(module.exports, "serializeAws_restXmlListPartsCommand", () => $e0af51232e7b34d9$export$b2b39cf3937e8c76);
$parcel$export(module.exports, "serializeAws_restXmlPutObjectCommand", () => $e0af51232e7b34d9$export$6c3f9d82bec72a8d);
$parcel$export(module.exports, "serializeAws_restXmlUploadPartCommand", () => $e0af51232e7b34d9$export$6dfc42032d3f37d4);
$parcel$export(module.exports, "deserializeAws_restXmlAbortMultipartUploadCommand", () => $e0af51232e7b34d9$export$87447564e9ee4b69);
$parcel$export(module.exports, "deserializeAws_restXmlCompleteMultipartUploadCommand", () => $e0af51232e7b34d9$export$ee5aaa25931389ce);
$parcel$export(module.exports, "deserializeAws_restXmlCreateMultipartUploadCommand", () => $e0af51232e7b34d9$export$95cf7bc6357ae5a8);
$parcel$export(module.exports, "deserializeAws_restXmlDeleteObjectCommand", () => $e0af51232e7b34d9$export$987b292ae9f16665);
$parcel$export(module.exports, "deserializeAws_restXmlGetObjectCommand", () => $e0af51232e7b34d9$export$c8faba1b7abd4024);
$parcel$export(module.exports, "deserializeAws_restXmlListObjectsCommand", () => $e0af51232e7b34d9$export$f8d39cd754f5521d);
$parcel$export(module.exports, "deserializeAws_restXmlListPartsCommand", () => $e0af51232e7b34d9$export$584d994fd27ec2bb);
$parcel$export(module.exports, "deserializeAws_restXmlPutObjectCommand", () => $e0af51232e7b34d9$export$45bbdbf5181c3607);
$parcel$export(module.exports, "deserializeAws_restXmlUploadPartCommand", () => $e0af51232e7b34d9$export$176ef954f1bec178);

var $2eeCH = parcelRequire("2eeCH");

var $g4BTM = parcelRequire("g4BTM");
parcelRequire("3uM9B");
var $dlqaT = parcelRequire("dlqaT");
parcelRequire("3vy9S");
var $hGFsd = parcelRequire("hGFsd");
var $9Nvib = parcelRequire("9Nvib");
var $bgM88 = parcelRequire("bgM88");
var $bvxsW = parcelRequire("bvxsW");
parcelRequire("bXXJg");
var $iqrNg = parcelRequire("iqrNg");
var $cm4u6 = parcelRequire("cm4u6");

var $iyNbS = parcelRequire("iyNbS");
var $e0af51232e7b34d9$export$a7d2d025c66f9235 = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $9Nvib.extendedEncodeURIComponent)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = (0, $2eeCH.__assign)({
                        "x-id": "AbortMultipartUpload"
                    }, input.UploadId !== undefined && {
                        uploadId: input.UploadId
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$2a09fb9495f08c55 = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({
                        "content-type": "application/xml"
                    }, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $9Nvib.extendedEncodeURIComponent)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = (0, $2eeCH.__assign)({}, input.UploadId !== undefined && {
                        uploadId: input.UploadId
                    });
                    if (input.MultipartUpload !== undefined) {
                        contents = $e0af51232e7b34d9$var$serializeAws_restXmlCompletedMultipartUpload(input.MultipartUpload, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$3fa883360ffbe82d = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ACL) && {
                        "x-amz-acl": input.ACL
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.CacheControl) && {
                        "cache-control": input.CacheControl
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ContentDisposition) && {
                        "content-disposition": input.ContentDisposition
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ContentEncoding) && {
                        "content-encoding": input.ContentEncoding
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ContentLanguage) && {
                        "content-language": input.ContentLanguage
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ContentType) && {
                        "content-type": input.ContentType
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.CopySource) && {
                        "x-amz-copy-source": input.CopySource
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.CopySourceIfMatch) && {
                        "x-amz-copy-source-if-match": input.CopySourceIfMatch
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.CopySourceIfModifiedSince) && {
                        "x-amz-copy-source-if-modified-since": (0, $hGFsd.dateToUtcString)(input.CopySourceIfModifiedSince).toString()
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.CopySourceIfNoneMatch) && {
                        "x-amz-copy-source-if-none-match": input.CopySourceIfNoneMatch
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.CopySourceIfUnmodifiedSince) && {
                        "x-amz-copy-source-if-unmodified-since": (0, $hGFsd.dateToUtcString)(input.CopySourceIfUnmodifiedSince).toString()
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.Expires) && {
                        expires: (0, $hGFsd.dateToUtcString)(input.Expires).toString()
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.GrantFullControl) && {
                        "x-amz-grant-full-control": input.GrantFullControl
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.GrantRead) && {
                        "x-amz-grant-read": input.GrantRead
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.GrantReadACP) && {
                        "x-amz-grant-read-acp": input.GrantReadACP
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.GrantWriteACP) && {
                        "x-amz-grant-write-acp": input.GrantWriteACP
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.MetadataDirective) && {
                        "x-amz-metadata-directive": input.MetadataDirective
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.TaggingDirective) && {
                        "x-amz-tagging-directive": input.TaggingDirective
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ServerSideEncryption) && {
                        "x-amz-server-side-encryption": input.ServerSideEncryption
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.StorageClass) && {
                        "x-amz-storage-class": input.StorageClass
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.WebsiteRedirectLocation) && {
                        "x-amz-website-redirect-location": input.WebsiteRedirectLocation
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.SSECustomerAlgorithm) && {
                        "x-amz-server-side-encryption-customer-algorithm": input.SSECustomerAlgorithm
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.SSECustomerKey) && {
                        "x-amz-server-side-encryption-customer-key": input.SSECustomerKey
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.SSECustomerKeyMD5) && {
                        "x-amz-server-side-encryption-customer-key-md5": input.SSECustomerKeyMD5
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.SSEKMSKeyId) && {
                        "x-amz-server-side-encryption-aws-kms-key-id": input.SSEKMSKeyId
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.SSEKMSEncryptionContext) && {
                        "x-amz-server-side-encryption-context": input.SSEKMSEncryptionContext
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.BucketKeyEnabled) && {
                        "x-amz-server-side-encryption-bucket-key-enabled": input.BucketKeyEnabled.toString()
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.CopySourceSSECustomerAlgorithm) && {
                        "x-amz-copy-source-server-side-encryption-customer-algorithm": input.CopySourceSSECustomerAlgorithm
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.CopySourceSSECustomerKey) && {
                        "x-amz-copy-source-server-side-encryption-customer-key": input.CopySourceSSECustomerKey
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.CopySourceSSECustomerKeyMD5) && {
                        "x-amz-copy-source-server-side-encryption-customer-key-md5": input.CopySourceSSECustomerKeyMD5
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.Tagging) && {
                        "x-amz-tagging": input.Tagging
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ObjectLockMode) && {
                        "x-amz-object-lock-mode": input.ObjectLockMode
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ObjectLockRetainUntilDate) && {
                        "x-amz-object-lock-retain-until-date": (input.ObjectLockRetainUntilDate.toISOString().split(".")[0] + "Z").toString()
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ObjectLockLegalHoldStatus) && {
                        "x-amz-object-lock-legal-hold": input.ObjectLockLegalHoldStatus
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedSourceBucketOwner) && {
                        "x-amz-source-expected-bucket-owner": input.ExpectedSourceBucketOwner
                    }), input.Metadata !== undefined && Object.keys(input.Metadata).reduce(function(acc, suffix) {
                        var _a;
                        return (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, acc), (_a = {}, _a["x-amz-meta-" + suffix.toLowerCase()] = input.Metadata[suffix], _a));
                    }, {}));
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $9Nvib.extendedEncodeURIComponent)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = {
                        "x-id": "CopyObject"
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$ff9b8bd3304a2cc2 = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, body, contents, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)({
                        "content-type": "application/xml"
                    }, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ACL) && {
                        "x-amz-acl": input.ACL
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.GrantFullControl) && {
                        "x-amz-grant-full-control": input.GrantFullControl
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.GrantRead) && {
                        "x-amz-grant-read": input.GrantRead
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.GrantReadACP) && {
                        "x-amz-grant-read-acp": input.GrantReadACP
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.GrantWrite) && {
                        "x-amz-grant-write": input.GrantWrite
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.GrantWriteACP) && {
                        "x-amz-grant-write-acp": input.GrantWriteACP
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ObjectLockEnabledForBucket) && {
                        "x-amz-bucket-object-lock-enabled": input.ObjectLockEnabledForBucket.toString()
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.CreateBucketConfiguration !== undefined) {
                        contents = $e0af51232e7b34d9$var$serializeAws_restXmlCreateBucketConfiguration(input.CreateBucketConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$4730de34492fdc2 = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ACL) && {
                        "x-amz-acl": input.ACL
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.CacheControl) && {
                        "cache-control": input.CacheControl
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ContentDisposition) && {
                        "content-disposition": input.ContentDisposition
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ContentEncoding) && {
                        "content-encoding": input.ContentEncoding
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ContentLanguage) && {
                        "content-language": input.ContentLanguage
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ContentType) && {
                        "content-type": input.ContentType
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.Expires) && {
                        expires: (0, $hGFsd.dateToUtcString)(input.Expires).toString()
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.GrantFullControl) && {
                        "x-amz-grant-full-control": input.GrantFullControl
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.GrantRead) && {
                        "x-amz-grant-read": input.GrantRead
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.GrantReadACP) && {
                        "x-amz-grant-read-acp": input.GrantReadACP
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.GrantWriteACP) && {
                        "x-amz-grant-write-acp": input.GrantWriteACP
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ServerSideEncryption) && {
                        "x-amz-server-side-encryption": input.ServerSideEncryption
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.StorageClass) && {
                        "x-amz-storage-class": input.StorageClass
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.WebsiteRedirectLocation) && {
                        "x-amz-website-redirect-location": input.WebsiteRedirectLocation
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.SSECustomerAlgorithm) && {
                        "x-amz-server-side-encryption-customer-algorithm": input.SSECustomerAlgorithm
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.SSECustomerKey) && {
                        "x-amz-server-side-encryption-customer-key": input.SSECustomerKey
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.SSECustomerKeyMD5) && {
                        "x-amz-server-side-encryption-customer-key-md5": input.SSECustomerKeyMD5
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.SSEKMSKeyId) && {
                        "x-amz-server-side-encryption-aws-kms-key-id": input.SSEKMSKeyId
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.SSEKMSEncryptionContext) && {
                        "x-amz-server-side-encryption-context": input.SSEKMSEncryptionContext
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.BucketKeyEnabled) && {
                        "x-amz-server-side-encryption-bucket-key-enabled": input.BucketKeyEnabled.toString()
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.Tagging) && {
                        "x-amz-tagging": input.Tagging
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ObjectLockMode) && {
                        "x-amz-object-lock-mode": input.ObjectLockMode
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ObjectLockRetainUntilDate) && {
                        "x-amz-object-lock-retain-until-date": (input.ObjectLockRetainUntilDate.toISOString().split(".")[0] + "Z").toString()
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ObjectLockLegalHoldStatus) && {
                        "x-amz-object-lock-legal-hold": input.ObjectLockLegalHoldStatus
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    }), input.Metadata !== undefined && Object.keys(input.Metadata).reduce(function(acc, suffix) {
                        var _a;
                        return (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, acc), (_a = {}, _a["x-amz-meta-" + suffix.toLowerCase()] = input.Metadata[suffix], _a));
                    }, {}));
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $9Nvib.extendedEncodeURIComponent)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = {
                        uploads: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$4c739e7bdecdc09e = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, body, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)({}, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$1599103c79e9cc48 = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)({}, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $2eeCH.__assign)({
                        analytics: ""
                    }, input.Id !== undefined && {
                        id: input.Id
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$328eda7443168fa1 = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)({}, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        cors: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$a935f4341563a8e5 = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)({}, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        encryption: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$c04145b770da67a8 = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = {};
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $2eeCH.__assign)({
                        "intelligent-tiering": ""
                    }, input.Id !== undefined && {
                        id: input.Id
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$ea4a1894e3000c1a = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)({}, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $2eeCH.__assign)({
                        inventory: ""
                    }, input.Id !== undefined && {
                        id: input.Id
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$ff5be01ded2fe32 = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)({}, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        lifecycle: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$f050fc1ef4eb3607 = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)({}, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $2eeCH.__assign)({
                        metrics: ""
                    }, input.Id !== undefined && {
                        id: input.Id
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$9809275ad1405c95 = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)({}, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        ownershipControls: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$d35e7f7cfb4671a8 = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)({}, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        policy: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$9a7bb1ffbd4a4abf = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)({}, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        replication: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$898454ff9153710a = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)({}, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        tagging: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$55003dd0346cc6e0 = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)({}, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        website: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$400c19cbac9616f7 = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.MFA) && {
                        "x-amz-mfa": input.MFA
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.BypassGovernanceRetention) && {
                        "x-amz-bypass-governance-retention": input.BypassGovernanceRetention.toString()
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $9Nvib.extendedEncodeURIComponent)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = (0, $2eeCH.__assign)({
                        "x-id": "DeleteObject"
                    }, input.VersionId !== undefined && {
                        versionId: input.VersionId
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$6867c23377cf4e18 = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)({
                        "content-type": "application/xml"
                    }, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.MFA) && {
                        "x-amz-mfa": input.MFA
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.BypassGovernanceRetention) && {
                        "x-amz-bypass-governance-retention": input.BypassGovernanceRetention.toString()
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        delete: ""
                    };
                    if (input.Delete !== undefined) {
                        contents = $e0af51232e7b34d9$var$serializeAws_restXmlDelete(input.Delete, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$c5216ce889528f85 = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)({}, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $9Nvib.extendedEncodeURIComponent)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = (0, $2eeCH.__assign)({
                        tagging: ""
                    }, input.VersionId !== undefined && {
                        versionId: input.VersionId
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$6e75832e2b10791c = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)({}, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        publicAccessBlock: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$401fbb1296db6719 = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)({}, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        accelerate: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$36598b1e884464d4 = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)({}, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        acl: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$4d648e59e03d69d2 = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)({}, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $2eeCH.__assign)({
                        analytics: "",
                        "x-id": "GetBucketAnalyticsConfiguration"
                    }, input.Id !== undefined && {
                        id: input.Id
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$c50cfec8b08a5bc7 = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)({}, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        cors: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$59a2b88153b9bcd3 = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)({}, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        encryption: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$f5f10fa8975a8db2 = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = {};
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $2eeCH.__assign)({
                        "intelligent-tiering": "",
                        "x-id": "GetBucketIntelligentTieringConfiguration"
                    }, input.Id !== undefined && {
                        id: input.Id
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$27733aaa6f8bdfce = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)({}, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $2eeCH.__assign)({
                        inventory: "",
                        "x-id": "GetBucketInventoryConfiguration"
                    }, input.Id !== undefined && {
                        id: input.Id
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$a45e301366f2d4b7 = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)({}, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        lifecycle: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$57578b49828da279 = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)({}, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        location: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$fba64f4839ba2759 = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)({}, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        logging: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$55cedf3b8782e93a = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)({}, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $2eeCH.__assign)({
                        metrics: "",
                        "x-id": "GetBucketMetricsConfiguration"
                    }, input.Id !== undefined && {
                        id: input.Id
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$28aa3066de46a217 = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)({}, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        notification: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$8ff61553a991ad45 = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)({}, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        ownershipControls: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$9c4ddc2418c2498a = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)({}, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        policy: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$5cc8b1c7c38eaa70 = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)({}, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        policyStatus: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$7bfb07297b27feda = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)({}, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        replication: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$c40582f35b41168f = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)({}, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        requestPayment: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$7fe7f3d9e83c1258 = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)({}, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        tagging: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$33bb47afa1d36b = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)({}, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        versioning: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$86d6bcc10cc7214f = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)({}, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        website: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$713ae52666bf2204 = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.IfMatch) && {
                        "if-match": input.IfMatch
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.IfModifiedSince) && {
                        "if-modified-since": (0, $hGFsd.dateToUtcString)(input.IfModifiedSince).toString()
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.IfNoneMatch) && {
                        "if-none-match": input.IfNoneMatch
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.IfUnmodifiedSince) && {
                        "if-unmodified-since": (0, $hGFsd.dateToUtcString)(input.IfUnmodifiedSince).toString()
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.Range) && {
                        range: input.Range
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.SSECustomerAlgorithm) && {
                        "x-amz-server-side-encryption-customer-algorithm": input.SSECustomerAlgorithm
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.SSECustomerKey) && {
                        "x-amz-server-side-encryption-customer-key": input.SSECustomerKey
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.SSECustomerKeyMD5) && {
                        "x-amz-server-side-encryption-customer-key-md5": input.SSECustomerKeyMD5
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $9Nvib.extendedEncodeURIComponent)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = (0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)({
                        "x-id": "GetObject"
                    }, input.ResponseCacheControl !== undefined && {
                        "response-cache-control": input.ResponseCacheControl
                    }), input.ResponseContentDisposition !== undefined && {
                        "response-content-disposition": input.ResponseContentDisposition
                    }), input.ResponseContentEncoding !== undefined && {
                        "response-content-encoding": input.ResponseContentEncoding
                    }), input.ResponseContentLanguage !== undefined && {
                        "response-content-language": input.ResponseContentLanguage
                    }), input.ResponseContentType !== undefined && {
                        "response-content-type": input.ResponseContentType
                    }), input.ResponseExpires !== undefined && {
                        "response-expires": (input.ResponseExpires.toISOString().split(".")[0] + "Z").toString()
                    }), input.VersionId !== undefined && {
                        versionId: input.VersionId
                    }), input.PartNumber !== undefined && {
                        partNumber: input.PartNumber.toString()
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$915aba65107b1e0b = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $9Nvib.extendedEncodeURIComponent)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = (0, $2eeCH.__assign)({
                        acl: ""
                    }, input.VersionId !== undefined && {
                        versionId: input.VersionId
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$9c08e676bdd74a0 = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $9Nvib.extendedEncodeURIComponent)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = (0, $2eeCH.__assign)({
                        "legal-hold": ""
                    }, input.VersionId !== undefined && {
                        versionId: input.VersionId
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$6b8bcfdbd9049617 = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)({}, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        "object-lock": ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$73761af73f60c98c = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $9Nvib.extendedEncodeURIComponent)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = (0, $2eeCH.__assign)({
                        retention: ""
                    }, input.VersionId !== undefined && {
                        versionId: input.VersionId
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$9eb633d3ed47ffa4 = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)({}, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $9Nvib.extendedEncodeURIComponent)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = (0, $2eeCH.__assign)({
                        tagging: ""
                    }, input.VersionId !== undefined && {
                        versionId: input.VersionId
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$19b09331a932f5f6 = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $9Nvib.extendedEncodeURIComponent)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = {
                        torrent: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$96bfd3c7dd0a4d0a = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)({}, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        publicAccessBlock: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$33042663db00ac59 = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, body, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)({}, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "HEAD",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$7d02887d047f6825 = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.IfMatch) && {
                        "if-match": input.IfMatch
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.IfModifiedSince) && {
                        "if-modified-since": (0, $hGFsd.dateToUtcString)(input.IfModifiedSince).toString()
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.IfNoneMatch) && {
                        "if-none-match": input.IfNoneMatch
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.IfUnmodifiedSince) && {
                        "if-unmodified-since": (0, $hGFsd.dateToUtcString)(input.IfUnmodifiedSince).toString()
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.Range) && {
                        range: input.Range
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.SSECustomerAlgorithm) && {
                        "x-amz-server-side-encryption-customer-algorithm": input.SSECustomerAlgorithm
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.SSECustomerKey) && {
                        "x-amz-server-side-encryption-customer-key": input.SSECustomerKey
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.SSECustomerKeyMD5) && {
                        "x-amz-server-side-encryption-customer-key-md5": input.SSECustomerKeyMD5
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $9Nvib.extendedEncodeURIComponent)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, input.VersionId !== undefined && {
                        versionId: input.VersionId
                    }), input.PartNumber !== undefined && {
                        partNumber: input.PartNumber.toString()
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "HEAD",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$1af1bbf8ced1a360 = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)({}, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $2eeCH.__assign)({
                        analytics: "",
                        "x-id": "ListBucketAnalyticsConfigurations"
                    }, input.ContinuationToken !== undefined && {
                        "continuation-token": input.ContinuationToken
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$471f09a61710187f = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = {};
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $2eeCH.__assign)({
                        "intelligent-tiering": "",
                        "x-id": "ListBucketIntelligentTieringConfigurations"
                    }, input.ContinuationToken !== undefined && {
                        "continuation-token": input.ContinuationToken
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$84049d82728011d8 = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)({}, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $2eeCH.__assign)({
                        inventory: "",
                        "x-id": "ListBucketInventoryConfigurations"
                    }, input.ContinuationToken !== undefined && {
                        "continuation-token": input.ContinuationToken
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$4386fb1e1f56eefe = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)({}, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $2eeCH.__assign)({
                        metrics: "",
                        "x-id": "ListBucketMetricsConfigurations"
                    }, input.ContinuationToken !== undefined && {
                        "continuation-token": input.ContinuationToken
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$94ca891f34564e01 = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, body, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = {};
                    resolvedPath = "/";
                    body = "";
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$67092c8b2bd6afb9 = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)({}, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)({
                        uploads: ""
                    }, input.Delimiter !== undefined && {
                        delimiter: input.Delimiter
                    }), input.EncodingType !== undefined && {
                        "encoding-type": input.EncodingType
                    }), input.KeyMarker !== undefined && {
                        "key-marker": input.KeyMarker
                    }), input.MaxUploads !== undefined && {
                        "max-uploads": input.MaxUploads.toString()
                    }), input.Prefix !== undefined && {
                        prefix: input.Prefix
                    }), input.UploadIdMarker !== undefined && {
                        "upload-id-marker": input.UploadIdMarker
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$acd8b176cbc51cb9 = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, input.Delimiter !== undefined && {
                        delimiter: input.Delimiter
                    }), input.EncodingType !== undefined && {
                        "encoding-type": input.EncodingType
                    }), input.Marker !== undefined && {
                        marker: input.Marker
                    }), input.MaxKeys !== undefined && {
                        "max-keys": input.MaxKeys.toString()
                    }), input.Prefix !== undefined && {
                        prefix: input.Prefix
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$ea6ee77e40f86bd9 = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)({
                        "list-type": "2"
                    }, input.Delimiter !== undefined && {
                        delimiter: input.Delimiter
                    }), input.EncodingType !== undefined && {
                        "encoding-type": input.EncodingType
                    }), input.MaxKeys !== undefined && {
                        "max-keys": input.MaxKeys.toString()
                    }), input.Prefix !== undefined && {
                        prefix: input.Prefix
                    }), input.ContinuationToken !== undefined && {
                        "continuation-token": input.ContinuationToken
                    }), input.FetchOwner !== undefined && {
                        "fetch-owner": input.FetchOwner.toString()
                    }), input.StartAfter !== undefined && {
                        "start-after": input.StartAfter
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$e9deb593aaba1069 = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)({}, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)({
                        versions: ""
                    }, input.Delimiter !== undefined && {
                        delimiter: input.Delimiter
                    }), input.EncodingType !== undefined && {
                        "encoding-type": input.EncodingType
                    }), input.KeyMarker !== undefined && {
                        "key-marker": input.KeyMarker
                    }), input.MaxKeys !== undefined && {
                        "max-keys": input.MaxKeys.toString()
                    }), input.Prefix !== undefined && {
                        prefix: input.Prefix
                    }), input.VersionIdMarker !== undefined && {
                        "version-id-marker": input.VersionIdMarker
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$b2b39cf3937e8c76 = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $9Nvib.extendedEncodeURIComponent)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = (0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)({
                        "x-id": "ListParts"
                    }, input.MaxParts !== undefined && {
                        "max-parts": input.MaxParts.toString()
                    }), input.PartNumberMarker !== undefined && {
                        "part-number-marker": input.PartNumberMarker
                    }), input.UploadId !== undefined && {
                        uploadId: input.UploadId
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$4d770bb452c6d670 = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)({
                        "content-type": "application/xml"
                    }, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        accelerate: ""
                    };
                    if (input.AccelerateConfiguration !== undefined) {
                        contents = $e0af51232e7b34d9$var$serializeAws_restXmlAccelerateConfiguration(input.AccelerateConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$415e832013d5f94b = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)({
                        "content-type": "application/xml"
                    }, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ACL) && {
                        "x-amz-acl": input.ACL
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "content-md5": input.ContentMD5
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.GrantFullControl) && {
                        "x-amz-grant-full-control": input.GrantFullControl
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.GrantRead) && {
                        "x-amz-grant-read": input.GrantRead
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.GrantReadACP) && {
                        "x-amz-grant-read-acp": input.GrantReadACP
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.GrantWrite) && {
                        "x-amz-grant-write": input.GrantWrite
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.GrantWriteACP) && {
                        "x-amz-grant-write-acp": input.GrantWriteACP
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        acl: ""
                    };
                    if (input.AccessControlPolicy !== undefined) {
                        contents = $e0af51232e7b34d9$var$serializeAws_restXmlAccessControlPolicy(input.AccessControlPolicy, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$82791d7115b07b04 = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)({
                        "content-type": "application/xml"
                    }, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $2eeCH.__assign)({
                        analytics: ""
                    }, input.Id !== undefined && {
                        id: input.Id
                    });
                    if (input.AnalyticsConfiguration !== undefined) {
                        contents = $e0af51232e7b34d9$var$serializeAws_restXmlAnalyticsConfiguration(input.AnalyticsConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$c86e5c4d1766d14 = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({
                        "content-type": "application/xml"
                    }, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "content-md5": input.ContentMD5
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        cors: ""
                    };
                    if (input.CORSConfiguration !== undefined) {
                        contents = $e0af51232e7b34d9$var$serializeAws_restXmlCORSConfiguration(input.CORSConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$c279f7b43c9bb310 = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({
                        "content-type": "application/xml"
                    }, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "content-md5": input.ContentMD5
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        encryption: ""
                    };
                    if (input.ServerSideEncryptionConfiguration !== undefined) {
                        contents = $e0af51232e7b34d9$var$serializeAws_restXmlServerSideEncryptionConfiguration(input.ServerSideEncryptionConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$c9101820ff6720b2 = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = {
                        "content-type": "application/xml"
                    };
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $2eeCH.__assign)({
                        "intelligent-tiering": ""
                    }, input.Id !== undefined && {
                        id: input.Id
                    });
                    if (input.IntelligentTieringConfiguration !== undefined) {
                        contents = $e0af51232e7b34d9$var$serializeAws_restXmlIntelligentTieringConfiguration(input.IntelligentTieringConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$6d95946d99f43eaa = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)({
                        "content-type": "application/xml"
                    }, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $2eeCH.__assign)({
                        inventory: ""
                    }, input.Id !== undefined && {
                        id: input.Id
                    });
                    if (input.InventoryConfiguration !== undefined) {
                        contents = $e0af51232e7b34d9$var$serializeAws_restXmlInventoryConfiguration(input.InventoryConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$70f4fe83400d730d = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)({
                        "content-type": "application/xml"
                    }, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        lifecycle: ""
                    };
                    if (input.LifecycleConfiguration !== undefined) {
                        contents = $e0af51232e7b34d9$var$serializeAws_restXmlBucketLifecycleConfiguration(input.LifecycleConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$2426ada7dacc12b9 = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({
                        "content-type": "application/xml"
                    }, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "content-md5": input.ContentMD5
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        logging: ""
                    };
                    if (input.BucketLoggingStatus !== undefined) {
                        contents = $e0af51232e7b34d9$var$serializeAws_restXmlBucketLoggingStatus(input.BucketLoggingStatus, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$dd9ccb6c86dc9b75 = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)({
                        "content-type": "application/xml"
                    }, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $2eeCH.__assign)({
                        metrics: ""
                    }, input.Id !== undefined && {
                        id: input.Id
                    });
                    if (input.MetricsConfiguration !== undefined) {
                        contents = $e0af51232e7b34d9$var$serializeAws_restXmlMetricsConfiguration(input.MetricsConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$cc9aba63382b97f4 = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)({
                        "content-type": "application/xml"
                    }, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        notification: ""
                    };
                    if (input.NotificationConfiguration !== undefined) {
                        contents = $e0af51232e7b34d9$var$serializeAws_restXmlNotificationConfiguration(input.NotificationConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$cd645fbb22474aad = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({
                        "content-type": "application/xml"
                    }, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "content-md5": input.ContentMD5
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        ownershipControls: ""
                    };
                    if (input.OwnershipControls !== undefined) {
                        contents = $e0af51232e7b34d9$var$serializeAws_restXmlOwnershipControls(input.OwnershipControls, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$46f7931bb495aaa = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)({
                        "content-type": "text/plain"
                    }, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "content-md5": input.ContentMD5
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ConfirmRemoveSelfBucketAccess) && {
                        "x-amz-confirm-remove-self-bucket-access": input.ConfirmRemoveSelfBucketAccess.toString()
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        policy: ""
                    };
                    if (input.Policy !== undefined) {
                        contents = input.Policy;
                        body = contents;
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$bc85604c47270690 = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)({
                        "content-type": "application/xml"
                    }, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "content-md5": input.ContentMD5
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.Token) && {
                        "x-amz-bucket-object-lock-token": input.Token
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        replication: ""
                    };
                    if (input.ReplicationConfiguration !== undefined) {
                        contents = $e0af51232e7b34d9$var$serializeAws_restXmlReplicationConfiguration(input.ReplicationConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$d688e45835bb412b = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({
                        "content-type": "application/xml"
                    }, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "content-md5": input.ContentMD5
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        requestPayment: ""
                    };
                    if (input.RequestPaymentConfiguration !== undefined) {
                        contents = $e0af51232e7b34d9$var$serializeAws_restXmlRequestPaymentConfiguration(input.RequestPaymentConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$fb33aa4addeb7925 = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({
                        "content-type": "application/xml"
                    }, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "content-md5": input.ContentMD5
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        tagging: ""
                    };
                    if (input.Tagging !== undefined) {
                        contents = $e0af51232e7b34d9$var$serializeAws_restXmlTagging(input.Tagging, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$b2b33319a5c1fa1b = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)({
                        "content-type": "application/xml"
                    }, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "content-md5": input.ContentMD5
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.MFA) && {
                        "x-amz-mfa": input.MFA
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        versioning: ""
                    };
                    if (input.VersioningConfiguration !== undefined) {
                        contents = $e0af51232e7b34d9$var$serializeAws_restXmlVersioningConfiguration(input.VersioningConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$3684a013c739abf7 = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({
                        "content-type": "application/xml"
                    }, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "content-md5": input.ContentMD5
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        website: ""
                    };
                    if (input.WebsiteConfiguration !== undefined) {
                        contents = $e0af51232e7b34d9$var$serializeAws_restXmlWebsiteConfiguration(input.WebsiteConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$6c3f9d82bec72a8d = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)({
                        "content-type": "application/octet-stream"
                    }, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ACL) && {
                        "x-amz-acl": input.ACL
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.CacheControl) && {
                        "cache-control": input.CacheControl
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ContentDisposition) && {
                        "content-disposition": input.ContentDisposition
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ContentEncoding) && {
                        "content-encoding": input.ContentEncoding
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ContentLanguage) && {
                        "content-language": input.ContentLanguage
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ContentLength) && {
                        "content-length": input.ContentLength.toString()
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "content-md5": input.ContentMD5
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ContentType) && {
                        "content-type": input.ContentType
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.Expires) && {
                        expires: (0, $hGFsd.dateToUtcString)(input.Expires).toString()
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.GrantFullControl) && {
                        "x-amz-grant-full-control": input.GrantFullControl
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.GrantRead) && {
                        "x-amz-grant-read": input.GrantRead
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.GrantReadACP) && {
                        "x-amz-grant-read-acp": input.GrantReadACP
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.GrantWriteACP) && {
                        "x-amz-grant-write-acp": input.GrantWriteACP
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ServerSideEncryption) && {
                        "x-amz-server-side-encryption": input.ServerSideEncryption
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.StorageClass) && {
                        "x-amz-storage-class": input.StorageClass
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.WebsiteRedirectLocation) && {
                        "x-amz-website-redirect-location": input.WebsiteRedirectLocation
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.SSECustomerAlgorithm) && {
                        "x-amz-server-side-encryption-customer-algorithm": input.SSECustomerAlgorithm
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.SSECustomerKey) && {
                        "x-amz-server-side-encryption-customer-key": input.SSECustomerKey
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.SSECustomerKeyMD5) && {
                        "x-amz-server-side-encryption-customer-key-md5": input.SSECustomerKeyMD5
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.SSEKMSKeyId) && {
                        "x-amz-server-side-encryption-aws-kms-key-id": input.SSEKMSKeyId
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.SSEKMSEncryptionContext) && {
                        "x-amz-server-side-encryption-context": input.SSEKMSEncryptionContext
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.BucketKeyEnabled) && {
                        "x-amz-server-side-encryption-bucket-key-enabled": input.BucketKeyEnabled.toString()
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.Tagging) && {
                        "x-amz-tagging": input.Tagging
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ObjectLockMode) && {
                        "x-amz-object-lock-mode": input.ObjectLockMode
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ObjectLockRetainUntilDate) && {
                        "x-amz-object-lock-retain-until-date": (input.ObjectLockRetainUntilDate.toISOString().split(".")[0] + "Z").toString()
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ObjectLockLegalHoldStatus) && {
                        "x-amz-object-lock-legal-hold": input.ObjectLockLegalHoldStatus
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    }), input.Metadata !== undefined && Object.keys(input.Metadata).reduce(function(acc, suffix) {
                        var _a;
                        return (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, acc), (_a = {}, _a["x-amz-meta-" + suffix.toLowerCase()] = input.Metadata[suffix], _a));
                    }, {}));
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $9Nvib.extendedEncodeURIComponent)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = {
                        "x-id": "PutObject"
                    };
                    if (input.Body !== undefined) {
                        contents = input.Body;
                        body = contents;
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$c5f7c1bb4a245310 = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)({
                        "content-type": "application/xml"
                    }, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ACL) && {
                        "x-amz-acl": input.ACL
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "content-md5": input.ContentMD5
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.GrantFullControl) && {
                        "x-amz-grant-full-control": input.GrantFullControl
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.GrantRead) && {
                        "x-amz-grant-read": input.GrantRead
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.GrantReadACP) && {
                        "x-amz-grant-read-acp": input.GrantReadACP
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.GrantWrite) && {
                        "x-amz-grant-write": input.GrantWrite
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.GrantWriteACP) && {
                        "x-amz-grant-write-acp": input.GrantWriteACP
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $9Nvib.extendedEncodeURIComponent)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = (0, $2eeCH.__assign)({
                        acl: ""
                    }, input.VersionId !== undefined && {
                        versionId: input.VersionId
                    });
                    if (input.AccessControlPolicy !== undefined) {
                        contents = $e0af51232e7b34d9$var$serializeAws_restXmlAccessControlPolicy(input.AccessControlPolicy, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$3cae5f4de1f7d8e0 = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)({
                        "content-type": "application/xml"
                    }, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "content-md5": input.ContentMD5
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $9Nvib.extendedEncodeURIComponent)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = (0, $2eeCH.__assign)({
                        "legal-hold": ""
                    }, input.VersionId !== undefined && {
                        versionId: input.VersionId
                    });
                    if (input.LegalHold !== undefined) {
                        contents = $e0af51232e7b34d9$var$serializeAws_restXmlObjectLockLegalHold(input.LegalHold, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$e85a5935e0b9ebcf = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)({
                        "content-type": "application/xml"
                    }, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.Token) && {
                        "x-amz-bucket-object-lock-token": input.Token
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "content-md5": input.ContentMD5
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        "object-lock": ""
                    };
                    if (input.ObjectLockConfiguration !== undefined) {
                        contents = $e0af51232e7b34d9$var$serializeAws_restXmlObjectLockConfiguration(input.ObjectLockConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$401e449dfbceed84 = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)({
                        "content-type": "application/xml"
                    }, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.BypassGovernanceRetention) && {
                        "x-amz-bypass-governance-retention": input.BypassGovernanceRetention.toString()
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "content-md5": input.ContentMD5
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $9Nvib.extendedEncodeURIComponent)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = (0, $2eeCH.__assign)({
                        retention: ""
                    }, input.VersionId !== undefined && {
                        versionId: input.VersionId
                    });
                    if (input.Retention !== undefined) {
                        contents = $e0af51232e7b34d9$var$serializeAws_restXmlObjectLockRetention(input.Retention, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$c73061b6e5d6a95a = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({
                        "content-type": "application/xml"
                    }, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "content-md5": input.ContentMD5
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $9Nvib.extendedEncodeURIComponent)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = (0, $2eeCH.__assign)({
                        tagging: ""
                    }, input.VersionId !== undefined && {
                        versionId: input.VersionId
                    });
                    if (input.Tagging !== undefined) {
                        contents = $e0af51232e7b34d9$var$serializeAws_restXmlTagging(input.Tagging, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$9f1c307a4d5bd5b3 = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({
                        "content-type": "application/xml"
                    }, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "content-md5": input.ContentMD5
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        publicAccessBlock: ""
                    };
                    if (input.PublicAccessBlockConfiguration !== undefined) {
                        contents = $e0af51232e7b34d9$var$serializeAws_restXmlPublicAccessBlockConfiguration(input.PublicAccessBlockConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$99a912d071900c76 = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({
                        "content-type": "application/xml"
                    }, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $9Nvib.extendedEncodeURIComponent)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = (0, $2eeCH.__assign)({
                        restore: ""
                    }, input.VersionId !== undefined && {
                        versionId: input.VersionId
                    });
                    if (input.RestoreRequest !== undefined) {
                        contents = $e0af51232e7b34d9$var$serializeAws_restXmlRestoreRequest(input.RestoreRequest, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$47ebf91740d2ce6f = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, bodyNode, node, node, node, node, node, node, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)({
                        "content-type": "application/xml"
                    }, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.SSECustomerAlgorithm) && {
                        "x-amz-server-side-encryption-customer-algorithm": input.SSECustomerAlgorithm
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.SSECustomerKey) && {
                        "x-amz-server-side-encryption-customer-key": input.SSECustomerKey
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.SSECustomerKeyMD5) && {
                        "x-amz-server-side-encryption-customer-key-md5": input.SSECustomerKeyMD5
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $9Nvib.extendedEncodeURIComponent)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = {
                        select: "",
                        "select-type": "2"
                    };
                    body = '<?xml version="1.0" encoding="UTF-8"?>';
                    bodyNode = new (0, $iqrNg.XmlNode)("SelectObjectContentRequest");
                    bodyNode.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                    if (input.Expression !== undefined) {
                        node = new (0, $iqrNg.XmlNode)("Expression").addChildNode(new (0, $cm4u6.XmlText)(input.Expression)).withName("Expression");
                        bodyNode.addChildNode(node);
                    }
                    if (input.ExpressionType !== undefined) {
                        node = new (0, $iqrNg.XmlNode)("ExpressionType").addChildNode(new (0, $cm4u6.XmlText)(input.ExpressionType)).withName("ExpressionType");
                        bodyNode.addChildNode(node);
                    }
                    if (input.InputSerialization !== undefined) {
                        node = $e0af51232e7b34d9$var$serializeAws_restXmlInputSerialization(input.InputSerialization, context).withName("InputSerialization");
                        bodyNode.addChildNode(node);
                    }
                    if (input.OutputSerialization !== undefined) {
                        node = $e0af51232e7b34d9$var$serializeAws_restXmlOutputSerialization(input.OutputSerialization, context).withName("OutputSerialization");
                        bodyNode.addChildNode(node);
                    }
                    if (input.RequestProgress !== undefined) {
                        node = $e0af51232e7b34d9$var$serializeAws_restXmlRequestProgress(input.RequestProgress, context).withName("RequestProgress");
                        bodyNode.addChildNode(node);
                    }
                    if (input.ScanRange !== undefined) {
                        node = $e0af51232e7b34d9$var$serializeAws_restXmlScanRange(input.ScanRange, context).withName("ScanRange");
                        bodyNode.addChildNode(node);
                    }
                    body += bodyNode.toString();
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$6dfc42032d3f37d4 = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)({
                        "content-type": "application/octet-stream"
                    }, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ContentLength) && {
                        "content-length": input.ContentLength.toString()
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "content-md5": input.ContentMD5
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.SSECustomerAlgorithm) && {
                        "x-amz-server-side-encryption-customer-algorithm": input.SSECustomerAlgorithm
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.SSECustomerKey) && {
                        "x-amz-server-side-encryption-customer-key": input.SSECustomerKey
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.SSECustomerKeyMD5) && {
                        "x-amz-server-side-encryption-customer-key-md5": input.SSECustomerKeyMD5
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $9Nvib.extendedEncodeURIComponent)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({
                        "x-id": "UploadPart"
                    }, input.PartNumber !== undefined && {
                        partNumber: input.PartNumber.toString()
                    }), input.UploadId !== undefined && {
                        uploadId: input.UploadId
                    });
                    if (input.Body !== undefined) {
                        contents = input.Body;
                        body = contents;
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$90763da135bbc5f9 = function(input, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, $e0af51232e7b34d9$var$isSerializableHeaderValue(input.CopySource) && {
                        "x-amz-copy-source": input.CopySource
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.CopySourceIfMatch) && {
                        "x-amz-copy-source-if-match": input.CopySourceIfMatch
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.CopySourceIfModifiedSince) && {
                        "x-amz-copy-source-if-modified-since": (0, $hGFsd.dateToUtcString)(input.CopySourceIfModifiedSince).toString()
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.CopySourceIfNoneMatch) && {
                        "x-amz-copy-source-if-none-match": input.CopySourceIfNoneMatch
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.CopySourceIfUnmodifiedSince) && {
                        "x-amz-copy-source-if-unmodified-since": (0, $hGFsd.dateToUtcString)(input.CopySourceIfUnmodifiedSince).toString()
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.CopySourceRange) && {
                        "x-amz-copy-source-range": input.CopySourceRange
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.SSECustomerAlgorithm) && {
                        "x-amz-server-side-encryption-customer-algorithm": input.SSECustomerAlgorithm
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.SSECustomerKey) && {
                        "x-amz-server-side-encryption-customer-key": input.SSECustomerKey
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.SSECustomerKeyMD5) && {
                        "x-amz-server-side-encryption-customer-key-md5": input.SSECustomerKeyMD5
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.CopySourceSSECustomerAlgorithm) && {
                        "x-amz-copy-source-server-side-encryption-customer-algorithm": input.CopySourceSSECustomerAlgorithm
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.CopySourceSSECustomerKey) && {
                        "x-amz-copy-source-server-side-encryption-customer-key": input.CopySourceSSECustomerKey
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.CopySourceSSECustomerKeyMD5) && {
                        "x-amz-copy-source-server-side-encryption-customer-key-md5": input.CopySourceSSECustomerKeyMD5
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    }), $e0af51232e7b34d9$var$isSerializableHeaderValue(input.ExpectedSourceBucketOwner) && {
                        "x-amz-source-expected-bucket-owner": input.ExpectedSourceBucketOwner
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $9Nvib.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $9Nvib.extendedEncodeURIComponent)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({
                        "x-id": "UploadPartCopy"
                    }, input.PartNumber !== undefined && {
                        partNumber: input.PartNumber.toString()
                    }), input.UploadId !== undefined && {
                        uploadId: input.UploadId
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $dlqaT.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$87447564e9ee4b69 = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlAbortMultipartUploadCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output),
                        RequestCharged: undefined
                    };
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlAbortMultipartUploadCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, parsedBody, message;
        var _d;
        return (0, $2eeCH.__generator)(this, function(_e) {
            switch(_e.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _d = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_d.body = _e.sent(), _d)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "NoSuchUpload":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.s3#NoSuchUpload":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlNoSuchUploadResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _c.concat([
                            _e.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 4:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    _e.label = 5;
                case 5:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$ee5aaa25931389ce = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlCompleteMultipartUploadCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output),
                        Bucket: undefined,
                        BucketKeyEnabled: undefined,
                        ETag: undefined,
                        Expiration: undefined,
                        Key: undefined,
                        Location: undefined,
                        RequestCharged: undefined,
                        SSEKMSKeyId: undefined,
                        ServerSideEncryption: undefined,
                        VersionId: undefined
                    };
                    if (output.headers["x-amz-expiration"] !== undefined) contents.Expiration = output.headers["x-amz-expiration"];
                    if (output.headers["x-amz-server-side-encryption"] !== undefined) contents.ServerSideEncryption = output.headers["x-amz-server-side-encryption"];
                    if (output.headers["x-amz-version-id"] !== undefined) contents.VersionId = output.headers["x-amz-version-id"];
                    if (output.headers["x-amz-server-side-encryption-aws-kms-key-id"] !== undefined) contents.SSEKMSKeyId = output.headers["x-amz-server-side-encryption-aws-kms-key-id"];
                    if (output.headers["x-amz-server-side-encryption-bucket-key-enabled"] !== undefined) contents.BucketKeyEnabled = output.headers["x-amz-server-side-encryption-bucket-key-enabled"] === "true";
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data["Bucket"] !== undefined) contents.Bucket = data["Bucket"];
                    if (data["ETag"] !== undefined) contents.ETag = data["ETag"];
                    if (data["Key"] !== undefined) contents.Key = data["Key"];
                    if (data["Location"] !== undefined) contents.Location = data["Location"];
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlCompleteMultipartUploadCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$a5d77c8b6651b993 = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlCopyObjectCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output),
                        BucketKeyEnabled: undefined,
                        CopyObjectResult: undefined,
                        CopySourceVersionId: undefined,
                        Expiration: undefined,
                        RequestCharged: undefined,
                        SSECustomerAlgorithm: undefined,
                        SSECustomerKeyMD5: undefined,
                        SSEKMSEncryptionContext: undefined,
                        SSEKMSKeyId: undefined,
                        ServerSideEncryption: undefined,
                        VersionId: undefined
                    };
                    if (output.headers["x-amz-expiration"] !== undefined) contents.Expiration = output.headers["x-amz-expiration"];
                    if (output.headers["x-amz-copy-source-version-id"] !== undefined) contents.CopySourceVersionId = output.headers["x-amz-copy-source-version-id"];
                    if (output.headers["x-amz-version-id"] !== undefined) contents.VersionId = output.headers["x-amz-version-id"];
                    if (output.headers["x-amz-server-side-encryption"] !== undefined) contents.ServerSideEncryption = output.headers["x-amz-server-side-encryption"];
                    if (output.headers["x-amz-server-side-encryption-customer-algorithm"] !== undefined) contents.SSECustomerAlgorithm = output.headers["x-amz-server-side-encryption-customer-algorithm"];
                    if (output.headers["x-amz-server-side-encryption-customer-key-md5"] !== undefined) contents.SSECustomerKeyMD5 = output.headers["x-amz-server-side-encryption-customer-key-md5"];
                    if (output.headers["x-amz-server-side-encryption-aws-kms-key-id"] !== undefined) contents.SSEKMSKeyId = output.headers["x-amz-server-side-encryption-aws-kms-key-id"];
                    if (output.headers["x-amz-server-side-encryption-context"] !== undefined) contents.SSEKMSEncryptionContext = output.headers["x-amz-server-side-encryption-context"];
                    if (output.headers["x-amz-server-side-encryption-bucket-key-enabled"] !== undefined) contents.BucketKeyEnabled = output.headers["x-amz-server-side-encryption-bucket-key-enabled"] === "true";
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.CopyObjectResult = $e0af51232e7b34d9$var$deserializeAws_restXmlCopyObjectResult(data, context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlCopyObjectCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, parsedBody, message;
        var _d;
        return (0, $2eeCH.__generator)(this, function(_e) {
            switch(_e.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _d = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_d.body = _e.sent(), _d)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "ObjectNotInActiveTierError":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.s3#ObjectNotInActiveTierError":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlObjectNotInActiveTierErrorResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _c.concat([
                            _e.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 4:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    _e.label = 5;
                case 5:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$b4e8f8f452bdb204 = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlCreateBucketCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output),
                        Location: undefined
                    };
                    if (output.headers["location"] !== undefined) contents.Location = output.headers["location"];
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlCreateBucketCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, parsedBody, message;
        var _e;
        return (0, $2eeCH.__generator)(this, function(_f) {
            switch(_f.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _e = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_e.body = _f.sent(), _e)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "BucketAlreadyExists":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.s3#BucketAlreadyExists":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "BucketAlreadyOwnedByYou":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.s3#BucketAlreadyOwnedByYou":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        6
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlBucketAlreadyExistsResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _c.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlBucketAlreadyOwnedByYouResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _d.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 6:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    _f.label = 7;
                case 7:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$95cf7bc6357ae5a8 = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlCreateMultipartUploadCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output),
                        AbortDate: undefined,
                        AbortRuleId: undefined,
                        Bucket: undefined,
                        BucketKeyEnabled: undefined,
                        Key: undefined,
                        RequestCharged: undefined,
                        SSECustomerAlgorithm: undefined,
                        SSECustomerKeyMD5: undefined,
                        SSEKMSEncryptionContext: undefined,
                        SSEKMSKeyId: undefined,
                        ServerSideEncryption: undefined,
                        UploadId: undefined
                    };
                    if (output.headers["x-amz-abort-date"] !== undefined) contents.AbortDate = new Date(output.headers["x-amz-abort-date"]);
                    if (output.headers["x-amz-abort-rule-id"] !== undefined) contents.AbortRuleId = output.headers["x-amz-abort-rule-id"];
                    if (output.headers["x-amz-server-side-encryption"] !== undefined) contents.ServerSideEncryption = output.headers["x-amz-server-side-encryption"];
                    if (output.headers["x-amz-server-side-encryption-customer-algorithm"] !== undefined) contents.SSECustomerAlgorithm = output.headers["x-amz-server-side-encryption-customer-algorithm"];
                    if (output.headers["x-amz-server-side-encryption-customer-key-md5"] !== undefined) contents.SSECustomerKeyMD5 = output.headers["x-amz-server-side-encryption-customer-key-md5"];
                    if (output.headers["x-amz-server-side-encryption-aws-kms-key-id"] !== undefined) contents.SSEKMSKeyId = output.headers["x-amz-server-side-encryption-aws-kms-key-id"];
                    if (output.headers["x-amz-server-side-encryption-context"] !== undefined) contents.SSEKMSEncryptionContext = output.headers["x-amz-server-side-encryption-context"];
                    if (output.headers["x-amz-server-side-encryption-bucket-key-enabled"] !== undefined) contents.BucketKeyEnabled = output.headers["x-amz-server-side-encryption-bucket-key-enabled"] === "true";
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data["Bucket"] !== undefined) contents.Bucket = data["Bucket"];
                    if (data["Key"] !== undefined) contents.Key = data["Key"];
                    if (data["UploadId"] !== undefined) contents.UploadId = data["UploadId"];
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlCreateMultipartUploadCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$c5d62536e1c56e82 = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlDeleteBucketCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlDeleteBucketCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$820ce8b5969d2c78 = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlDeleteBucketAnalyticsConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlDeleteBucketAnalyticsConfigurationCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$dea26f8b4dad38ea = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlDeleteBucketCorsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlDeleteBucketCorsCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$48d65b1878f8cb7f = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlDeleteBucketEncryptionCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlDeleteBucketEncryptionCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$bfa9d8ef1df37dec = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlDeleteBucketIntelligentTieringConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlDeleteBucketIntelligentTieringConfigurationCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$dc33768e2651b6cb = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlDeleteBucketInventoryConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlDeleteBucketInventoryConfigurationCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$1660bb2bbec5b369 = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlDeleteBucketLifecycleCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlDeleteBucketLifecycleCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$ea7eb03b8f77dc6a = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlDeleteBucketMetricsConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlDeleteBucketMetricsConfigurationCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$649e1231e4f3b774 = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlDeleteBucketOwnershipControlsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlDeleteBucketOwnershipControlsCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$470e22ed3eb8b871 = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlDeleteBucketPolicyCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlDeleteBucketPolicyCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$a8348308c83bfe9d = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlDeleteBucketReplicationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlDeleteBucketReplicationCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$8f5814a38b853d38 = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlDeleteBucketTaggingCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlDeleteBucketTaggingCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$bc95350311fac763 = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlDeleteBucketWebsiteCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlDeleteBucketWebsiteCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$987b292ae9f16665 = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlDeleteObjectCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output),
                        DeleteMarker: undefined,
                        RequestCharged: undefined,
                        VersionId: undefined
                    };
                    if (output.headers["x-amz-delete-marker"] !== undefined) contents.DeleteMarker = output.headers["x-amz-delete-marker"] === "true";
                    if (output.headers["x-amz-version-id"] !== undefined) contents.VersionId = output.headers["x-amz-version-id"];
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlDeleteObjectCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$ebb9378c7c531fa5 = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlDeleteObjectsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output),
                        Deleted: undefined,
                        Errors: undefined,
                        RequestCharged: undefined
                    };
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data.Deleted === "") contents.Deleted = [];
                    if (data["Deleted"] !== undefined) contents.Deleted = $e0af51232e7b34d9$var$deserializeAws_restXmlDeletedObjects((0, $bgM88.getArrayIfSingleItem)(data["Deleted"]), context);
                    if (data.Error === "") contents.Errors = [];
                    if (data["Error"] !== undefined) contents.Errors = $e0af51232e7b34d9$var$deserializeAws_restXmlErrors((0, $bgM88.getArrayIfSingleItem)(data["Error"]), context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlDeleteObjectsCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$7021ac5189f9792d = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlDeleteObjectTaggingCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output),
                        VersionId: undefined
                    };
                    if (output.headers["x-amz-version-id"] !== undefined) contents.VersionId = output.headers["x-amz-version-id"];
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlDeleteObjectTaggingCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$4cf24390776e8eb6 = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlDeletePublicAccessBlockCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlDeletePublicAccessBlockCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$30393acaf6414a50 = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlGetBucketAccelerateConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output),
                        Status: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data["Status"] !== undefined) contents.Status = data["Status"];
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlGetBucketAccelerateConfigurationCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$56e18e7cfcb102eb = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlGetBucketAclCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output),
                        Grants: undefined,
                        Owner: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data.AccessControlList === "") contents.Grants = [];
                    if (data["AccessControlList"] !== undefined && data["AccessControlList"]["Grant"] !== undefined) contents.Grants = $e0af51232e7b34d9$var$deserializeAws_restXmlGrants((0, $bgM88.getArrayIfSingleItem)(data["AccessControlList"]["Grant"]), context);
                    if (data["Owner"] !== undefined) contents.Owner = $e0af51232e7b34d9$var$deserializeAws_restXmlOwner(data["Owner"], context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlGetBucketAclCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$8103ef82db64a4aa = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlGetBucketAnalyticsConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output),
                        AnalyticsConfiguration: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.AnalyticsConfiguration = $e0af51232e7b34d9$var$deserializeAws_restXmlAnalyticsConfiguration(data, context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlGetBucketAnalyticsConfigurationCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$472fdec99155a887 = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlGetBucketCorsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output),
                        CORSRules: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data.CORSRule === "") contents.CORSRules = [];
                    if (data["CORSRule"] !== undefined) contents.CORSRules = $e0af51232e7b34d9$var$deserializeAws_restXmlCORSRules((0, $bgM88.getArrayIfSingleItem)(data["CORSRule"]), context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlGetBucketCorsCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$d83d67d0bf5676cb = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlGetBucketEncryptionCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output),
                        ServerSideEncryptionConfiguration: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.ServerSideEncryptionConfiguration = $e0af51232e7b34d9$var$deserializeAws_restXmlServerSideEncryptionConfiguration(data, context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlGetBucketEncryptionCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$3055c22f7a188cb2 = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlGetBucketIntelligentTieringConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output),
                        IntelligentTieringConfiguration: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.IntelligentTieringConfiguration = $e0af51232e7b34d9$var$deserializeAws_restXmlIntelligentTieringConfiguration(data, context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlGetBucketIntelligentTieringConfigurationCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$cd1101fd9c222af8 = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlGetBucketInventoryConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output),
                        InventoryConfiguration: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.InventoryConfiguration = $e0af51232e7b34d9$var$deserializeAws_restXmlInventoryConfiguration(data, context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlGetBucketInventoryConfigurationCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$b85a74c7951988c1 = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlGetBucketLifecycleConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output),
                        Rules: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data.Rule === "") contents.Rules = [];
                    if (data["Rule"] !== undefined) contents.Rules = $e0af51232e7b34d9$var$deserializeAws_restXmlLifecycleRules((0, $bgM88.getArrayIfSingleItem)(data["Rule"]), context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlGetBucketLifecycleConfigurationCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$d332d0a204c1f2de = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlGetBucketLocationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output),
                        LocationConstraint: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data["LocationConstraint"] !== undefined) contents.LocationConstraint = data["LocationConstraint"];
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlGetBucketLocationCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$99325a82aa21e152 = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlGetBucketLoggingCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output),
                        LoggingEnabled: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data["LoggingEnabled"] !== undefined) contents.LoggingEnabled = $e0af51232e7b34d9$var$deserializeAws_restXmlLoggingEnabled(data["LoggingEnabled"], context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlGetBucketLoggingCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$33f849a042e960f2 = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlGetBucketMetricsConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output),
                        MetricsConfiguration: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.MetricsConfiguration = $e0af51232e7b34d9$var$deserializeAws_restXmlMetricsConfiguration(data, context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlGetBucketMetricsConfigurationCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$f7ea4be33406a0a0 = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlGetBucketNotificationConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output),
                        LambdaFunctionConfigurations: undefined,
                        QueueConfigurations: undefined,
                        TopicConfigurations: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data.CloudFunctionConfiguration === "") contents.LambdaFunctionConfigurations = [];
                    if (data["CloudFunctionConfiguration"] !== undefined) contents.LambdaFunctionConfigurations = $e0af51232e7b34d9$var$deserializeAws_restXmlLambdaFunctionConfigurationList((0, $bgM88.getArrayIfSingleItem)(data["CloudFunctionConfiguration"]), context);
                    if (data.QueueConfiguration === "") contents.QueueConfigurations = [];
                    if (data["QueueConfiguration"] !== undefined) contents.QueueConfigurations = $e0af51232e7b34d9$var$deserializeAws_restXmlQueueConfigurationList((0, $bgM88.getArrayIfSingleItem)(data["QueueConfiguration"]), context);
                    if (data.TopicConfiguration === "") contents.TopicConfigurations = [];
                    if (data["TopicConfiguration"] !== undefined) contents.TopicConfigurations = $e0af51232e7b34d9$var$deserializeAws_restXmlTopicConfigurationList((0, $bgM88.getArrayIfSingleItem)(data["TopicConfiguration"]), context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlGetBucketNotificationConfigurationCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$e51b6b0868913b77 = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlGetBucketOwnershipControlsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output),
                        OwnershipControls: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.OwnershipControls = $e0af51232e7b34d9$var$deserializeAws_restXmlOwnershipControls(data, context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlGetBucketOwnershipControlsCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$74beb134589fee09 = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlGetBucketPolicyCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output),
                        Policy: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data["Policy"] !== undefined) contents.Policy = data["Policy"];
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlGetBucketPolicyCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$bb27e87cf2face4 = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlGetBucketPolicyStatusCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output),
                        PolicyStatus: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.PolicyStatus = $e0af51232e7b34d9$var$deserializeAws_restXmlPolicyStatus(data, context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlGetBucketPolicyStatusCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$640745a275665c3f = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlGetBucketReplicationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output),
                        ReplicationConfiguration: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.ReplicationConfiguration = $e0af51232e7b34d9$var$deserializeAws_restXmlReplicationConfiguration(data, context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlGetBucketReplicationCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$95dd746113207b99 = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlGetBucketRequestPaymentCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output),
                        Payer: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data["Payer"] !== undefined) contents.Payer = data["Payer"];
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlGetBucketRequestPaymentCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$e91d7dc8d3f2bb37 = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlGetBucketTaggingCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output),
                        TagSet: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data.TagSet === "") contents.TagSet = [];
                    if (data["TagSet"] !== undefined && data["TagSet"]["Tag"] !== undefined) contents.TagSet = $e0af51232e7b34d9$var$deserializeAws_restXmlTagSet((0, $bgM88.getArrayIfSingleItem)(data["TagSet"]["Tag"]), context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlGetBucketTaggingCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$87fb664bdbc56c8d = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlGetBucketVersioningCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output),
                        MFADelete: undefined,
                        Status: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data["MfaDelete"] !== undefined) contents.MFADelete = data["MfaDelete"];
                    if (data["Status"] !== undefined) contents.Status = data["Status"];
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlGetBucketVersioningCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$e9648c335e4af37a = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlGetBucketWebsiteCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output),
                        ErrorDocument: undefined,
                        IndexDocument: undefined,
                        RedirectAllRequestsTo: undefined,
                        RoutingRules: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data["ErrorDocument"] !== undefined) contents.ErrorDocument = $e0af51232e7b34d9$var$deserializeAws_restXmlErrorDocument(data["ErrorDocument"], context);
                    if (data["IndexDocument"] !== undefined) contents.IndexDocument = $e0af51232e7b34d9$var$deserializeAws_restXmlIndexDocument(data["IndexDocument"], context);
                    if (data["RedirectAllRequestsTo"] !== undefined) contents.RedirectAllRequestsTo = $e0af51232e7b34d9$var$deserializeAws_restXmlRedirectAllRequestsTo(data["RedirectAllRequestsTo"], context);
                    if (data.RoutingRules === "") contents.RoutingRules = [];
                    if (data["RoutingRules"] !== undefined && data["RoutingRules"]["RoutingRule"] !== undefined) contents.RoutingRules = $e0af51232e7b34d9$var$deserializeAws_restXmlRoutingRules((0, $bgM88.getArrayIfSingleItem)(data["RoutingRules"]["RoutingRule"]), context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlGetBucketWebsiteCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$c8faba1b7abd4024 = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $2eeCH.__generator)(this, function(_a) {
            if (output.statusCode !== 200 && output.statusCode >= 300) return [
                2 /*return*/ ,
                $e0af51232e7b34d9$var$deserializeAws_restXmlGetObjectCommandError(output, context)
            ];
            contents = {
                $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output),
                AcceptRanges: undefined,
                Body: undefined,
                BucketKeyEnabled: undefined,
                CacheControl: undefined,
                ContentDisposition: undefined,
                ContentEncoding: undefined,
                ContentLanguage: undefined,
                ContentLength: undefined,
                ContentRange: undefined,
                ContentType: undefined,
                DeleteMarker: undefined,
                ETag: undefined,
                Expiration: undefined,
                Expires: undefined,
                LastModified: undefined,
                Metadata: undefined,
                MissingMeta: undefined,
                ObjectLockLegalHoldStatus: undefined,
                ObjectLockMode: undefined,
                ObjectLockRetainUntilDate: undefined,
                PartsCount: undefined,
                ReplicationStatus: undefined,
                RequestCharged: undefined,
                Restore: undefined,
                SSECustomerAlgorithm: undefined,
                SSECustomerKeyMD5: undefined,
                SSEKMSKeyId: undefined,
                ServerSideEncryption: undefined,
                StorageClass: undefined,
                TagCount: undefined,
                VersionId: undefined,
                WebsiteRedirectLocation: undefined
            };
            if (output.headers["x-amz-delete-marker"] !== undefined) contents.DeleteMarker = output.headers["x-amz-delete-marker"] === "true";
            if (output.headers["accept-ranges"] !== undefined) contents.AcceptRanges = output.headers["accept-ranges"];
            if (output.headers["x-amz-expiration"] !== undefined) contents.Expiration = output.headers["x-amz-expiration"];
            if (output.headers["x-amz-restore"] !== undefined) contents.Restore = output.headers["x-amz-restore"];
            if (output.headers["last-modified"] !== undefined) contents.LastModified = new Date(output.headers["last-modified"]);
            if (output.headers["content-length"] !== undefined) contents.ContentLength = parseInt(output.headers["content-length"], 10);
            if (output.headers["etag"] !== undefined) contents.ETag = output.headers["etag"];
            if (output.headers["x-amz-missing-meta"] !== undefined) contents.MissingMeta = parseInt(output.headers["x-amz-missing-meta"], 10);
            if (output.headers["x-amz-version-id"] !== undefined) contents.VersionId = output.headers["x-amz-version-id"];
            if (output.headers["cache-control"] !== undefined) contents.CacheControl = output.headers["cache-control"];
            if (output.headers["content-disposition"] !== undefined) contents.ContentDisposition = output.headers["content-disposition"];
            if (output.headers["content-encoding"] !== undefined) contents.ContentEncoding = output.headers["content-encoding"];
            if (output.headers["content-language"] !== undefined) contents.ContentLanguage = output.headers["content-language"];
            if (output.headers["content-range"] !== undefined) contents.ContentRange = output.headers["content-range"];
            if (output.headers["content-type"] !== undefined) contents.ContentType = output.headers["content-type"];
            if (output.headers["expires"] !== undefined) contents.Expires = new Date(output.headers["expires"]);
            if (output.headers["x-amz-website-redirect-location"] !== undefined) contents.WebsiteRedirectLocation = output.headers["x-amz-website-redirect-location"];
            if (output.headers["x-amz-server-side-encryption"] !== undefined) contents.ServerSideEncryption = output.headers["x-amz-server-side-encryption"];
            if (output.headers["x-amz-server-side-encryption-customer-algorithm"] !== undefined) contents.SSECustomerAlgorithm = output.headers["x-amz-server-side-encryption-customer-algorithm"];
            if (output.headers["x-amz-server-side-encryption-customer-key-md5"] !== undefined) contents.SSECustomerKeyMD5 = output.headers["x-amz-server-side-encryption-customer-key-md5"];
            if (output.headers["x-amz-server-side-encryption-aws-kms-key-id"] !== undefined) contents.SSEKMSKeyId = output.headers["x-amz-server-side-encryption-aws-kms-key-id"];
            if (output.headers["x-amz-server-side-encryption-bucket-key-enabled"] !== undefined) contents.BucketKeyEnabled = output.headers["x-amz-server-side-encryption-bucket-key-enabled"] === "true";
            if (output.headers["x-amz-storage-class"] !== undefined) contents.StorageClass = output.headers["x-amz-storage-class"];
            if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
            if (output.headers["x-amz-replication-status"] !== undefined) contents.ReplicationStatus = output.headers["x-amz-replication-status"];
            if (output.headers["x-amz-mp-parts-count"] !== undefined) contents.PartsCount = parseInt(output.headers["x-amz-mp-parts-count"], 10);
            if (output.headers["x-amz-tagging-count"] !== undefined) contents.TagCount = parseInt(output.headers["x-amz-tagging-count"], 10);
            if (output.headers["x-amz-object-lock-mode"] !== undefined) contents.ObjectLockMode = output.headers["x-amz-object-lock-mode"];
            if (output.headers["x-amz-object-lock-retain-until-date"] !== undefined) contents.ObjectLockRetainUntilDate = new Date(output.headers["x-amz-object-lock-retain-until-date"]);
            if (output.headers["x-amz-object-lock-legal-hold"] !== undefined) contents.ObjectLockLegalHoldStatus = output.headers["x-amz-object-lock-legal-hold"];
            Object.keys(output.headers).forEach(function(header) {
                if (contents.Metadata === undefined) contents.Metadata = {};
                if (header.startsWith("x-amz-meta-")) contents.Metadata[header.substring(11)] = output.headers[header];
            });
            data = output.body;
            contents.Body = data;
            return [
                2 /*return*/ ,
                Promise.resolve(contents)
            ];
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlGetObjectCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, parsedBody, message;
        var _e;
        return (0, $2eeCH.__generator)(this, function(_f) {
            switch(_f.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _e = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_e.body = _f.sent(), _e)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidObjectState":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.s3#InvalidObjectState":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "NoSuchKey":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.s3#NoSuchKey":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        6
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlInvalidObjectStateResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _c.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlNoSuchKeyResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _d.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 6:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    _f.label = 7;
                case 7:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$7334ba1348400806 = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlGetObjectAclCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output),
                        Grants: undefined,
                        Owner: undefined,
                        RequestCharged: undefined
                    };
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data.AccessControlList === "") contents.Grants = [];
                    if (data["AccessControlList"] !== undefined && data["AccessControlList"]["Grant"] !== undefined) contents.Grants = $e0af51232e7b34d9$var$deserializeAws_restXmlGrants((0, $bgM88.getArrayIfSingleItem)(data["AccessControlList"]["Grant"]), context);
                    if (data["Owner"] !== undefined) contents.Owner = $e0af51232e7b34d9$var$deserializeAws_restXmlOwner(data["Owner"], context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlGetObjectAclCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, parsedBody, message;
        var _d;
        return (0, $2eeCH.__generator)(this, function(_e) {
            switch(_e.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _d = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_d.body = _e.sent(), _d)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "NoSuchKey":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.s3#NoSuchKey":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlNoSuchKeyResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _c.concat([
                            _e.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 4:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    _e.label = 5;
                case 5:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$3fe12927f071d9c2 = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlGetObjectLegalHoldCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output),
                        LegalHold: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.LegalHold = $e0af51232e7b34d9$var$deserializeAws_restXmlObjectLockLegalHold(data, context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlGetObjectLegalHoldCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$8a6b0973efae922a = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlGetObjectLockConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output),
                        ObjectLockConfiguration: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.ObjectLockConfiguration = $e0af51232e7b34d9$var$deserializeAws_restXmlObjectLockConfiguration(data, context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlGetObjectLockConfigurationCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$e8bb8c760a500abf = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlGetObjectRetentionCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output),
                        Retention: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.Retention = $e0af51232e7b34d9$var$deserializeAws_restXmlObjectLockRetention(data, context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlGetObjectRetentionCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$b55a093fbe745f1a = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlGetObjectTaggingCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output),
                        TagSet: undefined,
                        VersionId: undefined
                    };
                    if (output.headers["x-amz-version-id"] !== undefined) contents.VersionId = output.headers["x-amz-version-id"];
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data.TagSet === "") contents.TagSet = [];
                    if (data["TagSet"] !== undefined && data["TagSet"]["Tag"] !== undefined) contents.TagSet = $e0af51232e7b34d9$var$deserializeAws_restXmlTagSet((0, $bgM88.getArrayIfSingleItem)(data["TagSet"]["Tag"]), context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlGetObjectTaggingCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$77cab76edb05348f = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $2eeCH.__generator)(this, function(_a) {
            if (output.statusCode !== 200 && output.statusCode >= 300) return [
                2 /*return*/ ,
                $e0af51232e7b34d9$var$deserializeAws_restXmlGetObjectTorrentCommandError(output, context)
            ];
            contents = {
                $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output),
                Body: undefined,
                RequestCharged: undefined
            };
            if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
            data = output.body;
            contents.Body = data;
            return [
                2 /*return*/ ,
                Promise.resolve(contents)
            ];
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlGetObjectTorrentCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$ca2eb582f189d59e = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlGetPublicAccessBlockCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output),
                        PublicAccessBlockConfiguration: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.PublicAccessBlockConfiguration = $e0af51232e7b34d9$var$deserializeAws_restXmlPublicAccessBlockConfiguration(data, context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlGetPublicAccessBlockCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$7da61a6d1be4855c = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlHeadBucketCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlHeadBucketCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, parsedBody, message;
        var _d;
        return (0, $2eeCH.__generator)(this, function(_e) {
            switch(_e.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _d = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_d.body = _e.sent(), _d)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "NoSuchBucket":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.s3#NoSuchBucket":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlNoSuchBucketResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _c.concat([
                            _e.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 4:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    _e.label = 5;
                case 5:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$6facb3b50649bd07 = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlHeadObjectCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output),
                        AcceptRanges: undefined,
                        ArchiveStatus: undefined,
                        BucketKeyEnabled: undefined,
                        CacheControl: undefined,
                        ContentDisposition: undefined,
                        ContentEncoding: undefined,
                        ContentLanguage: undefined,
                        ContentLength: undefined,
                        ContentType: undefined,
                        DeleteMarker: undefined,
                        ETag: undefined,
                        Expiration: undefined,
                        Expires: undefined,
                        LastModified: undefined,
                        Metadata: undefined,
                        MissingMeta: undefined,
                        ObjectLockLegalHoldStatus: undefined,
                        ObjectLockMode: undefined,
                        ObjectLockRetainUntilDate: undefined,
                        PartsCount: undefined,
                        ReplicationStatus: undefined,
                        RequestCharged: undefined,
                        Restore: undefined,
                        SSECustomerAlgorithm: undefined,
                        SSECustomerKeyMD5: undefined,
                        SSEKMSKeyId: undefined,
                        ServerSideEncryption: undefined,
                        StorageClass: undefined,
                        VersionId: undefined,
                        WebsiteRedirectLocation: undefined
                    };
                    if (output.headers["x-amz-delete-marker"] !== undefined) contents.DeleteMarker = output.headers["x-amz-delete-marker"] === "true";
                    if (output.headers["accept-ranges"] !== undefined) contents.AcceptRanges = output.headers["accept-ranges"];
                    if (output.headers["x-amz-expiration"] !== undefined) contents.Expiration = output.headers["x-amz-expiration"];
                    if (output.headers["x-amz-restore"] !== undefined) contents.Restore = output.headers["x-amz-restore"];
                    if (output.headers["x-amz-archive-status"] !== undefined) contents.ArchiveStatus = output.headers["x-amz-archive-status"];
                    if (output.headers["last-modified"] !== undefined) contents.LastModified = new Date(output.headers["last-modified"]);
                    if (output.headers["content-length"] !== undefined) contents.ContentLength = parseInt(output.headers["content-length"], 10);
                    if (output.headers["etag"] !== undefined) contents.ETag = output.headers["etag"];
                    if (output.headers["x-amz-missing-meta"] !== undefined) contents.MissingMeta = parseInt(output.headers["x-amz-missing-meta"], 10);
                    if (output.headers["x-amz-version-id"] !== undefined) contents.VersionId = output.headers["x-amz-version-id"];
                    if (output.headers["cache-control"] !== undefined) contents.CacheControl = output.headers["cache-control"];
                    if (output.headers["content-disposition"] !== undefined) contents.ContentDisposition = output.headers["content-disposition"];
                    if (output.headers["content-encoding"] !== undefined) contents.ContentEncoding = output.headers["content-encoding"];
                    if (output.headers["content-language"] !== undefined) contents.ContentLanguage = output.headers["content-language"];
                    if (output.headers["content-type"] !== undefined) contents.ContentType = output.headers["content-type"];
                    if (output.headers["expires"] !== undefined) contents.Expires = new Date(output.headers["expires"]);
                    if (output.headers["x-amz-website-redirect-location"] !== undefined) contents.WebsiteRedirectLocation = output.headers["x-amz-website-redirect-location"];
                    if (output.headers["x-amz-server-side-encryption"] !== undefined) contents.ServerSideEncryption = output.headers["x-amz-server-side-encryption"];
                    if (output.headers["x-amz-server-side-encryption-customer-algorithm"] !== undefined) contents.SSECustomerAlgorithm = output.headers["x-amz-server-side-encryption-customer-algorithm"];
                    if (output.headers["x-amz-server-side-encryption-customer-key-md5"] !== undefined) contents.SSECustomerKeyMD5 = output.headers["x-amz-server-side-encryption-customer-key-md5"];
                    if (output.headers["x-amz-server-side-encryption-aws-kms-key-id"] !== undefined) contents.SSEKMSKeyId = output.headers["x-amz-server-side-encryption-aws-kms-key-id"];
                    if (output.headers["x-amz-server-side-encryption-bucket-key-enabled"] !== undefined) contents.BucketKeyEnabled = output.headers["x-amz-server-side-encryption-bucket-key-enabled"] === "true";
                    if (output.headers["x-amz-storage-class"] !== undefined) contents.StorageClass = output.headers["x-amz-storage-class"];
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    if (output.headers["x-amz-replication-status"] !== undefined) contents.ReplicationStatus = output.headers["x-amz-replication-status"];
                    if (output.headers["x-amz-mp-parts-count"] !== undefined) contents.PartsCount = parseInt(output.headers["x-amz-mp-parts-count"], 10);
                    if (output.headers["x-amz-object-lock-mode"] !== undefined) contents.ObjectLockMode = output.headers["x-amz-object-lock-mode"];
                    if (output.headers["x-amz-object-lock-retain-until-date"] !== undefined) contents.ObjectLockRetainUntilDate = new Date(output.headers["x-amz-object-lock-retain-until-date"]);
                    if (output.headers["x-amz-object-lock-legal-hold"] !== undefined) contents.ObjectLockLegalHoldStatus = output.headers["x-amz-object-lock-legal-hold"];
                    Object.keys(output.headers).forEach(function(header) {
                        if (contents.Metadata === undefined) contents.Metadata = {};
                        if (header.startsWith("x-amz-meta-")) contents.Metadata[header.substring(11)] = output.headers[header];
                    });
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlHeadObjectCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, parsedBody, message;
        var _d;
        return (0, $2eeCH.__generator)(this, function(_e) {
            switch(_e.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _d = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_d.body = _e.sent(), _d)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "NoSuchKey":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.s3#NoSuchKey":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlNoSuchKeyResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _c.concat([
                            _e.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 4:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    _e.label = 5;
                case 5:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$7c3a4eeaff09f66a = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlListBucketAnalyticsConfigurationsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output),
                        AnalyticsConfigurationList: undefined,
                        ContinuationToken: undefined,
                        IsTruncated: undefined,
                        NextContinuationToken: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data.AnalyticsConfiguration === "") contents.AnalyticsConfigurationList = [];
                    if (data["AnalyticsConfiguration"] !== undefined) contents.AnalyticsConfigurationList = $e0af51232e7b34d9$var$deserializeAws_restXmlAnalyticsConfigurationList((0, $bgM88.getArrayIfSingleItem)(data["AnalyticsConfiguration"]), context);
                    if (data["ContinuationToken"] !== undefined) contents.ContinuationToken = data["ContinuationToken"];
                    if (data["IsTruncated"] !== undefined) contents.IsTruncated = data["IsTruncated"] == "true";
                    if (data["NextContinuationToken"] !== undefined) contents.NextContinuationToken = data["NextContinuationToken"];
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlListBucketAnalyticsConfigurationsCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$e5945e65caff371e = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlListBucketIntelligentTieringConfigurationsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output),
                        ContinuationToken: undefined,
                        IntelligentTieringConfigurationList: undefined,
                        IsTruncated: undefined,
                        NextContinuationToken: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data["ContinuationToken"] !== undefined) contents.ContinuationToken = data["ContinuationToken"];
                    if (data.IntelligentTieringConfiguration === "") contents.IntelligentTieringConfigurationList = [];
                    if (data["IntelligentTieringConfiguration"] !== undefined) contents.IntelligentTieringConfigurationList = $e0af51232e7b34d9$var$deserializeAws_restXmlIntelligentTieringConfigurationList((0, $bgM88.getArrayIfSingleItem)(data["IntelligentTieringConfiguration"]), context);
                    if (data["IsTruncated"] !== undefined) contents.IsTruncated = data["IsTruncated"] == "true";
                    if (data["NextContinuationToken"] !== undefined) contents.NextContinuationToken = data["NextContinuationToken"];
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlListBucketIntelligentTieringConfigurationsCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$690ef4b20b3078b6 = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlListBucketInventoryConfigurationsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output),
                        ContinuationToken: undefined,
                        InventoryConfigurationList: undefined,
                        IsTruncated: undefined,
                        NextContinuationToken: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data["ContinuationToken"] !== undefined) contents.ContinuationToken = data["ContinuationToken"];
                    if (data.InventoryConfiguration === "") contents.InventoryConfigurationList = [];
                    if (data["InventoryConfiguration"] !== undefined) contents.InventoryConfigurationList = $e0af51232e7b34d9$var$deserializeAws_restXmlInventoryConfigurationList((0, $bgM88.getArrayIfSingleItem)(data["InventoryConfiguration"]), context);
                    if (data["IsTruncated"] !== undefined) contents.IsTruncated = data["IsTruncated"] == "true";
                    if (data["NextContinuationToken"] !== undefined) contents.NextContinuationToken = data["NextContinuationToken"];
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlListBucketInventoryConfigurationsCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$906cb5e8f067f67 = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlListBucketMetricsConfigurationsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output),
                        ContinuationToken: undefined,
                        IsTruncated: undefined,
                        MetricsConfigurationList: undefined,
                        NextContinuationToken: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data["ContinuationToken"] !== undefined) contents.ContinuationToken = data["ContinuationToken"];
                    if (data["IsTruncated"] !== undefined) contents.IsTruncated = data["IsTruncated"] == "true";
                    if (data.MetricsConfiguration === "") contents.MetricsConfigurationList = [];
                    if (data["MetricsConfiguration"] !== undefined) contents.MetricsConfigurationList = $e0af51232e7b34d9$var$deserializeAws_restXmlMetricsConfigurationList((0, $bgM88.getArrayIfSingleItem)(data["MetricsConfiguration"]), context);
                    if (data["NextContinuationToken"] !== undefined) contents.NextContinuationToken = data["NextContinuationToken"];
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlListBucketMetricsConfigurationsCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$63be43683e761a25 = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlListBucketsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output),
                        Buckets: undefined,
                        Owner: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data.Buckets === "") contents.Buckets = [];
                    if (data["Buckets"] !== undefined && data["Buckets"]["Bucket"] !== undefined) contents.Buckets = $e0af51232e7b34d9$var$deserializeAws_restXmlBuckets((0, $bgM88.getArrayIfSingleItem)(data["Buckets"]["Bucket"]), context);
                    if (data["Owner"] !== undefined) contents.Owner = $e0af51232e7b34d9$var$deserializeAws_restXmlOwner(data["Owner"], context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlListBucketsCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$8da47d46285c7a0 = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlListMultipartUploadsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output),
                        Bucket: undefined,
                        CommonPrefixes: undefined,
                        Delimiter: undefined,
                        EncodingType: undefined,
                        IsTruncated: undefined,
                        KeyMarker: undefined,
                        MaxUploads: undefined,
                        NextKeyMarker: undefined,
                        NextUploadIdMarker: undefined,
                        Prefix: undefined,
                        UploadIdMarker: undefined,
                        Uploads: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data["Bucket"] !== undefined) contents.Bucket = data["Bucket"];
                    if (data.CommonPrefixes === "") contents.CommonPrefixes = [];
                    if (data["CommonPrefixes"] !== undefined) contents.CommonPrefixes = $e0af51232e7b34d9$var$deserializeAws_restXmlCommonPrefixList((0, $bgM88.getArrayIfSingleItem)(data["CommonPrefixes"]), context);
                    if (data["Delimiter"] !== undefined) contents.Delimiter = data["Delimiter"];
                    if (data["EncodingType"] !== undefined) contents.EncodingType = data["EncodingType"];
                    if (data["IsTruncated"] !== undefined) contents.IsTruncated = data["IsTruncated"] == "true";
                    if (data["KeyMarker"] !== undefined) contents.KeyMarker = data["KeyMarker"];
                    if (data["MaxUploads"] !== undefined) contents.MaxUploads = parseInt(data["MaxUploads"]);
                    if (data["NextKeyMarker"] !== undefined) contents.NextKeyMarker = data["NextKeyMarker"];
                    if (data["NextUploadIdMarker"] !== undefined) contents.NextUploadIdMarker = data["NextUploadIdMarker"];
                    if (data["Prefix"] !== undefined) contents.Prefix = data["Prefix"];
                    if (data["UploadIdMarker"] !== undefined) contents.UploadIdMarker = data["UploadIdMarker"];
                    if (data.Upload === "") contents.Uploads = [];
                    if (data["Upload"] !== undefined) contents.Uploads = $e0af51232e7b34d9$var$deserializeAws_restXmlMultipartUploadList((0, $bgM88.getArrayIfSingleItem)(data["Upload"]), context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlListMultipartUploadsCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$f8d39cd754f5521d = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlListObjectsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output),
                        CommonPrefixes: undefined,
                        Contents: undefined,
                        Delimiter: undefined,
                        EncodingType: undefined,
                        IsTruncated: undefined,
                        Marker: undefined,
                        MaxKeys: undefined,
                        Name: undefined,
                        NextMarker: undefined,
                        Prefix: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data.CommonPrefixes === "") contents.CommonPrefixes = [];
                    if (data["CommonPrefixes"] !== undefined) contents.CommonPrefixes = $e0af51232e7b34d9$var$deserializeAws_restXmlCommonPrefixList((0, $bgM88.getArrayIfSingleItem)(data["CommonPrefixes"]), context);
                    if (data.Contents === "") contents.Contents = [];
                    if (data["Contents"] !== undefined) contents.Contents = $e0af51232e7b34d9$var$deserializeAws_restXmlObjectList((0, $bgM88.getArrayIfSingleItem)(data["Contents"]), context);
                    if (data["Delimiter"] !== undefined) contents.Delimiter = data["Delimiter"];
                    if (data["EncodingType"] !== undefined) contents.EncodingType = data["EncodingType"];
                    if (data["IsTruncated"] !== undefined) contents.IsTruncated = data["IsTruncated"] == "true";
                    if (data["Marker"] !== undefined) contents.Marker = data["Marker"];
                    if (data["MaxKeys"] !== undefined) contents.MaxKeys = parseInt(data["MaxKeys"]);
                    if (data["Name"] !== undefined) contents.Name = data["Name"];
                    if (data["NextMarker"] !== undefined) contents.NextMarker = data["NextMarker"];
                    if (data["Prefix"] !== undefined) contents.Prefix = data["Prefix"];
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlListObjectsCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, parsedBody, message;
        var _d;
        return (0, $2eeCH.__generator)(this, function(_e) {
            switch(_e.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _d = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_d.body = _e.sent(), _d)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "NoSuchBucket":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.s3#NoSuchBucket":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlNoSuchBucketResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _c.concat([
                            _e.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 4:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    _e.label = 5;
                case 5:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$2b371fcdd686ba8b = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlListObjectsV2CommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output),
                        CommonPrefixes: undefined,
                        Contents: undefined,
                        ContinuationToken: undefined,
                        Delimiter: undefined,
                        EncodingType: undefined,
                        IsTruncated: undefined,
                        KeyCount: undefined,
                        MaxKeys: undefined,
                        Name: undefined,
                        NextContinuationToken: undefined,
                        Prefix: undefined,
                        StartAfter: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data.CommonPrefixes === "") contents.CommonPrefixes = [];
                    if (data["CommonPrefixes"] !== undefined) contents.CommonPrefixes = $e0af51232e7b34d9$var$deserializeAws_restXmlCommonPrefixList((0, $bgM88.getArrayIfSingleItem)(data["CommonPrefixes"]), context);
                    if (data.Contents === "") contents.Contents = [];
                    if (data["Contents"] !== undefined) contents.Contents = $e0af51232e7b34d9$var$deserializeAws_restXmlObjectList((0, $bgM88.getArrayIfSingleItem)(data["Contents"]), context);
                    if (data["ContinuationToken"] !== undefined) contents.ContinuationToken = data["ContinuationToken"];
                    if (data["Delimiter"] !== undefined) contents.Delimiter = data["Delimiter"];
                    if (data["EncodingType"] !== undefined) contents.EncodingType = data["EncodingType"];
                    if (data["IsTruncated"] !== undefined) contents.IsTruncated = data["IsTruncated"] == "true";
                    if (data["KeyCount"] !== undefined) contents.KeyCount = parseInt(data["KeyCount"]);
                    if (data["MaxKeys"] !== undefined) contents.MaxKeys = parseInt(data["MaxKeys"]);
                    if (data["Name"] !== undefined) contents.Name = data["Name"];
                    if (data["NextContinuationToken"] !== undefined) contents.NextContinuationToken = data["NextContinuationToken"];
                    if (data["Prefix"] !== undefined) contents.Prefix = data["Prefix"];
                    if (data["StartAfter"] !== undefined) contents.StartAfter = data["StartAfter"];
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlListObjectsV2CommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, parsedBody, message;
        var _d;
        return (0, $2eeCH.__generator)(this, function(_e) {
            switch(_e.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _d = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_d.body = _e.sent(), _d)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "NoSuchBucket":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.s3#NoSuchBucket":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlNoSuchBucketResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _c.concat([
                            _e.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 4:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    _e.label = 5;
                case 5:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$637e7cd668cf8615 = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlListObjectVersionsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output),
                        CommonPrefixes: undefined,
                        DeleteMarkers: undefined,
                        Delimiter: undefined,
                        EncodingType: undefined,
                        IsTruncated: undefined,
                        KeyMarker: undefined,
                        MaxKeys: undefined,
                        Name: undefined,
                        NextKeyMarker: undefined,
                        NextVersionIdMarker: undefined,
                        Prefix: undefined,
                        VersionIdMarker: undefined,
                        Versions: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data.CommonPrefixes === "") contents.CommonPrefixes = [];
                    if (data["CommonPrefixes"] !== undefined) contents.CommonPrefixes = $e0af51232e7b34d9$var$deserializeAws_restXmlCommonPrefixList((0, $bgM88.getArrayIfSingleItem)(data["CommonPrefixes"]), context);
                    if (data.DeleteMarker === "") contents.DeleteMarkers = [];
                    if (data["DeleteMarker"] !== undefined) contents.DeleteMarkers = $e0af51232e7b34d9$var$deserializeAws_restXmlDeleteMarkers((0, $bgM88.getArrayIfSingleItem)(data["DeleteMarker"]), context);
                    if (data["Delimiter"] !== undefined) contents.Delimiter = data["Delimiter"];
                    if (data["EncodingType"] !== undefined) contents.EncodingType = data["EncodingType"];
                    if (data["IsTruncated"] !== undefined) contents.IsTruncated = data["IsTruncated"] == "true";
                    if (data["KeyMarker"] !== undefined) contents.KeyMarker = data["KeyMarker"];
                    if (data["MaxKeys"] !== undefined) contents.MaxKeys = parseInt(data["MaxKeys"]);
                    if (data["Name"] !== undefined) contents.Name = data["Name"];
                    if (data["NextKeyMarker"] !== undefined) contents.NextKeyMarker = data["NextKeyMarker"];
                    if (data["NextVersionIdMarker"] !== undefined) contents.NextVersionIdMarker = data["NextVersionIdMarker"];
                    if (data["Prefix"] !== undefined) contents.Prefix = data["Prefix"];
                    if (data["VersionIdMarker"] !== undefined) contents.VersionIdMarker = data["VersionIdMarker"];
                    if (data.Version === "") contents.Versions = [];
                    if (data["Version"] !== undefined) contents.Versions = $e0af51232e7b34d9$var$deserializeAws_restXmlObjectVersionList((0, $bgM88.getArrayIfSingleItem)(data["Version"]), context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlListObjectVersionsCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$584d994fd27ec2bb = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlListPartsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output),
                        AbortDate: undefined,
                        AbortRuleId: undefined,
                        Bucket: undefined,
                        Initiator: undefined,
                        IsTruncated: undefined,
                        Key: undefined,
                        MaxParts: undefined,
                        NextPartNumberMarker: undefined,
                        Owner: undefined,
                        PartNumberMarker: undefined,
                        Parts: undefined,
                        RequestCharged: undefined,
                        StorageClass: undefined,
                        UploadId: undefined
                    };
                    if (output.headers["x-amz-abort-date"] !== undefined) contents.AbortDate = new Date(output.headers["x-amz-abort-date"]);
                    if (output.headers["x-amz-abort-rule-id"] !== undefined) contents.AbortRuleId = output.headers["x-amz-abort-rule-id"];
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data["Bucket"] !== undefined) contents.Bucket = data["Bucket"];
                    if (data["Initiator"] !== undefined) contents.Initiator = $e0af51232e7b34d9$var$deserializeAws_restXmlInitiator(data["Initiator"], context);
                    if (data["IsTruncated"] !== undefined) contents.IsTruncated = data["IsTruncated"] == "true";
                    if (data["Key"] !== undefined) contents.Key = data["Key"];
                    if (data["MaxParts"] !== undefined) contents.MaxParts = parseInt(data["MaxParts"]);
                    if (data["NextPartNumberMarker"] !== undefined) contents.NextPartNumberMarker = data["NextPartNumberMarker"];
                    if (data["Owner"] !== undefined) contents.Owner = $e0af51232e7b34d9$var$deserializeAws_restXmlOwner(data["Owner"], context);
                    if (data["PartNumberMarker"] !== undefined) contents.PartNumberMarker = data["PartNumberMarker"];
                    if (data.Part === "") contents.Parts = [];
                    if (data["Part"] !== undefined) contents.Parts = $e0af51232e7b34d9$var$deserializeAws_restXmlParts((0, $bgM88.getArrayIfSingleItem)(data["Part"]), context);
                    if (data["StorageClass"] !== undefined) contents.StorageClass = data["StorageClass"];
                    if (data["UploadId"] !== undefined) contents.UploadId = data["UploadId"];
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlListPartsCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$e654cd63b770e3c4 = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlPutBucketAccelerateConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlPutBucketAccelerateConfigurationCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$468a83c548434951 = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlPutBucketAclCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlPutBucketAclCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$488c2e199ebb898d = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlPutBucketAnalyticsConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlPutBucketAnalyticsConfigurationCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$3eb4d44bdf561f91 = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlPutBucketCorsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlPutBucketCorsCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$d0f1e0a2cb4f5db6 = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlPutBucketEncryptionCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlPutBucketEncryptionCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$96bb8c8575dc5439 = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlPutBucketIntelligentTieringConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlPutBucketIntelligentTieringConfigurationCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$a7487a3c5377a809 = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlPutBucketInventoryConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlPutBucketInventoryConfigurationCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$9e27fb99395eb8b3 = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlPutBucketLifecycleConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlPutBucketLifecycleConfigurationCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$9e24aeee62aeef65 = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlPutBucketLoggingCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlPutBucketLoggingCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$3a85a94ca87604e2 = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlPutBucketMetricsConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlPutBucketMetricsConfigurationCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$ec8129277a63ef1e = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlPutBucketNotificationConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlPutBucketNotificationConfigurationCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$8d1d3805e977d457 = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlPutBucketOwnershipControlsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlPutBucketOwnershipControlsCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$2b7b6f0e8b2cc8a1 = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlPutBucketPolicyCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlPutBucketPolicyCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$8ea9e7fadc7c189a = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlPutBucketReplicationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlPutBucketReplicationCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$12b0ab2c5846a509 = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlPutBucketRequestPaymentCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlPutBucketRequestPaymentCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$5bf4de3b4501436e = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlPutBucketTaggingCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlPutBucketTaggingCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$ef405e59c399a368 = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlPutBucketVersioningCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlPutBucketVersioningCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$514d37c55d4fb4b5 = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlPutBucketWebsiteCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlPutBucketWebsiteCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$45bbdbf5181c3607 = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlPutObjectCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output),
                        BucketKeyEnabled: undefined,
                        ETag: undefined,
                        Expiration: undefined,
                        RequestCharged: undefined,
                        SSECustomerAlgorithm: undefined,
                        SSECustomerKeyMD5: undefined,
                        SSEKMSEncryptionContext: undefined,
                        SSEKMSKeyId: undefined,
                        ServerSideEncryption: undefined,
                        VersionId: undefined
                    };
                    if (output.headers["x-amz-expiration"] !== undefined) contents.Expiration = output.headers["x-amz-expiration"];
                    if (output.headers["etag"] !== undefined) contents.ETag = output.headers["etag"];
                    if (output.headers["x-amz-server-side-encryption"] !== undefined) contents.ServerSideEncryption = output.headers["x-amz-server-side-encryption"];
                    if (output.headers["x-amz-version-id"] !== undefined) contents.VersionId = output.headers["x-amz-version-id"];
                    if (output.headers["x-amz-server-side-encryption-customer-algorithm"] !== undefined) contents.SSECustomerAlgorithm = output.headers["x-amz-server-side-encryption-customer-algorithm"];
                    if (output.headers["x-amz-server-side-encryption-customer-key-md5"] !== undefined) contents.SSECustomerKeyMD5 = output.headers["x-amz-server-side-encryption-customer-key-md5"];
                    if (output.headers["x-amz-server-side-encryption-aws-kms-key-id"] !== undefined) contents.SSEKMSKeyId = output.headers["x-amz-server-side-encryption-aws-kms-key-id"];
                    if (output.headers["x-amz-server-side-encryption-context"] !== undefined) contents.SSEKMSEncryptionContext = output.headers["x-amz-server-side-encryption-context"];
                    if (output.headers["x-amz-server-side-encryption-bucket-key-enabled"] !== undefined) contents.BucketKeyEnabled = output.headers["x-amz-server-side-encryption-bucket-key-enabled"] === "true";
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlPutObjectCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$e0d1dc79dd7bc4d6 = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlPutObjectAclCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output),
                        RequestCharged: undefined
                    };
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlPutObjectAclCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, parsedBody, message;
        var _d;
        return (0, $2eeCH.__generator)(this, function(_e) {
            switch(_e.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _d = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_d.body = _e.sent(), _d)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "NoSuchKey":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.s3#NoSuchKey":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlNoSuchKeyResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _c.concat([
                            _e.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 4:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    _e.label = 5;
                case 5:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$a32f5469ffeef979 = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlPutObjectLegalHoldCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output),
                        RequestCharged: undefined
                    };
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlPutObjectLegalHoldCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$470735cd3fe9e5b5 = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlPutObjectLockConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output),
                        RequestCharged: undefined
                    };
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlPutObjectLockConfigurationCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$5377eccfb6cedf8b = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlPutObjectRetentionCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output),
                        RequestCharged: undefined
                    };
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlPutObjectRetentionCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$cecf7bb838bf1182 = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlPutObjectTaggingCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output),
                        VersionId: undefined
                    };
                    if (output.headers["x-amz-version-id"] !== undefined) contents.VersionId = output.headers["x-amz-version-id"];
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlPutObjectTaggingCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$7a1b291f9ae3d668 = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlPutPublicAccessBlockCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlPutPublicAccessBlockCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$317606d55789efe9 = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlRestoreObjectCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output),
                        RequestCharged: undefined,
                        RestoreOutputPath: undefined
                    };
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    if (output.headers["x-amz-restore-output-path"] !== undefined) contents.RestoreOutputPath = output.headers["x-amz-restore-output-path"];
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlRestoreObjectCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, parsedBody, message;
        var _d;
        return (0, $2eeCH.__generator)(this, function(_e) {
            switch(_e.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _d = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_d.body = _e.sent(), _d)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "ObjectAlreadyInActiveTierError":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.s3#ObjectAlreadyInActiveTierError":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlObjectAlreadyInActiveTierErrorResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $2eeCH.__assign).apply(void 0, [
                        (0, $2eeCH.__assign).apply(void 0, _c.concat([
                            _e.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 4:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    _e.label = 5;
                case 5:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$285881e5f25758a3 = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $2eeCH.__generator)(this, function(_a) {
            if (output.statusCode !== 200 && output.statusCode >= 300) return [
                2 /*return*/ ,
                $e0af51232e7b34d9$var$deserializeAws_restXmlSelectObjectContentCommandError(output, context)
            ];
            contents = {
                $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output),
                Payload: undefined
            };
            data = context.eventStreamMarshaller.deserialize(output.body, function(event) {
                return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
                    var eventName, eventHeaders, eventMessage, parsedEvent;
                    var _a;
                    return (0, $2eeCH.__generator)(this, function(_b) {
                        switch(_b.label){
                            case 0:
                                eventName = Object.keys(event)[0];
                                eventHeaders = Object.entries(event[eventName].headers).reduce(function(accummulator, curr) {
                                    accummulator[curr[0]] = curr[1].value;
                                    return accummulator;
                                }, {});
                                eventMessage = {
                                    headers: eventHeaders,
                                    body: event[eventName].body
                                };
                                parsedEvent = (_a = {}, _a[eventName] = eventMessage, _a);
                                return [
                                    4 /*yield*/ ,
                                    $e0af51232e7b34d9$var$deserializeAws_restXmlSelectObjectContentEventStream_event(parsedEvent, context)
                                ];
                            case 1:
                                return [
                                    2 /*return*/ ,
                                    _b.sent()
                                ];
                        }
                    });
                });
            });
            contents.Payload = data;
            return [
                2 /*return*/ ,
                Promise.resolve(contents)
            ];
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlSelectObjectContentCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$176ef954f1bec178 = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlUploadPartCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output),
                        BucketKeyEnabled: undefined,
                        ETag: undefined,
                        RequestCharged: undefined,
                        SSECustomerAlgorithm: undefined,
                        SSECustomerKeyMD5: undefined,
                        SSEKMSKeyId: undefined,
                        ServerSideEncryption: undefined
                    };
                    if (output.headers["x-amz-server-side-encryption"] !== undefined) contents.ServerSideEncryption = output.headers["x-amz-server-side-encryption"];
                    if (output.headers["etag"] !== undefined) contents.ETag = output.headers["etag"];
                    if (output.headers["x-amz-server-side-encryption-customer-algorithm"] !== undefined) contents.SSECustomerAlgorithm = output.headers["x-amz-server-side-encryption-customer-algorithm"];
                    if (output.headers["x-amz-server-side-encryption-customer-key-md5"] !== undefined) contents.SSECustomerKeyMD5 = output.headers["x-amz-server-side-encryption-customer-key-md5"];
                    if (output.headers["x-amz-server-side-encryption-aws-kms-key-id"] !== undefined) contents.SSEKMSKeyId = output.headers["x-amz-server-side-encryption-aws-kms-key-id"];
                    if (output.headers["x-amz-server-side-encryption-bucket-key-enabled"] !== undefined) contents.BucketKeyEnabled = output.headers["x-amz-server-side-encryption-bucket-key-enabled"] === "true";
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlUploadPartCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$export$460d1831a8acdf23 = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $2eeCH.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlUploadPartCopyCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output),
                        BucketKeyEnabled: undefined,
                        CopyPartResult: undefined,
                        CopySourceVersionId: undefined,
                        RequestCharged: undefined,
                        SSECustomerAlgorithm: undefined,
                        SSECustomerKeyMD5: undefined,
                        SSEKMSKeyId: undefined,
                        ServerSideEncryption: undefined
                    };
                    if (output.headers["x-amz-copy-source-version-id"] !== undefined) contents.CopySourceVersionId = output.headers["x-amz-copy-source-version-id"];
                    if (output.headers["x-amz-server-side-encryption"] !== undefined) contents.ServerSideEncryption = output.headers["x-amz-server-side-encryption"];
                    if (output.headers["x-amz-server-side-encryption-customer-algorithm"] !== undefined) contents.SSECustomerAlgorithm = output.headers["x-amz-server-side-encryption-customer-algorithm"];
                    if (output.headers["x-amz-server-side-encryption-customer-key-md5"] !== undefined) contents.SSECustomerKeyMD5 = output.headers["x-amz-server-side-encryption-customer-key-md5"];
                    if (output.headers["x-amz-server-side-encryption-aws-kms-key-id"] !== undefined) contents.SSEKMSKeyId = output.headers["x-amz-server-side-encryption-aws-kms-key-id"];
                    if (output.headers["x-amz-server-side-encryption-bucket-key-enabled"] !== undefined) contents.BucketKeyEnabled = output.headers["x-amz-server-side-encryption-bucket-key-enabled"] === "true";
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.CopyPartResult = $e0af51232e7b34d9$var$deserializeAws_restXmlCopyPartResult(data, context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlUploadPartCopyCommandError = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $2eeCH.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $2eeCH.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $2eeCH.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $e0af51232e7b34d9$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $e0af51232e7b34d9$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlSelectObjectContentEventStream_event = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var _a, _b, _c, _d, _e;
        return (0, $2eeCH.__generator)(this, function(_f) {
            switch(_f.label){
                case 0:
                    if (!(output["Records"] !== undefined)) return [
                        3 /*break*/ ,
                        2
                    ];
                    _a = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlRecordsEvent_event(output["Records"], context)
                    ];
                case 1:
                    return [
                        2 /*return*/ ,
                        (_a.Records = _f.sent(), _a)
                    ];
                case 2:
                    if (!(output["Stats"] !== undefined)) return [
                        3 /*break*/ ,
                        4
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlStatsEvent_event(output["Stats"], context)
                    ];
                case 3:
                    return [
                        2 /*return*/ ,
                        (_b.Stats = _f.sent(), _b)
                    ];
                case 4:
                    if (!(output["Progress"] !== undefined)) return [
                        3 /*break*/ ,
                        6
                    ];
                    _c = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlProgressEvent_event(output["Progress"], context)
                    ];
                case 5:
                    return [
                        2 /*return*/ ,
                        (_c.Progress = _f.sent(), _c)
                    ];
                case 6:
                    if (!(output["Cont"] !== undefined)) return [
                        3 /*break*/ ,
                        8
                    ];
                    _d = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlContinuationEvent_event(output["Cont"], context)
                    ];
                case 7:
                    return [
                        2 /*return*/ ,
                        (_d.Cont = _f.sent(), _d)
                    ];
                case 8:
                    if (!(output["End"] !== undefined)) return [
                        3 /*break*/ ,
                        10
                    ];
                    _e = {};
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$deserializeAws_restXmlEndEvent_event(output["End"], context)
                    ];
                case 9:
                    return [
                        2 /*return*/ ,
                        (_e.End = _f.sent(), _e)
                    ];
                case 10:
                    return [
                        2 /*return*/ ,
                        {
                            $unknown: output
                        }
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlContinuationEvent_event = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $2eeCH.__generator)(this, function(_a) {
            contents = {};
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlEndEvent_event = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $2eeCH.__generator)(this, function(_a) {
            contents = {};
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlProgressEvent_event = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents, _a;
        return (0, $2eeCH.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    contents = {};
                    _a = contents;
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    _a.Details = _b.sent();
                    return [
                        2 /*return*/ ,
                        contents
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlRecordsEvent_event = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $2eeCH.__generator)(this, function(_a) {
            contents = {};
            contents.Payload = output.body;
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlStatsEvent_event = function(output, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents, _a;
        return (0, $2eeCH.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    contents = {};
                    _a = contents;
                    return [
                        4 /*yield*/ ,
                        $e0af51232e7b34d9$var$parseBody(output.body, context)
                    ];
                case 1:
                    _a.Details = _b.sent();
                    return [
                        2 /*return*/ ,
                        contents
                    ];
            }
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlBucketAlreadyExistsResponse = function(parsedOutput, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $2eeCH.__generator)(this, function(_a) {
            contents = {
                name: "BucketAlreadyExists",
                $fault: "client",
                $metadata: $e0af51232e7b34d9$var$deserializeMetadata(parsedOutput)
            };
            data = parsedOutput.body;
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlBucketAlreadyOwnedByYouResponse = function(parsedOutput, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $2eeCH.__generator)(this, function(_a) {
            contents = {
                name: "BucketAlreadyOwnedByYou",
                $fault: "client",
                $metadata: $e0af51232e7b34d9$var$deserializeMetadata(parsedOutput)
            };
            data = parsedOutput.body;
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlInvalidObjectStateResponse = function(parsedOutput, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $2eeCH.__generator)(this, function(_a) {
            contents = {
                name: "InvalidObjectState",
                $fault: "client",
                $metadata: $e0af51232e7b34d9$var$deserializeMetadata(parsedOutput),
                AccessTier: undefined,
                StorageClass: undefined
            };
            data = parsedOutput.body;
            if (data["AccessTier"] !== undefined) contents.AccessTier = data["AccessTier"];
            if (data["StorageClass"] !== undefined) contents.StorageClass = data["StorageClass"];
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlNoSuchBucketResponse = function(parsedOutput, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $2eeCH.__generator)(this, function(_a) {
            contents = {
                name: "NoSuchBucket",
                $fault: "client",
                $metadata: $e0af51232e7b34d9$var$deserializeMetadata(parsedOutput)
            };
            data = parsedOutput.body;
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlNoSuchKeyResponse = function(parsedOutput, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $2eeCH.__generator)(this, function(_a) {
            contents = {
                name: "NoSuchKey",
                $fault: "client",
                $metadata: $e0af51232e7b34d9$var$deserializeMetadata(parsedOutput)
            };
            data = parsedOutput.body;
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlNoSuchUploadResponse = function(parsedOutput, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $2eeCH.__generator)(this, function(_a) {
            contents = {
                name: "NoSuchUpload",
                $fault: "client",
                $metadata: $e0af51232e7b34d9$var$deserializeMetadata(parsedOutput)
            };
            data = parsedOutput.body;
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlObjectAlreadyInActiveTierErrorResponse = function(parsedOutput, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $2eeCH.__generator)(this, function(_a) {
            contents = {
                name: "ObjectAlreadyInActiveTierError",
                $fault: "client",
                $metadata: $e0af51232e7b34d9$var$deserializeMetadata(parsedOutput)
            };
            data = parsedOutput.body;
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlObjectNotInActiveTierErrorResponse = function(parsedOutput, context) {
    return (0, $2eeCH.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $2eeCH.__generator)(this, function(_a) {
            contents = {
                name: "ObjectNotInActiveTierError",
                $fault: "client",
                $metadata: $e0af51232e7b34d9$var$deserializeMetadata(parsedOutput)
            };
            data = parsedOutput.body;
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $e0af51232e7b34d9$var$serializeAws_restXmlAbortIncompleteMultipartUpload = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("AbortIncompleteMultipartUpload");
    if (input.DaysAfterInitiation !== undefined && input.DaysAfterInitiation !== null) {
        var node = new (0, $iqrNg.XmlNode)("DaysAfterInitiation").addChildNode(new (0, $cm4u6.XmlText)(String(input.DaysAfterInitiation))).withName("DaysAfterInitiation");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlAccelerateConfiguration = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("AccelerateConfiguration");
    if (input.Status !== undefined && input.Status !== null) {
        var node = new (0, $iqrNg.XmlNode)("BucketAccelerateStatus").addChildNode(new (0, $cm4u6.XmlText)(input.Status)).withName("Status");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlAccessControlPolicy = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("AccessControlPolicy");
    if (input.Grants !== undefined && input.Grants !== null) {
        var nodes = $e0af51232e7b34d9$var$serializeAws_restXmlGrants(input.Grants, context);
        var containerNode_1 = new (0, $iqrNg.XmlNode)("AccessControlList");
        nodes.map(function(node) {
            containerNode_1.addChildNode(node);
        });
        bodyNode.addChildNode(containerNode_1);
    }
    if (input.Owner !== undefined && input.Owner !== null) {
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlOwner(input.Owner, context).withName("Owner");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlAccessControlTranslation = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("AccessControlTranslation");
    if (input.Owner !== undefined && input.Owner !== null) {
        var node = new (0, $iqrNg.XmlNode)("OwnerOverride").addChildNode(new (0, $cm4u6.XmlText)(input.Owner)).withName("Owner");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlAllowedHeaders = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        var node = new (0, $iqrNg.XmlNode)("AllowedHeader").addChildNode(new (0, $cm4u6.XmlText)(entry));
        return node.withName("member");
    });
};
var $e0af51232e7b34d9$var$serializeAws_restXmlAllowedMethods = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        var node = new (0, $iqrNg.XmlNode)("AllowedMethod").addChildNode(new (0, $cm4u6.XmlText)(entry));
        return node.withName("member");
    });
};
var $e0af51232e7b34d9$var$serializeAws_restXmlAllowedOrigins = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        var node = new (0, $iqrNg.XmlNode)("AllowedOrigin").addChildNode(new (0, $cm4u6.XmlText)(entry));
        return node.withName("member");
    });
};
var $e0af51232e7b34d9$var$serializeAws_restXmlAnalyticsAndOperator = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("AnalyticsAndOperator");
    if (input.Prefix !== undefined && input.Prefix !== null) {
        var node = new (0, $iqrNg.XmlNode)("Prefix").addChildNode(new (0, $cm4u6.XmlText)(input.Prefix)).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    if (input.Tags !== undefined && input.Tags !== null) {
        var nodes = $e0af51232e7b34d9$var$serializeAws_restXmlTagSet(input.Tags, context);
        nodes.map(function(node) {
            node = node.withName("Tag");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlAnalyticsConfiguration = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("AnalyticsConfiguration");
    if (input.Id !== undefined && input.Id !== null) {
        var node = new (0, $iqrNg.XmlNode)("AnalyticsId").addChildNode(new (0, $cm4u6.XmlText)(input.Id)).withName("Id");
        bodyNode.addChildNode(node);
    }
    if (input.Filter !== undefined && input.Filter !== null) {
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlAnalyticsFilter(input.Filter, context).withName("Filter");
        bodyNode.addChildNode(node);
    }
    if (input.StorageClassAnalysis !== undefined && input.StorageClassAnalysis !== null) {
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlStorageClassAnalysis(input.StorageClassAnalysis, context).withName("StorageClassAnalysis");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlAnalyticsExportDestination = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("AnalyticsExportDestination");
    if (input.S3BucketDestination !== undefined && input.S3BucketDestination !== null) {
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlAnalyticsS3BucketDestination(input.S3BucketDestination, context).withName("S3BucketDestination");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlAnalyticsFilter = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("AnalyticsFilter");
    (0, $g4BTM.AnalyticsFilter).visit(input, {
        Prefix: function(value) {
            var node = new (0, $iqrNg.XmlNode)("Prefix").addChildNode(new (0, $cm4u6.XmlText)(value)).withName("Prefix");
            bodyNode.addChildNode(node);
        },
        Tag: function(value) {
            var node = $e0af51232e7b34d9$var$serializeAws_restXmlTag(value, context).withName("Tag");
            bodyNode.addChildNode(node);
        },
        And: function(value) {
            var node = $e0af51232e7b34d9$var$serializeAws_restXmlAnalyticsAndOperator(value, context).withName("And");
            bodyNode.addChildNode(node);
        },
        _: function(name, value) {
            if (!(value instanceof (0, $iqrNg.XmlNode) || value instanceof (0, $cm4u6.XmlText))) throw new Error("Unable to serialize unknown union members in XML.");
            bodyNode.addChildNode(new (0, $iqrNg.XmlNode)(name).addChildNode(value));
        }
    });
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlAnalyticsS3BucketDestination = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("AnalyticsS3BucketDestination");
    if (input.Format !== undefined && input.Format !== null) {
        var node = new (0, $iqrNg.XmlNode)("AnalyticsS3ExportFileFormat").addChildNode(new (0, $cm4u6.XmlText)(input.Format)).withName("Format");
        bodyNode.addChildNode(node);
    }
    if (input.BucketAccountId !== undefined && input.BucketAccountId !== null) {
        var node = new (0, $iqrNg.XmlNode)("AccountId").addChildNode(new (0, $cm4u6.XmlText)(input.BucketAccountId)).withName("BucketAccountId");
        bodyNode.addChildNode(node);
    }
    if (input.Bucket !== undefined && input.Bucket !== null) {
        var node = new (0, $iqrNg.XmlNode)("BucketName").addChildNode(new (0, $cm4u6.XmlText)(input.Bucket)).withName("Bucket");
        bodyNode.addChildNode(node);
    }
    if (input.Prefix !== undefined && input.Prefix !== null) {
        var node = new (0, $iqrNg.XmlNode)("Prefix").addChildNode(new (0, $cm4u6.XmlText)(input.Prefix)).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlBucketLifecycleConfiguration = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("BucketLifecycleConfiguration");
    if (input.Rules !== undefined && input.Rules !== null) {
        var nodes = $e0af51232e7b34d9$var$serializeAws_restXmlLifecycleRules(input.Rules, context);
        nodes.map(function(node) {
            node = node.withName("Rule");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlBucketLoggingStatus = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("BucketLoggingStatus");
    if (input.LoggingEnabled !== undefined && input.LoggingEnabled !== null) {
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlLoggingEnabled(input.LoggingEnabled, context).withName("LoggingEnabled");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlCompletedMultipartUpload = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("CompletedMultipartUpload");
    if (input.Parts !== undefined && input.Parts !== null) {
        var nodes = $e0af51232e7b34d9$var$serializeAws_restXmlCompletedPartList(input.Parts, context);
        nodes.map(function(node) {
            node = node.withName("Part");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlCompletedPart = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("CompletedPart");
    if (input.ETag !== undefined && input.ETag !== null) {
        var node = new (0, $iqrNg.XmlNode)("ETag").addChildNode(new (0, $cm4u6.XmlText)(input.ETag)).withName("ETag");
        bodyNode.addChildNode(node);
    }
    if (input.PartNumber !== undefined && input.PartNumber !== null) {
        var node = new (0, $iqrNg.XmlNode)("PartNumber").addChildNode(new (0, $cm4u6.XmlText)(String(input.PartNumber))).withName("PartNumber");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlCompletedPartList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlCompletedPart(entry, context);
        return node.withName("member");
    });
};
var $e0af51232e7b34d9$var$serializeAws_restXmlCondition = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("Condition");
    if (input.HttpErrorCodeReturnedEquals !== undefined && input.HttpErrorCodeReturnedEquals !== null) {
        var node = new (0, $iqrNg.XmlNode)("HttpErrorCodeReturnedEquals").addChildNode(new (0, $cm4u6.XmlText)(input.HttpErrorCodeReturnedEquals)).withName("HttpErrorCodeReturnedEquals");
        bodyNode.addChildNode(node);
    }
    if (input.KeyPrefixEquals !== undefined && input.KeyPrefixEquals !== null) {
        var node = new (0, $iqrNg.XmlNode)("KeyPrefixEquals").addChildNode(new (0, $cm4u6.XmlText)(input.KeyPrefixEquals)).withName("KeyPrefixEquals");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlCORSConfiguration = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("CORSConfiguration");
    if (input.CORSRules !== undefined && input.CORSRules !== null) {
        var nodes = $e0af51232e7b34d9$var$serializeAws_restXmlCORSRules(input.CORSRules, context);
        nodes.map(function(node) {
            node = node.withName("CORSRule");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlCORSRule = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("CORSRule");
    if (input.AllowedHeaders !== undefined && input.AllowedHeaders !== null) {
        var nodes = $e0af51232e7b34d9$var$serializeAws_restXmlAllowedHeaders(input.AllowedHeaders, context);
        nodes.map(function(node) {
            node = node.withName("AllowedHeader");
            bodyNode.addChildNode(node);
        });
    }
    if (input.AllowedMethods !== undefined && input.AllowedMethods !== null) {
        var nodes = $e0af51232e7b34d9$var$serializeAws_restXmlAllowedMethods(input.AllowedMethods, context);
        nodes.map(function(node) {
            node = node.withName("AllowedMethod");
            bodyNode.addChildNode(node);
        });
    }
    if (input.AllowedOrigins !== undefined && input.AllowedOrigins !== null) {
        var nodes = $e0af51232e7b34d9$var$serializeAws_restXmlAllowedOrigins(input.AllowedOrigins, context);
        nodes.map(function(node) {
            node = node.withName("AllowedOrigin");
            bodyNode.addChildNode(node);
        });
    }
    if (input.ExposeHeaders !== undefined && input.ExposeHeaders !== null) {
        var nodes = $e0af51232e7b34d9$var$serializeAws_restXmlExposeHeaders(input.ExposeHeaders, context);
        nodes.map(function(node) {
            node = node.withName("ExposeHeader");
            bodyNode.addChildNode(node);
        });
    }
    if (input.MaxAgeSeconds !== undefined && input.MaxAgeSeconds !== null) {
        var node = new (0, $iqrNg.XmlNode)("MaxAgeSeconds").addChildNode(new (0, $cm4u6.XmlText)(String(input.MaxAgeSeconds))).withName("MaxAgeSeconds");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlCORSRules = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlCORSRule(entry, context);
        return node.withName("member");
    });
};
var $e0af51232e7b34d9$var$serializeAws_restXmlCreateBucketConfiguration = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("CreateBucketConfiguration");
    if (input.LocationConstraint !== undefined && input.LocationConstraint !== null) {
        var node = new (0, $iqrNg.XmlNode)("BucketLocationConstraint").addChildNode(new (0, $cm4u6.XmlText)(input.LocationConstraint)).withName("LocationConstraint");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlCSVInput = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("CSVInput");
    if (input.FileHeaderInfo !== undefined && input.FileHeaderInfo !== null) {
        var node = new (0, $iqrNg.XmlNode)("FileHeaderInfo").addChildNode(new (0, $cm4u6.XmlText)(input.FileHeaderInfo)).withName("FileHeaderInfo");
        bodyNode.addChildNode(node);
    }
    if (input.Comments !== undefined && input.Comments !== null) {
        var node = new (0, $iqrNg.XmlNode)("Comments").addChildNode(new (0, $cm4u6.XmlText)(input.Comments)).withName("Comments");
        bodyNode.addChildNode(node);
    }
    if (input.QuoteEscapeCharacter !== undefined && input.QuoteEscapeCharacter !== null) {
        var node = new (0, $iqrNg.XmlNode)("QuoteEscapeCharacter").addChildNode(new (0, $cm4u6.XmlText)(input.QuoteEscapeCharacter)).withName("QuoteEscapeCharacter");
        bodyNode.addChildNode(node);
    }
    if (input.RecordDelimiter !== undefined && input.RecordDelimiter !== null) {
        var node = new (0, $iqrNg.XmlNode)("RecordDelimiter").addChildNode(new (0, $cm4u6.XmlText)(input.RecordDelimiter)).withName("RecordDelimiter");
        bodyNode.addChildNode(node);
    }
    if (input.FieldDelimiter !== undefined && input.FieldDelimiter !== null) {
        var node = new (0, $iqrNg.XmlNode)("FieldDelimiter").addChildNode(new (0, $cm4u6.XmlText)(input.FieldDelimiter)).withName("FieldDelimiter");
        bodyNode.addChildNode(node);
    }
    if (input.QuoteCharacter !== undefined && input.QuoteCharacter !== null) {
        var node = new (0, $iqrNg.XmlNode)("QuoteCharacter").addChildNode(new (0, $cm4u6.XmlText)(input.QuoteCharacter)).withName("QuoteCharacter");
        bodyNode.addChildNode(node);
    }
    if (input.AllowQuotedRecordDelimiter !== undefined && input.AllowQuotedRecordDelimiter !== null) {
        var node = new (0, $iqrNg.XmlNode)("AllowQuotedRecordDelimiter").addChildNode(new (0, $cm4u6.XmlText)(String(input.AllowQuotedRecordDelimiter))).withName("AllowQuotedRecordDelimiter");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlCSVOutput = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("CSVOutput");
    if (input.QuoteFields !== undefined && input.QuoteFields !== null) {
        var node = new (0, $iqrNg.XmlNode)("QuoteFields").addChildNode(new (0, $cm4u6.XmlText)(input.QuoteFields)).withName("QuoteFields");
        bodyNode.addChildNode(node);
    }
    if (input.QuoteEscapeCharacter !== undefined && input.QuoteEscapeCharacter !== null) {
        var node = new (0, $iqrNg.XmlNode)("QuoteEscapeCharacter").addChildNode(new (0, $cm4u6.XmlText)(input.QuoteEscapeCharacter)).withName("QuoteEscapeCharacter");
        bodyNode.addChildNode(node);
    }
    if (input.RecordDelimiter !== undefined && input.RecordDelimiter !== null) {
        var node = new (0, $iqrNg.XmlNode)("RecordDelimiter").addChildNode(new (0, $cm4u6.XmlText)(input.RecordDelimiter)).withName("RecordDelimiter");
        bodyNode.addChildNode(node);
    }
    if (input.FieldDelimiter !== undefined && input.FieldDelimiter !== null) {
        var node = new (0, $iqrNg.XmlNode)("FieldDelimiter").addChildNode(new (0, $cm4u6.XmlText)(input.FieldDelimiter)).withName("FieldDelimiter");
        bodyNode.addChildNode(node);
    }
    if (input.QuoteCharacter !== undefined && input.QuoteCharacter !== null) {
        var node = new (0, $iqrNg.XmlNode)("QuoteCharacter").addChildNode(new (0, $cm4u6.XmlText)(input.QuoteCharacter)).withName("QuoteCharacter");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlDefaultRetention = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("DefaultRetention");
    if (input.Mode !== undefined && input.Mode !== null) {
        var node = new (0, $iqrNg.XmlNode)("ObjectLockRetentionMode").addChildNode(new (0, $cm4u6.XmlText)(input.Mode)).withName("Mode");
        bodyNode.addChildNode(node);
    }
    if (input.Days !== undefined && input.Days !== null) {
        var node = new (0, $iqrNg.XmlNode)("Days").addChildNode(new (0, $cm4u6.XmlText)(String(input.Days))).withName("Days");
        bodyNode.addChildNode(node);
    }
    if (input.Years !== undefined && input.Years !== null) {
        var node = new (0, $iqrNg.XmlNode)("Years").addChildNode(new (0, $cm4u6.XmlText)(String(input.Years))).withName("Years");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlDelete = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("Delete");
    if (input.Objects !== undefined && input.Objects !== null) {
        var nodes = $e0af51232e7b34d9$var$serializeAws_restXmlObjectIdentifierList(input.Objects, context);
        nodes.map(function(node) {
            node = node.withName("Object");
            bodyNode.addChildNode(node);
        });
    }
    if (input.Quiet !== undefined && input.Quiet !== null) {
        var node = new (0, $iqrNg.XmlNode)("Quiet").addChildNode(new (0, $cm4u6.XmlText)(String(input.Quiet))).withName("Quiet");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlDeleteMarkerReplication = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("DeleteMarkerReplication");
    if (input.Status !== undefined && input.Status !== null) {
        var node = new (0, $iqrNg.XmlNode)("DeleteMarkerReplicationStatus").addChildNode(new (0, $cm4u6.XmlText)(input.Status)).withName("Status");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlDestination = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("Destination");
    if (input.Bucket !== undefined && input.Bucket !== null) {
        var node = new (0, $iqrNg.XmlNode)("BucketName").addChildNode(new (0, $cm4u6.XmlText)(input.Bucket)).withName("Bucket");
        bodyNode.addChildNode(node);
    }
    if (input.Account !== undefined && input.Account !== null) {
        var node = new (0, $iqrNg.XmlNode)("AccountId").addChildNode(new (0, $cm4u6.XmlText)(input.Account)).withName("Account");
        bodyNode.addChildNode(node);
    }
    if (input.StorageClass !== undefined && input.StorageClass !== null) {
        var node = new (0, $iqrNg.XmlNode)("StorageClass").addChildNode(new (0, $cm4u6.XmlText)(input.StorageClass)).withName("StorageClass");
        bodyNode.addChildNode(node);
    }
    if (input.AccessControlTranslation !== undefined && input.AccessControlTranslation !== null) {
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlAccessControlTranslation(input.AccessControlTranslation, context).withName("AccessControlTranslation");
        bodyNode.addChildNode(node);
    }
    if (input.EncryptionConfiguration !== undefined && input.EncryptionConfiguration !== null) {
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlEncryptionConfiguration(input.EncryptionConfiguration, context).withName("EncryptionConfiguration");
        bodyNode.addChildNode(node);
    }
    if (input.ReplicationTime !== undefined && input.ReplicationTime !== null) {
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlReplicationTime(input.ReplicationTime, context).withName("ReplicationTime");
        bodyNode.addChildNode(node);
    }
    if (input.Metrics !== undefined && input.Metrics !== null) {
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlMetrics(input.Metrics, context).withName("Metrics");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlEncryption = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("Encryption");
    if (input.EncryptionType !== undefined && input.EncryptionType !== null) {
        var node = new (0, $iqrNg.XmlNode)("ServerSideEncryption").addChildNode(new (0, $cm4u6.XmlText)(input.EncryptionType)).withName("EncryptionType");
        bodyNode.addChildNode(node);
    }
    if (input.KMSKeyId !== undefined && input.KMSKeyId !== null) {
        var node = new (0, $iqrNg.XmlNode)("SSEKMSKeyId").addChildNode(new (0, $cm4u6.XmlText)(input.KMSKeyId)).withName("KMSKeyId");
        bodyNode.addChildNode(node);
    }
    if (input.KMSContext !== undefined && input.KMSContext !== null) {
        var node = new (0, $iqrNg.XmlNode)("KMSContext").addChildNode(new (0, $cm4u6.XmlText)(input.KMSContext)).withName("KMSContext");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlEncryptionConfiguration = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("EncryptionConfiguration");
    if (input.ReplicaKmsKeyID !== undefined && input.ReplicaKmsKeyID !== null) {
        var node = new (0, $iqrNg.XmlNode)("ReplicaKmsKeyID").addChildNode(new (0, $cm4u6.XmlText)(input.ReplicaKmsKeyID)).withName("ReplicaKmsKeyID");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlErrorDocument = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("ErrorDocument");
    if (input.Key !== undefined && input.Key !== null) {
        var node = new (0, $iqrNg.XmlNode)("ObjectKey").addChildNode(new (0, $cm4u6.XmlText)(input.Key)).withName("Key");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlEventList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        var node = new (0, $iqrNg.XmlNode)("Event").addChildNode(new (0, $cm4u6.XmlText)(entry));
        return node.withName("member");
    });
};
var $e0af51232e7b34d9$var$serializeAws_restXmlExistingObjectReplication = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("ExistingObjectReplication");
    if (input.Status !== undefined && input.Status !== null) {
        var node = new (0, $iqrNg.XmlNode)("ExistingObjectReplicationStatus").addChildNode(new (0, $cm4u6.XmlText)(input.Status)).withName("Status");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlExposeHeaders = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        var node = new (0, $iqrNg.XmlNode)("ExposeHeader").addChildNode(new (0, $cm4u6.XmlText)(entry));
        return node.withName("member");
    });
};
var $e0af51232e7b34d9$var$serializeAws_restXmlFilterRule = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("FilterRule");
    if (input.Name !== undefined && input.Name !== null) {
        var node = new (0, $iqrNg.XmlNode)("FilterRuleName").addChildNode(new (0, $cm4u6.XmlText)(input.Name)).withName("Name");
        bodyNode.addChildNode(node);
    }
    if (input.Value !== undefined && input.Value !== null) {
        var node = new (0, $iqrNg.XmlNode)("FilterRuleValue").addChildNode(new (0, $cm4u6.XmlText)(input.Value)).withName("Value");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlFilterRuleList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlFilterRule(entry, context);
        return node.withName("member");
    });
};
var $e0af51232e7b34d9$var$serializeAws_restXmlGlacierJobParameters = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("GlacierJobParameters");
    if (input.Tier !== undefined && input.Tier !== null) {
        var node = new (0, $iqrNg.XmlNode)("Tier").addChildNode(new (0, $cm4u6.XmlText)(input.Tier)).withName("Tier");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlGrant = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("Grant");
    if (input.Grantee !== undefined && input.Grantee !== null) {
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlGrantee(input.Grantee, context).withName("Grantee");
        bodyNode.addChildNode(node);
    }
    if (input.Permission !== undefined && input.Permission !== null) {
        var node = new (0, $iqrNg.XmlNode)("Permission").addChildNode(new (0, $cm4u6.XmlText)(input.Permission)).withName("Permission");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlGrantee = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("Grantee");
    if (input.DisplayName !== undefined && input.DisplayName !== null) {
        var node = new (0, $iqrNg.XmlNode)("DisplayName").addChildNode(new (0, $cm4u6.XmlText)(input.DisplayName)).withName("DisplayName");
        bodyNode.addChildNode(node);
    }
    if (input.EmailAddress !== undefined && input.EmailAddress !== null) {
        var node = new (0, $iqrNg.XmlNode)("EmailAddress").addChildNode(new (0, $cm4u6.XmlText)(input.EmailAddress)).withName("EmailAddress");
        bodyNode.addChildNode(node);
    }
    if (input.ID !== undefined && input.ID !== null) {
        var node = new (0, $iqrNg.XmlNode)("ID").addChildNode(new (0, $cm4u6.XmlText)(input.ID)).withName("ID");
        bodyNode.addChildNode(node);
    }
    if (input.URI !== undefined && input.URI !== null) {
        var node = new (0, $iqrNg.XmlNode)("URI").addChildNode(new (0, $cm4u6.XmlText)(input.URI)).withName("URI");
        bodyNode.addChildNode(node);
    }
    if (input.Type !== undefined && input.Type !== null) bodyNode.addAttribute("xsi:type", input.Type);
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlGrants = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlGrant(entry, context);
        return node.withName("Grant");
    });
};
var $e0af51232e7b34d9$var$serializeAws_restXmlIndexDocument = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("IndexDocument");
    if (input.Suffix !== undefined && input.Suffix !== null) {
        var node = new (0, $iqrNg.XmlNode)("Suffix").addChildNode(new (0, $cm4u6.XmlText)(input.Suffix)).withName("Suffix");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlInputSerialization = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("InputSerialization");
    if (input.CSV !== undefined && input.CSV !== null) {
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlCSVInput(input.CSV, context).withName("CSV");
        bodyNode.addChildNode(node);
    }
    if (input.CompressionType !== undefined && input.CompressionType !== null) {
        var node = new (0, $iqrNg.XmlNode)("CompressionType").addChildNode(new (0, $cm4u6.XmlText)(input.CompressionType)).withName("CompressionType");
        bodyNode.addChildNode(node);
    }
    if (input.JSON !== undefined && input.JSON !== null) {
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlJSONInput(input.JSON, context).withName("JSON");
        bodyNode.addChildNode(node);
    }
    if (input.Parquet !== undefined && input.Parquet !== null) {
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlParquetInput(input.Parquet, context).withName("Parquet");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlIntelligentTieringAndOperator = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("IntelligentTieringAndOperator");
    if (input.Prefix !== undefined && input.Prefix !== null) {
        var node = new (0, $iqrNg.XmlNode)("Prefix").addChildNode(new (0, $cm4u6.XmlText)(input.Prefix)).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    if (input.Tags !== undefined && input.Tags !== null) {
        var nodes = $e0af51232e7b34d9$var$serializeAws_restXmlTagSet(input.Tags, context);
        nodes.map(function(node) {
            node = node.withName("Tag");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlIntelligentTieringConfiguration = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("IntelligentTieringConfiguration");
    if (input.Id !== undefined && input.Id !== null) {
        var node = new (0, $iqrNg.XmlNode)("IntelligentTieringId").addChildNode(new (0, $cm4u6.XmlText)(input.Id)).withName("Id");
        bodyNode.addChildNode(node);
    }
    if (input.Filter !== undefined && input.Filter !== null) {
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlIntelligentTieringFilter(input.Filter, context).withName("Filter");
        bodyNode.addChildNode(node);
    }
    if (input.Status !== undefined && input.Status !== null) {
        var node = new (0, $iqrNg.XmlNode)("IntelligentTieringStatus").addChildNode(new (0, $cm4u6.XmlText)(input.Status)).withName("Status");
        bodyNode.addChildNode(node);
    }
    if (input.Tierings !== undefined && input.Tierings !== null) {
        var nodes = $e0af51232e7b34d9$var$serializeAws_restXmlTieringList(input.Tierings, context);
        nodes.map(function(node) {
            node = node.withName("Tiering");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlIntelligentTieringFilter = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("IntelligentTieringFilter");
    if (input.Prefix !== undefined && input.Prefix !== null) {
        var node = new (0, $iqrNg.XmlNode)("Prefix").addChildNode(new (0, $cm4u6.XmlText)(input.Prefix)).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    if (input.Tag !== undefined && input.Tag !== null) {
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlTag(input.Tag, context).withName("Tag");
        bodyNode.addChildNode(node);
    }
    if (input.And !== undefined && input.And !== null) {
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlIntelligentTieringAndOperator(input.And, context).withName("And");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlInventoryConfiguration = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("InventoryConfiguration");
    if (input.Destination !== undefined && input.Destination !== null) {
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlInventoryDestination(input.Destination, context).withName("Destination");
        bodyNode.addChildNode(node);
    }
    if (input.IsEnabled !== undefined && input.IsEnabled !== null) {
        var node = new (0, $iqrNg.XmlNode)("IsEnabled").addChildNode(new (0, $cm4u6.XmlText)(String(input.IsEnabled))).withName("IsEnabled");
        bodyNode.addChildNode(node);
    }
    if (input.Filter !== undefined && input.Filter !== null) {
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlInventoryFilter(input.Filter, context).withName("Filter");
        bodyNode.addChildNode(node);
    }
    if (input.Id !== undefined && input.Id !== null) {
        var node = new (0, $iqrNg.XmlNode)("InventoryId").addChildNode(new (0, $cm4u6.XmlText)(input.Id)).withName("Id");
        bodyNode.addChildNode(node);
    }
    if (input.IncludedObjectVersions !== undefined && input.IncludedObjectVersions !== null) {
        var node = new (0, $iqrNg.XmlNode)("InventoryIncludedObjectVersions").addChildNode(new (0, $cm4u6.XmlText)(input.IncludedObjectVersions)).withName("IncludedObjectVersions");
        bodyNode.addChildNode(node);
    }
    if (input.OptionalFields !== undefined && input.OptionalFields !== null) {
        var nodes = $e0af51232e7b34d9$var$serializeAws_restXmlInventoryOptionalFields(input.OptionalFields, context);
        var containerNode_2 = new (0, $iqrNg.XmlNode)("OptionalFields");
        nodes.map(function(node) {
            containerNode_2.addChildNode(node);
        });
        bodyNode.addChildNode(containerNode_2);
    }
    if (input.Schedule !== undefined && input.Schedule !== null) {
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlInventorySchedule(input.Schedule, context).withName("Schedule");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlInventoryDestination = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("InventoryDestination");
    if (input.S3BucketDestination !== undefined && input.S3BucketDestination !== null) {
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlInventoryS3BucketDestination(input.S3BucketDestination, context).withName("S3BucketDestination");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlInventoryEncryption = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("InventoryEncryption");
    if (input.SSES3 !== undefined && input.SSES3 !== null) {
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlSSES3(input.SSES3, context).withName("SSE-S3");
        bodyNode.addChildNode(node);
    }
    if (input.SSEKMS !== undefined && input.SSEKMS !== null) {
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlSSEKMS(input.SSEKMS, context).withName("SSE-KMS");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlInventoryFilter = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("InventoryFilter");
    if (input.Prefix !== undefined && input.Prefix !== null) {
        var node = new (0, $iqrNg.XmlNode)("Prefix").addChildNode(new (0, $cm4u6.XmlText)(input.Prefix)).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlInventoryOptionalFields = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        var node = new (0, $iqrNg.XmlNode)("InventoryOptionalField").addChildNode(new (0, $cm4u6.XmlText)(entry));
        return node.withName("Field");
    });
};
var $e0af51232e7b34d9$var$serializeAws_restXmlInventoryS3BucketDestination = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("InventoryS3BucketDestination");
    if (input.AccountId !== undefined && input.AccountId !== null) {
        var node = new (0, $iqrNg.XmlNode)("AccountId").addChildNode(new (0, $cm4u6.XmlText)(input.AccountId)).withName("AccountId");
        bodyNode.addChildNode(node);
    }
    if (input.Bucket !== undefined && input.Bucket !== null) {
        var node = new (0, $iqrNg.XmlNode)("BucketName").addChildNode(new (0, $cm4u6.XmlText)(input.Bucket)).withName("Bucket");
        bodyNode.addChildNode(node);
    }
    if (input.Format !== undefined && input.Format !== null) {
        var node = new (0, $iqrNg.XmlNode)("InventoryFormat").addChildNode(new (0, $cm4u6.XmlText)(input.Format)).withName("Format");
        bodyNode.addChildNode(node);
    }
    if (input.Prefix !== undefined && input.Prefix !== null) {
        var node = new (0, $iqrNg.XmlNode)("Prefix").addChildNode(new (0, $cm4u6.XmlText)(input.Prefix)).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    if (input.Encryption !== undefined && input.Encryption !== null) {
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlInventoryEncryption(input.Encryption, context).withName("Encryption");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlInventorySchedule = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("InventorySchedule");
    if (input.Frequency !== undefined && input.Frequency !== null) {
        var node = new (0, $iqrNg.XmlNode)("InventoryFrequency").addChildNode(new (0, $cm4u6.XmlText)(input.Frequency)).withName("Frequency");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlJSONInput = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("JSONInput");
    if (input.Type !== undefined && input.Type !== null) {
        var node = new (0, $iqrNg.XmlNode)("JSONType").addChildNode(new (0, $cm4u6.XmlText)(input.Type)).withName("Type");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlJSONOutput = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("JSONOutput");
    if (input.RecordDelimiter !== undefined && input.RecordDelimiter !== null) {
        var node = new (0, $iqrNg.XmlNode)("RecordDelimiter").addChildNode(new (0, $cm4u6.XmlText)(input.RecordDelimiter)).withName("RecordDelimiter");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlLambdaFunctionConfiguration = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("LambdaFunctionConfiguration");
    if (input.Id !== undefined && input.Id !== null) {
        var node = new (0, $iqrNg.XmlNode)("NotificationId").addChildNode(new (0, $cm4u6.XmlText)(input.Id)).withName("Id");
        bodyNode.addChildNode(node);
    }
    if (input.LambdaFunctionArn !== undefined && input.LambdaFunctionArn !== null) {
        var node = new (0, $iqrNg.XmlNode)("LambdaFunctionArn").addChildNode(new (0, $cm4u6.XmlText)(input.LambdaFunctionArn)).withName("CloudFunction");
        bodyNode.addChildNode(node);
    }
    if (input.Events !== undefined && input.Events !== null) {
        var nodes = $e0af51232e7b34d9$var$serializeAws_restXmlEventList(input.Events, context);
        nodes.map(function(node) {
            node = node.withName("Event");
            bodyNode.addChildNode(node);
        });
    }
    if (input.Filter !== undefined && input.Filter !== null) {
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlNotificationConfigurationFilter(input.Filter, context).withName("Filter");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlLambdaFunctionConfigurationList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlLambdaFunctionConfiguration(entry, context);
        return node.withName("member");
    });
};
var $e0af51232e7b34d9$var$serializeAws_restXmlLifecycleExpiration = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("LifecycleExpiration");
    if (input.Date !== undefined && input.Date !== null) {
        var node = new (0, $iqrNg.XmlNode)("Date").addChildNode(new (0, $cm4u6.XmlText)(input.Date.toISOString().split(".")[0] + "Z")).withName("Date");
        bodyNode.addChildNode(node);
    }
    if (input.Days !== undefined && input.Days !== null) {
        var node = new (0, $iqrNg.XmlNode)("Days").addChildNode(new (0, $cm4u6.XmlText)(String(input.Days))).withName("Days");
        bodyNode.addChildNode(node);
    }
    if (input.ExpiredObjectDeleteMarker !== undefined && input.ExpiredObjectDeleteMarker !== null) {
        var node = new (0, $iqrNg.XmlNode)("ExpiredObjectDeleteMarker").addChildNode(new (0, $cm4u6.XmlText)(String(input.ExpiredObjectDeleteMarker))).withName("ExpiredObjectDeleteMarker");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlLifecycleRule = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("LifecycleRule");
    if (input.Expiration !== undefined && input.Expiration !== null) {
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlLifecycleExpiration(input.Expiration, context).withName("Expiration");
        bodyNode.addChildNode(node);
    }
    if (input.ID !== undefined && input.ID !== null) {
        var node = new (0, $iqrNg.XmlNode)("ID").addChildNode(new (0, $cm4u6.XmlText)(input.ID)).withName("ID");
        bodyNode.addChildNode(node);
    }
    if (input.Prefix !== undefined && input.Prefix !== null) {
        var node = new (0, $iqrNg.XmlNode)("Prefix").addChildNode(new (0, $cm4u6.XmlText)(input.Prefix)).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    if (input.Filter !== undefined && input.Filter !== null) {
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlLifecycleRuleFilter(input.Filter, context).withName("Filter");
        bodyNode.addChildNode(node);
    }
    if (input.Status !== undefined && input.Status !== null) {
        var node = new (0, $iqrNg.XmlNode)("ExpirationStatus").addChildNode(new (0, $cm4u6.XmlText)(input.Status)).withName("Status");
        bodyNode.addChildNode(node);
    }
    if (input.Transitions !== undefined && input.Transitions !== null) {
        var nodes = $e0af51232e7b34d9$var$serializeAws_restXmlTransitionList(input.Transitions, context);
        nodes.map(function(node) {
            node = node.withName("Transition");
            bodyNode.addChildNode(node);
        });
    }
    if (input.NoncurrentVersionTransitions !== undefined && input.NoncurrentVersionTransitions !== null) {
        var nodes = $e0af51232e7b34d9$var$serializeAws_restXmlNoncurrentVersionTransitionList(input.NoncurrentVersionTransitions, context);
        nodes.map(function(node) {
            node = node.withName("NoncurrentVersionTransition");
            bodyNode.addChildNode(node);
        });
    }
    if (input.NoncurrentVersionExpiration !== undefined && input.NoncurrentVersionExpiration !== null) {
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlNoncurrentVersionExpiration(input.NoncurrentVersionExpiration, context).withName("NoncurrentVersionExpiration");
        bodyNode.addChildNode(node);
    }
    if (input.AbortIncompleteMultipartUpload !== undefined && input.AbortIncompleteMultipartUpload !== null) {
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlAbortIncompleteMultipartUpload(input.AbortIncompleteMultipartUpload, context).withName("AbortIncompleteMultipartUpload");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlLifecycleRuleAndOperator = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("LifecycleRuleAndOperator");
    if (input.Prefix !== undefined && input.Prefix !== null) {
        var node = new (0, $iqrNg.XmlNode)("Prefix").addChildNode(new (0, $cm4u6.XmlText)(input.Prefix)).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    if (input.Tags !== undefined && input.Tags !== null) {
        var nodes = $e0af51232e7b34d9$var$serializeAws_restXmlTagSet(input.Tags, context);
        nodes.map(function(node) {
            node = node.withName("Tag");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlLifecycleRuleFilter = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("LifecycleRuleFilter");
    (0, $g4BTM.LifecycleRuleFilter).visit(input, {
        Prefix: function(value) {
            var node = new (0, $iqrNg.XmlNode)("Prefix").addChildNode(new (0, $cm4u6.XmlText)(value)).withName("Prefix");
            bodyNode.addChildNode(node);
        },
        Tag: function(value) {
            var node = $e0af51232e7b34d9$var$serializeAws_restXmlTag(value, context).withName("Tag");
            bodyNode.addChildNode(node);
        },
        And: function(value) {
            var node = $e0af51232e7b34d9$var$serializeAws_restXmlLifecycleRuleAndOperator(value, context).withName("And");
            bodyNode.addChildNode(node);
        },
        _: function(name, value) {
            if (!(value instanceof (0, $iqrNg.XmlNode) || value instanceof (0, $cm4u6.XmlText))) throw new Error("Unable to serialize unknown union members in XML.");
            bodyNode.addChildNode(new (0, $iqrNg.XmlNode)(name).addChildNode(value));
        }
    });
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlLifecycleRules = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlLifecycleRule(entry, context);
        return node.withName("member");
    });
};
var $e0af51232e7b34d9$var$serializeAws_restXmlLoggingEnabled = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("LoggingEnabled");
    if (input.TargetBucket !== undefined && input.TargetBucket !== null) {
        var node = new (0, $iqrNg.XmlNode)("TargetBucket").addChildNode(new (0, $cm4u6.XmlText)(input.TargetBucket)).withName("TargetBucket");
        bodyNode.addChildNode(node);
    }
    if (input.TargetGrants !== undefined && input.TargetGrants !== null) {
        var nodes = $e0af51232e7b34d9$var$serializeAws_restXmlTargetGrants(input.TargetGrants, context);
        var containerNode_3 = new (0, $iqrNg.XmlNode)("TargetGrants");
        nodes.map(function(node) {
            containerNode_3.addChildNode(node);
        });
        bodyNode.addChildNode(containerNode_3);
    }
    if (input.TargetPrefix !== undefined && input.TargetPrefix !== null) {
        var node = new (0, $iqrNg.XmlNode)("TargetPrefix").addChildNode(new (0, $cm4u6.XmlText)(input.TargetPrefix)).withName("TargetPrefix");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlMetadataEntry = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("MetadataEntry");
    if (input.Name !== undefined && input.Name !== null) {
        var node = new (0, $iqrNg.XmlNode)("MetadataKey").addChildNode(new (0, $cm4u6.XmlText)(input.Name)).withName("Name");
        bodyNode.addChildNode(node);
    }
    if (input.Value !== undefined && input.Value !== null) {
        var node = new (0, $iqrNg.XmlNode)("MetadataValue").addChildNode(new (0, $cm4u6.XmlText)(input.Value)).withName("Value");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlMetrics = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("Metrics");
    if (input.Status !== undefined && input.Status !== null) {
        var node = new (0, $iqrNg.XmlNode)("MetricsStatus").addChildNode(new (0, $cm4u6.XmlText)(input.Status)).withName("Status");
        bodyNode.addChildNode(node);
    }
    if (input.EventThreshold !== undefined && input.EventThreshold !== null) {
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlReplicationTimeValue(input.EventThreshold, context).withName("EventThreshold");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlMetricsAndOperator = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("MetricsAndOperator");
    if (input.Prefix !== undefined && input.Prefix !== null) {
        var node = new (0, $iqrNg.XmlNode)("Prefix").addChildNode(new (0, $cm4u6.XmlText)(input.Prefix)).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    if (input.Tags !== undefined && input.Tags !== null) {
        var nodes = $e0af51232e7b34d9$var$serializeAws_restXmlTagSet(input.Tags, context);
        nodes.map(function(node) {
            node = node.withName("Tag");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlMetricsConfiguration = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("MetricsConfiguration");
    if (input.Id !== undefined && input.Id !== null) {
        var node = new (0, $iqrNg.XmlNode)("MetricsId").addChildNode(new (0, $cm4u6.XmlText)(input.Id)).withName("Id");
        bodyNode.addChildNode(node);
    }
    if (input.Filter !== undefined && input.Filter !== null) {
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlMetricsFilter(input.Filter, context).withName("Filter");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlMetricsFilter = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("MetricsFilter");
    (0, $g4BTM.MetricsFilter).visit(input, {
        Prefix: function(value) {
            var node = new (0, $iqrNg.XmlNode)("Prefix").addChildNode(new (0, $cm4u6.XmlText)(value)).withName("Prefix");
            bodyNode.addChildNode(node);
        },
        Tag: function(value) {
            var node = $e0af51232e7b34d9$var$serializeAws_restXmlTag(value, context).withName("Tag");
            bodyNode.addChildNode(node);
        },
        And: function(value) {
            var node = $e0af51232e7b34d9$var$serializeAws_restXmlMetricsAndOperator(value, context).withName("And");
            bodyNode.addChildNode(node);
        },
        _: function(name, value) {
            if (!(value instanceof (0, $iqrNg.XmlNode) || value instanceof (0, $cm4u6.XmlText))) throw new Error("Unable to serialize unknown union members in XML.");
            bodyNode.addChildNode(new (0, $iqrNg.XmlNode)(name).addChildNode(value));
        }
    });
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlNoncurrentVersionExpiration = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("NoncurrentVersionExpiration");
    if (input.NoncurrentDays !== undefined && input.NoncurrentDays !== null) {
        var node = new (0, $iqrNg.XmlNode)("Days").addChildNode(new (0, $cm4u6.XmlText)(String(input.NoncurrentDays))).withName("NoncurrentDays");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlNoncurrentVersionTransition = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("NoncurrentVersionTransition");
    if (input.NoncurrentDays !== undefined && input.NoncurrentDays !== null) {
        var node = new (0, $iqrNg.XmlNode)("Days").addChildNode(new (0, $cm4u6.XmlText)(String(input.NoncurrentDays))).withName("NoncurrentDays");
        bodyNode.addChildNode(node);
    }
    if (input.StorageClass !== undefined && input.StorageClass !== null) {
        var node = new (0, $iqrNg.XmlNode)("TransitionStorageClass").addChildNode(new (0, $cm4u6.XmlText)(input.StorageClass)).withName("StorageClass");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlNoncurrentVersionTransitionList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlNoncurrentVersionTransition(entry, context);
        return node.withName("member");
    });
};
var $e0af51232e7b34d9$var$serializeAws_restXmlNotificationConfiguration = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("NotificationConfiguration");
    if (input.TopicConfigurations !== undefined && input.TopicConfigurations !== null) {
        var nodes = $e0af51232e7b34d9$var$serializeAws_restXmlTopicConfigurationList(input.TopicConfigurations, context);
        nodes.map(function(node) {
            node = node.withName("TopicConfiguration");
            bodyNode.addChildNode(node);
        });
    }
    if (input.QueueConfigurations !== undefined && input.QueueConfigurations !== null) {
        var nodes = $e0af51232e7b34d9$var$serializeAws_restXmlQueueConfigurationList(input.QueueConfigurations, context);
        nodes.map(function(node) {
            node = node.withName("QueueConfiguration");
            bodyNode.addChildNode(node);
        });
    }
    if (input.LambdaFunctionConfigurations !== undefined && input.LambdaFunctionConfigurations !== null) {
        var nodes = $e0af51232e7b34d9$var$serializeAws_restXmlLambdaFunctionConfigurationList(input.LambdaFunctionConfigurations, context);
        nodes.map(function(node) {
            node = node.withName("CloudFunctionConfiguration");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlNotificationConfigurationFilter = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("NotificationConfigurationFilter");
    if (input.Key !== undefined && input.Key !== null) {
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlS3KeyFilter(input.Key, context).withName("S3Key");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlObjectIdentifier = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("ObjectIdentifier");
    if (input.Key !== undefined && input.Key !== null) {
        var node = new (0, $iqrNg.XmlNode)("ObjectKey").addChildNode(new (0, $cm4u6.XmlText)(input.Key)).withName("Key");
        bodyNode.addChildNode(node);
    }
    if (input.VersionId !== undefined && input.VersionId !== null) {
        var node = new (0, $iqrNg.XmlNode)("ObjectVersionId").addChildNode(new (0, $cm4u6.XmlText)(input.VersionId)).withName("VersionId");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlObjectIdentifierList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlObjectIdentifier(entry, context);
        return node.withName("member");
    });
};
var $e0af51232e7b34d9$var$serializeAws_restXmlObjectLockConfiguration = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("ObjectLockConfiguration");
    if (input.ObjectLockEnabled !== undefined && input.ObjectLockEnabled !== null) {
        var node = new (0, $iqrNg.XmlNode)("ObjectLockEnabled").addChildNode(new (0, $cm4u6.XmlText)(input.ObjectLockEnabled)).withName("ObjectLockEnabled");
        bodyNode.addChildNode(node);
    }
    if (input.Rule !== undefined && input.Rule !== null) {
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlObjectLockRule(input.Rule, context).withName("Rule");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlObjectLockLegalHold = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("ObjectLockLegalHold");
    if (input.Status !== undefined && input.Status !== null) {
        var node = new (0, $iqrNg.XmlNode)("ObjectLockLegalHoldStatus").addChildNode(new (0, $cm4u6.XmlText)(input.Status)).withName("Status");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlObjectLockRetention = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("ObjectLockRetention");
    if (input.Mode !== undefined && input.Mode !== null) {
        var node = new (0, $iqrNg.XmlNode)("ObjectLockRetentionMode").addChildNode(new (0, $cm4u6.XmlText)(input.Mode)).withName("Mode");
        bodyNode.addChildNode(node);
    }
    if (input.RetainUntilDate !== undefined && input.RetainUntilDate !== null) {
        var node = new (0, $iqrNg.XmlNode)("Date").addChildNode(new (0, $cm4u6.XmlText)(input.RetainUntilDate.toISOString().split(".")[0] + "Z")).withName("RetainUntilDate");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlObjectLockRule = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("ObjectLockRule");
    if (input.DefaultRetention !== undefined && input.DefaultRetention !== null) {
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlDefaultRetention(input.DefaultRetention, context).withName("DefaultRetention");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlOutputLocation = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("OutputLocation");
    if (input.S3 !== undefined && input.S3 !== null) {
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlS3Location(input.S3, context).withName("S3");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlOutputSerialization = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("OutputSerialization");
    if (input.CSV !== undefined && input.CSV !== null) {
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlCSVOutput(input.CSV, context).withName("CSV");
        bodyNode.addChildNode(node);
    }
    if (input.JSON !== undefined && input.JSON !== null) {
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlJSONOutput(input.JSON, context).withName("JSON");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlOwner = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("Owner");
    if (input.DisplayName !== undefined && input.DisplayName !== null) {
        var node = new (0, $iqrNg.XmlNode)("DisplayName").addChildNode(new (0, $cm4u6.XmlText)(input.DisplayName)).withName("DisplayName");
        bodyNode.addChildNode(node);
    }
    if (input.ID !== undefined && input.ID !== null) {
        var node = new (0, $iqrNg.XmlNode)("ID").addChildNode(new (0, $cm4u6.XmlText)(input.ID)).withName("ID");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlOwnershipControls = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("OwnershipControls");
    if (input.Rules !== undefined && input.Rules !== null) {
        var nodes = $e0af51232e7b34d9$var$serializeAws_restXmlOwnershipControlsRules(input.Rules, context);
        nodes.map(function(node) {
            node = node.withName("Rule");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlOwnershipControlsRule = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("OwnershipControlsRule");
    if (input.ObjectOwnership !== undefined && input.ObjectOwnership !== null) {
        var node = new (0, $iqrNg.XmlNode)("ObjectOwnership").addChildNode(new (0, $cm4u6.XmlText)(input.ObjectOwnership)).withName("ObjectOwnership");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlOwnershipControlsRules = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlOwnershipControlsRule(entry, context);
        return node.withName("member");
    });
};
var $e0af51232e7b34d9$var$serializeAws_restXmlParquetInput = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("ParquetInput");
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlPublicAccessBlockConfiguration = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("PublicAccessBlockConfiguration");
    if (input.BlockPublicAcls !== undefined && input.BlockPublicAcls !== null) {
        var node = new (0, $iqrNg.XmlNode)("Setting").addChildNode(new (0, $cm4u6.XmlText)(String(input.BlockPublicAcls))).withName("BlockPublicAcls");
        bodyNode.addChildNode(node);
    }
    if (input.IgnorePublicAcls !== undefined && input.IgnorePublicAcls !== null) {
        var node = new (0, $iqrNg.XmlNode)("Setting").addChildNode(new (0, $cm4u6.XmlText)(String(input.IgnorePublicAcls))).withName("IgnorePublicAcls");
        bodyNode.addChildNode(node);
    }
    if (input.BlockPublicPolicy !== undefined && input.BlockPublicPolicy !== null) {
        var node = new (0, $iqrNg.XmlNode)("Setting").addChildNode(new (0, $cm4u6.XmlText)(String(input.BlockPublicPolicy))).withName("BlockPublicPolicy");
        bodyNode.addChildNode(node);
    }
    if (input.RestrictPublicBuckets !== undefined && input.RestrictPublicBuckets !== null) {
        var node = new (0, $iqrNg.XmlNode)("Setting").addChildNode(new (0, $cm4u6.XmlText)(String(input.RestrictPublicBuckets))).withName("RestrictPublicBuckets");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlQueueConfiguration = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("QueueConfiguration");
    if (input.Id !== undefined && input.Id !== null) {
        var node = new (0, $iqrNg.XmlNode)("NotificationId").addChildNode(new (0, $cm4u6.XmlText)(input.Id)).withName("Id");
        bodyNode.addChildNode(node);
    }
    if (input.QueueArn !== undefined && input.QueueArn !== null) {
        var node = new (0, $iqrNg.XmlNode)("QueueArn").addChildNode(new (0, $cm4u6.XmlText)(input.QueueArn)).withName("Queue");
        bodyNode.addChildNode(node);
    }
    if (input.Events !== undefined && input.Events !== null) {
        var nodes = $e0af51232e7b34d9$var$serializeAws_restXmlEventList(input.Events, context);
        nodes.map(function(node) {
            node = node.withName("Event");
            bodyNode.addChildNode(node);
        });
    }
    if (input.Filter !== undefined && input.Filter !== null) {
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlNotificationConfigurationFilter(input.Filter, context).withName("Filter");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlQueueConfigurationList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlQueueConfiguration(entry, context);
        return node.withName("member");
    });
};
var $e0af51232e7b34d9$var$serializeAws_restXmlRedirect = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("Redirect");
    if (input.HostName !== undefined && input.HostName !== null) {
        var node = new (0, $iqrNg.XmlNode)("HostName").addChildNode(new (0, $cm4u6.XmlText)(input.HostName)).withName("HostName");
        bodyNode.addChildNode(node);
    }
    if (input.HttpRedirectCode !== undefined && input.HttpRedirectCode !== null) {
        var node = new (0, $iqrNg.XmlNode)("HttpRedirectCode").addChildNode(new (0, $cm4u6.XmlText)(input.HttpRedirectCode)).withName("HttpRedirectCode");
        bodyNode.addChildNode(node);
    }
    if (input.Protocol !== undefined && input.Protocol !== null) {
        var node = new (0, $iqrNg.XmlNode)("Protocol").addChildNode(new (0, $cm4u6.XmlText)(input.Protocol)).withName("Protocol");
        bodyNode.addChildNode(node);
    }
    if (input.ReplaceKeyPrefixWith !== undefined && input.ReplaceKeyPrefixWith !== null) {
        var node = new (0, $iqrNg.XmlNode)("ReplaceKeyPrefixWith").addChildNode(new (0, $cm4u6.XmlText)(input.ReplaceKeyPrefixWith)).withName("ReplaceKeyPrefixWith");
        bodyNode.addChildNode(node);
    }
    if (input.ReplaceKeyWith !== undefined && input.ReplaceKeyWith !== null) {
        var node = new (0, $iqrNg.XmlNode)("ReplaceKeyWith").addChildNode(new (0, $cm4u6.XmlText)(input.ReplaceKeyWith)).withName("ReplaceKeyWith");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlRedirectAllRequestsTo = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("RedirectAllRequestsTo");
    if (input.HostName !== undefined && input.HostName !== null) {
        var node = new (0, $iqrNg.XmlNode)("HostName").addChildNode(new (0, $cm4u6.XmlText)(input.HostName)).withName("HostName");
        bodyNode.addChildNode(node);
    }
    if (input.Protocol !== undefined && input.Protocol !== null) {
        var node = new (0, $iqrNg.XmlNode)("Protocol").addChildNode(new (0, $cm4u6.XmlText)(input.Protocol)).withName("Protocol");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlReplicaModifications = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("ReplicaModifications");
    if (input.Status !== undefined && input.Status !== null) {
        var node = new (0, $iqrNg.XmlNode)("ReplicaModificationsStatus").addChildNode(new (0, $cm4u6.XmlText)(input.Status)).withName("Status");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlReplicationConfiguration = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("ReplicationConfiguration");
    if (input.Role !== undefined && input.Role !== null) {
        var node = new (0, $iqrNg.XmlNode)("Role").addChildNode(new (0, $cm4u6.XmlText)(input.Role)).withName("Role");
        bodyNode.addChildNode(node);
    }
    if (input.Rules !== undefined && input.Rules !== null) {
        var nodes = $e0af51232e7b34d9$var$serializeAws_restXmlReplicationRules(input.Rules, context);
        nodes.map(function(node) {
            node = node.withName("Rule");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlReplicationRule = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("ReplicationRule");
    if (input.ID !== undefined && input.ID !== null) {
        var node = new (0, $iqrNg.XmlNode)("ID").addChildNode(new (0, $cm4u6.XmlText)(input.ID)).withName("ID");
        bodyNode.addChildNode(node);
    }
    if (input.Priority !== undefined && input.Priority !== null) {
        var node = new (0, $iqrNg.XmlNode)("Priority").addChildNode(new (0, $cm4u6.XmlText)(String(input.Priority))).withName("Priority");
        bodyNode.addChildNode(node);
    }
    if (input.Prefix !== undefined && input.Prefix !== null) {
        var node = new (0, $iqrNg.XmlNode)("Prefix").addChildNode(new (0, $cm4u6.XmlText)(input.Prefix)).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    if (input.Filter !== undefined && input.Filter !== null) {
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlReplicationRuleFilter(input.Filter, context).withName("Filter");
        bodyNode.addChildNode(node);
    }
    if (input.Status !== undefined && input.Status !== null) {
        var node = new (0, $iqrNg.XmlNode)("ReplicationRuleStatus").addChildNode(new (0, $cm4u6.XmlText)(input.Status)).withName("Status");
        bodyNode.addChildNode(node);
    }
    if (input.SourceSelectionCriteria !== undefined && input.SourceSelectionCriteria !== null) {
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlSourceSelectionCriteria(input.SourceSelectionCriteria, context).withName("SourceSelectionCriteria");
        bodyNode.addChildNode(node);
    }
    if (input.ExistingObjectReplication !== undefined && input.ExistingObjectReplication !== null) {
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlExistingObjectReplication(input.ExistingObjectReplication, context).withName("ExistingObjectReplication");
        bodyNode.addChildNode(node);
    }
    if (input.Destination !== undefined && input.Destination !== null) {
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlDestination(input.Destination, context).withName("Destination");
        bodyNode.addChildNode(node);
    }
    if (input.DeleteMarkerReplication !== undefined && input.DeleteMarkerReplication !== null) {
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlDeleteMarkerReplication(input.DeleteMarkerReplication, context).withName("DeleteMarkerReplication");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlReplicationRuleAndOperator = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("ReplicationRuleAndOperator");
    if (input.Prefix !== undefined && input.Prefix !== null) {
        var node = new (0, $iqrNg.XmlNode)("Prefix").addChildNode(new (0, $cm4u6.XmlText)(input.Prefix)).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    if (input.Tags !== undefined && input.Tags !== null) {
        var nodes = $e0af51232e7b34d9$var$serializeAws_restXmlTagSet(input.Tags, context);
        nodes.map(function(node) {
            node = node.withName("Tag");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlReplicationRuleFilter = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("ReplicationRuleFilter");
    (0, $g4BTM.ReplicationRuleFilter).visit(input, {
        Prefix: function(value) {
            var node = new (0, $iqrNg.XmlNode)("Prefix").addChildNode(new (0, $cm4u6.XmlText)(value)).withName("Prefix");
            bodyNode.addChildNode(node);
        },
        Tag: function(value) {
            var node = $e0af51232e7b34d9$var$serializeAws_restXmlTag(value, context).withName("Tag");
            bodyNode.addChildNode(node);
        },
        And: function(value) {
            var node = $e0af51232e7b34d9$var$serializeAws_restXmlReplicationRuleAndOperator(value, context).withName("And");
            bodyNode.addChildNode(node);
        },
        _: function(name, value) {
            if (!(value instanceof (0, $iqrNg.XmlNode) || value instanceof (0, $cm4u6.XmlText))) throw new Error("Unable to serialize unknown union members in XML.");
            bodyNode.addChildNode(new (0, $iqrNg.XmlNode)(name).addChildNode(value));
        }
    });
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlReplicationRules = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlReplicationRule(entry, context);
        return node.withName("member");
    });
};
var $e0af51232e7b34d9$var$serializeAws_restXmlReplicationTime = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("ReplicationTime");
    if (input.Status !== undefined && input.Status !== null) {
        var node = new (0, $iqrNg.XmlNode)("ReplicationTimeStatus").addChildNode(new (0, $cm4u6.XmlText)(input.Status)).withName("Status");
        bodyNode.addChildNode(node);
    }
    if (input.Time !== undefined && input.Time !== null) {
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlReplicationTimeValue(input.Time, context).withName("Time");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlReplicationTimeValue = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("ReplicationTimeValue");
    if (input.Minutes !== undefined && input.Minutes !== null) {
        var node = new (0, $iqrNg.XmlNode)("Minutes").addChildNode(new (0, $cm4u6.XmlText)(String(input.Minutes))).withName("Minutes");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlRequestPaymentConfiguration = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("RequestPaymentConfiguration");
    if (input.Payer !== undefined && input.Payer !== null) {
        var node = new (0, $iqrNg.XmlNode)("Payer").addChildNode(new (0, $cm4u6.XmlText)(input.Payer)).withName("Payer");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlRequestProgress = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("RequestProgress");
    if (input.Enabled !== undefined && input.Enabled !== null) {
        var node = new (0, $iqrNg.XmlNode)("EnableRequestProgress").addChildNode(new (0, $cm4u6.XmlText)(String(input.Enabled))).withName("Enabled");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlRestoreRequest = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("RestoreRequest");
    if (input.Days !== undefined && input.Days !== null) {
        var node = new (0, $iqrNg.XmlNode)("Days").addChildNode(new (0, $cm4u6.XmlText)(String(input.Days))).withName("Days");
        bodyNode.addChildNode(node);
    }
    if (input.GlacierJobParameters !== undefined && input.GlacierJobParameters !== null) {
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlGlacierJobParameters(input.GlacierJobParameters, context).withName("GlacierJobParameters");
        bodyNode.addChildNode(node);
    }
    if (input.Type !== undefined && input.Type !== null) {
        var node = new (0, $iqrNg.XmlNode)("RestoreRequestType").addChildNode(new (0, $cm4u6.XmlText)(input.Type)).withName("Type");
        bodyNode.addChildNode(node);
    }
    if (input.Tier !== undefined && input.Tier !== null) {
        var node = new (0, $iqrNg.XmlNode)("Tier").addChildNode(new (0, $cm4u6.XmlText)(input.Tier)).withName("Tier");
        bodyNode.addChildNode(node);
    }
    if (input.Description !== undefined && input.Description !== null) {
        var node = new (0, $iqrNg.XmlNode)("Description").addChildNode(new (0, $cm4u6.XmlText)(input.Description)).withName("Description");
        bodyNode.addChildNode(node);
    }
    if (input.SelectParameters !== undefined && input.SelectParameters !== null) {
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlSelectParameters(input.SelectParameters, context).withName("SelectParameters");
        bodyNode.addChildNode(node);
    }
    if (input.OutputLocation !== undefined && input.OutputLocation !== null) {
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlOutputLocation(input.OutputLocation, context).withName("OutputLocation");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlRoutingRule = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("RoutingRule");
    if (input.Condition !== undefined && input.Condition !== null) {
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlCondition(input.Condition, context).withName("Condition");
        bodyNode.addChildNode(node);
    }
    if (input.Redirect !== undefined && input.Redirect !== null) {
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlRedirect(input.Redirect, context).withName("Redirect");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlRoutingRules = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlRoutingRule(entry, context);
        return node.withName("RoutingRule");
    });
};
var $e0af51232e7b34d9$var$serializeAws_restXmlS3KeyFilter = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("S3KeyFilter");
    if (input.FilterRules !== undefined && input.FilterRules !== null) {
        var nodes = $e0af51232e7b34d9$var$serializeAws_restXmlFilterRuleList(input.FilterRules, context);
        nodes.map(function(node) {
            node = node.withName("FilterRule");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlS3Location = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("S3Location");
    if (input.BucketName !== undefined && input.BucketName !== null) {
        var node = new (0, $iqrNg.XmlNode)("BucketName").addChildNode(new (0, $cm4u6.XmlText)(input.BucketName)).withName("BucketName");
        bodyNode.addChildNode(node);
    }
    if (input.Prefix !== undefined && input.Prefix !== null) {
        var node = new (0, $iqrNg.XmlNode)("LocationPrefix").addChildNode(new (0, $cm4u6.XmlText)(input.Prefix)).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    if (input.Encryption !== undefined && input.Encryption !== null) {
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlEncryption(input.Encryption, context).withName("Encryption");
        bodyNode.addChildNode(node);
    }
    if (input.CannedACL !== undefined && input.CannedACL !== null) {
        var node = new (0, $iqrNg.XmlNode)("ObjectCannedACL").addChildNode(new (0, $cm4u6.XmlText)(input.CannedACL)).withName("CannedACL");
        bodyNode.addChildNode(node);
    }
    if (input.AccessControlList !== undefined && input.AccessControlList !== null) {
        var nodes = $e0af51232e7b34d9$var$serializeAws_restXmlGrants(input.AccessControlList, context);
        var containerNode_4 = new (0, $iqrNg.XmlNode)("AccessControlList");
        nodes.map(function(node) {
            containerNode_4.addChildNode(node);
        });
        bodyNode.addChildNode(containerNode_4);
    }
    if (input.Tagging !== undefined && input.Tagging !== null) {
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlTagging(input.Tagging, context).withName("Tagging");
        bodyNode.addChildNode(node);
    }
    if (input.UserMetadata !== undefined && input.UserMetadata !== null) {
        var nodes = $e0af51232e7b34d9$var$serializeAws_restXmlUserMetadata(input.UserMetadata, context);
        var containerNode_5 = new (0, $iqrNg.XmlNode)("UserMetadata");
        nodes.map(function(node) {
            containerNode_5.addChildNode(node);
        });
        bodyNode.addChildNode(containerNode_5);
    }
    if (input.StorageClass !== undefined && input.StorageClass !== null) {
        var node = new (0, $iqrNg.XmlNode)("StorageClass").addChildNode(new (0, $cm4u6.XmlText)(input.StorageClass)).withName("StorageClass");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlScanRange = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("ScanRange");
    if (input.Start !== undefined && input.Start !== null) {
        var node = new (0, $iqrNg.XmlNode)("Start").addChildNode(new (0, $cm4u6.XmlText)(String(input.Start))).withName("Start");
        bodyNode.addChildNode(node);
    }
    if (input.End !== undefined && input.End !== null) {
        var node = new (0, $iqrNg.XmlNode)("End").addChildNode(new (0, $cm4u6.XmlText)(String(input.End))).withName("End");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlSelectParameters = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("SelectParameters");
    if (input.InputSerialization !== undefined && input.InputSerialization !== null) {
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlInputSerialization(input.InputSerialization, context).withName("InputSerialization");
        bodyNode.addChildNode(node);
    }
    if (input.ExpressionType !== undefined && input.ExpressionType !== null) {
        var node = new (0, $iqrNg.XmlNode)("ExpressionType").addChildNode(new (0, $cm4u6.XmlText)(input.ExpressionType)).withName("ExpressionType");
        bodyNode.addChildNode(node);
    }
    if (input.Expression !== undefined && input.Expression !== null) {
        var node = new (0, $iqrNg.XmlNode)("Expression").addChildNode(new (0, $cm4u6.XmlText)(input.Expression)).withName("Expression");
        bodyNode.addChildNode(node);
    }
    if (input.OutputSerialization !== undefined && input.OutputSerialization !== null) {
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlOutputSerialization(input.OutputSerialization, context).withName("OutputSerialization");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlServerSideEncryptionByDefault = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("ServerSideEncryptionByDefault");
    if (input.SSEAlgorithm !== undefined && input.SSEAlgorithm !== null) {
        var node = new (0, $iqrNg.XmlNode)("ServerSideEncryption").addChildNode(new (0, $cm4u6.XmlText)(input.SSEAlgorithm)).withName("SSEAlgorithm");
        bodyNode.addChildNode(node);
    }
    if (input.KMSMasterKeyID !== undefined && input.KMSMasterKeyID !== null) {
        var node = new (0, $iqrNg.XmlNode)("SSEKMSKeyId").addChildNode(new (0, $cm4u6.XmlText)(input.KMSMasterKeyID)).withName("KMSMasterKeyID");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlServerSideEncryptionConfiguration = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("ServerSideEncryptionConfiguration");
    if (input.Rules !== undefined && input.Rules !== null) {
        var nodes = $e0af51232e7b34d9$var$serializeAws_restXmlServerSideEncryptionRules(input.Rules, context);
        nodes.map(function(node) {
            node = node.withName("Rule");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlServerSideEncryptionRule = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("ServerSideEncryptionRule");
    if (input.ApplyServerSideEncryptionByDefault !== undefined && input.ApplyServerSideEncryptionByDefault !== null) {
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlServerSideEncryptionByDefault(input.ApplyServerSideEncryptionByDefault, context).withName("ApplyServerSideEncryptionByDefault");
        bodyNode.addChildNode(node);
    }
    if (input.BucketKeyEnabled !== undefined && input.BucketKeyEnabled !== null) {
        var node = new (0, $iqrNg.XmlNode)("BucketKeyEnabled").addChildNode(new (0, $cm4u6.XmlText)(String(input.BucketKeyEnabled))).withName("BucketKeyEnabled");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlServerSideEncryptionRules = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlServerSideEncryptionRule(entry, context);
        return node.withName("member");
    });
};
var $e0af51232e7b34d9$var$serializeAws_restXmlSourceSelectionCriteria = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("SourceSelectionCriteria");
    if (input.SseKmsEncryptedObjects !== undefined && input.SseKmsEncryptedObjects !== null) {
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlSseKmsEncryptedObjects(input.SseKmsEncryptedObjects, context).withName("SseKmsEncryptedObjects");
        bodyNode.addChildNode(node);
    }
    if (input.ReplicaModifications !== undefined && input.ReplicaModifications !== null) {
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlReplicaModifications(input.ReplicaModifications, context).withName("ReplicaModifications");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlSSEKMS = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("SSE-KMS");
    if (input.KeyId !== undefined && input.KeyId !== null) {
        var node = new (0, $iqrNg.XmlNode)("SSEKMSKeyId").addChildNode(new (0, $cm4u6.XmlText)(input.KeyId)).withName("KeyId");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlSseKmsEncryptedObjects = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("SseKmsEncryptedObjects");
    if (input.Status !== undefined && input.Status !== null) {
        var node = new (0, $iqrNg.XmlNode)("SseKmsEncryptedObjectsStatus").addChildNode(new (0, $cm4u6.XmlText)(input.Status)).withName("Status");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlSSES3 = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("SSE-S3");
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlStorageClassAnalysis = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("StorageClassAnalysis");
    if (input.DataExport !== undefined && input.DataExport !== null) {
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlStorageClassAnalysisDataExport(input.DataExport, context).withName("DataExport");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlStorageClassAnalysisDataExport = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("StorageClassAnalysisDataExport");
    if (input.OutputSchemaVersion !== undefined && input.OutputSchemaVersion !== null) {
        var node = new (0, $iqrNg.XmlNode)("StorageClassAnalysisSchemaVersion").addChildNode(new (0, $cm4u6.XmlText)(input.OutputSchemaVersion)).withName("OutputSchemaVersion");
        bodyNode.addChildNode(node);
    }
    if (input.Destination !== undefined && input.Destination !== null) {
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlAnalyticsExportDestination(input.Destination, context).withName("Destination");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlTag = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("Tag");
    if (input.Key !== undefined && input.Key !== null) {
        var node = new (0, $iqrNg.XmlNode)("ObjectKey").addChildNode(new (0, $cm4u6.XmlText)(input.Key)).withName("Key");
        bodyNode.addChildNode(node);
    }
    if (input.Value !== undefined && input.Value !== null) {
        var node = new (0, $iqrNg.XmlNode)("Value").addChildNode(new (0, $cm4u6.XmlText)(input.Value)).withName("Value");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlTagging = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("Tagging");
    if (input.TagSet !== undefined && input.TagSet !== null) {
        var nodes = $e0af51232e7b34d9$var$serializeAws_restXmlTagSet(input.TagSet, context);
        var containerNode_6 = new (0, $iqrNg.XmlNode)("TagSet");
        nodes.map(function(node) {
            containerNode_6.addChildNode(node);
        });
        bodyNode.addChildNode(containerNode_6);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlTagSet = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlTag(entry, context);
        return node.withName("Tag");
    });
};
var $e0af51232e7b34d9$var$serializeAws_restXmlTargetGrant = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("TargetGrant");
    if (input.Grantee !== undefined && input.Grantee !== null) {
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlGrantee(input.Grantee, context).withName("Grantee");
        bodyNode.addChildNode(node);
    }
    if (input.Permission !== undefined && input.Permission !== null) {
        var node = new (0, $iqrNg.XmlNode)("BucketLogsPermission").addChildNode(new (0, $cm4u6.XmlText)(input.Permission)).withName("Permission");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlTargetGrants = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlTargetGrant(entry, context);
        return node.withName("Grant");
    });
};
var $e0af51232e7b34d9$var$serializeAws_restXmlTiering = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("Tiering");
    if (input.Days !== undefined && input.Days !== null) {
        var node = new (0, $iqrNg.XmlNode)("IntelligentTieringDays").addChildNode(new (0, $cm4u6.XmlText)(String(input.Days))).withName("Days");
        bodyNode.addChildNode(node);
    }
    if (input.AccessTier !== undefined && input.AccessTier !== null) {
        var node = new (0, $iqrNg.XmlNode)("IntelligentTieringAccessTier").addChildNode(new (0, $cm4u6.XmlText)(input.AccessTier)).withName("AccessTier");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlTieringList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlTiering(entry, context);
        return node.withName("member");
    });
};
var $e0af51232e7b34d9$var$serializeAws_restXmlTopicConfiguration = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("TopicConfiguration");
    if (input.Id !== undefined && input.Id !== null) {
        var node = new (0, $iqrNg.XmlNode)("NotificationId").addChildNode(new (0, $cm4u6.XmlText)(input.Id)).withName("Id");
        bodyNode.addChildNode(node);
    }
    if (input.TopicArn !== undefined && input.TopicArn !== null) {
        var node = new (0, $iqrNg.XmlNode)("TopicArn").addChildNode(new (0, $cm4u6.XmlText)(input.TopicArn)).withName("Topic");
        bodyNode.addChildNode(node);
    }
    if (input.Events !== undefined && input.Events !== null) {
        var nodes = $e0af51232e7b34d9$var$serializeAws_restXmlEventList(input.Events, context);
        nodes.map(function(node) {
            node = node.withName("Event");
            bodyNode.addChildNode(node);
        });
    }
    if (input.Filter !== undefined && input.Filter !== null) {
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlNotificationConfigurationFilter(input.Filter, context).withName("Filter");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlTopicConfigurationList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlTopicConfiguration(entry, context);
        return node.withName("member");
    });
};
var $e0af51232e7b34d9$var$serializeAws_restXmlTransition = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("Transition");
    if (input.Date !== undefined && input.Date !== null) {
        var node = new (0, $iqrNg.XmlNode)("Date").addChildNode(new (0, $cm4u6.XmlText)(input.Date.toISOString().split(".")[0] + "Z")).withName("Date");
        bodyNode.addChildNode(node);
    }
    if (input.Days !== undefined && input.Days !== null) {
        var node = new (0, $iqrNg.XmlNode)("Days").addChildNode(new (0, $cm4u6.XmlText)(String(input.Days))).withName("Days");
        bodyNode.addChildNode(node);
    }
    if (input.StorageClass !== undefined && input.StorageClass !== null) {
        var node = new (0, $iqrNg.XmlNode)("TransitionStorageClass").addChildNode(new (0, $cm4u6.XmlText)(input.StorageClass)).withName("StorageClass");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlTransitionList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlTransition(entry, context);
        return node.withName("member");
    });
};
var $e0af51232e7b34d9$var$serializeAws_restXmlUserMetadata = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlMetadataEntry(entry, context);
        return node.withName("MetadataEntry");
    });
};
var $e0af51232e7b34d9$var$serializeAws_restXmlVersioningConfiguration = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("VersioningConfiguration");
    if (input.MFADelete !== undefined && input.MFADelete !== null) {
        var node = new (0, $iqrNg.XmlNode)("MFADelete").addChildNode(new (0, $cm4u6.XmlText)(input.MFADelete)).withName("MfaDelete");
        bodyNode.addChildNode(node);
    }
    if (input.Status !== undefined && input.Status !== null) {
        var node = new (0, $iqrNg.XmlNode)("BucketVersioningStatus").addChildNode(new (0, $cm4u6.XmlText)(input.Status)).withName("Status");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$serializeAws_restXmlWebsiteConfiguration = function(input, context) {
    var bodyNode = new (0, $iqrNg.XmlNode)("WebsiteConfiguration");
    if (input.ErrorDocument !== undefined && input.ErrorDocument !== null) {
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlErrorDocument(input.ErrorDocument, context).withName("ErrorDocument");
        bodyNode.addChildNode(node);
    }
    if (input.IndexDocument !== undefined && input.IndexDocument !== null) {
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlIndexDocument(input.IndexDocument, context).withName("IndexDocument");
        bodyNode.addChildNode(node);
    }
    if (input.RedirectAllRequestsTo !== undefined && input.RedirectAllRequestsTo !== null) {
        var node = $e0af51232e7b34d9$var$serializeAws_restXmlRedirectAllRequestsTo(input.RedirectAllRequestsTo, context).withName("RedirectAllRequestsTo");
        bodyNode.addChildNode(node);
    }
    if (input.RoutingRules !== undefined && input.RoutingRules !== null) {
        var nodes = $e0af51232e7b34d9$var$serializeAws_restXmlRoutingRules(input.RoutingRules, context);
        var containerNode_7 = new (0, $iqrNg.XmlNode)("RoutingRules");
        nodes.map(function(node) {
            containerNode_7.addChildNode(node);
        });
        bodyNode.addChildNode(containerNode_7);
    }
    return bodyNode;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlAbortIncompleteMultipartUpload = function(output, context) {
    var contents = {
        DaysAfterInitiation: undefined
    };
    if (output["DaysAfterInitiation"] !== undefined) contents.DaysAfterInitiation = parseInt(output["DaysAfterInitiation"]);
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlAccessControlTranslation = function(output, context) {
    var contents = {
        Owner: undefined
    };
    if (output["Owner"] !== undefined) contents.Owner = output["Owner"];
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlAllowedHeaders = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlAllowedMethods = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlAllowedOrigins = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlAnalyticsAndOperator = function(output, context) {
    var contents = {
        Prefix: undefined,
        Tags: undefined
    };
    if (output["Prefix"] !== undefined) contents.Prefix = output["Prefix"];
    if (output.Tag === "") contents.Tags = [];
    if (output["Tag"] !== undefined) contents.Tags = $e0af51232e7b34d9$var$deserializeAws_restXmlTagSet((0, $bgM88.getArrayIfSingleItem)(output["Tag"]), context);
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlAnalyticsConfiguration = function(output, context) {
    var contents = {
        Id: undefined,
        Filter: undefined,
        StorageClassAnalysis: undefined
    };
    if (output["Id"] !== undefined) contents.Id = output["Id"];
    if (output["Filter"] !== undefined) contents.Filter = $e0af51232e7b34d9$var$deserializeAws_restXmlAnalyticsFilter(output["Filter"], context);
    if (output["StorageClassAnalysis"] !== undefined) contents.StorageClassAnalysis = $e0af51232e7b34d9$var$deserializeAws_restXmlStorageClassAnalysis(output["StorageClassAnalysis"], context);
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlAnalyticsConfigurationList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $e0af51232e7b34d9$var$deserializeAws_restXmlAnalyticsConfiguration(entry, context);
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlAnalyticsExportDestination = function(output, context) {
    var contents = {
        S3BucketDestination: undefined
    };
    if (output["S3BucketDestination"] !== undefined) contents.S3BucketDestination = $e0af51232e7b34d9$var$deserializeAws_restXmlAnalyticsS3BucketDestination(output["S3BucketDestination"], context);
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlAnalyticsFilter = function(output, context) {
    if (output["Prefix"] !== undefined) return {
        Prefix: output["Prefix"]
    };
    if (output["Tag"] !== undefined) return {
        Tag: $e0af51232e7b34d9$var$deserializeAws_restXmlTag(output["Tag"], context)
    };
    if (output["And"] !== undefined) return {
        And: $e0af51232e7b34d9$var$deserializeAws_restXmlAnalyticsAndOperator(output["And"], context)
    };
    return {
        $unknown: Object.entries(output)[0]
    };
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlAnalyticsS3BucketDestination = function(output, context) {
    var contents = {
        Format: undefined,
        BucketAccountId: undefined,
        Bucket: undefined,
        Prefix: undefined
    };
    if (output["Format"] !== undefined) contents.Format = output["Format"];
    if (output["BucketAccountId"] !== undefined) contents.BucketAccountId = output["BucketAccountId"];
    if (output["Bucket"] !== undefined) contents.Bucket = output["Bucket"];
    if (output["Prefix"] !== undefined) contents.Prefix = output["Prefix"];
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlBucket = function(output, context) {
    var contents = {
        Name: undefined,
        CreationDate: undefined
    };
    if (output["Name"] !== undefined) contents.Name = output["Name"];
    if (output["CreationDate"] !== undefined) contents.CreationDate = new Date(output["CreationDate"]);
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlBuckets = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $e0af51232e7b34d9$var$deserializeAws_restXmlBucket(entry, context);
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlCommonPrefix = function(output, context) {
    var contents = {
        Prefix: undefined
    };
    if (output["Prefix"] !== undefined) contents.Prefix = output["Prefix"];
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlCommonPrefixList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $e0af51232e7b34d9$var$deserializeAws_restXmlCommonPrefix(entry, context);
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlCondition = function(output, context) {
    var contents = {
        HttpErrorCodeReturnedEquals: undefined,
        KeyPrefixEquals: undefined
    };
    if (output["HttpErrorCodeReturnedEquals"] !== undefined) contents.HttpErrorCodeReturnedEquals = output["HttpErrorCodeReturnedEquals"];
    if (output["KeyPrefixEquals"] !== undefined) contents.KeyPrefixEquals = output["KeyPrefixEquals"];
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlCopyObjectResult = function(output, context) {
    var contents = {
        ETag: undefined,
        LastModified: undefined
    };
    if (output["ETag"] !== undefined) contents.ETag = output["ETag"];
    if (output["LastModified"] !== undefined) contents.LastModified = new Date(output["LastModified"]);
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlCopyPartResult = function(output, context) {
    var contents = {
        ETag: undefined,
        LastModified: undefined
    };
    if (output["ETag"] !== undefined) contents.ETag = output["ETag"];
    if (output["LastModified"] !== undefined) contents.LastModified = new Date(output["LastModified"]);
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlCORSRule = function(output, context) {
    var contents = {
        AllowedHeaders: undefined,
        AllowedMethods: undefined,
        AllowedOrigins: undefined,
        ExposeHeaders: undefined,
        MaxAgeSeconds: undefined
    };
    if (output.AllowedHeader === "") contents.AllowedHeaders = [];
    if (output["AllowedHeader"] !== undefined) contents.AllowedHeaders = $e0af51232e7b34d9$var$deserializeAws_restXmlAllowedHeaders((0, $bgM88.getArrayIfSingleItem)(output["AllowedHeader"]), context);
    if (output.AllowedMethod === "") contents.AllowedMethods = [];
    if (output["AllowedMethod"] !== undefined) contents.AllowedMethods = $e0af51232e7b34d9$var$deserializeAws_restXmlAllowedMethods((0, $bgM88.getArrayIfSingleItem)(output["AllowedMethod"]), context);
    if (output.AllowedOrigin === "") contents.AllowedOrigins = [];
    if (output["AllowedOrigin"] !== undefined) contents.AllowedOrigins = $e0af51232e7b34d9$var$deserializeAws_restXmlAllowedOrigins((0, $bgM88.getArrayIfSingleItem)(output["AllowedOrigin"]), context);
    if (output.ExposeHeader === "") contents.ExposeHeaders = [];
    if (output["ExposeHeader"] !== undefined) contents.ExposeHeaders = $e0af51232e7b34d9$var$deserializeAws_restXmlExposeHeaders((0, $bgM88.getArrayIfSingleItem)(output["ExposeHeader"]), context);
    if (output["MaxAgeSeconds"] !== undefined) contents.MaxAgeSeconds = parseInt(output["MaxAgeSeconds"]);
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlCORSRules = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $e0af51232e7b34d9$var$deserializeAws_restXmlCORSRule(entry, context);
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlDefaultRetention = function(output, context) {
    var contents = {
        Mode: undefined,
        Days: undefined,
        Years: undefined
    };
    if (output["Mode"] !== undefined) contents.Mode = output["Mode"];
    if (output["Days"] !== undefined) contents.Days = parseInt(output["Days"]);
    if (output["Years"] !== undefined) contents.Years = parseInt(output["Years"]);
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlDeletedObject = function(output, context) {
    var contents = {
        Key: undefined,
        VersionId: undefined,
        DeleteMarker: undefined,
        DeleteMarkerVersionId: undefined
    };
    if (output["Key"] !== undefined) contents.Key = output["Key"];
    if (output["VersionId"] !== undefined) contents.VersionId = output["VersionId"];
    if (output["DeleteMarker"] !== undefined) contents.DeleteMarker = output["DeleteMarker"] == "true";
    if (output["DeleteMarkerVersionId"] !== undefined) contents.DeleteMarkerVersionId = output["DeleteMarkerVersionId"];
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlDeletedObjects = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $e0af51232e7b34d9$var$deserializeAws_restXmlDeletedObject(entry, context);
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlDeleteMarkerEntry = function(output, context) {
    var contents = {
        Owner: undefined,
        Key: undefined,
        VersionId: undefined,
        IsLatest: undefined,
        LastModified: undefined
    };
    if (output["Owner"] !== undefined) contents.Owner = $e0af51232e7b34d9$var$deserializeAws_restXmlOwner(output["Owner"], context);
    if (output["Key"] !== undefined) contents.Key = output["Key"];
    if (output["VersionId"] !== undefined) contents.VersionId = output["VersionId"];
    if (output["IsLatest"] !== undefined) contents.IsLatest = output["IsLatest"] == "true";
    if (output["LastModified"] !== undefined) contents.LastModified = new Date(output["LastModified"]);
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlDeleteMarkerReplication = function(output, context) {
    var contents = {
        Status: undefined
    };
    if (output["Status"] !== undefined) contents.Status = output["Status"];
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlDeleteMarkers = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $e0af51232e7b34d9$var$deserializeAws_restXmlDeleteMarkerEntry(entry, context);
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlDestination = function(output, context) {
    var contents = {
        Bucket: undefined,
        Account: undefined,
        StorageClass: undefined,
        AccessControlTranslation: undefined,
        EncryptionConfiguration: undefined,
        ReplicationTime: undefined,
        Metrics: undefined
    };
    if (output["Bucket"] !== undefined) contents.Bucket = output["Bucket"];
    if (output["Account"] !== undefined) contents.Account = output["Account"];
    if (output["StorageClass"] !== undefined) contents.StorageClass = output["StorageClass"];
    if (output["AccessControlTranslation"] !== undefined) contents.AccessControlTranslation = $e0af51232e7b34d9$var$deserializeAws_restXmlAccessControlTranslation(output["AccessControlTranslation"], context);
    if (output["EncryptionConfiguration"] !== undefined) contents.EncryptionConfiguration = $e0af51232e7b34d9$var$deserializeAws_restXmlEncryptionConfiguration(output["EncryptionConfiguration"], context);
    if (output["ReplicationTime"] !== undefined) contents.ReplicationTime = $e0af51232e7b34d9$var$deserializeAws_restXmlReplicationTime(output["ReplicationTime"], context);
    if (output["Metrics"] !== undefined) contents.Metrics = $e0af51232e7b34d9$var$deserializeAws_restXmlMetrics(output["Metrics"], context);
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlEncryptionConfiguration = function(output, context) {
    var contents = {
        ReplicaKmsKeyID: undefined
    };
    if (output["ReplicaKmsKeyID"] !== undefined) contents.ReplicaKmsKeyID = output["ReplicaKmsKeyID"];
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXml_Error = function(output, context) {
    var contents = {
        Key: undefined,
        VersionId: undefined,
        Code: undefined,
        Message: undefined
    };
    if (output["Key"] !== undefined) contents.Key = output["Key"];
    if (output["VersionId"] !== undefined) contents.VersionId = output["VersionId"];
    if (output["Code"] !== undefined) contents.Code = output["Code"];
    if (output["Message"] !== undefined) contents.Message = output["Message"];
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlErrorDocument = function(output, context) {
    var contents = {
        Key: undefined
    };
    if (output["Key"] !== undefined) contents.Key = output["Key"];
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlErrors = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $e0af51232e7b34d9$var$deserializeAws_restXml_Error(entry, context);
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlEventList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlExistingObjectReplication = function(output, context) {
    var contents = {
        Status: undefined
    };
    if (output["Status"] !== undefined) contents.Status = output["Status"];
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlExposeHeaders = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlFilterRule = function(output, context) {
    var contents = {
        Name: undefined,
        Value: undefined
    };
    if (output["Name"] !== undefined) contents.Name = output["Name"];
    if (output["Value"] !== undefined) contents.Value = output["Value"];
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlFilterRuleList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $e0af51232e7b34d9$var$deserializeAws_restXmlFilterRule(entry, context);
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlGrant = function(output, context) {
    var contents = {
        Grantee: undefined,
        Permission: undefined
    };
    if (output["Grantee"] !== undefined) contents.Grantee = $e0af51232e7b34d9$var$deserializeAws_restXmlGrantee(output["Grantee"], context);
    if (output["Permission"] !== undefined) contents.Permission = output["Permission"];
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlGrantee = function(output, context) {
    var contents = {
        DisplayName: undefined,
        EmailAddress: undefined,
        ID: undefined,
        URI: undefined,
        Type: undefined
    };
    if (output["DisplayName"] !== undefined) contents.DisplayName = output["DisplayName"];
    if (output["EmailAddress"] !== undefined) contents.EmailAddress = output["EmailAddress"];
    if (output["ID"] !== undefined) contents.ID = output["ID"];
    if (output["URI"] !== undefined) contents.URI = output["URI"];
    if (output["xsi:type"] !== undefined) contents.Type = output["xsi:type"];
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlGrants = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $e0af51232e7b34d9$var$deserializeAws_restXmlGrant(entry, context);
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlIndexDocument = function(output, context) {
    var contents = {
        Suffix: undefined
    };
    if (output["Suffix"] !== undefined) contents.Suffix = output["Suffix"];
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlInitiator = function(output, context) {
    var contents = {
        ID: undefined,
        DisplayName: undefined
    };
    if (output["ID"] !== undefined) contents.ID = output["ID"];
    if (output["DisplayName"] !== undefined) contents.DisplayName = output["DisplayName"];
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlIntelligentTieringAndOperator = function(output, context) {
    var contents = {
        Prefix: undefined,
        Tags: undefined
    };
    if (output["Prefix"] !== undefined) contents.Prefix = output["Prefix"];
    if (output.Tag === "") contents.Tags = [];
    if (output["Tag"] !== undefined) contents.Tags = $e0af51232e7b34d9$var$deserializeAws_restXmlTagSet((0, $bgM88.getArrayIfSingleItem)(output["Tag"]), context);
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlIntelligentTieringConfiguration = function(output, context) {
    var contents = {
        Id: undefined,
        Filter: undefined,
        Status: undefined,
        Tierings: undefined
    };
    if (output["Id"] !== undefined) contents.Id = output["Id"];
    if (output["Filter"] !== undefined) contents.Filter = $e0af51232e7b34d9$var$deserializeAws_restXmlIntelligentTieringFilter(output["Filter"], context);
    if (output["Status"] !== undefined) contents.Status = output["Status"];
    if (output.Tiering === "") contents.Tierings = [];
    if (output["Tiering"] !== undefined) contents.Tierings = $e0af51232e7b34d9$var$deserializeAws_restXmlTieringList((0, $bgM88.getArrayIfSingleItem)(output["Tiering"]), context);
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlIntelligentTieringConfigurationList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $e0af51232e7b34d9$var$deserializeAws_restXmlIntelligentTieringConfiguration(entry, context);
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlIntelligentTieringFilter = function(output, context) {
    var contents = {
        Prefix: undefined,
        Tag: undefined,
        And: undefined
    };
    if (output["Prefix"] !== undefined) contents.Prefix = output["Prefix"];
    if (output["Tag"] !== undefined) contents.Tag = $e0af51232e7b34d9$var$deserializeAws_restXmlTag(output["Tag"], context);
    if (output["And"] !== undefined) contents.And = $e0af51232e7b34d9$var$deserializeAws_restXmlIntelligentTieringAndOperator(output["And"], context);
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlInventoryConfiguration = function(output, context) {
    var contents = {
        Destination: undefined,
        IsEnabled: undefined,
        Filter: undefined,
        Id: undefined,
        IncludedObjectVersions: undefined,
        OptionalFields: undefined,
        Schedule: undefined
    };
    if (output["Destination"] !== undefined) contents.Destination = $e0af51232e7b34d9$var$deserializeAws_restXmlInventoryDestination(output["Destination"], context);
    if (output["IsEnabled"] !== undefined) contents.IsEnabled = output["IsEnabled"] == "true";
    if (output["Filter"] !== undefined) contents.Filter = $e0af51232e7b34d9$var$deserializeAws_restXmlInventoryFilter(output["Filter"], context);
    if (output["Id"] !== undefined) contents.Id = output["Id"];
    if (output["IncludedObjectVersions"] !== undefined) contents.IncludedObjectVersions = output["IncludedObjectVersions"];
    if (output.OptionalFields === "") contents.OptionalFields = [];
    if (output["OptionalFields"] !== undefined && output["OptionalFields"]["Field"] !== undefined) contents.OptionalFields = $e0af51232e7b34d9$var$deserializeAws_restXmlInventoryOptionalFields((0, $bgM88.getArrayIfSingleItem)(output["OptionalFields"]["Field"]), context);
    if (output["Schedule"] !== undefined) contents.Schedule = $e0af51232e7b34d9$var$deserializeAws_restXmlInventorySchedule(output["Schedule"], context);
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlInventoryConfigurationList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $e0af51232e7b34d9$var$deserializeAws_restXmlInventoryConfiguration(entry, context);
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlInventoryDestination = function(output, context) {
    var contents = {
        S3BucketDestination: undefined
    };
    if (output["S3BucketDestination"] !== undefined) contents.S3BucketDestination = $e0af51232e7b34d9$var$deserializeAws_restXmlInventoryS3BucketDestination(output["S3BucketDestination"], context);
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlInventoryEncryption = function(output, context) {
    var contents = {
        SSES3: undefined,
        SSEKMS: undefined
    };
    if (output["SSE-S3"] !== undefined) contents.SSES3 = $e0af51232e7b34d9$var$deserializeAws_restXmlSSES3(output["SSE-S3"], context);
    if (output["SSE-KMS"] !== undefined) contents.SSEKMS = $e0af51232e7b34d9$var$deserializeAws_restXmlSSEKMS(output["SSE-KMS"], context);
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlInventoryFilter = function(output, context) {
    var contents = {
        Prefix: undefined
    };
    if (output["Prefix"] !== undefined) contents.Prefix = output["Prefix"];
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlInventoryOptionalFields = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlInventoryS3BucketDestination = function(output, context) {
    var contents = {
        AccountId: undefined,
        Bucket: undefined,
        Format: undefined,
        Prefix: undefined,
        Encryption: undefined
    };
    if (output["AccountId"] !== undefined) contents.AccountId = output["AccountId"];
    if (output["Bucket"] !== undefined) contents.Bucket = output["Bucket"];
    if (output["Format"] !== undefined) contents.Format = output["Format"];
    if (output["Prefix"] !== undefined) contents.Prefix = output["Prefix"];
    if (output["Encryption"] !== undefined) contents.Encryption = $e0af51232e7b34d9$var$deserializeAws_restXmlInventoryEncryption(output["Encryption"], context);
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlInventorySchedule = function(output, context) {
    var contents = {
        Frequency: undefined
    };
    if (output["Frequency"] !== undefined) contents.Frequency = output["Frequency"];
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlLambdaFunctionConfiguration = function(output, context) {
    var contents = {
        Id: undefined,
        LambdaFunctionArn: undefined,
        Events: undefined,
        Filter: undefined
    };
    if (output["Id"] !== undefined) contents.Id = output["Id"];
    if (output["CloudFunction"] !== undefined) contents.LambdaFunctionArn = output["CloudFunction"];
    if (output.Event === "") contents.Events = [];
    if (output["Event"] !== undefined) contents.Events = $e0af51232e7b34d9$var$deserializeAws_restXmlEventList((0, $bgM88.getArrayIfSingleItem)(output["Event"]), context);
    if (output["Filter"] !== undefined) contents.Filter = $e0af51232e7b34d9$var$deserializeAws_restXmlNotificationConfigurationFilter(output["Filter"], context);
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlLambdaFunctionConfigurationList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $e0af51232e7b34d9$var$deserializeAws_restXmlLambdaFunctionConfiguration(entry, context);
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlLifecycleExpiration = function(output, context) {
    var contents = {
        Date: undefined,
        Days: undefined,
        ExpiredObjectDeleteMarker: undefined
    };
    if (output["Date"] !== undefined) contents.Date = new Date(output["Date"]);
    if (output["Days"] !== undefined) contents.Days = parseInt(output["Days"]);
    if (output["ExpiredObjectDeleteMarker"] !== undefined) contents.ExpiredObjectDeleteMarker = output["ExpiredObjectDeleteMarker"] == "true";
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlLifecycleRule = function(output, context) {
    var contents = {
        Expiration: undefined,
        ID: undefined,
        Prefix: undefined,
        Filter: undefined,
        Status: undefined,
        Transitions: undefined,
        NoncurrentVersionTransitions: undefined,
        NoncurrentVersionExpiration: undefined,
        AbortIncompleteMultipartUpload: undefined
    };
    if (output["Expiration"] !== undefined) contents.Expiration = $e0af51232e7b34d9$var$deserializeAws_restXmlLifecycleExpiration(output["Expiration"], context);
    if (output["ID"] !== undefined) contents.ID = output["ID"];
    if (output["Prefix"] !== undefined) contents.Prefix = output["Prefix"];
    if (output["Filter"] !== undefined) contents.Filter = $e0af51232e7b34d9$var$deserializeAws_restXmlLifecycleRuleFilter(output["Filter"], context);
    if (output["Status"] !== undefined) contents.Status = output["Status"];
    if (output.Transition === "") contents.Transitions = [];
    if (output["Transition"] !== undefined) contents.Transitions = $e0af51232e7b34d9$var$deserializeAws_restXmlTransitionList((0, $bgM88.getArrayIfSingleItem)(output["Transition"]), context);
    if (output.NoncurrentVersionTransition === "") contents.NoncurrentVersionTransitions = [];
    if (output["NoncurrentVersionTransition"] !== undefined) contents.NoncurrentVersionTransitions = $e0af51232e7b34d9$var$deserializeAws_restXmlNoncurrentVersionTransitionList((0, $bgM88.getArrayIfSingleItem)(output["NoncurrentVersionTransition"]), context);
    if (output["NoncurrentVersionExpiration"] !== undefined) contents.NoncurrentVersionExpiration = $e0af51232e7b34d9$var$deserializeAws_restXmlNoncurrentVersionExpiration(output["NoncurrentVersionExpiration"], context);
    if (output["AbortIncompleteMultipartUpload"] !== undefined) contents.AbortIncompleteMultipartUpload = $e0af51232e7b34d9$var$deserializeAws_restXmlAbortIncompleteMultipartUpload(output["AbortIncompleteMultipartUpload"], context);
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlLifecycleRuleAndOperator = function(output, context) {
    var contents = {
        Prefix: undefined,
        Tags: undefined
    };
    if (output["Prefix"] !== undefined) contents.Prefix = output["Prefix"];
    if (output.Tag === "") contents.Tags = [];
    if (output["Tag"] !== undefined) contents.Tags = $e0af51232e7b34d9$var$deserializeAws_restXmlTagSet((0, $bgM88.getArrayIfSingleItem)(output["Tag"]), context);
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlLifecycleRuleFilter = function(output, context) {
    if (output["Prefix"] !== undefined) return {
        Prefix: output["Prefix"]
    };
    if (output["Tag"] !== undefined) return {
        Tag: $e0af51232e7b34d9$var$deserializeAws_restXmlTag(output["Tag"], context)
    };
    if (output["And"] !== undefined) return {
        And: $e0af51232e7b34d9$var$deserializeAws_restXmlLifecycleRuleAndOperator(output["And"], context)
    };
    return {
        $unknown: Object.entries(output)[0]
    };
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlLifecycleRules = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $e0af51232e7b34d9$var$deserializeAws_restXmlLifecycleRule(entry, context);
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlLoggingEnabled = function(output, context) {
    var contents = {
        TargetBucket: undefined,
        TargetGrants: undefined,
        TargetPrefix: undefined
    };
    if (output["TargetBucket"] !== undefined) contents.TargetBucket = output["TargetBucket"];
    if (output.TargetGrants === "") contents.TargetGrants = [];
    if (output["TargetGrants"] !== undefined && output["TargetGrants"]["Grant"] !== undefined) contents.TargetGrants = $e0af51232e7b34d9$var$deserializeAws_restXmlTargetGrants((0, $bgM88.getArrayIfSingleItem)(output["TargetGrants"]["Grant"]), context);
    if (output["TargetPrefix"] !== undefined) contents.TargetPrefix = output["TargetPrefix"];
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlMetrics = function(output, context) {
    var contents = {
        Status: undefined,
        EventThreshold: undefined
    };
    if (output["Status"] !== undefined) contents.Status = output["Status"];
    if (output["EventThreshold"] !== undefined) contents.EventThreshold = $e0af51232e7b34d9$var$deserializeAws_restXmlReplicationTimeValue(output["EventThreshold"], context);
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlMetricsAndOperator = function(output, context) {
    var contents = {
        Prefix: undefined,
        Tags: undefined
    };
    if (output["Prefix"] !== undefined) contents.Prefix = output["Prefix"];
    if (output.Tag === "") contents.Tags = [];
    if (output["Tag"] !== undefined) contents.Tags = $e0af51232e7b34d9$var$deserializeAws_restXmlTagSet((0, $bgM88.getArrayIfSingleItem)(output["Tag"]), context);
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlMetricsConfiguration = function(output, context) {
    var contents = {
        Id: undefined,
        Filter: undefined
    };
    if (output["Id"] !== undefined) contents.Id = output["Id"];
    if (output["Filter"] !== undefined) contents.Filter = $e0af51232e7b34d9$var$deserializeAws_restXmlMetricsFilter(output["Filter"], context);
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlMetricsConfigurationList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $e0af51232e7b34d9$var$deserializeAws_restXmlMetricsConfiguration(entry, context);
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlMetricsFilter = function(output, context) {
    if (output["Prefix"] !== undefined) return {
        Prefix: output["Prefix"]
    };
    if (output["Tag"] !== undefined) return {
        Tag: $e0af51232e7b34d9$var$deserializeAws_restXmlTag(output["Tag"], context)
    };
    if (output["And"] !== undefined) return {
        And: $e0af51232e7b34d9$var$deserializeAws_restXmlMetricsAndOperator(output["And"], context)
    };
    return {
        $unknown: Object.entries(output)[0]
    };
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlMultipartUpload = function(output, context) {
    var contents = {
        UploadId: undefined,
        Key: undefined,
        Initiated: undefined,
        StorageClass: undefined,
        Owner: undefined,
        Initiator: undefined
    };
    if (output["UploadId"] !== undefined) contents.UploadId = output["UploadId"];
    if (output["Key"] !== undefined) contents.Key = output["Key"];
    if (output["Initiated"] !== undefined) contents.Initiated = new Date(output["Initiated"]);
    if (output["StorageClass"] !== undefined) contents.StorageClass = output["StorageClass"];
    if (output["Owner"] !== undefined) contents.Owner = $e0af51232e7b34d9$var$deserializeAws_restXmlOwner(output["Owner"], context);
    if (output["Initiator"] !== undefined) contents.Initiator = $e0af51232e7b34d9$var$deserializeAws_restXmlInitiator(output["Initiator"], context);
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlMultipartUploadList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $e0af51232e7b34d9$var$deserializeAws_restXmlMultipartUpload(entry, context);
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlNoncurrentVersionExpiration = function(output, context) {
    var contents = {
        NoncurrentDays: undefined
    };
    if (output["NoncurrentDays"] !== undefined) contents.NoncurrentDays = parseInt(output["NoncurrentDays"]);
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlNoncurrentVersionTransition = function(output, context) {
    var contents = {
        NoncurrentDays: undefined,
        StorageClass: undefined
    };
    if (output["NoncurrentDays"] !== undefined) contents.NoncurrentDays = parseInt(output["NoncurrentDays"]);
    if (output["StorageClass"] !== undefined) contents.StorageClass = output["StorageClass"];
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlNoncurrentVersionTransitionList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $e0af51232e7b34d9$var$deserializeAws_restXmlNoncurrentVersionTransition(entry, context);
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlNotificationConfigurationFilter = function(output, context) {
    var contents = {
        Key: undefined
    };
    if (output["S3Key"] !== undefined) contents.Key = $e0af51232e7b34d9$var$deserializeAws_restXmlS3KeyFilter(output["S3Key"], context);
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXml_Object = function(output, context) {
    var contents = {
        Key: undefined,
        LastModified: undefined,
        ETag: undefined,
        Size: undefined,
        StorageClass: undefined,
        Owner: undefined
    };
    if (output["Key"] !== undefined) contents.Key = output["Key"];
    if (output["LastModified"] !== undefined) contents.LastModified = new Date(output["LastModified"]);
    if (output["ETag"] !== undefined) contents.ETag = output["ETag"];
    if (output["Size"] !== undefined) contents.Size = parseInt(output["Size"]);
    if (output["StorageClass"] !== undefined) contents.StorageClass = output["StorageClass"];
    if (output["Owner"] !== undefined) contents.Owner = $e0af51232e7b34d9$var$deserializeAws_restXmlOwner(output["Owner"], context);
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlObjectList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $e0af51232e7b34d9$var$deserializeAws_restXml_Object(entry, context);
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlObjectLockConfiguration = function(output, context) {
    var contents = {
        ObjectLockEnabled: undefined,
        Rule: undefined
    };
    if (output["ObjectLockEnabled"] !== undefined) contents.ObjectLockEnabled = output["ObjectLockEnabled"];
    if (output["Rule"] !== undefined) contents.Rule = $e0af51232e7b34d9$var$deserializeAws_restXmlObjectLockRule(output["Rule"], context);
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlObjectLockLegalHold = function(output, context) {
    var contents = {
        Status: undefined
    };
    if (output["Status"] !== undefined) contents.Status = output["Status"];
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlObjectLockRetention = function(output, context) {
    var contents = {
        Mode: undefined,
        RetainUntilDate: undefined
    };
    if (output["Mode"] !== undefined) contents.Mode = output["Mode"];
    if (output["RetainUntilDate"] !== undefined) contents.RetainUntilDate = new Date(output["RetainUntilDate"]);
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlObjectLockRule = function(output, context) {
    var contents = {
        DefaultRetention: undefined
    };
    if (output["DefaultRetention"] !== undefined) contents.DefaultRetention = $e0af51232e7b34d9$var$deserializeAws_restXmlDefaultRetention(output["DefaultRetention"], context);
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlObjectVersion = function(output, context) {
    var contents = {
        ETag: undefined,
        Size: undefined,
        StorageClass: undefined,
        Key: undefined,
        VersionId: undefined,
        IsLatest: undefined,
        LastModified: undefined,
        Owner: undefined
    };
    if (output["ETag"] !== undefined) contents.ETag = output["ETag"];
    if (output["Size"] !== undefined) contents.Size = parseInt(output["Size"]);
    if (output["StorageClass"] !== undefined) contents.StorageClass = output["StorageClass"];
    if (output["Key"] !== undefined) contents.Key = output["Key"];
    if (output["VersionId"] !== undefined) contents.VersionId = output["VersionId"];
    if (output["IsLatest"] !== undefined) contents.IsLatest = output["IsLatest"] == "true";
    if (output["LastModified"] !== undefined) contents.LastModified = new Date(output["LastModified"]);
    if (output["Owner"] !== undefined) contents.Owner = $e0af51232e7b34d9$var$deserializeAws_restXmlOwner(output["Owner"], context);
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlObjectVersionList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $e0af51232e7b34d9$var$deserializeAws_restXmlObjectVersion(entry, context);
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlOwner = function(output, context) {
    var contents = {
        DisplayName: undefined,
        ID: undefined
    };
    if (output["DisplayName"] !== undefined) contents.DisplayName = output["DisplayName"];
    if (output["ID"] !== undefined) contents.ID = output["ID"];
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlOwnershipControls = function(output, context) {
    var contents = {
        Rules: undefined
    };
    if (output.Rule === "") contents.Rules = [];
    if (output["Rule"] !== undefined) contents.Rules = $e0af51232e7b34d9$var$deserializeAws_restXmlOwnershipControlsRules((0, $bgM88.getArrayIfSingleItem)(output["Rule"]), context);
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlOwnershipControlsRule = function(output, context) {
    var contents = {
        ObjectOwnership: undefined
    };
    if (output["ObjectOwnership"] !== undefined) contents.ObjectOwnership = output["ObjectOwnership"];
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlOwnershipControlsRules = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $e0af51232e7b34d9$var$deserializeAws_restXmlOwnershipControlsRule(entry, context);
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlPart = function(output, context) {
    var contents = {
        PartNumber: undefined,
        LastModified: undefined,
        ETag: undefined,
        Size: undefined
    };
    if (output["PartNumber"] !== undefined) contents.PartNumber = parseInt(output["PartNumber"]);
    if (output["LastModified"] !== undefined) contents.LastModified = new Date(output["LastModified"]);
    if (output["ETag"] !== undefined) contents.ETag = output["ETag"];
    if (output["Size"] !== undefined) contents.Size = parseInt(output["Size"]);
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlParts = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $e0af51232e7b34d9$var$deserializeAws_restXmlPart(entry, context);
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlPolicyStatus = function(output, context) {
    var contents = {
        IsPublic: undefined
    };
    if (output["IsPublic"] !== undefined) contents.IsPublic = output["IsPublic"] == "true";
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlPublicAccessBlockConfiguration = function(output, context) {
    var contents = {
        BlockPublicAcls: undefined,
        IgnorePublicAcls: undefined,
        BlockPublicPolicy: undefined,
        RestrictPublicBuckets: undefined
    };
    if (output["BlockPublicAcls"] !== undefined) contents.BlockPublicAcls = output["BlockPublicAcls"] == "true";
    if (output["IgnorePublicAcls"] !== undefined) contents.IgnorePublicAcls = output["IgnorePublicAcls"] == "true";
    if (output["BlockPublicPolicy"] !== undefined) contents.BlockPublicPolicy = output["BlockPublicPolicy"] == "true";
    if (output["RestrictPublicBuckets"] !== undefined) contents.RestrictPublicBuckets = output["RestrictPublicBuckets"] == "true";
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlQueueConfiguration = function(output, context) {
    var contents = {
        Id: undefined,
        QueueArn: undefined,
        Events: undefined,
        Filter: undefined
    };
    if (output["Id"] !== undefined) contents.Id = output["Id"];
    if (output["Queue"] !== undefined) contents.QueueArn = output["Queue"];
    if (output.Event === "") contents.Events = [];
    if (output["Event"] !== undefined) contents.Events = $e0af51232e7b34d9$var$deserializeAws_restXmlEventList((0, $bgM88.getArrayIfSingleItem)(output["Event"]), context);
    if (output["Filter"] !== undefined) contents.Filter = $e0af51232e7b34d9$var$deserializeAws_restXmlNotificationConfigurationFilter(output["Filter"], context);
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlQueueConfigurationList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $e0af51232e7b34d9$var$deserializeAws_restXmlQueueConfiguration(entry, context);
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlRedirect = function(output, context) {
    var contents = {
        HostName: undefined,
        HttpRedirectCode: undefined,
        Protocol: undefined,
        ReplaceKeyPrefixWith: undefined,
        ReplaceKeyWith: undefined
    };
    if (output["HostName"] !== undefined) contents.HostName = output["HostName"];
    if (output["HttpRedirectCode"] !== undefined) contents.HttpRedirectCode = output["HttpRedirectCode"];
    if (output["Protocol"] !== undefined) contents.Protocol = output["Protocol"];
    if (output["ReplaceKeyPrefixWith"] !== undefined) contents.ReplaceKeyPrefixWith = output["ReplaceKeyPrefixWith"];
    if (output["ReplaceKeyWith"] !== undefined) contents.ReplaceKeyWith = output["ReplaceKeyWith"];
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlRedirectAllRequestsTo = function(output, context) {
    var contents = {
        HostName: undefined,
        Protocol: undefined
    };
    if (output["HostName"] !== undefined) contents.HostName = output["HostName"];
    if (output["Protocol"] !== undefined) contents.Protocol = output["Protocol"];
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlReplicaModifications = function(output, context) {
    var contents = {
        Status: undefined
    };
    if (output["Status"] !== undefined) contents.Status = output["Status"];
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlReplicationConfiguration = function(output, context) {
    var contents = {
        Role: undefined,
        Rules: undefined
    };
    if (output["Role"] !== undefined) contents.Role = output["Role"];
    if (output.Rule === "") contents.Rules = [];
    if (output["Rule"] !== undefined) contents.Rules = $e0af51232e7b34d9$var$deserializeAws_restXmlReplicationRules((0, $bgM88.getArrayIfSingleItem)(output["Rule"]), context);
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlReplicationRule = function(output, context) {
    var contents = {
        ID: undefined,
        Priority: undefined,
        Prefix: undefined,
        Filter: undefined,
        Status: undefined,
        SourceSelectionCriteria: undefined,
        ExistingObjectReplication: undefined,
        Destination: undefined,
        DeleteMarkerReplication: undefined
    };
    if (output["ID"] !== undefined) contents.ID = output["ID"];
    if (output["Priority"] !== undefined) contents.Priority = parseInt(output["Priority"]);
    if (output["Prefix"] !== undefined) contents.Prefix = output["Prefix"];
    if (output["Filter"] !== undefined) contents.Filter = $e0af51232e7b34d9$var$deserializeAws_restXmlReplicationRuleFilter(output["Filter"], context);
    if (output["Status"] !== undefined) contents.Status = output["Status"];
    if (output["SourceSelectionCriteria"] !== undefined) contents.SourceSelectionCriteria = $e0af51232e7b34d9$var$deserializeAws_restXmlSourceSelectionCriteria(output["SourceSelectionCriteria"], context);
    if (output["ExistingObjectReplication"] !== undefined) contents.ExistingObjectReplication = $e0af51232e7b34d9$var$deserializeAws_restXmlExistingObjectReplication(output["ExistingObjectReplication"], context);
    if (output["Destination"] !== undefined) contents.Destination = $e0af51232e7b34d9$var$deserializeAws_restXmlDestination(output["Destination"], context);
    if (output["DeleteMarkerReplication"] !== undefined) contents.DeleteMarkerReplication = $e0af51232e7b34d9$var$deserializeAws_restXmlDeleteMarkerReplication(output["DeleteMarkerReplication"], context);
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlReplicationRuleAndOperator = function(output, context) {
    var contents = {
        Prefix: undefined,
        Tags: undefined
    };
    if (output["Prefix"] !== undefined) contents.Prefix = output["Prefix"];
    if (output.Tag === "") contents.Tags = [];
    if (output["Tag"] !== undefined) contents.Tags = $e0af51232e7b34d9$var$deserializeAws_restXmlTagSet((0, $bgM88.getArrayIfSingleItem)(output["Tag"]), context);
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlReplicationRuleFilter = function(output, context) {
    if (output["Prefix"] !== undefined) return {
        Prefix: output["Prefix"]
    };
    if (output["Tag"] !== undefined) return {
        Tag: $e0af51232e7b34d9$var$deserializeAws_restXmlTag(output["Tag"], context)
    };
    if (output["And"] !== undefined) return {
        And: $e0af51232e7b34d9$var$deserializeAws_restXmlReplicationRuleAndOperator(output["And"], context)
    };
    return {
        $unknown: Object.entries(output)[0]
    };
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlReplicationRules = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $e0af51232e7b34d9$var$deserializeAws_restXmlReplicationRule(entry, context);
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlReplicationTime = function(output, context) {
    var contents = {
        Status: undefined,
        Time: undefined
    };
    if (output["Status"] !== undefined) contents.Status = output["Status"];
    if (output["Time"] !== undefined) contents.Time = $e0af51232e7b34d9$var$deserializeAws_restXmlReplicationTimeValue(output["Time"], context);
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlReplicationTimeValue = function(output, context) {
    var contents = {
        Minutes: undefined
    };
    if (output["Minutes"] !== undefined) contents.Minutes = parseInt(output["Minutes"]);
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlRoutingRule = function(output, context) {
    var contents = {
        Condition: undefined,
        Redirect: undefined
    };
    if (output["Condition"] !== undefined) contents.Condition = $e0af51232e7b34d9$var$deserializeAws_restXmlCondition(output["Condition"], context);
    if (output["Redirect"] !== undefined) contents.Redirect = $e0af51232e7b34d9$var$deserializeAws_restXmlRedirect(output["Redirect"], context);
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlRoutingRules = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $e0af51232e7b34d9$var$deserializeAws_restXmlRoutingRule(entry, context);
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlS3KeyFilter = function(output, context) {
    var contents = {
        FilterRules: undefined
    };
    if (output.FilterRule === "") contents.FilterRules = [];
    if (output["FilterRule"] !== undefined) contents.FilterRules = $e0af51232e7b34d9$var$deserializeAws_restXmlFilterRuleList((0, $bgM88.getArrayIfSingleItem)(output["FilterRule"]), context);
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlServerSideEncryptionByDefault = function(output, context) {
    var contents = {
        SSEAlgorithm: undefined,
        KMSMasterKeyID: undefined
    };
    if (output["SSEAlgorithm"] !== undefined) contents.SSEAlgorithm = output["SSEAlgorithm"];
    if (output["KMSMasterKeyID"] !== undefined) contents.KMSMasterKeyID = output["KMSMasterKeyID"];
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlServerSideEncryptionConfiguration = function(output, context) {
    var contents = {
        Rules: undefined
    };
    if (output.Rule === "") contents.Rules = [];
    if (output["Rule"] !== undefined) contents.Rules = $e0af51232e7b34d9$var$deserializeAws_restXmlServerSideEncryptionRules((0, $bgM88.getArrayIfSingleItem)(output["Rule"]), context);
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlServerSideEncryptionRule = function(output, context) {
    var contents = {
        ApplyServerSideEncryptionByDefault: undefined,
        BucketKeyEnabled: undefined
    };
    if (output["ApplyServerSideEncryptionByDefault"] !== undefined) contents.ApplyServerSideEncryptionByDefault = $e0af51232e7b34d9$var$deserializeAws_restXmlServerSideEncryptionByDefault(output["ApplyServerSideEncryptionByDefault"], context);
    if (output["BucketKeyEnabled"] !== undefined) contents.BucketKeyEnabled = output["BucketKeyEnabled"] == "true";
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlServerSideEncryptionRules = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $e0af51232e7b34d9$var$deserializeAws_restXmlServerSideEncryptionRule(entry, context);
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlSourceSelectionCriteria = function(output, context) {
    var contents = {
        SseKmsEncryptedObjects: undefined,
        ReplicaModifications: undefined
    };
    if (output["SseKmsEncryptedObjects"] !== undefined) contents.SseKmsEncryptedObjects = $e0af51232e7b34d9$var$deserializeAws_restXmlSseKmsEncryptedObjects(output["SseKmsEncryptedObjects"], context);
    if (output["ReplicaModifications"] !== undefined) contents.ReplicaModifications = $e0af51232e7b34d9$var$deserializeAws_restXmlReplicaModifications(output["ReplicaModifications"], context);
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlSSEKMS = function(output, context) {
    var contents = {
        KeyId: undefined
    };
    if (output["KeyId"] !== undefined) contents.KeyId = output["KeyId"];
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlSseKmsEncryptedObjects = function(output, context) {
    var contents = {
        Status: undefined
    };
    if (output["Status"] !== undefined) contents.Status = output["Status"];
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlSSES3 = function(output, context) {
    var contents = {};
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlStorageClassAnalysis = function(output, context) {
    var contents = {
        DataExport: undefined
    };
    if (output["DataExport"] !== undefined) contents.DataExport = $e0af51232e7b34d9$var$deserializeAws_restXmlStorageClassAnalysisDataExport(output["DataExport"], context);
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlStorageClassAnalysisDataExport = function(output, context) {
    var contents = {
        OutputSchemaVersion: undefined,
        Destination: undefined
    };
    if (output["OutputSchemaVersion"] !== undefined) contents.OutputSchemaVersion = output["OutputSchemaVersion"];
    if (output["Destination"] !== undefined) contents.Destination = $e0af51232e7b34d9$var$deserializeAws_restXmlAnalyticsExportDestination(output["Destination"], context);
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlTag = function(output, context) {
    var contents = {
        Key: undefined,
        Value: undefined
    };
    if (output["Key"] !== undefined) contents.Key = output["Key"];
    if (output["Value"] !== undefined) contents.Value = output["Value"];
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlTagSet = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $e0af51232e7b34d9$var$deserializeAws_restXmlTag(entry, context);
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlTargetGrant = function(output, context) {
    var contents = {
        Grantee: undefined,
        Permission: undefined
    };
    if (output["Grantee"] !== undefined) contents.Grantee = $e0af51232e7b34d9$var$deserializeAws_restXmlGrantee(output["Grantee"], context);
    if (output["Permission"] !== undefined) contents.Permission = output["Permission"];
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlTargetGrants = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $e0af51232e7b34d9$var$deserializeAws_restXmlTargetGrant(entry, context);
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlTiering = function(output, context) {
    var contents = {
        Days: undefined,
        AccessTier: undefined
    };
    if (output["Days"] !== undefined) contents.Days = parseInt(output["Days"]);
    if (output["AccessTier"] !== undefined) contents.AccessTier = output["AccessTier"];
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlTieringList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $e0af51232e7b34d9$var$deserializeAws_restXmlTiering(entry, context);
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlTopicConfiguration = function(output, context) {
    var contents = {
        Id: undefined,
        TopicArn: undefined,
        Events: undefined,
        Filter: undefined
    };
    if (output["Id"] !== undefined) contents.Id = output["Id"];
    if (output["Topic"] !== undefined) contents.TopicArn = output["Topic"];
    if (output.Event === "") contents.Events = [];
    if (output["Event"] !== undefined) contents.Events = $e0af51232e7b34d9$var$deserializeAws_restXmlEventList((0, $bgM88.getArrayIfSingleItem)(output["Event"]), context);
    if (output["Filter"] !== undefined) contents.Filter = $e0af51232e7b34d9$var$deserializeAws_restXmlNotificationConfigurationFilter(output["Filter"], context);
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlTopicConfigurationList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $e0af51232e7b34d9$var$deserializeAws_restXmlTopicConfiguration(entry, context);
    });
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlTransition = function(output, context) {
    var contents = {
        Date: undefined,
        Days: undefined,
        StorageClass: undefined
    };
    if (output["Date"] !== undefined) contents.Date = new Date(output["Date"]);
    if (output["Days"] !== undefined) contents.Days = parseInt(output["Days"]);
    if (output["StorageClass"] !== undefined) contents.StorageClass = output["StorageClass"];
    return contents;
};
var $e0af51232e7b34d9$var$deserializeAws_restXmlTransitionList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $e0af51232e7b34d9$var$deserializeAws_restXmlTransition(entry, context);
    });
};
var $e0af51232e7b34d9$var$deserializeMetadata = function(output) {
    var _a;
    return {
        httpStatusCode: output.statusCode,
        requestId: (_a = output.headers["x-amzn-requestid"]) !== null && _a !== void 0 ? _a : output.headers["x-amzn-request-id"],
        extendedRequestId: output.headers["x-amz-id-2"],
        cfId: output.headers["x-amz-cf-id"]
    };
};
// Collect low-level response body stream to Uint8Array.
var $e0af51232e7b34d9$var$collectBody = function(streamBody, context) {
    if (streamBody === void 0) streamBody = new Uint8Array();
    if (streamBody instanceof Uint8Array) return Promise.resolve(streamBody);
    return context.streamCollector(streamBody) || Promise.resolve(new Uint8Array());
};
// Encode Uint8Array data into string with utf-8.
var $e0af51232e7b34d9$var$collectBodyString = function(streamBody, context) {
    return $e0af51232e7b34d9$var$collectBody(streamBody, context).then(function(body) {
        return context.utf8Encoder(body);
    });
};
var $e0af51232e7b34d9$var$isSerializableHeaderValue = function(value) {
    return value !== undefined && value !== null && value !== "" && (!Object.getOwnPropertyNames(value).includes("length") || value.length != 0) && (!Object.getOwnPropertyNames(value).includes("size") || value.size != 0);
};
var $e0af51232e7b34d9$var$decodeEscapedXML = function(str) {
    return str.replace(/&amp;/g, "&").replace(/&apos;/g, "'").replace(/&quot;/g, '"').replace(/&gt;/g, ">").replace(/&lt;/g, "<");
};
var $e0af51232e7b34d9$var$parseBody = function(streamBody, context) {
    return $e0af51232e7b34d9$var$collectBodyString(streamBody, context).then(function(encoded) {
        if (encoded.length) {
            var parsedObj = (0, $iyNbS.parse)(encoded, {
                attributeNamePrefix: "",
                ignoreAttributes: false,
                parseNodeValue: false,
                tagValueProcessor: function(val, tagName) {
                    return $e0af51232e7b34d9$var$decodeEscapedXML(val);
                }
            });
            var textNodeName = "#text";
            var key = Object.keys(parsedObj)[0];
            var parsedObjToReturn = parsedObj[key];
            if (parsedObjToReturn[textNodeName]) {
                parsedObjToReturn[key] = parsedObjToReturn[textNodeName];
                delete parsedObjToReturn[textNodeName];
            }
            return (0, $bvxsW.getValueFromTextNode)(parsedObjToReturn);
        }
        return {};
    });
};
var $e0af51232e7b34d9$var$loadRestXmlErrorCode = function(output, data) {
    if (data.Code !== undefined) return data.Code;
    if (output.statusCode == 404) return "NotFound";
    return "";
};

});
parcelRegister("bXXJg", function(module, exports) {
$parcel$export(module.exports, "XmlNode", () => (parcelRequire("iqrNg")).XmlNode);
$parcel$export(module.exports, "XmlText", () => (parcelRequire("cm4u6")).XmlText);
parcelRequire("iqrNg");
parcelRequire("cm4u6");

});
parcelRegister("iqrNg", function(module, exports) {

$parcel$export(module.exports, "XmlNode", () => $d6a036f1ed2590a7$export$e775a15d806cbddc);

var $4JYsX = parcelRequire("4JYsX");

var $2LtjA = parcelRequire("2LtjA");
/**
 * Represents an XML node.
 */ var $d6a036f1ed2590a7$export$e775a15d806cbddc = /** @class */ function() {
    function XmlNode(name, children) {
        if (children === void 0) children = [];
        this.name = name;
        this.children = children;
        this.attributes = {};
    }
    XmlNode.prototype.withName = function(name) {
        this.name = name;
        return this;
    };
    XmlNode.prototype.addAttribute = function(name, value) {
        this.attributes[name] = value;
        return this;
    };
    XmlNode.prototype.addChildNode = function(child) {
        this.children.push(child);
        return this;
    };
    XmlNode.prototype.removeAttribute = function(name) {
        delete this.attributes[name];
        return this;
    };
    XmlNode.prototype.toString = function() {
        var e_1, _a;
        var hasChildren = Boolean(this.children.length);
        var xmlText = "<" + this.name;
        // add attributes
        var attributes = this.attributes;
        try {
            for(var _b = (0, $4JYsX.__values)(Object.keys(attributes)), _c = _b.next(); !_c.done; _c = _b.next()){
                var attributeName = _c.value;
                var attribute = attributes[attributeName];
                if (typeof attribute !== "undefined" && attribute !== null) xmlText += " " + attributeName + "=\"" + (0, $2LtjA.escapeAttribute)("" + attribute) + "\"";
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return xmlText += !hasChildren ? "/>" : ">" + this.children.map(function(c) {
            return c.toString();
        }).join("") + "</" + this.name + ">";
    };
    return XmlNode;
}();

});
parcelRegister("4JYsX", function(module, exports) {

$parcel$export(module.exports, "__values", () => $373a44b11bd28dd5$export$19a8beecd37a4c45);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $373a44b11bd28dd5$var$extendStatics = function(d, b) {
    $373a44b11bd28dd5$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $373a44b11bd28dd5$var$extendStatics(d, b);
};
function $373a44b11bd28dd5$export$a8ba968b8961cb8a(d, b) {
    $373a44b11bd28dd5$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $373a44b11bd28dd5$export$18ce0697a983be9b = function() {
    $373a44b11bd28dd5$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $373a44b11bd28dd5$export$18ce0697a983be9b.apply(this, arguments);
};
function $373a44b11bd28dd5$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $373a44b11bd28dd5$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $373a44b11bd28dd5$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $373a44b11bd28dd5$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $373a44b11bd28dd5$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $373a44b11bd28dd5$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $373a44b11bd28dd5$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $373a44b11bd28dd5$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $373a44b11bd28dd5$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $373a44b11bd28dd5$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $373a44b11bd28dd5$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($373a44b11bd28dd5$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $373a44b11bd28dd5$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $373a44b11bd28dd5$export$10c90e4f7922046c(v) {
    return this instanceof $373a44b11bd28dd5$export$10c90e4f7922046c ? (this.v = v, this) : new $373a44b11bd28dd5$export$10c90e4f7922046c(v);
}
function $373a44b11bd28dd5$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $373a44b11bd28dd5$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $373a44b11bd28dd5$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $373a44b11bd28dd5$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $373a44b11bd28dd5$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $373a44b11bd28dd5$export$19a8beecd37a4c45 === "function" ? $373a44b11bd28dd5$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $373a44b11bd28dd5$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $373a44b11bd28dd5$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $373a44b11bd28dd5$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $373a44b11bd28dd5$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $373a44b11bd28dd5$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("2LtjA", function(module, exports) {

$parcel$export(module.exports, "escapeAttribute", () => $2036b5e260613bbd$export$30330f3d5eb70e11);
/**
 * Escapes characters that can not be in an XML attribute.
 */ function $2036b5e260613bbd$export$30330f3d5eb70e11(value) {
    return value.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
}

});


parcelRegister("cm4u6", function(module, exports) {

$parcel$export(module.exports, "XmlText", () => $8feb04a3012eda41$export$b35b8f45887823df);

var $3MYkH = parcelRequire("3MYkH");
/**
 * Represents an XML text value.
 */ var $8feb04a3012eda41$export$b35b8f45887823df = /** @class */ function() {
    function XmlText(value) {
        this.value = value;
    }
    XmlText.prototype.toString = function() {
        return (0, $3MYkH.escapeElement)("" + this.value);
    };
    return XmlText;
}();

});
parcelRegister("3MYkH", function(module, exports) {

$parcel$export(module.exports, "escapeElement", () => $2c24a7a328c10aa0$export$e5104ffd394b43ec);
/**
 * Escapes characters that can not be in an XML element.
 */ function $2c24a7a328c10aa0$export$e5104ffd394b43ec(value) {
    return value.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}

});



parcelRegister("iyNbS", function(module, exports) {

$parcel$export(module.exports, "parse", () => $d8318f35bf1e765b$export$98e6a39c04603d36, (v) => $d8318f35bf1e765b$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "convertTonimn", () => $d8318f35bf1e765b$export$e4f0b40d01c251ab, (v) => $d8318f35bf1e765b$export$e4f0b40d01c251ab = v);
$parcel$export(module.exports, "getTraversalObj", () => $d8318f35bf1e765b$export$2ca3eb0a2f8a693a, (v) => $d8318f35bf1e765b$export$2ca3eb0a2f8a693a = v);
var $d8318f35bf1e765b$export$98e6a39c04603d36;
var $d8318f35bf1e765b$export$e4f0b40d01c251ab;
var $d8318f35bf1e765b$export$2ca3eb0a2f8a693a;
var $d8318f35bf1e765b$export$e31c2b05678acf26;
var $d8318f35bf1e765b$export$54ffaacfc0931fb0;
var $d8318f35bf1e765b$export$a22775fa5e2eebd9;
var $d8318f35bf1e765b$export$30384b60aedf98a5;
var $d8318f35bf1e765b$export$3a5cfc971f52ee31;
'use strict';

var $8nAeO = parcelRequire("8nAeO");

var $lOHFL = parcelRequire("lOHFL");

var $lOHFL = parcelRequire("lOHFL");

var $cW3kI = parcelRequire("cW3kI");
var $d8318f35bf1e765b$require$buildOptions = $cW3kI.buildOptions;

var $egdrK = parcelRequire("egdrK");
$d8318f35bf1e765b$export$98e6a39c04603d36 = function(xmlData, givenOptions = {}, validationOption) {
    if (validationOption) {
        if (validationOption === true) validationOption = {};
        const result = $egdrK.validate(xmlData, validationOption);
        if (result !== true) throw Error(result.err.msg);
    }
    if (givenOptions.parseTrueNumberOnly && givenOptions.parseNodeValue !== false && !givenOptions.numParseOptions) givenOptions.numParseOptions = {
        leadingZeros: false
    };
    let options = $d8318f35bf1e765b$require$buildOptions(givenOptions, $lOHFL.defaultOptions, $lOHFL.props);
    const traversableObj = $lOHFL.getTraversalObj(xmlData, options);
    //print(traversableObj, "  ");
    return $8nAeO.convertToJson(traversableObj, options);
};

$d8318f35bf1e765b$export$e4f0b40d01c251ab = (parcelRequire("h84ib")).convert2nimn;
$d8318f35bf1e765b$export$2ca3eb0a2f8a693a = $lOHFL.getTraversalObj;
$d8318f35bf1e765b$export$e31c2b05678acf26 = $8nAeO.convertToJson;

$d8318f35bf1e765b$export$54ffaacfc0931fb0 = (parcelRequire("4CvqR")).convertToJsonString;
$d8318f35bf1e765b$export$a22775fa5e2eebd9 = $egdrK.validate;

$d8318f35bf1e765b$export$30384b60aedf98a5 = (parcelRequire("a4Ot5"));
$d8318f35bf1e765b$export$3a5cfc971f52ee31 = function(xmlData, schema, options) {
    return $d8318f35bf1e765b$export$e4f0b40d01c251ab($d8318f35bf1e765b$export$2ca3eb0a2f8a693a(xmlData, options), schema, options);
};
function $d8318f35bf1e765b$var$print(xmlNode, indentation) {
    if (xmlNode) {
        console.log(indentation + "{");
        console.log(indentation + "  \"tagName\": \"" + xmlNode.tagname + "\", ");
        if (xmlNode.parent) console.log(indentation + "  \"parent\": \"" + xmlNode.parent.tagname + "\", ");
        console.log(indentation + "  \"val\": \"" + xmlNode.val + "\", ");
        console.log(indentation + "  \"attrs\": " + JSON.stringify(xmlNode.attrsMap, null, 4) + ", ");
        if (xmlNode.child) {
            console.log(indentation + "\"child\": {");
            const indentation2 = indentation + indentation;
            Object.keys(xmlNode.child).forEach(function(key) {
                const node = xmlNode.child[key];
                if (Array.isArray(node)) {
                    console.log(indentation + "\"" + key + "\" :[");
                    node.forEach(function(item, index) {
                        //console.log(indentation + " \""+index+"\" : [")
                        $d8318f35bf1e765b$var$print(item, indentation2);
                    });
                    console.log(indentation + "],");
                } else {
                    console.log(indentation + " \"" + key + "\" : {");
                    $d8318f35bf1e765b$var$print(node, indentation2);
                    console.log(indentation + "},");
                }
            });
            console.log(indentation + "},");
        }
        console.log(indentation + "},");
    }
}

});
parcelRegister("8nAeO", function(module, exports) {

$parcel$export(module.exports, "convertToJson", () => $619c94c998edf7fd$export$e31c2b05678acf26, (v) => $619c94c998edf7fd$export$e31c2b05678acf26 = v);
var $619c94c998edf7fd$export$e31c2b05678acf26;
'use strict';

var $cW3kI = parcelRequire("cW3kI");
const $619c94c998edf7fd$var$convertToJson = function(node, options, parentTagName) {
    const jObj = {};
    // when no child node or attr is present
    if (!options.alwaysCreateTextNode && (!node.child || $cW3kI.isEmptyObject(node.child)) && (!node.attrsMap || $cW3kI.isEmptyObject(node.attrsMap))) return $cW3kI.isExist(node.val) ? node.val : '';
    // otherwise create a textnode if node has some text
    if ($cW3kI.isExist(node.val) && !(typeof node.val === 'string' && (node.val === '' || node.val === options.cdataPositionChar))) {
        const asArray = $cW3kI.isTagNameInArrayMode(node.tagname, options.arrayMode, parentTagName);
        jObj[options.textNodeName] = asArray ? [
            node.val
        ] : node.val;
    }
    $cW3kI.merge(jObj, node.attrsMap, options.arrayMode);
    const keys = Object.keys(node.child);
    for(let index = 0; index < keys.length; index++){
        const tagName = keys[index];
        if (node.child[tagName] && node.child[tagName].length > 1) {
            jObj[tagName] = [];
            for(let tag in node.child[tagName])if (node.child[tagName].hasOwnProperty(tag)) jObj[tagName].push($619c94c998edf7fd$var$convertToJson(node.child[tagName][tag], options, tagName));
        } else {
            const result = $619c94c998edf7fd$var$convertToJson(node.child[tagName][0], options, tagName);
            const asArray = options.arrayMode === true && typeof result === 'object' || $cW3kI.isTagNameInArrayMode(tagName, options.arrayMode, parentTagName);
            jObj[tagName] = asArray ? [
                result
            ] : result;
        }
    }
    //add value
    return jObj;
};
$619c94c998edf7fd$export$e31c2b05678acf26 = $619c94c998edf7fd$var$convertToJson;

});
parcelRegister("cW3kI", function(module, exports) {

$parcel$export(module.exports, "isExist", () => $026e272c4b4669d8$export$a5edf3f35b6dd392, (v) => $026e272c4b4669d8$export$a5edf3f35b6dd392 = v);
$parcel$export(module.exports, "isEmptyObject", () => $026e272c4b4669d8$export$83b788b1a3698c03, (v) => $026e272c4b4669d8$export$83b788b1a3698c03 = v);
$parcel$export(module.exports, "merge", () => $026e272c4b4669d8$export$4950aa0f605343fb, (v) => $026e272c4b4669d8$export$4950aa0f605343fb = v);
$parcel$export(module.exports, "getValue", () => $026e272c4b4669d8$export$bf7199a9ebcb84a9, (v) => $026e272c4b4669d8$export$bf7199a9ebcb84a9 = v);
$parcel$export(module.exports, "buildOptions", () => $026e272c4b4669d8$export$ecbd7d678ac4909b, (v) => $026e272c4b4669d8$export$ecbd7d678ac4909b = v);
$parcel$export(module.exports, "isTagNameInArrayMode", () => $026e272c4b4669d8$export$fd3b6180ca5b0284, (v) => $026e272c4b4669d8$export$fd3b6180ca5b0284 = v);
$parcel$export(module.exports, "isName", () => $026e272c4b4669d8$export$998d7ff9801e90bb, (v) => $026e272c4b4669d8$export$998d7ff9801e90bb = v);
$parcel$export(module.exports, "getAllMatches", () => $026e272c4b4669d8$export$aaa9734c55cb7a19, (v) => $026e272c4b4669d8$export$aaa9734c55cb7a19 = v);
$parcel$export(module.exports, "nameRegexp", () => $026e272c4b4669d8$export$e8f2644f7085b4b1, (v) => $026e272c4b4669d8$export$e8f2644f7085b4b1 = v);
var $026e272c4b4669d8$export$a5edf3f35b6dd392;
var $026e272c4b4669d8$export$83b788b1a3698c03;
/**
 * Copy all the properties of a into b.
 * @param {*} target
 * @param {*} a
 */ var $026e272c4b4669d8$export$4950aa0f605343fb;
/* exports.merge =function (b,a){
  return Object.assign(b,a);
} */ var $026e272c4b4669d8$export$bf7199a9ebcb84a9;
// const fakeCall = function(a) {return a;};
// const fakeCallNoReturn = function() {};
var $026e272c4b4669d8$export$ecbd7d678ac4909b;
/**
 * Check if a tag name should be treated as array
 *
 * @param tagName the node tagname
 * @param arrayMode the array mode option
 * @param parentTagName the parent tag name
 * @returns {boolean} true if node should be parsed as array
 */ var $026e272c4b4669d8$export$fd3b6180ca5b0284;
var $026e272c4b4669d8$export$998d7ff9801e90bb;
var $026e272c4b4669d8$export$aaa9734c55cb7a19;
var $026e272c4b4669d8$export$e8f2644f7085b4b1;
'use strict';
const $026e272c4b4669d8$var$nameStartChar = ':A-Za-z_\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
const $026e272c4b4669d8$var$nameChar = $026e272c4b4669d8$var$nameStartChar + '\\-.\\d\\u00B7\\u0300-\\u036F\\u203F-\\u2040';
const $026e272c4b4669d8$var$nameRegexp = '[' + $026e272c4b4669d8$var$nameStartChar + '][' + $026e272c4b4669d8$var$nameChar + ']*';
const $026e272c4b4669d8$var$regexName = new RegExp('^' + $026e272c4b4669d8$var$nameRegexp + '$');
const $026e272c4b4669d8$var$getAllMatches = function(string, regex) {
    const matches = [];
    let match = regex.exec(string);
    while(match){
        const allmatches = [];
        allmatches.startIndex = regex.lastIndex - match[0].length;
        const len = match.length;
        for(let index = 0; index < len; index++)allmatches.push(match[index]);
        matches.push(allmatches);
        match = regex.exec(string);
    }
    return matches;
};
const $026e272c4b4669d8$var$isName = function(string) {
    const match = $026e272c4b4669d8$var$regexName.exec(string);
    return !(match === null || typeof match === 'undefined');
};
$026e272c4b4669d8$export$a5edf3f35b6dd392 = function(v) {
    return typeof v !== 'undefined';
};
$026e272c4b4669d8$export$83b788b1a3698c03 = function(obj) {
    return Object.keys(obj).length === 0;
};
$026e272c4b4669d8$export$4950aa0f605343fb = function(target, a, arrayMode) {
    if (a) {
        const keys = Object.keys(a); // will return an array of own properties
        const len = keys.length; //don't make it inline
        for(let i = 0; i < len; i++)if (arrayMode === 'strict') target[keys[i]] = [
            a[keys[i]]
        ];
        else target[keys[i]] = a[keys[i]];
    }
};
$026e272c4b4669d8$export$bf7199a9ebcb84a9 = function(v) {
    if ($026e272c4b4669d8$export$a5edf3f35b6dd392(v)) return v;
    else return '';
};
$026e272c4b4669d8$export$ecbd7d678ac4909b = function(options, defaultOptions, props) {
    let newOptions = {};
    if (!options) return defaultOptions; //if there are not options
    for(let i = 0; i < props.length; i++)if (options[props[i]] !== undefined) newOptions[props[i]] = options[props[i]];
    else newOptions[props[i]] = defaultOptions[props[i]];
    return newOptions;
};
$026e272c4b4669d8$export$fd3b6180ca5b0284 = function(tagName, arrayMode, parentTagName) {
    if (arrayMode === false) return false;
    else if (arrayMode instanceof RegExp) return arrayMode.test(tagName);
    else if (typeof arrayMode === 'function') return !!arrayMode(tagName, parentTagName);
    return arrayMode === "strict";
};
$026e272c4b4669d8$export$998d7ff9801e90bb = $026e272c4b4669d8$var$isName;
$026e272c4b4669d8$export$aaa9734c55cb7a19 = $026e272c4b4669d8$var$getAllMatches;
$026e272c4b4669d8$export$e8f2644f7085b4b1 = $026e272c4b4669d8$var$nameRegexp;

});


parcelRegister("lOHFL", function(module, exports) {

$parcel$export(module.exports, "defaultOptions", () => $fe2024f28d56bf4d$export$ba43bf67f3d48107, (v) => $fe2024f28d56bf4d$export$ba43bf67f3d48107 = v);
$parcel$export(module.exports, "props", () => $fe2024f28d56bf4d$export$8128bb6492cf3de7, (v) => $fe2024f28d56bf4d$export$8128bb6492cf3de7 = v);
$parcel$export(module.exports, "getTraversalObj", () => $fe2024f28d56bf4d$export$2ca3eb0a2f8a693a, (v) => $fe2024f28d56bf4d$export$2ca3eb0a2f8a693a = v);
var $fe2024f28d56bf4d$export$ba43bf67f3d48107;
var $fe2024f28d56bf4d$export$8128bb6492cf3de7;
var $fe2024f28d56bf4d$export$2ca3eb0a2f8a693a;
'use strict';

var $cW3kI = parcelRequire("cW3kI");

var $cW3kI = parcelRequire("cW3kI");
var $fe2024f28d56bf4d$require$buildOptions = $cW3kI.buildOptions;

var $1WG4k = parcelRequire("1WG4k");

var $6e9D4 = parcelRequire("6e9D4");
const $fe2024f28d56bf4d$var$regx = '<((!\\[CDATA\\[([\\s\\S]*?)(]]>))|((NAME:)?(NAME))([^>]*)>|((\\/)(NAME)\\s*>))([^<]*)'.replace(/NAME/g, $cW3kI.nameRegexp);
//const tagsRegx = new RegExp("<(\\/?[\\w:\\-\._]+)([^>]*)>(\\s*"+cdataRegx+")*([^<]+)?","g");
//const tagsRegx = new RegExp("<(\\/?)((\\w*:)?([\\w:\\-\._]+))([^>]*)>([^<]*)("+cdataRegx+"([^<]*))*([^<]+)?","g");
//polyfill
if (!Number.parseInt && window.parseInt) Number.parseInt = window.parseInt;
if (!Number.parseFloat && window.parseFloat) Number.parseFloat = window.parseFloat;
const $fe2024f28d56bf4d$var$defaultOptions = {
    attributeNamePrefix: '@_',
    attrNodeName: false,
    textNodeName: '#text',
    ignoreAttributes: true,
    ignoreNameSpace: false,
    allowBooleanAttributes: false,
    //ignoreRootElement : false,
    parseNodeValue: true,
    parseAttributeValue: false,
    arrayMode: false,
    trimValues: true,
    cdataTagName: false,
    cdataPositionChar: '\\c',
    numParseOptions: {
        hex: true,
        leadingZeros: true
    },
    tagValueProcessor: function(a, tagName) {
        return a;
    },
    attrValueProcessor: function(a, attrName) {
        return a;
    },
    stopNodes: [],
    alwaysCreateTextNode: false
};
$fe2024f28d56bf4d$export$ba43bf67f3d48107 = $fe2024f28d56bf4d$var$defaultOptions;
const $fe2024f28d56bf4d$var$props = [
    'attributeNamePrefix',
    'attrNodeName',
    'textNodeName',
    'ignoreAttributes',
    'ignoreNameSpace',
    'allowBooleanAttributes',
    'parseNodeValue',
    'parseAttributeValue',
    'arrayMode',
    'trimValues',
    'cdataTagName',
    'cdataPositionChar',
    'tagValueProcessor',
    'attrValueProcessor',
    'parseTrueNumberOnly',
    'numParseOptions',
    'stopNodes',
    'alwaysCreateTextNode'
];
$fe2024f28d56bf4d$export$8128bb6492cf3de7 = $fe2024f28d56bf4d$var$props;
/**
 * Trim -> valueProcessor -> parse value
 * @param {string} tagName
 * @param {string} val
 * @param {object} options
 */ function $fe2024f28d56bf4d$var$processTagValue(tagName, val, options) {
    if (val) {
        if (options.trimValues) val = val.trim();
        val = options.tagValueProcessor(val, tagName);
        val = $fe2024f28d56bf4d$var$parseValue(val, options.parseNodeValue, options.numParseOptions);
    }
    return val;
}
function $fe2024f28d56bf4d$var$resolveNameSpace(tagname, options) {
    if (options.ignoreNameSpace) {
        const tags = tagname.split(':');
        const prefix = tagname.charAt(0) === '/' ? '/' : '';
        if (tags[0] === 'xmlns') return '';
        if (tags.length === 2) tagname = prefix + tags[1];
    }
    return tagname;
}
function $fe2024f28d56bf4d$var$parseValue(val, shouldParse, options) {
    if (shouldParse && typeof val === 'string') {
        //console.log(options)
        const newval = val.trim();
        if (newval === 'true') return true;
        else if (newval === 'false') return false;
        else return $6e9D4(val, options);
    } else {
        if ($cW3kI.isExist(val)) return val;
        else return '';
    }
}
//TODO: change regex to capture NS
//const attrsRegx = new RegExp("([\\w\\-\\.\\:]+)\\s*=\\s*(['\"])((.|\n)*?)\\2","gm");
const $fe2024f28d56bf4d$var$attrsRegx = new RegExp('([^\\s=]+)\\s*(=\\s*([\'"])(.*?)\\3)?', 'g');
function $fe2024f28d56bf4d$var$buildAttributesMap(attrStr, options) {
    if (!options.ignoreAttributes && typeof attrStr === 'string') {
        attrStr = attrStr.replace(/\r?\n/g, ' ');
        //attrStr = attrStr || attrStr.trim();
        const matches = $cW3kI.getAllMatches(attrStr, $fe2024f28d56bf4d$var$attrsRegx);
        const len = matches.length; //don't make it inline
        const attrs = {};
        for(let i = 0; i < len; i++){
            const attrName = $fe2024f28d56bf4d$var$resolveNameSpace(matches[i][1], options);
            if (attrName.length) {
                if (matches[i][4] !== undefined) {
                    if (options.trimValues) matches[i][4] = matches[i][4].trim();
                    matches[i][4] = options.attrValueProcessor(matches[i][4], attrName);
                    attrs[options.attributeNamePrefix + attrName] = $fe2024f28d56bf4d$var$parseValue(matches[i][4], options.parseAttributeValue, options.numParseOptions);
                } else if (options.allowBooleanAttributes) attrs[options.attributeNamePrefix + attrName] = true;
            }
        }
        if (!Object.keys(attrs).length) return;
        if (options.attrNodeName) {
            const attrCollection = {};
            attrCollection[options.attrNodeName] = attrs;
            return attrCollection;
        }
        return attrs;
    }
}
const $fe2024f28d56bf4d$var$getTraversalObj = function(xmlData, options) {
    xmlData = xmlData.replace(/\r\n?/g, "\n");
    options = $fe2024f28d56bf4d$require$buildOptions(options, $fe2024f28d56bf4d$var$defaultOptions, $fe2024f28d56bf4d$var$props);
    const xmlObj = new $1WG4k('!xml');
    let currentNode = xmlObj;
    let textData = "";
    //function match(xmlData){
    for(let i = 0; i < xmlData.length; i++){
        const ch = xmlData[i];
        if (ch === '<') {
            if (xmlData[i + 1] === '/') {
                const closeIndex = $fe2024f28d56bf4d$var$findClosingIndex(xmlData, ">", i, "Closing Tag is not closed.");
                let tagName = xmlData.substring(i + 2, closeIndex).trim();
                if (options.ignoreNameSpace) {
                    const colonIndex = tagName.indexOf(":");
                    if (colonIndex !== -1) tagName = tagName.substr(colonIndex + 1);
                }
                /* if (currentNode.parent) {
          currentNode.parent.val = util.getValue(currentNode.parent.val) + '' + processTagValue2(tagName, textData , options);
        } */ if (currentNode) {
                    if (currentNode.val) currentNode.val = $cW3kI.getValue(currentNode.val) + '' + $fe2024f28d56bf4d$var$processTagValue(tagName, textData, options);
                    else currentNode.val = $fe2024f28d56bf4d$var$processTagValue(tagName, textData, options);
                }
                if (options.stopNodes.length && options.stopNodes.includes(currentNode.tagname)) {
                    currentNode.child = [];
                    if (currentNode.attrsMap == undefined) currentNode.attrsMap = {};
                    currentNode.val = xmlData.substr(currentNode.startIndex + 1, i - currentNode.startIndex - 1);
                }
                currentNode = currentNode.parent;
                textData = "";
                i = closeIndex;
            } else if (xmlData[i + 1] === '?') i = $fe2024f28d56bf4d$var$findClosingIndex(xmlData, "?>", i, "Pi Tag is not closed.");
            else if (xmlData.substr(i + 1, 3) === '!--') i = $fe2024f28d56bf4d$var$findClosingIndex(xmlData, "-->", i, "Comment is not closed.");
            else if (xmlData.substr(i + 1, 2) === '!D') {
                const closeIndex = $fe2024f28d56bf4d$var$findClosingIndex(xmlData, ">", i, "DOCTYPE is not closed.");
                const tagExp = xmlData.substring(i, closeIndex);
                if (tagExp.indexOf("[") >= 0) i = xmlData.indexOf("]>", i) + 1;
                else i = closeIndex;
            } else if (xmlData.substr(i + 1, 2) === '![') {
                const closeIndex = $fe2024f28d56bf4d$var$findClosingIndex(xmlData, "]]>", i, "CDATA is not closed.") - 2;
                const tagExp = xmlData.substring(i + 9, closeIndex);
                //considerations
                //1. CDATA will always have parent node
                //2. A tag with CDATA is not a leaf node so it's value would be string type.
                if (textData) {
                    currentNode.val = $cW3kI.getValue(currentNode.val) + '' + $fe2024f28d56bf4d$var$processTagValue(currentNode.tagname, textData, options);
                    textData = "";
                }
                if (options.cdataTagName) {
                    //add cdata node
                    const childNode = new $1WG4k(options.cdataTagName, currentNode, tagExp);
                    currentNode.addChild(childNode);
                    //for backtracking
                    currentNode.val = $cW3kI.getValue(currentNode.val) + options.cdataPositionChar;
                    //add rest value to parent node
                    if (tagExp) childNode.val = tagExp;
                } else currentNode.val = (currentNode.val || '') + (tagExp || '');
                i = closeIndex + 2;
            } else {
                const result = $fe2024f28d56bf4d$var$closingIndexForOpeningTag(xmlData, i + 1);
                let tagExp = result.data;
                const closeIndex = result.index;
                const separatorIndex = tagExp.indexOf(" ");
                let tagName = tagExp;
                let shouldBuildAttributesMap = true;
                if (separatorIndex !== -1) {
                    tagName = tagExp.substr(0, separatorIndex).replace(/\s\s*$/, '');
                    tagExp = tagExp.substr(separatorIndex + 1);
                }
                if (options.ignoreNameSpace) {
                    const colonIndex = tagName.indexOf(":");
                    if (colonIndex !== -1) {
                        tagName = tagName.substr(colonIndex + 1);
                        shouldBuildAttributesMap = tagName !== result.data.substr(colonIndex + 1);
                    }
                }
                //save text to parent node
                if (currentNode && textData) {
                    if (currentNode.tagname !== '!xml') currentNode.val = $cW3kI.getValue(currentNode.val) + '' + $fe2024f28d56bf4d$var$processTagValue(currentNode.tagname, textData, options);
                }
                if (tagExp.length > 0 && tagExp.lastIndexOf("/") === tagExp.length - 1) {
                    if (tagName[tagName.length - 1] === "/") {
                        tagName = tagName.substr(0, tagName.length - 1);
                        tagExp = tagName;
                    } else tagExp = tagExp.substr(0, tagExp.length - 1);
                    const childNode = new $1WG4k(tagName, currentNode, '');
                    if (tagName !== tagExp) childNode.attrsMap = $fe2024f28d56bf4d$var$buildAttributesMap(tagExp, options);
                    currentNode.addChild(childNode);
                } else {
                    const childNode = new $1WG4k(tagName, currentNode);
                    if (options.stopNodes.length && options.stopNodes.includes(childNode.tagname)) childNode.startIndex = closeIndex;
                    if (tagName !== tagExp && shouldBuildAttributesMap) childNode.attrsMap = $fe2024f28d56bf4d$var$buildAttributesMap(tagExp, options);
                    currentNode.addChild(childNode);
                    currentNode = childNode;
                }
                textData = "";
                i = closeIndex;
            }
        } else textData += xmlData[i];
    }
    return xmlObj;
};
function $fe2024f28d56bf4d$var$closingIndexForOpeningTag(data, i) {
    let attrBoundary;
    let tagExp = "";
    for(let index = i; index < data.length; index++){
        let ch = data[index];
        if (attrBoundary) {
            if (ch === attrBoundary) attrBoundary = ""; //reset
        } else if (ch === '"' || ch === "'") attrBoundary = ch;
        else if (ch === '>') return {
            data: tagExp,
            index: index
        };
        else if (ch === '\t') ch = " ";
        tagExp += ch;
    }
}
function $fe2024f28d56bf4d$var$findClosingIndex(xmlData, str, i, errMsg) {
    const closingIndex = xmlData.indexOf(str, i);
    if (closingIndex === -1) throw new Error(errMsg);
    else return closingIndex + str.length - 1;
}
$fe2024f28d56bf4d$export$2ca3eb0a2f8a693a = $fe2024f28d56bf4d$var$getTraversalObj;

});
parcelRegister("1WG4k", function(module, exports) {
'use strict';
module.exports = function(tagname, parent, val) {
    this.tagname = tagname;
    this.parent = parent;
    this.child = {}; //child tags
    this.attrsMap = {}; //attributes map
    this.val = val; //text only
    this.addChild = function(child) {
        if (Array.isArray(this.child[child.tagname])) //already presents
        this.child[child.tagname].push(child);
        else this.child[child.tagname] = [
            child
        ];
    };
};

});

parcelRegister("6e9D4", function(module, exports) {
const $012b8a6752cf965b$var$hexRegex = /^[-+]?0x[a-fA-F0-9]+$/;
const $012b8a6752cf965b$var$numRegex = /^([\-\+])?(0*)([0-9]*(\.[0-9]*)?)$/;
// const octRegex = /^0x[a-z0-9]+/;
// const binRegex = /0x[a-z0-9]+/;
const $012b8a6752cf965b$var$consider = {
    hex: true,
    // oct: false,
    leadingZeros: true,
    decimalPoint: "\.",
    eNotation: true
};
function $012b8a6752cf965b$var$toNumber(str, options = {}) {
    options = Object.assign({}, $012b8a6752cf965b$var$consider, options);
    if (!str || typeof str !== "string") return str;
    let trimmedStr = str.trim();
    if (options.skipLike !== undefined && options.skipLike.test(trimmedStr)) return str;
    else if (str === "0") return 0;
    else if (options.hex && $012b8a6752cf965b$var$hexRegex.test(trimmedStr)) return $012b8a6752cf965b$var$parse_int(trimmedStr, 16);
    else if (trimmedStr.search(/[eE]/) !== -1) {
        const notation = trimmedStr.match(/^([-\+])?(0*)([0-9]*(\.[0-9]*)?[eE][-\+]?[0-9]+)$/);
        // +00.123 => [ , '+', '00', '.123', ..
        if (notation) {
            // console.log(notation)
            if (options.leadingZeros) trimmedStr = (notation[1] || "") + notation[3];
            else {
                if (notation[2] === "0" && notation[3][0] === ".") ;
                else return str;
            }
            return options.eNotation ? Number(trimmedStr) : str;
        } else return str;
    // }else if (options.parseBin && binRegex.test(str)) {
    //     return Number.parseInt(val, 2);
    } else {
        //separate negative sign, leading zeros, and rest number
        const match = $012b8a6752cf965b$var$numRegex.exec(trimmedStr);
        // +00.123 => [ , '+', '00', '.123', ..
        if (match) {
            const sign = match[1];
            const leadingZeros = match[2];
            let numTrimmedByZeros = $012b8a6752cf965b$var$trimZeros(match[3]); //complete num without leading zeros
            //trim ending zeros for floating number
            if (!options.leadingZeros && leadingZeros.length > 0 && sign && trimmedStr[2] !== ".") return str; //-0123
            else if (!options.leadingZeros && leadingZeros.length > 0 && !sign && trimmedStr[1] !== ".") return str; //0123
            else if (options.leadingZeros && leadingZeros === str) return 0; //00
            else {
                const num = Number(trimmedStr);
                const numStr = "" + num;
                if (numStr.search(/[eE]/) !== -1) {
                    if (options.eNotation) return num;
                    else return str;
                } else if (trimmedStr.indexOf(".") !== -1) {
                    if (numStr === "0" && numTrimmedByZeros === "") return num; //0.0
                    else if (numStr === numTrimmedByZeros) return num; //0.456. 0.79000
                    else if (sign && numStr === "-" + numTrimmedByZeros) return num;
                    else return str;
                }
                if (leadingZeros) return numTrimmedByZeros === numStr || sign + numTrimmedByZeros === numStr ? num : str;
                else return trimmedStr === numStr || trimmedStr === sign + numStr ? num : str;
            }
        } else return str;
    }
}
/**
 * 
 * @param {string} numStr without leading zeros
 * @returns 
 */ function $012b8a6752cf965b$var$trimZeros(numStr) {
    if (numStr && numStr.indexOf(".") !== -1) {
        numStr = numStr.replace(/0+$/, ""); //remove ending zeros
        if (numStr === ".") numStr = "0";
        else if (numStr[0] === ".") numStr = "0" + numStr;
        else if (numStr[numStr.length - 1] === ".") numStr = numStr.substr(0, numStr.length - 1);
        return numStr;
    }
    return numStr;
}
function $012b8a6752cf965b$var$parse_int(numStr, base) {
    //polyfill
    if (parseInt) return parseInt(numStr, base);
    else if (Number.parseInt) return Number.parseInt(numStr, base);
    else if (window && window.parseInt) return window.parseInt(numStr, base);
    else throw new Error("parseInt, Number.parseInt, window.parseInt are not supported");
}
module.exports = $012b8a6752cf965b$var$toNumber;

});


parcelRegister("egdrK", function(module, exports) {

$parcel$export(module.exports, "validate", () => $a61cfd83910b20ff$export$a22775fa5e2eebd9, (v) => $a61cfd83910b20ff$export$a22775fa5e2eebd9 = v);
//const tagsPattern = new RegExp("<\\/?([\\w:\\-_\.]+)\\s*\/?>","g");
var $a61cfd83910b20ff$export$a22775fa5e2eebd9;
'use strict';

var $cW3kI = parcelRequire("cW3kI");
const $a61cfd83910b20ff$var$defaultOptions = {
    allowBooleanAttributes: false
};
const $a61cfd83910b20ff$var$props = [
    'allowBooleanAttributes'
];
$a61cfd83910b20ff$export$a22775fa5e2eebd9 = function(xmlData, options) {
    options = $cW3kI.buildOptions(options, $a61cfd83910b20ff$var$defaultOptions, $a61cfd83910b20ff$var$props);
    //xmlData = xmlData.replace(/(\r\n|\n|\r)/gm,"");//make it single line
    //xmlData = xmlData.replace(/(^\s*<\?xml.*?\?>)/g,"");//Remove XML starting tag
    //xmlData = xmlData.replace(/(<!DOCTYPE[\s\w\"\.\/\-\:]+(\[.*\])*\s*>)/g,"");//Remove DOCTYPE
    const tags = [];
    let tagFound = false;
    //indicates that the root tag has been closed (aka. depth 0 has been reached)
    let reachedRoot = false;
    if (xmlData[0] === '\ufeff') // check for byte order mark (BOM)
    xmlData = xmlData.substr(1);
    for(let i = 0; i < xmlData.length; i++){
        if (xmlData[i] === '<' && xmlData[i + 1] === '?') {
            i += 2;
            i = $a61cfd83910b20ff$var$readPI(xmlData, i);
            if (i.err) return i;
        } else if (xmlData[i] === '<') {
            //starting of tag
            //read until you reach to '>' avoiding any '>' in attribute value
            let tagStartPos = i;
            i++;
            if (xmlData[i] === '!') {
                i = $a61cfd83910b20ff$var$readCommentAndCDATA(xmlData, i);
                continue;
            } else {
                let closingTag = false;
                if (xmlData[i] === '/') {
                    //closing tag
                    closingTag = true;
                    i++;
                }
                //read tagname
                let tagName = '';
                for(; i < xmlData.length && xmlData[i] !== '>' && xmlData[i] !== ' ' && xmlData[i] !== '\t' && xmlData[i] !== '\n' && xmlData[i] !== '\r'; i++)tagName += xmlData[i];
                tagName = tagName.trim();
                //console.log(tagName);
                if (tagName[tagName.length - 1] === '/') {
                    //self closing tag without attributes
                    tagName = tagName.substring(0, tagName.length - 1);
                    //continue;
                    i--;
                }
                if (!$a61cfd83910b20ff$var$validateTagName(tagName)) {
                    let msg;
                    if (tagName.trim().length === 0) msg = "Invalid space after '<'.";
                    else msg = "Tag '" + tagName + "' is an invalid name.";
                    return $a61cfd83910b20ff$var$getErrorObject('InvalidTag', msg, $a61cfd83910b20ff$var$getLineNumberForPosition(xmlData, i));
                }
                const result = $a61cfd83910b20ff$var$readAttributeStr(xmlData, i);
                if (result === false) return $a61cfd83910b20ff$var$getErrorObject('InvalidAttr', "Attributes for '" + tagName + "' have open quote.", $a61cfd83910b20ff$var$getLineNumberForPosition(xmlData, i));
                let attrStr = result.value;
                i = result.index;
                if (attrStr[attrStr.length - 1] === '/') {
                    //self closing tag
                    const attrStrStart = i - attrStr.length;
                    attrStr = attrStr.substring(0, attrStr.length - 1);
                    const isValid = $a61cfd83910b20ff$var$validateAttributeString(attrStr, options);
                    if (isValid === true) tagFound = true;
                    else //the result from the nested function returns the position of the error within the attribute
                    //in order to get the 'true' error line, we need to calculate the position where the attribute begins (i - attrStr.length) and then add the position within the attribute
                    //this gives us the absolute index in the entire xml, which we can use to find the line at last
                    return $a61cfd83910b20ff$var$getErrorObject(isValid.err.code, isValid.err.msg, $a61cfd83910b20ff$var$getLineNumberForPosition(xmlData, attrStrStart + isValid.err.line));
                } else if (closingTag) {
                    if (!result.tagClosed) return $a61cfd83910b20ff$var$getErrorObject('InvalidTag', "Closing tag '" + tagName + "' doesn't have proper closing.", $a61cfd83910b20ff$var$getLineNumberForPosition(xmlData, i));
                    else if (attrStr.trim().length > 0) return $a61cfd83910b20ff$var$getErrorObject('InvalidTag', "Closing tag '" + tagName + "' can't have attributes or invalid starting.", $a61cfd83910b20ff$var$getLineNumberForPosition(xmlData, tagStartPos));
                    else {
                        const otg = tags.pop();
                        if (tagName !== otg.tagName) {
                            let openPos = $a61cfd83910b20ff$var$getLineNumberForPosition(xmlData, otg.tagStartPos);
                            return $a61cfd83910b20ff$var$getErrorObject('InvalidTag', "Expected closing tag '" + otg.tagName + "' (opened in line " + openPos.line + ", col " + openPos.col + ") instead of closing tag '" + tagName + "'.", $a61cfd83910b20ff$var$getLineNumberForPosition(xmlData, tagStartPos));
                        }
                        //when there are no more tags, we reached the root level.
                        if (tags.length == 0) reachedRoot = true;
                    }
                } else {
                    const isValid = $a61cfd83910b20ff$var$validateAttributeString(attrStr, options);
                    if (isValid !== true) //the result from the nested function returns the position of the error within the attribute
                    //in order to get the 'true' error line, we need to calculate the position where the attribute begins (i - attrStr.length) and then add the position within the attribute
                    //this gives us the absolute index in the entire xml, which we can use to find the line at last
                    return $a61cfd83910b20ff$var$getErrorObject(isValid.err.code, isValid.err.msg, $a61cfd83910b20ff$var$getLineNumberForPosition(xmlData, i - attrStr.length + isValid.err.line));
                    //if the root level has been reached before ...
                    if (reachedRoot === true) return $a61cfd83910b20ff$var$getErrorObject('InvalidXml', 'Multiple possible root nodes found.', $a61cfd83910b20ff$var$getLineNumberForPosition(xmlData, i));
                    else tags.push({
                        tagName: tagName,
                        tagStartPos: tagStartPos
                    });
                    tagFound = true;
                }
                //skip tag text value
                //It may include comments and CDATA value
                for(i++; i < xmlData.length; i++){
                    if (xmlData[i] === '<') {
                        if (xmlData[i + 1] === '!') {
                            //comment or CADATA
                            i++;
                            i = $a61cfd83910b20ff$var$readCommentAndCDATA(xmlData, i);
                            continue;
                        } else if (xmlData[i + 1] === '?') {
                            i = $a61cfd83910b20ff$var$readPI(xmlData, ++i);
                            if (i.err) return i;
                        } else break;
                    } else if (xmlData[i] === '&') {
                        const afterAmp = $a61cfd83910b20ff$var$validateAmpersand(xmlData, i);
                        if (afterAmp == -1) return $a61cfd83910b20ff$var$getErrorObject('InvalidChar', "char '&' is not expected.", $a61cfd83910b20ff$var$getLineNumberForPosition(xmlData, i));
                        i = afterAmp;
                    }
                } //end of reading tag text value
                if (xmlData[i] === '<') i--;
            }
        } else {
            if (xmlData[i] === ' ' || xmlData[i] === '\t' || xmlData[i] === '\n' || xmlData[i] === '\r') continue;
            return $a61cfd83910b20ff$var$getErrorObject('InvalidChar', "char '" + xmlData[i] + "' is not expected.", $a61cfd83910b20ff$var$getLineNumberForPosition(xmlData, i));
        }
    }
    if (!tagFound) return $a61cfd83910b20ff$var$getErrorObject('InvalidXml', 'Start tag expected.', 1);
    else if (tags.length == 1) return $a61cfd83910b20ff$var$getErrorObject('InvalidTag', "Unclosed tag '" + tags[0].tagName + "'.", $a61cfd83910b20ff$var$getLineNumberForPosition(xmlData, tags[0].tagStartPos));
    else if (tags.length > 0) return $a61cfd83910b20ff$var$getErrorObject('InvalidXml', "Invalid '" + JSON.stringify(tags.map((t)=>t.tagName), null, 4).replace(/\r?\n/g, '') + "' found.", {
        line: 1,
        col: 1
    });
    return true;
};
/**
 * Read Processing insstructions and skip
 * @param {*} xmlData
 * @param {*} i
 */ function $a61cfd83910b20ff$var$readPI(xmlData, i) {
    const start = i;
    for(; i < xmlData.length; i++)if (xmlData[i] == '?' || xmlData[i] == ' ') {
        //tagname
        const tagname = xmlData.substr(start, i - start);
        if (i > 5 && tagname === 'xml') return $a61cfd83910b20ff$var$getErrorObject('InvalidXml', 'XML declaration allowed only at the start of the document.', $a61cfd83910b20ff$var$getLineNumberForPosition(xmlData, i));
        else if (xmlData[i] == '?' && xmlData[i + 1] == '>') {
            //check if valid attribut string
            i++;
            break;
        } else continue;
    }
    return i;
}
function $a61cfd83910b20ff$var$readCommentAndCDATA(xmlData, i) {
    if (xmlData.length > i + 5 && xmlData[i + 1] === '-' && xmlData[i + 2] === '-') {
        //comment
        for(i += 3; i < xmlData.length; i++)if (xmlData[i] === '-' && xmlData[i + 1] === '-' && xmlData[i + 2] === '>') {
            i += 2;
            break;
        }
    } else if (xmlData.length > i + 8 && xmlData[i + 1] === 'D' && xmlData[i + 2] === 'O' && xmlData[i + 3] === 'C' && xmlData[i + 4] === 'T' && xmlData[i + 5] === 'Y' && xmlData[i + 6] === 'P' && xmlData[i + 7] === 'E') {
        let angleBracketsCount = 1;
        for(i += 8; i < xmlData.length; i++){
            if (xmlData[i] === '<') angleBracketsCount++;
            else if (xmlData[i] === '>') {
                angleBracketsCount--;
                if (angleBracketsCount === 0) break;
            }
        }
    } else if (xmlData.length > i + 9 && xmlData[i + 1] === '[' && xmlData[i + 2] === 'C' && xmlData[i + 3] === 'D' && xmlData[i + 4] === 'A' && xmlData[i + 5] === 'T' && xmlData[i + 6] === 'A' && xmlData[i + 7] === '[') {
        for(i += 8; i < xmlData.length; i++)if (xmlData[i] === ']' && xmlData[i + 1] === ']' && xmlData[i + 2] === '>') {
            i += 2;
            break;
        }
    }
    return i;
}
const $a61cfd83910b20ff$var$doubleQuote = '"';
const $a61cfd83910b20ff$var$singleQuote = "'";
/**
 * Keep reading xmlData until '<' is found outside the attribute value.
 * @param {string} xmlData
 * @param {number} i
 */ function $a61cfd83910b20ff$var$readAttributeStr(xmlData, i) {
    let attrStr = '';
    let startChar = '';
    let tagClosed = false;
    for(; i < xmlData.length; i++){
        if (xmlData[i] === $a61cfd83910b20ff$var$doubleQuote || xmlData[i] === $a61cfd83910b20ff$var$singleQuote) {
            if (startChar === '') startChar = xmlData[i];
            else if (startChar !== xmlData[i]) ;
            else startChar = '';
        } else if (xmlData[i] === '>') {
            if (startChar === '') {
                tagClosed = true;
                break;
            }
        }
        attrStr += xmlData[i];
    }
    if (startChar !== '') return false;
    return {
        value: attrStr,
        index: i,
        tagClosed: tagClosed
    };
}
/**
 * Select all the attributes whether valid or invalid.
 */ const $a61cfd83910b20ff$var$validAttrStrRegxp = new RegExp('(\\s*)([^\\s=]+)(\\s*=)?(\\s*([\'"])(([\\s\\S])*?)\\5)?', 'g');
//attr, ="sd", a="amit's", a="sd"b="saf", ab  cd=""
function $a61cfd83910b20ff$var$validateAttributeString(attrStr, options) {
    //console.log("start:"+attrStr+":end");
    //if(attrStr.trim().length === 0) return true; //empty string
    const matches = $cW3kI.getAllMatches(attrStr, $a61cfd83910b20ff$var$validAttrStrRegxp);
    const attrNames = {};
    for(let i = 0; i < matches.length; i++){
        if (matches[i][1].length === 0) //nospace before attribute name: a="sd"b="saf"
        return $a61cfd83910b20ff$var$getErrorObject('InvalidAttr', "Attribute '" + matches[i][2] + "' has no space in starting.", $a61cfd83910b20ff$var$getPositionFromMatch(matches[i]));
        else if (matches[i][3] === undefined && !options.allowBooleanAttributes) //independent attribute: ab
        return $a61cfd83910b20ff$var$getErrorObject('InvalidAttr', "boolean attribute '" + matches[i][2] + "' is not allowed.", $a61cfd83910b20ff$var$getPositionFromMatch(matches[i]));
        /* else if(matches[i][6] === undefined){//attribute without value: ab=
                    return { err: { code:"InvalidAttr",msg:"attribute " + matches[i][2] + " has no value assigned."}};
                } */ const attrName = matches[i][2];
        if (!$a61cfd83910b20ff$var$validateAttrName(attrName)) return $a61cfd83910b20ff$var$getErrorObject('InvalidAttr', "Attribute '" + attrName + "' is an invalid name.", $a61cfd83910b20ff$var$getPositionFromMatch(matches[i]));
        if (!attrNames.hasOwnProperty(attrName)) //check for duplicate attribute.
        attrNames[attrName] = 1;
        else return $a61cfd83910b20ff$var$getErrorObject('InvalidAttr', "Attribute '" + attrName + "' is repeated.", $a61cfd83910b20ff$var$getPositionFromMatch(matches[i]));
    }
    return true;
}
function $a61cfd83910b20ff$var$validateNumberAmpersand(xmlData, i) {
    let re = /\d/;
    if (xmlData[i] === 'x') {
        i++;
        re = /[\da-fA-F]/;
    }
    for(; i < xmlData.length; i++){
        if (xmlData[i] === ';') return i;
        if (!xmlData[i].match(re)) break;
    }
    return -1;
}
function $a61cfd83910b20ff$var$validateAmpersand(xmlData, i) {
    // https://www.w3.org/TR/xml/#dt-charref
    i++;
    if (xmlData[i] === ';') return -1;
    if (xmlData[i] === '#') {
        i++;
        return $a61cfd83910b20ff$var$validateNumberAmpersand(xmlData, i);
    }
    let count = 0;
    for(; i < xmlData.length; i++, count++){
        if (xmlData[i].match(/\w/) && count < 20) continue;
        if (xmlData[i] === ';') break;
        return -1;
    }
    return i;
}
function $a61cfd83910b20ff$var$getErrorObject(code, message, lineNumber) {
    return {
        err: {
            code: code,
            msg: message,
            line: lineNumber.line || lineNumber,
            col: lineNumber.col
        }
    };
}
function $a61cfd83910b20ff$var$validateAttrName(attrName) {
    return $cW3kI.isName(attrName);
}
// const startsWithXML = /^xml/i;
function $a61cfd83910b20ff$var$validateTagName(tagname) {
    return $cW3kI.isName(tagname) /* && !tagname.match(startsWithXML) */ ;
}
//this function returns the line number for the character at the given index
function $a61cfd83910b20ff$var$getLineNumberForPosition(xmlData, index) {
    const lines = xmlData.substring(0, index).split(/\r?\n/);
    return {
        line: lines.length,
        // column number is last line's length + 1, because column numbering starts at 1:
        col: lines[lines.length - 1].length + 1
    };
}
//this function returns the position of the first character of match within attrStr
function $a61cfd83910b20ff$var$getPositionFromMatch(match) {
    return match.startIndex + match[1].length;
}

});

parcelRegister("h84ib", function(module, exports) {

$parcel$export(module.exports, "convert2nimn", () => $c7868367b1a9716a$export$fa981bbccf843781, (v) => $c7868367b1a9716a$export$fa981bbccf843781 = v);
var $c7868367b1a9716a$export$fa981bbccf843781;
'use strict';
const $c7868367b1a9716a$var$char = function(a) {
    return String.fromCharCode(a);
};
const $c7868367b1a9716a$var$chars = {
    nilChar: $c7868367b1a9716a$var$char(176),
    missingChar: $c7868367b1a9716a$var$char(201),
    nilPremitive: $c7868367b1a9716a$var$char(175),
    missingPremitive: $c7868367b1a9716a$var$char(200),
    emptyChar: $c7868367b1a9716a$var$char(178),
    emptyValue: $c7868367b1a9716a$var$char(177),
    boundryChar: $c7868367b1a9716a$var$char(179),
    objStart: $c7868367b1a9716a$var$char(198),
    arrStart: $c7868367b1a9716a$var$char(204),
    arrayEnd: $c7868367b1a9716a$var$char(185)
};
const $c7868367b1a9716a$var$charsArr = [
    $c7868367b1a9716a$var$chars.nilChar,
    $c7868367b1a9716a$var$chars.nilPremitive,
    $c7868367b1a9716a$var$chars.missingChar,
    $c7868367b1a9716a$var$chars.missingPremitive,
    $c7868367b1a9716a$var$chars.boundryChar,
    $c7868367b1a9716a$var$chars.emptyChar,
    $c7868367b1a9716a$var$chars.emptyValue,
    $c7868367b1a9716a$var$chars.arrayEnd,
    $c7868367b1a9716a$var$chars.objStart,
    $c7868367b1a9716a$var$chars.arrStart
];
const $c7868367b1a9716a$var$_e = function(node, e_schema, options) {
    if (typeof e_schema === 'string') {
        //premitive
        if (node && node[0] && node[0].val !== undefined) return $c7868367b1a9716a$var$getValue(node[0].val, e_schema);
        else return $c7868367b1a9716a$var$getValue(node, e_schema);
    } else {
        const hasValidData = $c7868367b1a9716a$var$hasData(node);
        if (hasValidData === true) {
            let str = '';
            if (Array.isArray(e_schema)) {
                //attributes can't be repeated. hence check in children tags only
                str += $c7868367b1a9716a$var$chars.arrStart;
                const itemSchema = e_schema[0];
                //const itemSchemaType = itemSchema;
                const arr_len = node.length;
                if (typeof itemSchema === 'string') for(let arr_i = 0; arr_i < arr_len; arr_i++){
                    const r = $c7868367b1a9716a$var$getValue(node[arr_i].val, itemSchema);
                    str = $c7868367b1a9716a$var$processValue(str, r);
                }
                else for(let arr_i = 0; arr_i < arr_len; arr_i++){
                    const r = $c7868367b1a9716a$var$_e(node[arr_i], itemSchema, options);
                    str = $c7868367b1a9716a$var$processValue(str, r);
                }
                str += $c7868367b1a9716a$var$chars.arrayEnd; //indicates that next item is not array item
            } else {
                //object
                str += $c7868367b1a9716a$var$chars.objStart;
                const keys = Object.keys(e_schema);
                if (Array.isArray(node)) node = node[0];
                for(let i in keys){
                    const key = keys[i];
                    //a property defined in schema can be present either in attrsMap or children tags
                    //options.textNodeName will not present in both maps, take it's value from val
                    //options.attrNodeName will be present in attrsMap
                    let r;
                    if (!options.ignoreAttributes && node.attrsMap && node.attrsMap[key]) r = $c7868367b1a9716a$var$_e(node.attrsMap[key], e_schema[key], options);
                    else if (key === options.textNodeName) r = $c7868367b1a9716a$var$_e(node.val, e_schema[key], options);
                    else r = $c7868367b1a9716a$var$_e(node.child[key], e_schema[key], options);
                    str = $c7868367b1a9716a$var$processValue(str, r);
                }
            }
            return str;
        } else return hasValidData;
    }
};
const $c7868367b1a9716a$var$getValue = function(a /*, type*/ ) {
    switch(a){
        case undefined:
            return $c7868367b1a9716a$var$chars.missingPremitive;
        case null:
            return $c7868367b1a9716a$var$chars.nilPremitive;
        case '':
            return $c7868367b1a9716a$var$chars.emptyValue;
        default:
            return a;
    }
};
const $c7868367b1a9716a$var$processValue = function(str, r) {
    if (!$c7868367b1a9716a$var$isAppChar(r[0]) && !$c7868367b1a9716a$var$isAppChar(str[str.length - 1])) str += $c7868367b1a9716a$var$chars.boundryChar;
    return str + r;
};
const $c7868367b1a9716a$var$isAppChar = function(ch) {
    return $c7868367b1a9716a$var$charsArr.indexOf(ch) !== -1;
};
function $c7868367b1a9716a$var$hasData(jObj) {
    if (jObj === undefined) return $c7868367b1a9716a$var$chars.missingChar;
    else if (jObj === null) return $c7868367b1a9716a$var$chars.nilChar;
    else if (jObj.child && Object.keys(jObj.child).length === 0 && (!jObj.attrsMap || Object.keys(jObj.attrsMap).length === 0)) return $c7868367b1a9716a$var$chars.emptyChar;
    else return true;
}

var $lOHFL = parcelRequire("lOHFL");

var $cW3kI = parcelRequire("cW3kI");
var $c7868367b1a9716a$require$buildOptions = $cW3kI.buildOptions;
const $c7868367b1a9716a$var$convert2nimn = function(node, e_schema, options) {
    options = $c7868367b1a9716a$require$buildOptions(options, $lOHFL.defaultOptions, $lOHFL.props);
    return $c7868367b1a9716a$var$_e(node, e_schema, options);
};
$c7868367b1a9716a$export$fa981bbccf843781 = $c7868367b1a9716a$var$convert2nimn;

});

parcelRegister("4CvqR", function(module, exports) {

$parcel$export(module.exports, "convertToJsonString", () => $35d317d7d6d4bc17$export$54ffaacfc0931fb0, (v) => $35d317d7d6d4bc17$export$54ffaacfc0931fb0 = v);
var $35d317d7d6d4bc17$export$54ffaacfc0931fb0;
'use strict';

var $cW3kI = parcelRequire("cW3kI");

var $cW3kI = parcelRequire("cW3kI");
var $35d317d7d6d4bc17$require$buildOptions = $cW3kI.buildOptions;

var $lOHFL = parcelRequire("lOHFL");
//TODO: do it later
const $35d317d7d6d4bc17$var$convertToJsonString = function(node, options) {
    options = $35d317d7d6d4bc17$require$buildOptions(options, $lOHFL.defaultOptions, $lOHFL.props);
    options.indentBy = options.indentBy || '';
    return $35d317d7d6d4bc17$var$_cToJsonStr(node, options, 0);
};
const $35d317d7d6d4bc17$var$_cToJsonStr = function(node, options, level) {
    let jObj = '{';
    //traver through all the children
    const keys = Object.keys(node.child);
    for(let index = 0; index < keys.length; index++){
        const tagname = keys[index];
        if (node.child[tagname] && node.child[tagname].length > 1) {
            jObj += '"' + tagname + '" : [ ';
            for(let tag in node.child[tagname])jObj += $35d317d7d6d4bc17$var$_cToJsonStr(node.child[tagname][tag], options) + ' , ';
            jObj = jObj.substr(0, jObj.length - 1) + ' ] '; //remove extra comma in last
        } else jObj += '"' + tagname + '" : ' + $35d317d7d6d4bc17$var$_cToJsonStr(node.child[tagname][0], options) + ' ,';
    }
    $cW3kI.merge(jObj, node.attrsMap);
    //add attrsMap as new children
    if ($cW3kI.isEmptyObject(jObj)) return $cW3kI.isExist(node.val) ? node.val : '';
    else {
        if ($cW3kI.isExist(node.val)) {
            if (!(typeof node.val === 'string' && (node.val === '' || node.val === options.cdataPositionChar))) jObj += '"' + options.textNodeName + '" : ' + $35d317d7d6d4bc17$var$stringval(node.val);
        }
    }
    //add value
    if (jObj[jObj.length - 1] === ',') jObj = jObj.substr(0, jObj.length - 2);
    return jObj + '}';
};
function $35d317d7d6d4bc17$var$stringval(v) {
    if (v === true || v === false || !isNaN(v)) return v;
    else return '"' + v + '"';
}
function $35d317d7d6d4bc17$var$indentate(options, level) {
    return options.indentBy.repeat(level);
}
$35d317d7d6d4bc17$export$54ffaacfc0931fb0 = $35d317d7d6d4bc17$var$convertToJsonString;

});

parcelRegister("a4Ot5", function(module, exports) {
'use strict';

var $cW3kI = parcelRequire("cW3kI");
var $75616d01b478cb6c$require$buildOptions = $cW3kI.buildOptions;
const $75616d01b478cb6c$var$defaultOptions = {
    attributeNamePrefix: '@_',
    attrNodeName: false,
    textNodeName: '#text',
    ignoreAttributes: true,
    cdataTagName: false,
    cdataPositionChar: '\\c',
    format: false,
    indentBy: '  ',
    supressEmptyNode: false,
    tagValueProcessor: function(a) {
        return a;
    },
    attrValueProcessor: function(a) {
        return a;
    }
};
const $75616d01b478cb6c$var$props = [
    'attributeNamePrefix',
    'attrNodeName',
    'textNodeName',
    'ignoreAttributes',
    'cdataTagName',
    'cdataPositionChar',
    'format',
    'indentBy',
    'supressEmptyNode',
    'tagValueProcessor',
    'attrValueProcessor',
    'rootNodeName'
];
function $75616d01b478cb6c$var$Parser(options) {
    this.options = $75616d01b478cb6c$require$buildOptions(options, $75616d01b478cb6c$var$defaultOptions, $75616d01b478cb6c$var$props);
    if (this.options.ignoreAttributes || this.options.attrNodeName) this.isAttribute = function() {
        return false;
    };
    else {
        this.attrPrefixLen = this.options.attributeNamePrefix.length;
        this.isAttribute = $75616d01b478cb6c$var$isAttribute;
    }
    if (this.options.cdataTagName) this.isCDATA = $75616d01b478cb6c$var$isCDATA;
    else this.isCDATA = function() {
        return false;
    };
    this.replaceCDATAstr = $75616d01b478cb6c$var$replaceCDATAstr;
    this.replaceCDATAarr = $75616d01b478cb6c$var$replaceCDATAarr;
    this.processTextOrObjNode = $75616d01b478cb6c$var$processTextOrObjNode;
    if (this.options.format) {
        this.indentate = $75616d01b478cb6c$var$indentate;
        this.tagEndChar = '>\n';
        this.newLine = '\n';
    } else {
        this.indentate = function() {
            return '';
        };
        this.tagEndChar = '>';
        this.newLine = '';
    }
    if (this.options.supressEmptyNode) {
        this.buildTextNode = $75616d01b478cb6c$var$buildEmptyTextNode;
        this.buildObjNode = $75616d01b478cb6c$var$buildEmptyObjNode;
    } else {
        this.buildTextNode = $75616d01b478cb6c$var$buildTextValNode;
        this.buildObjNode = $75616d01b478cb6c$var$buildObjectNode;
    }
    this.buildTextValNode = $75616d01b478cb6c$var$buildTextValNode;
    this.buildObjectNode = $75616d01b478cb6c$var$buildObjectNode;
}
$75616d01b478cb6c$var$Parser.prototype.parse = function(jObj) {
    if (Array.isArray(jObj) && this.options.rootNodeName && this.options.rootNodeName.length > 1) jObj = {
        [this.options.rootNodeName]: jObj
    };
    return this.j2x(jObj, 0).val;
};
$75616d01b478cb6c$var$Parser.prototype.j2x = function(jObj, level) {
    let attrStr = '';
    let val = '';
    for(let key in jObj){
        if (typeof jObj[key] === 'undefined') ;
        else if (jObj[key] === null) val += this.indentate(level) + '<' + key + '/' + this.tagEndChar;
        else if (jObj[key] instanceof Date) val += this.buildTextNode(jObj[key], key, '', level);
        else if (typeof jObj[key] !== 'object') {
            //premitive type
            const attr = this.isAttribute(key);
            if (attr) attrStr += ' ' + attr + '="' + this.options.attrValueProcessor('' + jObj[key]) + '"';
            else if (this.isCDATA(key)) {
                if (jObj[this.options.textNodeName]) val += this.replaceCDATAstr(jObj[this.options.textNodeName], jObj[key]);
                else val += this.replaceCDATAstr('', jObj[key]);
            } else //tag value
            if (key === this.options.textNodeName) {
                if (jObj[this.options.cdataTagName]) ;
                else val += this.options.tagValueProcessor('' + jObj[key]);
            } else val += this.buildTextNode(jObj[key], key, '', level);
        } else if (Array.isArray(jObj[key])) {
            //repeated nodes
            if (this.isCDATA(key)) {
                val += this.indentate(level);
                if (jObj[this.options.textNodeName]) val += this.replaceCDATAarr(jObj[this.options.textNodeName], jObj[key]);
                else val += this.replaceCDATAarr('', jObj[key]);
            } else {
                //nested nodes
                const arrLen = jObj[key].length;
                for(let j = 0; j < arrLen; j++){
                    const item = jObj[key][j];
                    if (typeof item === 'undefined') ;
                    else if (item === null) val += this.indentate(level) + '<' + key + '/' + this.tagEndChar;
                    else if (typeof item === 'object') val += this.processTextOrObjNode(item, key, level);
                    else val += this.buildTextNode(item, key, '', level);
                }
            }
        } else //nested node
        if (this.options.attrNodeName && key === this.options.attrNodeName) {
            const Ks = Object.keys(jObj[key]);
            const L = Ks.length;
            for(let j = 0; j < L; j++)attrStr += ' ' + Ks[j] + '="' + this.options.attrValueProcessor('' + jObj[key][Ks[j]]) + '"';
        } else val += this.processTextOrObjNode(jObj[key], key, level);
    }
    return {
        attrStr: attrStr,
        val: val
    };
};
function $75616d01b478cb6c$var$processTextOrObjNode(object, key, level) {
    const result = this.j2x(object, level + 1);
    if (object[this.options.textNodeName] !== undefined && Object.keys(object).length === 1) return this.buildTextNode(result.val, key, result.attrStr, level);
    else return this.buildObjNode(result.val, key, result.attrStr, level);
}
function $75616d01b478cb6c$var$replaceCDATAstr(str, cdata) {
    str = this.options.tagValueProcessor('' + str);
    if (this.options.cdataPositionChar === '' || str === '') return str + '<![CDATA[' + cdata + ']]' + this.tagEndChar;
    else return str.replace(this.options.cdataPositionChar, '<![CDATA[' + cdata + ']]' + this.tagEndChar);
}
function $75616d01b478cb6c$var$replaceCDATAarr(str, cdata) {
    str = this.options.tagValueProcessor('' + str);
    if (this.options.cdataPositionChar === '' || str === '') return str + '<![CDATA[' + cdata.join(']]><![CDATA[') + ']]' + this.tagEndChar;
    else {
        for(let v in cdata)str = str.replace(this.options.cdataPositionChar, '<![CDATA[' + cdata[v] + ']]>');
        return str + this.newLine;
    }
}
function $75616d01b478cb6c$var$buildObjectNode(val, key, attrStr, level) {
    if (attrStr && val.indexOf('<') === -1) return this.indentate(level) + '<' + key + attrStr + '>' + val + //+ this.newLine
    // + this.indentate(level)
    '</' + key + this.tagEndChar;
    else return this.indentate(level) + '<' + key + attrStr + this.tagEndChar + val + //+ this.newLine
    this.indentate(level) + '</' + key + this.tagEndChar;
}
function $75616d01b478cb6c$var$buildEmptyObjNode(val, key, attrStr, level) {
    if (val !== '') return this.buildObjectNode(val, key, attrStr, level);
    else return this.indentate(level) + '<' + key + attrStr + '/' + this.tagEndChar;
}
function $75616d01b478cb6c$var$buildTextValNode(val, key, attrStr, level) {
    return this.indentate(level) + '<' + key + attrStr + '>' + this.options.tagValueProcessor(val) + '</' + key + this.tagEndChar;
}
function $75616d01b478cb6c$var$buildEmptyTextNode(val, key, attrStr, level) {
    if (val !== '') return this.buildTextValNode(val, key, attrStr, level);
    else return this.indentate(level) + '<' + key + attrStr + '/' + this.tagEndChar;
}
function $75616d01b478cb6c$var$indentate(level) {
    return this.options.indentBy.repeat(level);
}
function $75616d01b478cb6c$var$isAttribute(name /*, options*/ ) {
    if (name.startsWith(this.options.attributeNamePrefix)) return name.substr(this.attrPrefixLen);
    else return false;
}
function $75616d01b478cb6c$var$isCDATA(name) {
    return name === this.options.cdataTagName;
}
//formatting
//indentation
//\n after each closing or self closing tag
module.exports = $75616d01b478cb6c$var$Parser;

});



parcelRegister("dLiz3", function(module, exports) {
$parcel$export(module.exports, "getBucketEndpointPlugin", () => (parcelRequire("ifNwy")).getBucketEndpointPlugin);
$parcel$export(module.exports, "resolveBucketEndpointConfig", () => (parcelRequire("hQ5uE")).resolveBucketEndpointConfig);
parcelRequire("ifNwy");
parcelRequire("dZHnV");
parcelRequire("hQ5uE");

var $6uzAS = parcelRequire("6uzAS");

});
parcelRegister("ifNwy", function(module, exports) {

$parcel$export(module.exports, "getBucketEndpointPlugin", () => $d4a00b2620dc274a$export$6b750e866330f2fe);

var $hoCLj = parcelRequire("hoCLj");
parcelRequire("3uM9B");
var $dlqaT = parcelRequire("dlqaT");

var $6YlM1 = parcelRequire("6YlM1");

var $dZHnV = parcelRequire("dZHnV");

var $6uzAS = parcelRequire("6uzAS");
var $d4a00b2620dc274a$export$f49f3b47ec112939 = function(options) {
    return function(next, context) {
        return function(args) {
            return (0, $hoCLj.__awaiter)(void 0, void 0, void 0, function() {
                var bucketName, replaceBucketInPath, request, bucketArn, clientRegion, _a, _b, partition, _c, signingRegion, useArnRegion, _d, hostname, bucketEndpoint, modifiedSigningRegion, signingService, clientRegion, _e, _f, hostname, bucketEndpoint;
                return (0, $hoCLj.__generator)(this, function(_g) {
                    switch(_g.label){
                        case 0:
                            bucketName = args.input.Bucket;
                            replaceBucketInPath = options.bucketEndpoint;
                            request = args.request;
                            if (!(0, $dlqaT.HttpRequest).isInstance(request)) return [
                                3 /*break*/ ,
                                8
                            ];
                            if (!options.bucketEndpoint) return [
                                3 /*break*/ ,
                                1
                            ];
                            request.hostname = bucketName;
                            return [
                                3 /*break*/ ,
                                7
                            ];
                        case 1:
                            if (!(0, $6YlM1.validate)(bucketName)) return [
                                3 /*break*/ ,
                                5
                            ];
                            bucketArn = (0, $6YlM1.parse)(bucketName);
                            _a = (0, $6uzAS.getPseudoRegion);
                            return [
                                4 /*yield*/ ,
                                options.region()
                            ];
                        case 2:
                            clientRegion = _a.apply(void 0, [
                                _g.sent()
                            ]);
                            return [
                                4 /*yield*/ ,
                                options.regionInfoProvider(clientRegion)
                            ];
                        case 3:
                            _b = _g.sent() || {}, partition = _b.partition, _c = _b.signingRegion, signingRegion = _c === void 0 ? clientRegion : _c;
                            return [
                                4 /*yield*/ ,
                                options.useArnRegion()
                            ];
                        case 4:
                            useArnRegion = _g.sent();
                            _d = (0, $dZHnV.bucketHostname)({
                                bucketName: bucketArn,
                                baseHostname: request.hostname,
                                accelerateEndpoint: options.useAccelerateEndpoint,
                                dualstackEndpoint: options.useDualstackEndpoint,
                                pathStyleEndpoint: options.forcePathStyle,
                                tlsCompatible: request.protocol === "https:",
                                useArnRegion: useArnRegion,
                                clientPartition: partition,
                                clientSigningRegion: signingRegion,
                                clientRegion: clientRegion,
                                isCustomEndpoint: options.isCustomEndpoint
                            }), hostname = _d.hostname, bucketEndpoint = _d.bucketEndpoint, modifiedSigningRegion = _d.signingRegion, signingService = _d.signingService;
                            // If the request needs to use a region or service name inferred from ARN that different from client region, we
                            // need to set them in the handler context so the signer will use them
                            if (modifiedSigningRegion && modifiedSigningRegion !== signingRegion) context["signing_region"] = modifiedSigningRegion;
                            if (signingService && signingService !== "s3") context["signing_service"] = signingService;
                            request.hostname = hostname;
                            replaceBucketInPath = bucketEndpoint;
                            return [
                                3 /*break*/ ,
                                7
                            ];
                        case 5:
                            _e = (0, $6uzAS.getPseudoRegion);
                            return [
                                4 /*yield*/ ,
                                options.region()
                            ];
                        case 6:
                            clientRegion = _e.apply(void 0, [
                                _g.sent()
                            ]);
                            _f = (0, $dZHnV.bucketHostname)({
                                bucketName: bucketName,
                                clientRegion: clientRegion,
                                baseHostname: request.hostname,
                                accelerateEndpoint: options.useAccelerateEndpoint,
                                dualstackEndpoint: options.useDualstackEndpoint,
                                pathStyleEndpoint: options.forcePathStyle,
                                tlsCompatible: request.protocol === "https:",
                                isCustomEndpoint: options.isCustomEndpoint
                            }), hostname = _f.hostname, bucketEndpoint = _f.bucketEndpoint;
                            request.hostname = hostname;
                            replaceBucketInPath = bucketEndpoint;
                            _g.label = 7;
                        case 7:
                            if (replaceBucketInPath) {
                                request.path = request.path.replace(/^(\/)?[^\/]+/, "");
                                if (request.path === "") request.path = "/";
                            }
                            _g.label = 8;
                        case 8:
                            return [
                                2 /*return*/ ,
                                next((0, $hoCLj.__assign)((0, $hoCLj.__assign)({}, args), {
                                    request: request
                                }))
                            ];
                    }
                });
            });
        };
    };
};
var $d4a00b2620dc274a$export$3912e6e4bed18209 = {
    tags: [
        "BUCKET_ENDPOINT"
    ],
    name: "bucketEndpointMiddleware",
    relation: "before",
    toMiddleware: "hostHeaderMiddleware",
    override: true
};
var $d4a00b2620dc274a$export$6b750e866330f2fe = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.addRelativeTo($d4a00b2620dc274a$export$f49f3b47ec112939(options), $d4a00b2620dc274a$export$3912e6e4bed18209);
        }
    };
};

});
parcelRegister("hoCLj", function(module, exports) {

$parcel$export(module.exports, "__assign", () => $caa2beeb6624d753$export$18ce0697a983be9b);
$parcel$export(module.exports, "__awaiter", () => $caa2beeb6624d753$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $caa2beeb6624d753$export$67ebef60e6f28a6);
$parcel$export(module.exports, "__read", () => $caa2beeb6624d753$export$8d051b38c9118094);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $caa2beeb6624d753$var$extendStatics = function(d, b) {
    $caa2beeb6624d753$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $caa2beeb6624d753$var$extendStatics(d, b);
};
function $caa2beeb6624d753$export$a8ba968b8961cb8a(d, b) {
    $caa2beeb6624d753$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $caa2beeb6624d753$export$18ce0697a983be9b = function() {
    $caa2beeb6624d753$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $caa2beeb6624d753$export$18ce0697a983be9b.apply(this, arguments);
};
function $caa2beeb6624d753$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $caa2beeb6624d753$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $caa2beeb6624d753$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $caa2beeb6624d753$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $caa2beeb6624d753$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $caa2beeb6624d753$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $caa2beeb6624d753$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $caa2beeb6624d753$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $caa2beeb6624d753$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $caa2beeb6624d753$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $caa2beeb6624d753$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($caa2beeb6624d753$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $caa2beeb6624d753$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $caa2beeb6624d753$export$10c90e4f7922046c(v) {
    return this instanceof $caa2beeb6624d753$export$10c90e4f7922046c ? (this.v = v, this) : new $caa2beeb6624d753$export$10c90e4f7922046c(v);
}
function $caa2beeb6624d753$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $caa2beeb6624d753$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $caa2beeb6624d753$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $caa2beeb6624d753$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $caa2beeb6624d753$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $caa2beeb6624d753$export$19a8beecd37a4c45 === "function" ? $caa2beeb6624d753$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $caa2beeb6624d753$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $caa2beeb6624d753$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $caa2beeb6624d753$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $caa2beeb6624d753$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $caa2beeb6624d753$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("6YlM1", function(module, exports) {

$parcel$export(module.exports, "validate", () => $51393c77b824cb99$export$a22775fa5e2eebd9);
$parcel$export(module.exports, "parse", () => $51393c77b824cb99$export$98e6a39c04603d36);

var $2QWyN = parcelRequire("2QWyN");
var $51393c77b824cb99$export$a22775fa5e2eebd9 = function(str) {
    return typeof str === "string" && str.indexOf("arn:") === 0 && str.split(":").length >= 6;
};
var $51393c77b824cb99$export$98e6a39c04603d36 = function(arn) {
    var segments = arn.split(":");
    if (segments.length < 6 || segments[0] !== "arn") throw new Error("Malformed ARN");
    var _a = (0, $2QWyN.__read)(segments), //Skip "arn" literal
    partition = _a[1], service = _a[2], region = _a[3], accountId = _a[4], resource = _a.slice(5);
    return {
        partition: partition,
        service: service,
        region: region,
        accountId: accountId,
        resource: resource.join(":")
    };
};
var $51393c77b824cb99$export$3f8fe6489e95757d = function(arnObject) {
    var _a = arnObject.partition, partition = _a === void 0 ? "aws" : _a, service = arnObject.service, region = arnObject.region, accountId = arnObject.accountId, resource = arnObject.resource;
    if ([
        service,
        region,
        accountId,
        resource
    ].some(function(segment) {
        return typeof segment !== "string";
    })) throw new Error("Input ARN object is invalid");
    return "arn:" + partition + ":" + service + ":" + region + ":" + accountId + ":" + resource;
};

});
parcelRegister("2QWyN", function(module, exports) {

$parcel$export(module.exports, "__read", () => $213ddcf2e1e58aba$export$8d051b38c9118094);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $213ddcf2e1e58aba$var$extendStatics = function(d, b) {
    $213ddcf2e1e58aba$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $213ddcf2e1e58aba$var$extendStatics(d, b);
};
function $213ddcf2e1e58aba$export$a8ba968b8961cb8a(d, b) {
    $213ddcf2e1e58aba$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $213ddcf2e1e58aba$export$18ce0697a983be9b = function() {
    $213ddcf2e1e58aba$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $213ddcf2e1e58aba$export$18ce0697a983be9b.apply(this, arguments);
};
function $213ddcf2e1e58aba$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $213ddcf2e1e58aba$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $213ddcf2e1e58aba$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $213ddcf2e1e58aba$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $213ddcf2e1e58aba$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $213ddcf2e1e58aba$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $213ddcf2e1e58aba$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $213ddcf2e1e58aba$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $213ddcf2e1e58aba$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $213ddcf2e1e58aba$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $213ddcf2e1e58aba$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($213ddcf2e1e58aba$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $213ddcf2e1e58aba$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $213ddcf2e1e58aba$export$10c90e4f7922046c(v) {
    return this instanceof $213ddcf2e1e58aba$export$10c90e4f7922046c ? (this.v = v, this) : new $213ddcf2e1e58aba$export$10c90e4f7922046c(v);
}
function $213ddcf2e1e58aba$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $213ddcf2e1e58aba$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $213ddcf2e1e58aba$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $213ddcf2e1e58aba$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $213ddcf2e1e58aba$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $213ddcf2e1e58aba$export$19a8beecd37a4c45 === "function" ? $213ddcf2e1e58aba$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $213ddcf2e1e58aba$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $213ddcf2e1e58aba$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $213ddcf2e1e58aba$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $213ddcf2e1e58aba$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $213ddcf2e1e58aba$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});


parcelRegister("dZHnV", function(module, exports) {

$parcel$export(module.exports, "bucketHostname", () => $a302a038aef290fc$export$92dc36ff3a4794f7);

var $hoCLj = parcelRequire("hoCLj");

var $6uzAS = parcelRequire("6uzAS");
var $a302a038aef290fc$export$92dc36ff3a4794f7 = function(options) {
    var isCustomEndpoint = options.isCustomEndpoint, baseHostname = options.baseHostname, dualstackEndpoint = options.dualstackEndpoint, accelerateEndpoint = options.accelerateEndpoint;
    if (isCustomEndpoint) {
        if (dualstackEndpoint) throw new Error("Dualstack endpoint is not supported with custom endpoint");
        if (accelerateEndpoint) throw new Error("Accelerate endpoint is not supported with custom endpoint");
    }
    return (0, $6uzAS.isBucketNameOptions)(options) ? $a302a038aef290fc$var$getEndpointFromBucketName((0, $hoCLj.__assign)((0, $hoCLj.__assign)({}, options), {
        isCustomEndpoint: isCustomEndpoint
    })) : $a302a038aef290fc$var$getEndpointFromArn((0, $hoCLj.__assign)((0, $hoCLj.__assign)({}, options), {
        isCustomEndpoint: isCustomEndpoint
    }));
};
var $a302a038aef290fc$var$getEndpointFromArn = function(options) {
    var isCustomEndpoint = options.isCustomEndpoint, baseHostname = options.baseHostname;
    var _a = (0, $hoCLj.__read)(isCustomEndpoint ? [
        options.clientRegion,
        baseHostname
    ] : (0, $6uzAS.getSuffixForArnEndpoint)(baseHostname), 2), clientRegion = _a[0], hostnameSuffix = _a[1];
    var pathStyleEndpoint = options.pathStyleEndpoint, _b = options.dualstackEndpoint, dualstackEndpoint = _b === void 0 ? false : _b, _c = options.accelerateEndpoint, accelerateEndpoint = _c === void 0 ? false : _c, _d = options.tlsCompatible, tlsCompatible = _d === void 0 ? true : _d, useArnRegion = options.useArnRegion, bucketName = options.bucketName, _e = options.clientPartition, clientPartition = _e === void 0 ? "aws" : _e, _f = options.clientSigningRegion, clientSigningRegion = _f === void 0 ? clientRegion : _f;
    (0, $6uzAS.validateArnEndpointOptions)({
        pathStyleEndpoint: pathStyleEndpoint,
        accelerateEndpoint: accelerateEndpoint,
        tlsCompatible: tlsCompatible
    });
    // Validate and parse the ARN supplied as a bucket name
    var service = bucketName.service, partition = bucketName.partition, accountId = bucketName.accountId, region = bucketName.region, resource = bucketName.resource;
    (0, $6uzAS.validateService)(service);
    (0, $6uzAS.validatePartition)(partition, {
        clientPartition: clientPartition
    });
    (0, $6uzAS.validateAccountId)(accountId);
    (0, $6uzAS.validateRegion)(region, {
        useArnRegion: useArnRegion,
        clientRegion: clientRegion,
        clientSigningRegion: clientSigningRegion
    });
    var _g = (0, $6uzAS.getArnResources)(resource), accesspointName = _g.accesspointName, outpostId = _g.outpostId;
    (0, $6uzAS.validateDNSHostLabel)(accesspointName + "-" + accountId, {
        tlsCompatible: tlsCompatible
    });
    var endpointRegion = useArnRegion ? region : clientRegion;
    var signingRegion = useArnRegion ? region : clientSigningRegion;
    if (outpostId) {
        // if this is an Outpost ARN
        (0, $6uzAS.validateOutpostService)(service);
        (0, $6uzAS.validateDNSHostLabel)(outpostId, {
            tlsCompatible: tlsCompatible
        });
        (0, $6uzAS.validateNoDualstack)(dualstackEndpoint);
        (0, $6uzAS.validateNoFIPS)(endpointRegion);
        var hostnamePrefix_1 = accesspointName + "-" + accountId + "." + outpostId;
        return {
            bucketEndpoint: true,
            hostname: "" + hostnamePrefix_1 + (isCustomEndpoint ? "" : ".s3-outposts." + endpointRegion) + "." + hostnameSuffix,
            signingRegion: signingRegion,
            signingService: "s3-outposts"
        };
    }
    // construct endpoint from Accesspoint ARN
    (0, $6uzAS.validateS3Service)(service);
    var hostnamePrefix = accesspointName + "-" + accountId;
    return {
        bucketEndpoint: true,
        hostname: "" + hostnamePrefix + (isCustomEndpoint ? "" : ".s3-accesspoint" + (dualstackEndpoint ? ".dualstack" : "") + "." + endpointRegion) + "." + hostnameSuffix,
        signingRegion: signingRegion
    };
};
var $a302a038aef290fc$var$getEndpointFromBucketName = function(_a) {
    var _b = _a.accelerateEndpoint, accelerateEndpoint = _b === void 0 ? false : _b, region = _a.clientRegion, baseHostname = _a.baseHostname, bucketName = _a.bucketName, _c = _a.dualstackEndpoint, dualstackEndpoint = _c === void 0 ? false : _c, _d = _a.pathStyleEndpoint, pathStyleEndpoint = _d === void 0 ? false : _d, _e = _a.tlsCompatible, tlsCompatible = _e === void 0 ? true : _e, _f = _a.isCustomEndpoint, isCustomEndpoint = _f === void 0 ? false : _f;
    var _g = (0, $hoCLj.__read)(isCustomEndpoint ? [
        region,
        baseHostname
    ] : (0, $6uzAS.getSuffix)(baseHostname), 2), clientRegion = _g[0], hostnameSuffix = _g[1];
    if (pathStyleEndpoint || !(0, $6uzAS.isDnsCompatibleBucketName)(bucketName) || tlsCompatible && (0, $6uzAS.DOT_PATTERN).test(bucketName)) return {
        bucketEndpoint: false,
        hostname: dualstackEndpoint ? "s3.dualstack." + clientRegion + "." + hostnameSuffix : baseHostname
    };
    if (accelerateEndpoint) baseHostname = "s3-accelerate" + (dualstackEndpoint ? ".dualstack" : "") + "." + hostnameSuffix;
    else if (dualstackEndpoint) baseHostname = "s3.dualstack." + clientRegion + "." + hostnameSuffix;
    return {
        bucketEndpoint: true,
        hostname: bucketName + "." + baseHostname
    };
};

});
parcelRegister("6uzAS", function(module, exports) {

$parcel$export(module.exports, "DOT_PATTERN", () => $4ba1279fd8799b23$export$b0b24e5455be29b0);
$parcel$export(module.exports, "isBucketNameOptions", () => $4ba1279fd8799b23$export$5b522ec9d0d23583);
$parcel$export(module.exports, "getPseudoRegion", () => $4ba1279fd8799b23$export$2041e7d2db741fc6);
$parcel$export(module.exports, "isDnsCompatibleBucketName", () => $4ba1279fd8799b23$export$360a1e07839d0d27);
$parcel$export(module.exports, "getSuffix", () => $4ba1279fd8799b23$export$661d620f7edbf69d);
$parcel$export(module.exports, "getSuffixForArnEndpoint", () => $4ba1279fd8799b23$export$9822f1db281a24ef);
$parcel$export(module.exports, "validateArnEndpointOptions", () => $4ba1279fd8799b23$export$9d570635889bea10);
$parcel$export(module.exports, "validateService", () => $4ba1279fd8799b23$export$56395344d8f6da92);
$parcel$export(module.exports, "validateS3Service", () => $4ba1279fd8799b23$export$ee796dc843960f7e);
$parcel$export(module.exports, "validateOutpostService", () => $4ba1279fd8799b23$export$32ff3a9330dbd031);
$parcel$export(module.exports, "validatePartition", () => $4ba1279fd8799b23$export$2514cb957fb286b);
$parcel$export(module.exports, "validateRegion", () => $4ba1279fd8799b23$export$6cc2fb0ca7159d47);
$parcel$export(module.exports, "validateAccountId", () => $4ba1279fd8799b23$export$311f0c1e79834f5a);
$parcel$export(module.exports, "validateDNSHostLabel", () => $4ba1279fd8799b23$export$eab3c0a6ee9b0457);
$parcel$export(module.exports, "getArnResources", () => $4ba1279fd8799b23$export$6b274ce9ea6c3c3a);
$parcel$export(module.exports, "validateNoDualstack", () => $4ba1279fd8799b23$export$76b09f028141bdfc);
$parcel$export(module.exports, "validateNoFIPS", () => $4ba1279fd8799b23$export$8b4c0cb10287799f);

var $hoCLj = parcelRequire("hoCLj");
var $4ba1279fd8799b23$var$DOMAIN_PATTERN = /^[a-z0-9][a-z0-9\.\-]{1,61}[a-z0-9]$/;
var $4ba1279fd8799b23$var$IP_ADDRESS_PATTERN = /(\d+\.){3}\d+/;
var $4ba1279fd8799b23$var$DOTS_PATTERN = /\.\./;
var $4ba1279fd8799b23$export$b0b24e5455be29b0 = /\./;
var $4ba1279fd8799b23$export$43f53815580748f = /^(.+\.)?s3[.-]([a-z0-9-]+)\./;
var $4ba1279fd8799b23$var$S3_US_EAST_1_ALTNAME_PATTERN = /^s3(-external-1)?\.amazonaws\.com$/;
var $4ba1279fd8799b23$var$AWS_PARTITION_SUFFIX = "amazonaws.com";
var $4ba1279fd8799b23$export$5b522ec9d0d23583 = function(options) {
    return typeof options.bucketName === "string";
};
var $4ba1279fd8799b23$export$2041e7d2db741fc6 = function(region) {
    return $4ba1279fd8799b23$var$isFipsRegion(region) ? region.replace(/fips-|-fips/, "") : region;
};
var $4ba1279fd8799b23$export$360a1e07839d0d27 = function(bucketName) {
    return $4ba1279fd8799b23$var$DOMAIN_PATTERN.test(bucketName) && !$4ba1279fd8799b23$var$IP_ADDRESS_PATTERN.test(bucketName) && !$4ba1279fd8799b23$var$DOTS_PATTERN.test(bucketName);
};
var $4ba1279fd8799b23$var$getRegionalSuffix = function(hostname) {
    var parts = hostname.match($4ba1279fd8799b23$export$43f53815580748f);
    return [
        parts[2],
        hostname.replace(new RegExp("^" + parts[0]), "")
    ];
};
var $4ba1279fd8799b23$export$661d620f7edbf69d = function(hostname) {
    return $4ba1279fd8799b23$var$S3_US_EAST_1_ALTNAME_PATTERN.test(hostname) ? [
        "us-east-1",
        $4ba1279fd8799b23$var$AWS_PARTITION_SUFFIX
    ] : $4ba1279fd8799b23$var$getRegionalSuffix(hostname);
};
var $4ba1279fd8799b23$export$9822f1db281a24ef = function(hostname) {
    return $4ba1279fd8799b23$var$S3_US_EAST_1_ALTNAME_PATTERN.test(hostname) ? [
        hostname.replace("." + $4ba1279fd8799b23$var$AWS_PARTITION_SUFFIX, ""),
        $4ba1279fd8799b23$var$AWS_PARTITION_SUFFIX
    ] : $4ba1279fd8799b23$var$getRegionalSuffix(hostname);
};
var $4ba1279fd8799b23$export$9d570635889bea10 = function(options) {
    if (options.pathStyleEndpoint) throw new Error("Path-style S3 endpoint is not supported when bucket is an ARN");
    if (options.accelerateEndpoint) throw new Error("Accelerate endpoint is not supported when bucket is an ARN");
    if (!options.tlsCompatible) throw new Error("HTTPS is required when bucket is an ARN");
};
var $4ba1279fd8799b23$export$56395344d8f6da92 = function(service) {
    if (service !== "s3" && service !== "s3-outposts") throw new Error("Expect 's3' or 's3-outposts' in ARN service component");
};
var $4ba1279fd8799b23$export$ee796dc843960f7e = function(service) {
    if (service !== "s3") throw new Error("Expect 's3' in Accesspoint ARN service component");
};
var $4ba1279fd8799b23$export$32ff3a9330dbd031 = function(service) {
    if (service !== "s3-outposts") throw new Error("Expect 's3-posts' in Outpost ARN service component");
};
var $4ba1279fd8799b23$export$2514cb957fb286b = function(partition, options) {
    if (partition !== options.clientPartition) throw new Error("Partition in ARN is incompatible, got \"" + partition + "\" but expected \"" + options.clientPartition + "\"");
};
var $4ba1279fd8799b23$export$6cc2fb0ca7159d47 = function(region, options) {
    if (region === "") throw new Error("ARN region is empty");
    if (!options.useArnRegion && !$4ba1279fd8799b23$var$isEqualRegions(region, options.clientRegion) && !$4ba1279fd8799b23$var$isEqualRegions(region, options.clientSigningRegion)) throw new Error("Region in ARN is incompatible, got " + region + " but expected " + options.clientRegion);
    if (options.useArnRegion && $4ba1279fd8799b23$var$isFipsRegion(region)) throw new Error("Endpoint does not support FIPS region");
};
var $4ba1279fd8799b23$var$isFipsRegion = function(region) {
    return region.startsWith("fips-") || region.endsWith("-fips");
};
var $4ba1279fd8799b23$var$isEqualRegions = function(regionA, regionB) {
    return regionA === regionB || $4ba1279fd8799b23$export$2041e7d2db741fc6(regionA) === regionB || regionA === $4ba1279fd8799b23$export$2041e7d2db741fc6(regionB);
};
var $4ba1279fd8799b23$export$311f0c1e79834f5a = function(accountId) {
    if (!/[0-9]{12}/.exec(accountId)) throw new Error("Access point ARN accountID does not match regex '[0-9]{12}'");
};
var $4ba1279fd8799b23$export$eab3c0a6ee9b0457 = function(label, options) {
    if (options === void 0) options = {
        tlsCompatible: true
    };
    // reference: https://tools.ietf.org/html/rfc3986#section-3.2.2
    if (label.length >= 64 || !/^[a-z0-9][a-z0-9.-]+[a-z0-9]$/.test(label) || /(\d+\.){3}\d+/.test(label) || /[.-]{2}/.test(label) || (options === null || options === void 0 ? void 0 : options.tlsCompatible) && $4ba1279fd8799b23$export$b0b24e5455be29b0.test(label)) throw new Error("Invalid DNS label " + label);
};
var $4ba1279fd8799b23$export$6b274ce9ea6c3c3a = function(resource) {
    var delimiter = resource.includes(":") ? ":" : "/";
    var _a = (0, $hoCLj.__read)(resource.split(delimiter)), resourceType = _a[0], rest = _a.slice(1);
    if (resourceType === "accesspoint") {
        // Parse accesspoint ARN
        if (rest.length !== 1 || rest[0] === "") throw new Error("Access Point ARN should have one resource accesspoint" + delimiter + "{accesspointname}");
        return {
            accesspointName: rest[0]
        };
    } else if (resourceType === "outpost") {
        // Parse outpost ARN
        if (!rest[0] || rest[1] !== "accesspoint" || !rest[2] || rest.length !== 3) throw new Error("Outpost ARN should have resource outpost" + delimiter + "{outpostId}" + delimiter + "accesspoint" + delimiter + "{accesspointName}");
        var _b = (0, $hoCLj.__read)(rest, 3), outpostId = _b[0], _ = _b[1], accesspointName = _b[2];
        return {
            outpostId: outpostId,
            accesspointName: accesspointName
        };
    } else throw new Error("ARN resource should begin with 'accesspoint" + delimiter + "' or 'outpost" + delimiter + "'");
};
var $4ba1279fd8799b23$export$76b09f028141bdfc = function(dualstackEndpoint) {
    if (dualstackEndpoint) throw new Error("Dualstack endpoint is not supported with Outpost");
};
var $4ba1279fd8799b23$export$8b4c0cb10287799f = function(region) {
    if ($4ba1279fd8799b23$var$isFipsRegion(region !== null && region !== void 0 ? region : "")) throw new Error("FIPS region is not supported with Outpost, got " + region);
};

});



parcelRegister("hQ5uE", function(module, exports) {

$parcel$export(module.exports, "resolveBucketEndpointConfig", () => $cfcb8ddaf9711b7c$export$9810f1a949e3136);

var $hoCLj = parcelRequire("hoCLj");
function $cfcb8ddaf9711b7c$export$9810f1a949e3136(input) {
    var _a = input.bucketEndpoint, bucketEndpoint = _a === void 0 ? false : _a, _b = input.forcePathStyle, forcePathStyle = _b === void 0 ? false : _b, _c = input.useAccelerateEndpoint, useAccelerateEndpoint = _c === void 0 ? false : _c, _d = input.useDualstackEndpoint, useDualstackEndpoint = _d === void 0 ? false : _d, _e = input.useArnRegion, useArnRegion = _e === void 0 ? false : _e;
    return (0, $hoCLj.__assign)((0, $hoCLj.__assign)({}, input), {
        bucketEndpoint: bucketEndpoint,
        forcePathStyle: forcePathStyle,
        useAccelerateEndpoint: useAccelerateEndpoint,
        useDualstackEndpoint: useDualstackEndpoint,
        useArnRegion: typeof useArnRegion === "function" ? useArnRegion : function() {
            return Promise.resolve(useArnRegion);
        }
    });
}
var $cfcb8ddaf9711b7c$export$7eb281bbdddd5d12 = "AWS_S3_USE_ARN_REGION";
var $cfcb8ddaf9711b7c$export$812c693bf225d32a = "s3_use_arn_region";
var $cfcb8ddaf9711b7c$export$bac037ab69dc2bd4 = {
    environmentVariableSelector: function(env) {
        if (!Object.prototype.hasOwnProperty.call(env, $cfcb8ddaf9711b7c$export$7eb281bbdddd5d12)) return undefined;
        if (env[$cfcb8ddaf9711b7c$export$7eb281bbdddd5d12] === "true") return true;
        if (env[$cfcb8ddaf9711b7c$export$7eb281bbdddd5d12] === "false") return false;
        throw new Error("Cannot load env " + $cfcb8ddaf9711b7c$export$7eb281bbdddd5d12 + ". Expected \"true\" or \"false\", got " + env[$cfcb8ddaf9711b7c$export$7eb281bbdddd5d12] + ".");
    },
    configFileSelector: function(profile) {
        if (!Object.prototype.hasOwnProperty.call(profile, $cfcb8ddaf9711b7c$export$812c693bf225d32a)) return undefined;
        if (profile[$cfcb8ddaf9711b7c$export$812c693bf225d32a] === "true") return true;
        if (profile[$cfcb8ddaf9711b7c$export$812c693bf225d32a] === "false") return false;
        throw new Error("Cannot load shared config entry " + $cfcb8ddaf9711b7c$export$812c693bf225d32a + ". Expected \"true\" or \"false\", got " + profile[$cfcb8ddaf9711b7c$export$812c693bf225d32a] + ".");
    },
    default: false
};

});



parcelRegister("i0M77", function(module, exports) {

$parcel$export(module.exports, "GetObjectCommand", () => $d1cd8c80dd71d8d2$export$25364b3fa12a4666);

var $2eeCH = parcelRequire("2eeCH");

var $g4BTM = parcelRequire("g4BTM");

var $jhZvA = parcelRequire("jhZvA");
parcelRequire("dLiz3");
var $ifNwy = parcelRequire("ifNwy");
parcelRequire("6ZXPq");
var $dQtWs = parcelRequire("dQtWs");

var $1yer7 = parcelRequire("1yer7");
parcelRequire("3vy9S");
var $5nbBf = parcelRequire("5nbBf");
/**
 * <p>Retrieves objects from Amazon S3. To use <code>GET</code>, you must have <code>READ</code>
 *          access to the object. If you grant <code>READ</code> access to the anonymous user, you can
 *          return the object without using an authorization header.</p>
 *
 *          <p>An Amazon S3 bucket has no directory hierarchy such as you would find in a typical computer
 *          file system. You can, however, create a logical hierarchy by using object key names that
 *          imply a folder structure. For example, instead of naming an object <code>sample.jpg</code>,
 *          you can name it <code>photos/2006/February/sample.jpg</code>.</p>
 *
 *          <p>To get an object from such a logical hierarchy, specify the full key name for the object
 *          in the <code>GET</code> operation. For a virtual hosted-style request example, if you have
 *          the object <code>photos/2006/February/sample.jpg</code>, specify the resource as
 *             <code>/photos/2006/February/sample.jpg</code>. For a path-style request example, if you
 *          have the object <code>photos/2006/February/sample.jpg</code> in the bucket named
 *             <code>examplebucket</code>, specify the resource as
 *             <code>/examplebucket/photos/2006/February/sample.jpg</code>. For more information about
 *          request types, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/VirtualHosting.html#VirtualHostingSpecifyBucket">HTTP Host Header Bucket Specification</a>.</p>
 *
 *          <p>To distribute large files to many people, you can save bandwidth costs by using
 *          BitTorrent. For more information, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/S3Torrent.html">Amazon S3
 *             Torrent</a>. For more information about returning the ACL of an object, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_GetObjectAcl.html">GetObjectAcl</a>.</p>
 *
 *          <p>If the object you are retrieving is stored in the S3 Glacier or
 *          S3 Glacier Deep Archive storage class, or S3 Intelligent-Tiering Archive or
 *          S3 Intelligent-Tiering Deep Archive tiers, before you can retrieve the object you must first restore a
 *          copy using <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_RestoreObject.html">RestoreObject</a>. Otherwise, this operation returns an
 *             <code>InvalidObjectStateError</code> error. For information about restoring archived
 *          objects, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/restoring-objects.html">Restoring Archived
 *             Objects</a>.</p>
 *
 *          <p>Encryption request headers, like <code>x-amz-server-side-encryption</code>, should not
 *          be sent for GET requests if your object uses server-side encryption with CMKs stored in AWS
 *          KMS (SSE-KMS) or server-side encryption with Amazon S3–managed encryption keys (SSE-S3). If your
 *          object does use these types of keys, you’ll get an HTTP 400 BadRequest error.</p>
 *          <p>If you encrypt an object by using server-side encryption with customer-provided
 *          encryption keys (SSE-C) when you store the object in Amazon S3, then when you GET the object,
 *          you must use the following headers:</p>
 *          <ul>
 *             <li>
 *                <p>x-amz-server-side-encryption-customer-algorithm</p>
 *             </li>
 *             <li>
 *                <p>x-amz-server-side-encryption-customer-key</p>
 *             </li>
 *             <li>
 *                <p>x-amz-server-side-encryption-customer-key-MD5</p>
 *             </li>
 *          </ul>
 *          <p>For more information about SSE-C, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/ServerSideEncryptionCustomerKeys.html">Server-Side Encryption (Using
 *             Customer-Provided Encryption Keys)</a>.</p>
 *
 *          <p>Assuming you have permission to read object tags (permission for the
 *             <code>s3:GetObjectVersionTagging</code> action), the response also returns the
 *             <code>x-amz-tagging-count</code> header that provides the count of number of tags
 *          associated with the object. You can use <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_GetObjectTagging.html">GetObjectTagging</a> to retrieve
 *          the tag set associated with an object.</p>
 *
 *          <p>
 *             <b>Permissions</b>
 *          </p>
 *          <p>You need the <code>s3:GetObject</code> permission for this operation. For more
 *          information, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/using-with-s3-actions.html">Specifying Permissions
 *             in a Policy</a>. If the object you request does not exist, the error Amazon S3 returns
 *          depends on whether you also have the <code>s3:ListBucket</code> permission.</p>
 *          <ul>
 *             <li>
 *                <p>If you have the <code>s3:ListBucket</code> permission on the bucket, Amazon S3 will
 *                return an HTTP status code 404 ("no such key") error.</p>
 *             </li>
 *             <li>
 *                <p>If you don’t have the <code>s3:ListBucket</code> permission, Amazon S3 will return an
 *                HTTP status code 403 ("access denied") error.</p>
 *             </li>
 *          </ul>
 *
 *
 *          <p>
 *             <b>Versioning</b>
 *          </p>
 *          <p>By default, the GET operation returns the current version of an object. To return a
 *          different version, use the <code>versionId</code> subresource.</p>
 *
 *          <note>
 *             <p>If the current version of the object is a delete marker, Amazon S3 behaves as if the
 *             object was deleted and includes <code>x-amz-delete-marker: true</code> in the
 *             response.</p>
 *          </note>
 *
 *
 *          <p>For more information about versioning, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_PutBucketVersioning.html">PutBucketVersioning</a>. </p>
 *
 *          <p>
 *             <b>Overriding Response Header Values</b>
 *          </p>
 *          <p>There are times when you want to override certain response header values in a GET
 *          response. For example, you might override the Content-Disposition response header value in
 *          your GET request.</p>
 *
 *          <p>You can override values for a set of response headers using the following query
 *          parameters. These response header values are sent only on a successful request, that is,
 *          when status code 200 OK is returned. The set of headers you can override using these
 *          parameters is a subset of the headers that Amazon S3 accepts when you create an object. The
 *          response headers that you can override for the GET response are <code>Content-Type</code>,
 *             <code>Content-Language</code>, <code>Expires</code>, <code>Cache-Control</code>,
 *             <code>Content-Disposition</code>, and <code>Content-Encoding</code>. To override these
 *          header values in the GET response, you use the following request parameters.</p>
 *
 *          <note>
 *             <p>You must sign the request, either using an Authorization header or a presigned URL,
 *             when using these parameters. They cannot be used with an unsigned (anonymous)
 *             request.</p>
 *          </note>
 *          <ul>
 *             <li>
 *                <p>
 *                   <code>response-content-type</code>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <code>response-content-language</code>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <code>response-expires</code>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <code>response-cache-control</code>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <code>response-content-disposition</code>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <code>response-content-encoding</code>
 *                </p>
 *             </li>
 *          </ul>
 *
 *          <p>
 *             <b>Additional Considerations about Request Headers</b>
 *          </p>
 *
 *          <p>If both of the <code>If-Match</code> and <code>If-Unmodified-Since</code> headers are
 *          present in the request as follows: <code>If-Match</code> condition evaluates to
 *             <code>true</code>, and; <code>If-Unmodified-Since</code> condition evaluates to
 *             <code>false</code>; then, S3 returns 200 OK and the data requested. </p>
 *
 *          <p>If both of the <code>If-None-Match</code> and <code>If-Modified-Since</code> headers are
 *          present in the request as follows:<code> If-None-Match</code> condition evaluates to
 *             <code>false</code>, and; <code>If-Modified-Since</code> condition evaluates to
 *             <code>true</code>; then, S3 returns 304 Not Modified response code.</p>
 *
 *          <p>For more information about conditional requests, see <a href="https://tools.ietf.org/html/rfc7232">RFC 7232</a>.</p>
 *
 *          <p>The following operations are related to <code>GetObject</code>:</p>
 *          <ul>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_ListBuckets.html">ListBuckets</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_GetObjectAcl.html">GetObjectAcl</a>
 *                </p>
 *             </li>
 *          </ul>
 */ var $d1cd8c80dd71d8d2$export$25364b3fa12a4666 = /** @class */ function(_super) {
    (0, $2eeCH.__extends)(GetObjectCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function GetObjectCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    /**
     * @internal
     */ GetObjectCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $dQtWs.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use((0, $1yer7.getSsecPlugin)(configuration));
        this.middlewareStack.use((0, $ifNwy.getBucketEndpointPlugin)(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "S3Client";
        var commandName = "GetObjectCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $g4BTM.GetObjectRequest).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $g4BTM.GetObjectOutput).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetObjectCommand.prototype.serialize = function(input, context) {
        return (0, $jhZvA.serializeAws_restXmlGetObjectCommand)(input, context);
    };
    GetObjectCommand.prototype.deserialize = function(output, context) {
        return (0, $jhZvA.deserializeAws_restXmlGetObjectCommand)(output, context);
    };
    return GetObjectCommand;
}((0, $5nbBf.Command));

});
parcelRegister("1yer7", function(module, exports) {

$parcel$export(module.exports, "getSsecPlugin", () => $12142a2af36715db$export$baf25e0187b0946b);

var $1Agdh = parcelRequire("1Agdh");
function $12142a2af36715db$export$16515ae394ee1bc8(options) {
    var _this = this;
    return function(next) {
        return function(args) {
            return (0, $1Agdh.__awaiter)(_this, void 0, void 0, function() {
                var input, properties, properties_1, properties_1_1, prop, value, valueView, encoded, hash, _a, _b, _c, _d, e_1_1;
                var e_1, _e, _f;
                return (0, $1Agdh.__generator)(this, function(_g) {
                    switch(_g.label){
                        case 0:
                            input = (0, $1Agdh.__assign)({}, args.input);
                            properties = [
                                {
                                    target: "SSECustomerKey",
                                    hash: "SSECustomerKeyMD5"
                                },
                                {
                                    target: "CopySourceSSECustomerKey",
                                    hash: "CopySourceSSECustomerKeyMD5"
                                }
                            ];
                            _g.label = 1;
                        case 1:
                            _g.trys.push([
                                1,
                                6,
                                7,
                                8
                            ]);
                            properties_1 = (0, $1Agdh.__values)(properties), properties_1_1 = properties_1.next();
                            _g.label = 2;
                        case 2:
                            if (!!properties_1_1.done) return [
                                3 /*break*/ ,
                                5
                            ];
                            prop = properties_1_1.value;
                            value = input[prop.target];
                            if (!value) return [
                                3 /*break*/ ,
                                4
                            ];
                            valueView = ArrayBuffer.isView(value) ? new Uint8Array(value.buffer, value.byteOffset, value.byteLength) : typeof value === "string" ? options.utf8Decoder(value) : new Uint8Array(value);
                            encoded = options.base64Encoder(valueView);
                            hash = new options.md5();
                            hash.update(valueView);
                            _a = [
                                (0, $1Agdh.__assign)({}, input)
                            ];
                            _f = {}, _f[prop.target] = encoded;
                            _b = prop.hash;
                            _d = (_c = options).base64Encoder;
                            return [
                                4 /*yield*/ ,
                                hash.digest()
                            ];
                        case 3:
                            input = (0, $1Agdh.__assign).apply(void 0, _a.concat([
                                (_f[_b] = _d.apply(_c, [
                                    _g.sent()
                                ]), _f)
                            ]));
                            _g.label = 4;
                        case 4:
                            properties_1_1 = properties_1.next();
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case 5:
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 6:
                            e_1_1 = _g.sent();
                            e_1 = {
                                error: e_1_1
                            };
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 7:
                            try {
                                if (properties_1_1 && !properties_1_1.done && (_e = properties_1.return)) _e.call(properties_1);
                            } finally{
                                if (e_1) throw e_1.error;
                            }
                            return [
                                7 /*endfinally*/ 
                            ];
                        case 8:
                            return [
                                2 /*return*/ ,
                                next((0, $1Agdh.__assign)((0, $1Agdh.__assign)({}, args), {
                                    input: input
                                }))
                            ];
                    }
                });
            });
        };
    };
}
var $12142a2af36715db$export$bd3ed071b8ca05b3 = {
    name: "ssecMiddleware",
    step: "initialize",
    tags: [
        "SSE"
    ],
    override: true
};
var $12142a2af36715db$export$baf25e0187b0946b = function(config) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add($12142a2af36715db$export$16515ae394ee1bc8(config), $12142a2af36715db$export$bd3ed071b8ca05b3);
        }
    };
};

});
parcelRegister("1Agdh", function(module, exports) {

$parcel$export(module.exports, "__assign", () => $1275bad38295a5cb$export$18ce0697a983be9b);
$parcel$export(module.exports, "__awaiter", () => $1275bad38295a5cb$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $1275bad38295a5cb$export$67ebef60e6f28a6);
$parcel$export(module.exports, "__values", () => $1275bad38295a5cb$export$19a8beecd37a4c45);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $1275bad38295a5cb$var$extendStatics = function(d, b) {
    $1275bad38295a5cb$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $1275bad38295a5cb$var$extendStatics(d, b);
};
function $1275bad38295a5cb$export$a8ba968b8961cb8a(d, b) {
    $1275bad38295a5cb$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $1275bad38295a5cb$export$18ce0697a983be9b = function() {
    $1275bad38295a5cb$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1275bad38295a5cb$export$18ce0697a983be9b.apply(this, arguments);
};
function $1275bad38295a5cb$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $1275bad38295a5cb$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $1275bad38295a5cb$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $1275bad38295a5cb$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $1275bad38295a5cb$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $1275bad38295a5cb$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $1275bad38295a5cb$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $1275bad38295a5cb$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $1275bad38295a5cb$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $1275bad38295a5cb$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $1275bad38295a5cb$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($1275bad38295a5cb$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $1275bad38295a5cb$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $1275bad38295a5cb$export$10c90e4f7922046c(v) {
    return this instanceof $1275bad38295a5cb$export$10c90e4f7922046c ? (this.v = v, this) : new $1275bad38295a5cb$export$10c90e4f7922046c(v);
}
function $1275bad38295a5cb$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $1275bad38295a5cb$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $1275bad38295a5cb$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $1275bad38295a5cb$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $1275bad38295a5cb$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $1275bad38295a5cb$export$19a8beecd37a4c45 === "function" ? $1275bad38295a5cb$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $1275bad38295a5cb$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $1275bad38295a5cb$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $1275bad38295a5cb$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $1275bad38295a5cb$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $1275bad38295a5cb$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});



parcelRegister("edxX9", function(module, exports) {

$parcel$export(module.exports, "ListObjectsCommand", () => $a59c9dfaa8b957dd$export$918ee8a533502438);

var $2eeCH = parcelRequire("2eeCH");

var $g4BTM = parcelRequire("g4BTM");

var $jhZvA = parcelRequire("jhZvA");
parcelRequire("dLiz3");
var $ifNwy = parcelRequire("ifNwy");
parcelRequire("6ZXPq");
var $dQtWs = parcelRequire("dQtWs");
parcelRequire("3vy9S");
var $5nbBf = parcelRequire("5nbBf");
/**
 * <p>Returns some or all (up to 1,000) of the objects in a bucket. You can use the request
 *          parameters as selection criteria to return a subset of the objects in a bucket. A 200 OK
 *          response can contain valid or invalid XML. Be sure to design your application to parse the
 *          contents of the response and handle it appropriately.</p>
 *          <important>
 *             <p>This API has been revised. We recommend that you use the newer version, <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_ListObjectsV2.html">ListObjectsV2</a>, when developing applications. For backward compatibility,
 *             Amazon S3 continues to support <code>ListObjects</code>.</p>
 *          </important>
 *
 *
 *          <p>The following operations are related to <code>ListObjects</code>:</p>
 *          <ul>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_ListObjectsV2.html">ListObjectsV2</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_GetObject.html">GetObject</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_PutObject.html">PutObject</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_CreateBucket.html">CreateBucket</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_ListBuckets.html">ListBuckets</a>
 *                </p>
 *             </li>
 *          </ul>
 */ var $a59c9dfaa8b957dd$export$918ee8a533502438 = /** @class */ function(_super) {
    (0, $2eeCH.__extends)(ListObjectsCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function ListObjectsCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    /**
     * @internal
     */ ListObjectsCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $dQtWs.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use((0, $ifNwy.getBucketEndpointPlugin)(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "S3Client";
        var commandName = "ListObjectsCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $g4BTM.ListObjectsRequest).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $g4BTM.ListObjectsOutput).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    ListObjectsCommand.prototype.serialize = function(input, context) {
        return (0, $jhZvA.serializeAws_restXmlListObjectsCommand)(input, context);
    };
    ListObjectsCommand.prototype.deserialize = function(output, context) {
        return (0, $jhZvA.deserializeAws_restXmlListObjectsCommand)(output, context);
    };
    return ListObjectsCommand;
}((0, $5nbBf.Command));

});

parcelRegister("dpead", function(module, exports) {

$parcel$export(module.exports, "S3Client", () => $9c2898ce79d28476$export$b5be36c66bc46237);

var $2eeCH = parcelRequire("2eeCH");

var $9tAED = parcelRequire("9tAED");
parcelRequire("efaVN");
var $gqVgN = parcelRequire("gqVgN");
var $l59xh = parcelRequire("l59xh");
parcelRequire("jEAqK");
var $jph57 = parcelRequire("jph57");
parcelRequire("dLiz3");
var $hQ5uE = parcelRequire("hQ5uE");

var $d5DYF = parcelRequire("d5DYF");

var $kGyTS = parcelRequire("kGyTS");

var $e80zq = parcelRequire("e80zq");
parcelRequire("9FJYQ");
var $8Hvpq = parcelRequire("8Hvpq");
parcelRequire("3dE54");
var $3fI9X = parcelRequire("3fI9X");
var $efUMf = parcelRequire("efUMf");
parcelRequire("cWGRM");
var $haDot = parcelRequire("haDot");
var $b1leu = parcelRequire("b1leu");
parcelRequire("5jjeh");
var $aP5Uo = parcelRequire("aP5Uo");
var $6KIbI = parcelRequire("6KIbI");
parcelRequire("6VCaQ");
var $fAUAY = parcelRequire("fAUAY");
var $9YwGy = parcelRequire("9YwGy");
parcelRequire("3vy9S");
var $faPkI = parcelRequire("faPkI");
/**
 * <p></p>
 */ var $9c2898ce79d28476$export$b5be36c66bc46237 = /** @class */ function(_super) {
    (0, $2eeCH.__extends)(S3Client, _super);
    function S3Client(configuration) {
        var _this = this;
        var _config_0 = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, (0, $9tAED.ClientDefaultValues)), configuration);
        var _config_1 = (0, $l59xh.resolveRegionConfig)(_config_0);
        var _config_2 = (0, $gqVgN.resolveEndpointsConfig)(_config_1);
        var _config_3 = (0, $6KIbI.resolveAwsAuthConfig)(_config_2);
        var _config_4 = (0, $efUMf.resolveRetryConfig)(_config_3);
        var _config_5 = (0, $e80zq.resolveHostHeaderConfig)(_config_4);
        var _config_6 = (0, $hQ5uE.resolveBucketEndpointConfig)(_config_5);
        var _config_7 = (0, $9YwGy.resolveUserAgentConfig)(_config_6);
        var _config_8 = (0, $jph57.resolveEventStreamSerdeConfig)(_config_7);
        _this = _super.call(this, _config_8) || this;
        _this.config = _config_8;
        _this.middlewareStack.use((0, $aP5Uo.getAwsAuthPlugin)(_this.config));
        _this.middlewareStack.use((0, $3fI9X.getRetryPlugin)(_this.config));
        _this.middlewareStack.use((0, $d5DYF.getContentLengthPlugin)(_this.config));
        _this.middlewareStack.use((0, $e80zq.getHostHeaderPlugin)(_this.config));
        _this.middlewareStack.use((0, $8Hvpq.getLoggerPlugin)(_this.config));
        _this.middlewareStack.use((0, $b1leu.getValidateBucketNamePlugin)(_this.config));
        _this.middlewareStack.use((0, $haDot.getUseRegionalEndpointPlugin)(_this.config));
        _this.middlewareStack.use((0, $kGyTS.getAddExpectContinuePlugin)(_this.config));
        _this.middlewareStack.use((0, $fAUAY.getUserAgentPlugin)(_this.config));
        return _this;
    }
    S3Client.prototype.destroy = function() {
        _super.prototype.destroy.call(this);
    };
    return S3Client;
}((0, $faPkI.Client));

});
parcelRegister("9tAED", function(module, exports) {

$parcel$export(module.exports, "ClientDefaultValues", () => $6e63414f308f2bd2$export$b1f2d721b555a243);

var $2eeCH = parcelRequire("2eeCH");

var $zhi8b = parcelRequire("zhi8b");

var $kIeHp = parcelRequire("kIeHp");
parcelRequire("bZ2AW");
var $75UHz = parcelRequire("75UHz");
parcelRequire("lRt6C");
var $en8nh = parcelRequire("en8nh");
var $krpM4 = parcelRequire("krpM4");

var $lYnMo = parcelRequire("lYnMo");
parcelRequire("cEJWE");
var $ecitQ = parcelRequire("ecitQ");

var $jpy9E = parcelRequire("jpy9E");
parcelRequire("3dE54");
var $9EGMS = parcelRequire("9EGMS");

var $hZ4ci = parcelRequire("hZ4ci");

var $a6ye5 = parcelRequire("a6ye5");

var $b9Yj9 = parcelRequire("b9Yj9");

var $jJ4yr = parcelRequire("jJ4yr");

var $e6CV3 = parcelRequire("e6CV3");
var $6e63414f308f2bd2$export$b1f2d721b555a243 = (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, (0, $e6CV3.ClientSharedValues)), {
    runtime: "browser",
    base64Decoder: (0, $hZ4ci.fromBase64),
    base64Encoder: (0, $hZ4ci.toBase64),
    bodyLengthChecker: (0, $a6ye5.calculateBodyLength),
    credentialDefaultProvider: function(_) {
        return function() {
            return Promise.reject(new Error("Credential is missing"));
        };
    },
    defaultUserAgentProvider: (0, $b9Yj9.defaultUserAgent)({
        serviceId: (0, $e6CV3.ClientSharedValues).serviceId,
        clientVersion: (0, (/*@__PURE__*/$parcel$interopDefault($zhi8b))).version
    }),
    eventStreamSerdeProvider: (0, $75UHz.eventStreamSerdeProvider),
    maxAttempts: (0, $9EGMS.DEFAULT_MAX_ATTEMPTS),
    md5: (0, $jpy9E.Md5),
    region: (0, $ecitQ.invalidProvider)("Region is missing"),
    requestHandler: new (0, $en8nh.FetchHttpHandler)(),
    sha256: (0, $kIeHp.Sha256),
    streamCollector: (0, $krpM4.streamCollector),
    streamHasher: (0, $lYnMo.blobHasher),
    utf8Decoder: (0, $jJ4yr.fromUtf8),
    utf8Encoder: (0, $jJ4yr.toUtf8)
});

});
parcelRegister("zhi8b", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"@aws-sdk/client-s3\",\"description\":\"AWS SDK for JavaScript S3 Client for Node.js, Browser and React Native\",\"version\":\"3.6.1\",\"scripts\":{\"clean\":\"yarn remove-definitions && yarn remove-dist && yarn remove-documentation\",\"build-documentation\":\"yarn remove-documentation && typedoc ./\",\"prepublishOnly\":\"yarn build\",\"pretest\":\"yarn build:cjs\",\"remove-definitions\":\"rimraf ./types\",\"remove-dist\":\"rimraf ./dist\",\"remove-documentation\":\"rimraf ./docs\",\"test:unit\":\"mocha **/cjs/**/*.spec.js\",\"test:e2e\":\"mocha **/cjs/**/*.ispec.js && karma start karma.conf.js\",\"test\":\"yarn test:unit\",\"build:cjs\":\"tsc -p tsconfig.json\",\"build:es\":\"tsc -p tsconfig.es.json\",\"build\":\"yarn build:cjs && yarn build:es\",\"postbuild\":\"downlevel-dts types types/ts3.4\"},\"main\":\"./dist/cjs/index.js\",\"types\":\"./types/index.d.ts\",\"module\":\"./dist/es/index.js\",\"browser\":{\"./runtimeConfig\":\"./runtimeConfig.browser\"},\"react-native\":{\"./runtimeConfig\":\"./runtimeConfig.native\"},\"sideEffects\":false,\"dependencies\":{\"@aws-crypto/sha256-browser\":\"^1.0.0\",\"@aws-crypto/sha256-js\":\"^1.0.0\",\"@aws-sdk/config-resolver\":\"3.6.1\",\"@aws-sdk/credential-provider-node\":\"3.6.1\",\"@aws-sdk/eventstream-serde-browser\":\"3.6.1\",\"@aws-sdk/eventstream-serde-config-resolver\":\"3.6.1\",\"@aws-sdk/eventstream-serde-node\":\"3.6.1\",\"@aws-sdk/fetch-http-handler\":\"3.6.1\",\"@aws-sdk/hash-blob-browser\":\"3.6.1\",\"@aws-sdk/hash-node\":\"3.6.1\",\"@aws-sdk/hash-stream-node\":\"3.6.1\",\"@aws-sdk/invalid-dependency\":\"3.6.1\",\"@aws-sdk/md5-js\":\"3.6.1\",\"@aws-sdk/middleware-apply-body-checksum\":\"3.6.1\",\"@aws-sdk/middleware-bucket-endpoint\":\"3.6.1\",\"@aws-sdk/middleware-content-length\":\"3.6.1\",\"@aws-sdk/middleware-expect-continue\":\"3.6.1\",\"@aws-sdk/middleware-host-header\":\"3.6.1\",\"@aws-sdk/middleware-location-constraint\":\"3.6.1\",\"@aws-sdk/middleware-logger\":\"3.6.1\",\"@aws-sdk/middleware-retry\":\"3.6.1\",\"@aws-sdk/middleware-sdk-s3\":\"3.6.1\",\"@aws-sdk/middleware-serde\":\"3.6.1\",\"@aws-sdk/middleware-signing\":\"3.6.1\",\"@aws-sdk/middleware-ssec\":\"3.6.1\",\"@aws-sdk/middleware-stack\":\"3.6.1\",\"@aws-sdk/middleware-user-agent\":\"3.6.1\",\"@aws-sdk/node-config-provider\":\"3.6.1\",\"@aws-sdk/node-http-handler\":\"3.6.1\",\"@aws-sdk/protocol-http\":\"3.6.1\",\"@aws-sdk/smithy-client\":\"3.6.1\",\"@aws-sdk/types\":\"3.6.1\",\"@aws-sdk/url-parser\":\"3.6.1\",\"@aws-sdk/url-parser-native\":\"3.6.1\",\"@aws-sdk/util-base64-browser\":\"3.6.1\",\"@aws-sdk/util-base64-node\":\"3.6.1\",\"@aws-sdk/util-body-length-browser\":\"3.6.1\",\"@aws-sdk/util-body-length-node\":\"3.6.1\",\"@aws-sdk/util-user-agent-browser\":\"3.6.1\",\"@aws-sdk/util-user-agent-node\":\"3.6.1\",\"@aws-sdk/util-utf8-browser\":\"3.6.1\",\"@aws-sdk/util-utf8-node\":\"3.6.1\",\"@aws-sdk/util-waiter\":\"3.6.1\",\"@aws-sdk/xml-builder\":\"3.6.1\",\"fast-xml-parser\":\"^3.16.0\",\"tslib\":\"^2.0.0\"},\"devDependencies\":{\"@aws-sdk/client-documentation-generator\":\"3.6.1\",\"@types/chai\":\"^4.2.11\",\"@types/mocha\":\"^8.0.4\",\"@types/node\":\"^12.7.5\",\"downlevel-dts\":\"0.7.0\",\"jest\":\"^26.1.0\",\"rimraf\":\"^3.0.0\",\"typedoc\":\"^0.19.2\",\"typescript\":\"~4.1.2\"},\"engines\":{\"node\":\">=10.0.0\"},\"typesVersions\":{\"<4.0\":{\"types/*\":[\"types/ts3.4/*\"]}},\"author\":{\"name\":\"AWS SDK for JavaScript Team\",\"url\":\"https://aws.amazon.com/javascript/\"},\"license\":\"Apache-2.0\",\"homepage\":\"https://github.com/aws/aws-sdk-js-v3/tree/main/clients/client-s3\",\"repository\":{\"type\":\"git\",\"url\":\"https://github.com/aws/aws-sdk-js-v3.git\",\"directory\":\"clients/client-s3\"}}");

});

parcelRegister("bZ2AW", function(module, exports) {
$parcel$export(module.exports, "eventStreamSerdeProvider", () => (parcelRequire("75UHz")).eventStreamSerdeProvider);
parcelRequire("75UHz");
parcelRequire("9Fa1z");
parcelRequire("2PB0H");

});
parcelRegister("75UHz", function(module, exports) {

$parcel$export(module.exports, "eventStreamSerdeProvider", () => $52a4fbd3e8b65adb$export$9d23a885702ebafb);

var $9Fa1z = parcelRequire("9Fa1z");
var $52a4fbd3e8b65adb$export$9d23a885702ebafb = function(options) {
    return new (0, $9Fa1z.EventStreamMarshaller)(options);
};

});
parcelRegister("9Fa1z", function(module, exports) {

$parcel$export(module.exports, "EventStreamMarshaller", () => $708fb800d7b6ce6b$export$b64afa0aa6ce60e2);
parcelRequire("bHRM6");
var $2H0x3 = parcelRequire("2H0x3");
parcelRequire("6JsHr");
var $1OE66 = parcelRequire("1OE66");

var $2PB0H = parcelRequire("2PB0H");
/**
 * Utility class used to serialize and deserialize event streams in
 * browsers and ReactNative.
 *
 * In browsers where ReadableStream API is available:
 * * deserialize from ReadableStream to an async iterable of output structure
 * * serialize from async iterable of input structure to ReadableStream
 * In ReactNative where only async iterable API is available:
 * * deserialize from async iterable of binaries to async iterable of output structure
 * * serialize from async iterable of input structure to async iterable of binaries
 *
 * We use ReadableStream API in browsers because of the consistency with other
 * streaming operations, where ReadableStream API is used to denote streaming data.
 * Whereas in ReactNative, ReadableStream API is not available, we use async iterable
 * for streaming data although it has lower throughput.
 */ var $708fb800d7b6ce6b$export$b64afa0aa6ce60e2 = /** @class */ function() {
    function EventStreamMarshaller(_a) {
        var utf8Encoder = _a.utf8Encoder, utf8Decoder = _a.utf8Decoder;
        this.eventMarshaller = new (0, $2H0x3.EventStreamMarshaller)(utf8Encoder, utf8Decoder);
        this.universalMarshaller = new (0, $1OE66.EventStreamMarshaller)({
            utf8Decoder: utf8Decoder,
            utf8Encoder: utf8Encoder
        });
    }
    EventStreamMarshaller.prototype.deserialize = function(body, deserializer) {
        var bodyIterable = $708fb800d7b6ce6b$var$isReadableStream(body) ? (0, $2PB0H.readableStreamtoIterable)(body) : body;
        return this.universalMarshaller.deserialize(bodyIterable, deserializer);
    };
    /**
     * Generate a stream that serialize events into stream of binary chunks;
     *
     * Caveat is that streaming request payload doesn't work on browser with native
     * xhr or fetch handler currently because they don't support upload streaming.
     * reference:
     * * https://bugs.chromium.org/p/chromium/issues/detail?id=688906
     * * https://bugzilla.mozilla.org/show_bug.cgi?id=1387483
     *
     */ EventStreamMarshaller.prototype.serialize = function(input, serializer) {
        var serialziedIterable = this.universalMarshaller.serialize(input, serializer);
        return typeof ReadableStream === "function" ? (0, $2PB0H.iterableToReadableStream)(serialziedIterable) : serialziedIterable;
    };
    return EventStreamMarshaller;
}();
var $708fb800d7b6ce6b$var$isReadableStream = function(body) {
    return typeof ReadableStream === "function" && body instanceof ReadableStream;
};

});
parcelRegister("bHRM6", function(module, exports) {
$parcel$export(module.exports, "EventStreamMarshaller", () => (parcelRequire("2H0x3")).EventStreamMarshaller);
parcelRequire("2H0x3");
parcelRequire("dwGxe");
parcelRequire("7eD0L");

});
parcelRegister("2H0x3", function(module, exports) {

$parcel$export(module.exports, "EventStreamMarshaller", () => $1f600294c86211b3$export$b64afa0aa6ce60e2);

var $gpeif = parcelRequire("gpeif");

var $f1qmt = parcelRequire("f1qmt");

var $3QPi4 = parcelRequire("3QPi4");
/**
 * A marshaller that can convert binary-packed event stream messages into
 * JavaScript objects and back again into their binary format.
 */ var $1f600294c86211b3$export$b64afa0aa6ce60e2 = /** @class */ function() {
    function EventStreamMarshaller(toUtf8, fromUtf8) {
        this.headerMarshaller = new (0, $f1qmt.HeaderMarshaller)(toUtf8, fromUtf8);
    }
    /**
     * Convert a structured JavaScript object with tagged headers into a binary
     * event stream message.
     */ EventStreamMarshaller.prototype.marshall = function(_a) {
        var rawHeaders = _a.headers, body = _a.body;
        var headers = this.headerMarshaller.format(rawHeaders);
        var length = headers.byteLength + body.byteLength + 16;
        var out = new Uint8Array(length);
        var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
        var checksum = new (0, $gpeif.Crc32)();
        // Format message
        view.setUint32(0, length, false);
        view.setUint32(4, headers.byteLength, false);
        view.setUint32(8, checksum.update(out.subarray(0, 8)).digest(), false);
        out.set(headers, 12);
        out.set(body, headers.byteLength + 12);
        // Write trailing message checksum
        view.setUint32(length - 4, checksum.update(out.subarray(8, length - 4)).digest(), false);
        return out;
    };
    /**
     * Convert a binary event stream message into a JavaScript object with an
     * opaque, binary body and tagged, parsed headers.
     */ EventStreamMarshaller.prototype.unmarshall = function(message) {
        var _a = (0, $3QPi4.splitMessage)(message), headers = _a.headers, body = _a.body;
        return {
            headers: this.headerMarshaller.parse(headers),
            body: body
        };
    };
    /**
     * Convert a structured JavaScript object with tagged headers into a binary
     * event stream message header.
     */ EventStreamMarshaller.prototype.formatHeaders = function(rawHeaders) {
        return this.headerMarshaller.format(rawHeaders);
    };
    return EventStreamMarshaller;
}();

});
parcelRegister("gpeif", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AwsCrc32 = module.exports.Crc32 = module.exports.crc32 = void 0;

var $kWx9b = parcelRequire("kWx9b");

var $ezR3Y = parcelRequire("ezR3Y");
function $bf1a1182a0efd651$var$crc32(data) {
    return new $bf1a1182a0efd651$var$Crc32().update(data).digest();
}
module.exports.crc32 = $bf1a1182a0efd651$var$crc32;
var $bf1a1182a0efd651$var$Crc32 = /** @class */ function() {
    function Crc32() {
        this.checksum = 0xffffffff;
    }
    Crc32.prototype.update = function(data) {
        var e_1, _a;
        try {
            for(var data_1 = (0, $kWx9b.__values)(data), data_1_1 = data_1.next(); !data_1_1.done; data_1_1 = data_1.next()){
                var byte = data_1_1.value;
                this.checksum = this.checksum >>> 8 ^ $bf1a1182a0efd651$var$lookupTable[(this.checksum ^ byte) & 0xff];
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (data_1_1 && !data_1_1.done && (_a = data_1.return)) _a.call(data_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return this;
    };
    Crc32.prototype.digest = function() {
        return (this.checksum ^ 0xffffffff) >>> 0;
    };
    return Crc32;
}();
module.exports.Crc32 = $bf1a1182a0efd651$var$Crc32;
// prettier-ignore
var $bf1a1182a0efd651$var$a_lookUpTable = [
    0x00000000,
    0x77073096,
    0xEE0E612C,
    0x990951BA,
    0x076DC419,
    0x706AF48F,
    0xE963A535,
    0x9E6495A3,
    0x0EDB8832,
    0x79DCB8A4,
    0xE0D5E91E,
    0x97D2D988,
    0x09B64C2B,
    0x7EB17CBD,
    0xE7B82D07,
    0x90BF1D91,
    0x1DB71064,
    0x6AB020F2,
    0xF3B97148,
    0x84BE41DE,
    0x1ADAD47D,
    0x6DDDE4EB,
    0xF4D4B551,
    0x83D385C7,
    0x136C9856,
    0x646BA8C0,
    0xFD62F97A,
    0x8A65C9EC,
    0x14015C4F,
    0x63066CD9,
    0xFA0F3D63,
    0x8D080DF5,
    0x3B6E20C8,
    0x4C69105E,
    0xD56041E4,
    0xA2677172,
    0x3C03E4D1,
    0x4B04D447,
    0xD20D85FD,
    0xA50AB56B,
    0x35B5A8FA,
    0x42B2986C,
    0xDBBBC9D6,
    0xACBCF940,
    0x32D86CE3,
    0x45DF5C75,
    0xDCD60DCF,
    0xABD13D59,
    0x26D930AC,
    0x51DE003A,
    0xC8D75180,
    0xBFD06116,
    0x21B4F4B5,
    0x56B3C423,
    0xCFBA9599,
    0xB8BDA50F,
    0x2802B89E,
    0x5F058808,
    0xC60CD9B2,
    0xB10BE924,
    0x2F6F7C87,
    0x58684C11,
    0xC1611DAB,
    0xB6662D3D,
    0x76DC4190,
    0x01DB7106,
    0x98D220BC,
    0xEFD5102A,
    0x71B18589,
    0x06B6B51F,
    0x9FBFE4A5,
    0xE8B8D433,
    0x7807C9A2,
    0x0F00F934,
    0x9609A88E,
    0xE10E9818,
    0x7F6A0DBB,
    0x086D3D2D,
    0x91646C97,
    0xE6635C01,
    0x6B6B51F4,
    0x1C6C6162,
    0x856530D8,
    0xF262004E,
    0x6C0695ED,
    0x1B01A57B,
    0x8208F4C1,
    0xF50FC457,
    0x65B0D9C6,
    0x12B7E950,
    0x8BBEB8EA,
    0xFCB9887C,
    0x62DD1DDF,
    0x15DA2D49,
    0x8CD37CF3,
    0xFBD44C65,
    0x4DB26158,
    0x3AB551CE,
    0xA3BC0074,
    0xD4BB30E2,
    0x4ADFA541,
    0x3DD895D7,
    0xA4D1C46D,
    0xD3D6F4FB,
    0x4369E96A,
    0x346ED9FC,
    0xAD678846,
    0xDA60B8D0,
    0x44042D73,
    0x33031DE5,
    0xAA0A4C5F,
    0xDD0D7CC9,
    0x5005713C,
    0x270241AA,
    0xBE0B1010,
    0xC90C2086,
    0x5768B525,
    0x206F85B3,
    0xB966D409,
    0xCE61E49F,
    0x5EDEF90E,
    0x29D9C998,
    0xB0D09822,
    0xC7D7A8B4,
    0x59B33D17,
    0x2EB40D81,
    0xB7BD5C3B,
    0xC0BA6CAD,
    0xEDB88320,
    0x9ABFB3B6,
    0x03B6E20C,
    0x74B1D29A,
    0xEAD54739,
    0x9DD277AF,
    0x04DB2615,
    0x73DC1683,
    0xE3630B12,
    0x94643B84,
    0x0D6D6A3E,
    0x7A6A5AA8,
    0xE40ECF0B,
    0x9309FF9D,
    0x0A00AE27,
    0x7D079EB1,
    0xF00F9344,
    0x8708A3D2,
    0x1E01F268,
    0x6906C2FE,
    0xF762575D,
    0x806567CB,
    0x196C3671,
    0x6E6B06E7,
    0xFED41B76,
    0x89D32BE0,
    0x10DA7A5A,
    0x67DD4ACC,
    0xF9B9DF6F,
    0x8EBEEFF9,
    0x17B7BE43,
    0x60B08ED5,
    0xD6D6A3E8,
    0xA1D1937E,
    0x38D8C2C4,
    0x4FDFF252,
    0xD1BB67F1,
    0xA6BC5767,
    0x3FB506DD,
    0x48B2364B,
    0xD80D2BDA,
    0xAF0A1B4C,
    0x36034AF6,
    0x41047A60,
    0xDF60EFC3,
    0xA867DF55,
    0x316E8EEF,
    0x4669BE79,
    0xCB61B38C,
    0xBC66831A,
    0x256FD2A0,
    0x5268E236,
    0xCC0C7795,
    0xBB0B4703,
    0x220216B9,
    0x5505262F,
    0xC5BA3BBE,
    0xB2BD0B28,
    0x2BB45A92,
    0x5CB36A04,
    0xC2D7FFA7,
    0xB5D0CF31,
    0x2CD99E8B,
    0x5BDEAE1D,
    0x9B64C2B0,
    0xEC63F226,
    0x756AA39C,
    0x026D930A,
    0x9C0906A9,
    0xEB0E363F,
    0x72076785,
    0x05005713,
    0x95BF4A82,
    0xE2B87A14,
    0x7BB12BAE,
    0x0CB61B38,
    0x92D28E9B,
    0xE5D5BE0D,
    0x7CDCEFB7,
    0x0BDBDF21,
    0x86D3D2D4,
    0xF1D4E242,
    0x68DDB3F8,
    0x1FDA836E,
    0x81BE16CD,
    0xF6B9265B,
    0x6FB077E1,
    0x18B74777,
    0x88085AE6,
    0xFF0F6A70,
    0x66063BCA,
    0x11010B5C,
    0x8F659EFF,
    0xF862AE69,
    0x616BFFD3,
    0x166CCF45,
    0xA00AE278,
    0xD70DD2EE,
    0x4E048354,
    0x3903B3C2,
    0xA7672661,
    0xD06016F7,
    0x4969474D,
    0x3E6E77DB,
    0xAED16A4A,
    0xD9D65ADC,
    0x40DF0B66,
    0x37D83BF0,
    0xA9BCAE53,
    0xDEBB9EC5,
    0x47B2CF7F,
    0x30B5FFE9,
    0xBDBDF21C,
    0xCABAC28A,
    0x53B39330,
    0x24B4A3A6,
    0xBAD03605,
    0xCDD70693,
    0x54DE5729,
    0x23D967BF,
    0xB3667A2E,
    0xC4614AB8,
    0x5D681B02,
    0x2A6F2B94,
    0xB40BBE37,
    0xC30C8EA1,
    0x5A05DF1B,
    0x2D02EF8D
];
var $bf1a1182a0efd651$var$lookupTable = (0, $ezR3Y.uint32ArrayFrom)($bf1a1182a0efd651$var$a_lookUpTable);

var $eKOcf = parcelRequire("eKOcf");
Object.defineProperty(module.exports, "AwsCrc32", {
    enumerable: true,
    get: function() {
        return $eKOcf.AwsCrc32;
    }
});

});
parcelRegister("kWx9b", function(module, exports) {

$parcel$export(module.exports, "__awaiter", () => $f3f2efbf5f2a760b$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $f3f2efbf5f2a760b$export$67ebef60e6f28a6);
$parcel$export(module.exports, "__values", () => $f3f2efbf5f2a760b$export$19a8beecd37a4c45);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $f3f2efbf5f2a760b$var$extendStatics = function(d, b) {
    $f3f2efbf5f2a760b$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $f3f2efbf5f2a760b$var$extendStatics(d, b);
};
function $f3f2efbf5f2a760b$export$a8ba968b8961cb8a(d, b) {
    $f3f2efbf5f2a760b$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $f3f2efbf5f2a760b$export$18ce0697a983be9b = function() {
    $f3f2efbf5f2a760b$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f3f2efbf5f2a760b$export$18ce0697a983be9b.apply(this, arguments);
};
function $f3f2efbf5f2a760b$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $f3f2efbf5f2a760b$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $f3f2efbf5f2a760b$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $f3f2efbf5f2a760b$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $f3f2efbf5f2a760b$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $f3f2efbf5f2a760b$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $f3f2efbf5f2a760b$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $f3f2efbf5f2a760b$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $f3f2efbf5f2a760b$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $f3f2efbf5f2a760b$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $f3f2efbf5f2a760b$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($f3f2efbf5f2a760b$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $f3f2efbf5f2a760b$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $f3f2efbf5f2a760b$export$10c90e4f7922046c(v) {
    return this instanceof $f3f2efbf5f2a760b$export$10c90e4f7922046c ? (this.v = v, this) : new $f3f2efbf5f2a760b$export$10c90e4f7922046c(v);
}
function $f3f2efbf5f2a760b$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $f3f2efbf5f2a760b$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $f3f2efbf5f2a760b$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $f3f2efbf5f2a760b$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $f3f2efbf5f2a760b$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $f3f2efbf5f2a760b$export$19a8beecd37a4c45 === "function" ? $f3f2efbf5f2a760b$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $f3f2efbf5f2a760b$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $f3f2efbf5f2a760b$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $f3f2efbf5f2a760b$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $f3f2efbf5f2a760b$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $f3f2efbf5f2a760b$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("eKOcf", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AwsCrc32 = void 0;

var $kWx9b = parcelRequire("kWx9b");

var $ezR3Y = parcelRequire("ezR3Y");

var $gpeif = parcelRequire("gpeif");
var $abdc4c8dd7cb6537$var$AwsCrc32 = /** @class */ function() {
    function AwsCrc32() {
        this.crc32 = new $gpeif.Crc32();
    }
    AwsCrc32.prototype.update = function(toHash) {
        if ((0, $ezR3Y.isEmptyData)(toHash)) return;
        this.crc32.update((0, $ezR3Y.convertToBuffer)(toHash));
    };
    AwsCrc32.prototype.digest = function() {
        return (0, $kWx9b.__awaiter)(this, void 0, void 0, function() {
            return (0, $kWx9b.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    (0, $ezR3Y.numToUint8)(this.crc32.digest())
                ];
            });
        });
    };
    return AwsCrc32;
}();
module.exports.AwsCrc32 = $abdc4c8dd7cb6537$var$AwsCrc32;

});


parcelRegister("f1qmt", function(module, exports) {

$parcel$export(module.exports, "HeaderMarshaller", () => $aefb65dd10f86558$export$74fd41a85c5dcec9);

var $9rd8y = parcelRequire("9rd8y");

var $2YcGN = parcelRequire("2YcGN");

var $dwGxe = parcelRequire("dwGxe");
/**
 * @internal
 */ var $aefb65dd10f86558$export$74fd41a85c5dcec9 = /** @class */ function() {
    function HeaderMarshaller(toUtf8, fromUtf8) {
        this.toUtf8 = toUtf8;
        this.fromUtf8 = fromUtf8;
    }
    HeaderMarshaller.prototype.format = function(headers) {
        var e_1, _a, e_2, _b;
        var chunks = [];
        try {
            for(var _c = (0, $9rd8y.__values)(Object.keys(headers)), _d = _c.next(); !_d.done; _d = _c.next()){
                var headerName = _d.value;
                var bytes = this.fromUtf8(headerName);
                chunks.push(Uint8Array.from([
                    bytes.byteLength
                ]), bytes, this.formatHeaderValue(headers[headerName]));
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        var out = new Uint8Array(chunks.reduce(function(carry, bytes) {
            return carry + bytes.byteLength;
        }, 0));
        var position = 0;
        try {
            for(var chunks_1 = (0, $9rd8y.__values)(chunks), chunks_1_1 = chunks_1.next(); !chunks_1_1.done; chunks_1_1 = chunks_1.next()){
                var chunk = chunks_1_1.value;
                out.set(chunk, position);
                position += chunk.byteLength;
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (chunks_1_1 && !chunks_1_1.done && (_b = chunks_1.return)) _b.call(chunks_1);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        return out;
    };
    HeaderMarshaller.prototype.formatHeaderValue = function(header) {
        switch(header.type){
            case "boolean":
                return Uint8Array.from([
                    header.value ? 0 /* boolTrue */  : 1 /* boolFalse */ 
                ]);
            case "byte":
                return Uint8Array.from([
                    2 /* byte */ ,
                    header.value
                ]);
            case "short":
                var shortView = new DataView(new ArrayBuffer(3));
                shortView.setUint8(0, 3 /* short */ );
                shortView.setInt16(1, header.value, false);
                return new Uint8Array(shortView.buffer);
            case "integer":
                var intView = new DataView(new ArrayBuffer(5));
                intView.setUint8(0, 4 /* integer */ );
                intView.setInt32(1, header.value, false);
                return new Uint8Array(intView.buffer);
            case "long":
                var longBytes = new Uint8Array(9);
                longBytes[0] = 5 /* long */ ;
                longBytes.set(header.value.bytes, 1);
                return longBytes;
            case "binary":
                var binView = new DataView(new ArrayBuffer(3 + header.value.byteLength));
                binView.setUint8(0, 6 /* byteArray */ );
                binView.setUint16(1, header.value.byteLength, false);
                var binBytes = new Uint8Array(binView.buffer);
                binBytes.set(header.value, 3);
                return binBytes;
            case "string":
                var utf8Bytes = this.fromUtf8(header.value);
                var strView = new DataView(new ArrayBuffer(3 + utf8Bytes.byteLength));
                strView.setUint8(0, 7 /* string */ );
                strView.setUint16(1, utf8Bytes.byteLength, false);
                var strBytes = new Uint8Array(strView.buffer);
                strBytes.set(utf8Bytes, 3);
                return strBytes;
            case "timestamp":
                var tsBytes = new Uint8Array(9);
                tsBytes[0] = 8 /* timestamp */ ;
                tsBytes.set((0, $dwGxe.Int64).fromNumber(header.value.valueOf()).bytes, 1);
                return tsBytes;
            case "uuid":
                if (!$aefb65dd10f86558$var$UUID_PATTERN.test(header.value)) throw new Error("Invalid UUID received: " + header.value);
                var uuidBytes = new Uint8Array(17);
                uuidBytes[0] = 9 /* uuid */ ;
                uuidBytes.set((0, $2YcGN.fromHex)(header.value.replace(/\-/g, "")), 1);
                return uuidBytes;
        }
    };
    HeaderMarshaller.prototype.parse = function(headers) {
        var out = {};
        var position = 0;
        while(position < headers.byteLength){
            var nameLength = headers.getUint8(position++);
            var name = this.toUtf8(new Uint8Array(headers.buffer, headers.byteOffset + position, nameLength));
            position += nameLength;
            switch(headers.getUint8(position++)){
                case 0 /* boolTrue */ :
                    out[name] = {
                        type: $aefb65dd10f86558$var$BOOLEAN_TAG,
                        value: true
                    };
                    break;
                case 1 /* boolFalse */ :
                    out[name] = {
                        type: $aefb65dd10f86558$var$BOOLEAN_TAG,
                        value: false
                    };
                    break;
                case 2 /* byte */ :
                    out[name] = {
                        type: $aefb65dd10f86558$var$BYTE_TAG,
                        value: headers.getInt8(position++)
                    };
                    break;
                case 3 /* short */ :
                    out[name] = {
                        type: $aefb65dd10f86558$var$SHORT_TAG,
                        value: headers.getInt16(position, false)
                    };
                    position += 2;
                    break;
                case 4 /* integer */ :
                    out[name] = {
                        type: $aefb65dd10f86558$var$INT_TAG,
                        value: headers.getInt32(position, false)
                    };
                    position += 4;
                    break;
                case 5 /* long */ :
                    out[name] = {
                        type: $aefb65dd10f86558$var$LONG_TAG,
                        value: new (0, $dwGxe.Int64)(new Uint8Array(headers.buffer, headers.byteOffset + position, 8))
                    };
                    position += 8;
                    break;
                case 6 /* byteArray */ :
                    var binaryLength = headers.getUint16(position, false);
                    position += 2;
                    out[name] = {
                        type: $aefb65dd10f86558$var$BINARY_TAG,
                        value: new Uint8Array(headers.buffer, headers.byteOffset + position, binaryLength)
                    };
                    position += binaryLength;
                    break;
                case 7 /* string */ :
                    var stringLength = headers.getUint16(position, false);
                    position += 2;
                    out[name] = {
                        type: $aefb65dd10f86558$var$STRING_TAG,
                        value: this.toUtf8(new Uint8Array(headers.buffer, headers.byteOffset + position, stringLength))
                    };
                    position += stringLength;
                    break;
                case 8 /* timestamp */ :
                    out[name] = {
                        type: $aefb65dd10f86558$var$TIMESTAMP_TAG,
                        value: new Date(new (0, $dwGxe.Int64)(new Uint8Array(headers.buffer, headers.byteOffset + position, 8)).valueOf())
                    };
                    position += 8;
                    break;
                case 9 /* uuid */ :
                    var uuidBytes = new Uint8Array(headers.buffer, headers.byteOffset + position, 16);
                    position += 16;
                    out[name] = {
                        type: $aefb65dd10f86558$var$UUID_TAG,
                        value: (0, $2YcGN.toHex)(uuidBytes.subarray(0, 4)) + "-" + (0, $2YcGN.toHex)(uuidBytes.subarray(4, 6)) + "-" + (0, $2YcGN.toHex)(uuidBytes.subarray(6, 8)) + "-" + (0, $2YcGN.toHex)(uuidBytes.subarray(8, 10)) + "-" + (0, $2YcGN.toHex)(uuidBytes.subarray(10))
                    };
                    break;
                default:
                    throw new Error("Unrecognized header type tag");
            }
        }
        return out;
    };
    return HeaderMarshaller;
}();
var $aefb65dd10f86558$var$HEADER_VALUE_TYPE;
(function(HEADER_VALUE_TYPE) {
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["boolTrue"] = 0] = "boolTrue";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["boolFalse"] = 1] = "boolFalse";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["byte"] = 2] = "byte";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["short"] = 3] = "short";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["integer"] = 4] = "integer";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["long"] = 5] = "long";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["byteArray"] = 6] = "byteArray";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["string"] = 7] = "string";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["timestamp"] = 8] = "timestamp";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["uuid"] = 9] = "uuid";
})($aefb65dd10f86558$var$HEADER_VALUE_TYPE || ($aefb65dd10f86558$var$HEADER_VALUE_TYPE = {}));
var $aefb65dd10f86558$var$BOOLEAN_TAG = "boolean";
var $aefb65dd10f86558$var$BYTE_TAG = "byte";
var $aefb65dd10f86558$var$SHORT_TAG = "short";
var $aefb65dd10f86558$var$INT_TAG = "integer";
var $aefb65dd10f86558$var$LONG_TAG = "long";
var $aefb65dd10f86558$var$BINARY_TAG = "binary";
var $aefb65dd10f86558$var$STRING_TAG = "string";
var $aefb65dd10f86558$var$TIMESTAMP_TAG = "timestamp";
var $aefb65dd10f86558$var$UUID_TAG = "uuid";
var $aefb65dd10f86558$var$UUID_PATTERN = /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/;

});
parcelRegister("9rd8y", function(module, exports) {

$parcel$export(module.exports, "__values", () => $6df0d368bddc64e7$export$19a8beecd37a4c45);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $6df0d368bddc64e7$var$extendStatics = function(d, b) {
    $6df0d368bddc64e7$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $6df0d368bddc64e7$var$extendStatics(d, b);
};
function $6df0d368bddc64e7$export$a8ba968b8961cb8a(d, b) {
    $6df0d368bddc64e7$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $6df0d368bddc64e7$export$18ce0697a983be9b = function() {
    $6df0d368bddc64e7$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6df0d368bddc64e7$export$18ce0697a983be9b.apply(this, arguments);
};
function $6df0d368bddc64e7$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $6df0d368bddc64e7$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $6df0d368bddc64e7$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $6df0d368bddc64e7$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $6df0d368bddc64e7$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $6df0d368bddc64e7$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $6df0d368bddc64e7$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $6df0d368bddc64e7$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $6df0d368bddc64e7$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $6df0d368bddc64e7$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $6df0d368bddc64e7$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($6df0d368bddc64e7$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $6df0d368bddc64e7$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $6df0d368bddc64e7$export$10c90e4f7922046c(v) {
    return this instanceof $6df0d368bddc64e7$export$10c90e4f7922046c ? (this.v = v, this) : new $6df0d368bddc64e7$export$10c90e4f7922046c(v);
}
function $6df0d368bddc64e7$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $6df0d368bddc64e7$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $6df0d368bddc64e7$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $6df0d368bddc64e7$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $6df0d368bddc64e7$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $6df0d368bddc64e7$export$19a8beecd37a4c45 === "function" ? $6df0d368bddc64e7$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $6df0d368bddc64e7$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $6df0d368bddc64e7$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $6df0d368bddc64e7$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $6df0d368bddc64e7$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $6df0d368bddc64e7$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("dwGxe", function(module, exports) {

$parcel$export(module.exports, "Int64", () => $9d8f421ad7125c06$export$8a5e19712a0a5deb);

var $2YcGN = parcelRequire("2YcGN");
/**
 * A lossless representation of a signed, 64-bit integer. Instances of this
 * class may be used in arithmetic expressions as if they were numeric
 * primitives, but the binary representation will be preserved unchanged as the
 * `bytes` property of the object. The bytes should be encoded as big-endian,
 * two's complement integers.
 */ var $9d8f421ad7125c06$export$8a5e19712a0a5deb = /** @class */ function() {
    function Int64(bytes) {
        this.bytes = bytes;
        if (bytes.byteLength !== 8) throw new Error("Int64 buffers must be exactly 8 bytes");
    }
    Int64.fromNumber = function(number) {
        if (number > 9223372036854775807 || number < -9223372036854776000) throw new Error(number + " is too large (or, if negative, too small) to represent as an Int64");
        var bytes = new Uint8Array(8);
        for(var i = 7, remaining = Math.abs(Math.round(number)); i > -1 && remaining > 0; i--, remaining /= 256)bytes[i] = remaining;
        if (number < 0) $9d8f421ad7125c06$var$negate(bytes);
        return new Int64(bytes);
    };
    /**
     * Called implicitly by infix arithmetic operators.
     */ Int64.prototype.valueOf = function() {
        var bytes = this.bytes.slice(0);
        var negative = bytes[0] & 128;
        if (negative) $9d8f421ad7125c06$var$negate(bytes);
        return parseInt((0, $2YcGN.toHex)(bytes), 16) * (negative ? -1 : 1);
    };
    Int64.prototype.toString = function() {
        return String(this.valueOf());
    };
    return Int64;
}();
function $9d8f421ad7125c06$var$negate(bytes) {
    for(var i = 0; i < 8; i++)bytes[i] ^= 0xff;
    for(var i = 7; i > -1; i--){
        bytes[i]++;
        if (bytes[i] !== 0) break;
    }
}

});


parcelRegister("3QPi4", function(module, exports) {

$parcel$export(module.exports, "splitMessage", () => $2cde039e58a6ff0d$export$546b6bc432bd9a53);

var $gpeif = parcelRequire("gpeif");
// All prelude components are unsigned, 32-bit integers
var $2cde039e58a6ff0d$var$PRELUDE_MEMBER_LENGTH = 4;
// The prelude consists of two components
var $2cde039e58a6ff0d$var$PRELUDE_LENGTH = $2cde039e58a6ff0d$var$PRELUDE_MEMBER_LENGTH * 2;
// Checksums are always CRC32 hashes.
var $2cde039e58a6ff0d$var$CHECKSUM_LENGTH = 4;
// Messages must include a full prelude, a prelude checksum, and a message checksum
var $2cde039e58a6ff0d$var$MINIMUM_MESSAGE_LENGTH = $2cde039e58a6ff0d$var$PRELUDE_LENGTH + $2cde039e58a6ff0d$var$CHECKSUM_LENGTH * 2;
function $2cde039e58a6ff0d$export$546b6bc432bd9a53(_a) {
    var byteLength = _a.byteLength, byteOffset = _a.byteOffset, buffer = _a.buffer;
    if (byteLength < $2cde039e58a6ff0d$var$MINIMUM_MESSAGE_LENGTH) throw new Error("Provided message too short to accommodate event stream message overhead");
    var view = new DataView(buffer, byteOffset, byteLength);
    var messageLength = view.getUint32(0, false);
    if (byteLength !== messageLength) throw new Error("Reported message length does not match received message length");
    var headerLength = view.getUint32($2cde039e58a6ff0d$var$PRELUDE_MEMBER_LENGTH, false);
    var expectedPreludeChecksum = view.getUint32($2cde039e58a6ff0d$var$PRELUDE_LENGTH, false);
    var expectedMessageChecksum = view.getUint32(byteLength - $2cde039e58a6ff0d$var$CHECKSUM_LENGTH, false);
    var checksummer = new (0, $gpeif.Crc32)().update(new Uint8Array(buffer, byteOffset, $2cde039e58a6ff0d$var$PRELUDE_LENGTH));
    if (expectedPreludeChecksum !== checksummer.digest()) throw new Error("The prelude checksum specified in the message (" + expectedPreludeChecksum + ") does not match the calculated CRC32 checksum (" + checksummer.digest() + ")");
    checksummer.update(new Uint8Array(buffer, byteOffset + $2cde039e58a6ff0d$var$PRELUDE_LENGTH, byteLength - ($2cde039e58a6ff0d$var$PRELUDE_LENGTH + $2cde039e58a6ff0d$var$CHECKSUM_LENGTH)));
    if (expectedMessageChecksum !== checksummer.digest()) throw new Error("The message checksum (" + checksummer.digest() + ") did not match the expected value of " + expectedMessageChecksum);
    return {
        headers: new DataView(buffer, byteOffset + $2cde039e58a6ff0d$var$PRELUDE_LENGTH + $2cde039e58a6ff0d$var$CHECKSUM_LENGTH, headerLength),
        body: new Uint8Array(buffer, byteOffset + $2cde039e58a6ff0d$var$PRELUDE_LENGTH + $2cde039e58a6ff0d$var$CHECKSUM_LENGTH + headerLength, messageLength - headerLength - ($2cde039e58a6ff0d$var$PRELUDE_LENGTH + $2cde039e58a6ff0d$var$CHECKSUM_LENGTH + $2cde039e58a6ff0d$var$CHECKSUM_LENGTH))
    };
}

});


parcelRegister("7eD0L", function(module, exports) {

});


parcelRegister("6JsHr", function(module, exports) {
$parcel$export(module.exports, "EventStreamMarshaller", () => (parcelRequire("1OE66")).EventStreamMarshaller);
parcelRequire("2Tq77");
parcelRequire("1OE66");

});
parcelRegister("2Tq77", function(module, exports) {

var $1OE66 = parcelRequire("1OE66");
var $21b4f9818470baff$export$9d23a885702ebafb = function(options) {
    return new (0, $1OE66.EventStreamMarshaller)(options);
};

});
parcelRegister("1OE66", function(module, exports) {

$parcel$export(module.exports, "EventStreamMarshaller", () => $152990730bf2d891$export$b64afa0aa6ce60e2);

var $khVj1 = parcelRequire("khVj1");
parcelRequire("bHRM6");
var $2H0x3 = parcelRequire("2H0x3");

var $aruQK = parcelRequire("aruQK");

var $iJ3yK = parcelRequire("iJ3yK");
var $152990730bf2d891$export$b64afa0aa6ce60e2 = /** @class */ function() {
    function EventStreamMarshaller(_a) {
        var utf8Encoder = _a.utf8Encoder, utf8Decoder = _a.utf8Decoder;
        this.eventMarshaller = new (0, $2H0x3.EventStreamMarshaller)(utf8Encoder, utf8Decoder);
        this.utfEncoder = utf8Encoder;
    }
    EventStreamMarshaller.prototype.deserialize = function(body, deserializer) {
        var chunkedStream = (0, $aruQK.getChunkedStream)(body);
        var unmarshalledStream = (0, $iJ3yK.getUnmarshalledStream)(chunkedStream, {
            eventMarshaller: this.eventMarshaller,
            deserializer: deserializer,
            toUtf8: this.utfEncoder
        });
        return unmarshalledStream;
    };
    EventStreamMarshaller.prototype.serialize = function(input, serializer) {
        var _a;
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var self = this;
        var serializedIterator = function() {
            return (0, $khVj1.__asyncGenerator)(this, arguments, function() {
                var input_1, input_1_1, chunk, payloadBuf, e_1_1;
                var e_1, _a;
                return (0, $khVj1.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            _b.trys.push([
                                0,
                                7,
                                8,
                                13
                            ]);
                            input_1 = (0, $khVj1.__asyncValues)(input);
                            _b.label = 1;
                        case 1:
                            return [
                                4 /*yield*/ ,
                                (0, $khVj1.__await)(input_1.next())
                            ];
                        case 2:
                            if (!(input_1_1 = _b.sent(), !input_1_1.done)) return [
                                3 /*break*/ ,
                                6
                            ];
                            chunk = input_1_1.value;
                            payloadBuf = self.eventMarshaller.marshall(serializer(chunk));
                            return [
                                4 /*yield*/ ,
                                (0, $khVj1.__await)(payloadBuf)
                            ];
                        case 3:
                            return [
                                4 /*yield*/ ,
                                _b.sent()
                            ];
                        case 4:
                            _b.sent();
                            _b.label = 5;
                        case 5:
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 6:
                            return [
                                3 /*break*/ ,
                                13
                            ];
                        case 7:
                            e_1_1 = _b.sent();
                            e_1 = {
                                error: e_1_1
                            };
                            return [
                                3 /*break*/ ,
                                13
                            ];
                        case 8:
                            _b.trys.push([
                                8,
                                ,
                                11,
                                12
                            ]);
                            if (!(input_1_1 && !input_1_1.done && (_a = input_1.return))) return [
                                3 /*break*/ ,
                                10
                            ];
                            return [
                                4 /*yield*/ ,
                                (0, $khVj1.__await)(_a.call(input_1))
                            ];
                        case 9:
                            _b.sent();
                            _b.label = 10;
                        case 10:
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case 11:
                            if (e_1) throw e_1.error;
                            return [
                                7 /*endfinally*/ 
                            ];
                        case 12:
                            return [
                                7 /*endfinally*/ 
                            ];
                        case 13:
                            return [
                                4 /*yield*/ ,
                                (0, $khVj1.__await)(new Uint8Array(0))
                            ];
                        case 14:
                            // Ending frame
                            return [
                                4 /*yield*/ ,
                                _b.sent()
                            ];
                        case 15:
                            // Ending frame
                            _b.sent();
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        return _a = {}, _a[Symbol.asyncIterator] = serializedIterator, _a;
    };
    return EventStreamMarshaller;
}();

});
parcelRegister("khVj1", function(module, exports) {

$parcel$export(module.exports, "__generator", () => $ec51d8e5c1187044$export$67ebef60e6f28a6);
$parcel$export(module.exports, "__await", () => $ec51d8e5c1187044$export$10c90e4f7922046c);
$parcel$export(module.exports, "__asyncGenerator", () => $ec51d8e5c1187044$export$e427f37a30a4de9b);
$parcel$export(module.exports, "__asyncValues", () => $ec51d8e5c1187044$export$e3b29a3d6162315f);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $ec51d8e5c1187044$var$extendStatics = function(d, b) {
    $ec51d8e5c1187044$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $ec51d8e5c1187044$var$extendStatics(d, b);
};
function $ec51d8e5c1187044$export$a8ba968b8961cb8a(d, b) {
    $ec51d8e5c1187044$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $ec51d8e5c1187044$export$18ce0697a983be9b = function() {
    $ec51d8e5c1187044$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ec51d8e5c1187044$export$18ce0697a983be9b.apply(this, arguments);
};
function $ec51d8e5c1187044$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $ec51d8e5c1187044$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $ec51d8e5c1187044$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $ec51d8e5c1187044$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $ec51d8e5c1187044$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $ec51d8e5c1187044$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $ec51d8e5c1187044$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $ec51d8e5c1187044$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $ec51d8e5c1187044$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $ec51d8e5c1187044$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $ec51d8e5c1187044$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($ec51d8e5c1187044$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $ec51d8e5c1187044$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $ec51d8e5c1187044$export$10c90e4f7922046c(v) {
    return this instanceof $ec51d8e5c1187044$export$10c90e4f7922046c ? (this.v = v, this) : new $ec51d8e5c1187044$export$10c90e4f7922046c(v);
}
function $ec51d8e5c1187044$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $ec51d8e5c1187044$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $ec51d8e5c1187044$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $ec51d8e5c1187044$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $ec51d8e5c1187044$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $ec51d8e5c1187044$export$19a8beecd37a4c45 === "function" ? $ec51d8e5c1187044$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $ec51d8e5c1187044$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $ec51d8e5c1187044$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $ec51d8e5c1187044$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $ec51d8e5c1187044$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $ec51d8e5c1187044$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("aruQK", function(module, exports) {

$parcel$export(module.exports, "getChunkedStream", () => $79a45b2018965832$export$3071cd8be9cd01e0);

var $khVj1 = parcelRequire("khVj1");
function $79a45b2018965832$export$3071cd8be9cd01e0(source) {
    var _a;
    var currentMessageTotalLength = 0;
    var currentMessagePendingLength = 0;
    var currentMessage = null;
    var messageLengthBuffer = null;
    var allocateMessage = function(size) {
        if (typeof size !== "number") throw new Error("Attempted to allocate an event message where size was not a number: " + size);
        currentMessageTotalLength = size;
        currentMessagePendingLength = 4;
        currentMessage = new Uint8Array(size);
        var currentMessageView = new DataView(currentMessage.buffer);
        currentMessageView.setUint32(0, size, false); //set big-endian Uint32 to 0~3 bytes
    };
    var iterator = function() {
        return (0, $khVj1.__asyncGenerator)(this, arguments, function() {
            var sourceIterator, _a, value, done, chunkLength, currentOffset, bytesRemaining, numBytesForTotal, numBytesToWrite;
            return (0, $khVj1.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        sourceIterator = source[Symbol.asyncIterator]();
                        _b.label = 1;
                    case 1:
                        return [
                            4 /*yield*/ ,
                            (0, $khVj1.__await)(sourceIterator.next())
                        ];
                    case 2:
                        _a = _b.sent(), value = _a.value, done = _a.done;
                        if (!done) return [
                            3 /*break*/ ,
                            10
                        ];
                        if (!!currentMessageTotalLength) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $khVj1.__await)(void 0)
                        ];
                    case 3:
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                    case 4:
                        if (!(currentMessageTotalLength === currentMessagePendingLength)) return [
                            3 /*break*/ ,
                            7
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $khVj1.__await)(currentMessage)
                        ];
                    case 5:
                        return [
                            4 /*yield*/ ,
                            _b.sent()
                        ];
                    case 6:
                        _b.sent();
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 7:
                        throw new Error("Truncated event message received.");
                    case 8:
                        return [
                            4 /*yield*/ ,
                            (0, $khVj1.__await)(void 0)
                        ];
                    case 9:
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                    case 10:
                        chunkLength = value.length;
                        currentOffset = 0;
                        _b.label = 11;
                    case 11:
                        if (!(currentOffset < chunkLength)) return [
                            3 /*break*/ ,
                            15
                        ];
                        // create new message if necessary
                        if (!currentMessage) {
                            bytesRemaining = chunkLength - currentOffset;
                            // prevent edge case where total length spans 2 chunks
                            if (!messageLengthBuffer) messageLengthBuffer = new Uint8Array(4);
                            numBytesForTotal = Math.min(4 - currentMessagePendingLength, bytesRemaining // bytes left in chunk
                            );
                            messageLengthBuffer.set(// @ts-ignore error TS2532: Object is possibly 'undefined' for value
                            value.slice(currentOffset, currentOffset + numBytesForTotal), currentMessagePendingLength);
                            currentMessagePendingLength += numBytesForTotal;
                            currentOffset += numBytesForTotal;
                            if (currentMessagePendingLength < 4) // not enough information to create the current message
                            return [
                                3 /*break*/ ,
                                15
                            ];
                            allocateMessage(new DataView(messageLengthBuffer.buffer).getUint32(0, false));
                            messageLengthBuffer = null;
                        }
                        numBytesToWrite = Math.min(currentMessageTotalLength - currentMessagePendingLength, chunkLength - currentOffset // number of bytes left in the original chunk
                        );
                        currentMessage.set(// @ts-ignore error TS2532: Object is possibly 'undefined' for value
                        value.slice(currentOffset, currentOffset + numBytesToWrite), currentMessagePendingLength);
                        currentMessagePendingLength += numBytesToWrite;
                        currentOffset += numBytesToWrite;
                        if (!(currentMessageTotalLength && currentMessageTotalLength === currentMessagePendingLength)) return [
                            3 /*break*/ ,
                            14
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $khVj1.__await)(currentMessage)
                        ];
                    case 12:
                        // push out the message
                        return [
                            4 /*yield*/ ,
                            _b.sent()
                        ];
                    case 13:
                        // push out the message
                        _b.sent();
                        // cleanup
                        currentMessage = null;
                        currentMessageTotalLength = 0;
                        currentMessagePendingLength = 0;
                        _b.label = 14;
                    case 14:
                        return [
                            3 /*break*/ ,
                            11
                        ];
                    case 15:
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 16:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return _a = {}, _a[Symbol.asyncIterator] = iterator, _a;
}

});

parcelRegister("iJ3yK", function(module, exports) {

$parcel$export(module.exports, "getUnmarshalledStream", () => $0384a1d1b02522fe$export$a1a364c5c6ddc1b4);

var $khVj1 = parcelRequire("khVj1");
function $0384a1d1b02522fe$export$a1a364c5c6ddc1b4(source, options) {
    var _a;
    return _a = {}, _a[Symbol.asyncIterator] = function() {
        return (0, $khVj1.__asyncGenerator)(this, arguments, function() {
            var source_1, source_1_1, chunk, message, messageType, unmodeledError, code, exception, deserializedException, error, event, deserialized, e_1_1;
            var _a, _b;
            var e_1, _c;
            return (0, $khVj1.__generator)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        _d.trys.push([
                            0,
                            12,
                            13,
                            18
                        ]);
                        source_1 = (0, $khVj1.__asyncValues)(source);
                        _d.label = 1;
                    case 1:
                        return [
                            4 /*yield*/ ,
                            (0, $khVj1.__await)(source_1.next())
                        ];
                    case 2:
                        if (!(source_1_1 = _d.sent(), !source_1_1.done)) return [
                            3 /*break*/ ,
                            11
                        ];
                        chunk = source_1_1.value;
                        message = options.eventMarshaller.unmarshall(chunk);
                        messageType = message.headers[":message-type"].value;
                        if (!(messageType === "error")) return [
                            3 /*break*/ ,
                            3
                        ];
                        unmodeledError = new Error(message.headers[":error-message"].value || "UnknownError");
                        unmodeledError.name = message.headers[":error-code"].value;
                        throw unmodeledError;
                    case 3:
                        if (!(messageType === "exception")) return [
                            3 /*break*/ ,
                            5
                        ];
                        code = message.headers[":exception-type"].value;
                        exception = (_a = {}, _a[code] = message, _a);
                        return [
                            4 /*yield*/ ,
                            (0, $khVj1.__await)(options.deserializer(exception))
                        ];
                    case 4:
                        deserializedException = _d.sent();
                        if (deserializedException.$unknown) {
                            error = new Error(options.toUtf8(message.body));
                            error.name = code;
                            throw error;
                        }
                        throw deserializedException[code];
                    case 5:
                        if (!(messageType === "event")) return [
                            3 /*break*/ ,
                            9
                        ];
                        event = (_b = {}, _b[message.headers[":event-type"].value] = message, _b);
                        return [
                            4 /*yield*/ ,
                            (0, $khVj1.__await)(options.deserializer(event))
                        ];
                    case 6:
                        deserialized = _d.sent();
                        if (deserialized.$unknown) return [
                            3 /*break*/ ,
                            10
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $khVj1.__await)(deserialized)
                        ];
                    case 7:
                        return [
                            4 /*yield*/ ,
                            _d.sent()
                        ];
                    case 8:
                        _d.sent();
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 9:
                        throw Error("Unrecognizable event type: " + message.headers[":event-type"].value);
                    case 10:
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 11:
                        return [
                            3 /*break*/ ,
                            18
                        ];
                    case 12:
                        e_1_1 = _d.sent();
                        e_1 = {
                            error: e_1_1
                        };
                        return [
                            3 /*break*/ ,
                            18
                        ];
                    case 13:
                        _d.trys.push([
                            13,
                            ,
                            16,
                            17
                        ]);
                        if (!(source_1_1 && !source_1_1.done && (_c = source_1.return))) return [
                            3 /*break*/ ,
                            15
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $khVj1.__await)(_c.call(source_1))
                        ];
                    case 14:
                        _d.sent();
                        _d.label = 15;
                    case 15:
                        return [
                            3 /*break*/ ,
                            17
                        ];
                    case 16:
                        if (e_1) throw e_1.error;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 17:
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 18:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, _a;
}

});




parcelRegister("2PB0H", function(module, exports) {

$parcel$export(module.exports, "readableStreamtoIterable", () => $20fd0da723bacc64$export$2346526b0991dd88);
$parcel$export(module.exports, "iterableToReadableStream", () => $20fd0da723bacc64$export$92326f9d37f111f);

var $8SwW1 = parcelRequire("8SwW1");
var $20fd0da723bacc64$export$2346526b0991dd88 = function(readableStream) {
    var _a;
    return _a = {}, _a[Symbol.asyncIterator] = function() {
        return (0, $8SwW1.__asyncGenerator)(this, arguments, function() {
            var reader, _a, done, value;
            return (0, $8SwW1.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        reader = readableStream.getReader();
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            ,
                            9,
                            10
                        ]);
                        _b.label = 2;
                    case 2:
                        return [
                            4 /*yield*/ ,
                            (0, $8SwW1.__await)(reader.read())
                        ];
                    case 3:
                        _a = _b.sent(), done = _a.done, value = _a.value;
                        if (!done) return [
                            3 /*break*/ ,
                            5
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $8SwW1.__await)(void 0)
                        ];
                    case 4:
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                    case 5:
                        return [
                            4 /*yield*/ ,
                            (0, $8SwW1.__await)(value)
                        ];
                    case 6:
                        return [
                            4 /*yield*/ ,
                            _b.sent()
                        ];
                    case 7:
                        _b.sent();
                        return [
                            3 /*break*/ ,
                            2
                        ];
                    case 8:
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 9:
                        reader.releaseLock();
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 10:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, _a;
};
var $20fd0da723bacc64$export$92326f9d37f111f = function(asyncIterable) {
    var iterator = asyncIterable[Symbol.asyncIterator]();
    return new ReadableStream({
        pull: function(controller) {
            return (0, $8SwW1.__awaiter)(this, void 0, void 0, function() {
                var _a, done, value;
                return (0, $8SwW1.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                iterator.next()
                            ];
                        case 1:
                            _a = _b.sent(), done = _a.done, value = _a.value;
                            if (done) return [
                                2 /*return*/ ,
                                controller.close()
                            ];
                            controller.enqueue(value);
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        }
    });
};

});
parcelRegister("8SwW1", function(module, exports) {

$parcel$export(module.exports, "__awaiter", () => $676cea0ae0973220$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $676cea0ae0973220$export$67ebef60e6f28a6);
$parcel$export(module.exports, "__await", () => $676cea0ae0973220$export$10c90e4f7922046c);
$parcel$export(module.exports, "__asyncGenerator", () => $676cea0ae0973220$export$e427f37a30a4de9b);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $676cea0ae0973220$var$extendStatics = function(d, b) {
    $676cea0ae0973220$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $676cea0ae0973220$var$extendStatics(d, b);
};
function $676cea0ae0973220$export$a8ba968b8961cb8a(d, b) {
    $676cea0ae0973220$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $676cea0ae0973220$export$18ce0697a983be9b = function() {
    $676cea0ae0973220$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $676cea0ae0973220$export$18ce0697a983be9b.apply(this, arguments);
};
function $676cea0ae0973220$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $676cea0ae0973220$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $676cea0ae0973220$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $676cea0ae0973220$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $676cea0ae0973220$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $676cea0ae0973220$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $676cea0ae0973220$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $676cea0ae0973220$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $676cea0ae0973220$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $676cea0ae0973220$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $676cea0ae0973220$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($676cea0ae0973220$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $676cea0ae0973220$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $676cea0ae0973220$export$10c90e4f7922046c(v) {
    return this instanceof $676cea0ae0973220$export$10c90e4f7922046c ? (this.v = v, this) : new $676cea0ae0973220$export$10c90e4f7922046c(v);
}
function $676cea0ae0973220$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $676cea0ae0973220$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $676cea0ae0973220$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $676cea0ae0973220$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $676cea0ae0973220$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $676cea0ae0973220$export$19a8beecd37a4c45 === "function" ? $676cea0ae0973220$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $676cea0ae0973220$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $676cea0ae0973220$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $676cea0ae0973220$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $676cea0ae0973220$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $676cea0ae0973220$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});





parcelRegister("lYnMo", function(module, exports) {

$parcel$export(module.exports, "blobHasher", () => $fff1a5b36d4a9869$export$ea66e9c498b7933c);

var $5IYid = parcelRequire("5IYid");

var $8xI1p = parcelRequire("8xI1p");
var $fff1a5b36d4a9869$export$ea66e9c498b7933c = function blobHasher(hashCtor, blob) {
    return (0, $5IYid.__awaiter)(this, void 0, void 0, function() {
        var hash;
        return (0, $5IYid.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    hash = new hashCtor();
                    return [
                        4 /*yield*/ ,
                        (0, $8xI1p.blobReader)(blob, function(chunk) {
                            hash.update(chunk);
                        })
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        hash.digest()
                    ];
            }
        });
    });
};

});
parcelRegister("5IYid", function(module, exports) {

$parcel$export(module.exports, "__awaiter", () => $42afd4b721add550$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $42afd4b721add550$export$67ebef60e6f28a6);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $42afd4b721add550$var$extendStatics = function(d, b) {
    $42afd4b721add550$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $42afd4b721add550$var$extendStatics(d, b);
};
function $42afd4b721add550$export$a8ba968b8961cb8a(d, b) {
    $42afd4b721add550$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $42afd4b721add550$export$18ce0697a983be9b = function() {
    $42afd4b721add550$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $42afd4b721add550$export$18ce0697a983be9b.apply(this, arguments);
};
function $42afd4b721add550$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $42afd4b721add550$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $42afd4b721add550$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $42afd4b721add550$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $42afd4b721add550$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $42afd4b721add550$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $42afd4b721add550$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $42afd4b721add550$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $42afd4b721add550$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $42afd4b721add550$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $42afd4b721add550$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($42afd4b721add550$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $42afd4b721add550$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $42afd4b721add550$export$10c90e4f7922046c(v) {
    return this instanceof $42afd4b721add550$export$10c90e4f7922046c ? (this.v = v, this) : new $42afd4b721add550$export$10c90e4f7922046c(v);
}
function $42afd4b721add550$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $42afd4b721add550$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $42afd4b721add550$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $42afd4b721add550$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $42afd4b721add550$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $42afd4b721add550$export$19a8beecd37a4c45 === "function" ? $42afd4b721add550$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $42afd4b721add550$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $42afd4b721add550$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $42afd4b721add550$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $42afd4b721add550$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $42afd4b721add550$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("8xI1p", function(module, exports) {

$parcel$export(module.exports, "blobReader", () => $63838d98e7ed0414$export$7541dba16c2127c8);
function $63838d98e7ed0414$export$7541dba16c2127c8(blob, onChunk, chunkSize) {
    if (chunkSize === void 0) chunkSize = 1048576;
    return new Promise(function(resolve, reject) {
        var fileReader = new FileReader();
        fileReader.addEventListener("error", reject);
        fileReader.addEventListener("abort", reject);
        var size = blob.size;
        var totalBytesRead = 0;
        function read() {
            if (totalBytesRead >= size) {
                resolve();
                return;
            }
            fileReader.readAsArrayBuffer(blob.slice(totalBytesRead, Math.min(size, totalBytesRead + chunkSize)));
        }
        fileReader.addEventListener("load", function(event) {
            var result = event.target.result;
            onChunk(new Uint8Array(result));
            totalBytesRead += result.byteLength;
            // read the next block
            read();
        });
        // kick off the read
        read();
    });
}

});


parcelRegister("jpy9E", function(module, exports) {

$parcel$export(module.exports, "Md5", () => $e21ad8880a0848f1$export$9f5a3dfc7a9f5dd);

var $fVWLV = parcelRequire("fVWLV");

var $jJ4yr = parcelRequire("jJ4yr");

var $cHoN9 = parcelRequire("cHoN9");
var $e21ad8880a0848f1$export$9f5a3dfc7a9f5dd = /** @class */ function() {
    function Md5() {
        this.state = Uint32Array.from((0, $cHoN9.INIT));
        this.buffer = new DataView(new ArrayBuffer((0, $cHoN9.BLOCK_SIZE)));
        this.bufferLength = 0;
        this.bytesHashed = 0;
        this.finished = false;
    }
    Md5.prototype.update = function(sourceData) {
        if ($e21ad8880a0848f1$var$isEmptyData(sourceData)) return;
        else if (this.finished) throw new Error("Attempted to update an already finished hash.");
        var data = $e21ad8880a0848f1$var$convertToBuffer(sourceData);
        var position = 0;
        var byteLength = data.byteLength;
        this.bytesHashed += byteLength;
        while(byteLength > 0){
            this.buffer.setUint8(this.bufferLength++, data[position++]);
            byteLength--;
            if (this.bufferLength === (0, $cHoN9.BLOCK_SIZE)) {
                this.hashBuffer();
                this.bufferLength = 0;
            }
        }
    };
    Md5.prototype.digest = function() {
        return (0, $fVWLV.__awaiter)(this, void 0, void 0, function() {
            var _a, buffer, undecoratedLength, bytesHashed, bitsHashed, i, i, out, i;
            return (0, $fVWLV.__generator)(this, function(_b) {
                if (!this.finished) {
                    _a = this, buffer = _a.buffer, undecoratedLength = _a.bufferLength, bytesHashed = _a.bytesHashed;
                    bitsHashed = bytesHashed * 8;
                    buffer.setUint8(this.bufferLength++, 128);
                    // Ensure the final block has enough room for the hashed length
                    if (undecoratedLength % (0, $cHoN9.BLOCK_SIZE) >= (0, $cHoN9.BLOCK_SIZE) - 8) {
                        for(i = this.bufferLength; i < (0, $cHoN9.BLOCK_SIZE); i++)buffer.setUint8(i, 0);
                        this.hashBuffer();
                        this.bufferLength = 0;
                    }
                    for(i = this.bufferLength; i < (0, $cHoN9.BLOCK_SIZE) - 8; i++)buffer.setUint8(i, 0);
                    buffer.setUint32((0, $cHoN9.BLOCK_SIZE) - 8, bitsHashed >>> 0, true);
                    buffer.setUint32((0, $cHoN9.BLOCK_SIZE) - 4, Math.floor(bitsHashed / 0x100000000), true);
                    this.hashBuffer();
                    this.finished = true;
                }
                out = new DataView(new ArrayBuffer((0, $cHoN9.DIGEST_LENGTH)));
                for(i = 0; i < 4; i++)out.setUint32(i * 4, this.state[i], true);
                return [
                    2 /*return*/ ,
                    new Uint8Array(out.buffer, out.byteOffset, out.byteLength)
                ];
            });
        });
    };
    Md5.prototype.hashBuffer = function() {
        var _a = this, buffer = _a.buffer, state = _a.state;
        var a = state[0], b = state[1], c = state[2], d = state[3];
        a = $e21ad8880a0848f1$var$ff(a, b, c, d, buffer.getUint32(0, true), 7, 0xd76aa478);
        d = $e21ad8880a0848f1$var$ff(d, a, b, c, buffer.getUint32(4, true), 12, 0xe8c7b756);
        c = $e21ad8880a0848f1$var$ff(c, d, a, b, buffer.getUint32(8, true), 17, 0x242070db);
        b = $e21ad8880a0848f1$var$ff(b, c, d, a, buffer.getUint32(12, true), 22, 0xc1bdceee);
        a = $e21ad8880a0848f1$var$ff(a, b, c, d, buffer.getUint32(16, true), 7, 0xf57c0faf);
        d = $e21ad8880a0848f1$var$ff(d, a, b, c, buffer.getUint32(20, true), 12, 0x4787c62a);
        c = $e21ad8880a0848f1$var$ff(c, d, a, b, buffer.getUint32(24, true), 17, 0xa8304613);
        b = $e21ad8880a0848f1$var$ff(b, c, d, a, buffer.getUint32(28, true), 22, 0xfd469501);
        a = $e21ad8880a0848f1$var$ff(a, b, c, d, buffer.getUint32(32, true), 7, 0x698098d8);
        d = $e21ad8880a0848f1$var$ff(d, a, b, c, buffer.getUint32(36, true), 12, 0x8b44f7af);
        c = $e21ad8880a0848f1$var$ff(c, d, a, b, buffer.getUint32(40, true), 17, 0xffff5bb1);
        b = $e21ad8880a0848f1$var$ff(b, c, d, a, buffer.getUint32(44, true), 22, 0x895cd7be);
        a = $e21ad8880a0848f1$var$ff(a, b, c, d, buffer.getUint32(48, true), 7, 0x6b901122);
        d = $e21ad8880a0848f1$var$ff(d, a, b, c, buffer.getUint32(52, true), 12, 0xfd987193);
        c = $e21ad8880a0848f1$var$ff(c, d, a, b, buffer.getUint32(56, true), 17, 0xa679438e);
        b = $e21ad8880a0848f1$var$ff(b, c, d, a, buffer.getUint32(60, true), 22, 0x49b40821);
        a = $e21ad8880a0848f1$var$gg(a, b, c, d, buffer.getUint32(4, true), 5, 0xf61e2562);
        d = $e21ad8880a0848f1$var$gg(d, a, b, c, buffer.getUint32(24, true), 9, 0xc040b340);
        c = $e21ad8880a0848f1$var$gg(c, d, a, b, buffer.getUint32(44, true), 14, 0x265e5a51);
        b = $e21ad8880a0848f1$var$gg(b, c, d, a, buffer.getUint32(0, true), 20, 0xe9b6c7aa);
        a = $e21ad8880a0848f1$var$gg(a, b, c, d, buffer.getUint32(20, true), 5, 0xd62f105d);
        d = $e21ad8880a0848f1$var$gg(d, a, b, c, buffer.getUint32(40, true), 9, 0x02441453);
        c = $e21ad8880a0848f1$var$gg(c, d, a, b, buffer.getUint32(60, true), 14, 0xd8a1e681);
        b = $e21ad8880a0848f1$var$gg(b, c, d, a, buffer.getUint32(16, true), 20, 0xe7d3fbc8);
        a = $e21ad8880a0848f1$var$gg(a, b, c, d, buffer.getUint32(36, true), 5, 0x21e1cde6);
        d = $e21ad8880a0848f1$var$gg(d, a, b, c, buffer.getUint32(56, true), 9, 0xc33707d6);
        c = $e21ad8880a0848f1$var$gg(c, d, a, b, buffer.getUint32(12, true), 14, 0xf4d50d87);
        b = $e21ad8880a0848f1$var$gg(b, c, d, a, buffer.getUint32(32, true), 20, 0x455a14ed);
        a = $e21ad8880a0848f1$var$gg(a, b, c, d, buffer.getUint32(52, true), 5, 0xa9e3e905);
        d = $e21ad8880a0848f1$var$gg(d, a, b, c, buffer.getUint32(8, true), 9, 0xfcefa3f8);
        c = $e21ad8880a0848f1$var$gg(c, d, a, b, buffer.getUint32(28, true), 14, 0x676f02d9);
        b = $e21ad8880a0848f1$var$gg(b, c, d, a, buffer.getUint32(48, true), 20, 0x8d2a4c8a);
        a = $e21ad8880a0848f1$var$hh(a, b, c, d, buffer.getUint32(20, true), 4, 0xfffa3942);
        d = $e21ad8880a0848f1$var$hh(d, a, b, c, buffer.getUint32(32, true), 11, 0x8771f681);
        c = $e21ad8880a0848f1$var$hh(c, d, a, b, buffer.getUint32(44, true), 16, 0x6d9d6122);
        b = $e21ad8880a0848f1$var$hh(b, c, d, a, buffer.getUint32(56, true), 23, 0xfde5380c);
        a = $e21ad8880a0848f1$var$hh(a, b, c, d, buffer.getUint32(4, true), 4, 0xa4beea44);
        d = $e21ad8880a0848f1$var$hh(d, a, b, c, buffer.getUint32(16, true), 11, 0x4bdecfa9);
        c = $e21ad8880a0848f1$var$hh(c, d, a, b, buffer.getUint32(28, true), 16, 0xf6bb4b60);
        b = $e21ad8880a0848f1$var$hh(b, c, d, a, buffer.getUint32(40, true), 23, 0xbebfbc70);
        a = $e21ad8880a0848f1$var$hh(a, b, c, d, buffer.getUint32(52, true), 4, 0x289b7ec6);
        d = $e21ad8880a0848f1$var$hh(d, a, b, c, buffer.getUint32(0, true), 11, 0xeaa127fa);
        c = $e21ad8880a0848f1$var$hh(c, d, a, b, buffer.getUint32(12, true), 16, 0xd4ef3085);
        b = $e21ad8880a0848f1$var$hh(b, c, d, a, buffer.getUint32(24, true), 23, 0x04881d05);
        a = $e21ad8880a0848f1$var$hh(a, b, c, d, buffer.getUint32(36, true), 4, 0xd9d4d039);
        d = $e21ad8880a0848f1$var$hh(d, a, b, c, buffer.getUint32(48, true), 11, 0xe6db99e5);
        c = $e21ad8880a0848f1$var$hh(c, d, a, b, buffer.getUint32(60, true), 16, 0x1fa27cf8);
        b = $e21ad8880a0848f1$var$hh(b, c, d, a, buffer.getUint32(8, true), 23, 0xc4ac5665);
        a = $e21ad8880a0848f1$var$ii(a, b, c, d, buffer.getUint32(0, true), 6, 0xf4292244);
        d = $e21ad8880a0848f1$var$ii(d, a, b, c, buffer.getUint32(28, true), 10, 0x432aff97);
        c = $e21ad8880a0848f1$var$ii(c, d, a, b, buffer.getUint32(56, true), 15, 0xab9423a7);
        b = $e21ad8880a0848f1$var$ii(b, c, d, a, buffer.getUint32(20, true), 21, 0xfc93a039);
        a = $e21ad8880a0848f1$var$ii(a, b, c, d, buffer.getUint32(48, true), 6, 0x655b59c3);
        d = $e21ad8880a0848f1$var$ii(d, a, b, c, buffer.getUint32(12, true), 10, 0x8f0ccc92);
        c = $e21ad8880a0848f1$var$ii(c, d, a, b, buffer.getUint32(40, true), 15, 0xffeff47d);
        b = $e21ad8880a0848f1$var$ii(b, c, d, a, buffer.getUint32(4, true), 21, 0x85845dd1);
        a = $e21ad8880a0848f1$var$ii(a, b, c, d, buffer.getUint32(32, true), 6, 0x6fa87e4f);
        d = $e21ad8880a0848f1$var$ii(d, a, b, c, buffer.getUint32(60, true), 10, 0xfe2ce6e0);
        c = $e21ad8880a0848f1$var$ii(c, d, a, b, buffer.getUint32(24, true), 15, 0xa3014314);
        b = $e21ad8880a0848f1$var$ii(b, c, d, a, buffer.getUint32(52, true), 21, 0x4e0811a1);
        a = $e21ad8880a0848f1$var$ii(a, b, c, d, buffer.getUint32(16, true), 6, 0xf7537e82);
        d = $e21ad8880a0848f1$var$ii(d, a, b, c, buffer.getUint32(44, true), 10, 0xbd3af235);
        c = $e21ad8880a0848f1$var$ii(c, d, a, b, buffer.getUint32(8, true), 15, 0x2ad7d2bb);
        b = $e21ad8880a0848f1$var$ii(b, c, d, a, buffer.getUint32(36, true), 21, 0xeb86d391);
        state[0] = a + state[0] & 0xffffffff;
        state[1] = b + state[1] & 0xffffffff;
        state[2] = c + state[2] & 0xffffffff;
        state[3] = d + state[3] & 0xffffffff;
    };
    return Md5;
}();
function $e21ad8880a0848f1$var$cmn(q, a, b, x, s, t) {
    a = (a + q & 0xffffffff) + (x + t & 0xffffffff) & 0xffffffff;
    return (a << s | a >>> 32 - s) + b & 0xffffffff;
}
function $e21ad8880a0848f1$var$ff(a, b, c, d, x, s, t) {
    return $e21ad8880a0848f1$var$cmn(b & c | ~b & d, a, b, x, s, t);
}
function $e21ad8880a0848f1$var$gg(a, b, c, d, x, s, t) {
    return $e21ad8880a0848f1$var$cmn(b & d | c & ~d, a, b, x, s, t);
}
function $e21ad8880a0848f1$var$hh(a, b, c, d, x, s, t) {
    return $e21ad8880a0848f1$var$cmn(b ^ c ^ d, a, b, x, s, t);
}
function $e21ad8880a0848f1$var$ii(a, b, c, d, x, s, t) {
    return $e21ad8880a0848f1$var$cmn(c ^ (b | ~d), a, b, x, s, t);
}
function $e21ad8880a0848f1$var$isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
function $e21ad8880a0848f1$var$convertToBuffer(data) {
    if (typeof data === "string") return (0, $jJ4yr.fromUtf8)(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}

});
parcelRegister("fVWLV", function(module, exports) {

$parcel$export(module.exports, "__awaiter", () => $b999c4c2773a9b76$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $b999c4c2773a9b76$export$67ebef60e6f28a6);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $b999c4c2773a9b76$var$extendStatics = function(d, b) {
    $b999c4c2773a9b76$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $b999c4c2773a9b76$var$extendStatics(d, b);
};
function $b999c4c2773a9b76$export$a8ba968b8961cb8a(d, b) {
    $b999c4c2773a9b76$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $b999c4c2773a9b76$export$18ce0697a983be9b = function() {
    $b999c4c2773a9b76$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b999c4c2773a9b76$export$18ce0697a983be9b.apply(this, arguments);
};
function $b999c4c2773a9b76$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $b999c4c2773a9b76$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $b999c4c2773a9b76$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $b999c4c2773a9b76$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $b999c4c2773a9b76$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $b999c4c2773a9b76$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $b999c4c2773a9b76$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $b999c4c2773a9b76$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $b999c4c2773a9b76$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $b999c4c2773a9b76$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $b999c4c2773a9b76$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($b999c4c2773a9b76$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $b999c4c2773a9b76$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $b999c4c2773a9b76$export$10c90e4f7922046c(v) {
    return this instanceof $b999c4c2773a9b76$export$10c90e4f7922046c ? (this.v = v, this) : new $b999c4c2773a9b76$export$10c90e4f7922046c(v);
}
function $b999c4c2773a9b76$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $b999c4c2773a9b76$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $b999c4c2773a9b76$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $b999c4c2773a9b76$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $b999c4c2773a9b76$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $b999c4c2773a9b76$export$19a8beecd37a4c45 === "function" ? $b999c4c2773a9b76$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $b999c4c2773a9b76$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $b999c4c2773a9b76$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $b999c4c2773a9b76$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $b999c4c2773a9b76$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $b999c4c2773a9b76$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("cHoN9", function(module, exports) {

$parcel$export(module.exports, "BLOCK_SIZE", () => $93ecbb5597722e4c$export$b2e3d6d444266a5c);
$parcel$export(module.exports, "DIGEST_LENGTH", () => $93ecbb5597722e4c$export$d7bd469488748c5f);
$parcel$export(module.exports, "INIT", () => $93ecbb5597722e4c$export$d788bc089976c004);
/**
 * @internal
 */ var $93ecbb5597722e4c$export$b2e3d6d444266a5c = 64;
var $93ecbb5597722e4c$export$d7bd469488748c5f = 16;
var $93ecbb5597722e4c$export$d788bc089976c004 = [
    0x67452301,
    0xefcdab89,
    0x98badcfe,
    0x10325476
];

});


parcelRegister("e6CV3", function(module, exports) {

$parcel$export(module.exports, "ClientSharedValues", () => $a44fd0cb1fbdecd3$export$608864383388f904);

var $6u5dM = parcelRequire("6u5dM");

var $bYLXw = parcelRequire("bYLXw");
var $a44fd0cb1fbdecd3$export$608864383388f904 = {
    apiVersion: "2006-03-01",
    disableHostPrefix: false,
    logger: {},
    regionInfoProvider: (0, $6u5dM.defaultRegionInfoProvider),
    serviceId: "S3",
    signingEscapePath: false,
    urlParser: (0, $bYLXw.parseUrl),
    useArnRegion: false
};

});
parcelRegister("6u5dM", function(module, exports) {

$parcel$export(module.exports, "defaultRegionInfoProvider", () => $4b8998454ca617af$export$2e4318bf13462aa2);

var $2eeCH = parcelRequire("2eeCH");
// Partition default templates
var $4b8998454ca617af$var$AWS_TEMPLATE = "s3.{region}.amazonaws.com";
var $4b8998454ca617af$var$AWS_CN_TEMPLATE = "s3.{region}.amazonaws.com.cn";
var $4b8998454ca617af$var$AWS_ISO_TEMPLATE = "s3.{region}.c2s.ic.gov";
var $4b8998454ca617af$var$AWS_ISO_B_TEMPLATE = "s3.{region}.sc2s.sgov.gov";
var $4b8998454ca617af$var$AWS_US_GOV_TEMPLATE = "s3.{region}.amazonaws.com";
// Partition regions
var $4b8998454ca617af$var$AWS_REGIONS = new Set([
    "af-south-1",
    "ap-east-1",
    "ap-northeast-1",
    "ap-northeast-2",
    "ap-south-1",
    "ap-southeast-1",
    "ap-southeast-2",
    "ca-central-1",
    "eu-central-1",
    "eu-north-1",
    "eu-south-1",
    "eu-west-1",
    "eu-west-2",
    "eu-west-3",
    "me-south-1",
    "sa-east-1",
    "us-east-1",
    "us-east-2",
    "us-west-1",
    "us-west-2"
]);
var $4b8998454ca617af$var$AWS_CN_REGIONS = new Set([
    "cn-north-1",
    "cn-northwest-1"
]);
var $4b8998454ca617af$var$AWS_ISO_REGIONS = new Set([
    "us-iso-east-1"
]);
var $4b8998454ca617af$var$AWS_ISO_B_REGIONS = new Set([
    "us-isob-east-1"
]);
var $4b8998454ca617af$var$AWS_US_GOV_REGIONS = new Set([
    "us-gov-east-1",
    "us-gov-west-1"
]);
var $4b8998454ca617af$export$2e4318bf13462aa2 = function(region, options) {
    var regionInfo = undefined;
    switch(region){
        // First, try to match exact region names.
        case "af-south-1":
            regionInfo = {
                hostname: "s3.af-south-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-east-1":
            regionInfo = {
                hostname: "s3.ap-east-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-northeast-1":
            regionInfo = {
                hostname: "s3.ap-northeast-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-northeast-2":
            regionInfo = {
                hostname: "s3.ap-northeast-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-south-1":
            regionInfo = {
                hostname: "s3.ap-south-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-southeast-1":
            regionInfo = {
                hostname: "s3.ap-southeast-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-southeast-2":
            regionInfo = {
                hostname: "s3.ap-southeast-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "aws-global":
            regionInfo = {
                hostname: "s3.amazonaws.com",
                partition: "aws",
                signingRegion: "us-east-1"
            };
            break;
        case "ca-central-1":
            regionInfo = {
                hostname: "s3.ca-central-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "cn-north-1":
            regionInfo = {
                hostname: "s3.cn-north-1.amazonaws.com.cn",
                partition: "aws-cn"
            };
            break;
        case "cn-northwest-1":
            regionInfo = {
                hostname: "s3.cn-northwest-1.amazonaws.com.cn",
                partition: "aws-cn"
            };
            break;
        case "eu-central-1":
            regionInfo = {
                hostname: "s3.eu-central-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-north-1":
            regionInfo = {
                hostname: "s3.eu-north-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-south-1":
            regionInfo = {
                hostname: "s3.eu-south-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-west-1":
            regionInfo = {
                hostname: "s3.eu-west-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-west-2":
            regionInfo = {
                hostname: "s3.eu-west-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-west-3":
            regionInfo = {
                hostname: "s3.eu-west-3.amazonaws.com",
                partition: "aws"
            };
            break;
        case "fips-us-gov-west-1":
            regionInfo = {
                hostname: "s3-fips.us-gov-west-1.amazonaws.com",
                partition: "aws-us-gov",
                signingRegion: "us-gov-west-1"
            };
            break;
        case "me-south-1":
            regionInfo = {
                hostname: "s3.me-south-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "s3-external-1":
            regionInfo = {
                hostname: "s3-external-1.amazonaws.com",
                partition: "aws",
                signingRegion: "us-east-1"
            };
            break;
        case "sa-east-1":
            regionInfo = {
                hostname: "s3.sa-east-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "us-east-1":
            regionInfo = {
                hostname: "s3.us-east-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "us-east-2":
            regionInfo = {
                hostname: "s3.us-east-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "us-gov-east-1":
            regionInfo = {
                hostname: "s3.us-gov-east-1.amazonaws.com",
                partition: "aws-us-gov"
            };
            break;
        case "us-gov-west-1":
            regionInfo = {
                hostname: "s3.us-gov-west-1.amazonaws.com",
                partition: "aws-us-gov"
            };
            break;
        case "us-iso-east-1":
            regionInfo = {
                hostname: "s3.us-iso-east-1.c2s.ic.gov",
                partition: "aws-iso"
            };
            break;
        case "us-isob-east-1":
            regionInfo = {
                hostname: "s3.us-isob-east-1.sc2s.sgov.gov",
                partition: "aws-iso-b"
            };
            break;
        case "us-west-1":
            regionInfo = {
                hostname: "s3.us-west-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "us-west-2":
            regionInfo = {
                hostname: "s3.us-west-2.amazonaws.com",
                partition: "aws"
            };
            break;
        // Next, try to match partition endpoints.
        default:
            if ($4b8998454ca617af$var$AWS_REGIONS.has(region)) regionInfo = {
                hostname: $4b8998454ca617af$var$AWS_TEMPLATE.replace("{region}", region),
                partition: "aws"
            };
            if ($4b8998454ca617af$var$AWS_CN_REGIONS.has(region)) regionInfo = {
                hostname: $4b8998454ca617af$var$AWS_CN_TEMPLATE.replace("{region}", region),
                partition: "aws-cn"
            };
            if ($4b8998454ca617af$var$AWS_ISO_REGIONS.has(region)) regionInfo = {
                hostname: $4b8998454ca617af$var$AWS_ISO_TEMPLATE.replace("{region}", region),
                partition: "aws-iso"
            };
            if ($4b8998454ca617af$var$AWS_ISO_B_REGIONS.has(region)) regionInfo = {
                hostname: $4b8998454ca617af$var$AWS_ISO_B_TEMPLATE.replace("{region}", region),
                partition: "aws-iso-b"
            };
            if ($4b8998454ca617af$var$AWS_US_GOV_REGIONS.has(region)) regionInfo = {
                hostname: $4b8998454ca617af$var$AWS_US_GOV_TEMPLATE.replace("{region}", region),
                partition: "aws-us-gov"
            };
            // Finally, assume it's an AWS partition endpoint.
            if (regionInfo === undefined) regionInfo = {
                hostname: $4b8998454ca617af$var$AWS_TEMPLATE.replace("{region}", region),
                partition: "aws"
            };
    }
    return Promise.resolve((0, $2eeCH.__assign)({
        signingService: "s3"
    }, regionInfo));
};

});



parcelRegister("jEAqK", function(module, exports) {
$parcel$export(module.exports, "resolveEventStreamSerdeConfig", () => (parcelRequire("jph57")).resolveEventStreamSerdeConfig);
parcelRequire("jph57");

});
parcelRegister("jph57", function(module, exports) {

$parcel$export(module.exports, "resolveEventStreamSerdeConfig", () => $e20d9a2ada67b320$export$5e2ae00bf65442f0);

var $kmUdb = parcelRequire("kmUdb");
var $e20d9a2ada67b320$export$5e2ae00bf65442f0 = function(input) {
    return (0, $kmUdb.__assign)((0, $kmUdb.__assign)({}, input), {
        eventStreamMarshaller: input.eventStreamSerdeProvider(input)
    });
};

});
parcelRegister("kmUdb", function(module, exports) {

$parcel$export(module.exports, "__assign", () => $ed41772b97fe501d$export$18ce0697a983be9b);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $ed41772b97fe501d$var$extendStatics = function(d, b) {
    $ed41772b97fe501d$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $ed41772b97fe501d$var$extendStatics(d, b);
};
function $ed41772b97fe501d$export$a8ba968b8961cb8a(d, b) {
    $ed41772b97fe501d$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $ed41772b97fe501d$export$18ce0697a983be9b = function() {
    $ed41772b97fe501d$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ed41772b97fe501d$export$18ce0697a983be9b.apply(this, arguments);
};
function $ed41772b97fe501d$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $ed41772b97fe501d$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $ed41772b97fe501d$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $ed41772b97fe501d$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $ed41772b97fe501d$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $ed41772b97fe501d$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $ed41772b97fe501d$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $ed41772b97fe501d$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $ed41772b97fe501d$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $ed41772b97fe501d$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $ed41772b97fe501d$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($ed41772b97fe501d$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $ed41772b97fe501d$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $ed41772b97fe501d$export$10c90e4f7922046c(v) {
    return this instanceof $ed41772b97fe501d$export$10c90e4f7922046c ? (this.v = v, this) : new $ed41772b97fe501d$export$10c90e4f7922046c(v);
}
function $ed41772b97fe501d$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $ed41772b97fe501d$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $ed41772b97fe501d$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $ed41772b97fe501d$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $ed41772b97fe501d$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $ed41772b97fe501d$export$19a8beecd37a4c45 === "function" ? $ed41772b97fe501d$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $ed41772b97fe501d$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $ed41772b97fe501d$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $ed41772b97fe501d$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $ed41772b97fe501d$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $ed41772b97fe501d$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});



parcelRegister("kGyTS", function(module, exports) {

$parcel$export(module.exports, "getAddExpectContinuePlugin", () => $f0f2cd5d27be2693$export$7692e5e7214e5cd1);

var $6Taed = parcelRequire("6Taed");
parcelRequire("3uM9B");
var $dlqaT = parcelRequire("dlqaT");
function $f0f2cd5d27be2693$export$ea55ca13ab589d75(options) {
    var _this = this;
    return function(next) {
        return function(args) {
            return (0, $6Taed.__awaiter)(_this, void 0, void 0, function() {
                var request;
                return (0, $6Taed.__generator)(this, function(_a) {
                    request = args.request;
                    if ((0, $dlqaT.HttpRequest).isInstance(request) && request.body && options.runtime === "node") request.headers = (0, $6Taed.__assign)((0, $6Taed.__assign)({}, request.headers), {
                        Expect: "100-continue"
                    });
                    return [
                        2 /*return*/ ,
                        next((0, $6Taed.__assign)((0, $6Taed.__assign)({}, args), {
                            request: request
                        }))
                    ];
                });
            });
        };
    };
}
var $f0f2cd5d27be2693$export$582010bfa3126ad3 = {
    step: "build",
    tags: [
        "SET_EXPECT_HEADER",
        "EXPECT_HEADER"
    ],
    name: "addExpectContinueMiddleware",
    override: true
};
var $f0f2cd5d27be2693$export$7692e5e7214e5cd1 = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add($f0f2cd5d27be2693$export$ea55ca13ab589d75(options), $f0f2cd5d27be2693$export$582010bfa3126ad3);
        }
    };
};

});
parcelRegister("6Taed", function(module, exports) {

$parcel$export(module.exports, "__assign", () => $503fd042c818610c$export$18ce0697a983be9b);
$parcel$export(module.exports, "__awaiter", () => $503fd042c818610c$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $503fd042c818610c$export$67ebef60e6f28a6);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $503fd042c818610c$var$extendStatics = function(d, b) {
    $503fd042c818610c$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $503fd042c818610c$var$extendStatics(d, b);
};
function $503fd042c818610c$export$a8ba968b8961cb8a(d, b) {
    $503fd042c818610c$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $503fd042c818610c$export$18ce0697a983be9b = function() {
    $503fd042c818610c$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $503fd042c818610c$export$18ce0697a983be9b.apply(this, arguments);
};
function $503fd042c818610c$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $503fd042c818610c$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $503fd042c818610c$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $503fd042c818610c$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $503fd042c818610c$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $503fd042c818610c$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $503fd042c818610c$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $503fd042c818610c$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $503fd042c818610c$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $503fd042c818610c$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $503fd042c818610c$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($503fd042c818610c$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $503fd042c818610c$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $503fd042c818610c$export$10c90e4f7922046c(v) {
    return this instanceof $503fd042c818610c$export$10c90e4f7922046c ? (this.v = v, this) : new $503fd042c818610c$export$10c90e4f7922046c(v);
}
function $503fd042c818610c$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $503fd042c818610c$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $503fd042c818610c$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $503fd042c818610c$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $503fd042c818610c$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $503fd042c818610c$export$19a8beecd37a4c45 === "function" ? $503fd042c818610c$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $503fd042c818610c$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $503fd042c818610c$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $503fd042c818610c$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $503fd042c818610c$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $503fd042c818610c$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});


parcelRegister("cWGRM", function(module, exports) {
$parcel$export(module.exports, "getValidateBucketNamePlugin", () => (parcelRequire("b1leu")).getValidateBucketNamePlugin);
$parcel$export(module.exports, "getUseRegionalEndpointPlugin", () => (parcelRequire("haDot")).getUseRegionalEndpointPlugin);
$parcel$export(module.exports, "getThrow200ExceptionsPlugin", () => (parcelRequire("alXCp")).getThrow200ExceptionsPlugin);
parcelRequire("b1leu");
parcelRequire("haDot");
parcelRequire("alXCp");

});
parcelRegister("b1leu", function(module, exports) {

$parcel$export(module.exports, "getValidateBucketNamePlugin", () => $80604216c965577b$export$c30d61978fbb3ad8);

var $1pRXg = parcelRequire("1pRXg");

var $6YlM1 = parcelRequire("6YlM1");
function $80604216c965577b$export$97e70cdcaaace32a() {
    var _this = this;
    return function(next) {
        return function(args) {
            return (0, $1pRXg.__awaiter)(_this, void 0, void 0, function() {
                var Bucket, err;
                return (0, $1pRXg.__generator)(this, function(_a) {
                    Bucket = args.input.Bucket;
                    if (typeof Bucket === "string" && !(0, $6YlM1.validate)(Bucket) && Bucket.indexOf("/") >= 0) {
                        err = new Error("Bucket name shouldn't contain '/', received '" + Bucket + "'");
                        err.name = "InvalidBucketName";
                        throw err;
                    }
                    return [
                        2 /*return*/ ,
                        next((0, $1pRXg.__assign)({}, args))
                    ];
                });
            });
        };
    };
}
var $80604216c965577b$export$db8005617bec77bd = {
    step: "initialize",
    tags: [
        "VALIDATE_BUCKET_NAME"
    ],
    name: "validateBucketNameMiddleware",
    override: true
};
var $80604216c965577b$export$c30d61978fbb3ad8 = function(unused) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add($80604216c965577b$export$97e70cdcaaace32a(), $80604216c965577b$export$db8005617bec77bd);
        }
    };
};

});
parcelRegister("1pRXg", function(module, exports) {

$parcel$export(module.exports, "__assign", () => $1081fa88bc18f379$export$18ce0697a983be9b);
$parcel$export(module.exports, "__awaiter", () => $1081fa88bc18f379$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $1081fa88bc18f379$export$67ebef60e6f28a6);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $1081fa88bc18f379$var$extendStatics = function(d, b) {
    $1081fa88bc18f379$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $1081fa88bc18f379$var$extendStatics(d, b);
};
function $1081fa88bc18f379$export$a8ba968b8961cb8a(d, b) {
    $1081fa88bc18f379$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $1081fa88bc18f379$export$18ce0697a983be9b = function() {
    $1081fa88bc18f379$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1081fa88bc18f379$export$18ce0697a983be9b.apply(this, arguments);
};
function $1081fa88bc18f379$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $1081fa88bc18f379$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $1081fa88bc18f379$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $1081fa88bc18f379$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $1081fa88bc18f379$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $1081fa88bc18f379$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $1081fa88bc18f379$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $1081fa88bc18f379$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $1081fa88bc18f379$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $1081fa88bc18f379$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $1081fa88bc18f379$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($1081fa88bc18f379$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $1081fa88bc18f379$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $1081fa88bc18f379$export$10c90e4f7922046c(v) {
    return this instanceof $1081fa88bc18f379$export$10c90e4f7922046c ? (this.v = v, this) : new $1081fa88bc18f379$export$10c90e4f7922046c(v);
}
function $1081fa88bc18f379$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $1081fa88bc18f379$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $1081fa88bc18f379$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $1081fa88bc18f379$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $1081fa88bc18f379$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $1081fa88bc18f379$export$19a8beecd37a4c45 === "function" ? $1081fa88bc18f379$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $1081fa88bc18f379$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $1081fa88bc18f379$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $1081fa88bc18f379$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $1081fa88bc18f379$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $1081fa88bc18f379$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});


parcelRegister("haDot", function(module, exports) {

$parcel$export(module.exports, "getUseRegionalEndpointPlugin", () => $c801ed9d26de1874$export$8512187c26b3935b);

var $1pRXg = parcelRequire("1pRXg");
parcelRequire("3uM9B");
var $dlqaT = parcelRequire("dlqaT");
var $c801ed9d26de1874$export$47830883dba0cb3a = function(config) {
    return function(next) {
        return function(args) {
            return (0, $1pRXg.__awaiter)(void 0, void 0, void 0, function() {
                var request, _a;
                return (0, $1pRXg.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            request = args.request;
                            if (!(0, $dlqaT.HttpRequest).isInstance(request) || config.isCustomEndpoint) return [
                                2 /*return*/ ,
                                next((0, $1pRXg.__assign)({}, args))
                            ];
                            if (!(request.hostname === "s3.amazonaws.com")) return [
                                3 /*break*/ ,
                                1
                            ];
                            request.hostname = "s3.us-east-1.amazonaws.com";
                            return [
                                3 /*break*/ ,
                                3
                            ];
                        case 1:
                            _a = "aws-global";
                            return [
                                4 /*yield*/ ,
                                config.region()
                            ];
                        case 2:
                            if (_a === _b.sent()) request.hostname = "s3.amazonaws.com";
                            _b.label = 3;
                        case 3:
                            return [
                                2 /*return*/ ,
                                next((0, $1pRXg.__assign)({}, args))
                            ];
                    }
                });
            });
        };
    };
};
var $c801ed9d26de1874$export$984fdb6c4de63240 = {
    step: "build",
    tags: [
        "USE_REGIONAL_ENDPOINT",
        "S3"
    ],
    name: "useRegionalEndpointMiddleware",
    override: true
};
var $c801ed9d26de1874$export$8512187c26b3935b = function(config) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add($c801ed9d26de1874$export$47830883dba0cb3a(config), $c801ed9d26de1874$export$984fdb6c4de63240);
        }
    };
};

});

parcelRegister("alXCp", function(module, exports) {

$parcel$export(module.exports, "getThrow200ExceptionsPlugin", () => $789a1c88cb155d0f$export$97cbbd0d754f3189);

var $1pRXg = parcelRequire("1pRXg");
parcelRequire("3uM9B");
var $d4VAq = parcelRequire("d4VAq");
var $789a1c88cb155d0f$export$61d7988259be6660 = function(config) {
    return function(next) {
        return function(args) {
            return (0, $1pRXg.__awaiter)(void 0, void 0, void 0, function() {
                var result, response, statusCode, body, bodyBytes, bodyString, err;
                return (0, $1pRXg.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                next(args)
                            ];
                        case 1:
                            result = _a.sent();
                            response = result.response;
                            if (!(0, $d4VAq.HttpResponse).isInstance(response)) return [
                                2 /*return*/ ,
                                result
                            ];
                            statusCode = response.statusCode, body = response.body;
                            if (statusCode < 200 && statusCode >= 300) return [
                                2 /*return*/ ,
                                result
                            ];
                            return [
                                4 /*yield*/ ,
                                $789a1c88cb155d0f$var$collectBody(body, config)
                            ];
                        case 2:
                            bodyBytes = _a.sent();
                            return [
                                4 /*yield*/ ,
                                $789a1c88cb155d0f$var$collectBodyString(bodyBytes, config)
                            ];
                        case 3:
                            bodyString = _a.sent();
                            if (bodyBytes.length === 0) {
                                err = new Error("S3 aborted request");
                                err.name = "InternalError";
                                throw err;
                            }
                            if (bodyString && bodyString.match("<Error>")) // Set the error code to 4XX so that error deserializer can parse them
                            response.statusCode = 400;
                            // Body stream is consumed and paused at this point. So replace the response.body to the collected bytes.
                            // So that the deserializer can consume the body as normal.
                            response.body = bodyBytes;
                            return [
                                2 /*return*/ ,
                                result
                            ];
                    }
                });
            });
        };
    };
};
// Collect low-level response body stream to Uint8Array.
var $789a1c88cb155d0f$var$collectBody = function(streamBody, context) {
    if (streamBody === void 0) streamBody = new Uint8Array();
    if (streamBody instanceof Uint8Array) return Promise.resolve(streamBody);
    return context.streamCollector(streamBody) || Promise.resolve(new Uint8Array());
};
// Encode Uint8Array data into string with utf-8.
var $789a1c88cb155d0f$var$collectBodyString = function(streamBody, context) {
    return $789a1c88cb155d0f$var$collectBody(streamBody, context).then(function(body) {
        return context.utf8Encoder(body);
    });
};
var $789a1c88cb155d0f$export$ea0247469da1888 = {
    relation: "after",
    toMiddleware: "deserializerMiddleware",
    tags: [
        "THROW_200_EXCEPTIONS",
        "S3"
    ],
    name: "throw200ExceptionsMiddleware",
    override: true
};
var $789a1c88cb155d0f$export$97cbbd0d754f3189 = function(config) {
    return {
        applyToStack: function(clientStack) {
            clientStack.addRelativeTo($789a1c88cb155d0f$export$61d7988259be6660(config), $789a1c88cb155d0f$export$ea0247469da1888);
        }
    };
};

});



parcelRegister("fM9Kx", function(module, exports) {

$parcel$export(module.exports, "formatUrl", () => $b7c2e6cac64fa3f1$export$75025487296cba38);

var $gbly0 = parcelRequire("gbly0");
function $b7c2e6cac64fa3f1$export$75025487296cba38(request) {
    var port = request.port, query = request.query;
    var protocol = request.protocol, path = request.path, hostname = request.hostname;
    if (protocol && protocol.substr(-1) !== ":") protocol += ":";
    if (port) hostname += ":" + port;
    if (path && path.charAt(0) !== "/") path = "/" + path;
    var queryString = query ? (0, $gbly0.buildQueryString)(query) : "";
    if (queryString && queryString[0] !== "?") queryString = "?" + queryString;
    return protocol + "//" + hostname + path + queryString;
}

});

parcelRegister("6Ogql", function(module, exports) {

$parcel$export(module.exports, "createRequest", () => $4f5427070f78e7b2$export$72e3afa9ac8966be);

var $8FGOf = parcelRequire("8FGOf");
function $4f5427070f78e7b2$export$72e3afa9ac8966be(client, command) {
    return (0, $8FGOf.__awaiter)(this, void 0, void 0, function() {
        var interceptMiddleware, clientStack, handler;
        var _this = this;
        return (0, $8FGOf.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    interceptMiddleware = function(next) {
                        return function(args) {
                            return (0, $8FGOf.__awaiter)(_this, void 0, void 0, function() {
                                return (0, $8FGOf.__generator)(this, function(_a) {
                                    return [
                                        2 /*return*/ ,
                                        {
                                            output: {
                                                request: args.request
                                            },
                                            response: undefined
                                        }
                                    ];
                                });
                            });
                        };
                    };
                    clientStack = client.middlewareStack.clone();
                    // @ts-ignore: add middleware to the last of 'build' step
                    clientStack.add(interceptMiddleware, {
                        step: "build",
                        priority: "low"
                    });
                    handler = command.resolveMiddleware(clientStack, client.config, undefined);
                    return [
                        4 /*yield*/ ,
                        handler(command).then(function(output) {
                            return output.output.request;
                        })
                    ];
                case 1:
                    // @ts-ignore
                    return [
                        2 /*return*/ ,
                        _a.sent()
                    ];
            }
        });
    });
}

});
parcelRegister("8FGOf", function(module, exports) {

$parcel$export(module.exports, "__awaiter", () => $65035c25d2342b83$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $65035c25d2342b83$export$67ebef60e6f28a6);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $65035c25d2342b83$var$extendStatics = function(d, b) {
    $65035c25d2342b83$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $65035c25d2342b83$var$extendStatics(d, b);
};
function $65035c25d2342b83$export$a8ba968b8961cb8a(d, b) {
    $65035c25d2342b83$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $65035c25d2342b83$export$18ce0697a983be9b = function() {
    $65035c25d2342b83$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $65035c25d2342b83$export$18ce0697a983be9b.apply(this, arguments);
};
function $65035c25d2342b83$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $65035c25d2342b83$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $65035c25d2342b83$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $65035c25d2342b83$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $65035c25d2342b83$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $65035c25d2342b83$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $65035c25d2342b83$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $65035c25d2342b83$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $65035c25d2342b83$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $65035c25d2342b83$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $65035c25d2342b83$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($65035c25d2342b83$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $65035c25d2342b83$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $65035c25d2342b83$export$10c90e4f7922046c(v) {
    return this instanceof $65035c25d2342b83$export$10c90e4f7922046c ? (this.v = v, this) : new $65035c25d2342b83$export$10c90e4f7922046c(v);
}
function $65035c25d2342b83$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $65035c25d2342b83$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $65035c25d2342b83$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $65035c25d2342b83$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $65035c25d2342b83$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $65035c25d2342b83$export$19a8beecd37a4c45 === "function" ? $65035c25d2342b83$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $65035c25d2342b83$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $65035c25d2342b83$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $65035c25d2342b83$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $65035c25d2342b83$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $65035c25d2342b83$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});


parcelRegister("kIQg0", function(module, exports) {
$parcel$export(module.exports, "S3RequestPresigner", () => (parcelRequire("6kQzE")).S3RequestPresigner);
parcelRequire("6kQzE");
parcelRequire("cJUTw");

});
parcelRegister("6kQzE", function(module, exports) {

$parcel$export(module.exports, "S3RequestPresigner", () => $49cd647308985037$export$a1673011a6b3560f);

var $fBHEu = parcelRequire("fBHEu");
parcelRequire("2f1qr");
var $6Wqud = parcelRequire("6Wqud");

var $i8Uao = parcelRequire("i8Uao");
var $49cd647308985037$export$a1673011a6b3560f = /** @class */ function() {
    function S3RequestPresigner(options) {
        var resolvedOptions = (0, $fBHEu.__assign)({
            // Allow `signingName` because we want to support usecase of supply client's resolved config
            // directly. Where service equals signingName.
            service: options.signingName || options.service || "s3",
            uriEscapePath: options.uriEscapePath || false
        }, options);
        this.signer = new (0, $6Wqud.SignatureV4)(resolvedOptions);
    }
    S3RequestPresigner.prototype.presign = function(requestToSign, _a) {
        if (_a === void 0) _a = {};
        var _b = _a.unsignableHeaders, unsignableHeaders = _b === void 0 ? new Set() : _b, _c = _a.unhoistableHeaders, unhoistableHeaders = _c === void 0 ? new Set() : _c, options = (0, $fBHEu.__rest)(_a, [
            "unsignableHeaders",
            "unhoistableHeaders"
        ]);
        return (0, $fBHEu.__awaiter)(this, void 0, void 0, function() {
            return (0, $fBHEu.__generator)(this, function(_d) {
                unsignableHeaders.add("content-type");
                // S3 requires SSE headers to be signed in headers instead of query
                // See: https://github.com/aws/aws-sdk-js-v3/issues/1576
                Object.keys(requestToSign.headers).map(function(header) {
                    return header.toLowerCase();
                }).filter(function(header) {
                    return header.startsWith("x-amz-server-side-encryption");
                }).forEach(function(header) {
                    unhoistableHeaders.add(header);
                });
                requestToSign.headers[0, $i8Uao.SHA256_HEADER] = (0, $i8Uao.UNSIGNED_PAYLOAD);
                if (!requestToSign.headers["host"]) requestToSign.headers.host = requestToSign.hostname;
                return [
                    2 /*return*/ ,
                    this.signer.presign(requestToSign, (0, $fBHEu.__assign)({
                        expiresIn: 900,
                        unsignableHeaders: unsignableHeaders,
                        unhoistableHeaders: unhoistableHeaders
                    }, options))
                ];
            });
        });
    };
    return S3RequestPresigner;
}();

});
parcelRegister("fBHEu", function(module, exports) {

$parcel$export(module.exports, "__assign", () => $b5cc2c19915cc2ba$export$18ce0697a983be9b);
$parcel$export(module.exports, "__rest", () => $b5cc2c19915cc2ba$export$3c9a16f847548506);
$parcel$export(module.exports, "__awaiter", () => $b5cc2c19915cc2ba$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $b5cc2c19915cc2ba$export$67ebef60e6f28a6);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $b5cc2c19915cc2ba$var$extendStatics = function(d, b) {
    $b5cc2c19915cc2ba$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $b5cc2c19915cc2ba$var$extendStatics(d, b);
};
function $b5cc2c19915cc2ba$export$a8ba968b8961cb8a(d, b) {
    $b5cc2c19915cc2ba$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $b5cc2c19915cc2ba$export$18ce0697a983be9b = function() {
    $b5cc2c19915cc2ba$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b5cc2c19915cc2ba$export$18ce0697a983be9b.apply(this, arguments);
};
function $b5cc2c19915cc2ba$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $b5cc2c19915cc2ba$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $b5cc2c19915cc2ba$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $b5cc2c19915cc2ba$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $b5cc2c19915cc2ba$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $b5cc2c19915cc2ba$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $b5cc2c19915cc2ba$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $b5cc2c19915cc2ba$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $b5cc2c19915cc2ba$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $b5cc2c19915cc2ba$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $b5cc2c19915cc2ba$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($b5cc2c19915cc2ba$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $b5cc2c19915cc2ba$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $b5cc2c19915cc2ba$export$10c90e4f7922046c(v) {
    return this instanceof $b5cc2c19915cc2ba$export$10c90e4f7922046c ? (this.v = v, this) : new $b5cc2c19915cc2ba$export$10c90e4f7922046c(v);
}
function $b5cc2c19915cc2ba$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $b5cc2c19915cc2ba$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $b5cc2c19915cc2ba$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $b5cc2c19915cc2ba$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $b5cc2c19915cc2ba$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $b5cc2c19915cc2ba$export$19a8beecd37a4c45 === "function" ? $b5cc2c19915cc2ba$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $b5cc2c19915cc2ba$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $b5cc2c19915cc2ba$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $b5cc2c19915cc2ba$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $b5cc2c19915cc2ba$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $b5cc2c19915cc2ba$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("i8Uao", function(module, exports) {

$parcel$export(module.exports, "UNSIGNED_PAYLOAD", () => $d3548ade3fa3c23a$export$91f7321b40d9fd07);
$parcel$export(module.exports, "SHA256_HEADER", () => $d3548ade3fa3c23a$export$eaef12179141669a);
var $d3548ade3fa3c23a$export$91f7321b40d9fd07 = "UNSIGNED-PAYLOAD";
var $d3548ade3fa3c23a$export$eaef12179141669a = "X-Amz-Content-Sha256";
var $d3548ade3fa3c23a$export$186cd8495ba0377d = "X-Amz-Algorithm";
var $d3548ade3fa3c23a$export$5c8e6dd7758f59d6 = "X-Amz-Credential";
var $d3548ade3fa3c23a$export$6e114beec37430d7 = "X-Amz-Date";
var $d3548ade3fa3c23a$export$2dcbb254f883c238 = "X-Amz-SignedHeaders";
var $d3548ade3fa3c23a$export$a0afe6f3bbfaf76e = "X-Amz-Expires";
var $d3548ade3fa3c23a$export$96307741595055fc = "host";
var $d3548ade3fa3c23a$export$863a63fba5b2ddf5 = "AWS4-HMAC-SHA256";

});


parcelRegister("cJUTw", function(module, exports) {

var $fBHEu = parcelRequire("fBHEu");
parcelRequire("3uM9B");
var $dlqaT = parcelRequire("dlqaT");

var $fM9Kx = parcelRequire("fM9Kx");

var $6kQzE = parcelRequire("6kQzE");
var $9465d2128772c6ac$export$d6e65e470b2c127c = function(client, command, options) {
    if (options === void 0) options = {};
    return (0, $fBHEu.__awaiter)(void 0, void 0, void 0, function() {
        var s3Presigner, presignInterceptMiddleware, middlewareName, presigned, output;
        return (0, $fBHEu.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    s3Presigner = new (0, $6kQzE.S3RequestPresigner)((0, $fBHEu.__assign)({}, client.config));
                    presignInterceptMiddleware = function(next, context) {
                        return function(args) {
                            return (0, $fBHEu.__awaiter)(void 0, void 0, void 0, function() {
                                var request, presigned;
                                var _a, _b;
                                return (0, $fBHEu.__generator)(this, function(_c) {
                                    switch(_c.label){
                                        case 0:
                                            request = args.request;
                                            if (!(0, $dlqaT.HttpRequest).isInstance(request)) throw new Error("Request to be presigned is not an valid HTTP request.");
                                            // Retry information headers are not meaningful in presigned URLs
                                            delete request.headers["amz-sdk-invocation-id"];
                                            delete request.headers["amz-sdk-request"];
                                            return [
                                                4 /*yield*/ ,
                                                s3Presigner.presign(request, (0, $fBHEu.__assign)((0, $fBHEu.__assign)({}, options), {
                                                    signingRegion: (_a = options.signingRegion) !== null && _a !== void 0 ? _a : context["signing_region"],
                                                    signingService: (_b = options.signingService) !== null && _b !== void 0 ? _b : context["signing_service"]
                                                }))
                                            ];
                                        case 1:
                                            presigned = _c.sent();
                                            return [
                                                2 /*return*/ ,
                                                {
                                                    // Intercept the middleware stack by returning fake response
                                                    response: {},
                                                    output: {
                                                        $metadata: {
                                                            httpStatusCode: 200
                                                        },
                                                        presigned: presigned
                                                    }
                                                }
                                            ];
                                    }
                                });
                            });
                        };
                    };
                    middlewareName = "presignInterceptMiddleware";
                    client.middlewareStack.addRelativeTo(presignInterceptMiddleware, {
                        name: middlewareName,
                        relation: "before",
                        toMiddleware: "awsAuthMiddleware",
                        override: true
                    });
                    _a.label = 1;
                case 1:
                    _a.trys.push([
                        1,
                        ,
                        3,
                        4
                    ]);
                    return [
                        4 /*yield*/ ,
                        client.send(command)
                    ];
                case 2:
                    output = _a.sent();
                    //@ts-ignore the output is faked, so it's not actually OutputType
                    presigned = output.presigned;
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 3:
                    client.middlewareStack.remove(middlewareName);
                    return [
                        7 /*endfinally*/ 
                    ];
                case 4:
                    return [
                        2 /*return*/ ,
                        (0, $fM9Kx.formatUrl)(presigned)
                    ];
            }
        });
    });
};

});


parcelRegister("eMxaO", function(module, exports) {

$parcel$export(module.exports, "SEND_PROGRESS_EVENT", () => $ac2f47ee2c1d3b64$export$67c09327664a588d);
$parcel$export(module.exports, "AxiosHttpHandler", () => $ac2f47ee2c1d3b64$export$43af02f23afacda3);
/*
 * Copyright 2017-2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ parcelRequire("3uM9B");
var $d4VAq = parcelRequire("d4VAq");

var $gbly0 = parcelRequire("gbly0");

var $iFJFJ = parcelRequire("iFJFJ");

var $7UO1b = parcelRequire("7UO1b");
var $ac2f47ee2c1d3b64$var$logger = new (0, $7UO1b.ConsoleLogger)('axios-http-handler');
var $ac2f47ee2c1d3b64$export$67c09327664a588d = 'sendProgress';
var $ac2f47ee2c1d3b64$export$43af02f23afacda3 = /** @class */ function() {
    function AxiosHttpHandler(httpOptions, emitter, cancelTokenSource) {
        if (httpOptions === void 0) httpOptions = {};
        this.httpOptions = httpOptions;
        this.emitter = emitter;
        this.cancelTokenSource = cancelTokenSource;
    }
    AxiosHttpHandler.prototype.destroy = function() {
    // Do nothing. TLS and HTTP/2 connection pooling is handled by the
    // browser.
    };
    AxiosHttpHandler.prototype.handle = function(request, options) {
        var requestTimeoutInMs = this.httpOptions.requestTimeout;
        var emitter = this.emitter;
        var path = request.path;
        if (request.query) {
            var queryString = (0, $gbly0.buildQueryString)(request.query);
            if (queryString) path += "?" + queryString;
        }
        var port = request.port;
        var url = request.protocol + "//" + request.hostname + (port ? ":" + port : '') + path;
        var axiosRequest = {};
        axiosRequest.url = url;
        axiosRequest.method = request.method;
        axiosRequest.headers = request.headers;
        // The host header is automatically added by the browser and adding it explicitly in the
        // axios request throws an error https://github.com/aws-amplify/amplify-js/issues/5376
        // This is because the host header is a forbidden header for the http client to set
        // see https://developer.mozilla.org/en-US/docs/Glossary/Forbidden_header_name and
        // https://fetch.spec.whatwg.org/#forbidden-header-name
        // The reason we are removing this header here instead of in the aws-sdk's client
        // middleware is that the host header is required to be in the request signature and if
        // we remove it from the middlewares, then the request fails because the header is added
        // by the browser but is absent from the signature.
        delete axiosRequest.headers['host'];
        if (request.body) axiosRequest.data = request.body;
        else // Fix for https://github.com/aws-amplify/amplify-js/issues/5432
        // If the POST request body is empty but content-type header is set, axios is forcibly removing it
        // See https://github.com/axios/axios/issues/1535 and refusing to fix it https://github.com/axios/axios/issues/755
        // This change is a workaround to set the data as null (instead of undefined) to prevent axios from
        // removing the content-type header. Link for the source code
        // https://github.com/axios/axios/blob/dc4bc49673943e35280e5df831f5c3d0347a9393/lib/adapters/xhr.js#L121-L123
        if (axiosRequest.headers['Content-Type']) axiosRequest.data = null;
        if (emitter) axiosRequest.onUploadProgress = function(event) {
            emitter.emit($ac2f47ee2c1d3b64$export$67c09327664a588d, event);
            $ac2f47ee2c1d3b64$var$logger.debug(event);
        };
        // If a cancel token source is passed down from the provider, allows cancellation of in-flight requests
        if (this.cancelTokenSource) axiosRequest.cancelToken = this.cancelTokenSource.token;
        // From gamma release, aws-sdk now expects all response type to be of blob or streams
        axiosRequest.responseType = 'blob';
        var raceOfPromises = [
            (0, (/*@__PURE__*/$parcel$interopDefault($iFJFJ))).request(axiosRequest).then(function(response) {
                return {
                    response: new (0, $d4VAq.HttpResponse)({
                        headers: response.headers,
                        statusCode: response.status,
                        body: response.data
                    })
                };
            }).catch(function(error) {
                // Error
                $ac2f47ee2c1d3b64$var$logger.error(error);
                throw error;
            }),
            $ac2f47ee2c1d3b64$var$requestTimeout(requestTimeoutInMs)
        ];
        return Promise.race(raceOfPromises);
    };
    return AxiosHttpHandler;
}();
function $ac2f47ee2c1d3b64$var$requestTimeout(timeoutInMs) {
    if (timeoutInMs === void 0) timeoutInMs = 0;
    return new Promise(function(resolve, reject) {
        if (timeoutInMs) setTimeout(function() {
            var timeoutError = new Error("Request did not complete within " + timeoutInMs + " ms");
            timeoutError.name = 'TimeoutError';
            reject(timeoutError);
        }, timeoutInMs);
    });
}

});
parcelRegister("iFJFJ", function(module, exports) {

module.exports = (parcelRequire("2vRck"));

});
parcelRegister("2vRck", function(module, exports) {
'use strict';

var $hrCem = parcelRequire("hrCem");

var $58Yjj = parcelRequire("58Yjj");

var $iW3Dk = parcelRequire("iW3Dk");

var $v6QDe = parcelRequire("v6QDe");

var $1EKvZ = parcelRequire("1EKvZ");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $1d47bdfe7f2a0cd5$var$createInstance(defaultConfig) {
    var context = new $iW3Dk(defaultConfig);
    var instance = $58Yjj($iW3Dk.prototype.request, context);
    // Copy axios.prototype to instance
    $hrCem.extend(instance, $iW3Dk.prototype, context);
    // Copy context to instance
    $hrCem.extend(instance, context);
    return instance;
}
// Create the default instance to be exported
var $1d47bdfe7f2a0cd5$var$axios = $1d47bdfe7f2a0cd5$var$createInstance($1EKvZ);
// Expose Axios class to allow class inheritance
$1d47bdfe7f2a0cd5$var$axios.Axios = $iW3Dk;
// Factory for creating new instances
$1d47bdfe7f2a0cd5$var$axios.create = function create(instanceConfig) {
    return $1d47bdfe7f2a0cd5$var$createInstance($v6QDe($1d47bdfe7f2a0cd5$var$axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
$1d47bdfe7f2a0cd5$var$axios.Cancel = (parcelRequire("8Hyoh"));

$1d47bdfe7f2a0cd5$var$axios.CancelToken = (parcelRequire("9FpHG"));

$1d47bdfe7f2a0cd5$var$axios.isCancel = (parcelRequire("enOvb"));
// Expose all/spread
$1d47bdfe7f2a0cd5$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$1d47bdfe7f2a0cd5$var$axios.spread = (parcelRequire("3z4kd"));

// Expose isAxiosError
$1d47bdfe7f2a0cd5$var$axios.isAxiosError = (parcelRequire("gonhQ"));
module.exports = $1d47bdfe7f2a0cd5$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $1d47bdfe7f2a0cd5$var$axios;

});
parcelRegister("hrCem", function(module, exports) {
'use strict';

var $58Yjj = parcelRequire("58Yjj");
/*global toString:true*/ // utils is a library of generic helper functions non-specific to axios
var $cb329d16626a74f8$var$toString = Object.prototype.toString;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $cb329d16626a74f8$var$isArray(val) {
    return $cb329d16626a74f8$var$toString.call(val) === '[object Array]';
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $cb329d16626a74f8$var$isUndefined(val) {
    return typeof val === 'undefined';
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $cb329d16626a74f8$var$isBuffer(val) {
    return val !== null && !$cb329d16626a74f8$var$isUndefined(val) && val.constructor !== null && !$cb329d16626a74f8$var$isUndefined(val.constructor) && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ function $cb329d16626a74f8$var$isArrayBuffer(val) {
    return $cb329d16626a74f8$var$toString.call(val) === '[object ArrayBuffer]';
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $cb329d16626a74f8$var$isFormData(val) {
    return typeof FormData !== 'undefined' && val instanceof FormData;
}
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $cb329d16626a74f8$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && val.buffer instanceof ArrayBuffer;
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $cb329d16626a74f8$var$isString(val) {
    return typeof val === 'string';
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $cb329d16626a74f8$var$isNumber(val) {
    return typeof val === 'number';
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $cb329d16626a74f8$var$isObject(val) {
    return val !== null && typeof val === 'object';
}
/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */ function $cb329d16626a74f8$var$isPlainObject(val) {
    if ($cb329d16626a74f8$var$toString.call(val) !== '[object Object]') return false;
    var prototype = Object.getPrototypeOf(val);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ function $cb329d16626a74f8$var$isDate(val) {
    return $cb329d16626a74f8$var$toString.call(val) === '[object Date]';
}
/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ function $cb329d16626a74f8$var$isFile(val) {
    return $cb329d16626a74f8$var$toString.call(val) === '[object File]';
}
/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ function $cb329d16626a74f8$var$isBlob(val) {
    return $cb329d16626a74f8$var$toString.call(val) === '[object Blob]';
}
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $cb329d16626a74f8$var$isFunction(val) {
    return $cb329d16626a74f8$var$toString.call(val) === '[object Function]';
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $cb329d16626a74f8$var$isStream(val) {
    return $cb329d16626a74f8$var$isObject(val) && $cb329d16626a74f8$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ function $cb329d16626a74f8$var$isURLSearchParams(val) {
    return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $cb329d16626a74f8$var$trim(str) {
    return str.replace(/^\s*/, '').replace(/\s*$/, '');
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function $cb329d16626a74f8$var$isStandardBrowserEnv() {
    if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' || navigator.product === 'NativeScript' || navigator.product === 'NS')) return false;
    return typeof window !== 'undefined' && typeof document !== 'undefined';
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $cb329d16626a74f8$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($cb329d16626a74f8$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $cb329d16626a74f8$var$merge() {
    var result = {};
    function assignValue(val, key) {
        if ($cb329d16626a74f8$var$isPlainObject(result[key]) && $cb329d16626a74f8$var$isPlainObject(val)) result[key] = $cb329d16626a74f8$var$merge(result[key], val);
        else if ($cb329d16626a74f8$var$isPlainObject(val)) result[key] = $cb329d16626a74f8$var$merge({}, val);
        else if ($cb329d16626a74f8$var$isArray(val)) result[key] = val.slice();
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$cb329d16626a74f8$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $cb329d16626a74f8$var$extend(a, b, thisArg) {
    $cb329d16626a74f8$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === 'function') a[key] = $58Yjj(val, thisArg);
        else a[key] = val;
    });
    return a;
}
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */ function $cb329d16626a74f8$var$stripBOM(content) {
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
}
module.exports = {
    isArray: $cb329d16626a74f8$var$isArray,
    isArrayBuffer: $cb329d16626a74f8$var$isArrayBuffer,
    isBuffer: $cb329d16626a74f8$var$isBuffer,
    isFormData: $cb329d16626a74f8$var$isFormData,
    isArrayBufferView: $cb329d16626a74f8$var$isArrayBufferView,
    isString: $cb329d16626a74f8$var$isString,
    isNumber: $cb329d16626a74f8$var$isNumber,
    isObject: $cb329d16626a74f8$var$isObject,
    isPlainObject: $cb329d16626a74f8$var$isPlainObject,
    isUndefined: $cb329d16626a74f8$var$isUndefined,
    isDate: $cb329d16626a74f8$var$isDate,
    isFile: $cb329d16626a74f8$var$isFile,
    isBlob: $cb329d16626a74f8$var$isBlob,
    isFunction: $cb329d16626a74f8$var$isFunction,
    isStream: $cb329d16626a74f8$var$isStream,
    isURLSearchParams: $cb329d16626a74f8$var$isURLSearchParams,
    isStandardBrowserEnv: $cb329d16626a74f8$var$isStandardBrowserEnv,
    forEach: $cb329d16626a74f8$var$forEach,
    merge: $cb329d16626a74f8$var$merge,
    extend: $cb329d16626a74f8$var$extend,
    trim: $cb329d16626a74f8$var$trim,
    stripBOM: $cb329d16626a74f8$var$stripBOM
};

});
parcelRegister("58Yjj", function(module, exports) {
'use strict';
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

});


parcelRegister("iW3Dk", function(module, exports) {
'use strict';

var $hrCem = parcelRequire("hrCem");

var $gl49Y = parcelRequire("gl49Y");

var $i49Zx = parcelRequire("i49Zx");

var $iqfmB = parcelRequire("iqfmB");

var $v6QDe = parcelRequire("v6QDe");
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $dc907648842374d9$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $i49Zx(),
        response: new $i49Zx()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ $dc907648842374d9$var$Axios.prototype.request = function request(config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof config === 'string') {
        config = arguments[1] || {};
        config.url = arguments[0];
    } else config = config || {};
    config = $v6QDe(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = 'get';
    // Hook up interceptors middleware
    var chain = [
        $iqfmB,
        undefined
    ];
    var promise = Promise.resolve(config);
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        chain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        chain.push(interceptor.fulfilled, interceptor.rejected);
    });
    while(chain.length)promise = promise.then(chain.shift(), chain.shift());
    return promise;
};
$dc907648842374d9$var$Axios.prototype.getUri = function getUri(config) {
    config = $v6QDe(this.defaults, config);
    return $gl49Y(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};
// Provide aliases for supported request methods
$hrCem.forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $dc907648842374d9$var$Axios.prototype[method] = function(url, config) {
        return this.request($v6QDe(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
$hrCem.forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ $dc907648842374d9$var$Axios.prototype[method] = function(url, data, config) {
        return this.request($v6QDe(config || {}, {
            method: method,
            url: url,
            data: data
        }));
    };
});
module.exports = $dc907648842374d9$var$Axios;

});
parcelRegister("gl49Y", function(module, exports) {
'use strict';

var $hrCem = parcelRequire("hrCem");
function $be51d58f4f1f1b91$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if ($hrCem.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        $hrCem.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === 'undefined') return;
            if ($hrCem.isArray(val)) key = key + '[]';
            else val = [
                val
            ];
            $hrCem.forEach(val, function parseValue(v) {
                if ($hrCem.isDate(v)) v = v.toISOString();
                else if ($hrCem.isObject(v)) v = JSON.stringify(v);
                parts.push($be51d58f4f1f1b91$var$encode(key) + '=' + $be51d58f4f1f1b91$var$encode(v));
            });
        });
        serializedParams = parts.join('&');
    }
    if (serializedParams) {
        var hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
};

});

parcelRegister("i49Zx", function(module, exports) {
'use strict';

var $hrCem = parcelRequire("hrCem");
function $d27059d2e5eab563$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $d27059d2e5eab563$var$InterceptorManager.prototype.use = function use(fulfilled, rejected) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $d27059d2e5eab563$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $d27059d2e5eab563$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $hrCem.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $d27059d2e5eab563$var$InterceptorManager;

});

parcelRegister("iqfmB", function(module, exports) {
'use strict';

var $hrCem = parcelRequire("hrCem");

var $cwR0w = parcelRequire("cwR0w");

var $enOvb = parcelRequire("enOvb");

var $1EKvZ = parcelRequire("1EKvZ");
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ function $d696929b9fb94cd8$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $d696929b9fb94cd8$var$throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $cwR0w(config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = $hrCem.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
    $hrCem.forEach([
        'delete',
        'get',
        'head',
        'post',
        'put',
        'patch',
        'common'
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || $1EKvZ.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $d696929b9fb94cd8$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $cwR0w(response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$enOvb(reason)) {
            $d696929b9fb94cd8$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $cwR0w(reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRegister("cwR0w", function(module, exports) {
'use strict';

var $hrCem = parcelRequire("hrCem");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    /*eslint no-param-reassign:0*/ $hrCem.forEach(fns, function transform(fn) {
        data = fn(data, headers);
    });
    return data;
};

});

parcelRegister("enOvb", function(module, exports) {
'use strict';
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});

parcelRegister("1EKvZ", function(module, exports) {
'use strict';

var $hrCem = parcelRequire("hrCem");

var $lHx81 = parcelRequire("lHx81");
var $134d9bc6c8969015$var$DEFAULT_CONTENT_TYPE = {
    'Content-Type': 'application/x-www-form-urlencoded'
};
function $134d9bc6c8969015$var$setContentTypeIfUnset(headers, value) {
    if (!$hrCem.isUndefined(headers) && $hrCem.isUndefined(headers['Content-Type'])) headers['Content-Type'] = value;
}

function $134d9bc6c8969015$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== 'undefined') // For browsers use XHR adapter
    adapter = (parcelRequire("5pfYv"));
    return adapter;
}
var $134d9bc6c8969015$var$defaults = {
    adapter: $134d9bc6c8969015$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $lHx81(headers, 'Accept');
            $lHx81(headers, 'Content-Type');
            if ($hrCem.isFormData(data) || $hrCem.isArrayBuffer(data) || $hrCem.isBuffer(data) || $hrCem.isStream(data) || $hrCem.isFile(data) || $hrCem.isBlob(data)) return data;
            if ($hrCem.isArrayBufferView(data)) return data.buffer;
            if ($hrCem.isURLSearchParams(data)) {
                $134d9bc6c8969015$var$setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
                return data.toString();
            }
            if ($hrCem.isObject(data)) {
                $134d9bc6c8969015$var$setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
                return JSON.stringify(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            /*eslint no-param-reassign:0*/ if (typeof data === 'string') try {
                data = JSON.parse(data);
            } catch (e) {}
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    }
};
$134d9bc6c8969015$var$defaults.headers = {
    common: {
        'Accept': 'application/json, text/plain, */*'
    }
};
$hrCem.forEach([
    'delete',
    'get',
    'head'
], function forEachMethodNoData(method) {
    $134d9bc6c8969015$var$defaults.headers[method] = {};
});
$hrCem.forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    $134d9bc6c8969015$var$defaults.headers[method] = $hrCem.merge($134d9bc6c8969015$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $134d9bc6c8969015$var$defaults;

});
parcelRegister("lHx81", function(module, exports) {
'use strict';

var $hrCem = parcelRequire("hrCem");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $hrCem.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRegister("5pfYv", function(module, exports) {
'use strict';

var $hrCem = parcelRequire("hrCem");

var $f84bZ = parcelRequire("f84bZ");

var $aWdP4 = parcelRequire("aWdP4");

var $gl49Y = parcelRequire("gl49Y");

var $iCTfr = parcelRequire("iCTfr");

var $5Ok6B = parcelRequire("5Ok6B");

var $lulQ9 = parcelRequire("lulQ9");

var $cMf72 = parcelRequire("cMf72");
module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        if ($hrCem.isFormData(requestData)) delete requestHeaders['Content-Type']; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || '';
            var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
            requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
        }
        var fullPath = $iCTfr(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), $gl49Y(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        // Listen for ready state
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // Prepare the response
            var responseHeaders = 'getAllResponseHeaders' in request ? $5Ok6B(request.getAllResponseHeaders()) : null;
            var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $f84bZ(resolve, reject, response);
            // Clean up request
            request = null;
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject($cMf72('Request aborted', config, 'ECONNABORTED', request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject($cMf72('Network Error', config, null, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject($cMf72(timeoutErrorMessage, config, 'ECONNABORTED', request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($hrCem.isStandardBrowserEnv()) {
            // Add xsrf header
            var xsrfValue = (config.withCredentials || $lulQ9(fullPath)) && config.xsrfCookieName ? $aWdP4.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ('setRequestHeader' in request) $hrCem.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!$hrCem.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (config.responseType) try {
            request.responseType = config.responseType;
        } catch (e) {
            // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
            // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
            if (config.responseType !== 'json') throw e;
        }
        // Handle progress if needed
        if (typeof config.onDownloadProgress === 'function') request.addEventListener('progress', config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === 'function' && request.upload) request.upload.addEventListener('progress', config.onUploadProgress);
        if (config.cancelToken) // Handle cancellation
        config.cancelToken.promise.then(function onCanceled(cancel) {
            if (!request) return;
            request.abort();
            reject(cancel);
            // Clean up request
            request = null;
        });
        if (!requestData) requestData = null;
        // Send the request
        request.send(requestData);
    });
};

});
parcelRegister("f84bZ", function(module, exports) {
'use strict';

var $cMf72 = parcelRequire("cMf72");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject($cMf72('Request failed with status code ' + response.status, response.config, null, response.request, response));
};

});
parcelRegister("cMf72", function(module, exports) {
'use strict';

var $2aNNi = parcelRequire("2aNNi");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ module.exports = function createError(message, config, code, request, response) {
    var error = new Error(message);
    return $2aNNi(error, config, code, request, response);
};

});
parcelRegister("2aNNi", function(module, exports) {
'use strict';
/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */ module.exports = function enhanceError(error, config, code, request, response) {
    error.config = config;
    if (code) error.code = code;
    error.request = request;
    error.response = response;
    error.isAxiosError = true;
    error.toJSON = function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code
        };
    };
    return error;
};

});



parcelRegister("aWdP4", function(module, exports) {
'use strict';

var $hrCem = parcelRequire("hrCem");
module.exports = $hrCem.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + '=' + encodeURIComponent(value));
            if ($hrCem.isNumber(expires)) cookie.push('expires=' + new Date(expires).toGMTString());
            if ($hrCem.isString(path)) cookie.push('path=' + path);
            if ($hrCem.isString(domain)) cookie.push('domain=' + domain);
            if (secure === true) cookie.push('secure');
            document.cookie = cookie.join('; ');
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, '', Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});

parcelRegister("iCTfr", function(module, exports) {
'use strict';

var $5Cyk3 = parcelRequire("5Cyk3");

var $9YwSG = parcelRequire("9YwSG");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !$5Cyk3(requestedURL)) return $9YwSG(baseURL, requestedURL);
    return requestedURL;
};

});
parcelRegister("5Cyk3", function(module, exports) {
'use strict';
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

});

parcelRegister("9YwSG", function(module, exports) {
'use strict';
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
};

});


parcelRegister("5Ok6B", function(module, exports) {
'use strict';

var $hrCem = parcelRequire("hrCem");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $43b137cdfb71451d$var$ignoreDuplicateOf = [
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $hrCem.forEach(headers.split('\n'), function parser(line) {
        i = line.indexOf(':');
        key = $hrCem.trim(line.substr(0, i)).toLowerCase();
        val = $hrCem.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && $43b137cdfb71451d$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === 'set-cookie') parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
        }
    });
    return parsed;
};

});

parcelRegister("lulQ9", function(module, exports) {
'use strict';

var $hrCem = parcelRequire("hrCem");
module.exports = $hrCem.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute('href', href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute('href', href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = $hrCem.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});




parcelRegister("v6QDe", function(module, exports) {
'use strict';

var $hrCem = parcelRequire("hrCem");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    var valueFromConfig2Keys = [
        'url',
        'method',
        'data'
    ];
    var mergeDeepPropertiesKeys = [
        'headers',
        'auth',
        'proxy',
        'params'
    ];
    var defaultToConfig2Keys = [
        'baseURL',
        'transformRequest',
        'transformResponse',
        'paramsSerializer',
        'timeout',
        'timeoutMessage',
        'withCredentials',
        'adapter',
        'responseType',
        'xsrfCookieName',
        'xsrfHeaderName',
        'onUploadProgress',
        'onDownloadProgress',
        'decompress',
        'maxContentLength',
        'maxBodyLength',
        'maxRedirects',
        'transport',
        'httpAgent',
        'httpsAgent',
        'cancelToken',
        'socketPath',
        'responseEncoding'
    ];
    var directMergeKeys = [
        'validateStatus'
    ];
    function getMergedValue(target, source) {
        if ($hrCem.isPlainObject(target) && $hrCem.isPlainObject(source)) return $hrCem.merge(target, source);
        else if ($hrCem.isPlainObject(source)) return $hrCem.merge({}, source);
        else if ($hrCem.isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(prop) {
        if (!$hrCem.isUndefined(config2[prop])) config[prop] = getMergedValue(config1[prop], config2[prop]);
        else if (!$hrCem.isUndefined(config1[prop])) config[prop] = getMergedValue(undefined, config1[prop]);
    }
    $hrCem.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
        if (!$hrCem.isUndefined(config2[prop])) config[prop] = getMergedValue(undefined, config2[prop]);
    });
    $hrCem.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);
    $hrCem.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
        if (!$hrCem.isUndefined(config2[prop])) config[prop] = getMergedValue(undefined, config2[prop]);
        else if (!$hrCem.isUndefined(config1[prop])) config[prop] = getMergedValue(undefined, config1[prop]);
    });
    $hrCem.forEach(directMergeKeys, function merge(prop) {
        if (prop in config2) config[prop] = getMergedValue(config1[prop], config2[prop]);
        else if (prop in config1) config[prop] = getMergedValue(undefined, config1[prop]);
    });
    var axiosKeys = valueFromConfig2Keys.concat(mergeDeepPropertiesKeys).concat(defaultToConfig2Keys).concat(directMergeKeys);
    var otherKeys = Object.keys(config1).concat(Object.keys(config2)).filter(function filterAxiosKeys(key) {
        return axiosKeys.indexOf(key) === -1;
    });
    $hrCem.forEach(otherKeys, mergeDeepProperties);
    return config;
};

});


parcelRegister("8Hyoh", function(module, exports) {
'use strict';
/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function $655d041ef80da876$var$Cancel(message) {
    this.message = message;
}
$655d041ef80da876$var$Cancel.prototype.toString = function toString() {
    return 'Cancel' + (this.message ? ': ' + this.message : '');
};
$655d041ef80da876$var$Cancel.prototype.__CANCEL__ = true;
module.exports = $655d041ef80da876$var$Cancel;

});

parcelRegister("9FpHG", function(module, exports) {
'use strict';

var $8Hyoh = parcelRequire("8Hyoh");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $709be197834357d5$var$CancelToken(executor) {
    if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $8Hyoh(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ $709be197834357d5$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $709be197834357d5$var$CancelToken.source = function source() {
    var cancel;
    var token = new $709be197834357d5$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $709be197834357d5$var$CancelToken;

});

parcelRegister("3z4kd", function(module, exports) {
'use strict';
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});

parcelRegister("gonhQ", function(module, exports) {
'use strict';
/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */ module.exports = function isAxiosError(payload) {
    return typeof payload === 'object' && payload.isAxiosError === true;
};

});




parcelRegister("daywO", function(module, exports) {

$parcel$export(module.exports, "AWSS3ProviderManagedUpload", () => $9966fe1d37e45228$export$da75ae8ad0285104);
/*
 * Copyright 2017-2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $7UO1b = parcelRequire("7UO1b");
var $29OQz = parcelRequire("29OQz");
var $kaH5c = parcelRequire("kaH5c");parcelRequire("8qWqv");
var $kaH5c = parcelRequire("kaH5c");

var $2yat6 = parcelRequire("2yat6");
var $jt2YR = parcelRequire("jt2YR");
var $54bFk = parcelRequire("54bFk");
var $7jPQC = parcelRequire("7jPQC");
var $lvM37 = parcelRequire("lvM37");
var $dpead = parcelRequire("dpead");
var $7K5Aj = parcelRequire("7K5Aj");

var $eMxaO = parcelRequire("eMxaO");

var $hepb8 = parcelRequire("hepb8");
parcelRequire("lRt6C");
var $krpM4 = parcelRequire("krpM4");
var $9966fe1d37e45228$var$__assign = undefined && undefined.__assign || function() {
    $9966fe1d37e45228$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $9966fe1d37e45228$var$__assign.apply(this, arguments);
};
var $9966fe1d37e45228$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $9966fe1d37e45228$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $9966fe1d37e45228$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $9966fe1d37e45228$var$logger = new (0, $7UO1b.ConsoleLogger)('AWSS3ProviderManagedUpload');
var $9966fe1d37e45228$var$localTestingStorageEndpoint = 'http://localhost:20005';
var $9966fe1d37e45228$var$SET_CONTENT_LENGTH_HEADER = 'contentLengthMiddleware';
var $9966fe1d37e45228$export$da75ae8ad0285104 = /** @class */ function() {
    function AWSS3ProviderManagedUpload(params, opts, emitter) {
        // Defaults
        this.minPartSize = 5242880; // in MB
        this.queueSize = 4;
        // Data for current upload
        this.body = null;
        this.params = null;
        this.opts = null;
        this.multiPartMap = [];
        this.cancel = false;
        // Progress reporting
        this.bytesUploaded = 0;
        this.totalBytesToUpload = 0;
        this.emitter = null;
        this.params = params;
        this.opts = opts;
        this.emitter = emitter;
    }
    AWSS3ProviderManagedUpload.prototype.upload = function() {
        return $9966fe1d37e45228$var$__awaiter(this, void 0, void 0, function() {
            var _a, putObjectCommand, s3, uploadId, numberOfPartsToUpload, start, parts;
            return $9966fe1d37e45228$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = this;
                        return [
                            4 /*yield*/ ,
                            this.validateAndSanitizeBody(this.params.Body)
                        ];
                    case 1:
                        _a.body = _b.sent();
                        this.totalBytesToUpload = this.byteLength(this.body);
                        if (!(this.totalBytesToUpload <= this.minPartSize)) return [
                            3 /*break*/ ,
                            3
                        ];
                        // Multipart upload is not required. Upload the sanitized body as is
                        this.params.Body = this.body;
                        putObjectCommand = new (0, $lvM37.PutObjectCommand)(this.params);
                        return [
                            4 /*yield*/ ,
                            this._createNewS3Client(this.opts, this.emitter)
                        ];
                    case 2:
                        s3 = _b.sent();
                        return [
                            2 /*return*/ ,
                            s3.send(putObjectCommand)
                        ];
                    case 3:
                        return [
                            4 /*yield*/ ,
                            this.createMultiPartUpload()
                        ];
                    case 4:
                        uploadId = _b.sent();
                        numberOfPartsToUpload = Math.ceil(this.totalBytesToUpload / this.minPartSize);
                        start = 0;
                        _b.label = 5;
                    case 5:
                        if (!(start < numberOfPartsToUpload)) return [
                            3 /*break*/ ,
                            10
                        ];
                        /** This first block will try to cancel the upload if the cancel
                         *	request came before any parts uploads have started.
                         **/ return [
                            4 /*yield*/ ,
                            this.checkIfUploadCancelled(uploadId)
                        ];
                    case 6:
                        /** This first block will try to cancel the upload if the cancel
                         *	request came before any parts uploads have started.
                         **/ _b.sent();
                        parts = this.createParts(start);
                        return [
                            4 /*yield*/ ,
                            this.uploadParts(uploadId, parts)
                        ];
                    case 7:
                        _b.sent();
                        /** Call cleanup a second time in case there were part upload requests
                         *  in flight. This is to ensure that all parts are cleaned up.
                         */ return [
                            4 /*yield*/ ,
                            this.checkIfUploadCancelled(uploadId)
                        ];
                    case 8:
                        /** Call cleanup a second time in case there were part upload requests
                         *  in flight. This is to ensure that all parts are cleaned up.
                         */ _b.sent();
                        _b.label = 9;
                    case 9:
                        start += this.queueSize;
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 10:
                        return [
                            4 /*yield*/ ,
                            this.finishMultiPartUpload(uploadId)
                        ];
                    case 11:
                        // Step 3: Finalize the upload such that S3 can recreate the file
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                }
            });
        });
    };
    AWSS3ProviderManagedUpload.prototype.createParts = function(startPartNumber) {
        var parts = [];
        var partNumber = startPartNumber;
        for(var bodyStart = startPartNumber * this.minPartSize; bodyStart < this.totalBytesToUpload && parts.length < this.queueSize;){
            var bodyEnd = Math.min(bodyStart + this.minPartSize, this.totalBytesToUpload);
            parts.push({
                bodyPart: this.body.slice(bodyStart, bodyEnd),
                partNumber: ++partNumber,
                emitter: new $hepb8.EventEmitter(),
                _lastUploadedBytes: 0
            });
            bodyStart += this.minPartSize;
        }
        return parts;
    };
    AWSS3ProviderManagedUpload.prototype.createMultiPartUpload = function() {
        return $9966fe1d37e45228$var$__awaiter(this, void 0, void 0, function() {
            var createMultiPartUploadCommand, s3, response;
            var _this = this;
            return $9966fe1d37e45228$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        createMultiPartUploadCommand = new (0, $54bFk.CreateMultipartUploadCommand)(this.params);
                        return [
                            4 /*yield*/ ,
                            this._createNewS3Client(this.opts)
                        ];
                    case 1:
                        s3 = _a.sent();
                        // @aws-sdk/client-s3 seems to be ignoring the `ContentType` parameter, so we
                        // are explicitly adding it via middleware.
                        // https://github.com/aws/aws-sdk-js-v3/issues/2000
                        s3.middlewareStack.add(function(next) {
                            return function(args) {
                                if (_this.params.ContentType && args && args.request && args.request.headers) args.request.headers['Content-Type'] = _this.params.ContentType;
                                return next(args);
                            };
                        }, {
                            step: 'build'
                        });
                        return [
                            4 /*yield*/ ,
                            s3.send(createMultiPartUploadCommand)
                        ];
                    case 2:
                        response = _a.sent();
                        $9966fe1d37e45228$var$logger.debug(response.UploadId);
                        return [
                            2 /*return*/ ,
                            response.UploadId
                        ];
                }
            });
        });
    };
    /**
     * @private Not to be extended outside of tests
     * @VisibleFotTesting
     */ AWSS3ProviderManagedUpload.prototype.uploadParts = function(uploadId, parts) {
        return $9966fe1d37e45228$var$__awaiter(this, void 0, void 0, function() {
            var promises, parts_1, parts_1_1, part, uploadPartCommandInput, uploadPartCommand, s3, e_1_1, allResults, i, error_1;
            var e_1, _a;
            return $9966fe1d37e45228$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        promises = [];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            6,
                            7,
                            8
                        ]);
                        parts_1 = $9966fe1d37e45228$var$__values(parts), parts_1_1 = parts_1.next();
                        _b.label = 2;
                    case 2:
                        if (!!parts_1_1.done) return [
                            3 /*break*/ ,
                            5
                        ];
                        part = parts_1_1.value;
                        this.setupEventListener(part);
                        uploadPartCommandInput = {
                            PartNumber: part.partNumber,
                            Body: part.bodyPart,
                            UploadId: uploadId,
                            Key: this.params.Key,
                            Bucket: this.params.Bucket
                        };
                        uploadPartCommand = new (0, $7K5Aj.UploadPartCommand)(uploadPartCommandInput);
                        return [
                            4 /*yield*/ ,
                            this._createNewS3Client(this.opts, part.emitter)
                        ];
                    case 3:
                        s3 = _b.sent();
                        promises.push(s3.send(uploadPartCommand));
                        _b.label = 4;
                    case 4:
                        parts_1_1 = parts_1.next();
                        return [
                            3 /*break*/ ,
                            2
                        ];
                    case 5:
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 6:
                        e_1_1 = _b.sent();
                        e_1 = {
                            error: e_1_1
                        };
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 7:
                        try {
                            if (parts_1_1 && !parts_1_1.done && (_a = parts_1.return)) _a.call(parts_1);
                        } finally{
                            if (e_1) throw e_1.error;
                        }
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 8:
                        _b.trys.push([
                            8,
                            10,
                            ,
                            11
                        ]);
                        return [
                            4 /*yield*/ ,
                            Promise.all(promises)
                        ];
                    case 9:
                        allResults = _b.sent();
                        // The order of resolved promises is the same as input promise order.
                        for(i = 0; i < allResults.length; i++)this.multiPartMap.push({
                            PartNumber: parts[i].partNumber,
                            ETag: allResults[i].ETag
                        });
                        return [
                            3 /*break*/ ,
                            11
                        ];
                    case 10:
                        error_1 = _b.sent();
                        $9966fe1d37e45228$var$logger.error('error happened while uploading a part. Cancelling the multipart upload', error_1);
                        this.cancelUpload();
                        return [
                            2 /*return*/ 
                        ];
                    case 11:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3ProviderManagedUpload.prototype.finishMultiPartUpload = function(uploadId) {
        return $9966fe1d37e45228$var$__awaiter(this, void 0, void 0, function() {
            var input, completeUploadCommand, s3, data, error_2;
            return $9966fe1d37e45228$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        input = {
                            Bucket: this.params.Bucket,
                            Key: this.params.Key,
                            UploadId: uploadId,
                            MultipartUpload: {
                                Parts: this.multiPartMap
                            }
                        };
                        completeUploadCommand = new (0, $jt2YR.CompleteMultipartUploadCommand)(input);
                        return [
                            4 /*yield*/ ,
                            this._createNewS3Client(this.opts)
                        ];
                    case 1:
                        s3 = _a.sent();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            s3.send(completeUploadCommand)
                        ];
                    case 3:
                        data = _a.sent();
                        return [
                            2 /*return*/ ,
                            data.Key
                        ];
                    case 4:
                        error_2 = _a.sent();
                        $9966fe1d37e45228$var$logger.error('error happened while finishing the upload. Cancelling the multipart upload', error_2);
                        this.cancelUpload();
                        return [
                            2 /*return*/ 
                        ];
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3ProviderManagedUpload.prototype.checkIfUploadCancelled = function(uploadId) {
        return $9966fe1d37e45228$var$__awaiter(this, void 0, void 0, function() {
            var errorMessage, error_3;
            return $9966fe1d37e45228$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.cancel) return [
                            3 /*break*/ ,
                            5
                        ];
                        errorMessage = 'Upload was cancelled.';
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.cleanup(uploadId)
                        ];
                    case 2:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        error_3 = _a.sent();
                        errorMessage += error_3.errorMessage;
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        throw new Error(errorMessage);
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3ProviderManagedUpload.prototype.cancelUpload = function() {
        this.cancel = true;
    };
    AWSS3ProviderManagedUpload.prototype.cleanup = function(uploadId) {
        return $9966fe1d37e45228$var$__awaiter(this, void 0, void 0, function() {
            var input, s3, data;
            return $9966fe1d37e45228$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        // Reset this's state
                        this.body = null;
                        this.multiPartMap = [];
                        this.bytesUploaded = 0;
                        this.totalBytesToUpload = 0;
                        input = {
                            Bucket: this.params.Bucket,
                            Key: this.params.Key,
                            UploadId: uploadId
                        };
                        return [
                            4 /*yield*/ ,
                            this._createNewS3Client(this.opts)
                        ];
                    case 1:
                        s3 = _a.sent();
                        return [
                            4 /*yield*/ ,
                            s3.send(new (0, $2yat6.AbortMultipartUploadCommand)(input))
                        ];
                    case 2:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            s3.send(new (0, $7jPQC.ListPartsCommand)(input))
                        ];
                    case 3:
                        data = _a.sent();
                        if (data && data.Parts && data.Parts.length > 0) throw new Error('Multi Part upload clean up failed');
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3ProviderManagedUpload.prototype.setupEventListener = function(part) {
        var _this = this;
        part.emitter.on((0, $eMxaO.SEND_PROGRESS_EVENT), function(progress) {
            _this.progressChanged(part.partNumber, progress.loaded - part._lastUploadedBytes);
            part._lastUploadedBytes = progress.loaded;
        });
    };
    AWSS3ProviderManagedUpload.prototype.progressChanged = function(partNumber, incrementalUpdate) {
        this.bytesUploaded += incrementalUpdate;
        this.emitter.emit((0, $eMxaO.SEND_PROGRESS_EVENT), {
            loaded: this.bytesUploaded,
            total: this.totalBytesToUpload,
            part: partNumber,
            key: this.params.Key
        });
    };
    AWSS3ProviderManagedUpload.prototype.byteLength = function(input) {
        if (input === null || input === undefined) return 0;
        if (typeof input.byteLength === 'number') return input.byteLength;
        else if (typeof input.length === 'number') return input.length;
        else if (typeof input.size === 'number') return input.size;
        else if (typeof input.path === 'string') ;
        else throw new Error('Cannot determine length of ' + input);
    };
    AWSS3ProviderManagedUpload.prototype.validateAndSanitizeBody = function(body) {
        return $9966fe1d37e45228$var$__awaiter(this, void 0, void 0, function() {
            return $9966fe1d37e45228$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.isGenericObject(body)) return [
                            3 /*break*/ ,
                            1
                        ];
                        // Any javascript object
                        return [
                            2 /*return*/ ,
                            JSON.stringify(body)
                        ];
                    case 1:
                        if (!this.isBlob(body)) return [
                            3 /*break*/ ,
                            4
                        ];
                        if (!(0, $kaH5c.Platform).isReactNative) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $krpM4.streamCollector)(body)
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                    case 3:
                        return [
                            2 /*return*/ ,
                            body
                        ];
                    case 4:
                        // Files, arrayBuffer etc
                        return [
                            2 /*return*/ ,
                            body
                        ];
                }
            });
        });
    };
    AWSS3ProviderManagedUpload.prototype.isBlob = function(body) {
        return typeof Blob !== 'undefined' && body instanceof Blob;
    };
    AWSS3ProviderManagedUpload.prototype.isGenericObject = function(body) {
        if (body !== null && typeof body === 'object') try {
            return !(this.byteLength(body) >= 0);
        } catch (error) {
            // If we cannot determine the length of the body, consider it
            // as a generic object and upload a stringified version of it
            return true;
        }
        return false;
    };
    /**
     * @private
     * creates an S3 client with new V3 aws sdk
     */ AWSS3ProviderManagedUpload.prototype._createNewS3Client = function(config, emitter) {
        return $9966fe1d37e45228$var$__awaiter(this, void 0, void 0, function() {
            var credentials, region, dangerouslyConnectToHttpEndpointForTesting, cancelTokenSource, localTestingConfig, client;
            return $9966fe1d37e45228$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._getCredentials()
                        ];
                    case 1:
                        credentials = _a.sent();
                        region = config.region, dangerouslyConnectToHttpEndpointForTesting = config.dangerouslyConnectToHttpEndpointForTesting, cancelTokenSource = config.cancelTokenSource;
                        localTestingConfig = {};
                        if (dangerouslyConnectToHttpEndpointForTesting) localTestingConfig = {
                            endpoint: $9966fe1d37e45228$var$localTestingStorageEndpoint,
                            tls: false,
                            bucketEndpoint: false,
                            forcePathStyle: true
                        };
                        client = new (0, $dpead.S3Client)($9966fe1d37e45228$var$__assign($9966fe1d37e45228$var$__assign({
                            region: region,
                            credentials: credentials
                        }, localTestingConfig), {
                            requestHandler: new (0, $eMxaO.AxiosHttpHandler)({}, emitter, cancelTokenSource),
                            customUserAgent: (0, $kaH5c.getAmplifyUserAgent)()
                        }));
                        client.middlewareStack.remove($9966fe1d37e45228$var$SET_CONTENT_LENGTH_HEADER);
                        return [
                            2 /*return*/ ,
                            client
                        ];
                }
            });
        });
    };
    /**
     * @private
     */ AWSS3ProviderManagedUpload.prototype._getCredentials = function() {
        return (0, $29OQz.Credentials).get().then(function(credentials) {
            if (!credentials) return false;
            var cred = (0, $29OQz.Credentials).shear(credentials);
            $9966fe1d37e45228$var$logger.debug('set credentials for storage', cred);
            return cred;
        }).catch(function(error) {
            $9966fe1d37e45228$var$logger.warn('ensure credentials error', error);
            return false;
        });
    };
    return AWSS3ProviderManagedUpload;
}();

});
parcelRegister("2yat6", function(module, exports) {

$parcel$export(module.exports, "AbortMultipartUploadCommand", () => $1db6e08a55d09c6c$export$87d2388f8662d995);

var $2eeCH = parcelRequire("2eeCH");

var $g4BTM = parcelRequire("g4BTM");

var $jhZvA = parcelRequire("jhZvA");
parcelRequire("dLiz3");
var $ifNwy = parcelRequire("ifNwy");
parcelRequire("6ZXPq");
var $dQtWs = parcelRequire("dQtWs");
parcelRequire("3vy9S");
var $5nbBf = parcelRequire("5nbBf");
/**
 * <p>This operation aborts a multipart upload. After a multipart upload is aborted, no
 *          additional parts can be uploaded using that upload ID. The storage consumed by any
 *          previously uploaded parts will be freed. However, if any part uploads are currently in
 *          progress, those part uploads might or might not succeed. As a result, it might be necessary
 *          to abort a given multipart upload multiple times in order to completely free all storage
 *          consumed by all parts. </p>
 *          <p>To verify that all parts have been removed, so you don't get charged for the part
 *          storage, you should call the <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_ListParts.html">ListParts</a> operation and ensure that
 *          the parts list is empty.</p>
 *          <p>For information about permissions required to use the multipart upload API, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/mpuAndPermissions.html">Multipart Upload API and
 *          Permissions</a>.</p>
 *          <p>The following operations are related to <code>AbortMultipartUpload</code>:</p>
 *          <ul>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_CreateMultipartUpload.html">CreateMultipartUpload</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_UploadPart.html">UploadPart</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_CompleteMultipartUpload.html">CompleteMultipartUpload</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_ListParts.html">ListParts</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_ListMultipartUploads.html">ListMultipartUploads</a>
 *                </p>
 *             </li>
 *          </ul>
 */ var $1db6e08a55d09c6c$export$87d2388f8662d995 = /** @class */ function(_super) {
    (0, $2eeCH.__extends)(AbortMultipartUploadCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function AbortMultipartUploadCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    /**
     * @internal
     */ AbortMultipartUploadCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $dQtWs.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use((0, $ifNwy.getBucketEndpointPlugin)(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "S3Client";
        var commandName = "AbortMultipartUploadCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $g4BTM.AbortMultipartUploadRequest).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $g4BTM.AbortMultipartUploadOutput).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    AbortMultipartUploadCommand.prototype.serialize = function(input, context) {
        return (0, $jhZvA.serializeAws_restXmlAbortMultipartUploadCommand)(input, context);
    };
    AbortMultipartUploadCommand.prototype.deserialize = function(output, context) {
        return (0, $jhZvA.deserializeAws_restXmlAbortMultipartUploadCommand)(output, context);
    };
    return AbortMultipartUploadCommand;
}((0, $5nbBf.Command));

});

parcelRegister("jt2YR", function(module, exports) {

$parcel$export(module.exports, "CompleteMultipartUploadCommand", () => $e2c3099f849952b3$export$f827ea0301b4eeff);

var $2eeCH = parcelRequire("2eeCH");

var $g4BTM = parcelRequire("g4BTM");

var $jhZvA = parcelRequire("jhZvA");
parcelRequire("dLiz3");
var $ifNwy = parcelRequire("ifNwy");
parcelRequire("cWGRM");
var $alXCp = parcelRequire("alXCp");
parcelRequire("6ZXPq");
var $dQtWs = parcelRequire("dQtWs");
parcelRequire("3vy9S");
var $5nbBf = parcelRequire("5nbBf");
/**
 * <p>Completes a multipart upload by assembling previously uploaded parts.</p>
 *          <p>You first initiate the multipart upload and then upload all parts using the <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_UploadPart.html">UploadPart</a>
 *          operation. After successfully uploading all relevant parts of an upload, you call this
 *          operation to complete the upload. Upon receiving this request, Amazon S3 concatenates all
 *          the parts in ascending order by part number to create a new object. In the Complete
 *          Multipart Upload request, you must provide the parts list. You must ensure that the parts
 *          list is complete. This operation concatenates the parts that you provide in the list. For
 *          each part in the list, you must provide the part number and the <code>ETag</code> value,
 *          returned after that part was uploaded.</p>
 *          <p>Processing of a Complete Multipart Upload request could take several minutes to
 *          complete. After Amazon S3 begins processing the request, it sends an HTTP response header that
 *          specifies a 200 OK response. While processing is in progress, Amazon S3 periodically sends white
 *          space characters to keep the connection from timing out. Because a request could fail after
 *          the initial 200 OK response has been sent, it is important that you check the response body
 *          to determine whether the request succeeded.</p>
 *          <p>Note that if <code>CompleteMultipartUpload</code> fails, applications should be prepared
 *          to retry the failed requests. For more information, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/ErrorBestPractices.html">Amazon S3 Error Best Practices</a>.</p>
 *          <p>For more information about multipart uploads, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/uploadobjusingmpu.html">Uploading Objects Using Multipart
 *             Upload</a>.</p>
 *          <p>For information about permissions required to use the multipart upload API, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/mpuAndPermissions.html">Multipart Upload API and
 *          Permissions</a>.</p>
 *
 *
 *          <p>
 *             <code>CompleteMultipartUpload</code> has the following special errors:</p>
 *          <ul>
 *             <li>
 *                <p>Error code: <code>EntityTooSmall</code>
 *                </p>
 *                <ul>
 *                   <li>
 *                      <p>Description: Your proposed upload is smaller than the minimum allowed object
 *                      size. Each part must be at least 5 MB in size, except the last part.</p>
 *                   </li>
 *                   <li>
 *                      <p>400 Bad Request</p>
 *                   </li>
 *                </ul>
 *             </li>
 *             <li>
 *                <p>Error code: <code>InvalidPart</code>
 *                </p>
 *                <ul>
 *                   <li>
 *                      <p>Description: One or more of the specified parts could not be found. The part
 *                      might not have been uploaded, or the specified entity tag might not have
 *                      matched the part's entity tag.</p>
 *                   </li>
 *                   <li>
 *                      <p>400 Bad Request</p>
 *                   </li>
 *                </ul>
 *             </li>
 *             <li>
 *                <p>Error code: <code>InvalidPartOrder</code>
 *                </p>
 *                <ul>
 *                   <li>
 *                      <p>Description: The list of parts was not in ascending order. The parts list
 *                      must be specified in order by part number.</p>
 *                   </li>
 *                   <li>
 *                      <p>400 Bad Request</p>
 *                   </li>
 *                </ul>
 *             </li>
 *             <li>
 *                <p>Error code: <code>NoSuchUpload</code>
 *                </p>
 *                <ul>
 *                   <li>
 *                      <p>Description: The specified multipart upload does not exist. The upload ID
 *                      might be invalid, or the multipart upload might have been aborted or
 *                      completed.</p>
 *                   </li>
 *                   <li>
 *                      <p>404 Not Found</p>
 *                   </li>
 *                </ul>
 *             </li>
 *          </ul>
 *
 *          <p>The following operations are related to <code>CompleteMultipartUpload</code>:</p>
 *          <ul>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_CreateMultipartUpload.html">CreateMultipartUpload</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_UploadPart.html">UploadPart</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_AbortMultipartUpload.html">AbortMultipartUpload</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_ListParts.html">ListParts</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_ListMultipartUploads.html">ListMultipartUploads</a>
 *                </p>
 *             </li>
 *          </ul>
 */ var $e2c3099f849952b3$export$f827ea0301b4eeff = /** @class */ function(_super) {
    (0, $2eeCH.__extends)(CompleteMultipartUploadCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function CompleteMultipartUploadCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    /**
     * @internal
     */ CompleteMultipartUploadCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $dQtWs.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use((0, $alXCp.getThrow200ExceptionsPlugin)(configuration));
        this.middlewareStack.use((0, $ifNwy.getBucketEndpointPlugin)(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "S3Client";
        var commandName = "CompleteMultipartUploadCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $g4BTM.CompleteMultipartUploadRequest).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $g4BTM.CompleteMultipartUploadOutput).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    CompleteMultipartUploadCommand.prototype.serialize = function(input, context) {
        return (0, $jhZvA.serializeAws_restXmlCompleteMultipartUploadCommand)(input, context);
    };
    CompleteMultipartUploadCommand.prototype.deserialize = function(output, context) {
        return (0, $jhZvA.deserializeAws_restXmlCompleteMultipartUploadCommand)(output, context);
    };
    return CompleteMultipartUploadCommand;
}((0, $5nbBf.Command));

});

parcelRegister("54bFk", function(module, exports) {

$parcel$export(module.exports, "CreateMultipartUploadCommand", () => $3b066009fd36a4c8$export$76155123c96043b8);

var $2eeCH = parcelRequire("2eeCH");

var $g4BTM = parcelRequire("g4BTM");

var $jhZvA = parcelRequire("jhZvA");
parcelRequire("dLiz3");
var $ifNwy = parcelRequire("ifNwy");
parcelRequire("6ZXPq");
var $dQtWs = parcelRequire("dQtWs");

var $1yer7 = parcelRequire("1yer7");
parcelRequire("3vy9S");
var $5nbBf = parcelRequire("5nbBf");
/**
 * <p>This operation initiates a multipart upload and returns an upload ID. This upload ID is
 *          used to associate all of the parts in the specific multipart upload. You specify this
 *          upload ID in each of your subsequent upload part requests (see <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_UploadPart.html">UploadPart</a>). You also include this
 *          upload ID in the final request to either complete or abort the multipart upload
 *          request.</p>
 *
 *          <p>For more information about multipart uploads, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/mpuoverview.html">Multipart Upload Overview</a>.</p>
 *
 *          <p>If you have configured a lifecycle rule to abort incomplete multipart uploads, the
 *          upload must complete within the number of days specified in the bucket lifecycle
 *          configuration. Otherwise, the incomplete multipart upload becomes eligible for an abort
 *          operation and Amazon S3 aborts the multipart upload. For more information, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/mpuoverview.html#mpu-abort-incomplete-mpu-lifecycle-config">Aborting
 *             Incomplete Multipart Uploads Using a Bucket Lifecycle Policy</a>.</p>
 *
 *          <p>For information about the permissions required to use the multipart upload API, see
 *             <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/mpuAndPermissions.html">Multipart Upload API and
 *             Permissions</a>.</p>
 *
 *          <p>For request signing, multipart upload is just a series of regular requests. You initiate
 *          a multipart upload, send one or more requests to upload parts, and then complete the
 *          multipart upload process. You sign each request individually. There is nothing special
 *          about signing multipart upload requests. For more information about signing, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/sig-v4-authenticating-requests.html">Authenticating
 *             Requests (AWS Signature Version 4)</a>.</p>
 *
 *          <note>
 *             <p> After you initiate a multipart upload and upload one or more parts, to stop being
 *             charged for storing the uploaded parts, you must either complete or abort the multipart
 *             upload. Amazon S3 frees up the space used to store the parts and stop charging you for
 *             storing them only after you either complete or abort a multipart upload. </p>
 *          </note>
 *
 *          <p>You can optionally request server-side encryption. For server-side encryption, Amazon S3
 *          encrypts your data as it writes it to disks in its data centers and decrypts it when you
 *          access it. You can provide your own encryption key, or use AWS Key Management Service (AWS
 *          KMS) customer master keys (CMKs) or Amazon S3-managed encryption keys. If you choose to provide
 *          your own encryption key, the request headers you provide in <a href="AmazonS3/latest/API/API_UploadPart.html">UploadPart</a> and <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_UploadPartCopy.html">UploadPartCopy</a> requests must match the headers you used in the request to
 *          initiate the upload by using <code>CreateMultipartUpload</code>. </p>
 *          <p>To perform a multipart upload with encryption using an AWS KMS CMK, the requester must
 *          have permission to the <code>kms:Encrypt</code>, <code>kms:Decrypt</code>,
 *             <code>kms:ReEncrypt*</code>, <code>kms:GenerateDataKey*</code>, and
 *             <code>kms:DescribeKey</code> actions on the key. These permissions are required because
 *          Amazon S3 must decrypt and read data from the encrypted file parts before it completes the
 *          multipart upload.</p>
 *
 *          <p>If your AWS Identity and Access Management (IAM) user or role is in the same AWS account
 *          as the AWS KMS CMK, then you must have these permissions on the key policy. If your IAM
 *          user or role belongs to a different account than the key, then you must have the
 *          permissions on both the key policy and your IAM user or role.</p>
 *
 *
 *          <p> For more information, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/serv-side-encryption.html">Protecting
 *             Data Using Server-Side Encryption</a>.</p>
 *
 *          <dl>
 *             <dt>Access Permissions</dt>
 *             <dd>
 *                <p>When copying an object, you can optionally specify the accounts or groups that
 *                   should be granted specific permissions on the new object. There are two ways to
 *                   grant the permissions using the request headers:</p>
 *                <ul>
 *                   <li>
 *                      <p>Specify a canned ACL with the <code>x-amz-acl</code> request header. For
 *                         more information, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/acl-overview.html#CannedACL">Canned ACL</a>.</p>
 *                   </li>
 *                   <li>
 *                      <p>Specify access permissions explicitly with the
 *                            <code>x-amz-grant-read</code>, <code>x-amz-grant-read-acp</code>,
 *                            <code>x-amz-grant-write-acp</code>, and
 *                            <code>x-amz-grant-full-control</code> headers. These parameters map to
 *                         the set of permissions that Amazon S3 supports in an ACL. For more information,
 *                         see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/acl-overview.html">Access Control List (ACL)
 *                            Overview</a>.</p>
 *                   </li>
 *                </ul>
 *                <p>You can use either a canned ACL or specify access permissions explicitly. You
 *                   cannot do both.</p>
 *             </dd>
 *             <dt>Server-Side- Encryption-Specific Request Headers</dt>
 *             <dd>
 *                <p>You can optionally tell Amazon S3 to encrypt data at rest using server-side
 *                   encryption. Server-side encryption is for data encryption at rest. Amazon S3 encrypts
 *                   your data as it writes it to disks in its data centers and decrypts it when you
 *                   access it. The option you use depends on whether you want to use AWS managed
 *                   encryption keys or provide your own encryption key. </p>
 *                <ul>
 *                   <li>
 *                      <p>Use encryption keys managed by Amazon S3 or customer master keys (CMKs) stored
 *                         in AWS Key Management Service (AWS KMS) – If you want AWS to manage the keys
 *                         used to encrypt data, specify the following headers in the request.</p>
 *                      <ul>
 *                         <li>
 *                            <p>x-amz-server-side-encryption</p>
 *                         </li>
 *                         <li>
 *                            <p>x-amz-server-side-encryption-aws-kms-key-id</p>
 *                         </li>
 *                         <li>
 *                            <p>x-amz-server-side-encryption-context</p>
 *                         </li>
 *                      </ul>
 *                      <note>
 *                         <p>If you specify <code>x-amz-server-side-encryption:aws:kms</code>, but
 *                            don't provide <code>x-amz-server-side-encryption-aws-kms-key-id</code>,
 *                            Amazon S3 uses the AWS managed CMK in AWS KMS to protect the data.</p>
 *                      </note>
 *                      <important>
 *                         <p>All GET and PUT requests for an object protected by AWS KMS fail if
 *                            you don't make them with SSL or by using SigV4.</p>
 *                      </important>
 *                      <p>For more information about server-side encryption with CMKs stored in AWS
 *                         KMS (SSE-KMS), see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/UsingKMSEncryption.html">Protecting Data Using Server-Side Encryption with CMKs stored in AWS
 *                            KMS</a>.</p>
 *                   </li>
 *                   <li>
 *                      <p>Use customer-provided encryption keys – If you want to manage your own
 *                         encryption keys, provide all the following headers in the request.</p>
 *                      <ul>
 *                         <li>
 *                            <p>x-amz-server-side-encryption-customer-algorithm</p>
 *                         </li>
 *                         <li>
 *                            <p>x-amz-server-side-encryption-customer-key</p>
 *                         </li>
 *                         <li>
 *                            <p>x-amz-server-side-encryption-customer-key-MD5</p>
 *                         </li>
 *                      </ul>
 *                      <p>For more information about server-side encryption with CMKs stored in AWS
 *                         KMS (SSE-KMS), see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/UsingKMSEncryption.html">Protecting Data Using Server-Side Encryption with CMKs stored in AWS
 *                            KMS</a>.</p>
 *                   </li>
 *                </ul>
 *             </dd>
 *             <dt>Access-Control-List (ACL)-Specific Request Headers</dt>
 *             <dd>
 *                <p>You also can use the following access control–related headers with this
 *                   operation. By default, all objects are private. Only the owner has full access
 *                   control. When adding a new object, you can grant permissions to individual AWS
 *                   accounts or to predefined groups defined by Amazon S3. These permissions are then added
 *                   to the access control list (ACL) on the object. For more information, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/S3_ACLs_UsingACLs.html">Using ACLs</a>. With this
 *                   operation, you can grant access permissions using one of the following two
 *                   methods:</p>
 *                <ul>
 *                   <li>
 *                      <p>Specify a canned ACL (<code>x-amz-acl</code>) — Amazon S3 supports a set of
 *                         predefined ACLs, known as <i>canned ACLs</i>. Each canned ACL
 *                         has a predefined set of grantees and permissions. For more information, see
 *                            <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/acl-overview.html#CannedACL">Canned
 *                         ACL</a>.</p>
 *                   </li>
 *                   <li>
 *                      <p>Specify access permissions explicitly — To explicitly grant access
 *                         permissions to specific AWS accounts or groups, use the following headers.
 *                         Each header maps to specific permissions that Amazon S3 supports in an ACL. For
 *                         more information, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/acl-overview.html">Access
 *                            Control List (ACL) Overview</a>. In the header, you specify a list of
 *                         grantees who get the specific permission. To grant permissions explicitly,
 *                         use:</p>
 *                      <ul>
 *                         <li>
 *                            <p>x-amz-grant-read</p>
 *                         </li>
 *                         <li>
 *                            <p>x-amz-grant-write</p>
 *                         </li>
 *                         <li>
 *                            <p>x-amz-grant-read-acp</p>
 *                         </li>
 *                         <li>
 *                            <p>x-amz-grant-write-acp</p>
 *                         </li>
 *                         <li>
 *                            <p>x-amz-grant-full-control</p>
 *                         </li>
 *                      </ul>
 *                      <p>You specify each grantee as a type=value pair, where the type is one of
 *                         the following:</p>
 *                      <ul>
 *                         <li>
 *                            <p>
 *                               <code>id</code> – if the value specified is the canonical user ID
 *                               of an AWS account</p>
 *                         </li>
 *                         <li>
 *                            <p>
 *                               <code>uri</code> – if you are granting permissions to a predefined
 *                               group</p>
 *                         </li>
 *                         <li>
 *                            <p>
 *                               <code>emailAddress</code> – if the value specified is the email
 *                               address of an AWS account</p>
 *                            <note>
 *                               <p>Using email addresses to specify a grantee is only supported in the following AWS Regions: </p>
 *                               <ul>
 *                                  <li>
 *                                     <p>US East (N. Virginia)</p>
 *                                  </li>
 *                                  <li>
 *                                     <p>US West (N. California)</p>
 *                                  </li>
 *                                  <li>
 *                                     <p> US West (Oregon)</p>
 *                                  </li>
 *                                  <li>
 *                                     <p> Asia Pacific (Singapore)</p>
 *                                  </li>
 *                                  <li>
 *                                     <p>Asia Pacific (Sydney)</p>
 *                                  </li>
 *                                  <li>
 *                                     <p>Asia Pacific (Tokyo)</p>
 *                                  </li>
 *                                  <li>
 *                                     <p>Europe (Ireland)</p>
 *                                  </li>
 *                                  <li>
 *                                     <p>South America (São Paulo)</p>
 *                                  </li>
 *                               </ul>
 *                               <p>For a list of all the Amazon S3 supported Regions and endpoints, see <a href="https://docs.aws.amazon.com/general/latest/gr/rande.html#s3_region">Regions and Endpoints</a> in the AWS General Reference.</p>
 *                            </note>
 *                         </li>
 *                      </ul>
 *                      <p>For example, the following <code>x-amz-grant-read</code> header grants the AWS accounts identified by account IDs permissions to read object data and its metadata:</p>
 *                      <p>
 *                         <code>x-amz-grant-read: id="11112222333", id="444455556666" </code>
 *                      </p>
 *                   </li>
 *                </ul>
 *
 *             </dd>
 *          </dl>
 *
 *          <p>The following operations are related to <code>CreateMultipartUpload</code>:</p>
 *          <ul>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_UploadPart.html">UploadPart</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_CompleteMultipartUpload.html">CompleteMultipartUpload</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_AbortMultipartUpload.html">AbortMultipartUpload</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_ListParts.html">ListParts</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_ListMultipartUploads.html">ListMultipartUploads</a>
 *                </p>
 *             </li>
 *          </ul>
 */ var $3b066009fd36a4c8$export$76155123c96043b8 = /** @class */ function(_super) {
    (0, $2eeCH.__extends)(CreateMultipartUploadCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function CreateMultipartUploadCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    /**
     * @internal
     */ CreateMultipartUploadCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $dQtWs.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use((0, $1yer7.getSsecPlugin)(configuration));
        this.middlewareStack.use((0, $ifNwy.getBucketEndpointPlugin)(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "S3Client";
        var commandName = "CreateMultipartUploadCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $g4BTM.CreateMultipartUploadRequest).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $g4BTM.CreateMultipartUploadOutput).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    CreateMultipartUploadCommand.prototype.serialize = function(input, context) {
        return (0, $jhZvA.serializeAws_restXmlCreateMultipartUploadCommand)(input, context);
    };
    CreateMultipartUploadCommand.prototype.deserialize = function(output, context) {
        return (0, $jhZvA.deserializeAws_restXmlCreateMultipartUploadCommand)(output, context);
    };
    return CreateMultipartUploadCommand;
}((0, $5nbBf.Command));

});

parcelRegister("7jPQC", function(module, exports) {

$parcel$export(module.exports, "ListPartsCommand", () => $5542869b976a0745$export$17fb27d830090508);

var $2eeCH = parcelRequire("2eeCH");

var $g4BTM = parcelRequire("g4BTM");

var $jhZvA = parcelRequire("jhZvA");
parcelRequire("dLiz3");
var $ifNwy = parcelRequire("ifNwy");
parcelRequire("6ZXPq");
var $dQtWs = parcelRequire("dQtWs");
parcelRequire("3vy9S");
var $5nbBf = parcelRequire("5nbBf");
/**
 * <p>Lists the parts that have been uploaded for a specific multipart upload. This operation
 *          must include the upload ID, which you obtain by sending the initiate multipart upload
 *          request (see <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_CreateMultipartUpload.html">CreateMultipartUpload</a>).
 *          This request returns a maximum of 1,000 uploaded parts. The default number of parts
 *          returned is 1,000 parts. You can restrict the number of parts returned by specifying the
 *             <code>max-parts</code> request parameter. If your multipart upload consists of more than
 *          1,000 parts, the response returns an <code>IsTruncated</code> field with the value of true,
 *          and a <code>NextPartNumberMarker</code> element. In subsequent <code>ListParts</code>
 *          requests you can include the part-number-marker query string parameter and set its value to
 *          the <code>NextPartNumberMarker</code> field value from the previous response.</p>
 *
 *          <p>For more information on multipart uploads, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/uploadobjusingmpu.html">Uploading Objects Using Multipart
 *             Upload</a>.</p>
 *
 *          <p>For information on permissions required to use the multipart upload API, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/mpuAndPermissions.html">Multipart Upload API and
 *          Permissions</a>.</p>
 *
 *          <p>The following operations are related to <code>ListParts</code>:</p>
 *          <ul>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_CreateMultipartUpload.html">CreateMultipartUpload</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_UploadPart.html">UploadPart</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_CompleteMultipartUpload.html">CompleteMultipartUpload</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_AbortMultipartUpload.html">AbortMultipartUpload</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_ListMultipartUploads.html">ListMultipartUploads</a>
 *                </p>
 *             </li>
 *          </ul>
 */ var $5542869b976a0745$export$17fb27d830090508 = /** @class */ function(_super) {
    (0, $2eeCH.__extends)(ListPartsCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function ListPartsCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    /**
     * @internal
     */ ListPartsCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $dQtWs.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use((0, $ifNwy.getBucketEndpointPlugin)(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "S3Client";
        var commandName = "ListPartsCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $g4BTM.ListPartsRequest).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $g4BTM.ListPartsOutput).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    ListPartsCommand.prototype.serialize = function(input, context) {
        return (0, $jhZvA.serializeAws_restXmlListPartsCommand)(input, context);
    };
    ListPartsCommand.prototype.deserialize = function(output, context) {
        return (0, $jhZvA.deserializeAws_restXmlListPartsCommand)(output, context);
    };
    return ListPartsCommand;
}((0, $5nbBf.Command));

});

parcelRegister("lvM37", function(module, exports) {

$parcel$export(module.exports, "PutObjectCommand", () => $fa91c3d1cda07fc1$export$4afa2352f8871c26);

var $2eeCH = parcelRequire("2eeCH");

var $g4BTM = parcelRequire("g4BTM");

var $jhZvA = parcelRequire("jhZvA");
parcelRequire("dLiz3");
var $ifNwy = parcelRequire("ifNwy");
parcelRequire("6ZXPq");
var $dQtWs = parcelRequire("dQtWs");

var $1yer7 = parcelRequire("1yer7");
parcelRequire("3vy9S");
var $5nbBf = parcelRequire("5nbBf");
/**
 * <p>Adds an object to a bucket. You must have WRITE permissions on a bucket to add an object
 *          to it.</p>
 *
 *
 *          <p>Amazon S3 never adds partial objects; if you receive a success response, Amazon S3 added the
 *          entire object to the bucket.</p>
 *
 *          <p>Amazon S3 is a distributed system. If it receives multiple write requests for the same object
 *          simultaneously, it overwrites all but the last object written. Amazon S3 does not provide object
 *          locking; if you need this, make sure to build it into your application layer or use
 *          versioning instead.</p>
 *
 *          <p>To ensure that data is not corrupted traversing the network, use the
 *             <code>Content-MD5</code> header. When you use this header, Amazon S3 checks the object
 *          against the provided MD5 value and, if they do not match, returns an error. Additionally,
 *          you can calculate the MD5 while putting an object to Amazon S3 and compare the returned ETag to
 *          the calculated MD5 value.</p>
 *          <note>
 *             <p> The <code>Content-MD5</code> header is required for any request to upload an object
 *             with a retention period configured using Amazon S3 Object Lock. For more information about
 *             Amazon S3 Object Lock, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/object-lock-overview.html">Amazon S3 Object Lock Overview</a>
 *             in the <i>Amazon Simple Storage Service Developer Guide</i>. </p>
 *          </note>
 *
 *
 *          <p>
 *             <b>Server-side Encryption</b>
 *          </p>
 *          <p>You can optionally request server-side encryption. With server-side encryption, Amazon S3 encrypts your data as it writes it to disks in its data centers and decrypts the data
 *          when you access it. You have the option to provide your own encryption key or use AWS
 *          managed encryption keys (SSE-S3 or SSE-KMS). For more information, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/UsingServerSideEncryption.html">Using Server-Side
 *             Encryption</a>.</p>
 *          <p>If you request server-side encryption using AWS Key Management Service (SSE-KMS), you can enable an S3 Bucket Key at the object-level. For more information, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/bucket-key.html">Amazon S3 Bucket Keys</a> in the <i>Amazon Simple Storage Service Developer Guide</i>.</p>
 *          <p>
 *             <b>Access Control List (ACL)-Specific Request
 *          Headers</b>
 *          </p>
 *          <p>You can use headers to grant ACL- based permissions. By default, all objects are
 *          private. Only the owner has full access control. When adding a new object, you can grant
 *          permissions to individual AWS accounts or to predefined groups defined by Amazon S3. These
 *          permissions are then added to the ACL on the object. For more information, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/acl-overview.html">Access Control List
 *             (ACL) Overview</a> and <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/acl-using-rest-api.html">Managing ACLs Using the REST
 *             API</a>. </p>
 *
 *          <p>
 *             <b>Storage Class Options</b>
 *          </p>
 *          <p>By default, Amazon S3 uses the STANDARD Storage Class to store newly created objects. The
 *          STANDARD storage class provides high durability and high availability. Depending on
 *          performance needs, you can specify a different Storage Class. Amazon S3 on Outposts only uses
 *          the OUTPOSTS Storage Class. For more information, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/storage-class-intro.html">Storage Classes</a> in the <i>Amazon S3
 *             Service Developer Guide</i>.</p>
 *
 *
 *          <p>
 *             <b>Versioning</b>
 *          </p>
 *          <p>If you enable versioning for a bucket, Amazon S3 automatically generates a unique version ID
 *          for the object being stored. Amazon S3 returns this ID in the response. When you enable
 *          versioning for a bucket, if Amazon S3 receives multiple write requests for the same object
 *          simultaneously, it stores all of the objects.</p>
 *          <p>For more information about versioning, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/AddingObjectstoVersioningEnabledBuckets.html">Adding Objects to
 *             Versioning Enabled Buckets</a>. For information about returning the versioning state
 *          of a bucket, see <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_GetBucketVersioning.html">GetBucketVersioning</a>. </p>
 *
 *
 *          <p class="title">
 *             <b>Related Resources</b>
 *          </p>
 *          <ul>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_CopyObject.html">CopyObject</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_DeleteObject.html">DeleteObject</a>
 *                </p>
 *             </li>
 *          </ul>
 */ var $fa91c3d1cda07fc1$export$4afa2352f8871c26 = /** @class */ function(_super) {
    (0, $2eeCH.__extends)(PutObjectCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function PutObjectCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    /**
     * @internal
     */ PutObjectCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $dQtWs.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use((0, $1yer7.getSsecPlugin)(configuration));
        this.middlewareStack.use((0, $ifNwy.getBucketEndpointPlugin)(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "S3Client";
        var commandName = "PutObjectCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $g4BTM.PutObjectRequest).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $g4BTM.PutObjectOutput).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    PutObjectCommand.prototype.serialize = function(input, context) {
        return (0, $jhZvA.serializeAws_restXmlPutObjectCommand)(input, context);
    };
    PutObjectCommand.prototype.deserialize = function(output, context) {
        return (0, $jhZvA.deserializeAws_restXmlPutObjectCommand)(output, context);
    };
    return PutObjectCommand;
}((0, $5nbBf.Command));

});

parcelRegister("7K5Aj", function(module, exports) {

$parcel$export(module.exports, "UploadPartCommand", () => $5a31294732e07a9e$export$20fd13f6cebe56f0);

var $2eeCH = parcelRequire("2eeCH");

var $4iJ0h = parcelRequire("4iJ0h");

var $jhZvA = parcelRequire("jhZvA");
parcelRequire("dLiz3");
var $ifNwy = parcelRequire("ifNwy");
parcelRequire("6ZXPq");
var $dQtWs = parcelRequire("dQtWs");

var $1yer7 = parcelRequire("1yer7");
parcelRequire("3vy9S");
var $5nbBf = parcelRequire("5nbBf");
/**
 * <p>Uploads a part in a multipart upload.</p>
 *          <note>
 *             <p>In this operation, you provide part data in your request. However, you have an option
 *             to specify your existing Amazon S3 object as a data source for the part you are uploading. To
 *             upload a part from an existing object, you use the <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_UploadPartCopy.html">UploadPartCopy</a> operation.
 *          </p>
 *          </note>
 *
 *          <p>You must initiate a multipart upload (see <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_CreateMultipartUpload.html">CreateMultipartUpload</a>)
 *          before you can upload any part. In response to your initiate request, Amazon S3 returns an
 *          upload ID, a unique identifier, that you must include in your upload part request.</p>
 *          <p>Part numbers can be any number from 1 to 10,000, inclusive. A part number uniquely
 *          identifies a part and also defines its position within the object being created. If you
 *          upload a new part using the same part number that was used with a previous part, the
 *          previously uploaded part is overwritten. Each part must be at least 5 MB in size, except
 *          the last part. There is no size limit on the last part of your multipart upload.</p>
 *          <p>To ensure that data is not corrupted when traversing the network, specify the
 *             <code>Content-MD5</code> header in the upload part request. Amazon S3 checks the part data
 *          against the provided MD5 value. If they do not match, Amazon S3 returns an error. </p>
 *
 *          <p>If the upload request is signed with Signature Version 4, then AWS S3 uses the
 *             <code>x-amz-content-sha256</code> header as a checksum instead of
 *             <code>Content-MD5</code>. For more information see <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/sigv4-auth-using-authorization-header.html">Authenticating Requests: Using the Authorization Header (AWS Signature Version
 *             4)</a>. </p>
 *
 *
 *
 *          <p>
 *             <b>Note:</b> After you initiate multipart upload and upload
 *          one or more parts, you must either complete or abort multipart upload in order to stop
 *          getting charged for storage of the uploaded parts. Only after you either complete or abort
 *          multipart upload, Amazon S3 frees up the parts storage and stops charging you for the parts
 *          storage.</p>
 *
 *          <p>For more information on multipart uploads, go to <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/mpuoverview.html">Multipart Upload Overview</a> in the
 *             <i>Amazon Simple Storage Service Developer Guide </i>.</p>
 *          <p>For information on the permissions required to use the multipart upload API, go to
 *             <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/mpuAndPermissions.html">Multipart Upload API and
 *             Permissions</a> in the <i>Amazon Simple Storage Service Developer Guide</i>.</p>
 *
 *          <p>You can optionally request server-side encryption where Amazon S3 encrypts your data as it
 *          writes it to disks in its data centers and decrypts it for you when you access it. You have
 *          the option of providing your own encryption key, or you can use the AWS managed encryption
 *          keys. If you choose to provide your own encryption key, the request headers you provide in
 *          the request must match the headers you used in the request to initiate the upload by using
 *             <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_CreateMultipartUpload.html">CreateMultipartUpload</a>. For more information, go to <a href="https://docs.aws.amazon.com/AmazonS3/latest/dev/UsingServerSideEncryption.html">Using Server-Side Encryption</a> in
 *          the <i>Amazon Simple Storage Service Developer Guide</i>.</p>
 *
 *          <p>Server-side encryption is supported by the S3 Multipart Upload actions. Unless you are
 *          using a customer-provided encryption key, you don't need to specify the encryption
 *          parameters in each UploadPart request. Instead, you only need to specify the server-side
 *          encryption parameters in the initial Initiate Multipart request. For more information, see
 *             <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_CreateMultipartUpload.html">CreateMultipartUpload</a>.</p>
 *
 *          <p>If you requested server-side encryption using a customer-provided encryption key in your
 *          initiate multipart upload request, you must provide identical encryption information in
 *          each part upload using the following headers.</p>
 *
 *
 *          <ul>
 *             <li>
 *                <p>x-amz-server-side-encryption-customer-algorithm</p>
 *             </li>
 *             <li>
 *                <p>x-amz-server-side-encryption-customer-key</p>
 *             </li>
 *             <li>
 *                <p>x-amz-server-side-encryption-customer-key-MD5</p>
 *             </li>
 *          </ul>
 *
 *          <p class="title">
 *             <b>Special Errors</b>
 *          </p>
 *          <ul>
 *             <li>
 *                <ul>
 *                   <li>
 *                      <p>
 *                         <i>Code: NoSuchUpload</i>
 *                      </p>
 *                   </li>
 *                   <li>
 *                      <p>
 *                         <i>Cause: The specified multipart upload does not exist. The upload
 *                         ID might be invalid, or the multipart upload might have been aborted or
 *                         completed.</i>
 *                      </p>
 *                   </li>
 *                   <li>
 *                      <p>
 *                         <i> HTTP Status Code: 404 Not Found </i>
 *                      </p>
 *                   </li>
 *                   <li>
 *                      <p>
 *                         <i>SOAP Fault Code Prefix: Client</i>
 *                      </p>
 *                   </li>
 *                </ul>
 *             </li>
 *          </ul>
 *
 *
 *
 *
 *
 *
 *          <p class="title">
 *             <b>Related Resources</b>
 *          </p>
 *          <ul>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_CreateMultipartUpload.html">CreateMultipartUpload</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_CompleteMultipartUpload.html">CompleteMultipartUpload</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_AbortMultipartUpload.html">AbortMultipartUpload</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_ListParts.html">ListParts</a>
 *                </p>
 *             </li>
 *             <li>
 *                <p>
 *                   <a href="https://docs.aws.amazon.com/AmazonS3/latest/API/API_ListMultipartUploads.html">ListMultipartUploads</a>
 *                </p>
 *             </li>
 *          </ul>
 */ var $5a31294732e07a9e$export$20fd13f6cebe56f0 = /** @class */ function(_super) {
    (0, $2eeCH.__extends)(UploadPartCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function UploadPartCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    /**
     * @internal
     */ UploadPartCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $dQtWs.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use((0, $1yer7.getSsecPlugin)(configuration));
        this.middlewareStack.use((0, $ifNwy.getBucketEndpointPlugin)(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "S3Client";
        var commandName = "UploadPartCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $4iJ0h.UploadPartRequest).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $4iJ0h.UploadPartOutput).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    UploadPartCommand.prototype.serialize = function(input, context) {
        return (0, $jhZvA.serializeAws_restXmlUploadPartCommand)(input, context);
    };
    UploadPartCommand.prototype.deserialize = function(output, context) {
        return (0, $jhZvA.deserializeAws_restXmlUploadPartCommand)(output, context);
    };
    return UploadPartCommand;
}((0, $5nbBf.Command));

});
parcelRegister("4iJ0h", function(module, exports) {

$parcel$export(module.exports, "UploadPartOutput", () => $321bc09f7ebe36da$export$1e083fd90afa2f51);
$parcel$export(module.exports, "UploadPartRequest", () => $321bc09f7ebe36da$export$ecf841796ea7b1f0);

var $2eeCH = parcelRequire("2eeCH");

var $g4BTM = parcelRequire("g4BTM");
parcelRequire("3vy9S");
var $IsgKV = parcelRequire("IsgKV");
var $321bc09f7ebe36da$export$9c5e83992d724a63;
(function(MetadataEntry) {
    MetadataEntry.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($321bc09f7ebe36da$export$9c5e83992d724a63 || ($321bc09f7ebe36da$export$9c5e83992d724a63 = {}));
var $321bc09f7ebe36da$export$7bb542410b46ffb9;
(function(S3Location) {
    S3Location.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, obj), obj.Encryption && {
            Encryption: (0, $g4BTM.Encryption).filterSensitiveLog(obj.Encryption)
        });
    };
})($321bc09f7ebe36da$export$7bb542410b46ffb9 || ($321bc09f7ebe36da$export$7bb542410b46ffb9 = {}));
var $321bc09f7ebe36da$export$cc3fbbd78713fc6c;
(function(OutputLocation) {
    OutputLocation.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, obj), obj.S3 && {
            S3: $321bc09f7ebe36da$export$7bb542410b46ffb9.filterSensitiveLog(obj.S3)
        });
    };
})($321bc09f7ebe36da$export$cc3fbbd78713fc6c || ($321bc09f7ebe36da$export$cc3fbbd78713fc6c = {}));
var $321bc09f7ebe36da$export$e0a8b40ee8e7958f;
(function(FileHeaderInfo) {
    FileHeaderInfo["IGNORE"] = "IGNORE";
    FileHeaderInfo["NONE"] = "NONE";
    FileHeaderInfo["USE"] = "USE";
})($321bc09f7ebe36da$export$e0a8b40ee8e7958f || ($321bc09f7ebe36da$export$e0a8b40ee8e7958f = {}));
var $321bc09f7ebe36da$export$cd4a4cfd0598253e;
(function(CSVInput) {
    CSVInput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($321bc09f7ebe36da$export$cd4a4cfd0598253e || ($321bc09f7ebe36da$export$cd4a4cfd0598253e = {}));
var $321bc09f7ebe36da$export$b8d04dd3765058e2;
(function(JSONType) {
    JSONType["DOCUMENT"] = "DOCUMENT";
    JSONType["LINES"] = "LINES";
})($321bc09f7ebe36da$export$b8d04dd3765058e2 || ($321bc09f7ebe36da$export$b8d04dd3765058e2 = {}));
var $321bc09f7ebe36da$export$1bc8a3cf179ad9c;
(function(JSONInput) {
    JSONInput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($321bc09f7ebe36da$export$1bc8a3cf179ad9c || ($321bc09f7ebe36da$export$1bc8a3cf179ad9c = {}));
var $321bc09f7ebe36da$export$a457f185006c756f;
(function(ParquetInput) {
    ParquetInput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($321bc09f7ebe36da$export$a457f185006c756f || ($321bc09f7ebe36da$export$a457f185006c756f = {}));
var $321bc09f7ebe36da$export$71ed8fe19d426eb7;
(function(InputSerialization) {
    InputSerialization.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($321bc09f7ebe36da$export$71ed8fe19d426eb7 || ($321bc09f7ebe36da$export$71ed8fe19d426eb7 = {}));
var $321bc09f7ebe36da$export$b4890521754421ba;
(function(QuoteFields) {
    QuoteFields["ALWAYS"] = "ALWAYS";
    QuoteFields["ASNEEDED"] = "ASNEEDED";
})($321bc09f7ebe36da$export$b4890521754421ba || ($321bc09f7ebe36da$export$b4890521754421ba = {}));
var $321bc09f7ebe36da$export$623bc581753795b3;
(function(CSVOutput) {
    CSVOutput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($321bc09f7ebe36da$export$623bc581753795b3 || ($321bc09f7ebe36da$export$623bc581753795b3 = {}));
var $321bc09f7ebe36da$export$403a844dcc531976;
(function(JSONOutput) {
    JSONOutput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($321bc09f7ebe36da$export$403a844dcc531976 || ($321bc09f7ebe36da$export$403a844dcc531976 = {}));
var $321bc09f7ebe36da$export$cb22c2d1ef9f03c1;
(function(OutputSerialization) {
    OutputSerialization.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($321bc09f7ebe36da$export$cb22c2d1ef9f03c1 || ($321bc09f7ebe36da$export$cb22c2d1ef9f03c1 = {}));
var $321bc09f7ebe36da$export$722dd036ddb6b3f;
(function(SelectParameters) {
    SelectParameters.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($321bc09f7ebe36da$export$722dd036ddb6b3f || ($321bc09f7ebe36da$export$722dd036ddb6b3f = {}));
var $321bc09f7ebe36da$export$ee855080cc4fa5a8;
(function(RestoreRequestType) {
    RestoreRequestType["SELECT"] = "SELECT";
})($321bc09f7ebe36da$export$ee855080cc4fa5a8 || ($321bc09f7ebe36da$export$ee855080cc4fa5a8 = {}));
var $321bc09f7ebe36da$export$116b002a1c4d25c0;
(function(RestoreRequest) {
    RestoreRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, obj), obj.OutputLocation && {
            OutputLocation: $321bc09f7ebe36da$export$cc3fbbd78713fc6c.filterSensitiveLog(obj.OutputLocation)
        });
    };
})($321bc09f7ebe36da$export$116b002a1c4d25c0 || ($321bc09f7ebe36da$export$116b002a1c4d25c0 = {}));
var $321bc09f7ebe36da$export$bd1b29d0f94512e7;
(function(RestoreObjectRequest) {
    RestoreObjectRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, obj), obj.RestoreRequest && {
            RestoreRequest: $321bc09f7ebe36da$export$116b002a1c4d25c0.filterSensitiveLog(obj.RestoreRequest)
        });
    };
})($321bc09f7ebe36da$export$bd1b29d0f94512e7 || ($321bc09f7ebe36da$export$bd1b29d0f94512e7 = {}));
var $321bc09f7ebe36da$export$d20e6aaa08a7363f;
(function(ContinuationEvent) {
    ContinuationEvent.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($321bc09f7ebe36da$export$d20e6aaa08a7363f || ($321bc09f7ebe36da$export$d20e6aaa08a7363f = {}));
var $321bc09f7ebe36da$export$2066b1507471daea;
(function(EndEvent) {
    EndEvent.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($321bc09f7ebe36da$export$2066b1507471daea || ($321bc09f7ebe36da$export$2066b1507471daea = {}));
var $321bc09f7ebe36da$export$b25a304ec7d746bb;
(function(Progress) {
    Progress.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($321bc09f7ebe36da$export$b25a304ec7d746bb || ($321bc09f7ebe36da$export$b25a304ec7d746bb = {}));
var $321bc09f7ebe36da$export$863d066dc35784fb;
(function(ProgressEvent) {
    ProgressEvent.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($321bc09f7ebe36da$export$863d066dc35784fb || ($321bc09f7ebe36da$export$863d066dc35784fb = {}));
var $321bc09f7ebe36da$export$bb48554e89f06bf8;
(function(RecordsEvent) {
    RecordsEvent.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($321bc09f7ebe36da$export$bb48554e89f06bf8 || ($321bc09f7ebe36da$export$bb48554e89f06bf8 = {}));
var $321bc09f7ebe36da$export$3cdec2bba15e3523;
(function(Stats) {
    Stats.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($321bc09f7ebe36da$export$3cdec2bba15e3523 || ($321bc09f7ebe36da$export$3cdec2bba15e3523 = {}));
var $321bc09f7ebe36da$export$72935df6390a4cde;
(function(StatsEvent) {
    StatsEvent.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($321bc09f7ebe36da$export$72935df6390a4cde || ($321bc09f7ebe36da$export$72935df6390a4cde = {}));
var $321bc09f7ebe36da$export$4c951f3462fad8ac;
(function(SelectObjectContentEventStream) {
    SelectObjectContentEventStream.visit = function(value, visitor) {
        if (value.Records !== undefined) return visitor.Records(value.Records);
        if (value.Stats !== undefined) return visitor.Stats(value.Stats);
        if (value.Progress !== undefined) return visitor.Progress(value.Progress);
        if (value.Cont !== undefined) return visitor.Cont(value.Cont);
        if (value.End !== undefined) return visitor.End(value.End);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
    SelectObjectContentEventStream.filterSensitiveLog = function(obj) {
        var _a;
        if (obj.Records !== undefined) return {
            Records: $321bc09f7ebe36da$export$bb48554e89f06bf8.filterSensitiveLog(obj.Records)
        };
        if (obj.Stats !== undefined) return {
            Stats: $321bc09f7ebe36da$export$72935df6390a4cde.filterSensitiveLog(obj.Stats)
        };
        if (obj.Progress !== undefined) return {
            Progress: $321bc09f7ebe36da$export$863d066dc35784fb.filterSensitiveLog(obj.Progress)
        };
        if (obj.Cont !== undefined) return {
            Cont: $321bc09f7ebe36da$export$d20e6aaa08a7363f.filterSensitiveLog(obj.Cont)
        };
        if (obj.End !== undefined) return {
            End: $321bc09f7ebe36da$export$2066b1507471daea.filterSensitiveLog(obj.End)
        };
        if (obj.$unknown !== undefined) return _a = {}, _a[obj.$unknown[0]] = "UNKNOWN", _a;
    };
})($321bc09f7ebe36da$export$4c951f3462fad8ac || ($321bc09f7ebe36da$export$4c951f3462fad8ac = {}));
var $321bc09f7ebe36da$export$5bf8ed4e571234e3;
(function(SelectObjectContentOutput) {
    SelectObjectContentOutput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, obj), obj.Payload && {
            Payload: "STREAMING_CONTENT"
        });
    };
})($321bc09f7ebe36da$export$5bf8ed4e571234e3 || ($321bc09f7ebe36da$export$5bf8ed4e571234e3 = {}));
var $321bc09f7ebe36da$export$b8081f25e3a7bfbd;
(function(RequestProgress) {
    RequestProgress.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($321bc09f7ebe36da$export$b8081f25e3a7bfbd || ($321bc09f7ebe36da$export$b8081f25e3a7bfbd = {}));
var $321bc09f7ebe36da$export$33f7c3433c085364;
(function(ScanRange) {
    ScanRange.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($321bc09f7ebe36da$export$33f7c3433c085364 || ($321bc09f7ebe36da$export$33f7c3433c085364 = {}));
var $321bc09f7ebe36da$export$852c159401aad03e;
(function(SelectObjectContentRequest) {
    SelectObjectContentRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, obj), obj.SSECustomerKey && {
            SSECustomerKey: (0, $IsgKV.SENSITIVE_STRING)
        });
    };
})($321bc09f7ebe36da$export$852c159401aad03e || ($321bc09f7ebe36da$export$852c159401aad03e = {}));
var $321bc09f7ebe36da$export$1e083fd90afa2f51;
(function(UploadPartOutput) {
    UploadPartOutput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, obj), obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $IsgKV.SENSITIVE_STRING)
        });
    };
})($321bc09f7ebe36da$export$1e083fd90afa2f51 || ($321bc09f7ebe36da$export$1e083fd90afa2f51 = {}));
var $321bc09f7ebe36da$export$ecf841796ea7b1f0;
(function(UploadPartRequest) {
    UploadPartRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, obj), obj.SSECustomerKey && {
            SSECustomerKey: (0, $IsgKV.SENSITIVE_STRING)
        });
    };
})($321bc09f7ebe36da$export$ecf841796ea7b1f0 || ($321bc09f7ebe36da$export$ecf841796ea7b1f0 = {}));
var $321bc09f7ebe36da$export$ff4e5952953c0084;
(function(CopyPartResult) {
    CopyPartResult.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)({}, obj);
    };
})($321bc09f7ebe36da$export$ff4e5952953c0084 || ($321bc09f7ebe36da$export$ff4e5952953c0084 = {}));
var $321bc09f7ebe36da$export$d6a8bd15a4edcee7;
(function(UploadPartCopyOutput) {
    UploadPartCopyOutput.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, obj), obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $IsgKV.SENSITIVE_STRING)
        });
    };
})($321bc09f7ebe36da$export$d6a8bd15a4edcee7 || ($321bc09f7ebe36da$export$d6a8bd15a4edcee7 = {}));
var $321bc09f7ebe36da$export$b68c35e4811b33e;
(function(UploadPartCopyRequest) {
    UploadPartCopyRequest.filterSensitiveLog = function(obj) {
        return (0, $2eeCH.__assign)((0, $2eeCH.__assign)((0, $2eeCH.__assign)({}, obj), obj.SSECustomerKey && {
            SSECustomerKey: (0, $IsgKV.SENSITIVE_STRING)
        }), obj.CopySourceSSECustomerKey && {
            CopySourceSSECustomerKey: (0, $IsgKV.SENSITIVE_STRING)
        });
    };
})($321bc09f7ebe36da$export$b68c35e4811b33e || ($321bc09f7ebe36da$export$b68c35e4811b33e = {}));

});


parcelRegister("hepb8", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $c8b746662da5cacf$var$R = typeof Reflect === 'object' ? Reflect : null;
var $c8b746662da5cacf$var$ReflectApply = $c8b746662da5cacf$var$R && typeof $c8b746662da5cacf$var$R.apply === 'function' ? $c8b746662da5cacf$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $c8b746662da5cacf$var$ReflectOwnKeys;
if ($c8b746662da5cacf$var$R && typeof $c8b746662da5cacf$var$R.ownKeys === 'function') $c8b746662da5cacf$var$ReflectOwnKeys = $c8b746662da5cacf$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $c8b746662da5cacf$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $c8b746662da5cacf$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $c8b746662da5cacf$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $c8b746662da5cacf$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $c8b746662da5cacf$var$EventEmitter() {
    $c8b746662da5cacf$var$EventEmitter.init.call(this);
}
module.exports = $c8b746662da5cacf$var$EventEmitter;
module.exports.once = $c8b746662da5cacf$var$once;
// Backwards-compat with node 0.10.x
$c8b746662da5cacf$var$EventEmitter.EventEmitter = $c8b746662da5cacf$var$EventEmitter;
$c8b746662da5cacf$var$EventEmitter.prototype._events = undefined;
$c8b746662da5cacf$var$EventEmitter.prototype._eventsCount = 0;
$c8b746662da5cacf$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $c8b746662da5cacf$var$defaultMaxListeners = 10;
function $c8b746662da5cacf$var$checkListener(listener) {
    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($c8b746662da5cacf$var$EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
        return $c8b746662da5cacf$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== 'number' || arg < 0 || $c8b746662da5cacf$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
        $c8b746662da5cacf$var$defaultMaxListeners = arg;
    }
});
$c8b746662da5cacf$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$c8b746662da5cacf$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || $c8b746662da5cacf$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
    this._maxListeners = n;
    return this;
};
function $c8b746662da5cacf$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $c8b746662da5cacf$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$c8b746662da5cacf$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $c8b746662da5cacf$var$_getMaxListeners(this);
};
$c8b746662da5cacf$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === 'error';
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === 'function') $c8b746662da5cacf$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $c8b746662da5cacf$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$c8b746662da5cacf$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $c8b746662da5cacf$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $c8b746662da5cacf$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $c8b746662da5cacf$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $c8b746662da5cacf$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$c8b746662da5cacf$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $c8b746662da5cacf$var$_addListener(this, type, listener, false);
};
$c8b746662da5cacf$var$EventEmitter.prototype.on = $c8b746662da5cacf$var$EventEmitter.prototype.addListener;
$c8b746662da5cacf$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $c8b746662da5cacf$var$_addListener(this, type, listener, true);
};
function $c8b746662da5cacf$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $c8b746662da5cacf$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $c8b746662da5cacf$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$c8b746662da5cacf$var$EventEmitter.prototype.once = function once(type, listener) {
    $c8b746662da5cacf$var$checkListener(listener);
    this.on(type, $c8b746662da5cacf$var$_onceWrap(this, type, listener));
    return this;
};
$c8b746662da5cacf$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $c8b746662da5cacf$var$checkListener(listener);
    this.prependListener(type, $c8b746662da5cacf$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$c8b746662da5cacf$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $c8b746662da5cacf$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $c8b746662da5cacf$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
$c8b746662da5cacf$var$EventEmitter.prototype.off = $c8b746662da5cacf$var$EventEmitter.prototype.removeListener;
$c8b746662da5cacf$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $c8b746662da5cacf$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === 'function') return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $c8b746662da5cacf$var$unwrapListeners(evlistener) : $c8b746662da5cacf$var$arrayClone(evlistener, evlistener.length);
}
$c8b746662da5cacf$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $c8b746662da5cacf$var$_listeners(this, type, true);
};
$c8b746662da5cacf$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $c8b746662da5cacf$var$_listeners(this, type, false);
};
$c8b746662da5cacf$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return $c8b746662da5cacf$var$listenerCount.call(emitter, type);
};
$c8b746662da5cacf$var$EventEmitter.prototype.listenerCount = $c8b746662da5cacf$var$listenerCount;
function $c8b746662da5cacf$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$c8b746662da5cacf$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $c8b746662da5cacf$var$ReflectOwnKeys(this._events) : [];
};
function $c8b746662da5cacf$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $c8b746662da5cacf$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $c8b746662da5cacf$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $c8b746662da5cacf$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
            resolve([].slice.call(arguments));
        }
        $c8b746662da5cacf$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== 'error') $c8b746662da5cacf$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $c8b746662da5cacf$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === 'function') $c8b746662da5cacf$var$eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
}
function $c8b746662da5cacf$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === 'function') {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});





parcelRegister("atl0T", function(module, exports) {

$parcel$export(module.exports, "default", () => $79fce9a2972e72fc$export$2e2bcd8739ae039);
$parcel$export(module.exports, "API", () => (parcelRequire("cbbVi")).API);
/*
 * Copyright 2017-2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $cbbVi = parcelRequire("cbbVi");
parcelRequire("3X1JC");
var $gBcFT = parcelRequire("gBcFT");
var /*
 * @deprecated use named import
 */ $79fce9a2972e72fc$export$2e2bcd8739ae039 = (0, $cbbVi.API);

});
parcelRegister("cbbVi", function(module, exports) {

$parcel$export(module.exports, "API", () => $8ddfc2ce37f48bd5$export$2c4e825dc9120f87);
parcelRequire("i14CG");
var $g0OFw = parcelRequire("g0OFw");

var $8SrNO = parcelRequire("8SrNO");

var $6sc5F = parcelRequire("6sc5F");

var $g8Cjm = parcelRequire("g8Cjm");
parcelRequire("8qWqv");
var $a16qJ = parcelRequire("a16qJ");
var $7UO1b = parcelRequire("7UO1b");
var $29OQz = parcelRequire("29OQz");
var $8ddfc2ce37f48bd5$var$__assign = undefined && undefined.__assign || function() {
    $8ddfc2ce37f48bd5$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8ddfc2ce37f48bd5$var$__assign.apply(this, arguments);
};
var $8ddfc2ce37f48bd5$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $8ddfc2ce37f48bd5$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $8ddfc2ce37f48bd5$var$logger = new (0, $7UO1b.ConsoleLogger)('API');
/**
 * @deprecated
 * Use RestApi or GraphQLAPI to reduce your application bundle size
 * Export Cloud Logic APIs
 */ var $8ddfc2ce37f48bd5$export$8361325628175dce = /** @class */ function() {
    /**
     * Initialize API with AWS configuration
     * @param {Object} options - Configuration object for API
     */ function APIClass(options) {
        this.Auth = (0, $g0OFw.Auth);
        this.Cache = (0, $8SrNO.default);
        this.Credentials = (0, $29OQz.Credentials);
        this._options = options;
        this._restApi = new (0, $6sc5F.RestAPIClass)(options);
        this._graphqlApi = new (0, $g8Cjm.GraphQLAPIClass)(options);
        $8ddfc2ce37f48bd5$var$logger.debug('API Options', this._options);
    }
    APIClass.prototype.getModuleName = function() {
        return 'API';
    };
    /**
     * Configure API part with aws configurations
     * @param {Object} config - Configuration of the API
     * @return {Object} - The current configuration
     */ APIClass.prototype.configure = function(options) {
        this._options = Object.assign({}, this._options, options);
        // Share Amplify instance with client for SSR
        this._restApi.Credentials = this.Credentials;
        this._graphqlApi.Auth = this.Auth;
        this._graphqlApi.Cache = this.Cache;
        this._graphqlApi.Credentials = this.Credentials;
        var restAPIConfig = this._restApi.configure(this._options);
        var graphQLAPIConfig = this._graphqlApi.configure(this._options);
        return $8ddfc2ce37f48bd5$var$__assign($8ddfc2ce37f48bd5$var$__assign({}, restAPIConfig), graphQLAPIConfig);
    };
    /**
     * Make a GET request
     * @param {string} apiName - The api name of the request
     * @param {string} path - The path of the request
     * @param {json} [init] - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ APIClass.prototype.get = function(apiName, path, init) {
        return this._restApi.get(apiName, path, init);
    };
    /**
     * Make a POST request
     * @param {string} apiName - The api name of the request
     * @param {string} path - The path of the request
     * @param {json} [init] - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ APIClass.prototype.post = function(apiName, path, init) {
        return this._restApi.post(apiName, path, init);
    };
    /**
     * Make a PUT request
     * @param {string} apiName - The api name of the request
     * @param {string} path - The path of the request
     * @param {json} [init] - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ APIClass.prototype.put = function(apiName, path, init) {
        return this._restApi.put(apiName, path, init);
    };
    /**
     * Make a PATCH request
     * @param {string} apiName - The api name of the request
     * @param {string} path - The path of the request
     * @param {json} [init] - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ APIClass.prototype.patch = function(apiName, path, init) {
        return this._restApi.patch(apiName, path, init);
    };
    /**
     * Make a DEL request
     * @param {string} apiName - The api name of the request
     * @param {string} path - The path of the request
     * @param {json} [init] - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ APIClass.prototype.del = function(apiName, path, init) {
        return this._restApi.del(apiName, path, init);
    };
    /**
     * Make a HEAD request
     * @param {string} apiName - The api name of the request
     * @param {string} path - The path of the request
     * @param {json} [init] - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ APIClass.prototype.head = function(apiName, path, init) {
        return this._restApi.head(apiName, path, init);
    };
    /**
     * Checks to see if an error thrown is from an api request cancellation
     * @param {any} error - Any error
     * @return {boolean} - A boolean indicating if the error was from an api request cancellation
     */ APIClass.prototype.isCancel = function(error) {
        return this._restApi.isCancel(error);
    };
    /**
     * Cancels an inflight request
     * @param {any} request - request to cancel
     * @return {boolean} - A boolean indicating if the request was cancelled
     */ APIClass.prototype.cancel = function(request, message) {
        return this._restApi.cancel(request, message);
    };
    /**
     * Getting endpoint for API
     * @param {string} apiName - The name of the api
     * @return {string} - The endpoint of the api
     */ APIClass.prototype.endpoint = function(apiName) {
        return $8ddfc2ce37f48bd5$var$__awaiter(this, void 0, void 0, function() {
            return $8ddfc2ce37f48bd5$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this._restApi.endpoint(apiName)
                ];
            });
        });
    };
    /**
     * to get the operation type
     * @param operation
     */ APIClass.prototype.getGraphqlOperationType = function(operation) {
        return this._graphqlApi.getGraphqlOperationType(operation);
    };
    /**
     * Executes a GraphQL operation
     *
     * @param {GraphQLOptions} GraphQL Options
     * @param {object} additionalHeaders headers to merge in after any `graphql_headers` set in the config
     * @returns {Promise<GraphQLResult> | Observable<object>}
     */ APIClass.prototype.graphql = function(options, additionalHeaders) {
        return this._graphqlApi.graphql(options, additionalHeaders);
    };
    return APIClass;
}();
var $8ddfc2ce37f48bd5$export$2c4e825dc9120f87 = new $8ddfc2ce37f48bd5$export$8361325628175dce(null);
(0, $a16qJ.Amplify).register($8ddfc2ce37f48bd5$export$2c4e825dc9120f87);

});
parcelRegister("6sc5F", function(module, exports) {

$parcel$export(module.exports, "RestAPIClass", () => $4b2ebc834340dfe8$export$dcf8f1a1141f2be6);

var $kJimX = parcelRequire("kJimX");
parcelRequire("8qWqv");
var $a16qJ = parcelRequire("a16qJ");
var $7UO1b = parcelRequire("7UO1b");
var $29OQz = parcelRequire("29OQz");
var $4b2ebc834340dfe8$var$__assign = undefined && undefined.__assign || function() {
    $4b2ebc834340dfe8$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4b2ebc834340dfe8$var$__assign.apply(this, arguments);
};
var $4b2ebc834340dfe8$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $4b2ebc834340dfe8$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $4b2ebc834340dfe8$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $4b2ebc834340dfe8$var$logger = new (0, $7UO1b.ConsoleLogger)('RestAPI');
/**
 * Export Cloud Logic APIs
 */ var $4b2ebc834340dfe8$export$dcf8f1a1141f2be6 = /** @class */ function() {
    /**
     * Initialize Rest API with AWS configuration
     * @param {Object} options - Configuration object for API
     */ function RestAPIClass(options) {
        this._api = null;
        this.Credentials = (0, $29OQz.Credentials);
        this._options = options;
        $4b2ebc834340dfe8$var$logger.debug('API Options', this._options);
    }
    RestAPIClass.prototype.getModuleName = function() {
        return 'RestAPI';
    };
    /**
     * Configure API part with aws configurations
     * @param {Object} config - Configuration of the API
     * @return {Object} - The current configuration
     */ RestAPIClass.prototype.configure = function(options) {
        var _a = options || {}, _b = _a.API, API = _b === void 0 ? {} : _b, otherOptions = $4b2ebc834340dfe8$var$__rest(_a, [
            "API"
        ]);
        var opt = $4b2ebc834340dfe8$var$__assign($4b2ebc834340dfe8$var$__assign({}, otherOptions), API);
        $4b2ebc834340dfe8$var$logger.debug('configure Rest API', {
            opt: opt
        });
        if (opt['aws_project_region']) {
            if (opt['aws_cloud_logic_custom']) {
                var custom = opt['aws_cloud_logic_custom'];
                opt.endpoints = typeof custom === 'string' ? JSON.parse(custom) : custom;
            }
            opt = Object.assign({}, opt, {
                region: opt['aws_project_region'],
                header: {}
            });
        }
        if (Array.isArray(opt.endpoints)) // Check if endpoints has custom_headers and validate if is a function
        opt.endpoints.forEach(function(endpoint) {
            if (typeof endpoint.custom_header !== 'undefined' && typeof endpoint.custom_header !== 'function') {
                $4b2ebc834340dfe8$var$logger.warn('Rest API ' + endpoint.name + ', custom_header should be a function');
                endpoint.custom_header = undefined;
            }
        });
        else if (this._options && Array.isArray(this._options.endpoints)) opt.endpoints = this._options.endpoints;
        else opt.endpoints = [];
        this._options = Object.assign({}, this._options, opt);
        this.createInstance();
        return this._options;
    };
    /**
     * Create an instance of API for the library
     * @return - A promise of true if Success
     */ RestAPIClass.prototype.createInstance = function() {
        $4b2ebc834340dfe8$var$logger.debug('create Rest API instance');
        this._api = new (0, $kJimX.RestClient)(this._options);
        // Share Amplify instance with client for SSR
        this._api.Credentials = this.Credentials;
        return true;
    };
    /**
     * Make a GET request
     * @param {string} apiName - The api name of the request
     * @param {string} path - The path of the request
     * @param {json} [init] - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ RestAPIClass.prototype.get = function(apiName, path, init) {
        try {
            var apiInfo = this.getEndpointInfo(apiName, path);
            var cancellableToken = this._api.getCancellableToken();
            var initParams = Object.assign({}, init);
            initParams.cancellableToken = cancellableToken;
            var responsePromise = this._api.get(apiInfo, initParams);
            this._api.updateRequestToBeCancellable(responsePromise, cancellableToken);
            return responsePromise;
        } catch (err) {
            return Promise.reject(err.message);
        }
    };
    /**
     * Make a POST request
     * @param {string} apiName - The api name of the request
     * @param {string} path - The path of the request
     * @param {json} [init] - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ RestAPIClass.prototype.post = function(apiName, path, init) {
        try {
            var apiInfo = this.getEndpointInfo(apiName, path);
            var cancellableToken = this._api.getCancellableToken();
            var initParams = Object.assign({}, init);
            initParams.cancellableToken = cancellableToken;
            var responsePromise = this._api.post(apiInfo, initParams);
            this._api.updateRequestToBeCancellable(responsePromise, cancellableToken);
            return responsePromise;
        } catch (err) {
            return Promise.reject(err.message);
        }
    };
    /**
     * Make a PUT request
     * @param {string} apiName - The api name of the request
     * @param {string} path - The path of the request
     * @param {json} [init] - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ RestAPIClass.prototype.put = function(apiName, path, init) {
        try {
            var apiInfo = this.getEndpointInfo(apiName, path);
            var cancellableToken = this._api.getCancellableToken();
            var initParams = Object.assign({}, init);
            initParams.cancellableToken = cancellableToken;
            var responsePromise = this._api.put(apiInfo, initParams);
            this._api.updateRequestToBeCancellable(responsePromise, cancellableToken);
            return responsePromise;
        } catch (err) {
            return Promise.reject(err.message);
        }
    };
    /**
     * Make a PATCH request
     * @param {string} apiName - The api name of the request
     * @param {string} path - The path of the request
     * @param {json} [init] - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ RestAPIClass.prototype.patch = function(apiName, path, init) {
        try {
            var apiInfo = this.getEndpointInfo(apiName, path);
            var cancellableToken = this._api.getCancellableToken();
            var initParams = Object.assign({}, init);
            initParams.cancellableToken = cancellableToken;
            var responsePromise = this._api.patch(apiInfo, initParams);
            this._api.updateRequestToBeCancellable(responsePromise, cancellableToken);
            return responsePromise;
        } catch (err) {
            return Promise.reject(err.message);
        }
    };
    /**
     * Make a DEL request
     * @param {string} apiName - The api name of the request
     * @param {string} path - The path of the request
     * @param {json} [init] - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ RestAPIClass.prototype.del = function(apiName, path, init) {
        try {
            var apiInfo = this.getEndpointInfo(apiName, path);
            var cancellableToken = this._api.getCancellableToken();
            var initParams = Object.assign({}, init);
            initParams.cancellableToken = cancellableToken;
            var responsePromise = this._api.del(apiInfo, initParams);
            this._api.updateRequestToBeCancellable(responsePromise, cancellableToken);
            return responsePromise;
        } catch (err) {
            return Promise.reject(err.message);
        }
    };
    /**
     * Make a HEAD request
     * @param {string} apiName - The api name of the request
     * @param {string} path - The path of the request
     * @param {json} [init] - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ RestAPIClass.prototype.head = function(apiName, path, init) {
        try {
            var apiInfo = this.getEndpointInfo(apiName, path);
            var cancellableToken = this._api.getCancellableToken();
            var initParams = Object.assign({}, init);
            initParams.cancellableToken = cancellableToken;
            var responsePromise = this._api.head(apiInfo, initParams);
            this._api.updateRequestToBeCancellable(responsePromise, cancellableToken);
            return responsePromise;
        } catch (err) {
            return Promise.reject(err.message);
        }
    };
    /**
     * Checks to see if an error thrown is from an api request cancellation
     * @param {any} error - Any error
     * @return {boolean} - A boolean indicating if the error was from an api request cancellation
     */ RestAPIClass.prototype.isCancel = function(error) {
        return this._api.isCancel(error);
    };
    /**
     * Cancels an inflight request
     * @param {any} request - request to cancel
     * @return {boolean} - A boolean indicating if the request was cancelled
     */ RestAPIClass.prototype.cancel = function(request, message) {
        return this._api.cancel(request, message);
    };
    /**
     * Getting endpoint for API
     * @param {string} apiName - The name of the api
     * @return {string} - The endpoint of the api
     */ RestAPIClass.prototype.endpoint = function(apiName) {
        return $4b2ebc834340dfe8$var$__awaiter(this, void 0, void 0, function() {
            return $4b2ebc834340dfe8$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this._api.endpoint(apiName)
                ];
            });
        });
    };
    /**
     * Getting endpoint info for API
     * @param {string} apiName - The name of the api
     * @param {string} path - The path of the api that is going to accessed
     * @return {ApiInfo} - The endpoint information for that api-name
     */ RestAPIClass.prototype.getEndpointInfo = function(apiName, path) {
        var cloud_logic_array = this._options.endpoints;
        if (!Array.isArray(cloud_logic_array)) throw new Error("API category not configured");
        var apiConfig = cloud_logic_array.find(function(api) {
            return api.name === apiName;
        });
        if (!apiConfig) throw new Error("API " + apiName + " does not exist");
        var response = {
            endpoint: apiConfig.endpoint + path
        };
        if (typeof apiConfig.region === 'string') response.region = apiConfig.region;
        else if (typeof this._options.region === 'string') response.region = this._options.region;
        if (typeof apiConfig.service === 'string') response.service = apiConfig.service || 'execute-api';
        else response.service = 'execute-api';
        if (typeof apiConfig.custom_header === 'function') response.custom_header = apiConfig.custom_header;
        else response.custom_header = undefined;
        return response;
    };
    return RestAPIClass;
}();
var $4b2ebc834340dfe8$export$45f9ca334065d2ff = new $4b2ebc834340dfe8$export$dcf8f1a1141f2be6(null);
(0, $a16qJ.Amplify).register($4b2ebc834340dfe8$export$45f9ca334065d2ff);

});
parcelRegister("kJimX", function(module, exports) {

$parcel$export(module.exports, "RestClient", () => $f176425b6012bcc4$export$ea8b5b3aea9558ce);
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $7UO1b = parcelRequire("7UO1b");
var $29OQz = parcelRequire("29OQz");
var $fsezd = parcelRequire("fsezd");parcelRequire("8qWqv");
var $kaH5c = parcelRequire("kaH5c");
var $ap2RT = parcelRequire("ap2RT");

var $b14gs = parcelRequire("b14gs");

var $kcgTr = parcelRequire("kcgTr");
var $f176425b6012bcc4$var$__assign = undefined && undefined.__assign || function() {
    $f176425b6012bcc4$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f176425b6012bcc4$var$__assign.apply(this, arguments);
};
var $f176425b6012bcc4$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $f176425b6012bcc4$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $f176425b6012bcc4$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $f176425b6012bcc4$var$logger = new (0, $7UO1b.ConsoleLogger)('RestClient');
/**
* HTTP Client for REST requests. Send and receive JSON data.
* Sign request with AWS credentials if available
* Usage:
<pre>
const restClient = new RestClient();
restClient.get('...')
    .then(function(data) {
        console.log(data);
    })
    .catch(err => console.log(err));
</pre>
*/ var $f176425b6012bcc4$export$ea8b5b3aea9558ce = /** @class */ function() {
    /**
     * @param {RestClientOptions} [options] - Instance options
     */ function RestClient(options) {
        this._region = 'us-east-1'; // this will be updated by endpoint function
        this._service = 'execute-api'; // this can be updated by endpoint function
        this._custom_header = undefined; // this can be updated by endpoint function
        /**
         * This weak map provides functionality to let clients cancel
         * in-flight axios requests. https://github.com/axios/axios#cancellation
         *
         * 1. For every axios request, a unique cancel token is generated and added in the request.
         * 2. Promise for fulfilling the request is then mapped to that unique cancel token.
         * 3. The promise is returned to the client.
         * 4. Clients can either wait for the promise to fulfill or call `API.cancel(promise)` to cancel the request.
         * 5. If `API.cancel(promise)` is called, then the corresponding cancel token is retrieved from the map below.
         * 6. Promise returned to the client will be in rejected state with the error provided during cancel.
         * 7. Clients can check if the error is because of cancelling by calling `API.isCancel(error)`.
         *
         * For more details, see https://github.com/aws-amplify/amplify-js/pull/3769#issuecomment-552660025
         */ this._cancelTokenMap = null;
        this.Credentials = (0, $29OQz.Credentials);
        this._options = options;
        $f176425b6012bcc4$var$logger.debug('API Options', this._options);
        if (this._cancelTokenMap == null) this._cancelTokenMap = new WeakMap();
    }
    /**
    * Update AWS credentials
    * @param {AWSCredentials} credentials - AWS credentials
    *
    updateCredentials(credentials: AWSCredentials) {
        this.options.credentials = credentials;
    }
*/ /**
     * Basic HTTP request. Customizable
     * @param {string | ApiInfo } urlOrApiInfo - Full request URL or Api information
     * @param {string} method - Request HTTP method
     * @param {json} [init] - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ RestClient.prototype.ajax = function(urlOrApiInfo, method, init) {
        return $f176425b6012bcc4$var$__awaiter(this, void 0, void 0, function() {
            var parsed_url, url, region, service, custom_header, params, libraryHeaders, userAgent, initParams, isAllResponse, custom_header_obj, _a, _b, search, parsedUrl;
            var _this = this;
            return $f176425b6012bcc4$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        $f176425b6012bcc4$var$logger.debug(method, urlOrApiInfo);
                        region = 'us-east-1';
                        service = 'execute-api';
                        custom_header = undefined;
                        if (typeof urlOrApiInfo === 'string') {
                            parsed_url = this._parseUrl(urlOrApiInfo);
                            url = urlOrApiInfo;
                        } else {
                            url = urlOrApiInfo.endpoint, custom_header = urlOrApiInfo.custom_header, region = urlOrApiInfo.region, service = urlOrApiInfo.service;
                            parsed_url = this._parseUrl(urlOrApiInfo.endpoint);
                        }
                        params = {
                            method: method,
                            url: url,
                            host: parsed_url.host,
                            path: parsed_url.path,
                            headers: {},
                            data: null,
                            responseType: 'json',
                            timeout: 0,
                            cancelToken: null
                        };
                        libraryHeaders = {};
                        if ((0, $kaH5c.Platform).isReactNative) {
                            userAgent = (0, $kaH5c.Platform).userAgent || 'aws-amplify/0.1.x';
                            libraryHeaders = {
                                'User-Agent': userAgent
                            };
                        }
                        initParams = Object.assign({}, init);
                        isAllResponse = initParams.response;
                        if (initParams.body) {
                            if (typeof FormData === 'function' && initParams.body instanceof FormData) {
                                libraryHeaders['Content-Type'] = 'multipart/form-data';
                                params.data = initParams.body;
                            } else {
                                libraryHeaders['Content-Type'] = 'application/json; charset=UTF-8';
                                params.data = JSON.stringify(initParams.body);
                            }
                        }
                        if (initParams.responseType) params.responseType = initParams.responseType;
                        if (initParams.withCredentials) params['withCredentials'] = initParams.withCredentials;
                        if (initParams.timeout) params.timeout = initParams.timeout;
                        if (initParams.cancellableToken) params.cancelToken = initParams.cancellableToken.token;
                        params['signerServiceInfo'] = initParams.signerServiceInfo;
                        if (!(typeof custom_header === 'function')) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            custom_header()
                        ];
                    case 1:
                        _a = _c.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        _a = undefined;
                        _c.label = 3;
                    case 3:
                        custom_header_obj = _a;
                        params.headers = $f176425b6012bcc4$var$__assign($f176425b6012bcc4$var$__assign($f176425b6012bcc4$var$__assign({}, libraryHeaders), custom_header_obj), initParams.headers);
                        _b = (0, $kcgTr.parse)(url, true, true), search = _b.search, parsedUrl = $f176425b6012bcc4$var$__rest(_b, [
                            "search"
                        ]);
                        params.url = (0, $kcgTr.format)($f176425b6012bcc4$var$__assign($f176425b6012bcc4$var$__assign({}, parsedUrl), {
                            query: $f176425b6012bcc4$var$__assign($f176425b6012bcc4$var$__assign({}, parsedUrl.query), initParams.queryStringParameters || {})
                        }));
                        // Do not sign the request if client has added 'Authorization' header,
                        // which means custom authorizer.
                        if (typeof params.headers['Authorization'] !== 'undefined') {
                            params.headers = Object.keys(params.headers).reduce(function(acc, k) {
                                if (params.headers[k]) acc[k] = params.headers[k];
                                return acc;
                            // tslint:disable-next-line:align
                            }, {});
                            return [
                                2 /*return*/ ,
                                this._request(params, isAllResponse)
                            ];
                        }
                        // Signing the request in case there credentials are available
                        return [
                            2 /*return*/ ,
                            this.Credentials.get().then(function(credentials) {
                                return _this._signed($f176425b6012bcc4$var$__assign({}, params), credentials, isAllResponse, {
                                    region: region,
                                    service: service
                                }).catch(function(error) {
                                    if ((0, $fsezd.DateUtils).isClockSkewError(error)) {
                                        var headers = error.response.headers;
                                        var dateHeader = headers && (headers.date || headers.Date);
                                        var responseDate = new Date(dateHeader);
                                        var requestDate = (0, $fsezd.DateUtils).getDateFromHeaderString(params.headers['x-amz-date']);
                                        if ((0, $fsezd.DateUtils).isClockSkewed(requestDate, responseDate)) {
                                            (0, $fsezd.DateUtils).setClockOffset(responseDate.getTime() - requestDate.getTime());
                                            return _this.ajax(urlOrApiInfo, method, init);
                                        }
                                    }
                                    throw error;
                                });
                            }, function(err) {
                                $f176425b6012bcc4$var$logger.debug('No credentials available, the request will be unsigned');
                                return _this._request(params, isAllResponse);
                            })
                        ];
                }
            });
        });
    };
    /**
     * GET HTTP request
     * @param {string | ApiInfo } urlOrApiInfo - Full request URL or Api information
     * @param {JSON} init - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ RestClient.prototype.get = function(urlOrApiInfo, init) {
        return this.ajax(urlOrApiInfo, 'GET', init);
    };
    /**
     * PUT HTTP request
     * @param {string | ApiInfo } urlOrApiInfo - Full request URL or Api information
     * @param {json} init - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ RestClient.prototype.put = function(urlOrApiInfo, init) {
        return this.ajax(urlOrApiInfo, 'PUT', init);
    };
    /**
     * PATCH HTTP request
     * @param {string | ApiInfo } urlOrApiInfo - Full request URL or Api information
     * @param {json} init - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ RestClient.prototype.patch = function(urlOrApiInfo, init) {
        return this.ajax(urlOrApiInfo, 'PATCH', init);
    };
    /**
     * POST HTTP request
     * @param {string | ApiInfo } urlOrApiInfo - Full request URL or Api information
     * @param {json} init - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ RestClient.prototype.post = function(urlOrApiInfo, init) {
        return this.ajax(urlOrApiInfo, 'POST', init);
    };
    /**
     * DELETE HTTP request
     * @param {string | ApiInfo } urlOrApiInfo - Full request URL or Api information
     * @param {json} init - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ RestClient.prototype.del = function(urlOrApiInfo, init) {
        return this.ajax(urlOrApiInfo, 'DELETE', init);
    };
    /**
     * HEAD HTTP request
     * @param {string | ApiInfo } urlOrApiInfo - Full request URL or Api information
     * @param {json} init - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ RestClient.prototype.head = function(urlOrApiInfo, init) {
        return this.ajax(urlOrApiInfo, 'HEAD', init);
    };
    /**
     * Cancel an inflight API request
     * @param {Promise<any>} request - The request promise to cancel
     * @param {string} [message] - A message to include in the cancelation exception
     */ RestClient.prototype.cancel = function(request, message) {
        var source = this._cancelTokenMap.get(request);
        if (source) source.cancel(message);
        return true;
    };
    /**
     * Checks to see if an error thrown is from an api request cancellation
     * @param {any} error - Any error
     * @return {boolean} - A boolean indicating if the error was from an api request cancellation
     */ RestClient.prototype.isCancel = function(error) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($b14gs))).isCancel(error);
    };
    /**
     * Retrieves a new and unique cancel token which can be
     * provided in an axios request to be cancelled later.
     */ RestClient.prototype.getCancellableToken = function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($b14gs))).CancelToken.source();
    };
    /**
     * Updates the weakmap with a response promise and its
     * cancel token such that the cancel token can be easily
     * retrieved (and used for cancelling the request)
     */ RestClient.prototype.updateRequestToBeCancellable = function(promise, cancelTokenSource) {
        this._cancelTokenMap.set(promise, cancelTokenSource);
    };
    /**
     * Getting endpoint for API
     * @param {string} apiName - The name of the api
     * @return {string} - The endpoint of the api
     */ RestClient.prototype.endpoint = function(apiName) {
        var _this = this;
        var cloud_logic_array = this._options.endpoints;
        var response = '';
        if (!Array.isArray(cloud_logic_array)) return response;
        cloud_logic_array.forEach(function(v) {
            if (v.name === apiName) {
                response = v.endpoint;
                if (typeof v.region === 'string') _this._region = v.region;
                else if (typeof _this._options.region === 'string') _this._region = _this._options.region;
                if (typeof v.service === 'string') _this._service = v.service || 'execute-api';
                else _this._service = 'execute-api';
                if (typeof v.custom_header === 'function') _this._custom_header = v.custom_header;
                else _this._custom_header = undefined;
            }
        });
        return response;
    };
    /** private methods **/ RestClient.prototype._signed = function(params, credentials, isAllResponse, _a) {
        var service = _a.service, region = _a.region;
        var signerServiceInfoParams = params.signerServiceInfo, otherParams = $f176425b6012bcc4$var$__rest(params, [
            "signerServiceInfo"
        ]);
        var endpoint_region = region || this._region || this._options.region;
        var endpoint_service = service || this._service || this._options.service;
        var creds = {
            secret_key: credentials.secretAccessKey,
            access_key: credentials.accessKeyId,
            session_token: credentials.sessionToken
        };
        var endpointInfo = {
            region: endpoint_region,
            service: endpoint_service
        };
        var signerServiceInfo = Object.assign(endpointInfo, signerServiceInfoParams);
        var signed_params = (0, $ap2RT.Signer).sign(otherParams, creds, signerServiceInfo);
        if (signed_params.data) signed_params.body = signed_params.data;
        $f176425b6012bcc4$var$logger.debug('Signed Request: ', signed_params);
        delete signed_params.headers['host'];
        return (0, (/*@__PURE__*/$parcel$interopDefault($b14gs)))(signed_params).then(function(response) {
            return isAllResponse ? response : response.data;
        }).catch(function(error) {
            $f176425b6012bcc4$var$logger.debug(error);
            throw error;
        });
    };
    RestClient.prototype._request = function(params, isAllResponse) {
        if (isAllResponse === void 0) isAllResponse = false;
        return (0, (/*@__PURE__*/$parcel$interopDefault($b14gs)))(params).then(function(response) {
            return isAllResponse ? response : response.data;
        }).catch(function(error) {
            $f176425b6012bcc4$var$logger.debug(error);
            throw error;
        });
    };
    RestClient.prototype._parseUrl = function(url) {
        var parts = url.split('/');
        return {
            host: parts[2],
            path: '/' + parts.slice(3).join('/')
        };
    };
    return RestClient;
}();

});
parcelRegister("b14gs", function(module, exports) {

module.exports = (parcelRequire("12yPf"));

});
parcelRegister("12yPf", function(module, exports) {
'use strict';

var $cVuK8 = parcelRequire("cVuK8");

var $aSXXH = parcelRequire("aSXXH");

var $ctEyb = parcelRequire("ctEyb");

var $6Y9Aa = parcelRequire("6Y9Aa");

var $4nLGm = parcelRequire("4nLGm");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $0c20fdfaf03c78ff$var$createInstance(defaultConfig) {
    var context = new $ctEyb(defaultConfig);
    var instance = $aSXXH($ctEyb.prototype.request, context);
    // Copy axios.prototype to instance
    $cVuK8.extend(instance, $ctEyb.prototype, context);
    // Copy context to instance
    $cVuK8.extend(instance, context);
    return instance;
}
// Create the default instance to be exported
var $0c20fdfaf03c78ff$var$axios = $0c20fdfaf03c78ff$var$createInstance($4nLGm);
// Expose Axios class to allow class inheritance
$0c20fdfaf03c78ff$var$axios.Axios = $ctEyb;
// Factory for creating new instances
$0c20fdfaf03c78ff$var$axios.create = function create(instanceConfig) {
    return $0c20fdfaf03c78ff$var$createInstance($6Y9Aa($0c20fdfaf03c78ff$var$axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
$0c20fdfaf03c78ff$var$axios.Cancel = (parcelRequire("iVE37"));

$0c20fdfaf03c78ff$var$axios.CancelToken = (parcelRequire("8IK93"));

$0c20fdfaf03c78ff$var$axios.isCancel = (parcelRequire("enk4n"));
// Expose all/spread
$0c20fdfaf03c78ff$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$0c20fdfaf03c78ff$var$axios.spread = (parcelRequire("lWWjV"));

// Expose isAxiosError
$0c20fdfaf03c78ff$var$axios.isAxiosError = (parcelRequire("icW79"));
module.exports = $0c20fdfaf03c78ff$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $0c20fdfaf03c78ff$var$axios;

});
parcelRegister("cVuK8", function(module, exports) {
'use strict';

var $aSXXH = parcelRequire("aSXXH");
/*global toString:true*/ // utils is a library of generic helper functions non-specific to axios
var $9692a7db25fe195b$var$toString = Object.prototype.toString;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $9692a7db25fe195b$var$isArray(val) {
    return $9692a7db25fe195b$var$toString.call(val) === '[object Array]';
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $9692a7db25fe195b$var$isUndefined(val) {
    return typeof val === 'undefined';
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $9692a7db25fe195b$var$isBuffer(val) {
    return val !== null && !$9692a7db25fe195b$var$isUndefined(val) && val.constructor !== null && !$9692a7db25fe195b$var$isUndefined(val.constructor) && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ function $9692a7db25fe195b$var$isArrayBuffer(val) {
    return $9692a7db25fe195b$var$toString.call(val) === '[object ArrayBuffer]';
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $9692a7db25fe195b$var$isFormData(val) {
    return typeof FormData !== 'undefined' && val instanceof FormData;
}
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $9692a7db25fe195b$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && val.buffer instanceof ArrayBuffer;
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $9692a7db25fe195b$var$isString(val) {
    return typeof val === 'string';
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $9692a7db25fe195b$var$isNumber(val) {
    return typeof val === 'number';
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $9692a7db25fe195b$var$isObject(val) {
    return val !== null && typeof val === 'object';
}
/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */ function $9692a7db25fe195b$var$isPlainObject(val) {
    if ($9692a7db25fe195b$var$toString.call(val) !== '[object Object]') return false;
    var prototype = Object.getPrototypeOf(val);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ function $9692a7db25fe195b$var$isDate(val) {
    return $9692a7db25fe195b$var$toString.call(val) === '[object Date]';
}
/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ function $9692a7db25fe195b$var$isFile(val) {
    return $9692a7db25fe195b$var$toString.call(val) === '[object File]';
}
/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ function $9692a7db25fe195b$var$isBlob(val) {
    return $9692a7db25fe195b$var$toString.call(val) === '[object Blob]';
}
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $9692a7db25fe195b$var$isFunction(val) {
    return $9692a7db25fe195b$var$toString.call(val) === '[object Function]';
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $9692a7db25fe195b$var$isStream(val) {
    return $9692a7db25fe195b$var$isObject(val) && $9692a7db25fe195b$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ function $9692a7db25fe195b$var$isURLSearchParams(val) {
    return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $9692a7db25fe195b$var$trim(str) {
    return str.replace(/^\s*/, '').replace(/\s*$/, '');
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function $9692a7db25fe195b$var$isStandardBrowserEnv() {
    if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' || navigator.product === 'NativeScript' || navigator.product === 'NS')) return false;
    return typeof window !== 'undefined' && typeof document !== 'undefined';
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $9692a7db25fe195b$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($9692a7db25fe195b$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $9692a7db25fe195b$var$merge() {
    var result = {};
    function assignValue(val, key) {
        if ($9692a7db25fe195b$var$isPlainObject(result[key]) && $9692a7db25fe195b$var$isPlainObject(val)) result[key] = $9692a7db25fe195b$var$merge(result[key], val);
        else if ($9692a7db25fe195b$var$isPlainObject(val)) result[key] = $9692a7db25fe195b$var$merge({}, val);
        else if ($9692a7db25fe195b$var$isArray(val)) result[key] = val.slice();
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$9692a7db25fe195b$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $9692a7db25fe195b$var$extend(a, b, thisArg) {
    $9692a7db25fe195b$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === 'function') a[key] = $aSXXH(val, thisArg);
        else a[key] = val;
    });
    return a;
}
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */ function $9692a7db25fe195b$var$stripBOM(content) {
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
}
module.exports = {
    isArray: $9692a7db25fe195b$var$isArray,
    isArrayBuffer: $9692a7db25fe195b$var$isArrayBuffer,
    isBuffer: $9692a7db25fe195b$var$isBuffer,
    isFormData: $9692a7db25fe195b$var$isFormData,
    isArrayBufferView: $9692a7db25fe195b$var$isArrayBufferView,
    isString: $9692a7db25fe195b$var$isString,
    isNumber: $9692a7db25fe195b$var$isNumber,
    isObject: $9692a7db25fe195b$var$isObject,
    isPlainObject: $9692a7db25fe195b$var$isPlainObject,
    isUndefined: $9692a7db25fe195b$var$isUndefined,
    isDate: $9692a7db25fe195b$var$isDate,
    isFile: $9692a7db25fe195b$var$isFile,
    isBlob: $9692a7db25fe195b$var$isBlob,
    isFunction: $9692a7db25fe195b$var$isFunction,
    isStream: $9692a7db25fe195b$var$isStream,
    isURLSearchParams: $9692a7db25fe195b$var$isURLSearchParams,
    isStandardBrowserEnv: $9692a7db25fe195b$var$isStandardBrowserEnv,
    forEach: $9692a7db25fe195b$var$forEach,
    merge: $9692a7db25fe195b$var$merge,
    extend: $9692a7db25fe195b$var$extend,
    trim: $9692a7db25fe195b$var$trim,
    stripBOM: $9692a7db25fe195b$var$stripBOM
};

});
parcelRegister("aSXXH", function(module, exports) {
'use strict';
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

});


parcelRegister("ctEyb", function(module, exports) {
'use strict';

var $cVuK8 = parcelRequire("cVuK8");

var $4J5oi = parcelRequire("4J5oi");

var $7fwLY = parcelRequire("7fwLY");

var $1IQIi = parcelRequire("1IQIi");

var $6Y9Aa = parcelRequire("6Y9Aa");
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $9157a5f0f3159c37$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $7fwLY(),
        response: new $7fwLY()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ $9157a5f0f3159c37$var$Axios.prototype.request = function request(config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof config === 'string') {
        config = arguments[1] || {};
        config.url = arguments[0];
    } else config = config || {};
    config = $6Y9Aa(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = 'get';
    // Hook up interceptors middleware
    var chain = [
        $1IQIi,
        undefined
    ];
    var promise = Promise.resolve(config);
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        chain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        chain.push(interceptor.fulfilled, interceptor.rejected);
    });
    while(chain.length)promise = promise.then(chain.shift(), chain.shift());
    return promise;
};
$9157a5f0f3159c37$var$Axios.prototype.getUri = function getUri(config) {
    config = $6Y9Aa(this.defaults, config);
    return $4J5oi(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};
// Provide aliases for supported request methods
$cVuK8.forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $9157a5f0f3159c37$var$Axios.prototype[method] = function(url, config) {
        return this.request($6Y9Aa(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
$cVuK8.forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ $9157a5f0f3159c37$var$Axios.prototype[method] = function(url, data, config) {
        return this.request($6Y9Aa(config || {}, {
            method: method,
            url: url,
            data: data
        }));
    };
});
module.exports = $9157a5f0f3159c37$var$Axios;

});
parcelRegister("4J5oi", function(module, exports) {
'use strict';

var $cVuK8 = parcelRequire("cVuK8");
function $370f8be2c4a011a0$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if ($cVuK8.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        $cVuK8.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === 'undefined') return;
            if ($cVuK8.isArray(val)) key = key + '[]';
            else val = [
                val
            ];
            $cVuK8.forEach(val, function parseValue(v) {
                if ($cVuK8.isDate(v)) v = v.toISOString();
                else if ($cVuK8.isObject(v)) v = JSON.stringify(v);
                parts.push($370f8be2c4a011a0$var$encode(key) + '=' + $370f8be2c4a011a0$var$encode(v));
            });
        });
        serializedParams = parts.join('&');
    }
    if (serializedParams) {
        var hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
};

});

parcelRegister("7fwLY", function(module, exports) {
'use strict';

var $cVuK8 = parcelRequire("cVuK8");
function $54735b185e2e6498$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $54735b185e2e6498$var$InterceptorManager.prototype.use = function use(fulfilled, rejected) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $54735b185e2e6498$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $54735b185e2e6498$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $cVuK8.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $54735b185e2e6498$var$InterceptorManager;

});

parcelRegister("1IQIi", function(module, exports) {
'use strict';

var $cVuK8 = parcelRequire("cVuK8");

var $a2xBF = parcelRequire("a2xBF");

var $enk4n = parcelRequire("enk4n");

var $4nLGm = parcelRequire("4nLGm");
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ function $1412ca4b06d2a974$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $1412ca4b06d2a974$var$throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $a2xBF(config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = $cVuK8.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
    $cVuK8.forEach([
        'delete',
        'get',
        'head',
        'post',
        'put',
        'patch',
        'common'
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || $4nLGm.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $1412ca4b06d2a974$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $a2xBF(response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$enk4n(reason)) {
            $1412ca4b06d2a974$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $a2xBF(reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRegister("a2xBF", function(module, exports) {
'use strict';

var $cVuK8 = parcelRequire("cVuK8");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    /*eslint no-param-reassign:0*/ $cVuK8.forEach(fns, function transform(fn) {
        data = fn(data, headers);
    });
    return data;
};

});

parcelRegister("enk4n", function(module, exports) {
'use strict';
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});

parcelRegister("4nLGm", function(module, exports) {
'use strict';

var $cVuK8 = parcelRequire("cVuK8");

var $d42xm = parcelRequire("d42xm");
var $330e4c1779c909d6$var$DEFAULT_CONTENT_TYPE = {
    'Content-Type': 'application/x-www-form-urlencoded'
};
function $330e4c1779c909d6$var$setContentTypeIfUnset(headers, value) {
    if (!$cVuK8.isUndefined(headers) && $cVuK8.isUndefined(headers['Content-Type'])) headers['Content-Type'] = value;
}

function $330e4c1779c909d6$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== 'undefined') // For browsers use XHR adapter
    adapter = (parcelRequire("jxQZi"));
    return adapter;
}
var $330e4c1779c909d6$var$defaults = {
    adapter: $330e4c1779c909d6$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $d42xm(headers, 'Accept');
            $d42xm(headers, 'Content-Type');
            if ($cVuK8.isFormData(data) || $cVuK8.isArrayBuffer(data) || $cVuK8.isBuffer(data) || $cVuK8.isStream(data) || $cVuK8.isFile(data) || $cVuK8.isBlob(data)) return data;
            if ($cVuK8.isArrayBufferView(data)) return data.buffer;
            if ($cVuK8.isURLSearchParams(data)) {
                $330e4c1779c909d6$var$setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
                return data.toString();
            }
            if ($cVuK8.isObject(data)) {
                $330e4c1779c909d6$var$setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
                return JSON.stringify(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            /*eslint no-param-reassign:0*/ if (typeof data === 'string') try {
                data = JSON.parse(data);
            } catch (e) {}
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    }
};
$330e4c1779c909d6$var$defaults.headers = {
    common: {
        'Accept': 'application/json, text/plain, */*'
    }
};
$cVuK8.forEach([
    'delete',
    'get',
    'head'
], function forEachMethodNoData(method) {
    $330e4c1779c909d6$var$defaults.headers[method] = {};
});
$cVuK8.forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    $330e4c1779c909d6$var$defaults.headers[method] = $cVuK8.merge($330e4c1779c909d6$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $330e4c1779c909d6$var$defaults;

});
parcelRegister("d42xm", function(module, exports) {
'use strict';

var $cVuK8 = parcelRequire("cVuK8");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $cVuK8.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRegister("jxQZi", function(module, exports) {
'use strict';

var $cVuK8 = parcelRequire("cVuK8");

var $e7g49 = parcelRequire("e7g49");

var $5wvgl = parcelRequire("5wvgl");

var $4J5oi = parcelRequire("4J5oi");

var $ajOEU = parcelRequire("ajOEU");

var $9gKLE = parcelRequire("9gKLE");

var $l6a9Z = parcelRequire("l6a9Z");

var $aGM4J = parcelRequire("aGM4J");
module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        if ($cVuK8.isFormData(requestData)) delete requestHeaders['Content-Type']; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || '';
            var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
            requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
        }
        var fullPath = $ajOEU(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), $4J5oi(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        // Listen for ready state
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // Prepare the response
            var responseHeaders = 'getAllResponseHeaders' in request ? $9gKLE(request.getAllResponseHeaders()) : null;
            var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $e7g49(resolve, reject, response);
            // Clean up request
            request = null;
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject($aGM4J('Request aborted', config, 'ECONNABORTED', request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject($aGM4J('Network Error', config, null, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject($aGM4J(timeoutErrorMessage, config, 'ECONNABORTED', request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($cVuK8.isStandardBrowserEnv()) {
            // Add xsrf header
            var xsrfValue = (config.withCredentials || $l6a9Z(fullPath)) && config.xsrfCookieName ? $5wvgl.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ('setRequestHeader' in request) $cVuK8.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!$cVuK8.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (config.responseType) try {
            request.responseType = config.responseType;
        } catch (e) {
            // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
            // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
            if (config.responseType !== 'json') throw e;
        }
        // Handle progress if needed
        if (typeof config.onDownloadProgress === 'function') request.addEventListener('progress', config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === 'function' && request.upload) request.upload.addEventListener('progress', config.onUploadProgress);
        if (config.cancelToken) // Handle cancellation
        config.cancelToken.promise.then(function onCanceled(cancel) {
            if (!request) return;
            request.abort();
            reject(cancel);
            // Clean up request
            request = null;
        });
        if (!requestData) requestData = null;
        // Send the request
        request.send(requestData);
    });
};

});
parcelRegister("e7g49", function(module, exports) {
'use strict';

var $aGM4J = parcelRequire("aGM4J");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject($aGM4J('Request failed with status code ' + response.status, response.config, null, response.request, response));
};

});
parcelRegister("aGM4J", function(module, exports) {
'use strict';

var $aAjw6 = parcelRequire("aAjw6");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ module.exports = function createError(message, config, code, request, response) {
    var error = new Error(message);
    return $aAjw6(error, config, code, request, response);
};

});
parcelRegister("aAjw6", function(module, exports) {
'use strict';
/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */ module.exports = function enhanceError(error, config, code, request, response) {
    error.config = config;
    if (code) error.code = code;
    error.request = request;
    error.response = response;
    error.isAxiosError = true;
    error.toJSON = function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code
        };
    };
    return error;
};

});



parcelRegister("5wvgl", function(module, exports) {
'use strict';

var $cVuK8 = parcelRequire("cVuK8");
module.exports = $cVuK8.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + '=' + encodeURIComponent(value));
            if ($cVuK8.isNumber(expires)) cookie.push('expires=' + new Date(expires).toGMTString());
            if ($cVuK8.isString(path)) cookie.push('path=' + path);
            if ($cVuK8.isString(domain)) cookie.push('domain=' + domain);
            if (secure === true) cookie.push('secure');
            document.cookie = cookie.join('; ');
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, '', Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});

parcelRegister("ajOEU", function(module, exports) {
'use strict';

var $3Lxku = parcelRequire("3Lxku");

var $jaVc2 = parcelRequire("jaVc2");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !$3Lxku(requestedURL)) return $jaVc2(baseURL, requestedURL);
    return requestedURL;
};

});
parcelRegister("3Lxku", function(module, exports) {
'use strict';
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

});

parcelRegister("jaVc2", function(module, exports) {
'use strict';
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
};

});


parcelRegister("9gKLE", function(module, exports) {
'use strict';

var $cVuK8 = parcelRequire("cVuK8");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $6bf9e2c3c114b456$var$ignoreDuplicateOf = [
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $cVuK8.forEach(headers.split('\n'), function parser(line) {
        i = line.indexOf(':');
        key = $cVuK8.trim(line.substr(0, i)).toLowerCase();
        val = $cVuK8.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && $6bf9e2c3c114b456$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === 'set-cookie') parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
        }
    });
    return parsed;
};

});

parcelRegister("l6a9Z", function(module, exports) {
'use strict';

var $cVuK8 = parcelRequire("cVuK8");
module.exports = $cVuK8.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute('href', href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute('href', href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = $cVuK8.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});




parcelRegister("6Y9Aa", function(module, exports) {
'use strict';

var $cVuK8 = parcelRequire("cVuK8");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    var valueFromConfig2Keys = [
        'url',
        'method',
        'data'
    ];
    var mergeDeepPropertiesKeys = [
        'headers',
        'auth',
        'proxy',
        'params'
    ];
    var defaultToConfig2Keys = [
        'baseURL',
        'transformRequest',
        'transformResponse',
        'paramsSerializer',
        'timeout',
        'timeoutMessage',
        'withCredentials',
        'adapter',
        'responseType',
        'xsrfCookieName',
        'xsrfHeaderName',
        'onUploadProgress',
        'onDownloadProgress',
        'decompress',
        'maxContentLength',
        'maxBodyLength',
        'maxRedirects',
        'transport',
        'httpAgent',
        'httpsAgent',
        'cancelToken',
        'socketPath',
        'responseEncoding'
    ];
    var directMergeKeys = [
        'validateStatus'
    ];
    function getMergedValue(target, source) {
        if ($cVuK8.isPlainObject(target) && $cVuK8.isPlainObject(source)) return $cVuK8.merge(target, source);
        else if ($cVuK8.isPlainObject(source)) return $cVuK8.merge({}, source);
        else if ($cVuK8.isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(prop) {
        if (!$cVuK8.isUndefined(config2[prop])) config[prop] = getMergedValue(config1[prop], config2[prop]);
        else if (!$cVuK8.isUndefined(config1[prop])) config[prop] = getMergedValue(undefined, config1[prop]);
    }
    $cVuK8.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
        if (!$cVuK8.isUndefined(config2[prop])) config[prop] = getMergedValue(undefined, config2[prop]);
    });
    $cVuK8.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);
    $cVuK8.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
        if (!$cVuK8.isUndefined(config2[prop])) config[prop] = getMergedValue(undefined, config2[prop]);
        else if (!$cVuK8.isUndefined(config1[prop])) config[prop] = getMergedValue(undefined, config1[prop]);
    });
    $cVuK8.forEach(directMergeKeys, function merge(prop) {
        if (prop in config2) config[prop] = getMergedValue(config1[prop], config2[prop]);
        else if (prop in config1) config[prop] = getMergedValue(undefined, config1[prop]);
    });
    var axiosKeys = valueFromConfig2Keys.concat(mergeDeepPropertiesKeys).concat(defaultToConfig2Keys).concat(directMergeKeys);
    var otherKeys = Object.keys(config1).concat(Object.keys(config2)).filter(function filterAxiosKeys(key) {
        return axiosKeys.indexOf(key) === -1;
    });
    $cVuK8.forEach(otherKeys, mergeDeepProperties);
    return config;
};

});


parcelRegister("iVE37", function(module, exports) {
'use strict';
/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function $dc7c9dd8314e187e$var$Cancel(message) {
    this.message = message;
}
$dc7c9dd8314e187e$var$Cancel.prototype.toString = function toString() {
    return 'Cancel' + (this.message ? ': ' + this.message : '');
};
$dc7c9dd8314e187e$var$Cancel.prototype.__CANCEL__ = true;
module.exports = $dc7c9dd8314e187e$var$Cancel;

});

parcelRegister("8IK93", function(module, exports) {
'use strict';

var $iVE37 = parcelRequire("iVE37");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $65963a3a701f5156$var$CancelToken(executor) {
    if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $iVE37(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ $65963a3a701f5156$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $65963a3a701f5156$var$CancelToken.source = function source() {
    var cancel;
    var token = new $65963a3a701f5156$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $65963a3a701f5156$var$CancelToken;

});

parcelRegister("lWWjV", function(module, exports) {
'use strict';
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});

parcelRegister("icW79", function(module, exports) {
'use strict';
/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */ module.exports = function isAxiosError(payload) {
    return typeof payload === 'object' && payload.isAxiosError === true;
};

});





parcelRegister("g8Cjm", function(module, exports) {

$parcel$export(module.exports, "GraphQLAPIClass", () => $bbfb1c8084238e89$export$e32503f9802a56ee);
$parcel$export(module.exports, "GraphQLAPI", () => $bbfb1c8084238e89$export$6572ab1b3fe6697f);

var $1aNdC = parcelRequire("1aNdC");

var $2MDAc = parcelRequire("2MDAc");

var $8DzV8 = parcelRequire("8DzV8");
parcelRequire("8qWqv");
var $a16qJ = parcelRequire("a16qJ");
var $8qWqv = parcelRequire("8qWqv");
var $7UO1b = parcelRequire("7UO1b");
var $29OQz = parcelRequire("29OQz");
var $6zWMj = parcelRequire("6zWMj");

var $gy3Xv = parcelRequire("gy3Xv");

var $i14CG = parcelRequire("i14CG");

var $8SrNO = parcelRequire("8SrNO");

var $gBcFT = parcelRequire("gBcFT");

var $kJimX = parcelRequire("kJimX");
var $bbfb1c8084238e89$var$__assign = undefined && undefined.__assign || function() {
    $bbfb1c8084238e89$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $bbfb1c8084238e89$var$__assign.apply(this, arguments);
};
var $bbfb1c8084238e89$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $bbfb1c8084238e89$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $bbfb1c8084238e89$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $bbfb1c8084238e89$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $bbfb1c8084238e89$var$USER_AGENT_HEADER = 'x-amz-user-agent';
var $bbfb1c8084238e89$var$logger = new (0, $7UO1b.ConsoleLogger)('GraphQLAPI');
var $bbfb1c8084238e89$export$78930a3b816845f9 = function(query, variables) {
    if (variables === void 0) variables = {};
    return {
        query: query,
        variables: variables
    };
};
/**
 * Export Cloud Logic APIs
 */ var $bbfb1c8084238e89$export$e32503f9802a56ee = /** @class */ function() {
    /**
     * Initialize GraphQL API with AWS configuration
     * @param {Object} options - Configuration object for API
     */ function GraphQLAPIClass(options) {
        this._api = null;
        this.Auth = (0, $i14CG.default);
        this.Cache = (0, $8SrNO.default);
        this.Credentials = (0, $29OQz.Credentials);
        this._options = options;
        $bbfb1c8084238e89$var$logger.debug('API Options', this._options);
    }
    GraphQLAPIClass.prototype.getModuleName = function() {
        return 'GraphQLAPI';
    };
    /**
     * Configure API
     * @param {Object} config - Configuration of the API
     * @return {Object} - The current configuration
     */ GraphQLAPIClass.prototype.configure = function(options) {
        var _a = options || {}, _b = _a.API, API = _b === void 0 ? {} : _b, otherOptions = $bbfb1c8084238e89$var$__rest(_a, [
            "API"
        ]);
        var opt = $bbfb1c8084238e89$var$__assign($bbfb1c8084238e89$var$__assign({}, otherOptions), API);
        $bbfb1c8084238e89$var$logger.debug('configure GraphQL API', {
            opt: opt
        });
        if (opt['aws_project_region']) opt = Object.assign({}, opt, {
            region: opt['aws_project_region'],
            header: {}
        });
        if (typeof opt.graphql_headers !== 'undefined' && typeof opt.graphql_headers !== 'function') {
            $bbfb1c8084238e89$var$logger.warn('graphql_headers should be a function');
            opt.graphql_headers = undefined;
        }
        this._options = Object.assign({}, this._options, opt);
        this.createInstance();
        return this._options;
    };
    /**
     * Create an instance of API for the library
     * @return - A promise of true if Success
     */ GraphQLAPIClass.prototype.createInstance = function() {
        $bbfb1c8084238e89$var$logger.debug('create Rest instance');
        if (this._options) {
            this._api = new (0, $kJimX.RestClient)(this._options);
            // Share instance Credentials with client for SSR
            this._api.Credentials = this.Credentials;
            return true;
        } else return Promise.reject('API not configured');
    };
    GraphQLAPIClass.prototype._headerBasedAuth = function(defaultAuthenticationType) {
        return $bbfb1c8084238e89$var$__awaiter(this, void 0, void 0, function() {
            var _a, aws_appsync_authenticationType, apiKey, authenticationType, headers, _b, credentialsOK, token, federatedInfo, currentUser, e_1, session, e_2;
            return $bbfb1c8084238e89$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _a = this._options, aws_appsync_authenticationType = _a.aws_appsync_authenticationType, apiKey = _a.aws_appsync_apiKey;
                        authenticationType = defaultAuthenticationType || aws_appsync_authenticationType || 'AWS_IAM';
                        headers = {};
                        _b = authenticationType;
                        switch(_b){
                            case 'API_KEY':
                                return [
                                    3 /*break*/ ,
                                    1
                                ];
                            case 'AWS_IAM':
                                return [
                                    3 /*break*/ ,
                                    2
                                ];
                            case 'OPENID_CONNECT':
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 'AMAZON_COGNITO_USER_POOLS':
                                return [
                                    3 /*break*/ ,
                                    11
                                ];
                        }
                        return [
                            3 /*break*/ ,
                            15
                        ];
                    case 1:
                        if (!apiKey) throw new Error((0, $gBcFT.GraphQLAuthError).NO_API_KEY);
                        headers = {
                            Authorization: null,
                            'X-Api-Key': apiKey
                        };
                        return [
                            3 /*break*/ ,
                            16
                        ];
                    case 2:
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 3:
                        credentialsOK = _c.sent();
                        if (!credentialsOK) throw new Error((0, $gBcFT.GraphQLAuthError).NO_CREDENTIALS);
                        return [
                            3 /*break*/ ,
                            16
                        ];
                    case 4:
                        _c.trys.push([
                            4,
                            9,
                            ,
                            10
                        ]);
                        token = void 0;
                        return [
                            4 /*yield*/ ,
                            (0, $8SrNO.default).getItem('federatedInfo')
                        ];
                    case 5:
                        federatedInfo = _c.sent();
                        if (!federatedInfo) return [
                            3 /*break*/ ,
                            6
                        ];
                        token = federatedInfo.token;
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 6:
                        return [
                            4 /*yield*/ ,
                            (0, $i14CG.default).currentAuthenticatedUser()
                        ];
                    case 7:
                        currentUser = _c.sent();
                        if (currentUser) token = currentUser.token;
                        _c.label = 8;
                    case 8:
                        if (!token) throw new Error((0, $gBcFT.GraphQLAuthError).NO_FEDERATED_JWT);
                        headers = {
                            Authorization: token
                        };
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 9:
                        e_1 = _c.sent();
                        throw new Error((0, $gBcFT.GraphQLAuthError).NO_CURRENT_USER);
                    case 10:
                        return [
                            3 /*break*/ ,
                            16
                        ];
                    case 11:
                        _c.trys.push([
                            11,
                            13,
                            ,
                            14
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.Auth.currentSession()
                        ];
                    case 12:
                        session = _c.sent();
                        headers = {
                            Authorization: session.getAccessToken().getJwtToken()
                        };
                        return [
                            3 /*break*/ ,
                            14
                        ];
                    case 13:
                        e_2 = _c.sent();
                        throw new Error((0, $gBcFT.GraphQLAuthError).NO_CURRENT_USER);
                    case 14:
                        return [
                            3 /*break*/ ,
                            16
                        ];
                    case 15:
                        headers = {
                            Authorization: null
                        };
                        return [
                            3 /*break*/ ,
                            16
                        ];
                    case 16:
                        return [
                            2 /*return*/ ,
                            headers
                        ];
                }
            });
        });
    };
    /**
     * to get the operation type
     * @param operation
     */ GraphQLAPIClass.prototype.getGraphqlOperationType = function(operation) {
        var doc = (0, $8DzV8.parse)(operation);
        var _a = $bbfb1c8084238e89$var$__read(doc.definitions, 1), operationType = _a[0].operation;
        return operationType;
    };
    /**
     * Executes a GraphQL operation
     *
     * @param {GraphQLOptions} GraphQL Options
     * @param {object} additionalHeaders headers to merge in after any `graphql_headers` set in the config
     * @returns {Promise<GraphQLResult> | Observable<object>}
     */ GraphQLAPIClass.prototype.graphql = function(_a, additionalHeaders) {
        var paramQuery = _a.query, _b = _a.variables, variables = _b === void 0 ? {} : _b, authMode = _a.authMode;
        var query = typeof paramQuery === 'string' ? (0, $8DzV8.parse)(paramQuery) : (0, $8DzV8.parse)((0, $2MDAc.print)(paramQuery));
        var _c = $bbfb1c8084238e89$var$__read(query.definitions.filter(function(def) {
            return def.kind === 'OperationDefinition';
        }), 1), _d = _c[0], operationDef = _d === void 0 ? {} : _d;
        var operationType = operationDef.operation;
        switch(operationType){
            case 'query':
            case 'mutation':
                var cancellableToken = this._api.getCancellableToken();
                var initParams = {
                    cancellableToken: cancellableToken
                };
                var responsePromise = this._graphql({
                    query: query,
                    variables: variables,
                    authMode: authMode
                }, additionalHeaders, initParams);
                this._api.updateRequestToBeCancellable(responsePromise, cancellableToken);
                return responsePromise;
            case 'subscription':
                return this._graphqlSubscribe({
                    query: query,
                    variables: variables,
                    authMode: authMode
                }, additionalHeaders);
        }
        throw new Error("invalid operation type: " + operationType);
    };
    GraphQLAPIClass.prototype._graphql = function(_a, additionalHeaders, initParams) {
        var query = _a.query, variables = _a.variables, authMode = _a.authMode;
        if (additionalHeaders === void 0) additionalHeaders = {};
        if (initParams === void 0) initParams = {};
        return $bbfb1c8084238e89$var$__awaiter(this, void 0, void 0, function() {
            var _b, region, appSyncGraphqlEndpoint, _c, graphql_headers, customGraphqlEndpoint, customEndpointRegion, headers, _d, _e, _f, _g, _h, _j, body, init, endpoint, error, response, err_1, errors;
            var _k;
            return $bbfb1c8084238e89$var$__generator(this, function(_l) {
                switch(_l.label){
                    case 0:
                        if (!!this._api) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.createInstance()
                        ];
                    case 1:
                        _l.sent();
                        _l.label = 2;
                    case 2:
                        _b = this._options, region = _b.aws_appsync_region, appSyncGraphqlEndpoint = _b.aws_appsync_graphqlEndpoint, _c = _b.graphql_headers, graphql_headers = _c === void 0 ? function() {
                            return {};
                        } : _c, customGraphqlEndpoint = _b.graphql_endpoint, customEndpointRegion = _b.graphql_endpoint_iam_region;
                        _d = [
                            {}
                        ];
                        _e = !customGraphqlEndpoint;
                        if (!_e) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            this._headerBasedAuth(authMode)
                        ];
                    case 3:
                        _e = _l.sent();
                        _l.label = 4;
                    case 4:
                        _f = [
                            $bbfb1c8084238e89$var$__assign.apply(void 0, _d.concat([
                                _e
                            ]))
                        ];
                        _g = customGraphqlEndpoint;
                        if (!_g) return [
                            3 /*break*/ ,
                            8
                        ];
                        if (!customEndpointRegion) return [
                            3 /*break*/ ,
                            6
                        ];
                        return [
                            4 /*yield*/ ,
                            this._headerBasedAuth(authMode)
                        ];
                    case 5:
                        _h = _l.sent();
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 6:
                        _h = {
                            Authorization: null
                        };
                        _l.label = 7;
                    case 7:
                        _g = _h;
                        _l.label = 8;
                    case 8:
                        _j = [
                            $bbfb1c8084238e89$var$__assign.apply(void 0, _f.concat([
                                _g
                            ]))
                        ];
                        return [
                            4 /*yield*/ ,
                            graphql_headers({
                                query: query,
                                variables: variables
                            })
                        ];
                    case 9:
                        headers = $bbfb1c8084238e89$var$__assign.apply(void 0, [
                            $bbfb1c8084238e89$var$__assign.apply(void 0, [
                                $bbfb1c8084238e89$var$__assign.apply(void 0, _j.concat([
                                    _l.sent()
                                ])),
                                additionalHeaders
                            ]),
                            !customGraphqlEndpoint && (_k = {}, _k[$bbfb1c8084238e89$var$USER_AGENT_HEADER] = (0, $8qWqv.Constants).userAgent, _k)
                        ]);
                        body = {
                            query: (0, $2MDAc.print)(query),
                            variables: variables
                        };
                        init = Object.assign({
                            headers: headers,
                            body: body,
                            signerServiceInfo: {
                                service: !customGraphqlEndpoint ? 'appsync' : 'execute-api',
                                region: !customGraphqlEndpoint ? region : customEndpointRegion
                            }
                        }, initParams);
                        endpoint = customGraphqlEndpoint || appSyncGraphqlEndpoint;
                        if (!endpoint) {
                            error = new (0, $1aNdC.GraphQLError)('No graphql endpoint provided.');
                            throw {
                                data: {},
                                errors: [
                                    error
                                ]
                            };
                        }
                        _l.label = 10;
                    case 10:
                        _l.trys.push([
                            10,
                            12,
                            ,
                            13
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._api.post(endpoint, init)
                        ];
                    case 11:
                        response = _l.sent();
                        return [
                            3 /*break*/ ,
                            13
                        ];
                    case 12:
                        err_1 = _l.sent();
                        // If the exception is because user intentionally
                        // cancelled the request, do not modify the exception
                        // so that clients can identify the exception correctly.
                        if (this._api.isCancel(err_1)) throw err_1;
                        response = {
                            data: {},
                            errors: [
                                new (0, $1aNdC.GraphQLError)(err_1.message, null, null, null, null, err_1)
                            ]
                        };
                        return [
                            3 /*break*/ ,
                            13
                        ];
                    case 13:
                        errors = response.errors;
                        if (errors && errors.length) throw response;
                        return [
                            2 /*return*/ ,
                            response
                        ];
                }
            });
        });
    };
    /**
     * Checks to see if an error thrown is from an api request cancellation
     * @param {any} error - Any error
     * @return {boolean} - A boolean indicating if the error was from an api request cancellation
     */ GraphQLAPIClass.prototype.isCancel = function(error) {
        return this._api.isCancel(error);
    };
    /**
     * Cancels an inflight request. Only applicable for graphql queries and mutations
     * @param {any} request - request to cancel
     * @return {boolean} - A boolean indicating if the request was cancelled
     */ GraphQLAPIClass.prototype.cancel = function(request, message) {
        return this._api.cancel(request, message);
    };
    GraphQLAPIClass.prototype._graphqlSubscribe = function(_a, additionalHeaders) {
        var query = _a.query, variables = _a.variables, defaultAuthenticationType = _a.authMode;
        if (additionalHeaders === void 0) additionalHeaders = {};
        var _b = this._options, region = _b.aws_appsync_region, appSyncGraphqlEndpoint = _b.aws_appsync_graphqlEndpoint, aws_appsync_authenticationType = _b.aws_appsync_authenticationType, apiKey = _b.aws_appsync_apiKey, _c = _b.graphql_headers, graphql_headers = _c === void 0 ? function() {
            return {};
        } : _c;
        var authenticationType = defaultAuthenticationType || aws_appsync_authenticationType || 'AWS_IAM';
        if ((0, $gy3Xv.default) && typeof (0, $gy3Xv.default).subscribe === 'function') return (0, $gy3Xv.default).subscribe('', {
            provider: (0, $6zWMj.INTERNAL_AWS_APPSYNC_REALTIME_PUBSUB_PROVIDER),
            appSyncGraphqlEndpoint: appSyncGraphqlEndpoint,
            authenticationType: authenticationType,
            apiKey: apiKey,
            query: (0, $2MDAc.print)(query),
            region: region,
            variables: variables,
            graphql_headers: graphql_headers,
            additionalHeaders: additionalHeaders
        });
        else {
            $bbfb1c8084238e89$var$logger.debug('No pubsub module applied for subscription');
            throw new Error('No pubsub module applied for subscription');
        }
    };
    /**
     * @private
     */ GraphQLAPIClass.prototype._ensureCredentials = function() {
        var _this = this;
        return this.Credentials.get().then(function(credentials) {
            if (!credentials) return false;
            var cred = _this.Credentials.shear(credentials);
            $bbfb1c8084238e89$var$logger.debug('set credentials for api', cred);
            return true;
        }).catch(function(err) {
            $bbfb1c8084238e89$var$logger.warn('ensure credentials error', err);
            return false;
        });
    };
    return GraphQLAPIClass;
}();
var $bbfb1c8084238e89$export$6572ab1b3fe6697f = new $bbfb1c8084238e89$export$e32503f9802a56ee(null);
(0, $a16qJ.Amplify).register($bbfb1c8084238e89$export$6572ab1b3fe6697f);

});
parcelRegister("1aNdC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GraphQLError = $0dace76fdd002fe4$var$GraphQLError;

var $70Wub = parcelRequire("70Wub");

var $aPdWS = parcelRequire("aPdWS");
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */ function $0dace76fdd002fe4$var$GraphQLError(message, nodes, source, positions, path, originalError, extensions) {
    // Compute list of blame nodes.
    var _nodes = Array.isArray(nodes) ? nodes.length !== 0 ? nodes : undefined : nodes ? [
        nodes
    ] : undefined; // Compute locations in the source for the given nodes/positions.
    var _source = source;
    if (!_source && _nodes) {
        var node = _nodes[0];
        _source = node && node.loc && node.loc.source;
    }
    var _positions = positions;
    if (!_positions && _nodes) _positions = _nodes.reduce(function(list, node) {
        if (node.loc) list.push(node.loc.start);
        return list;
    }, []);
    if (_positions && _positions.length === 0) _positions = undefined;
    var _locations;
    if (positions && source) _locations = positions.map(function(pos) {
        return (0, $aPdWS.getLocation)(source, pos);
    });
    else if (_nodes) _locations = _nodes.reduce(function(list, node) {
        if (node.loc) list.push((0, $aPdWS.getLocation)(node.loc.source, node.loc.start));
        return list;
    }, []);
    var _extensions = extensions || originalError && originalError.extensions;
    Object.defineProperties(this, {
        message: {
            value: message,
            // By being enumerable, JSON.stringify will include `message` in the
            // resulting output. This ensures that the simplest possible GraphQL
            // service adheres to the spec.
            enumerable: true,
            writable: true
        },
        locations: {
            // Coercing falsey values to undefined ensures they will not be included
            // in JSON.stringify() when not provided.
            value: _locations || undefined,
            // By being enumerable, JSON.stringify will include `locations` in the
            // resulting output. This ensures that the simplest possible GraphQL
            // service adheres to the spec.
            enumerable: Boolean(_locations)
        },
        path: {
            // Coercing falsey values to undefined ensures they will not be included
            // in JSON.stringify() when not provided.
            value: path || undefined,
            // By being enumerable, JSON.stringify will include `path` in the
            // resulting output. This ensures that the simplest possible GraphQL
            // service adheres to the spec.
            enumerable: Boolean(path)
        },
        nodes: {
            value: _nodes || undefined
        },
        source: {
            value: _source || undefined
        },
        positions: {
            value: _positions || undefined
        },
        originalError: {
            value: originalError
        },
        extensions: {
            // Coercing falsey values to undefined ensures they will not be included
            // in JSON.stringify() when not provided.
            value: _extensions || undefined,
            // By being enumerable, JSON.stringify will include `path` in the
            // resulting output. This ensures that the simplest possible GraphQL
            // service adheres to the spec.
            enumerable: Boolean(_extensions)
        }
    }); // Include (non-enumerable) stack trace.
    if (originalError && originalError.stack) Object.defineProperty(this, 'stack', {
        value: originalError.stack,
        writable: true,
        configurable: true
    });
    else if (Error.captureStackTrace) Error.captureStackTrace(this, $0dace76fdd002fe4$var$GraphQLError);
    else Object.defineProperty(this, 'stack', {
        value: Error().stack,
        writable: true,
        configurable: true
    });
}
$0dace76fdd002fe4$var$GraphQLError.prototype = Object.create(Error.prototype, {
    constructor: {
        value: $0dace76fdd002fe4$var$GraphQLError
    },
    name: {
        value: 'GraphQLError'
    },
    toString: {
        value: function toString() {
            return (0, $70Wub.printError)(this);
        }
    }
});

});
parcelRegister("70Wub", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.printError = $51b5e68edefdbb6d$var$printError;

var $aPdWS = parcelRequire("aPdWS");
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */ /**
 * Prints a GraphQLError to a string, representing useful location information
 * about the error's position in the source.
 */ function $51b5e68edefdbb6d$var$printError(error) {
    var printedLocations = [];
    if (error.nodes) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;
        try {
            for(var _iterator = error.nodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var node = _step.value;
                if (node.loc) printedLocations.push($51b5e68edefdbb6d$var$highlightSourceAtLocation(node.loc.source, (0, $aPdWS.getLocation)(node.loc.source, node.loc.start)));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) _iterator.return();
            } finally{
                if (_didIteratorError) throw _iteratorError;
            }
        }
    } else if (error.source && error.locations) {
        var source = error.source;
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;
        try {
            for(var _iterator2 = error.locations[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                var location = _step2.value;
                printedLocations.push($51b5e68edefdbb6d$var$highlightSourceAtLocation(source, location));
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return != null) _iterator2.return();
            } finally{
                if (_didIteratorError2) throw _iteratorError2;
            }
        }
    }
    return printedLocations.length === 0 ? error.message : [
        error.message
    ].concat(printedLocations).join('\n\n') + '\n';
}
/**
 * Render a helpful description of the location of the error in the GraphQL
 * Source document.
 */ function $51b5e68edefdbb6d$var$highlightSourceAtLocation(source, location) {
    var firstLineColumnOffset = source.locationOffset.column - 1;
    var body = $51b5e68edefdbb6d$var$whitespace(firstLineColumnOffset) + source.body;
    var lineIndex = location.line - 1;
    var lineOffset = source.locationOffset.line - 1;
    var lineNum = location.line + lineOffset;
    var columnOffset = location.line === 1 ? firstLineColumnOffset : 0;
    var columnNum = location.column + columnOffset;
    var lines = body.split(/\r\n|[\n\r]/g);
    return "".concat(source.name, " (").concat(lineNum, ":").concat(columnNum, ")\n") + $51b5e68edefdbb6d$var$printPrefixedLines([
        [
            "".concat(lineNum - 1, ": "),
            lines[lineIndex - 1]
        ],
        [
            "".concat(lineNum, ": "),
            lines[lineIndex]
        ],
        [
            '',
            $51b5e68edefdbb6d$var$whitespace(columnNum - 1) + '^'
        ],
        [
            "".concat(lineNum + 1, ": "),
            lines[lineIndex + 1]
        ]
    ]);
}
function $51b5e68edefdbb6d$var$printPrefixedLines(lines) {
    var existingLines = lines.filter(function(_ref) {
        var _ = _ref[0], line = _ref[1];
        return line !== undefined;
    });
    var padLen = 0;
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;
    try {
        for(var _iterator3 = existingLines[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
            var _ref4 = _step3.value;
            var prefix = _ref4[0];
            padLen = Math.max(padLen, prefix.length);
        }
    } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion3 && _iterator3.return != null) _iterator3.return();
        } finally{
            if (_didIteratorError3) throw _iteratorError3;
        }
    }
    return existingLines.map(function(_ref3) {
        var prefix = _ref3[0], line = _ref3[1];
        return $51b5e68edefdbb6d$var$lpad(padLen, prefix) + line;
    }).join('\n');
}
function $51b5e68edefdbb6d$var$whitespace(len) {
    return Array(len + 1).join(' ');
}
function $51b5e68edefdbb6d$var$lpad(len, str) {
    return $51b5e68edefdbb6d$var$whitespace(len - str.length) + str;
}

});
parcelRegister("aPdWS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getLocation = $7e197cb13878649d$var$getLocation;
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */ /**
 * Represents a location in a Source.
 */ /**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */ function $7e197cb13878649d$var$getLocation(source, position) {
    var lineRegexp = /\r\n|[\n\r]/g;
    var line = 1;
    var column = position + 1;
    var match;
    while((match = lineRegexp.exec(source.body)) && match.index < position){
        line += 1;
        column = position + 1 - (match.index + match[0].length);
    }
    return {
        line: line,
        column: column
    };
}

});



parcelRegister("2MDAc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.print = $206ec4cfbffd163d$var$print;

var $ctaJp = parcelRequire("ctaJp");
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Converts an AST into a string, using one set of reasonable
 * formatting rules.
 */ function $206ec4cfbffd163d$var$print(ast) {
    return (0, $ctaJp.visit)(ast, {
        leave: $206ec4cfbffd163d$var$printDocASTReducer
    });
}
var $206ec4cfbffd163d$var$printDocASTReducer = {
    Name: function Name(node) {
        return node.value;
    },
    Variable: function Variable(node) {
        return '$' + node.name;
    },
    // Document
    Document: function Document(node) {
        return $206ec4cfbffd163d$var$join(node.definitions, '\n\n') + '\n';
    },
    OperationDefinition: function OperationDefinition(node) {
        var op = node.operation;
        var name = node.name;
        var varDefs = $206ec4cfbffd163d$var$wrap('(', $206ec4cfbffd163d$var$join(node.variableDefinitions, ', '), ')');
        var directives = $206ec4cfbffd163d$var$join(node.directives, ' ');
        var selectionSet = node.selectionSet; // Anonymous queries with no directives or variable definitions can use
        // the query short form.
        return !name && !directives && !varDefs && op === 'query' ? selectionSet : $206ec4cfbffd163d$var$join([
            op,
            $206ec4cfbffd163d$var$join([
                name,
                varDefs
            ]),
            directives,
            selectionSet
        ], ' ');
    },
    VariableDefinition: function VariableDefinition(_ref) {
        var variable = _ref.variable, type = _ref.type, defaultValue = _ref.defaultValue, directives = _ref.directives;
        return variable + ': ' + type + $206ec4cfbffd163d$var$wrap(' = ', defaultValue) + $206ec4cfbffd163d$var$wrap(' ', $206ec4cfbffd163d$var$join(directives, ' '));
    },
    SelectionSet: function SelectionSet(_ref2) {
        var selections = _ref2.selections;
        return $206ec4cfbffd163d$var$block(selections);
    },
    Field: function Field(_ref3) {
        var alias = _ref3.alias, name = _ref3.name, args = _ref3.arguments, directives = _ref3.directives, selectionSet = _ref3.selectionSet;
        return $206ec4cfbffd163d$var$join([
            $206ec4cfbffd163d$var$wrap('', alias, ': ') + name + $206ec4cfbffd163d$var$wrap('(', $206ec4cfbffd163d$var$join(args, ', '), ')'),
            $206ec4cfbffd163d$var$join(directives, ' '),
            selectionSet
        ], ' ');
    },
    Argument: function Argument(_ref4) {
        var name = _ref4.name, value = _ref4.value;
        return name + ': ' + value;
    },
    // Fragments
    FragmentSpread: function FragmentSpread(_ref5) {
        var name = _ref5.name, directives = _ref5.directives;
        return '...' + name + $206ec4cfbffd163d$var$wrap(' ', $206ec4cfbffd163d$var$join(directives, ' '));
    },
    InlineFragment: function InlineFragment(_ref6) {
        var typeCondition = _ref6.typeCondition, directives = _ref6.directives, selectionSet = _ref6.selectionSet;
        return $206ec4cfbffd163d$var$join([
            '...',
            $206ec4cfbffd163d$var$wrap('on ', typeCondition),
            $206ec4cfbffd163d$var$join(directives, ' '),
            selectionSet
        ], ' ');
    },
    FragmentDefinition: function FragmentDefinition(_ref7) {
        var name = _ref7.name, typeCondition = _ref7.typeCondition, variableDefinitions = _ref7.variableDefinitions, directives = _ref7.directives, selectionSet = _ref7.selectionSet;
        return(// or removed in the future.
        "fragment ".concat(name).concat($206ec4cfbffd163d$var$wrap('(', $206ec4cfbffd163d$var$join(variableDefinitions, ', '), ')'), " ") + "on ".concat(typeCondition, " ").concat($206ec4cfbffd163d$var$wrap('', $206ec4cfbffd163d$var$join(directives, ' '), ' ')) + selectionSet);
    },
    // Value
    IntValue: function IntValue(_ref8) {
        var value = _ref8.value;
        return value;
    },
    FloatValue: function FloatValue(_ref9) {
        var value = _ref9.value;
        return value;
    },
    StringValue: function StringValue(_ref10, key) {
        var value = _ref10.value, isBlockString = _ref10.block;
        return isBlockString ? $206ec4cfbffd163d$var$printBlockString(value, key === 'description') : JSON.stringify(value);
    },
    BooleanValue: function BooleanValue(_ref11) {
        var value = _ref11.value;
        return value ? 'true' : 'false';
    },
    NullValue: function NullValue() {
        return 'null';
    },
    EnumValue: function EnumValue(_ref12) {
        var value = _ref12.value;
        return value;
    },
    ListValue: function ListValue(_ref13) {
        var values = _ref13.values;
        return '[' + $206ec4cfbffd163d$var$join(values, ', ') + ']';
    },
    ObjectValue: function ObjectValue(_ref14) {
        var fields = _ref14.fields;
        return '{' + $206ec4cfbffd163d$var$join(fields, ', ') + '}';
    },
    ObjectField: function ObjectField(_ref15) {
        var name = _ref15.name, value = _ref15.value;
        return name + ': ' + value;
    },
    // Directive
    Directive: function Directive(_ref16) {
        var name = _ref16.name, args = _ref16.arguments;
        return '@' + name + $206ec4cfbffd163d$var$wrap('(', $206ec4cfbffd163d$var$join(args, ', '), ')');
    },
    // Type
    NamedType: function NamedType(_ref17) {
        var name = _ref17.name;
        return name;
    },
    ListType: function ListType(_ref18) {
        var type = _ref18.type;
        return '[' + type + ']';
    },
    NonNullType: function NonNullType(_ref19) {
        var type = _ref19.type;
        return type + '!';
    },
    // Type System Definitions
    SchemaDefinition: function SchemaDefinition(_ref20) {
        var directives = _ref20.directives, operationTypes = _ref20.operationTypes;
        return $206ec4cfbffd163d$var$join([
            'schema',
            $206ec4cfbffd163d$var$join(directives, ' '),
            $206ec4cfbffd163d$var$block(operationTypes)
        ], ' ');
    },
    OperationTypeDefinition: function OperationTypeDefinition(_ref21) {
        var operation = _ref21.operation, type = _ref21.type;
        return operation + ': ' + type;
    },
    ScalarTypeDefinition: $206ec4cfbffd163d$var$addDescription(function(_ref22) {
        var name = _ref22.name, directives = _ref22.directives;
        return $206ec4cfbffd163d$var$join([
            'scalar',
            name,
            $206ec4cfbffd163d$var$join(directives, ' ')
        ], ' ');
    }),
    ObjectTypeDefinition: $206ec4cfbffd163d$var$addDescription(function(_ref23) {
        var name = _ref23.name, interfaces = _ref23.interfaces, directives = _ref23.directives, fields = _ref23.fields;
        return $206ec4cfbffd163d$var$join([
            'type',
            name,
            $206ec4cfbffd163d$var$wrap('implements ', $206ec4cfbffd163d$var$join(interfaces, ' & ')),
            $206ec4cfbffd163d$var$join(directives, ' '),
            $206ec4cfbffd163d$var$block(fields)
        ], ' ');
    }),
    FieldDefinition: $206ec4cfbffd163d$var$addDescription(function(_ref24) {
        var name = _ref24.name, args = _ref24.arguments, type = _ref24.type, directives = _ref24.directives;
        return name + (args.every(function(arg) {
            return arg.indexOf('\n') === -1;
        }) ? $206ec4cfbffd163d$var$wrap('(', $206ec4cfbffd163d$var$join(args, ', '), ')') : $206ec4cfbffd163d$var$wrap('(\n', $206ec4cfbffd163d$var$indent($206ec4cfbffd163d$var$join(args, '\n')), '\n)')) + ': ' + type + $206ec4cfbffd163d$var$wrap(' ', $206ec4cfbffd163d$var$join(directives, ' '));
    }),
    InputValueDefinition: $206ec4cfbffd163d$var$addDescription(function(_ref25) {
        var name = _ref25.name, type = _ref25.type, defaultValue = _ref25.defaultValue, directives = _ref25.directives;
        return $206ec4cfbffd163d$var$join([
            name + ': ' + type,
            $206ec4cfbffd163d$var$wrap('= ', defaultValue),
            $206ec4cfbffd163d$var$join(directives, ' ')
        ], ' ');
    }),
    InterfaceTypeDefinition: $206ec4cfbffd163d$var$addDescription(function(_ref26) {
        var name = _ref26.name, directives = _ref26.directives, fields = _ref26.fields;
        return $206ec4cfbffd163d$var$join([
            'interface',
            name,
            $206ec4cfbffd163d$var$join(directives, ' '),
            $206ec4cfbffd163d$var$block(fields)
        ], ' ');
    }),
    UnionTypeDefinition: $206ec4cfbffd163d$var$addDescription(function(_ref27) {
        var name = _ref27.name, directives = _ref27.directives, types = _ref27.types;
        return $206ec4cfbffd163d$var$join([
            'union',
            name,
            $206ec4cfbffd163d$var$join(directives, ' '),
            types && types.length !== 0 ? '= ' + $206ec4cfbffd163d$var$join(types, ' | ') : ''
        ], ' ');
    }),
    EnumTypeDefinition: $206ec4cfbffd163d$var$addDescription(function(_ref28) {
        var name = _ref28.name, directives = _ref28.directives, values = _ref28.values;
        return $206ec4cfbffd163d$var$join([
            'enum',
            name,
            $206ec4cfbffd163d$var$join(directives, ' '),
            $206ec4cfbffd163d$var$block(values)
        ], ' ');
    }),
    EnumValueDefinition: $206ec4cfbffd163d$var$addDescription(function(_ref29) {
        var name = _ref29.name, directives = _ref29.directives;
        return $206ec4cfbffd163d$var$join([
            name,
            $206ec4cfbffd163d$var$join(directives, ' ')
        ], ' ');
    }),
    InputObjectTypeDefinition: $206ec4cfbffd163d$var$addDescription(function(_ref30) {
        var name = _ref30.name, directives = _ref30.directives, fields = _ref30.fields;
        return $206ec4cfbffd163d$var$join([
            'input',
            name,
            $206ec4cfbffd163d$var$join(directives, ' '),
            $206ec4cfbffd163d$var$block(fields)
        ], ' ');
    }),
    DirectiveDefinition: $206ec4cfbffd163d$var$addDescription(function(_ref31) {
        var name = _ref31.name, args = _ref31.arguments, locations = _ref31.locations;
        return 'directive @' + name + (args.every(function(arg) {
            return arg.indexOf('\n') === -1;
        }) ? $206ec4cfbffd163d$var$wrap('(', $206ec4cfbffd163d$var$join(args, ', '), ')') : $206ec4cfbffd163d$var$wrap('(\n', $206ec4cfbffd163d$var$indent($206ec4cfbffd163d$var$join(args, '\n')), '\n)')) + ' on ' + $206ec4cfbffd163d$var$join(locations, ' | ');
    }),
    SchemaExtension: function SchemaExtension(_ref32) {
        var directives = _ref32.directives, operationTypes = _ref32.operationTypes;
        return $206ec4cfbffd163d$var$join([
            'extend schema',
            $206ec4cfbffd163d$var$join(directives, ' '),
            $206ec4cfbffd163d$var$block(operationTypes)
        ], ' ');
    },
    ScalarTypeExtension: function ScalarTypeExtension(_ref33) {
        var name = _ref33.name, directives = _ref33.directives;
        return $206ec4cfbffd163d$var$join([
            'extend scalar',
            name,
            $206ec4cfbffd163d$var$join(directives, ' ')
        ], ' ');
    },
    ObjectTypeExtension: function ObjectTypeExtension(_ref34) {
        var name = _ref34.name, interfaces = _ref34.interfaces, directives = _ref34.directives, fields = _ref34.fields;
        return $206ec4cfbffd163d$var$join([
            'extend type',
            name,
            $206ec4cfbffd163d$var$wrap('implements ', $206ec4cfbffd163d$var$join(interfaces, ' & ')),
            $206ec4cfbffd163d$var$join(directives, ' '),
            $206ec4cfbffd163d$var$block(fields)
        ], ' ');
    },
    InterfaceTypeExtension: function InterfaceTypeExtension(_ref35) {
        var name = _ref35.name, directives = _ref35.directives, fields = _ref35.fields;
        return $206ec4cfbffd163d$var$join([
            'extend interface',
            name,
            $206ec4cfbffd163d$var$join(directives, ' '),
            $206ec4cfbffd163d$var$block(fields)
        ], ' ');
    },
    UnionTypeExtension: function UnionTypeExtension(_ref36) {
        var name = _ref36.name, directives = _ref36.directives, types = _ref36.types;
        return $206ec4cfbffd163d$var$join([
            'extend union',
            name,
            $206ec4cfbffd163d$var$join(directives, ' '),
            types && types.length !== 0 ? '= ' + $206ec4cfbffd163d$var$join(types, ' | ') : ''
        ], ' ');
    },
    EnumTypeExtension: function EnumTypeExtension(_ref37) {
        var name = _ref37.name, directives = _ref37.directives, values = _ref37.values;
        return $206ec4cfbffd163d$var$join([
            'extend enum',
            name,
            $206ec4cfbffd163d$var$join(directives, ' '),
            $206ec4cfbffd163d$var$block(values)
        ], ' ');
    },
    InputObjectTypeExtension: function InputObjectTypeExtension(_ref38) {
        var name = _ref38.name, directives = _ref38.directives, fields = _ref38.fields;
        return $206ec4cfbffd163d$var$join([
            'extend input',
            name,
            $206ec4cfbffd163d$var$join(directives, ' '),
            $206ec4cfbffd163d$var$block(fields)
        ], ' ');
    }
};
function $206ec4cfbffd163d$var$addDescription(cb) {
    return function(node) {
        return $206ec4cfbffd163d$var$join([
            node.description,
            cb(node)
        ], '\n');
    };
}
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */ function $206ec4cfbffd163d$var$join(maybeArray, separator) {
    return maybeArray ? maybeArray.filter(function(x) {
        return x;
    }).join(separator || '') : '';
}
/**
 * Given array, print each item on its own line, wrapped in an
 * indented "{ }" block.
 */ function $206ec4cfbffd163d$var$block(array) {
    return array && array.length !== 0 ? '{\n' + $206ec4cfbffd163d$var$indent($206ec4cfbffd163d$var$join(array, '\n')) + '\n}' : '';
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise
 * print an empty string.
 */ function $206ec4cfbffd163d$var$wrap(start, maybeString, end) {
    return maybeString ? start + maybeString + (end || '') : '';
}
function $206ec4cfbffd163d$var$indent(maybeString) {
    return maybeString && '  ' + maybeString.replace(/\n/g, '\n  ');
}
/**
 * Print a block string in the indented block form by adding a leading and
 * trailing blank line. However, if a block string starts with whitespace and is
 * a single-line, adding a leading blank line would strip that whitespace.
 */ function $206ec4cfbffd163d$var$printBlockString(value, isDescription) {
    var escaped = value.replace(/"""/g, '\\"""');
    return (value[0] === ' ' || value[0] === '\t') && value.indexOf('\n') === -1 ? "\"\"\"".concat(escaped.replace(/"$/, '"\n'), "\"\"\"") : "\"\"\"\n".concat(isDescription ? escaped : $206ec4cfbffd163d$var$indent(escaped), "\n\"\"\"");
}

});
parcelRegister("ctaJp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.visit = $9140848489ee4417$var$visit;
module.exports.visitInParallel = $9140848489ee4417$var$visitInParallel;
module.exports.visitWithTypeInfo = $9140848489ee4417$var$visitWithTypeInfo;
module.exports.getVisitFn = $9140848489ee4417$var$getVisitFn;
module.exports.BREAK = module.exports.QueryDocumentKeys = void 0;
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */ /**
 * A visitor is provided to visit, it contains the collection of
 * relevant functions to be called during the visitor's traversal.
 */ /**
 * A visitor is comprised of visit functions, which are called on each node
 * during the visitor's traversal.
 */ /**
 * A KeyMap describes each the traversable properties of each kind of node.
 */ var $9140848489ee4417$var$QueryDocumentKeys = {
    Name: [],
    Document: [
        'definitions'
    ],
    OperationDefinition: [
        'name',
        'variableDefinitions',
        'directives',
        'selectionSet'
    ],
    VariableDefinition: [
        'variable',
        'type',
        'defaultValue',
        'directives'
    ],
    Variable: [
        'name'
    ],
    SelectionSet: [
        'selections'
    ],
    Field: [
        'alias',
        'name',
        'arguments',
        'directives',
        'selectionSet'
    ],
    Argument: [
        'name',
        'value'
    ],
    FragmentSpread: [
        'name',
        'directives'
    ],
    InlineFragment: [
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    FragmentDefinition: [
        'name',
        // or removed in the future.
        'variableDefinitions',
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        'values'
    ],
    ObjectValue: [
        'fields'
    ],
    ObjectField: [
        'name',
        'value'
    ],
    Directive: [
        'name',
        'arguments'
    ],
    NamedType: [
        'name'
    ],
    ListType: [
        'type'
    ],
    NonNullType: [
        'type'
    ],
    SchemaDefinition: [
        'directives',
        'operationTypes'
    ],
    OperationTypeDefinition: [
        'type'
    ],
    ScalarTypeDefinition: [
        'description',
        'name',
        'directives'
    ],
    ObjectTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    FieldDefinition: [
        'description',
        'name',
        'arguments',
        'type',
        'directives'
    ],
    InputValueDefinition: [
        'description',
        'name',
        'type',
        'defaultValue',
        'directives'
    ],
    InterfaceTypeDefinition: [
        'description',
        'name',
        'directives',
        'fields'
    ],
    UnionTypeDefinition: [
        'description',
        'name',
        'directives',
        'types'
    ],
    EnumTypeDefinition: [
        'description',
        'name',
        'directives',
        'values'
    ],
    EnumValueDefinition: [
        'description',
        'name',
        'directives'
    ],
    InputObjectTypeDefinition: [
        'description',
        'name',
        'directives',
        'fields'
    ],
    DirectiveDefinition: [
        'description',
        'name',
        'arguments',
        'locations'
    ],
    SchemaExtension: [
        'directives',
        'operationTypes'
    ],
    ScalarTypeExtension: [
        'name',
        'directives'
    ],
    ObjectTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    InterfaceTypeExtension: [
        'name',
        'directives',
        'fields'
    ],
    UnionTypeExtension: [
        'name',
        'directives',
        'types'
    ],
    EnumTypeExtension: [
        'name',
        'directives',
        'values'
    ],
    InputObjectTypeExtension: [
        'name',
        'directives',
        'fields'
    ]
};
module.exports.QueryDocumentKeys = $9140848489ee4417$var$QueryDocumentKeys;
var $9140848489ee4417$var$BREAK = {};
/**
 * visit() will walk through an AST using a depth first traversal, calling
 * the visitor's enter function at each node in the traversal, and calling the
 * leave function after visiting that node and all of its child nodes.
 *
 * By returning different values from the enter and leave functions, the
 * behavior of the visitor can be altered, including skipping over a sub-tree of
 * the AST (by returning false), editing the AST by returning a value or null
 * to remove the value, or to stop the whole traversal by returning BREAK.
 *
 * When using visit() to edit an AST, the original AST will not be modified, and
 * a new version of the AST with the changes applied will be returned from the
 * visit function.
 *
 *     const editedAST = visit(ast, {
 *       enter(node, key, parent, path, ancestors) {
 *         // @return
 *         //   undefined: no action
 *         //   false: skip visiting this node
 *         //   visitor.BREAK: stop visiting altogether
 *         //   null: delete this node
 *         //   any value: replace this node with the returned value
 *       },
 *       leave(node, key, parent, path, ancestors) {
 *         // @return
 *         //   undefined: no action
 *         //   false: no action
 *         //   visitor.BREAK: stop visiting altogether
 *         //   null: delete this node
 *         //   any value: replace this node with the returned value
 *       }
 *     });
 *
 * Alternatively to providing enter() and leave() functions, a visitor can
 * instead provide functions named the same as the kinds of AST nodes, or
 * enter/leave visitors at a named key, leading to four permutations of
 * visitor API:
 *
 * 1) Named visitors triggered when entering a node a specific kind.
 *
 *     visit(ast, {
 *       Kind(node) {
 *         // enter the "Kind" node
 *       }
 *     })
 *
 * 2) Named visitors that trigger upon entering and leaving a node of
 *    a specific kind.
 *
 *     visit(ast, {
 *       Kind: {
 *         enter(node) {
 *           // enter the "Kind" node
 *         }
 *         leave(node) {
 *           // leave the "Kind" node
 *         }
 *       }
 *     })
 *
 * 3) Generic visitors that trigger upon entering and leaving any node.
 *
 *     visit(ast, {
 *       enter(node) {
 *         // enter any node
 *       },
 *       leave(node) {
 *         // leave any node
 *       }
 *     })
 *
 * 4) Parallel visitors for entering and leaving nodes of a specific kind.
 *
 *     visit(ast, {
 *       enter: {
 *         Kind(node) {
 *           // enter the "Kind" node
 *         }
 *       },
 *       leave: {
 *         Kind(node) {
 *           // leave the "Kind" node
 *         }
 *       }
 *     })
 */ module.exports.BREAK = $9140848489ee4417$var$BREAK;
function $9140848489ee4417$var$visit(root, visitor) {
    var visitorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $9140848489ee4417$var$QueryDocumentKeys;
    /* eslint-disable no-undef-init */ var stack = undefined;
    var inArray = Array.isArray(root);
    var keys = [
        root
    ];
    var index = -1;
    var edits = [];
    var node = undefined;
    var key = undefined;
    var parent = undefined;
    var path = [];
    var ancestors = [];
    var newRoot = root;
    /* eslint-enable no-undef-init */ do {
        index++;
        var isLeaving = index === keys.length;
        var isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) node = node.slice();
                else {
                    var clone = {};
                    for(var k in node)if (node.hasOwnProperty(k)) clone[k] = node[k];
                    node = clone;
                }
                var editOffset = 0;
                for(var ii = 0; ii < edits.length; ii++){
                    var editKey = edits[ii][0];
                    var editValue = edits[ii][1];
                    if (inArray) editKey -= editOffset;
                    if (inArray && editValue === null) {
                        node.splice(editKey, 1);
                        editOffset++;
                    } else node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else {
            key = parent ? inArray ? index : keys[index] : undefined;
            node = parent ? parent[key] : newRoot;
            if (node === null || node === undefined) continue;
            if (parent) path.push(key);
        }
        var result = void 0;
        if (!Array.isArray(node)) {
            if (!$9140848489ee4417$var$isNode(node)) throw new Error('Invalid AST Node: ' + JSON.stringify(node));
            var visitFn = $9140848489ee4417$var$getVisitFn(visitor, node.kind, isLeaving);
            if (visitFn) {
                result = visitFn.call(visitor, node, key, parent, path, ancestors);
                if (result === $9140848489ee4417$var$BREAK) break;
                if (result === false) {
                    if (!isLeaving) {
                        path.pop();
                        continue;
                    }
                } else if (result !== undefined) {
                    edits.push([
                        key,
                        result
                    ]);
                    if (!isLeaving) {
                        if ($9140848489ee4417$var$isNode(result)) node = result;
                        else {
                            path.pop();
                            continue;
                        }
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : visitorKeys[node.kind] || [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) newRoot = edits[edits.length - 1][1];
    return newRoot;
}
function $9140848489ee4417$var$isNode(maybeNode) {
    return Boolean(maybeNode && typeof maybeNode.kind === 'string');
}
/**
 * Creates a new visitor instance which delegates to many visitors to run in
 * parallel. Each visitor will be visited for each node before moving on.
 *
 * If a prior visitor edits a node, no following visitors will see that node.
 */ function $9140848489ee4417$var$visitInParallel(visitors) {
    var skipping = new Array(visitors.length);
    return {
        enter: function enter(node) {
            for(var i = 0; i < visitors.length; i++)if (!skipping[i]) {
                var fn = $9140848489ee4417$var$getVisitFn(visitors[i], node.kind, /* isLeaving */ false);
                if (fn) {
                    var result = fn.apply(visitors[i], arguments);
                    if (result === false) skipping[i] = node;
                    else if (result === $9140848489ee4417$var$BREAK) skipping[i] = $9140848489ee4417$var$BREAK;
                    else if (result !== undefined) return result;
                }
            }
        },
        leave: function leave(node) {
            for(var i = 0; i < visitors.length; i++){
                if (!skipping[i]) {
                    var fn = $9140848489ee4417$var$getVisitFn(visitors[i], node.kind, /* isLeaving */ true);
                    if (fn) {
                        var result = fn.apply(visitors[i], arguments);
                        if (result === $9140848489ee4417$var$BREAK) skipping[i] = $9140848489ee4417$var$BREAK;
                        else if (result !== undefined && result !== false) return result;
                    }
                } else if (skipping[i] === node) skipping[i] = null;
            }
        }
    };
}
/**
 * Creates a new visitor instance which maintains a provided TypeInfo instance
 * along with visiting visitor.
 */ function $9140848489ee4417$var$visitWithTypeInfo(typeInfo, visitor) {
    return {
        enter: function enter(node) {
            typeInfo.enter(node);
            var fn = $9140848489ee4417$var$getVisitFn(visitor, node.kind, /* isLeaving */ false);
            if (fn) {
                var result = fn.apply(visitor, arguments);
                if (result !== undefined) {
                    typeInfo.leave(node);
                    if ($9140848489ee4417$var$isNode(result)) typeInfo.enter(result);
                }
                return result;
            }
        },
        leave: function leave(node) {
            var fn = $9140848489ee4417$var$getVisitFn(visitor, node.kind, /* isLeaving */ true);
            var result;
            if (fn) result = fn.apply(visitor, arguments);
            typeInfo.leave(node);
            return result;
        }
    };
}
/**
 * Given a visitor instance, if it is leaving or not, and a node kind, return
 * the function the visitor runtime should call.
 */ function $9140848489ee4417$var$getVisitFn(visitor, kind, isLeaving) {
    var kindVisitor = visitor[kind];
    if (kindVisitor) {
        if (!isLeaving && typeof kindVisitor === 'function') // { Kind() {} }
        return kindVisitor;
        var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;
        if (typeof kindSpecificVisitor === 'function') // { Kind: { enter() {}, leave() {} } }
        return kindSpecificVisitor;
    } else {
        var specificVisitor = isLeaving ? visitor.leave : visitor.enter;
        if (specificVisitor) {
            if (typeof specificVisitor === 'function') // { enter() {}, leave() {} }
            return specificVisitor;
            var specificKindVisitor = specificVisitor[kind];
            if (typeof specificKindVisitor === 'function') // { enter: { Kind() {} }, leave: { Kind() {} } }
            return specificKindVisitor;
        }
    }
}

});


parcelRegister("8DzV8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parse = $649dd453bc440c43$var$parse;
module.exports.parseValue = $649dd453bc440c43$var$parseValue;
module.exports.parseType = $649dd453bc440c43$var$parseType;
module.exports.parseConstValue = $649dd453bc440c43$var$parseConstValue;
module.exports.parseTypeReference = $649dd453bc440c43$var$parseTypeReference;
module.exports.parseNamedType = $649dd453bc440c43$var$parseNamedType;

var $649dd453bc440c43$var$_inspect = $649dd453bc440c43$var$_interopRequireDefault((parcelRequire("l8ejJ")));

var $jtA0P = parcelRequire("jtA0P");

var $iOpAS = parcelRequire("iOpAS");

var $4rUvP = parcelRequire("4rUvP");

var $27ePX = parcelRequire("27ePX");

var $bKKxQ = parcelRequire("bKKxQ");
function $649dd453bc440c43$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */ /**
 * Given a GraphQL source, parses it into a Document.
 * Throws GraphQLError if a syntax error is encountered.
 */ function $649dd453bc440c43$var$parse(source, options) {
    var sourceObj = typeof source === 'string' ? new $jtA0P.Source(source) : source;
    if (!(sourceObj instanceof $jtA0P.Source)) throw new TypeError("Must provide Source. Received: ".concat((0, $649dd453bc440c43$var$_inspect.default)(sourceObj)));
    var lexer = (0, $4rUvP.createLexer)(sourceObj, options || {});
    return $649dd453bc440c43$var$parseDocument(lexer);
}
/**
 * Given a string containing a GraphQL value (ex. `[42]`), parse the AST for
 * that value.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Values directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: valueFromAST().
 */ function $649dd453bc440c43$var$parseValue(source, options) {
    var sourceObj = typeof source === 'string' ? new $jtA0P.Source(source) : source;
    var lexer = (0, $4rUvP.createLexer)(sourceObj, options || {});
    $649dd453bc440c43$var$expect(lexer, $4rUvP.TokenKind.SOF);
    var value = $649dd453bc440c43$var$parseValueLiteral(lexer, false);
    $649dd453bc440c43$var$expect(lexer, $4rUvP.TokenKind.EOF);
    return value;
}
/**
 * Given a string containing a GraphQL Type (ex. `[Int!]`), parse the AST for
 * that type.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Types directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: typeFromAST().
 */ function $649dd453bc440c43$var$parseType(source, options) {
    var sourceObj = typeof source === 'string' ? new $jtA0P.Source(source) : source;
    var lexer = (0, $4rUvP.createLexer)(sourceObj, options || {});
    $649dd453bc440c43$var$expect(lexer, $4rUvP.TokenKind.SOF);
    var type = $649dd453bc440c43$var$parseTypeReference(lexer);
    $649dd453bc440c43$var$expect(lexer, $4rUvP.TokenKind.EOF);
    return type;
}
/**
 * Converts a name lex token into a name parse node.
 */ function $649dd453bc440c43$var$parseName(lexer) {
    var token = $649dd453bc440c43$var$expect(lexer, $4rUvP.TokenKind.NAME);
    return {
        kind: $27ePX.Kind.NAME,
        value: token.value,
        loc: $649dd453bc440c43$var$loc(lexer, token)
    };
} // Implements the parsing rules in the Document section.
/**
 * Document : Definition+
 */ function $649dd453bc440c43$var$parseDocument(lexer) {
    var start = lexer.token;
    return {
        kind: $27ePX.Kind.DOCUMENT,
        definitions: $649dd453bc440c43$var$many(lexer, $4rUvP.TokenKind.SOF, $649dd453bc440c43$var$parseDefinition, $4rUvP.TokenKind.EOF),
        loc: $649dd453bc440c43$var$loc(lexer, start)
    };
}
/**
 * Definition :
 *   - ExecutableDefinition
 *   - TypeSystemDefinition
 *   - TypeSystemExtension
 */ function $649dd453bc440c43$var$parseDefinition(lexer) {
    if ($649dd453bc440c43$var$peek(lexer, $4rUvP.TokenKind.NAME)) switch(lexer.token.value){
        case 'query':
        case 'mutation':
        case 'subscription':
        case 'fragment':
            return $649dd453bc440c43$var$parseExecutableDefinition(lexer);
        case 'schema':
        case 'scalar':
        case 'type':
        case 'interface':
        case 'union':
        case 'enum':
        case 'input':
        case 'directive':
            return $649dd453bc440c43$var$parseTypeSystemDefinition(lexer);
        case 'extend':
            return $649dd453bc440c43$var$parseTypeSystemExtension(lexer);
    }
    else if ($649dd453bc440c43$var$peek(lexer, $4rUvP.TokenKind.BRACE_L)) return $649dd453bc440c43$var$parseExecutableDefinition(lexer);
    else if ($649dd453bc440c43$var$peekDescription(lexer)) return $649dd453bc440c43$var$parseTypeSystemDefinition(lexer);
    throw $649dd453bc440c43$var$unexpected(lexer);
}
/**
 * ExecutableDefinition :
 *   - OperationDefinition
 *   - FragmentDefinition
 */ function $649dd453bc440c43$var$parseExecutableDefinition(lexer) {
    if ($649dd453bc440c43$var$peek(lexer, $4rUvP.TokenKind.NAME)) switch(lexer.token.value){
        case 'query':
        case 'mutation':
        case 'subscription':
            return $649dd453bc440c43$var$parseOperationDefinition(lexer);
        case 'fragment':
            return $649dd453bc440c43$var$parseFragmentDefinition(lexer);
    }
    else if ($649dd453bc440c43$var$peek(lexer, $4rUvP.TokenKind.BRACE_L)) return $649dd453bc440c43$var$parseOperationDefinition(lexer);
    throw $649dd453bc440c43$var$unexpected(lexer);
} // Implements the parsing rules in the Operations section.
/**
 * OperationDefinition :
 *  - SelectionSet
 *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
 */ function $649dd453bc440c43$var$parseOperationDefinition(lexer) {
    var start = lexer.token;
    if ($649dd453bc440c43$var$peek(lexer, $4rUvP.TokenKind.BRACE_L)) return {
        kind: $27ePX.Kind.OPERATION_DEFINITION,
        operation: 'query',
        name: undefined,
        variableDefinitions: [],
        directives: [],
        selectionSet: $649dd453bc440c43$var$parseSelectionSet(lexer),
        loc: $649dd453bc440c43$var$loc(lexer, start)
    };
    var operation = $649dd453bc440c43$var$parseOperationType(lexer);
    var name;
    if ($649dd453bc440c43$var$peek(lexer, $4rUvP.TokenKind.NAME)) name = $649dd453bc440c43$var$parseName(lexer);
    return {
        kind: $27ePX.Kind.OPERATION_DEFINITION,
        operation: operation,
        name: name,
        variableDefinitions: $649dd453bc440c43$var$parseVariableDefinitions(lexer),
        directives: $649dd453bc440c43$var$parseDirectives(lexer, false),
        selectionSet: $649dd453bc440c43$var$parseSelectionSet(lexer),
        loc: $649dd453bc440c43$var$loc(lexer, start)
    };
}
/**
 * OperationType : one of query mutation subscription
 */ function $649dd453bc440c43$var$parseOperationType(lexer) {
    var operationToken = $649dd453bc440c43$var$expect(lexer, $4rUvP.TokenKind.NAME);
    switch(operationToken.value){
        case 'query':
            return 'query';
        case 'mutation':
            return 'mutation';
        case 'subscription':
            return 'subscription';
    }
    throw $649dd453bc440c43$var$unexpected(lexer, operationToken);
}
/**
 * VariableDefinitions : ( VariableDefinition+ )
 */ function $649dd453bc440c43$var$parseVariableDefinitions(lexer) {
    return $649dd453bc440c43$var$peek(lexer, $4rUvP.TokenKind.PAREN_L) ? $649dd453bc440c43$var$many(lexer, $4rUvP.TokenKind.PAREN_L, $649dd453bc440c43$var$parseVariableDefinition, $4rUvP.TokenKind.PAREN_R) : [];
}
/**
 * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
 */ function $649dd453bc440c43$var$parseVariableDefinition(lexer) {
    var start = lexer.token;
    if (lexer.options.experimentalVariableDefinitionDirectives) return {
        kind: $27ePX.Kind.VARIABLE_DEFINITION,
        variable: $649dd453bc440c43$var$parseVariable(lexer),
        type: ($649dd453bc440c43$var$expect(lexer, $4rUvP.TokenKind.COLON), $649dd453bc440c43$var$parseTypeReference(lexer)),
        defaultValue: $649dd453bc440c43$var$skip(lexer, $4rUvP.TokenKind.EQUALS) ? $649dd453bc440c43$var$parseValueLiteral(lexer, true) : undefined,
        directives: $649dd453bc440c43$var$parseDirectives(lexer, true),
        loc: $649dd453bc440c43$var$loc(lexer, start)
    };
    return {
        kind: $27ePX.Kind.VARIABLE_DEFINITION,
        variable: $649dd453bc440c43$var$parseVariable(lexer),
        type: ($649dd453bc440c43$var$expect(lexer, $4rUvP.TokenKind.COLON), $649dd453bc440c43$var$parseTypeReference(lexer)),
        defaultValue: $649dd453bc440c43$var$skip(lexer, $4rUvP.TokenKind.EQUALS) ? $649dd453bc440c43$var$parseValueLiteral(lexer, true) : undefined,
        loc: $649dd453bc440c43$var$loc(lexer, start)
    };
}
/**
 * Variable : $ Name
 */ function $649dd453bc440c43$var$parseVariable(lexer) {
    var start = lexer.token;
    $649dd453bc440c43$var$expect(lexer, $4rUvP.TokenKind.DOLLAR);
    return {
        kind: $27ePX.Kind.VARIABLE,
        name: $649dd453bc440c43$var$parseName(lexer),
        loc: $649dd453bc440c43$var$loc(lexer, start)
    };
}
/**
 * SelectionSet : { Selection+ }
 */ function $649dd453bc440c43$var$parseSelectionSet(lexer) {
    var start = lexer.token;
    return {
        kind: $27ePX.Kind.SELECTION_SET,
        selections: $649dd453bc440c43$var$many(lexer, $4rUvP.TokenKind.BRACE_L, $649dd453bc440c43$var$parseSelection, $4rUvP.TokenKind.BRACE_R),
        loc: $649dd453bc440c43$var$loc(lexer, start)
    };
}
/**
 * Selection :
 *   - Field
 *   - FragmentSpread
 *   - InlineFragment
 */ function $649dd453bc440c43$var$parseSelection(lexer) {
    return $649dd453bc440c43$var$peek(lexer, $4rUvP.TokenKind.SPREAD) ? $649dd453bc440c43$var$parseFragment(lexer) : $649dd453bc440c43$var$parseField(lexer);
}
/**
 * Field : Alias? Name Arguments? Directives? SelectionSet?
 *
 * Alias : Name :
 */ function $649dd453bc440c43$var$parseField(lexer) {
    var start = lexer.token;
    var nameOrAlias = $649dd453bc440c43$var$parseName(lexer);
    var alias;
    var name;
    if ($649dd453bc440c43$var$skip(lexer, $4rUvP.TokenKind.COLON)) {
        alias = nameOrAlias;
        name = $649dd453bc440c43$var$parseName(lexer);
    } else name = nameOrAlias;
    return {
        kind: $27ePX.Kind.FIELD,
        alias: alias,
        name: name,
        arguments: $649dd453bc440c43$var$parseArguments(lexer, false),
        directives: $649dd453bc440c43$var$parseDirectives(lexer, false),
        selectionSet: $649dd453bc440c43$var$peek(lexer, $4rUvP.TokenKind.BRACE_L) ? $649dd453bc440c43$var$parseSelectionSet(lexer) : undefined,
        loc: $649dd453bc440c43$var$loc(lexer, start)
    };
}
/**
 * Arguments[Const] : ( Argument[?Const]+ )
 */ function $649dd453bc440c43$var$parseArguments(lexer, isConst) {
    var item = isConst ? $649dd453bc440c43$var$parseConstArgument : $649dd453bc440c43$var$parseArgument;
    return $649dd453bc440c43$var$peek(lexer, $4rUvP.TokenKind.PAREN_L) ? $649dd453bc440c43$var$many(lexer, $4rUvP.TokenKind.PAREN_L, item, $4rUvP.TokenKind.PAREN_R) : [];
}
/**
 * Argument[Const] : Name : Value[?Const]
 */ function $649dd453bc440c43$var$parseArgument(lexer) {
    var start = lexer.token;
    return {
        kind: $27ePX.Kind.ARGUMENT,
        name: $649dd453bc440c43$var$parseName(lexer),
        value: ($649dd453bc440c43$var$expect(lexer, $4rUvP.TokenKind.COLON), $649dd453bc440c43$var$parseValueLiteral(lexer, false)),
        loc: $649dd453bc440c43$var$loc(lexer, start)
    };
}
function $649dd453bc440c43$var$parseConstArgument(lexer) {
    var start = lexer.token;
    return {
        kind: $27ePX.Kind.ARGUMENT,
        name: $649dd453bc440c43$var$parseName(lexer),
        value: ($649dd453bc440c43$var$expect(lexer, $4rUvP.TokenKind.COLON), $649dd453bc440c43$var$parseConstValue(lexer)),
        loc: $649dd453bc440c43$var$loc(lexer, start)
    };
} // Implements the parsing rules in the Fragments section.
/**
 * Corresponds to both FragmentSpread and InlineFragment in the spec.
 *
 * FragmentSpread : ... FragmentName Directives?
 *
 * InlineFragment : ... TypeCondition? Directives? SelectionSet
 */ function $649dd453bc440c43$var$parseFragment(lexer) {
    var start = lexer.token;
    $649dd453bc440c43$var$expect(lexer, $4rUvP.TokenKind.SPREAD);
    if ($649dd453bc440c43$var$peek(lexer, $4rUvP.TokenKind.NAME) && lexer.token.value !== 'on') return {
        kind: $27ePX.Kind.FRAGMENT_SPREAD,
        name: $649dd453bc440c43$var$parseFragmentName(lexer),
        directives: $649dd453bc440c43$var$parseDirectives(lexer, false),
        loc: $649dd453bc440c43$var$loc(lexer, start)
    };
    var typeCondition;
    if (lexer.token.value === 'on') {
        lexer.advance();
        typeCondition = $649dd453bc440c43$var$parseNamedType(lexer);
    }
    return {
        kind: $27ePX.Kind.INLINE_FRAGMENT,
        typeCondition: typeCondition,
        directives: $649dd453bc440c43$var$parseDirectives(lexer, false),
        selectionSet: $649dd453bc440c43$var$parseSelectionSet(lexer),
        loc: $649dd453bc440c43$var$loc(lexer, start)
    };
}
/**
 * FragmentDefinition :
 *   - fragment FragmentName on TypeCondition Directives? SelectionSet
 *
 * TypeCondition : NamedType
 */ function $649dd453bc440c43$var$parseFragmentDefinition(lexer) {
    var start = lexer.token;
    $649dd453bc440c43$var$expectKeyword(lexer, 'fragment'); // Experimental support for defining variables within fragments changes
    // the grammar of FragmentDefinition:
    //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet
    if (lexer.options.experimentalFragmentVariables) return {
        kind: $27ePX.Kind.FRAGMENT_DEFINITION,
        name: $649dd453bc440c43$var$parseFragmentName(lexer),
        variableDefinitions: $649dd453bc440c43$var$parseVariableDefinitions(lexer),
        typeCondition: ($649dd453bc440c43$var$expectKeyword(lexer, 'on'), $649dd453bc440c43$var$parseNamedType(lexer)),
        directives: $649dd453bc440c43$var$parseDirectives(lexer, false),
        selectionSet: $649dd453bc440c43$var$parseSelectionSet(lexer),
        loc: $649dd453bc440c43$var$loc(lexer, start)
    };
    return {
        kind: $27ePX.Kind.FRAGMENT_DEFINITION,
        name: $649dd453bc440c43$var$parseFragmentName(lexer),
        typeCondition: ($649dd453bc440c43$var$expectKeyword(lexer, 'on'), $649dd453bc440c43$var$parseNamedType(lexer)),
        directives: $649dd453bc440c43$var$parseDirectives(lexer, false),
        selectionSet: $649dd453bc440c43$var$parseSelectionSet(lexer),
        loc: $649dd453bc440c43$var$loc(lexer, start)
    };
}
/**
 * FragmentName : Name but not `on`
 */ function $649dd453bc440c43$var$parseFragmentName(lexer) {
    if (lexer.token.value === 'on') throw $649dd453bc440c43$var$unexpected(lexer);
    return $649dd453bc440c43$var$parseName(lexer);
} // Implements the parsing rules in the Values section.
/**
 * Value[Const] :
 *   - [~Const] Variable
 *   - IntValue
 *   - FloatValue
 *   - StringValue
 *   - BooleanValue
 *   - NullValue
 *   - EnumValue
 *   - ListValue[?Const]
 *   - ObjectValue[?Const]
 *
 * BooleanValue : one of `true` `false`
 *
 * NullValue : `null`
 *
 * EnumValue : Name but not `true`, `false` or `null`
 */ function $649dd453bc440c43$var$parseValueLiteral(lexer, isConst) {
    var token = lexer.token;
    switch(token.kind){
        case $4rUvP.TokenKind.BRACKET_L:
            return $649dd453bc440c43$var$parseList(lexer, isConst);
        case $4rUvP.TokenKind.BRACE_L:
            return $649dd453bc440c43$var$parseObject(lexer, isConst);
        case $4rUvP.TokenKind.INT:
            lexer.advance();
            return {
                kind: $27ePX.Kind.INT,
                value: token.value,
                loc: $649dd453bc440c43$var$loc(lexer, token)
            };
        case $4rUvP.TokenKind.FLOAT:
            lexer.advance();
            return {
                kind: $27ePX.Kind.FLOAT,
                value: token.value,
                loc: $649dd453bc440c43$var$loc(lexer, token)
            };
        case $4rUvP.TokenKind.STRING:
        case $4rUvP.TokenKind.BLOCK_STRING:
            return $649dd453bc440c43$var$parseStringLiteral(lexer);
        case $4rUvP.TokenKind.NAME:
            if (token.value === 'true' || token.value === 'false') {
                lexer.advance();
                return {
                    kind: $27ePX.Kind.BOOLEAN,
                    value: token.value === 'true',
                    loc: $649dd453bc440c43$var$loc(lexer, token)
                };
            } else if (token.value === 'null') {
                lexer.advance();
                return {
                    kind: $27ePX.Kind.NULL,
                    loc: $649dd453bc440c43$var$loc(lexer, token)
                };
            }
            lexer.advance();
            return {
                kind: $27ePX.Kind.ENUM,
                value: token.value,
                loc: $649dd453bc440c43$var$loc(lexer, token)
            };
        case $4rUvP.TokenKind.DOLLAR:
            if (!isConst) return $649dd453bc440c43$var$parseVariable(lexer);
            break;
    }
    throw $649dd453bc440c43$var$unexpected(lexer);
}
function $649dd453bc440c43$var$parseStringLiteral(lexer) {
    var token = lexer.token;
    lexer.advance();
    return {
        kind: $27ePX.Kind.STRING,
        value: token.value,
        block: token.kind === $4rUvP.TokenKind.BLOCK_STRING,
        loc: $649dd453bc440c43$var$loc(lexer, token)
    };
}
function $649dd453bc440c43$var$parseConstValue(lexer) {
    return $649dd453bc440c43$var$parseValueLiteral(lexer, true);
}
function $649dd453bc440c43$var$parseValueValue(lexer) {
    return $649dd453bc440c43$var$parseValueLiteral(lexer, false);
}
/**
 * ListValue[Const] :
 *   - [ ]
 *   - [ Value[?Const]+ ]
 */ function $649dd453bc440c43$var$parseList(lexer, isConst) {
    var start = lexer.token;
    var item = isConst ? $649dd453bc440c43$var$parseConstValue : $649dd453bc440c43$var$parseValueValue;
    return {
        kind: $27ePX.Kind.LIST,
        values: $649dd453bc440c43$var$any(lexer, $4rUvP.TokenKind.BRACKET_L, item, $4rUvP.TokenKind.BRACKET_R),
        loc: $649dd453bc440c43$var$loc(lexer, start)
    };
}
/**
 * ObjectValue[Const] :
 *   - { }
 *   - { ObjectField[?Const]+ }
 */ function $649dd453bc440c43$var$parseObject(lexer, isConst) {
    var start = lexer.token;
    $649dd453bc440c43$var$expect(lexer, $4rUvP.TokenKind.BRACE_L);
    var fields = [];
    while(!$649dd453bc440c43$var$skip(lexer, $4rUvP.TokenKind.BRACE_R))fields.push($649dd453bc440c43$var$parseObjectField(lexer, isConst));
    return {
        kind: $27ePX.Kind.OBJECT,
        fields: fields,
        loc: $649dd453bc440c43$var$loc(lexer, start)
    };
}
/**
 * ObjectField[Const] : Name : Value[?Const]
 */ function $649dd453bc440c43$var$parseObjectField(lexer, isConst) {
    var start = lexer.token;
    return {
        kind: $27ePX.Kind.OBJECT_FIELD,
        name: $649dd453bc440c43$var$parseName(lexer),
        value: ($649dd453bc440c43$var$expect(lexer, $4rUvP.TokenKind.COLON), $649dd453bc440c43$var$parseValueLiteral(lexer, isConst)),
        loc: $649dd453bc440c43$var$loc(lexer, start)
    };
} // Implements the parsing rules in the Directives section.
/**
 * Directives[Const] : Directive[?Const]+
 */ function $649dd453bc440c43$var$parseDirectives(lexer, isConst) {
    var directives = [];
    while($649dd453bc440c43$var$peek(lexer, $4rUvP.TokenKind.AT))directives.push($649dd453bc440c43$var$parseDirective(lexer, isConst));
    return directives;
}
/**
 * Directive[Const] : @ Name Arguments[?Const]?
 */ function $649dd453bc440c43$var$parseDirective(lexer, isConst) {
    var start = lexer.token;
    $649dd453bc440c43$var$expect(lexer, $4rUvP.TokenKind.AT);
    return {
        kind: $27ePX.Kind.DIRECTIVE,
        name: $649dd453bc440c43$var$parseName(lexer),
        arguments: $649dd453bc440c43$var$parseArguments(lexer, isConst),
        loc: $649dd453bc440c43$var$loc(lexer, start)
    };
} // Implements the parsing rules in the Types section.
/**
 * Type :
 *   - NamedType
 *   - ListType
 *   - NonNullType
 */ function $649dd453bc440c43$var$parseTypeReference(lexer) {
    var start = lexer.token;
    var type;
    if ($649dd453bc440c43$var$skip(lexer, $4rUvP.TokenKind.BRACKET_L)) {
        type = $649dd453bc440c43$var$parseTypeReference(lexer);
        $649dd453bc440c43$var$expect(lexer, $4rUvP.TokenKind.BRACKET_R);
        type = {
            kind: $27ePX.Kind.LIST_TYPE,
            type: type,
            loc: $649dd453bc440c43$var$loc(lexer, start)
        };
    } else type = $649dd453bc440c43$var$parseNamedType(lexer);
    if ($649dd453bc440c43$var$skip(lexer, $4rUvP.TokenKind.BANG)) return {
        kind: $27ePX.Kind.NON_NULL_TYPE,
        type: type,
        loc: $649dd453bc440c43$var$loc(lexer, start)
    };
    return type;
}
/**
 * NamedType : Name
 */ function $649dd453bc440c43$var$parseNamedType(lexer) {
    var start = lexer.token;
    return {
        kind: $27ePX.Kind.NAMED_TYPE,
        name: $649dd453bc440c43$var$parseName(lexer),
        loc: $649dd453bc440c43$var$loc(lexer, start)
    };
} // Implements the parsing rules in the Type Definition section.
/**
 * TypeSystemDefinition :
 *   - SchemaDefinition
 *   - TypeDefinition
 *   - DirectiveDefinition
 *
 * TypeDefinition :
 *   - ScalarTypeDefinition
 *   - ObjectTypeDefinition
 *   - InterfaceTypeDefinition
 *   - UnionTypeDefinition
 *   - EnumTypeDefinition
 *   - InputObjectTypeDefinition
 */ function $649dd453bc440c43$var$parseTypeSystemDefinition(lexer) {
    // Many definitions begin with a description and require a lookahead.
    var keywordToken = $649dd453bc440c43$var$peekDescription(lexer) ? lexer.lookahead() : lexer.token;
    if (keywordToken.kind === $4rUvP.TokenKind.NAME) switch(keywordToken.value){
        case 'schema':
            return $649dd453bc440c43$var$parseSchemaDefinition(lexer);
        case 'scalar':
            return $649dd453bc440c43$var$parseScalarTypeDefinition(lexer);
        case 'type':
            return $649dd453bc440c43$var$parseObjectTypeDefinition(lexer);
        case 'interface':
            return $649dd453bc440c43$var$parseInterfaceTypeDefinition(lexer);
        case 'union':
            return $649dd453bc440c43$var$parseUnionTypeDefinition(lexer);
        case 'enum':
            return $649dd453bc440c43$var$parseEnumTypeDefinition(lexer);
        case 'input':
            return $649dd453bc440c43$var$parseInputObjectTypeDefinition(lexer);
        case 'directive':
            return $649dd453bc440c43$var$parseDirectiveDefinition(lexer);
    }
    throw $649dd453bc440c43$var$unexpected(lexer, keywordToken);
}
function $649dd453bc440c43$var$peekDescription(lexer) {
    return $649dd453bc440c43$var$peek(lexer, $4rUvP.TokenKind.STRING) || $649dd453bc440c43$var$peek(lexer, $4rUvP.TokenKind.BLOCK_STRING);
}
/**
 * Description : StringValue
 */ function $649dd453bc440c43$var$parseDescription(lexer) {
    if ($649dd453bc440c43$var$peekDescription(lexer)) return $649dd453bc440c43$var$parseStringLiteral(lexer);
}
/**
 * SchemaDefinition : schema Directives[Const]? { OperationTypeDefinition+ }
 */ function $649dd453bc440c43$var$parseSchemaDefinition(lexer) {
    var start = lexer.token;
    $649dd453bc440c43$var$expectKeyword(lexer, 'schema');
    var directives = $649dd453bc440c43$var$parseDirectives(lexer, true);
    var operationTypes = $649dd453bc440c43$var$many(lexer, $4rUvP.TokenKind.BRACE_L, $649dd453bc440c43$var$parseOperationTypeDefinition, $4rUvP.TokenKind.BRACE_R);
    return {
        kind: $27ePX.Kind.SCHEMA_DEFINITION,
        directives: directives,
        operationTypes: operationTypes,
        loc: $649dd453bc440c43$var$loc(lexer, start)
    };
}
/**
 * OperationTypeDefinition : OperationType : NamedType
 */ function $649dd453bc440c43$var$parseOperationTypeDefinition(lexer) {
    var start = lexer.token;
    var operation = $649dd453bc440c43$var$parseOperationType(lexer);
    $649dd453bc440c43$var$expect(lexer, $4rUvP.TokenKind.COLON);
    var type = $649dd453bc440c43$var$parseNamedType(lexer);
    return {
        kind: $27ePX.Kind.OPERATION_TYPE_DEFINITION,
        operation: operation,
        type: type,
        loc: $649dd453bc440c43$var$loc(lexer, start)
    };
}
/**
 * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
 */ function $649dd453bc440c43$var$parseScalarTypeDefinition(lexer) {
    var start = lexer.token;
    var description = $649dd453bc440c43$var$parseDescription(lexer);
    $649dd453bc440c43$var$expectKeyword(lexer, 'scalar');
    var name = $649dd453bc440c43$var$parseName(lexer);
    var directives = $649dd453bc440c43$var$parseDirectives(lexer, true);
    return {
        kind: $27ePX.Kind.SCALAR_TYPE_DEFINITION,
        description: description,
        name: name,
        directives: directives,
        loc: $649dd453bc440c43$var$loc(lexer, start)
    };
}
/**
 * ObjectTypeDefinition :
 *   Description?
 *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
 */ function $649dd453bc440c43$var$parseObjectTypeDefinition(lexer) {
    var start = lexer.token;
    var description = $649dd453bc440c43$var$parseDescription(lexer);
    $649dd453bc440c43$var$expectKeyword(lexer, 'type');
    var name = $649dd453bc440c43$var$parseName(lexer);
    var interfaces = $649dd453bc440c43$var$parseImplementsInterfaces(lexer);
    var directives = $649dd453bc440c43$var$parseDirectives(lexer, true);
    var fields = $649dd453bc440c43$var$parseFieldsDefinition(lexer);
    return {
        kind: $27ePX.Kind.OBJECT_TYPE_DEFINITION,
        description: description,
        name: name,
        interfaces: interfaces,
        directives: directives,
        fields: fields,
        loc: $649dd453bc440c43$var$loc(lexer, start)
    };
}
/**
 * ImplementsInterfaces :
 *   - implements `&`? NamedType
 *   - ImplementsInterfaces & NamedType
 */ function $649dd453bc440c43$var$parseImplementsInterfaces(lexer) {
    var types = [];
    if (lexer.token.value === 'implements') {
        lexer.advance(); // Optional leading ampersand
        $649dd453bc440c43$var$skip(lexer, $4rUvP.TokenKind.AMP);
        do types.push($649dd453bc440c43$var$parseNamedType(lexer));
        while ($649dd453bc440c43$var$skip(lexer, $4rUvP.TokenKind.AMP) || // Legacy support for the SDL?
        lexer.options.allowLegacySDLImplementsInterfaces && $649dd453bc440c43$var$peek(lexer, $4rUvP.TokenKind.NAME));
    }
    return types;
}
/**
 * FieldsDefinition : { FieldDefinition+ }
 */ function $649dd453bc440c43$var$parseFieldsDefinition(lexer) {
    // Legacy support for the SDL?
    if (lexer.options.allowLegacySDLEmptyFields && $649dd453bc440c43$var$peek(lexer, $4rUvP.TokenKind.BRACE_L) && lexer.lookahead().kind === $4rUvP.TokenKind.BRACE_R) {
        lexer.advance();
        lexer.advance();
        return [];
    }
    return $649dd453bc440c43$var$peek(lexer, $4rUvP.TokenKind.BRACE_L) ? $649dd453bc440c43$var$many(lexer, $4rUvP.TokenKind.BRACE_L, $649dd453bc440c43$var$parseFieldDefinition, $4rUvP.TokenKind.BRACE_R) : [];
}
/**
 * FieldDefinition :
 *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
 */ function $649dd453bc440c43$var$parseFieldDefinition(lexer) {
    var start = lexer.token;
    var description = $649dd453bc440c43$var$parseDescription(lexer);
    var name = $649dd453bc440c43$var$parseName(lexer);
    var args = $649dd453bc440c43$var$parseArgumentDefs(lexer);
    $649dd453bc440c43$var$expect(lexer, $4rUvP.TokenKind.COLON);
    var type = $649dd453bc440c43$var$parseTypeReference(lexer);
    var directives = $649dd453bc440c43$var$parseDirectives(lexer, true);
    return {
        kind: $27ePX.Kind.FIELD_DEFINITION,
        description: description,
        name: name,
        arguments: args,
        type: type,
        directives: directives,
        loc: $649dd453bc440c43$var$loc(lexer, start)
    };
}
/**
 * ArgumentsDefinition : ( InputValueDefinition+ )
 */ function $649dd453bc440c43$var$parseArgumentDefs(lexer) {
    if (!$649dd453bc440c43$var$peek(lexer, $4rUvP.TokenKind.PAREN_L)) return [];
    return $649dd453bc440c43$var$many(lexer, $4rUvP.TokenKind.PAREN_L, $649dd453bc440c43$var$parseInputValueDef, $4rUvP.TokenKind.PAREN_R);
}
/**
 * InputValueDefinition :
 *   - Description? Name : Type DefaultValue? Directives[Const]?
 */ function $649dd453bc440c43$var$parseInputValueDef(lexer) {
    var start = lexer.token;
    var description = $649dd453bc440c43$var$parseDescription(lexer);
    var name = $649dd453bc440c43$var$parseName(lexer);
    $649dd453bc440c43$var$expect(lexer, $4rUvP.TokenKind.COLON);
    var type = $649dd453bc440c43$var$parseTypeReference(lexer);
    var defaultValue;
    if ($649dd453bc440c43$var$skip(lexer, $4rUvP.TokenKind.EQUALS)) defaultValue = $649dd453bc440c43$var$parseConstValue(lexer);
    var directives = $649dd453bc440c43$var$parseDirectives(lexer, true);
    return {
        kind: $27ePX.Kind.INPUT_VALUE_DEFINITION,
        description: description,
        name: name,
        type: type,
        defaultValue: defaultValue,
        directives: directives,
        loc: $649dd453bc440c43$var$loc(lexer, start)
    };
}
/**
 * InterfaceTypeDefinition :
 *   - Description? interface Name Directives[Const]? FieldsDefinition?
 */ function $649dd453bc440c43$var$parseInterfaceTypeDefinition(lexer) {
    var start = lexer.token;
    var description = $649dd453bc440c43$var$parseDescription(lexer);
    $649dd453bc440c43$var$expectKeyword(lexer, 'interface');
    var name = $649dd453bc440c43$var$parseName(lexer);
    var directives = $649dd453bc440c43$var$parseDirectives(lexer, true);
    var fields = $649dd453bc440c43$var$parseFieldsDefinition(lexer);
    return {
        kind: $27ePX.Kind.INTERFACE_TYPE_DEFINITION,
        description: description,
        name: name,
        directives: directives,
        fields: fields,
        loc: $649dd453bc440c43$var$loc(lexer, start)
    };
}
/**
 * UnionTypeDefinition :
 *   - Description? union Name Directives[Const]? UnionMemberTypes?
 */ function $649dd453bc440c43$var$parseUnionTypeDefinition(lexer) {
    var start = lexer.token;
    var description = $649dd453bc440c43$var$parseDescription(lexer);
    $649dd453bc440c43$var$expectKeyword(lexer, 'union');
    var name = $649dd453bc440c43$var$parseName(lexer);
    var directives = $649dd453bc440c43$var$parseDirectives(lexer, true);
    var types = $649dd453bc440c43$var$parseUnionMemberTypes(lexer);
    return {
        kind: $27ePX.Kind.UNION_TYPE_DEFINITION,
        description: description,
        name: name,
        directives: directives,
        types: types,
        loc: $649dd453bc440c43$var$loc(lexer, start)
    };
}
/**
 * UnionMemberTypes :
 *   - = `|`? NamedType
 *   - UnionMemberTypes | NamedType
 */ function $649dd453bc440c43$var$parseUnionMemberTypes(lexer) {
    var types = [];
    if ($649dd453bc440c43$var$skip(lexer, $4rUvP.TokenKind.EQUALS)) {
        // Optional leading pipe
        $649dd453bc440c43$var$skip(lexer, $4rUvP.TokenKind.PIPE);
        do types.push($649dd453bc440c43$var$parseNamedType(lexer));
        while ($649dd453bc440c43$var$skip(lexer, $4rUvP.TokenKind.PIPE));
    }
    return types;
}
/**
 * EnumTypeDefinition :
 *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
 */ function $649dd453bc440c43$var$parseEnumTypeDefinition(lexer) {
    var start = lexer.token;
    var description = $649dd453bc440c43$var$parseDescription(lexer);
    $649dd453bc440c43$var$expectKeyword(lexer, 'enum');
    var name = $649dd453bc440c43$var$parseName(lexer);
    var directives = $649dd453bc440c43$var$parseDirectives(lexer, true);
    var values = $649dd453bc440c43$var$parseEnumValuesDefinition(lexer);
    return {
        kind: $27ePX.Kind.ENUM_TYPE_DEFINITION,
        description: description,
        name: name,
        directives: directives,
        values: values,
        loc: $649dd453bc440c43$var$loc(lexer, start)
    };
}
/**
 * EnumValuesDefinition : { EnumValueDefinition+ }
 */ function $649dd453bc440c43$var$parseEnumValuesDefinition(lexer) {
    return $649dd453bc440c43$var$peek(lexer, $4rUvP.TokenKind.BRACE_L) ? $649dd453bc440c43$var$many(lexer, $4rUvP.TokenKind.BRACE_L, $649dd453bc440c43$var$parseEnumValueDefinition, $4rUvP.TokenKind.BRACE_R) : [];
}
/**
 * EnumValueDefinition : Description? EnumValue Directives[Const]?
 *
 * EnumValue : Name
 */ function $649dd453bc440c43$var$parseEnumValueDefinition(lexer) {
    var start = lexer.token;
    var description = $649dd453bc440c43$var$parseDescription(lexer);
    var name = $649dd453bc440c43$var$parseName(lexer);
    var directives = $649dd453bc440c43$var$parseDirectives(lexer, true);
    return {
        kind: $27ePX.Kind.ENUM_VALUE_DEFINITION,
        description: description,
        name: name,
        directives: directives,
        loc: $649dd453bc440c43$var$loc(lexer, start)
    };
}
/**
 * InputObjectTypeDefinition :
 *   - Description? input Name Directives[Const]? InputFieldsDefinition?
 */ function $649dd453bc440c43$var$parseInputObjectTypeDefinition(lexer) {
    var start = lexer.token;
    var description = $649dd453bc440c43$var$parseDescription(lexer);
    $649dd453bc440c43$var$expectKeyword(lexer, 'input');
    var name = $649dd453bc440c43$var$parseName(lexer);
    var directives = $649dd453bc440c43$var$parseDirectives(lexer, true);
    var fields = $649dd453bc440c43$var$parseInputFieldsDefinition(lexer);
    return {
        kind: $27ePX.Kind.INPUT_OBJECT_TYPE_DEFINITION,
        description: description,
        name: name,
        directives: directives,
        fields: fields,
        loc: $649dd453bc440c43$var$loc(lexer, start)
    };
}
/**
 * InputFieldsDefinition : { InputValueDefinition+ }
 */ function $649dd453bc440c43$var$parseInputFieldsDefinition(lexer) {
    return $649dd453bc440c43$var$peek(lexer, $4rUvP.TokenKind.BRACE_L) ? $649dd453bc440c43$var$many(lexer, $4rUvP.TokenKind.BRACE_L, $649dd453bc440c43$var$parseInputValueDef, $4rUvP.TokenKind.BRACE_R) : [];
}
/**
 * TypeSystemExtension :
 *   - SchemaExtension
 *   - TypeExtension
 *
 * TypeExtension :
 *   - ScalarTypeExtension
 *   - ObjectTypeExtension
 *   - InterfaceTypeExtension
 *   - UnionTypeExtension
 *   - EnumTypeExtension
 *   - InputObjectTypeDefinition
 */ function $649dd453bc440c43$var$parseTypeSystemExtension(lexer) {
    var keywordToken = lexer.lookahead();
    if (keywordToken.kind === $4rUvP.TokenKind.NAME) switch(keywordToken.value){
        case 'schema':
            return $649dd453bc440c43$var$parseSchemaExtension(lexer);
        case 'scalar':
            return $649dd453bc440c43$var$parseScalarTypeExtension(lexer);
        case 'type':
            return $649dd453bc440c43$var$parseObjectTypeExtension(lexer);
        case 'interface':
            return $649dd453bc440c43$var$parseInterfaceTypeExtension(lexer);
        case 'union':
            return $649dd453bc440c43$var$parseUnionTypeExtension(lexer);
        case 'enum':
            return $649dd453bc440c43$var$parseEnumTypeExtension(lexer);
        case 'input':
            return $649dd453bc440c43$var$parseInputObjectTypeExtension(lexer);
    }
    throw $649dd453bc440c43$var$unexpected(lexer, keywordToken);
}
/**
 * SchemaExtension :
 *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
 *  - extend schema Directives[Const]
 */ function $649dd453bc440c43$var$parseSchemaExtension(lexer) {
    var start = lexer.token;
    $649dd453bc440c43$var$expectKeyword(lexer, 'extend');
    $649dd453bc440c43$var$expectKeyword(lexer, 'schema');
    var directives = $649dd453bc440c43$var$parseDirectives(lexer, true);
    var operationTypes = $649dd453bc440c43$var$peek(lexer, $4rUvP.TokenKind.BRACE_L) ? $649dd453bc440c43$var$many(lexer, $4rUvP.TokenKind.BRACE_L, $649dd453bc440c43$var$parseOperationTypeDefinition, $4rUvP.TokenKind.BRACE_R) : [];
    if (directives.length === 0 && operationTypes.length === 0) throw $649dd453bc440c43$var$unexpected(lexer);
    return {
        kind: $27ePX.Kind.SCHEMA_EXTENSION,
        directives: directives,
        operationTypes: operationTypes,
        loc: $649dd453bc440c43$var$loc(lexer, start)
    };
}
/**
 * ScalarTypeExtension :
 *   - extend scalar Name Directives[Const]
 */ function $649dd453bc440c43$var$parseScalarTypeExtension(lexer) {
    var start = lexer.token;
    $649dd453bc440c43$var$expectKeyword(lexer, 'extend');
    $649dd453bc440c43$var$expectKeyword(lexer, 'scalar');
    var name = $649dd453bc440c43$var$parseName(lexer);
    var directives = $649dd453bc440c43$var$parseDirectives(lexer, true);
    if (directives.length === 0) throw $649dd453bc440c43$var$unexpected(lexer);
    return {
        kind: $27ePX.Kind.SCALAR_TYPE_EXTENSION,
        name: name,
        directives: directives,
        loc: $649dd453bc440c43$var$loc(lexer, start)
    };
}
/**
 * ObjectTypeExtension :
 *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
 *  - extend type Name ImplementsInterfaces? Directives[Const]
 *  - extend type Name ImplementsInterfaces
 */ function $649dd453bc440c43$var$parseObjectTypeExtension(lexer) {
    var start = lexer.token;
    $649dd453bc440c43$var$expectKeyword(lexer, 'extend');
    $649dd453bc440c43$var$expectKeyword(lexer, 'type');
    var name = $649dd453bc440c43$var$parseName(lexer);
    var interfaces = $649dd453bc440c43$var$parseImplementsInterfaces(lexer);
    var directives = $649dd453bc440c43$var$parseDirectives(lexer, true);
    var fields = $649dd453bc440c43$var$parseFieldsDefinition(lexer);
    if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw $649dd453bc440c43$var$unexpected(lexer);
    return {
        kind: $27ePX.Kind.OBJECT_TYPE_EXTENSION,
        name: name,
        interfaces: interfaces,
        directives: directives,
        fields: fields,
        loc: $649dd453bc440c43$var$loc(lexer, start)
    };
}
/**
 * InterfaceTypeExtension :
 *   - extend interface Name Directives[Const]? FieldsDefinition
 *   - extend interface Name Directives[Const]
 */ function $649dd453bc440c43$var$parseInterfaceTypeExtension(lexer) {
    var start = lexer.token;
    $649dd453bc440c43$var$expectKeyword(lexer, 'extend');
    $649dd453bc440c43$var$expectKeyword(lexer, 'interface');
    var name = $649dd453bc440c43$var$parseName(lexer);
    var directives = $649dd453bc440c43$var$parseDirectives(lexer, true);
    var fields = $649dd453bc440c43$var$parseFieldsDefinition(lexer);
    if (directives.length === 0 && fields.length === 0) throw $649dd453bc440c43$var$unexpected(lexer);
    return {
        kind: $27ePX.Kind.INTERFACE_TYPE_EXTENSION,
        name: name,
        directives: directives,
        fields: fields,
        loc: $649dd453bc440c43$var$loc(lexer, start)
    };
}
/**
 * UnionTypeExtension :
 *   - extend union Name Directives[Const]? UnionMemberTypes
 *   - extend union Name Directives[Const]
 */ function $649dd453bc440c43$var$parseUnionTypeExtension(lexer) {
    var start = lexer.token;
    $649dd453bc440c43$var$expectKeyword(lexer, 'extend');
    $649dd453bc440c43$var$expectKeyword(lexer, 'union');
    var name = $649dd453bc440c43$var$parseName(lexer);
    var directives = $649dd453bc440c43$var$parseDirectives(lexer, true);
    var types = $649dd453bc440c43$var$parseUnionMemberTypes(lexer);
    if (directives.length === 0 && types.length === 0) throw $649dd453bc440c43$var$unexpected(lexer);
    return {
        kind: $27ePX.Kind.UNION_TYPE_EXTENSION,
        name: name,
        directives: directives,
        types: types,
        loc: $649dd453bc440c43$var$loc(lexer, start)
    };
}
/**
 * EnumTypeExtension :
 *   - extend enum Name Directives[Const]? EnumValuesDefinition
 *   - extend enum Name Directives[Const]
 */ function $649dd453bc440c43$var$parseEnumTypeExtension(lexer) {
    var start = lexer.token;
    $649dd453bc440c43$var$expectKeyword(lexer, 'extend');
    $649dd453bc440c43$var$expectKeyword(lexer, 'enum');
    var name = $649dd453bc440c43$var$parseName(lexer);
    var directives = $649dd453bc440c43$var$parseDirectives(lexer, true);
    var values = $649dd453bc440c43$var$parseEnumValuesDefinition(lexer);
    if (directives.length === 0 && values.length === 0) throw $649dd453bc440c43$var$unexpected(lexer);
    return {
        kind: $27ePX.Kind.ENUM_TYPE_EXTENSION,
        name: name,
        directives: directives,
        values: values,
        loc: $649dd453bc440c43$var$loc(lexer, start)
    };
}
/**
 * InputObjectTypeExtension :
 *   - extend input Name Directives[Const]? InputFieldsDefinition
 *   - extend input Name Directives[Const]
 */ function $649dd453bc440c43$var$parseInputObjectTypeExtension(lexer) {
    var start = lexer.token;
    $649dd453bc440c43$var$expectKeyword(lexer, 'extend');
    $649dd453bc440c43$var$expectKeyword(lexer, 'input');
    var name = $649dd453bc440c43$var$parseName(lexer);
    var directives = $649dd453bc440c43$var$parseDirectives(lexer, true);
    var fields = $649dd453bc440c43$var$parseInputFieldsDefinition(lexer);
    if (directives.length === 0 && fields.length === 0) throw $649dd453bc440c43$var$unexpected(lexer);
    return {
        kind: $27ePX.Kind.INPUT_OBJECT_TYPE_EXTENSION,
        name: name,
        directives: directives,
        fields: fields,
        loc: $649dd453bc440c43$var$loc(lexer, start)
    };
}
/**
 * DirectiveDefinition :
 *   - Description? directive @ Name ArgumentsDefinition? on DirectiveLocations
 */ function $649dd453bc440c43$var$parseDirectiveDefinition(lexer) {
    var start = lexer.token;
    var description = $649dd453bc440c43$var$parseDescription(lexer);
    $649dd453bc440c43$var$expectKeyword(lexer, 'directive');
    $649dd453bc440c43$var$expect(lexer, $4rUvP.TokenKind.AT);
    var name = $649dd453bc440c43$var$parseName(lexer);
    var args = $649dd453bc440c43$var$parseArgumentDefs(lexer);
    $649dd453bc440c43$var$expectKeyword(lexer, 'on');
    var locations = $649dd453bc440c43$var$parseDirectiveLocations(lexer);
    return {
        kind: $27ePX.Kind.DIRECTIVE_DEFINITION,
        description: description,
        name: name,
        arguments: args,
        locations: locations,
        loc: $649dd453bc440c43$var$loc(lexer, start)
    };
}
/**
 * DirectiveLocations :
 *   - `|`? DirectiveLocation
 *   - DirectiveLocations | DirectiveLocation
 */ function $649dd453bc440c43$var$parseDirectiveLocations(lexer) {
    // Optional leading pipe
    $649dd453bc440c43$var$skip(lexer, $4rUvP.TokenKind.PIPE);
    var locations = [];
    do locations.push($649dd453bc440c43$var$parseDirectiveLocation(lexer));
    while ($649dd453bc440c43$var$skip(lexer, $4rUvP.TokenKind.PIPE));
    return locations;
}
/*
 * DirectiveLocation :
 *   - ExecutableDirectiveLocation
 *   - TypeSystemDirectiveLocation
 *
 * ExecutableDirectiveLocation : one of
 *   `QUERY`
 *   `MUTATION`
 *   `SUBSCRIPTION`
 *   `FIELD`
 *   `FRAGMENT_DEFINITION`
 *   `FRAGMENT_SPREAD`
 *   `INLINE_FRAGMENT`
 *
 * TypeSystemDirectiveLocation : one of
 *   `SCHEMA`
 *   `SCALAR`
 *   `OBJECT`
 *   `FIELD_DEFINITION`
 *   `ARGUMENT_DEFINITION`
 *   `INTERFACE`
 *   `UNION`
 *   `ENUM`
 *   `ENUM_VALUE`
 *   `INPUT_OBJECT`
 *   `INPUT_FIELD_DEFINITION`
 */ function $649dd453bc440c43$var$parseDirectiveLocation(lexer) {
    var start = lexer.token;
    var name = $649dd453bc440c43$var$parseName(lexer);
    if ($bKKxQ.DirectiveLocation.hasOwnProperty(name.value)) return name;
    throw $649dd453bc440c43$var$unexpected(lexer, start);
} // Core parsing utility functions
/**
 * Returns a location object, used to identify the place in
 * the source that created a given parsed object.
 */ function $649dd453bc440c43$var$loc(lexer, startToken) {
    if (!lexer.options.noLocation) return new $649dd453bc440c43$var$Loc(startToken, lexer.lastToken, lexer.source);
}
function $649dd453bc440c43$var$Loc(startToken, endToken, source) {
    this.start = startToken.start;
    this.end = endToken.end;
    this.startToken = startToken;
    this.endToken = endToken;
    this.source = source;
} // Print a simplified form when appearing in JSON/util.inspect.
$649dd453bc440c43$var$Loc.prototype.toJSON = $649dd453bc440c43$var$Loc.prototype.inspect = function toJSON() {
    return {
        start: this.start,
        end: this.end
    };
};
/**
 * Determines if the next token is of a given kind
 */ function $649dd453bc440c43$var$peek(lexer, kind) {
    return lexer.token.kind === kind;
}
/**
 * If the next token is of the given kind, return true after advancing
 * the lexer. Otherwise, do not change the parser state and return false.
 */ function $649dd453bc440c43$var$skip(lexer, kind) {
    var match = lexer.token.kind === kind;
    if (match) lexer.advance();
    return match;
}
/**
 * If the next token is of the given kind, return that token after advancing
 * the lexer. Otherwise, do not change the parser state and throw an error.
 */ function $649dd453bc440c43$var$expect(lexer, kind) {
    var token = lexer.token;
    if (token.kind === kind) {
        lexer.advance();
        return token;
    }
    throw (0, $iOpAS.syntaxError)(lexer.source, token.start, "Expected ".concat(kind, ", found ").concat((0, $4rUvP.getTokenDesc)(token)));
}
/**
 * If the next token is a keyword with the given value, return that token after
 * advancing the lexer. Otherwise, do not change the parser state and return
 * false.
 */ function $649dd453bc440c43$var$expectKeyword(lexer, value) {
    var token = lexer.token;
    if (token.kind === $4rUvP.TokenKind.NAME && token.value === value) {
        lexer.advance();
        return token;
    }
    throw (0, $iOpAS.syntaxError)(lexer.source, token.start, "Expected \"".concat(value, "\", found ").concat((0, $4rUvP.getTokenDesc)(token)));
}
/**
 * Helper function for creating an error when an unexpected lexed token
 * is encountered.
 */ function $649dd453bc440c43$var$unexpected(lexer, atToken) {
    var token = atToken || lexer.token;
    return (0, $iOpAS.syntaxError)(lexer.source, token.start, "Unexpected ".concat((0, $4rUvP.getTokenDesc)(token)));
}
/**
 * Returns a possibly empty list of parse nodes, determined by
 * the parseFn. This list begins with a lex token of openKind
 * and ends with a lex token of closeKind. Advances the parser
 * to the next lex token after the closing token.
 */ function $649dd453bc440c43$var$any(lexer, openKind, parseFn, closeKind) {
    $649dd453bc440c43$var$expect(lexer, openKind);
    var nodes = [];
    while(!$649dd453bc440c43$var$skip(lexer, closeKind))nodes.push(parseFn(lexer));
    return nodes;
}
/**
 * Returns a non-empty list of parse nodes, determined by
 * the parseFn. This list begins with a lex token of openKind
 * and ends with a lex token of closeKind. Advances the parser
 * to the next lex token after the closing token.
 */ function $649dd453bc440c43$var$many(lexer, openKind, parseFn, closeKind) {
    $649dd453bc440c43$var$expect(lexer, openKind);
    var nodes = [
        parseFn(lexer)
    ];
    while(!$649dd453bc440c43$var$skip(lexer, closeKind))nodes.push(parseFn(lexer));
    return nodes;
}

});
parcelRegister("l8ejJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f6257372191baad9$var$inspect;
function $f6257372191baad9$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $f6257372191baad9$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $f6257372191baad9$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $f6257372191baad9$var$_typeof(obj);
}
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */ /**
 * Used to print values in error messages.
 */ function $f6257372191baad9$var$inspect(value) {
    return value && $f6257372191baad9$var$_typeof(value) === 'object' ? typeof value.inspect === 'function' ? value.inspect() : Array.isArray(value) ? '[' + value.map($f6257372191baad9$var$inspect).join(', ') + ']' : '{' + Object.keys(value).map(function(k) {
        return "".concat(k, ": ").concat($f6257372191baad9$var$inspect(value[k]));
    }).join(', ') + '}' : typeof value === 'string' ? '"' + value + '"' : typeof value === 'function' ? "[function ".concat(value.name, "]") : String(value);
}

});

parcelRegister("jtA0P", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Source = void 0;

var $e2dca90d45238857$var$_invariant = $e2dca90d45238857$var$_interopRequireDefault((parcelRequire("c50qC")));

var $e2dca90d45238857$var$_defineToStringTag = $e2dca90d45238857$var$_interopRequireDefault((parcelRequire("igPbd")));
function $e2dca90d45238857$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e2dca90d45238857$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
/**
 * A representation of source input to GraphQL.
 * `name` and `locationOffset` are optional. They are useful for clients who
 * store GraphQL documents in source files; for example, if the GraphQL input
 * starts at line 40 in a file named Foo.graphql, it might be useful for name to
 * be "Foo.graphql" and location to be `{ line: 40, column: 0 }`.
 * line and column in locationOffset are 1-indexed
 */ var $e2dca90d45238857$var$Source = function Source(body, name, locationOffset) {
    $e2dca90d45238857$var$_defineProperty(this, "body", void 0);
    $e2dca90d45238857$var$_defineProperty(this, "name", void 0);
    $e2dca90d45238857$var$_defineProperty(this, "locationOffset", void 0);
    this.body = body;
    this.name = name || 'GraphQL request';
    this.locationOffset = locationOffset || {
        line: 1,
        column: 1
    };
    !(this.locationOffset.line > 0) && (0, $e2dca90d45238857$var$_invariant.default)(0, 'line in locationOffset is 1-indexed and must be positive');
    !(this.locationOffset.column > 0) && (0, $e2dca90d45238857$var$_invariant.default)(0, 'column in locationOffset is 1-indexed and must be positive');
}; // Conditionally apply `[Symbol.toStringTag]` if `Symbol`s are supported
module.exports.Source = $e2dca90d45238857$var$Source;
(0, $e2dca90d45238857$var$_defineToStringTag.default)($e2dca90d45238857$var$Source);

});
parcelRegister("c50qC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8cb648b97c272989$var$invariant;
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */ function $8cb648b97c272989$var$invariant(condition, message) {
    /* istanbul ignore else */ if (!condition) throw new Error(message);
}

});

parcelRegister("igPbd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d4d16bdef0c531a8$var$applyToStringTag;
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */ /**
 * The `applyToStringTag()` function checks first to see if the runtime
 * supports the `Symbol` class and then if the `Symbol.toStringTag` constant
 * is defined as a `Symbol` instance. If both conditions are met, the
 * Symbol.toStringTag property is defined as a getter that returns the
 * supplied class constructor's name.
 *
 * @method applyToStringTag
 *
 * @param {Class<any>} classObject a class such as Object, String, Number but
 * typically one of your own creation through the class keyword; `class A {}`,
 * for example.
 */ function $d4d16bdef0c531a8$var$applyToStringTag(classObject) {
    if (typeof Symbol === 'function' && Symbol.toStringTag) Object.defineProperty(classObject.prototype, Symbol.toStringTag, {
        get: function get() {
            return this.constructor.name;
        }
    });
}

});


parcelRegister("iOpAS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "GraphQLError", {
    enumerable: true,
    get: function get() {
        return $1aNdC.GraphQLError;
    }
});
Object.defineProperty(module.exports, "syntaxError", {
    enumerable: true,
    get: function get() {
        return $7NZNf.syntaxError;
    }
});
Object.defineProperty(module.exports, "locatedError", {
    enumerable: true,
    get: function get() {
        return $agYVZ.locatedError;
    }
});
Object.defineProperty(module.exports, "printError", {
    enumerable: true,
    get: function get() {
        return $70Wub.printError;
    }
});
Object.defineProperty(module.exports, "formatError", {
    enumerable: true,
    get: function get() {
        return $4bF8t.formatError;
    }
});

var $1aNdC = parcelRequire("1aNdC");

var $7NZNf = parcelRequire("7NZNf");

var $agYVZ = parcelRequire("agYVZ");

var $70Wub = parcelRequire("70Wub");

var $4bF8t = parcelRequire("4bF8t");

});
parcelRegister("7NZNf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.syntaxError = $5aed0ae5c779c354$var$syntaxError;

var $1aNdC = parcelRequire("1aNdC");
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */ /**
 * Produces a GraphQLError representing a syntax error, containing useful
 * descriptive information about the syntax error's position in the source.
 */ function $5aed0ae5c779c354$var$syntaxError(source, position, description) {
    return new $1aNdC.GraphQLError("Syntax Error: ".concat(description), undefined, source, [
        position
    ]);
}

});

parcelRegister("agYVZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.locatedError = $77aaaa4990b0bea7$var$locatedError;

var $1aNdC = parcelRequire("1aNdC");
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */ /**
 * Given an arbitrary Error, presumably thrown while attempting to execute a
 * GraphQL operation, produce a new GraphQLError aware of the location in the
 * document responsible for the original Error.
 */ function $77aaaa4990b0bea7$var$locatedError(originalError, nodes, path) {
    // Note: this uses a brand-check to support GraphQL errors originating from
    // other contexts.
    if (originalError && Array.isArray(originalError.path)) return originalError;
    return new $1aNdC.GraphQLError(originalError && originalError.message, originalError && originalError.nodes || nodes, originalError && originalError.source, originalError && originalError.positions, path, originalError);
}

});

parcelRegister("4bF8t", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.formatError = $30c819365bf15fda$var$formatError;

var $30c819365bf15fda$var$_invariant = $30c819365bf15fda$var$_interopRequireDefault((parcelRequire("c50qC")));
function $30c819365bf15fda$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */ /**
 * Given a GraphQLError, format it according to the rules described by the
 * Response Format, Errors section of the GraphQL Specification.
 */ function $30c819365bf15fda$var$formatError(error) {
    !error && (0, $30c819365bf15fda$var$_invariant.default)(0, 'Received null or undefined error.');
    var message = error.message || 'An unknown error occurred.';
    var locations = error.locations;
    var path = error.path;
    var extensions = error.extensions;
    return extensions ? {
        message: message,
        locations: locations,
        path: path,
        extensions: extensions
    } : {
        message: message,
        locations: locations,
        path: path
    };
}

});


parcelRegister("4rUvP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createLexer = $33d5853d8e90d945$var$createLexer;
module.exports.getTokenDesc = $33d5853d8e90d945$var$getTokenDesc;
module.exports.TokenKind = void 0;

var $iOpAS = parcelRequire("iOpAS");

var $33d5853d8e90d945$var$_blockStringValue = $33d5853d8e90d945$var$_interopRequireDefault((parcelRequire("bQjcM")));
function $33d5853d8e90d945$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */ /**
 * Given a Source object, this returns a Lexer for that source.
 * A Lexer is a stateful stream generator in that every time
 * it is advanced, it returns the next token in the Source. Assuming the
 * source lexes, the final Token emitted by the lexer will be of kind
 * EOF, after which the lexer will repeatedly return the same EOF token
 * whenever called.
 */ function $33d5853d8e90d945$var$createLexer(source, options) {
    var startOfFileToken = new $33d5853d8e90d945$var$Tok($33d5853d8e90d945$var$TokenKind.SOF, 0, 0, 0, 0, null);
    var lexer = {
        source: source,
        options: options,
        lastToken: startOfFileToken,
        token: startOfFileToken,
        line: 1,
        lineStart: 0,
        advance: $33d5853d8e90d945$var$advanceLexer,
        lookahead: $33d5853d8e90d945$var$lookahead
    };
    return lexer;
}
function $33d5853d8e90d945$var$advanceLexer() {
    this.lastToken = this.token;
    var token = this.token = this.lookahead();
    return token;
}
function $33d5853d8e90d945$var$lookahead() {
    var token = this.token;
    if (token.kind !== $33d5853d8e90d945$var$TokenKind.EOF) do // Note: next is only mutable during parsing, so we cast to allow this.
    token = token.next || (token.next = $33d5853d8e90d945$var$readToken(this, token));
    while (token.kind === $33d5853d8e90d945$var$TokenKind.COMMENT);
    return token;
}
/**
 * The return type of createLexer.
 */ /**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */ var $33d5853d8e90d945$var$TokenKind = Object.freeze({
    SOF: '<SOF>',
    EOF: '<EOF>',
    BANG: '!',
    DOLLAR: '$',
    AMP: '&',
    PAREN_L: '(',
    PAREN_R: ')',
    SPREAD: '...',
    COLON: ':',
    EQUALS: '=',
    AT: '@',
    BRACKET_L: '[',
    BRACKET_R: ']',
    BRACE_L: '{',
    PIPE: '|',
    BRACE_R: '}',
    NAME: 'Name',
    INT: 'Int',
    FLOAT: 'Float',
    STRING: 'String',
    BLOCK_STRING: 'BlockString',
    COMMENT: 'Comment'
});
/**
 * The enum type representing the token kinds values.
 */ module.exports.TokenKind = $33d5853d8e90d945$var$TokenKind;
/**
 * A helper function to describe a token as a string for debugging
 */ function $33d5853d8e90d945$var$getTokenDesc(token) {
    var value = token.value;
    return value ? "".concat(token.kind, " \"").concat(value, "\"") : token.kind;
}
var $33d5853d8e90d945$var$charCodeAt = String.prototype.charCodeAt;
var $33d5853d8e90d945$var$slice = String.prototype.slice;
/**
 * Helper function for constructing the Token object.
 */ function $33d5853d8e90d945$var$Tok(kind, start, end, line, column, prev, value) {
    this.kind = kind;
    this.start = start;
    this.end = end;
    this.line = line;
    this.column = column;
    this.value = value;
    this.prev = prev;
    this.next = null;
} // Print a simplified form when appearing in JSON/util.inspect.
$33d5853d8e90d945$var$Tok.prototype.toJSON = $33d5853d8e90d945$var$Tok.prototype.inspect = function toJSON() {
    return {
        kind: this.kind,
        value: this.value,
        line: this.line,
        column: this.column
    };
};
function $33d5853d8e90d945$var$printCharCode(code) {
    return isNaN(code) ? $33d5853d8e90d945$var$TokenKind.EOF : code < 0x007f ? JSON.stringify(String.fromCharCode(code)) : "\"\\u".concat(('00' + code.toString(16).toUpperCase()).slice(-4), "\"");
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace and comments until it finds the next lexable
 * token, then lexes punctuators immediately or calls the appropriate helper
 * function for more complicated tokens.
 */ function $33d5853d8e90d945$var$readToken(lexer, prev) {
    var source = lexer.source;
    var body = source.body;
    var bodyLength = body.length;
    var pos = $33d5853d8e90d945$var$positionAfterWhitespace(body, prev.end, lexer);
    var line = lexer.line;
    var col = 1 + pos - lexer.lineStart;
    if (pos >= bodyLength) return new $33d5853d8e90d945$var$Tok($33d5853d8e90d945$var$TokenKind.EOF, bodyLength, bodyLength, line, col, prev);
    var code = $33d5853d8e90d945$var$charCodeAt.call(body, pos); // SourceCharacter
    switch(code){
        // !
        case 33:
            return new $33d5853d8e90d945$var$Tok($33d5853d8e90d945$var$TokenKind.BANG, pos, pos + 1, line, col, prev);
        // #
        case 35:
            return $33d5853d8e90d945$var$readComment(source, pos, line, col, prev);
        // $
        case 36:
            return new $33d5853d8e90d945$var$Tok($33d5853d8e90d945$var$TokenKind.DOLLAR, pos, pos + 1, line, col, prev);
        // &
        case 38:
            return new $33d5853d8e90d945$var$Tok($33d5853d8e90d945$var$TokenKind.AMP, pos, pos + 1, line, col, prev);
        // (
        case 40:
            return new $33d5853d8e90d945$var$Tok($33d5853d8e90d945$var$TokenKind.PAREN_L, pos, pos + 1, line, col, prev);
        // )
        case 41:
            return new $33d5853d8e90d945$var$Tok($33d5853d8e90d945$var$TokenKind.PAREN_R, pos, pos + 1, line, col, prev);
        // .
        case 46:
            if ($33d5853d8e90d945$var$charCodeAt.call(body, pos + 1) === 46 && $33d5853d8e90d945$var$charCodeAt.call(body, pos + 2) === 46) return new $33d5853d8e90d945$var$Tok($33d5853d8e90d945$var$TokenKind.SPREAD, pos, pos + 3, line, col, prev);
            break;
        // :
        case 58:
            return new $33d5853d8e90d945$var$Tok($33d5853d8e90d945$var$TokenKind.COLON, pos, pos + 1, line, col, prev);
        // =
        case 61:
            return new $33d5853d8e90d945$var$Tok($33d5853d8e90d945$var$TokenKind.EQUALS, pos, pos + 1, line, col, prev);
        // @
        case 64:
            return new $33d5853d8e90d945$var$Tok($33d5853d8e90d945$var$TokenKind.AT, pos, pos + 1, line, col, prev);
        // [
        case 91:
            return new $33d5853d8e90d945$var$Tok($33d5853d8e90d945$var$TokenKind.BRACKET_L, pos, pos + 1, line, col, prev);
        // ]
        case 93:
            return new $33d5853d8e90d945$var$Tok($33d5853d8e90d945$var$TokenKind.BRACKET_R, pos, pos + 1, line, col, prev);
        // {
        case 123:
            return new $33d5853d8e90d945$var$Tok($33d5853d8e90d945$var$TokenKind.BRACE_L, pos, pos + 1, line, col, prev);
        // |
        case 124:
            return new $33d5853d8e90d945$var$Tok($33d5853d8e90d945$var$TokenKind.PIPE, pos, pos + 1, line, col, prev);
        // }
        case 125:
            return new $33d5853d8e90d945$var$Tok($33d5853d8e90d945$var$TokenKind.BRACE_R, pos, pos + 1, line, col, prev);
        // A-Z _ a-z
        case 65:
        case 66:
        case 67:
        case 68:
        case 69:
        case 70:
        case 71:
        case 72:
        case 73:
        case 74:
        case 75:
        case 76:
        case 77:
        case 78:
        case 79:
        case 80:
        case 81:
        case 82:
        case 83:
        case 84:
        case 85:
        case 86:
        case 87:
        case 88:
        case 89:
        case 90:
        case 95:
        case 97:
        case 98:
        case 99:
        case 100:
        case 101:
        case 102:
        case 103:
        case 104:
        case 105:
        case 106:
        case 107:
        case 108:
        case 109:
        case 110:
        case 111:
        case 112:
        case 113:
        case 114:
        case 115:
        case 116:
        case 117:
        case 118:
        case 119:
        case 120:
        case 121:
        case 122:
            return $33d5853d8e90d945$var$readName(source, pos, line, col, prev);
        // - 0-9
        case 45:
        case 48:
        case 49:
        case 50:
        case 51:
        case 52:
        case 53:
        case 54:
        case 55:
        case 56:
        case 57:
            return $33d5853d8e90d945$var$readNumber(source, pos, code, line, col, prev);
        // "
        case 34:
            if ($33d5853d8e90d945$var$charCodeAt.call(body, pos + 1) === 34 && $33d5853d8e90d945$var$charCodeAt.call(body, pos + 2) === 34) return $33d5853d8e90d945$var$readBlockString(source, pos, line, col, prev);
            return $33d5853d8e90d945$var$readString(source, pos, line, col, prev);
    }
    throw (0, $iOpAS.syntaxError)(source, pos, $33d5853d8e90d945$var$unexpectedCharacterMessage(code));
}
/**
 * Report a message that an unexpected character was encountered.
 */ function $33d5853d8e90d945$var$unexpectedCharacterMessage(code) {
    if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) return "Cannot contain the invalid character ".concat($33d5853d8e90d945$var$printCharCode(code), ".");
    if (code === 39) // '
    return "Unexpected single quote character ('), did you mean to use a double quote (\")?";
    return "Cannot parse the unexpected character ".concat($33d5853d8e90d945$var$printCharCode(code), ".");
}
/**
 * Reads from body starting at startPosition until it finds a non-whitespace
 * or commented character, then returns the position of that character for
 * lexing.
 */ function $33d5853d8e90d945$var$positionAfterWhitespace(body, startPosition, lexer) {
    var bodyLength = body.length;
    var position = startPosition;
    while(position < bodyLength){
        var code = $33d5853d8e90d945$var$charCodeAt.call(body, position); // tab | space | comma | BOM
        if (code === 9 || code === 32 || code === 44 || code === 0xfeff) ++position;
        else if (code === 10) {
            // new line
            ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 13) {
            // carriage return
            if ($33d5853d8e90d945$var$charCodeAt.call(body, position + 1) === 10) position += 2;
            else ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else break;
    }
    return position;
}
/**
 * Reads a comment token from the source file.
 *
 * #[\u0009\u0020-\uFFFF]*
 */ function $33d5853d8e90d945$var$readComment(source, start, line, col, prev) {
    var body = source.body;
    var code;
    var position = start;
    do code = $33d5853d8e90d945$var$charCodeAt.call(body, ++position);
    while (code !== null && (code > 0x001f || code === 0x0009));
    return new $33d5853d8e90d945$var$Tok($33d5853d8e90d945$var$TokenKind.COMMENT, start, position, line, col, prev, $33d5853d8e90d945$var$slice.call(body, start + 1, position));
}
/**
 * Reads a number token from the source file, either a float
 * or an int depending on whether a decimal point appears.
 *
 * Int:   -?(0|[1-9][0-9]*)
 * Float: -?(0|[1-9][0-9]*)(\.[0-9]+)?((E|e)(+|-)?[0-9]+)?
 */ function $33d5853d8e90d945$var$readNumber(source, start, firstCode, line, col, prev) {
    var body = source.body;
    var code = firstCode;
    var position = start;
    var isFloat = false;
    if (code === 45) // -
    code = $33d5853d8e90d945$var$charCodeAt.call(body, ++position);
    if (code === 48) {
        // 0
        code = $33d5853d8e90d945$var$charCodeAt.call(body, ++position);
        if (code >= 48 && code <= 57) throw (0, $iOpAS.syntaxError)(source, position, "Invalid number, unexpected digit after 0: ".concat($33d5853d8e90d945$var$printCharCode(code), "."));
    } else {
        position = $33d5853d8e90d945$var$readDigits(source, position, code);
        code = $33d5853d8e90d945$var$charCodeAt.call(body, position);
    }
    if (code === 46) {
        // .
        isFloat = true;
        code = $33d5853d8e90d945$var$charCodeAt.call(body, ++position);
        position = $33d5853d8e90d945$var$readDigits(source, position, code);
        code = $33d5853d8e90d945$var$charCodeAt.call(body, position);
    }
    if (code === 69 || code === 101) {
        // E e
        isFloat = true;
        code = $33d5853d8e90d945$var$charCodeAt.call(body, ++position);
        if (code === 43 || code === 45) // + -
        code = $33d5853d8e90d945$var$charCodeAt.call(body, ++position);
        position = $33d5853d8e90d945$var$readDigits(source, position, code);
    }
    return new $33d5853d8e90d945$var$Tok(isFloat ? $33d5853d8e90d945$var$TokenKind.FLOAT : $33d5853d8e90d945$var$TokenKind.INT, start, position, line, col, prev, $33d5853d8e90d945$var$slice.call(body, start, position));
}
/**
 * Returns the new position in the source after reading digits.
 */ function $33d5853d8e90d945$var$readDigits(source, start, firstCode) {
    var body = source.body;
    var position = start;
    var code = firstCode;
    if (code >= 48 && code <= 57) {
        // 0 - 9
        do code = $33d5853d8e90d945$var$charCodeAt.call(body, ++position);
        while (code >= 48 && code <= 57); // 0 - 9
        return position;
    }
    throw (0, $iOpAS.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat($33d5853d8e90d945$var$printCharCode(code), "."));
}
/**
 * Reads a string token from the source file.
 *
 * "([^"\\\u000A\u000D]|(\\(u[0-9a-fA-F]{4}|["\\/bfnrt])))*"
 */ function $33d5853d8e90d945$var$readString(source, start, line, col, prev) {
    var body = source.body;
    var position = start + 1;
    var chunkStart = position;
    var code = 0;
    var value = '';
    while(position < body.length && (code = $33d5853d8e90d945$var$charCodeAt.call(body, position)) !== null && // not LineTerminator
    code !== 0x000a && code !== 0x000d){
        // Closing Quote (")
        if (code === 34) {
            value += $33d5853d8e90d945$var$slice.call(body, chunkStart, position);
            return new $33d5853d8e90d945$var$Tok($33d5853d8e90d945$var$TokenKind.STRING, start, position + 1, line, col, prev, value);
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009) throw (0, $iOpAS.syntaxError)(source, position, "Invalid character within String: ".concat($33d5853d8e90d945$var$printCharCode(code), "."));
        ++position;
        if (code === 92) {
            // \
            value += $33d5853d8e90d945$var$slice.call(body, chunkStart, position - 1);
            code = $33d5853d8e90d945$var$charCodeAt.call(body, position);
            switch(code){
                case 34:
                    value += '"';
                    break;
                case 47:
                    value += '/';
                    break;
                case 92:
                    value += '\\';
                    break;
                case 98:
                    value += '\b';
                    break;
                case 102:
                    value += '\f';
                    break;
                case 110:
                    value += '\n';
                    break;
                case 114:
                    value += '\r';
                    break;
                case 116:
                    value += '\t';
                    break;
                case 117:
                    // u
                    var charCode = $33d5853d8e90d945$var$uniCharCode($33d5853d8e90d945$var$charCodeAt.call(body, position + 1), $33d5853d8e90d945$var$charCodeAt.call(body, position + 2), $33d5853d8e90d945$var$charCodeAt.call(body, position + 3), $33d5853d8e90d945$var$charCodeAt.call(body, position + 4));
                    if (charCode < 0) throw (0, $iOpAS.syntaxError)(source, position, 'Invalid character escape sequence: ' + "\\u".concat(body.slice(position + 1, position + 5), "."));
                    value += String.fromCharCode(charCode);
                    position += 4;
                    break;
                default:
                    throw (0, $iOpAS.syntaxError)(source, position, "Invalid character escape sequence: \\".concat(String.fromCharCode(code), "."));
            }
            ++position;
            chunkStart = position;
        }
    }
    throw (0, $iOpAS.syntaxError)(source, position, 'Unterminated string.');
}
/**
 * Reads a block string token from the source file.
 *
 * """("?"?(\\"""|\\(?!=""")|[^"\\]))*"""
 */ function $33d5853d8e90d945$var$readBlockString(source, start, line, col, prev) {
    var body = source.body;
    var position = start + 3;
    var chunkStart = position;
    var code = 0;
    var rawValue = '';
    while(position < body.length && (code = $33d5853d8e90d945$var$charCodeAt.call(body, position)) !== null){
        // Closing Triple-Quote (""")
        if (code === 34 && $33d5853d8e90d945$var$charCodeAt.call(body, position + 1) === 34 && $33d5853d8e90d945$var$charCodeAt.call(body, position + 2) === 34) {
            rawValue += $33d5853d8e90d945$var$slice.call(body, chunkStart, position);
            return new $33d5853d8e90d945$var$Tok($33d5853d8e90d945$var$TokenKind.BLOCK_STRING, start, position + 3, line, col, prev, (0, $33d5853d8e90d945$var$_blockStringValue.default)(rawValue));
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) throw (0, $iOpAS.syntaxError)(source, position, "Invalid character within String: ".concat($33d5853d8e90d945$var$printCharCode(code), "."));
         // Escape Triple-Quote (\""")
        if (code === 92 && $33d5853d8e90d945$var$charCodeAt.call(body, position + 1) === 34 && $33d5853d8e90d945$var$charCodeAt.call(body, position + 2) === 34 && $33d5853d8e90d945$var$charCodeAt.call(body, position + 3) === 34) {
            rawValue += $33d5853d8e90d945$var$slice.call(body, chunkStart, position) + '"""';
            position += 4;
            chunkStart = position;
        } else ++position;
    }
    throw (0, $iOpAS.syntaxError)(source, position, 'Unterminated string.');
}
/**
 * Converts four hexidecimal chars to the integer that the
 * string represents. For example, uniCharCode('0','0','0','f')
 * will return 15, and uniCharCode('0','0','f','f') returns 255.
 *
 * Returns a negative number on error, if a char was invalid.
 *
 * This is implemented by noting that char2hex() returns -1 on error,
 * which means the result of ORing the char2hex() will also be negative.
 */ function $33d5853d8e90d945$var$uniCharCode(a, b, c, d) {
    return $33d5853d8e90d945$var$char2hex(a) << 12 | $33d5853d8e90d945$var$char2hex(b) << 8 | $33d5853d8e90d945$var$char2hex(c) << 4 | $33d5853d8e90d945$var$char2hex(d);
}
/**
 * Converts a hex character to its integer value.
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 on error.
 */ function $33d5853d8e90d945$var$char2hex(a) {
    return a >= 48 && a <= 57 ? a - 48 // 0-9
     : a >= 65 && a <= 70 ? a - 55 // A-F
     : a >= 97 && a <= 102 ? a - 87 // a-f
     : -1;
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * [_A-Za-z][_0-9A-Za-z]*
 */ function $33d5853d8e90d945$var$readName(source, start, line, col, prev) {
    var body = source.body;
    var bodyLength = body.length;
    var position = start + 1;
    var code = 0;
    while(position !== bodyLength && (code = $33d5853d8e90d945$var$charCodeAt.call(body, position)) !== null && (code === 95 || // _
    code >= 48 && code <= 57 || // 0-9
    code >= 65 && code <= 90 || // A-Z
    code >= 97 && code <= 122 // a-z
    ))++position;
    return new $33d5853d8e90d945$var$Tok($33d5853d8e90d945$var$TokenKind.NAME, start, position, line, col, prev, $33d5853d8e90d945$var$slice.call(body, start, position));
}

});
parcelRegister("bQjcM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $89f372c102391fa8$var$blockStringValue;
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */ /**
 * Produces the value of a block string from its parsed raw value, similar to
 * Coffeescript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 */ function $89f372c102391fa8$var$blockStringValue(rawString) {
    // Expand a block string's raw value into independent lines.
    var lines = rawString.split(/\r\n|[\n\r]/g); // Remove common indentation from all lines but first.
    var commonIndent = null;
    for(var i = 1; i < lines.length; i++){
        var line = lines[i];
        var indent = $89f372c102391fa8$var$leadingWhitespace(line);
        if (indent < line.length && (commonIndent === null || indent < commonIndent)) {
            commonIndent = indent;
            if (commonIndent === 0) break;
        }
    }
    if (commonIndent) for(var _i = 1; _i < lines.length; _i++)lines[_i] = lines[_i].slice(commonIndent);
     // Remove leading and trailing blank lines.
    while(lines.length > 0 && $89f372c102391fa8$var$isBlank(lines[0]))lines.shift();
    while(lines.length > 0 && $89f372c102391fa8$var$isBlank(lines[lines.length - 1]))lines.pop();
     // Return a string of the lines joined with U+000A.
    return lines.join('\n');
}
function $89f372c102391fa8$var$leadingWhitespace(str) {
    var i = 0;
    while(i < str.length && (str[i] === ' ' || str[i] === '\t'))i++;
    return i;
}
function $89f372c102391fa8$var$isBlank(str) {
    return $89f372c102391fa8$var$leadingWhitespace(str) === str.length;
}

});


parcelRegister("27ePX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Kind = void 0;
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */ /**
 * The set of allowed kind values for AST nodes.
 */ var $18a7be8510a70d2a$var$Kind = Object.freeze({
    // Name
    NAME: 'Name',
    // Document
    DOCUMENT: 'Document',
    OPERATION_DEFINITION: 'OperationDefinition',
    VARIABLE_DEFINITION: 'VariableDefinition',
    SELECTION_SET: 'SelectionSet',
    FIELD: 'Field',
    ARGUMENT: 'Argument',
    // Fragments
    FRAGMENT_SPREAD: 'FragmentSpread',
    INLINE_FRAGMENT: 'InlineFragment',
    FRAGMENT_DEFINITION: 'FragmentDefinition',
    // Values
    VARIABLE: 'Variable',
    INT: 'IntValue',
    FLOAT: 'FloatValue',
    STRING: 'StringValue',
    BOOLEAN: 'BooleanValue',
    NULL: 'NullValue',
    ENUM: 'EnumValue',
    LIST: 'ListValue',
    OBJECT: 'ObjectValue',
    OBJECT_FIELD: 'ObjectField',
    // Directives
    DIRECTIVE: 'Directive',
    // Types
    NAMED_TYPE: 'NamedType',
    LIST_TYPE: 'ListType',
    NON_NULL_TYPE: 'NonNullType',
    // Type System Definitions
    SCHEMA_DEFINITION: 'SchemaDefinition',
    OPERATION_TYPE_DEFINITION: 'OperationTypeDefinition',
    // Type Definitions
    SCALAR_TYPE_DEFINITION: 'ScalarTypeDefinition',
    OBJECT_TYPE_DEFINITION: 'ObjectTypeDefinition',
    FIELD_DEFINITION: 'FieldDefinition',
    INPUT_VALUE_DEFINITION: 'InputValueDefinition',
    INTERFACE_TYPE_DEFINITION: 'InterfaceTypeDefinition',
    UNION_TYPE_DEFINITION: 'UnionTypeDefinition',
    ENUM_TYPE_DEFINITION: 'EnumTypeDefinition',
    ENUM_VALUE_DEFINITION: 'EnumValueDefinition',
    INPUT_OBJECT_TYPE_DEFINITION: 'InputObjectTypeDefinition',
    // Directive Definitions
    DIRECTIVE_DEFINITION: 'DirectiveDefinition',
    // Type System Extensions
    SCHEMA_EXTENSION: 'SchemaExtension',
    // Type Extensions
    SCALAR_TYPE_EXTENSION: 'ScalarTypeExtension',
    OBJECT_TYPE_EXTENSION: 'ObjectTypeExtension',
    INTERFACE_TYPE_EXTENSION: 'InterfaceTypeExtension',
    UNION_TYPE_EXTENSION: 'UnionTypeExtension',
    ENUM_TYPE_EXTENSION: 'EnumTypeExtension',
    INPUT_OBJECT_TYPE_EXTENSION: 'InputObjectTypeExtension'
});
/**
 * The enum type representing the possible kind values of AST nodes.
 */ module.exports.Kind = $18a7be8510a70d2a$var$Kind;

});

parcelRegister("bKKxQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DirectiveLocation = void 0;
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */ /**
 * The set of allowed directive location values.
 */ var $88e818688c2a3083$var$DirectiveLocation = Object.freeze({
    // Request Definitions
    QUERY: 'QUERY',
    MUTATION: 'MUTATION',
    SUBSCRIPTION: 'SUBSCRIPTION',
    FIELD: 'FIELD',
    FRAGMENT_DEFINITION: 'FRAGMENT_DEFINITION',
    FRAGMENT_SPREAD: 'FRAGMENT_SPREAD',
    INLINE_FRAGMENT: 'INLINE_FRAGMENT',
    VARIABLE_DEFINITION: 'VARIABLE_DEFINITION',
    // Type System Definitions
    SCHEMA: 'SCHEMA',
    SCALAR: 'SCALAR',
    OBJECT: 'OBJECT',
    FIELD_DEFINITION: 'FIELD_DEFINITION',
    ARGUMENT_DEFINITION: 'ARGUMENT_DEFINITION',
    INTERFACE: 'INTERFACE',
    UNION: 'UNION',
    ENUM: 'ENUM',
    ENUM_VALUE: 'ENUM_VALUE',
    INPUT_OBJECT: 'INPUT_OBJECT',
    INPUT_FIELD_DEFINITION: 'INPUT_FIELD_DEFINITION'
});
/**
 * The enum type representing the directive location values.
 */ module.exports.DirectiveLocation = $88e818688c2a3083$var$DirectiveLocation;

});


parcelRegister("gy3Xv", function(module, exports) {

$parcel$export(module.exports, "CONTROL_MSG", () => $c0c2e4778734f36e$export$f96baa4bc836aea4);
$parcel$export(module.exports, "default", () => $c0c2e4778734f36e$export$2e2bcd8739ae039);
/*
 * Copyright 2017-2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $fZTBN = parcelRequire("fZTBN");

var $c0c2e4778734f36e$export$f96baa4bc836aea4;
(function(CONTROL_MSG) {
    CONTROL_MSG["CONNECTION_CLOSED"] = "Connection closed";
    CONTROL_MSG["CONNECTION_FAILED"] = "Connection failed";
    CONTROL_MSG["REALTIME_SUBSCRIPTION_INIT_ERROR"] = "AppSync Realtime subscription init error";
    CONTROL_MSG["SUBSCRIPTION_ACK"] = "Subscription ack";
    CONTROL_MSG["TIMEOUT_DISCONNECT"] = "Timeout disconnect";
})($c0c2e4778734f36e$export$f96baa4bc836aea4 || ($c0c2e4778734f36e$export$f96baa4bc836aea4 = {}));
var /**
 * @deprecated use named import
 */ $c0c2e4778734f36e$export$2e2bcd8739ae039 = (0, $fZTBN.PubSub);

});
parcelRegister("fZTBN", function(module, exports) {

$parcel$export(module.exports, "PubSub", () => $ba57b037f1b9630a$export$939228aba9bab083);

var $fi57Q = parcelRequire("fi57Q");
parcelRequire("8qWqv");
var $a16qJ = parcelRequire("a16qJ");
var $9Mfkr = parcelRequire("9Mfkr");
var $7UO1b = parcelRequire("7UO1b");
var $6zWMj = parcelRequire("6zWMj");

var $bz7xm = parcelRequire("bz7xm");
var $jGX6r = parcelRequire("jGX6r");
var $ba57b037f1b9630a$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $ba57b037f1b9630a$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $ba57b037f1b9630a$var$isNode = (0, $9Mfkr.browserOrNode)().isNode;
var $ba57b037f1b9630a$var$logger = new (0, $7UO1b.ConsoleLogger)('PubSub');
var $ba57b037f1b9630a$export$583325a4fc78935f = /** @class */ function() {
    /**
     * Initialize PubSub with AWS configurations
     *
     * @param {PubSubOptions} options - Configuration object for PubSub
     */ function PubSubClass(options) {
        this._options = options;
        $ba57b037f1b9630a$var$logger.debug('PubSub Options', this._options);
        this._pluggables = [];
        this.subscribe = this.subscribe.bind(this);
    }
    Object.defineProperty(PubSubClass.prototype, "awsAppSyncProvider", {
        /**
         * Lazy instantiate AWSAppSyncProvider when it is required by the API category
         */ get: function() {
            if (!this._awsAppSyncProvider) this._awsAppSyncProvider = new (0, $bz7xm.AWSAppSyncProvider)(this._options);
            return this._awsAppSyncProvider;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PubSubClass.prototype, "awsAppSyncRealTimeProvider", {
        /**
         * Lazy instantiate AWSAppSyncRealTimeProvider when it is required by the API category
         */ get: function() {
            if (!this._awsAppSyncRealTimeProvider) this._awsAppSyncRealTimeProvider = new (0, $jGX6r.AWSAppSyncRealTimeProvider)(this._options);
            return this._awsAppSyncRealTimeProvider;
        },
        enumerable: true,
        configurable: true
    });
    PubSubClass.prototype.getModuleName = function() {
        return 'PubSub';
    };
    /**
     * Configure PubSub part with configurations
     *
     * @param {PubSubOptions} config - Configuration for PubSub
     * @return {Object} - The current configuration
     */ PubSubClass.prototype.configure = function(options) {
        var _this = this;
        var opt = options ? options.PubSub || options : {};
        $ba57b037f1b9630a$var$logger.debug('configure PubSub', {
            opt: opt
        });
        this._options = Object.assign({}, this._options, opt);
        this._pluggables.map(function(pluggable) {
            return pluggable.configure(_this._options);
        });
        return this._options;
    };
    /**
     * add plugin into Analytics category
     * @param {Object} pluggable - an instance of the plugin
     */ PubSubClass.prototype.addPluggable = function(pluggable) {
        return $ba57b037f1b9630a$var$__awaiter(this, void 0, void 0, function() {
            var config;
            return $ba57b037f1b9630a$var$__generator(this, function(_a) {
                if (pluggable && pluggable.getCategory() === 'PubSub') {
                    this._pluggables.push(pluggable);
                    config = pluggable.configure(this._options);
                    return [
                        2 /*return*/ ,
                        config
                    ];
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    PubSubClass.prototype.getProviderByName = function(providerName) {
        if (providerName === (0, $6zWMj.INTERNAL_AWS_APPSYNC_PUBSUB_PROVIDER)) return this.awsAppSyncProvider;
        if (providerName === (0, $6zWMj.INTERNAL_AWS_APPSYNC_REALTIME_PUBSUB_PROVIDER)) return this.awsAppSyncRealTimeProvider;
        return this._pluggables.find(function(pluggable) {
            return pluggable.getProviderName() === providerName;
        });
    };
    PubSubClass.prototype.getProviders = function(options) {
        if (options === void 0) options = {};
        var providerName = options.provider;
        if (!providerName) return this._pluggables;
        var provider = this.getProviderByName(providerName);
        if (!provider) throw new Error("Could not find provider named " + providerName);
        return [
            provider
        ];
    };
    PubSubClass.prototype.publish = function(topics, msg, options) {
        return $ba57b037f1b9630a$var$__awaiter(this, void 0, void 0, function() {
            return $ba57b037f1b9630a$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    Promise.all(this.getProviders(options).map(function(provider) {
                        return provider.publish(topics, msg, options);
                    }))
                ];
            });
        });
    };
    PubSubClass.prototype.subscribe = function(topics, options) {
        if ($ba57b037f1b9630a$var$isNode && this._options && this._options.ssr) throw new Error('Subscriptions are not supported for Server-Side Rendering (SSR)');
        $ba57b037f1b9630a$var$logger.debug('subscribe options', options);
        var providers = this.getProviders(options);
        return new (0, $fi57Q.default)(function(observer) {
            var observables = providers.map(function(provider) {
                return {
                    provider: provider,
                    observable: provider.subscribe(topics, options)
                };
            });
            var subscriptions = observables.map(function(_a) {
                var provider = _a.provider, observable = _a.observable;
                return observable.subscribe({
                    start: console.error,
                    next: function(value) {
                        return observer.next({
                            provider: provider,
                            value: value
                        });
                    },
                    error: function(error) {
                        return observer.error({
                            provider: provider,
                            error: error
                        });
                    }
                });
            });
            return function() {
                return subscriptions.forEach(function(subscription) {
                    return subscription.unsubscribe();
                });
            };
        });
    };
    return PubSubClass;
}();
var $ba57b037f1b9630a$export$939228aba9bab083 = new $ba57b037f1b9630a$export$583325a4fc78935f(null);
(0, $a16qJ.Amplify).register($ba57b037f1b9630a$export$939228aba9bab083);

});
parcelRegister("bz7xm", function(module, exports) {

$parcel$export(module.exports, "AWSAppSyncProvider", () => $86b8cf4badca378c$export$937fc88a753c4320);

var $fi57Q = parcelRequire("fi57Q");

var $7UO1b = parcelRequire("7UO1b");

var $gARm7 = parcelRequire("gARm7");
var $86b8cf4badca378c$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $86b8cf4badca378c$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $86b8cf4badca378c$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $86b8cf4badca378c$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $86b8cf4badca378c$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $86b8cf4badca378c$var$__spread = undefined && undefined.__spread || function() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($86b8cf4badca378c$var$__read(arguments[i]));
    return ar;
};
var $86b8cf4badca378c$var$logger = new (0, $7UO1b.ConsoleLogger)('AWSAppSyncProvider');
var $86b8cf4badca378c$export$937fc88a753c4320 = /** @class */ function(_super) {
    $86b8cf4badca378c$var$__extends(AWSAppSyncProvider, _super);
    function AWSAppSyncProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._topicClient = new Map();
        _this._topicAlias = new Map();
        return _this;
    }
    Object.defineProperty(AWSAppSyncProvider.prototype, "endpoint", {
        get: function() {
            throw new Error('Not supported');
        },
        enumerable: true,
        configurable: true
    });
    AWSAppSyncProvider.prototype.getProviderName = function() {
        return 'AWSAppSyncProvider';
    };
    AWSAppSyncProvider.prototype.publish = function(topics, msg, options) {
        return $86b8cf4badca378c$var$__awaiter(this, void 0, void 0, function() {
            return $86b8cf4badca378c$var$__generator(this, function(_a) {
                throw new Error('Operation not supported');
            });
        });
    };
    AWSAppSyncProvider.prototype._cleanUp = function(clientId) {
        var _this = this;
        var topicsForClient = Array.from(this._topicClient.entries()).filter(function(_a) {
            var _b = $86b8cf4badca378c$var$__read(_a, 2), c = _b[1];
            return c.clientId === clientId;
        }).map(function(_a) {
            var _b = $86b8cf4badca378c$var$__read(_a, 1), t = _b[0];
            return t;
        });
        topicsForClient.forEach(function(t) {
            return _this._cleanUpForTopic(t);
        });
    };
    AWSAppSyncProvider.prototype._cleanUpForTopic = function(topic) {
        this._topicClient.delete(topic);
        this._topicAlias.delete(topic);
    };
    AWSAppSyncProvider.prototype.onDisconnect = function(_a) {
        var _this = this;
        var clientId = _a.clientId, errorCode = _a.errorCode, args = $86b8cf4badca378c$var$__rest(_a, [
            "clientId",
            "errorCode"
        ]);
        if (errorCode !== 0) {
            var topicsForClient = Array.from(this._topicClient.entries()).filter(function(_a) {
                var _b = $86b8cf4badca378c$var$__read(_a, 2), c = _b[1];
                return c.clientId === clientId;
            }).map(function(_a) {
                var _b = $86b8cf4badca378c$var$__read(_a, 1), t = _b[0];
                return t;
            });
            topicsForClient.forEach(function(topic) {
                if (_this._topicObservers.has(topic)) {
                    _this._topicObservers.get(topic).forEach(function(obs) {
                        if (!obs.closed) obs.error(args);
                    });
                    _this._topicObservers.delete(topic);
                }
            });
            this._cleanUp(clientId);
        }
    };
    AWSAppSyncProvider.prototype.disconnect = function(clientId) {
        return $86b8cf4badca378c$var$__awaiter(this, void 0, void 0, function() {
            var client;
            return $86b8cf4badca378c$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.clientsQueue.get(clientId, function() {
                                return null;
                            })
                        ];
                    case 1:
                        client = _a.sent();
                        return [
                            4 /*yield*/ ,
                            _super.prototype.disconnect.call(this, clientId)
                        ];
                    case 2:
                        _a.sent();
                        this._cleanUp(clientId);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSAppSyncProvider.prototype.subscribe = function(topics, options) {
        var _this = this;
        if (options === void 0) options = {};
        var result = new (0, $fi57Q.default)(function(observer) {
            var targetTopics = [].concat(topics);
            $86b8cf4badca378c$var$logger.debug('Subscribing to topic(s)', targetTopics.join(','));
            (function() {
                return $86b8cf4badca378c$var$__awaiter(_this, void 0, void 0, function() {
                    var _a, mqttConnections, newSubscriptions, newAliases, map;
                    var _this = this;
                    return $86b8cf4badca378c$var$__generator(this, function(_b) {
                        switch(_b.label){
                            case 0:
                                // Add these topics to map
                                targetTopics.forEach(function(t) {
                                    if (!_this._topicObservers.has(t)) _this._topicObservers.set(t, new Set());
                                    _this._topicObservers.get(t).add(observer);
                                });
                                _a = options.mqttConnections, mqttConnections = _a === void 0 ? [] : _a, newSubscriptions = options.newSubscriptions;
                                newAliases = Object.entries(newSubscriptions).map(function(_a) {
                                    var _b = $86b8cf4badca378c$var$__read(_a, 2), alias = _b[0], v = _b[1];
                                    return [
                                        v.topic,
                                        alias
                                    ];
                                });
                                // Merge new aliases with old ones
                                this._topicAlias = new Map($86b8cf4badca378c$var$__spread(Array.from(this._topicAlias.entries()), newAliases));
                                map = Object.entries(targetTopics.reduce(function(acc, elem) {
                                    var connectionInfoForTopic = mqttConnections.find(function(c) {
                                        return c.topics.indexOf(elem) > -1;
                                    });
                                    if (connectionInfoForTopic) {
                                        var clientId = connectionInfoForTopic.client, url = connectionInfoForTopic.url;
                                        if (!acc[clientId]) acc[clientId] = {
                                            url: url,
                                            topics: new Set()
                                        };
                                        acc[clientId].topics.add(elem);
                                    }
                                    return acc;
                                }, {}));
                                // reconnect everything we have in the map
                                return [
                                    4 /*yield*/ ,
                                    Promise.all(map.map(function(_a) {
                                        var _b = $86b8cf4badca378c$var$__read(_a, 2), clientId = _b[0], _c = _b[1], url = _c.url, topics = _c.topics;
                                        return $86b8cf4badca378c$var$__awaiter(_this, void 0, void 0, function() {
                                            var client, err_1;
                                            var _this = this;
                                            return $86b8cf4badca378c$var$__generator(this, function(_d) {
                                                switch(_d.label){
                                                    case 0:
                                                        client = null;
                                                        _d.label = 1;
                                                    case 1:
                                                        _d.trys.push([
                                                            1,
                                                            3,
                                                            ,
                                                            4
                                                        ]);
                                                        return [
                                                            4 /*yield*/ ,
                                                            this.connect(clientId, {
                                                                clientId: clientId,
                                                                url: url
                                                            })
                                                        ];
                                                    case 2:
                                                        client = _d.sent();
                                                        return [
                                                            3 /*break*/ ,
                                                            4
                                                        ];
                                                    case 3:
                                                        err_1 = _d.sent();
                                                        observer.error({
                                                            message: 'Failed to connect',
                                                            error: err_1
                                                        });
                                                        observer.complete();
                                                        return [
                                                            2 /*return*/ ,
                                                            undefined
                                                        ];
                                                    case 4:
                                                        // subscribe to all topics for this client
                                                        // store topic-client mapping
                                                        topics.forEach(function(topic) {
                                                            if (client.isConnected()) {
                                                                client.subscribe(topic);
                                                                _this._topicClient.set(topic, client);
                                                            }
                                                        });
                                                        return [
                                                            2 /*return*/ ,
                                                            client
                                                        ];
                                                }
                                            });
                                        });
                                    }))
                                ];
                            case 1:
                                // reconnect everything we have in the map
                                _b.sent();
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            })();
            return function() {
                $86b8cf4badca378c$var$logger.debug('Unsubscribing from topic(s)', targetTopics.join(','));
                targetTopics.forEach(function(t) {
                    var client = _this._topicClient.get(t);
                    if (client && client.isConnected()) {
                        client.unsubscribe(t);
                        _this._topicClient.delete(t);
                        if (!Array.from(_this._topicClient.values()).some(function(c) {
                            return c === client;
                        })) _this.disconnect(client.clientId);
                    }
                    _this._topicObservers.delete(t);
                });
            };
        });
        return (0, $fi57Q.default).from(result).map(function(value) {
            var topic = _this.getTopicForValue(value);
            var alias = _this._topicAlias.get(topic);
            value.data = Object.entries(value.data).reduce(function(obj, _a) {
                var _b = $86b8cf4badca378c$var$__read(_a, 2), origKey = _b[0], val = _b[1];
                return obj[alias || origKey] = val, obj;
            }, {});
            return value;
        });
    };
    return AWSAppSyncProvider;
}((0, $gARm7.MqttOverWSProvider));

});
parcelRegister("gARm7", function(module, exports) {

$parcel$export(module.exports, "MqttOverWSProvider", () => $c1496579a8f8e5df$export$4e8eac6aa347b425);

var $1woBr = parcelRequire("1woBr");

var $8hnDM = parcelRequire("8hnDM");

var $fi57Q = parcelRequire("fi57Q");

var $gGyGQ = parcelRequire("gGyGQ");

var $7UO1b = parcelRequire("7UO1b");
var $c1496579a8f8e5df$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $c1496579a8f8e5df$var$__assign = undefined && undefined.__assign || function() {
    $c1496579a8f8e5df$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c1496579a8f8e5df$var$__assign.apply(this, arguments);
};
var $c1496579a8f8e5df$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $c1496579a8f8e5df$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $c1496579a8f8e5df$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $c1496579a8f8e5df$var$logger = new (0, $7UO1b.ConsoleLogger)('MqttOverWSProvider');
function $c1496579a8f8e5df$export$4848305770dbede7(filter, topic) {
    var filterArray = filter.split('/');
    var length = filterArray.length;
    var topicArray = topic.split('/');
    for(var i = 0; i < length; ++i){
        var left = filterArray[i];
        var right = topicArray[i];
        if (left === '#') return topicArray.length >= length;
        if (left !== '+' && left !== right) return false;
    }
    return length === topicArray.length;
}
var $c1496579a8f8e5df$var$ClientsQueue = /** @class */ function() {
    function ClientsQueue() {
        this.promises = new Map();
    }
    ClientsQueue.prototype.get = function(clientId, clientFactory) {
        return $c1496579a8f8e5df$var$__awaiter(this, void 0, void 0, function() {
            var promise;
            return $c1496579a8f8e5df$var$__generator(this, function(_a) {
                promise = this.promises.get(clientId);
                if (promise) return [
                    2 /*return*/ ,
                    promise
                ];
                promise = clientFactory(clientId);
                this.promises.set(clientId, promise);
                return [
                    2 /*return*/ ,
                    promise
                ];
            });
        });
    };
    Object.defineProperty(ClientsQueue.prototype, "allClients", {
        get: function() {
            return Array.from(this.promises.keys());
        },
        enumerable: true,
        configurable: true
    });
    ClientsQueue.prototype.remove = function(clientId) {
        this.promises.delete(clientId);
    };
    return ClientsQueue;
}();
var $c1496579a8f8e5df$var$topicSymbol = typeof Symbol !== 'undefined' ? Symbol('topic') : '@@topic';
var $c1496579a8f8e5df$export$4e8eac6aa347b425 = /** @class */ function(_super) {
    $c1496579a8f8e5df$var$__extends(MqttOverWSProvider, _super);
    function MqttOverWSProvider(options) {
        if (options === void 0) options = {};
        var _this = _super.call(this, $c1496579a8f8e5df$var$__assign($c1496579a8f8e5df$var$__assign({}, options), {
            clientId: options.clientId || (0, $8hnDM.v4)()
        })) || this;
        _this._clientsQueue = new $c1496579a8f8e5df$var$ClientsQueue();
        _this._topicObservers = new Map();
        _this._clientIdObservers = new Map();
        return _this;
    }
    Object.defineProperty(MqttOverWSProvider.prototype, "clientId", {
        get: function() {
            return this.options.clientId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MqttOverWSProvider.prototype, "endpoint", {
        get: function() {
            return this.options.aws_pubsub_endpoint;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MqttOverWSProvider.prototype, "clientsQueue", {
        get: function() {
            return this._clientsQueue;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MqttOverWSProvider.prototype, "isSSLEnabled", {
        get: function() {
            return !this.options.aws_appsync_dangerously_connect_to_http_endpoint_for_testing;
        },
        enumerable: true,
        configurable: true
    });
    MqttOverWSProvider.prototype.getTopicForValue = function(value) {
        return typeof value === 'object' && value[$c1496579a8f8e5df$var$topicSymbol];
    };
    MqttOverWSProvider.prototype.getProviderName = function() {
        return 'MqttOverWSProvider';
    };
    MqttOverWSProvider.prototype.onDisconnect = function(_a) {
        var _this = this;
        var clientId = _a.clientId, errorCode = _a.errorCode, args = $c1496579a8f8e5df$var$__rest(_a, [
            "clientId",
            "errorCode"
        ]);
        if (errorCode !== 0) {
            $c1496579a8f8e5df$var$logger.warn(clientId, JSON.stringify($c1496579a8f8e5df$var$__assign({
                errorCode: errorCode
            }, args), null, 2));
            var topicsToDelete_1 = [];
            var clientIdObservers = this._clientIdObservers.get(clientId);
            if (!clientIdObservers) return;
            clientIdObservers.forEach(function(observer) {
                observer.error('Disconnected, error code: ' + errorCode);
                // removing observers for disconnected clientId
                _this._topicObservers.forEach(function(observerForTopic, observerTopic) {
                    observerForTopic.delete(observer);
                    if (observerForTopic.size === 0) topicsToDelete_1.push(observerTopic);
                });
            });
            // forgiving any trace of clientId
            this._clientIdObservers.delete(clientId);
            // Removing topics that are not listen by an observer
            topicsToDelete_1.forEach(function(topic) {
                _this._topicObservers.delete(topic);
            });
        }
    };
    MqttOverWSProvider.prototype.newClient = function(_a) {
        var url = _a.url, clientId = _a.clientId;
        return $c1496579a8f8e5df$var$__awaiter(this, void 0, void 0, function() {
            var client;
            var _this = this;
            return $c1496579a8f8e5df$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        $c1496579a8f8e5df$var$logger.debug('Creating new MQTT client', clientId);
                        client = new $1woBr.Client(url, clientId);
                        // client.trace = (args) => logger.debug(clientId, JSON.stringify(args, null, 2));
                        client.onMessageArrived = function(_a) {
                            var topic = _a.destinationName, msg = _a.payloadString;
                            _this._onMessage(topic, msg);
                        };
                        client.onConnectionLost = function(_a) {
                            var errorCode = _a.errorCode, args = $c1496579a8f8e5df$var$__rest(_a, [
                                "errorCode"
                            ]);
                            _this.onDisconnect($c1496579a8f8e5df$var$__assign({
                                clientId: clientId,
                                errorCode: errorCode
                            }, args));
                        };
                        return [
                            4 /*yield*/ ,
                            new Promise(function(resolve, reject) {
                                client.connect({
                                    useSSL: _this.isSSLEnabled,
                                    mqttVersion: 3,
                                    onSuccess: function() {
                                        return resolve(client);
                                    },
                                    onFailure: reject
                                });
                            })
                        ];
                    case 1:
                        _b.sent();
                        return [
                            2 /*return*/ ,
                            client
                        ];
                }
            });
        });
    };
    MqttOverWSProvider.prototype.connect = function(clientId, options) {
        if (options === void 0) options = {};
        return $c1496579a8f8e5df$var$__awaiter(this, void 0, void 0, function() {
            var _this = this;
            return $c1496579a8f8e5df$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.clientsQueue.get(clientId, function(clientId) {
                                return _this.newClient($c1496579a8f8e5df$var$__assign($c1496579a8f8e5df$var$__assign({}, options), {
                                    clientId: clientId
                                }));
                            })
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    MqttOverWSProvider.prototype.disconnect = function(clientId) {
        return $c1496579a8f8e5df$var$__awaiter(this, void 0, void 0, function() {
            var client;
            return $c1496579a8f8e5df$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.clientsQueue.get(clientId, function() {
                                return null;
                            })
                        ];
                    case 1:
                        client = _a.sent();
                        if (client && client.isConnected()) client.disconnect();
                        this.clientsQueue.remove(clientId);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    MqttOverWSProvider.prototype.publish = function(topics, msg) {
        return $c1496579a8f8e5df$var$__awaiter(this, void 0, void 0, function() {
            var targetTopics, message, url, client;
            return $c1496579a8f8e5df$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        targetTopics = [].concat(topics);
                        message = JSON.stringify(msg);
                        return [
                            4 /*yield*/ ,
                            this.endpoint
                        ];
                    case 1:
                        url = _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.connect(this.clientId, {
                                url: url
                            })
                        ];
                    case 2:
                        client = _a.sent();
                        $c1496579a8f8e5df$var$logger.debug('Publishing to topic(s)', targetTopics.join(','), message);
                        targetTopics.forEach(function(topic) {
                            return client.send(topic, message);
                        });
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    MqttOverWSProvider.prototype._onMessage = function(topic, msg) {
        try {
            var matchedTopicObservers_1 = [];
            this._topicObservers.forEach(function(observerForTopic, observerTopic) {
                if ($c1496579a8f8e5df$export$4848305770dbede7(observerTopic, topic)) matchedTopicObservers_1.push(observerForTopic);
            });
            var parsedMessage_1 = JSON.parse(msg);
            if (typeof parsedMessage_1 === 'object') parsedMessage_1[$c1496579a8f8e5df$var$topicSymbol] = topic;
            matchedTopicObservers_1.forEach(function(observersForTopic) {
                observersForTopic.forEach(function(observer) {
                    return observer.next(parsedMessage_1);
                });
            });
        } catch (error) {
            $c1496579a8f8e5df$var$logger.warn('Error handling message', error, msg);
        }
    };
    MqttOverWSProvider.prototype.subscribe = function(topics, options) {
        var _this = this;
        if (options === void 0) options = {};
        var targetTopics = [].concat(topics);
        $c1496579a8f8e5df$var$logger.debug('Subscribing to topic(s)', targetTopics.join(','));
        return new (0, $fi57Q.default)(function(observer) {
            targetTopics.forEach(function(topic) {
                // this._topicObservers is used to notify the observers according to the topic received on the message
                var observersForTopic = _this._topicObservers.get(topic);
                if (!observersForTopic) {
                    observersForTopic = new Set();
                    _this._topicObservers.set(topic, observersForTopic);
                }
                observersForTopic.add(observer);
            });
            // @ts-ignore
            var client;
            var _a = options.clientId, clientId = _a === void 0 ? _this.clientId : _a;
            // this._clientIdObservers is used to close observers when client gets disconnected
            var observersForClientId = _this._clientIdObservers.get(clientId);
            if (!observersForClientId) observersForClientId = new Set();
            observersForClientId.add(observer);
            _this._clientIdObservers.set(clientId, observersForClientId);
            (function() {
                return $c1496579a8f8e5df$var$__awaiter(_this, void 0, void 0, function() {
                    var _a, url, _b, e_1;
                    return $c1496579a8f8e5df$var$__generator(this, function(_c) {
                        switch(_c.label){
                            case 0:
                                _a = options.url;
                                if (!(_a === void 0)) return [
                                    3 /*break*/ ,
                                    2
                                ];
                                return [
                                    4 /*yield*/ ,
                                    this.endpoint
                                ];
                            case 1:
                                _b = _c.sent();
                                return [
                                    3 /*break*/ ,
                                    3
                                ];
                            case 2:
                                _b = _a;
                                _c.label = 3;
                            case 3:
                                url = _b;
                                _c.label = 4;
                            case 4:
                                _c.trys.push([
                                    4,
                                    6,
                                    ,
                                    7
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    this.connect(clientId, {
                                        url: url
                                    })
                                ];
                            case 5:
                                client = _c.sent();
                                targetTopics.forEach(function(topic) {
                                    client.subscribe(topic);
                                });
                                return [
                                    3 /*break*/ ,
                                    7
                                ];
                            case 6:
                                e_1 = _c.sent();
                                observer.error(e_1);
                                return [
                                    3 /*break*/ ,
                                    7
                                ];
                            case 7:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            })();
            return function() {
                $c1496579a8f8e5df$var$logger.debug('Unsubscribing from topic(s)', targetTopics.join(','));
                if (client) {
                    _this._clientIdObservers.get(clientId).delete(observer);
                    // No more observers per client => client not needed anymore
                    if (_this._clientIdObservers.get(clientId).size === 0) {
                        _this.disconnect(clientId);
                        _this._clientIdObservers.delete(clientId);
                    }
                    targetTopics.forEach(function(topic) {
                        var observersForTopic = _this._topicObservers.get(topic) || new Set();
                        observersForTopic.delete(observer);
                        // if no observers exists for the topic, topic should be removed
                        if (observersForTopic.size === 0) {
                            _this._topicObservers.delete(topic);
                            if (client.isConnected()) client.unsubscribe(topic);
                        }
                    });
                }
                return null;
            };
        });
    };
    return MqttOverWSProvider;
}((0, $gGyGQ.AbstractPubSubProvider));

});
parcelRegister("1woBr", function(module, exports) {
/*******************************************************************************
 * Copyright (c) 2013 IBM Corp.
 *
 * All rights reserved. This program and the accompanying materials
 * are made available under the terms of the Eclipse Public License v1.0
 * and Eclipse Distribution License v1.0 which accompany this distribution.
 *
 * The Eclipse Public License is available at
 *    http://www.eclipse.org/legal/epl-v10.html
 * and the Eclipse Distribution License is available at
 *   http://www.eclipse.org/org/documents/edl-v10.php.
 *
 * Contributors:
 *    Andrew Banks - initial API and implementation and initial documentation
 *******************************************************************************/ // Only expose a single object name in the global namespace.
// Everything must go through this module. Global Paho module
// only has a single public function, client, which returns
// a Paho client object given connection details.
/**
 * Send and receive messages using web browsers.
 * <p>
 * This programming interface lets a JavaScript client application use the MQTT V3.1 or
 * V3.1.1 protocol to connect to an MQTT-supporting messaging server.
 *
 * The function supported includes:
 * <ol>
 * <li>Connecting to and disconnecting from a server. The server is identified by its host name and port number.
 * <li>Specifying options that relate to the communications link with the server,
 * for example the frequency of keep-alive heartbeats, and whether SSL/TLS is required.
 * <li>Subscribing to and receiving messages from MQTT Topics.
 * <li>Publishing messages to MQTT Topics.
 * </ol>
 * <p>
 * The API consists of two main objects:
 * <dl>
 * <dt><b>{@link Paho.Client}</b></dt>
 * <dd>This contains methods that provide the functionality of the API,
 * including provision of callbacks that notify the application when a message
 * arrives from or is delivered to the messaging server,
 * or when the status of its connection to the messaging server changes.</dd>
 * <dt><b>{@link Paho.Message}</b></dt>
 * <dd>This encapsulates the payload of the message along with various attributes
 * associated with its delivery, in particular the destination to which it has
 * been (or is about to be) sent.</dd>
 * </dl>
 * <p>
 * The programming interface validates parameters passed to it, and will throw
 * an Error containing an error message intended for developer use, if it detects
 * an error with any parameter.
 * <p>
 * Example:
 *
 * <code><pre>
var client = new Paho.MQTT.Client(location.hostname, Number(location.port), "clientId");
client.onConnectionLost = onConnectionLost;
client.onMessageArrived = onMessageArrived;
client.connect({onSuccess:onConnect});

function onConnect() {
  // Once a connection has been made, make a subscription and send a message.
  console.log("onConnect");
  client.subscribe("/World");
  var message = new Paho.MQTT.Message("Hello");
  message.destinationName = "/World";
  client.send(message);
};
function onConnectionLost(responseObject) {
  if (responseObject.errorCode !== 0)
	console.log("onConnectionLost:"+responseObject.errorMessage);
};
function onMessageArrived(message) {
  console.log("onMessageArrived:"+message.payloadString);
  client.disconnect();
};
 * </pre></code>
 * @namespace Paho
 */ /* jshint shadow:true */ (function ExportLibrary(root, factory) {
    module.exports = factory();
})(module.exports, function LibraryFactory() {
    var PahoMQTT = function(global1) {
        // Private variables below, these are only visible inside the function closure
        // which is used to define the module.
        var version = "@VERSION@-@BUILDLEVEL@";
        /**
	 * @private
	 */ var localStorage = global1.localStorage || function() {
            var data = {};
            return {
                setItem: function(key, item) {
                    data[key] = item;
                },
                getItem: function(key) {
                    return data[key];
                },
                removeItem: function(key) {
                    delete data[key];
                }
            };
        }();
        /**
	 * Unique message type identifiers, with associated
	 * associated integer values.
	 * @private
	 */ var MESSAGE_TYPE = {
            CONNECT: 1,
            CONNACK: 2,
            PUBLISH: 3,
            PUBACK: 4,
            PUBREC: 5,
            PUBREL: 6,
            PUBCOMP: 7,
            SUBSCRIBE: 8,
            SUBACK: 9,
            UNSUBSCRIBE: 10,
            UNSUBACK: 11,
            PINGREQ: 12,
            PINGRESP: 13,
            DISCONNECT: 14
        };
        // Collection of utility methods used to simplify module code
        // and promote the DRY pattern.
        /**
	 * Validate an object's parameter names to ensure they
	 * match a list of expected variables name for this option
	 * type. Used to ensure option object passed into the API don't
	 * contain erroneous parameters.
	 * @param {Object} obj - User options object
	 * @param {Object} keys - valid keys and types that may exist in obj.
	 * @throws {Error} Invalid option parameter found.
	 * @private
	 */ var validate = function(obj, keys) {
            for(var key in obj)if (obj.hasOwnProperty(key)) {
                if (keys.hasOwnProperty(key)) {
                    if (typeof obj[key] !== keys[key]) throw new Error(format(ERROR.INVALID_TYPE, [
                        typeof obj[key],
                        key
                    ]));
                } else {
                    var errorStr = "Unknown property, " + key + ". Valid properties are:";
                    for(var validKey in keys)if (keys.hasOwnProperty(validKey)) errorStr = errorStr + " " + validKey;
                    throw new Error(errorStr);
                }
            }
        };
        /**
	 * Return a new function which runs the user function bound
	 * to a fixed scope.
	 * @param {function} User function
	 * @param {object} Function scope
	 * @return {function} User function bound to another scope
	 * @private
	 */ var scope = function(f, scope) {
            return function() {
                return f.apply(scope, arguments);
            };
        };
        /**
	 * Unique message type identifiers, with associated
	 * associated integer values.
	 * @private
	 */ var ERROR = {
            OK: {
                code: 0,
                text: "AMQJSC0000I OK."
            },
            CONNECT_TIMEOUT: {
                code: 1,
                text: "AMQJSC0001E Connect timed out."
            },
            SUBSCRIBE_TIMEOUT: {
                code: 2,
                text: "AMQJS0002E Subscribe timed out."
            },
            UNSUBSCRIBE_TIMEOUT: {
                code: 3,
                text: "AMQJS0003E Unsubscribe timed out."
            },
            PING_TIMEOUT: {
                code: 4,
                text: "AMQJS0004E Ping timed out."
            },
            INTERNAL_ERROR: {
                code: 5,
                text: "AMQJS0005E Internal error. Error Message: {0}, Stack trace: {1}"
            },
            CONNACK_RETURNCODE: {
                code: 6,
                text: "AMQJS0006E Bad Connack return code:{0} {1}."
            },
            SOCKET_ERROR: {
                code: 7,
                text: "AMQJS0007E Socket error:{0}."
            },
            SOCKET_CLOSE: {
                code: 8,
                text: "AMQJS0008I Socket closed."
            },
            MALFORMED_UTF: {
                code: 9,
                text: "AMQJS0009E Malformed UTF data:{0} {1} {2}."
            },
            UNSUPPORTED: {
                code: 10,
                text: "AMQJS0010E {0} is not supported by this browser."
            },
            INVALID_STATE: {
                code: 11,
                text: "AMQJS0011E Invalid state {0}."
            },
            INVALID_TYPE: {
                code: 12,
                text: "AMQJS0012E Invalid type {0} for {1}."
            },
            INVALID_ARGUMENT: {
                code: 13,
                text: "AMQJS0013E Invalid argument {0} for {1}."
            },
            UNSUPPORTED_OPERATION: {
                code: 14,
                text: "AMQJS0014E Unsupported operation."
            },
            INVALID_STORED_DATA: {
                code: 15,
                text: "AMQJS0015E Invalid data in local storage key={0} value={1}."
            },
            INVALID_MQTT_MESSAGE_TYPE: {
                code: 16,
                text: "AMQJS0016E Invalid MQTT message type {0}."
            },
            MALFORMED_UNICODE: {
                code: 17,
                text: "AMQJS0017E Malformed Unicode string:{0} {1}."
            },
            BUFFER_FULL: {
                code: 18,
                text: "AMQJS0018E Message buffer is full, maximum buffer size: {0}."
            }
        };
        /** CONNACK RC Meaning. */ var CONNACK_RC = {
            0: "Connection Accepted",
            1: "Connection Refused: unacceptable protocol version",
            2: "Connection Refused: identifier rejected",
            3: "Connection Refused: server unavailable",
            4: "Connection Refused: bad user name or password",
            5: "Connection Refused: not authorized"
        };
        /**
	 * Format an error message text.
	 * @private
	 * @param {error} ERROR value above.
	 * @param {substitutions} [array] substituted into the text.
	 * @return the text with the substitutions made.
	 */ var format = function(error, substitutions) {
            var text = error.text;
            if (substitutions) {
                var field, start;
                for(var i = 0; i < substitutions.length; i++){
                    field = "{" + i + "}";
                    start = text.indexOf(field);
                    if (start > 0) {
                        var part1 = text.substring(0, start);
                        var part2 = text.substring(start + field.length);
                        text = part1 + substitutions[i] + part2;
                    }
                }
            }
            return text;
        };
        //MQTT protocol and version          6    M    Q    I    s    d    p    3
        var MqttProtoIdentifierv3 = [
            0x00,
            0x06,
            0x4d,
            0x51,
            0x49,
            0x73,
            0x64,
            0x70,
            0x03
        ];
        //MQTT proto/version for 311         4    M    Q    T    T    4
        var MqttProtoIdentifierv4 = [
            0x00,
            0x04,
            0x4d,
            0x51,
            0x54,
            0x54,
            0x04
        ];
        /**
	 * Construct an MQTT wire protocol message.
	 * @param type MQTT packet type.
	 * @param options optional wire message attributes.
	 *
	 * Optional properties
	 *
	 * messageIdentifier: message ID in the range [0..65535]
	 * payloadMessage:	Application Message - PUBLISH only
	 * connectStrings:	array of 0 or more Strings to be put into the CONNECT payload
	 * topics:			array of strings (SUBSCRIBE, UNSUBSCRIBE)
	 * requestQoS:		array of QoS values [0..2]
	 *
	 * "Flag" properties
	 * cleanSession:	true if present / false if absent (CONNECT)
	 * willMessage:  	true if present / false if absent (CONNECT)
	 * isRetained:		true if present / false if absent (CONNECT)
	 * userName:		true if present / false if absent (CONNECT)
	 * password:		true if present / false if absent (CONNECT)
	 * keepAliveInterval:	integer [0..65535]  (CONNECT)
	 *
	 * @private
	 * @ignore
	 */ var WireMessage = function(type, options) {
            this.type = type;
            for(var name in options)if (options.hasOwnProperty(name)) this[name] = options[name];
        };
        WireMessage.prototype.encode = function() {
            // Compute the first byte of the fixed header
            var first = (this.type & 0x0f) << 4;
            /*
		 * Now calculate the length of the variable header + payload by adding up the lengths
		 * of all the component parts
		 */ var remLength = 0;
            var topicStrLength = [];
            var destinationNameLength = 0;
            var willMessagePayloadBytes;
            // if the message contains a messageIdentifier then we need two bytes for that
            if (this.messageIdentifier !== undefined) remLength += 2;
            switch(this.type){
                // If this a Connect then we need to include 12 bytes for its header
                case MESSAGE_TYPE.CONNECT:
                    switch(this.mqttVersion){
                        case 3:
                            remLength += MqttProtoIdentifierv3.length + 3;
                            break;
                        case 4:
                            remLength += MqttProtoIdentifierv4.length + 3;
                            break;
                    }
                    remLength += UTF8Length(this.clientId) + 2;
                    if (this.willMessage !== undefined) {
                        remLength += UTF8Length(this.willMessage.destinationName) + 2;
                        // Will message is always a string, sent as UTF-8 characters with a preceding length.
                        willMessagePayloadBytes = this.willMessage.payloadBytes;
                        if (!(willMessagePayloadBytes instanceof Uint8Array)) willMessagePayloadBytes = new Uint8Array(payloadBytes);
                        remLength += willMessagePayloadBytes.byteLength + 2;
                    }
                    if (this.userName !== undefined) remLength += UTF8Length(this.userName) + 2;
                    if (this.password !== undefined) remLength += UTF8Length(this.password) + 2;
                    break;
                // Subscribe, Unsubscribe can both contain topic strings
                case MESSAGE_TYPE.SUBSCRIBE:
                    first |= 0x02; // Qos = 1;
                    for(var i = 0; i < this.topics.length; i++){
                        topicStrLength[i] = UTF8Length(this.topics[i]);
                        remLength += topicStrLength[i] + 2;
                    }
                    remLength += this.requestedQos.length; // 1 byte for each topic's Qos
                    break;
                case MESSAGE_TYPE.UNSUBSCRIBE:
                    first |= 0x02; // Qos = 1;
                    for(var i = 0; i < this.topics.length; i++){
                        topicStrLength[i] = UTF8Length(this.topics[i]);
                        remLength += topicStrLength[i] + 2;
                    }
                    break;
                case MESSAGE_TYPE.PUBREL:
                    first |= 0x02; // Qos = 1;
                    break;
                case MESSAGE_TYPE.PUBLISH:
                    if (this.payloadMessage.duplicate) first |= 0x08;
                    first = first |= this.payloadMessage.qos << 1;
                    if (this.payloadMessage.retained) first |= 0x01;
                    destinationNameLength = UTF8Length(this.payloadMessage.destinationName);
                    remLength += destinationNameLength + 2;
                    var payloadBytes = this.payloadMessage.payloadBytes;
                    remLength += payloadBytes.byteLength;
                    if (payloadBytes instanceof ArrayBuffer) payloadBytes = new Uint8Array(payloadBytes);
                    else if (!(payloadBytes instanceof Uint8Array)) payloadBytes = new Uint8Array(payloadBytes.buffer);
                    break;
                case MESSAGE_TYPE.DISCONNECT:
                    break;
                default:
                    break;
            }
            // Now we can allocate a buffer for the message
            var mbi = encodeMBI(remLength); // Convert the length to MQTT MBI format
            var pos = mbi.length + 1; // Offset of start of variable header
            var buffer = new ArrayBuffer(remLength + pos);
            var byteStream = new Uint8Array(buffer); // view it as a sequence of bytes
            //Write the fixed header into the buffer
            byteStream[0] = first;
            byteStream.set(mbi, 1);
            // If this is a PUBLISH then the variable header starts with a topic
            if (this.type == MESSAGE_TYPE.PUBLISH) pos = writeString(this.payloadMessage.destinationName, destinationNameLength, byteStream, pos);
            else if (this.type == MESSAGE_TYPE.CONNECT) {
                switch(this.mqttVersion){
                    case 3:
                        byteStream.set(MqttProtoIdentifierv3, pos);
                        pos += MqttProtoIdentifierv3.length;
                        break;
                    case 4:
                        byteStream.set(MqttProtoIdentifierv4, pos);
                        pos += MqttProtoIdentifierv4.length;
                        break;
                }
                var connectFlags = 0;
                if (this.cleanSession) connectFlags = 0x02;
                if (this.willMessage !== undefined) {
                    connectFlags |= 0x04;
                    connectFlags |= this.willMessage.qos << 3;
                    if (this.willMessage.retained) connectFlags |= 0x20;
                }
                if (this.userName !== undefined) connectFlags |= 0x80;
                if (this.password !== undefined) connectFlags |= 0x40;
                byteStream[pos++] = connectFlags;
                pos = writeUint16(this.keepAliveInterval, byteStream, pos);
            }
            // Output the messageIdentifier - if there is one
            if (this.messageIdentifier !== undefined) pos = writeUint16(this.messageIdentifier, byteStream, pos);
            switch(this.type){
                case MESSAGE_TYPE.CONNECT:
                    pos = writeString(this.clientId, UTF8Length(this.clientId), byteStream, pos);
                    if (this.willMessage !== undefined) {
                        pos = writeString(this.willMessage.destinationName, UTF8Length(this.willMessage.destinationName), byteStream, pos);
                        pos = writeUint16(willMessagePayloadBytes.byteLength, byteStream, pos);
                        byteStream.set(willMessagePayloadBytes, pos);
                        pos += willMessagePayloadBytes.byteLength;
                    }
                    if (this.userName !== undefined) pos = writeString(this.userName, UTF8Length(this.userName), byteStream, pos);
                    if (this.password !== undefined) pos = writeString(this.password, UTF8Length(this.password), byteStream, pos);
                    break;
                case MESSAGE_TYPE.PUBLISH:
                    // PUBLISH has a text or binary payload, if text do not add a 2 byte length field, just the UTF characters.
                    byteStream.set(payloadBytes, pos);
                    break;
                //    	    case MESSAGE_TYPE.PUBREC:
                //    	    case MESSAGE_TYPE.PUBREL:
                //    	    case MESSAGE_TYPE.PUBCOMP:
                //    	    	break;
                case MESSAGE_TYPE.SUBSCRIBE:
                    // SUBSCRIBE has a list of topic strings and request QoS
                    for(var i = 0; i < this.topics.length; i++){
                        pos = writeString(this.topics[i], topicStrLength[i], byteStream, pos);
                        byteStream[pos++] = this.requestedQos[i];
                    }
                    break;
                case MESSAGE_TYPE.UNSUBSCRIBE:
                    // UNSUBSCRIBE has a list of topic strings
                    for(var i = 0; i < this.topics.length; i++)pos = writeString(this.topics[i], topicStrLength[i], byteStream, pos);
                    break;
                default:
            }
            return buffer;
        };
        function decodeMessage(input, pos) {
            var startingPos = pos;
            var first = input[pos];
            var type = first >> 4;
            var messageInfo = first &= 0x0f;
            pos += 1;
            // Decode the remaining length (MBI format)
            var digit;
            var remLength = 0;
            var multiplier = 1;
            do {
                if (pos == input.length) return [
                    null,
                    startingPos
                ];
                digit = input[pos++];
                remLength += (digit & 0x7F) * multiplier;
                multiplier *= 128;
            }while ((digit & 0x80) !== 0);
            var endPos = pos + remLength;
            if (endPos > input.length) return [
                null,
                startingPos
            ];
            var wireMessage = new WireMessage(type);
            switch(type){
                case MESSAGE_TYPE.CONNACK:
                    var connectAcknowledgeFlags = input[pos++];
                    if (connectAcknowledgeFlags & 0x01) wireMessage.sessionPresent = true;
                    wireMessage.returnCode = input[pos++];
                    break;
                case MESSAGE_TYPE.PUBLISH:
                    var qos = messageInfo >> 1 & 0x03;
                    var len = readUint16(input, pos);
                    pos += 2;
                    var topicName = parseUTF8(input, pos, len);
                    pos += len;
                    // If QoS 1 or 2 there will be a messageIdentifier
                    if (qos > 0) {
                        wireMessage.messageIdentifier = readUint16(input, pos);
                        pos += 2;
                    }
                    var message = new Message(input.subarray(pos, endPos));
                    if ((messageInfo & 0x01) == 0x01) message.retained = true;
                    if ((messageInfo & 0x08) == 0x08) message.duplicate = true;
                    message.qos = qos;
                    message.destinationName = topicName;
                    wireMessage.payloadMessage = message;
                    break;
                case MESSAGE_TYPE.PUBACK:
                case MESSAGE_TYPE.PUBREC:
                case MESSAGE_TYPE.PUBREL:
                case MESSAGE_TYPE.PUBCOMP:
                case MESSAGE_TYPE.UNSUBACK:
                    wireMessage.messageIdentifier = readUint16(input, pos);
                    break;
                case MESSAGE_TYPE.SUBACK:
                    wireMessage.messageIdentifier = readUint16(input, pos);
                    pos += 2;
                    wireMessage.returnCode = input.subarray(pos, endPos);
                    break;
                default:
                    break;
            }
            return [
                wireMessage,
                endPos
            ];
        }
        function writeUint16(input, buffer, offset) {
            buffer[offset++] = input >> 8; //MSB
            buffer[offset++] = input % 256; //LSB
            return offset;
        }
        function writeString(input, utf8Length, buffer, offset) {
            offset = writeUint16(utf8Length, buffer, offset);
            stringToUTF8(input, buffer, offset);
            return offset + utf8Length;
        }
        function readUint16(buffer, offset) {
            return 256 * buffer[offset] + buffer[offset + 1];
        }
        /**
	 * Encodes an MQTT Multi-Byte Integer
	 * @private
	 */ function encodeMBI(number) {
            var output = new Array(1);
            var numBytes = 0;
            do {
                var digit = number % 128;
                number = number >> 7;
                if (number > 0) digit |= 0x80;
                output[numBytes++] = digit;
            }while (number > 0 && numBytes < 4);
            return output;
        }
        /**
	 * Takes a String and calculates its length in bytes when encoded in UTF8.
	 * @private
	 */ function UTF8Length(input) {
            var output = 0;
            for(var i = 0; i < input.length; i++){
                var charCode = input.charCodeAt(i);
                if (charCode > 0x7FF) {
                    // Surrogate pair means its a 4 byte character
                    if (0xD800 <= charCode && charCode <= 0xDBFF) {
                        i++;
                        output++;
                    }
                    output += 3;
                } else if (charCode > 0x7F) output += 2;
                else output++;
            }
            return output;
        }
        /**
	 * Takes a String and writes it into an array as UTF8 encoded bytes.
	 * @private
	 */ function stringToUTF8(input, output, start) {
            var pos = start;
            for(var i = 0; i < input.length; i++){
                var charCode = input.charCodeAt(i);
                // Check for a surrogate pair.
                if (0xD800 <= charCode && charCode <= 0xDBFF) {
                    var lowCharCode = input.charCodeAt(++i);
                    if (isNaN(lowCharCode)) throw new Error(format(ERROR.MALFORMED_UNICODE, [
                        charCode,
                        lowCharCode
                    ]));
                    charCode = (charCode - 0xD800 << 10) + (lowCharCode - 0xDC00) + 0x10000;
                }
                if (charCode <= 0x7F) output[pos++] = charCode;
                else if (charCode <= 0x7FF) {
                    output[pos++] = charCode >> 6 & 0x1F | 0xC0;
                    output[pos++] = charCode & 0x3F | 0x80;
                } else if (charCode <= 0xFFFF) {
                    output[pos++] = charCode >> 12 & 0x0F | 0xE0;
                    output[pos++] = charCode >> 6 & 0x3F | 0x80;
                    output[pos++] = charCode & 0x3F | 0x80;
                } else {
                    output[pos++] = charCode >> 18 & 0x07 | 0xF0;
                    output[pos++] = charCode >> 12 & 0x3F | 0x80;
                    output[pos++] = charCode >> 6 & 0x3F | 0x80;
                    output[pos++] = charCode & 0x3F | 0x80;
                }
            }
            return output;
        }
        function parseUTF8(input, offset, length) {
            var output = "";
            var utf16;
            var pos = offset;
            while(pos < offset + length){
                var byte1 = input[pos++];
                if (byte1 < 128) utf16 = byte1;
                else {
                    var byte2 = input[pos++] - 128;
                    if (byte2 < 0) throw new Error(format(ERROR.MALFORMED_UTF, [
                        byte1.toString(16),
                        byte2.toString(16),
                        ""
                    ]));
                    if (byte1 < 0xE0) utf16 = 64 * (byte1 - 0xC0) + byte2;
                    else {
                        var byte3 = input[pos++] - 128;
                        if (byte3 < 0) throw new Error(format(ERROR.MALFORMED_UTF, [
                            byte1.toString(16),
                            byte2.toString(16),
                            byte3.toString(16)
                        ]));
                        if (byte1 < 0xF0) utf16 = 4096 * (byte1 - 0xE0) + 64 * byte2 + byte3;
                        else {
                            var byte4 = input[pos++] - 128;
                            if (byte4 < 0) throw new Error(format(ERROR.MALFORMED_UTF, [
                                byte1.toString(16),
                                byte2.toString(16),
                                byte3.toString(16),
                                byte4.toString(16)
                            ]));
                            if (byte1 < 0xF8) utf16 = 262144 * (byte1 - 0xF0) + 4096 * byte2 + 64 * byte3 + byte4;
                            else throw new Error(format(ERROR.MALFORMED_UTF, [
                                byte1.toString(16),
                                byte2.toString(16),
                                byte3.toString(16),
                                byte4.toString(16)
                            ]));
                        }
                    }
                }
                if (utf16 > 0xFFFF) {
                    utf16 -= 0x10000;
                    output += String.fromCharCode(0xD800 + (utf16 >> 10)); // lead character
                    utf16 = 0xDC00 + (utf16 & 0x3FF); // trail character
                }
                output += String.fromCharCode(utf16);
            }
            return output;
        }
        /**
	 * Repeat keepalive requests, monitor responses.
	 * @ignore
	 */ var Pinger = function(client, keepAliveInterval) {
            this._client = client;
            this._keepAliveInterval = keepAliveInterval * 1000;
            this.isReset = false;
            var pingReq = new WireMessage(MESSAGE_TYPE.PINGREQ).encode();
            var doTimeout = function(pinger) {
                return function() {
                    return doPing.apply(pinger);
                };
            };
            /** @ignore */ var doPing = function() {
                if (!this.isReset) {
                    this._client._trace("Pinger.doPing", "Timed out");
                    this._client._disconnected(ERROR.PING_TIMEOUT.code, format(ERROR.PING_TIMEOUT));
                } else {
                    this.isReset = false;
                    this._client._trace("Pinger.doPing", "send PINGREQ");
                    this._client.socket.send(pingReq);
                    this.timeout = setTimeout(doTimeout(this), this._keepAliveInterval);
                }
            };
            this.reset = function() {
                this.isReset = true;
                clearTimeout(this.timeout);
                if (this._keepAliveInterval > 0) this.timeout = setTimeout(doTimeout(this), this._keepAliveInterval);
            };
            this.cancel = function() {
                clearTimeout(this.timeout);
            };
        };
        /**
	 * Monitor request completion.
	 * @ignore
	 */ var Timeout = function(client, timeoutSeconds, action, args) {
            if (!timeoutSeconds) timeoutSeconds = 30;
            var doTimeout = function(action, client, args) {
                return function() {
                    return action.apply(client, args);
                };
            };
            this.timeout = setTimeout(doTimeout(action, client, args), timeoutSeconds * 1000);
            this.cancel = function() {
                clearTimeout(this.timeout);
            };
        };
        /**
	 * Internal implementation of the Websockets MQTT V3.1 client.
	 *
	 * @name Paho.ClientImpl @constructor
	 * @param {String} host the DNS nameof the webSocket host.
	 * @param {Number} port the port number for that host.
	 * @param {String} clientId the MQ client identifier.
	 */ var ClientImpl = function(uri, host, port, path, clientId) {
            // Check dependencies are satisfied in this browser.
            if (!("WebSocket" in global1 && global1.WebSocket !== null)) throw new Error(format(ERROR.UNSUPPORTED, [
                "WebSocket"
            ]));
            if (!("ArrayBuffer" in global1 && global1.ArrayBuffer !== null)) throw new Error(format(ERROR.UNSUPPORTED, [
                "ArrayBuffer"
            ]));
            this._trace("Paho.Client", uri, host, port, path, clientId);
            this.host = host;
            this.port = port;
            this.path = path;
            this.uri = uri;
            this.clientId = clientId;
            this._wsuri = null;
            // Local storagekeys are qualified with the following string.
            // The conditional inclusion of path in the key is for backward
            // compatibility to when the path was not configurable and assumed to
            // be /mqtt
            this._localKey = host + ":" + port + (path != "/mqtt" ? ":" + path : "") + ":" + clientId + ":";
            // Create private instance-only message queue
            // Internal queue of messages to be sent, in sending order.
            this._msg_queue = [];
            this._buffered_msg_queue = [];
            // Messages we have sent and are expecting a response for, indexed by their respective message ids.
            this._sentMessages = {};
            // Messages we have received and acknowleged and are expecting a confirm message for
            // indexed by their respective message ids.
            this._receivedMessages = {};
            // Internal list of callbacks to be executed when messages
            // have been successfully sent over web socket, e.g. disconnect
            // when it doesn't have to wait for ACK, just message is dispatched.
            this._notify_msg_sent = {};
            // Unique identifier for SEND messages, incrementing
            // counter as messages are sent.
            this._message_identifier = 1;
            // Used to determine the transmission sequence of stored sent messages.
            this._sequence = 0;
            // Load the local state, if any, from the saved version, only restore state relevant to this client.
            for(var key in localStorage)if (key.indexOf("Sent:" + this._localKey) === 0 || key.indexOf("Received:" + this._localKey) === 0) this.restore(key);
        };
        // Messaging Client public instance members.
        ClientImpl.prototype.host = null;
        ClientImpl.prototype.port = null;
        ClientImpl.prototype.path = null;
        ClientImpl.prototype.uri = null;
        ClientImpl.prototype.clientId = null;
        // Messaging Client private instance members.
        ClientImpl.prototype.socket = null;
        /* true once we have received an acknowledgement to a CONNECT packet. */ ClientImpl.prototype.connected = false;
        /* The largest message identifier allowed, may not be larger than 2**16 but
		 * if set smaller reduces the maximum number of outbound messages allowed.
		 */ ClientImpl.prototype.maxMessageIdentifier = 65536;
        ClientImpl.prototype.connectOptions = null;
        ClientImpl.prototype.hostIndex = null;
        ClientImpl.prototype.onConnected = null;
        ClientImpl.prototype.onConnectionLost = null;
        ClientImpl.prototype.onMessageDelivered = null;
        ClientImpl.prototype.onMessageArrived = null;
        ClientImpl.prototype.traceFunction = null;
        ClientImpl.prototype._msg_queue = null;
        ClientImpl.prototype._buffered_msg_queue = null;
        ClientImpl.prototype._connectTimeout = null;
        /* The sendPinger monitors how long we allow before we send data to prove to the server that we are alive. */ ClientImpl.prototype.sendPinger = null;
        /* The receivePinger monitors how long we allow before we require evidence that the server is alive. */ ClientImpl.prototype.receivePinger = null;
        ClientImpl.prototype._reconnectInterval = 1; // Reconnect Delay, starts at 1 second
        ClientImpl.prototype._reconnecting = false;
        ClientImpl.prototype._reconnectTimeout = null;
        ClientImpl.prototype.disconnectedPublishing = false;
        ClientImpl.prototype.disconnectedBufferSize = 5000;
        ClientImpl.prototype.receiveBuffer = null;
        ClientImpl.prototype._traceBuffer = null;
        ClientImpl.prototype._MAX_TRACE_ENTRIES = 100;
        ClientImpl.prototype.connect = function(connectOptions) {
            var connectOptionsMasked = this._traceMask(connectOptions, "password");
            this._trace("Client.connect", connectOptionsMasked, this.socket, this.connected);
            if (this.connected) throw new Error(format(ERROR.INVALID_STATE, [
                "already connected"
            ]));
            if (this.socket) throw new Error(format(ERROR.INVALID_STATE, [
                "already connected"
            ]));
            if (this._reconnecting) {
                // connect() function is called while reconnect is in progress.
                // Terminate the auto reconnect process to use new connect options.
                this._reconnectTimeout.cancel();
                this._reconnectTimeout = null;
                this._reconnecting = false;
            }
            this.connectOptions = connectOptions;
            this._reconnectInterval = 1;
            this._reconnecting = false;
            if (connectOptions.uris) {
                this.hostIndex = 0;
                this._doConnect(connectOptions.uris[0]);
            } else this._doConnect(this.uri);
        };
        ClientImpl.prototype.subscribe = function(filter, subscribeOptions) {
            this._trace("Client.subscribe", filter, subscribeOptions);
            if (!this.connected) throw new Error(format(ERROR.INVALID_STATE, [
                "not connected"
            ]));
            var wireMessage = new WireMessage(MESSAGE_TYPE.SUBSCRIBE);
            wireMessage.topics = filter.constructor === Array ? filter : [
                filter
            ];
            if (subscribeOptions.qos === undefined) subscribeOptions.qos = 0;
            wireMessage.requestedQos = [];
            for(var i = 0; i < wireMessage.topics.length; i++)wireMessage.requestedQos[i] = subscribeOptions.qos;
            if (subscribeOptions.onSuccess) wireMessage.onSuccess = function(grantedQos) {
                subscribeOptions.onSuccess({
                    invocationContext: subscribeOptions.invocationContext,
                    grantedQos: grantedQos
                });
            };
            if (subscribeOptions.onFailure) wireMessage.onFailure = function(errorCode) {
                subscribeOptions.onFailure({
                    invocationContext: subscribeOptions.invocationContext,
                    errorCode: errorCode,
                    errorMessage: format(errorCode)
                });
            };
            if (subscribeOptions.timeout) wireMessage.timeOut = new Timeout(this, subscribeOptions.timeout, subscribeOptions.onFailure, [
                {
                    invocationContext: subscribeOptions.invocationContext,
                    errorCode: ERROR.SUBSCRIBE_TIMEOUT.code,
                    errorMessage: format(ERROR.SUBSCRIBE_TIMEOUT)
                }
            ]);
            // All subscriptions return a SUBACK.
            this._requires_ack(wireMessage);
            this._schedule_message(wireMessage);
        };
        /** @ignore */ ClientImpl.prototype.unsubscribe = function(filter, unsubscribeOptions) {
            this._trace("Client.unsubscribe", filter, unsubscribeOptions);
            if (!this.connected) throw new Error(format(ERROR.INVALID_STATE, [
                "not connected"
            ]));
            var wireMessage = new WireMessage(MESSAGE_TYPE.UNSUBSCRIBE);
            wireMessage.topics = filter.constructor === Array ? filter : [
                filter
            ];
            if (unsubscribeOptions.onSuccess) wireMessage.callback = function() {
                unsubscribeOptions.onSuccess({
                    invocationContext: unsubscribeOptions.invocationContext
                });
            };
            if (unsubscribeOptions.timeout) wireMessage.timeOut = new Timeout(this, unsubscribeOptions.timeout, unsubscribeOptions.onFailure, [
                {
                    invocationContext: unsubscribeOptions.invocationContext,
                    errorCode: ERROR.UNSUBSCRIBE_TIMEOUT.code,
                    errorMessage: format(ERROR.UNSUBSCRIBE_TIMEOUT)
                }
            ]);
            // All unsubscribes return a SUBACK.
            this._requires_ack(wireMessage);
            this._schedule_message(wireMessage);
        };
        ClientImpl.prototype.send = function(message) {
            this._trace("Client.send", message);
            var wireMessage = new WireMessage(MESSAGE_TYPE.PUBLISH);
            wireMessage.payloadMessage = message;
            if (this.connected) {
                // Mark qos 1 & 2 message as "ACK required"
                // For qos 0 message, invoke onMessageDelivered callback if there is one.
                // Then schedule the message.
                if (message.qos > 0) this._requires_ack(wireMessage);
                else if (this.onMessageDelivered) this._notify_msg_sent[wireMessage] = this.onMessageDelivered(wireMessage.payloadMessage);
                this._schedule_message(wireMessage);
            } else {
                // Currently disconnected, will not schedule this message
                // Check if reconnecting is in progress and disconnected publish is enabled.
                if (this._reconnecting && this.disconnectedPublishing) {
                    // Check the limit which include the "required ACK" messages
                    var messageCount = Object.keys(this._sentMessages).length + this._buffered_msg_queue.length;
                    if (messageCount > this.disconnectedBufferSize) throw new Error(format(ERROR.BUFFER_FULL, [
                        this.disconnectedBufferSize
                    ]));
                    else if (message.qos > 0) // Mark this message as "ACK required"
                    this._requires_ack(wireMessage);
                    else {
                        wireMessage.sequence = ++this._sequence;
                        // Add messages in fifo order to array, by adding to start
                        this._buffered_msg_queue.unshift(wireMessage);
                    }
                } else throw new Error(format(ERROR.INVALID_STATE, [
                    "not connected"
                ]));
            }
        };
        ClientImpl.prototype.disconnect = function() {
            this._trace("Client.disconnect");
            if (this._reconnecting) {
                // disconnect() function is called while reconnect is in progress.
                // Terminate the auto reconnect process.
                this._reconnectTimeout.cancel();
                this._reconnectTimeout = null;
                this._reconnecting = false;
            }
            if (!this.socket) throw new Error(format(ERROR.INVALID_STATE, [
                "not connecting or connected"
            ]));
            var wireMessage = new WireMessage(MESSAGE_TYPE.DISCONNECT);
            // Run the disconnected call back as soon as the message has been sent,
            // in case of a failure later on in the disconnect processing.
            // as a consequence, the _disconected call back may be run several times.
            this._notify_msg_sent[wireMessage] = scope(this._disconnected, this);
            this._schedule_message(wireMessage);
        };
        ClientImpl.prototype.getTraceLog = function() {
            if (this._traceBuffer !== null) {
                this._trace("Client.getTraceLog", new Date());
                this._trace("Client.getTraceLog in flight messages", this._sentMessages.length);
                for(var key in this._sentMessages)this._trace("_sentMessages ", key, this._sentMessages[key]);
                for(var key in this._receivedMessages)this._trace("_receivedMessages ", key, this._receivedMessages[key]);
                return this._traceBuffer;
            }
        };
        ClientImpl.prototype.startTrace = function() {
            if (this._traceBuffer === null) this._traceBuffer = [];
            this._trace("Client.startTrace", new Date(), version);
        };
        ClientImpl.prototype.stopTrace = function() {
            delete this._traceBuffer;
        };
        ClientImpl.prototype._doConnect = function(wsurl) {
            // When the socket is open, this client will send the CONNECT WireMessage using the saved parameters.
            if (this.connectOptions.useSSL) {
                var uriParts = wsurl.split(":");
                uriParts[0] = "wss";
                wsurl = uriParts.join(":");
            }
            this._wsuri = wsurl;
            this.connected = false;
            if (this.connectOptions.mqttVersion < 4) this.socket = new WebSocket(wsurl, [
                "mqttv3.1"
            ]);
            else this.socket = new WebSocket(wsurl, [
                "mqtt"
            ]);
            this.socket.binaryType = "arraybuffer";
            this.socket.onopen = scope(this._on_socket_open, this);
            this.socket.onmessage = scope(this._on_socket_message, this);
            this.socket.onerror = scope(this._on_socket_error, this);
            this.socket.onclose = scope(this._on_socket_close, this);
            this.sendPinger = new Pinger(this, this.connectOptions.keepAliveInterval);
            this.receivePinger = new Pinger(this, this.connectOptions.keepAliveInterval);
            if (this._connectTimeout) {
                this._connectTimeout.cancel();
                this._connectTimeout = null;
            }
            this._connectTimeout = new Timeout(this, this.connectOptions.timeout, this._disconnected, [
                ERROR.CONNECT_TIMEOUT.code,
                format(ERROR.CONNECT_TIMEOUT)
            ]);
        };
        // Schedule a new message to be sent over the WebSockets
        // connection. CONNECT messages cause WebSocket connection
        // to be started. All other messages are queued internally
        // until this has happened. When WS connection starts, process
        // all outstanding messages.
        ClientImpl.prototype._schedule_message = function(message) {
            // Add messages in fifo order to array, by adding to start
            this._msg_queue.unshift(message);
            // Process outstanding messages in the queue if we have an  open socket, and have received CONNACK.
            if (this.connected) this._process_queue();
        };
        ClientImpl.prototype.store = function(prefix, wireMessage) {
            var storedMessage = {
                type: wireMessage.type,
                messageIdentifier: wireMessage.messageIdentifier,
                version: 1
            };
            switch(wireMessage.type){
                case MESSAGE_TYPE.PUBLISH:
                    if (wireMessage.pubRecReceived) storedMessage.pubRecReceived = true;
                    // Convert the payload to a hex string.
                    storedMessage.payloadMessage = {};
                    var hex = "";
                    var messageBytes = wireMessage.payloadMessage.payloadBytes;
                    for(var i = 0; i < messageBytes.length; i++)if (messageBytes[i] <= 0xF) hex = hex + "0" + messageBytes[i].toString(16);
                    else hex = hex + messageBytes[i].toString(16);
                    storedMessage.payloadMessage.payloadHex = hex;
                    storedMessage.payloadMessage.qos = wireMessage.payloadMessage.qos;
                    storedMessage.payloadMessage.destinationName = wireMessage.payloadMessage.destinationName;
                    if (wireMessage.payloadMessage.duplicate) storedMessage.payloadMessage.duplicate = true;
                    if (wireMessage.payloadMessage.retained) storedMessage.payloadMessage.retained = true;
                    // Add a sequence number to sent messages.
                    if (prefix.indexOf("Sent:") === 0) {
                        if (wireMessage.sequence === undefined) wireMessage.sequence = ++this._sequence;
                        storedMessage.sequence = wireMessage.sequence;
                    }
                    break;
                default:
                    throw Error(format(ERROR.INVALID_STORED_DATA, [
                        prefix + this._localKey + wireMessage.messageIdentifier,
                        storedMessage
                    ]));
            }
            localStorage.setItem(prefix + this._localKey + wireMessage.messageIdentifier, JSON.stringify(storedMessage));
        };
        ClientImpl.prototype.restore = function(key) {
            var value = localStorage.getItem(key);
            var storedMessage = JSON.parse(value);
            var wireMessage = new WireMessage(storedMessage.type, storedMessage);
            switch(storedMessage.type){
                case MESSAGE_TYPE.PUBLISH:
                    // Replace the payload message with a Message object.
                    var hex = storedMessage.payloadMessage.payloadHex;
                    var buffer = new ArrayBuffer(hex.length / 2);
                    var byteStream = new Uint8Array(buffer);
                    var i = 0;
                    while(hex.length >= 2){
                        var x = parseInt(hex.substring(0, 2), 16);
                        hex = hex.substring(2, hex.length);
                        byteStream[i++] = x;
                    }
                    var payloadMessage = new Message(byteStream);
                    payloadMessage.qos = storedMessage.payloadMessage.qos;
                    payloadMessage.destinationName = storedMessage.payloadMessage.destinationName;
                    if (storedMessage.payloadMessage.duplicate) payloadMessage.duplicate = true;
                    if (storedMessage.payloadMessage.retained) payloadMessage.retained = true;
                    wireMessage.payloadMessage = payloadMessage;
                    break;
                default:
                    throw Error(format(ERROR.INVALID_STORED_DATA, [
                        key,
                        value
                    ]));
            }
            if (key.indexOf("Sent:" + this._localKey) === 0) {
                wireMessage.payloadMessage.duplicate = true;
                this._sentMessages[wireMessage.messageIdentifier] = wireMessage;
            } else if (key.indexOf("Received:" + this._localKey) === 0) this._receivedMessages[wireMessage.messageIdentifier] = wireMessage;
        };
        ClientImpl.prototype._process_queue = function() {
            var message = null;
            // Send all queued messages down socket connection
            while(message = this._msg_queue.pop()){
                this._socket_send(message);
                // Notify listeners that message was successfully sent
                if (this._notify_msg_sent[message]) {
                    this._notify_msg_sent[message]();
                    delete this._notify_msg_sent[message];
                }
            }
        };
        /**
	 * Expect an ACK response for this message. Add message to the set of in progress
	 * messages and set an unused identifier in this message.
	 * @ignore
	 */ ClientImpl.prototype._requires_ack = function(wireMessage) {
            var messageCount = Object.keys(this._sentMessages).length;
            if (messageCount > this.maxMessageIdentifier) throw Error("Too many messages:" + messageCount);
            while(this._sentMessages[this._message_identifier] !== undefined)this._message_identifier++;
            wireMessage.messageIdentifier = this._message_identifier;
            this._sentMessages[wireMessage.messageIdentifier] = wireMessage;
            if (wireMessage.type === MESSAGE_TYPE.PUBLISH) this.store("Sent:", wireMessage);
            if (this._message_identifier === this.maxMessageIdentifier) this._message_identifier = 1;
        };
        /**
	 * Called when the underlying websocket has been opened.
	 * @ignore
	 */ ClientImpl.prototype._on_socket_open = function() {
            // Create the CONNECT message object.
            var wireMessage = new WireMessage(MESSAGE_TYPE.CONNECT, this.connectOptions);
            wireMessage.clientId = this.clientId;
            this._socket_send(wireMessage);
        };
        /**
	 * Called when the underlying websocket has received a complete packet.
	 * @ignore
	 */ ClientImpl.prototype._on_socket_message = function(event) {
            this._trace("Client._on_socket_message", event.data);
            var messages = this._deframeMessages(event.data);
            for(var i = 0; i < messages.length; i += 1)this._handleMessage(messages[i]);
        };
        ClientImpl.prototype._deframeMessages = function(data) {
            var byteArray = new Uint8Array(data);
            var messages = [];
            if (this.receiveBuffer) {
                var newData = new Uint8Array(this.receiveBuffer.length + byteArray.length);
                newData.set(this.receiveBuffer);
                newData.set(byteArray, this.receiveBuffer.length);
                byteArray = newData;
                delete this.receiveBuffer;
            }
            try {
                var offset = 0;
                while(offset < byteArray.length){
                    var result = decodeMessage(byteArray, offset);
                    var wireMessage = result[0];
                    offset = result[1];
                    if (wireMessage !== null) messages.push(wireMessage);
                    else break;
                }
                if (offset < byteArray.length) this.receiveBuffer = byteArray.subarray(offset);
            } catch (error) {
                var errorStack = error.hasOwnProperty("stack") == "undefined" ? error.stack.toString() : "No Error Stack Available";
                this._disconnected(ERROR.INTERNAL_ERROR.code, format(ERROR.INTERNAL_ERROR, [
                    error.message,
                    errorStack
                ]));
                return;
            }
            return messages;
        };
        ClientImpl.prototype._handleMessage = function(wireMessage) {
            this._trace("Client._handleMessage", wireMessage);
            try {
                switch(wireMessage.type){
                    case MESSAGE_TYPE.CONNACK:
                        this._connectTimeout.cancel();
                        if (this._reconnectTimeout) this._reconnectTimeout.cancel();
                        // If we have started using clean session then clear up the local state.
                        if (this.connectOptions.cleanSession) {
                            for(var key in this._sentMessages){
                                var sentMessage = this._sentMessages[key];
                                localStorage.removeItem("Sent:" + this._localKey + sentMessage.messageIdentifier);
                            }
                            this._sentMessages = {};
                            for(var key in this._receivedMessages){
                                var receivedMessage = this._receivedMessages[key];
                                localStorage.removeItem("Received:" + this._localKey + receivedMessage.messageIdentifier);
                            }
                            this._receivedMessages = {};
                        }
                        // Client connected and ready for business.
                        if (wireMessage.returnCode === 0) {
                            this.connected = true;
                            // Jump to the end of the list of uris and stop looking for a good host.
                            if (this.connectOptions.uris) this.hostIndex = this.connectOptions.uris.length;
                        } else {
                            this._disconnected(ERROR.CONNACK_RETURNCODE.code, format(ERROR.CONNACK_RETURNCODE, [
                                wireMessage.returnCode,
                                CONNACK_RC[wireMessage.returnCode]
                            ]));
                            break;
                        }
                        // Resend messages.
                        var sequencedMessages = [];
                        for(var msgId in this._sentMessages)if (this._sentMessages.hasOwnProperty(msgId)) sequencedMessages.push(this._sentMessages[msgId]);
                        // Also schedule qos 0 buffered messages if any
                        if (this._buffered_msg_queue.length > 0) {
                            var msg = null;
                            while(msg = this._buffered_msg_queue.pop()){
                                sequencedMessages.push(msg);
                                if (this.onMessageDelivered) this._notify_msg_sent[msg] = this.onMessageDelivered(msg.payloadMessage);
                            }
                        }
                        // Sort sentMessages into the original sent order.
                        var sequencedMessages = sequencedMessages.sort(function(a, b) {
                            return a.sequence - b.sequence;
                        });
                        for(var i = 0, len = sequencedMessages.length; i < len; i++){
                            var sentMessage = sequencedMessages[i];
                            if (sentMessage.type == MESSAGE_TYPE.PUBLISH && sentMessage.pubRecReceived) {
                                var pubRelMessage = new WireMessage(MESSAGE_TYPE.PUBREL, {
                                    messageIdentifier: sentMessage.messageIdentifier
                                });
                                this._schedule_message(pubRelMessage);
                            } else this._schedule_message(sentMessage);
                        }
                        // Execute the connectOptions.onSuccess callback if there is one.
                        // Will also now return if this connection was the result of an automatic
                        // reconnect and which URI was successfully connected to.
                        if (this.connectOptions.onSuccess) this.connectOptions.onSuccess({
                            invocationContext: this.connectOptions.invocationContext
                        });
                        var reconnected = false;
                        if (this._reconnecting) {
                            reconnected = true;
                            this._reconnectInterval = 1;
                            this._reconnecting = false;
                        }
                        // Execute the onConnected callback if there is one.
                        this._connected(reconnected, this._wsuri);
                        // Process all queued messages now that the connection is established.
                        this._process_queue();
                        break;
                    case MESSAGE_TYPE.PUBLISH:
                        this._receivePublish(wireMessage);
                        break;
                    case MESSAGE_TYPE.PUBACK:
                        var sentMessage = this._sentMessages[wireMessage.messageIdentifier];
                        // If this is a re flow of a PUBACK after we have restarted receivedMessage will not exist.
                        if (sentMessage) {
                            delete this._sentMessages[wireMessage.messageIdentifier];
                            localStorage.removeItem("Sent:" + this._localKey + wireMessage.messageIdentifier);
                            if (this.onMessageDelivered) this.onMessageDelivered(sentMessage.payloadMessage);
                        }
                        break;
                    case MESSAGE_TYPE.PUBREC:
                        var sentMessage = this._sentMessages[wireMessage.messageIdentifier];
                        // If this is a re flow of a PUBREC after we have restarted receivedMessage will not exist.
                        if (sentMessage) {
                            sentMessage.pubRecReceived = true;
                            var pubRelMessage = new WireMessage(MESSAGE_TYPE.PUBREL, {
                                messageIdentifier: wireMessage.messageIdentifier
                            });
                            this.store("Sent:", sentMessage);
                            this._schedule_message(pubRelMessage);
                        }
                        break;
                    case MESSAGE_TYPE.PUBREL:
                        var receivedMessage = this._receivedMessages[wireMessage.messageIdentifier];
                        localStorage.removeItem("Received:" + this._localKey + wireMessage.messageIdentifier);
                        // If this is a re flow of a PUBREL after we have restarted receivedMessage will not exist.
                        if (receivedMessage) {
                            this._receiveMessage(receivedMessage);
                            delete this._receivedMessages[wireMessage.messageIdentifier];
                        }
                        // Always flow PubComp, we may have previously flowed PubComp but the server lost it and restarted.
                        var pubCompMessage = new WireMessage(MESSAGE_TYPE.PUBCOMP, {
                            messageIdentifier: wireMessage.messageIdentifier
                        });
                        this._schedule_message(pubCompMessage);
                        break;
                    case MESSAGE_TYPE.PUBCOMP:
                        var sentMessage = this._sentMessages[wireMessage.messageIdentifier];
                        delete this._sentMessages[wireMessage.messageIdentifier];
                        localStorage.removeItem("Sent:" + this._localKey + wireMessage.messageIdentifier);
                        if (this.onMessageDelivered) this.onMessageDelivered(sentMessage.payloadMessage);
                        break;
                    case MESSAGE_TYPE.SUBACK:
                        var sentMessage = this._sentMessages[wireMessage.messageIdentifier];
                        if (sentMessage) {
                            if (sentMessage.timeOut) sentMessage.timeOut.cancel();
                            // This will need to be fixed when we add multiple topic support
                            if (wireMessage.returnCode[0] === 0x80) {
                                if (sentMessage.onFailure) sentMessage.onFailure(wireMessage.returnCode);
                            } else if (sentMessage.onSuccess) sentMessage.onSuccess(wireMessage.returnCode);
                            delete this._sentMessages[wireMessage.messageIdentifier];
                        }
                        break;
                    case MESSAGE_TYPE.UNSUBACK:
                        var sentMessage = this._sentMessages[wireMessage.messageIdentifier];
                        if (sentMessage) {
                            if (sentMessage.timeOut) sentMessage.timeOut.cancel();
                            if (sentMessage.callback) sentMessage.callback();
                            delete this._sentMessages[wireMessage.messageIdentifier];
                        }
                        break;
                    case MESSAGE_TYPE.PINGRESP:
                        /* The sendPinger or receivePinger may have sent a ping, the receivePinger has already been reset. */ this.sendPinger.reset();
                        break;
                    case MESSAGE_TYPE.DISCONNECT:
                        // Clients do not expect to receive disconnect packets.
                        this._disconnected(ERROR.INVALID_MQTT_MESSAGE_TYPE.code, format(ERROR.INVALID_MQTT_MESSAGE_TYPE, [
                            wireMessage.type
                        ]));
                        break;
                    default:
                        this._disconnected(ERROR.INVALID_MQTT_MESSAGE_TYPE.code, format(ERROR.INVALID_MQTT_MESSAGE_TYPE, [
                            wireMessage.type
                        ]));
                }
            } catch (error) {
                var errorStack = error.hasOwnProperty("stack") == "undefined" ? error.stack.toString() : "No Error Stack Available";
                this._disconnected(ERROR.INTERNAL_ERROR.code, format(ERROR.INTERNAL_ERROR, [
                    error.message,
                    errorStack
                ]));
                return;
            }
        };
        /** @ignore */ ClientImpl.prototype._on_socket_error = function(error) {
            if (!this._reconnecting) this._disconnected(ERROR.SOCKET_ERROR.code, format(ERROR.SOCKET_ERROR, [
                error.data
            ]));
        };
        /** @ignore */ ClientImpl.prototype._on_socket_close = function() {
            if (!this._reconnecting) this._disconnected(ERROR.SOCKET_CLOSE.code, format(ERROR.SOCKET_CLOSE));
        };
        /** @ignore */ ClientImpl.prototype._socket_send = function(wireMessage) {
            if (wireMessage.type == 1) {
                var wireMessageMasked = this._traceMask(wireMessage, "password");
                this._trace("Client._socket_send", wireMessageMasked);
            } else this._trace("Client._socket_send", wireMessage);
            this.socket.send(wireMessage.encode());
            /* We have proved to the server we are alive. */ this.sendPinger.reset();
        };
        /** @ignore */ ClientImpl.prototype._receivePublish = function(wireMessage) {
            switch(wireMessage.payloadMessage.qos){
                case "undefined":
                case 0:
                    this._receiveMessage(wireMessage);
                    break;
                case 1:
                    var pubAckMessage = new WireMessage(MESSAGE_TYPE.PUBACK, {
                        messageIdentifier: wireMessage.messageIdentifier
                    });
                    this._schedule_message(pubAckMessage);
                    this._receiveMessage(wireMessage);
                    break;
                case 2:
                    this._receivedMessages[wireMessage.messageIdentifier] = wireMessage;
                    this.store("Received:", wireMessage);
                    var pubRecMessage = new WireMessage(MESSAGE_TYPE.PUBREC, {
                        messageIdentifier: wireMessage.messageIdentifier
                    });
                    this._schedule_message(pubRecMessage);
                    break;
                default:
                    throw Error("Invaild qos=" + wireMessage.payloadMessage.qos);
            }
        };
        /** @ignore */ ClientImpl.prototype._receiveMessage = function(wireMessage) {
            if (this.onMessageArrived) this.onMessageArrived(wireMessage.payloadMessage);
        };
        /**
	 * Client has connected.
	 * @param {reconnect} [boolean] indicate if this was a result of reconnect operation.
	 * @param {uri} [string] fully qualified WebSocket URI of the server.
	 */ ClientImpl.prototype._connected = function(reconnect, uri) {
            // Execute the onConnected callback if there is one.
            if (this.onConnected) this.onConnected(reconnect, uri);
        };
        /**
	 * Attempts to reconnect the client to the server.
   * For each reconnect attempt, will double the reconnect interval
   * up to 128 seconds.
	 */ ClientImpl.prototype._reconnect = function() {
            this._trace("Client._reconnect");
            if (!this.connected) {
                this._reconnecting = true;
                this.sendPinger.cancel();
                this.receivePinger.cancel();
                if (this._reconnectInterval < 128) this._reconnectInterval = this._reconnectInterval * 2;
                if (this.connectOptions.uris) {
                    this.hostIndex = 0;
                    this._doConnect(this.connectOptions.uris[0]);
                } else this._doConnect(this.uri);
            }
        };
        /**
	 * Client has disconnected either at its own request or because the server
	 * or network disconnected it. Remove all non-durable state.
	 * @param {errorCode} [number] the error number.
	 * @param {errorText} [string] the error text.
	 * @ignore
	 */ ClientImpl.prototype._disconnected = function(errorCode, errorText) {
            this._trace("Client._disconnected", errorCode, errorText);
            if (errorCode !== undefined && this._reconnecting) {
                //Continue automatic reconnect process
                this._reconnectTimeout = new Timeout(this, this._reconnectInterval, this._reconnect);
                return;
            }
            this.sendPinger.cancel();
            this.receivePinger.cancel();
            if (this._connectTimeout) {
                this._connectTimeout.cancel();
                this._connectTimeout = null;
            }
            // Clear message buffers.
            this._msg_queue = [];
            this._buffered_msg_queue = [];
            this._notify_msg_sent = {};
            if (this.socket) {
                // Cancel all socket callbacks so that they cannot be driven again by this socket.
                this.socket.onopen = null;
                this.socket.onmessage = null;
                this.socket.onerror = null;
                this.socket.onclose = null;
                if (this.socket.readyState === 1) this.socket.close();
                delete this.socket;
            }
            if (this.connectOptions.uris && this.hostIndex < this.connectOptions.uris.length - 1) {
                // Try the next host.
                this.hostIndex++;
                this._doConnect(this.connectOptions.uris[this.hostIndex]);
            } else {
                if (errorCode === undefined) {
                    errorCode = ERROR.OK.code;
                    errorText = format(ERROR.OK);
                }
                // Run any application callbacks last as they may attempt to reconnect and hence create a new socket.
                if (this.connected) {
                    this.connected = false;
                    // Execute the connectionLostCallback if there is one, and we were connected.
                    if (this.onConnectionLost) this.onConnectionLost({
                        errorCode: errorCode,
                        errorMessage: errorText,
                        reconnect: this.connectOptions.reconnect,
                        uri: this._wsuri
                    });
                    if (errorCode !== ERROR.OK.code && this.connectOptions.reconnect) {
                        // Start automatic reconnect process for the very first time since last successful connect.
                        this._reconnectInterval = 1;
                        this._reconnect();
                        return;
                    }
                } else {
                    // Otherwise we never had a connection, so indicate that the connect has failed.
                    if (this.connectOptions.mqttVersion === 4 && this.connectOptions.mqttVersionExplicit === false) {
                        this._trace("Failed to connect V4, dropping back to V3");
                        this.connectOptions.mqttVersion = 3;
                        if (this.connectOptions.uris) {
                            this.hostIndex = 0;
                            this._doConnect(this.connectOptions.uris[0]);
                        } else this._doConnect(this.uri);
                    } else if (this.connectOptions.onFailure) this.connectOptions.onFailure({
                        invocationContext: this.connectOptions.invocationContext,
                        errorCode: errorCode,
                        errorMessage: errorText
                    });
                }
            }
        };
        /** @ignore */ ClientImpl.prototype._trace = function() {
            // Pass trace message back to client's callback function
            if (this.traceFunction) {
                var args = Array.prototype.slice.call(arguments);
                for(var i in args)if (typeof args[i] !== "undefined") args.splice(i, 1, JSON.stringify(args[i]));
                var record = args.join("");
                this.traceFunction({
                    severity: "Debug",
                    message: record
                });
            }
            //buffer style trace
            if (this._traceBuffer !== null) for(var i = 0, max = arguments.length; i < max; i++){
                if (this._traceBuffer.length == this._MAX_TRACE_ENTRIES) this._traceBuffer.shift();
                if (i === 0) this._traceBuffer.push(arguments[i]);
                else if (typeof arguments[i] === "undefined") this._traceBuffer.push(arguments[i]);
                else this._traceBuffer.push("  " + JSON.stringify(arguments[i]));
            }
        };
        /** @ignore */ ClientImpl.prototype._traceMask = function(traceObject, masked) {
            var traceObjectMasked = {};
            for(var attr in traceObject)if (traceObject.hasOwnProperty(attr)) {
                if (attr == masked) traceObjectMasked[attr] = "******";
                else traceObjectMasked[attr] = traceObject[attr];
            }
            return traceObjectMasked;
        };
        // ------------------------------------------------------------------------
        // Public Programming interface.
        // ------------------------------------------------------------------------
        /**
	 * The JavaScript application communicates to the server using a {@link Paho.Client} object.
	 * <p>
	 * Most applications will create just one Client object and then call its connect() method,
	 * however applications can create more than one Client object if they wish.
	 * In this case the combination of host, port and clientId attributes must be different for each Client object.
	 * <p>
	 * The send, subscribe and unsubscribe methods are implemented as asynchronous JavaScript methods
	 * (even though the underlying protocol exchange might be synchronous in nature).
	 * This means they signal their completion by calling back to the application,
	 * via Success or Failure callback functions provided by the application on the method in question.
	 * Such callbacks are called at most once per method invocation and do not persist beyond the lifetime
	 * of the script that made the invocation.
	 * <p>
	 * In contrast there are some callback functions, most notably <i>onMessageArrived</i>,
	 * that are defined on the {@link Paho.Client} object.
	 * These may get called multiple times, and aren't directly related to specific method invocations made by the client.
	 *
	 * @name Paho.Client
	 *
	 * @constructor
	 *
	 * @param {string} host - the address of the messaging server, as a fully qualified WebSocket URI, as a DNS name or dotted decimal IP address.
	 * @param {number} port - the port number to connect to - only required if host is not a URI
	 * @param {string} path - the path on the host to connect to - only used if host is not a URI. Default: '/mqtt'.
	 * @param {string} clientId - the Messaging client identifier, between 1 and 23 characters in length.
	 *
	 * @property {string} host - <i>read only</i> the server's DNS hostname or dotted decimal IP address.
	 * @property {number} port - <i>read only</i> the server's port.
	 * @property {string} path - <i>read only</i> the server's path.
	 * @property {string} clientId - <i>read only</i> used when connecting to the server.
	 * @property {function} onConnectionLost - called when a connection has been lost.
	 *                            after a connect() method has succeeded.
	 *                            Establish the call back used when a connection has been lost. The connection may be
	 *                            lost because the client initiates a disconnect or because the server or network
	 *                            cause the client to be disconnected. The disconnect call back may be called without
	 *                            the connectionComplete call back being invoked if, for example the client fails to
	 *                            connect.
	 *                            A single response object parameter is passed to the onConnectionLost callback containing the following fields:
	 *                            <ol>
	 *                            <li>errorCode
	 *                            <li>errorMessage
	 *                            </ol>
	 * @property {function} onMessageDelivered - called when a message has been delivered.
	 *                            All processing that this Client will ever do has been completed. So, for example,
	 *                            in the case of a Qos=2 message sent by this client, the PubComp flow has been received from the server
	 *                            and the message has been removed from persistent storage before this callback is invoked.
	 *                            Parameters passed to the onMessageDelivered callback are:
	 *                            <ol>
	 *                            <li>{@link Paho.Message} that was delivered.
	 *                            </ol>
	 * @property {function} onMessageArrived - called when a message has arrived in this Paho.client.
	 *                            Parameters passed to the onMessageArrived callback are:
	 *                            <ol>
	 *                            <li>{@link Paho.Message} that has arrived.
	 *                            </ol>
	 * @property {function} onConnected - called when a connection is successfully made to the server.
	 *                                  after a connect() method.
	 *                                  Parameters passed to the onConnected callback are:
	 *                                  <ol>
	 *                                  <li>reconnect (boolean) - If true, the connection was the result of a reconnect.</li>
	 *                                  <li>URI (string) - The URI used to connect to the server.</li>
	 *                                  </ol>
	 * @property {boolean} disconnectedPublishing - if set, will enable disconnected publishing in
	 *                                            in the event that the connection to the server is lost.
	 * @property {number} disconnectedBufferSize - Used to set the maximum number of messages that the disconnected
	 *                                             buffer will hold before rejecting new messages. Default size: 5000 messages
	 * @property {function} trace - called whenever trace is called. TODO
	 */ var Client = function(host, port, path, clientId) {
            var uri;
            if (typeof host !== "string") throw new Error(format(ERROR.INVALID_TYPE, [
                typeof host,
                "host"
            ]));
            if (arguments.length == 2) {
                // host: must be full ws:// uri
                // port: clientId
                clientId = port;
                uri = host;
                var match = uri.match(/^(wss?):\/\/((\[(.+)\])|([^\/]+?))(:(\d+))?(\/.*)$/);
                if (match) {
                    host = match[4] || match[2];
                    port = parseInt(match[7]);
                    path = match[8];
                } else throw new Error(format(ERROR.INVALID_ARGUMENT, [
                    host,
                    "host"
                ]));
            } else {
                if (arguments.length == 3) {
                    clientId = path;
                    path = "/mqtt";
                }
                if (typeof port !== "number" || port < 0) throw new Error(format(ERROR.INVALID_TYPE, [
                    typeof port,
                    "port"
                ]));
                if (typeof path !== "string") throw new Error(format(ERROR.INVALID_TYPE, [
                    typeof path,
                    "path"
                ]));
                var ipv6AddSBracket = host.indexOf(":") !== -1 && host.slice(0, 1) !== "[" && host.slice(-1) !== "]";
                uri = "ws://" + (ipv6AddSBracket ? "[" + host + "]" : host) + ":" + port + path;
            }
            var clientIdLength = 0;
            for(var i = 0; i < clientId.length; i++){
                var charCode = clientId.charCodeAt(i);
                if (0xD800 <= charCode && charCode <= 0xDBFF) i++; // Surrogate pair.
                clientIdLength++;
            }
            if (typeof clientId !== "string" || clientIdLength > 65535) throw new Error(format(ERROR.INVALID_ARGUMENT, [
                clientId,
                "clientId"
            ]));
            var client = new ClientImpl(uri, host, port, path, clientId);
            //Public Properties
            Object.defineProperties(this, {
                "host": {
                    get: function() {
                        return host;
                    },
                    set: function() {
                        throw new Error(format(ERROR.UNSUPPORTED_OPERATION));
                    }
                },
                "port": {
                    get: function() {
                        return port;
                    },
                    set: function() {
                        throw new Error(format(ERROR.UNSUPPORTED_OPERATION));
                    }
                },
                "path": {
                    get: function() {
                        return path;
                    },
                    set: function() {
                        throw new Error(format(ERROR.UNSUPPORTED_OPERATION));
                    }
                },
                "uri": {
                    get: function() {
                        return uri;
                    },
                    set: function() {
                        throw new Error(format(ERROR.UNSUPPORTED_OPERATION));
                    }
                },
                "clientId": {
                    get: function() {
                        return client.clientId;
                    },
                    set: function() {
                        throw new Error(format(ERROR.UNSUPPORTED_OPERATION));
                    }
                },
                "onConnected": {
                    get: function() {
                        return client.onConnected;
                    },
                    set: function(newOnConnected) {
                        if (typeof newOnConnected === "function") client.onConnected = newOnConnected;
                        else throw new Error(format(ERROR.INVALID_TYPE, [
                            typeof newOnConnected,
                            "onConnected"
                        ]));
                    }
                },
                "disconnectedPublishing": {
                    get: function() {
                        return client.disconnectedPublishing;
                    },
                    set: function(newDisconnectedPublishing) {
                        client.disconnectedPublishing = newDisconnectedPublishing;
                    }
                },
                "disconnectedBufferSize": {
                    get: function() {
                        return client.disconnectedBufferSize;
                    },
                    set: function(newDisconnectedBufferSize) {
                        client.disconnectedBufferSize = newDisconnectedBufferSize;
                    }
                },
                "onConnectionLost": {
                    get: function() {
                        return client.onConnectionLost;
                    },
                    set: function(newOnConnectionLost) {
                        if (typeof newOnConnectionLost === "function") client.onConnectionLost = newOnConnectionLost;
                        else throw new Error(format(ERROR.INVALID_TYPE, [
                            typeof newOnConnectionLost,
                            "onConnectionLost"
                        ]));
                    }
                },
                "onMessageDelivered": {
                    get: function() {
                        return client.onMessageDelivered;
                    },
                    set: function(newOnMessageDelivered) {
                        if (typeof newOnMessageDelivered === "function") client.onMessageDelivered = newOnMessageDelivered;
                        else throw new Error(format(ERROR.INVALID_TYPE, [
                            typeof newOnMessageDelivered,
                            "onMessageDelivered"
                        ]));
                    }
                },
                "onMessageArrived": {
                    get: function() {
                        return client.onMessageArrived;
                    },
                    set: function(newOnMessageArrived) {
                        if (typeof newOnMessageArrived === "function") client.onMessageArrived = newOnMessageArrived;
                        else throw new Error(format(ERROR.INVALID_TYPE, [
                            typeof newOnMessageArrived,
                            "onMessageArrived"
                        ]));
                    }
                },
                "trace": {
                    get: function() {
                        return client.traceFunction;
                    },
                    set: function(trace) {
                        if (typeof trace === "function") client.traceFunction = trace;
                        else throw new Error(format(ERROR.INVALID_TYPE, [
                            typeof trace,
                            "onTrace"
                        ]));
                    }
                }
            });
            /**
		 * Connect this Messaging client to its server.
		 *
		 * @name Paho.Client#connect
		 * @function
		 * @param {object} connectOptions - Attributes used with the connection.
		 * @param {number} connectOptions.timeout - If the connect has not succeeded within this
		 *                    number of seconds, it is deemed to have failed.
		 *                    The default is 30 seconds.
		 * @param {string} connectOptions.userName - Authentication username for this connection.
		 * @param {string} connectOptions.password - Authentication password for this connection.
		 * @param {Paho.Message} connectOptions.willMessage - sent by the server when the client
		 *                    disconnects abnormally.
		 * @param {number} connectOptions.keepAliveInterval - the server disconnects this client if
		 *                    there is no activity for this number of seconds.
		 *                    The default value of 60 seconds is assumed if not set.
		 * @param {boolean} connectOptions.cleanSession - if true(default) the client and server
		 *                    persistent state is deleted on successful connect.
		 * @param {boolean} connectOptions.useSSL - if present and true, use an SSL Websocket connection.
		 * @param {object} connectOptions.invocationContext - passed to the onSuccess callback or onFailure callback.
		 * @param {function} connectOptions.onSuccess - called when the connect acknowledgement
		 *                    has been received from the server.
		 * A single response object parameter is passed to the onSuccess callback containing the following fields:
		 * <ol>
		 * <li>invocationContext as passed in to the onSuccess method in the connectOptions.
		 * </ol>
	 * @param {function} connectOptions.onFailure - called when the connect request has failed or timed out.
		 * A single response object parameter is passed to the onFailure callback containing the following fields:
		 * <ol>
		 * <li>invocationContext as passed in to the onFailure method in the connectOptions.
		 * <li>errorCode a number indicating the nature of the error.
		 * <li>errorMessage text describing the error.
		 * </ol>
	 * @param {array} connectOptions.hosts - If present this contains either a set of hostnames or fully qualified
		 * WebSocket URIs (ws://iot.eclipse.org:80/ws), that are tried in order in place
		 * of the host and port paramater on the construtor. The hosts are tried one at at time in order until
		 * one of then succeeds.
	 * @param {array} connectOptions.ports - If present the set of ports matching the hosts. If hosts contains URIs, this property
		 * is not used.
	 * @param {boolean} connectOptions.reconnect - Sets whether the client will automatically attempt to reconnect
	 * to the server if the connection is lost.
	 *<ul>
	 *<li>If set to false, the client will not attempt to automatically reconnect to the server in the event that the
	 * connection is lost.</li>
	 *<li>If set to true, in the event that the connection is lost, the client will attempt to reconnect to the server.
	 * It will initially wait 1 second before it attempts to reconnect, for every failed reconnect attempt, the delay
	 * will double until it is at 2 minutes at which point the delay will stay at 2 minutes.</li>
	 *</ul>
	 * @param {number} connectOptions.mqttVersion - The version of MQTT to use to connect to the MQTT Broker.
	 *<ul>
	 *<li>3 - MQTT V3.1</li>
	 *<li>4 - MQTT V3.1.1</li>
	 *</ul>
	 * @param {boolean} connectOptions.mqttVersionExplicit - If set to true, will force the connection to use the
	 * selected MQTT Version or will fail to connect.
	 * @param {array} connectOptions.uris - If present, should contain a list of fully qualified WebSocket uris
	 * (e.g. ws://iot.eclipse.org:80/ws), that are tried in order in place of the host and port parameter of the construtor.
	 * The uris are tried one at a time in order until one of them succeeds. Do not use this in conjunction with hosts as
	 * the hosts array will be converted to uris and will overwrite this property.
		 * @throws {InvalidState} If the client is not in disconnected state. The client must have received connectionLost
		 * or disconnected before calling connect for a second or subsequent time.
		 */ this.connect = function(connectOptions) {
                connectOptions = connectOptions || {};
                validate(connectOptions, {
                    timeout: "number",
                    userName: "string",
                    password: "string",
                    willMessage: "object",
                    keepAliveInterval: "number",
                    cleanSession: "boolean",
                    useSSL: "boolean",
                    invocationContext: "object",
                    onSuccess: "function",
                    onFailure: "function",
                    hosts: "object",
                    ports: "object",
                    reconnect: "boolean",
                    mqttVersion: "number",
                    mqttVersionExplicit: "boolean",
                    uris: "object"
                });
                // If no keep alive interval is set, assume 60 seconds.
                if (connectOptions.keepAliveInterval === undefined) connectOptions.keepAliveInterval = 60;
                if (connectOptions.mqttVersion > 4 || connectOptions.mqttVersion < 3) throw new Error(format(ERROR.INVALID_ARGUMENT, [
                    connectOptions.mqttVersion,
                    "connectOptions.mqttVersion"
                ]));
                if (connectOptions.mqttVersion === undefined) {
                    connectOptions.mqttVersionExplicit = false;
                    connectOptions.mqttVersion = 4;
                } else connectOptions.mqttVersionExplicit = true;
                //Check that if password is set, so is username
                if (connectOptions.password !== undefined && connectOptions.userName === undefined) throw new Error(format(ERROR.INVALID_ARGUMENT, [
                    connectOptions.password,
                    "connectOptions.password"
                ]));
                if (connectOptions.willMessage) {
                    if (!(connectOptions.willMessage instanceof Message)) throw new Error(format(ERROR.INVALID_TYPE, [
                        connectOptions.willMessage,
                        "connectOptions.willMessage"
                    ]));
                    // The will message must have a payload that can be represented as a string.
                    // Cause the willMessage to throw an exception if this is not the case.
                    connectOptions.willMessage.stringPayload = null;
                    if (typeof connectOptions.willMessage.destinationName === "undefined") throw new Error(format(ERROR.INVALID_TYPE, [
                        typeof connectOptions.willMessage.destinationName,
                        "connectOptions.willMessage.destinationName"
                    ]));
                }
                if (typeof connectOptions.cleanSession === "undefined") connectOptions.cleanSession = true;
                if (connectOptions.hosts) {
                    if (!(connectOptions.hosts instanceof Array)) throw new Error(format(ERROR.INVALID_ARGUMENT, [
                        connectOptions.hosts,
                        "connectOptions.hosts"
                    ]));
                    if (connectOptions.hosts.length < 1) throw new Error(format(ERROR.INVALID_ARGUMENT, [
                        connectOptions.hosts,
                        "connectOptions.hosts"
                    ]));
                    var usingURIs = false;
                    for(var i = 0; i < connectOptions.hosts.length; i++){
                        if (typeof connectOptions.hosts[i] !== "string") throw new Error(format(ERROR.INVALID_TYPE, [
                            typeof connectOptions.hosts[i],
                            "connectOptions.hosts[" + i + "]"
                        ]));
                        if (/^(wss?):\/\/((\[(.+)\])|([^\/]+?))(:(\d+))?(\/.*)$/.test(connectOptions.hosts[i])) {
                            if (i === 0) usingURIs = true;
                            else if (!usingURIs) throw new Error(format(ERROR.INVALID_ARGUMENT, [
                                connectOptions.hosts[i],
                                "connectOptions.hosts[" + i + "]"
                            ]));
                        } else if (usingURIs) throw new Error(format(ERROR.INVALID_ARGUMENT, [
                            connectOptions.hosts[i],
                            "connectOptions.hosts[" + i + "]"
                        ]));
                    }
                    if (!usingURIs) {
                        if (!connectOptions.ports) throw new Error(format(ERROR.INVALID_ARGUMENT, [
                            connectOptions.ports,
                            "connectOptions.ports"
                        ]));
                        if (!(connectOptions.ports instanceof Array)) throw new Error(format(ERROR.INVALID_ARGUMENT, [
                            connectOptions.ports,
                            "connectOptions.ports"
                        ]));
                        if (connectOptions.hosts.length !== connectOptions.ports.length) throw new Error(format(ERROR.INVALID_ARGUMENT, [
                            connectOptions.ports,
                            "connectOptions.ports"
                        ]));
                        connectOptions.uris = [];
                        for(var i = 0; i < connectOptions.hosts.length; i++){
                            if (typeof connectOptions.ports[i] !== "number" || connectOptions.ports[i] < 0) throw new Error(format(ERROR.INVALID_TYPE, [
                                typeof connectOptions.ports[i],
                                "connectOptions.ports[" + i + "]"
                            ]));
                            var host = connectOptions.hosts[i];
                            var port = connectOptions.ports[i];
                            var ipv6 = host.indexOf(":") !== -1;
                            uri = "ws://" + (ipv6 ? "[" + host + "]" : host) + ":" + port + path;
                            connectOptions.uris.push(uri);
                        }
                    } else connectOptions.uris = connectOptions.hosts;
                }
                client.connect(connectOptions);
            };
            /**
		 * Subscribe for messages, request receipt of a copy of messages sent to the destinations described by the filter.
		 *
		 * @name Paho.Client#subscribe
		 * @function
		 * @param {string} filter describing the destinations to receive messages from.
		 * <br>
		 * @param {object} subscribeOptions - used to control the subscription
		 *
		 * @param {number} subscribeOptions.qos - the maximum qos of any publications sent
		 *                                  as a result of making this subscription.
		 * @param {object} subscribeOptions.invocationContext - passed to the onSuccess callback
		 *                                  or onFailure callback.
		 * @param {function} subscribeOptions.onSuccess - called when the subscribe acknowledgement
		 *                                  has been received from the server.
		 *                                  A single response object parameter is passed to the onSuccess callback containing the following fields:
		 *                                  <ol>
		 *                                  <li>invocationContext if set in the subscribeOptions.
		 *                                  </ol>
		 * @param {function} subscribeOptions.onFailure - called when the subscribe request has failed or timed out.
		 *                                  A single response object parameter is passed to the onFailure callback containing the following fields:
		 *                                  <ol>
		 *                                  <li>invocationContext - if set in the subscribeOptions.
		 *                                  <li>errorCode - a number indicating the nature of the error.
		 *                                  <li>errorMessage - text describing the error.
		 *                                  </ol>
		 * @param {number} subscribeOptions.timeout - which, if present, determines the number of
		 *                                  seconds after which the onFailure calback is called.
		 *                                  The presence of a timeout does not prevent the onSuccess
		 *                                  callback from being called when the subscribe completes.
		 * @throws {InvalidState} if the client is not in connected state.
		 */ this.subscribe = function(filter, subscribeOptions) {
                if (typeof filter !== "string" && filter.constructor !== Array) throw new Error("Invalid argument:" + filter);
                subscribeOptions = subscribeOptions || {};
                validate(subscribeOptions, {
                    qos: "number",
                    invocationContext: "object",
                    onSuccess: "function",
                    onFailure: "function",
                    timeout: "number"
                });
                if (subscribeOptions.timeout && !subscribeOptions.onFailure) throw new Error("subscribeOptions.timeout specified with no onFailure callback.");
                if (typeof subscribeOptions.qos !== "undefined" && !(subscribeOptions.qos === 0 || subscribeOptions.qos === 1 || subscribeOptions.qos === 2)) throw new Error(format(ERROR.INVALID_ARGUMENT, [
                    subscribeOptions.qos,
                    "subscribeOptions.qos"
                ]));
                client.subscribe(filter, subscribeOptions);
            };
            /**
		 * Unsubscribe for messages, stop receiving messages sent to destinations described by the filter.
		 *
		 * @name Paho.Client#unsubscribe
		 * @function
		 * @param {string} filter - describing the destinations to receive messages from.
		 * @param {object} unsubscribeOptions - used to control the subscription
		 * @param {object} unsubscribeOptions.invocationContext - passed to the onSuccess callback
											  or onFailure callback.
		 * @param {function} unsubscribeOptions.onSuccess - called when the unsubscribe acknowledgement has been received from the server.
		 *                                    A single response object parameter is passed to the
		 *                                    onSuccess callback containing the following fields:
		 *                                    <ol>
		 *                                    <li>invocationContext - if set in the unsubscribeOptions.
		 *                                    </ol>
		 * @param {function} unsubscribeOptions.onFailure called when the unsubscribe request has failed or timed out.
		 *                                    A single response object parameter is passed to the onFailure callback containing the following fields:
		 *                                    <ol>
		 *                                    <li>invocationContext - if set in the unsubscribeOptions.
		 *                                    <li>errorCode - a number indicating the nature of the error.
		 *                                    <li>errorMessage - text describing the error.
		 *                                    </ol>
		 * @param {number} unsubscribeOptions.timeout - which, if present, determines the number of seconds
		 *                                    after which the onFailure callback is called. The presence of
		 *                                    a timeout does not prevent the onSuccess callback from being
		 *                                    called when the unsubscribe completes
		 * @throws {InvalidState} if the client is not in connected state.
		 */ this.unsubscribe = function(filter, unsubscribeOptions) {
                if (typeof filter !== "string" && filter.constructor !== Array) throw new Error("Invalid argument:" + filter);
                unsubscribeOptions = unsubscribeOptions || {};
                validate(unsubscribeOptions, {
                    invocationContext: "object",
                    onSuccess: "function",
                    onFailure: "function",
                    timeout: "number"
                });
                if (unsubscribeOptions.timeout && !unsubscribeOptions.onFailure) throw new Error("unsubscribeOptions.timeout specified with no onFailure callback.");
                client.unsubscribe(filter, unsubscribeOptions);
            };
            /**
		 * Send a message to the consumers of the destination in the Message.
		 *
		 * @name Paho.Client#send
		 * @function
		 * @param {string|Paho.Message} topic - <b>mandatory</b> The name of the destination to which the message is to be sent.
		 * 					   - If it is the only parameter, used as Paho.Message object.
		 * @param {String|ArrayBuffer} payload - The message data to be sent.
		 * @param {number} qos The Quality of Service used to deliver the message.
		 * 		<dl>
		 * 			<dt>0 Best effort (default).
		 *     			<dt>1 At least once.
		 *     			<dt>2 Exactly once.
		 * 		</dl>
		 * @param {Boolean} retained If true, the message is to be retained by the server and delivered
		 *                     to both current and future subscriptions.
		 *                     If false the server only delivers the message to current subscribers, this is the default for new Messages.
		 *                     A received message has the retained boolean set to true if the message was published
		 *                     with the retained boolean set to true
		 *                     and the subscrption was made after the message has been published.
		 * @throws {InvalidState} if the client is not connected.
		 */ this.send = function(topic, payload, qos, retained) {
                var message;
                if (arguments.length === 0) throw new Error("Invalid argument.length");
                else if (arguments.length == 1) {
                    if (!(topic instanceof Message) && typeof topic !== "string") throw new Error("Invalid argument:" + typeof topic);
                    message = topic;
                    if (typeof message.destinationName === "undefined") throw new Error(format(ERROR.INVALID_ARGUMENT, [
                        message.destinationName,
                        "Message.destinationName"
                    ]));
                    client.send(message);
                } else {
                    //parameter checking in Message object
                    message = new Message(payload);
                    message.destinationName = topic;
                    if (arguments.length >= 3) message.qos = qos;
                    if (arguments.length >= 4) message.retained = retained;
                    client.send(message);
                }
            };
            /**
		 * Publish a message to the consumers of the destination in the Message.
		 * Synonym for Paho.Mqtt.Client#send
		 *
		 * @name Paho.Client#publish
		 * @function
		 * @param {string|Paho.Message} topic - <b>mandatory</b> The name of the topic to which the message is to be published.
		 * 					   - If it is the only parameter, used as Paho.Message object.
		 * @param {String|ArrayBuffer} payload - The message data to be published.
		 * @param {number} qos The Quality of Service used to deliver the message.
		 * 		<dl>
		 * 			<dt>0 Best effort (default).
		 *     			<dt>1 At least once.
		 *     			<dt>2 Exactly once.
		 * 		</dl>
		 * @param {Boolean} retained If true, the message is to be retained by the server and delivered
		 *                     to both current and future subscriptions.
		 *                     If false the server only delivers the message to current subscribers, this is the default for new Messages.
		 *                     A received message has the retained boolean set to true if the message was published
		 *                     with the retained boolean set to true
		 *                     and the subscrption was made after the message has been published.
		 * @throws {InvalidState} if the client is not connected.
		 */ this.publish = function(topic, payload, qos, retained) {
                var message;
                if (arguments.length === 0) throw new Error("Invalid argument.length");
                else if (arguments.length == 1) {
                    if (!(topic instanceof Message) && typeof topic !== "string") throw new Error("Invalid argument:" + typeof topic);
                    message = topic;
                    if (typeof message.destinationName === "undefined") throw new Error(format(ERROR.INVALID_ARGUMENT, [
                        message.destinationName,
                        "Message.destinationName"
                    ]));
                    client.send(message);
                } else {
                    //parameter checking in Message object
                    message = new Message(payload);
                    message.destinationName = topic;
                    if (arguments.length >= 3) message.qos = qos;
                    if (arguments.length >= 4) message.retained = retained;
                    client.send(message);
                }
            };
            /**
		 * Normal disconnect of this Messaging client from its server.
		 *
		 * @name Paho.Client#disconnect
		 * @function
		 * @throws {InvalidState} if the client is already disconnected.
		 */ this.disconnect = function() {
                client.disconnect();
            };
            /**
		 * Get the contents of the trace log.
		 *
		 * @name Paho.Client#getTraceLog
		 * @function
		 * @return {Object[]} tracebuffer containing the time ordered trace records.
		 */ this.getTraceLog = function() {
                return client.getTraceLog();
            };
            /**
		 * Start tracing.
		 *
		 * @name Paho.Client#startTrace
		 * @function
		 */ this.startTrace = function() {
                client.startTrace();
            };
            /**
		 * Stop tracing.
		 *
		 * @name Paho.Client#stopTrace
		 * @function
		 */ this.stopTrace = function() {
                client.stopTrace();
            };
            this.isConnected = function() {
                return client.connected;
            };
        };
        /**
	 * An application message, sent or received.
	 * <p>
	 * All attributes may be null, which implies the default values.
	 *
	 * @name Paho.Message
	 * @constructor
	 * @param {String|ArrayBuffer} payload The message data to be sent.
	 * <p>
	 * @property {string} payloadString <i>read only</i> The payload as a string if the payload consists of valid UTF-8 characters.
	 * @property {ArrayBuffer} payloadBytes <i>read only</i> The payload as an ArrayBuffer.
	 * <p>
	 * @property {string} destinationName <b>mandatory</b> The name of the destination to which the message is to be sent
	 *                    (for messages about to be sent) or the name of the destination from which the message has been received.
	 *                    (for messages received by the onMessage function).
	 * <p>
	 * @property {number} qos The Quality of Service used to deliver the message.
	 * <dl>
	 *     <dt>0 Best effort (default).
	 *     <dt>1 At least once.
	 *     <dt>2 Exactly once.
	 * </dl>
	 * <p>
	 * @property {Boolean} retained If true, the message is to be retained by the server and delivered
	 *                     to both current and future subscriptions.
	 *                     If false the server only delivers the message to current subscribers, this is the default for new Messages.
	 *                     A received message has the retained boolean set to true if the message was published
	 *                     with the retained boolean set to true
	 *                     and the subscrption was made after the message has been published.
	 * <p>
	 * @property {Boolean} duplicate <i>read only</i> If true, this message might be a duplicate of one which has already been received.
	 *                     This is only set on messages received from the server.
	 *
	 */ var Message = function(newPayload) {
            var payload;
            if (typeof newPayload === "string" || newPayload instanceof ArrayBuffer || ArrayBuffer.isView(newPayload) && !(newPayload instanceof DataView)) payload = newPayload;
            else throw format(ERROR.INVALID_ARGUMENT, [
                newPayload,
                "newPayload"
            ]);
            var destinationName;
            var qos = 0;
            var retained = false;
            var duplicate = false;
            Object.defineProperties(this, {
                "payloadString": {
                    enumerable: true,
                    get: function() {
                        if (typeof payload === "string") return payload;
                        else return parseUTF8(payload, 0, payload.length);
                    }
                },
                "payloadBytes": {
                    enumerable: true,
                    get: function() {
                        if (typeof payload === "string") {
                            var buffer = new ArrayBuffer(UTF8Length(payload));
                            var byteStream = new Uint8Array(buffer);
                            stringToUTF8(payload, byteStream, 0);
                            return byteStream;
                        } else return payload;
                    }
                },
                "destinationName": {
                    enumerable: true,
                    get: function() {
                        return destinationName;
                    },
                    set: function(newDestinationName) {
                        if (typeof newDestinationName === "string") destinationName = newDestinationName;
                        else throw new Error(format(ERROR.INVALID_ARGUMENT, [
                            newDestinationName,
                            "newDestinationName"
                        ]));
                    }
                },
                "qos": {
                    enumerable: true,
                    get: function() {
                        return qos;
                    },
                    set: function(newQos) {
                        if (newQos === 0 || newQos === 1 || newQos === 2) qos = newQos;
                        else throw new Error("Invalid argument:" + newQos);
                    }
                },
                "retained": {
                    enumerable: true,
                    get: function() {
                        return retained;
                    },
                    set: function(newRetained) {
                        if (typeof newRetained === "boolean") retained = newRetained;
                        else throw new Error(format(ERROR.INVALID_ARGUMENT, [
                            newRetained,
                            "newRetained"
                        ]));
                    }
                },
                "topic": {
                    enumerable: true,
                    get: function() {
                        return destinationName;
                    },
                    set: function(newTopic) {
                        destinationName = newTopic;
                    }
                },
                "duplicate": {
                    enumerable: true,
                    get: function() {
                        return duplicate;
                    },
                    set: function(newDuplicate) {
                        duplicate = newDuplicate;
                    }
                }
            });
        };
        // Module contents.
        return {
            Client: Client,
            Message: Message
        };
    // eslint-disable-next-line no-nested-ternary
    }(typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
    return PahoMQTT;
});

});

parcelRegister("8hnDM", function(module, exports) {

var $a0oc2 = parcelRequire("a0oc2");

var $dz9RD = parcelRequire("dz9RD");
var $60723fc91d336c51$var$uuid = $dz9RD;
$60723fc91d336c51$var$uuid.v1 = $a0oc2;
$60723fc91d336c51$var$uuid.v4 = $dz9RD;
module.exports = $60723fc91d336c51$var$uuid;

});
parcelRegister("a0oc2", function(module, exports) {

var $etDn2 = parcelRequire("etDn2");

var $aWx5w = parcelRequire("aWx5w");
// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var $748cabbd5cf25169$var$_nodeId;
var $748cabbd5cf25169$var$_clockseq;
// Previous uuid creation time
var $748cabbd5cf25169$var$_lastMSecs = 0;
var $748cabbd5cf25169$var$_lastNSecs = 0;
// See https://github.com/uuidjs/uuid for API details
function $748cabbd5cf25169$var$v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || $748cabbd5cf25169$var$_nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : $748cabbd5cf25169$var$_clockseq;
    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = $etDn2();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = $748cabbd5cf25169$var$_nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = $748cabbd5cf25169$var$_clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : $748cabbd5cf25169$var$_lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - $748cabbd5cf25169$var$_lastMSecs + (nsecs - $748cabbd5cf25169$var$_lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > $748cabbd5cf25169$var$_lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
    $748cabbd5cf25169$var$_lastMSecs = msecs;
    $748cabbd5cf25169$var$_lastNSecs = nsecs;
    $748cabbd5cf25169$var$_clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf ? buf : $aWx5w(b);
}
module.exports = $748cabbd5cf25169$var$v1;

});
parcelRegister("etDn2", function(module, exports) {
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var $a8a2504ce896a3bd$var$getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto);
if ($a8a2504ce896a3bd$var$getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var $a8a2504ce896a3bd$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    module.exports = function whatwgRNG() {
        $a8a2504ce896a3bd$var$getRandomValues($a8a2504ce896a3bd$var$rnds8);
        return $a8a2504ce896a3bd$var$rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var $a8a2504ce896a3bd$var$rnds = new Array(16);
    module.exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            $a8a2504ce896a3bd$var$rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return $a8a2504ce896a3bd$var$rnds;
    };
}

});

parcelRegister("aWx5w", function(module, exports) {
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $7f78fcc81b14ac52$var$byteToHex = [];
for(var $7f78fcc81b14ac52$var$i = 0; $7f78fcc81b14ac52$var$i < 256; ++$7f78fcc81b14ac52$var$i)$7f78fcc81b14ac52$var$byteToHex[$7f78fcc81b14ac52$var$i] = ($7f78fcc81b14ac52$var$i + 0x100).toString(16).substr(1);
function $7f78fcc81b14ac52$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $7f78fcc81b14ac52$var$byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join('');
}
module.exports = $7f78fcc81b14ac52$var$bytesToUuid;

});


parcelRegister("dz9RD", function(module, exports) {

var $etDn2 = parcelRequire("etDn2");

var $aWx5w = parcelRequire("aWx5w");
function $9e0632080d656a91$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == 'string') {
        buf = options === 'binary' ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || $etDn2)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || $aWx5w(rnds);
}
module.exports = $9e0632080d656a91$var$v4;

});


parcelRegister("gGyGQ", function(module, exports) {

$parcel$export(module.exports, "AbstractPubSubProvider", () => $c25b7a48efcc192f$export$38596aa9173af3e4);

var $7UO1b = parcelRequire("7UO1b");
var $c25b7a48efcc192f$var$__assign = undefined && undefined.__assign || function() {
    $c25b7a48efcc192f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c25b7a48efcc192f$var$__assign.apply(this, arguments);
};
var $c25b7a48efcc192f$var$logger = new (0, $7UO1b.ConsoleLogger)('AbstractPubSubProvider');
var $c25b7a48efcc192f$export$38596aa9173af3e4 = /** @class */ function() {
    function AbstractPubSubProvider(options) {
        if (options === void 0) options = {};
        this._config = options;
    }
    AbstractPubSubProvider.prototype.configure = function(config) {
        if (config === void 0) config = {};
        this._config = $c25b7a48efcc192f$var$__assign($c25b7a48efcc192f$var$__assign({}, config), this._config);
        $c25b7a48efcc192f$var$logger.debug("configure " + this.getProviderName(), this._config);
        return this.options;
    };
    AbstractPubSubProvider.prototype.getCategory = function() {
        return 'PubSub';
    };
    Object.defineProperty(AbstractPubSubProvider.prototype, "options", {
        get: function() {
            return $c25b7a48efcc192f$var$__assign({}, this._config);
        },
        enumerable: true,
        configurable: true
    });
    return AbstractPubSubProvider;
}();

});



parcelRegister("jGX6r", function(module, exports) {

$parcel$export(module.exports, "AWSAppSyncRealTimeProvider", () => $e55fc92c79f0c78e$export$b7b5e6371992068d);

var $fi57Q = parcelRequire("fi57Q");

var $5SVEU = parcelRequire("5SVEU");

var $kcgTr = parcelRequire("kcgTr");

var $8hnDM = parcelRequire("8hnDM");

var $j4MAF = parcelRequire("j4MAF");

var $8qWqv = parcelRequire("8qWqv");
var $29OQz = parcelRequire("29OQz");
var $kRjsJ = parcelRequire("kRjsJ");
var $7TTzY = parcelRequire("7TTzY");
var $7UO1b = parcelRequire("7UO1b");
var $ap2RT = parcelRequire("ap2RT");
var $6zWMj = parcelRequire("6zWMj");

var $8SrNO = parcelRequire("8SrNO");

var $i14CG = parcelRequire("i14CG");

var $gGyGQ = parcelRequire("gGyGQ");

var $gy3Xv = parcelRequire("gy3Xv");
var $e55fc92c79f0c78e$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $e55fc92c79f0c78e$var$__assign = undefined && undefined.__assign || function() {
    $e55fc92c79f0c78e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e55fc92c79f0c78e$var$__assign.apply(this, arguments);
};
var $e55fc92c79f0c78e$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $e55fc92c79f0c78e$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $e55fc92c79f0c78e$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $e55fc92c79f0c78e$var$logger = new (0, $7UO1b.ConsoleLogger)('AWSAppSyncRealTimeProvider');
var $e55fc92c79f0c78e$var$AMPLIFY_SYMBOL = typeof Symbol !== 'undefined' && typeof Symbol.for === 'function' ? Symbol.for('amplify_default') : '@@amplify_default';
var $e55fc92c79f0c78e$var$dispatchApiEvent = function(event, data, message) {
    (0, $kRjsJ.Hub).dispatch('api', {
        event: event,
        data: data,
        message: message
    }, 'PubSub', $e55fc92c79f0c78e$var$AMPLIFY_SYMBOL);
};
var $e55fc92c79f0c78e$var$MAX_DELAY_MS = 5000;
var $e55fc92c79f0c78e$var$NON_RETRYABLE_CODES = [
    400,
    401,
    403
];
var $e55fc92c79f0c78e$var$MESSAGE_TYPES;
(function(MESSAGE_TYPES) {
    /**
     * Client -> Server message.
     * This message type is the first message after handshake and this will initialize AWS AppSync RealTime communication
     */ MESSAGE_TYPES["GQL_CONNECTION_INIT"] = "connection_init";
    /**
     * Server -> Client message
     * This message type is in case there is an issue with AWS AppSync RealTime when establishing connection
     */ MESSAGE_TYPES["GQL_CONNECTION_ERROR"] = "connection_error";
    /**
     * Server -> Client message.
     * This message type is for the ack response from AWS AppSync RealTime for GQL_CONNECTION_INIT message
     */ MESSAGE_TYPES["GQL_CONNECTION_ACK"] = "connection_ack";
    /**
     * Client -> Server message.
     * This message type is for register subscriptions with AWS AppSync RealTime
     */ MESSAGE_TYPES["GQL_START"] = "start";
    /**
     * Server -> Client message.
     * This message type is for the ack response from AWS AppSync RealTime for GQL_START message
     */ MESSAGE_TYPES["GQL_START_ACK"] = "start_ack";
    /**
     * Server -> Client message.
     * This message type is for subscription message from AWS AppSync RealTime
     */ MESSAGE_TYPES["GQL_DATA"] = "data";
    /**
     * Server -> Client message.
     * This message type helps the client to know is still receiving messages from AWS AppSync RealTime
     */ MESSAGE_TYPES["GQL_CONNECTION_KEEP_ALIVE"] = "ka";
    /**
     * Client -> Server message.
     * This message type is for unregister subscriptions with AWS AppSync RealTime
     */ MESSAGE_TYPES["GQL_STOP"] = "stop";
    /**
     * Server -> Client message.
     * This message type is for the ack response from AWS AppSync RealTime for GQL_STOP message
     */ MESSAGE_TYPES["GQL_COMPLETE"] = "complete";
    /**
     * Server -> Client message.
     * This message type is for sending error messages from AWS AppSync RealTime to the client
     */ MESSAGE_TYPES["GQL_ERROR"] = "error";
})($e55fc92c79f0c78e$var$MESSAGE_TYPES || ($e55fc92c79f0c78e$var$MESSAGE_TYPES = {}));
var $e55fc92c79f0c78e$var$SUBSCRIPTION_STATUS;
(function(SUBSCRIPTION_STATUS) {
    SUBSCRIPTION_STATUS[SUBSCRIPTION_STATUS["PENDING"] = 0] = "PENDING";
    SUBSCRIPTION_STATUS[SUBSCRIPTION_STATUS["CONNECTED"] = 1] = "CONNECTED";
    SUBSCRIPTION_STATUS[SUBSCRIPTION_STATUS["FAILED"] = 2] = "FAILED";
})($e55fc92c79f0c78e$var$SUBSCRIPTION_STATUS || ($e55fc92c79f0c78e$var$SUBSCRIPTION_STATUS = {}));
var $e55fc92c79f0c78e$var$SOCKET_STATUS;
(function(SOCKET_STATUS) {
    SOCKET_STATUS[SOCKET_STATUS["CLOSED"] = 0] = "CLOSED";
    SOCKET_STATUS[SOCKET_STATUS["READY"] = 1] = "READY";
    SOCKET_STATUS[SOCKET_STATUS["CONNECTING"] = 2] = "CONNECTING";
})($e55fc92c79f0c78e$var$SOCKET_STATUS || ($e55fc92c79f0c78e$var$SOCKET_STATUS = {}));
var $e55fc92c79f0c78e$var$AWS_APPSYNC_REALTIME_HEADERS = {
    accept: 'application/json, text/javascript',
    'content-encoding': 'amz-1.0',
    'content-type': 'application/json; charset=UTF-8'
};
/**
 * Time in milleseconds to wait for GQL_CONNECTION_INIT message
 */ var $e55fc92c79f0c78e$var$CONNECTION_INIT_TIMEOUT = 15000;
/**
 * Time in milleseconds to wait for GQL_START_ACK message
 */ var $e55fc92c79f0c78e$var$START_ACK_TIMEOUT = 15000;
/**
 * Default Time in milleseconds to wait for GQL_CONNECTION_KEEP_ALIVE message
 */ var $e55fc92c79f0c78e$var$DEFAULT_KEEP_ALIVE_TIMEOUT = 300000;
var $e55fc92c79f0c78e$export$b7b5e6371992068d = /** @class */ function(_super) {
    $e55fc92c79f0c78e$var$__extends(AWSAppSyncRealTimeProvider, _super);
    function AWSAppSyncRealTimeProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.socketStatus = $e55fc92c79f0c78e$var$SOCKET_STATUS.CLOSED;
        _this.keepAliveTimeout = $e55fc92c79f0c78e$var$DEFAULT_KEEP_ALIVE_TIMEOUT;
        _this.subscriptionObserverMap = new Map();
        _this.promiseArray = [];
        return _this;
    }
    AWSAppSyncRealTimeProvider.prototype.getProviderName = function() {
        return 'AWSAppSyncRealTimeProvider';
    };
    AWSAppSyncRealTimeProvider.prototype.newClient = function() {
        throw new Error('Not used here');
    };
    AWSAppSyncRealTimeProvider.prototype.publish = function(_topics, _msg, _options) {
        return $e55fc92c79f0c78e$var$__awaiter(this, void 0, void 0, function() {
            return $e55fc92c79f0c78e$var$__generator(this, function(_a) {
                throw new Error('Operation not supported');
            });
        });
    };
    AWSAppSyncRealTimeProvider.prototype.subscribe = function(_topics, options) {
        var _this = this;
        var appSyncGraphqlEndpoint = options.appSyncGraphqlEndpoint;
        return new (0, $fi57Q.default)(function(observer) {
            if (!appSyncGraphqlEndpoint) {
                observer.error({
                    errors: [
                        $e55fc92c79f0c78e$var$__assign({}, new (0, $5SVEU.GraphQLError)("Subscribe only available for AWS AppSync endpoint"))
                    ]
                });
                observer.complete();
            } else {
                var subscriptionId_1 = (0, $8hnDM.v4)();
                _this._startSubscriptionWithAWSAppSyncRealTime({
                    options: options,
                    observer: observer,
                    subscriptionId: subscriptionId_1
                }).catch(function(err) {
                    observer.error({
                        errors: [
                            $e55fc92c79f0c78e$var$__assign({}, new (0, $5SVEU.GraphQLError)((0, $gy3Xv.CONTROL_MSG).REALTIME_SUBSCRIPTION_INIT_ERROR + ": " + err))
                        ]
                    });
                    observer.complete();
                });
                return function() {
                    return $e55fc92c79f0c78e$var$__awaiter(_this, void 0, void 0, function() {
                        var subscriptionState, err_1;
                        return $e55fc92c79f0c78e$var$__generator(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    _a.trys.push([
                                        0,
                                        2,
                                        3,
                                        4
                                    ]);
                                    // Waiting that subscription has been connected before trying to unsubscribe
                                    return [
                                        4 /*yield*/ ,
                                        this._waitForSubscriptionToBeConnected(subscriptionId_1)
                                    ];
                                case 1:
                                    // Waiting that subscription has been connected before trying to unsubscribe
                                    _a.sent();
                                    subscriptionState = (this.subscriptionObserverMap.get(subscriptionId_1) || {}).subscriptionState;
                                    if (!subscriptionState) // subscription already unsubscribed
                                    return [
                                        2 /*return*/ 
                                    ];
                                    if (subscriptionState === $e55fc92c79f0c78e$var$SUBSCRIPTION_STATUS.CONNECTED) this._sendUnsubscriptionMessage(subscriptionId_1);
                                    else throw new Error('Subscription never connected');
                                    return [
                                        3 /*break*/ ,
                                        4
                                    ];
                                case 2:
                                    err_1 = _a.sent();
                                    $e55fc92c79f0c78e$var$logger.debug("Error while unsubscribing " + err_1);
                                    return [
                                        3 /*break*/ ,
                                        4
                                    ];
                                case 3:
                                    this._removeSubscriptionObserver(subscriptionId_1);
                                    return [
                                        7 /*endfinally*/ 
                                    ];
                                case 4:
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                };
            }
        });
    };
    Object.defineProperty(AWSAppSyncRealTimeProvider.prototype, "isSSLEnabled", {
        get: function() {
            return !this.options.aws_appsync_dangerously_connect_to_http_endpoint_for_testing;
        },
        enumerable: true,
        configurable: true
    });
    AWSAppSyncRealTimeProvider.prototype._startSubscriptionWithAWSAppSyncRealTime = function(_a) {
        var options = _a.options, observer = _a.observer, subscriptionId = _a.subscriptionId;
        return $e55fc92c79f0c78e$var$__awaiter(this, void 0, void 0, function() {
            var appSyncGraphqlEndpoint, authenticationType, query, variables, apiKey, region, _b, graphql_headers, _c, additionalHeaders, subscriptionState, data, dataString, headerObj, _d, _e, subscriptionMessage, stringToAWSRealTime, err_2, _f, message, subscriptionFailedCallback_1, _g, subscriptionFailedCallback, subscriptionReadyCallback;
            var _h;
            var _this = this;
            return $e55fc92c79f0c78e$var$__generator(this, function(_j) {
                switch(_j.label){
                    case 0:
                        appSyncGraphqlEndpoint = options.appSyncGraphqlEndpoint, authenticationType = options.authenticationType, query = options.query, variables = options.variables, apiKey = options.apiKey, region = options.region, _b = options.graphql_headers, graphql_headers = _b === void 0 ? function() {
                            return {};
                        } : _b, _c = options.additionalHeaders, additionalHeaders = _c === void 0 ? {} : _c;
                        subscriptionState = $e55fc92c79f0c78e$var$SUBSCRIPTION_STATUS.PENDING;
                        data = {
                            query: query,
                            variables: variables
                        };
                        // Having a subscription id map will make it simple to forward messages received
                        this.subscriptionObserverMap.set(subscriptionId, {
                            observer: observer,
                            query: query,
                            variables: variables,
                            subscriptionState: subscriptionState,
                            startAckTimeoutId: null
                        });
                        dataString = JSON.stringify(data);
                        _d = [
                            {}
                        ];
                        return [
                            4 /*yield*/ ,
                            this._awsRealTimeHeaderBasedAuth({
                                apiKey: apiKey,
                                appSyncGraphqlEndpoint: appSyncGraphqlEndpoint,
                                authenticationType: authenticationType,
                                payload: dataString,
                                canonicalUri: '',
                                region: region
                            })
                        ];
                    case 1:
                        _e = [
                            $e55fc92c79f0c78e$var$__assign.apply(void 0, _d.concat([
                                _j.sent()
                            ]))
                        ];
                        return [
                            4 /*yield*/ ,
                            graphql_headers()
                        ];
                    case 2:
                        headerObj = $e55fc92c79f0c78e$var$__assign.apply(void 0, [
                            $e55fc92c79f0c78e$var$__assign.apply(void 0, [
                                $e55fc92c79f0c78e$var$__assign.apply(void 0, _e.concat([
                                    _j.sent()
                                ])),
                                additionalHeaders
                            ]),
                            (_h = {}, _h[0, $6zWMj.USER_AGENT_HEADER] = (0, $8qWqv.Constants).userAgent, _h)
                        ]);
                        subscriptionMessage = {
                            id: subscriptionId,
                            payload: {
                                data: dataString,
                                extensions: {
                                    authorization: $e55fc92c79f0c78e$var$__assign({}, headerObj)
                                }
                            },
                            type: $e55fc92c79f0c78e$var$MESSAGE_TYPES.GQL_START
                        };
                        stringToAWSRealTime = JSON.stringify(subscriptionMessage);
                        _j.label = 3;
                    case 3:
                        _j.trys.push([
                            3,
                            5,
                            ,
                            6
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._initializeWebSocketConnection({
                                apiKey: apiKey,
                                appSyncGraphqlEndpoint: appSyncGraphqlEndpoint,
                                authenticationType: authenticationType,
                                region: region
                            })
                        ];
                    case 4:
                        _j.sent();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 5:
                        err_2 = _j.sent();
                        $e55fc92c79f0c78e$var$logger.debug({
                            err: err_2
                        });
                        _f = err_2.message, message = _f === void 0 ? '' : _f;
                        observer.error({
                            errors: [
                                $e55fc92c79f0c78e$var$__assign({}, new (0, $5SVEU.GraphQLError)((0, $gy3Xv.CONTROL_MSG).CONNECTION_FAILED + ": " + message))
                            ]
                        });
                        observer.complete();
                        subscriptionFailedCallback_1 = (this.subscriptionObserverMap.get(subscriptionId) || {}).subscriptionFailedCallback;
                        // Notify concurrent unsubscription
                        if (typeof subscriptionFailedCallback_1 === 'function') subscriptionFailedCallback_1();
                        return [
                            2 /*return*/ 
                        ];
                    case 6:
                        _g = this.subscriptionObserverMap.get(subscriptionId), subscriptionFailedCallback = _g.subscriptionFailedCallback, subscriptionReadyCallback = _g.subscriptionReadyCallback;
                        // This must be done before sending the message in order to be listening immediately
                        this.subscriptionObserverMap.set(subscriptionId, {
                            observer: observer,
                            subscriptionState: subscriptionState,
                            variables: variables,
                            query: query,
                            subscriptionReadyCallback: subscriptionReadyCallback,
                            subscriptionFailedCallback: subscriptionFailedCallback,
                            startAckTimeoutId: setTimeout(function() {
                                _this._timeoutStartSubscriptionAck.call(_this, subscriptionId);
                            }, $e55fc92c79f0c78e$var$START_ACK_TIMEOUT)
                        });
                        if (this.awsRealTimeSocket) this.awsRealTimeSocket.send(stringToAWSRealTime);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    // Waiting that subscription has been connected before trying to unsubscribe
    AWSAppSyncRealTimeProvider.prototype._waitForSubscriptionToBeConnected = function(subscriptionId) {
        return $e55fc92c79f0c78e$var$__awaiter(this, void 0, void 0, function() {
            var subscriptionState;
            var _this = this;
            return $e55fc92c79f0c78e$var$__generator(this, function(_a) {
                subscriptionState = this.subscriptionObserverMap.get(subscriptionId).subscriptionState;
                // This in case unsubscribe is invoked before sending start subscription message
                if (subscriptionState === $e55fc92c79f0c78e$var$SUBSCRIPTION_STATUS.PENDING) return [
                    2 /*return*/ ,
                    new Promise(function(res, rej) {
                        var _a = _this.subscriptionObserverMap.get(subscriptionId), observer = _a.observer, subscriptionState = _a.subscriptionState, variables = _a.variables, query = _a.query;
                        _this.subscriptionObserverMap.set(subscriptionId, {
                            observer: observer,
                            subscriptionState: subscriptionState,
                            variables: variables,
                            query: query,
                            subscriptionReadyCallback: res,
                            subscriptionFailedCallback: rej
                        });
                    })
                ];
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    AWSAppSyncRealTimeProvider.prototype._sendUnsubscriptionMessage = function(subscriptionId) {
        try {
            if (this.awsRealTimeSocket && this.awsRealTimeSocket.readyState === WebSocket.OPEN && this.socketStatus === $e55fc92c79f0c78e$var$SOCKET_STATUS.READY) {
                // Preparing unsubscribe message to stop receiving messages for that subscription
                var unsubscribeMessage = {
                    id: subscriptionId,
                    type: $e55fc92c79f0c78e$var$MESSAGE_TYPES.GQL_STOP
                };
                var stringToAWSRealTime = JSON.stringify(unsubscribeMessage);
                this.awsRealTimeSocket.send(stringToAWSRealTime);
            }
        } catch (err) {
            // If GQL_STOP is not sent because of disconnection issue, then there is nothing the client can do
            $e55fc92c79f0c78e$var$logger.debug({
                err: err
            });
        }
    };
    AWSAppSyncRealTimeProvider.prototype._removeSubscriptionObserver = function(subscriptionId) {
        this.subscriptionObserverMap.delete(subscriptionId);
        // Verifying 1000ms after removing subscription in case there are new subscription unmount/mount
        setTimeout(this._closeSocketIfRequired.bind(this), 1000);
    };
    AWSAppSyncRealTimeProvider.prototype._closeSocketIfRequired = function() {
        if (this.subscriptionObserverMap.size > 0) // Active subscriptions on the WebSocket
        return;
        if (!this.awsRealTimeSocket) {
            this.socketStatus = $e55fc92c79f0c78e$var$SOCKET_STATUS.CLOSED;
            return;
        }
        if (this.awsRealTimeSocket.bufferedAmount > 0) // Still data on the WebSocket
        setTimeout(this._closeSocketIfRequired.bind(this), 1000);
        else {
            $e55fc92c79f0c78e$var$logger.debug('closing WebSocket...');
            clearTimeout(this.keepAliveTimeoutId);
            var tempSocket = this.awsRealTimeSocket;
            // Cleaning callbacks to avoid race condition, socket still exists
            tempSocket.onclose = undefined;
            tempSocket.onerror = undefined;
            tempSocket.close(1000);
            this.awsRealTimeSocket = null;
            this.socketStatus = $e55fc92c79f0c78e$var$SOCKET_STATUS.CLOSED;
        }
    };
    AWSAppSyncRealTimeProvider.prototype._handleIncomingSubscriptionMessage = function(message) {
        $e55fc92c79f0c78e$var$logger.debug("subscription message from AWS AppSync RealTime: " + message.data);
        var _a = JSON.parse(message.data), _b = _a.id, id = _b === void 0 ? '' : _b, payload = _a.payload, type = _a.type;
        var _c = this.subscriptionObserverMap.get(id) || {}, _d = _c.observer, observer = _d === void 0 ? null : _d, _e = _c.query, query = _e === void 0 ? '' : _e, _f = _c.variables, variables = _f === void 0 ? {} : _f, startAckTimeoutId = _c.startAckTimeoutId, subscriptionReadyCallback = _c.subscriptionReadyCallback, subscriptionFailedCallback = _c.subscriptionFailedCallback;
        $e55fc92c79f0c78e$var$logger.debug({
            id: id,
            observer: observer,
            query: query,
            variables: variables
        });
        if (type === $e55fc92c79f0c78e$var$MESSAGE_TYPES.GQL_DATA && payload && payload.data) {
            if (observer) observer.next(payload);
            else $e55fc92c79f0c78e$var$logger.debug("observer not found for id: " + id);
            return;
        }
        if (type === $e55fc92c79f0c78e$var$MESSAGE_TYPES.GQL_START_ACK) {
            $e55fc92c79f0c78e$var$logger.debug("subscription ready for " + JSON.stringify({
                query: query,
                variables: variables
            }));
            if (typeof subscriptionReadyCallback === 'function') subscriptionReadyCallback();
            clearTimeout(startAckTimeoutId);
            $e55fc92c79f0c78e$var$dispatchApiEvent((0, $gy3Xv.CONTROL_MSG).SUBSCRIPTION_ACK, {
                query: query,
                variables: variables
            }, 'Connection established for subscription');
            var subscriptionState = $e55fc92c79f0c78e$var$SUBSCRIPTION_STATUS.CONNECTED;
            this.subscriptionObserverMap.set(id, {
                observer: observer,
                query: query,
                variables: variables,
                startAckTimeoutId: null,
                subscriptionState: subscriptionState,
                subscriptionReadyCallback: subscriptionReadyCallback,
                subscriptionFailedCallback: subscriptionFailedCallback
            });
            // TODO: emit event on hub but it requires to store the id first
            return;
        }
        if (type === $e55fc92c79f0c78e$var$MESSAGE_TYPES.GQL_CONNECTION_KEEP_ALIVE) {
            clearTimeout(this.keepAliveTimeoutId);
            this.keepAliveTimeoutId = setTimeout(this._errorDisconnect.bind(this, (0, $gy3Xv.CONTROL_MSG).TIMEOUT_DISCONNECT), this.keepAliveTimeout);
            return;
        }
        if (type === $e55fc92c79f0c78e$var$MESSAGE_TYPES.GQL_ERROR) {
            var subscriptionState = $e55fc92c79f0c78e$var$SUBSCRIPTION_STATUS.FAILED;
            this.subscriptionObserverMap.set(id, {
                observer: observer,
                query: query,
                variables: variables,
                startAckTimeoutId: startAckTimeoutId,
                subscriptionReadyCallback: subscriptionReadyCallback,
                subscriptionFailedCallback: subscriptionFailedCallback,
                subscriptionState: subscriptionState
            });
            observer.error({
                errors: [
                    $e55fc92c79f0c78e$var$__assign({}, new (0, $5SVEU.GraphQLError)((0, $gy3Xv.CONTROL_MSG).CONNECTION_FAILED + ": " + JSON.stringify(payload)))
                ]
            });
            clearTimeout(startAckTimeoutId);
            observer.complete();
            if (typeof subscriptionFailedCallback === 'function') subscriptionFailedCallback();
        }
    };
    AWSAppSyncRealTimeProvider.prototype._errorDisconnect = function(msg) {
        $e55fc92c79f0c78e$var$logger.debug("Disconnect error: " + msg);
        this.subscriptionObserverMap.forEach(function(_a) {
            var observer = _a.observer;
            if (observer && !observer.closed) observer.error({
                errors: [
                    $e55fc92c79f0c78e$var$__assign({}, new (0, $5SVEU.GraphQLError)(msg))
                ]
            });
        });
        this.subscriptionObserverMap.clear();
        if (this.awsRealTimeSocket) this.awsRealTimeSocket.close();
        this.socketStatus = $e55fc92c79f0c78e$var$SOCKET_STATUS.CLOSED;
    };
    AWSAppSyncRealTimeProvider.prototype._timeoutStartSubscriptionAck = function(subscriptionId) {
        var _a = this.subscriptionObserverMap.get(subscriptionId) || {}, observer = _a.observer, query = _a.query, variables = _a.variables;
        if (!observer) return;
        this.subscriptionObserverMap.set(subscriptionId, {
            observer: observer,
            query: query,
            variables: variables,
            subscriptionState: $e55fc92c79f0c78e$var$SUBSCRIPTION_STATUS.FAILED
        });
        if (observer && !observer.closed) {
            observer.error({
                errors: [
                    $e55fc92c79f0c78e$var$__assign({}, new (0, $5SVEU.GraphQLError)("Subscription timeout " + JSON.stringify({
                        query: query,
                        variables: variables
                    })))
                ]
            });
            // Cleanup will be automatically executed
            observer.complete();
        }
        $e55fc92c79f0c78e$var$logger.debug('timeoutStartSubscription', JSON.stringify({
            query: query,
            variables: variables
        }));
    };
    AWSAppSyncRealTimeProvider.prototype._initializeWebSocketConnection = function(_a) {
        var _this = this;
        var appSyncGraphqlEndpoint = _a.appSyncGraphqlEndpoint, authenticationType = _a.authenticationType, apiKey = _a.apiKey, region = _a.region;
        if (this.socketStatus === $e55fc92c79f0c78e$var$SOCKET_STATUS.READY) return;
        return new Promise(function(res, rej) {
            return $e55fc92c79f0c78e$var$__awaiter(_this, void 0, void 0, function() {
                var protocol, discoverableEndpoint, payloadString, headerString, _a, _b, headerQs, payloadQs, awsRealTimeUrl, err_3;
                return $e55fc92c79f0c78e$var$__generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            this.promiseArray.push({
                                res: res,
                                rej: rej
                            });
                            if (!(this.socketStatus === $e55fc92c79f0c78e$var$SOCKET_STATUS.CLOSED)) return [
                                3 /*break*/ ,
                                5
                            ];
                            _c.label = 1;
                        case 1:
                            _c.trys.push([
                                1,
                                4,
                                ,
                                5
                            ]);
                            this.socketStatus = $e55fc92c79f0c78e$var$SOCKET_STATUS.CONNECTING;
                            protocol = this.isSSLEnabled ? 'wss://' : 'ws://';
                            discoverableEndpoint = appSyncGraphqlEndpoint.replace('https://', protocol).replace('http://', protocol).replace('appsync-api', 'appsync-realtime-api').replace('gogi-beta', 'grt-beta');
                            payloadString = '{}';
                            _b = (_a = JSON).stringify;
                            return [
                                4 /*yield*/ ,
                                this._awsRealTimeHeaderBasedAuth({
                                    authenticationType: authenticationType,
                                    payload: payloadString,
                                    canonicalUri: '/connect',
                                    apiKey: apiKey,
                                    appSyncGraphqlEndpoint: appSyncGraphqlEndpoint,
                                    region: region
                                })
                            ];
                        case 2:
                            headerString = _b.apply(_a, [
                                _c.sent()
                            ]);
                            headerQs = (0, $j4MAF.Buffer).from(headerString).toString('base64');
                            payloadQs = (0, $j4MAF.Buffer).from(payloadString).toString('base64');
                            awsRealTimeUrl = discoverableEndpoint + "?header=" + headerQs + "&payload=" + payloadQs;
                            return [
                                4 /*yield*/ ,
                                this._initializeRetryableHandshake({
                                    awsRealTimeUrl: awsRealTimeUrl
                                })
                            ];
                        case 3:
                            _c.sent();
                            this.promiseArray.forEach(function(_a) {
                                var res = _a.res;
                                $e55fc92c79f0c78e$var$logger.debug('Notifying connection successful');
                                res();
                            });
                            this.socketStatus = $e55fc92c79f0c78e$var$SOCKET_STATUS.READY;
                            this.promiseArray = [];
                            return [
                                3 /*break*/ ,
                                5
                            ];
                        case 4:
                            err_3 = _c.sent();
                            this.promiseArray.forEach(function(_a) {
                                var rej = _a.rej;
                                return rej(err_3);
                            });
                            this.promiseArray = [];
                            if (this.awsRealTimeSocket && this.awsRealTimeSocket.readyState === WebSocket.OPEN) this.awsRealTimeSocket.close(3001);
                            this.awsRealTimeSocket = null;
                            this.socketStatus = $e55fc92c79f0c78e$var$SOCKET_STATUS.CLOSED;
                            return [
                                3 /*break*/ ,
                                5
                            ];
                        case 5:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        });
    };
    AWSAppSyncRealTimeProvider.prototype._initializeRetryableHandshake = function(_a) {
        var awsRealTimeUrl = _a.awsRealTimeUrl;
        return $e55fc92c79f0c78e$var$__awaiter(this, void 0, void 0, function() {
            return $e55fc92c79f0c78e$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        $e55fc92c79f0c78e$var$logger.debug("Initializaling retryable Handshake");
                        return [
                            4 /*yield*/ ,
                            (0, $7TTzY.jitteredExponentialRetry)(this._initializeHandshake.bind(this), [
                                {
                                    awsRealTimeUrl: awsRealTimeUrl
                                }
                            ], $e55fc92c79f0c78e$var$MAX_DELAY_MS)
                        ];
                    case 1:
                        _b.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSAppSyncRealTimeProvider.prototype._initializeHandshake = function(_a) {
        var awsRealTimeUrl = _a.awsRealTimeUrl;
        return $e55fc92c79f0c78e$var$__awaiter(this, void 0, void 0, function() {
            var err_4, errorType, errorCode;
            var _this = this;
            return $e55fc92c79f0c78e$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        $e55fc92c79f0c78e$var$logger.debug("Initializing handshake " + awsRealTimeUrl);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            function() {
                                return new Promise(function(res, rej) {
                                    var newSocket = new WebSocket(awsRealTimeUrl, 'graphql-ws');
                                    newSocket.onerror = function() {
                                        $e55fc92c79f0c78e$var$logger.debug("WebSocket connection error");
                                    };
                                    newSocket.onclose = function() {
                                        rej(new Error('Connection handshake error'));
                                    };
                                    newSocket.onopen = function() {
                                        _this.awsRealTimeSocket = newSocket;
                                        return res();
                                    };
                                });
                            }()
                        ];
                    case 2:
                        _b.sent();
                        // Step 2: wait for ack from AWS AppSyncReaTime after sending init
                        return [
                            4 /*yield*/ ,
                            function() {
                                return new Promise(function(res, rej) {
                                    var ackOk = false;
                                    _this.awsRealTimeSocket.onerror = function(error) {
                                        $e55fc92c79f0c78e$var$logger.debug("WebSocket error " + JSON.stringify(error));
                                    };
                                    _this.awsRealTimeSocket.onclose = function(event) {
                                        $e55fc92c79f0c78e$var$logger.debug("WebSocket closed " + event.reason);
                                        rej(new Error(JSON.stringify(event)));
                                    };
                                    _this.awsRealTimeSocket.onmessage = function(message) {
                                        $e55fc92c79f0c78e$var$logger.debug("subscription message from AWS AppSyncRealTime: " + message.data + " ");
                                        var data = JSON.parse(message.data);
                                        var type = data.type, _a = data.payload, _b = (_a === void 0 ? {} : _a).connectionTimeoutMs, connectionTimeoutMs = _b === void 0 ? $e55fc92c79f0c78e$var$DEFAULT_KEEP_ALIVE_TIMEOUT : _b;
                                        if (type === $e55fc92c79f0c78e$var$MESSAGE_TYPES.GQL_CONNECTION_ACK) {
                                            ackOk = true;
                                            _this.keepAliveTimeout = connectionTimeoutMs;
                                            _this.awsRealTimeSocket.onmessage = _this._handleIncomingSubscriptionMessage.bind(_this);
                                            _this.awsRealTimeSocket.onerror = function(err) {
                                                $e55fc92c79f0c78e$var$logger.debug(err);
                                                _this._errorDisconnect((0, $gy3Xv.CONTROL_MSG).CONNECTION_CLOSED);
                                            };
                                            _this.awsRealTimeSocket.onclose = function(event) {
                                                $e55fc92c79f0c78e$var$logger.debug("WebSocket closed " + event.reason);
                                                _this._errorDisconnect((0, $gy3Xv.CONTROL_MSG).CONNECTION_CLOSED);
                                            };
                                            res('Cool, connected to AWS AppSyncRealTime');
                                            return;
                                        }
                                        if (type === $e55fc92c79f0c78e$var$MESSAGE_TYPES.GQL_CONNECTION_ERROR) {
                                            var _c = data.payload, _d = (_c === void 0 ? {} : _c).errors, _e = $e55fc92c79f0c78e$var$__read(_d === void 0 ? [] : _d, 1), _f = _e[0], _g = _f === void 0 ? {} : _f, _h = _g.errorType, errorType = _h === void 0 ? '' : _h, _j = _g.errorCode, errorCode = _j === void 0 ? 0 : _j;
                                            rej({
                                                errorType: errorType,
                                                errorCode: errorCode
                                            });
                                        }
                                    };
                                    var gqlInit = {
                                        type: $e55fc92c79f0c78e$var$MESSAGE_TYPES.GQL_CONNECTION_INIT
                                    };
                                    _this.awsRealTimeSocket.send(JSON.stringify(gqlInit));
                                    function checkAckOk() {
                                        if (!ackOk) rej(new Error("Connection timeout: ack from AWSRealTime was not received on " + $e55fc92c79f0c78e$var$CONNECTION_INIT_TIMEOUT + " ms"));
                                    }
                                    setTimeout(checkAckOk.bind(_this), $e55fc92c79f0c78e$var$CONNECTION_INIT_TIMEOUT);
                                });
                            }()
                        ];
                    case 3:
                        // Step 2: wait for ack from AWS AppSyncReaTime after sending init
                        _b.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        err_4 = _b.sent();
                        errorType = err_4.errorType, errorCode = err_4.errorCode;
                        if ($e55fc92c79f0c78e$var$NON_RETRYABLE_CODES.includes(errorCode)) throw new (0, $7TTzY.NonRetryableError)(errorType);
                        else if (errorType) throw new Error(errorType);
                        else throw err_4;
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSAppSyncRealTimeProvider.prototype._awsRealTimeHeaderBasedAuth = function(_a) {
        var authenticationType = _a.authenticationType, payload = _a.payload, canonicalUri = _a.canonicalUri, appSyncGraphqlEndpoint = _a.appSyncGraphqlEndpoint, apiKey = _a.apiKey, region = _a.region;
        return $e55fc92c79f0c78e$var$__awaiter(this, void 0, void 0, function() {
            var headerHandler, handler, host, result;
            return $e55fc92c79f0c78e$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        headerHandler = {
                            API_KEY: this._awsRealTimeApiKeyHeader.bind(this),
                            AWS_IAM: this._awsRealTimeIAMHeader.bind(this),
                            OPENID_CONNECT: this._awsRealTimeOPENIDHeader.bind(this),
                            AMAZON_COGNITO_USER_POOLS: this._awsRealTimeCUPHeader.bind(this)
                        };
                        handler = headerHandler[authenticationType];
                        if (typeof handler !== 'function') {
                            $e55fc92c79f0c78e$var$logger.debug("Authentication type " + authenticationType + " not supported");
                            return [
                                2 /*return*/ ,
                                ''
                            ];
                        }
                        host = $kcgTr.parse(appSyncGraphqlEndpoint).host;
                        return [
                            4 /*yield*/ ,
                            handler({
                                payload: payload,
                                canonicalUri: canonicalUri,
                                appSyncGraphqlEndpoint: appSyncGraphqlEndpoint,
                                apiKey: apiKey,
                                region: region,
                                host: host
                            })
                        ];
                    case 1:
                        result = _b.sent();
                        return [
                            2 /*return*/ ,
                            result
                        ];
                }
            });
        });
    };
    AWSAppSyncRealTimeProvider.prototype._awsRealTimeCUPHeader = function(_a) {
        var host = _a.host;
        return $e55fc92c79f0c78e$var$__awaiter(this, void 0, void 0, function() {
            var session;
            return $e55fc92c79f0c78e$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            (0, $i14CG.default).currentSession()
                        ];
                    case 1:
                        session = _b.sent();
                        return [
                            2 /*return*/ ,
                            {
                                Authorization: session.getAccessToken().getJwtToken(),
                                host: host
                            }
                        ];
                }
            });
        });
    };
    AWSAppSyncRealTimeProvider.prototype._awsRealTimeOPENIDHeader = function(_a) {
        var host = _a.host;
        return $e55fc92c79f0c78e$var$__awaiter(this, void 0, void 0, function() {
            var token, federatedInfo, currentUser;
            return $e55fc92c79f0c78e$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            (0, $8SrNO.default).getItem('federatedInfo')
                        ];
                    case 1:
                        federatedInfo = _b.sent();
                        if (!federatedInfo) return [
                            3 /*break*/ ,
                            2
                        ];
                        token = federatedInfo.token;
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 2:
                        return [
                            4 /*yield*/ ,
                            (0, $i14CG.default).currentAuthenticatedUser()
                        ];
                    case 3:
                        currentUser = _b.sent();
                        if (currentUser) token = currentUser.token;
                        _b.label = 4;
                    case 4:
                        if (!token) throw new Error('No federated jwt');
                        return [
                            2 /*return*/ ,
                            {
                                Authorization: token,
                                host: host
                            }
                        ];
                }
            });
        });
    };
    AWSAppSyncRealTimeProvider.prototype._awsRealTimeApiKeyHeader = function(_a) {
        var apiKey = _a.apiKey, host = _a.host;
        return $e55fc92c79f0c78e$var$__awaiter(this, void 0, void 0, function() {
            var dt, dtStr;
            return $e55fc92c79f0c78e$var$__generator(this, function(_b) {
                dt = new Date();
                dtStr = dt.toISOString().replace(/[:\-]|\.\d{3}/g, '');
                return [
                    2 /*return*/ ,
                    {
                        host: host,
                        'x-amz-date': dtStr,
                        'x-api-key': apiKey
                    }
                ];
            });
        });
    };
    AWSAppSyncRealTimeProvider.prototype._awsRealTimeIAMHeader = function(_a) {
        var payload = _a.payload, canonicalUri = _a.canonicalUri, appSyncGraphqlEndpoint = _a.appSyncGraphqlEndpoint, region = _a.region;
        return $e55fc92c79f0c78e$var$__awaiter(this, void 0, void 0, function() {
            var endpointInfo, credentialsOK, creds, request, signed_params;
            return $e55fc92c79f0c78e$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        endpointInfo = {
                            region: region,
                            service: 'appsync'
                        };
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _b.sent();
                        if (!credentialsOK) throw new Error('No credentials');
                        return [
                            4 /*yield*/ ,
                            (0, $29OQz.Credentials).get().then(function(credentials) {
                                return {
                                    secret_key: credentials.secretAccessKey,
                                    access_key: credentials.accessKeyId,
                                    session_token: credentials.sessionToken
                                };
                            })
                        ];
                    case 2:
                        creds = _b.sent();
                        request = {
                            url: "" + appSyncGraphqlEndpoint + canonicalUri,
                            data: payload,
                            method: 'POST',
                            headers: $e55fc92c79f0c78e$var$__assign({}, $e55fc92c79f0c78e$var$AWS_APPSYNC_REALTIME_HEADERS)
                        };
                        signed_params = (0, $ap2RT.Signer).sign(request, creds, endpointInfo);
                        return [
                            2 /*return*/ ,
                            signed_params.headers
                        ];
                }
            });
        });
    };
    /**
     * @private
     */ AWSAppSyncRealTimeProvider.prototype._ensureCredentials = function() {
        return (0, $29OQz.Credentials).get().then(function(credentials) {
            if (!credentials) return false;
            var cred = (0, $29OQz.Credentials).shear(credentials);
            $e55fc92c79f0c78e$var$logger.debug('set credentials for AWSAppSyncRealTimeProvider', cred);
            return true;
        }).catch(function(err) {
            $e55fc92c79f0c78e$var$logger.warn('ensure credentials error', err);
            return false;
        });
    };
    return AWSAppSyncRealTimeProvider;
}((0, $gGyGQ.AbstractPubSubProvider));

});
parcelRegister("5SVEU", function(module, exports) {

$parcel$export(module.exports, "GraphQLError", () => $c5bbf3b1d974f311$export$92d6ed0888e7cb7f);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */ 
var $kcFri = parcelRequire("kcFri");

var $cYyrB = parcelRequire("cYyrB");
function $c5bbf3b1d974f311$export$92d6ed0888e7cb7f(message, nodes, source, positions, path, originalError, extensions) {
    // Compute list of blame nodes.
    var _nodes = Array.isArray(nodes) ? nodes.length !== 0 ? nodes : undefined : nodes ? [
        nodes
    ] : undefined; // Compute locations in the source for the given nodes/positions.
    var _source = source;
    if (!_source && _nodes) {
        var node = _nodes[0];
        _source = node && node.loc && node.loc.source;
    }
    var _positions = positions;
    if (!_positions && _nodes) _positions = _nodes.reduce(function(list, node) {
        if (node.loc) list.push(node.loc.start);
        return list;
    }, []);
    if (_positions && _positions.length === 0) _positions = undefined;
    var _locations;
    if (positions && source) _locations = positions.map(function(pos) {
        return (0, $cYyrB.getLocation)(source, pos);
    });
    else if (_nodes) _locations = _nodes.reduce(function(list, node) {
        if (node.loc) list.push((0, $cYyrB.getLocation)(node.loc.source, node.loc.start));
        return list;
    }, []);
    var _extensions = extensions || originalError && originalError.extensions;
    Object.defineProperties(this, {
        message: {
            value: message,
            // By being enumerable, JSON.stringify will include `message` in the
            // resulting output. This ensures that the simplest possible GraphQL
            // service adheres to the spec.
            enumerable: true,
            writable: true
        },
        locations: {
            // Coercing falsey values to undefined ensures they will not be included
            // in JSON.stringify() when not provided.
            value: _locations || undefined,
            // By being enumerable, JSON.stringify will include `locations` in the
            // resulting output. This ensures that the simplest possible GraphQL
            // service adheres to the spec.
            enumerable: Boolean(_locations)
        },
        path: {
            // Coercing falsey values to undefined ensures they will not be included
            // in JSON.stringify() when not provided.
            value: path || undefined,
            // By being enumerable, JSON.stringify will include `path` in the
            // resulting output. This ensures that the simplest possible GraphQL
            // service adheres to the spec.
            enumerable: Boolean(path)
        },
        nodes: {
            value: _nodes || undefined
        },
        source: {
            value: _source || undefined
        },
        positions: {
            value: _positions || undefined
        },
        originalError: {
            value: originalError
        },
        extensions: {
            // Coercing falsey values to undefined ensures they will not be included
            // in JSON.stringify() when not provided.
            value: _extensions || undefined,
            // By being enumerable, JSON.stringify will include `path` in the
            // resulting output. This ensures that the simplest possible GraphQL
            // service adheres to the spec.
            enumerable: Boolean(_extensions)
        }
    }); // Include (non-enumerable) stack trace.
    if (originalError && originalError.stack) Object.defineProperty(this, 'stack', {
        value: originalError.stack,
        writable: true,
        configurable: true
    });
    else if (Error.captureStackTrace) Error.captureStackTrace(this, $c5bbf3b1d974f311$export$92d6ed0888e7cb7f);
    else Object.defineProperty(this, 'stack', {
        value: Error().stack,
        writable: true,
        configurable: true
    });
}
$c5bbf3b1d974f311$export$92d6ed0888e7cb7f.prototype = Object.create(Error.prototype, {
    constructor: {
        value: $c5bbf3b1d974f311$export$92d6ed0888e7cb7f
    },
    name: {
        value: 'GraphQLError'
    },
    toString: {
        value: function toString() {
            return (0, $kcFri.printError)(this);
        }
    }
});

});
parcelRegister("kcFri", function(module, exports) {

$parcel$export(module.exports, "printError", () => $62a126b30427d6b3$export$55ee1551a3f962e6);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */ 
var $cYyrB = parcelRequire("cYyrB");
function $62a126b30427d6b3$export$55ee1551a3f962e6(error) {
    var printedLocations = [];
    if (error.nodes) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;
        try {
            for(var _iterator = error.nodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var node = _step.value;
                if (node.loc) printedLocations.push($62a126b30427d6b3$var$highlightSourceAtLocation(node.loc.source, (0, $cYyrB.getLocation)(node.loc.source, node.loc.start)));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) _iterator.return();
            } finally{
                if (_didIteratorError) throw _iteratorError;
            }
        }
    } else if (error.source && error.locations) {
        var source = error.source;
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;
        try {
            for(var _iterator2 = error.locations[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                var location = _step2.value;
                printedLocations.push($62a126b30427d6b3$var$highlightSourceAtLocation(source, location));
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return != null) _iterator2.return();
            } finally{
                if (_didIteratorError2) throw _iteratorError2;
            }
        }
    }
    return printedLocations.length === 0 ? error.message : [
        error.message
    ].concat(printedLocations).join('\n\n') + '\n';
}
/**
 * Render a helpful description of the location of the error in the GraphQL
 * Source document.
 */ function $62a126b30427d6b3$var$highlightSourceAtLocation(source, location) {
    var firstLineColumnOffset = source.locationOffset.column - 1;
    var body = $62a126b30427d6b3$var$whitespace(firstLineColumnOffset) + source.body;
    var lineIndex = location.line - 1;
    var lineOffset = source.locationOffset.line - 1;
    var lineNum = location.line + lineOffset;
    var columnOffset = location.line === 1 ? firstLineColumnOffset : 0;
    var columnNum = location.column + columnOffset;
    var lines = body.split(/\r\n|[\n\r]/g);
    return "".concat(source.name, " (").concat(lineNum, ":").concat(columnNum, ")\n") + $62a126b30427d6b3$var$printPrefixedLines([
        [
            "".concat(lineNum - 1, ": "),
            lines[lineIndex - 1]
        ],
        [
            "".concat(lineNum, ": "),
            lines[lineIndex]
        ],
        [
            '',
            $62a126b30427d6b3$var$whitespace(columnNum - 1) + '^'
        ],
        [
            "".concat(lineNum + 1, ": "),
            lines[lineIndex + 1]
        ]
    ]);
}
function $62a126b30427d6b3$var$printPrefixedLines(lines) {
    var existingLines = lines.filter(function(_ref) {
        var _ = _ref[0], line = _ref[1];
        return line !== undefined;
    });
    var padLen = 0;
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;
    try {
        for(var _iterator3 = existingLines[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
            var _ref4 = _step3.value;
            var prefix = _ref4[0];
            padLen = Math.max(padLen, prefix.length);
        }
    } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion3 && _iterator3.return != null) _iterator3.return();
        } finally{
            if (_didIteratorError3) throw _iteratorError3;
        }
    }
    return existingLines.map(function(_ref3) {
        var prefix = _ref3[0], line = _ref3[1];
        return $62a126b30427d6b3$var$lpad(padLen, prefix) + line;
    }).join('\n');
}
function $62a126b30427d6b3$var$whitespace(len) {
    return Array(len + 1).join(' ');
}
function $62a126b30427d6b3$var$lpad(len, str) {
    return $62a126b30427d6b3$var$whitespace(len - str.length) + str;
}

});
parcelRegister("cYyrB", function(module, exports) {

$parcel$export(module.exports, "getLocation", () => $262895fefceab2a2$export$e7fd20fad3cf4b5f);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */ /**
 * Represents a location in a Source.
 */ /**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */ function $262895fefceab2a2$export$e7fd20fad3cf4b5f(source, position) {
    var lineRegexp = /\r\n|[\n\r]/g;
    var line = 1;
    var column = position + 1;
    var match;
    while((match = lineRegexp.exec(source.body)) && match.index < position){
        line += 1;
        column = position + 1 - (match.index + match[0].length);
    }
    return {
        line: line,
        column: column
    };
}

});






parcelRegister("gBcFT", function(module, exports) {

$parcel$export(module.exports, "GRAPHQL_AUTH_MODE", () => $c159eef711817d24$export$cfce9c15015bef96);
$parcel$export(module.exports, "GraphQLAuthError", () => $c159eef711817d24$export$b77ee9d1a91b5bd);
var $c159eef711817d24$export$cfce9c15015bef96;
(function(GRAPHQL_AUTH_MODE) {
    GRAPHQL_AUTH_MODE["API_KEY"] = "API_KEY";
    GRAPHQL_AUTH_MODE["AWS_IAM"] = "AWS_IAM";
    GRAPHQL_AUTH_MODE["OPENID_CONNECT"] = "OPENID_CONNECT";
    GRAPHQL_AUTH_MODE["AMAZON_COGNITO_USER_POOLS"] = "AMAZON_COGNITO_USER_POOLS";
})($c159eef711817d24$export$cfce9c15015bef96 || ($c159eef711817d24$export$cfce9c15015bef96 = {}));
var $c159eef711817d24$export$b77ee9d1a91b5bd;
(function(GraphQLAuthError) {
    GraphQLAuthError["NO_API_KEY"] = "No api-key configured";
    GraphQLAuthError["NO_CURRENT_USER"] = "No current user";
    GraphQLAuthError["NO_CREDENTIALS"] = "No credentials";
    GraphQLAuthError["NO_FEDERATED_JWT"] = "No federated jwt";
})($c159eef711817d24$export$b77ee9d1a91b5bd || ($c159eef711817d24$export$b77ee9d1a91b5bd = {}));

});



parcelRegister("3X1JC", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "GraphQLAuthError", () => (parcelRequire("gBcFT")).GraphQLAuthError);
$parcel$export(module.exports, "GRAPHQL_AUTH_MODE", () => (parcelRequire("gBcFT")).GRAPHQL_AUTH_MODE);
/*
 * Copyright 2017-2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $g8Cjm = parcelRequire("g8Cjm");

var $gBcFT = parcelRequire("gBcFT");
var $2e083a44905ff581$export$2e2bcd8739ae039 = (0, $g8Cjm.GraphQLAPI);

});


parcelRegister("5osCm", function(module, exports) {
!function(t, _) {
    module.exports = _();
}(module.exports, function() {
    return function(t) {
        var _ = {};
        function n(o) {
            if (_[o]) return _[o].exports;
            var e = _[o] = {
                i: o,
                l: !1,
                exports: {}
            };
            return t[o].call(e.exports, e, e.exports, n), e.l = !0, e.exports;
        }
        return n.m = t, n.c = _, n.d = function(t, _, o) {
            n.o(t, _) || Object.defineProperty(t, _, {
                enumerable: !0,
                get: o
            });
        }, n.r = function(t) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(t, "__esModule", {
                value: !0
            });
        }, n.t = function(t, _) {
            if (1 & _ && (t = n(t)), 8 & _) return t;
            if (4 & _ && "object" == typeof t && t && t.__esModule) return t;
            var o = Object.create(null);
            if (n.r(o), Object.defineProperty(o, "default", {
                enumerable: !0,
                value: t
            }), 2 & _ && "string" != typeof t) for(var e in t)n.d(o, e, (function(_) {
                return t[_];
            }).bind(null, e));
            return o;
        }, n.n = function(t) {
            var _ = t && t.__esModule ? function() {
                return t.default;
            } : function() {
                return t;
            };
            return n.d(_, "a", _), _;
        }, n.o = function(t, _) {
            return Object.prototype.hasOwnProperty.call(t, _);
        }, n.p = "", n(n.s = 0);
    }([
        function(t, _, n) {
            "use strict";
            function o(t) {
                for(var n in t)_.hasOwnProperty(n) || (_[n] = t[n]);
            }
            Object.defineProperty(_, "__esModule", {
                value: !0
            }), o(n(1)), o(n(2)), o(n(3)), o(n(4)), o(n(5)), o(n(6)), o(n(7)), o(n(8)), o(n(9)), o(n(10)), o(n(11)), o(n(12)), o(n(13));
        },
        function(t, _, n) {
            t.exports = {
                a: "Anchor__a___1_Iz8"
            };
        },
        function(t, _, n) {
            t.exports = {
                button: "Button__button___vS7Mv",
                signInButton: "Button__signInButton___3bUH-",
                googleSignInButton: "Button__googleSignInButton___1YiCu",
                signInButtonIcon: "Button__signInButtonIcon___ihN75",
                auth0SignInButton: "Button__auth0SignInButton___znnCj",
                facebookSignInButton: "Button__facebookSignInButton___34Txh",
                amazonSignInButton: "Button__amazonSignInButton___2EMtl",
                oAuthSignInButton: "Button__oAuthSignInButton___3UGOl",
                signInButtonContent: "Button__signInButtonContent___xqTXJ"
            };
        },
        function(t, _, n) {
            t.exports = {
                formContainer: "Form__formContainer___1GA3x",
                formSection: "Form__formSection___1PPvW",
                formField: "Form__formField___38Ikl",
                formRow: "Form__formRow___2mwRs"
            };
        },
        function(t, _, n) {
            t.exports = {
                hint: "Hint__hint___2XngB"
            };
        },
        function(t, _, n) {
            t.exports = {
                input: "Input__input___3e_bf",
                inputLabel: "Input__inputLabel___3VF0S",
                label: "Input__label___23sO8",
                radio: "Input__radio___2hllK"
            };
        },
        function(t, _, n) {
            t.exports = {
                navBar: "Nav__navBar___xtCFA",
                navRight: "Nav__navRight___1QG2J",
                nav: "Nav__nav___2Dx2Y",
                navItem: "Nav__navItem___1LtFQ"
            };
        },
        function(t, _, n) {
            t.exports = {
                photoPickerButton: "PhotoPicker__photoPickerButton___2XdVn",
                photoPlaceholder: "PhotoPicker__photoPlaceholder___2JXO4",
                photoPlaceholderIcon: "PhotoPicker__photoPlaceholderIcon___3Et71"
            };
        },
        function(t, _, n) {
            t.exports = {
                container: "Section__container___3YYTG",
                actionRow: "Section__actionRow___2LWSU",
                sectionHeader: "Section__sectionHeader___2djyg",
                sectionHeaderHint: "Section__sectionHeaderHint___3Wxdc",
                sectionBody: "Section__sectionBody___ihqqd",
                sectionHeaderContent: "Section__sectionHeaderContent___1UCqa",
                sectionFooter: "Section__sectionFooter___1T54C",
                sectionFooterPrimaryContent: "Section__sectionFooterPrimaryContent___2r9ZX",
                sectionFooterSecondaryContent: "Section__sectionFooterSecondaryContent___Nj41Q"
            };
        },
        function(t, _, n) {
            t.exports = {
                selectInput: "SelectInput__selectInput___3efO4"
            };
        },
        function(t, _, n) {
            t.exports = {
                strike: "Strike__strike___1XV1b",
                strikeContent: "Strike__strikeContent___10gLb"
            };
        },
        function(t, _, n) {
            t.exports = {
                toast: "Toast__toast___XXr3v",
                toastClose: "Toast__toastClose___18lU4"
            };
        },
        function(t, _, n) {
            t.exports = {
                totpQrcode: "Totp__totpQrcode___1crLx"
            };
        },
        function(t, _, n) {
            t.exports = {
                sumerianSceneContainer: "XR__sumerianSceneContainer___3nVMt",
                sumerianScene: "XR__sumerianScene___2Tt7-",
                loadingOverlay: "XR__loadingOverlay___IbqcI",
                loadingContainer: "XR__loadingContainer___2Itxb",
                loadingLogo: "XR__loadingLogo___Ub7xQ",
                loadingSceneName: "XR__loadingSceneName___3__ne",
                loadingBar: "XR__loadingBar___2vcke",
                loadingBarFill: "XR__loadingBarFill___3M-D9",
                sceneErrorText: "XR__sceneErrorText___2y0tp",
                sceneBar: "XR__sceneBar___2ShrP",
                sceneName: "XR__sceneName___1ApHr",
                sceneActions: "XR__sceneActions___7plGs",
                actionButton: "XR__actionButton___2poIM",
                tooltip: "XR__tooltip___UYyhn",
                actionIcon: "XR__actionIcon___2qnd2",
                autoShowTooltip: "XR__autoShowTooltip___V1QH7"
            };
        }
    ]);
});

});


parcelRegister("f9eUc", function(module, exports) {

$parcel$export(module.exports, "AirCurtainGroup", () => $ae12bb685e37d818$export$b5e4d4cf5c16ad2);

var $4hGcu = parcelRequire("4hGcu");

var $gAjJp = parcelRequire("gAjJp");
const $ae12bb685e37d818$var$objectType = 'airCurtainGroup';
class $ae12bb685e37d818$export$b5e4d4cf5c16ad2 {
    constructor(airCurtainGroupID){
        this._saveMethod = (0, $4hGcu.createObjects);
        this._object = {
            airCurtainGroupID: airCurtainGroupID,
            accountID: undefined,
            name: undefined,
            parentObjectType: undefined,
            parentObjectID: undefined,
            airCurtains: []
        };
    }
    static createNew() {
        return new $ae12bb685e37d818$export$b5e4d4cf5c16ad2((0, $gAjJp.default)());
    }
    static createFromObject(airCurtainGroup) {
        const obj = new $ae12bb685e37d818$export$b5e4d4cf5c16ad2(airCurtainGroup.airCurtainGroupID);
        obj._object = airCurtainGroup;
        obj._saveMethod = (0, $4hGcu.updateObjects);
        return obj;
    }
    async load() {
        const getObject = {
            objectType: $ae12bb685e37d818$var$objectType,
            keys: [
                this._object.airCurtainGroupID
            ]
        };
        this._lastError = undefined;
        try {
            const response = await (0, $4hGcu.getObjects)([
                getObject
            ]);
            if (response && response.length > 0 && response[0].objects && response[0].objects.length == 1) {
                this._saveMethod = (0, $4hGcu.updateObjects);
                this._object = response[0].objects[0];
                return true;
            } else {
                this._lastError = new Error('air curtain group not found');
                return false;
            }
        } catch (error) {
            this._lastError = error;
            return false;
        }
    }
    async save() {
        const saveObject = {
            objectType: $ae12bb685e37d818$var$objectType,
            object: this._object
        };
        this._lastError = undefined;
        if (this._object.name == undefined) {
            this._lastError = new Error('Name is undefined');
            return false;
        }
        if (this._object.accountID == undefined) {
            this._lastError = new Error('Account ID is undefined');
            return false;
        }
        if (this._object.parentObjectType == undefined) {
            this._lastError = new Error('Parent Group Type is undefined');
            return false;
        }
        if (this._object.parentObjectID == undefined) {
            this._lastError = new Error('Parent Group ID is undefined');
            return false;
        }
        try {
            const response = await this._saveMethod([
                saveObject
            ]);
            if (response) this._saveMethod = (0, $4hGcu.updateObjects);
            else this._lastError = new Error('unknown server error');
            return response;
        } catch (error) {
            this._lastError = error;
            return false;
        }
    }
    async delete() {
        const deleteObject = {
            objectType: $ae12bb685e37d818$var$objectType,
            object: this._object
        };
        this._lastError = undefined;
        try {
            const response = await (0, $4hGcu.deleteObjects)([
                deleteObject
            ]);
            return response;
        } catch (error) {
            this._lastError = error;
            return false;
        }
    }
    get lastError() {
        return this._lastError;
    }
    get airCurtainGroupID() {
        return this._object.airCurtainGroupID;
    }
    get accountID() {
        return this._object.accountID;
    }
    set accountID(accountID) {
        this._object.accountID = accountID;
    }
    get name() {
        return this._object.name;
    }
    set name(name) {
        this._object.name = name;
    }
    get parentObjectType() {
        return this._object.parentObjectType;
    }
    set parentObjectType(parentObjectType) {
        this._object.parentObjectType = parentObjectType;
    }
    get parentObjectID() {
        return this._object.parentObjectID;
    }
    set parentObjectID(parentObjectID) {
        this._object.parentObjectID = parentObjectID;
    }
    get airCurtains() {
        return this._object.airCurtains;
    }
    addAirCurtain(airCurtain) {
        if (this._object.airCurtains.includes(airCurtain.airCurtainID)) return;
        this._object.airCurtains.push(airCurtain.airCurtainID);
    }
    deleteAirCurtain(airCurtain) {
        const index = this._object.airCurtains.indexOf(airCurtain.airCurtainID);
        if (index > -1) this._object.airCurtains.splice(index, 1);
    }
}

});
parcelRegister("4hGcu", function(module, exports) {

$parcel$export(module.exports, "getObjects", () => $27819f8eb786d0cc$export$87e29e00b94380cb);
$parcel$export(module.exports, "createObjects", () => $27819f8eb786d0cc$export$1765ea771e08bbac);
$parcel$export(module.exports, "updateObjects", () => $27819f8eb786d0cc$export$63ecd376187faef3);
$parcel$export(module.exports, "deleteObjects", () => $27819f8eb786d0cc$export$97260d2b45a861d7);
$parcel$export(module.exports, "getUserPolicies", () => $27819f8eb786d0cc$export$a17e6eff6cf672c8);
$parcel$export(module.exports, "getShadow", () => $27819f8eb786d0cc$export$db93b77dbb14f011);
$parcel$export(module.exports, "updateShadow", () => $27819f8eb786d0cc$export$f5c9f43142e3a83e);
$parcel$export(module.exports, "getInstallations", () => $27819f8eb786d0cc$export$9bfc115e43431ff5);
$parcel$export(module.exports, "saveInstallations", () => $27819f8eb786d0cc$export$ec4ef56f237e2533);
$parcel$export(module.exports, "deleteInstallations", () => $27819f8eb786d0cc$export$5f6b87a08674814c);
$parcel$export(module.exports, "getLocations", () => $27819f8eb786d0cc$export$c07c686062478869);
$parcel$export(module.exports, "saveLocations", () => $27819f8eb786d0cc$export$1723e7c2a68c794b);
$parcel$export(module.exports, "deleteLocations", () => $27819f8eb786d0cc$export$c6b784afcd27cfc3);
$parcel$export(module.exports, "getCognitoUser", () => $27819f8eb786d0cc$export$3679b2e96ab4b6be);
$parcel$export(module.exports, "sendInvitationEmail", () => $27819f8eb786d0cc$export$6c31257c58714c54);
$parcel$export(module.exports, "getSiteCurrentWeather", () => $27819f8eb786d0cc$export$cd9ebf2264fdbe04);
$parcel$export(module.exports, "getUnitIDs", () => $27819f8eb786d0cc$export$8b1f560709551ebd);
$parcel$export(module.exports, "getIdentityAirCurtainCounts", () => $27819f8eb786d0cc$export$fa6cd2d6b5dba0e9);
parcelRequire("atl0T");
var $cbbVi = parcelRequire("cbbVi");parcelRequire("hIPiC");
var $g0OFw = parcelRequire("g0OFw");

var $gdUg7 = parcelRequire("gdUg7");
const $27819f8eb786d0cc$var$API_NAME = 'WebApplicationAPI';
const $27819f8eb786d0cc$var$APP_VERSION = '2.0';
const $27819f8eb786d0cc$var$PROTOCOL_VERSION = '0.1';
const $27819f8eb786d0cc$export$87e29e00b94380cb = (getRequests)=>{
    return new Promise(async (resolve, reject)=>{
        try {
            const response = await $27819f8eb786d0cc$var$post('getobjects', {
                getRequests: getRequests
            });
            resolve(response.data.body.response);
        } catch (error) {
            if (error.response && error.response.data && error.response.data.body && error.response.data.body.error) reject(new Error(error.response.data.body.error));
            else reject(error);
        }
    });
};
const $27819f8eb786d0cc$export$1765ea771e08bbac = (createRequests)=>{
    return new Promise(async (resolve, reject)=>{
        try {
            const response = await $27819f8eb786d0cc$var$post('createobjects', {
                createRequests: createRequests
            });
            resolve(response.data.body.response);
        } catch (error) {
            if (error.response && error.response.data && error.response.data.body && error.response.data.body.error) reject(new Error(error.response.data.body.error));
            else reject(error);
        }
    });
};
const $27819f8eb786d0cc$export$63ecd376187faef3 = (updateRequests)=>{
    return new Promise(async (resolve, reject)=>{
        try {
            const response = await $27819f8eb786d0cc$var$post('updateobjects', {
                updateRequests: updateRequests
            });
            resolve(response.data.body.response);
        } catch (error) {
            if (error.response && error.response.data && error.response.data.body && error.response.data.body.error) reject(new Error(error.response.data.body.error));
            else reject(error);
        }
    });
};
const $27819f8eb786d0cc$export$97260d2b45a861d7 = (deleteRequests)=>{
    return new Promise(async (resolve, reject)=>{
        try {
            const response = await $27819f8eb786d0cc$var$post('deleteobjects', {
                deleteRequests: deleteRequests
            });
            resolve(response.data.body.response);
        } catch (error) {
            if (error.response && error.response.data && error.response.data.body && error.response.data.body.error) reject(new Error(error.response.data.body.error));
            else reject(error);
        }
    });
};
const $27819f8eb786d0cc$export$a17e6eff6cf672c8 = (objectTypes)=>{
    return new Promise(async (resolve, reject)=>{
        try {
            const response = await $27819f8eb786d0cc$var$post('getuserpolicies', {
                objectTypes: objectTypes
            });
            resolve(response.data.body.response);
        } catch (error) {
            if (error.response && error.response.data && error.response.data.body && error.response.data.body.error) reject(new Error(error.response.data.body.error));
            else reject(error);
        }
    });
};
const $27819f8eb786d0cc$export$c98dbabd82197a3c = (request)=>{
    return new Promise(async (resolve, reject)=>{
        try {
            const response = await $27819f8eb786d0cc$var$post('verifypermissions', request);
            resolve(response.data.body.response);
        } catch (error) {
            if (error.response && error.response.data && error.response.data.body && error.response.data.body.error) reject(new Error(error.response.data.body.error));
            else reject(error);
        }
    });
};
const $27819f8eb786d0cc$export$db93b77dbb14f011 = (request)=>{
    return new Promise(async (resolve, reject)=>{
        try {
            const response = await $27819f8eb786d0cc$var$post('getshadow', request);
            resolve(response.data.body.response);
        } catch (error) {
            if (error.response && error.response.data && error.response.data.body && error.response.data.body.error) reject(new Error(error.response.data.body.error));
            else reject(error);
        }
    });
};
const $27819f8eb786d0cc$export$f5c9f43142e3a83e = (request)=>{
    return new Promise(async (resolve, reject)=>{
        try {
            const response = await $27819f8eb786d0cc$var$post('getshadow', request);
            resolve(response.data.body.response);
        } catch (error) {
            if (error.response && error.response.data && error.response.data.body && error.response.data.body.error) reject(new Error(error.response.data.body.error));
            else reject(error);
        }
    });
};
const $27819f8eb786d0cc$export$b45934b7aabb2fc3 = ()=>{
    return new Promise(async (resolve, reject)=>{
        try {
            const response = await $27819f8eb786d0cc$var$post('getobjectandactiontypes', undefined);
            resolve(response.data.body.response);
        } catch (error) {
            if (error.response && error.response.data && error.response.data.body && error.response.data.body.error) reject(new Error(error.response.data.body.error));
            else reject(error);
        }
    });
};
const $27819f8eb786d0cc$export$9bfc115e43431ff5 = (installations)=>{
    return new Promise(async (resolve, reject)=>{
        try {
            const response = await $27819f8eb786d0cc$var$post('getinstallations', {
                installations: installations
            });
            resolve(response.data.body.response);
        } catch (error) {
            if (error.response && error.response.data && error.response.data.body && error.response.data.body.error) reject(new Error(error.response.data.body.error));
            else reject(error);
        }
    });
};
const $27819f8eb786d0cc$export$ec4ef56f237e2533 = (installations)=>{
    return new Promise(async (resolve, reject)=>{
        try {
            const response = await $27819f8eb786d0cc$var$post('saveinstallations', {
                installations: installations
            });
            resolve(response.data.body.response);
        } catch (error) {
            if (error.response && error.response.data && error.response.data.body && error.response.data.body.error) reject(new Error(error.response.data.body.error));
            else reject(error);
        }
    });
};
const $27819f8eb786d0cc$export$5f6b87a08674814c = (installations)=>{
    return new Promise(async (resolve, reject)=>{
        try {
            const response = await $27819f8eb786d0cc$var$post('deleteinstallations', {
                installations: installations
            });
            resolve(response.data.body.response);
        } catch (error) {
            if (error.response && error.response.data && error.response.data.body && error.response.data.body.error) reject(new Error(error.response.data.body.error));
            else reject(error);
        }
    });
};
const $27819f8eb786d0cc$export$c07c686062478869 = (siteIDs)=>{
    return new Promise(async (resolve, reject)=>{
        try {
            const response = await $27819f8eb786d0cc$var$post('getlocations', {
                siteIDs: siteIDs
            });
            resolve(response.data.body.response);
        } catch (error) {
            if (error.response && error.response.data && error.response.data.body && error.response.data.body.error) reject(new Error(error.response.data.body.error));
            else reject(error);
        }
    });
};
const $27819f8eb786d0cc$export$1723e7c2a68c794b = (locations)=>{
    return new Promise(async (resolve, reject)=>{
        try {
            const response = await $27819f8eb786d0cc$var$post('savelocations', {
                locations: locations
            });
            resolve(response.data.body.response);
        } catch (error) {
            if (error.response && error.response.data && error.response.data.body && error.response.data.body.error) reject(new Error(error.response.data.body.error));
            else reject(error);
        }
    });
};
const $27819f8eb786d0cc$export$c6b784afcd27cfc3 = (siteIDs)=>{
    return new Promise(async (resolve, reject)=>{
        try {
            const response = await $27819f8eb786d0cc$var$post('deletelocations', {
                siteIDs: siteIDs
            });
            resolve(response.data.body.response);
        } catch (error) {
            if (error.response && error.response.data && error.response.data.body && error.response.data.body.error) reject(new Error(error.response.data.body.error));
            else reject(error);
        }
    });
};
const $27819f8eb786d0cc$export$3679b2e96ab4b6be = (request)=>{
    return new Promise(async (resolve, reject)=>{
        try {
            const response = await $27819f8eb786d0cc$var$post('getcognitouser', request);
            resolve(response.data.body.response);
        } catch (error) {
            if (error.response && error.response.data && error.response.data.body && error.response.data.body.error) reject(new Error(error.response.data.body.error));
            else reject(error);
        }
    });
};
const $27819f8eb786d0cc$export$6c31257c58714c54 = (request)=>{
    return new Promise(async (resolve, reject)=>{
        try {
            const response = await $27819f8eb786d0cc$var$post('sendinvitationemail', request);
            resolve(response.data.body.response);
        } catch (error) {
            if (error.response && error.response.data && error.response.data.body && error.response.data.body.error) reject(new Error(error.response.data.body.error));
            else reject(error);
        }
    });
};
const $27819f8eb786d0cc$export$cd9ebf2264fdbe04 = (request)=>{
    return new Promise(async (resolve, reject)=>{
        try {
            const response = await $27819f8eb786d0cc$var$post('getsitecurrentweather', request);
            resolve(response.data.body.response);
        } catch (error) {
            if (error.response && error.response.data && error.response.data.body && error.response.data.body.error) reject(new Error(error.response.data.body.error));
            else reject(error);
        }
    });
};
const $27819f8eb786d0cc$export$8b1f560709551ebd = (orderID)=>{
    return new Promise(async (resolve, reject)=>{
        try {
            const response = await $27819f8eb786d0cc$var$post('getunitids', {
                orderID: orderID
            });
            resolve(response.data.body.response);
        } catch (error) {
            if (error.response && error.response.data && error.response.data.body && error.response.data.body.error) reject(new Error(error.response.data.body.error));
            else reject(error);
        }
    });
};
const $27819f8eb786d0cc$export$fa6cd2d6b5dba0e9 = (identityIDs)=>{
    return new Promise(async (resolve, reject)=>{
        try {
            const response = await $27819f8eb786d0cc$var$post('getidentityaircurtaincounts', {
                identityIDs: identityIDs
            });
            resolve(response.data.body.response);
        } catch (error) {
            if (error.response && error.response.data && error.response.data.body && error.response.data.body.error) reject(new Error(error.response.data.body.error));
            else reject(error);
        }
    });
};
const $27819f8eb786d0cc$var$post = async (endpoint, body)=>{
    const session = await (0, $g0OFw.Auth).currentSession();
    const init = {
        headers: {
            Authorization: session.getIdToken().getJwtToken(),
            'x-api-key': (0, $gdUg7.key)
        },
        response: true,
        body: body
    };
    const response = await (0, $cbbVi.API).post($27819f8eb786d0cc$var$API_NAME, '/prod/' + endpoint, init);
    // console.log('post response: ', response);
    return response;
};

});
parcelRegister("gdUg7", function(module, exports) {
module.exports = JSON.parse("{\"key\":\"ol9FFdwsLr58oaMVNfkls2j4eJ5sxVwhp3xbPVb0\"}");

});


parcelRegister("gAjJp", function(module, exports) {

$parcel$export(module.exports, "default", () => $c12f5060cd98c99c$export$2e2bcd8739ae039);

var $apv4B = parcelRequire("apv4B");

var $e5CpU = parcelRequire("e5CpU");
function $c12f5060cd98c99c$var$v4(options, buf, offset) {
    options = options || {};
    var rnds = options.random || (options.rng || (0, $apv4B.default))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $e5CpU.default)(rnds);
}
var $c12f5060cd98c99c$export$2e2bcd8739ae039 = $c12f5060cd98c99c$var$v4;

});
parcelRegister("apv4B", function(module, exports) {

$parcel$export(module.exports, "default", () => $794457b0f8a54052$export$2e2bcd8739ae039);
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var $794457b0f8a54052$var$getRandomValues;
var $794457b0f8a54052$var$rnds8 = new Uint8Array(16);
function $794457b0f8a54052$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$794457b0f8a54052$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
        // find the complete implementation of crypto (msCrypto) on IE11.
        $794457b0f8a54052$var$getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);
        if (!$794457b0f8a54052$var$getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
    return $794457b0f8a54052$var$getRandomValues($794457b0f8a54052$var$rnds8);
}

});

parcelRegister("e5CpU", function(module, exports) {

$parcel$export(module.exports, "default", () => $a41f55210734a4c4$export$2e2bcd8739ae039);

var $csdZx = parcelRequire("csdZx");
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $a41f55210734a4c4$var$byteToHex = [];
for(var $a41f55210734a4c4$var$i = 0; $a41f55210734a4c4$var$i < 256; ++$a41f55210734a4c4$var$i)$a41f55210734a4c4$var$byteToHex.push(($a41f55210734a4c4$var$i + 0x100).toString(16).substr(1));
function $a41f55210734a4c4$var$stringify(arr) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    var uuid = ($a41f55210734a4c4$var$byteToHex[arr[offset + 0]] + $a41f55210734a4c4$var$byteToHex[arr[offset + 1]] + $a41f55210734a4c4$var$byteToHex[arr[offset + 2]] + $a41f55210734a4c4$var$byteToHex[arr[offset + 3]] + '-' + $a41f55210734a4c4$var$byteToHex[arr[offset + 4]] + $a41f55210734a4c4$var$byteToHex[arr[offset + 5]] + '-' + $a41f55210734a4c4$var$byteToHex[arr[offset + 6]] + $a41f55210734a4c4$var$byteToHex[arr[offset + 7]] + '-' + $a41f55210734a4c4$var$byteToHex[arr[offset + 8]] + $a41f55210734a4c4$var$byteToHex[arr[offset + 9]] + '-' + $a41f55210734a4c4$var$byteToHex[arr[offset + 10]] + $a41f55210734a4c4$var$byteToHex[arr[offset + 11]] + $a41f55210734a4c4$var$byteToHex[arr[offset + 12]] + $a41f55210734a4c4$var$byteToHex[arr[offset + 13]] + $a41f55210734a4c4$var$byteToHex[arr[offset + 14]] + $a41f55210734a4c4$var$byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $csdZx.default)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $a41f55210734a4c4$export$2e2bcd8739ae039 = $a41f55210734a4c4$var$stringify;

});
parcelRegister("csdZx", function(module, exports) {

$parcel$export(module.exports, "default", () => $9112f3fc89d7a1ce$export$2e2bcd8739ae039);

var $7ihFV = parcelRequire("7ihFV");
function $9112f3fc89d7a1ce$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $7ihFV.default).test(uuid);
}
var $9112f3fc89d7a1ce$export$2e2bcd8739ae039 = $9112f3fc89d7a1ce$var$validate;

});
parcelRegister("7ihFV", function(module, exports) {

$parcel$export(module.exports, "default", () => $54f7ecc64ee98ca0$export$2e2bcd8739ae039);
var $54f7ecc64ee98ca0$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

});





parcelRegister("93EVF", function(module, exports) {

$parcel$export(module.exports, "UserGroup", () => $a63f2755e35a1fab$export$6f1d3bf96df15c79);

var $4hGcu = parcelRequire("4hGcu");

var $gAjJp = parcelRequire("gAjJp");
const $a63f2755e35a1fab$var$objectType = 'userGroup';
class $a63f2755e35a1fab$export$6f1d3bf96df15c79 {
    constructor(userGroupID){
        this._saveMethod = (0, $4hGcu.createObjects);
        this._object = {
            userGroupID: userGroupID,
            accountID: undefined,
            name: undefined,
            parentObjectType: undefined,
            parentObjectID: undefined,
            headObjectType: undefined,
            headObjectID: undefined,
            users: [],
            roles: [],
            policies: []
        };
    }
    static createNew() {
        return new $a63f2755e35a1fab$export$6f1d3bf96df15c79((0, $gAjJp.default)());
    }
    static createFromObject(userGroup) {
        const obj = new $a63f2755e35a1fab$export$6f1d3bf96df15c79(userGroup.userGroupID);
        obj._object = userGroup;
        obj._saveMethod = (0, $4hGcu.updateObjects);
        return obj;
    }
    async load() {
        const getObject = {
            objectType: $a63f2755e35a1fab$var$objectType,
            keys: [
                this._object.userGroupID
            ]
        };
        this._lastError = undefined;
        try {
            const response = await (0, $4hGcu.getObjects)([
                getObject
            ]);
            if (response && response.length > 0 && response[0].objects && response[0].objects.length == 1) {
                this._saveMethod = (0, $4hGcu.updateObjects);
                this._object = response[0].objects[0];
                return true;
            } else {
                this._lastError = new Error('user group not found');
                return false;
            }
        } catch (error) {
            this._lastError = error;
            return false;
        }
    }
    async save() {
        const saveObject = {
            objectType: $a63f2755e35a1fab$var$objectType,
            object: this._object
        };
        this._lastError = undefined;
        if (this._object.name == undefined) {
            this._lastError = new Error('Name is undefined');
            return false;
        }
        if (this._object.accountID == undefined) {
            this._lastError = new Error('Account ID is undefined');
            return false;
        }
        if (this._object.parentObjectType == undefined) {
            this._lastError = new Error('Parent Group Type is undefined');
            return false;
        }
        if (this._object.parentObjectID == undefined) {
            this._lastError = new Error('Parent Group ID is undefined');
            return false;
        }
        try {
            const response = await this._saveMethod([
                saveObject
            ]);
            if (response) this._saveMethod = (0, $4hGcu.updateObjects);
            else this._lastError = new Error('unknow server error');
            return response;
        } catch (error) {
            this._lastError = error;
            return false;
        }
    }
    async delete() {
        const deleteObject = {
            objectType: $a63f2755e35a1fab$var$objectType,
            object: this._object
        };
        this._lastError = undefined;
        try {
            const response = await (0, $4hGcu.deleteObjects)([
                deleteObject
            ]);
            return response;
        } catch (error) {
            this._lastError = error;
            return false;
        }
    }
    get lastError() {
        return this._lastError;
    }
    get userGroupID() {
        return this._object.userGroupID;
    }
    get accountID() {
        return this._object.accountID;
    }
    set accountID(accountID) {
        this._object.accountID = accountID;
    }
    get name() {
        return this._object.name;
    }
    set name(name) {
        this._object.name = name;
    }
    get parentObjectType() {
        return this._object.parentObjectType;
    }
    set parentObjectType(parentObjectType) {
        this._object.parentObjectType = parentObjectType;
    }
    get parentObjectID() {
        return this._object.parentObjectID;
    }
    set parentObjectID(parentObjectID) {
        this._object.parentObjectID = parentObjectID;
    }
    get headObjectType() {
        return this._object.headObjectType;
    }
    set headObjectType(headObjectType) {
        this._object.headObjectType = headObjectType;
    }
    get headObjectID() {
        return this._object.headObjectID;
    }
    set headObjectID(headObjectID) {
        this._object.headObjectID = headObjectID;
    }
    get users() {
        return this._object.users;
    }
    addUser(user) {
        if (this._object.users.includes(user.userID)) return;
        this._object.users.push(user.userID);
    }
    deleteUser(user) {
        const index = this._object.users.indexOf(user.userID);
        if (index > -1) this._object.users.splice(index, 1);
    }
    get roles() {
        return this._object.roles;
    }
    addRole(role) {
        if (this._object.roles.includes(role.roleID)) return;
        this._object.roles.push(role.roleID);
    }
    deleteRole(role) {
        const index = this._object.roles.indexOf(role.roleID);
        if (index > -1) this._object.roles.splice(index, 1);
    }
    get policies() {
        return this._object.policies;
    }
    addPolicy(policy) {
        if (this._object.policies.includes(policy.policyID)) return;
        this._object.policies.push(policy.policyID);
    }
    deletePolicy(policy) {
        const index = this._object.policies.indexOf(policy.policyID);
        if (index > -1) this._object.policies.splice(index, 1);
    }
}

});

parcelRegister("ifhNi", function(module, exports) {

$parcel$export(module.exports, "RANGES", () => $d24a7f28562686f3$export$a0fdf8f9a8661a37);
$parcel$export(module.exports, "INTERVALS", () => $d24a7f28562686f3$export$bb940c082c78bda2);
$parcel$export(module.exports, "RATIOS", () => $d24a7f28562686f3$export$d881a06e04a926f1);
$parcel$export(module.exports, "getIntervalFromRange", () => $d24a7f28562686f3$export$ea23209f8e262614);
$parcel$export(module.exports, "GRAPH_TYPES", () => $d24a7f28562686f3$export$68ca4bab3ef5b52c);
$parcel$export(module.exports, "getDatesInRange", () => $d24a7f28562686f3$export$7f8baf765ac4d32c);
$parcel$export(module.exports, "dateToUTCDate", () => $d24a7f28562686f3$export$589853b078ba5772);
$parcel$export(module.exports, "getDateMinusRange", () => $d24a7f28562686f3$export$cbe31791537812f7);
$parcel$export(module.exports, "getDateStringsFromRange", () => $d24a7f28562686f3$export$ef9506b5271089aa);
$parcel$export(module.exports, "MEASUREMENTS", () => $d24a7f28562686f3$export$71e224562e187273);
$parcel$export(module.exports, "getAirCurtainData", () => $d24a7f28562686f3$export$94b97498ceb9e8b0);
$parcel$export(module.exports, "getSiteWeatherData", () => $d24a7f28562686f3$export$ef02d9e07981d371);
parcelRequire("atl0T");
var $cbbVi = parcelRequire("cbbVi");parcelRequire("hIPiC");
var $g0OFw = parcelRequire("g0OFw");

var $beEUu = parcelRequire("beEUu");
const $d24a7f28562686f3$var$API_NAME = 'ReportingAPI';
const $d24a7f28562686f3$var$APP_VERSION = '2.0';
const $d24a7f28562686f3$var$PROTOCOL_VERSION = '0.1';
const $d24a7f28562686f3$export$a0fdf8f9a8661a37 = {
    ONE_DAY: 'one_day',
    TWO_DAYS: 'two_days',
    WEEKLY: 'weekly',
    MONTHLY: 'monthly',
    YEARLY: 'yearly'
};
const $d24a7f28562686f3$export$bb940c082c78bda2 = {
    HOURLY: 'hourly',
    DAILY: 'daily',
    WEEKLY: 'weekly',
    MONTHLY: 'monthly',
    YEARLY: 'yearly'
};
const $d24a7f28562686f3$var$rangeToIntervalDefault = new Map([
    [
        $d24a7f28562686f3$export$a0fdf8f9a8661a37.ONE_DAY,
        $d24a7f28562686f3$export$bb940c082c78bda2.HOURLY
    ],
    [
        $d24a7f28562686f3$export$a0fdf8f9a8661a37.TWO_DAYS,
        $d24a7f28562686f3$export$bb940c082c78bda2.HOURLY
    ],
    [
        $d24a7f28562686f3$export$a0fdf8f9a8661a37.WEEKLY,
        $d24a7f28562686f3$export$bb940c082c78bda2.HOURLY
    ],
    [
        $d24a7f28562686f3$export$a0fdf8f9a8661a37.MONTHLY,
        $d24a7f28562686f3$export$bb940c082c78bda2.HOURLY
    ],
    [
        $d24a7f28562686f3$export$a0fdf8f9a8661a37.YEARLY,
        $d24a7f28562686f3$export$bb940c082c78bda2.DAILY
    ]
]);
const $d24a7f28562686f3$var$rangeToIntervalBarChart = new Map([
    [
        $d24a7f28562686f3$export$a0fdf8f9a8661a37.ONE_DAY,
        $d24a7f28562686f3$export$bb940c082c78bda2.HOURLY
    ],
    [
        $d24a7f28562686f3$export$a0fdf8f9a8661a37.TWO_DAYS,
        $d24a7f28562686f3$export$bb940c082c78bda2.DAILY
    ],
    [
        $d24a7f28562686f3$export$a0fdf8f9a8661a37.WEEKLY,
        $d24a7f28562686f3$export$bb940c082c78bda2.DAILY
    ],
    [
        $d24a7f28562686f3$export$a0fdf8f9a8661a37.MONTHLY,
        $d24a7f28562686f3$export$bb940c082c78bda2.WEEKLY
    ],
    [
        $d24a7f28562686f3$export$a0fdf8f9a8661a37.YEARLY,
        $d24a7f28562686f3$export$bb940c082c78bda2.MONTHLY
    ]
]);
const $d24a7f28562686f3$var$rangeToIntervalHeatMap = new Map([
    [
        $d24a7f28562686f3$export$a0fdf8f9a8661a37.ONE_DAY,
        $d24a7f28562686f3$export$bb940c082c78bda2.HOURLY
    ],
    [
        $d24a7f28562686f3$export$a0fdf8f9a8661a37.TWO_DAYS,
        $d24a7f28562686f3$export$bb940c082c78bda2.HOURLY
    ],
    [
        $d24a7f28562686f3$export$a0fdf8f9a8661a37.WEEKLY,
        $d24a7f28562686f3$export$bb940c082c78bda2.HOURLY
    ],
    [
        $d24a7f28562686f3$export$a0fdf8f9a8661a37.MONTHLY,
        $d24a7f28562686f3$export$bb940c082c78bda2.HOURLY
    ],
    [
        $d24a7f28562686f3$export$a0fdf8f9a8661a37.YEARLY,
        $d24a7f28562686f3$export$bb940c082c78bda2.MONTHLY
    ]
]);
function $d24a7f28562686f3$var$getSundayOfWeek(date) {
    const first = date.getDate() - date.getDay() + 1;
    const last = first + 6;
    const sunday = new Date(date.setDate(last));
    return sunday;
}
const $d24a7f28562686f3$export$d881a06e04a926f1 = {
    TEN_BY_NINE: 'container-10-9',
    FIFTEEN_BY_NINE: 'container-15-9',
    SIXTEEN_BY_NINE: 'container-16-9',
    SIXTEEN_BY_NINE_NO_BORDER: 'container-16-9-no-border',
    TWENTYTHREE_BY_TEN: 'container-23-10',
    THIRTYTWO_BY_NINE: 'container-32-9',
    THREE_BY_TEN: 'container-3-10',
    SQUARE: 'container-square'
};
const $d24a7f28562686f3$export$ad0f4b3f331ed6e1 = {
    VERTICAL: 'VERTICAL',
    HORIZONTAL: 'HORIZONTAL'
};
function $d24a7f28562686f3$export$ea23209f8e262614(range, graphType) {
    if (graphType === $d24a7f28562686f3$export$68ca4bab3ef5b52c.BAR || graphType === $d24a7f28562686f3$export$68ca4bab3ef5b52c.COLUMN) return $d24a7f28562686f3$var$rangeToIntervalBarChart.get(range);
    else if (graphType === $d24a7f28562686f3$export$68ca4bab3ef5b52c.HEAT_MAP) return $d24a7f28562686f3$var$rangeToIntervalHeatMap.get(range);
    else return $d24a7f28562686f3$var$rangeToIntervalDefault.get(range);
}
function $d24a7f28562686f3$export$7f8baf765ac4d32c(range) {
    const dates = [];
    let date = $d24a7f28562686f3$export$589853b078ba5772(new Date());
    date.setMinutes(0);
    date.setSeconds(0);
    if (range === $d24a7f28562686f3$export$a0fdf8f9a8661a37.ONE_DAY) {
        const count = 24;
        for(let i = 0; i < count; i++){
            date = $d24a7f28562686f3$export$cbe31791537812f7("one_hour", new Date(date.getTime()));
            dates.push(date);
        }
    } else if (range === $d24a7f28562686f3$export$a0fdf8f9a8661a37.TWO_DAYS || range === $d24a7f28562686f3$export$a0fdf8f9a8661a37.WEEKLY) {
        const count = range === $d24a7f28562686f3$export$a0fdf8f9a8661a37.WEEKLY ? 7 : 2;
        for(let i = 0; i < count; i++){
            date = $d24a7f28562686f3$export$cbe31791537812f7($d24a7f28562686f3$export$a0fdf8f9a8661a37.ONE_DAY, new Date(date.getTime()));
            dates.push(date);
        }
    } else if (range === $d24a7f28562686f3$export$a0fdf8f9a8661a37.MONTHLY) {
        const count = 4;
        // Weekly data is each Sunday
        date = $d24a7f28562686f3$var$getSundayOfWeek(date);
        for(let i = 0; i < count; i++){
            date = $d24a7f28562686f3$export$cbe31791537812f7($d24a7f28562686f3$export$a0fdf8f9a8661a37.WEEKLY, new Date(date.getTime()));
            dates.push(date);
        }
    } else if (range === $d24a7f28562686f3$export$a0fdf8f9a8661a37.YEARLY) {
        const count = 12;
        for(let i = 0; i < count; i++){
            date = $d24a7f28562686f3$export$cbe31791537812f7($d24a7f28562686f3$export$a0fdf8f9a8661a37.MONTHLY, new Date(date.getTime()));
            dates.push(date);
        }
    }
    return dates;
}
function $d24a7f28562686f3$export$589853b078ba5772(date) {
    const date_utc = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
    return new Date(date_utc);
}
function $d24a7f28562686f3$export$cbe31791537812f7(range, date) {
    const oldDate = date;
    if (range === $d24a7f28562686f3$export$a0fdf8f9a8661a37.YEARLY) {
        oldDate.setFullYear(date.getFullYear() - 1);
        oldDate.setHours(0);
    } else if (range === $d24a7f28562686f3$export$a0fdf8f9a8661a37.MONTHLY) {
        oldDate.setMonth(date.getMonth() - 1);
        oldDate.setHours(0);
    } else if (range === $d24a7f28562686f3$export$a0fdf8f9a8661a37.WEEKLY) {
        oldDate.setDate(date.getDate() - 7);
        oldDate.setHours(0);
    } else if (range === $d24a7f28562686f3$export$a0fdf8f9a8661a37.TWO_DAYS) {
        oldDate.setDate(date.getDate() - 2);
        oldDate.setHours(0);
    } else if (range === $d24a7f28562686f3$export$a0fdf8f9a8661a37.ONE_DAY) {
        oldDate.setDate(date.getDate() - 1);
        oldDate.setHours(0);
    } else if (range === 'one_hour') {
        const time = date.getTime();
        const minusOneHour = time - 3600000;
        oldDate.setTime(minusOneHour);
    }
    return oldDate;
}
function $d24a7f28562686f3$export$ef9506b5271089aa(range, endDate) {
    const startDate = $d24a7f28562686f3$export$51237157d5b45e27(range, endDate);
    return {
        startDate: (startDate.getTime() / 1000).toFixed().toString(),
        endDate: (endDate.getTime() / 1000).toFixed().toString()
    };
}
function $d24a7f28562686f3$export$51237157d5b45e27(range, endDate) {
    const startDate = $d24a7f28562686f3$export$cbe31791537812f7(range, $d24a7f28562686f3$export$589853b078ba5772(endDate));
    return startDate;
}
const $d24a7f28562686f3$export$71e224562e187273 = {
    AVERAGE_TEMP: 'avgTemperature',
    MAX_TEMP: 'maxTemperature',
    MIN_TEMP: 'minTemperature',
    WEATHER_AVG_TEMP: 'weatherAvgTemperature',
    DOOR_OPEN_COUNT: 'doorOpenCount',
    BTU: 'btu',
    TON_GAIN_RATE: 'tonGainRate',
    LOSS: 'loss',
    GROSS_SAVING: 'grossSaving',
    COST_TO_OPERATE: 'costToOperate',
    SAVING: 'savings',
    DOOR_OPEN_TIME: 'doorOpenTime',
    EFFICIENCY: 'efficiency'
};
const $d24a7f28562686f3$export$68ca4bab3ef5b52c = {
    AREA: 'area',
    AREASPLINE: 'areaspline',
    BAR: 'bar',
    COLUMN: 'column',
    HEAT_MAP: 'heatmap'
};
const $d24a7f28562686f3$export$94b97498ceb9e8b0 = async (thingNames, siteIDThingNamePairs, intervals, measurements, startTimestamp, endTimestamp)=>{
    return await $d24a7f28562686f3$var$post('getdata', {
        SiteIDThingNamePairs: siteIDThingNamePairs,
        ThingNames: thingNames,
        Intervals: intervals,
        Measurements: measurements,
        StartTimestamp: startTimestamp,
        EndTimestamp: endTimestamp
    });
};
const $d24a7f28562686f3$export$ef02d9e07981d371 = async (siteIds, intervals, measurements, startTimestamp, endTimestamp)=>{
    return await $d24a7f28562686f3$var$post('getdata', {
        SiteIDs: siteIds,
        Intervals: intervals,
        Measurements: measurements,
        StartTimestamp: startTimestamp,
        EndTimestamp: endTimestamp
    });
};
const $d24a7f28562686f3$var$post = async (endpoint, body)=>{
    const session = await (0, $g0OFw.Auth).currentSession();
    const mergedBody = Object.assign({}, {
        AppVersion: $d24a7f28562686f3$var$APP_VERSION,
        ProtocolVersion: $d24a7f28562686f3$var$PROTOCOL_VERSION
    }, body);
    const init = {
        headers: {
            Authorization: session.getIdToken().getJwtToken(),
            'x-api-key': (0, $beEUu.key)
        },
        response: true,
        body: mergedBody
    };
    const response = await (0, $cbbVi.API).post($d24a7f28562686f3$var$API_NAME, '/prod/' + endpoint, init).catch((err)=>{
        console.log('post exception: ', err);
    });
    // console.log('post response: ', response);
    if (response && response.data.statusCode == 200) return response.data.body;
    else return '';
};

});
parcelRegister("beEUu", function(module, exports) {
module.exports = JSON.parse("{\"key\":\"7NCivH4MDGayVaxxcHtpW5A1DpSEt6bm5xdo2YBd\"}");

});


parcelRegister("2BCvg", function(module, exports) {
$parcel$export(module.exports, "classMap", () => (parcelRequire("Txkvx")).classMap);
parcelRequire("Txkvx");

});
parcelRegister("Txkvx", function(module, exports) {

$parcel$export(module.exports, "classMap", () => $0a6efdc45c5912cd$export$56cc687933817664);

var $2Vehe = parcelRequire("2Vehe");

var $8my0p = parcelRequire("8my0p");
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $0a6efdc45c5912cd$export$56cc687933817664 = (0, $8my0p.directive)(class extends (0, $8my0p.Directive) {
    constructor(t){
        if (super(t), t.type !== (0, $8my0p.PartType).ATTRIBUTE || "class" !== t.name || t.strings?.length > 2) throw Error("`classMap()` can only be used in the `class` attribute and must be the only part in the attribute.");
    }
    render(t) {
        return " " + Object.keys(t).filter((s)=>t[s]).join(" ") + " ";
    }
    update(s, [i]) {
        if (void 0 === this.st) {
            this.st = new Set, void 0 !== s.strings && (this.nt = new Set(s.strings.join(" ").split(/\s/).filter((t)=>"" !== t)));
            for(const t in i)i[t] && !this.nt?.has(t) && this.st.add(t);
            return this.render(i);
        }
        const r = s.element.classList;
        for (const t of this.st)t in i || (r.remove(t), this.st.delete(t));
        for(const t in i){
            const s = !!i[t];
            s === this.st.has(t) || this.nt?.has(t) || (s ? (r.add(t), this.st.add(t)) : (r.remove(t), this.st.delete(t)));
        }
        return 0, $2Vehe.noChange;
    }
});

});
parcelRegister("8my0p", function(module, exports) {

$parcel$export(module.exports, "PartType", () => $616ac19f1f2b0ce8$export$9ba3b3f20a85bfa);
$parcel$export(module.exports, "directive", () => $616ac19f1f2b0ce8$export$99b43ad1ed32e735);
$parcel$export(module.exports, "Directive", () => $616ac19f1f2b0ce8$export$befdefbdce210f91);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $616ac19f1f2b0ce8$export$9ba3b3f20a85bfa = {
    ATTRIBUTE: 1,
    CHILD: 2,
    PROPERTY: 3,
    BOOLEAN_ATTRIBUTE: 4,
    EVENT: 5,
    ELEMENT: 6
}, $616ac19f1f2b0ce8$export$99b43ad1ed32e735 = (t)=>(...e)=>({
            _$litDirective$: t,
            values: e
        });
class $616ac19f1f2b0ce8$export$befdefbdce210f91 {
    constructor(t){}
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AT(t, e, i) {
        this._$Ct = t, this._$AM = e, this._$Ci = i;
    }
    _$AS(t, e) {
        return this.update(t, e);
    }
    update(t, e) {
        return this.render(...e);
    }
}

});



parcelRegister("jRqJ2", function(module, exports) {
$parcel$export(module.exports, "repeat", () => (parcelRequire("3q9Vf")).repeat);
parcelRequire("3q9Vf");

});
parcelRegister("3q9Vf", function(module, exports) {

$parcel$export(module.exports, "repeat", () => $27db7f2f2085c35c$export$76d90c956114f2c2);

var $2Vehe = parcelRequire("2Vehe");

var $8my0p = parcelRequire("8my0p");

var $gyEV7 = parcelRequire("gyEV7");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $27db7f2f2085c35c$var$u = (e, s, t)=>{
    const r = new Map;
    for(let l = s; l <= t; l++)r.set(e[l], l);
    return r;
}, $27db7f2f2085c35c$export$76d90c956114f2c2 = (0, $8my0p.directive)(class extends (0, $8my0p.Directive) {
    constructor(e){
        if (super(e), e.type !== (0, $8my0p.PartType).CHILD) throw Error("repeat() can only be used in text expressions");
    }
    dt(e, s, t) {
        let r;
        void 0 === t ? t = s : void 0 !== s && (r = s);
        const l = [], o = [];
        let i = 0;
        for (const s of e)l[i] = r ? r(s, i) : i, o[i] = t(s, i), i++;
        return {
            values: o,
            keys: l
        };
    }
    render(e, s, t) {
        return this.dt(e, s, t).values;
    }
    update(s, [t, r, c]) {
        const d = (0, $gyEV7.getCommittedValue)(s), { values: p, keys: a } = this.dt(t, r, c);
        if (!Array.isArray(d)) return this.ut = a, p;
        const h = this.ut ??= [], v = [];
        let m, y, x = 0, j = d.length - 1, k = 0, w = p.length - 1;
        for(; x <= j && k <= w;)if (null === d[x]) x++;
        else if (null === d[j]) j--;
        else if (h[x] === a[k]) v[k] = (0, $gyEV7.setChildPartValue)(d[x], p[k]), x++, k++;
        else if (h[j] === a[w]) v[w] = (0, $gyEV7.setChildPartValue)(d[j], p[w]), j--, w--;
        else if (h[x] === a[w]) v[w] = (0, $gyEV7.setChildPartValue)(d[x], p[w]), (0, $gyEV7.insertPart)(s, v[w + 1], d[x]), x++, w--;
        else if (h[j] === a[k]) v[k] = (0, $gyEV7.setChildPartValue)(d[j], p[k]), (0, $gyEV7.insertPart)(s, d[x], d[j]), j--, k++;
        else if (void 0 === m && (m = $27db7f2f2085c35c$var$u(a, k, w), y = $27db7f2f2085c35c$var$u(h, x, j)), m.has(h[x])) {
            if (m.has(h[j])) {
                const e = y.get(a[k]), t = void 0 !== e ? d[e] : null;
                if (null === t) {
                    const e = (0, $gyEV7.insertPart)(s, d[x]);
                    (0, $gyEV7.setChildPartValue)(e, p[k]), v[k] = e;
                } else v[k] = (0, $gyEV7.setChildPartValue)(t, p[k]), (0, $gyEV7.insertPart)(s, d[x], t), d[e] = null;
                k++;
            } else (0, $gyEV7.removePart)(d[j]), j--;
        } else (0, $gyEV7.removePart)(d[x]), x++;
        for(; k <= w;){
            const e = (0, $gyEV7.insertPart)(s, v[w + 1]);
            (0, $gyEV7.setChildPartValue)(e, p[k]), v[k++] = e;
        }
        for(; x <= j;){
            const e = d[x++];
            null !== e && (0, $gyEV7.removePart)(e);
        }
        return this.ut = a, (0, $gyEV7.setCommittedValue)(s, v), $2Vehe.noChange;
    }
});

});
parcelRegister("gyEV7", function(module, exports) {

$parcel$export(module.exports, "insertPart", () => $c0df903fd070ffee$export$291b2338ad9b0b30);
$parcel$export(module.exports, "setChildPartValue", () => $c0df903fd070ffee$export$cb8bf9562088e9f4);
$parcel$export(module.exports, "setCommittedValue", () => $c0df903fd070ffee$export$ea70d9dd5965b1c8);
$parcel$export(module.exports, "getCommittedValue", () => $c0df903fd070ffee$export$59e9bce518cde500);
$parcel$export(module.exports, "removePart", () => $c0df903fd070ffee$export$3133b3144bbba267);

var $2Vehe = parcelRequire("2Vehe");
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { I: $c0df903fd070ffee$var$t } = (0, $2Vehe._$LH), $c0df903fd070ffee$var$i = (o)=>o, $c0df903fd070ffee$export$c3825b437cbdea5c = (o)=>null === o || "object" != typeof o && "function" != typeof o, $c0df903fd070ffee$export$80c36ae3cab9881d = {
    HTML: 1,
    SVG: 2,
    MATHML: 3
}, $c0df903fd070ffee$export$6b6d145ec2a44ca9 = (o, t)=>void 0 === t ? void 0 !== o?._$litType$ : o?._$litType$ === t, $c0df903fd070ffee$export$6a0e8de894d2fcca = (o)=>null != o?._$litType$?.h, $c0df903fd070ffee$export$2f448fec17d50a3e = (o)=>void 0 !== o?._$litDirective$, $c0df903fd070ffee$export$f28e31de6a6eaf32 = (o)=>o?._$litDirective$, $c0df903fd070ffee$export$7f431ad0fff82fd9 = (o)=>void 0 === o.strings, $c0df903fd070ffee$var$s = ()=>document.createComment(""), $c0df903fd070ffee$export$291b2338ad9b0b30 = (o, n, e)=>{
    const l = o._$AA.parentNode, d = void 0 === n ? o._$AB : n._$AA;
    if (void 0 === e) {
        const i = l.insertBefore($c0df903fd070ffee$var$s(), d), n = l.insertBefore($c0df903fd070ffee$var$s(), d);
        e = new $c0df903fd070ffee$var$t(i, n, o, o.options);
    } else {
        const t = e._$AB.nextSibling, n = e._$AM, c = n !== o;
        if (c) {
            let t;
            e._$AQ?.(o), e._$AM = o, void 0 !== e._$AP && (t = o._$AU) !== n._$AU && e._$AP(t);
        }
        if (t !== d || c) {
            let o = e._$AA;
            for(; o !== t;){
                const t = $c0df903fd070ffee$var$i(o).nextSibling;
                $c0df903fd070ffee$var$i(l).insertBefore(o, d), o = t;
            }
        }
    }
    return e;
}, $c0df903fd070ffee$export$cb8bf9562088e9f4 = (o, t, i = o)=>(o._$AI(t, i), o), $c0df903fd070ffee$var$m = {}, $c0df903fd070ffee$export$ea70d9dd5965b1c8 = (o, t = $c0df903fd070ffee$var$m)=>o._$AH = t, $c0df903fd070ffee$export$59e9bce518cde500 = (o)=>o._$AH, $c0df903fd070ffee$export$3133b3144bbba267 = (o)=>{
    o._$AR(), o._$AA.remove();
}, $c0df903fd070ffee$export$7f600b8138c094dc = (o)=>{
    o._$AR();
};

});



parcelRegister("ht1kU", function(module, exports) {

$parcel$export(module.exports, "MEASUREMENT_TO_FUNC", () => $91d714d4673280cd$export$c3830efb74ac7f4f);
$parcel$export(module.exports, "saveToLocalStorage", () => $91d714d4673280cd$export$1b8cd2d0ef9a8e5d);
$parcel$export(module.exports, "getFromLocalStorage", () => $91d714d4673280cd$export$602bc7b349337fec);
$parcel$export(module.exports, "preloadObjects", () => $91d714d4673280cd$export$fed1db8afc972c67);
$parcel$export(module.exports, "cacheAllMeasurementData", () => $91d714d4673280cd$export$845a6f9bb96581b9);
$parcel$export(module.exports, "cacheMeasurementDataForDevice", () => $91d714d4673280cd$export$be5526cbd29ba917);
$parcel$export(module.exports, "getCachedData", () => $91d714d4673280cd$export$86b4d9d091ee17fe);
$parcel$export(module.exports, "initObjectManager", () => $91d714d4673280cd$export$8f55abe053034367);

var $hdJfe = parcelRequire("hdJfe");

var $dNrEV = parcelRequire("dNrEV");

var $ifhNi = parcelRequire("ifhNi");

var $96LZE = parcelRequire("96LZE");

var $hkQda = parcelRequire("hkQda");

var $kcenM = parcelRequire("kcenM");
parcelRequire("hIPiC");
var $g0OFw = parcelRequire("g0OFw");
const $91d714d4673280cd$var$FUNCTION_TYPES = {
    AVG: "avg",
    MIN: "min",
    MAX: "max",
    SUM: "sum"
};
const $91d714d4673280cd$export$c3830efb74ac7f4f = new Map([
    [
        (0, $ifhNi.MEASUREMENTS).AVERAGE_TEMP,
        $91d714d4673280cd$var$FUNCTION_TYPES.AVG
    ],
    [
        (0, $ifhNi.MEASUREMENTS).MIN_TEMP,
        $91d714d4673280cd$var$FUNCTION_TYPES.AVG
    ],
    [
        (0, $ifhNi.MEASUREMENTS).MAX_TEMP,
        $91d714d4673280cd$var$FUNCTION_TYPES.AVG
    ],
    [
        (0, $ifhNi.MEASUREMENTS).WEATHER_AVG_TEMP,
        $91d714d4673280cd$var$FUNCTION_TYPES.AVG
    ],
    [
        (0, $ifhNi.MEASUREMENTS).BTU,
        $91d714d4673280cd$var$FUNCTION_TYPES.AVG
    ],
    [
        (0, $ifhNi.MEASUREMENTS).TON_GAIN_RATE,
        $91d714d4673280cd$var$FUNCTION_TYPES.AVG
    ],
    [
        (0, $ifhNi.MEASUREMENTS).EFFICIENCY,
        $91d714d4673280cd$var$FUNCTION_TYPES.AVG
    ],
    [
        (0, $ifhNi.MEASUREMENTS).DOOR_OPEN_COUNT,
        $91d714d4673280cd$var$FUNCTION_TYPES.SUM
    ],
    [
        (0, $ifhNi.MEASUREMENTS).DOOR_OPEN_TIME,
        $91d714d4673280cd$var$FUNCTION_TYPES.SUM
    ],
    [
        (0, $ifhNi.MEASUREMENTS).COST_TO_OPERATE,
        $91d714d4673280cd$var$FUNCTION_TYPES.SUM
    ],
    [
        (0, $ifhNi.MEASUREMENTS).GROSS_SAVING,
        $91d714d4673280cd$var$FUNCTION_TYPES.SUM
    ],
    [
        (0, $ifhNi.MEASUREMENTS).LOSS,
        $91d714d4673280cd$var$FUNCTION_TYPES.SUM
    ],
    [
        (0, $ifhNi.MEASUREMENTS).SAVING,
        $91d714d4673280cd$var$FUNCTION_TYPES.SUM
    ]
]);
const $91d714d4673280cd$var$localStorage = window.localStorage;
function $91d714d4673280cd$var$mergeData(a, b) {
    if (a && b) for (const device of a.keys()){
        const dataB = b.get(device);
        if (dataB) {
            const dataA = a.get(device);
            for (const key of dataB.keys())dataA.set(key, dataB.get(key));
        }
    }
    return a;
}
function $91d714d4673280cd$export$1b8cd2d0ef9a8e5d(key, value) {
    $91d714d4673280cd$var$localStorage.setItem(key, value);
}
function $91d714d4673280cd$export$602bc7b349337fec(key) {
    return $91d714d4673280cd$var$localStorage.getItem(key);
}
async function $91d714d4673280cd$export$fed1db8afc972c67(objectManager) {
    (0, $dNrEV.store).dispatch((0, $hdJfe.setPreloadObjectsInProgressState)());
    await objectManager.getAllAirCurtains();
    await objectManager.getAllUsers();
    await objectManager.getAllIdentities();
    (0, $dNrEV.store).dispatch((0, $hdJfe.setPreloadObjectsState)(true));
}
async function $91d714d4673280cd$export$845a6f9bb96581b9(objectManager) {
    (0, $dNrEV.store).dispatch((0, $hdJfe.setMeasurementDataCachingInProgressState)());
    const siteGroup = objectManager.getSiteGroup();
    const siteToAirCurtains = new Map();
    // minimal data
    for (const siteId of siteGroup.sites){
        const site = objectManager.getSite(siteId);
        for (const curtainGroupId of site.airCurtainGroups){
            const airCurtainGroup = objectManager.getAirCurtainGroup(curtainGroupId);
            if (siteToAirCurtains.has(siteId)) {
                let airCurtainsIds = siteToAirCurtains.get(siteId);
                airCurtainsIds = airCurtainsIds.concat(airCurtainGroup.airCurtains);
                siteToAirCurtains.set(siteId, airCurtainsIds);
            } else siteToAirCurtains.set(siteId, airCurtainGroup.airCurtains);
        }
        const siteAirCurtains = siteToAirCurtains.get(siteId);
        if (siteAirCurtains?.length) await $91d714d4673280cd$export$845f6f296d2bbc11(objectManager, [
            (0, $ifhNi.RANGES).WEEKLY
        ], siteAirCurtains, siteId);
    }
    await $91d714d4673280cd$var$cacheHistoricWeatherData([
        (0, $ifhNi.RANGES).WEEKLY
    ], siteGroup.sites);
    window.dispatchEvent(new CustomEvent((0, $hkQda.EVENTS).MINIMAL_DATA_CACHED));
    // all data
    await $91d714d4673280cd$var$cacheHistoricWeatherData(Object.values((0, $ifhNi.RANGES)), siteGroup.sites);
    for (const siteId of siteGroup.sites){
        const siteAirCurtains = siteToAirCurtains.get(siteId);
        if (siteAirCurtains?.length) {
            // get all data including old  (last week, last month etc) for infographics comparison
            await $91d714d4673280cd$export$845f6f296d2bbc11(objectManager, Object.values((0, $ifhNi.RANGES)), siteAirCurtains, siteId);
            await $91d714d4673280cd$export$845f6f296d2bbc11(objectManager, Object.values((0, $ifhNi.RANGES)), siteAirCurtains, siteId, true);
        }
    }
    (0, $dNrEV.store).dispatch((0, $hdJfe.setMeasurementDataCachedState)(true));
    window.dispatchEvent(new CustomEvent((0, $hkQda.EVENTS).ALL_DATA_CACHED));
}
async function $91d714d4673280cd$var$cacheHistoricWeatherData(ranges, siteIds) {
    const dataByRange = new Map();
    for (const range of ranges){
        const weatherData = await $91d714d4673280cd$export$b2eb56fd7a161b3f(range, siteIds, [
            (0, $ifhNi.MEASUREMENTS).WEATHER_AVG_TEMP
        ], (0, $ifhNi.getIntervalFromRange)(range, (0, $ifhNi.GRAPH_TYPES).AREA), (0, $ifhNi.dateToUTCDate)(new Date()) //now
        );
        dataByRange.set(range, weatherData);
    }
    const dataBySite = new Map();
    for (const entry of dataByRange.entries()){
        const range = entry[0];
        const siteToMeasurements = entry[1];
        for (const siteToData of siteToMeasurements.entries()){
            const siteId = siteToData[0];
            const measurementsToData = siteToData[1];
            const siteData = dataBySite.has(siteId) ? dataBySite.get(siteId) : [];
            for (const measurementToData of measurementsToData.entries()){
                const measurement = measurementToData[0];
                const measurementData = measurementToData[1];
                if (!siteData[`${measurement}`]) siteData[`${measurement}`] = [];
                for (const rangeData of measurementData.entries()){
                    const graphData = rangeData[1];
                    siteData[`${measurement}`][`${range}`] = graphData.values;
                }
                dataBySite.set(siteId, siteData);
            }
        }
    }
    for (const entry of dataBySite.entries()){
        const siteId = entry[0];
        const data = entry[1];
        (0, $dNrEV.store).dispatch((0, $hdJfe.setMeasurementData)(siteId, data));
    }
}
async function $91d714d4673280cd$export$be5526cbd29ba917(objectManager, airCurtainID, siteID) {
    // cache data for new air curtain
    await $91d714d4673280cd$export$845f6f296d2bbc11(objectManager, Object.values((0, $ifhNi.RANGES)), [
        airCurtainID
    ], siteID);
    await $91d714d4673280cd$export$845f6f296d2bbc11(objectManager, Object.values((0, $ifhNi.RANGES)), [
        airCurtainID
    ], siteID, true);
    // trigger a refresh
    window.dispatchEvent(new CustomEvent((0, $hkQda.EVENTS).DATA_UPDATED));
}
async function $91d714d4673280cd$export$845f6f296d2bbc11(objectManager, ranges, airCurtainIds, siteId, cacheOldData = false) {
    const airCurtainIdChunks = [];
    const deviceMeasurements = new Map();
    let location;
    const requestedInstallationObjects = [];
    let installations = new Map();
    // batch requests by smaller groups of curtains to avoid response size limit on AWS
    const MAX_CHUNK = 100;
    let count = 0;
    let chunk = 0;
    for (const id of airCurtainIds){
        requestedInstallationObjects.push({
            thingName: id,
            siteID: siteId
        });
        if (!airCurtainIdChunks[chunk]) airCurtainIdChunks[chunk] = [];
        airCurtainIdChunks[chunk].push(id);
        count++;
        if (count % MAX_CHUNK === 0) chunk++;
    }
    if (!cacheOldData) {
        location = await objectManager.getLocation(siteId);
        installations = await objectManager.getInstallations(requestedInstallationObjects);
    }
    for (const deviceIds of airCurtainIdChunks){
        const utcD = (0, $ifhNi.dateToUTCDate)(new Date()); //now
        for (const range of ranges){
            const rangeDataForAreaGraphs = await $91d714d4673280cd$var$getMeasurementData(range, deviceIds.join(","), siteId, cacheOldData ? [
                (0, $ifhNi.MEASUREMENTS).AVERAGE_TEMP
            ] : (0, $96LZE.AREA_GRAPH_MEASUREMENTS), (0, $ifhNi.getIntervalFromRange)(range, (0, $ifhNi.GRAPH_TYPES).AREA), cacheOldData ? (0, $ifhNi.getDateMinusRange)(range, new Date()) : utcD);
            const rangeDataForBarGraphs = await $91d714d4673280cd$var$getMeasurementData(range, deviceIds.join(","), siteId, cacheOldData ? [
                (0, $ifhNi.MEASUREMENTS).DOOR_OPEN_COUNT,
                (0, $ifhNi.MEASUREMENTS).EFFICIENCY
            ] : (0, $96LZE.COLUMN_CHART_MEASUREMENTS), (0, $ifhNi.getIntervalFromRange)(range, (0, $ifhNi.GRAPH_TYPES).BAR), cacheOldData ? (0, $ifhNi.getDateMinusRange)(range, new Date()) : utcD);
            const allRangeData = $91d714d4673280cd$var$mergeData(rangeDataForAreaGraphs, rangeDataForBarGraphs);
            if (allRangeData) for (const deviceData of allRangeData){
                const deviceId = deviceData[0];
                const graphData = deviceData[1];
                const deviceDataByMeasurement = deviceMeasurements.get(deviceId) ?? {};
                const measurementTypes = Array.from(graphData.keys());
                for (const measurement of measurementTypes){
                    const measurementData = deviceDataByMeasurement[`${measurement}`] ?? {};
                    measurementData[`${range}`] = graphData.get(measurement);
                    deviceDataByMeasurement[`${measurement}`] = measurementData;
                }
                if (!cacheOldData) {
                    const installation = installations.get(siteId + "|" + deviceId);
                    if (installation && location) {
                        const coolingCost = (0, $96LZE.getCoolingCost)(location.electricityRate, location.naturalGasRate, location.oilRate, installation.coolingEnergyType);
                        const heatingCost = (0, $96LZE.getHeatingCost)(location.electricityRate, location.naturalGasRate, location.oilRate, installation.heatingEnergyType);
                        $91d714d4673280cd$var$locallyCalculateMeasurementData(deviceDataByMeasurement, range, coolingCost, heatingCost, location.electricityRate, installation.model);
                    }
                }
                deviceMeasurements.set(deviceId, deviceDataByMeasurement);
            }
        }
    }
    for (const deviceId of Array.from(deviceMeasurements.keys())){
        const func = cacheOldData ? (0, $hdJfe.setOldMeasurementData)(deviceId, deviceMeasurements.get(deviceId)) : (0, $hdJfe.setMeasurementData)(deviceId, deviceMeasurements.get(deviceId));
        (0, $dNrEV.store).dispatch(func);
    }
}
function $91d714d4673280cd$var$locallyCalculateMeasurementData(deviceDataByMeasurement, range, coolingCost, heatingCost, electricityRate, model) {
    const btuData = deviceDataByMeasurement[`${(0, $ifhNi.MEASUREMENTS).BTU}`];
    const tonGainRateData = deviceDataByMeasurement[`${(0, $ifhNi.MEASUREMENTS).TON_GAIN_RATE}`];
    const efficiencyData = deviceDataByMeasurement[`${(0, $ifhNi.MEASUREMENTS).EFFICIENCY}`];
    const doorOpenTimeData = deviceDataByMeasurement[`${(0, $ifhNi.MEASUREMENTS).DOOR_OPEN_TIME}`];
    // GROSS_SAVING
    if (btuData && btuData[`${range}`] && tonGainRateData && tonGainRateData[`${range}`] && efficiencyData && efficiencyData[`${range}`]) {
        const grossSavingData = (0, $96LZE.getGrossSavingData)(efficiencyData[`${range}`], btuData[`${range}`], tonGainRateData[`${range}`], coolingCost, heatingCost);
        if (grossSavingData.length) {
            if (deviceDataByMeasurement[`${(0, $ifhNi.MEASUREMENTS).GROSS_SAVING}`] === undefined) deviceDataByMeasurement[`${(0, $ifhNi.MEASUREMENTS).GROSS_SAVING}`] = {};
            deviceDataByMeasurement[`${(0, $ifhNi.MEASUREMENTS).GROSS_SAVING}`][`${range}`] = grossSavingData;
        }
    }
    //LOSS
    if (btuData && btuData[`${range}`] && tonGainRateData && tonGainRateData[`${range}`]) {
        const lossData = (0, $96LZE.getLossData)(btuData[`${range}`], tonGainRateData[`${range}`], coolingCost, heatingCost);
        if (lossData.length) {
            if (deviceDataByMeasurement[`${(0, $ifhNi.MEASUREMENTS).LOSS}`] === undefined) deviceDataByMeasurement[`${(0, $ifhNi.MEASUREMENTS).LOSS}`] = {};
            deviceDataByMeasurement[`${(0, $ifhNi.MEASUREMENTS).LOSS}`][`${range}`] = lossData;
        }
    }
    //COST TO OPERATE
    if (doorOpenTimeData && doorOpenTimeData[`${range}`]) {
        const costToOperateData = (0, $96LZE.getCostToOperateData)(doorOpenTimeData[`${range}`], model, electricityRate);
        if (costToOperateData.length) {
            if (deviceDataByMeasurement[`${(0, $ifhNi.MEASUREMENTS).COST_TO_OPERATE}`] === undefined) deviceDataByMeasurement[`${(0, $ifhNi.MEASUREMENTS).COST_TO_OPERATE}`] = {};
            deviceDataByMeasurement[`${(0, $ifhNi.MEASUREMENTS).COST_TO_OPERATE}`][`${range}`] = costToOperateData;
        }
    }
    //SAVINGS
    const grossSavingData = deviceDataByMeasurement[`${(0, $ifhNi.MEASUREMENTS).GROSS_SAVING}`];
    const costToOperateData = deviceDataByMeasurement[`${(0, $ifhNi.MEASUREMENTS).COST_TO_OPERATE}`];
    if (grossSavingData && grossSavingData[`${range}`] && costToOperateData && costToOperateData[`${range}`]) {
        const savingData = (0, $96LZE.getSavingData)(grossSavingData[`${range}`], costToOperateData[`${range}`]);
        if (savingData.length) {
            if (deviceDataByMeasurement[`${(0, $ifhNi.MEASUREMENTS).SAVING}`] === undefined) deviceDataByMeasurement[`${(0, $ifhNi.MEASUREMENTS).SAVING}`] = {};
            deviceDataByMeasurement[`${(0, $ifhNi.MEASUREMENTS).SAVING}`][`${range}`] = savingData;
        }
    }
}
async function $91d714d4673280cd$export$86b4d9d091ee17fe(range, deviceIds, requestMeasurements, shouldAggregate, useOldData, siteId) {
    const { measurementData: measurementData, measurementDataOld: measurementDataOld } = (0, $dNrEV.store).getState();
    const data = useOldData ? measurementDataOld : measurementData;
    const deviceToData = new Map();
    for (const deviceId of deviceIds){
        const measurementsToData = new Map();
        let deviceData = data[`${deviceId}`];
        for (const measurement of requestMeasurements){
            const isSiteSpecific = (0, $96LZE.SITE_SPECIFIC_MEASUREMENTS).includes(measurement);
            deviceData = isSiteSpecific ? data[`${siteId}`] : deviceData;
            if (deviceData) {
                const measurementData = deviceData[`${measurement}`];
                const graphData = measurementData ? measurementData[`${range}`] : [];
                measurementsToData.set(measurement, graphData);
            }
        }
        deviceToData.set(deviceId, measurementsToData);
    }
    if (shouldAggregate) {
        const aggregates = {};
        for (const measurement of requestMeasurements)if (measurement.trim() !== "") aggregates[measurement] = [
            $91d714d4673280cd$export$c3830efb74ac7f4f.get(measurement)
        ];
        const thingName = "thingName";
        const aggregate = {
            thingName: "aggregates"
        };
        const promises = [];
        for(const measurement in aggregates){
            const functionTypes = aggregates[measurement];
            functionTypes.forEach((func)=>{
                promises.push($91d714d4673280cd$var$computeAggregation(aggregate, Object.fromEntries(deviceToData), measurement, func));
            });
        }
        await Promise.all(promises);
        const aggregatedMeasures = Object.keys(aggregate).filter((key)=>key !== thingName);
        const aggregationData = new Map();
        for (const measure of aggregatedMeasures){
            const aggMeasure = aggregate[measure];
            const aggValues = aggMeasure.values;
            aggregationData.set(measure, aggValues);
        }
        deviceToData.set((0, $96LZE.AGGREGATES_KEY), aggregationData);
    }
    return deviceToData;
}
async function $91d714d4673280cd$var$getMeasurementData(range, deviceIds, siteId, requestMeasurements, interval, endDate = (0, $ifhNi.dateToUTCDate)(new Date())) {
    const backendMeasurements = requestMeasurements.filter((measurement)=>{
        return !(0, $96LZE.LOCALLY_CALCULATED_MEASUREMENTS).includes(measurement);
    }).filter((measurement)=>{
        return measurement !== (0, $ifhNi.MEASUREMENTS).WEATHER_AVG_TEMP;
    });
    const data = await $91d714d4673280cd$export$d505643be4f46d3d(range, deviceIds, siteId, backendMeasurements, false, interval, endDate);
    const devicesToData = new Map();
    for (const entry of data.entries()){
        const measurementToData = new Map();
        const deviceId = entry[0];
        const measurementsToIntervalsToData = entry[1];
        for (const measurement of backendMeasurements){
            const intervalToData = measurementsToIntervalsToData.get(measurement);
            let graphDataContainer; // {startTimestamp: 0, endTimestamp: 0, values: GraphData[]};
            if (intervalToData && intervalToData.size) {
                graphDataContainer = intervalToData.has(interval) ? intervalToData.get(interval) : [];
                measurementToData.set(measurement, graphDataContainer.values);
            }
        }
        devicesToData.set(deviceId, measurementToData);
    }
    return devicesToData.size ? devicesToData : null;
}
const $91d714d4673280cd$var$computeAggregation = async (aggregate, aircurtains, measurement, func)=>{
    const aggregateName = func + "(" + measurement + ")";
    aggregate[aggregateName] = {
        "startTimestamp": Number.MAX_VALUE,
        "endTimestamp": -Number.MAX_VALUE,
        "values": {},
        "counts": {}
    };
    const targetValues = aggregate[aggregateName].values;
    const targetCounts = aggregate[aggregateName].counts;
    for(const key in aircurtains){
        const values = aircurtains[key].get(measurement) ? aircurtains[key].get(measurement) : [];
        const startTimestamp = aircurtains[key].get(measurement)?.startTimestamp;
        const endTimestamp = aircurtains[key].get(measurement)?.endTimestamp;
        if (startTimestamp < aggregate[aggregateName].startTimestamp) aggregate[aggregateName].startTimestamp = startTimestamp;
        if (endTimestamp > aggregate[aggregateName].endTimestamp) aggregate[aggregateName].endTimestamp = endTimestamp;
        let lastValidValue = 0;
        for (const gData of values){
            if (!(gData.timestamp in targetValues)) {
                switch(func){
                    case 'max':
                        targetValues[gData.timestamp] = -Number.MAX_VALUE;
                        break;
                    case 'min':
                        targetValues[gData.timestamp] = Number.MAX_VALUE;
                        break;
                    default:
                        targetValues[gData.timestamp] = 0;
                }
                targetCounts[gData.timestamp] = 0;
            }
            let value = gData.value;
            switch(func){
                case 'max':
                    if (gData.value > targetValues[gData.timestamp]) targetValues[gData.timestamp] = value;
                    break;
                case 'min':
                    if (gData.value < targetValues[gData.timestamp]) targetValues[gData.timestamp] = value;
                    break;
                default:
                    if ((0, $hkQda.isTimeStampLast24hrs)(gData.timestamp) && (0, $96LZE.MEASUREMENTS_LACKING_24HR_DATA).includes(measurement)) value = lastValidValue;
                    else lastValidValue = value;
                    targetValues[gData.timestamp] += value;
            }
            targetCounts[gData.timestamp]++;
        }
    }
    const temp = [];
    for(const key in targetValues){
        if (func == 'avg') targetValues[key] /= targetCounts[key];
        temp.push({
            "timestamp": key,
            "value": targetValues[key]
        });
    }
    delete aggregate[aggregateName].counts;
    aggregate[aggregateName].values = temp;
    if (temp.length == 0) {
        aggregate[aggregateName].startTimestamp = undefined;
        aggregate[aggregateName].endTimestamp = undefined;
    }
};
async function $91d714d4673280cd$export$d505643be4f46d3d(range, deviceIds, siteId, measurements, aggregate, interval, endDate = (0, $ifhNi.dateToUTCDate)(new Date())) {
    // one or many devices?
    const devices = deviceIds.indexOf(',') ? deviceIds.split(',') : [
        deviceIds
    ];
    const siteIDThingNamePairs = [];
    for (const devicesId of devices)siteIDThingNamePairs.push({
        "ThingName": devicesId,
        "SiteID": siteId
    });
    const requestMeasurements = [];
    for (const measurement of measurements)if (measurement.trim().length) {
        const aggregationType = measurement === (0, $ifhNi.MEASUREMENTS).DOOR_OPEN_COUNT ? 'sum' : 'avg';
        requestMeasurements.push(aggregate ? `${aggregationType}(${measurement})` : measurement);
    }
    const dates = (0, $ifhNi.getDateStringsFromRange)(range, endDate);
    const response = await (0, $ifhNi.getAirCurtainData)(devices, siteIDThingNamePairs, [
        interval
    ], requestMeasurements, dates.startDate, dates.endDate);
    const deviceToMeasurementsToIntervalData = new Map();
    if (response?.length) // one mData per device/<energy data> one per device/<non energy data> (data by siteId/aircurtainId vs data by siteId)
    response.forEach((mData)=>{
        const measurementsToIntervalData = new Map();
        const thingName = mData['thingName'];
        const keys = Object.keys(mData);
        const measurements = keys.filter((key)=>key !== 'thingName');
        for (const measurement of measurements){
            const intervalsToData = mData[measurement];
            const intervalsToDataMap = new Map();
            for (const interval of Object.keys(intervalsToData))intervalsToDataMap.set(interval, intervalsToData[interval]);
            measurementsToIntervalData.set(measurement, intervalsToDataMap);
        }
        if (deviceToMeasurementsToIntervalData.has(thingName)) {
            const existingMeasurementsToIntervalData = deviceToMeasurementsToIntervalData.get(thingName);
            const mergedMeasurementsToIntervalData = new Map([
                ...measurementsToIntervalData,
                ...existingMeasurementsToIntervalData
            ]);
            deviceToMeasurementsToIntervalData.set(thingName, mergedMeasurementsToIntervalData);
        } else deviceToMeasurementsToIntervalData.set(thingName, measurementsToIntervalData);
    });
    return deviceToMeasurementsToIntervalData;
}
async function $91d714d4673280cd$export$b2eb56fd7a161b3f(range, siteIds, measurements, interval, endDate = (0, $ifhNi.dateToUTCDate)(new Date())) {
    const dates = (0, $ifhNi.getDateStringsFromRange)(range, endDate);
    const response = await (0, $ifhNi.getSiteWeatherData)(siteIds, [
        interval
    ], measurements, dates.startDate, dates.endDate);
    const dataBySite = new Map();
    if (response?.length) response.forEach((siteData)=>{
        const siteId = siteData["siteID"];
        const measurements = Object.keys(siteData).filter((key)=>key !== "siteID");
        // measurement to map of interval to GraphData
        const measurementDataByInterval = new Map();
        for (const measurement of measurements){
            const measurementData = siteData[`${measurement}`];
            const intervals = Object.keys(measurementData);
            const intervalToGraphData = new Map();
            for (interval of intervals){
                const graphData = measurementData[`${interval}`];
                intervalToGraphData.set(interval, graphData);
            }
            measurementDataByInterval.set(measurement, intervalToGraphData);
        }
        dataBySite.set(siteId, measurementDataByInterval);
    });
    return dataBySite;
}
async function $91d714d4673280cd$export$8f55abe053034367(username) {
    let initialized = false;
    const session = await (0, $g0OFw.Auth).currentSession();
    const identityID = session.getAccessToken().payload.sub;
    // identityID is the same as the cognito sub (UUID) for the user
    const objectManager = new (0, $kcenM.ObjectManager)(identityID, username);
    initialized = await objectManager.initialize();
    return {
        objectManager: objectManager,
        initialized: initialized
    };
}

});
parcelRegister("hdJfe", function(module, exports) {

$parcel$export(module.exports, "SET_APP_STATE", () => $4edad8324d59ae29$export$8a3d8160a35668df);
$parcel$export(module.exports, "AUTH_FAILED", () => $4edad8324d59ae29$export$91f0fa4f424cda68);
$parcel$export(module.exports, "SET_APP_TEXT", () => $4edad8324d59ae29$export$975b9f09da88ad84);
$parcel$export(module.exports, "SET_USER_EMAIL", () => $4edad8324d59ae29$export$6d3a583d89c1326d);
$parcel$export(module.exports, "SET_OBJECT_MANAGER", () => $4edad8324d59ae29$export$fac88b0afacdf9ba);
$parcel$export(module.exports, "SET_NAV_BAR_COLLAPSED_STATE", () => $4edad8324d59ae29$export$5562e352d06fd311);
$parcel$export(module.exports, "SET_MEASUREMENT_DATA", () => $4edad8324d59ae29$export$ba0014d8dd9fad8);
$parcel$export(module.exports, "SET_OLD_MEASUREMENT_DATA", () => $4edad8324d59ae29$export$691aa76b72a217f4);
$parcel$export(module.exports, "RESET_CACHED_MEASUREMENT_DATA", () => $4edad8324d59ae29$export$f14698b9cfe06937);
$parcel$export(module.exports, "SET_MEASUREMENT_DATA_CACHED_STATE", () => $4edad8324d59ae29$export$9b91935c8edafade);
$parcel$export(module.exports, "SET_MEASUREMENT_DATA_CACHING_IN_PROGRESS_STATE", () => $4edad8324d59ae29$export$68af77f479c165c4);
$parcel$export(module.exports, "SET_PRELOAD_OBJECTS_STATE", () => $4edad8324d59ae29$export$face11a7f9d3dba6);
$parcel$export(module.exports, "SET_PRELOAD_OBJECTS_IN_PROGRESS_STATE", () => $4edad8324d59ae29$export$694c1cbeb6994672);
$parcel$export(module.exports, "RESET_PRELOADED_OBJECTS_STATE", () => $4edad8324d59ae29$export$25fa6d3d42cb448a);
$parcel$export(module.exports, "setAppState", () => $4edad8324d59ae29$export$8921d147d4d1b7);
$parcel$export(module.exports, "authFailed", () => $4edad8324d59ae29$export$3005e514b5302a19);
$parcel$export(module.exports, "setAppText", () => $4edad8324d59ae29$export$4222cb6e94316fdd);
$parcel$export(module.exports, "setUserEmail", () => $4edad8324d59ae29$export$93840d43102f8c7d);
$parcel$export(module.exports, "setNavBarCollapsedState", () => $4edad8324d59ae29$export$574fa64bb2fac9aa);
$parcel$export(module.exports, "setObjectManager", () => $4edad8324d59ae29$export$b452227195ebf44f);
$parcel$export(module.exports, "setMeasurementData", () => $4edad8324d59ae29$export$7e5f42894cd96b29);
$parcel$export(module.exports, "setOldMeasurementData", () => $4edad8324d59ae29$export$e5568ebdd0da7790);
$parcel$export(module.exports, "setMeasurementDataCachedState", () => $4edad8324d59ae29$export$4097d80223c0aff8);
$parcel$export(module.exports, "setMeasurementDataCachingInProgressState", () => $4edad8324d59ae29$export$dc11bee12b8b40ff);
$parcel$export(module.exports, "resetCachedMeasurementData", () => $4edad8324d59ae29$export$902c02c188501d2a);
$parcel$export(module.exports, "setPreloadObjectsState", () => $4edad8324d59ae29$export$53d92e4cd399da23);
$parcel$export(module.exports, "setPreloadObjectsInProgressState", () => $4edad8324d59ae29$export$beb8a5d494875926);
$parcel$export(module.exports, "resetPreloadedObjectsState", () => $4edad8324d59ae29$export$64fecd9b39448332);
const $4edad8324d59ae29$export$8a3d8160a35668df = 'SET_APP_STATE';
const $4edad8324d59ae29$export$91f0fa4f424cda68 = 'AUTH_FAILED';
const $4edad8324d59ae29$export$975b9f09da88ad84 = 'SET_APP_TEXT';
const $4edad8324d59ae29$export$6d3a583d89c1326d = 'SET_USER_EMAIL';
const $4edad8324d59ae29$export$fac88b0afacdf9ba = 'SET_OBJECT_MANAGER';
const $4edad8324d59ae29$export$5562e352d06fd311 = 'SET_NAV_BAR_COLLAPSED_STATE';
const $4edad8324d59ae29$export$ba0014d8dd9fad8 = "SET_MEASUREMENT_DATA";
const $4edad8324d59ae29$export$691aa76b72a217f4 = "SET_OLD_MEASUREMENT_DATA";
const $4edad8324d59ae29$export$f14698b9cfe06937 = "RESET_CACHED_MEASUREMENT_DATA";
const $4edad8324d59ae29$export$9b91935c8edafade = "SET_MEASUREMENT_DATA_CACHED_STATE";
const $4edad8324d59ae29$export$68af77f479c165c4 = "SET_MEASUREMENT_DATA_CACHING_IN_PROGRESS_STATE";
const $4edad8324d59ae29$export$face11a7f9d3dba6 = "SET_PRELOAD_OBJECTS_STATE";
const $4edad8324d59ae29$export$694c1cbeb6994672 = "SET_PRELOAD_OBJECTS_IN_PROGRESS_STATE";
const $4edad8324d59ae29$export$25fa6d3d42cb448a = "RESET_PRELOADED_OBJECTS_STATE";
const $4edad8324d59ae29$export$8921d147d4d1b7 = (appState)=>{
    return {
        type: $4edad8324d59ae29$export$8a3d8160a35668df,
        payload: {
            appState: appState
        }
    };
};
const $4edad8324d59ae29$export$3005e514b5302a19 = (error)=>{
    return {
        type: $4edad8324d59ae29$export$91f0fa4f424cda68,
        payload: {
            error: error
        }
    };
};
const $4edad8324d59ae29$export$4222cb6e94316fdd = (applicationText)=>{
    return {
        type: $4edad8324d59ae29$export$975b9f09da88ad84,
        payload: {
            applicationText: applicationText
        }
    };
};
const $4edad8324d59ae29$export$93840d43102f8c7d = (userEmail)=>{
    return {
        type: $4edad8324d59ae29$export$6d3a583d89c1326d,
        payload: {
            userEmail: userEmail
        }
    };
};
const $4edad8324d59ae29$export$574fa64bb2fac9aa = (collapsed)=>{
    return {
        type: $4edad8324d59ae29$export$5562e352d06fd311,
        payload: {
            navBarCollapsedState: collapsed
        }
    };
};
const $4edad8324d59ae29$export$b452227195ebf44f = (objectManager)=>{
    return {
        type: $4edad8324d59ae29$export$fac88b0afacdf9ba,
        payload: {
            objectManager: objectManager
        }
    };
};
const $4edad8324d59ae29$export$7e5f42894cd96b29 = (deviceId, measurementData)=>{
    return {
        type: $4edad8324d59ae29$export$ba0014d8dd9fad8,
        payload: {
            deviceId: deviceId,
            measurementData: measurementData
        }
    };
};
const $4edad8324d59ae29$export$e5568ebdd0da7790 = (deviceId, measurementDataOld)=>{
    return {
        type: $4edad8324d59ae29$export$691aa76b72a217f4,
        payload: {
            deviceId: deviceId,
            measurementDataOld: measurementDataOld
        }
    };
};
const $4edad8324d59ae29$export$4097d80223c0aff8 = (cached)=>{
    return {
        type: $4edad8324d59ae29$export$9b91935c8edafade,
        payload: {
            measurementDataCachedState: cached
        }
    };
};
const $4edad8324d59ae29$export$dc11bee12b8b40ff = ()=>{
    return {
        type: $4edad8324d59ae29$export$68af77f479c165c4,
        payload: {
            measurementDataCachingInProgressState: true
        }
    };
};
const $4edad8324d59ae29$export$902c02c188501d2a = ()=>{
    return {
        type: $4edad8324d59ae29$export$f14698b9cfe06937,
        payload: {}
    };
};
const $4edad8324d59ae29$export$53d92e4cd399da23 = (preloaded)=>{
    return {
        type: $4edad8324d59ae29$export$face11a7f9d3dba6,
        payload: {
            preloadObjectsState: preloaded
        }
    };
};
const $4edad8324d59ae29$export$beb8a5d494875926 = ()=>{
    return {
        type: $4edad8324d59ae29$export$694c1cbeb6994672,
        payload: {
            preloadObjectsInProgressState: true
        }
    };
};
const $4edad8324d59ae29$export$64fecd9b39448332 = ()=>{
    return {
        type: $4edad8324d59ae29$export$25fa6d3d42cb448a,
        payload: {}
    };
};

});

parcelRegister("dNrEV", function(module, exports) {

$parcel$export(module.exports, "store", () => $1ccce19e6a495442$export$6f57813fe9f31bf9);

var $deRlU = parcelRequire("deRlU");

var $etPji = parcelRequire("etPji");

var $gAlqJ = parcelRequire("gAlqJ");
const $1ccce19e6a495442$export$6f57813fe9f31bf9 = (0, $deRlU.createStore)((0, $etPji.reducer), (0, $gAlqJ.composeWithDevTools)());

});
parcelRegister("deRlU", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $9a35f7d0eecef0db$export$f51a9068ac82ea43);
$parcel$export(module.exports, "compose", () => $9a35f7d0eecef0db$export$f672e0b6f7222cd7);

var $lJExL = parcelRequire("lJExL");
/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $9a35f7d0eecef0db$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}
// Inlined version of the `symbol-observable` polyfill
var $9a35f7d0eecef0db$var$$$observable = function() {
    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $9a35f7d0eecef0db$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split('').join('.');
};
var $9a35f7d0eecef0db$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $9a35f7d0eecef0db$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $9a35f7d0eecef0db$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $9a35f7d0eecef0db$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $9a35f7d0eecef0db$var$isPlainObject(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $9a35f7d0eecef0db$var$miniKindOf(val) {
    if (val === void 0) return 'undefined';
    if (val === null) return 'null';
    var type = typeof val;
    switch(type){
        case 'boolean':
        case 'string':
        case 'number':
        case 'symbol':
        case 'function':
            return type;
    }
    if (Array.isArray(val)) return 'array';
    if ($9a35f7d0eecef0db$var$isDate(val)) return 'date';
    if ($9a35f7d0eecef0db$var$isError(val)) return 'error';
    var constructorName = $9a35f7d0eecef0db$var$ctorName(val);
    switch(constructorName){
        case 'Symbol':
        case 'Promise':
        case 'WeakMap':
        case 'WeakSet':
        case 'Map':
        case 'Set':
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}
function $9a35f7d0eecef0db$var$ctorName(val) {
    return typeof val.constructor === 'function' ? val.constructor.name : null;
}
function $9a35f7d0eecef0db$var$isError(val) {
    return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}
function $9a35f7d0eecef0db$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}
function $9a35f7d0eecef0db$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $9a35f7d0eecef0db$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') throw new Error($9a35f7d0eecef0db$var$formatProdErrorMessage(0));
    if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== 'undefined') {
        if (typeof enhancer !== 'function') throw new Error($9a35f7d0eecef0db$var$formatProdErrorMessage(1));
        return enhancer($9a35f7d0eecef0db$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== 'function') throw new Error($9a35f7d0eecef0db$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($9a35f7d0eecef0db$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== 'function') throw new Error($9a35f7d0eecef0db$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($9a35f7d0eecef0db$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($9a35f7d0eecef0db$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$9a35f7d0eecef0db$var$isPlainObject(action)) throw new Error($9a35f7d0eecef0db$var$formatProdErrorMessage(7));
        if (typeof action.type === 'undefined') throw new Error($9a35f7d0eecef0db$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($9a35f7d0eecef0db$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== 'function') throw new Error($9a35f7d0eecef0db$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $9a35f7d0eecef0db$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) throw new Error($9a35f7d0eecef0db$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$9a35f7d0eecef0db$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $9a35f7d0eecef0db$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$9a35f7d0eecef0db$var$$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var $9a35f7d0eecef0db$export$8928921ea2d3b126 = $9a35f7d0eecef0db$export$f51a9068ac82ea43;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $9a35f7d0eecef0db$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $9a35f7d0eecef0db$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $9a35f7d0eecef0db$export$4219e499db7ca678.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$9a35f7d0eecef0db$var$isPlainObject(inputState)) return "The " + argumentName + " has unexpected type of \"" + $9a35f7d0eecef0db$var$kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $9a35f7d0eecef0db$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
}
function $9a35f7d0eecef0db$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $9a35f7d0eecef0db$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === 'undefined') throw new Error($9a35f7d0eecef0db$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $9a35f7d0eecef0db$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === 'undefined') throw new Error($9a35f7d0eecef0db$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $9a35f7d0eecef0db$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === 'function') finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $9a35f7d0eecef0db$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === 'undefined') {
                var actionType = action && action.type;
                throw new Error($9a35f7d0eecef0db$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $9a35f7d0eecef0db$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $9a35f7d0eecef0db$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === 'function') return $9a35f7d0eecef0db$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== 'object' || actionCreators === null) throw new Error($9a35f7d0eecef0db$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = $9a35f7d0eecef0db$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $9a35f7d0eecef0db$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $9a35f7d0eecef0db$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($9a35f7d0eecef0db$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $9a35f7d0eecef0db$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $lJExL.default)((0, $lJExL.default)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}

});
parcelRegister("lJExL", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd2d4014411af5f1$export$2e2bcd8739ae039);

var $hTCUO = parcelRequire("hTCUO");
function $fd2d4014411af5f1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fd2d4014411af5f1$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fd2d4014411af5f1$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $hTCUO.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fd2d4014411af5f1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

});
parcelRegister("hTCUO", function(module, exports) {

$parcel$export(module.exports, "default", () => $d075c27fcf0ff8cb$export$2e2bcd8739ae039);

var $5owm8 = parcelRequire("5owm8");
function $d075c27fcf0ff8cb$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $5owm8.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("5owm8", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ed84ade06056058$export$2e2bcd8739ae039);

var $4nKb5 = parcelRequire("4nKb5");

var $fQsi9 = parcelRequire("fQsi9");
function $3ed84ade06056058$export$2e2bcd8739ae039(t) {
    var i = (0, $fQsi9.default)(t, "string");
    return "symbol" == (0, $4nKb5.default)(i) ? i : i + "";
}

});
parcelRegister("4nKb5", function(module, exports) {

$parcel$export(module.exports, "default", () => $330d215c8773d9cf$export$2e2bcd8739ae039);
function $330d215c8773d9cf$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $330d215c8773d9cf$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $330d215c8773d9cf$export$2e2bcd8739ae039(o);
}

});

parcelRegister("fQsi9", function(module, exports) {

$parcel$export(module.exports, "default", () => $b891a88180a5d288$export$2e2bcd8739ae039);

var $4nKb5 = parcelRequire("4nKb5");
function $b891a88180a5d288$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $4nKb5.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $4nKb5.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});





parcelRegister("etPji", function(module, exports) {

$parcel$export(module.exports, "reducer", () => $f5bbd3941c8f4897$export$1650419e431d3ba3);

var $hdJfe = parcelRequire("hdJfe");
// userEmail saved here only when being retained between screens before user auth
const $f5bbd3941c8f4897$var$INITIAL_STATE = {
    appState: '',
    userEmail: '',
    applicationText: null,
    authError: null,
    objectManager: null,
    navBarCollapsedState: false,
    measurementData: {},
    measurementDataOld: {},
    measurementDataCachedState: false,
    measurementDataCachingInProgressState: false,
    preloadObjectsState: false,
    preloadObjectsInProgressState: false
};
const $f5bbd3941c8f4897$export$1650419e431d3ba3 = (state = $f5bbd3941c8f4897$var$INITIAL_STATE, action)=>{
    switch(action.type){
        case 0, $hdJfe.SET_APP_STATE:
            return {
                ...state,
                appState: action.payload.appState
            };
        case 0, $hdJfe.SET_APP_TEXT:
            return {
                ...state,
                applicationText: action.payload.applicationText
            };
        case 0, $hdJfe.SET_USER_EMAIL:
            return {
                ...state,
                userEmail: action.payload.userEmail
            };
        case 0, $hdJfe.AUTH_FAILED:
            return {
                ...state,
                authError: action.payload.error
            };
        case 0, $hdJfe.SET_OBJECT_MANAGER:
            return {
                ...state,
                objectManager: action.payload.objectManager
            };
        case 0, $hdJfe.SET_NAV_BAR_COLLAPSED_STATE:
            return {
                ...state,
                navBarCollapsedState: action.payload.navBarCollapsedState
            };
        case 0, $hdJfe.SET_MEASUREMENT_DATA:
            return {
                ...state,
                measurementData: {
                    ...state.measurementData,
                    [action.payload.deviceId]: action.payload.measurementData
                }
            };
        case 0, $hdJfe.SET_OLD_MEASUREMENT_DATA:
            return {
                ...state,
                measurementDataOld: {
                    ...state.measurementDataOld,
                    [action.payload.deviceId]: action.payload.measurementDataOld
                }
            };
        case 0, $hdJfe.SET_MEASUREMENT_DATA_CACHED_STATE:
            return {
                ...state,
                measurementDataCachedState: action.payload.measurementDataCachedState,
                measurementDataCachingInProgressState: false
            };
        case 0, $hdJfe.SET_MEASUREMENT_DATA_CACHING_IN_PROGRESS_STATE:
            return {
                ...state,
                measurementDataCachingInProgressState: action.payload.measurementDataCachingInProgressState
            };
        case 0, $hdJfe.RESET_CACHED_MEASUREMENT_DATA:
            return {
                ...state,
                measurementData: {},
                measurementDataOld: {},
                measurementDataCachedState: false,
                measurementDataCachingInProgressState: false
            };
        case 0, $hdJfe.SET_PRELOAD_OBJECTS_STATE:
            return {
                ...state,
                preloadObjectsState: action.payload.preloadObjectsState,
                preloadObjectsInProgressState: false
            };
        case 0, $hdJfe.SET_PRELOAD_OBJECTS_IN_PROGRESS_STATE:
            return {
                ...state,
                preloadObjectsInProgressState: action.payload.preloadObjectsInProgressState
            };
        case 0, $hdJfe.RESET_PRELOADED_OBJECTS_STATE:
            return {
                ...state,
                preloadObjectsState: false,
                preloadObjectsInProgressState: false
            };
        default:
            return state;
    }
};

});

parcelRegister("gAlqJ", function(module, exports) {

$parcel$export(module.exports, "composeWithDevTools", () => $c130a1ba6a4d2cbe$export$d32324a03b6bde1b, (v) => $c130a1ba6a4d2cbe$export$d32324a03b6bde1b = v);
var $c130a1ba6a4d2cbe$export$1e511d4a378977f5;
var $c130a1ba6a4d2cbe$export$d32324a03b6bde1b;
var $c130a1ba6a4d2cbe$export$321b1ffcca858b2b;
'use strict';

var $deRlU = parcelRequire("deRlU");
var $c130a1ba6a4d2cbe$require$compose = $deRlU.compose;
$c130a1ba6a4d2cbe$export$1e511d4a378977f5 = true;
$c130a1ba6a4d2cbe$export$d32324a03b6bde1b = typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return undefined;
    if (typeof arguments[0] === 'object') return $c130a1ba6a4d2cbe$require$compose;
    return $c130a1ba6a4d2cbe$require$compose.apply(null, arguments);
};
$c130a1ba6a4d2cbe$export$321b1ffcca858b2b = typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop) {
        return noop;
    };
};

});


parcelRegister("96LZE", function(module, exports) {

$parcel$export(module.exports, "AGGREGATES_KEY", () => $53ff2edd9e0c3e36$export$704f2b7b6f16ed7c);
$parcel$export(module.exports, "COLUMN_CHART_MEASUREMENTS", () => $53ff2edd9e0c3e36$export$fddd03b8515aca5c);
$parcel$export(module.exports, "AREA_GRAPH_MEASUREMENTS", () => $53ff2edd9e0c3e36$export$3b7c5ebb66f29e74);
$parcel$export(module.exports, "MEASUREMENTS_LACKING_24HR_DATA", () => $53ff2edd9e0c3e36$export$4bfc66f530c85f42);
$parcel$export(module.exports, "LOCALLY_CALCULATED_MEASUREMENTS", () => $53ff2edd9e0c3e36$export$3b886d8b0604dcca);
$parcel$export(module.exports, "SITE_SPECIFIC_MEASUREMENTS", () => $53ff2edd9e0c3e36$export$2fca03af38bea04);
$parcel$export(module.exports, "getInfographicDataAggregated", () => $53ff2edd9e0c3e36$export$36751d001480b67f);
$parcel$export(module.exports, "getTotal", () => $53ff2edd9e0c3e36$export$94860ac4a286a8d9);
$parcel$export(module.exports, "getInfographicData", () => $53ff2edd9e0c3e36$export$873a720814caf90a);
$parcel$export(module.exports, "getAverage", () => $53ff2edd9e0c3e36$export$4c1248d708f92e20);
$parcel$export(module.exports, "getDisplayValue", () => $53ff2edd9e0c3e36$export$a1621ec3333dbcad);
$parcel$export(module.exports, "getMaxMin", () => $53ff2edd9e0c3e36$export$3b15deb8a684d8b0);
$parcel$export(module.exports, "getCoolingCost", () => $53ff2edd9e0c3e36$export$fe0cd733438c58fb);
$parcel$export(module.exports, "getHeatingCost", () => $53ff2edd9e0c3e36$export$d04ab43682b07746);
$parcel$export(module.exports, "getSavingData", () => $53ff2edd9e0c3e36$export$f6823ac152ec03aa);
$parcel$export(module.exports, "getCostToOperateData", () => $53ff2edd9e0c3e36$export$2d457b0cab5c09a8);
$parcel$export(module.exports, "getLossData", () => $53ff2edd9e0c3e36$export$7b271758c4e67c41);
$parcel$export(module.exports, "getGrossSavingData", () => $53ff2edd9e0c3e36$export$3a1dea53dc4486bd);
$parcel$export(module.exports, "getConvertedTemperature", () => $53ff2edd9e0c3e36$export$ac7136d785dfd9fd);
$parcel$export(module.exports, "convertCelsiusToFahrenheit", () => $53ff2edd9e0c3e36$export$b359f8b323416624);
$parcel$export(module.exports, "getMeasurementUI", () => $53ff2edd9e0c3e36$export$14413bc2d459d19a);

var $ifhNi = parcelRequire("ifhNi");

var $ht1kU = parcelRequire("ht1kU");

var $hkQda = parcelRequire("hkQda");

var $kKwbp = parcelRequire("kKwbp");
const $53ff2edd9e0c3e36$export$704f2b7b6f16ed7c = 'aggregates';
const $53ff2edd9e0c3e36$export$fddd03b8515aca5c = [
    (0, $ifhNi.MEASUREMENTS).BTU,
    (0, $ifhNi.MEASUREMENTS).LOSS,
    (0, $ifhNi.MEASUREMENTS).COST_TO_OPERATE,
    (0, $ifhNi.MEASUREMENTS).GROSS_SAVING,
    (0, $ifhNi.MEASUREMENTS).SAVING,
    (0, $ifhNi.MEASUREMENTS).TON_GAIN_RATE,
    (0, $ifhNi.MEASUREMENTS).DOOR_OPEN_TIME,
    (0, $ifhNi.MEASUREMENTS).DOOR_OPEN_COUNT
];
const $53ff2edd9e0c3e36$export$3b7c5ebb66f29e74 = [
    (0, $ifhNi.MEASUREMENTS).AVERAGE_TEMP,
    (0, $ifhNi.MEASUREMENTS).MAX_TEMP,
    (0, $ifhNi.MEASUREMENTS).MIN_TEMP,
    (0, $ifhNi.MEASUREMENTS).WEATHER_AVG_TEMP,
    (0, $ifhNi.MEASUREMENTS).EFFICIENCY
];
const $53ff2edd9e0c3e36$export$4bfc66f530c85f42 = [
    (0, $ifhNi.MEASUREMENTS).EFFICIENCY,
    (0, $ifhNi.MEASUREMENTS).SAVING,
    (0, $ifhNi.MEASUREMENTS).GROSS_SAVING,
    (0, $ifhNi.MEASUREMENTS).BTU,
    (0, $ifhNi.MEASUREMENTS).TON_GAIN_RATE,
    (0, $ifhNi.MEASUREMENTS).LOSS,
    (0, $ifhNi.MEASUREMENTS).COST_TO_OPERATE,
    (0, $ifhNi.MEASUREMENTS).DOOR_OPEN_TIME,
    (0, $ifhNi.MEASUREMENTS).WEATHER_AVG_TEMP
];
const $53ff2edd9e0c3e36$export$3b886d8b0604dcca = [
    (0, $ifhNi.MEASUREMENTS).LOSS,
    (0, $ifhNi.MEASUREMENTS).COST_TO_OPERATE,
    (0, $ifhNi.MEASUREMENTS).SAVING,
    (0, $ifhNi.MEASUREMENTS).GROSS_SAVING
];
const $53ff2edd9e0c3e36$export$2fca03af38bea04 = [
    (0, $ifhNi.MEASUREMENTS).WEATHER_AVG_TEMP
];
async function $53ff2edd9e0c3e36$export$36751d001480b67f(selectedRange, measurement, average, airCurtains) {
    const aircurtainIds = airCurtains.map((aircurtain)=>{
        return aircurtain.airCurtainID;
    });
    const aggMeasurementKey = (0, $ht1kU.MEASUREMENT_TO_FUNC).get(measurement) + '(' + measurement + ')';
    const oldData = await (0, $ht1kU.getCachedData)(selectedRange, aircurtainIds, [
        measurement
    ], true, true, "");
    // Data from the period preceding the range, i.e. week before last, to check change amount
    const oldDataAggregated = oldData.get($53ff2edd9e0c3e36$export$704f2b7b6f16ed7c)?.get(aggMeasurementKey);
    let oldValue = $53ff2edd9e0c3e36$export$94860ac4a286a8d9(oldDataAggregated) ?? 0;
    if (average) oldValue = oldDataAggregated?.length ? oldValue / oldDataAggregated.length : 0;
    //Data from the current range, i.e. last week
    const newData = await (0, $ht1kU.getCachedData)(selectedRange, aircurtainIds, [
        measurement
    ], true, false, "");
    const newDataAggregated = newData.get($53ff2edd9e0c3e36$export$704f2b7b6f16ed7c)?.get(aggMeasurementKey);
    let value = newDataAggregated?.length ? Math.ceil($53ff2edd9e0c3e36$export$94860ac4a286a8d9(newDataAggregated)) : undefined;
    if (average) value = newDataAggregated?.length ? value / newDataAggregated.length : undefined;
    // TODO: shouldn't return a value until old data is cached
    return {
        value: value,
        change: value === undefined ? 0 : value - oldValue
    };
}
async function $53ff2edd9e0c3e36$export$873a720814caf90a(selectedRange, measurement, average, airCurtains) {
    const aircurtainIds = airCurtains.map((aircurtain)=>{
        return aircurtain.airCurtainID;
    });
    const results = new Map();
    for (const deviceId of aircurtainIds){
        const dataByMeasurement = await (0, $ht1kU.getCachedData)(selectedRange, [
            deviceId
        ], [
            measurement
        ], false, false, "");
        const oldDataByMeasurement = await (0, $ht1kU.getCachedData)(selectedRange, [
            deviceId
        ], [
            measurement
        ], false, true, "");
        results.set(deviceId, null);
        const deviceData = dataByMeasurement.get(deviceId);
        const oldDeviceData = oldDataByMeasurement.get(deviceId);
        if (deviceData) {
            const data = deviceData.get(measurement);
            const oldData = oldDeviceData?.get(measurement);
            if (data && data.length) {
                let value = Math.ceil($53ff2edd9e0c3e36$export$94860ac4a286a8d9(data));
                let oldValue = 0;
                if (average) value = value / Object.keys(data).length;
                if (oldData) {
                    oldValue = Math.ceil($53ff2edd9e0c3e36$export$94860ac4a286a8d9(oldData));
                    if (average) oldValue = oldValue / Object.keys(oldData).length;
                }
                const infoGraphicData = {
                    value: value,
                    change: value === undefined ? 0 : value - oldValue
                };
                results.set(deviceId, infoGraphicData);
            }
        }
    }
    return results;
}
function $53ff2edd9e0c3e36$export$94860ac4a286a8d9(graphData) {
    let value = 0;
    value = graphData?.reduce((accumulator, currentValue, currentIndex, data)=>{
        return accumulator + data[currentIndex].value;
    }, 0);
    return value;
}
function $53ff2edd9e0c3e36$export$4c1248d708f92e20(data, measurement, numDates) {
    let average = 0;
    let values = [];
    let lastValidValue = 0;
    values = data?.map((gData)=>{
        // compensate for data not yet processed within last 24 hrs
        let value = gData.value;
        if ((0, $hkQda.isTimeStampLast24hrs)(gData.timestamp) && $53ff2edd9e0c3e36$export$4bfc66f530c85f42.includes(measurement)) value = lastValidValue;
        else lastValidValue = gData.value;
        return $53ff2edd9e0c3e36$export$a1621ec3333dbcad(measurement, value);
    });
    const divisor = numDates > 0 ? numDates : values.length;
    if (values?.length) average = values.reduce((acc, current)=>{
        return acc += current;
    }) / divisor;
    return average;
}
function $53ff2edd9e0c3e36$export$3b15deb8a684d8b0(data, measurement) {
    let values = [];
    let lastValidValue = 0;
    values = data?.map((gData)=>{
        let value = gData.value;
        // compensate for data not yet processed within last 24 hrs
        if ((0, $hkQda.isTimeStampLast24hrs)(gData.timestamp) && $53ff2edd9e0c3e36$export$4bfc66f530c85f42.includes(measurement)) value = lastValidValue;
        else lastValidValue = gData.value;
        return $53ff2edd9e0c3e36$export$a1621ec3333dbcad(measurement, value);
    });
    const sorted = values?.length ? values.sort((a, b)=>{
        return a - b;
    }) : [
        0,
        0
    ];
    return {
        max: sorted[sorted.length - 1],
        min: sorted[0]
    };
}
function $53ff2edd9e0c3e36$export$fe0cd733438c58fb(electricityRate, naturalGasRate, oilRate, energyType) {
    switch(energyType){
        case 'e':
            return electricityRate;
        case 'g':
            return naturalGasRate * 0.974966278 / 0.99;
        case 'o':
            return 0;
    }
}
function $53ff2edd9e0c3e36$export$d04ab43682b07746(electricityRate, naturalGasRate, oilRate, energyType) {
    switch(energyType){
        case 'e':
            return electricityRate * 1000 / 3.413;
        case 'g':
            return naturalGasRate * 0.974966278;
        case 'o':
            return oilRate * 0.172323997;
    }
}
function $53ff2edd9e0c3e36$var$getLoss(btu, tonGainRate, coolingCost, heatingCost) {
    return btu * heatingCost + tonGainRate * coolingCost;
}
function $53ff2edd9e0c3e36$var$getCostToOperate(modelId, electricityRate, doorOpenHours) {
    const modelsStruct = JSON.parse(JSON.stringify((0, $kKwbp.models)));
    const modelData = modelsStruct[`${modelId}`];
    if (modelData === undefined) return 0;
    const totalHorsePower = modelData.totalHorsePower;
    if (totalHorsePower === undefined) return 0;
    return 0.746 * totalHorsePower * electricityRate * doorOpenHours;
}
function $53ff2edd9e0c3e36$var$getSaving(grossSaving, costToOperate) {
    return grossSaving - costToOperate;
}
function $53ff2edd9e0c3e36$var$precise_round(num, decimals) {
    const sign = num >= 0 ? 1 : -1;
    return (Math.round(num * Math.pow(10, decimals) + sign * 0.001) / Math.pow(10, decimals)).toFixed(decimals);
}
function $53ff2edd9e0c3e36$export$f6823ac152ec03aa(grossSavingData, costToOperateData) {
    const timeStamps = grossSavingData?.map((graphData)=>{
        return graphData.timestamp;
    });
    const results = [];
    for (const timestamp of timeStamps){
        const grossSaving = grossSavingData.find((graphData)=>{
            return graphData.timestamp === timestamp;
        })?.value;
        const costToOperate = costToOperateData.find((graphData)=>{
            return graphData.timestamp === timestamp;
        })?.value;
        if (grossSaving !== undefined && costToOperate !== undefined) {
            const value = $53ff2edd9e0c3e36$var$getSaving(grossSaving, costToOperate);
            results.push({
                timestamp: timestamp,
                value: value
            });
        }
    }
    return results;
}
function $53ff2edd9e0c3e36$export$2d457b0cab5c09a8(doorOpenTimeData, modelId, electricityRate) {
    const timeStamps = doorOpenTimeData?.map((doorOpenTimeData)=>{
        return doorOpenTimeData.timestamp;
    });
    const results = [];
    for (const timestamp of timeStamps){
        const doorOpenHours = doorOpenTimeData.find((graphData)=>{
            return graphData.timestamp === timestamp;
        })?.value;
        if (doorOpenHours !== undefined) {
            const value = $53ff2edd9e0c3e36$var$getCostToOperate(modelId, electricityRate, doorOpenHours);
            results.push({
                timestamp: timestamp,
                value: value
            });
        }
    }
    return results;
}
function $53ff2edd9e0c3e36$export$7b271758c4e67c41(btuData, tonGainRateData, coolingCost, heatingCost) {
    const timeStamps = btuData?.map((graphData)=>{
        return graphData.timestamp;
    });
    const results = [];
    for (const timestamp of timeStamps){
        const btu = btuData.find((graphData)=>{
            return graphData.timestamp === timestamp;
        })?.value;
        const tonGainRate = tonGainRateData.find((graphData)=>{
            return graphData.timestamp === timestamp;
        })?.value;
        if (btu !== undefined && tonGainRate !== undefined) {
            const value = $53ff2edd9e0c3e36$var$getLoss(btu, tonGainRate, coolingCost, heatingCost);
            results.push({
                timestamp: timestamp,
                value: value
            });
        }
    }
    return results;
}
function $53ff2edd9e0c3e36$export$3a1dea53dc4486bd(efficiencyData, btuData, tonGainRateData, coolingCost, heatingCost) {
    const timeStamps = efficiencyData?.map((graphData)=>{
        return graphData.timestamp;
    });
    const results = [];
    for (const timestamp of timeStamps){
        const btu = btuData.find((graphData)=>{
            return graphData.timestamp === timestamp;
        })?.value;
        const tonGainRate = tonGainRateData.find((graphData)=>{
            return graphData.timestamp === timestamp;
        })?.value;
        const efficiency = efficiencyData.find((graphData)=>{
            return graphData.timestamp === timestamp;
        })?.value;
        if (btu !== undefined && tonGainRate !== undefined && efficiency !== undefined) {
            const loss = $53ff2edd9e0c3e36$var$getLoss(btu, tonGainRate, coolingCost, heatingCost);
            const value = loss * efficiency;
            if (value !== undefined) results.push({
                timestamp: timestamp,
                value: value
            });
        }
    }
    return results;
}
function $53ff2edd9e0c3e36$export$ac7136d785dfd9fd(value, decimalPoints = 1) {
    if ((0, $hkQda.getTempUnitCelsiusSelected)()) return $53ff2edd9e0c3e36$var$convertFahrenheitToCelsius(value, decimalPoints);
    else return +$53ff2edd9e0c3e36$var$precise_round(value, decimalPoints);
}
function $53ff2edd9e0c3e36$var$convertFahrenheitToCelsius(value, decimalPoints = 1) {
    const result = (value - 32) * .5556;
    return +$53ff2edd9e0c3e36$var$precise_round(result, decimalPoints);
}
function $53ff2edd9e0c3e36$export$b359f8b323416624(value) {
    const result = value * 9 / 5 + 32;
    return +$53ff2edd9e0c3e36$var$precise_round(result, 1);
}
function $53ff2edd9e0c3e36$export$a1621ec3333dbcad(measurement, value) {
    switch(measurement){
        case (0, $ifhNi.MEASUREMENTS).EFFICIENCY:
            return value * 100;
        case (0, $ifhNi.MEASUREMENTS).DOOR_OPEN_COUNT:
            return Math.ceil(value);
        case (0, $ifhNi.MEASUREMENTS).DOOR_OPEN_TIME:
            return value < 1 ? Math.ceil(value * 60) : Math.ceil(value);
        case (0, $ifhNi.MEASUREMENTS).SAVING:
        case (0, $ifhNi.MEASUREMENTS).GROSS_SAVING:
            // if location / installation are misconfigured negative values are possible
            return value < 0 ? 0 : value;
        case (0, $ifhNi.MEASUREMENTS).AVERAGE_TEMP:
        case (0, $ifhNi.MEASUREMENTS).MIN_TEMP:
        case (0, $ifhNi.MEASUREMENTS).MAX_TEMP:
        case (0, $ifhNi.MEASUREMENTS).WEATHER_AVG_TEMP:
            return $53ff2edd9e0c3e36$export$ac7136d785dfd9fd(value);
        default:
            return value;
    }
}
function $53ff2edd9e0c3e36$export$14413bc2d459d19a(measurement, interval = '') {
    const graphUI = {
        label: '',
        yAxisLabel: '',
        color: 'lightblue',
        colorSecondary: 'midnightblue',
        colorAlpha: 'lightblue',
        unit: '',
        decimals: 0,
        icon: '',
        subtitle: '',
        yAxisMin: 0,
        yAxisMax: 0,
        yAxisRangePercentLimit: 0,
        displayTotal: false
    };
    const redAlpha = 'rgba(255,95,76,0.05)';
    const blueAlpha = 'rgba(74,144,226,0.05)';
    const greenAlpha = 'rgba(67,185,41,0.05)';
    const greyAlpha = 'rgba(80,80,80,0.05)';
    const orangeAlpha = 'rgba(255,165,0,0.05)';
    switch(measurement){
        case (0, $ifhNi.MEASUREMENTS).AVERAGE_TEMP:
            graphUI.label = 'Temperature';
            graphUI.color = '#ff5f4c';
            graphUI.colorSecondary = 'tomato';
            graphUI.colorAlpha = redAlpha;
            graphUI.yAxisLabel = 'Degrees';
            graphUI.unit = (0, $hkQda.getTempUnitCelsiusSelected)() ? "\xb0C" : "\xb0F";
            graphUI.yAxisRangePercentLimit = 5;
            graphUI.decimals = 1;
            break;
        case (0, $ifhNi.MEASUREMENTS).MAX_TEMP:
            graphUI.label = 'Max Temperature';
            graphUI.color = '#ff5f4c';
            graphUI.colorSecondary = 'tomato';
            graphUI.colorAlpha = redAlpha;
            graphUI.yAxisLabel = 'Degrees';
            graphUI.unit = (0, $hkQda.getTempUnitCelsiusSelected)() ? "\xb0C" : "\xb0F";
            graphUI.yAxisRangePercentLimit = 5;
            graphUI.decimals = 1;
            break;
        case (0, $ifhNi.MEASUREMENTS).MIN_TEMP:
            graphUI.label = 'Min Temperature';
            graphUI.color = '#ff5f4c';
            graphUI.colorSecondary = 'tomato';
            graphUI.colorAlpha = redAlpha;
            graphUI.yAxisLabel = 'Degrees';
            graphUI.unit = (0, $hkQda.getTempUnitCelsiusSelected)() ? "\xb0C" : "\xb0F";
            graphUI.yAxisRangePercentLimit = 5;
            graphUI.decimals = 1;
            break;
        case (0, $ifhNi.MEASUREMENTS).WEATHER_AVG_TEMP:
            graphUI.label = 'Outside Temperature';
            graphUI.color = 'orange';
            graphUI.colorSecondary = 'red';
            graphUI.colorAlpha = orangeAlpha;
            graphUI.yAxisLabel = 'Degrees';
            graphUI.unit = (0, $hkQda.getTempUnitCelsiusSelected)() ? "\xb0C" : "\xb0F";
            graphUI.yAxisRangePercentLimit = 5;
            graphUI.decimals = 1;
            break;
        case (0, $ifhNi.MEASUREMENTS).EFFICIENCY:
            graphUI.label = 'Energy Saving';
            graphUI.color = '#43b929';
            graphUI.colorSecondary = 'mediumseagreen';
            graphUI.colorAlpha = greenAlpha;
            graphUI.yAxisLabel = 'Percent';
            graphUI.unit = '%';
            graphUI.yAxisMax = 100;
            break;
        case (0, $ifhNi.MEASUREMENTS).SAVING:
            graphUI.label = 'Saving';
            graphUI.color = 'royalblue';
            graphUI.colorSecondary = 'midnightblue';
            graphUI.colorAlpha = blueAlpha;
            graphUI.decimals = 2;
            graphUI.yAxisLabel = 'Dollars';
            graphUI.unit = '$';
            graphUI.displayTotal = true;
            break;
        case (0, $ifhNi.MEASUREMENTS).COST_TO_OPERATE:
            graphUI.label = 'Cost to Operate';
            graphUI.color = 'royalblue';
            graphUI.colorSecondary = 'midnightblue';
            graphUI.colorAlpha = blueAlpha;
            graphUI.decimals = 2;
            graphUI.yAxisLabel = 'Dollars';
            graphUI.unit = '$';
            graphUI.yAxisRangePercentLimit = 5;
            graphUI.displayTotal = true;
            break;
        case (0, $ifhNi.MEASUREMENTS).GROSS_SAVING:
            graphUI.label = 'Gross Saving';
            graphUI.color = 'royalblue';
            graphUI.colorSecondary = 'midnightblue';
            graphUI.colorAlpha = blueAlpha;
            graphUI.decimals = 2;
            graphUI.yAxisLabel = 'Dollars';
            graphUI.unit = '$';
            graphUI.yAxisRangePercentLimit = 5;
            graphUI.displayTotal = true;
            break;
        case (0, $ifhNi.MEASUREMENTS).BTU:
            graphUI.label = 'BTU';
            graphUI.color = 'pink';
            graphUI.colorSecondary = 'tomato';
            graphUI.colorAlpha = redAlpha;
            graphUI.decimals = 6;
            graphUI.yAxisLabel = 'BTU';
            graphUI.unit = 'Btu';
            graphUI.subtitle = 'Heat energy saved by the air curtain(s)';
            break;
        case (0, $ifhNi.MEASUREMENTS).TON_GAIN_RATE:
            graphUI.label = 'Ton Gain Rate';
            graphUI.color = 'pink';
            graphUI.colorSecondary = 'tomato';
            graphUI.colorAlpha = redAlpha;
            graphUI.decimals = 3;
            graphUI.yAxisLabel = '';
            graphUI.unit = 'TR';
            graphUI.subtitle = 'Cooling energy lost';
            graphUI.yAxisRangePercentLimit = 5;
            break;
        case (0, $ifhNi.MEASUREMENTS).LOSS:
            graphUI.label = 'Loss';
            graphUI.color = 'lightsteelblue';
            graphUI.colorSecondary = 'lightslategrey';
            graphUI.colorAlpha = greyAlpha;
            graphUI.decimals = 2;
            graphUI.yAxisLabel = 'Dollars';
            graphUI.unit = '$';
            graphUI.displayTotal = true;
            break;
        case (0, $ifhNi.MEASUREMENTS).DOOR_OPEN_TIME:
            graphUI.label = 'Door Open Time';
            graphUI.color = 'royalblue';
            graphUI.yAxisMax = 100;
            graphUI.yAxisLabel = 'Time', graphUI.unit = interval === (0, $ifhNi.INTERVALS).HOURLY ? 'min' : 'hour';
            break;
        case (0, $ifhNi.MEASUREMENTS).DOOR_OPEN_COUNT:
            graphUI.label = 'Doors Open';
            graphUI.color = '#4a90e2';
            graphUI.colorSecondary = 'cornflowerblue', graphUI.yAxisLabel = 'Number';
            graphUI.unit = '';
            graphUI.displayTotal = true;
            break;
    }
    return graphUI;
}

});
parcelRegister("kKwbp", function(module, exports) {
module.exports = JSON.parse("{\"models\":{\"CHD10-1042A\":{\"penalty\":0,\"totalHorsePower\":0.5},\"CHD10-1042E\":{\"penalty\":0,\"totalHorsePower\":0.5},\"ARD12-2060S\":{\"penalty\":0,\"totalHorsePower\":1},\"IBC20-1144W\":{\"penalty\":0,\"totalHorsePower\":15},\"ARD12-2060W\":{\"penalty\":0,\"totalHorsePower\":1},\"SLC07-1072A\":{\"penalty\":0,\"totalHorsePower\":0.2},\"IBC20-1144S\":{\"penalty\":0,\"totalHorsePower\":15},\"HLC12-1060A\":{\"penalty\":-0.15,\"totalHorsePower\":0.5},\"FLY16-2100A\":{\"penalty\":0,\"totalHorsePower\":4},\"HLC16-1108A\":{\"penalty\":0,\"totalHorsePower\":5},\"AED08-1042E\":{\"penalty\":0,\"totalHorsePower\":0.5},\"ARD12-2060A\":{\"penalty\":0,\"totalHorsePower\":1},\"AED08-1042A\":{\"penalty\":0,\"totalHorsePower\":0.5},\"IBC20-1144A\":{\"penalty\":0,\"totalHorsePower\":15},\"ARD12-2060E\":{\"penalty\":0,\"totalHorsePower\":1},\"IBC20-1192A\":{\"penalty\":0,\"totalHorsePower\":15},\"IDC14-4180E\":{\"penalty\":-0.1,\"totalHorsePower\":4},\"IBC20-1192G\":{\"penalty\":0,\"totalHorsePower\":15},\"HLC12-1060W\":{\"penalty\":-0.15,\"totalHorsePower\":0.5},\"HLC12-5192A\":{\"penalty\":0,\"totalHorsePower\":2.5},\"IBC20-1192D\":{\"penalty\":0,\"totalHorsePower\":15},\"IDC12-3120E\":{\"penalty\":0,\"totalHorsePower\":1.5},\"IDC14-2108E\":{\"penalty\":-0.125,\"totalHorsePower\":2},\"IDC12-3120G\":{\"penalty\":0,\"totalHorsePower\":1.5},\"IDC14-2108G\":{\"penalty\":-0.125,\"totalHorsePower\":2},\"IDC12-3120A\":{\"penalty\":0,\"totalHorsePower\":1.5},\"IDC14-2108A\":{\"penalty\":-0.125,\"totalHorsePower\":2},\"HLC12-5192W\":{\"penalty\":0,\"totalHorsePower\":2.5},\"CHD10-3108A\":{\"penalty\":0,\"totalHorsePower\":1.5},\"HLC12-5192S\":{\"penalty\":0,\"totalHorsePower\":2.5},\"CHD10-3108E\":{\"penalty\":0,\"totalHorsePower\":1.5},\"IDC14-1060S\":{\"penalty\":-0.15,\"totalHorsePower\":1},\"IDC12-3120W\":{\"penalty\":0,\"totalHorsePower\":1.5},\"IDC14-2108W\":{\"penalty\":-0.125,\"totalHorsePower\":2},\"IDC12-3120S\":{\"penalty\":0,\"totalHorsePower\":1.5},\"IDC14-2108S\":{\"penalty\":-0.125,\"totalHorsePower\":2},\"CHD10-2096A\":{\"penalty\":-0.1,\"totalHorsePower\":1},\"HLC16-1120S\":{\"penalty\":0,\"totalHorsePower\":7.5},\"CHD10-2096E\":{\"penalty\":-0.1,\"totalHorsePower\":1},\"HLC16-1120W\":{\"penalty\":0,\"totalHorsePower\":7.5},\"IBC16-1168A\":{\"penalty\":0,\"totalHorsePower\":7.5},\"HLC14-2108S\":{\"penalty\":-0.125,\"totalHorsePower\":2},\"IDC14-4192W\":{\"penalty\":-0.1,\"totalHorsePower\":4},\"HLC14-2108W\":{\"penalty\":-0.125,\"totalHorsePower\":2},\"IDC14-1060W\":{\"penalty\":-0.15,\"totalHorsePower\":1},\"IBC16-1144G\":{\"penalty\":0,\"totalHorsePower\":7.5},\"IDC14-5180S\":{\"penalty\":0,\"totalHorsePower\":5},\"HLC16-1120A\":{\"penalty\":0,\"totalHorsePower\":7.5},\"IDC12-5180A\":{\"penalty\":0,\"totalHorsePower\":2.5},\"IBC16-1144A\":{\"penalty\":0,\"totalHorsePower\":7.5},\"HLC14-2108A\":{\"penalty\":-0.125,\"totalHorsePower\":2},\"SLC07-1048A\":{\"penalty\":0,\"totalHorsePower\":0.2},\"IDC14-4180G\":{\"penalty\":-0.1,\"totalHorsePower\":4},\"AHD10-2060W\":{\"penalty\":0,\"totalHorsePower\":1},\"IDC14-3144S\":{\"penalty\":-0.1,\"totalHorsePower\":3},\"AHD10-2060S\":{\"penalty\":0,\"totalHorsePower\":1},\"IDC14-3144W\":{\"penalty\":-0.1,\"totalHorsePower\":3},\"IDC12-2072G\":{\"penalty\":0,\"totalHorsePower\":1},\"IDC14-3132E\":{\"penalty\":0,\"totalHorsePower\":3},\"ARC16-2072S\":{\"penalty\":0,\"totalHorsePower\":2},\"ARD12-1042W\":{\"penalty\":0,\"totalHorsePower\":0.5},\"ARC16-2072W\":{\"penalty\":0,\"totalHorsePower\":2},\"ARD12-1042S\":{\"penalty\":0,\"totalHorsePower\":0.5},\"IDC12-1060E\":{\"penalty\":-0.15,\"totalHorsePower\":0.5},\"IDC14-3144A\":{\"penalty\":-0.1,\"totalHorsePower\":3},\"AHD10-2060E\":{\"penalty\":0,\"totalHorsePower\":1},\"IDC14-3144E\":{\"penalty\":-0.1,\"totalHorsePower\":3},\"IDC14-3144G\":{\"penalty\":-0.1,\"totalHorsePower\":3},\"AHD10-2060A\":{\"penalty\":0,\"totalHorsePower\":1},\"ARD12-1042E\":{\"penalty\":0,\"totalHorsePower\":0.5},\"ARC16-2072A\":{\"penalty\":0,\"totalHorsePower\":2},\"ARD12-1042A\":{\"penalty\":0,\"totalHorsePower\":0.5},\"ARC16-2072E\":{\"penalty\":0,\"totalHorsePower\":2},\"CLC08-2108E\":{\"penalty\":0,\"totalHorsePower\":0.4},\"IBC16-1060S\":{\"penalty\":0,\"totalHorsePower\":3},\"IDC12-1060S\":{\"penalty\":-0.15,\"totalHorsePower\":0.5},\"CLC08-2108A\":{\"penalty\":0,\"totalHorsePower\":0.4},\"IBC16-1060W\":{\"penalty\":0,\"totalHorsePower\":3},\"IDC12-1060W\":{\"penalty\":-0.15,\"totalHorsePower\":0.5},\"CLC08-1060W\":{\"penalty\":0,\"totalHorsePower\":0.2},\"IDC14-2072S\":{\"penalty\":0,\"totalHorsePower\":2},\"CLC08-1060S\":{\"penalty\":0,\"totalHorsePower\":0.2},\"IDC14-2072W\":{\"penalty\":0,\"totalHorsePower\":2},\"IBC20-1144D\":{\"penalty\":0,\"totalHorsePower\":15},\"CLC08-2108W\":{\"penalty\":0,\"totalHorsePower\":0.4},\"IBC16-1060A\":{\"penalty\":0,\"totalHorsePower\":3},\"IBC16-1060G\":{\"penalty\":0,\"totalHorsePower\":3},\"CLC08-2108S\":{\"penalty\":0,\"totalHorsePower\":0.4},\"IDC12-1060G\":{\"penalty\":-0.15,\"totalHorsePower\":0.5},\"CLC08-1060E\":{\"penalty\":0,\"totalHorsePower\":0.2},\"IDC14-2072A\":{\"penalty\":0,\"totalHorsePower\":2},\"IDC14-2072G\":{\"penalty\":0,\"totalHorsePower\":2},\"CLC08-1060A\":{\"penalty\":0,\"totalHorsePower\":0.2},\"IDC12-2078W\":{\"penalty\":0,\"totalHorsePower\":1},\"ARD12-3108S\":{\"penalty\":0,\"totalHorsePower\":1.5},\"IBC20-1144G\":{\"penalty\":0,\"totalHorsePower\":15},\"IDC14-3132G\":{\"penalty\":0,\"totalHorsePower\":3},\"ARD12-3108W\":{\"penalty\":0,\"totalHorsePower\":1.5},\"IDC20-1132D\":{\"penalty\":0,\"totalHorsePower\":10},\"HLC20-1120W\":{\"penalty\":0,\"totalHorsePower\":10},\"HLC20-1072A\":{\"penalty\":0,\"totalHorsePower\":5},\"HLC20-1120S\":{\"penalty\":0,\"totalHorsePower\":10},\"IBC16-1192W\":{\"penalty\":0,\"totalHorsePower\":10},\"ARD12-3108A\":{\"penalty\":0,\"totalHorsePower\":1.5},\"ARD12-3108E\":{\"penalty\":0,\"totalHorsePower\":1.5},\"HLC20-1072W\":{\"penalty\":0,\"totalHorsePower\":5},\"IDC14-1060E\":{\"penalty\":-0.15,\"totalHorsePower\":1},\"HLC20-1120A\":{\"penalty\":0,\"totalHorsePower\":10},\"HLC20-1072S\":{\"penalty\":0,\"totalHorsePower\":5},\"IDC12-3144W\":{\"penalty\":-0.1,\"totalHorsePower\":1.5},\"CLC08-1030A\":{\"penalty\":0,\"totalHorsePower\":0.2},\"IDC12-3144S\":{\"penalty\":-0.1,\"totalHorsePower\":1.5},\"AHD10-1042A\":{\"penalty\":0,\"totalHorsePower\":0.5},\"HLC12-2072A\":{\"penalty\":0,\"totalHorsePower\":1},\"IDC20-1168A\":{\"penalty\":0,\"totalHorsePower\":15},\"IDC12-3144G\":{\"penalty\":-0.1,\"totalHorsePower\":1.5},\"IDC12-3144E\":{\"penalty\":-0.1,\"totalHorsePower\":1.5},\"IDC12-3144A\":{\"penalty\":-0.1,\"totalHorsePower\":1.5},\"IDC20-1144E\":{\"penalty\":0,\"totalHorsePower\":15},\"AHD10-1042S\":{\"penalty\":0,\"totalHorsePower\":0.5},\"IDC16-1156E\":{\"penalty\":0,\"totalHorsePower\":7.5},\"AHD10-1042W\":{\"penalty\":0,\"totalHorsePower\":0.5},\"IBC16-1180W\":{\"penalty\":0,\"totalHorsePower\":7.5},\"IBC16-1180S\":{\"penalty\":0,\"totalHorsePower\":7.5},\"IDC14-1036S\":{\"penalty\":0,\"totalHorsePower\":1},\"CLC08-2084W\":{\"penalty\":0,\"totalHorsePower\":0.4},\"CLC08-2084S\":{\"penalty\":0,\"totalHorsePower\":0.4},\"IBC16-1180G\":{\"penalty\":0,\"totalHorsePower\":7.5},\"IBC16-1180D\":{\"penalty\":0,\"totalHorsePower\":7.5},\"IBC16-1180A\":{\"penalty\":0,\"totalHorsePower\":7.5},\"IDC14-4144W\":{\"penalty\":0,\"totalHorsePower\":4},\"CLC08-2084E\":{\"penalty\":0,\"totalHorsePower\":0.4},\"IBC16-1168G\":{\"penalty\":0,\"totalHorsePower\":7.5},\"IDC20-1144D\":{\"penalty\":0,\"totalHorsePower\":15},\"CLC08-2084A\":{\"penalty\":0,\"totalHorsePower\":0.4},\"IBC16-1144S\":{\"penalty\":0,\"totalHorsePower\":7.5},\"IBC20-1132S\":{\"penalty\":0,\"totalHorsePower\":10},\"IBC20-1132W\":{\"penalty\":0,\"totalHorsePower\":10},\"IDC12-1042A\":{\"penalty\":0,\"totalHorsePower\":0.5},\"IDC12-1042E\":{\"penalty\":0,\"totalHorsePower\":0.5},\"IDC12-1042G\":{\"penalty\":0,\"totalHorsePower\":0.5},\"IBC20-1132A\":{\"penalty\":0,\"totalHorsePower\":10},\"IDC14-4180A\":{\"penalty\":-0.1,\"totalHorsePower\":4},\"IDC14-3132S\":{\"penalty\":0,\"totalHorsePower\":3},\"IBC20-1132D\":{\"penalty\":0,\"totalHorsePower\":10},\"IBC20-1132G\":{\"penalty\":0,\"totalHorsePower\":10},\"IDC12-1042S\":{\"penalty\":0,\"totalHorsePower\":0.5},\"SHD07-1048A\":{\"penalty\":0,\"totalHorsePower\":0.75},\"IDC20-1168S\":{\"penalty\":0,\"totalHorsePower\":15},\"IDC12-1042W\":{\"penalty\":0,\"totalHorsePower\":0.5},\"IBC20-1192S\":{\"penalty\":0,\"totalHorsePower\":15},\"IDC16-1096S\":{\"penalty\":0,\"totalHorsePower\":5},\"IDC20-1168W\":{\"penalty\":0,\"totalHorsePower\":15},\"IDC14-1048E\":{\"penalty\":0,\"totalHorsePower\":1},\"IBC16-1192S\":{\"penalty\":0,\"totalHorsePower\":10},\"HLC12-3144A\":{\"penalty\":-0.1,\"totalHorsePower\":1.5},\"IDC16-1096A\":{\"penalty\":0,\"totalHorsePower\":5},\"IDC14-2084S\":{\"penalty\":0,\"totalHorsePower\":2},\"IDC16-1096E\":{\"penalty\":0,\"totalHorsePower\":5},\"IDC16-1096D\":{\"penalty\":0,\"totalHorsePower\":5},\"IDC16-1096G\":{\"penalty\":0,\"totalHorsePower\":5},\"HLC12-3144S\":{\"penalty\":-0.1,\"totalHorsePower\":1.5},\"IDC12-5192A\":{\"penalty\":0,\"totalHorsePower\":2.5},\"HLC12-3144W\":{\"penalty\":-0.1,\"totalHorsePower\":1.5},\"IDC16-1144W\":{\"penalty\":0,\"totalHorsePower\":7.5},\"CHD10-2084E\":{\"penalty\":0,\"totalHorsePower\":1},\"HLC14-2096A\":{\"penalty\":-0.1,\"totalHorsePower\":2},\"IDC14-3120A\":{\"penalty\":0,\"totalHorsePower\":3},\"CHD10-2084A\":{\"penalty\":0,\"totalHorsePower\":1},\"IDC14-2084W\":{\"penalty\":0,\"totalHorsePower\":2},\"HLC14-3096S\":{\"penalty\":0,\"totalHorsePower\":3},\"HLC14-3096W\":{\"penalty\":0,\"totalHorsePower\":3},\"IBC16-1156D\":{\"penalty\":0,\"totalHorsePower\":7.5},\"IDC16-1144D\":{\"penalty\":0,\"totalHorsePower\":7.5},\"HLC14-2096W\":{\"penalty\":-0.1,\"totalHorsePower\":2},\"IBC16-1156G\":{\"penalty\":0,\"totalHorsePower\":7.5},\"IDC16-1144A\":{\"penalty\":0,\"totalHorsePower\":7.5},\"IBC16-1156A\":{\"penalty\":0,\"totalHorsePower\":7.5},\"HLC14-2096S\":{\"penalty\":-0.1,\"totalHorsePower\":2},\"HLC14-3096A\":{\"penalty\":0,\"totalHorsePower\":3},\"IDC20-1120E\":{\"penalty\":0,\"totalHorsePower\":10},\"IDC12-4192W\":{\"penalty\":0,\"totalHorsePower\":2},\"IDC14-1048G\":{\"penalty\":0,\"totalHorsePower\":1},\"IDC14-4168S\":{\"penalty\":0,\"totalHorsePower\":4},\"IDC12-4192S\":{\"penalty\":-0.1,\"totalHorsePower\":2},\"HLC20-1144A\":{\"penalty\":0,\"totalHorsePower\":15},\"IDC14-3132A\":{\"penalty\":0,\"totalHorsePower\":3},\"HLC16-1072W\":{\"penalty\":0,\"totalHorsePower\":3},\"HLC14-4180A\":{\"penalty\":-0.1,\"totalHorsePower\":4},\"IDC20-1060D\":{\"penalty\":0,\"totalHorsePower\":5},\"HLC16-1072S\":{\"penalty\":0,\"totalHorsePower\":3},\"HLC20-1144W\":{\"penalty\":0,\"totalHorsePower\":15},\"IDC12-4192E\":{\"penalty\":-0.1,\"totalHorsePower\":2},\"HLC20-1144S\":{\"penalty\":0,\"totalHorsePower\":15},\"IDC12-4192A\":{\"penalty\":-0.1,\"totalHorsePower\":2},\"HLC14-4180S\":{\"penalty\":-0.1,\"totalHorsePower\":4},\"IDC14-4168W\":{\"penalty\":0,\"totalHorsePower\":4},\"HLC14-4180W\":{\"penalty\":-0.1,\"totalHorsePower\":4},\"HLC16-1072A\":{\"penalty\":0,\"totalHorsePower\":3},\"IBC16-1144W\":{\"penalty\":0,\"totalHorsePower\":7.5},\"HLC12-1042A\":{\"penalty\":0,\"totalHorsePower\":0.5},\"HLC20-1180A\":{\"penalty\":0,\"totalHorsePower\":15},\"HLC14-4144A\":{\"penalty\":0,\"totalHorsePower\":4},\"CLC08-1072W\":{\"penalty\":0,\"totalHorsePower\":0.2},\"CLC08-1072S\":{\"penalty\":0,\"totalHorsePower\":0.2},\"HLC20-1180W\":{\"penalty\":0,\"totalHorsePower\":15},\"IDC14-3108A\":{\"penalty\":0,\"totalHorsePower\":3},\"HLC12-1042W\":{\"penalty\":0,\"totalHorsePower\":0.5},\"HLC20-1180S\":{\"penalty\":0,\"totalHorsePower\":15},\"HLC12-1042S\":{\"penalty\":0,\"totalHorsePower\":0.5},\"CLC08-1072E\":{\"penalty\":0,\"totalHorsePower\":0.2},\"HLC14-4144S\":{\"penalty\":0,\"totalHorsePower\":4},\"FLY16-3120A\":{\"penalty\":0,\"totalHorsePower\":6},\"IDC14-3108G\":{\"penalty\":0,\"totalHorsePower\":3},\"SLC07-1042A\":{\"penalty\":0,\"totalHorsePower\":0.2},\"HLC14-4144W\":{\"penalty\":0,\"totalHorsePower\":4},\"CLC08-1072A\":{\"penalty\":0,\"totalHorsePower\":0.2},\"IBC30-1120D\":{\"penalty\":0,\"totalHorsePower\":20},\"IBC30-1108A\":{\"penalty\":0,\"totalHorsePower\":15},\"HLC20-1060A\":{\"penalty\":0,\"totalHorsePower\":5},\"IBC30-1108D\":{\"penalty\":0,\"totalHorsePower\":15},\"IBC16-1132W\":{\"penalty\":0,\"totalHorsePower\":7.5},\"FLY16-2088A\":{\"penalty\":0,\"totalHorsePower\":4},\"HLC14-2072A\":{\"penalty\":0,\"totalHorsePower\":2},\"IBC30-1108S\":{\"penalty\":0,\"totalHorsePower\":15},\"HLC20-1060S\":{\"penalty\":0,\"totalHorsePower\":5},\"SHD07-3108A\":{\"penalty\":0,\"totalHorsePower\":2.25},\"IDC20-2192S\":{\"penalty\":0,\"totalHorsePower\":15},\"IBC30-1108W\":{\"penalty\":0,\"totalHorsePower\":15},\"HLC20-1060W\":{\"penalty\":0,\"totalHorsePower\":5},\"HLC14-2072W\":{\"penalty\":0,\"totalHorsePower\":2},\"IBC16-1132G\":{\"penalty\":0,\"totalHorsePower\":7.5},\"IBC16-1132D\":{\"penalty\":0,\"totalHorsePower\":7.5},\"HLC14-2072S\":{\"penalty\":0,\"totalHorsePower\":2},\"IDC14-1036G\":{\"penalty\":0,\"totalHorsePower\":1},\"IDC14-2084A\":{\"penalty\":0,\"totalHorsePower\":2},\"IBC16-1132A\":{\"penalty\":0,\"totalHorsePower\":7.5},\"HLC12-2060A\":{\"penalty\":0,\"totalHorsePower\":1},\"ARD12-3132S\":{\"penalty\":0,\"totalHorsePower\":1.5},\"IDC12-2072W\":{\"penalty\":0,\"totalHorsePower\":1},\"HLC12-2060S\":{\"penalty\":0,\"totalHorsePower\":1},\"SLC07-2108A\":{\"penalty\":0,\"totalHorsePower\":0.4},\"HLC12-2060W\":{\"penalty\":0,\"totalHorsePower\":1},\"IDC14-1036E\":{\"penalty\":0,\"totalHorsePower\":1},\"IBC30-1156D\":{\"penalty\":0,\"totalHorsePower\":20},\"IDC16-2180E\":{\"penalty\":0,\"totalHorsePower\":8},\"AHD10-2084W\":{\"penalty\":0,\"totalHorsePower\":1},\"AHD10-2084S\":{\"penalty\":0,\"totalHorsePower\":1},\"IDC16-1144G\":{\"penalty\":0,\"totalHorsePower\":7.5},\"IBC16-1192D\":{\"penalty\":0,\"totalHorsePower\":10},\"AHD10-2084E\":{\"penalty\":0,\"totalHorsePower\":1},\"CHD10-1060E\":{\"penalty\":-0.15,\"totalHorsePower\":0.5},\"IBC16-1144D\":{\"penalty\":0,\"totalHorsePower\":7.5},\"AHD10-2084A\":{\"penalty\":0,\"totalHorsePower\":1},\"CHD10-1060A\":{\"penalty\":-0.15,\"totalHorsePower\":0.5},\"IDC14-4168E\":{\"penalty\":0,\"totalHorsePower\":4},\"IDC12-5180W\":{\"penalty\":0,\"totalHorsePower\":2.5},\"IDC14-2084G\":{\"penalty\":0,\"totalHorsePower\":2},\"IBC20-1120W\":{\"penalty\":0,\"totalHorsePower\":10},\"IBC20-1120S\":{\"penalty\":0,\"totalHorsePower\":10},\"ARC16-4144W\":{\"penalty\":0,\"totalHorsePower\":4},\"ARD12-4144W\":{\"penalty\":0,\"totalHorsePower\":2},\"ARD12-2120W\":{\"penalty\":-0.15,\"totalHorsePower\":1},\"ARD12-4144S\":{\"penalty\":0,\"totalHorsePower\":2},\"IBC16-1132S\":{\"penalty\":0,\"totalHorsePower\":7.5},\"IBC20-1120G\":{\"penalty\":0,\"totalHorsePower\":10},\"IBC20-1120D\":{\"penalty\":0,\"totalHorsePower\":10},\"IDC16-1132W\":{\"penalty\":0,\"totalHorsePower\":7.5},\"IBC20-1120A\":{\"penalty\":0,\"totalHorsePower\":10},\"ARD12-4144E\":{\"penalty\":0,\"totalHorsePower\":2},\"ARC16-4144E\":{\"penalty\":0,\"totalHorsePower\":4},\"ARD12-4144A\":{\"penalty\":0,\"totalHorsePower\":2},\"IDC14-1036W\":{\"penalty\":0,\"totalHorsePower\":1},\"ARC16-4144A\":{\"penalty\":0,\"totalHorsePower\":4},\"IDC16-1084W\":{\"penalty\":0,\"totalHorsePower\":3},\"ALC08-2084S\":{\"penalty\":0,\"totalHorsePower\":0.4},\"IDC14-1060G\":{\"penalty\":-0.15,\"totalHorsePower\":1},\"ALC08-2084W\":{\"penalty\":0,\"totalHorsePower\":0.4},\"IDC12-3132W\":{\"penalty\":0,\"totalHorsePower\":1.5},\"IBC20-1180W\":{\"penalty\":0,\"totalHorsePower\":15},\"IDC14-4192G\":{\"penalty\":-0.1,\"totalHorsePower\":4},\"IDC12-3132S\":{\"penalty\":0,\"totalHorsePower\":1.5},\"IBC20-1180S\":{\"penalty\":0,\"totalHorsePower\":15},\"ALC08-2084A\":{\"penalty\":0,\"totalHorsePower\":0.4},\"IDC16-1084D\":{\"penalty\":0,\"totalHorsePower\":3},\"IDC16-1084E\":{\"penalty\":0,\"totalHorsePower\":3},\"ALC08-2084E\":{\"penalty\":0,\"totalHorsePower\":0.4},\"IDC16-1084A\":{\"penalty\":0,\"totalHorsePower\":3},\"IBC20-1180D\":{\"penalty\":0,\"totalHorsePower\":15},\"IDC12-3132G\":{\"penalty\":0,\"totalHorsePower\":1.5},\"IBC20-1180G\":{\"penalty\":0,\"totalHorsePower\":15},\"IBC20-1180A\":{\"penalty\":0,\"totalHorsePower\":15},\"IDC16-1084S\":{\"penalty\":0,\"totalHorsePower\":3},\"IDC12-3132A\":{\"penalty\":0,\"totalHorsePower\":1.5},\"ARD12-2096W\":{\"penalty\":-0.1,\"totalHorsePower\":1},\"HLC14-1036W\":{\"penalty\":0,\"totalHorsePower\":1},\"IDC14-4192A\":{\"penalty\":-0.1,\"totalHorsePower\":4},\"HLC14-2084S\":{\"penalty\":0,\"totalHorsePower\":2},\"HLC12-2120W\":{\"penalty\":-0.15,\"totalHorsePower\":1},\"HLC14-2084W\":{\"penalty\":0,\"totalHorsePower\":2},\"HLC12-2120S\":{\"penalty\":-0.15,\"totalHorsePower\":1},\"IDC14-1036A\":{\"penalty\":0,\"totalHorsePower\":1},\"SLC07-1060A\":{\"penalty\":0,\"totalHorsePower\":0.2},\"ARC16-3120W\":{\"penalty\":0,\"totalHorsePower\":3},\"HLC14-2084A\":{\"penalty\":0,\"totalHorsePower\":2},\"HLC12-2120A\":{\"penalty\":-0.15,\"totalHorsePower\":1},\"SHD07-1042A\":{\"penalty\":0,\"totalHorsePower\":0.75},\"IDC12-2072E\":{\"penalty\":0,\"totalHorsePower\":1},\"IDC16-1132D\":{\"penalty\":0,\"totalHorsePower\":7.5},\"HLC20-1156A\":{\"penalty\":0,\"totalHorsePower\":15},\"IDC20-1096A\":{\"penalty\":0,\"totalHorsePower\":7.5},\"IDC16-1132E\":{\"penalty\":0,\"totalHorsePower\":7.5},\"HLC14-4192A\":{\"penalty\":-0.1,\"totalHorsePower\":4},\"HLC16-2180A\":{\"penalty\":0,\"totalHorsePower\":8},\"IDC14-2078S\":{\"penalty\":0,\"totalHorsePower\":2},\"IDC14-2078W\":{\"penalty\":0,\"totalHorsePower\":2},\"IDC12-5180S\":{\"penalty\":0,\"totalHorsePower\":2.5},\"HLC14-1060A\":{\"penalty\":-0.15,\"totalHorsePower\":1},\"HLC20-1156W\":{\"penalty\":0,\"totalHorsePower\":15},\"HLC20-1156S\":{\"penalty\":0,\"totalHorsePower\":15},\"HLC16-2180S\":{\"penalty\":0,\"totalHorsePower\":8},\"IDC14-2078A\":{\"penalty\":0,\"totalHorsePower\":2},\"HLC14-4192S\":{\"penalty\":-0.1,\"totalHorsePower\":4},\"HLC16-2180W\":{\"penalty\":0,\"totalHorsePower\":8},\"IDC14-2078E\":{\"penalty\":0,\"totalHorsePower\":2},\"HLC14-4192W\":{\"penalty\":-0.1,\"totalHorsePower\":4},\"SHD07-2060A\":{\"penalty\":0,\"totalHorsePower\":1.5},\"IDC20-2192A\":{\"penalty\":0,\"totalHorsePower\":15},\"HLC14-4156A\":{\"penalty\":0,\"totalHorsePower\":4},\"HLC20-1084S\":{\"penalty\":0,\"totalHorsePower\":5},\"HLC14-4156S\":{\"penalty\":0,\"totalHorsePower\":4},\"HLC14-4156W\":{\"penalty\":0,\"totalHorsePower\":4},\"FLY16-2076A\":{\"penalty\":0,\"totalHorsePower\":4},\"ARC16-2120W\":{\"penalty\":-0.15,\"totalHorsePower\":2},\"ARC16-2120S\":{\"penalty\":-0.15,\"totalHorsePower\":2},\"IBC30-1120A\":{\"penalty\":0,\"totalHorsePower\":20},\"CHD10-2072A\":{\"penalty\":0,\"totalHorsePower\":1},\"ALC08-1036A\":{\"penalty\":0,\"totalHorsePower\":0.2},\"ARD12-2096E\":{\"penalty\":-0.1,\"totalHorsePower\":1},\"CHD10-2072E\":{\"penalty\":0,\"totalHorsePower\":1},\"ALC08-1036E\":{\"penalty\":0,\"totalHorsePower\":0.2},\"ARC16-2120E\":{\"penalty\":-0.15,\"totalHorsePower\":2},\"ARC16-2120A\":{\"penalty\":-0.15,\"totalHorsePower\":2},\"ALC08-1036S\":{\"penalty\":0,\"totalHorsePower\":0.2},\"IBC30-1120S\":{\"penalty\":0,\"totalHorsePower\":20},\"ALC08-1036W\":{\"penalty\":0,\"totalHorsePower\":0.2},\"IBC30-1120W\":{\"penalty\":0,\"totalHorsePower\":20},\"IDC12-2078S\":{\"penalty\":0,\"totalHorsePower\":1},\"ARC16-3120E\":{\"penalty\":0,\"totalHorsePower\":3},\"ALC08-2096E\":{\"penalty\":0,\"totalHorsePower\":0.4},\"CLC08-1030E\":{\"penalty\":0,\"totalHorsePower\":0.2},\"ALC08-2096A\":{\"penalty\":0,\"totalHorsePower\":0.4},\"IDC14-3108E\":{\"penalty\":0,\"totalHorsePower\":3},\"IDC12-2078A\":{\"penalty\":0,\"totalHorsePower\":1},\"IDC12-2078G\":{\"penalty\":0,\"totalHorsePower\":1},\"IDC12-2078E\":{\"penalty\":0,\"totalHorsePower\":1},\"ALC08-2096W\":{\"penalty\":0,\"totalHorsePower\":0.4},\"ALC08-2096S\":{\"penalty\":0,\"totalHorsePower\":0.4},\"IBC30-1168W\":{\"penalty\":0,\"totalHorsePower\":25},\"IBC30-1168S\":{\"penalty\":0,\"totalHorsePower\":25},\"HLC20-1084A\":{\"penalty\":0,\"totalHorsePower\":5},\"HLC12-5180W\":{\"penalty\":0,\"totalHorsePower\":2.5},\"HLC14-3108A\":{\"penalty\":0,\"totalHorsePower\":3},\"IBC30-1168D\":{\"penalty\":0,\"totalHorsePower\":25},\"IBC30-1168A\":{\"penalty\":0,\"totalHorsePower\":25},\"AHD10-3120E\":{\"penalty\":0,\"totalHorsePower\":1.5},\"CHD10-1048E\":{\"penalty\":0,\"totalHorsePower\":0.5},\"HLC14-3108W\":{\"penalty\":0,\"totalHorsePower\":3},\"CHD10-1048A\":{\"penalty\":0,\"totalHorsePower\":0.5},\"HLC14-3108S\":{\"penalty\":0,\"totalHorsePower\":3},\"IDC12-4180A\":{\"penalty\":-0.1,\"totalHorsePower\":2},\"IDC12-4180E\":{\"penalty\":-0.1,\"totalHorsePower\":2},\"IDC12-4180G\":{\"penalty\":-0.1,\"totalHorsePower\":2},\"IDC14-5192G\":{\"penalty\":0,\"totalHorsePower\":5},\"SHD07-2096A\":{\"penalty\":0,\"totalHorsePower\":1.5},\"HLC16-1084A\":{\"penalty\":0,\"totalHorsePower\":3},\"ALC08-1030A\":{\"penalty\":0,\"totalHorsePower\":0.2},\"IDC12-4180S\":{\"penalty\":-0.1,\"totalHorsePower\":2},\"IDC12-4180W\":{\"penalty\":-0.1,\"totalHorsePower\":2},\"HLC16-1084W\":{\"penalty\":0,\"totalHorsePower\":3},\"HLC12-4144A\":{\"penalty\":0,\"totalHorsePower\":2},\"HLC16-1084S\":{\"penalty\":0,\"totalHorsePower\":3},\"FLY16-2120A\":{\"penalty\":0,\"totalHorsePower\":4},\"IDC14-2120S\":{\"penalty\":-0.15,\"totalHorsePower\":2},\"ARC16-1036E\":{\"penalty\":0,\"totalHorsePower\":1},\"IDC14-4156S\":{\"penalty\":0,\"totalHorsePower\":4},\"ARC16-1036A\":{\"penalty\":0,\"totalHorsePower\":1},\"IDC14-4156W\":{\"penalty\":0,\"totalHorsePower\":4},\"IDC14-4156A\":{\"penalty\":0,\"totalHorsePower\":4},\"ARC16-1036W\":{\"penalty\":0,\"totalHorsePower\":1},\"IDC14-4156E\":{\"penalty\":0,\"totalHorsePower\":4},\"ARC16-1036S\":{\"penalty\":0,\"totalHorsePower\":1},\"IBC16-1108W\":{\"penalty\":0,\"totalHorsePower\":5},\"IDC12-2060S\":{\"penalty\":0,\"totalHorsePower\":1},\"IBC16-1108S\":{\"penalty\":0,\"totalHorsePower\":5},\"HLC20-1132A\":{\"penalty\":0,\"totalHorsePower\":10},\"IBC16-1108G\":{\"penalty\":0,\"totalHorsePower\":5},\"HLC14-1036S\":{\"penalty\":0,\"totalHorsePower\":1},\"IBC20-1084W\":{\"penalty\":0,\"totalHorsePower\":5},\"IBC16-1108A\":{\"penalty\":0,\"totalHorsePower\":5},\"IDC12-3132E\":{\"penalty\":0,\"totalHorsePower\":1.5},\"HLC20-1132W\":{\"penalty\":0,\"totalHorsePower\":10},\"HLC20-1132S\":{\"penalty\":0,\"totalHorsePower\":10},\"AHD10-3120W\":{\"penalty\":0,\"totalHorsePower\":1.5},\"IDC12-1060A\":{\"penalty\":-0.15,\"totalHorsePower\":0.5},\"HLC12-1048S\":{\"penalty\":0,\"totalHorsePower\":0.5},\"HLC16-2192A\":{\"penalty\":0,\"totalHorsePower\":10},\"IDC20-1084A\":{\"penalty\":0,\"totalHorsePower\":5},\"ARD12-3096A\":{\"penalty\":0,\"totalHorsePower\":1.5},\"HLC12-1048W\":{\"penalty\":0,\"totalHorsePower\":0.5},\"HLC12-4144W\":{\"penalty\":0,\"totalHorsePower\":2},\"ARD12-3096E\":{\"penalty\":0,\"totalHorsePower\":1.5},\"IDC14-4156G\":{\"penalty\":0,\"totalHorsePower\":4},\"IDC14-2060G\":{\"penalty\":0,\"totalHorsePower\":2},\"ARD12-3096S\":{\"penalty\":0,\"totalHorsePower\":1.5},\"HLC12-1048A\":{\"penalty\":0,\"totalHorsePower\":0.5},\"AHD10-3120S\":{\"penalty\":0,\"totalHorsePower\":1.5},\"ARD12-3096W\":{\"penalty\":0,\"totalHorsePower\":1.5},\"HLC16-2192W\":{\"penalty\":0,\"totalHorsePower\":10},\"SLC07-2084A\":{\"penalty\":0,\"totalHorsePower\":0.4},\"IDC12-1036W\":{\"penalty\":0,\"totalHorsePower\":0.5},\"HLC12-4144S\":{\"penalty\":0,\"totalHorsePower\":2},\"HLC12-2108A\":{\"penalty\":-0.125,\"totalHorsePower\":1},\"HLC14-3144W\":{\"penalty\":-0.1,\"totalHorsePower\":3},\"HLC14-4168A\":{\"penalty\":0,\"totalHorsePower\":4},\"HLC14-3144S\":{\"penalty\":-0.1,\"totalHorsePower\":3},\"HLC12-2108W\":{\"penalty\":-0.125,\"totalHorsePower\":1},\"IDC20-1120D\":{\"penalty\":0,\"totalHorsePower\":10},\"FLY16-3144A\":{\"penalty\":0,\"totalHorsePower\":6},\"HLC12-2108S\":{\"penalty\":-0.125,\"totalHorsePower\":1},\"IDC12-1036S\":{\"penalty\":0,\"totalHorsePower\":0.5},\"HLC14-4168W\":{\"penalty\":0,\"totalHorsePower\":4},\"HLC14-3144A\":{\"penalty\":-0.1,\"totalHorsePower\":3},\"HLC14-4168S\":{\"penalty\":0,\"totalHorsePower\":4},\"IDC12-4168A\":{\"penalty\":0,\"totalHorsePower\":2},\"IDC16-1156D\":{\"penalty\":0,\"totalHorsePower\":7.5},\"IDC16-2168W\":{\"penalty\":0,\"totalHorsePower\":8},\"IDC16-2168A\":{\"penalty\":0,\"totalHorsePower\":8},\"IBC16-1192G\":{\"penalty\":0,\"totalHorsePower\":10},\"IDC16-2168D\":{\"penalty\":0,\"totalHorsePower\":8},\"IDC16-2168E\":{\"penalty\":0,\"totalHorsePower\":8},\"IDC16-2168G\":{\"penalty\":0,\"totalHorsePower\":8},\"IDC14-2072E\":{\"penalty\":0,\"totalHorsePower\":2},\"HLC16-1132W\":{\"penalty\":0,\"totalHorsePower\":7.5},\"IBC16-1192A\":{\"penalty\":0,\"totalHorsePower\":10},\"IDC12-3108W\":{\"penalty\":0,\"totalHorsePower\":1.5},\"DTU03-2026A\":{\"penalty\":0,\"totalHorsePower\":0.16},\"IDC12-3108S\":{\"penalty\":0,\"totalHorsePower\":1.5},\"DTU03-2026E\":{\"penalty\":0,\"totalHorsePower\":0.16},\"IBC30-1144A\":{\"penalty\":0,\"totalHorsePower\":20},\"IDC12-3108G\":{\"penalty\":0,\"totalHorsePower\":1.5},\"IDC14-2120G\":{\"penalty\":-0.15,\"totalHorsePower\":2},\"IDC12-3108E\":{\"penalty\":0,\"totalHorsePower\":1.5},\"IDC14-2120E\":{\"penalty\":-0.15,\"totalHorsePower\":2},\"HLC16-1132S\":{\"penalty\":0,\"totalHorsePower\":7.5},\"IDC12-3108A\":{\"penalty\":0,\"totalHorsePower\":1.5},\"IDC14-2120A\":{\"penalty\":-0.15,\"totalHorsePower\":2},\"IBC30-1180S\":{\"penalty\":0,\"totalHorsePower\":25},\"IBC30-1180W\":{\"penalty\":0,\"totalHorsePower\":25},\"ARC16-2084S\":{\"penalty\":0,\"totalHorsePower\":2},\"HLC12-4180W\":{\"penalty\":-0.1,\"totalHorsePower\":2},\"ARC16-2084W\":{\"penalty\":0,\"totalHorsePower\":2},\"IDC12-1036E\":{\"penalty\":0,\"totalHorsePower\":0.5},\"HLC12-4180S\":{\"penalty\":-0.1,\"totalHorsePower\":2},\"IBC30-1180A\":{\"penalty\":0,\"totalHorsePower\":25},\"IBC16-1108D\":{\"penalty\":0,\"totalHorsePower\":5},\"IBC30-1180D\":{\"penalty\":0,\"totalHorsePower\":25},\"ARC16-2084A\":{\"penalty\":0,\"totalHorsePower\":2},\"CHD10-3120A\":{\"penalty\":0,\"totalHorsePower\":1.5},\"HLC12-4180A\":{\"penalty\":-0.1,\"totalHorsePower\":2},\"ARC16-2084E\":{\"penalty\":0,\"totalHorsePower\":2},\"CHD10-3120E\":{\"penalty\":0,\"totalHorsePower\":1.5},\"SHD07-2084A\":{\"penalty\":0,\"totalHorsePower\":1.5},\"IDC20-2192E\":{\"penalty\":0,\"totalHorsePower\":15},\"IDC16-1072D\":{\"penalty\":0,\"totalHorsePower\":3},\"HLC14-2078S\":{\"penalty\":0,\"totalHorsePower\":2},\"IDC16-1072W\":{\"penalty\":0,\"totalHorsePower\":3},\"HLC16-1096A\":{\"penalty\":0,\"totalHorsePower\":5},\"HLC14-2078W\":{\"penalty\":0,\"totalHorsePower\":2},\"IDC16-1060W\":{\"penalty\":0,\"totalHorsePower\":3},\"HLC14-2078A\":{\"penalty\":0,\"totalHorsePower\":2},\"IDC16-1072A\":{\"penalty\":0,\"totalHorsePower\":3},\"HLC16-1096W\":{\"penalty\":0,\"totalHorsePower\":5},\"IDC16-1072G\":{\"penalty\":0,\"totalHorsePower\":3},\"IDC16-1072E\":{\"penalty\":0,\"totalHorsePower\":3},\"HLC16-1096S\":{\"penalty\":0,\"totalHorsePower\":5},\"ARC16-1048S\":{\"penalty\":0,\"totalHorsePower\":1},\"IDC14-3108W\":{\"penalty\":0,\"totalHorsePower\":3},\"ARC16-1048W\":{\"penalty\":0,\"totalHorsePower\":1},\"HLC16-1132A\":{\"penalty\":0,\"totalHorsePower\":7.5},\"IDC14-4144S\":{\"penalty\":0,\"totalHorsePower\":4},\"IDC14-4168G\":{\"penalty\":0,\"totalHorsePower\":4},\"IDC14-1060A\":{\"penalty\":-0.15,\"totalHorsePower\":1},\"ARC16-1048A\":{\"penalty\":0,\"totalHorsePower\":1},\"ARC16-1048E\":{\"penalty\":0,\"totalHorsePower\":1},\"IDC14-4144G\":{\"penalty\":0,\"totalHorsePower\":4},\"IDC14-4144E\":{\"penalty\":0,\"totalHorsePower\":4},\"HLC14-5192S\":{\"penalty\":0,\"totalHorsePower\":5},\"IDC14-4144A\":{\"penalty\":0,\"totalHorsePower\":4},\"ALC08-1060S\":{\"penalty\":0,\"totalHorsePower\":0.2},\"ALC08-1060W\":{\"penalty\":0,\"totalHorsePower\":0.2},\"ARD12-3132W\":{\"penalty\":0,\"totalHorsePower\":1.5},\"CLC08-2120E\":{\"penalty\":0,\"totalHorsePower\":0.4},\"AHD10-1036E\":{\"penalty\":0,\"totalHorsePower\":0.5},\"FLY16-1051A\":{\"penalty\":0,\"totalHorsePower\":2},\"IDC12-2060A\":{\"penalty\":0,\"totalHorsePower\":1},\"CLC08-2120A\":{\"penalty\":0,\"totalHorsePower\":0.4},\"AHD10-1036A\":{\"penalty\":0,\"totalHorsePower\":0.5},\"ALC08-1060A\":{\"penalty\":0,\"totalHorsePower\":0.2},\"ALC08-1060E\":{\"penalty\":0,\"totalHorsePower\":0.2},\"CLC08-2120W\":{\"penalty\":0,\"totalHorsePower\":0.4},\"AHD10-1036W\":{\"penalty\":0,\"totalHorsePower\":0.5},\"ARD12-3132E\":{\"penalty\":0,\"totalHorsePower\":1.5},\"CLC08-2120S\":{\"penalty\":0,\"totalHorsePower\":0.4},\"AHD10-1036S\":{\"penalty\":0,\"totalHorsePower\":0.5},\"ARD12-3132A\":{\"penalty\":0,\"totalHorsePower\":1.5},\"ARC16-3120S\":{\"penalty\":0,\"totalHorsePower\":3},\"IDC16-1120G\":{\"penalty\":0,\"totalHorsePower\":7.5},\"IBC16-1168S\":{\"penalty\":0,\"totalHorsePower\":7.5},\"ALC08-1048W\":{\"penalty\":0,\"totalHorsePower\":0.2},\"ARD12-2096S\":{\"penalty\":-0.1,\"totalHorsePower\":1},\"IDC12-2060E\":{\"penalty\":0,\"totalHorsePower\":1},\"HLC20-1108A\":{\"penalty\":0,\"totalHorsePower\":7.5},\"IDC16-1060E\":{\"penalty\":0,\"totalHorsePower\":3},\"IBC20-1156S\":{\"penalty\":0,\"totalHorsePower\":15},\"ARD12-2084S\":{\"penalty\":0,\"totalHorsePower\":1},\"IBC20-1156W\":{\"penalty\":0,\"totalHorsePower\":15},\"ARD12-2084W\":{\"penalty\":0,\"totalHorsePower\":1},\"HLC20-1108W\":{\"penalty\":0,\"totalHorsePower\":7.5},\"ARC16-3120A\":{\"penalty\":0,\"totalHorsePower\":3},\"IDC16-1120D\":{\"penalty\":0,\"totalHorsePower\":7.5},\"HLC20-1108S\":{\"penalty\":0,\"totalHorsePower\":7.5},\"IBC16-1168D\":{\"penalty\":0,\"totalHorsePower\":7.5},\"ARD12-2096A\":{\"penalty\":-0.1,\"totalHorsePower\":1},\"ARD12-2084A\":{\"penalty\":0,\"totalHorsePower\":1},\"IBC20-1156A\":{\"penalty\":0,\"totalHorsePower\":15},\"IBC20-1156G\":{\"penalty\":0,\"totalHorsePower\":15},\"ARD12-2084E\":{\"penalty\":0,\"totalHorsePower\":1},\"IBC20-1156D\":{\"penalty\":0,\"totalHorsePower\":15},\"HLC14-1048A\":{\"penalty\":0,\"totalHorsePower\":1},\"HLC14-3132S\":{\"penalty\":0,\"totalHorsePower\":3},\"IBC20-1108G\":{\"penalty\":0,\"totalHorsePower\":7.5},\"IDC14-3120W\":{\"penalty\":0,\"totalHorsePower\":3},\"HLC14-3132W\":{\"penalty\":0,\"totalHorsePower\":3},\"IDC20-1096S\":{\"penalty\":0,\"totalHorsePower\":7.5},\"IDC20-1120G\":{\"penalty\":0,\"totalHorsePower\":10},\"HLC16-2168A\":{\"penalty\":0,\"totalHorsePower\":8},\"HLC14-1060W\":{\"penalty\":-0.15,\"totalHorsePower\":1},\"HLC14-3132A\":{\"penalty\":0,\"totalHorsePower\":3},\"HLC14-1048S\":{\"penalty\":0,\"totalHorsePower\":1},\"IDC14-3120G\":{\"penalty\":0,\"totalHorsePower\":3},\"HLC14-1048W\":{\"penalty\":0,\"totalHorsePower\":1},\"IDC20-1132S\":{\"penalty\":0,\"totalHorsePower\":10},\"HLC16-2168W\":{\"penalty\":0,\"totalHorsePower\":8},\"HLC16-2168S\":{\"penalty\":0,\"totalHorsePower\":8},\"CHD10-2060E\":{\"penalty\":0,\"totalHorsePower\":1},\"CHD10-2120E\":{\"penalty\":-0.15,\"totalHorsePower\":1},\"CHD10-2060A\":{\"penalty\":0,\"totalHorsePower\":1},\"CHD10-2120A\":{\"penalty\":-0.15,\"totalHorsePower\":1},\"IBC30-1144D\":{\"penalty\":0,\"totalHorsePower\":20},\"IBC30-1132S\":{\"penalty\":0,\"totalHorsePower\":20},\"IBC30-1132W\":{\"penalty\":0,\"totalHorsePower\":20},\"IBC30-1144S\":{\"penalty\":0,\"totalHorsePower\":20},\"IBC20-1084S\":{\"penalty\":0,\"totalHorsePower\":5},\"IBC30-1144W\":{\"penalty\":0,\"totalHorsePower\":20},\"HLC12-4156W\":{\"penalty\":0,\"totalHorsePower\":2},\"IDC12-2060W\":{\"penalty\":0,\"totalHorsePower\":1},\"IBC30-1132A\":{\"penalty\":0,\"totalHorsePower\":20},\"IBC30-1132D\":{\"penalty\":0,\"totalHorsePower\":20},\"IDC20-1132W\":{\"penalty\":0,\"totalHorsePower\":10},\"IBC16-1084A\":{\"penalty\":0,\"totalHorsePower\":3},\"IBC16-1084D\":{\"penalty\":0,\"totalHorsePower\":3},\"IDC20-1096W\":{\"penalty\":0,\"totalHorsePower\":7.5},\"IBC16-1084G\":{\"penalty\":0,\"totalHorsePower\":3},\"IBC16-1096W\":{\"penalty\":0,\"totalHorsePower\":5},\"AHD10-1042E\":{\"penalty\":0,\"totalHorsePower\":0.5},\"IDC12-5180G\":{\"penalty\":0,\"totalHorsePower\":2.5},\"HLC16-2192S\":{\"penalty\":0,\"totalHorsePower\":10},\"IBC16-1096S\":{\"penalty\":0,\"totalHorsePower\":5},\"HLC12-4156S\":{\"penalty\":0,\"totalHorsePower\":2},\"SHD07-3120A\":{\"penalty\":0,\"totalHorsePower\":2.25},\"IDC20-1132G\":{\"penalty\":0,\"totalHorsePower\":10},\"IDC20-1132E\":{\"penalty\":0,\"totalHorsePower\":10},\"HLC12-5180S\":{\"penalty\":0,\"totalHorsePower\":2.5},\"IDC12-2084G\":{\"penalty\":0,\"totalHorsePower\":1},\"IDC20-1096D\":{\"penalty\":0,\"totalHorsePower\":7.5},\"IBC16-1084W\":{\"penalty\":0,\"totalHorsePower\":3},\"IBC16-1096G\":{\"penalty\":0,\"totalHorsePower\":5},\"IBC20-1084A\":{\"penalty\":0,\"totalHorsePower\":5},\"IBC16-1096D\":{\"penalty\":0,\"totalHorsePower\":5},\"IBC20-1084G\":{\"penalty\":0,\"totalHorsePower\":5},\"IBC16-1060D\":{\"penalty\":0,\"totalHorsePower\":3},\"HLC12-4156A\":{\"penalty\":0,\"totalHorsePower\":2},\"CLC08-1036W\":{\"penalty\":0,\"totalHorsePower\":0.2},\"SHD07-2072A\":{\"penalty\":0,\"totalHorsePower\":1.5},\"CLC08-1036S\":{\"penalty\":0,\"totalHorsePower\":0.2},\"HLC12-4168S\":{\"penalty\":0,\"totalHorsePower\":2},\"ARC16-2096S\":{\"penalty\":-0.1,\"totalHorsePower\":2},\"HLC12-4168W\":{\"penalty\":0,\"totalHorsePower\":2},\"IDC20-1084D\":{\"penalty\":0,\"totalHorsePower\":5},\"IDC20-1084G\":{\"penalty\":0,\"totalHorsePower\":5},\"ARC16-2096W\":{\"penalty\":-0.1,\"totalHorsePower\":2},\"IBC16-1096A\":{\"penalty\":0,\"totalHorsePower\":5},\"CLC08-1036E\":{\"penalty\":0,\"totalHorsePower\":0.2},\"IBC16-1084S\":{\"penalty\":0,\"totalHorsePower\":3},\"IBC30-1192D\":{\"penalty\":0,\"totalHorsePower\":30},\"CLC08-1036A\":{\"penalty\":0,\"totalHorsePower\":0.2},\"SLC07-2120A\":{\"penalty\":0,\"totalHorsePower\":0.4},\"ARC16-2096A\":{\"penalty\":-0.1,\"totalHorsePower\":2},\"HLC12-4168A\":{\"penalty\":0,\"totalHorsePower\":2},\"ARC16-2096E\":{\"penalty\":-0.1,\"totalHorsePower\":2},\"IDC20-1084W\":{\"penalty\":0,\"totalHorsePower\":5},\"IDC20-1096G\":{\"penalty\":0,\"totalHorsePower\":7.5},\"HLC20-1168A\":{\"penalty\":0,\"totalHorsePower\":15},\"HLC12-3096A\":{\"penalty\":0,\"totalHorsePower\":1.5},\"IDC20-1132A\":{\"penalty\":0,\"totalHorsePower\":10},\"HLC12-3132A\":{\"penalty\":0,\"totalHorsePower\":1.5},\"IDC20-1096E\":{\"penalty\":0,\"totalHorsePower\":7.5},\"FLY16-1042A\":{\"penalty\":0,\"totalHorsePower\":2},\"HLC12-3132W\":{\"penalty\":0,\"totalHorsePower\":1.5},\"HLC12-3096S\":{\"penalty\":0,\"totalHorsePower\":1.5},\"HLC20-1168S\":{\"penalty\":0,\"totalHorsePower\":15},\"IDC16-1084G\":{\"penalty\":0,\"totalHorsePower\":3},\"HLC12-3132S\":{\"penalty\":0,\"totalHorsePower\":1.5},\"HLC12-3096W\":{\"penalty\":0,\"totalHorsePower\":1.5},\"HLC20-1168W\":{\"penalty\":0,\"totalHorsePower\":15},\"HLC12-2072W\":{\"penalty\":0,\"totalHorsePower\":1},\"IBC20-1192W\":{\"penalty\":0,\"totalHorsePower\":15},\"IBC30-1096S\":{\"penalty\":0,\"totalHorsePower\":15},\"IDC12-4144A\":{\"penalty\":0,\"totalHorsePower\":2},\"IBC30-1096W\":{\"penalty\":0,\"totalHorsePower\":15},\"IDC12-4144E\":{\"penalty\":0,\"totalHorsePower\":2},\"HLC12-5180A\":{\"penalty\":0,\"totalHorsePower\":2.5},\"IDC12-4156W\":{\"penalty\":0,\"totalHorsePower\":2},\"IDC12-4156S\":{\"penalty\":0,\"totalHorsePower\":2},\"IDC12-4168G\":{\"penalty\":0,\"totalHorsePower\":2},\"IBC30-1096A\":{\"penalty\":0,\"totalHorsePower\":15},\"IDC12-4144S\":{\"penalty\":0,\"totalHorsePower\":2},\"IDC20-1156D\":{\"penalty\":0,\"totalHorsePower\":15},\"HLC12-2072S\":{\"penalty\":0,\"totalHorsePower\":1},\"IBC30-1096D\":{\"penalty\":0,\"totalHorsePower\":15},\"IDC12-4156G\":{\"penalty\":0,\"totalHorsePower\":2},\"IDC12-4156E\":{\"penalty\":0,\"totalHorsePower\":2},\"IBC20-1084D\":{\"penalty\":0,\"totalHorsePower\":5},\"IDC12-4156A\":{\"penalty\":0,\"totalHorsePower\":2},\"IDC12-2096S\":{\"penalty\":-0.1,\"totalHorsePower\":1},\"IDC14-1048S\":{\"penalty\":0,\"totalHorsePower\":1},\"IDC12-2096W\":{\"penalty\":-0.1,\"totalHorsePower\":1},\"IDC14-1048W\":{\"penalty\":0,\"totalHorsePower\":1},\"IDC12-3096W\":{\"penalty\":0,\"totalHorsePower\":1.5},\"AHD10-2048E\":{\"penalty\":0.1,\"totalHorsePower\":1},\"HLC14-2060S\":{\"penalty\":0,\"totalHorsePower\":2},\"IDC12-3096S\":{\"penalty\":0,\"totalHorsePower\":1.5},\"AHD10-2048A\":{\"penalty\":0.1,\"totalHorsePower\":1},\"HLC14-2060W\":{\"penalty\":0,\"totalHorsePower\":2},\"IDC14-1048A\":{\"penalty\":0,\"totalHorsePower\":1},\"IBC30-1192S\":{\"penalty\":0,\"totalHorsePower\":30},\"IDC12-2096G\":{\"penalty\":-0.1,\"totalHorsePower\":1},\"IDC12-2096E\":{\"penalty\":-0.1,\"totalHorsePower\":1},\"IDC12-3096G\":{\"penalty\":0,\"totalHorsePower\":1.5},\"HLC14-2060A\":{\"penalty\":0,\"totalHorsePower\":2},\"IDC12-3096E\":{\"penalty\":0,\"totalHorsePower\":1.5},\"AHD10-2048W\":{\"penalty\":0.1,\"totalHorsePower\":1},\"IDC12-3096A\":{\"penalty\":0,\"totalHorsePower\":1.5},\"AHD10-2048S\":{\"penalty\":0.1,\"totalHorsePower\":1},\"ARC16-3132S\":{\"penalty\":0,\"totalHorsePower\":3},\"IDC16-1156W\":{\"penalty\":0,\"totalHorsePower\":7.5},\"ARC16-3132W\":{\"penalty\":0,\"totalHorsePower\":3},\"IDC12-2084A\":{\"penalty\":0,\"totalHorsePower\":1},\"ARC16-3108S\":{\"penalty\":0,\"totalHorsePower\":3},\"IBC30-1192W\":{\"penalty\":0,\"totalHorsePower\":30},\"IDC12-2084E\":{\"penalty\":0,\"totalHorsePower\":1},\"ARC16-3108W\":{\"penalty\":0,\"totalHorsePower\":3},\"IDC16-1156S\":{\"penalty\":0,\"totalHorsePower\":7.5},\"ARC16-3132A\":{\"penalty\":0,\"totalHorsePower\":3},\"ARC16-3132E\":{\"penalty\":0,\"totalHorsePower\":3},\"IDC20-1144S\":{\"penalty\":0,\"totalHorsePower\":15},\"ARC16-3108A\":{\"penalty\":0,\"totalHorsePower\":3},\"IDC12-2084S\":{\"penalty\":0,\"totalHorsePower\":1},\"ARC16-3108E\":{\"penalty\":0,\"totalHorsePower\":3},\"IDC12-2084W\":{\"penalty\":0,\"totalHorsePower\":1},\"HLC14-3120W\":{\"penalty\":0,\"totalHorsePower\":3},\"ARD12-1048A\":{\"penalty\":0,\"totalHorsePower\":0.5},\"ALC08-1072A\":{\"penalty\":0,\"totalHorsePower\":0.2},\"HLC14-3120S\":{\"penalty\":0,\"totalHorsePower\":3},\"ARD12-1048E\":{\"penalty\":0,\"totalHorsePower\":0.5},\"ALC08-1072E\":{\"penalty\":0,\"totalHorsePower\":0.2},\"HLC20-2192S\":{\"penalty\":0,\"totalHorsePower\":15},\"ARD12-3120A\":{\"penalty\":0,\"totalHorsePower\":1.5},\"ALC08-2120W\":{\"penalty\":0,\"totalHorsePower\":0.4},\"HLC20-2192W\":{\"penalty\":0,\"totalHorsePower\":15},\"ARD12-3120E\":{\"penalty\":0,\"totalHorsePower\":1.5},\"ALC08-2120S\":{\"penalty\":0,\"totalHorsePower\":0.4},\"HLC12-4192A\":{\"penalty\":-0.1,\"totalHorsePower\":2},\"ARD12-1048S\":{\"penalty\":0,\"totalHorsePower\":0.5},\"ALC08-1072S\":{\"penalty\":0,\"totalHorsePower\":0.2},\"ARD12-1048W\":{\"penalty\":0,\"totalHorsePower\":0.5},\"ALC08-1072W\":{\"penalty\":0,\"totalHorsePower\":0.2},\"HLC14-3120A\":{\"penalty\":0,\"totalHorsePower\":3},\"ALC08-2120E\":{\"penalty\":0,\"totalHorsePower\":0.4},\"HLC12-4192W\":{\"penalty\":-0.1,\"totalHorsePower\":2},\"HLC20-2192A\":{\"penalty\":0,\"totalHorsePower\":15},\"ARD12-3120S\":{\"penalty\":0,\"totalHorsePower\":1.5},\"ALC08-2120A\":{\"penalty\":0,\"totalHorsePower\":0.4},\"HLC12-4192S\":{\"penalty\":-0.1,\"totalHorsePower\":2},\"IDC14-2084E\":{\"penalty\":0,\"totalHorsePower\":2},\"ARD12-3120W\":{\"penalty\":0,\"totalHorsePower\":1.5},\"AHD10-2096S\":{\"penalty\":-0.1,\"totalHorsePower\":1},\"IBC30-1156A\":{\"penalty\":0,\"totalHorsePower\":20},\"AED08-1048A\":{\"penalty\":0,\"totalHorsePower\":0.5},\"AHD10-2096W\":{\"penalty\":-0.1,\"totalHorsePower\":1},\"AED08-1048E\":{\"penalty\":0,\"totalHorsePower\":0.5},\"IBC30-1192A\":{\"penalty\":0,\"totalHorsePower\":30},\"CHD10-2108E\":{\"penalty\":-0.125,\"totalHorsePower\":1},\"FLY16-1072A\":{\"penalty\":0,\"totalHorsePower\":2},\"CHD10-2108A\":{\"penalty\":-0.125,\"totalHorsePower\":1},\"AHD10-2096A\":{\"penalty\":-0.1,\"totalHorsePower\":1},\"IBC30-1156S\":{\"penalty\":0,\"totalHorsePower\":20},\"AHD10-2096E\":{\"penalty\":-0.1,\"totalHorsePower\":1},\"IBC30-1156W\":{\"penalty\":0,\"totalHorsePower\":20},\"ALC08-1042E\":{\"penalty\":0,\"totalHorsePower\":0.2},\"CLC08-1048W\":{\"penalty\":0,\"totalHorsePower\":0.2},\"ARD12-1036A\":{\"penalty\":0,\"totalHorsePower\":0.5},\"ALC08-1042A\":{\"penalty\":0,\"totalHorsePower\":0.2},\"CLC08-1048S\":{\"penalty\":0,\"totalHorsePower\":0.2},\"ARD12-1036E\":{\"penalty\":0,\"totalHorsePower\":0.5},\"IBC20-1060A\":{\"penalty\":0,\"totalHorsePower\":5},\"IBC20-1096S\":{\"penalty\":0,\"totalHorsePower\":7.5},\"IBC20-1060D\":{\"penalty\":0,\"totalHorsePower\":5},\"IBC20-1060G\":{\"penalty\":0,\"totalHorsePower\":5},\"IBC20-1096W\":{\"penalty\":0,\"totalHorsePower\":7.5},\"CLC08-1048E\":{\"penalty\":0,\"totalHorsePower\":0.2},\"ARD12-1036S\":{\"penalty\":0,\"totalHorsePower\":0.5},\"ALC08-1042W\":{\"penalty\":0,\"totalHorsePower\":0.2},\"IDC16-2168S\":{\"penalty\":0,\"totalHorsePower\":8},\"CLC08-1048A\":{\"penalty\":0,\"totalHorsePower\":0.2},\"ARD12-1036W\":{\"penalty\":0,\"totalHorsePower\":0.5},\"ALC08-1042S\":{\"penalty\":0,\"totalHorsePower\":0.2},\"IBC20-1096A\":{\"penalty\":0,\"totalHorsePower\":7.5},\"IBC20-1060S\":{\"penalty\":0,\"totalHorsePower\":5},\"IBC20-1096D\":{\"penalty\":0,\"totalHorsePower\":7.5},\"IDC20-1084S\":{\"penalty\":0,\"totalHorsePower\":5},\"IBC20-1060W\":{\"penalty\":0,\"totalHorsePower\":5},\"IBC20-1096G\":{\"penalty\":0,\"totalHorsePower\":7.5},\"HLC20-1084W\":{\"penalty\":0,\"totalHorsePower\":5},\"AED08-1036A\":{\"penalty\":0,\"totalHorsePower\":0.5},\"IDC20-2192G\":{\"penalty\":0,\"totalHorsePower\":15},\"IDC20-2192D\":{\"penalty\":0,\"totalHorsePower\":15},\"AED08-1036E\":{\"penalty\":0,\"totalHorsePower\":0.5},\"IDC20-1144A\":{\"penalty\":0,\"totalHorsePower\":15},\"IDC20-1108S\":{\"penalty\":0,\"totalHorsePower\":7.5},\"IDC16-2180A\":{\"penalty\":0,\"totalHorsePower\":8},\"IDC20-1108W\":{\"penalty\":0,\"totalHorsePower\":7.5},\"HLC20-1096A\":{\"penalty\":0,\"totalHorsePower\":7.5},\"IDC20-1144G\":{\"penalty\":0,\"totalHorsePower\":15},\"HLC14-1036A\":{\"penalty\":0,\"totalHorsePower\":1},\"IDC16-1072S\":{\"penalty\":0,\"totalHorsePower\":3},\"IDC20-2192W\":{\"penalty\":0,\"totalHorsePower\":15},\"IBC16-1120D\":{\"penalty\":0,\"totalHorsePower\":7.5},\"HLC20-1096W\":{\"penalty\":0,\"totalHorsePower\":7.5},\"IDC20-1108A\":{\"penalty\":0,\"totalHorsePower\":7.5},\"HLC20-1096S\":{\"penalty\":0,\"totalHorsePower\":7.5},\"IDC20-1108G\":{\"penalty\":0,\"totalHorsePower\":7.5},\"IDC20-1108D\":{\"penalty\":0,\"totalHorsePower\":7.5},\"IDC20-1108E\":{\"penalty\":0,\"totalHorsePower\":7.5},\"IDC16-1120W\":{\"penalty\":0,\"totalHorsePower\":7.5},\"IDC12-1048A\":{\"penalty\":0,\"totalHorsePower\":0.5},\"IDC16-1120S\":{\"penalty\":0,\"totalHorsePower\":7.5},\"IDC16-1060S\":{\"penalty\":0,\"totalHorsePower\":3},\"IBC20-1168S\":{\"penalty\":0,\"totalHorsePower\":15},\"FLY16-1066A\":{\"penalty\":0,\"totalHorsePower\":2},\"IBC20-1168W\":{\"penalty\":0,\"totalHorsePower\":15},\"HLC14-5192W\":{\"penalty\":0,\"totalHorsePower\":5},\"IDC14-5192E\":{\"penalty\":0,\"totalHorsePower\":5},\"IDC16-1060D\":{\"penalty\":0,\"totalHorsePower\":3},\"IDC14-5192A\":{\"penalty\":0,\"totalHorsePower\":5},\"IDC16-1120E\":{\"penalty\":0,\"totalHorsePower\":7.5},\"IDC16-1060G\":{\"penalty\":0,\"totalHorsePower\":3},\"IDC16-1060A\":{\"penalty\":0,\"totalHorsePower\":3},\"IDC16-1120A\":{\"penalty\":0,\"totalHorsePower\":7.5},\"HLC14-5192A\":{\"penalty\":0,\"totalHorsePower\":5},\"IBC20-1168A\":{\"penalty\":0,\"totalHorsePower\":15},\"IBC20-1168G\":{\"penalty\":0,\"totalHorsePower\":15},\"IBC20-1168D\":{\"penalty\":0,\"totalHorsePower\":15},\"AHD10-3108E\":{\"penalty\":0,\"totalHorsePower\":1.5},\"AHD10-3108A\":{\"penalty\":0,\"totalHorsePower\":1.5},\"IDC16-1156G\":{\"penalty\":0,\"totalHorsePower\":7.5},\"ARD12-2108E\":{\"penalty\":-0.125,\"totalHorsePower\":1},\"HLC12-3108A\":{\"penalty\":0,\"totalHorsePower\":1.5},\"ARD12-2108A\":{\"penalty\":-0.125,\"totalHorsePower\":1},\"IDC16-1156A\":{\"penalty\":0,\"totalHorsePower\":7.5},\"AHD10-3108W\":{\"penalty\":0,\"totalHorsePower\":1.5},\"AHD10-3108S\":{\"penalty\":0,\"totalHorsePower\":1.5},\"SHD07-1036A\":{\"penalty\":0,\"totalHorsePower\":0.75},\"ARD12-2108W\":{\"penalty\":-0.125,\"totalHorsePower\":1},\"HLC12-3108S\":{\"penalty\":0,\"totalHorsePower\":1.5},\"ARD12-2108S\":{\"penalty\":-0.125,\"totalHorsePower\":1},\"HLC12-3108W\":{\"penalty\":0,\"totalHorsePower\":1.5},\"IDC16-2180S\":{\"penalty\":0,\"totalHorsePower\":8},\"HLC12-2078S\":{\"penalty\":0,\"totalHorsePower\":1},\"ARC16-3144S\":{\"penalty\":-0.1,\"totalHorsePower\":3},\"HLC12-2078W\":{\"penalty\":0,\"totalHorsePower\":1},\"ARC16-3144W\":{\"penalty\":-0.1,\"totalHorsePower\":3},\"AHD10-1048W\":{\"penalty\":0,\"totalHorsePower\":0.5},\"CHD10-1036E\":{\"penalty\":0,\"totalHorsePower\":0.5},\"AHD10-1048S\":{\"penalty\":0,\"totalHorsePower\":0.5},\"CHD10-1036A\":{\"penalty\":0,\"totalHorsePower\":0.5},\"ARC16-3144A\":{\"penalty\":-0.1,\"totalHorsePower\":3},\"HLC12-2078A\":{\"penalty\":0,\"totalHorsePower\":1},\"IDC20-1144W\":{\"penalty\":0,\"totalHorsePower\":15},\"ARC16-3144E\":{\"penalty\":-0.1,\"totalHorsePower\":3},\"AHD10-1048E\":{\"penalty\":0,\"totalHorsePower\":0.5},\"IDC12-4192G\":{\"penalty\":-0.1,\"totalHorsePower\":2},\"AHD10-1048A\":{\"penalty\":0,\"totalHorsePower\":0.5},\"ARC16-3096E\":{\"penalty\":0,\"totalHorsePower\":3},\"IDC14-5192S\":{\"penalty\":0,\"totalHorsePower\":5},\"ARC16-3096A\":{\"penalty\":0,\"totalHorsePower\":3},\"HLC14-1042A\":{\"penalty\":0,\"totalHorsePower\":1},\"ARC16-2060A\":{\"penalty\":0,\"totalHorsePower\":2},\"IDC12-2108S\":{\"penalty\":-0.125,\"totalHorsePower\":1},\"ARC16-2060E\":{\"penalty\":0,\"totalHorsePower\":2},\"IDC12-2108W\":{\"penalty\":-0.125,\"totalHorsePower\":1},\"HLC14-1042W\":{\"penalty\":0,\"totalHorsePower\":1},\"ARC16-3096W\":{\"penalty\":0,\"totalHorsePower\":3},\"HLC14-1042S\":{\"penalty\":0,\"totalHorsePower\":1},\"ARC16-3096S\":{\"penalty\":0,\"totalHorsePower\":3},\"ARC16-2060S\":{\"penalty\":0,\"totalHorsePower\":2},\"IDC12-2108A\":{\"penalty\":-0.125,\"totalHorsePower\":1},\"IDC12-2108G\":{\"penalty\":-0.125,\"totalHorsePower\":1},\"ARC16-2060W\":{\"penalty\":0,\"totalHorsePower\":2},\"IDC12-2108E\":{\"penalty\":-0.125,\"totalHorsePower\":1},\"IDC14-3096E\":{\"penalty\":0,\"totalHorsePower\":3},\"IDC14-3096G\":{\"penalty\":0,\"totalHorsePower\":3},\"IDC14-3096A\":{\"penalty\":0,\"totalHorsePower\":3},\"IDC20-1180E\":{\"penalty\":0,\"totalHorsePower\":15},\"IDC14-2120W\":{\"penalty\":-0.15,\"totalHorsePower\":2},\"ARD12-1060A\":{\"penalty\":-0.15,\"totalHorsePower\":0.5},\"IDC20-1168E\":{\"penalty\":0,\"totalHorsePower\":15},\"IDC14-2096S\":{\"penalty\":-0.1,\"totalHorsePower\":2},\"ARD12-1060E\":{\"penalty\":-0.15,\"totalHorsePower\":0.5},\"HLC12-2096A\":{\"penalty\":-0.1,\"totalHorsePower\":1},\"IDC14-2096W\":{\"penalty\":-0.1,\"totalHorsePower\":2},\"IDC14-3096W\":{\"penalty\":0,\"totalHorsePower\":3},\"IDC14-1042A\":{\"penalty\":0,\"totalHorsePower\":1},\"IDC14-3096S\":{\"penalty\":0,\"totalHorsePower\":3},\"HLC12-2096W\":{\"penalty\":-0.1,\"totalHorsePower\":1},\"IDC14-2096A\":{\"penalty\":-0.1,\"totalHorsePower\":2},\"ARD12-1060S\":{\"penalty\":-0.15,\"totalHorsePower\":0.5},\"HLC12-2096S\":{\"penalty\":-0.1,\"totalHorsePower\":1},\"IDC14-2096E\":{\"penalty\":-0.1,\"totalHorsePower\":2},\"ARD12-1060W\":{\"penalty\":-0.15,\"totalHorsePower\":0.5},\"IDC14-2096G\":{\"penalty\":-0.1,\"totalHorsePower\":2},\"IDC16-2192A\":{\"penalty\":0,\"totalHorsePower\":10},\"ARC16-1042A\":{\"penalty\":0,\"totalHorsePower\":1},\"IDC16-2192E\":{\"penalty\":0,\"totalHorsePower\":10},\"IDC16-2192D\":{\"penalty\":0,\"totalHorsePower\":10},\"IDC16-2192G\":{\"penalty\":0,\"totalHorsePower\":10},\"ARC16-1042E\":{\"penalty\":0,\"totalHorsePower\":1},\"AED08-1060A\":{\"penalty\":0,\"totalHorsePower\":0.5},\"IDC14-5180A\":{\"penalty\":0,\"totalHorsePower\":5},\"AED08-1060E\":{\"penalty\":0,\"totalHorsePower\":0.5},\"IDC14-5180E\":{\"penalty\":0,\"totalHorsePower\":5},\"ARC16-1042S\":{\"penalty\":0,\"totalHorsePower\":1},\"IDC16-2192S\":{\"penalty\":0,\"totalHorsePower\":10},\"ARC16-1042W\":{\"penalty\":0,\"totalHorsePower\":1},\"IDC16-2192W\":{\"penalty\":0,\"totalHorsePower\":10},\"IDC14-3120E\":{\"penalty\":0,\"totalHorsePower\":3},\"ALC08-1048A\":{\"penalty\":0,\"totalHorsePower\":0.2},\"IDC14-5180W\":{\"penalty\":0,\"totalHorsePower\":5},\"ALC08-1048E\":{\"penalty\":0,\"totalHorsePower\":0.2},\"CHD10-3096E\":{\"penalty\":0,\"totalHorsePower\":1.5},\"IDC14-3132W\":{\"penalty\":0,\"totalHorsePower\":3},\"CHD10-3096A\":{\"penalty\":0,\"totalHorsePower\":1.5},\"IDC12-4168W\":{\"penalty\":0,\"totalHorsePower\":2},\"IDC20-1168D\":{\"penalty\":0,\"totalHorsePower\":15},\"IDC12-5192W\":{\"penalty\":0,\"totalHorsePower\":2.5},\"IDC20-1168G\":{\"penalty\":0,\"totalHorsePower\":15},\"IDC12-5192S\":{\"penalty\":0,\"totalHorsePower\":2.5},\"IDC20-1180G\":{\"penalty\":0,\"totalHorsePower\":15},\"IDC16-1132S\":{\"penalty\":0,\"totalHorsePower\":7.5},\"IDC12-5192G\":{\"penalty\":0,\"totalHorsePower\":2.5},\"IDC12-5192E\":{\"penalty\":0,\"totalHorsePower\":2.5},\"ARC16-4144S\":{\"penalty\":0,\"totalHorsePower\":4},\"IDC12-4168S\":{\"penalty\":0,\"totalHorsePower\":2},\"IDC20-1120A\":{\"penalty\":0,\"totalHorsePower\":10},\"IDC20-1060A\":{\"penalty\":0,\"totalHorsePower\":5},\"HLC12-2084S\":{\"penalty\":0,\"totalHorsePower\":1},\"IDC20-1060G\":{\"penalty\":0,\"totalHorsePower\":5},\"IDC16-1096W\":{\"penalty\":0,\"totalHorsePower\":5},\"IDC20-1060E\":{\"penalty\":0,\"totalHorsePower\":5},\"HLC12-2084W\":{\"penalty\":0,\"totalHorsePower\":1},\"IDC14-5192W\":{\"penalty\":0,\"totalHorsePower\":5},\"IDC12-4144G\":{\"penalty\":0,\"totalHorsePower\":2},\"SLC07-2096A\":{\"penalty\":0,\"totalHorsePower\":0.4},\"IDC20-1060S\":{\"penalty\":0,\"totalHorsePower\":5},\"HLC12-2084A\":{\"penalty\":0,\"totalHorsePower\":1},\"IDC20-1120S\":{\"penalty\":0,\"totalHorsePower\":10},\"IDC20-1060W\":{\"penalty\":0,\"totalHorsePower\":5},\"IDC20-1120W\":{\"penalty\":0,\"totalHorsePower\":10},\"IDC14-2078G\":{\"penalty\":0,\"totalHorsePower\":2},\"ARD12-2072E\":{\"penalty\":0,\"totalHorsePower\":1},\"HLC12-1060S\":{\"penalty\":-0.15,\"totalHorsePower\":0.5},\"HLC12-3120S\":{\"penalty\":0,\"totalHorsePower\":1.5},\"ARD12-2072A\":{\"penalty\":0,\"totalHorsePower\":1},\"ARD12-2120S\":{\"penalty\":-0.15,\"totalHorsePower\":1},\"HLC12-3120W\":{\"penalty\":0,\"totalHorsePower\":1.5},\"HLC14-5180W\":{\"penalty\":0,\"totalHorsePower\":5},\"IDC16-1108W\":{\"penalty\":0,\"totalHorsePower\":5},\"HLC14-5180S\":{\"penalty\":0,\"totalHorsePower\":5},\"IDC16-1108S\":{\"penalty\":0,\"totalHorsePower\":5},\"ARD12-2120E\":{\"penalty\":-0.15,\"totalHorsePower\":1},\"HLC12-3120A\":{\"penalty\":0,\"totalHorsePower\":1.5},\"ARD12-2072W\":{\"penalty\":0,\"totalHorsePower\":1},\"IDC16-1132G\":{\"penalty\":0,\"totalHorsePower\":7.5},\"ARD12-2120A\":{\"penalty\":-0.15,\"totalHorsePower\":1},\"IDC16-1132A\":{\"penalty\":0,\"totalHorsePower\":7.5},\"ARD12-2072S\":{\"penalty\":0,\"totalHorsePower\":1},\"IDC16-1108E\":{\"penalty\":0,\"totalHorsePower\":5},\"IDC16-1108D\":{\"penalty\":0,\"totalHorsePower\":5},\"IDC16-1108G\":{\"penalty\":0,\"totalHorsePower\":5},\"IDC16-1108A\":{\"penalty\":0,\"totalHorsePower\":5},\"IBC16-1168W\":{\"penalty\":0,\"totalHorsePower\":7.5},\"HLC14-5180A\":{\"penalty\":0,\"totalHorsePower\":5},\"IDC20-1084E\":{\"penalty\":0,\"totalHorsePower\":5},\"IBC20-1072A\":{\"penalty\":0,\"totalHorsePower\":5},\"ALC08-1030E\":{\"penalty\":0,\"totalHorsePower\":0.2},\"IDC14-3120S\":{\"penalty\":0,\"totalHorsePower\":3},\"AHD10-3120A\":{\"penalty\":0,\"totalHorsePower\":1.5},\"IDC20-1180W\":{\"penalty\":0,\"totalHorsePower\":15},\"IDC14-2060A\":{\"penalty\":0,\"totalHorsePower\":2},\"IDC12-4168E\":{\"penalty\":0,\"totalHorsePower\":2},\"ALC08-1030W\":{\"penalty\":0,\"totalHorsePower\":0.2},\"ALC08-1030S\":{\"penalty\":0,\"totalHorsePower\":0.2},\"HLC14-2120S\":{\"penalty\":-0.15,\"totalHorsePower\":2},\"IDC14-1042S\":{\"penalty\":0,\"totalHorsePower\":1},\"AHD10-3096E\":{\"penalty\":0,\"totalHorsePower\":1.5},\"HLC14-2120W\":{\"penalty\":-0.15,\"totalHorsePower\":2},\"AHD10-3096A\":{\"penalty\":0,\"totalHorsePower\":1.5},\"IDC14-2060E\":{\"penalty\":0,\"totalHorsePower\":2},\"CLC08-1042A\":{\"penalty\":0,\"totalHorsePower\":0.2},\"IDC12-4144W\":{\"penalty\":0,\"totalHorsePower\":2},\"CLC08-1042E\":{\"penalty\":0,\"totalHorsePower\":0.2},\"IDC12-1036G\":{\"penalty\":0,\"totalHorsePower\":0.5},\"AHD10-3096W\":{\"penalty\":0,\"totalHorsePower\":1.5},\"HLC14-2120A\":{\"penalty\":-0.15,\"totalHorsePower\":2},\"AHD10-3096S\":{\"penalty\":0,\"totalHorsePower\":1.5},\"IDC12-1036A\":{\"penalty\":0,\"totalHorsePower\":0.5},\"CLC08-1042S\":{\"penalty\":0,\"totalHorsePower\":0.2},\"IDC20-1156A\":{\"penalty\":0,\"totalHorsePower\":15},\"CLC08-1042W\":{\"penalty\":0,\"totalHorsePower\":0.2},\"SLC07-1036A\":{\"penalty\":0,\"totalHorsePower\":0.2},\"IDC12-2120A\":{\"penalty\":-0.15,\"totalHorsePower\":1},\"AHD10-2072S\":{\"penalty\":0,\"totalHorsePower\":1},\"IDC12-2060G\":{\"penalty\":0,\"totalHorsePower\":1},\"IDC12-2120E\":{\"penalty\":-0.15,\"totalHorsePower\":1},\"AHD10-2072W\":{\"penalty\":0,\"totalHorsePower\":1},\"IDC12-2120G\":{\"penalty\":-0.15,\"totalHorsePower\":1},\"IBC20-1108D\":{\"penalty\":0,\"totalHorsePower\":7.5},\"IDC14-4192E\":{\"penalty\":-0.1,\"totalHorsePower\":4},\"HLC12-1036A\":{\"penalty\":0,\"totalHorsePower\":0.5},\"HLC16-1060A\":{\"penalty\":0,\"totalHorsePower\":3},\"IBC20-1108A\":{\"penalty\":0,\"totalHorsePower\":7.5},\"AHD10-2072A\":{\"penalty\":0,\"totalHorsePower\":1},\"IDC12-2072S\":{\"penalty\":0,\"totalHorsePower\":1},\"IDC12-2120S\":{\"penalty\":-0.15,\"totalHorsePower\":1},\"AHD10-2072E\":{\"penalty\":0,\"totalHorsePower\":1},\"IDC14-4168A\":{\"penalty\":0,\"totalHorsePower\":4},\"IDC12-2120W\":{\"penalty\":-0.15,\"totalHorsePower\":1},\"HLC12-1036S\":{\"penalty\":0,\"totalHorsePower\":0.5},\"HLC16-1060W\":{\"penalty\":0,\"totalHorsePower\":3},\"IBC20-1108W\":{\"penalty\":0,\"totalHorsePower\":7.5},\"HLC12-1036W\":{\"penalty\":0,\"totalHorsePower\":0.5},\"HLC16-1060S\":{\"penalty\":0,\"totalHorsePower\":3},\"IBC20-1108S\":{\"penalty\":0,\"totalHorsePower\":7.5},\"ARD12-3144A\":{\"penalty\":-0.1,\"totalHorsePower\":1.5},\"ARD12-3144E\":{\"penalty\":-0.1,\"totalHorsePower\":1.5},\"ARC16-2108E\":{\"penalty\":-0.125,\"totalHorsePower\":2},\"IBC16-1072W\":{\"penalty\":0,\"totalHorsePower\":3},\"ARC16-2108A\":{\"penalty\":-0.125,\"totalHorsePower\":2},\"IBC16-1072S\":{\"penalty\":0,\"totalHorsePower\":3},\"ARD12-3144S\":{\"penalty\":-0.1,\"totalHorsePower\":1.5},\"IBC16-1156W\":{\"penalty\":0,\"totalHorsePower\":7.5},\"ARD12-3144W\":{\"penalty\":-0.1,\"totalHorsePower\":1.5},\"IBC16-1072D\":{\"penalty\":0,\"totalHorsePower\":3},\"IBC16-1072G\":{\"penalty\":0,\"totalHorsePower\":3},\"ARC16-2108W\":{\"penalty\":-0.125,\"totalHorsePower\":2},\"IBC16-1072A\":{\"penalty\":0,\"totalHorsePower\":3},\"IDC14-2060S\":{\"penalty\":0,\"totalHorsePower\":2},\"IDC14-3108S\":{\"penalty\":0,\"totalHorsePower\":3},\"ARC16-2108S\":{\"penalty\":-0.125,\"totalHorsePower\":2},\"IDC16-2180G\":{\"penalty\":0,\"totalHorsePower\":8},\"IDC16-2180D\":{\"penalty\":0,\"totalHorsePower\":8},\"IDC14-5180G\":{\"penalty\":0,\"totalHorsePower\":5},\"IDC16-1144S\":{\"penalty\":0,\"totalHorsePower\":7.5},\"HLC16-1156A\":{\"penalty\":0,\"totalHorsePower\":7.5},\"IDC12-2072A\":{\"penalty\":0,\"totalHorsePower\":1},\"HLC16-1144A\":{\"penalty\":0,\"totalHorsePower\":7.5},\"IBC16-1120G\":{\"penalty\":0,\"totalHorsePower\":7.5},\"IBC16-1156S\":{\"penalty\":0,\"totalHorsePower\":7.5},\"IBC16-1120A\":{\"penalty\":0,\"totalHorsePower\":7.5},\"IDC12-1048G\":{\"penalty\":0,\"totalHorsePower\":0.5},\"IDC12-1048E\":{\"penalty\":0,\"totalHorsePower\":0.5},\"HLC16-1156W\":{\"penalty\":0,\"totalHorsePower\":7.5},\"IDC16-2180W\":{\"penalty\":0,\"totalHorsePower\":8},\"IDC20-1072S\":{\"penalty\":0,\"totalHorsePower\":5},\"HLC16-1156S\":{\"penalty\":0,\"totalHorsePower\":7.5},\"IDC14-2060W\":{\"penalty\":0,\"totalHorsePower\":2},\"IDC14-4180W\":{\"penalty\":-0.1,\"totalHorsePower\":4},\"IDC12-1048S\":{\"penalty\":0,\"totalHorsePower\":0.5},\"IBC16-1120W\":{\"penalty\":0,\"totalHorsePower\":7.5},\"HLC16-1144S\":{\"penalty\":0,\"totalHorsePower\":7.5},\"IDC12-1048W\":{\"penalty\":0,\"totalHorsePower\":0.5},\"IBC16-1120S\":{\"penalty\":0,\"totalHorsePower\":7.5},\"HLC16-1144W\":{\"penalty\":0,\"totalHorsePower\":7.5},\"HLC16-1108S\":{\"penalty\":0,\"totalHorsePower\":5},\"IDC14-1042G\":{\"penalty\":0,\"totalHorsePower\":1},\"IDC14-1042E\":{\"penalty\":0,\"totalHorsePower\":1},\"IBC20-1072S\":{\"penalty\":0,\"totalHorsePower\":5},\"IDC20-1180A\":{\"penalty\":0,\"totalHorsePower\":15},\"IBC20-1072W\":{\"penalty\":0,\"totalHorsePower\":5},\"IDC20-1180D\":{\"penalty\":0,\"totalHorsePower\":15},\"IDC14-4180S\":{\"penalty\":-0.1,\"totalHorsePower\":4},\"HLC14-1060S\":{\"penalty\":-0.15,\"totalHorsePower\":1},\"DTU03-1018E\":{\"penalty\":0,\"totalHorsePower\":0.08},\"IDC14-4192S\":{\"penalty\":-0.1,\"totalHorsePower\":4},\"IDC14-1042W\":{\"penalty\":0,\"totalHorsePower\":1},\"DTU03-1018A\":{\"penalty\":0,\"totalHorsePower\":0.08},\"IDC20-1180S\":{\"penalty\":0,\"totalHorsePower\":15},\"HLC16-1108W\":{\"penalty\":0,\"totalHorsePower\":5},\"IDC12-5180E\":{\"penalty\":0,\"totalHorsePower\":2.5},\"IBC20-1072G\":{\"penalty\":0,\"totalHorsePower\":5},\"IBC20-1072D\":{\"penalty\":0,\"totalHorsePower\":5},\"IDC20-1156E\":{\"penalty\":0,\"totalHorsePower\":15},\"IDC16-1144E\":{\"penalty\":0,\"totalHorsePower\":7.5},\"IDC20-1156G\":{\"penalty\":0,\"totalHorsePower\":15},\"IDC20-1072A\":{\"penalty\":0,\"totalHorsePower\":5},\"IDC20-1072D\":{\"penalty\":0,\"totalHorsePower\":5},\"IDC20-1072E\":{\"penalty\":0,\"totalHorsePower\":5},\"IDC20-1072G\":{\"penalty\":0,\"totalHorsePower\":5},\"ARC16-1060S\":{\"penalty\":-0.15,\"totalHorsePower\":1},\"CLC08-2096S\":{\"penalty\":0,\"totalHorsePower\":0.4},\"ARC16-1060W\":{\"penalty\":-0.15,\"totalHorsePower\":1},\"CLC08-2096W\":{\"penalty\":0,\"totalHorsePower\":0.4},\"ALC08-1048S\":{\"penalty\":0,\"totalHorsePower\":0.2},\"IDC20-1156W\":{\"penalty\":0,\"totalHorsePower\":15},\"IDC12-2096A\":{\"penalty\":-0.1,\"totalHorsePower\":1},\"IDC20-1156S\":{\"penalty\":0,\"totalHorsePower\":15},\"IDC20-1072W\":{\"penalty\":0,\"totalHorsePower\":5},\"CLC08-2096A\":{\"penalty\":0,\"totalHorsePower\":0.4},\"ARC16-1060A\":{\"penalty\":-0.15,\"totalHorsePower\":1},\"CLC08-2096E\":{\"penalty\":0,\"totalHorsePower\":0.4},\"ARC16-1060E\":{\"penalty\":-0.15,\"totalHorsePower\":1}}}");

});


parcelRegister("kcenM", function(module, exports) {

$parcel$export(module.exports, "ObjectManager", () => $d888e7560c61db6f$export$19321809bd793da0);

var $eXcdI = parcelRequire("eXcdI");

var $cE472 = parcelRequire("cE472");

var $f9eUc = parcelRequire("f9eUc");

var $WPLvD = parcelRequire("WPLvD");

var $gdtFo = parcelRequire("gdtFo");

var $4YMO4 = parcelRequire("4YMO4");

var $1phGj = parcelRequire("1phGj");

var $bQWlT = parcelRequire("bQWlT");

var $gYvZU = parcelRequire("gYvZU");

var $lz3oz = parcelRequire("lz3oz");

var $93EVF = parcelRequire("93EVF");

var $ap51u = parcelRequire("ap51u");

var $io94P = parcelRequire("io94P");

var $7HheK = parcelRequire("7HheK");

var $4hGcu = parcelRequire("4hGcu");

var $bNLF2 = parcelRequire("bNLF2");

var $bpA0O = parcelRequire("bpA0O");
const $d888e7560c61db6f$var$systemID = '15140447-f0c3-405e-a789-6f040bf2d754';
const $d888e7560c61db6f$var$ownerRoleID = '40c461cb-8866-468c-8dfc-1a0bf28e5b9a';
class $d888e7560c61db6f$export$19321809bd793da0 {
    constructor(identityID, email){
        this._users = new Map();
        this._identities = new Map();
        this._sites = new Map();
        this._userGroups = new Map();
        this._airCurtainGroups = new Map();
        this._airCurtains = new Map();
        this._roles = new Map();
        this._invitations = new Map();
        this._locations = new Map();
        this._installations = new Map();
        this._lastError = undefined;
        this._identityID = identityID;
        this._email = email;
    }
    async initialize() {
        this._lastError = undefined;
        // concurrent load of System, Identity
        const getSystemRequest = {
            objectType: 'system',
            keys: [
                $d888e7560c61db6f$var$systemID
            ]
        };
        const getIdentityRequest = {
            objectType: 'identity',
            keys: [
                this._identityID
            ]
        };
        const getInviteRequest = {
            objectType: 'invitation',
            keys: [
                this._email
            ]
        };
        let invitation = undefined;
        let identity = undefined;
        let responses = await (0, $4hGcu.getObjects)([
            getSystemRequest,
            getIdentityRequest,
            getInviteRequest
        ]);
        responses.forEach((response)=>{
            switch(response.objectType){
                case 'system':
                    this._system = (0, $gYvZU.System).createFromObject(response.objects[0]);
                    break;
                case 'identity':
                    if (response.objects.length > 0) identity = (0, $WPLvD.Identity).createFromObject(response.objects[0]);
                    break;
                case 'invitation':
                    if (response.objects.length > 0) invitation = (0, $ap51u.Invitation).createFromObject(response.objects[0]);
                    break;
            }
        });
        if (invitation != undefined) {
            if (identity == undefined) {
                //accept invitation
                const result = await this.acceptInvitation(invitation, this._identityID);
                if (result != undefined) identity = result;
            } else //delete invitation
            await this.deleteInvitation(invitation);
        }
        // load roles
        if (identity != undefined) {
            this._identity = identity;
            //identity found load user and system roles
            // in simple scenario, one user per identity
            const getUserRequest = {
                objectType: 'user',
                keys: [
                    this._identity.users[0]
                ]
            };
            const getSystemRolesRequest = {
                objectType: 'role',
                keys: this._system.roles
            };
            responses = await (0, $4hGcu.getObjects)([
                getUserRequest,
                getSystemRolesRequest
            ]);
            responses.forEach((response)=>{
                switch(response.objectType){
                    case 'user':
                        if (response.objects.length > 0) this._user = (0, $lz3oz.User).createFromObject(response.objects[0]);
                        break;
                    case 'role':
                        response.objects.forEach((obj)=>{
                            this._roles.set(obj.roleID, (0, $4YMO4.Role).createFromObject(obj));
                        });
                        break;
                }
            });
            if (!this._user) {
                this._lastError = new Error('identity: ' + this._identityID + ' is denied access to the system');
                return false;
            }
            await this.loadAccountAndAll();
            return true;
        }
        //no identity found, IT SHOULD HAVE BEEN CREATED ON INDIVIDUAL ACCEPTING INVITE
        this._lastError = new Error('identity: ' + this._identityID + ' is unknown. Please check your email for an invitation');
        return false;
    }
    async acceptInvitation(invitation, identityID) {
        // get user from invite
        const user = new (0, $lz3oz.User)(invitation.userID);
        let result = await user.load();
        if (!result) return undefined;
        // some validation
        if (user.invitationID != invitation.invitationID) return undefined;
        if (user.accountID != invitation.accountID) return undefined;
        //create identity
        const identity = new (0, $WPLvD.Identity)(identityID);
        identity.email = invitation.invitationID;
        identity.addUser(user);
        result = await identity.save();
        if (!result) return undefined;
        // user mods (removing the reference to the invitationID will activate a trigger on the objUsers table)
        user.invitationID = undefined;
        user.identityID = identity.identityID;
        user.acceptedInvitationDate = new Date();
        result = await user.save();
        if (!result) return undefined;
        return identity;
    }
    async deleteInvitation(invitation) {
        // get user from invite
        const user = new (0, $lz3oz.User)(invitation.userID);
        let result = await user.load();
        if (!result) return false;
        // some validation
        if (user.invitationID != invitation.invitationID) return false;
        if (user.accountID != invitation.accountID) return false;
        // user mods (removing the reference to the invitationID will activate a trigger on the objUsers table)
        user.invitationID = undefined;
        result = await user.save();
        if (!result) return false;
        return true;
    }
    get lastError() {
        return this._lastError;
    }
    createAccount(name) {
        const account = (0, $cE472.Account).createNew();
        account.name = name;
        return account;
    }
    createUser(name, firstName, lastName) {
        const user = (0, $lz3oz.User).createNew();
        user.name = name;
        user.firstName = firstName;
        user.lastName = lastName;
        user.accountID = this._account.accountID;
        return user;
    }
    createBin() {
        const bin = (0, $bpA0O.Bin).createNew();
        bin.accountID = this._account.accountID;
        return bin;
    }
    createLocation(siteID, latitude, longitude, naturalGasRate, electricityRate, oilRate, powerCycles, address) {
        const location = new (0, $io94P.Location)(siteID);
        location.latitude = latitude;
        location.longitude = longitude;
        location.naturalGasRate = naturalGasRate;
        location.electricityRate = electricityRate;
        location.oilRate = oilRate;
        location.powerCycles = powerCycles;
        location.postalCode = address;
        this._locations.set(siteID, location);
        return location;
    }
    createOrganization(name) {
        const organization = (0, $gdtFo.Organization).createNew();
        organization.name = name;
        organization.accountID = this._account.accountID;
        return organization;
    }
    createUserGroup(name) {
        const userGroup = (0, $93EVF.UserGroup).createNew();
        userGroup.name = name;
        userGroup.accountID = this._account.accountID;
        return userGroup;
    }
    createSiteGroup(name) {
        const siteGroup = (0, $bQWlT.SiteGroup).createNew();
        siteGroup.name = name;
        siteGroup.accountID = this._account.accountID;
        return siteGroup;
    }
    createSite(name) {
        const site = (0, $1phGj.Site).createNew();
        site.name = name;
        site.accountID = this._account.accountID;
        return site;
    }
    createAirCurtainGroup(name) {
        const airCurtainGroup = (0, $f9eUc.AirCurtainGroup).createNew();
        airCurtainGroup.name = name;
        airCurtainGroup.accountID = this._account.accountID;
        return airCurtainGroup;
    }
    linkOwnerToAccount(owner) {
        if (owner.accountID != this._account.accountID) throw new Error("user doesn't belong to account");
        this._account.ownerUserID = owner.userID;
        owner.headObjectType = 'account';
        owner.headObjectID = this._account.accountID;
    }
    linkBinToAccount(bin) {
        if (bin.accountID != this._account.accountID) throw new Error("bin doesn't belong to account");
        this._account.binID = bin.binID;
    }
    linkOrganizationToAccount(organization) {
        if (organization.accountID != this._account.accountID) throw new Error("organization doesn't belong to account");
        this._account.organizationID = organization.organizationId;
    }
    addSiteGroupToOrganization(organization, siteGroup) {
        organization.addSiteGroup(siteGroup);
        siteGroup.parentObjectType = 'organization';
        siteGroup.parentObjectID = organization.organizationId;
    }
    removeSiteGroupFromOrganization(organization, siteGroup) {
        organization.deleteSiteGroup(siteGroup);
        siteGroup.parentObjectType = undefined;
        siteGroup.parentObjectID = undefined;
    }
    addUserGroupToSite(site, userGroup) {
        site.addUserGroup(userGroup);
        userGroup.parentObjectType = 'site';
        userGroup.parentObjectID = site.siteID;
        userGroup.headObjectType = 'site';
        userGroup.headObjectID = site.siteID;
    }
    removeUserGroupFromSite(site, userGroup) {
        site.deleteUserGroup(userGroup);
        userGroup.parentObjectType = undefined;
        userGroup.parentObjectID = undefined;
    }
    addUserToIdentity(identity, user) {
        identity.addUser(user);
        user.identityID = identity.identityID;
    }
    removeUserFromIdentity(identity, user) {
        identity.deleteUser(user);
        user.identityID = undefined;
    }
    addSiteToSiteGroup(siteGroup, site) {
        siteGroup.addSite(site);
        site.siteGroupID = siteGroup.siteGroupID;
    }
    removeSiteFromSiteGroup(siteGroup, site) {
        siteGroup.deleteSite(site);
        site.siteGroupID = undefined;
    }
    addAirCurtainGroupToSite(site, airCurtainGroup) {
        site.addAirCurtainGroup(airCurtainGroup);
        airCurtainGroup.parentObjectType = 'site';
        airCurtainGroup.parentObjectID = site.siteID;
    }
    removeAirCurtainGroupFromSite(site, airCurtainGroup) {
        site.deleteAirCurtainGroup(airCurtainGroup);
        airCurtainGroup.parentObjectType = undefined;
        airCurtainGroup.parentObjectID = undefined;
    }
    addUserToUserGroup(userGroup, user) {
        userGroup.addUser(user);
        user.addUserGroup(userGroup);
    }
    removeUserFromUserGroup(userGroup, user) {
        userGroup.deleteUser(user);
        user.deleteUserGroup(userGroup);
    }
    addAirCurtainToAirCurtainGroup(airCurtainGroup, airCurtain) {
        airCurtainGroup.addAirCurtain(airCurtain);
        airCurtain.addAirCurtainGroup(airCurtainGroup);
    }
    removeAirCurtainFromAirCurtainGroup(airCurtainGroup, airCurtain) {
        airCurtainGroup.deleteAirCurtain(airCurtain);
        airCurtain.deleteAirCurtainGroup(airCurtainGroup);
    }
    addAirCurtainToUser(user, airCurtain) {
        user.addAirCurtain(airCurtain);
    }
    removeAirCurtainFromUser(user, airCurtain) {
        user.deleteAirCurtain(airCurtain);
    }
    addRoleToUser(user, role) {
        user.addRole(role);
    }
    removeRoleFromUser(user, role) {
        user.deleteRole(role);
    }
    getSystem() {
        return this._system;
    }
    getOrganization() {
        return this._organization;
    }
    getAccount() {
        return this._account;
    }
    isOwner() {
        return this._isOwner;
    }
    getOwner() {
        return this._owner;
    }
    getCurrentIdentity() {
        return this._identity;
    }
    getSiteGroup() {
        return this._siteGroup;
    }
    getSite(siteID) {
        if (this._sites.has(siteID)) return this._sites.get(siteID);
        return undefined;
    }
    getAllSites() {
        return Array.from(this._sites, ([key, value])=>value);
    }
    getUserGroup(siteGroupID) {
        if (this._userGroups.has(siteGroupID)) return this._userGroups.get(siteGroupID);
        return undefined;
    }
    async getUser(userID) {
        if (this._users.has(userID)) return this._users.get(userID);
        else {
            const user = new (0, $lz3oz.User)(userID);
            const result = await user.load();
            if (result) {
                this._users.set(userID, user);
                return user;
            }
            return undefined;
        }
    }
    async getAllUsers() {
        const users = [];
        this._userGroups.forEach((userGroup)=>{
            userGroup.users.forEach((userId)=>{
                users.push(userId);
            });
        });
        await this.loadUsers(users);
        return Array.from(this._users, ([key, value])=>value);
    }
    async getAllUsersFromUserGroup(userGroup) {
        await this.loadUsers(userGroup.users);
        const users = Array.from(this._users, ([key, value])=>value);
        return users.filter((user)=>{
            return user.userGroups.includes(userGroup.userGroupID);
        });
    }
    async getIdentity(identityID) {
        if (this._identities.has(identityID)) return this._identities.get(identityID);
        else {
            const identity = new (0, $WPLvD.Identity)(identityID);
            const result = await identity.load();
            if (result) {
                this._identities.set(identityID, identity);
                return identity;
            }
            return undefined;
        }
    }
    async getAllIdentities() {
        const identities = [];
        this._users.forEach((user)=>{
            //invitees have no identityID
            if (user.identityID) identities.push(user.identityID);
        });
        await this.loadIdentities(identities);
        return Array.from(this._identities, ([key, value])=>value);
    }
    async getIdentities(identityIDs) {
        await this.loadIdentities(identityIDs);
        const identities = Array.from(this._identities, ([key, value])=>value);
        return identities.filter((identity)=>{
            return identityIDs.includes(identity.identityID);
        });
    }
    getAirCurtainGroup(airCurtainID) {
        if (this._airCurtainGroups.has(airCurtainID)) return this._airCurtainGroups.get(airCurtainID);
        return undefined;
    }
    async getAirCurtain(airCurtainID) {
        if (this._airCurtains.has(airCurtainID)) return this._airCurtains.get(airCurtainID);
        else {
            const airCurtain = new (0, $eXcdI.AirCurtain)(airCurtainID);
            const result = await airCurtain.load();
            if (result) {
                this._airCurtains.set(airCurtainID, airCurtain);
                return airCurtain;
            }
            return undefined;
        }
    }
    async getAllAirCurtains() {
        const airCurtains = [];
        this._airCurtainGroups.forEach((airCurtainGroup)=>{
            airCurtainGroup.airCurtains.forEach((airCurtainId)=>{
                if (!airCurtains.includes(airCurtainId)) airCurtains.push(airCurtainId);
            });
        });
        await this.loadAirCurtains(airCurtains);
        return Array.from(this._airCurtains, ([key, value])=>value);
    }
    async getAllAirCurtainsFromAirCurtainGroup(airCurtainGroup) {
        await this.loadAirCurtains(airCurtainGroup.airCurtains);
        const airCurtains = Array.from(this._airCurtains, ([key, value])=>value);
        return airCurtains.filter((airCurtain)=>{
            //TODO check: newly assigned air curtains have airCurtainGroupID but no airCurtainGroups array
            return airCurtain.airCurtainGroups?.includes(airCurtainGroup.airCurtainGroupID);
        });
    }
    getAllRoles() {
        return Array.from(this._roles, ([key, value])=>value);
    }
    getRole(roleID) {
        if (this._roles.has(roleID)) return this._roles.get(roleID);
        return undefined;
    }
    getUserPolicies() {
        return this._userPolicies;
    }
    // public getAllTrashesFromBin():Array<omTrash> {
    //     return this._bin.trashes;
    // }
    // public async addTrashToBin(trash:omTrash):Promise<boolean>{
    //     this._bin.addTrash(trash);
    //     return await this._bin.save();
    // }
    // public async removeTrashFromBin(trash:omTrash):Promise<boolean>{
    //     this._bin.deleteTrash(trash);
    //     return await this._bin.save();
    // }
    get bin() {
        return this._bin;
    }
    async getInvitation(invitationID) {
        if (this._invitations.has(invitationID)) return this._invitations.get(invitationID);
        else {
            const invitation = new (0, $ap51u.Invitation)(invitationID);
            const result = await invitation.load();
            if (result) {
                this._invitations.set(invitationID, invitation);
                return invitation;
            }
            return undefined;
        }
    }
    async getUnitIDs(orderId) {
        return await (0, $4hGcu.getUnitIDs)(orderId);
    }
    async getInstallations(requestedInstallations) {
        const requestInstallationObjects = [];
        for (const requestedInstallation of requestedInstallations){
            const key = requestedInstallation.siteID + "|" + requestedInstallation.thingName;
            if (!this._installations.has(key)) {
                const installation = {
                    thingName: requestedInstallation.thingName,
                    siteID: requestedInstallation.siteID,
                    applicationType: undefined,
                    openingWidth: undefined,
                    openingHeight: undefined,
                    doorMountingHeight: undefined,
                    interiorTemperatureSetPointWinter: undefined,
                    interiorTemperatureSetPointSummer: undefined,
                    interiorRelativeHumidityWinter: undefined,
                    interiorRelativeHumiditySummer: undefined,
                    model: undefined,
                    heatingEnergyType: undefined,
                    coolingEnergyType: undefined,
                    calculateHeatingSaving: undefined,
                    calculateCoolingSaving: undefined,
                    hasHeating: undefined,
                    hasTemperatureSensor: undefined,
                    heatingPower: undefined,
                    unconditionedHeatingTemperatureSetPoint: undefined
                };
                requestInstallationObjects.push(installation);
            }
        }
        if (requestInstallationObjects.length) {
            const responseInstallations = await (0, $4hGcu.getInstallations)(requestInstallationObjects);
            for (const installation of responseInstallations){
                const key = installation.siteID + "|" + installation.thingName;
                this._installations.set(key, (0, $7HheK.Installation).createFromObject(installation));
            }
        }
        return this._installations;
    }
    async getInstallation(siteID, airCurtainID) {
        const key = siteID + "|" + airCurtainID;
        if (this._installations.has(key)) return this._installations.get(key);
        else {
            const installation = new (0, $7HheK.Installation)(airCurtainID, siteID);
            const result = await installation.load();
            if (result) {
                this._installations.set(key, installation);
                return installation;
            }
            return installation;
        }
    }
    async getLocation(siteID) {
        if (this._locations.has(siteID)) return this._locations.get(siteID);
        else {
            const location = new (0, $io94P.Location)(siteID);
            const result = await location.load();
            if (result) {
                this._locations.set(siteID, location);
                return location;
            }
            return undefined;
        }
    }
    async createDefaultAccount(email, accountName, userName, userFirstName, userLastName, organizationName, siteName) {
        const promises = []; //will save all in batch
        if (this._roles.size == 0) {
            const getSystemRolesRequest = {
                objectType: 'role',
                keys: this._system.roles
            };
            const responses = await (0, $4hGcu.getObjects)([
                getSystemRolesRequest
            ]);
            responses[0].objects.forEach((obj)=>{
                this._roles.set(obj.roleID, (0, $4YMO4.Role).createFromObject(obj));
            });
        }
        // create identity
        this._identity = new (0, $WPLvD.Identity)(this._identityID);
        this._identity.email = email;
        // create account
        this._account = this.createAccount(accountName);
        // create bin
        this._bin = this.createBin();
        // create user (owner)
        this._user = this.createUser(userName, userFirstName, userLastName);
        //link identity with user
        this.addUserToIdentity(this._identity, this._user);
        //link admin role to user
        this.addRoleToUser(this._user, this._roles.get($d888e7560c61db6f$var$ownerRoleID));
        //link account with owner
        this.linkOwnerToAccount(this._user);
        //link account to bin
        this.linkBinToAccount(this._bin);
        //save user to have permissions set on backend
        let result = await this._identity.save(); // create identity first, api will check that we create a user for this identity
        if (!result) console.log(this._identity.lastError);
        // await this.sleep(1000);
        result = await this._user.save();
        if (!result) console.log(this._user.lastError);
        this._userPolicies = await (0, $4hGcu.getUserPolicies)([]);
        this._users.set(this._user.userID, this._user);
        this._owner = this._user;
        this._isOwner = true;
        // create organization
        this._organization = this.createOrganization(organizationName);
        // create site group
        this._siteGroup = this.createSiteGroup('Sites');
        // create default site
        const defaultSite = this.createSite(siteName);
        this._sites.set(defaultSite.siteID, defaultSite);
        // create default user group
        const defaultUserGroup = this.createUserGroup('Users');
        this._userGroups.set(defaultUserGroup.userGroupID, defaultUserGroup);
        // create default air curtain group
        const defaultAirCurtainGroup = this.createAirCurtainGroup('Air Curtains');
        this._airCurtainGroups.set(defaultAirCurtainGroup.airCurtainGroupID, defaultAirCurtainGroup);
        //link user to user group
        this.addUserToUserGroup(defaultUserGroup, this._user);
        //link account with organization
        this.linkOrganizationToAccount(this._organization);
        //link organization with site group
        this.addSiteGroupToOrganization(this._organization, this._siteGroup);
        //link site to site group
        this.addSiteToSiteGroup(this._siteGroup, defaultSite);
        //link air curtain group to site
        this.addAirCurtainGroupToSite(defaultSite, defaultAirCurtainGroup);
        //link user group to site
        this.addUserGroupToSite(defaultSite, defaultUserGroup);
        /*
        //get all user air curtains from mobile api, attach to user and to default air curtain group
        if (!this._identity.email.includes('berner.com')) {
            // berner users can't attach air curtains to their own account, else they will be unavaillable to others as we all use the sames
            // admin will attach them manually if required
            const airCurtains = await this.getUserAirCurtainsFromMobileAPI();
            airCurtains.forEach((airCurtain) => {
                this._airCurtains.set(airCurtain.airCurtainID, airCurtain);
                this.addAirCurtainToUser(this._user, airCurtain);
                this.addAirCurtainToAirCurtainGroup(
                    defaultAirCurtainGroup,
                    airCurtain
                );
                promises.push(airCurtain.saveProperties());
            });
        }
        */ //save all
        promises.push(this._account.save());
        promises.push(this._bin.save());
        promises.push(this._user.save());
        promises.push(this._organization.save());
        promises.push(defaultUserGroup.save());
        promises.push(this._siteGroup.save());
        promises.push(defaultSite.save());
        promises.push(defaultAirCurtainGroup.save());
        const results = await Promise.all(promises);
        //load shadows
        promises.length = 0;
        if (this._airCurtains.size > 0) {
            this._airCurtains.forEach((airCurtain)=>{
                promises.push(airCurtain.refreshShadow());
            });
            await Promise.all(promises);
        }
        return !results.includes(false);
    }
    async loadAccountAndAll() {
        const promises = [];
        // concurrently load account, usr policies and user air curtains
        const getAccountRequest = {
            objectType: 'account',
            keys: [
                this._user.accountID
            ]
        };
        const getUserAirCurtainsRequest = {
            objectType: 'airCurtain',
            keys: this._user.airCurtains
        };
        promises.push((0, $4hGcu.getObjects)([
            getAccountRequest,
            getUserAirCurtainsRequest
        ]));
        promises.push((0, $4hGcu.getUserPolicies)([]));
        this._user.airCurtains.forEach((airCurtainID)=>{
            const getShadowRequest = {
                airCurtainID: airCurtainID
            };
            promises.push((0, $4hGcu.getShadow)(getShadowRequest));
        });
        let responses = await Promise.all(promises);
        let getObjectResponses = responses[0];
        this._userPolicies = responses[1];
        const shadows = new Map();
        for(let i = 2; i < responses.length - 1; i++)shadows.set(responses[i].airCurtainID, responses[i]);
        getObjectResponses.forEach((response)=>{
            switch(response.objectType){
                case 'account':
                    this._account = (0, $cE472.Account).createFromObject(response.objects[0]);
                    break;
                case 'airCurtain':
                    response.objects.forEach((obj)=>{
                        this._airCurtains.set(obj.airCurtainID, (0, $eXcdI.AirCurtain).createFromObject(obj, shadows.get(obj.airCurtainID)));
                    });
                    break;
            }
        });
        //is owner logged in?
        this._isOwner = this._account.ownerUserID == this._user.userID;
        if (this._isOwner) this._owner = this._user;
        else {
            this._owner = new (0, $lz3oz.User)(this._account.ownerUserID);
            await this._owner.load();
            this._users.set(this._account.ownerUserID, this._owner);
        }
        //load organization
        const organizationID = this._account.organizationID;
        this._organization = new (0, $gdtFo.Organization)(organizationID);
        await this._organization.load();
        //load site group
        const siteGroupID = this._organization.siteGroups[0]; // in simple scenario, one site group only
        this._siteGroup = new (0, $bQWlT.SiteGroup)(siteGroupID);
        await this._siteGroup.load();
        //load sites
        promises.length = 0;
        const getSitesRequest = {
            objectType: 'site',
            keys: this._siteGroup.sites
        };
        promises.push((0, $4hGcu.getObjects)([
            getSitesRequest
        ]));
        responses = await Promise.all(promises);
        const getSitesResponse = responses[0];
        getSitesResponse.forEach((response)=>{
            response.objects.forEach((obj)=>{
                this._sites.set(obj.siteID, (0, $1phGj.Site).createFromObject(obj));
            });
        });
        const getSiteGroupsRequest = {
            objectType: 'airCurtainGroup',
            keys: []
        };
        const getUserGroupsRequest = {
            objectType: 'userGroup',
            keys: []
        };
        const getBinRequest = {
            objectType: 'bin',
            keys: [
                this._account.binID
            ]
        };
        promises.length = 0;
        this._sites.forEach((site)=>{
            getSiteGroupsRequest.keys.push(site.airCurtainGroups[0]); // in simple scenario, one air curtain group per site
            getUserGroupsRequest.keys.push(site.userGroups[0]); // in simple scenario, one user group per site
        });
        const getObjectsRequest = [];
        getObjectsRequest.push(getSiteGroupsRequest);
        getObjectsRequest.push(getUserGroupsRequest);
        if (this._account.binID != undefined) getObjectsRequest.push(getBinRequest);
        getObjectResponses = await (0, $4hGcu.getObjects)(getObjectsRequest);
        getObjectResponses.forEach((response)=>{
            switch(response.objectType){
                case 'airCurtainGroup':
                    response.objects.forEach((obj)=>{
                        this._airCurtainGroups.set(obj.airCurtainGroupID, (0, $f9eUc.AirCurtainGroup).createFromObject(obj));
                    });
                    break;
                case 'userGroup':
                    response.objects.forEach((obj)=>{
                        this._userGroups.set(obj.userGroupID, (0, $93EVF.UserGroup).createFromObject(obj));
                    });
                    break;
                case 'bin':
                    if (response.objects.length > 0) this._bin = (0, $bpA0O.Bin).createFromObject(response.objects[0]);
                    break;
            }
        });
    }
    async loadAirCurtains(airCurtainIDs) {
        // load in batch of 100 the air curtains ID passed to the function
        const promises = [];
        const keys = [];
        airCurtainIDs.forEach((airCurtainID)=>{
            if (!this._airCurtains.has(airCurtainID)) {
                keys.push(airCurtainID);
                if (keys.length == 100) {
                    const getAirCurtainsRequest = {
                        objectType: 'airCurtain',
                        keys: [
                            ...keys
                        ]
                    };
                    promises.push((0, $4hGcu.getObjects)([
                        getAirCurtainsRequest
                    ]));
                    keys.length = 0;
                }
            }
        });
        if (keys.length > 0) {
            const getAirCurtainsRequest = {
                objectType: 'airCurtain',
                keys: [
                    ...keys
                ]
            };
            promises.push((0, $4hGcu.getObjects)([
                getAirCurtainsRequest
            ]));
            keys.length = 0;
        }
        if (promises.length > 0) {
            const responses = await Promise.all(promises);
            for(let i = 0; i < responses.length; i++){
                const response = responses[i][0];
                if (response) response.objects.forEach((obj)=>{
                    if (!this._airCurtains.has(obj.airCurtainID)) this._airCurtains.set(obj.airCurtainID, (0, $eXcdI.AirCurtain).createFromObject(obj, undefined));
                });
            }
        }
        return true;
    }
    async loadUsers(userIDs) {
        // load in batch of 100 the user ID passed to the function
        const promises = [];
        const keys = [];
        userIDs.forEach((userID)=>{
            if (!this._users.has(userID)) {
                keys.push(userID);
                if (keys.length == 100) {
                    const getUsersRequest = {
                        objectType: 'user',
                        keys: [
                            ...keys
                        ]
                    };
                    promises.push((0, $4hGcu.getObjects)([
                        getUsersRequest
                    ]));
                    keys.length = 0;
                }
            }
        });
        if (keys.length > 0) {
            const getUsersRequest = {
                objectType: 'user',
                keys: [
                    ...keys
                ]
            };
            promises.push((0, $4hGcu.getObjects)([
                getUsersRequest
            ]));
            keys.length = 0;
        }
        if (promises.length > 0) {
            const responses = await Promise.all(promises);
            for(let i = 0; i < responses.length; i++){
                const response = responses[i][0];
                if (response) response.objects.forEach((obj)=>{
                    if (!this._users.has(obj.userID)) this._users.set(obj.userID, (0, $lz3oz.User).createFromObject(obj));
                });
            }
        }
        return true;
    }
    async loadIdentities(identityIDs) {
        // load in batch of 100 the identity IDs passed to the function
        const promises = [];
        const keys = [];
        identityIDs.forEach((identityID)=>{
            if (!this._identities.has(identityID)) {
                keys.push(identityID);
                if (keys.length == 100) {
                    const getIdentitiesRequest = {
                        objectType: 'identity',
                        keys: [
                            ...keys
                        ]
                    };
                    promises.push((0, $4hGcu.getObjects)([
                        getIdentitiesRequest
                    ]));
                    keys.length = 0;
                }
            }
        });
        if (keys.length > 0) {
            const getIdentitiesRequest = {
                objectType: 'identity',
                keys: [
                    ...keys
                ]
            };
            promises.push((0, $4hGcu.getObjects)([
                getIdentitiesRequest
            ]));
            keys.length = 0;
        }
        if (promises.length > 0) {
            const responses = await Promise.all(promises);
            for(let i = 0; i < responses.length; i++){
                const response = responses[i][0];
                if (response) response.objects.forEach((obj)=>{
                    if (!this._identities.has(obj.identityID)) this._identities.set(obj.identityID, (0, $WPLvD.Identity).createFromObject(obj));
                });
            }
        }
        return true;
    }
    // public async loadAllLazyObjects(): Promise<boolean> {
    //     const promises: Array<Promise<any>> = [];
    //     let getUsers = false;
    //     const getUsersRequest: GetRequest = {
    //         objectType: 'user',
    //         keys: [],
    //     };
    //     this._userGroups.forEach((userGroup) => {
    //         userGroup.users.forEach((userID) => {
    //             if (
    //                 !getUsersRequest.keys.includes(userID) &&
    //                 !this._users.has(userID)
    //             ) {
    //                 getUsersRequest.keys.push(userID);
    //                 getUsers = true;
    //             }
    //         });
    //     });
    //     let getAirCurtains = false;
    //     const getAirCurtainsRequest: GetRequest = {
    //         objectType: 'airCurtain',
    //         keys: [],
    //     };
    //     this._airCurtainGroups.forEach((airCurtainGroup) => {
    //         airCurtainGroup.airCurtains.forEach((airCurtainID) => {
    //             if (
    //                 !getAirCurtainsRequest.keys.includes(airCurtainID) &&
    //                 !this._airCurtains.has(airCurtainID)
    //             ) {
    //                 const getShadowRequest: GetShadowRequest = { airCurtainID };
    //                 promises.push(getShadow(getShadowRequest));
    //                 getAirCurtainsRequest.keys.push(airCurtainID);
    //                 getAirCurtains = true;
    //             }
    //         });
    //     });
    //     let getInvitations = false;
    //     const getInvitationsRequest: GetRequest = {
    //         objectType: 'invitation',
    //         keys: [],
    //     };
    //     this._organization.invitations.forEach((invitationID) => {
    //         if (!getInvitationsRequest.keys.includes(invitationID)) {
    //             getInvitationsRequest.keys.push(invitationID);
    //             getInvitations = true;
    //         }
    //     });
    //     const requests: Array<GetRequest> = [];
    //     if (getUsers) requests.push(getUsersRequest);
    //     if (getAirCurtains) requests.push(getAirCurtainsRequest);
    //     if (getInvitations) requests.push(getInvitationsRequest);
    //     if (requests.length == 0) return true;
    //     promises.push(getObjects(requests));
    //     const responses = await Promise.all(promises);
    //     const shadows: Map<string, AirCurtainShadow2> = new Map<
    //         string,
    //         AirCurtainShadow2
    //     >();
    //     if (getAirCurtains) {
    //         for (let i = 0; i < responses.length - 1; i++) {
    //             shadows.set(responses[i].airCurtainID, responses[i]);
    //         }
    //     }
    //     const getObjectsResponses = responses[responses.length - 1]; // last element
    //     getObjectsResponses.forEach((response: any) => {
    //         switch (response.objectType) {
    //             case 'user':
    //                 response.objects.forEach((obj: omUser) => {
    //                     this._users.set(obj.userID, User.createFromObject(obj));
    //                 });
    //                 break;
    //             case 'airCurtain':
    //                 response.objects.forEach((obj: omAirCurtain) => {
    //                     if (!this._airCurtains.has(obj.airCurtainID)) {
    //                         this._airCurtains.set(
    //                             obj.airCurtainID,
    //                             AirCurtain.createFromObject(
    //                                 obj,
    //                                 shadows.get(obj.airCurtainID),
    //                                 undefined
    //                             )
    //                         ); // installation can't exist because the air curtain is only in mobile app
    //                     }
    //                 });
    //                 break;
    //             case 'invitation':
    //                 response.objects.forEach((obj: omInvitation) => {
    //                     this._invitations.set(
    //                         obj.invitationID,
    //                         Invitation.createFromObject(obj)
    //                     );
    //                 });
    //                 break;
    //         }
    //     });
    //     return true;
    // }
    async getCognitoUser(email) {
        const response = await (0, $4hGcu.getCognitoUser)({
            email: email
        });
        if (response.result) return response.user;
        console.log(response.error);
        return undefined;
    }
    async invite(user, email) {
        console.log('inviting ' + email + ' to join organization');
        if (user.invitationID != undefined) return {
            result: false,
            error: 'user already has an active invitation',
            invitationID: user.invitationID
        };
        const cognitoUser = await this.getCognitoUser(email);
        if (cognitoUser != undefined) return {
            result: false,
            error: "cognito user arleady using this email exists, \
                load identity associated to it. if it doesn't exists you may create it and link it with user \
                else check if account is the same as current one, \
                if so you may link the identity with the user, else, \
                reject the invitation as the cognito user is in another account",
            cognitoUser: cognitoUser
        };
        // create invitation
        const invitation = new (0, $ap51u.Invitation)(email);
        invitation.userID = user.userID;
        invitation.accountID = this._account.accountID;
        invitation.organizationID = this._organization.organizationId;
        invitation.fromUserID = this._user.userID;
        invitation.invitationDate = new Date();
        // link to user and organization
        user.invitationID = invitation.invitationID;
        this._organization.addInvitation(invitation);
        //save invitation, user and organization
        const promises = [];
        promises.push(invitation.save());
        promises.push(this._organization.save());
        promises.push(user.save());
        const results = await Promise.all(promises);
        if (!results[0]) return {
            result: false,
            error: "couldn't save invitation"
        };
        if (!results[1]) return {
            result: false,
            error: "couldn't save organization"
        };
        if (!results[2]) return {
            result: false,
            error: "couldn't save user"
        };
        // send email
        const result = await invitation.sendInvitationEmail();
        if (result) return {
            result: true,
            invitationID: invitation.invitationID
        };
        return {
            result: false,
            error: "couldn't send email"
        };
    }
    getUserAirCurtainsFromMobileAPI() {
        return new Promise((resolve)=>{
            (0, $bNLF2.getListAirCurtainUserRelation)().then((airCurtainShadows)=>{
                const airCurtains = [];
                if (airCurtainShadows) for(const airCurtainID in airCurtainShadows){
                    const airCurtainShdow = airCurtainShadows[airCurtainID];
                    const airCurtain = new (0, $eXcdI.AirCurtain)(airCurtainID);
                    airCurtain.model = airCurtainShdow.model;
                    airCurtain.name = airCurtainShdow.name;
                    airCurtain.heaterPower = airCurtainShdow.heaterPower;
                    airCurtains.push(airCurtain);
                }
                resolve(airCurtains);
            });
        });
    }
}

});
parcelRegister("eXcdI", function(module, exports) {

$parcel$export(module.exports, "AirCurtain", () => $e6fcde1ac1ce3d95$export$8c2caad290cfb05d);

var $4hGcu = parcelRequire("4hGcu");
const $e6fcde1ac1ce3d95$var$objectType = 'airCurtain';
class $e6fcde1ac1ce3d95$export$8c2caad290cfb05d {
    constructor(airCurtainID){
        this._saveMethod = (0, $4hGcu.createObjects);
        this._object = {
            name: undefined,
            airCurtainID: airCurtainID,
            airCurtainGroups: [],
            connected: undefined,
            connectivityTimestamp: undefined,
            eccPub: undefined,
            heaterPower: undefined,
            model: undefined,
            pairingKey: undefined
        };
    }
    static createNew(airCurtainID) {
        return new $e6fcde1ac1ce3d95$export$8c2caad290cfb05d(airCurtainID);
    }
    static createFromObject(airCurtain, shadow) {
        const obj = new $e6fcde1ac1ce3d95$export$8c2caad290cfb05d(airCurtain.airCurtainID);
        obj._object = airCurtain;
        obj._shadow = shadow;
        obj._saveMethod = (0, $4hGcu.updateObjects);
        return obj;
    }
    async load() {
        const getObject = {
            objectType: $e6fcde1ac1ce3d95$var$objectType,
            keys: [
                this._object.airCurtainID
            ]
        };
        const getShadowRequest = {
            airCurtainID: this._object.airCurtainID
        };
        this._lastError = undefined;
        try {
            const response = await (0, $4hGcu.getObjects)([
                getObject
            ]);
            if (response && response.length > 0 && response[0].objects && response[0].objects.length == 1) {
                this._saveMethod = (0, $4hGcu.updateObjects);
                this._object = response[0].objects[0];
                this._shadow = await (0, $4hGcu.getShadow)(getShadowRequest);
                return true;
            } else {
                this._lastError = new Error('air curtain not found');
                return false;
            }
        } catch (error) {
            this._lastError = error;
            return false;
        }
    }
    async refreshShadow() {
        const getShadowRequest = {
            airCurtainID: this._object.airCurtainID
        };
        this._lastError = undefined;
        try {
            this._shadow = await (0, $4hGcu.getShadow)(getShadowRequest);
            return true;
        } catch (error) {
            this._lastError = error;
            return false;
        }
    }
    async saveProperties() {
        const saveObject = {
            objectType: $e6fcde1ac1ce3d95$var$objectType,
            object: this._object
        };
        this._lastError = undefined;
        if (this._object.name == undefined) {
            this._lastError = new Error('Name is undefined');
            return false;
        }
        if (this._object.heaterPower == undefined) {
            this._lastError = new Error('Heater Power is undefined');
            return false;
        }
        if (this._object.model == undefined) {
            this._lastError = new Error('Model is undefined');
            return false;
        }
        try {
            const response = await this._saveMethod([
                saveObject
            ]);
            if (response) this._saveMethod = (0, $4hGcu.updateObjects);
            else this._lastError = new Error('unknown server error');
            return response;
        } catch (error) {
            this._lastError = error;
            return false;
        }
    }
    async saveAirCurtainDesired(desired) {
        const updateShadowRequest = {
            airCurtainID: this._object.airCurtainID,
            desired: desired
        };
        this._lastError = undefined;
        try {
            const response = await (0, $4hGcu.updateShadow)(updateShadowRequest);
            if (!response) this._lastError = new Error('unknown server error');
            return response;
        } catch (error) {
            this._lastError = error;
            return false;
        }
    }
    // public async delete() {
    //     const deleteObject:CreateUpdateDeleteRequest = {
    //         objectType: objectType,
    //         object: this._object
    //     };
    //     return new Promise(resolve => deleteObjects([deleteObject]).then(response => resolve(response)));
    // }
    //object properties
    get lastError() {
        return this._lastError;
    }
    get airCurtainID() {
        return this._object.airCurtainID;
    }
    get name() {
        return this._object.name;
    }
    set name(name) {
        this._object.name = name;
    }
    get airCurtainGroups() {
        if (this._object.airCurtainGroups === undefined) this._object.airCurtainGroups = [];
        return this._object.airCurtainGroups;
    }
    addAirCurtainGroup(airCurtainGroup) {
        if (this._object.airCurtainGroups.includes(airCurtainGroup.airCurtainGroupID)) return;
        this._object.airCurtainGroups.push(airCurtainGroup.airCurtainGroupID);
    }
    deleteAirCurtainGroup(airCurtainGroup) {
        const index = this._object.airCurtainGroups.indexOf(airCurtainGroup.airCurtainGroupID);
        if (index > -1) this._object.airCurtainGroups.splice(index, 1);
    }
    get connected() {
        return this._object.connected;
    }
    get connectivityTimestamp() {
        return this._object.connectivityTimestamp;
    }
    get eccPub() {
        return this._object.eccPub;
    }
    get heaterPower() {
        return this._object.heaterPower;
    }
    set heaterPower(heaterPower) {
        this._object.heaterPower = heaterPower;
    }
    get model() {
        return this._object.model;
    }
    set model(model) {
        this._object.model = model;
    }
    get pairingKey() {
        return this._object.pairingKey;
    }
    get provisionedTimestamp() {
        return this._object.provisionedTimestamp;
    }
    // shadow properties
    get isShadowLoaded() {
        return this._shadow != undefined;
    }
    get bacnetConfiguration() {
        if (!this.isShadowLoaded) return undefined;
        return this._shadow.bacnetConfiguration ? {
            enabled: this._shadow.bacnetConfiguration.enabled,
            deviceName: this._shadow.bacnetConfiguration.deviceName,
            deviceId: this._shadow.bacnetConfiguration.deviceId,
            udpPort: this._shadow.bacnetConfiguration.udpPort,
            bbmdEnabled: this._shadow.bacnetConfiguration.bbmdEnabled,
            bbmdAddress: this._shadow.bacnetConfiguration.bbmdAddress,
            bbmdPort: this._shadow.bacnetConfiguration.bbmdPort,
            bbmdTtl: this._shadow.bacnetConfiguration.bbmdTtl,
            interface: this._shadow.bacnetConfiguration.interface
        } : undefined;
    }
    async setBacnetConfiguration(bacnetConfiguration) {
        if (!this.isShadowLoaded) return false;
        const bacnetConfigurationShadow = {
            enabled: bacnetConfiguration.enabled != undefined ? bacnetConfiguration.enabled : this._shadow.bacnetConfiguration.enabled,
            deviceName: bacnetConfiguration.deviceName != undefined ? bacnetConfiguration.deviceName : this._shadow.bacnetConfiguration.deviceName,
            deviceId: bacnetConfiguration.deviceId != undefined ? bacnetConfiguration.deviceId : this._shadow.bacnetConfiguration.deviceId,
            udpPort: bacnetConfiguration.udpPort != undefined ? bacnetConfiguration.udpPort : this._shadow.bacnetConfiguration.udpPort,
            bbmdEnabled: bacnetConfiguration.bbmdEnabled != undefined ? bacnetConfiguration.bbmdEnabled : this._shadow.bacnetConfiguration.bbmdEnabled,
            bbmdAddress: bacnetConfiguration.bbmdAddress != undefined ? bacnetConfiguration.bbmdAddress : this._shadow.bacnetConfiguration.bbmdAddress,
            bbmdPort: bacnetConfiguration.bbmdPort != undefined ? bacnetConfiguration.bbmdPort : this._shadow.bacnetConfiguration.bbmdPort,
            bbmdTtl: bacnetConfiguration.bbmdTtl != undefined ? bacnetConfiguration.bbmdTtl : this._shadow.bacnetConfiguration.bbmdTtl,
            interface: bacnetConfiguration.interface != undefined ? bacnetConfiguration.interface : this._shadow.bacnetConfiguration.interface
        };
        const desired = {
            bacnetConfiguration: bacnetConfigurationShadow
        };
        const result = await this.saveAirCurtainDesired(desired);
        if (result) this._shadow.bacnetConfiguration = bacnetConfigurationShadow;
        return result;
    }
    get cpuSerial() {
        if (!this.isShadowLoaded) return undefined;
        if (this._shadow.cpuSerial) return this._shadow.cpuSerial.replace(/^[0]+/g, '');
        else return 'N/A';
    }
    get doorState() {
        if (!this.isShadowLoaded) return undefined;
        return this._shadow.doorState;
    }
    get doorOpenCount() {
        if (!this.isShadowLoaded) return undefined;
        return this._shadow.doorOpenCount;
    }
    get eth0Ip() {
        if (!this.isShadowLoaded) return undefined;
        return this._shadow.eth0Ip;
    }
    get eth0Mac() {
        if (!this.isShadowLoaded) return undefined;
        return this._shadow.eth0Mac;
    }
    get externalThermostatContactState() {
        if (!this.isShadowLoaded) return undefined;
        return this._shadow.externalThermostatContactState;
    }
    get thermostatProbeModeState() {
        if (!this.isShadowLoaded) return undefined;
        return this._shadow.thermostatProbeModeState;
    }
    get heaterRelayState() {
        if (!this.isShadowLoaded) return undefined;
        return this._shadow.heaterRelayState;
    }
    get sensorTemperature() {
        if (!this.isShadowLoaded) return undefined;
        return this._shadow.temperature;
    }
    get intelliswitchVersion() {
        if (!this.isShadowLoaded) return undefined;
        return this._shadow.intelliswitchVersion;
    }
    get lineFrequency() {
        if (!this.isShadowLoaded) return undefined;
        return this._shadow.lineFrequency;
    }
    get mode() {
        if (!this.isShadowLoaded) return undefined;
        return this._shadow.modeState;
    }
    async setMode(mode) {
        if (!this.isShadowLoaded) return false;
        const desired = {
            modeState: mode
        };
        const result = await this.saveAirCurtainDesired(desired);
        if (result) this._shadow.modeState = mode;
        return result;
    }
    get motorRpm() {
        if (!this.isShadowLoaded) return undefined;
        return this._shadow.motorRpm;
    }
    get osVersion() {
        if (!this.isShadowLoaded) return undefined;
        return this._shadow.osVersion;
    }
    get wcsVersion() {
        if (!this.isShadowLoaded) return undefined;
        return this._shadow.wcsVersion;
    }
    get pureMode() {
        if (!this.isShadowLoaded) return undefined;
        return this._shadow.pureMode;
    }
    get schedule() {
        if (!this.isShadowLoaded) return undefined;
        return this._shadow.schedule ? {
            enabled: this._shadow.schedule.enabled,
            events: this._shadow.schedule.events ? this._shadow.schedule.events.map((item)=>{
                return {
                    dayMinute: item.day_minute,
                    mode: item.mode,
                    weekDay: item.week_day,
                    enabled: item.enabled
                };
            }) : []
        } : undefined;
    }
    async setSchedule(schedule) {
        if (!this.isShadowLoaded) return false;
        const scheduleShadow = {
            enabled: schedule.enabled,
            events: schedule.events.map((item)=>{
                return {
                    day_minute: item.dayMinute,
                    mode: item.mode,
                    week_day: item.weekDay,
                    enabled: item.enabled
                };
            })
        };
        const desired = {
            schedule: scheduleShadow
        };
        const result = await this.saveAirCurtainDesired(desired);
        if (result) this._shadow.schedule = scheduleShadow;
        return result;
    }
    get fanSpeed() {
        if (!this.isShadowLoaded) return undefined;
        return this._shadow.fanSpeed;
    }
    async setFanSpeed(fanSpeed) {
        if (!this.isShadowLoaded) return false;
        const desired = {
            fanSpeed: fanSpeed
        };
        const result = await this.saveAirCurtainDesired(desired);
        if (result) this._shadow.fanSpeed = fanSpeed;
        return result;
    }
    // fan speeds
    get fanSpeeds() {
        if (!this.isShadowLoaded) return undefined;
        switch(this._shadow.speedRange){
            case 3:
            case 4:
            case 5:
                return 1;
            case 10:
            case 11:
                return 2;
            case 6:
            case 7:
            case 8:
            case 9:
                return 3;
            case 0:
            case 1:
            case 2:
            case 12:
            case 13:
            case 14:
            case 15:
            case 16:
            case 20:
            case 21:
            case 22:
            case 23:
            case 30:
            case 31:
            case 32:
            case 33:
            case 40:
            case 41:
            case 42:
            case 43:
                return 10;
            default:
                return 0;
        }
    }
    // has speed control
    get hasSpeedControl() {
        if (!this.isShadowLoaded) return undefined;
        return this.fanSpeeds > 0;
    }
    // has thermostat
    get hasThermostat() {
        if (!this.isShadowLoaded) return undefined;
        switch(this._shadow.speedRange){
            case 2:
            case 4:
            case 5:
            case 7:
            case 9:
            case 11:
            case 12:
            case 14:
            case 16:
            case 21:
            case 23:
            case 31:
            case 33:
            case 41:
            case 43:
                return true;
            default:
                return false;
        }
    }
    get speedRange() {
        if (!this.isShadowLoaded) return undefined;
        return this._shadow.speedRange;
    }
    get temperatureSetPoint() {
        if (!this.isShadowLoaded) return undefined;
        return this._shadow.temperatureSetPoint;
    }
    async setTemperatureSetPoint(temperatureSetPoint) {
        if (!this.isShadowLoaded) return false;
        const desired = {
            temperatureSetPoint: temperatureSetPoint
        };
        const result = await this.saveAirCurtainDesired(desired);
        if (result) this._shadow.temperatureSetPoint = temperatureSetPoint;
        return result;
    }
    get timeDelay() {
        if (!this.isShadowLoaded) return undefined;
        return this._shadow.timeDelay;
    }
    async setTimeDelay(timeDelay) {
        if (!this.isShadowLoaded) return false;
        const desired = {
            timeDelay: timeDelay
        };
        const result = await this.saveAirCurtainDesired(desired);
        if (result) this._shadow.timeDelay = timeDelay;
        return result;
    }
    get maxTimestamp() {
        if (!this.isShadowLoaded) return undefined;
        return this._shadow.maxTimestamp;
    }
    get timezone() {
        if (!this.isShadowLoaded) return undefined;
        return this._shadow.timezone;
    }
    async setTimezone(timezone) {
        if (!this.isShadowLoaded) return false;
        const desired = {
            timezone: timezone
        };
        const result = await this.saveAirCurtainDesired(desired);
        if (result) this._shadow.timezone = timezone;
        return result;
    }
    get version() {
        if (!this.isShadowLoaded) return undefined;
        return this._shadow.version;
    }
    get wifiSSID() {
        if (!this.isShadowLoaded) return undefined;
        return this._shadow.wifiSSID;
    }
    get wlan0Ip() {
        if (!this.isShadowLoaded) return undefined;
        return this._shadow.wlan0Ip;
    }
    get wlan0Mac() {
        if (!this.isShadowLoaded) return undefined;
        return this._shadow.wlan0Mac;
    }
}

});

parcelRegister("cE472", function(module, exports) {

$parcel$export(module.exports, "Account", () => $3d2fa0cc0af07853$export$1ed4b10e4aba04a7);

var $4hGcu = parcelRequire("4hGcu");

var $gAjJp = parcelRequire("gAjJp");
const $3d2fa0cc0af07853$var$objectType = 'account';
class $3d2fa0cc0af07853$export$1ed4b10e4aba04a7 {
    constructor(accountID){
        this._saveMethod = (0, $4hGcu.createObjects);
        this._object = {
            accountID: accountID,
            name: undefined,
            ownerUserID: undefined,
            organizationID: undefined,
            binID: undefined
        };
    }
    static createNew() {
        return new $3d2fa0cc0af07853$export$1ed4b10e4aba04a7((0, $gAjJp.default)());
    }
    static createFromObject(account) {
        const obj = new $3d2fa0cc0af07853$export$1ed4b10e4aba04a7(account.accountID);
        obj._object = account;
        obj._saveMethod = (0, $4hGcu.updateObjects);
        return obj;
    }
    async load() {
        const getObject = {
            objectType: $3d2fa0cc0af07853$var$objectType,
            keys: [
                this._object.accountID
            ]
        };
        this._lastError = undefined;
        try {
            const response = await (0, $4hGcu.getObjects)([
                getObject
            ]);
            if (response && response.length > 0 && response[0].objects && response[0].objects.length == 1) {
                this._saveMethod = (0, $4hGcu.updateObjects);
                this._object = response[0].objects[0];
                return true;
            } else {
                this._lastError = new Error('account not found');
                return false;
            }
        } catch (error) {
            this._lastError = error;
            return false;
        }
    }
    async save() {
        const saveObject = {
            objectType: $3d2fa0cc0af07853$var$objectType,
            object: this._object
        };
        this._lastError = undefined;
        if (this._object.name == undefined) {
            this._lastError = new Error('Name is undefined');
            return false;
        }
        if (this._object.organizationID == undefined) {
            this._lastError = new Error('Organization ID is undefined');
            return false;
        }
        if (this._object.ownerUserID == undefined) {
            this._lastError = new Error('Owner User ID is undefined');
            return false;
        }
        try {
            const response = await this._saveMethod([
                saveObject
            ]);
            if (response) this._saveMethod = (0, $4hGcu.updateObjects);
            else this._lastError = new Error('unknow server error');
            return response;
        } catch (error) {
            this._lastError = error;
            return false;
        }
    }
    async delete() {
        const deleteObject = {
            objectType: $3d2fa0cc0af07853$var$objectType,
            object: this._object
        };
        this._lastError = undefined;
        try {
            const response = await (0, $4hGcu.deleteObjects)([
                deleteObject
            ]);
            return response;
        } catch (error) {
            this._lastError = error;
            return false;
        }
    }
    get lastError() {
        return this._lastError;
    }
    get accountID() {
        return this._object.accountID;
    }
    get binID() {
        return this._object.binID;
    }
    set binID(binID) {
        this._object.binID = binID;
    }
    get name() {
        return this._object.name;
    }
    set name(name) {
        this._object.name = name;
    }
    get organizationID() {
        return this._object.organizationID;
    }
    set organizationID(organizationID) {
        this._object.organizationID = organizationID;
    }
    get ownerUserID() {
        return this._object.ownerUserID;
    }
    set ownerUserID(ownerUserID) {
        this._object.ownerUserID = ownerUserID;
    }
}

});

parcelRegister("WPLvD", function(module, exports) {

$parcel$export(module.exports, "Identity", () => $46081fbd48ef9452$export$544bf02140fa9a77);

var $4hGcu = parcelRequire("4hGcu");
const $46081fbd48ef9452$var$objectType = 'identity';
class $46081fbd48ef9452$export$544bf02140fa9a77 {
    constructor(identityID){
        this._saveMethod = (0, $4hGcu.createObjects);
        this._object = {
            identityID: identityID,
            email: undefined,
            firstLogin: undefined,
            lastLogin: undefined,
            users: []
        };
    }
    static createFromObject(identity) {
        const obj = new $46081fbd48ef9452$export$544bf02140fa9a77(identity.identityID);
        obj._object = identity;
        obj._saveMethod = (0, $4hGcu.updateObjects);
        return obj;
    }
    async load() {
        const getObject = {
            objectType: $46081fbd48ef9452$var$objectType,
            keys: [
                this._object.identityID
            ]
        };
        this._lastError = undefined;
        try {
            const response = await (0, $4hGcu.getObjects)([
                getObject
            ]);
            if (response && response.length > 0 && response[0].objects && response[0].objects.length == 1) {
                this._saveMethod = (0, $4hGcu.updateObjects);
                this._object = response[0].objects[0];
                return true;
            } else {
                this._lastError = new Error('identity not found');
                return false;
            }
        } catch (error) {
            this._lastError = error;
            return false;
        }
    }
    async save() {
        const saveObject = {
            objectType: $46081fbd48ef9452$var$objectType,
            object: this._object
        };
        this._lastError = undefined;
        if (this._object.email == undefined) {
            this._lastError = new Error('Name is undefined');
            return false;
        }
        try {
            const response = await this._saveMethod([
                saveObject
            ]);
            if (response) this._saveMethod = (0, $4hGcu.updateObjects);
            else this._lastError = new Error('unknow server error');
            return response;
        } catch (error) {
            this._lastError = error;
            return false;
        }
    }
    async delete() {
        const deleteObject = {
            objectType: $46081fbd48ef9452$var$objectType,
            object: this._object
        };
        this._lastError = undefined;
        try {
            const response = await (0, $4hGcu.deleteObjects)([
                deleteObject
            ]);
            return response;
        } catch (error) {
            this._lastError = error;
            return false;
        }
    }
    async loadCognitoUser() {
        if (!this._cognitoUser) {
            const getCognitoUserRequest = {
                email: this._object.email
            };
            this._cognitoUser = await (0, $4hGcu.getCognitoUser)(getCognitoUserRequest);
        }
        return true;
    }
    get cognitoUser() {
        return this._cognitoUser;
    }
    get lastError() {
        return this._lastError;
    }
    get identityID() {
        return this._object.identityID;
    }
    get email() {
        return this._object.email;
    }
    set email(email) {
        this._object.email = email;
    }
    get firstLogin() {
        if (this._object.firstLogin) return new Date(this._object.firstLogin);
        return undefined;
    }
    get lastLogin() {
        if (this._object.lastLogin) return new Date(this._object.lastLogin);
        return undefined;
    }
    get users() {
        return this._object.users;
    }
    addUser(user) {
        if (this._object.users.includes(user.userID)) return;
        this._object.users.push(user.userID);
    }
    deleteUser(user) {
        const index = this._object.users.indexOf(user.userID);
        if (index > -1) this._object.users.splice(index, 1);
    }
}

});

parcelRegister("gdtFo", function(module, exports) {

$parcel$export(module.exports, "Organization", () => $0fc2e7b1bcd7a249$export$f3a6aa388b70f149);

var $4hGcu = parcelRequire("4hGcu");

var $gAjJp = parcelRequire("gAjJp");
const $0fc2e7b1bcd7a249$var$objectType = 'organization';
class $0fc2e7b1bcd7a249$export$f3a6aa388b70f149 {
    constructor(organizationID){
        this._saveMethod = (0, $4hGcu.createObjects);
        this._object = {
            organizationID: organizationID,
            accountID: undefined,
            name: undefined,
            groups: [],
            userGroups: [],
            siteGroups: [],
            roles: [],
            policies: [],
            invitations: []
        };
    }
    static createNew() {
        return new $0fc2e7b1bcd7a249$export$f3a6aa388b70f149((0, $gAjJp.default)());
    }
    static createFromObject(organization) {
        const obj = new $0fc2e7b1bcd7a249$export$f3a6aa388b70f149(organization.organizationID);
        obj._object = organization;
        obj._saveMethod = (0, $4hGcu.updateObjects);
        return obj;
    }
    async load() {
        const getObject = {
            objectType: $0fc2e7b1bcd7a249$var$objectType,
            keys: [
                this._object.organizationID
            ]
        };
        this._lastError = undefined;
        try {
            const response = await (0, $4hGcu.getObjects)([
                getObject
            ]);
            if (response && response.length > 0 && response[0].objects && response[0].objects.length == 1) {
                this._saveMethod = (0, $4hGcu.updateObjects);
                this._object = response[0].objects[0];
                return true;
            } else {
                this._lastError = new Error('organization not found');
                return false;
            }
        } catch (error) {
            this._lastError = error;
            return false;
        }
    }
    async save() {
        const saveObject = {
            objectType: $0fc2e7b1bcd7a249$var$objectType,
            object: this._object
        };
        this._lastError = undefined;
        if (this._object.name == undefined) {
            this._lastError = new Error('Name is undefined');
            return false;
        }
        if (this._object.accountID == undefined) {
            this._lastError = new Error('Account ID is undefined');
            return false;
        }
        try {
            const response = await this._saveMethod([
                saveObject
            ]);
            if (response) this._saveMethod = (0, $4hGcu.updateObjects);
            else this._lastError = new Error('unknown server error');
            return response;
        } catch (error) {
            this._lastError = error;
            return false;
        }
    }
    async delete() {
        const deleteObject = {
            objectType: $0fc2e7b1bcd7a249$var$objectType,
            object: this._object
        };
        this._lastError = undefined;
        try {
            const response = await (0, $4hGcu.deleteObjects)([
                deleteObject
            ]);
            return response;
        } catch (error) {
            this._lastError = error;
            return false;
        }
    }
    get lastError() {
        return this._lastError;
    }
    get organizationId() {
        return this._object.organizationID;
    }
    get accountID() {
        return this._object.accountID;
    }
    set accountID(accountID) {
        this._object.accountID = accountID;
    }
    get name() {
        return this._object.name;
    }
    set name(name) {
        this._object.name = name;
    }
    get groups() {
        return this._object.groups;
    }
    addGroup(group) {
        if (this._object.groups.includes(group.groupID)) return;
        this._object.groups.push(group.groupID);
    }
    deleteGroup(group) {
        const index = this._object.groups.indexOf(group.groupID);
        if (index > -1) this._object.groups.splice(index, 1);
    }
    get userGroups() {
        return this._object.userGroups;
    }
    addUserGroup(userGroup) {
        if (this._object.userGroups.includes(userGroup.userGroupID)) return;
        this._object.userGroups.push(userGroup.userGroupID);
    }
    deleteUserGroup(userGroup) {
        const index = this._object.userGroups.indexOf(userGroup.userGroupID);
        if (index > -1) this._object.userGroups.splice(index, 1);
    }
    get siteGroups() {
        return this._object.siteGroups;
    }
    addSiteGroup(siteGroup) {
        if (this._object.siteGroups.includes(siteGroup.siteGroupID)) return;
        this._object.siteGroups.push(siteGroup.siteGroupID);
    }
    deleteSiteGroup(siteGroup) {
        const index = this._object.siteGroups.indexOf(siteGroup.siteGroupID);
        if (index > -1) this._object.siteGroups.splice(index, 1);
    }
    get roles() {
        return this._object.roles;
    }
    addRole(role) {
        if (this._object.roles.includes(role.roleID)) return;
        this._object.roles.push(role.roleID);
    }
    deleteRole(role) {
        const index = this._object.roles.indexOf(role.roleID);
        if (index > -1) this._object.roles.splice(index, 1);
    }
    get policies() {
        return this._object.policies;
    }
    addPolicy(policy) {
        if (this._object.policies.includes(policy.policyID)) return;
        this._object.policies.push(policy.policyID);
    }
    deletePolicy(policy) {
        const index = this._object.policies.indexOf(policy.policyID);
        if (index > -1) this._object.policies.splice(index, 1);
    }
    get invitations() {
        return this._object.invitations;
    }
    addInvitation(invitation) {
        if (this._object.invitations.includes(invitation.invitationID)) return;
        this._object.invitations.push(invitation.invitationID);
    }
    deleteInvitation(invitation) {
        const index = this._object.invitations.indexOf(invitation.invitationID);
        if (index > -1) this._object.invitations.splice(index, 1);
    }
}

});

parcelRegister("4YMO4", function(module, exports) {

$parcel$export(module.exports, "Role", () => $19eb797bbce89973$export$46919bad18fb2f76);

var $4hGcu = parcelRequire("4hGcu");

var $gAjJp = parcelRequire("gAjJp");
const $19eb797bbce89973$var$objectType = 'role';
class $19eb797bbce89973$export$46919bad18fb2f76 {
    constructor(roleID){
        this._saveMethod = (0, $4hGcu.createObjects);
        this._object = {
            roleID: roleID,
            name: undefined,
            policies: []
        };
    }
    static createNew() {
        return new $19eb797bbce89973$export$46919bad18fb2f76((0, $gAjJp.default)());
    }
    static createFromObject(role) {
        const obj = new $19eb797bbce89973$export$46919bad18fb2f76(role.roleID);
        obj._object = role;
        obj._saveMethod = (0, $4hGcu.updateObjects);
        return obj;
    }
    async load() {
        const getObject = {
            objectType: $19eb797bbce89973$var$objectType,
            keys: [
                this._object.roleID
            ]
        };
        this._lastError = undefined;
        try {
            const response = await (0, $4hGcu.getObjects)([
                getObject
            ]);
            if (response && response.length > 0 && response[0].objects && response[0].objects.length == 1) {
                this._saveMethod = (0, $4hGcu.updateObjects);
                this._object = response[0].objects[0];
                return true;
            } else {
                this._lastError = new Error('role not found');
                return false;
            }
        } catch (error) {
            this._lastError = error;
            return false;
        }
    }
    async save() {
        const saveObject = {
            objectType: $19eb797bbce89973$var$objectType,
            object: this._object
        };
        this._lastError = undefined;
        if (this._object.name == undefined) {
            this._lastError = new Error('Name is undefined');
            return false;
        }
        try {
            const response = await this._saveMethod([
                saveObject
            ]);
            if (response) this._saveMethod = (0, $4hGcu.updateObjects);
            else this._lastError = new Error('unknow server error');
            return response;
        } catch (error) {
            this._lastError = error;
            return false;
        }
    }
    async delete() {
        const deleteObject = {
            objectType: $19eb797bbce89973$var$objectType,
            object: this._object
        };
        this._lastError = undefined;
        try {
            const response = await (0, $4hGcu.deleteObjects)([
                deleteObject
            ]);
            return response;
        } catch (error) {
            this._lastError = error;
            return false;
        }
    }
    get lastError() {
        return this._lastError;
    }
    get roleID() {
        return this._object.roleID;
    }
    get name() {
        return this._object.name;
    }
    set name(name) {
        this._object.name = name;
    }
    get policies() {
        return this._object.policies;
    }
    addPolicy(policy) {
        if (this._object.policies.includes(policy.policyID)) return;
        this._object.policies.push(policy.policyID);
    }
    deletePolicy(policy) {
        const index = this._object.policies.indexOf(policy.policyID);
        if (index > -1) this._object.policies.splice(index, 1);
    }
}

});

parcelRegister("1phGj", function(module, exports) {

$parcel$export(module.exports, "Site", () => $3315a340ddf05bb0$export$ca6fd6057d03ddab);

var $4hGcu = parcelRequire("4hGcu");

var $gAjJp = parcelRequire("gAjJp");
const $3315a340ddf05bb0$var$objectType = 'site';
class $3315a340ddf05bb0$export$ca6fd6057d03ddab {
    constructor(siteID){
        this._saveMethod = (0, $4hGcu.createObjects);
        this._object = {
            siteID: siteID,
            accountID: undefined,
            name: undefined,
            siteGroupID: undefined,
            groups: [],
            airCurtainGroups: [],
            userGroups: [],
            siteGroups: [],
            roles: [],
            policies: []
        };
    }
    static createNew() {
        return new $3315a340ddf05bb0$export$ca6fd6057d03ddab((0, $gAjJp.default)());
    }
    static createFromObject(site) {
        const obj = new $3315a340ddf05bb0$export$ca6fd6057d03ddab(site.siteID);
        obj._object = site;
        obj._saveMethod = (0, $4hGcu.updateObjects);
        return obj;
    }
    async load() {
        const getObject = {
            objectType: $3315a340ddf05bb0$var$objectType,
            keys: [
                this._object.siteID
            ]
        };
        this._lastError = undefined;
        try {
            const response = await (0, $4hGcu.getObjects)([
                getObject
            ]);
            if (response && response.length > 0 && response[0].objects && response[0].objects.length == 1) {
                this._saveMethod = (0, $4hGcu.updateObjects);
                this._object = response[0].objects[0];
                return true;
            } else {
                this._lastError = new Error('site not found');
                return false;
            }
        } catch (error) {
            this._lastError = error;
            return false;
        }
    }
    async save() {
        const saveObject = {
            objectType: $3315a340ddf05bb0$var$objectType,
            object: this._object
        };
        this._lastError = undefined;
        if (this._object.name == undefined) {
            this._lastError = new Error('Name is undefined');
            return false;
        }
        if (this._object.accountID == undefined) {
            this._lastError = new Error('Account ID is undefined');
            return false;
        }
        if (this._object.siteGroupID == undefined) {
            this._lastError = new Error('Site Group ID is undefined');
            return false;
        }
        try {
            const response = await this._saveMethod([
                saveObject
            ]);
            if (response) this._saveMethod = (0, $4hGcu.updateObjects);
            else this._lastError = new Error('unknow server error');
            return response;
        } catch (error) {
            this._lastError = error;
            return false;
        }
    }
    async delete() {
        const deleteObject = {
            objectType: $3315a340ddf05bb0$var$objectType,
            object: this._object
        };
        this._lastError = undefined;
        try {
            const response = await (0, $4hGcu.deleteObjects)([
                deleteObject
            ]);
            return response;
        } catch (error) {
            this._lastError = error;
            return false;
        }
    }
    async getCurrentWeather() {
        const getWeatherRequest = {
            siteID: this._object.siteID,
            language: 'en'
        };
        this._lastError = undefined;
        try {
            return await (0, $4hGcu.getSiteCurrentWeather)(getWeatherRequest);
        } catch (error) {
            this._lastError = error;
            return undefined;
        }
    }
    get lastError() {
        return this._lastError;
    }
    get siteID() {
        return this._object.siteID;
    }
    get accountID() {
        return this._object.accountID;
    }
    set accountID(accountID) {
        this._object.accountID = accountID;
    }
    get name() {
        return this._object.name;
    }
    set name(name) {
        this._object.name = name;
    }
    get siteGroupID() {
        return this._object.siteGroupID;
    }
    set siteGroupID(siteGroupID) {
        this._object.siteGroupID = siteGroupID;
    }
    get groups() {
        return this._object.groups;
    }
    addGroup(group) {
        if (this._object.groups.includes(group.groupID)) return;
        this._object.groups.push(group.groupID);
    }
    deleteGroup(group) {
        const index = this._object.groups.indexOf(group.groupID);
        if (index > -1) this._object.groups.splice(index, 1);
    }
    get userGroups() {
        return this._object.userGroups;
    }
    addUserGroup(userGroup) {
        if (this._object.userGroups.includes(userGroup.userGroupID)) return;
        this._object.userGroups.push(userGroup.userGroupID);
    }
    deleteUserGroup(userGroup) {
        const index = this._object.userGroups.indexOf(userGroup.userGroupID);
        if (index > -1) this._object.userGroups.splice(index, 1);
    }
    get siteGroups() {
        return this._object.siteGroups;
    }
    addSiteGroup(siteGroup) {
        if (this._object.siteGroups.includes(siteGroup.siteGroupID)) return;
        this._object.siteGroups.push(siteGroup.siteGroupID);
    }
    deleteSiteGroup(siteGroup) {
        const index = this._object.siteGroups.indexOf(siteGroup.siteGroupID);
        if (index > -1) this._object.siteGroups.splice(index, 1);
    }
    get airCurtainGroups() {
        return this._object.airCurtainGroups;
    }
    addAirCurtainGroup(airCurtainGroup) {
        if (this._object.airCurtainGroups.includes(airCurtainGroup.airCurtainGroupID)) return;
        this._object.airCurtainGroups.push(airCurtainGroup.airCurtainGroupID);
    }
    deleteAirCurtainGroup(airCurtainGroup) {
        const index = this._object.airCurtainGroups.indexOf(airCurtainGroup.airCurtainGroupID);
        if (index > -1) this._object.airCurtainGroups.splice(index, 1);
    }
    get roles() {
        return this._object.roles;
    }
    addRole(role) {
        if (this._object.roles.includes(role.roleID)) return;
        this._object.roles.push(role.roleID);
    }
    deleteRole(role) {
        const index = this._object.roles.indexOf(role.roleID);
        if (index > -1) this._object.roles.splice(index, 1);
    }
    get policies() {
        return this._object.policies;
    }
    addPolicy(policy) {
        if (this._object.policies.includes(policy.policyID)) return;
        this._object.policies.push(policy.policyID);
    }
    deletePolicy(policy) {
        const index = this._object.policies.indexOf(policy.policyID);
        if (index > -1) this._object.policies.splice(index, 1);
    }
}

});

parcelRegister("bQWlT", function(module, exports) {

$parcel$export(module.exports, "SiteGroup", () => $24f543eff32d4be5$export$9e40fb01638b8dff);

var $4hGcu = parcelRequire("4hGcu");

var $gAjJp = parcelRequire("gAjJp");
const $24f543eff32d4be5$var$objectType = 'siteGroup';
class $24f543eff32d4be5$export$9e40fb01638b8dff {
    constructor(siteGroupID){
        this._saveMethod = (0, $4hGcu.createObjects);
        this._object = {
            siteGroupID: siteGroupID,
            accountID: undefined,
            name: undefined,
            parentObjectType: undefined,
            parentObjectID: undefined,
            sites: [],
            roles: [],
            policies: []
        };
    }
    static createNew() {
        return new $24f543eff32d4be5$export$9e40fb01638b8dff((0, $gAjJp.default)());
    }
    static createFromObject(siteGroup) {
        const obj = new $24f543eff32d4be5$export$9e40fb01638b8dff(siteGroup.siteGroupID);
        obj._object = siteGroup;
        obj._saveMethod = (0, $4hGcu.updateObjects);
        return obj;
    }
    async load() {
        const getObject = {
            objectType: $24f543eff32d4be5$var$objectType,
            keys: [
                this._object.siteGroupID
            ]
        };
        this._lastError = undefined;
        try {
            const response = await (0, $4hGcu.getObjects)([
                getObject
            ]);
            if (response && response.length > 0 && response[0].objects && response[0].objects.length == 1) {
                this._saveMethod = (0, $4hGcu.updateObjects);
                this._object = response[0].objects[0];
                return true;
            } else {
                this._lastError = new Error('site group not found');
                return false;
            }
        } catch (error) {
            this._lastError = error;
            return false;
        }
    }
    async save() {
        const saveObject = {
            objectType: $24f543eff32d4be5$var$objectType,
            object: this._object
        };
        this._lastError = undefined;
        if (this._object.name == undefined) {
            this._lastError = new Error('Name is undefined');
            return false;
        }
        if (this._object.accountID == undefined) {
            this._lastError = new Error('Account ID is undefined');
            return false;
        }
        if (this._object.parentObjectType == undefined) {
            this._lastError = new Error('Parent Group Type is undefined');
            return false;
        }
        if (this._object.parentObjectID == undefined) {
            this._lastError = new Error('Parent Group ID is undefined');
            return false;
        }
        try {
            const response = await this._saveMethod([
                saveObject
            ]);
            if (response) this._saveMethod = (0, $4hGcu.updateObjects);
            else this._lastError = new Error('unknow server error');
            return response;
        } catch (error) {
            this._lastError = error;
            return false;
        }
    }
    async delete() {
        const deleteObject = {
            objectType: $24f543eff32d4be5$var$objectType,
            object: this._object
        };
        this._lastError = undefined;
        try {
            const response = await (0, $4hGcu.deleteObjects)([
                deleteObject
            ]);
            return response;
        } catch (error) {
            this._lastError = error;
            return false;
        }
    }
    get lastError() {
        return this._lastError;
    }
    get siteGroupID() {
        return this._object.siteGroupID;
    }
    get accountID() {
        return this._object.accountID;
    }
    set accountID(accountID) {
        this._object.accountID = accountID;
    }
    get name() {
        return this._object.name;
    }
    set name(name) {
        this._object.name = name;
    }
    get parentObjectType() {
        return this._object.parentObjectType;
    }
    set parentObjectType(parentObjectType) {
        this._object.parentObjectType = parentObjectType;
    }
    get parentObjectID() {
        return this._object.parentObjectID;
    }
    set parentObjectID(parentObjectID) {
        this._object.parentObjectID = parentObjectID;
    }
    get sites() {
        return this._object.sites;
    }
    addSite(site) {
        if (this._object.sites.includes(site.siteID)) return;
        this._object.sites.push(site.siteID);
    }
    deleteSite(site) {
        const index = this._object.sites.indexOf(site.siteID);
        if (index > -1) this._object.sites.splice(index, 1);
    }
    get roles() {
        return this._object.roles;
    }
    addRole(role) {
        if (this._object.roles.includes(role.roleID)) return;
        this._object.roles.push(role.roleID);
    }
    deleteRole(role) {
        const index = this._object.roles.indexOf(role.roleID);
        if (index > -1) this._object.roles.splice(index, 1);
    }
    get policies() {
        return this._object.policies;
    }
    addPolicy(policy) {
        if (this._object.policies.includes(policy.policyID)) return;
        this._object.policies.push(policy.policyID);
    }
    deletePolicy(policy) {
        const index = this._object.policies.indexOf(policy.policyID);
        if (index > -1) this._object.policies.splice(index, 1);
    }
}

});

parcelRegister("gYvZU", function(module, exports) {

$parcel$export(module.exports, "System", () => $7b69462bb9932931$export$e1dae5660003ffa7);

var $4hGcu = parcelRequire("4hGcu");

var $gAjJp = parcelRequire("gAjJp");
const $7b69462bb9932931$var$objectType = 'system';
class $7b69462bb9932931$export$e1dae5660003ffa7 {
    constructor(systemID){
        this._saveMethod = (0, $4hGcu.createObjects);
        this._object = {
            systemID: systemID,
            name: undefined,
            roles: [],
            policies: []
        };
    }
    static createNew() {
        return new $7b69462bb9932931$export$e1dae5660003ffa7((0, $gAjJp.default)());
    }
    static createFromObject(system) {
        const obj = new $7b69462bb9932931$export$e1dae5660003ffa7(system.systemID);
        obj._object = system;
        obj._saveMethod = (0, $4hGcu.updateObjects);
        return obj;
    }
    async load() {
        const getObject = {
            objectType: $7b69462bb9932931$var$objectType,
            keys: [
                this._object.systemID
            ]
        };
        this._lastError = undefined;
        try {
            const response = await (0, $4hGcu.getObjects)([
                getObject
            ]);
            if (response && response.length > 0 && response[0].objects && response[0].objects.length == 1) {
                this._saveMethod = (0, $4hGcu.updateObjects);
                this._object = response[0].objects[0];
                return true;
            } else {
                this._lastError = new Error('system not found');
                return false;
            }
        } catch (error) {
            this._lastError = error;
            return false;
        }
    }
    // public async save(): Promise<boolean> {
    //     const saveObject:CreateUpdateDeleteRequest = {
    //         objectType: objectType,
    //         object: this._object
    //     };
    //     this._lastError = undefined;
    //     if (this._object.name == undefined){
    //         this._lastError = new Error('Name is undefined');
    //         return false;
    //     }
    //     try {
    //         const response = await this._saveMethod([saveObject]);
    //         if (response) {
    //             this._saveMethod = updateObjects;
    //         } else {
    //             this._lastError = new Error('unknow server error');
    //         }
    //         return response;
    //     } catch(error) {
    //         this._lastError = error;
    //         return false;
    //     }
    // }
    // public async delete() {
    //     const deleteObject:CreateUpdateDeleteRequest = {
    //         objectType: objectType,
    //         object: this._object
    //     };
    //     this._lastError = undefined;
    //     try {
    //         const response = await deleteObjects([deleteObject]);
    //         return response;
    //     } catch (error) {
    //         this._lastError = error;
    //         return false;
    //     }
    // }
    get lastError() {
        return this._lastError;
    }
    get systemID() {
        return this._object.systemID;
    }
    get name() {
        return this._object.name;
    }
    set name(name) {
        this._object.name = name;
    }
    get roles() {
        return this._object.roles;
    }
    addRole(role) {
        if (this._object.roles.includes(role.roleID)) return;
        this._object.roles.push(role.roleID);
    }
    deleteRole(role) {
        const index = this._object.roles.indexOf(role.roleID);
        if (index > -1) this._object.roles.splice(index, 1);
    }
    get policies() {
        return this._object.policies;
    }
    addPolicy(policy) {
        if (this._object.policies.includes(policy.policyID)) return;
        this._object.policies.push(policy.policyID);
    }
    deletePolicy(policy) {
        const index = this._object.policies.indexOf(policy.policyID);
        if (index > -1) this._object.policies.splice(index, 1);
    }
}

});

parcelRegister("lz3oz", function(module, exports) {

$parcel$export(module.exports, "User", () => $1d1b4bde2f6dac70$export$1f44aaf2ec115b54);

var $4hGcu = parcelRequire("4hGcu");

var $gAjJp = parcelRequire("gAjJp");
const $1d1b4bde2f6dac70$var$objectType = 'user';
class $1d1b4bde2f6dac70$export$1f44aaf2ec115b54 {
    constructor(userID){
        this._saveMethod = (0, $4hGcu.createObjects);
        this._object = {
            userID: userID,
            userGroups: [],
            accountID: undefined,
            identityID: undefined,
            headObjectID: undefined,
            headObjectType: undefined,
            name: undefined,
            firstName: undefined,
            lastName: undefined,
            airCurtains: [],
            roles: [],
            invitationID: undefined,
            acceptedInvitationDate: undefined
        };
    }
    static createNew() {
        return new $1d1b4bde2f6dac70$export$1f44aaf2ec115b54((0, $gAjJp.default)());
    }
    static createFromObject(user) {
        const obj = new $1d1b4bde2f6dac70$export$1f44aaf2ec115b54(user.userID);
        obj._object = user;
        obj._saveMethod = (0, $4hGcu.updateObjects);
        return obj;
    }
    async load() {
        const getObject = {
            objectType: $1d1b4bde2f6dac70$var$objectType,
            keys: [
                this._object.userID
            ]
        };
        this._lastError = undefined;
        try {
            const response = await (0, $4hGcu.getObjects)([
                getObject
            ]);
            if (response && response.length > 0 && response[0].objects && response[0].objects.length == 1) {
                this._saveMethod = (0, $4hGcu.updateObjects);
                this._object = response[0].objects[0];
                return true;
            } else {
                this._lastError = new Error('user not found');
                return false;
            }
        } catch (error) {
            this._lastError = error;
            return false;
        }
    }
    async save() {
        const saveObject = {
            objectType: $1d1b4bde2f6dac70$var$objectType,
            object: this._object
        };
        this._lastError = undefined;
        // if (this._object.name == undefined) {
        //     this._lastError = new Error('Name is undefined');
        //     return false;
        // }
        if (this._object.accountID == undefined) {
            this._lastError = new Error('Account ID is undefined');
            return false;
        }
        try {
            const response = await this._saveMethod([
                saveObject
            ]);
            if (response) this._saveMethod = (0, $4hGcu.updateObjects);
            else this._lastError = new Error('unknow server error');
            return response;
        } catch (error) {
            this._lastError = error;
            return false;
        }
    }
    async delete() {
        const deleteObject = {
            objectType: $1d1b4bde2f6dac70$var$objectType,
            object: this._object
        };
        this._lastError = undefined;
        try {
            const response = await (0, $4hGcu.deleteObjects)([
                deleteObject
            ]);
            return response;
        } catch (error) {
            this._lastError = error;
            return false;
        }
    }
    get lastError() {
        return this._lastError;
    }
    get userID() {
        return this._object.userID;
    }
    get accountID() {
        return this._object.accountID;
    }
    set accountID(accountID) {
        this._object.accountID = accountID;
    }
    get identityID() {
        return this._object.identityID;
    }
    set identityID(identityID) {
        this._object.identityID = identityID;
    }
    get name() {
        return this._object.name;
    }
    set name(name) {
        this._object.name = name;
    }
    get firstName() {
        return this._object.firstName;
    }
    set firstName(firstName) {
        this._object.firstName = firstName;
    }
    get lastName() {
        return this._object.lastName;
    }
    set lastName(lastName) {
        this._object.lastName = lastName;
    }
    get headObjectType() {
        return this._object.headObjectType;
    }
    set headObjectType(headObjectType) {
        this._object.headObjectType = headObjectType;
    }
    get headObjectID() {
        return this._object.headObjectID;
    }
    set headObjectID(headObjectID) {
        this._object.headObjectID = headObjectID;
    }
    get userGroups() {
        return this._object.userGroups;
    }
    get invitationID() {
        return this._object.invitationID;
    }
    set invitationID(invitationID) {
        this._object.invitationID = invitationID;
    }
    get acceptedInvitationDate() {
        return this._object.acceptedInvitationDate;
    }
    set acceptedInvitationDate(acceptedInvitationDate) {
        this._object.acceptedInvitationDate = acceptedInvitationDate;
    }
    addUserGroup(userGroup) {
        if (this._object.userGroups.includes(userGroup.userGroupID)) return;
        this._object.userGroups.push(userGroup.userGroupID);
    }
    deleteUserGroup(userGroup) {
        const index = this._object.userGroups.indexOf(userGroup.userGroupID);
        if (index > -1) this._object.userGroups.splice(index, 1);
    }
    get roles() {
        return this._object.roles;
    }
    addRole(role) {
        if (this._object.roles.includes(role.roleID)) return;
        this._object.roles.push(role.roleID);
    }
    deleteRole(role) {
        const index = this._object.roles.indexOf(role.roleID);
        if (index > -1) this._object.roles.splice(index, 1);
    }
    get airCurtains() {
        return this._object.airCurtains;
    }
    addAirCurtain(airCurtain) {
        if (this._object.airCurtains.includes(airCurtain.airCurtainID)) return;
        this._object.airCurtains.push(airCurtain.airCurtainID);
    }
    deleteAirCurtain(airCurtain) {
        const index = this._object.airCurtains.indexOf(airCurtain.airCurtainID);
        if (index > -1) this._object.airCurtains.splice(index, 1);
    }
}

});

parcelRegister("ap51u", function(module, exports) {

$parcel$export(module.exports, "Invitation", () => $4924fc817ec8805d$export$d899bafc7f84ca89);

var $4hGcu = parcelRequire("4hGcu");
const $4924fc817ec8805d$var$objectType = 'invitation';
class $4924fc817ec8805d$export$d899bafc7f84ca89 {
    constructor(email){
        this._saveMethod = (0, $4hGcu.createObjects);
        this._object = {
            invitationID: email,
            organizationID: undefined,
            accountID: undefined,
            userID: undefined,
            invitationDate: undefined,
            fromUserID: undefined
        };
    }
    static createFromObject(invitation) {
        const obj = new $4924fc817ec8805d$export$d899bafc7f84ca89(invitation.invitationID);
        obj._object = invitation;
        obj._saveMethod = (0, $4hGcu.updateObjects);
        return obj;
    }
    async load() {
        const getObject = {
            objectType: $4924fc817ec8805d$var$objectType,
            keys: [
                this._object.invitationID
            ]
        };
        this._lastError = undefined;
        try {
            const response = await (0, $4hGcu.getObjects)([
                getObject
            ]);
            if (response && response.length > 0 && response[0].objects && response[0].objects.length == 1) {
                this._saveMethod = (0, $4hGcu.updateObjects);
                this._object = response[0].objects[0];
                return true;
            } else {
                this._lastError = new Error('invitation not found');
                return false;
            }
        } catch (error) {
            this._lastError = error;
            return false;
        }
    }
    async save() {
        const saveObject = {
            objectType: $4924fc817ec8805d$var$objectType,
            object: this._object
        };
        this._lastError = undefined;
        if (this._object.fromUserID == undefined) {
            this._lastError = new Error('From User ID is undefined');
            return false;
        }
        if (this._object.organizationID == undefined) {
            this._lastError = new Error('Organization ID is undefined');
            return false;
        }
        if (this._object.invitationDate == undefined) {
            this._lastError = new Error('Invitation Date is undefined');
            return false;
        }
        if (this._object.accountID == undefined) {
            this._lastError = new Error('Account ID Date is undefined');
            return false;
        }
        if (this._object.userID == undefined) {
            this._lastError = new Error('User ID is undefined');
            return false;
        }
        try {
            const response = await this._saveMethod([
                saveObject
            ]);
            if (response) this._saveMethod = (0, $4hGcu.updateObjects);
            else this._lastError = new Error('unknow server error');
            return response;
        } catch (error) {
            this._lastError = error;
            return false;
        }
    }
    async delete() {
        const deleteObject = {
            objectType: $4924fc817ec8805d$var$objectType,
            object: this._object
        };
        this._lastError = undefined;
        try {
            const response = await (0, $4hGcu.deleteObjects)([
                deleteObject
            ]);
            return response;
        } catch (error) {
            this._lastError = error;
            return false;
        }
    }
    async sendInvitationEmail() {
        // has to save first so the backend can retreive the Invitation object
        if (this._saveMethod == (0, $4hGcu.createObjects)) return false;
        const sendInvitationEmailRequest = {
            invitationID: this.invitationID
        };
        const response = await (0, $4hGcu.sendInvitationEmail)(sendInvitationEmailRequest);
        return response;
    }
    get lastError() {
        return this._lastError;
    }
    get invitationID() {
        return this._object.invitationID;
    }
    get accountID() {
        return this._object.accountID;
    }
    set accountID(accountID) {
        this._object.accountID = accountID;
    }
    get organizationID() {
        return this._object.organizationID;
    }
    set organizationID(organizationID) {
        this._object.organizationID = organizationID;
    }
    get fromUserID() {
        return this._object.fromUserID;
    }
    set fromUserID(fromUserID) {
        this._object.fromUserID = fromUserID;
    }
    get invitationDate() {
        return this._object.invitationDate;
    }
    set invitationDate(invitationDate) {
        this._object.invitationDate = invitationDate;
    }
    get userID() {
        return this._object.userID;
    }
    set userID(userID) {
        this._object.userID = userID;
    }
}

});

parcelRegister("io94P", function(module, exports) {

$parcel$export(module.exports, "Location", () => $e054b1ce62311eb8$export$18a2be9195644f38);

var $4hGcu = parcelRequire("4hGcu");
class $e054b1ce62311eb8$export$18a2be9195644f38 {
    constructor(siteID){
        this._location = {
            siteID: siteID,
            latitude: undefined,
            longitude: undefined,
            locationType: 'postal_code',
            location: undefined,
            naturalGasRate: 0,
            electricityRate: 0,
            oilRate: 0,
            powerCycles: 60
        };
    }
    static createFromObject(location) {
        const obj = new $e054b1ce62311eb8$export$18a2be9195644f38(location.siteID);
        obj._location = location;
        return obj;
    }
    async load() {
        const response = await (0, $4hGcu.getLocations)([
            this._location.siteID
        ]);
        if (response.length > 0) {
            this._location = response[0];
            return true;
        }
        return false;
    }
    async save() {
        if (this._location.latitude == undefined) {
            this._lastError = new Error('Latitude is undefined');
            return false;
        }
        if (this._location.longitude == undefined) {
            this._lastError = new Error('longitude is undefined');
            return false;
        }
        if (this._location.locationType == undefined) {
            this._lastError = new Error('Location Type is undefined');
            return false;
        }
        if (this._location.location == undefined) {
            this._lastError = new Error('Location is undefined');
            return false;
        }
        if (this._location.naturalGasRate == undefined) {
            this._lastError = new Error('Natural Gas Rate is undefined');
            return false;
        }
        if (this._location.electricityRate == undefined) {
            this._lastError = new Error('Electricity Rate is undefined');
            return false;
        }
        if (this._location.oilRate == undefined) {
            this._lastError = new Error('Oil Rate is undefined');
            return false;
        }
        if (this._location.powerCycles == undefined) {
            this._lastError = new Error('Power Cycles Rate is undefined');
            return false;
        }
        this._lastError = undefined;
        try {
            const response = await (0, $4hGcu.saveLocations)([
                this._location
            ]);
            return response;
        } catch (error) {
            this._lastError = error;
            return false;
        }
    }
    async delete() {
        this._lastError = undefined;
        try {
            const response = await (0, $4hGcu.deleteLocations)([
                this._location.siteID
            ]);
            return response;
        } catch (error) {
            this._lastError = error;
            return false;
        }
    }
    get lastError() {
        return this._lastError;
    }
    get longitude() {
        return this._location.longitude;
    }
    set longitude(longitude) {
        this._location.longitude = longitude;
    }
    get latitude() {
        return this._location.latitude;
    }
    set latitude(latitude) {
        this._location.latitude = latitude;
    }
    get postalCode() {
        return this._location.location;
    }
    set postalCode(postalCode) {
        this._location.location = postalCode;
    }
    get powerCycles() {
        return this._location.powerCycles;
    }
    set powerCycles(powerCycles) {
        this._location.powerCycles = powerCycles;
    }
    get electricityRate() {
        return this._location.electricityRate;
    }
    set electricityRate(electricityRate) {
        this._location.electricityRate = electricityRate;
    }
    get naturalGasRate() {
        return this._location.naturalGasRate;
    }
    set naturalGasRate(naturalGasRate) {
        this._location.naturalGasRate = naturalGasRate;
    }
    get oilRate() {
        return this._location.oilRate;
    }
    set oilRate(oilRate) {
        this._location.oilRate = oilRate;
    }
}

});

parcelRegister("7HheK", function(module, exports) {

$parcel$export(module.exports, "Installation", () => $e95775f14254edf0$export$8564277db535bd71);

var $4hGcu = parcelRequire("4hGcu");
class $e95775f14254edf0$export$8564277db535bd71 {
    constructor(airCurtainID, siteID){
        this._installation = {
            thingName: airCurtainID,
            siteID: siteID,
            applicationType: undefined,
            openingWidth: undefined,
            openingHeight: undefined,
            doorMountingHeight: undefined,
            interiorTemperatureSetPointWinter: undefined,
            interiorTemperatureSetPointSummer: undefined,
            interiorRelativeHumidityWinter: undefined,
            interiorRelativeHumiditySummer: undefined,
            model: undefined,
            heatingEnergyType: undefined,
            coolingEnergyType: undefined,
            calculateHeatingSaving: undefined,
            calculateCoolingSaving: undefined,
            hasHeating: undefined,
            hasTemperatureSensor: undefined,
            heatingPower: undefined,
            unconditionedHeatingTemperatureSetPoint: undefined
        };
    }
    static createFromObject(installation) {
        const obj = new $e95775f14254edf0$export$8564277db535bd71(installation.thingName, installation.siteID);
        obj._installation = installation;
        return obj;
    }
    async load() {
        const response = await (0, $4hGcu.getInstallations)([
            this._installation
        ]);
        if (response.length > 0) {
            this._installation = response[0];
            return true;
        }
        return false;
    }
    async save() {
        if (this._installation.siteID == undefined) {
            this._lastError = new Error('Site ID is undefined');
            return false;
        }
        if (this._installation.applicationType == undefined) {
            this._lastError = new Error('Application Type is undefined');
            return false;
        }
        if (this._installation.openingWidth == undefined) {
            this._lastError = new Error('Opening Width is undefined');
            return false;
        }
        if (this._installation.openingHeight == undefined) {
            this._lastError = new Error('Opening Height is undefined');
            return false;
        }
        if (this._installation.doorMountingHeight == undefined) {
            this._lastError = new Error('Door Mounting Height is undefined');
            return false;
        }
        if (this._installation.interiorTemperatureSetPointWinter == undefined) {
            this._lastError = new Error('Interior Temperature Set Point Winter is undefined');
            return false;
        }
        if (this._installation.interiorTemperatureSetPointSummer == undefined) {
            this._lastError = new Error('Interior Temperature Set Point Summer is undefined');
            return false;
        }
        if (this._installation.interiorRelativeHumidityWinter == undefined) {
            this._lastError = new Error('Interior Relative Humidity Winter Type is undefined');
            return false;
        }
        if (this._installation.interiorRelativeHumiditySummer == undefined) {
            this._lastError = new Error('Interior Relative Humidity Summer is undefined');
            return false;
        }
        if (this._installation.model == undefined) {
            this._lastError = new Error('Model is undefined');
            return false;
        }
        if (this._installation.heatingEnergyType == undefined) {
            this._lastError = new Error('Heating Energy Type is undefined');
            return false;
        }
        if (this._installation.coolingEnergyType == undefined) {
            this._lastError = new Error('Cooling Energy Type is undefined');
            return false;
        }
        if (this._installation.calculateHeatingSaving == undefined) {
            this._lastError = new Error('Calculate Heating Saving is undefined');
            return false;
        }
        if (this._installation.calculateCoolingSaving == undefined) {
            this._lastError = new Error('Calculate Cooling Saving is undefined');
            return false;
        }
        if (this._installation.hasHeating == undefined) {
            this._lastError = new Error('Has Heating is undefined');
            return false;
        }
        if (this._installation.hasTemperatureSensor == undefined) {
            this._lastError = new Error('Has Temperature Sensor is undefined');
            return false;
        }
        if (this._installation.heatingPower == undefined) {
            this._lastError = new Error('Heating Power is undefined');
            return false;
        }
        if (this._installation.unconditionedHeatingTemperatureSetPoint == undefined) {
            this._lastError = new Error('Unconditioned Heating Temperature Set Point is undefined');
            return false;
        }
        this._lastError = undefined;
        try {
            const response = await (0, $4hGcu.saveInstallations)([
                this._installation
            ]);
            return response;
        } catch (error) {
            this._lastError = error;
            return false;
        }
    }
    async delete() {
        this._lastError = undefined;
        try {
            const response = await (0, $4hGcu.deleteInstallations)([
                this._installation
            ]);
            return response;
        } catch (error) {
            this._lastError = error;
            return false;
        }
    }
    get lastError() {
        return this._lastError;
    }
    get siteID() {
        return this._installation.siteID;
    }
    set siteID(siteID) {
        this._installation.siteID = siteID;
    }
    get applicationType() {
        return this._installation.applicationType;
    }
    set applicationType(applicationType) {
        this._installation.applicationType = applicationType;
    }
    get openingWidth() {
        return this._installation.openingWidth;
    }
    set openingWidth(openingWidth) {
        this._installation.openingWidth = openingWidth;
    }
    get openingHeight() {
        return this._installation.openingHeight;
    }
    set openingHeight(openingHeight) {
        this._installation.openingHeight = openingHeight;
    }
    get doorMountingHeight() {
        return this._installation.doorMountingHeight;
    }
    set doorMountingHeight(doorMountingHeight) {
        this._installation.doorMountingHeight = doorMountingHeight;
    }
    get interiorTemperatureSetPointWinter() {
        return this._installation.interiorTemperatureSetPointWinter;
    }
    set interiorTemperatureSetPointWinter(interiorTemperatureSetPointWinter) {
        this._installation.interiorTemperatureSetPointWinter = interiorTemperatureSetPointWinter;
    }
    get interiorTemperatureSetPointSummer() {
        return this._installation.interiorTemperatureSetPointSummer;
    }
    set interiorTemperatureSetPointSummer(interiorTemperatureSetPointSummer) {
        this._installation.interiorTemperatureSetPointSummer = interiorTemperatureSetPointSummer;
    }
    get interiorRelativeHumidityWinter() {
        return this._installation.interiorRelativeHumidityWinter;
    }
    set interiorRelativeHumidityWinter(interiorRelativeHumidityWinter) {
        this._installation.interiorRelativeHumidityWinter = interiorRelativeHumidityWinter;
    }
    get interiorRelativeHumiditySummer() {
        return this._installation.interiorRelativeHumiditySummer;
    }
    set interiorRelativeHumiditySummer(interiorRelativeHumiditySummer) {
        this._installation.interiorRelativeHumiditySummer = interiorRelativeHumiditySummer;
    }
    get model() {
        return this._installation.model;
    }
    set model(model) {
        this._installation.model = model;
    }
    get heatingEnergyType() {
        return this._installation.heatingEnergyType;
    }
    set heatingEnergyType(heatingEnergyType) {
        this._installation.heatingEnergyType = heatingEnergyType;
    }
    get coolingEnergyType() {
        return this._installation.coolingEnergyType;
    }
    set coolingEnergyType(coolingEnergyType) {
        this._installation.coolingEnergyType = coolingEnergyType;
    }
    get calculateHeatingSaving() {
        return this._installation.calculateHeatingSaving;
    }
    set calculateHeatingSaving(calculateHeatingSaving) {
        this._installation.calculateHeatingSaving = calculateHeatingSaving;
    }
    get calculateCoolingSaving() {
        return this._installation.calculateCoolingSaving;
    }
    set calculateCoolingSaving(calculateCoolingSaving) {
        this._installation.calculateCoolingSaving = calculateCoolingSaving;
    }
    get hasHeating() {
        return this._installation.hasHeating;
    }
    set hasHeating(hasHeating) {
        this._installation.hasHeating = hasHeating;
    }
    get hasTemperatureSensor() {
        return this._installation.hasTemperatureSensor;
    }
    set hasTemperatureSensor(hasTemperatureSensor) {
        this._installation.hasTemperatureSensor = hasTemperatureSensor;
    }
    get heatingPower() {
        return this._installation.heatingPower;
    }
    set heatingPower(heatingPower) {
        this._installation.heatingPower = heatingPower;
    }
    get unconditionedHeatingTemperatureSetPoint() {
        return this._installation.unconditionedHeatingTemperatureSetPoint;
    }
    set unconditionedHeatingTemperatureSetPoint(unconditionedHeatingTemperatureSetPoint) {
        this._installation.unconditionedHeatingTemperatureSetPoint = unconditionedHeatingTemperatureSetPoint;
    }
}

});

parcelRegister("bNLF2", function(module, exports) {

$parcel$export(module.exports, "getListAirCurtainUserRelation", () => $8df162483e023ce9$export$787ee28929c4196a);
parcelRequire("atl0T");
var $cbbVi = parcelRequire("cbbVi");parcelRequire("hIPiC");
var $g0OFw = parcelRequire("g0OFw");

var $az5Iq = parcelRequire("az5Iq");
const $8df162483e023ce9$var$API_NAME = 'AirCurtainClientAPI';
const $8df162483e023ce9$var$APP_VERSION = '2.0';
const $8df162483e023ce9$var$PROTOCAL_VERSION = '0.1';
const $8df162483e023ce9$export$787ee28929c4196a = async ()=>{
    try {
        const response = await $8df162483e023ce9$var$post('getlistaircurtainuserrelation', {
            GetDetails: true
        });
        if (response && response.data.statusCode == 200) return response.data.body;
        else return [];
    } catch (error) {
        console.error(error);
        return [];
    }
};
const $8df162483e023ce9$export$ad9e7b0c01e41771 = async (airCurtain)=>{
    try {
        const response = await $8df162483e023ce9$var$post('updateaircurtain', airCurtain);
        return response.data.statusCode == 200;
    } catch (error) {
        console.error(error);
        return false;
    }
};
const $8df162483e023ce9$export$1b83fb70675602e1 = async (aircurtainId, wcsVersion)=>{
    try {
        await $8df162483e023ce9$var$post('removeaircurtainuserrelation', {
            airCurtainId: aircurtainId,
            wcsVersion: wcsVersion
        });
        return true;
    } catch (error) {
        console.error(error);
        return false;
    }
};
const $8df162483e023ce9$export$a5b67ea51cc69de2 = async (aircurtainId, wcsVersion)=>{
    try {
        return await $8df162483e023ce9$var$post('getaircurtain', {
            airCurtainId: aircurtainId,
            wcsVersion: wcsVersion
        });
    } catch (error) {
        console.error(error);
        return null;
    }
};
const $8df162483e023ce9$var$post = async (endpoint, body)=>{
    const session = await (0, $g0OFw.Auth).currentSession();
    const mergedBody = Object.assign({}, {
        AppVersion: $8df162483e023ce9$var$APP_VERSION,
        ProtocolVersion: $8df162483e023ce9$var$PROTOCAL_VERSION
    }, body);
    const init = {
        headers: {
            Authorization: session.getIdToken().getJwtToken(),
            'x-api-key': (0, $az5Iq.key)
        },
        response: true,
        body: mergedBody
    };
    const response = await (0, $cbbVi.API).post($8df162483e023ce9$var$API_NAME, '/dev/' + endpoint, init).catch((err)=>{
        console.log(err);
    });
    // console.log('post response: ', response);
    return response;
};

});
parcelRegister("az5Iq", function(module, exports) {
module.exports = JSON.parse("{\"key\":\"xWysAG8ZF33zynf7VIbMR11VYRmwILFT1GRqFkHd\"}");

});


parcelRegister("bpA0O", function(module, exports) {

$parcel$export(module.exports, "Bin", () => $bf3a4978cfa49720$export$28e1ba20e0688eb7);

var $4hGcu = parcelRequire("4hGcu");

var $gAjJp = parcelRequire("gAjJp");
const $bf3a4978cfa49720$var$objectType = 'bin';
class $bf3a4978cfa49720$export$28e1ba20e0688eb7 {
    constructor(binID){
        this._saveMethod = (0, $4hGcu.createObjects);
        this._object = {
            binID: binID,
            accountID: undefined,
            trashes: []
        };
    }
    static createNew() {
        return new $bf3a4978cfa49720$export$28e1ba20e0688eb7((0, $gAjJp.default)());
    }
    static createFromObject(bin) {
        const obj = new $bf3a4978cfa49720$export$28e1ba20e0688eb7(bin.binID);
        obj._object = bin;
        obj._saveMethod = (0, $4hGcu.updateObjects);
        return obj;
    }
    async load() {
        const getObject = {
            objectType: $bf3a4978cfa49720$var$objectType,
            keys: [
                this._object.binID
            ]
        };
        this._lastError = undefined;
        try {
            const response = await (0, $4hGcu.getObjects)([
                getObject
            ]);
            if (response && response.length > 0 && response[0].objects && response[0].objects.length == 1) {
                this._saveMethod = (0, $4hGcu.updateObjects);
                this._object = response[0].objects[0];
                return true;
            } else {
                this._lastError = new Error('bin not found');
                return false;
            }
        } catch (error) {
            this._lastError = error;
            return false;
        }
    }
    async save() {
        const saveObject = {
            objectType: $bf3a4978cfa49720$var$objectType,
            object: this._object
        };
        this._lastError = undefined;
        if (this._object.accountID == undefined) {
            this._lastError = new Error('Account ID is undefined');
            return false;
        }
        try {
            const response = await this._saveMethod([
                saveObject
            ]);
            if (response) this._saveMethod = (0, $4hGcu.updateObjects);
            else this._lastError = new Error('unknow server error');
            return response;
        } catch (error) {
            this._lastError = error;
            return false;
        }
    }
    async delete() {
        const deleteObject = {
            objectType: $bf3a4978cfa49720$var$objectType,
            object: this._object
        };
        this._lastError = undefined;
        try {
            const response = await (0, $4hGcu.deleteObjects)([
                deleteObject
            ]);
            return response;
        } catch (error) {
            this._lastError = error;
            return false;
        }
    }
    get lastError() {
        return this._lastError;
    }
    get binID() {
        return this._object.binID;
    }
    get accountID() {
        return this._object.accountID;
    }
    set accountID(accountID) {
        this._object.accountID = accountID;
    }
    get trashes() {
        return this._object.trashes;
    }
    addTrash(trash) {
        if (this._object.trashes.findIndex((item)=>{
            return item.objectID == trash.objectID;
        }) >= 0) return;
        this._object.trashes.push(trash);
    }
    deleteTrash(trash) {
        const index = this._object.trashes.findIndex((item)=>{
            return item.objectID == trash.objectID;
        });
        if (index > -1) this._object.trashes.splice(index, 1);
    }
}

});




parcelRegister("aL447", function(module, exports) {

$parcel$export(module.exports, "BernerScreenBase", () => $0b6d29c5df653c96$export$40a5039e7447b713);
parcelRequire("k6o0V");
var $1EWBs = parcelRequire("1EWBs");
var $2Vehe = parcelRequire("2Vehe");
var $l0Nlx = parcelRequire("l0Nlx");

var $6tV27 = parcelRequire("6tV27");

var $dNrEV = parcelRequire("dNrEV");

var $cqI6A = parcelRequire("cqI6A");

var $ht1kU = parcelRequire("ht1kU");

var $hdJfe = parcelRequire("hdJfe");

var $hkQda = parcelRequire("hkQda");
class $0b6d29c5df653c96$export$40a5039e7447b713 extends (0, $l0Nlx.LitElement) {
    async checkInitialized() {
        const userEmail = await (0, $6tV27.default).getCurrentUserEmail();
        const authenticated = Boolean(userEmail);
        if (authenticated) {
            console.log(`${userEmail} is authenticated`);
            const { objectManager: objectManager, measurementDataCachedState: measurementDataCachedState, measurementDataCachingInProgressState: measurementDataCachingInProgressState, preloadObjectsState: preloadObjectsState, preloadObjectsInProgressState: preloadObjectsInProgressState } = (0, $dNrEV.store).getState();
            this._objectManager = objectManager;
            if (!this._objectManager) {
                const { objectManager: objectManager, initialized: initialized } = await (0, $ht1kU.initObjectManager)(userEmail);
                if (!objectManager) {
                    console.error(`Failed to create ObjectManager`);
                    (0, $cqI6A.Router).go('auth/login');
                    return false;
                } else {
                    (0, $dNrEV.store).dispatch((0, $hdJfe.setObjectManager)(objectManager));
                    this._objectManager = objectManager;
                    if (!initialized) {
                        console.warn(objectManager.lastError);
                        if (!this._objectManager.getCurrentIdentity()) {
                            (0, $hdJfe.setAppState)((0, $hkQda.APP_STATES).CREATE_ORG);
                            (0, $cqI6A.Router).go('auth/create-org');
                        }
                        return false;
                    } else (0, $dNrEV.store).dispatch((0, $hdJfe.setAppState)((0, $hkQda.APP_STATES).LOGGED_IN));
                }
            }
            // cache measurement data for each air curtain, per site
            if (!measurementDataCachedState && !measurementDataCachingInProgressState) (0, $ht1kU.cacheAllMeasurementData)(this._objectManager);
            // preload air curtains, users and identities
            if (!preloadObjectsState && !preloadObjectsInProgressState) (0, $ht1kU.preloadObjects)(this._objectManager);
        } else {
            console.log(`${userEmail} is not authenticated`);
            (0, $cqI6A.Router).go('auth/login');
        }
        return authenticated;
    }
    // class css-loading is removed as soon as the external css is loaded
    static get styles() {
        return (0, $1EWBs.css)`
            .css-loading {
                display: none;
            }
        `;
    }
    renderLoader() {
        return (0, $2Vehe.html)`
            <div class="row content-row col-lg-12 loader-container">
                <div
                    class="spinner-border spinner-loader mx-auto"
                    role="status"
                ></div>
            </div>
        `;
    }
    renderAlert(message, closeFunc) {
        return (0, $2Vehe.html)`
            <div
                class="alert alert-light alert-dismissible show mx-auto mt-2"
                role="alert"
            >
                <button
                    type="button"
                    class="btn close"
                    data-bs-dismiss="alert"
                    aria-label="Close"
                    @click=${closeFunc}
                >
                    x
                </button>
                <span class="mx-auto"> ${message} </span>
            </div>
        `;
    }
}

});
parcelRegister("6tV27", function(module, exports) {

$parcel$export(module.exports, "default", () => $723c252cee754205$export$2e2bcd8739ae039);
parcelRequire("hIPiC");
var $g0OFw = parcelRequire("g0OFw");
var $hIPiC = parcelRequire("hIPiC");

var $lk3dI = parcelRequire("lk3dI");

var $hdJfe = parcelRequire("hdJfe");

var $dNrEV = parcelRequire("dNrEV");
(0, $hIPiC.default).configure((0, (/*@__PURE__*/$parcel$interopDefault($lk3dI))));
class $723c252cee754205$export$2e2bcd8739ae039 {
    static{
        this.USER_NOT_FOUND_EXCEPTION = 'UserNotFoundException';
    }
    static{
        this.NOT_AUTHORIZED_EXCEPTION = 'NotAuthorizedException';
    }
    static{
        this.USERNAME_EXISTS_EXCEPTION = 'UsernameExistsException';
    }
    static{
        this.CODE_MISMATCH_EXCEPTION = 'CodeMismatchException';
    }
    static async authenticate(username, password) {
        console.log('authenticate called for u: ', username);
        let user;
        try {
            user = await (0, $g0OFw.Auth).signIn(username, password);
        } catch (e) {
            console.log('Auth.signIn failed: ', e);
            (0, $dNrEV.store).dispatch((0, $hdJfe.authFailed)(e));
        }
        if (user) {
            const currentCredentials = await (0, $g0OFw.Auth).currentCredentials();
            await (0, $g0OFw.Auth).updateUserAttributes(user, {
                'custom:cognitoIdentityId': currentCredentials.identityId
            });
            (0, $dNrEV.store).dispatch((0, $hdJfe.setUserEmail)(username));
            return true;
        } else return false;
    }
    static async signup(username, password) {
        console.log('signup called for u: ', username);
        let signUpResult;
        try {
            signUpResult = await (0, $g0OFw.Auth).signUp(username, password, username);
        } catch (e) {
            console.log('Auth.signup failed: ', e);
            (0, $dNrEV.store).dispatch((0, $hdJfe.authFailed)(e));
            return undefined;
        }
        if (signUpResult) {
            (0, $dNrEV.store).dispatch((0, $hdJfe.setUserEmail)(username));
            return true;
        } else return false;
    }
    static async passwordResetRequest(username) {
        console.log('passwordReset called for u: ', username);
        let user;
        try {
            user = await (0, $g0OFw.Auth).forgotPassword(username);
        } catch (e) {
            console.log('Auth.forgotPassword failed: ', e);
            (0, $dNrEV.store).dispatch((0, $hdJfe.authFailed)(e));
        }
        if (user) {
            (0, $dNrEV.store).dispatch((0, $hdJfe.setUserEmail)(username));
            return true;
        } else return false;
    }
    static async passwordResetValidate(password, validationCode) {
        const { userEmail: passwordResetEmail } = (0, $dNrEV.store).getState();
        console.log('passwordResetValidate called for u: ', passwordResetEmail);
        try {
            await (0, $g0OFw.Auth).forgotPasswordSubmit(passwordResetEmail, validationCode, password);
        } catch (e) {
            console.log('Auth.forgotPasswordSubmit failed: ', e);
            (0, $dNrEV.store).dispatch((0, $hdJfe.authFailed)(e));
            return false;
        }
        return true;
    }
    static getAuthenticationError() {
        const { authError: authError } = (0, $dNrEV.store).getState();
        return authError;
    }
    static async signOut() {
        try {
            await (0, $g0OFw.Auth).signOut();
            return true;
        } catch (e) {
            console.log('Auth.signOut failed: ', e);
            (0, $dNrEV.store).dispatch((0, $hdJfe.authFailed)(e));
            return false;
        }
    }
    static async getCurrentUserEmail() {
        try {
            const user = await (0, $g0OFw.Auth).currentAuthenticatedUser({
                bypassCache: false
            });
            return user?.attributes?.email;
        } catch (error) {
            console.error(error);
            return '';
        }
    }
}

});
parcelRegister("lk3dI", function(module, exports) {
module.exports = JSON.parse("{\"aws_project_region\":\"us-east-1\",\"aws_cognito_region\":\"us-east-1\",\"aws_user_pools_id\":\"us-east-1_cCJoLDsKb\",\"aws_user_pools_web_client_id\":\"41ljlle94bqn9hpmlfii6jcci2\",\"identityPoolId\":\"us-east-1:15085853-639f-4345-b1f5-10785585ba71\",\"mandatorySignIn\":true,\"oauth\":{},\"API\":{\"endpoints\":[{\"name\":\"AirCurtainClientAPI\",\"endpoint\":\"https://cywz7qz484.execute-api.us-east-1.amazonaws.com\"},{\"name\":\"ReportingAPI\",\"endpoint\":\"https://hug9lf04pg.execute-api.us-east-1.amazonaws.com\"},{\"name\":\"WebApplicationAPI\",\"endpoint\":\"https://lqd5rbn1ze.execute-api.us-east-1.amazonaws.com\"}]}}");

});



parcelRegister("5fchy", function(module, exports) {

var $2eeCH = parcelRequire("2eeCH");
parcelRequire("k6o0V");
var $1EWBs = parcelRequire("1EWBs");
var $2Vehe = parcelRequire("2Vehe");
var $l0Nlx = parcelRequire("l0Nlx");
parcelRequire("2NKH4");
var $jZi7J = parcelRequire("jZi7J");
var $lANGx = parcelRequire("lANGx");
var $ejp6K = parcelRequire("ejp6K");
parcelRequire("2BCvg");
var $Txkvx = parcelRequire("Txkvx");
parcelRequire("jRqJ2");
var $3q9Vf = parcelRequire("3q9Vf");

var $dNrEV = parcelRequire("dNrEV");

var $hkQda = parcelRequire("hkQda");

var $96LZE = parcelRequire("96LZE");
class $0df3068143bb7a4d$export$fa913cb1a97ad22f extends (0, $l0Nlx.LitElement) {
    get selected() {
        return this._selected.toString();
    }
    set selected(value) {
        this._selected = value === 'true' ? true : false;
    }
    // class css-loading is removed as soon as the external css is loaded
    static get styles() {
        return (0, $1EWBs.css)`
            .css-loading {
                display: none;
            }
        `;
    }
    connectedCallback() {
        window.addEventListener((0, $hkQda.EVENTS).CHANGE_TEMP_UNIT, this.onTempUnitChanged.bind(this));
        super.connectedCallback();
    }
    disconnectedCallback() {
        window.removeEventListener((0, $hkQda.EVENTS).CHANGE_TEMP_UNIT, this.onTempUnitChanged);
        super.disconnectedCallback();
    }
    onTempUnitChanged(e) {
        this.requestUpdate();
    }
    async firstUpdated() {
        const { objectManager: objectManager } = (0, $dNrEV.store).getState();
        // assigned id is <airCurtainID>:<siteID>
        this._airCurtain = await objectManager.getAirCurtain(this.id.split(':')[0]);
        if (!this._airCurtain.isShadowLoaded) await this._airCurtain.refreshShadow();
        const rowContainer = this.shadowRoot.getElementById('row-container');
        rowContainer.addEventListener('mouseover', ()=>{
            rowContainer.classList.add('mouse-over');
        });
        rowContainer.addEventListener('mouseout', ()=>{
            rowContainer.classList.remove('mouse-over');
        });
        this._doorSensor = this._airCurtain.doorOpenCount > 0;
        this._mode = this._airCurtain.mode;
        await (0, $hkQda.loadStyle)('./css/berner-curtain.css', this.shadowRoot);
        this.requestUpdate();
    }
    getNextEvent() {
        const days = [
            'Sun',
            'Mon',
            'Tue',
            'Wed',
            'Thur',
            'Fri',
            'Sat',
            'Sun'
        ];
        if (!this._airCurtain?.schedule?.enabled) return '';
        else {
            if (this._airCurtain?.schedule.events.length == 0) return '';
            const event = this._airCurtain?.schedule.events[0];
            const hours = event.dayMinute / 60;
            const rhours = Math.floor(hours);
            const minutes = (hours - rhours) * 60;
            const rminutes = Math.round(minutes);
            const paddedMins = rminutes < 10 ? '0' + rminutes : rminutes;
            const day = days[event.weekDay];
            return `${day} ${rhours}:${paddedMins}`;
        }
    }
    renderMode() {
        if (!this._airCurtain?.mode) return (0, $2Vehe.html)``;
        // TODO: handle pureMode
        const modes = [
            {
                name: 'Off',
                icon: './assets/icon_mode_off.png'
            },
            {
                name: 'On',
                icon: './assets/icon_mode_on.png'
            },
            {
                name: 'Auto',
                icon: './assets/icon_mode_auto.png'
            },
            {
                name: 'Comfort Plus',
                icon: './assets/icon_mode_comfort_plus.png'
            }
        ];
        return (0, $2Vehe.html)` <div class="item mode">
            <h3>Mode</h3>

            <button
                class="mdc-button mdc-button--raised mdc-button--primary mdc-tab mdc-ripple-upgraded"
                role="tab"
            >
                <span class="button-contents">
                    <img src=${modes[this._mode].icon} alt="selected mode" />
                    <span>${modes[this._mode].name}</span>
                </span>
            </button>

            <div class="mdc-menu mdc-menu-surface">
                <ul
                    class="mdc-list"
                    role="menu"
                    aria-hidden="true"
                    aria-orientation="vertical"
                    tabindex="-1"
                >
                    ${(0, $3q9Vf.repeat)(modes, (mode, index)=>(0, $2Vehe.html)`
                        <li
                            id="mode-${index}"
                            class="mdc-list-item"
                            role="menuitem"
                            @click=${this.onModeItemClicked}
                        >
                            <span class="mdc-list-item__ripple"></span>
                            <span class="mdc-list-item__text">
                                <img
                                    src=${mode.icon}
                                    alt="mode ${mode.name}"
                                />
                                <span>${mode.name}</span>
                            </span>
                        </li>
                        `)}
                </ul>
            </div>
        </div>`;
    }
    renderDropDownButton() {
        const ItemClickHandler = async (option, e)=>{
            if (option === 'curtain-remove') {
                const event = new CustomEvent((0, $hkQda.EVENTS).SHOW_REMOVE_CURTAIN, {
                    detail: {
                        id: this.id
                    }
                });
                window.dispatchEvent(event);
            } else if (option === 'curtain-update') {
                const event = new CustomEvent((0, $hkQda.EVENTS).SHOW_UPDATE_CURTAIN, {
                    detail: {
                        id: this.id
                    }
                });
                window.dispatchEvent(event);
            } else if (option === 'curtain-info') {
                const event = new CustomEvent((0, $hkQda.EVENTS).SHOW_CURTAIN_INFO, {
                    detail: {
                        id: this.id
                    }
                });
                window.dispatchEvent(event);
            }
            e.stopPropagation();
        };
        const options = (0, $2Vehe.html)`
        <span
            class="dropdown-item"
            id="curtain-info"
            @click=${(e)=>{
            ItemClickHandler('curtain-info', e);
        }}
        >
            <img src="./assets/icon_info.svg" alt="air curtain info"/>
            <span class="">Air curtain info</span>
        </span>
        <span
            class="dropdown-item"
            id="curtain-update"
            @click=${(e)=>{
            ItemClickHandler('curtain-update', e);
        }}
        >
            <img src="./assets/icon_gear.svg" alt="update installation"/>
            <span>Update installation</span>
        </span>
        <span
            class="dropdown-item"
            id="curtain-remove"
            @click=${(e)=>{
            ItemClickHandler('curtain-remove', e);
        }}
        >
            <img src="./assets/icon_trash.svg" alt="remove from site"/>
            <span>Remove from site</span>
        </span>
        `;
        return (0, $2Vehe.html)`
        <div class="btn-group dropleft" .hidden=${!this._showMenu}>
            <button
                class="kebab"
                type="button"
                class="btn btn-light py-0"
                data-toggle="dropdown"
                aria-expanded="false"
                @click=${(e)=>(0, $hkQda.dropDownClickHandler)(e, this.shadowRoot)}
            >
                &#x22EE;
            </button>
            <div class="dropdown-menu dropdown-menu-right">${options}</div>
        </div>
        `;
    }
    renderModel() {
        return (0, $2Vehe.html)`
        <div class="col-12 col-md-3 col-lg-2 item label--model">
            <span>${this._airCurtain?.model}</span>
        </div>`;
    }
    renderElapsedTime() {
        const connectivityPrescript = this._airCurtain?.connected ? 'Connected: ' : 'Online: ';
        const message = this._airCurtain?.connectivityTimestamp ? connectivityPrescript + (0, $hkQda.getTimeElapsed)(this._airCurtain?.connectivityTimestamp) : '';
        return (0, $2Vehe.html)`
        <div class="col-12 col-md-4 col-lg-2">
            <div class="item label small elapsed-time">
                <span>${message}</span>
            </div>
        </div>`;
    }
    renderCalender() {
        return (0, $2Vehe.html)`
        <div class="col-3 col-lg-1 item--calender">
            <img src="./assets/icon_calendar.svg" alt="calender" />
            <span class="label--calender">${this.getNextEvent()}</span>
        </div>`;
    }
    renderTempSetPoint() {
        return (0, $2Vehe.html)`
        <div class="col-md-1 col-sm-2 item">
            <img
                src="./assets/icon_unit_heating_set_to.svg"
                alt="heating"
            />

            <span class="label">
                ${this._airCurtain?.temperatureSetPoint !== undefined ? (0, $96LZE.getConvertedTemperature)(this._airCurtain?.temperatureSetPoint, 0) + `\u00B0` : ''}
            </span>
        </div>`;
    }
    renderDoorOpenCount() {
        return (0, $2Vehe.html)`
        <div class="col-md-1 col-sm-2 item">
            <img src="./assets/icon_unit_times_door_open_active.svg" alt="doors">

            <span class="label">
                ${this._airCurtain?.doorOpenCount ? this._airCurtain?.doorOpenCount : ''}
            </span>
        </div>`;
    }
    renderFanSpeed() {
        return (0, $2Vehe.html)`
        <div class="col-md-1 col-sm-2 item">

            <img
                src="./assets/icon_unit_current_fan_speed_active.svg"
                alt="fan"
            />


            <span class="label">
                ${this._airCurtain?.fanSpeed ? this._airCurtain?.fanSpeed : ''}
            </span>
        </div>`;
    }
    renderCurrentTemperature() {
        return (0, $2Vehe.html)`
        <div class="col-md-1 col-sm-2 item">
            <img
                src="./assets/icon_unit_current_temperature.svg"
                alt="temp"
            />
            <span class="label">
                ${this._airCurtain?.sensorTemperature !== undefined ? (0, $96LZE.getConvertedTemperature)(this._airCurtain?.sensorTemperature, 0) + `\u00B0` : ''}
            </span>
        </div>`;
    }
    render() {
        return (0, $2Vehe.html)`
        <link id="css-target">
        <div class="css-loading" id="root" 
            @mouseover="${()=>this._showMenu = true}"
            @mouseleave="${()=>this._showMenu = false}">
            <div
                id="row-container"
                class="${(0, $Txkvx.classMap)({
            'row-container': true,
            selected: this.selected === 'true'
        })}"
            >
                <section
                    class=${(0, $Txkvx.classMap)({
            row: true,
            'no-gutters': true,
            'content-row': true,
            'col-12': true
        })}
                >
                    <div class="col-12 col-md-7 col-lg-2 item">
                        <span class=${(0, $Txkvx.classMap)({
            'dot': this._airCurtain?.connected,
            'dot--red': !this._airCurtain?.connected
        })}></span>
                        <span class="name"> ${this._airCurtain?.name}</span>
                    </div>
                    ${(0, $2Vehe.html)`
                        ${this.renderElapsedTime()}
                        ${this.renderCurrentTemperature()}
                        ${this.renderDoorOpenCount()}
                        ${this.renderFanSpeed()}
                        ${this.renderTempSetPoint()}
                        ${this.renderCalender()}
                        ${this.renderModel()}
                        ${this.renderDropDownButton()}`}
                </section>
            </div>
        </div>`;
    }
    constructor(...args){
        super(...args), this._selected = false, this._doorSensor = false, this._mode = -1, this.onModeClicked = (e)=>{
            this.shadowRoot.querySelector('.mdc-menu-surface').classList.add('show-menu');
            e.stopPropagation();
        }, this.onModeItemClicked = (e)=>{
            this._mode = parseInt(e.currentTarget.id.split('-')[1]);
            this.shadowRoot.querySelector('.mdc-menu-surface').classList.remove('show-menu');
            e.stopPropagation();
        }, this.onDoorClicked = (e)=>{
            this._doorSensor = !this._doorSensor;
            e.stopPropagation();
        };
    }
}
(0, $2eeCH.__decorate)([
    (0, $lANGx.property)({
        type: String
    })
], $0df3068143bb7a4d$export$fa913cb1a97ad22f.prototype, "id", void 0);
(0, $2eeCH.__decorate)([
    (0, $lANGx.property)()
], $0df3068143bb7a4d$export$fa913cb1a97ad22f.prototype, "selected", null);
(0, $2eeCH.__decorate)([
    (0, $ejp6K.state)()
], $0df3068143bb7a4d$export$fa913cb1a97ad22f.prototype, "_showMenu", void 0);
(0, $2eeCH.__decorate)([
    (0, $ejp6K.state)()
], $0df3068143bb7a4d$export$fa913cb1a97ad22f.prototype, "_airCurtain", void 0);
(0, $2eeCH.__decorate)([
    (0, $ejp6K.state)()
], $0df3068143bb7a4d$export$fa913cb1a97ad22f.prototype, "_doorSensor", void 0);
(0, $2eeCH.__decorate)([
    (0, $ejp6K.state)()
], $0df3068143bb7a4d$export$fa913cb1a97ad22f.prototype, "_mode", void 0);
$0df3068143bb7a4d$export$fa913cb1a97ad22f = (0, $2eeCH.__decorate)([
    (0, $jZi7J.customElement)('berner-curtain')
], $0df3068143bb7a4d$export$fa913cb1a97ad22f);

});

parcelRegister("1yYF5", function(module, exports) {

var $2eeCH = parcelRequire("2eeCH");
parcelRequire("k6o0V");
var $1EWBs = parcelRequire("1EWBs");
var $2Vehe = parcelRequire("2Vehe");
parcelRequire("2NKH4");
var $jZi7J = parcelRequire("jZi7J");

var $f7Z1w = parcelRequire("f7Z1w");

var $fap4R = parcelRequire("fap4R");

var $ifhNi = parcelRequire("ifhNi");

var $96LZE = parcelRequire("96LZE");

var $ht1kU = parcelRequire("ht1kU");

var $hkQda = parcelRequire("hkQda");
class $50979cd2641a0dd9$export$345757aa11a5aaa5 extends (0, $fap4R.BernerChartBase) {
    // class css-loading is removed as soon as the external css is loaded
    static get styles() {
        return (0, $1EWBs.css)`
            .css-loading {
                height: 100%;
                display: none;
            }
        `;
    }
    constructor(){
        super(), this.getYAxis = (measurementOne, measurementTwo, yAxisLabel, yAxisM1minVal, yAxisM1maxVal, yAxisM2minVal, yAxisM2maxVal)=>{
            const graphTypeM1 = this.getGraphType(measurementOne);
            const yAxis = [];
            yAxis.push({
                zoomEnabled: graphTypeM1 !== (0, $ifhNi.GRAPH_TYPES).BAR && graphTypeM1 !== (0, $ifhNi.GRAPH_TYPES).COLUMN,
                gridLineWidth: 1,
                visible: !this.useMinimalUI,
                title: {
                    text: yAxisLabel,
                    style: {
                        fontWeight: 'bold'
                    },
                    y: 5
                },
                min: yAxisM1minVal,
                max: yAxisM1maxVal,
                height: '100%'
            });
            if (measurementTwo) {
                const graphTypeM2 = this.getGraphType(measurementTwo);
                yAxis.push({
                    zoomEnabled: graphTypeM2 !== (0, $ifhNi.GRAPH_TYPES).BAR && graphTypeM2 !== (0, $ifhNi.GRAPH_TYPES).COLUMN,
                    gridLineWidth: 1,
                    visible: !this.useMinimalUI,
                    title: {
                        text: yAxisLabel,
                        style: {
                            fontWeight: 'bold'
                        },
                        y: 5
                    },
                    min: graphTypeM2 === (0, $ifhNi.GRAPH_TYPES).BAR || graphTypeM2 === (0, $ifhNi.GRAPH_TYPES).COLUMN ? 0 : yAxisM2minVal,
                    max: yAxisM2maxVal,
                    height: '100%'
                });
            }
            return yAxis;
        }, this.getSeries = (colorM1, colorAlphaM1, timestampsM1, valuesM1, colorM2, colorAlphaM2, timestampsM2, valuesM2, seriesNameM1, seriesNameM2, averageLineData, injectedTimestampsM1, injectedTimestampsM2)=>{
            const zoneYesterdayMidnight = (0, $ifhNi.getDateMinusRange)((0, $ifhNi.RANGES).ONE_DAY, (0, $ifhNi.dateToUTCDate)(new Date())).setHours(0);
            const zone24HoursAgo = (0, $ifhNi.getDateMinusRange)((0, $ifhNi.RANGES).ONE_DAY, (0, $ifhNi.dateToUTCDate)(new Date())).getTime();
            const zoneToday = (0, $ifhNi.dateToUTCDate)(new Date()).getTime();
            const series = [];
            const zonesM1 = [];
            // push a dot zone for injected timestamps
            if (injectedTimestampsM1?.length) for (const ts of injectedTimestampsM1){
                const realValueDate = timestampsM1.find((date)=>{
                    return Number(date) > ts;
                });
                zonesM1.push({
                    value: realValueDate,
                    dashStyle: 'Dot'
                });
            }
            zonesM1.push({
                value: zoneYesterdayMidnight,
                dashStyle: 'Solid'
            });
            zonesM1.push({
                value: zone24HoursAgo,
                dashStyle: (0, $96LZE.MEASUREMENTS_LACKING_24HR_DATA).includes(this.measurementOne) ? 'Dot' : 'Solid'
            });
            zonesM1.push({
                value: zoneToday,
                dashStyle: (0, $96LZE.MEASUREMENTS_LACKING_24HR_DATA).includes(this.measurementOne) ? 'Dot' : 'Solid'
            });
            const graphTypeM1 = this.getGraphType(this.measurementOne);
            series.push({
                id: 'trend-line-m1',
                yAxis: 0,
                color: colorM1,
                fillColor: colorAlphaM1,
                data: valuesM1,
                lineWidth: 2,
                type: graphTypeM1,
                name: seriesNameM1,
                animation: true,
                zoneAxis: 'x',
                // dot zones are for projected data
                zones: zonesM1,
                threshold: graphTypeM1 === (0, $ifhNi.GRAPH_TYPES).BAR || graphTypeM1 === (0, $ifhNi.GRAPH_TYPES).COLUMN ? 0 : -9999
            });
            if (valuesM2?.length) {
                const zonesM2 = [];
                const graphTypeM2 = this.getGraphType(this.measurementTwo);
                if (injectedTimestampsM2?.length) {
                    const nonInjectedTimestamps = timestampsM2.filter((ts)=>{
                        return injectedTimestampsM2.indexOf(ts) == -1;
                    });
                    let injectedTS = injectedTimestampsM2[0];
                    let nonInjectedTS = -1;
                    while(injectedTS){
                        injectedTS = injectedTimestampsM2.find((ts)=>{
                            return ts > nonInjectedTS;
                        });
                        if (injectedTS) zonesM2.push({
                            value: injectedTS,
                            dashStyle: 'solid'
                        });
                        nonInjectedTS = nonInjectedTimestamps.find((ts)=>{
                            return ts > injectedTS;
                        });
                        zonesM2.push({
                            value: nonInjectedTS,
                            dashStyle: 'dot'
                        });
                    }
                }
                series.push({
                    id: 'trend-line-m2',
                    yAxis: 1,
                    color: colorM2,
                    fillColor: colorAlphaM2,
                    data: valuesM2,
                    lineWidth: 2,
                    type: graphTypeM2,
                    name: seriesNameM2,
                    animation: true,
                    zoneAxis: 'x',
                    pointWidth: graphTypeM2 === (0, $ifhNi.GRAPH_TYPES).BAR || graphTypeM2 === (0, $ifhNi.GRAPH_TYPES).COLUMN ? 10 : undefined,
                    // dot zones are for projected data
                    zones: zonesM2,
                    threshold: graphTypeM2 === (0, $ifhNi.GRAPH_TYPES).BAR || graphTypeM2 === (0, $ifhNi.GRAPH_TYPES).COLUMN ? 0 : -9999
                });
            }
            series.push({
                id: 'average-line',
                linkedTo: 'trend-line-m1',
                color: 'rgb(80,80,80)',
                data: averageLineData,
                type: 'line',
                lineWidth: 0.5,
                dashStyle: 'LongDashDot',
                allowPointSelect: false,
                enableMouseTracking: false,
                showInLegend: false,
                visible: this.shouldPlotAverages,
                animation: false
            });
            return series;
        }, this.injectMissingTimestamps = (data, expectedTimestamps)=>{
            const injectedTimestamps = [];
            const earliestTS = data?.map((gd)=>gd.timestamp)[0];
            const earliestValue = data[0].value;
            const lastTS = data?.map((gd)=>gd.timestamp)[data.length - 1];
            const lastValue = data?.map((gd)=>gd.value)[data.length - 1];
            for (const ts of expectedTimestamps){
                if (ts < earliestTS * 1000) {
                    const injectedTS = Number(ts);
                    data.push({
                        timestamp: injectedTS / 1000,
                        value: earliestValue
                    });
                    injectedTimestamps.push(injectedTS);
                } else if (ts > lastTS * 1000) {
                    const injectedTS = Number(ts);
                    data.push({
                        timestamp: injectedTS / 1000,
                        value: lastValue
                    });
                    injectedTimestamps.push(injectedTS);
                }
            }
            injectedTimestamps.sort((a, b)=>{
                return a > b ? 1 : -1;
            });
            data.sort((a, b)=>{
                return a.timestamp > b.timestamp ? 1 : -1;
            });
            return {
                amendedData: data,
                injectedTimestamps: injectedTimestamps
            };
        }, this.injectMissingTimestampsFromRange = (data, range)=>{
            const expectedDatesFromRange = (0, $ifhNi.getDatesInRange)(this.range);
            const injectedTimestamps = [];
            if (data?.length !== expectedDatesFromRange.length) {
                for (const day of expectedDatesFromRange)if (!data.find((gData)=>{
                    let raw;
                    let expected;
                    if (range === (0, $ifhNi.RANGES).ONE_DAY) {
                        raw = new Date(gData.timestamp * 1000).getHours();
                        expected = day.getHours();
                    } else if (range === (0, $ifhNi.RANGES).TWO_DAYS || range === (0, $ifhNi.RANGES).WEEKLY) {
                        raw = new Date(gData.timestamp * 1000).getDate();
                        expected = day.getDate();
                    } else if (range === (0, $ifhNi.RANGES).MONTHLY) {
                        raw = new Date(gData.timestamp * 1000).getDate();
                        expected = day.getDate();
                    } else if (range === (0, $ifhNi.RANGES).YEARLY) {
                        raw = new Date(gData.timestamp * 1000).getMonth();
                        expected = day.getMonth();
                    }
                    return raw === expected;
                })) {
                    const ts = day.getTime() / 1000;
                    data.push({
                        timestamp: ts,
                        value: 0
                    });
                    injectedTimestamps.push(ts * 1000);
                }
            }
            data.sort((a, b)=>{
                return a.timestamp > b.timestamp ? 1 : -1;
            });
            injectedTimestamps.sort((a, b)=>{
                return a > b ? 1 : -1;
            });
            return {
                amendedData: data,
                injectedTimestamps: injectedTimestamps
            };
        }, this.getDatesAndValues = (rawData, measurement, categoryGraph)=>{
            let timestamps = [];
            let values;
            // values for a category graph with dates handled separately
            if (categoryGraph) {
                const { amendedData: amendedData } = this.injectMissingTimestampsFromRange(rawData, this.range);
                values = amendedData ? amendedData.map((gData)=>{
                    return (0, $96LZE.getDisplayValue)(measurement, gData.value);
                }) : [];
                timestamps = amendedData ? amendedData.map((gData)=>{
                    return gData.timestamp;
                }) : [];
            } else {
                let lastValidValue = 0;
                let injectedProjectedData = false;
                values = rawData ? rawData.map((gData)=>{
                    let value = gData.value;
                    // compensate for data not yet processed within last 24 hrs
                    if ((0, $hkQda.isTimeStampLast24hrs)(gData.timestamp) && (0, $96LZE.MEASUREMENTS_LACKING_24HR_DATA).includes(measurement)) {
                        injectedProjectedData = true;
                        value = lastValidValue;
                    } else lastValidValue = value;
                    const d = new Date(gData.timestamp * 1000).getTime();
                    timestamps.push(d);
                    // values for a datetime graph (value and date)
                    return [
                        d,
                        (0, $96LZE.getDisplayValue)(measurement, value)
                    ];
                }) : [];
                // push a timestamp from now / today to end projection
                if (injectedProjectedData) {
                    const date = new Date();
                    date.setMinutes(0);
                    const timeStamp = (0, $ifhNi.dateToUTCDate)(date).getTime();
                    values.push([
                        timeStamp,
                        (0, $96LZE.getDisplayValue)(measurement, lastValidValue)
                    ]);
                }
            }
            return {
                timestamps: timestamps,
                values: values
            };
        }, this.getDisplaySummary = (unit, displayTotal, rawData, decimals, average, min, max)=>{
            const displayMax = min.toFixed(decimals) + unit;
            const displayMin = max.toFixed(decimals) + unit;
            const spaceBeforeUnit = (0, $hkQda.UNITS_SPACE_PREFIX).includes(unit) ? true : false;
            const pluralUnits = (0, $hkQda.UNITS_PLURAL).includes(unit) ? true : false;
            const displayValue = displayTotal ? (0, $96LZE.getTotal)(rawData).toFixed(decimals) : average.toFixed(decimals);
            const displayUnit = pluralUnits && (displayTotal ? Math.ceil((0, $96LZE.getTotal)(rawData)) > 1 : average > 1) ? unit.concat('s') : unit;
            let displaySummary;
            if ((0, $hkQda.UNITS_PRECEDING_VALUE).includes(unit)) displaySummary = displayUnit + displayValue;
            else displaySummary = displayValue + (spaceBeforeUnit ? ' ' : '') + displayUnit;
            const summaryTitle = displayTotal ? 'Total' : 'Average';
            return this.useMinimalUI ? `<span class="legend-summary-streamlined"> <span class="summary"> ${displaySummary} </span> ${summaryTitle}</span>` : `<span class="legend-summary"> Average: <span class="summary">${displaySummary}</span> Max: ${displayMax} Min: ${displayMin}</span>`;
        }, this.drawGraph = ()=>{
            const aggregateFuncM1 = (0, $ht1kU.MEASUREMENT_TO_FUNC).get(this.measurementOne);
            const rangeData = this._data?.get(this.range);
            const m1Name = this.shouldAggregate ? aggregateFuncM1 + '(' + this.measurementOne + ')' : this.measurementOne;
            const rawDataM1 = rangeData?.get(m1Name);
            const graphType = this.getGraphType(this.measurementOne);
            const isBarOrColumnGraph = graphType === (0, $ifhNi.GRAPH_TYPES).BAR || graphType === (0, $ifhNi.GRAPH_TYPES).COLUMN;
            const { timestamps: timestampsM1, values: valuesM1 } = this.getDatesAndValues(rawDataM1, this.measurementOne, isBarOrColumnGraph);
            const xAxisLabelFormatterFunc = this.xAxisLabelFormatter;
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const componentContext = this;
            const range = this.range;
            let valuesM2;
            let timestampsM2;
            let rawDataM2;
            let colorM2;
            let yAxisMinM2;
            let yAxisMaxM2;
            let unitM2;
            let displayTotalM2;
            let decimalsM2;
            let m2Name;
            let LabelM2;
            let colorAlphaM2;
            if (this.measurementTwo) {
                const aggregateFuncM2 = (0, $ht1kU.MEASUREMENT_TO_FUNC).get(this.measurementTwo);
                m2Name = this.shouldAggregate ? aggregateFuncM2 + '(' + this.measurementTwo + ')' : this.measurementTwo;
                rawDataM2 = rangeData?.get(m2Name);
                const { timestamps: timestamps, values: values } = this.getDatesAndValues(rawDataM2, this.measurementTwo, isBarOrColumnGraph);
                const { color: color, label: label, yAxisMin: yAxisMin, yAxisMax: yAxisMax, unit: unit, displayTotal: displayTotal, decimals: decimals, colorAlpha: colorAlpha } = (0, $96LZE.getMeasurementUI)(this.measurementTwo);
                colorM2 = color;
                yAxisMinM2 = yAxisMin;
                yAxisMaxM2 = yAxisMax;
                unitM2 = unit;
                displayTotalM2 = displayTotal;
                decimalsM2 = decimals;
                LabelM2 = label;
                colorAlphaM2 = colorAlpha;
                valuesM2 = values;
                timestampsM2 = timestamps;
            }
            let injectedTimestampsM2 = [];
            if (rawDataM2 && rawDataM2.length) {
                //let amendedData = [...rawDataM2];
                const { amendedData: amendedData, injectedTimestamps: injectedTimestamps } = this.injectMissingTimestamps(rawDataM2, timestampsM1);
                injectedTimestampsM2 = injectedTimestamps;
                const { values: values, timestamps: timestamps } = this.getDatesAndValues(amendedData, this.measurementTwo, isBarOrColumnGraph);
                valuesM2 = values;
                timestampsM2 = timestamps;
            }
            const { unit: unitM1, label: LabelM1, yAxisLabel: yAxisLabel, color: colorM1, colorAlpha: colorAlphaM1, decimals: decimalsM1, icon: icon, subtitle: subtitle, yAxisMin: yAxisMinM1, yAxisMax: yAxisMaxM1, yAxisRangePercentLimit: yAxisRangePercentLimit, displayTotal: displayTotalM1 } = (0, $96LZE.getMeasurementUI)(this.measurementOne);
            const averageM1 = (0, $96LZE.getAverage)(rawDataM1, this.measurementOne, timestampsM1.length);
            const maxMinM1 = (0, $96LZE.getMaxMin)(rawDataM1, this.measurementOne);
            let averageM2;
            let maxMinM2;
            let yAxisM2minVal;
            let yAxisM2maxVal;
            if (this.measurementTwo) {
                averageM2 = (0, $96LZE.getAverage)(rawDataM2, this.measurementTwo, timestampsM1.length);
                maxMinM2 = (0, $96LZE.getMaxMin)(rawDataM2, this.measurementTwo);
                const min = Math.min(maxMinM1.min, maxMinM2.min);
                const max = Math.max(maxMinM1.max, maxMinM2.max);
                yAxisM2minVal = yAxisMinM2 ? yAxisMinM2 : yAxisRangePercentLimit ? Math.floor(min - min * (yAxisRangePercentLimit / 100)) : null;
                yAxisM2maxVal = yAxisMaxM2 ? yAxisMaxM2 : yAxisRangePercentLimit ? Math.ceil(max + min * (yAxisRangePercentLimit / 100)) : null;
            }
            // use same min max y axis values for M1 and M2
            const yAxisM1minVal = yAxisM2minVal !== undefined && rawDataM2.length ? yAxisM2minVal : yAxisMinM1 ? yAxisMinM1 : yAxisRangePercentLimit ? Math.floor(maxMinM1.min - maxMinM1.min * (yAxisRangePercentLimit / 100)) : null;
            const yAxisM1maxVal = yAxisM2maxVal !== undefined && rawDataM2.length ? yAxisM2maxVal : yAxisMaxM1 ? yAxisMaxM1 : yAxisRangePercentLimit ? Math.ceil(maxMinM1.max + maxMinM1.min * (yAxisRangePercentLimit / 100)) : null;
            let seriesNameM1 = this.getDisplaySummary(unitM1, displayTotalM1, rawDataM1, decimalsM1, averageM1, maxMinM1.min, maxMinM1.max);
            let seriesNameM2 = this.measurementTwo ? this.getDisplaySummary(unitM2, displayTotalM2, rawDataM2, decimalsM2, averageM2, maxMinM2.min, maxMinM2.max) : '';
            if (this.measurementTwo) {
                seriesNameM1 = seriesNameM1 + ' ' + LabelM1;
                seriesNameM2 = seriesNameM2 + ' ' + LabelM2;
            }
            let averageLineData;
            if (this.shouldPlotAverages) averageLineData = rawDataM1.map((gData)=>{
                return [
                    new Date(gData.timestamp * 1000).getTime(),
                    averageM1
                ];
            });
            let labelInterval;
            if (!isBarOrColumnGraph) switch(this.range){
                case (0, $ifhNi.RANGES).ONE_DAY:
                case (0, $ifhNi.RANGES).TWO_DAYS:
                    labelInterval = 28800000;
                    break;
                case (0, $ifhNi.RANGES).WEEKLY:
                case (0, $ifhNi.RANGES).MONTHLY:
                    labelInterval = 86400000;
                    break;
                case (0, $ifhNi.RANGES).YEARLY:
                    labelInterval = 2592000000;
                    break;
            }
            const legendAlign = valuesM2?.length ? 'center' : this.useMinimalUI ? 'left' : 'right';
            const titleAlign = this.titlePosition === 'center' ? 'center' : this.titlePosition === 'left' ? 'left' : this.useMinimalUI ? 'left' : 'center';
            this._chart = (0, (/*@__PURE__*/$parcel$interopDefault($f7Z1w))).chart(this.shadowRoot.getElementById('canvas'), {
                chart: {
                    zoomType: 'x',
                    style: {
                        fontFamily: 'museo-sans, sans-serif'
                    }
                },
                xAxis: {
                    type: isBarOrColumnGraph ? 'category' : 'datetime',
                    zoomEnabled: !isBarOrColumnGraph,
                    gridLineWidth: this.useMinimalUI ? 1 : 0,
                    gridLineColor: 'rgb(80,80,80, 0.1)',
                    categories: isBarOrColumnGraph ? timestampsM1.map((ts)=>ts.toString()) : null,
                    startOnTick: false,
                    endOnTick: false,
                    tickInterval: labelInterval,
                    labels: {
                        style: {
                            fontWeight: 'bold'
                        },
                        formatter: function() {
                            return xAxisLabelFormatterFunc.call(componentContext, this.value, isBarOrColumnGraph);
                        }
                    }
                },
                title: {
                    useHTML: icon ? true : false,
                    text: !this.shouldShowTitle ? undefined : icon ? `<img class="chart-icon" src="./assets/${icon}"><span>${LabelM1}</span>` : LabelM1,
                    style: {
                        color: colorM1,
                        fontFamily: 'museo-sans, sans-serif',
                        fontWeight: 'bold',
                        fontSize: '14'
                    },
                    align: titleAlign,
                    y: 40,
                    x: 8
                },
                subtitle: {
                    text: subtitle,
                    style: {
                        color: colorM2,
                        fontFamily: 'museo-sans, sans-serif',
                        fontWeight: 'bold'
                    },
                    y: 45
                },
                legend: {
                    useHTML: true,
                    labelFormatter: function() {
                        const label = this.index == 0 ? seriesNameM1 : seriesNameM2;
                        const color = this.index == 0 ? colorM1 : colorM2;
                        const classes = legendAlign === 'center' ? "ml-1" : "";
                        return `<p style='color:${color};' class=${classes}>${label}</p>`;
                    },
                    verticalAlign: this.useMinimalUI ? 'top' : 'bottom',
                    align: legendAlign,
                    y: 0,
                    symbolPadding: 0,
                    symbolWidth: 0,
                    symbolHeight: 0,
                    squareSymbol: false
                },
                tooltip: {
                    valueDecimals: 1,
                    backgroundColor: 'rgba(20,40,82,0.75)',
                    borderColor: "transparent",
                    useHTML: true,
                    formatter: function() {
                        const graphType = componentContext.getGraphType(this.series.index === 1 ? componentContext.measurementTwo : componentContext.measurementOne);
                        const isBarOrColumnGraph = graphType === (0, $ifhNi.GRAPH_TYPES).BAR || graphType === (0, $ifhNi.GRAPH_TYPES).COLUMN;
                        let value = this.x;
                        if (isBarOrColumnGraph) value = new Date(this.x * 1000).getTime();
                        // i.e. Apr 1 2021
                        let dateFormatted = (0, (/*@__PURE__*/$parcel$interopDefault($f7Z1w))).dateFormat.call(this, '%b %e, %Y', value);
                        let displayDate = dateFormatted;
                        // i.e. 09:00 AM
                        let displayHour = (0, (/*@__PURE__*/$parcel$interopDefault($f7Z1w))).dateFormat.call(this, '%I:%M %p ', value);
                        if (graphType === (0, $ifhNi.GRAPH_TYPES).BAR || graphType === (0, $ifhNi.GRAPH_TYPES).COLUMN) {
                            // i.e. Apr 2021
                            dateFormatted = (0, (/*@__PURE__*/$parcel$interopDefault($f7Z1w))).dateFormat.call(this, '%b, %Y', value);
                            if (range !== (0, $ifhNi.RANGES).ONE_DAY || range !== (0, $ifhNi.RANGES).TWO_DAYS) displayHour = '';
                            if (range === (0, $ifhNi.RANGES).YEARLY) displayDate = dateFormatted;
                            else if (range === (0, $ifhNi.RANGES).MONTHLY) displayDate = 'Week of ' + displayDate;
                        }
                        const decimals = this.series.index === 0 ? decimalsM1 : decimalsM2;
                        const unit = this.series.index === 1 ? unitM2 : unitM1;
                        const spaceBeforeUnit = (0, $hkQda.UNITS_SPACE_PREFIX).includes(unit) ? true : false;
                        const pluralUnits = (0, $hkQda.UNITS_PLURAL).includes(unit) ? true : false;
                        const displayUnit = pluralUnits && this.y > 1 ? unit.concat('s') : unit;
                        const spacer = spaceBeforeUnit ? ' ' : '';
                        const displayValue = (0, $hkQda.UNITS_PRECEDING_VALUE).includes(unit) ? unit + this.y.toFixed(decimals) : this.y.toFixed(decimals) + spacer + displayUnit;
                        return '<table class="tool-tip"><tr><td style="text-align: center">' + displayDate + '</td></tr>' + '<tr><td style="text-align: center">' + displayHour + '</td></tr>' + '<tr><td style="text-align: center">' + displayValue + '</td></tr>' + '</table>';
                    }
                },
                plotOptions: {
                    series: {
                        marker: {
                            enabled: false
                        }
                    }
                },
                yAxis: this.getYAxis(this.measurementOne, this.measurementTwo, yAxisLabel, yAxisM1minVal, yAxisM1maxVal, yAxisM2minVal, yAxisM2maxVal),
                series: this.getSeries(colorM1, colorAlphaM1, timestampsM1, valuesM1, colorM2, colorAlphaM2, timestampsM2, valuesM2, seriesNameM1, seriesNameM2, averageLineData, [], injectedTimestampsM2)
            });
        };
        (0, (/*@__PURE__*/$parcel$interopDefault($f7Z1w))).setOptions({
            time: {
                timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
            }
        });
    }
    updated(changed) {
        super.updated(changed);
    }
    async firstUpdated(changed) {
        await (0, $hkQda.loadStyle)('./css/graphs/berner-graph.css', this.shadowRoot);
        super.firstUpdated(changed);
        this.requestUpdate();
    }
    xAxisLabelFormatter(value, valueIsTimestamp) {
        let formattedDate = '';
        const graphType = this.getGraphType(this.measurementOne);
        if (valueIsTimestamp) {
            const date = new Date(Number(value) * 1000);
            value = date.getTime();
        }
        switch(this.range){
            case (0, $ifhNi.RANGES).ONE_DAY:
                formattedDate = (0, (/*@__PURE__*/$parcel$interopDefault($f7Z1w))).dateFormat('%I %p', value);
                break;
            case (0, $ifhNi.RANGES).TWO_DAYS:
                if (graphType === (0, $ifhNi.GRAPH_TYPES).BAR || graphType === (0, $ifhNi.GRAPH_TYPES).COLUMN) formattedDate = (0, (/*@__PURE__*/$parcel$interopDefault($f7Z1w))).dateFormat.call(this, '%m.%d', value);
                else formattedDate = (0, (/*@__PURE__*/$parcel$interopDefault($f7Z1w))).dateFormat('%I %p', value);
                break;
            case (0, $ifhNi.RANGES).WEEKLY:
            case (0, $ifhNi.RANGES).MONTHLY:
                formattedDate = (0, (/*@__PURE__*/$parcel$interopDefault($f7Z1w))).dateFormat.call(this, '%m.%d', value);
                break;
            case (0, $ifhNi.RANGES).YEARLY:
                formattedDate = (0, (/*@__PURE__*/$parcel$interopDefault($f7Z1w))).dateFormat.call(this, '%m', value);
                break;
        }
        return formattedDate;
    }
    render() {
        return (0, $2Vehe.html)`
        <link id="css-target">
        <div class="css-loading" id="root">
            <div class="container ${this.ratio}" id="container">
                <div class="chart-container">
                    <div class="canvas" id="canvas">
                        <div
                            class="spinner-border spinner-loader"
                            role="status"
                        ></div>
                    </div>
                </div>
            </div>
        </div>`;
    }
}
$50979cd2641a0dd9$export$345757aa11a5aaa5 = (0, $2eeCH.__decorate)([
    (0, $jZi7J.customElement)('berner-graph')
], $50979cd2641a0dd9$export$345757aa11a5aaa5);

});
parcelRegister("f7Z1w", function(module, exports) {
/*
 Highcharts JS v9.3.3 (2022-02-01)

 (c) 2009-2021 Torstein Honsi

 License: www.highcharts.com/license
*/ 'use strict';
(function(Z, M) {
    module.exports ? (M["default"] = M, module.exports = Z.document ? M(Z) : M) : "function" === typeof define && define.amd ? define("highcharts/highcharts", function() {
        return M(Z);
    }) : (Z.Highcharts && Z.Highcharts.error(16, !0), Z.Highcharts = M(Z));
})("undefined" !== typeof window ? window : module.exports, function(Z) {
    function M(v, a, z, F) {
        v.hasOwnProperty(a) || (v[a] = F.apply(null, z));
    }
    var a = {};
    M(a, "Core/Globals.js", [], function() {
        var v = "undefined" !== typeof Z ? Z : "undefined" !== typeof window ? window : {}, a;
        (function(a) {
            a.SVG_NS = "http://www.w3.org/2000/svg";
            a.product = "Highcharts";
            a.version = "9.3.3";
            a.win = v;
            a.doc = a.win.document;
            a.svg = a.doc && a.doc.createElementNS && !!a.doc.createElementNS(a.SVG_NS, "svg").createSVGRect;
            a.userAgent = a.win.navigator && a.win.navigator.userAgent || "";
            a.isChrome = -1 !== a.userAgent.indexOf("Chrome");
            a.isFirefox = -1 !== a.userAgent.indexOf("Firefox");
            a.isMS = /(edge|msie|trident)/i.test(a.userAgent) && !a.win.opera;
            a.isSafari = !a.isChrome && -1 !== a.userAgent.indexOf("Safari");
            a.isTouchDevice = /(Mobile|Android|Windows Phone)/.test(a.userAgent);
            a.isWebKit = -1 !== a.userAgent.indexOf("AppleWebKit");
            a.deg2rad = 2 * Math.PI / 360;
            a.hasBidiBug = a.isFirefox && 4 > parseInt(a.userAgent.split("Firefox/")[1], 10);
            a.hasTouch = !!a.win.TouchEvent;
            a.marginNames = [
                "plotTop",
                "marginRight",
                "marginBottom",
                "plotLeft"
            ];
            a.noop = function() {};
            a.supportsPassiveEvents = function() {
                var v = !1;
                if (!a.isMS) {
                    var u = Object.defineProperty({}, "passive", {
                        get: function() {
                            v = !0;
                        }
                    });
                    a.win.addEventListener && a.win.removeEventListener && (a.win.addEventListener("testPassive", a.noop, u), a.win.removeEventListener("testPassive", a.noop, u));
                }
                return v;
            }();
            a.charts = [];
            a.dateFormats = {};
            a.seriesTypes = {};
            a.symbolSizes = {};
            a.chartCount = 0;
        })(a || (a = {}));
        "";
        return a;
    });
    M(a, "Core/Utilities.js", [
        a["Core/Globals.js"]
    ], function(a) {
        function v(m, b, d, g) {
            var D = b ? "Highcharts error" : "Highcharts warning";
            32 === m && (m = D + ": Deprecated member");
            var x = n(m), c = x ? D + " #" + m + ": www.highcharts.com/errors/" + m + "/" : m.toString();
            if ("undefined" !== typeof g) {
                var r = "";
                x && (c += "?");
                B(g, function(m, b) {
                    r += "\n - " + b + ": " + m;
                    x && (c += encodeURI(b) + "=" + encodeURI(m));
                });
                c += r;
            }
            J(a, "displayError", {
                chart: d,
                code: m,
                message: c,
                params: g
            }, function() {
                if (b) throw Error(c);
                l.console && -1 === v.messages.indexOf(c) && console.warn(c);
            });
            v.messages.push(c);
        }
        function z(m, b) {
            var d = {};
            B(m, function(D, x) {
                if (H(m[x], !0) && !m.nodeType && b[x]) D = z(m[x], b[x]), Object.keys(D).length && (d[x] = D);
                else if (H(m[x]) || m[x] !== b[x]) d[x] = m[x];
            });
            return d;
        }
        function F(m, b) {
            return parseInt(m, b || 10);
        }
        function y(m) {
            return "string" === typeof m;
        }
        function G(m) {
            m = Object.prototype.toString.call(m);
            return "[object Array]" === m || "[object Array Iterator]" === m;
        }
        function H(m, b) {
            return !!m && "object" === typeof m && (!b || !G(m));
        }
        function A(m) {
            return H(m) && "number" === typeof m.nodeType;
        }
        function q(m) {
            var b = m && m.constructor;
            return !(!H(m, !0) || A(m) || !b || !b.name || "Object" === b.name);
        }
        function n(m) {
            return "number" === typeof m && !isNaN(m) && Infinity > m && -Infinity < m;
        }
        function k(m) {
            return "undefined" !== typeof m && null !== m;
        }
        function e(m, b, d) {
            var D;
            y(b) ? k(d) ? m.setAttribute(b, d) : m && m.getAttribute && ((D = m.getAttribute(b)) || "class" !== b || (D = m.getAttribute(b + "Name"))) : B(b, function(b, d) {
                k(b) ? m.setAttribute(d, b) : m.removeAttribute(d);
            });
            return D;
        }
        function c(b, d) {
            var m;
            b || (b = {});
            for(m in d)b[m] = d[m];
            return b;
        }
        function h() {
            for(var b = arguments, d = b.length, x = 0; x < d; x++){
                var g = b[x];
                if ("undefined" !== typeof g && null !== g) return g;
            }
        }
        function f(b, d) {
            a.isMS && !a.svg && d && "undefined" !== typeof d.opacity && (d.filter = "alpha(opacity=" + 100 * d.opacity + ")");
            c(b.style, d);
        }
        function w(b, d) {
            return 1E14 < b ? b : parseFloat(b.toPrecision(d || 14));
        }
        function p(b, d, x) {
            var m = a.getStyle || p;
            if ("width" === d) return d = Math.min(b.offsetWidth, b.scrollWidth), x = b.getBoundingClientRect && b.getBoundingClientRect().width, x < d && x >= d - 1 && (d = Math.floor(x)), Math.max(0, d - (m(b, "padding-left", !0) || 0) - (m(b, "padding-right", !0) || 0));
            if ("height" === d) return Math.max(0, Math.min(b.offsetHeight, b.scrollHeight) - (m(b, "padding-top", !0) || 0) - (m(b, "padding-bottom", !0) || 0));
            l.getComputedStyle || v(27, !0);
            if (b = l.getComputedStyle(b, void 0)) {
                var g = b.getPropertyValue(d);
                h(x, "opacity" !== d) && (g = F(g));
            }
            return g;
        }
        function B(b, d, g) {
            for(var m in b)Object.hasOwnProperty.call(b, m) && d.call(g || b[m], b[m], m, b);
        }
        function t(b, d, g) {
            function m(d, m) {
                var L = b.removeEventListener || a.removeEventListenerPolyfill;
                L && L.call(b, d, m, !1);
            }
            function x(g) {
                var x;
                if (b.nodeName) {
                    if (d) {
                        var L = {};
                        L[d] = !0;
                    } else L = g;
                    B(L, function(b, d) {
                        if (g[d]) for(x = g[d].length; x--;)m(d, g[d][x].fn);
                    });
                }
            }
            var D = "function" === typeof b && b.prototype || b;
            if (Object.hasOwnProperty.call(D, "hcEvents")) {
                var l = D.hcEvents;
                d ? (D = l[d] || [], g ? (l[d] = D.filter(function(b) {
                    return g !== b.fn;
                }), m(d, g)) : (x(l), l[d] = [])) : (x(l), delete D.hcEvents);
            }
        }
        function J(b, d, g, l) {
            g = g || {};
            if (r.createEvent && (b.dispatchEvent || b.fireEvent && b !== a)) {
                var m = r.createEvent("Events");
                m.initEvent(d, !0, !0);
                g = c(m, g);
                b.dispatchEvent ? b.dispatchEvent(g) : b.fireEvent(d, g);
            } else if (b.hcEvents) {
                g.target || c(g, {
                    preventDefault: function() {
                        g.defaultPrevented = !0;
                    },
                    target: b,
                    type: d
                });
                m = [];
                for(var x = b, D = !1; x.hcEvents;)Object.hasOwnProperty.call(x, "hcEvents") && x.hcEvents[d] && (m.length && (D = !0), m.unshift.apply(m, x.hcEvents[d])), x = Object.getPrototypeOf(x);
                D && m.sort(function(b, d) {
                    return b.order - d.order;
                });
                m.forEach(function(d) {
                    !1 === d.fn.call(b, g) && g.preventDefault();
                });
            }
            l && !g.defaultPrevented && l.call(b, g);
        }
        var C = a.charts, r = a.doc, l = a.win;
        (v || (v = {})).messages = [];
        Math.easeInOutSine = function(b) {
            return -0.5 * (Math.cos(Math.PI * b) - 1);
        };
        var b = Array.prototype.find ? function(b, d) {
            return b.find(d);
        } : function(b, d) {
            var m, g = b.length;
            for(m = 0; m < g; m++)if (d(b[m], m)) return b[m];
        };
        B({
            map: "map",
            each: "forEach",
            grep: "filter",
            reduce: "reduce",
            some: "some"
        }, function(b, d) {
            a[d] = function(m) {
                var g;
                v(32, !1, void 0, (g = {}, g["Highcharts." + d] = "use Array." + b, g));
                return Array.prototype[b].apply(m, [].slice.call(arguments, 1));
            };
        });
        var g, d = function() {
            var b = Math.random().toString(36).substring(2, 9) + "-", d = 0;
            return function() {
                return "highcharts-" + (g ? "" : b) + d++;
            };
        }();
        l.jQuery && (l.jQuery.fn.highcharts = function() {
            var b = [].slice.call(arguments);
            if (this[0]) return b[0] ? (new a[y(b[0]) ? b.shift() : "Chart"](this[0], b[0], b[1]), this) : C[e(this[0], "data-highcharts-chart")];
        });
        b = {
            addEvent: function(b, d, g, l) {
                void 0 === l && (l = {});
                var m = "function" === typeof b && b.prototype || b;
                Object.hasOwnProperty.call(m, "hcEvents") || (m.hcEvents = {});
                m = m.hcEvents;
                a.Point && b instanceof a.Point && b.series && b.series.chart && (b.series.chart.runTrackerClick = !0);
                var x = b.addEventListener || a.addEventListenerPolyfill;
                x && x.call(b, d, g, a.supportsPassiveEvents ? {
                    passive: void 0 === l.passive ? -1 !== d.indexOf("touch") : l.passive,
                    capture: !1
                } : !1);
                m[d] || (m[d] = []);
                m[d].push({
                    fn: g,
                    order: "number" === typeof l.order ? l.order : Infinity
                });
                m[d].sort(function(b, d) {
                    return b.order - d.order;
                });
                return function() {
                    t(b, d, g);
                };
            },
            arrayMax: function(b) {
                for(var d = b.length, m = b[0]; d--;)b[d] > m && (m = b[d]);
                return m;
            },
            arrayMin: function(b) {
                for(var d = b.length, m = b[0]; d--;)b[d] < m && (m = b[d]);
                return m;
            },
            attr: e,
            clamp: function(b, d, g) {
                return b > d ? b < g ? b : g : d;
            },
            cleanRecursively: z,
            clearTimeout: function(b) {
                k(b) && clearTimeout(b);
            },
            correctFloat: w,
            createElement: function(b, d, g, l, e) {
                b = r.createElement(b);
                d && c(b, d);
                e && f(b, {
                    padding: "0",
                    border: "none",
                    margin: "0"
                });
                g && f(b, g);
                l && l.appendChild(b);
                return b;
            },
            css: f,
            defined: k,
            destroyObjectProperties: function(b, d) {
                B(b, function(m, g) {
                    m && m !== d && m.destroy && m.destroy();
                    delete b[g];
                });
            },
            discardElement: function(b) {
                b && b.parentElement && b.parentElement.removeChild(b);
            },
            erase: function(b, d) {
                for(var m = b.length; m--;)if (b[m] === d) {
                    b.splice(m, 1);
                    break;
                }
            },
            error: v,
            extend: c,
            extendClass: function(b, d) {
                var m = function() {};
                m.prototype = new b;
                c(m.prototype, d);
                return m;
            },
            find: b,
            fireEvent: J,
            getMagnitude: function(b) {
                return Math.pow(10, Math.floor(Math.log(b) / Math.LN10));
            },
            getNestedProperty: function(b, d) {
                for(b = b.split("."); b.length && k(d);){
                    var m = b.shift();
                    if ("undefined" === typeof m || "__proto__" === m) return;
                    d = d[m];
                    if (!k(d) || "function" === typeof d || "number" === typeof d.nodeType || d === l) return;
                }
                return d;
            },
            getStyle: p,
            inArray: function(b, d, g) {
                v(32, !1, void 0, {
                    "Highcharts.inArray": "use Array.indexOf"
                });
                return d.indexOf(b, g);
            },
            isArray: G,
            isClass: q,
            isDOMElement: A,
            isFunction: function(b) {
                return "function" === typeof b;
            },
            isNumber: n,
            isObject: H,
            isString: y,
            keys: function(b) {
                v(32, !1, void 0, {
                    "Highcharts.keys": "use Object.keys"
                });
                return Object.keys(b);
            },
            merge: function() {
                var b, d = arguments, g = {}, l = function(b, d) {
                    "object" !== typeof b && (b = {});
                    B(d, function(m, g) {
                        "__proto__" !== g && "constructor" !== g && (!H(m, !0) || q(m) || A(m) ? b[g] = d[g] : b[g] = l(b[g] || {}, m));
                    });
                    return b;
                };
                !0 === d[0] && (g = d[1], d = Array.prototype.slice.call(d, 2));
                var c = d.length;
                for(b = 0; b < c; b++)g = l(g, d[b]);
                return g;
            },
            normalizeTickInterval: function(b, d, g, l, c) {
                var m = b;
                g = h(g, 1);
                var r = b / g;
                d || (d = c ? [
                    1,
                    1.2,
                    1.5,
                    2,
                    2.5,
                    3,
                    4,
                    5,
                    6,
                    8,
                    10
                ] : [
                    1,
                    2,
                    2.5,
                    5,
                    10
                ], !1 === l && (1 === g ? d = d.filter(function(b) {
                    return 0 === b % 1;
                }) : .1 >= g && (d = [
                    1 / g
                ])));
                for(l = 0; l < d.length && !(m = d[l], c && m * g >= b || !c && r <= (d[l] + (d[l + 1] || d[l])) / 2); l++);
                return m = w(m * g, -Math.round(Math.log(.001) / Math.LN10));
            },
            objectEach: B,
            offset: function(b) {
                var d = r.documentElement;
                b = b.parentElement || b.parentNode ? b.getBoundingClientRect() : {
                    top: 0,
                    left: 0,
                    width: 0,
                    height: 0
                };
                return {
                    top: b.top + (l.pageYOffset || d.scrollTop) - (d.clientTop || 0),
                    left: b.left + (l.pageXOffset || d.scrollLeft) - (d.clientLeft || 0),
                    width: b.width,
                    height: b.height
                };
            },
            pad: function(b, d, g) {
                return Array((d || 2) + 1 - String(b).replace("-", "").length).join(g || "0") + b;
            },
            pick: h,
            pInt: F,
            relativeLength: function(b, d, g) {
                return /%$/.test(b) ? d * parseFloat(b) / 100 + (g || 0) : parseFloat(b);
            },
            removeEvent: t,
            splat: function(b) {
                return G(b) ? b : [
                    b
                ];
            },
            stableSort: function(b, d) {
                var g = b.length, m, l;
                for(l = 0; l < g; l++)b[l].safeI = l;
                b.sort(function(b, g) {
                    m = d(b, g);
                    return 0 === m ? b.safeI - g.safeI : m;
                });
                for(l = 0; l < g; l++)delete b[l].safeI;
            },
            syncTimeout: function(b, d, g) {
                if (0 < d) return setTimeout(b, d, g);
                b.call(0, g);
                return -1;
            },
            timeUnits: {
                millisecond: 1,
                second: 1E3,
                minute: 6E4,
                hour: 36E5,
                day: 864E5,
                week: 6048E5,
                month: 24192E5,
                year: 314496E5
            },
            uniqueKey: d,
            useSerialIds: function(b) {
                return g = h(b, g);
            },
            wrap: function(b, d, g) {
                var m = b[d];
                b[d] = function() {
                    var b = Array.prototype.slice.call(arguments), d = arguments, l = this;
                    l.proceed = function() {
                        m.apply(l, arguments.length ? arguments : d);
                    };
                    b.unshift(m);
                    b = g.apply(this, b);
                    l.proceed = null;
                    return b;
                };
            }
        };
        "";
        return b;
    });
    M(a, "Core/Chart/ChartDefaults.js", [], function() {
        return {
            panning: {
                enabled: !1,
                type: "x"
            },
            styledMode: !1,
            borderRadius: 0,
            colorCount: 10,
            defaultSeriesType: "line",
            ignoreHiddenSeries: !0,
            spacing: [
                10,
                10,
                15,
                10
            ],
            resetZoomButton: {
                theme: {
                    zIndex: 6
                },
                position: {
                    align: "right",
                    x: -10,
                    y: 10
                }
            },
            zoomBySingleTouch: !1,
            width: null,
            height: null,
            borderColor: "#335cad",
            backgroundColor: "#ffffff",
            plotBorderColor: "#cccccc"
        };
    });
    M(a, "Core/Color/Color.js", [
        a["Core/Globals.js"],
        a["Core/Utilities.js"]
    ], function(a, u) {
        var v = u.isNumber, F = u.merge, y = u.pInt;
        u = function() {
            function u(v) {
                this.rgba = [
                    NaN,
                    NaN,
                    NaN,
                    NaN
                ];
                this.input = v;
                var A = a.Color;
                if (A && A !== u) return new A(v);
                if (!(this instanceof u)) return new u(v);
                this.init(v);
            }
            u.parse = function(a) {
                return a ? new u(a) : u.None;
            };
            u.prototype.init = function(a) {
                var A;
                if ("object" === typeof a && "undefined" !== typeof a.stops) this.stops = a.stops.map(function(e) {
                    return new u(e[1]);
                });
                else if ("string" === typeof a) {
                    this.input = a = u.names[a.toLowerCase()] || a;
                    if ("#" === a.charAt(0)) {
                        var q = a.length;
                        var n = parseInt(a.substr(1), 16);
                        7 === q ? A = [
                            (n & 16711680) >> 16,
                            (n & 65280) >> 8,
                            n & 255,
                            1
                        ] : 4 === q && (A = [
                            (n & 3840) >> 4 | (n & 3840) >> 8,
                            (n & 240) >> 4 | n & 240,
                            (n & 15) << 4 | n & 15,
                            1
                        ]);
                    }
                    if (!A) for(n = u.parsers.length; n-- && !A;){
                        var k = u.parsers[n];
                        (q = k.regex.exec(a)) && (A = k.parse(q));
                    }
                }
                A && (this.rgba = A);
            };
            u.prototype.get = function(a) {
                var A = this.input, q = this.rgba;
                if ("object" === typeof A && "undefined" !== typeof this.stops) {
                    var n = F(A);
                    n.stops = [].slice.call(n.stops);
                    this.stops.forEach(function(k, e) {
                        n.stops[e] = [
                            n.stops[e][0],
                            k.get(a)
                        ];
                    });
                    return n;
                }
                return q && v(q[0]) ? "rgb" === a || !a && 1 === q[3] ? "rgb(" + q[0] + "," + q[1] + "," + q[2] + ")" : "a" === a ? "" + q[3] : "rgba(" + q.join(",") + ")" : A;
            };
            u.prototype.brighten = function(a) {
                var A = this.rgba;
                if (this.stops) this.stops.forEach(function(n) {
                    n.brighten(a);
                });
                else if (v(a) && 0 !== a) for(var q = 0; 3 > q; q++)A[q] += y(255 * a), 0 > A[q] && (A[q] = 0), 255 < A[q] && (A[q] = 255);
                return this;
            };
            u.prototype.setOpacity = function(a) {
                this.rgba[3] = a;
                return this;
            };
            u.prototype.tweenTo = function(a, A) {
                var q = this.rgba, n = a.rgba;
                if (!v(q[0]) || !v(n[0])) return a.input || "none";
                a = 1 !== n[3] || 1 !== q[3];
                return (a ? "rgba(" : "rgb(") + Math.round(n[0] + (q[0] - n[0]) * (1 - A)) + "," + Math.round(n[1] + (q[1] - n[1]) * (1 - A)) + "," + Math.round(n[2] + (q[2] - n[2]) * (1 - A)) + (a ? "," + (n[3] + (q[3] - n[3]) * (1 - A)) : "") + ")";
            };
            u.names = {
                white: "#ffffff",
                black: "#000000"
            };
            u.parsers = [
                {
                    regex: /rgba\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]?(?:\.[0-9]+)?)\s*\)/,
                    parse: function(a) {
                        return [
                            y(a[1]),
                            y(a[2]),
                            y(a[3]),
                            parseFloat(a[4], 10)
                        ];
                    }
                },
                {
                    regex: /rgb\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*\)/,
                    parse: function(a) {
                        return [
                            y(a[1]),
                            y(a[2]),
                            y(a[3]),
                            1
                        ];
                    }
                }
            ];
            u.None = new u("");
            return u;
        }();
        "";
        return u;
    });
    M(a, "Core/Color/Palettes.js", [], function() {
        return {
            colors: "#7cb5ec #434348 #90ed7d #f7a35c #8085e9 #f15c80 #e4d354 #2b908f #f45b5b #91e8e1".split(" ")
        };
    });
    M(a, "Core/Time.js", [
        a["Core/Globals.js"],
        a["Core/Utilities.js"]
    ], function(a, u) {
        var v = a.win, F = u.defined, y = u.error, G = u.extend, H = u.isObject, A = u.merge, q = u.objectEach, n = u.pad, k = u.pick, e = u.splat, c = u.timeUnits, h = a.isSafari && v.Intl && v.Intl.DateTimeFormat.prototype.formatRange, f = a.isSafari && v.Intl && !v.Intl.DateTimeFormat.prototype.formatRange;
        u = function() {
            function w(c) {
                this.options = {};
                this.variableTimezone = this.useUTC = !1;
                this.Date = v.Date;
                this.getTimezoneOffset = this.timezoneOffsetFunction();
                this.update(c);
            }
            w.prototype.get = function(c, e) {
                if (this.variableTimezone || this.timezoneOffset) {
                    var p = e.getTime(), f = p - this.getTimezoneOffset(e);
                    e.setTime(f);
                    c = e["getUTC" + c]();
                    e.setTime(p);
                    return c;
                }
                return this.useUTC ? e["getUTC" + c]() : e["get" + c]();
            };
            w.prototype.set = function(c, e, f) {
                if (this.variableTimezone || this.timezoneOffset) {
                    if ("Milliseconds" === c || "Seconds" === c || "Minutes" === c && 0 === this.getTimezoneOffset(e) % 36E5) return e["setUTC" + c](f);
                    var p = this.getTimezoneOffset(e);
                    p = e.getTime() - p;
                    e.setTime(p);
                    e["setUTC" + c](f);
                    c = this.getTimezoneOffset(e);
                    p = e.getTime() + c;
                    return e.setTime(p);
                }
                return this.useUTC || h && "FullYear" === c ? e["setUTC" + c](f) : e["set" + c](f);
            };
            w.prototype.update = function(c) {
                var e = k(c && c.useUTC, !0);
                this.options = c = A(!0, this.options || {}, c);
                this.Date = c.Date || v.Date || Date;
                this.timezoneOffset = (this.useUTC = e) && c.timezoneOffset;
                this.getTimezoneOffset = this.timezoneOffsetFunction();
                this.variableTimezone = e && !(!c.getTimezoneOffset && !c.timezone);
            };
            w.prototype.makeTime = function(c, e, h, w, C, r) {
                if (this.useUTC) {
                    var l = this.Date.UTC.apply(0, arguments);
                    var b = this.getTimezoneOffset(l);
                    l += b;
                    var g = this.getTimezoneOffset(l);
                    b !== g ? l += g - b : b - 36E5 !== this.getTimezoneOffset(l - 36E5) || f || (l -= 36E5);
                } else l = new this.Date(c, e, k(h, 1), k(w, 0), k(C, 0), k(r, 0)).getTime();
                return l;
            };
            w.prototype.timezoneOffsetFunction = function() {
                var c = this, e = this.options, f = e.getTimezoneOffset, h = e.moment || v.moment;
                if (!this.useUTC) return function(c) {
                    return 6E4 * new Date(c.toString()).getTimezoneOffset();
                };
                if (e.timezone) {
                    if (h) return function(c) {
                        return 6E4 * -h.tz(c, e.timezone).utcOffset();
                    };
                    y(25);
                }
                return this.useUTC && f ? function(c) {
                    return 6E4 * f(c.valueOf());
                } : function() {
                    return 6E4 * (c.timezoneOffset || 0);
                };
            };
            w.prototype.dateFormat = function(c, e, f) {
                if (!F(e) || isNaN(e)) return a.defaultOptions.lang && a.defaultOptions.lang.invalidDate || "";
                c = k(c, "%Y-%m-%d %H:%M:%S");
                var p = this, h = new this.Date(e), r = this.get("Hours", h), l = this.get("Day", h), b = this.get("Date", h), g = this.get("Month", h), d = this.get("FullYear", h), m = a.defaultOptions.lang, D = m && m.weekdays, x = m && m.shortWeekdays;
                h = G({
                    a: x ? x[l] : D[l].substr(0, 3),
                    A: D[l],
                    d: n(b),
                    e: n(b, 2, " "),
                    w: l,
                    b: m.shortMonths[g],
                    B: m.months[g],
                    m: n(g + 1),
                    o: g + 1,
                    y: d.toString().substr(2, 2),
                    Y: d,
                    H: n(r),
                    k: r,
                    I: n(r % 12 || 12),
                    l: r % 12 || 12,
                    M: n(this.get("Minutes", h)),
                    p: 12 > r ? "AM" : "PM",
                    P: 12 > r ? "am" : "pm",
                    S: n(h.getSeconds()),
                    L: n(Math.floor(e % 1E3), 3)
                }, a.dateFormats);
                q(h, function(b, d) {
                    for(; -1 !== c.indexOf("%" + d);)c = c.replace("%" + d, "function" === typeof b ? b.call(p, e) : b);
                });
                return f ? c.substr(0, 1).toUpperCase() + c.substr(1) : c;
            };
            w.prototype.resolveDTLFormat = function(c) {
                return H(c, !0) ? c : (c = e(c), {
                    main: c[0],
                    from: c[1],
                    to: c[2]
                });
            };
            w.prototype.getTimeTicks = function(e, h, f, w) {
                var p = this, r = [], l = {}, b = new p.Date(h), g = e.unitRange, d = e.count || 1, m;
                w = k(w, 1);
                if (F(h)) {
                    p.set("Milliseconds", b, g >= c.second ? 0 : d * Math.floor(p.get("Milliseconds", b) / d));
                    g >= c.second && p.set("Seconds", b, g >= c.minute ? 0 : d * Math.floor(p.get("Seconds", b) / d));
                    g >= c.minute && p.set("Minutes", b, g >= c.hour ? 0 : d * Math.floor(p.get("Minutes", b) / d));
                    g >= c.hour && p.set("Hours", b, g >= c.day ? 0 : d * Math.floor(p.get("Hours", b) / d));
                    g >= c.day && p.set("Date", b, g >= c.month ? 1 : Math.max(1, d * Math.floor(p.get("Date", b) / d)));
                    if (g >= c.month) {
                        p.set("Month", b, g >= c.year ? 0 : d * Math.floor(p.get("Month", b) / d));
                        var D = p.get("FullYear", b);
                    }
                    g >= c.year && p.set("FullYear", b, D - D % d);
                    g === c.week && (D = p.get("Day", b), p.set("Date", b, p.get("Date", b) - D + w + (D < w ? -7 : 0)));
                    D = p.get("FullYear", b);
                    w = p.get("Month", b);
                    var x = p.get("Date", b), t = p.get("Hours", b);
                    h = b.getTime();
                    !p.variableTimezone && p.useUTC || !F(f) || (m = f - h > 4 * c.month || p.getTimezoneOffset(h) !== p.getTimezoneOffset(f));
                    h = b.getTime();
                    for(b = 1; h < f;)r.push(h), h = g === c.year ? p.makeTime(D + b * d, 0) : g === c.month ? p.makeTime(D, w + b * d) : !m || g !== c.day && g !== c.week ? m && g === c.hour && 1 < d ? p.makeTime(D, w, x, t + b * d) : h + g * d : p.makeTime(D, w, x + b * d * (g === c.day ? 1 : 7)), b++;
                    r.push(h);
                    g <= c.hour && 1E4 > r.length && r.forEach(function(b) {
                        0 === b % 18E5 && "000000000" === p.dateFormat("%H%M%S%L", b) && (l[b] = "day");
                    });
                }
                r.info = G(e, {
                    higherRanks: l,
                    totalRange: g * d
                });
                return r;
            };
            w.prototype.getDateFormat = function(e, h, f, w) {
                var p = this.dateFormat("%m-%d %H:%M:%S.%L", h), r = {
                    millisecond: 15,
                    second: 12,
                    minute: 9,
                    hour: 6,
                    day: 3
                }, l = "millisecond";
                for(b in c){
                    if (e === c.week && +this.dateFormat("%w", h) === f && "00:00:00.000" === p.substr(6)) {
                        var b = "week";
                        break;
                    }
                    if (c[b] > e) {
                        b = l;
                        break;
                    }
                    if (r[b] && p.substr(r[b]) !== "01-01 00:00:00.000".substr(r[b])) break;
                    "week" !== b && (l = b);
                }
                if (b) var g = this.resolveDTLFormat(w[b]).main;
                return g;
            };
            return w;
        }();
        "";
        return u;
    });
    M(a, "Core/DefaultOptions.js", [
        a["Core/Chart/ChartDefaults.js"],
        a["Core/Color/Color.js"],
        a["Core/Globals.js"],
        a["Core/Color/Palettes.js"],
        a["Core/Time.js"],
        a["Core/Utilities.js"]
    ], function(a, u, z, F, y, G) {
        u = u.parse;
        var v = G.merge, A = {
            colors: F.colors,
            symbols: [
                "circle",
                "diamond",
                "square",
                "triangle",
                "triangle-down"
            ],
            lang: {
                loading: "Loading...",
                months: "January February March April May June July August September October November December".split(" "),
                shortMonths: "Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec".split(" "),
                weekdays: "Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" "),
                decimalPoint: ".",
                numericSymbols: "kMGTPE".split(""),
                resetZoom: "Reset zoom",
                resetZoomTitle: "Reset zoom level 1:1",
                thousandsSep: " "
            },
            global: {},
            time: {
                Date: void 0,
                getTimezoneOffset: void 0,
                timezone: void 0,
                timezoneOffset: 0,
                useUTC: !0
            },
            chart: a,
            title: {
                text: "Chart title",
                align: "center",
                margin: 15,
                widthAdjust: -44
            },
            subtitle: {
                text: "",
                align: "center",
                widthAdjust: -44
            },
            caption: {
                margin: 15,
                text: "",
                align: "left",
                verticalAlign: "bottom"
            },
            plotOptions: {},
            labels: {
                style: {
                    position: "absolute",
                    color: "#333333"
                }
            },
            legend: {
                enabled: !0,
                align: "center",
                alignColumns: !0,
                className: "highcharts-no-tooltip",
                layout: "horizontal",
                labelFormatter: function() {
                    return this.name;
                },
                borderColor: "#999999",
                borderRadius: 0,
                navigation: {
                    activeColor: "#003399",
                    inactiveColor: "#cccccc"
                },
                itemStyle: {
                    color: "#333333",
                    cursor: "pointer",
                    fontSize: "12px",
                    fontWeight: "bold",
                    textOverflow: "ellipsis"
                },
                itemHoverStyle: {
                    color: "#000000"
                },
                itemHiddenStyle: {
                    color: "#cccccc"
                },
                shadow: !1,
                itemCheckboxStyle: {
                    position: "absolute",
                    width: "13px",
                    height: "13px"
                },
                squareSymbol: !0,
                symbolPadding: 5,
                verticalAlign: "bottom",
                x: 0,
                y: 0,
                title: {
                    style: {
                        fontWeight: "bold"
                    }
                }
            },
            loading: {
                labelStyle: {
                    fontWeight: "bold",
                    position: "relative",
                    top: "45%"
                },
                style: {
                    position: "absolute",
                    backgroundColor: "#ffffff",
                    opacity: .5,
                    textAlign: "center"
                }
            },
            tooltip: {
                enabled: !0,
                animation: z.svg,
                borderRadius: 3,
                dateTimeLabelFormats: {
                    millisecond: "%A, %b %e, %H:%M:%S.%L",
                    second: "%A, %b %e, %H:%M:%S",
                    minute: "%A, %b %e, %H:%M",
                    hour: "%A, %b %e, %H:%M",
                    day: "%A, %b %e, %Y",
                    week: "Week from %A, %b %e, %Y",
                    month: "%B %Y",
                    year: "%Y"
                },
                footerFormat: "",
                headerShape: "callout",
                hideDelay: 500,
                padding: 8,
                shape: "callout",
                shared: !1,
                snap: z.isTouchDevice ? 25 : 10,
                headerFormat: '<span style="font-size: 10px">{point.key}</span><br/>',
                pointFormat: '<span style="color:{point.color}">\u25cf</span> {series.name}: <b>{point.y}</b><br/>',
                backgroundColor: u("#f7f7f7").setOpacity(.85).get(),
                borderWidth: 1,
                shadow: !0,
                stickOnContact: !1,
                style: {
                    color: "#333333",
                    cursor: "default",
                    fontSize: "12px",
                    whiteSpace: "nowrap"
                },
                useHTML: !1
            },
            credits: {
                enabled: !0,
                href: "https://www.highcharts.com?credits",
                position: {
                    align: "right",
                    x: -10,
                    verticalAlign: "bottom",
                    y: -5
                },
                style: {
                    cursor: "pointer",
                    color: "#999999",
                    fontSize: "9px"
                },
                text: "Highcharts.com"
            }
        };
        A.chart.styledMode = !1;
        "";
        var q = new y(v(A.global, A.time));
        a = {
            defaultOptions: A,
            defaultTime: q,
            getOptions: function() {
                return A;
            },
            setOptions: function(n) {
                v(!0, A, n);
                if (n.time || n.global) z.time ? z.time.update(v(A.global, A.time, n.global, n.time)) : z.time = q;
                return A;
            }
        };
        "";
        return a;
    });
    M(a, "Core/Animation/Fx.js", [
        a["Core/Color/Color.js"],
        a["Core/Globals.js"],
        a["Core/Utilities.js"]
    ], function(a, u, z) {
        var v = a.parse, y = u.win, G = z.isNumber, H = z.objectEach;
        return function() {
            function a(a, n, k) {
                this.pos = NaN;
                this.options = n;
                this.elem = a;
                this.prop = k;
            }
            a.prototype.dSetter = function() {
                var a = this.paths, n = a && a[0];
                a = a && a[1];
                var k = this.now || 0, e = [];
                if (1 !== k && n && a) {
                    if (n.length === a.length && 1 > k) for(var c = 0; c < a.length; c++){
                        for(var h = n[c], f = a[c], w = [], p = 0; p < f.length; p++){
                            var B = h[p], t = f[p];
                            G(B) && G(t) && ("A" !== f[0] || 4 !== p && 5 !== p) ? w[p] = B + k * (t - B) : w[p] = t;
                        }
                        e.push(w);
                    }
                    else e = a;
                } else e = this.toD || [];
                this.elem.attr("d", e, void 0, !0);
            };
            a.prototype.update = function() {
                var a = this.elem, n = this.prop, k = this.now, e = this.options.step;
                if (this[n + "Setter"]) this[n + "Setter"]();
                else a.attr ? a.element && a.attr(n, k, null, !0) : a.style[n] = k + this.unit;
                e && e.call(a, k, this);
            };
            a.prototype.run = function(q, n, k) {
                var e = this, c = e.options, h = function(c) {
                    return h.stopped ? !1 : e.step(c);
                }, f = y.requestAnimationFrame || function(c) {
                    setTimeout(c, 13);
                }, w = function() {
                    for(var c = 0; c < a.timers.length; c++)a.timers[c]() || a.timers.splice(c--, 1);
                    a.timers.length && f(w);
                };
                q !== n || this.elem["forceAnimate:" + this.prop] ? (this.startTime = +new Date, this.start = q, this.end = n, this.unit = k, this.now = this.start, this.pos = 0, h.elem = this.elem, h.prop = this.prop, h() && 1 === a.timers.push(h) && f(w)) : (delete c.curAnim[this.prop], c.complete && 0 === Object.keys(c.curAnim).length && c.complete.call(this.elem));
            };
            a.prototype.step = function(a) {
                var n = +new Date, k = this.options, e = this.elem, c = k.complete, h = k.duration, f = k.curAnim;
                if (e.attr && !e.element) a = !1;
                else if (a || n >= h + this.startTime) {
                    this.now = this.end;
                    this.pos = 1;
                    this.update();
                    var w = f[this.prop] = !0;
                    H(f, function(c) {
                        !0 !== c && (w = !1);
                    });
                    w && c && c.call(e);
                    a = !1;
                } else this.pos = k.easing((n - this.startTime) / h), this.now = this.start + (this.end - this.start) * this.pos, this.update(), a = !0;
                return a;
            };
            a.prototype.initPath = function(a, n, k) {
                function e(c, e) {
                    for(; c.length < J;){
                        var l = c[0], b = e[J - c.length];
                        b && "M" === l[0] && (c[0] = "C" === b[0] ? [
                            "C",
                            l[1],
                            l[2],
                            l[1],
                            l[2],
                            l[1],
                            l[2]
                        ] : [
                            "L",
                            l[1],
                            l[2]
                        ]);
                        c.unshift(l);
                        w && (l = c.pop(), c.push(c[c.length - 1], l));
                    }
                }
                function c(c, e) {
                    for(; c.length < J;)if (e = c[Math.floor(c.length / p) - 1].slice(), "C" === e[0] && (e[1] = e[5], e[2] = e[6]), w) {
                        var l = c[Math.floor(c.length / p)].slice();
                        c.splice(c.length / 2, 0, e, l);
                    } else c.push(e);
                }
                var h = a.startX, f = a.endX;
                k = k.slice();
                var w = a.isArea, p = w ? 2 : 1;
                n = n && n.slice();
                if (!n) return [
                    k,
                    k
                ];
                if (h && f && f.length) {
                    for(a = 0; a < h.length; a++)if (h[a] === f[0]) {
                        var B = a;
                        break;
                    } else if (h[0] === f[f.length - h.length + a]) {
                        B = a;
                        var t = !0;
                        break;
                    } else if (h[h.length - 1] === f[f.length - h.length + a]) {
                        B = h.length - a;
                        break;
                    }
                    "undefined" === typeof B && (n = []);
                }
                if (n.length && G(B)) {
                    var J = k.length + B * p;
                    t ? (e(n, k), c(k, n)) : (e(k, n), c(n, k));
                }
                return [
                    n,
                    k
                ];
            };
            a.prototype.fillSetter = function() {
                a.prototype.strokeSetter.apply(this, arguments);
            };
            a.prototype.strokeSetter = function() {
                this.elem.attr(this.prop, v(this.start).tweenTo(v(this.end), this.pos), void 0, !0);
            };
            a.timers = [];
            return a;
        }();
    });
    M(a, "Core/Animation/AnimationUtilities.js", [
        a["Core/Animation/Fx.js"],
        a["Core/Utilities.js"]
    ], function(a, u) {
        function v(c) {
            return q(c) ? n({
                duration: 500,
                defer: 0
            }, c) : {
                duration: c ? 500 : 0,
                defer: 0
            };
        }
        function F(c, e) {
            for(var h = a.timers.length; h--;)a.timers[h].elem !== c || e && e !== a.timers[h].prop || (a.timers[h].stopped = !0);
        }
        var y = u.defined, G = u.getStyle, H = u.isArray, A = u.isNumber, q = u.isObject, n = u.merge, k = u.objectEach, e = u.pick;
        return {
            animate: function(c, e, f) {
                var h, p = "", B, t;
                if (!q(f)) {
                    var J = arguments;
                    f = {
                        duration: J[2],
                        easing: J[3],
                        complete: J[4]
                    };
                }
                A(f.duration) || (f.duration = 400);
                f.easing = "function" === typeof f.easing ? f.easing : Math[f.easing] || Math.easeInOutSine;
                f.curAnim = n(e);
                k(e, function(k, r) {
                    F(c, r);
                    t = new a(c, f, r);
                    B = void 0;
                    "d" === r && H(e.d) ? (t.paths = t.initPath(c, c.pathArray, e.d), t.toD = e.d, h = 0, B = 1) : c.attr ? h = c.attr(r) : (h = parseFloat(G(c, r)) || 0, "opacity" !== r && (p = "px"));
                    B || (B = k);
                    "string" === typeof B && B.match("px") && (B = B.replace(/px/g, ""));
                    t.run(h, B, p);
                });
            },
            animObject: v,
            getDeferredAnimation: function(c, e, f) {
                var h = v(e), p = 0, a = 0;
                (f ? [
                    f
                ] : c.series).forEach(function(c) {
                    c = v(c.options.animation);
                    p = e && y(e.defer) ? h.defer : Math.max(p, c.duration + c.defer);
                    a = Math.min(h.duration, c.duration);
                });
                c.renderer.forExport && (p = 0);
                return {
                    defer: Math.max(0, p - a),
                    duration: Math.min(p, a)
                };
            },
            setAnimation: function(c, h) {
                h.renderer.globalAnimation = e(c, h.options.chart.animation, !0);
            },
            stop: F
        };
    });
    M(a, "Core/Renderer/HTML/AST.js", [
        a["Core/Globals.js"],
        a["Core/Utilities.js"]
    ], function(a, u) {
        var v = a.SVG_NS, F = u.attr, y = u.createElement, G = u.error, H = u.isFunction, A = u.isString, q = u.objectEach, n = u.splat, k = (u = a.win.trustedTypes) && H(u.createPolicy) && u.createPolicy("highcharts", {
            createHTML: function(c) {
                return c;
            }
        }), e = k ? k.createHTML("") : "";
        try {
            var c = !!(new DOMParser).parseFromString(e, "text/html");
        } catch (h) {
            c = !1;
        }
        H = function() {
            function h(c) {
                this.nodes = "string" === typeof c ? this.parseMarkup(c) : c;
            }
            h.filterUserAttributes = function(c) {
                q(c, function(e, p) {
                    var f = !0;
                    -1 === h.allowedAttributes.indexOf(p) && (f = !1);
                    -1 !== [
                        "background",
                        "dynsrc",
                        "href",
                        "lowsrc",
                        "src"
                    ].indexOf(p) && (f = A(e) && h.allowedReferences.some(function(c) {
                        return 0 === e.indexOf(c);
                    }));
                    f || (G("Highcharts warning: Invalid attribute '" + p + "' in config"), delete c[p]);
                });
                return c;
            };
            h.setElementHTML = function(c, e) {
                c.innerHTML = h.emptyHTML;
                e && new h(e).addToDOM(c);
            };
            h.prototype.addToDOM = function(c) {
                function e(c, f) {
                    var p;
                    n(c).forEach(function(c) {
                        var t = c.tagName, r = c.textContent ? a.doc.createTextNode(c.textContent) : void 0;
                        if (t) {
                            if ("#text" === t) var l = r;
                            else if (-1 !== h.allowedTags.indexOf(t)) {
                                t = a.doc.createElementNS("svg" === t ? v : f.namespaceURI || v, t);
                                var b = c.attributes || {};
                                q(c, function(c, d) {
                                    "tagName" !== d && "attributes" !== d && "children" !== d && "textContent" !== d && (b[d] = c);
                                });
                                F(t, h.filterUserAttributes(b));
                                r && t.appendChild(r);
                                e(c.children || [], t);
                                l = t;
                            } else G("Highcharts warning: Invalid tagName " + t + " in config");
                        }
                        l && f.appendChild(l);
                        p = l;
                    });
                    return p;
                }
                return e(this.nodes, c);
            };
            h.prototype.parseMarkup = function(e) {
                var h = [];
                e = e.trim();
                if (c) e = (new DOMParser).parseFromString(k ? k.createHTML(e) : e, "text/html");
                else {
                    var p = y("div");
                    p.innerHTML = e;
                    e = {
                        body: p
                    };
                }
                var f = function(c, e) {
                    var h = c.nodeName.toLowerCase(), r = {
                        tagName: h
                    };
                    "#text" === h && (r.textContent = c.textContent || "");
                    if (h = c.attributes) {
                        var l = {};
                        [].forEach.call(h, function(b) {
                            l[b.name] = b.value;
                        });
                        r.attributes = l;
                    }
                    if (c.childNodes.length) {
                        var b = [];
                        [].forEach.call(c.childNodes, function(c) {
                            f(c, b);
                        });
                        b.length && (r.children = b);
                    }
                    e.push(r);
                };
                [].forEach.call(e.body.childNodes, function(c) {
                    return f(c, h);
                });
                return h;
            };
            h.allowedAttributes = "aria-controls aria-describedby aria-expanded aria-haspopup aria-hidden aria-label aria-labelledby aria-live aria-pressed aria-readonly aria-roledescription aria-selected class clip-path color colspan cx cy d dx dy disabled fill height href id in markerHeight markerWidth offset opacity orient padding paddingLeft paddingRight patternUnits r refX refY role scope slope src startOffset stdDeviation stroke stroke-linecap stroke-width style tableValues result rowspan summary target tabindex text-align textAnchor textLength title type valign width x x1 x2 y y1 y2 zIndex".split(" ");
            h.allowedReferences = "https:// http:// mailto: / ../ ./ #".split(" ");
            h.allowedTags = "a abbr b br button caption circle clipPath code dd defs div dl dt em feComponentTransfer feFuncA feFuncB feFuncG feFuncR feGaussianBlur feOffset feMerge feMergeNode filter h1 h2 h3 h4 h5 h6 hr i img li linearGradient marker ol p path pattern pre rect small span stop strong style sub sup svg table text thead tbody tspan td th tr u ul #text".split(" ");
            h.emptyHTML = e;
            return h;
        }();
        "";
        return H;
    });
    M(a, "Core/FormatUtilities.js", [
        a["Core/DefaultOptions.js"],
        a["Core/Utilities.js"]
    ], function(a, u) {
        function v(a, k, e, c) {
            a = +a || 0;
            k = +k;
            var h = F.lang, f = (a.toString().split(".")[1] || "").split("e")[0].length, w = a.toString().split("e"), p = k;
            if (-1 === k) k = Math.min(f, 20);
            else if (!H(k)) k = 2;
            else if (k && w[1] && 0 > w[1]) {
                var B = k + +w[1];
                0 <= B ? (w[0] = (+w[0]).toExponential(B).split("e")[0], k = B) : (w[0] = w[0].split(".")[0] || 0, a = 20 > k ? (w[0] * Math.pow(10, w[1])).toFixed(k) : 0, w[1] = 0);
            }
            B = (Math.abs(w[1] ? w[0] : a) + Math.pow(10, -Math.max(k, f) - 1)).toFixed(k);
            f = String(q(B));
            var t = 3 < f.length ? f.length % 3 : 0;
            e = A(e, h.decimalPoint);
            c = A(c, h.thousandsSep);
            a = (0 > a ? "-" : "") + (t ? f.substr(0, t) + c : "");
            a = 0 > +w[1] && !p ? "0" : a + f.substr(t).replace(/(\d{3})(?=\d)/g, "$1" + c);
            k && (a += e + B.slice(-k));
            w[1] && 0 !== +a && (a += "e" + w[1]);
            return a;
        }
        var F = a.defaultOptions, y = a.defaultTime, G = u.getNestedProperty, H = u.isNumber, A = u.pick, q = u.pInt;
        return {
            dateFormat: function(a, k, e) {
                return y.dateFormat(a, k, e);
            },
            format: function(a, k, e) {
                var c = "{", h = !1, f = /f$/, w = /\.([0-9])/, p = F.lang, B = e && e.time || y;
                e = e && e.numberFormatter || v;
                for(var t = []; a;){
                    var J = a.indexOf(c);
                    if (-1 === J) break;
                    var C = a.slice(0, J);
                    if (h) {
                        C = C.split(":");
                        c = G(C.shift() || "", k);
                        if (C.length && "number" === typeof c) {
                            if (C = C.join(":"), f.test(C)) {
                                var r = parseInt((C.match(w) || [
                                    "",
                                    "-1"
                                ])[1], 10);
                                null !== c && (c = e(c, r, p.decimalPoint, -1 < C.indexOf(",") ? p.thousandsSep : ""));
                            } else c = B.dateFormat(C, c);
                        }
                        t.push(c);
                    } else t.push(C);
                    a = a.slice(J + 1);
                    c = (h = !h) ? "}" : "{";
                }
                t.push(a);
                return t.join("");
            },
            numberFormat: v
        };
    });
    M(a, "Core/Renderer/RendererUtilities.js", [
        a["Core/Utilities.js"]
    ], function(a) {
        var v = a.clamp, z = a.pick, F = a.stableSort, y;
        (function(a) {
            function u(a, q, n) {
                var k = a, e = k.reducedLen || q, c = function(c, e) {
                    return (e.rank || 0) - (c.rank || 0);
                }, h = function(c, e) {
                    return c.target - e.target;
                }, f, w = !0, p = [], B = 0;
                for(f = a.length; f--;)B += a[f].size;
                if (B > e) {
                    F(a, c);
                    for(B = f = 0; B <= e;)B += a[f].size, f++;
                    p = a.splice(f - 1, a.length);
                }
                F(a, h);
                for(a = a.map(function(c) {
                    return {
                        size: c.size,
                        targets: [
                            c.target
                        ],
                        align: z(c.align, .5)
                    };
                }); w;){
                    for(f = a.length; f--;)e = a[f], c = (Math.min.apply(0, e.targets) + Math.max.apply(0, e.targets)) / 2, e.pos = v(c - e.size * e.align, 0, q - e.size);
                    f = a.length;
                    for(w = !1; f--;)0 < f && a[f - 1].pos + a[f - 1].size > a[f].pos && (a[f - 1].size += a[f].size, a[f - 1].targets = a[f - 1].targets.concat(a[f].targets), a[f - 1].align = .5, a[f - 1].pos + a[f - 1].size > q && (a[f - 1].pos = q - a[f - 1].size), a.splice(f, 1), w = !0);
                }
                k.push.apply(k, p);
                f = 0;
                a.some(function(c) {
                    var e = 0;
                    return (c.targets || []).some(function() {
                        k[f].pos = c.pos + e;
                        if ("undefined" !== typeof n && Math.abs(k[f].pos - k[f].target) > n) return k.slice(0, f + 1).forEach(function(c) {
                            return delete c.pos;
                        }), k.reducedLen = (k.reducedLen || q) - .1 * q, k.reducedLen > .1 * q && u(k, q, n), !0;
                        e += k[f].size;
                        f++;
                        return !1;
                    });
                });
                F(k, h);
                return k;
            }
            a.distribute = u;
        })(y || (y = {}));
        return y;
    });
    M(a, "Core/Renderer/SVG/SVGElement.js", [
        a["Core/Animation/AnimationUtilities.js"],
        a["Core/Renderer/HTML/AST.js"],
        a["Core/Color/Color.js"],
        a["Core/Globals.js"],
        a["Core/Utilities.js"]
    ], function(a, u, z, F, y) {
        var v = a.animate, H = a.animObject, A = a.stop, q = F.deg2rad, n = F.doc, k = F.noop, e = F.svg, c = F.SVG_NS, h = F.win, f = y.addEvent, w = y.attr, p = y.createElement, B = y.css, t = y.defined, J = y.erase, C = y.extend, r = y.fireEvent, l = y.isArray, b = y.isFunction, g = y.isNumber, d = y.isString, m = y.merge, D = y.objectEach, x = y.pick, I = y.pInt, P = y.syncTimeout, S = y.uniqueKey;
        a = function() {
            function a() {
                this.element = void 0;
                this.onEvents = {};
                this.opacity = 1;
                this.renderer = void 0;
                this.SVG_NS = c;
                this.symbolCustomAttribs = "x y width height r start end innerR anchorX anchorY rounded".split(" ");
            }
            a.prototype._defaultGetter = function(b) {
                b = x(this[b + "Value"], this[b], this.element ? this.element.getAttribute(b) : null, 0);
                /^[\-0-9\.]+$/.test(b) && (b = parseFloat(b));
                return b;
            };
            a.prototype._defaultSetter = function(b, d, c) {
                c.setAttribute(d, b);
            };
            a.prototype.add = function(b) {
                var d = this.renderer, c = this.element;
                b && (this.parentGroup = b);
                this.parentInverted = b && b.inverted;
                "undefined" !== typeof this.textStr && "text" === this.element.nodeName && d.buildText(this);
                this.added = !0;
                if (!b || b.handleZ || this.zIndex) var g = this.zIndexSetter();
                g || (b ? b.element : d.box).appendChild(c);
                if (this.onAdd) this.onAdd();
                return this;
            };
            a.prototype.addClass = function(b, d) {
                var c = d ? "" : this.attr("class") || "";
                b = (b || "").split(/ /g).reduce(function(b, d) {
                    -1 === c.indexOf(d) && b.push(d);
                    return b;
                }, c ? [
                    c
                ] : []).join(" ");
                b !== c && this.attr("class", b);
                return this;
            };
            a.prototype.afterSetters = function() {
                this.doTransform && (this.updateTransform(), this.doTransform = !1);
            };
            a.prototype.align = function(b, c, g) {
                var m = {}, L = this.renderer, e = L.alignedObjects, l, a, E;
                if (b) {
                    if (this.alignOptions = b, this.alignByTranslate = c, !g || d(g)) this.alignTo = l = g || "renderer", J(e, this), e.push(this), g = void 0;
                } else b = this.alignOptions, c = this.alignByTranslate, l = this.alignTo;
                g = x(g, L[l], "scrollablePlotBox" === l ? L.plotBox : void 0, L);
                l = b.align;
                var r = b.verticalAlign;
                L = (g.x || 0) + (b.x || 0);
                e = (g.y || 0) + (b.y || 0);
                "right" === l ? a = 1 : "center" === l && (a = 2);
                a && (L += (g.width - (b.width || 0)) / a);
                m[c ? "translateX" : "x"] = Math.round(L);
                "bottom" === r ? E = 1 : "middle" === r && (E = 2);
                E && (e += (g.height - (b.height || 0)) / E);
                m[c ? "translateY" : "y"] = Math.round(e);
                this[this.placed ? "animate" : "attr"](m);
                this.placed = !0;
                this.alignAttr = m;
                return this;
            };
            a.prototype.alignSetter = function(b) {
                var d = {
                    left: "start",
                    center: "middle",
                    right: "end"
                };
                d[b] && (this.alignValue = b, this.element.setAttribute("text-anchor", d[b]));
            };
            a.prototype.animate = function(b, d, c) {
                var g = this, m = H(x(d, this.renderer.globalAnimation, !0));
                d = m.defer;
                x(n.hidden, n.msHidden, n.webkitHidden, !1) && (m.duration = 0);
                0 !== m.duration ? (c && (m.complete = c), P(function() {
                    g.element && v(g, b, m);
                }, d)) : (this.attr(b, void 0, c), D(b, function(b, d) {
                    m.step && m.step.call(this, b, {
                        prop: d,
                        pos: 1,
                        elem: this
                    });
                }, this));
                return this;
            };
            a.prototype.applyTextOutline = function(b) {
                var d = this.element;
                -1 !== b.indexOf("contrast") && (b = b.replace(/contrast/g, this.renderer.getContrast(d.style.fill)));
                var g = b.split(" ");
                b = g[g.length - 1];
                if ((g = g[0]) && "none" !== g && F.svg) {
                    this.fakeTS = !0;
                    this.ySetter = this.xSetter;
                    g = g.replace(/(^[\d\.]+)(.*?)$/g, function(b, d, c) {
                        return 2 * Number(d) + c;
                    });
                    this.removeTextOutline();
                    var m = n.createElementNS(c, "tspan");
                    w(m, {
                        "class": "highcharts-text-outline",
                        fill: b,
                        stroke: b,
                        "stroke-width": g,
                        "stroke-linejoin": "round"
                    });
                    [].forEach.call(d.childNodes, function(b) {
                        var d = b.cloneNode(!0);
                        d.removeAttribute && [
                            "fill",
                            "stroke",
                            "stroke-width",
                            "stroke"
                        ].forEach(function(b) {
                            return d.removeAttribute(b);
                        });
                        m.appendChild(d);
                    });
                    var e = n.createElementNS(c, "tspan");
                    e.textContent = "\u200b";
                    [
                        "x",
                        "y"
                    ].forEach(function(b) {
                        var c = d.getAttribute(b);
                        c && e.setAttribute(b, c);
                    });
                    m.appendChild(e);
                    d.insertBefore(m, d.firstChild);
                }
            };
            a.prototype.attr = function(b, d, c, g) {
                var m = this.element, e = this.symbolCustomAttribs, L, l = this, E, a;
                if ("string" === typeof b && "undefined" !== typeof d) {
                    var K = b;
                    b = {};
                    b[K] = d;
                }
                "string" === typeof b ? l = (this[b + "Getter"] || this._defaultGetter).call(this, b, m) : (D(b, function(d, c) {
                    E = !1;
                    g || A(this, c);
                    this.symbolName && -1 !== e.indexOf(c) && (L || (this.symbolAttr(b), L = !0), E = !0);
                    !this.rotation || "x" !== c && "y" !== c || (this.doTransform = !0);
                    E || (a = this[c + "Setter"] || this._defaultSetter, a.call(this, d, c, m), !this.styledMode && this.shadows && /^(width|height|visibility|x|y|d|transform|cx|cy|r)$/.test(c) && this.updateShadows(c, d, a));
                }, this), this.afterSetters());
                c && c.call(this);
                return l;
            };
            a.prototype.clip = function(b) {
                return this.attr("clip-path", b ? "url(" + this.renderer.url + "#" + b.id + ")" : "none");
            };
            a.prototype.crisp = function(b, d) {
                d = d || b.strokeWidth || 0;
                var c = Math.round(d) % 2 / 2;
                b.x = Math.floor(b.x || this.x || 0) + c;
                b.y = Math.floor(b.y || this.y || 0) + c;
                b.width = Math.floor((b.width || this.width || 0) - 2 * c);
                b.height = Math.floor((b.height || this.height || 0) - 2 * c);
                t(b.strokeWidth) && (b.strokeWidth = d);
                return b;
            };
            a.prototype.complexColor = function(b, d, c) {
                var g = this.renderer, e, L, a, h, E, x, p, f, k, w, B = [], I;
                r(this.renderer, "complexColor", {
                    args: arguments
                }, function() {
                    b.radialGradient ? L = "radialGradient" : b.linearGradient && (L = "linearGradient");
                    if (L) {
                        a = b[L];
                        E = g.gradients;
                        x = b.stops;
                        k = c.radialReference;
                        l(a) && (b[L] = a = {
                            x1: a[0],
                            y1: a[1],
                            x2: a[2],
                            y2: a[3],
                            gradientUnits: "userSpaceOnUse"
                        });
                        "radialGradient" === L && k && !t(a.gradientUnits) && (h = a, a = m(a, g.getRadialAttr(k, h), {
                            gradientUnits: "userSpaceOnUse"
                        }));
                        D(a, function(b, d) {
                            "id" !== d && B.push(d, b);
                        });
                        D(x, function(b) {
                            B.push(b);
                        });
                        B = B.join(",");
                        if (E[B]) w = E[B].attr("id");
                        else {
                            a.id = w = S();
                            var K = E[B] = g.createElement(L).attr(a).add(g.defs);
                            K.radAttr = h;
                            K.stops = [];
                            x.forEach(function(b) {
                                0 === b[1].indexOf("rgba") ? (e = z.parse(b[1]), p = e.get("rgb"), f = e.get("a")) : (p = b[1], f = 1);
                                b = g.createElement("stop").attr({
                                    offset: b[0],
                                    "stop-color": p,
                                    "stop-opacity": f
                                }).add(K);
                                K.stops.push(b);
                            });
                        }
                        I = "url(" + g.url + "#" + w + ")";
                        c.setAttribute(d, I);
                        c.gradient = B;
                        b.toString = function() {
                            return I;
                        };
                    }
                });
            };
            a.prototype.css = function(b) {
                var d = this.styles, c = {}, g = this.element, m = [
                    "textOutline",
                    "textOverflow",
                    "width"
                ], a = "", l = !d;
                b && b.color && (b.fill = b.color);
                d && D(b, function(b, g) {
                    d && d[g] !== b && (c[g] = b, l = !0);
                });
                if (l) {
                    d && (b = C(d, c));
                    if (b) {
                        if (null === b.width || "auto" === b.width) delete this.textWidth;
                        else if ("text" === g.nodeName.toLowerCase() && b.width) var r = this.textWidth = I(b.width);
                    }
                    this.styles = b;
                    r && !e && this.renderer.forExport && delete b.width;
                    if (g.namespaceURI === this.SVG_NS) {
                        var E = function(b, d) {
                            return "-" + d.toLowerCase();
                        };
                        D(b, function(b, d) {
                            -1 === m.indexOf(d) && (a += d.replace(/([A-Z])/g, E) + ":" + b + ";");
                        });
                        a && w(g, "style", a);
                    } else B(g, b);
                    this.added && ("text" === this.element.nodeName && this.renderer.buildText(this), b && b.textOutline && this.applyTextOutline(b.textOutline));
                }
                return this;
            };
            a.prototype.dashstyleSetter = function(b) {
                var d = this["stroke-width"];
                "inherit" === d && (d = 1);
                if (b = b && b.toLowerCase()) {
                    var c = b.replace("shortdashdotdot", "3,1,1,1,1,1,").replace("shortdashdot", "3,1,1,1").replace("shortdot", "1,1,").replace("shortdash", "3,1,").replace("longdash", "8,3,").replace(/dot/g, "1,3,").replace("dash", "4,3,").replace(/,$/, "").split(",");
                    for(b = c.length; b--;)c[b] = "" + I(c[b]) * x(d, NaN);
                    b = c.join(",").replace(/NaN/g, "none");
                    this.element.setAttribute("stroke-dasharray", b);
                }
            };
            a.prototype.destroy = function() {
                var b = this, d = b.element || {}, c = b.renderer, g = d.ownerSVGElement, m = c.isSVG && "SPAN" === d.nodeName && b.parentGroup || void 0;
                d.onclick = d.onmouseout = d.onmouseover = d.onmousemove = d.point = null;
                A(b);
                if (b.clipPath && g) {
                    var e = b.clipPath;
                    [].forEach.call(g.querySelectorAll("[clip-path],[CLIP-PATH]"), function(b) {
                        -1 < b.getAttribute("clip-path").indexOf(e.element.id) && b.removeAttribute("clip-path");
                    });
                    b.clipPath = e.destroy();
                }
                if (b.stops) {
                    for(g = 0; g < b.stops.length; g++)b.stops[g].destroy();
                    b.stops.length = 0;
                    b.stops = void 0;
                }
                b.safeRemoveChild(d);
                for(c.styledMode || b.destroyShadows(); m && m.div && 0 === m.div.childNodes.length;)d = m.parentGroup, b.safeRemoveChild(m.div), delete m.div, m = d;
                b.alignTo && J(c.alignedObjects, b);
                D(b, function(d, c) {
                    b[c] && b[c].parentGroup === b && b[c].destroy && b[c].destroy();
                    delete b[c];
                });
            };
            a.prototype.destroyShadows = function() {
                (this.shadows || []).forEach(function(b) {
                    this.safeRemoveChild(b);
                }, this);
                this.shadows = void 0;
            };
            a.prototype.destroyTextPath = function(b, d) {
                var c = b.getElementsByTagName("text")[0];
                if (c) {
                    if (c.removeAttribute("dx"), c.removeAttribute("dy"), d.element.setAttribute("id", ""), this.textPathWrapper && c.getElementsByTagName("textPath").length) {
                        for(b = this.textPathWrapper.element.childNodes; b.length;)c.appendChild(b[0]);
                        c.removeChild(this.textPathWrapper.element);
                    }
                } else if (b.getAttribute("dx") || b.getAttribute("dy")) b.removeAttribute("dx"), b.removeAttribute("dy");
                this.textPathWrapper && (this.textPathWrapper = this.textPathWrapper.destroy());
            };
            a.prototype.dSetter = function(b, d, c) {
                l(b) && ("string" === typeof b[0] && (b = this.renderer.pathToSegments(b)), this.pathArray = b, b = b.reduce(function(b, d, c) {
                    return d && d.join ? (c ? b + " " : "") + d.join(" ") : (d || "").toString();
                }, ""));
                /(NaN| {2}|^$)/.test(b) && (b = "M 0 0");
                this[d] !== b && (c.setAttribute(d, b), this[d] = b);
            };
            a.prototype.fadeOut = function(b) {
                var d = this;
                d.animate({
                    opacity: 0
                }, {
                    duration: x(b, 150),
                    complete: function() {
                        d.attr({
                            y: -9999
                        }).hide();
                    }
                });
            };
            a.prototype.fillSetter = function(b, d, c) {
                "string" === typeof b ? c.setAttribute(d, b) : b && this.complexColor(b, d, c);
            };
            a.prototype.getBBox = function(d, c) {
                var g = this.renderer, m = this.element, e = this.styles, l = this.textStr, r = g.cache, h = g.cacheKeys, E = m.namespaceURI === this.SVG_NS;
                c = x(c, this.rotation, 0);
                var p = g.styledMode ? m && a.prototype.getStyle.call(m, "font-size") : e && e.fontSize, f;
                if (t(l)) {
                    var D = l.toString();
                    -1 === D.indexOf("<") && (D = D.replace(/[0-9]/g, "0"));
                    D += [
                        "",
                        c,
                        p,
                        this.textWidth,
                        e && e.textOverflow,
                        e && e.fontWeight
                    ].join();
                }
                D && !d && (f = r[D]);
                if (!f) {
                    if (E || g.forExport) {
                        try {
                            var k = this.fakeTS && function(b) {
                                var d = m.querySelector(".highcharts-text-outline");
                                d && B(d, {
                                    display: b
                                });
                            };
                            b(k) && k("none");
                            f = m.getBBox ? C({}, m.getBBox()) : {
                                width: m.offsetWidth,
                                height: m.offsetHeight
                            };
                            b(k) && k("");
                        } catch (X) {
                            "";
                        }
                        if (!f || 0 > f.width) f = {
                            width: 0,
                            height: 0
                        };
                    } else f = this.htmlGetBBox();
                    g.isSVG && (d = f.width, g = f.height, E && (f.height = g = ({
                        "11px,17": 14,
                        "13px,20": 16
                    })[(p || "") + "," + Math.round(g)] || g), c && (E = c * q, f.width = Math.abs(g * Math.sin(E)) + Math.abs(d * Math.cos(E)), f.height = Math.abs(g * Math.cos(E)) + Math.abs(d * Math.sin(E))));
                    if (D && ("" === l || 0 < f.height)) {
                        for(; 250 < h.length;)delete r[h.shift()];
                        r[D] || h.push(D);
                        r[D] = f;
                    }
                }
                return f;
            };
            a.prototype.getStyle = function(b) {
                return h.getComputedStyle(this.element || this, "").getPropertyValue(b);
            };
            a.prototype.hasClass = function(b) {
                return -1 !== ("" + this.attr("class")).split(" ").indexOf(b);
            };
            a.prototype.hide = function(b) {
                b ? this.attr({
                    y: -9999
                }) : this.attr({
                    visibility: "hidden"
                });
                return this;
            };
            a.prototype.htmlGetBBox = function() {
                return {
                    height: 0,
                    width: 0,
                    x: 0,
                    y: 0
                };
            };
            a.prototype.init = function(b, d) {
                this.element = "span" === d ? p(d) : n.createElementNS(this.SVG_NS, d);
                this.renderer = b;
                r(this, "afterInit");
            };
            a.prototype.invert = function(b) {
                this.inverted = b;
                this.updateTransform();
                return this;
            };
            a.prototype.on = function(b, d) {
                var c = this.onEvents;
                if (c[b]) c[b]();
                c[b] = f(this.element, b, d);
                return this;
            };
            a.prototype.opacitySetter = function(b, d, c) {
                this.opacity = b = Number(Number(b).toFixed(3));
                c.setAttribute(d, b);
            };
            a.prototype.removeClass = function(b) {
                return this.attr("class", ("" + this.attr("class")).replace(d(b) ? new RegExp("(^| )" + b + "( |$)") : b, " ").replace(/ +/g, " ").trim());
            };
            a.prototype.removeTextOutline = function() {
                var b = this.element.querySelector("tspan.highcharts-text-outline");
                b && this.safeRemoveChild(b);
            };
            a.prototype.safeRemoveChild = function(b) {
                var d = b.parentNode;
                d && d.removeChild(b);
            };
            a.prototype.setRadialReference = function(b) {
                var d = this.element.gradient && this.renderer.gradients[this.element.gradient];
                this.element.radialReference = b;
                d && d.radAttr && d.animate(this.renderer.getRadialAttr(b, d.radAttr));
                return this;
            };
            a.prototype.setTextPath = function(b, d) {
                var c = this.element, e = this.text ? this.text.element : c, a = {
                    textAnchor: "text-anchor"
                }, l = !1, r = this.textPathWrapper, x = !r;
                d = m(!0, {
                    enabled: !0,
                    attributes: {
                        dy: -5,
                        startOffset: "50%",
                        textAnchor: "middle"
                    }
                }, d);
                var E = u.filterUserAttributes(d.attributes);
                if (b && d && d.enabled) {
                    r && null === r.element.parentNode ? (x = !0, r = r.destroy()) : r && this.removeTextOutline.call(r.parentGroup);
                    this.options && this.options.padding && (E.dx = -this.options.padding);
                    r || (this.textPathWrapper = r = this.renderer.createElement("textPath"), l = !0);
                    var p = r.element;
                    (d = b.element.getAttribute("id")) || b.element.setAttribute("id", d = S());
                    if (x) for(e.setAttribute("y", 0), g(E.dx) && e.setAttribute("x", -E.dx), b = [].slice.call(e.childNodes), x = 0; x < b.length; x++){
                        var f = b[x];
                        f.nodeType !== h.Node.TEXT_NODE && "tspan" !== f.nodeName || p.appendChild(f);
                    }
                    l && r && r.add({
                        element: e
                    });
                    p.setAttributeNS("http://www.w3.org/1999/xlink", "href", this.renderer.url + "#" + d);
                    t(E.dy) && (p.parentNode.setAttribute("dy", E.dy), delete E.dy);
                    t(E.dx) && (p.parentNode.setAttribute("dx", E.dx), delete E.dx);
                    D(E, function(b, d) {
                        p.setAttribute(a[d] || d, b);
                    });
                    c.removeAttribute("transform");
                    this.removeTextOutline.call(r);
                    this.text && !this.renderer.styledMode && this.attr({
                        fill: "none",
                        "stroke-width": 0
                    });
                    this.applyTextOutline = this.updateTransform = k;
                } else r && (delete this.updateTransform, delete this.applyTextOutline, this.destroyTextPath(c, b), this.updateTransform(), this.options && this.options.rotation && this.applyTextOutline(this.options.style.textOutline));
                return this;
            };
            a.prototype.shadow = function(b, d, c) {
                var g = [], m = this.element, e = this.oldShadowOptions, a = {
                    color: "#000000",
                    offsetX: this.parentInverted ? -1 : 1,
                    offsetY: this.parentInverted ? -1 : 1,
                    opacity: .15,
                    width: 3
                }, l = !1, E;
                !0 === b ? E = a : "object" === typeof b && (E = C(a, b));
                E && (E && e && D(E, function(b, d) {
                    b !== e[d] && (l = !0);
                }), l && this.destroyShadows(), this.oldShadowOptions = E);
                if (!E) this.destroyShadows();
                else if (!this.shadows) {
                    var L = E.opacity / E.width;
                    var r = this.parentInverted ? "translate(" + E.offsetY + ", " + E.offsetX + ")" : "translate(" + E.offsetX + ", " + E.offsetY + ")";
                    for(a = 1; a <= E.width; a++){
                        var h = m.cloneNode(!1);
                        var x = 2 * E.width + 1 - 2 * a;
                        w(h, {
                            stroke: b.color || "#000000",
                            "stroke-opacity": L * a,
                            "stroke-width": x,
                            transform: r,
                            fill: "none"
                        });
                        h.setAttribute("class", (h.getAttribute("class") || "") + " highcharts-shadow");
                        c && (w(h, "height", Math.max(w(h, "height") - x, 0)), h.cutHeight = x);
                        d ? d.element.appendChild(h) : m.parentNode && m.parentNode.insertBefore(h, m);
                        g.push(h);
                    }
                    this.shadows = g;
                }
                return this;
            };
            a.prototype.show = function(b) {
                return this.attr({
                    visibility: b ? "inherit" : "visible"
                });
            };
            a.prototype.strokeSetter = function(b, d, c) {
                this[d] = b;
                this.stroke && this["stroke-width"] ? (a.prototype.fillSetter.call(this, this.stroke, "stroke", c), c.setAttribute("stroke-width", this["stroke-width"]), this.hasStroke = !0) : "stroke-width" === d && 0 === b && this.hasStroke ? (c.removeAttribute("stroke"), this.hasStroke = !1) : this.renderer.styledMode && this["stroke-width"] && (c.setAttribute("stroke-width", this["stroke-width"]), this.hasStroke = !0);
            };
            a.prototype.strokeWidth = function() {
                if (!this.renderer.styledMode) return this["stroke-width"] || 0;
                var b = this.getStyle("stroke-width"), d = 0;
                if (b.indexOf("px") === b.length - 2) d = I(b);
                else if ("" !== b) {
                    var g = n.createElementNS(c, "rect");
                    w(g, {
                        width: b,
                        "stroke-width": 0
                    });
                    this.element.parentNode.appendChild(g);
                    d = g.getBBox().width;
                    g.parentNode.removeChild(g);
                }
                return d;
            };
            a.prototype.symbolAttr = function(b) {
                var d = this;
                "x y r start end width height innerR anchorX anchorY clockwise".split(" ").forEach(function(c) {
                    d[c] = x(b[c], d[c]);
                });
                d.attr({
                    d: d.renderer.symbols[d.symbolName](d.x, d.y, d.width, d.height, d)
                });
            };
            a.prototype.textSetter = function(b) {
                b !== this.textStr && (delete this.textPxLength, this.textStr = b, this.added && this.renderer.buildText(this));
            };
            a.prototype.titleSetter = function(b) {
                var d = this.element, c = d.getElementsByTagName("title")[0] || n.createElementNS(this.SVG_NS, "title");
                d.insertBefore ? d.insertBefore(c, d.firstChild) : d.appendChild(c);
                c.textContent = String(x(b, "")).replace(/<[^>]*>/g, "").replace(/&lt;/g, "<").replace(/&gt;/g, ">");
            };
            a.prototype.toFront = function() {
                var b = this.element;
                b.parentNode.appendChild(b);
                return this;
            };
            a.prototype.translate = function(b, d) {
                return this.attr({
                    translateX: b,
                    translateY: d
                });
            };
            a.prototype.updateShadows = function(b, d, c) {
                var g = this.shadows;
                if (g) for(var m = g.length; m--;)c.call(g[m], "height" === b ? Math.max(d - (g[m].cutHeight || 0), 0) : "d" === b ? this.d : d, b, g[m]);
            };
            a.prototype.updateTransform = function() {
                var b = this.scaleX, d = this.scaleY, c = this.inverted, g = this.rotation, m = this.matrix, e = this.element, a = this.translateX || 0, l = this.translateY || 0;
                c && (a += this.width, l += this.height);
                a = [
                    "translate(" + a + "," + l + ")"
                ];
                t(m) && a.push("matrix(" + m.join(",") + ")");
                c ? a.push("rotate(90) scale(-1,1)") : g && a.push("rotate(" + g + " " + x(this.rotationOriginX, e.getAttribute("x"), 0) + " " + x(this.rotationOriginY, e.getAttribute("y") || 0) + ")");
                (t(b) || t(d)) && a.push("scale(" + x(b, 1) + " " + x(d, 1) + ")");
                a.length && e.setAttribute("transform", a.join(" "));
            };
            a.prototype.visibilitySetter = function(b, d, c) {
                "inherit" === b ? c.removeAttribute(d) : this[d] !== b && c.setAttribute(d, b);
                this[d] = b;
            };
            a.prototype.xGetter = function(b) {
                "circle" === this.element.nodeName && ("x" === b ? b = "cx" : "y" === b && (b = "cy"));
                return this._defaultGetter(b);
            };
            a.prototype.zIndexSetter = function(b, d) {
                var c = this.renderer, g = this.parentGroup, m = (g || c).element || c.box, e = this.element;
                c = m === c.box;
                var a = !1;
                var l = this.added;
                var E;
                t(b) ? (e.setAttribute("data-z-index", b), b = +b, this[d] === b && (l = !1)) : t(this[d]) && e.removeAttribute("data-z-index");
                this[d] = b;
                if (l) {
                    (b = this.zIndex) && g && (g.handleZ = !0);
                    d = m.childNodes;
                    for(E = d.length - 1; 0 <= E && !a; E--){
                        g = d[E];
                        l = g.getAttribute("data-z-index");
                        var r = !t(l);
                        if (g !== e) {
                            if (0 > b && r && !c && !E) m.insertBefore(e, d[E]), a = !0;
                            else if (I(l) <= b || r && (!t(b) || 0 <= b)) m.insertBefore(e, d[E + 1] || null), a = !0;
                        }
                    }
                    a || (m.insertBefore(e, d[c ? 3 : 0] || null), a = !0);
                }
                return a;
            };
            return a;
        }();
        a.prototype["stroke-widthSetter"] = a.prototype.strokeSetter;
        a.prototype.yGetter = a.prototype.xGetter;
        a.prototype.matrixSetter = a.prototype.rotationOriginXSetter = a.prototype.rotationOriginYSetter = a.prototype.rotationSetter = a.prototype.scaleXSetter = a.prototype.scaleYSetter = a.prototype.translateXSetter = a.prototype.translateYSetter = a.prototype.verticalAlignSetter = function(b, d) {
            this[d] = b;
            this.doTransform = !0;
        };
        "";
        return a;
    });
    M(a, "Core/Renderer/RendererRegistry.js", [
        a["Core/Globals.js"]
    ], function(a) {
        var v;
        (function(v) {
            v.rendererTypes = {};
            var u;
            v.getRendererType = function(a) {
                void 0 === a && (a = u);
                return v.rendererTypes[a] || v.rendererTypes[u];
            };
            v.registerRendererType = function(y, z, H) {
                v.rendererTypes[y] = z;
                if (!u || H) u = y, a.Renderer = z;
            };
        })(v || (v = {}));
        return v;
    });
    M(a, "Core/Renderer/SVG/SVGLabel.js", [
        a["Core/Renderer/SVG/SVGElement.js"],
        a["Core/Utilities.js"]
    ], function(a, u) {
        var v = this && this.__extends || function() {
            var a = function(k, e) {
                a = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(c, e) {
                    c.__proto__ = e;
                } || function(c, e) {
                    for(var a in e)e.hasOwnProperty(a) && (c[a] = e[a]);
                };
                return a(k, e);
            };
            return function(k, e) {
                function c() {
                    this.constructor = k;
                }
                a(k, e);
                k.prototype = null === e ? Object.create(e) : (c.prototype = e.prototype, new c);
            };
        }(), F = u.defined, y = u.extend, G = u.isNumber, H = u.merge, A = u.pick, q = u.removeEvent;
        return function(n) {
            function k(e, c, a, f, w, p, B, t, J, C) {
                var r = n.call(this) || this;
                r.paddingLeftSetter = r.paddingSetter;
                r.paddingRightSetter = r.paddingSetter;
                r.init(e, "g");
                r.textStr = c;
                r.x = a;
                r.y = f;
                r.anchorX = p;
                r.anchorY = B;
                r.baseline = J;
                r.className = C;
                r.addClass("button" === C ? "highcharts-no-tooltip" : "highcharts-label");
                C && r.addClass("highcharts-" + C);
                r.text = e.text(void 0, 0, 0, t).attr({
                    zIndex: 1
                });
                var l;
                "string" === typeof w && ((l = /^url\((.*?)\)$/.test(w)) || r.renderer.symbols[w]) && (r.symbolKey = w);
                r.bBox = k.emptyBBox;
                r.padding = 3;
                r.baselineOffset = 0;
                r.needsBox = e.styledMode || l;
                r.deferredAttr = {};
                r.alignFactor = 0;
                return r;
            }
            v(k, n);
            k.prototype.alignSetter = function(e) {
                e = ({
                    left: 0,
                    center: .5,
                    right: 1
                })[e];
                e !== this.alignFactor && (this.alignFactor = e, this.bBox && G(this.xSetting) && this.attr({
                    x: this.xSetting
                }));
            };
            k.prototype.anchorXSetter = function(e, c) {
                this.anchorX = e;
                this.boxAttr(c, Math.round(e) - this.getCrispAdjust() - this.xSetting);
            };
            k.prototype.anchorYSetter = function(e, c) {
                this.anchorY = e;
                this.boxAttr(c, e - this.ySetting);
            };
            k.prototype.boxAttr = function(e, c) {
                this.box ? this.box.attr(e, c) : this.deferredAttr[e] = c;
            };
            k.prototype.css = function(e) {
                if (e) {
                    var c = {};
                    e = H(e);
                    k.textProps.forEach(function(a) {
                        "undefined" !== typeof e[a] && (c[a] = e[a], delete e[a]);
                    });
                    this.text.css(c);
                    var h = "width" in c;
                    "fontSize" in c || "fontWeight" in c ? this.updateTextPadding() : h && this.updateBoxSize();
                }
                return a.prototype.css.call(this, e);
            };
            k.prototype.destroy = function() {
                q(this.element, "mouseenter");
                q(this.element, "mouseleave");
                this.text && this.text.destroy();
                this.box && (this.box = this.box.destroy());
                a.prototype.destroy.call(this);
            };
            k.prototype.fillSetter = function(e, c) {
                e && (this.needsBox = !0);
                this.fill = e;
                this.boxAttr(c, e);
            };
            k.prototype.getBBox = function() {
                this.textStr && 0 === this.bBox.width && 0 === this.bBox.height && this.updateBoxSize();
                var e = this.padding, c = A(this.paddingLeft, e);
                return {
                    width: this.width,
                    height: this.height,
                    x: this.bBox.x - c,
                    y: this.bBox.y - e
                };
            };
            k.prototype.getCrispAdjust = function() {
                return this.renderer.styledMode && this.box ? this.box.strokeWidth() % 2 / 2 : (this["stroke-width"] ? parseInt(this["stroke-width"], 10) : 0) % 2 / 2;
            };
            k.prototype.heightSetter = function(e) {
                this.heightSetting = e;
            };
            k.prototype.onAdd = function() {
                var e = this.textStr;
                this.text.add(this);
                this.attr({
                    text: F(e) ? e : "",
                    x: this.x,
                    y: this.y
                });
                this.box && F(this.anchorX) && this.attr({
                    anchorX: this.anchorX,
                    anchorY: this.anchorY
                });
            };
            k.prototype.paddingSetter = function(e, c) {
                G(e) ? e !== this[c] && (this[c] = e, this.updateTextPadding()) : this[c] = void 0;
            };
            k.prototype.rSetter = function(e, c) {
                this.boxAttr(c, e);
            };
            k.prototype.shadow = function(e) {
                e && !this.renderer.styledMode && (this.updateBoxSize(), this.box && this.box.shadow(e));
                return this;
            };
            k.prototype.strokeSetter = function(e, c) {
                this.stroke = e;
                this.boxAttr(c, e);
            };
            k.prototype["stroke-widthSetter"] = function(e, c) {
                e && (this.needsBox = !0);
                this["stroke-width"] = e;
                this.boxAttr(c, e);
            };
            k.prototype["text-alignSetter"] = function(e) {
                this.textAlign = e;
            };
            k.prototype.textSetter = function(e) {
                "undefined" !== typeof e && this.text.attr({
                    text: e
                });
                this.updateTextPadding();
            };
            k.prototype.updateBoxSize = function() {
                var e = this.text.element.style, c = {}, a = this.padding, f = this.bBox = G(this.widthSetting) && G(this.heightSetting) && !this.textAlign || !F(this.text.textStr) ? k.emptyBBox : this.text.getBBox();
                this.width = this.getPaddedWidth();
                this.height = (this.heightSetting || f.height || 0) + 2 * a;
                e = this.renderer.fontMetrics(e && e.fontSize, this.text);
                this.baselineOffset = a + Math.min((this.text.firstLineMetrics || e).b, f.height || Infinity);
                this.heightSetting && (this.baselineOffset += (this.heightSetting - e.h) / 2);
                this.needsBox && (this.box || (a = this.box = this.symbolKey ? this.renderer.symbol(this.symbolKey) : this.renderer.rect(), a.addClass(("button" === this.className ? "" : "highcharts-label-box") + (this.className ? " highcharts-" + this.className + "-box" : "")), a.add(this)), a = this.getCrispAdjust(), c.x = a, c.y = (this.baseline ? -this.baselineOffset : 0) + a, c.width = Math.round(this.width), c.height = Math.round(this.height), this.box.attr(y(c, this.deferredAttr)), this.deferredAttr = {});
            };
            k.prototype.updateTextPadding = function() {
                var a = this.text;
                this.updateBoxSize();
                var c = this.baseline ? 0 : this.baselineOffset, h = A(this.paddingLeft, this.padding);
                F(this.widthSetting) && this.bBox && ("center" === this.textAlign || "right" === this.textAlign) && (h += ({
                    center: .5,
                    right: 1
                })[this.textAlign] * (this.widthSetting - this.bBox.width));
                if (h !== a.x || c !== a.y) a.attr("x", h), a.hasBoxWidthChanged && (this.bBox = a.getBBox(!0)), "undefined" !== typeof c && a.attr("y", c);
                a.x = h;
                a.y = c;
            };
            k.prototype.widthSetter = function(a) {
                this.widthSetting = G(a) ? a : void 0;
            };
            k.prototype.getPaddedWidth = function() {
                var a = this.padding, c = A(this.paddingLeft, a);
                a = A(this.paddingRight, a);
                return (this.widthSetting || this.bBox.width || 0) + c + a;
            };
            k.prototype.xSetter = function(a) {
                this.x = a;
                this.alignFactor && (a -= this.alignFactor * this.getPaddedWidth(), this["forceAnimate:x"] = !0);
                this.xSetting = Math.round(a);
                this.attr("translateX", this.xSetting);
            };
            k.prototype.ySetter = function(a) {
                this.ySetting = this.y = Math.round(a);
                this.attr("translateY", this.ySetting);
            };
            k.emptyBBox = {
                width: 0,
                height: 0,
                x: 0,
                y: 0
            };
            k.textProps = "color direction fontFamily fontSize fontStyle fontWeight lineHeight textAlign textDecoration textOutline textOverflow width".split(" ");
            return k;
        }(a);
    });
    M(a, "Core/Renderer/SVG/Symbols.js", [
        a["Core/Utilities.js"]
    ], function(a) {
        function v(a, q, n, k, e) {
            var c = [];
            if (e) {
                var h = e.start || 0, f = H(e.r, n);
                n = H(e.r, k || n);
                var w = (e.end || 0) - .001;
                k = e.innerR;
                var p = H(e.open, .001 > Math.abs((e.end || 0) - h - 2 * Math.PI)), B = Math.cos(h), t = Math.sin(h), J = Math.cos(w), C = Math.sin(w);
                h = H(e.longArc, .001 > w - h - Math.PI ? 0 : 1);
                c.push([
                    "M",
                    a + f * B,
                    q + n * t
                ], [
                    "A",
                    f,
                    n,
                    0,
                    h,
                    H(e.clockwise, 1),
                    a + f * J,
                    q + n * C
                ]);
                y(k) && c.push(p ? [
                    "M",
                    a + k * J,
                    q + k * C
                ] : [
                    "L",
                    a + k * J,
                    q + k * C
                ], [
                    "A",
                    k,
                    k,
                    0,
                    h,
                    y(e.clockwise) ? 1 - e.clockwise : 0,
                    a + k * B,
                    q + k * t
                ]);
                p || c.push([
                    "Z"
                ]);
            }
            return c;
        }
        function z(a, q, n, k, e) {
            return e && e.r ? F(a, q, n, k, e) : [
                [
                    "M",
                    a,
                    q
                ],
                [
                    "L",
                    a + n,
                    q
                ],
                [
                    "L",
                    a + n,
                    q + k
                ],
                [
                    "L",
                    a,
                    q + k
                ],
                [
                    "Z"
                ]
            ];
        }
        function F(a, q, n, k, e) {
            e = e && e.r || 0;
            return [
                [
                    "M",
                    a + e,
                    q
                ],
                [
                    "L",
                    a + n - e,
                    q
                ],
                [
                    "C",
                    a + n,
                    q,
                    a + n,
                    q,
                    a + n,
                    q + e
                ],
                [
                    "L",
                    a + n,
                    q + k - e
                ],
                [
                    "C",
                    a + n,
                    q + k,
                    a + n,
                    q + k,
                    a + n - e,
                    q + k
                ],
                [
                    "L",
                    a + e,
                    q + k
                ],
                [
                    "C",
                    a,
                    q + k,
                    a,
                    q + k,
                    a,
                    q + k - e
                ],
                [
                    "L",
                    a,
                    q + e
                ],
                [
                    "C",
                    a,
                    q,
                    a,
                    q,
                    a + e,
                    q
                ]
            ];
        }
        var y = a.defined, G = a.isNumber, H = a.pick;
        return {
            arc: v,
            callout: function(a, q, n, k, e) {
                var c = Math.min(e && e.r || 0, n, k), h = c + 6, f = e && e.anchorX;
                e = e && e.anchorY || 0;
                var w = F(a, q, n, k, {
                    r: c
                });
                if (!G(f)) return w;
                a + f >= n ? e > q + h && e < q + k - h ? w.splice(3, 1, [
                    "L",
                    a + n,
                    e - 6
                ], [
                    "L",
                    a + n + 6,
                    e
                ], [
                    "L",
                    a + n,
                    e + 6
                ], [
                    "L",
                    a + n,
                    q + k - c
                ]) : w.splice(3, 1, [
                    "L",
                    a + n,
                    k / 2
                ], [
                    "L",
                    f,
                    e
                ], [
                    "L",
                    a + n,
                    k / 2
                ], [
                    "L",
                    a + n,
                    q + k - c
                ]) : 0 >= a + f ? e > q + h && e < q + k - h ? w.splice(7, 1, [
                    "L",
                    a,
                    e + 6
                ], [
                    "L",
                    a - 6,
                    e
                ], [
                    "L",
                    a,
                    e - 6
                ], [
                    "L",
                    a,
                    q + c
                ]) : w.splice(7, 1, [
                    "L",
                    a,
                    k / 2
                ], [
                    "L",
                    f,
                    e
                ], [
                    "L",
                    a,
                    k / 2
                ], [
                    "L",
                    a,
                    q + c
                ]) : e && e > k && f > a + h && f < a + n - h ? w.splice(5, 1, [
                    "L",
                    f + 6,
                    q + k
                ], [
                    "L",
                    f,
                    q + k + 6
                ], [
                    "L",
                    f - 6,
                    q + k
                ], [
                    "L",
                    a + c,
                    q + k
                ]) : e && 0 > e && f > a + h && f < a + n - h && w.splice(1, 1, [
                    "L",
                    f - 6,
                    q
                ], [
                    "L",
                    f,
                    q - 6
                ], [
                    "L",
                    f + 6,
                    q
                ], [
                    "L",
                    n - c,
                    q
                ]);
                return w;
            },
            circle: function(a, q, n, k) {
                return v(a + n / 2, q + k / 2, n / 2, k / 2, {
                    start: .5 * Math.PI,
                    end: 2.5 * Math.PI,
                    open: !1
                });
            },
            diamond: function(a, q, n, k) {
                return [
                    [
                        "M",
                        a + n / 2,
                        q
                    ],
                    [
                        "L",
                        a + n,
                        q + k / 2
                    ],
                    [
                        "L",
                        a + n / 2,
                        q + k
                    ],
                    [
                        "L",
                        a,
                        q + k / 2
                    ],
                    [
                        "Z"
                    ]
                ];
            },
            rect: z,
            roundedRect: F,
            square: z,
            triangle: function(a, q, n, k) {
                return [
                    [
                        "M",
                        a + n / 2,
                        q
                    ],
                    [
                        "L",
                        a + n,
                        q + k
                    ],
                    [
                        "L",
                        a,
                        q + k
                    ],
                    [
                        "Z"
                    ]
                ];
            },
            "triangle-down": function(a, q, n, k) {
                return [
                    [
                        "M",
                        a,
                        q
                    ],
                    [
                        "L",
                        a + n,
                        q
                    ],
                    [
                        "L",
                        a + n / 2,
                        q + k
                    ],
                    [
                        "Z"
                    ]
                ];
            }
        };
    });
    M(a, "Core/Renderer/SVG/TextBuilder.js", [
        a["Core/Renderer/HTML/AST.js"],
        a["Core/Globals.js"],
        a["Core/Utilities.js"]
    ], function(a, u, z) {
        var v = u.doc, y = u.SVG_NS, G = u.win, H = z.attr, A = z.isString, q = z.objectEach, n = z.pick;
        return function() {
            function k(a) {
                var c = a.styles;
                this.renderer = a.renderer;
                this.svgElement = a;
                this.width = a.textWidth;
                this.textLineHeight = c && c.lineHeight;
                this.textOutline = c && c.textOutline;
                this.ellipsis = !(!c || "ellipsis" !== c.textOverflow);
                this.noWrap = !(!c || "nowrap" !== c.whiteSpace);
                this.fontSize = c && c.fontSize;
            }
            k.prototype.buildSVG = function() {
                var e = this.svgElement, c = e.element, h = e.renderer, f = n(e.textStr, "").toString(), k = -1 !== f.indexOf("<"), p = c.childNodes;
                h = this.width && !e.added && h.box;
                var B = /<br.*?>/g, t = [
                    f,
                    this.ellipsis,
                    this.noWrap,
                    this.textLineHeight,
                    this.textOutline,
                    this.fontSize,
                    this.width
                ].join();
                if (t !== e.textCache) {
                    e.textCache = t;
                    delete e.actualWidth;
                    for(t = p.length; t--;)c.removeChild(p[t]);
                    k || this.ellipsis || this.width || -1 !== f.indexOf(" ") && (!this.noWrap || B.test(f)) ? "" !== f && (h && h.appendChild(c), f = new a(f), this.modifyTree(f.nodes), f.addToDOM(e.element), this.modifyDOM(), this.ellipsis && -1 !== (c.textContent || "").indexOf("\u2026") && e.attr("title", this.unescapeEntities(e.textStr || "", [
                        "&lt;",
                        "&gt;"
                    ])), h && h.removeChild(c)) : c.appendChild(v.createTextNode(this.unescapeEntities(f)));
                    A(this.textOutline) && e.applyTextOutline && e.applyTextOutline(this.textOutline);
                }
            };
            k.prototype.modifyDOM = function() {
                var a = this, c = this.svgElement, h = H(c.element, "x");
                c.firstLineMetrics = void 0;
                for(var f; f = c.element.firstChild;)if (/^[\s\u200B]*$/.test(f.textContent || " ")) c.element.removeChild(f);
                else break;
                [].forEach.call(c.element.querySelectorAll("tspan.highcharts-br"), function(e, p) {
                    e.nextSibling && e.previousSibling && (0 === p && 1 === e.previousSibling.nodeType && (c.firstLineMetrics = c.renderer.fontMetrics(void 0, e.previousSibling)), H(e, {
                        dy: a.getLineHeight(e.nextSibling),
                        x: h
                    }));
                });
                var k = this.width || 0;
                if (k) {
                    var p = function(e, p) {
                        var f = e.textContent || "", r = f.replace(/([^\^])-/g, "$1- ").split(" "), l = !a.noWrap && (1 < r.length || 1 < c.element.childNodes.length), b = a.getLineHeight(p), g = 0, d = c.actualWidth;
                        if (a.ellipsis) f && a.truncate(e, f, void 0, 0, Math.max(0, k - parseInt(a.fontSize || 12, 10)), function(b, d) {
                            return b.substring(0, d) + "\u2026";
                        });
                        else if (l) {
                            f = [];
                            for(l = []; p.firstChild && p.firstChild !== e;)l.push(p.firstChild), p.removeChild(p.firstChild);
                            for(; r.length;)r.length && !a.noWrap && 0 < g && (f.push(e.textContent || ""), e.textContent = r.join(" ").replace(/- /g, "-")), a.truncate(e, void 0, r, 0 === g ? d || 0 : 0, k, function(b, d) {
                                return r.slice(0, d).join(" ").replace(/- /g, "-");
                            }), d = c.actualWidth, g++;
                            l.forEach(function(b) {
                                p.insertBefore(b, e);
                            });
                            f.forEach(function(d) {
                                p.insertBefore(v.createTextNode(d), e);
                                d = v.createElementNS(y, "tspan");
                                d.textContent = "\u200b";
                                H(d, {
                                    dy: b,
                                    x: h
                                });
                                p.insertBefore(d, e);
                            });
                        }
                    }, B = function(a) {
                        [].slice.call(a.childNodes).forEach(function(e) {
                            e.nodeType === G.Node.TEXT_NODE ? p(e, a) : (-1 !== e.className.baseVal.indexOf("highcharts-br") && (c.actualWidth = 0), B(e));
                        });
                    };
                    B(c.element);
                }
            };
            k.prototype.getLineHeight = function(a) {
                var c;
                a = a.nodeType === G.Node.TEXT_NODE ? a.parentElement : a;
                this.renderer.styledMode || (c = a && /(px|em)$/.test(a.style.fontSize) ? a.style.fontSize : this.fontSize || this.renderer.style.fontSize || 12);
                return this.textLineHeight ? parseInt(this.textLineHeight.toString(), 10) : this.renderer.fontMetrics(c, a || this.svgElement.element).h;
            };
            k.prototype.modifyTree = function(a) {
                var c = this, e = function(h, k) {
                    var p = h.attributes;
                    p = void 0 === p ? {} : p;
                    var f = h.children, t = h.tagName, w = c.renderer.styledMode;
                    if ("b" === t || "strong" === t) w ? p["class"] = "highcharts-strong" : p.style = "font-weight:bold;" + (p.style || "");
                    else if ("i" === t || "em" === t) w ? p["class"] = "highcharts-emphasized" : p.style = "font-style:italic;" + (p.style || "");
                    A(p.style) && (p.style = p.style.replace(/(;| |^)color([ :])/, "$1fill$2"));
                    "br" === t ? (p["class"] = "highcharts-br", h.textContent = "\u200b", (k = a[k + 1]) && k.textContent && (k.textContent = k.textContent.replace(/^ +/gm, ""))) : "a" === t && f && f.some(function(c) {
                        return "#text" === c.tagName;
                    }) && (h.children = [
                        {
                            children: f,
                            tagName: "tspan"
                        }
                    ]);
                    "#text" !== t && "a" !== t && (h.tagName = "tspan");
                    h.attributes = p;
                    f && f.filter(function(c) {
                        return "#text" !== c.tagName;
                    }).forEach(e);
                };
                a.forEach(e);
            };
            k.prototype.truncate = function(a, c, h, f, k, p) {
                var e = this.svgElement, t = e.renderer, w = e.rotation, n = [], r = h ? 1 : 0, l = (c || h || "").length, b = l, g, d = function(b, d) {
                    d = d || b;
                    var g = a.parentNode;
                    if (g && "undefined" === typeof n[d]) {
                        if (g.getSubStringLength) try {
                            n[d] = f + g.getSubStringLength(0, h ? d + 1 : d);
                        } catch (P) {
                            "";
                        }
                        else t.getSpanWidth && (a.textContent = p(c || h, b), n[d] = f + t.getSpanWidth(e, a));
                    }
                    return n[d];
                };
                e.rotation = 0;
                var m = d(a.textContent.length);
                if (f + m > k) {
                    for(; r <= l;)b = Math.ceil((r + l) / 2), h && (g = p(h, b)), m = d(b, g && g.length - 1), r === l ? r = l + 1 : m > k ? l = b - 1 : r = b;
                    0 === l ? a.textContent = "" : c && l === c.length - 1 || (a.textContent = g || p(c || h, b));
                }
                h && h.splice(0, b);
                e.actualWidth = m;
                e.rotation = w;
            };
            k.prototype.unescapeEntities = function(a, c) {
                q(this.renderer.escapes, function(e, f) {
                    c && -1 !== c.indexOf(e) || (a = a.toString().replace(new RegExp(e, "g"), f));
                });
                return a;
            };
            return k;
        }();
    });
    M(a, "Core/Renderer/SVG/SVGRenderer.js", [
        a["Core/Renderer/HTML/AST.js"],
        a["Core/Color/Color.js"],
        a["Core/Globals.js"],
        a["Core/Renderer/RendererRegistry.js"],
        a["Core/Renderer/SVG/SVGElement.js"],
        a["Core/Renderer/SVG/SVGLabel.js"],
        a["Core/Renderer/SVG/Symbols.js"],
        a["Core/Renderer/SVG/TextBuilder.js"],
        a["Core/Utilities.js"]
    ], function(a, u, z, F, y, G, H, A, q) {
        var n = z.charts, k = z.deg2rad, e = z.doc, c = z.isFirefox, h = z.isMS, f = z.isWebKit, w = z.noop, p = z.SVG_NS, B = z.symbolSizes, t = z.win, J = q.addEvent, C = q.attr, r = q.createElement, l = q.css, b = q.defined, g = q.destroyObjectProperties, d = q.extend, m = q.isArray, D = q.isNumber, x = q.isObject, I = q.isString, P = q.merge, v = q.pick, O = q.pInt, U = q.uniqueKey, Y;
        z = function() {
            function L(b, d, a, c, g, m, e) {
                this.width = this.url = this.style = this.isSVG = this.imgCount = this.height = this.gradients = this.globalAnimation = this.defs = this.chartIndex = this.cacheKeys = this.cache = this.boxWrapper = this.box = this.alignedObjects = void 0;
                this.init(b, d, a, c, g, m, e);
            }
            L.prototype.init = function(b, d, a, g, m, E, L) {
                var r = this.createElement("svg").attr({
                    version: "1.1",
                    "class": "highcharts-root"
                }), K = r.element;
                L || r.css(this.getStyle(g));
                b.appendChild(K);
                C(b, "dir", "ltr");
                -1 === b.innerHTML.indexOf("xmlns") && C(K, "xmlns", this.SVG_NS);
                this.isSVG = !0;
                this.box = K;
                this.boxWrapper = r;
                this.alignedObjects = [];
                this.url = this.getReferenceURL();
                this.createElement("desc").add().element.appendChild(e.createTextNode("Created with Highcharts 9.3.3"));
                this.defs = this.createElement("defs").add();
                this.allowHTML = E;
                this.forExport = m;
                this.styledMode = L;
                this.gradients = {};
                this.cache = {};
                this.cacheKeys = [];
                this.imgCount = 0;
                this.setSize(d, a, !1);
                var p;
                c && b.getBoundingClientRect && (d = function() {
                    l(b, {
                        left: 0,
                        top: 0
                    });
                    p = b.getBoundingClientRect();
                    l(b, {
                        left: Math.ceil(p.left) - p.left + "px",
                        top: Math.ceil(p.top) - p.top + "px"
                    });
                }, d(), this.unSubPixelFix = J(t, "resize", d));
            };
            L.prototype.definition = function(b) {
                return new a([
                    b
                ]).addToDOM(this.defs.element);
            };
            L.prototype.getReferenceURL = function() {
                if ((c || f) && e.getElementsByTagName("base").length) {
                    if (!b(Y)) {
                        var d = U();
                        d = new a([
                            {
                                tagName: "svg",
                                attributes: {
                                    width: 8,
                                    height: 8
                                },
                                children: [
                                    {
                                        tagName: "defs",
                                        children: [
                                            {
                                                tagName: "clipPath",
                                                attributes: {
                                                    id: d
                                                },
                                                children: [
                                                    {
                                                        tagName: "rect",
                                                        attributes: {
                                                            width: 4,
                                                            height: 4
                                                        }
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        tagName: "rect",
                                        attributes: {
                                            id: "hitme",
                                            width: 8,
                                            height: 8,
                                            "clip-path": "url(#" + d + ")",
                                            fill: "rgba(0,0,0,0.001)"
                                        }
                                    }
                                ]
                            }
                        ]).addToDOM(e.body);
                        l(d, {
                            position: "fixed",
                            top: 0,
                            left: 0,
                            zIndex: 9E5
                        });
                        var g = e.elementFromPoint(6, 6);
                        Y = "hitme" === (g && g.id);
                        e.body.removeChild(d);
                    }
                    if (Y) return t.location.href.split("#")[0].replace(/<[^>]*>/g, "").replace(/([\('\)])/g, "\\$1").replace(/ /g, "%20");
                }
                return "";
            };
            L.prototype.getStyle = function(b) {
                return this.style = d({
                    fontFamily: '"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif',
                    fontSize: "12px"
                }, b);
            };
            L.prototype.setStyle = function(b) {
                this.boxWrapper.css(this.getStyle(b));
            };
            L.prototype.isHidden = function() {
                return !this.boxWrapper.getBBox().width;
            };
            L.prototype.destroy = function() {
                var b = this.defs;
                this.box = null;
                this.boxWrapper = this.boxWrapper.destroy();
                g(this.gradients || {});
                this.gradients = null;
                b && (this.defs = b.destroy());
                this.unSubPixelFix && this.unSubPixelFix();
                return this.alignedObjects = null;
            };
            L.prototype.createElement = function(b) {
                var d = new this.Element;
                d.init(this, b);
                return d;
            };
            L.prototype.getRadialAttr = function(b, d) {
                return {
                    cx: b[0] - b[2] / 2 + (d.cx || 0) * b[2],
                    cy: b[1] - b[2] / 2 + (d.cy || 0) * b[2],
                    r: (d.r || 0) * b[2]
                };
            };
            L.prototype.buildText = function(b) {
                new A(b).buildSVG();
            };
            L.prototype.getContrast = function(b) {
                b = u.parse(b).rgba;
                b[0] *= 1;
                b[1] *= 1.2;
                b[2] *= .5;
                return 459 < b[0] + b[1] + b[2] ? "#000000" : "#FFFFFF";
            };
            L.prototype.button = function(b, c, g, m, e, l, L, r, p, x) {
                var E = this.label(b, c, g, p, void 0, void 0, x, void 0, "button"), f = this.styledMode, K = 0, D = e ? P(e) : {};
                b = D && D.style || {};
                D = a.filterUserAttributes(D);
                E.attr(P({
                    padding: 8,
                    r: 2
                }, D));
                if (!f) {
                    D = P({
                        fill: "#f7f7f7",
                        stroke: "#cccccc",
                        "stroke-width": 1,
                        style: {
                            color: "#333333",
                            cursor: "pointer",
                            fontWeight: "normal"
                        }
                    }, {
                        style: b
                    }, D);
                    var k = D.style;
                    delete D.style;
                    l = P(D, {
                        fill: "#e6e6e6"
                    }, a.filterUserAttributes(l || {}));
                    var N = l.style;
                    delete l.style;
                    L = P(D, {
                        fill: "#e6ebf5",
                        style: {
                            color: "#000000",
                            fontWeight: "bold"
                        }
                    }, a.filterUserAttributes(L || {}));
                    var w = L.style;
                    delete L.style;
                    r = P(D, {
                        style: {
                            color: "#cccccc"
                        }
                    }, a.filterUserAttributes(r || {}));
                    var t = r.style;
                    delete r.style;
                }
                J(E.element, h ? "mouseover" : "mouseenter", function() {
                    3 !== K && E.setState(1);
                });
                J(E.element, h ? "mouseout" : "mouseleave", function() {
                    3 !== K && E.setState(K);
                });
                E.setState = function(b) {
                    1 !== b && (E.state = K = b);
                    E.removeClass(/highcharts-button-(normal|hover|pressed|disabled)/).addClass("highcharts-button-" + [
                        "normal",
                        "hover",
                        "pressed",
                        "disabled"
                    ][b || 0]);
                    f || E.attr([
                        D,
                        l,
                        L,
                        r
                    ][b || 0]).css([
                        k,
                        N,
                        w,
                        t
                    ][b || 0]);
                };
                f || E.attr(D).css(d({
                    cursor: "default"
                }, k));
                return E.on("touchstart", function(b) {
                    return b.stopPropagation();
                }).on("click", function(b) {
                    3 !== K && m.call(E, b);
                });
            };
            L.prototype.crispLine = function(d, a, c) {
                void 0 === c && (c = "round");
                var g = d[0], m = d[1];
                b(g[1]) && g[1] === m[1] && (g[1] = m[1] = Math[c](g[1]) - a % 2 / 2);
                b(g[2]) && g[2] === m[2] && (g[2] = m[2] = Math[c](g[2]) + a % 2 / 2);
                return d;
            };
            L.prototype.path = function(b) {
                var a = this.styledMode ? {} : {
                    fill: "none"
                };
                m(b) ? a.d = b : x(b) && d(a, b);
                return this.createElement("path").attr(a);
            };
            L.prototype.circle = function(b, d, a) {
                b = x(b) ? b : "undefined" === typeof b ? {} : {
                    x: b,
                    y: d,
                    r: a
                };
                d = this.createElement("circle");
                d.xSetter = d.ySetter = function(b, d, a) {
                    a.setAttribute("c" + d, b);
                };
                return d.attr(b);
            };
            L.prototype.arc = function(b, d, a, c, g, m) {
                x(b) ? (c = b, d = c.y, a = c.r, b = c.x) : c = {
                    innerR: c,
                    start: g,
                    end: m
                };
                b = this.symbol("arc", b, d, a, a, c);
                b.r = a;
                return b;
            };
            L.prototype.rect = function(b, d, a, c, g, m) {
                g = x(b) ? b.r : g;
                var e = this.createElement("rect");
                b = x(b) ? b : "undefined" === typeof b ? {} : {
                    x: b,
                    y: d,
                    width: Math.max(a, 0),
                    height: Math.max(c, 0)
                };
                this.styledMode || ("undefined" !== typeof m && (b["stroke-width"] = m, b = e.crisp(b)), b.fill = "none");
                g && (b.r = g);
                e.rSetter = function(b, d, a) {
                    e.r = b;
                    C(a, {
                        rx: b,
                        ry: b
                    });
                };
                e.rGetter = function() {
                    return e.r || 0;
                };
                return e.attr(b);
            };
            L.prototype.setSize = function(b, d, a) {
                this.width = b;
                this.height = d;
                this.boxWrapper.animate({
                    width: b,
                    height: d
                }, {
                    step: function() {
                        this.attr({
                            viewBox: "0 0 " + this.attr("width") + " " + this.attr("height")
                        });
                    },
                    duration: v(a, !0) ? void 0 : 0
                });
                this.alignElements();
            };
            L.prototype.g = function(b) {
                var d = this.createElement("g");
                return b ? d.attr({
                    "class": "highcharts-" + b
                }) : d;
            };
            L.prototype.image = function(b, d, a, c, g, m) {
                var e = {
                    preserveAspectRatio: "none"
                }, l = function(b, d) {
                    b.setAttributeNS ? b.setAttributeNS("http://www.w3.org/1999/xlink", "href", d) : b.setAttribute("hc-svg-href", d);
                };
                D(d) && (e.x = d);
                D(a) && (e.y = a);
                D(c) && (e.width = c);
                D(g) && (e.height = g);
                var E = this.createElement("image").attr(e);
                d = function(d) {
                    l(E.element, b);
                    m.call(E, d);
                };
                m ? (l(E.element, "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="), a = new t.Image, J(a, "load", d), a.src = b, a.complete && d({})) : l(E.element, b);
                return E;
            };
            L.prototype.symbol = function(a, c, g, m, L, E) {
                var p = this, h = /^url\((.*?)\)$/, x = h.test(a), f = !x && (this.symbols[a] ? a : "circle"), D = f && this.symbols[f], k;
                if (D) {
                    "number" === typeof c && (k = D.call(this.symbols, Math.round(c || 0), Math.round(g || 0), m || 0, L || 0, E));
                    var K = this.path(k);
                    p.styledMode || K.attr("fill", "none");
                    d(K, {
                        symbolName: f || void 0,
                        x: c,
                        y: g,
                        width: m,
                        height: L
                    });
                    E && d(K, E);
                } else if (x) {
                    var w = a.match(h)[1];
                    var t = K = this.image(w);
                    t.imgwidth = v(B[w] && B[w].width, E && E.width);
                    t.imgheight = v(B[w] && B[w].height, E && E.height);
                    var I = function(b) {
                        return b.attr({
                            width: b.width,
                            height: b.height
                        });
                    };
                    [
                        "width",
                        "height"
                    ].forEach(function(d) {
                        t[d + "Setter"] = function(d, a) {
                            var c = this["img" + a];
                            this[a] = d;
                            b(c) && (E && "within" === E.backgroundSize && this.width && this.height && (c = Math.round(c * Math.min(this.width / this.imgwidth, this.height / this.imgheight))), this.element && this.element.setAttribute(a, c), this.alignByTranslate || (d = ((this[a] || 0) - c) / 2, this.attr("width" === a ? {
                                translateX: d
                            } : {
                                translateY: d
                            })));
                        };
                    });
                    b(c) && t.attr({
                        x: c,
                        y: g
                    });
                    t.isImg = !0;
                    b(t.imgwidth) && b(t.imgheight) ? I(t) : (t.attr({
                        width: 0,
                        height: 0
                    }), r("img", {
                        onload: function() {
                            var b = n[p.chartIndex];
                            0 === this.width && (l(this, {
                                position: "absolute",
                                top: "-999em"
                            }), e.body.appendChild(this));
                            B[w] = {
                                width: this.width,
                                height: this.height
                            };
                            t.imgwidth = this.width;
                            t.imgheight = this.height;
                            t.element && I(t);
                            this.parentNode && this.parentNode.removeChild(this);
                            p.imgCount--;
                            if (!p.imgCount && b && !b.hasLoaded) b.onload();
                        },
                        src: w
                    }), this.imgCount++);
                }
                return K;
            };
            L.prototype.clipRect = function(b, d, a, c) {
                var g = U() + "-", m = this.createElement("clipPath").attr({
                    id: g
                }).add(this.defs);
                b = this.rect(b, d, a, c, 0).add(m);
                b.id = g;
                b.clipPath = m;
                b.count = 0;
                return b;
            };
            L.prototype.text = function(d, a, c, g) {
                var m = {};
                if (g && (this.allowHTML || !this.forExport)) return this.html(d, a, c);
                m.x = Math.round(a || 0);
                c && (m.y = Math.round(c));
                b(d) && (m.text = d);
                d = this.createElement("text").attr(m);
                if (!g || this.forExport && !this.allowHTML) d.xSetter = function(b, d, a) {
                    for(var c = a.getElementsByTagName("tspan"), g = a.getAttribute(d), m = 0, e; m < c.length; m++)e = c[m], e.getAttribute(d) === g && e.setAttribute(d, b);
                    a.setAttribute(d, b);
                };
                return d;
            };
            L.prototype.fontMetrics = function(b, d) {
                b = !this.styledMode && /px/.test(b) || !t.getComputedStyle ? b || d && d.style && d.style.fontSize || this.style && this.style.fontSize : d && y.prototype.getStyle.call(d, "font-size");
                b = /px/.test(b) ? O(b) : 12;
                d = 24 > b ? b + 3 : Math.round(1.2 * b);
                return {
                    h: d,
                    b: Math.round(.8 * d),
                    f: b
                };
            };
            L.prototype.rotCorr = function(b, d, a) {
                var c = b;
                d && a && (c = Math.max(c * Math.cos(d * k), 4));
                return {
                    x: -b / 3 * Math.sin(d * k),
                    y: c
                };
            };
            L.prototype.pathToSegments = function(b) {
                for(var d = [], a = [], c = {
                    A: 8,
                    C: 7,
                    H: 2,
                    L: 3,
                    M: 3,
                    Q: 5,
                    S: 5,
                    T: 3,
                    V: 2
                }, g = 0; g < b.length; g++)I(a[0]) && D(b[g]) && a.length === c[a[0].toUpperCase()] && b.splice(g, 0, a[0].replace("M", "L").replace("m", "l")), "string" === typeof b[g] && (a.length && d.push(a.slice(0)), a.length = 0), a.push(b[g]);
                d.push(a.slice(0));
                return d;
            };
            L.prototype.label = function(b, d, a, c, g, m, e, l, L) {
                return new G(this, b, d, a, c, g, m, e, l, L);
            };
            L.prototype.alignElements = function() {
                this.alignedObjects.forEach(function(b) {
                    return b.align();
                });
            };
            return L;
        }();
        d(z.prototype, {
            Element: y,
            SVG_NS: p,
            escapes: {
                "&": "&amp;",
                "<": "&lt;",
                ">": "&gt;",
                "'": "&#39;",
                '"': "&quot;"
            },
            symbols: H,
            draw: w
        });
        F.registerRendererType("svg", z, !0);
        "";
        return z;
    });
    M(a, "Core/Renderer/HTML/HTMLElement.js", [
        a["Core/Globals.js"],
        a["Core/Renderer/SVG/SVGElement.js"],
        a["Core/Utilities.js"]
    ], function(a, u, z) {
        var v = this && this.__extends || function() {
            var a = function(c, e) {
                a = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(a, c) {
                    a.__proto__ = c;
                } || function(a, c) {
                    for(var e in c)c.hasOwnProperty(e) && (a[e] = c[e]);
                };
                return a(c, e);
            };
            return function(c, e) {
                function p() {
                    this.constructor = c;
                }
                a(c, e);
                c.prototype = null === e ? Object.create(e) : (p.prototype = e.prototype, new p);
            };
        }(), y = a.isFirefox, G = a.isMS, H = a.isWebKit, A = a.win, q = z.css, n = z.defined, k = z.extend, e = z.pick, c = z.pInt;
        return function(a) {
            function h() {
                return null !== a && a.apply(this, arguments) || this;
            }
            v(h, a);
            h.compose = function(a) {
                if (-1 === h.composedClasses.indexOf(a)) {
                    h.composedClasses.push(a);
                    var c = h.prototype, e = a.prototype;
                    e.getSpanCorrection = c.getSpanCorrection;
                    e.htmlCss = c.htmlCss;
                    e.htmlGetBBox = c.htmlGetBBox;
                    e.htmlUpdateTransform = c.htmlUpdateTransform;
                    e.setSpanRotation = c.setSpanRotation;
                }
                return a;
            };
            h.prototype.getSpanCorrection = function(a, c, e) {
                this.xCorr = -a * e;
                this.yCorr = -c;
            };
            h.prototype.htmlCss = function(a) {
                var c = "SPAN" === this.element.tagName && a && "width" in a, h = e(c && a.width, void 0);
                if (c) {
                    delete a.width;
                    this.textWidth = h;
                    var f = !0;
                }
                a && "ellipsis" === a.textOverflow && (a.whiteSpace = "nowrap", a.overflow = "hidden");
                this.styles = k(this.styles, a);
                q(this.element, a);
                f && this.htmlUpdateTransform();
                return this;
            };
            h.prototype.htmlGetBBox = function() {
                var a = this.element;
                return {
                    x: a.offsetLeft,
                    y: a.offsetTop,
                    width: a.offsetWidth,
                    height: a.offsetHeight
                };
            };
            h.prototype.htmlUpdateTransform = function() {
                if (this.added) {
                    var a = this.renderer, e = this.element, h = this.translateX || 0, f = this.translateY || 0, k = this.x || 0, C = this.y || 0, r = this.textAlign || "left", l = {
                        left: 0,
                        center: .5,
                        right: 1
                    }[r], b = this.styles;
                    b = b && b.whiteSpace;
                    q(e, {
                        marginLeft: h,
                        marginTop: f
                    });
                    !a.styledMode && this.shadows && this.shadows.forEach(function(b) {
                        q(b, {
                            marginLeft: h + 1,
                            marginTop: f + 1
                        });
                    });
                    this.inverted && [].forEach.call(e.childNodes, function(b) {
                        a.invertChild(b, e);
                    });
                    if ("SPAN" === e.tagName) {
                        var g = this.rotation, d = this.textWidth && c(this.textWidth), m = [
                            g,
                            r,
                            e.innerHTML,
                            this.textWidth,
                            this.textAlign
                        ].join(), D = void 0;
                        D = !1;
                        if (d !== this.oldTextWidth) {
                            if (this.textPxLength) var x = this.textPxLength;
                            else q(e, {
                                width: "",
                                whiteSpace: b || "nowrap"
                            }), x = e.offsetWidth;
                            (d > this.oldTextWidth || x > d) && (/[ \-]/.test(e.textContent || e.innerText) || "ellipsis" === e.style.textOverflow) && (q(e, {
                                width: x > d || g ? d + "px" : "auto",
                                display: "block",
                                whiteSpace: b || "normal"
                            }), this.oldTextWidth = d, D = !0);
                        }
                        this.hasBoxWidthChanged = D;
                        m !== this.cTT && (D = a.fontMetrics(e.style.fontSize, e).b, !n(g) || g === (this.oldRotation || 0) && r === this.oldAlign || this.setSpanRotation(g, l, D), this.getSpanCorrection(!n(g) && this.textPxLength || e.offsetWidth, D, l, g, r));
                        q(e, {
                            left: k + (this.xCorr || 0) + "px",
                            top: C + (this.yCorr || 0) + "px"
                        });
                        this.cTT = m;
                        this.oldRotation = g;
                        this.oldAlign = r;
                    }
                } else this.alignOnAdd = !0;
            };
            h.prototype.setSpanRotation = function(a, c, e) {
                var h = {}, p = G && !/Edge/.test(A.navigator.userAgent) ? "-ms-transform" : H ? "-webkit-transform" : y ? "MozTransform" : A.opera ? "-o-transform" : void 0;
                p && (h[p] = h.transform = "rotate(" + a + "deg)", h[p + (y ? "Origin" : "-origin")] = h.transformOrigin = 100 * c + "% " + e + "px", q(this.element, h));
            };
            h.composedClasses = [];
            return h;
        }(u);
    });
    M(a, "Core/Renderer/HTML/HTMLRenderer.js", [
        a["Core/Renderer/HTML/AST.js"],
        a["Core/Renderer/SVG/SVGElement.js"],
        a["Core/Renderer/SVG/SVGRenderer.js"],
        a["Core/Utilities.js"]
    ], function(a, u, z, F) {
        var v = this && this.__extends || function() {
            var a = function(k, e) {
                a = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(a, e) {
                    a.__proto__ = e;
                } || function(a, e) {
                    for(var c in e)e.hasOwnProperty(c) && (a[c] = e[c]);
                };
                return a(k, e);
            };
            return function(k, e) {
                function c() {
                    this.constructor = k;
                }
                a(k, e);
                k.prototype = null === e ? Object.create(e) : (c.prototype = e.prototype, new c);
            };
        }(), G = F.attr, H = F.createElement, A = F.extend, q = F.pick;
        return function(n) {
            function k() {
                return null !== n && n.apply(this, arguments) || this;
            }
            v(k, n);
            k.compose = function(a) {
                -1 === k.composedClasses.indexOf(a) && (k.composedClasses.push(a), a.prototype.html = k.prototype.html);
                return a;
            };
            k.prototype.html = function(e, c, h) {
                var f = this.createElement("span"), k = f.element, p = f.renderer, n = p.isSVG, t = function(a, c) {
                    [
                        "opacity",
                        "visibility"
                    ].forEach(function(e) {
                        a[e + "Setter"] = function(l, b, g) {
                            var d = a.div ? a.div.style : c;
                            u.prototype[e + "Setter"].call(this, l, b, g);
                            d && (d[b] = l);
                        };
                    });
                    a.addedSetters = !0;
                };
                f.textSetter = function(c) {
                    c !== this.textStr && (delete this.bBox, delete this.oldTextWidth, a.setElementHTML(this.element, q(c, "")), this.textStr = c, f.doTransform = !0);
                };
                n && t(f, f.element.style);
                f.xSetter = f.ySetter = f.alignSetter = f.rotationSetter = function(a, c) {
                    "align" === c ? f.alignValue = f.textAlign = a : f[c] = a;
                    f.doTransform = !0;
                };
                f.afterSetters = function() {
                    this.doTransform && (this.htmlUpdateTransform(), this.doTransform = !1);
                };
                f.attr({
                    text: e,
                    x: Math.round(c),
                    y: Math.round(h)
                }).css({
                    position: "absolute"
                });
                p.styledMode || f.css({
                    fontFamily: this.style.fontFamily,
                    fontSize: this.style.fontSize
                });
                k.style.whiteSpace = "nowrap";
                f.css = f.htmlCss;
                n && (f.add = function(a) {
                    var c = p.box.parentNode, e = [];
                    if (this.parentGroup = a) {
                        var l = a.div;
                        if (!l) {
                            for(; a;)e.push(a), a = a.parentGroup;
                            e.reverse().forEach(function(b) {
                                function a(d, a) {
                                    b[a] = d;
                                    "translateX" === a ? r.left = d + "px" : r.top = d + "px";
                                    b.doTransform = !0;
                                }
                                var d = G(b.element, "class"), m = b.styles || {};
                                l = b.div = b.div || H("div", d ? {
                                    className: d
                                } : void 0, {
                                    position: "absolute",
                                    left: (b.translateX || 0) + "px",
                                    top: (b.translateY || 0) + "px",
                                    display: b.display,
                                    opacity: b.opacity,
                                    cursor: m.cursor,
                                    pointerEvents: m.pointerEvents,
                                    visibility: b.visibility
                                }, l || c);
                                var r = l.style;
                                A(b, {
                                    classSetter: function(b) {
                                        return function(d) {
                                            this.element.setAttribute("class", d);
                                            b.className = d;
                                        };
                                    }(l),
                                    on: function() {
                                        e[0].div && f.on.apply({
                                            element: e[0].div,
                                            onEvents: b.onEvents
                                        }, arguments);
                                        return b;
                                    },
                                    translateXSetter: a,
                                    translateYSetter: a
                                });
                                b.addedSetters || t(b);
                            });
                        }
                    } else l = c;
                    l.appendChild(k);
                    f.added = !0;
                    f.alignOnAdd && f.htmlUpdateTransform();
                    return f;
                });
                return f;
            };
            k.composedClasses = [];
            return k;
        }(z);
    });
    M(a, "Core/Axis/AxisDefaults.js", [], function() {
        var a;
        (function(a) {
            a.defaultXAxisOptions = {
                alignTicks: !0,
                allowDecimals: void 0,
                panningEnabled: !0,
                zIndex: 2,
                zoomEnabled: !0,
                dateTimeLabelFormats: {
                    millisecond: {
                        main: "%H:%M:%S.%L",
                        range: !1
                    },
                    second: {
                        main: "%H:%M:%S",
                        range: !1
                    },
                    minute: {
                        main: "%H:%M",
                        range: !1
                    },
                    hour: {
                        main: "%H:%M",
                        range: !1
                    },
                    day: {
                        main: "%e. %b"
                    },
                    week: {
                        main: "%e. %b"
                    },
                    month: {
                        main: "%b '%y"
                    },
                    year: {
                        main: "%Y"
                    }
                },
                endOnTick: !1,
                gridLineDashStyle: "Solid",
                gridZIndex: 1,
                labels: {
                    autoRotation: void 0,
                    autoRotationLimit: 80,
                    distance: void 0,
                    enabled: !0,
                    indentation: 10,
                    overflow: "justify",
                    padding: 5,
                    reserveSpace: void 0,
                    rotation: void 0,
                    staggerLines: 0,
                    step: 0,
                    useHTML: !1,
                    x: 0,
                    zIndex: 7,
                    style: {
                        color: "#666666",
                        cursor: "default",
                        fontSize: "11px"
                    }
                },
                maxPadding: .01,
                minorGridLineDashStyle: "Solid",
                minorTickLength: 2,
                minorTickPosition: "outside",
                minPadding: .01,
                offset: void 0,
                opposite: !1,
                reversed: void 0,
                reversedStacks: !1,
                showEmpty: !0,
                showFirstLabel: !0,
                showLastLabel: !0,
                startOfWeek: 1,
                startOnTick: !1,
                tickLength: 10,
                tickPixelInterval: 100,
                tickmarkPlacement: "between",
                tickPosition: "outside",
                title: {
                    align: "middle",
                    rotation: 0,
                    useHTML: !1,
                    x: 0,
                    y: 0,
                    style: {
                        color: "#666666"
                    }
                },
                type: "linear",
                uniqueNames: !0,
                visible: !0,
                minorGridLineColor: "#f2f2f2",
                minorGridLineWidth: 1,
                minorTickColor: "#999999",
                lineColor: "#ccd6eb",
                lineWidth: 1,
                gridLineColor: "#e6e6e6",
                gridLineWidth: void 0,
                tickColor: "#ccd6eb"
            };
            a.defaultYAxisOptions = {
                reversedStacks: !0,
                endOnTick: !0,
                maxPadding: .05,
                minPadding: .05,
                tickPixelInterval: 72,
                showLastLabel: !0,
                labels: {
                    x: -8
                },
                startOnTick: !0,
                title: {
                    rotation: 270,
                    text: "Values"
                },
                stackLabels: {
                    animation: {},
                    allowOverlap: !1,
                    enabled: !1,
                    crop: !0,
                    overflow: "justify",
                    formatter: function() {
                        var a = this.axis.chart.numberFormatter;
                        return a(this.total, -1);
                    },
                    style: {
                        color: "#000000",
                        fontSize: "11px",
                        fontWeight: "bold",
                        textOutline: "1px contrast"
                    }
                },
                gridLineWidth: 1,
                lineWidth: 0
            };
            a.defaultLeftAxisOptions = {
                labels: {
                    x: -15
                },
                title: {
                    rotation: 270
                }
            };
            a.defaultRightAxisOptions = {
                labels: {
                    x: 15
                },
                title: {
                    rotation: 90
                }
            };
            a.defaultBottomAxisOptions = {
                labels: {
                    autoRotation: [
                        -45
                    ],
                    x: 0
                },
                margin: 15,
                title: {
                    rotation: 0
                }
            };
            a.defaultTopAxisOptions = {
                labels: {
                    autoRotation: [
                        -45
                    ],
                    x: 0
                },
                margin: 15,
                title: {
                    rotation: 0
                }
            };
        })(a || (a = {}));
        return a;
    });
    M(a, "Core/Foundation.js", [
        a["Core/Utilities.js"]
    ], function(a) {
        var v = a.addEvent, z = a.isFunction, F = a.objectEach, y = a.removeEvent, G;
        (function(a) {
            a.registerEventOptions = function(a, q) {
                a.eventOptions = a.eventOptions || {};
                F(q.events, function(n, k) {
                    a.eventOptions[k] !== n && (a.eventOptions[k] && (y(a, k, a.eventOptions[k]), delete a.eventOptions[k]), z(n) && (a.eventOptions[k] = n, v(a, k, n)));
                });
            };
        })(G || (G = {}));
        return G;
    });
    M(a, "Core/Axis/Tick.js", [
        a["Core/FormatUtilities.js"],
        a["Core/Globals.js"],
        a["Core/Utilities.js"]
    ], function(a, u, z) {
        var v = u.deg2rad, y = z.clamp, G = z.correctFloat, H = z.defined, A = z.destroyObjectProperties, q = z.extend, n = z.fireEvent, k = z.isNumber, e = z.merge, c = z.objectEach, h = z.pick;
        u = function() {
            function f(a, c, e, h, f) {
                this.isNewLabel = this.isNew = !0;
                this.axis = a;
                this.pos = c;
                this.type = e || "";
                this.parameters = f || {};
                this.tickmarkOffset = this.parameters.tickmarkOffset;
                this.options = this.parameters.options;
                n(this, "init");
                e || h || this.addLabel();
            }
            f.prototype.addLabel = function() {
                var c = this, e = c.axis, f = e.options, t = e.chart, J = e.categories, C = e.logarithmic, r = e.names, l = c.pos, b = h(c.options && c.options.labels, f.labels), g = e.tickPositions, d = l === g[0], m = l === g[g.length - 1], D = (!b.step || 1 === b.step) && 1 === e.tickInterval;
                g = g.info;
                var x = c.label, I;
                J = this.parameters.category || (J ? h(J[l], r[l], l) : l);
                C && k(J) && (J = G(C.lin2log(J)));
                if (e.dateTime) {
                    if (g) {
                        var P = t.time.resolveDTLFormat(f.dateTimeLabelFormats[!f.grid && g.higherRanks[l] || g.unitName]);
                        var v = P.main;
                    } else k(J) && (v = e.dateTime.getXDateFormat(J, f.dateTimeLabelFormats || {}));
                }
                c.isFirst = d;
                c.isLast = m;
                var O = {
                    axis: e,
                    chart: t,
                    dateTimeLabelFormat: v,
                    isFirst: d,
                    isLast: m,
                    pos: l,
                    tick: c,
                    tickPositionInfo: g,
                    value: J
                };
                n(this, "labelFormat", O);
                var u = function(d) {
                    return b.formatter ? b.formatter.call(d, d) : b.format ? (d.text = e.defaultLabelFormatter.call(d), a.format(b.format, d, t)) : e.defaultLabelFormatter.call(d, d);
                };
                f = u.call(O, O);
                var A = P && P.list;
                c.shortenLabel = A ? function() {
                    for(I = 0; I < A.length; I++)if (q(O, {
                        dateTimeLabelFormat: A[I]
                    }), x.attr({
                        text: u.call(O, O)
                    }), x.getBBox().width < e.getSlotWidth(c) - 2 * b.padding) return;
                    x.attr({
                        text: ""
                    });
                } : void 0;
                D && e._addedPlotLB && c.moveLabel(f, b);
                H(x) || c.movedLabel ? x && x.textStr !== f && !D && (!x.textWidth || b.style.width || x.styles.width || x.css({
                    width: null
                }), x.attr({
                    text: f
                }), x.textPxLength = x.getBBox().width) : (c.label = x = c.createLabel({
                    x: 0,
                    y: 0
                }, f, b), c.rotation = 0);
            };
            f.prototype.createLabel = function(a, c, h) {
                var f = this.axis, p = f.chart;
                if (a = H(c) && h.enabled ? p.renderer.text(c, a.x, a.y, h.useHTML).add(f.labelGroup) : null) p.styledMode || a.css(e(h.style)), a.textPxLength = a.getBBox().width;
                return a;
            };
            f.prototype.destroy = function() {
                A(this, this.axis);
            };
            f.prototype.getPosition = function(a, c, e, h) {
                var f = this.axis, p = f.chart, r = h && p.oldChartHeight || p.chartHeight;
                a = {
                    x: a ? G(f.translate(c + e, null, null, h) + f.transB) : f.left + f.offset + (f.opposite ? (h && p.oldChartWidth || p.chartWidth) - f.right - f.left : 0),
                    y: a ? r - f.bottom + f.offset - (f.opposite ? f.height : 0) : G(r - f.translate(c + e, null, null, h) - f.transB)
                };
                a.y = y(a.y, -100000, 1E5);
                n(this, "afterGetPosition", {
                    pos: a
                });
                return a;
            };
            f.prototype.getLabelPosition = function(a, c, e, h, f, k, r, l) {
                var b = this.axis, g = b.transA, d = b.isLinked && b.linkedParent ? b.linkedParent.reversed : b.reversed, m = b.staggerLines, D = b.tickRotCorr || {
                    x: 0,
                    y: 0
                }, x = h || b.reserveSpaceDefault ? 0 : -b.labelOffset * ("center" === b.labelAlign ? .5 : 1), p = {}, t = f.y;
                H(t) || (t = 0 === b.side ? e.rotation ? -8 : -e.getBBox().height : 2 === b.side ? D.y + 8 : Math.cos(e.rotation * v) * (D.y - e.getBBox(!1, 0).height / 2));
                a = a + f.x + x + D.x - (k && h ? k * g * (d ? -1 : 1) : 0);
                c = c + t - (k && !h ? k * g * (d ? 1 : -1) : 0);
                m && (e = r / (l || 1) % m, b.opposite && (e = m - e - 1), c += b.labelOffset / m * e);
                p.x = a;
                p.y = Math.round(c);
                n(this, "afterGetLabelPosition", {
                    pos: p,
                    tickmarkOffset: k,
                    index: r
                });
                return p;
            };
            f.prototype.getLabelSize = function() {
                return this.label ? this.label.getBBox()[this.axis.horiz ? "height" : "width"] : 0;
            };
            f.prototype.getMarkPath = function(a, c, e, h, f, k) {
                return k.crispLine([
                    [
                        "M",
                        a,
                        c
                    ],
                    [
                        "L",
                        a + (f ? 0 : -e),
                        c + (f ? e : 0)
                    ]
                ], h);
            };
            f.prototype.handleOverflow = function(a) {
                var c = this.axis, e = c.options.labels, f = a.x, k = c.chart.chartWidth, n = c.chart.spacing, r = h(c.labelLeft, Math.min(c.pos, n[3]));
                n = h(c.labelRight, Math.max(c.isRadial ? 0 : c.pos + c.len, k - n[1]));
                var l = this.label, b = this.rotation, g = {
                    left: 0,
                    center: .5,
                    right: 1
                }[c.labelAlign || l.attr("align")], d = l.getBBox().width, m = c.getSlotWidth(this), D = {}, x = m, I = 1, w;
                if (b || "justify" !== e.overflow) 0 > b && f - g * d < r ? w = Math.round(f / Math.cos(b * v) - r) : 0 < b && f + g * d > n && (w = Math.round((k - f) / Math.cos(b * v)));
                else if (k = f + (1 - g) * d, f - g * d < r ? x = a.x + x * (1 - g) - r : k > n && (x = n - a.x + x * g, I = -1), x = Math.min(m, x), x < m && "center" === c.labelAlign && (a.x += I * (m - x - g * (m - Math.min(d, x)))), d > x || c.autoRotation && (l.styles || {}).width) w = x;
                w && (this.shortenLabel ? this.shortenLabel() : (D.width = Math.floor(w) + "px", (e.style || {}).textOverflow || (D.textOverflow = "ellipsis"), l.css(D)));
            };
            f.prototype.moveLabel = function(a, e) {
                var h = this, f = h.label, k = h.axis, p = k.reversed, r = !1;
                f && f.textStr === a ? (h.movedLabel = f, r = !0, delete h.label) : c(k.ticks, function(b) {
                    r || b.isNew || b === h || !b.label || b.label.textStr !== a || (h.movedLabel = b.label, r = !0, b.labelPos = h.movedLabel.xy, delete b.label);
                });
                if (!r && (h.labelPos || f)) {
                    var l = h.labelPos || f.xy;
                    f = k.horiz ? p ? 0 : k.width + k.left : l.x;
                    k = k.horiz ? l.y : p ? k.width + k.left : 0;
                    h.movedLabel = h.createLabel({
                        x: f,
                        y: k
                    }, a, e);
                    h.movedLabel && h.movedLabel.attr({
                        opacity: 0
                    });
                }
            };
            f.prototype.render = function(a, c, e) {
                var f = this.axis, k = f.horiz, p = this.pos, r = h(this.tickmarkOffset, f.tickmarkOffset);
                p = this.getPosition(k, p, r, c);
                r = p.x;
                var l = p.y;
                f = k && r === f.pos + f.len || !k && l === f.pos ? -1 : 1;
                k = h(e, this.label && this.label.newOpacity, 1);
                e = h(e, 1);
                this.isActive = !0;
                this.renderGridLine(c, e, f);
                this.renderMark(p, e, f);
                this.renderLabel(p, c, k, a);
                this.isNew = !1;
                n(this, "afterRender");
            };
            f.prototype.renderGridLine = function(a, c, e) {
                var f = this.axis, k = f.options, p = {}, r = this.pos, l = this.type, b = h(this.tickmarkOffset, f.tickmarkOffset), g = f.chart.renderer, d = this.gridLine, m = k.gridLineWidth, D = k.gridLineColor, x = k.gridLineDashStyle;
                "minor" === this.type && (m = k.minorGridLineWidth, D = k.minorGridLineColor, x = k.minorGridLineDashStyle);
                d || (f.chart.styledMode || (p.stroke = D, p["stroke-width"] = m || 0, p.dashstyle = x), l || (p.zIndex = 1), a && (c = 0), this.gridLine = d = g.path().attr(p).addClass("highcharts-" + (l ? l + "-" : "") + "grid-line").add(f.gridGroup));
                if (d && (e = f.getPlotLinePath({
                    value: r + b,
                    lineWidth: d.strokeWidth() * e,
                    force: "pass",
                    old: a
                }))) d[a || this.isNew ? "attr" : "animate"]({
                    d: e,
                    opacity: c
                });
            };
            f.prototype.renderMark = function(a, c, e) {
                var f = this.axis, k = f.options, p = f.chart.renderer, r = this.type, l = f.tickSize(r ? r + "Tick" : "tick"), b = a.x;
                a = a.y;
                var g = h(k["minor" !== r ? "tickWidth" : "minorTickWidth"], !r && f.isXAxis ? 1 : 0);
                k = k["minor" !== r ? "tickColor" : "minorTickColor"];
                var d = this.mark, m = !d;
                l && (f.opposite && (l[0] = -l[0]), d || (this.mark = d = p.path().addClass("highcharts-" + (r ? r + "-" : "") + "tick").add(f.axisGroup), f.chart.styledMode || d.attr({
                    stroke: k,
                    "stroke-width": g
                })), d[m ? "attr" : "animate"]({
                    d: this.getMarkPath(b, a, l[0], d.strokeWidth() * e, f.horiz, p),
                    opacity: c
                }));
            };
            f.prototype.renderLabel = function(a, c, e, f) {
                var p = this.axis, n = p.horiz, r = p.options, l = this.label, b = r.labels, g = b.step;
                p = h(this.tickmarkOffset, p.tickmarkOffset);
                var d = a.x;
                a = a.y;
                var m = !0;
                l && k(d) && (l.xy = a = this.getLabelPosition(d, a, l, n, b, p, f, g), this.isFirst && !this.isLast && !r.showFirstLabel || this.isLast && !this.isFirst && !r.showLastLabel ? m = !1 : !n || b.step || b.rotation || c || 0 === e || this.handleOverflow(a), g && f % g && (m = !1), m && k(a.y) ? (a.opacity = e, l[this.isNewLabel ? "attr" : "animate"](a), this.isNewLabel = !1) : (l.attr("y", -9999), this.isNewLabel = !0));
            };
            f.prototype.replaceMovedLabel = function() {
                var a = this.label, c = this.axis, e = c.reversed;
                if (a && !this.isNew) {
                    var f = c.horiz ? e ? c.left : c.width + c.left : a.xy.x;
                    e = c.horiz ? a.xy.y : e ? c.width + c.top : c.top;
                    a.animate({
                        x: f,
                        y: e,
                        opacity: 0
                    }, void 0, a.destroy);
                    delete this.label;
                }
                c.isDirty = !0;
                this.label = this.movedLabel;
                delete this.movedLabel;
            };
            return f;
        }();
        "";
        return u;
    });
    M(a, "Core/Axis/Axis.js", [
        a["Core/Animation/AnimationUtilities.js"],
        a["Core/Axis/AxisDefaults.js"],
        a["Core/Color/Color.js"],
        a["Core/DefaultOptions.js"],
        a["Core/Foundation.js"],
        a["Core/Globals.js"],
        a["Core/Axis/Tick.js"],
        a["Core/Utilities.js"]
    ], function(a, u, z, F, y, G, H, A) {
        var q = a.animObject, n = F.defaultOptions, k = y.registerEventOptions, e = G.deg2rad, c = A.arrayMax, h = A.arrayMin, f = A.clamp, w = A.correctFloat, p = A.defined, B = A.destroyObjectProperties, t = A.erase, J = A.error, C = A.extend, r = A.fireEvent, l = A.getMagnitude, b = A.isArray, g = A.isNumber, d = A.isString, m = A.merge, D = A.normalizeTickInterval, x = A.objectEach, I = A.pick, P = A.relativeLength, v = A.removeEvent, O = A.splat, U = A.syncTimeout;
        a = function() {
            function a(b, d) {
                this.zoomEnabled = this.width = this.visible = this.userOptions = this.translationSlope = this.transB = this.transA = this.top = this.ticks = this.tickRotCorr = this.tickPositions = this.tickmarkOffset = this.tickInterval = this.tickAmount = this.side = this.series = this.right = this.positiveValuesOnly = this.pos = this.pointRangePadding = this.pointRange = this.plotLinesAndBandsGroups = this.plotLinesAndBands = this.paddedTicks = this.overlap = this.options = this.offset = this.names = this.minPixelPadding = this.minorTicks = this.minorTickInterval = this.min = this.maxLabelLength = this.max = this.len = this.left = this.labelFormatter = this.labelEdge = this.isLinked = this.height = this.hasVisibleSeries = this.hasNames = this.eventOptions = this.coll = this.closestPointRange = this.chart = this.categories = this.bottom = this.alternateBands = void 0;
                this.init(b, d);
            }
            a.prototype.init = function(b, d) {
                var a = d.isX;
                this.chart = b;
                this.horiz = b.inverted && !this.isZAxis ? !a : a;
                this.isXAxis = a;
                this.coll = this.coll || (a ? "xAxis" : "yAxis");
                r(this, "init", {
                    userOptions: d
                });
                this.opposite = I(d.opposite, this.opposite);
                this.side = I(d.side, this.side, this.horiz ? this.opposite ? 0 : 2 : this.opposite ? 1 : 3);
                this.setOptions(d);
                var c = this.options, e = c.labels, m = c.type;
                this.userOptions = d;
                this.minPixelPadding = 0;
                this.reversed = I(c.reversed, this.reversed);
                this.visible = c.visible;
                this.zoomEnabled = c.zoomEnabled;
                this.hasNames = "category" === m || !0 === c.categories;
                this.categories = c.categories || this.hasNames;
                this.names || (this.names = [], this.names.keys = {});
                this.plotLinesAndBandsGroups = {};
                this.positiveValuesOnly = !!this.logarithmic;
                this.isLinked = p(c.linkedTo);
                this.ticks = {};
                this.labelEdge = [];
                this.minorTicks = {};
                this.plotLinesAndBands = [];
                this.alternateBands = {};
                this.len = 0;
                this.minRange = this.userMinRange = c.minRange || c.maxZoom;
                this.range = c.range;
                this.offset = c.offset || 0;
                this.min = this.max = null;
                d = I(c.crosshair, O(b.options.tooltip.crosshairs)[a ? 0 : 1]);
                this.crosshair = !0 === d ? {} : d;
                -1 === b.axes.indexOf(this) && (a ? b.axes.splice(b.xAxis.length, 0, this) : b.axes.push(this), b[this.coll].push(this));
                this.series = this.series || [];
                b.inverted && !this.isZAxis && a && "undefined" === typeof this.reversed && (this.reversed = !0);
                this.labelRotation = g(e.rotation) ? e.rotation : void 0;
                k(this, c);
                r(this, "afterInit");
            };
            a.prototype.setOptions = function(b) {
                this.options = m(u.defaultXAxisOptions, "yAxis" === this.coll && u.defaultYAxisOptions, [
                    u.defaultTopAxisOptions,
                    u.defaultRightAxisOptions,
                    u.defaultBottomAxisOptions,
                    u.defaultLeftAxisOptions
                ][this.side], m(n[this.coll], b));
                r(this, "afterSetOptions", {
                    userOptions: b
                });
            };
            a.prototype.defaultLabelFormatter = function(b) {
                var d = this.axis;
                b = this.chart.numberFormatter;
                var a = g(this.value) ? this.value : NaN, c = d.chart.time, e = this.dateTimeLabelFormat, m = n.lang, l = m.numericSymbols;
                m = m.numericSymbolMagnitude || 1E3;
                var f = d.logarithmic ? Math.abs(a) : d.tickInterval, h = l && l.length;
                if (d.categories) var r = "" + this.value;
                else if (e) r = c.dateFormat(e, a);
                else if (h && 1E3 <= f) for(; h-- && "undefined" === typeof r;)d = Math.pow(m, h + 1), f >= d && 0 === 10 * a % d && null !== l[h] && 0 !== a && (r = b(a / d, -1) + l[h]);
                "undefined" === typeof r && (r = 1E4 <= Math.abs(a) ? b(a, -1) : b(a, -1, void 0, ""));
                return r;
            };
            a.prototype.getSeriesExtremes = function() {
                var b = this, d = b.chart, a;
                r(this, "getSeriesExtremes", null, function() {
                    b.hasVisibleSeries = !1;
                    b.dataMin = b.dataMax = b.threshold = null;
                    b.softThreshold = !b.isXAxis;
                    b.stacking && b.stacking.buildStacks();
                    b.series.forEach(function(c) {
                        if (c.visible || !d.options.chart.ignoreHiddenSeries) {
                            var e = c.options, m = e.threshold;
                            b.hasVisibleSeries = !0;
                            b.positiveValuesOnly && 0 >= m && (m = null);
                            if (b.isXAxis) {
                                if (e = c.xData, e.length) {
                                    e = b.logarithmic ? e.filter(b.validatePositiveValue) : e;
                                    a = c.getXExtremes(e);
                                    var l = a.min;
                                    var f = a.max;
                                    g(l) || l instanceof Date || (e = e.filter(g), a = c.getXExtremes(e), l = a.min, f = a.max);
                                    e.length && (b.dataMin = Math.min(I(b.dataMin, l), l), b.dataMax = Math.max(I(b.dataMax, f), f));
                                }
                            } else if (c = c.applyExtremes(), g(c.dataMin) && (l = c.dataMin, b.dataMin = Math.min(I(b.dataMin, l), l)), g(c.dataMax) && (f = c.dataMax, b.dataMax = Math.max(I(b.dataMax, f), f)), p(m) && (b.threshold = m), !e.softThreshold || b.positiveValuesOnly) b.softThreshold = !1;
                        }
                    });
                });
                r(this, "afterGetSeriesExtremes");
            };
            a.prototype.translate = function(b, d, a, c, e, m) {
                var l = this.linkedParent || this, f = c && l.old ? l.old.min : l.min, r = l.minPixelPadding;
                e = (l.isOrdinal || l.brokenAxis && l.brokenAxis.hasBreaks || l.logarithmic && e) && l.lin2val;
                var h = 1, k = 0;
                c = c && l.old ? l.old.transA : l.transA;
                c || (c = l.transA);
                a && (h *= -1, k = l.len);
                l.reversed && (h *= -1, k -= h * (l.sector || l.len));
                d ? (b = (b * h + k - r) / c + f, e && (b = l.lin2val(b))) : (e && (b = l.val2lin(b)), b = g(f) ? h * (b - f) * c + k + h * r + (g(m) ? c * m : 0) : void 0);
                return b;
            };
            a.prototype.toPixels = function(b, d) {
                return this.translate(b, !1, !this.horiz, null, !0) + (d ? 0 : this.pos);
            };
            a.prototype.toValue = function(b, d) {
                return this.translate(b - (d ? 0 : this.pos), !0, !this.horiz, null, !0);
            };
            a.prototype.getPlotLinePath = function(b) {
                function d(b, d, a) {
                    if ("pass" !== n && b < d || b > a) n ? b = f(b, d, a) : B = !0;
                    return b;
                }
                var a = this, c = a.chart, e = a.left, m = a.top, l = b.old, h = b.value, k = b.lineWidth, x = l && c.oldChartHeight || c.chartHeight, D = l && c.oldChartWidth || c.chartWidth, L = a.transB, p = b.translatedValue, n = b.force, t, C, w, q, B;
                b = {
                    value: h,
                    lineWidth: k,
                    old: l,
                    force: n,
                    acrossPanes: b.acrossPanes,
                    translatedValue: p
                };
                r(this, "getPlotLinePath", b, function(b) {
                    p = I(p, a.translate(h, null, null, l));
                    p = f(p, -100000, 1E5);
                    t = w = Math.round(p + L);
                    C = q = Math.round(x - p - L);
                    g(p) ? a.horiz ? (C = m, q = x - a.bottom, t = w = d(t, e, e + a.width)) : (t = e, w = D - a.right, C = q = d(C, m, m + a.height)) : (B = !0, n = !1);
                    b.path = B && !n ? null : c.renderer.crispLine([
                        [
                            "M",
                            t,
                            C
                        ],
                        [
                            "L",
                            w,
                            q
                        ]
                    ], k || 1);
                });
                return b.path;
            };
            a.prototype.getLinearTickPositions = function(b, d, a) {
                var c = w(Math.floor(d / b) * b);
                a = w(Math.ceil(a / b) * b);
                var e = [], g;
                w(c + b) === c && (g = 20);
                if (this.single) return [
                    d
                ];
                for(d = c; d <= a;){
                    e.push(d);
                    d = w(d + b, g);
                    if (d === m) break;
                    var m = d;
                }
                return e;
            };
            a.prototype.getMinorTickInterval = function() {
                var b = this.options;
                return !0 === b.minorTicks ? I(b.minorTickInterval, "auto") : !1 === b.minorTicks ? null : b.minorTickInterval;
            };
            a.prototype.getMinorTickPositions = function() {
                var b = this.options, d = this.tickPositions, a = this.minorTickInterval, c = this.pointRangePadding || 0, e = this.min - c;
                c = this.max + c;
                var g = c - e, m = [];
                if (g && g / a < this.len / 3) {
                    var l = this.logarithmic;
                    if (l) this.paddedTicks.forEach(function(b, d, c) {
                        d && m.push.apply(m, l.getLogTickPositions(a, c[d - 1], c[d], !0));
                    });
                    else if (this.dateTime && "auto" === this.getMinorTickInterval()) m = m.concat(this.getTimeTicks(this.dateTime.normalizeTimeTickInterval(a), e, c, b.startOfWeek));
                    else for(b = e + (d[0] - e) % a; b <= c && b !== m[0]; b += a)m.push(b);
                }
                0 !== m.length && this.trimTicks(m);
                return m;
            };
            a.prototype.adjustForMinRange = function() {
                var b = this.options, d = this.logarithmic, a = this.min, e = this.max, g = 0, m, l, f, r;
                this.isXAxis && "undefined" === typeof this.minRange && !d && (p(b.min) || p(b.max) || p(b.floor) || p(b.ceiling) ? this.minRange = null : (this.series.forEach(function(b) {
                    f = b.xData;
                    r = b.xIncrement ? 1 : f.length - 1;
                    if (1 < f.length) {
                        for(m = r; 0 < m; m--)if (l = f[m] - f[m - 1], !g || l < g) g = l;
                    }
                }), this.minRange = Math.min(5 * g, this.dataMax - this.dataMin)));
                if (e - a < this.minRange) {
                    var k = this.dataMax - this.dataMin >= this.minRange;
                    var x = this.minRange;
                    var D = (x - e + a) / 2;
                    D = [
                        a - D,
                        I(b.min, a - D)
                    ];
                    k && (D[2] = this.logarithmic ? this.logarithmic.log2lin(this.dataMin) : this.dataMin);
                    a = c(D);
                    e = [
                        a + x,
                        I(b.max, a + x)
                    ];
                    k && (e[2] = d ? d.log2lin(this.dataMax) : this.dataMax);
                    e = h(e);
                    e - a < x && (D[0] = e - x, D[1] = I(b.min, e - x), a = c(D));
                }
                this.min = a;
                this.max = e;
            };
            a.prototype.getClosest = function() {
                var b;
                this.categories ? b = 1 : this.series.forEach(function(d) {
                    var a = d.closestPointRange, c = d.visible || !d.chart.options.chart.ignoreHiddenSeries;
                    !d.noSharedTooltip && p(a) && c && (b = p(b) ? Math.min(b, a) : a);
                });
                return b;
            };
            a.prototype.nameToX = function(d) {
                var a = b(this.categories), c = a ? this.categories : this.names, e = d.options.x;
                d.series.requireSorting = !1;
                p(e) || (e = this.options.uniqueNames ? a ? c.indexOf(d.name) : I(c.keys[d.name], -1) : d.series.autoIncrement());
                if (-1 === e) {
                    if (!a) var g = c.length;
                } else g = e;
                "undefined" !== typeof g && (this.names[g] = d.name, this.names.keys[d.name] = g);
                return g;
            };
            a.prototype.updateNames = function() {
                var b = this, d = this.names;
                0 < d.length && (Object.keys(d.keys).forEach(function(b) {
                    delete d.keys[b];
                }), d.length = 0, this.minRange = this.userMinRange, (this.series || []).forEach(function(d) {
                    d.xIncrement = null;
                    if (!d.points || d.isDirtyData) b.max = Math.max(b.max, d.xData.length - 1), d.processData(), d.generatePoints();
                    d.data.forEach(function(a, c) {
                        if (a && a.options && "undefined" !== typeof a.name) {
                            var e = b.nameToX(a);
                            "undefined" !== typeof e && e !== a.x && (a.x = e, d.xData[c] = e);
                        }
                    });
                }));
            };
            a.prototype.setAxisTranslation = function() {
                var b = this, a = b.max - b.min, c = b.linkedParent, e = !!b.categories, g = b.isXAxis, m = b.axisPointRange || 0, l = 0, f = 0, h = b.transA;
                if (g || e || m) {
                    var k = b.getClosest();
                    c ? (l = c.minPointOffset, f = c.pointRangePadding) : b.series.forEach(function(a) {
                        var c = e ? 1 : g ? I(a.options.pointRange, k, 0) : b.axisPointRange || 0, h = a.options.pointPlacement;
                        m = Math.max(m, c);
                        if (!b.single || e) a = a.is("xrange") ? !g : g, l = Math.max(l, a && d(h) ? 0 : c / 2), f = Math.max(f, a && "on" === h ? 0 : c);
                    });
                    c = b.ordinal && b.ordinal.slope && k ? b.ordinal.slope / k : 1;
                    b.minPointOffset = l *= c;
                    b.pointRangePadding = f *= c;
                    b.pointRange = Math.min(m, b.single && e ? 1 : a);
                    g && (b.closestPointRange = k);
                }
                b.translationSlope = b.transA = h = b.staticScale || b.len / (a + f || 1);
                b.transB = b.horiz ? b.left : b.bottom;
                b.minPixelPadding = h * l;
                r(this, "afterSetAxisTranslation");
            };
            a.prototype.minFromRange = function() {
                return this.max - this.range;
            };
            a.prototype.setTickInterval = function(b) {
                var d = this.chart, a = this.logarithmic, c = this.options, e = this.isXAxis, m = this.isLinked, f = c.tickPixelInterval, h = this.categories, k = this.softThreshold, x = c.maxPadding, L = c.minPadding, n = g(c.tickInterval) && 0 <= c.tickInterval ? c.tickInterval : void 0, t = g(this.threshold) ? this.threshold : null;
                this.dateTime || h || m || this.getTickAmount();
                var C = I(this.userMin, c.min);
                var q = I(this.userMax, c.max);
                if (m) {
                    this.linkedParent = d[this.coll][c.linkedTo];
                    var B = this.linkedParent.getExtremes();
                    this.min = I(B.min, B.dataMin);
                    this.max = I(B.max, B.dataMax);
                    c.type !== this.linkedParent.options.type && J(11, 1, d);
                } else {
                    if (k && p(t)) {
                        if (this.dataMin >= t) B = t, L = 0;
                        else if (this.dataMax <= t) {
                            var P = t;
                            x = 0;
                        }
                    }
                    this.min = I(C, B, this.dataMin);
                    this.max = I(q, P, this.dataMax);
                }
                a && (this.positiveValuesOnly && !b && 0 >= Math.min(this.min, I(this.dataMin, this.min)) && J(10, 1, d), this.min = w(a.log2lin(this.min), 16), this.max = w(a.log2lin(this.max), 16));
                this.range && p(this.max) && (this.userMin = this.min = C = Math.max(this.dataMin, this.minFromRange()), this.userMax = q = this.max, this.range = null);
                r(this, "foundExtremes");
                this.beforePadding && this.beforePadding();
                this.adjustForMinRange();
                !(h || this.axisPointRange || this.stacking && this.stacking.usePercentage || m) && p(this.min) && p(this.max) && (d = this.max - this.min) && (!p(C) && L && (this.min -= d * L), !p(q) && x && (this.max += d * x));
                g(this.userMin) || (g(c.softMin) && c.softMin < this.min && (this.min = C = c.softMin), g(c.floor) && (this.min = Math.max(this.min, c.floor)));
                g(this.userMax) || (g(c.softMax) && c.softMax > this.max && (this.max = q = c.softMax), g(c.ceiling) && (this.max = Math.min(this.max, c.ceiling)));
                k && p(this.dataMin) && (t = t || 0, !p(C) && this.min < t && this.dataMin >= t ? this.min = this.options.minRange ? Math.min(t, this.max - this.minRange) : t : !p(q) && this.max > t && this.dataMax <= t && (this.max = this.options.minRange ? Math.max(t, this.min + this.minRange) : t));
                g(this.min) && g(this.max) && !this.chart.polar && this.min > this.max && (p(this.options.min) ? this.max = this.min : p(this.options.max) && (this.min = this.max));
                this.tickInterval = this.min === this.max || "undefined" === typeof this.min || "undefined" === typeof this.max ? 1 : m && this.linkedParent && !n && f === this.linkedParent.options.tickPixelInterval ? n = this.linkedParent.tickInterval : I(n, this.tickAmount ? (this.max - this.min) / Math.max(this.tickAmount - 1, 1) : void 0, h ? 1 : (this.max - this.min) * f / Math.max(this.len, f));
                if (e && !b) {
                    var v = this.min !== (this.old && this.old.min) || this.max !== (this.old && this.old.max);
                    this.series.forEach(function(b) {
                        b.forceCrop = b.forceCropping && b.forceCropping();
                        b.processData(v);
                    });
                    r(this, "postProcessData", {
                        hasExtemesChanged: v
                    });
                }
                this.setAxisTranslation();
                r(this, "initialAxisTranslation");
                this.pointRange && !n && (this.tickInterval = Math.max(this.pointRange, this.tickInterval));
                b = I(c.minTickInterval, this.dateTime && !this.series.some(function(b) {
                    return b.noSharedTooltip;
                }) ? this.closestPointRange : 0);
                !n && this.tickInterval < b && (this.tickInterval = b);
                this.dateTime || this.logarithmic || n || (this.tickInterval = D(this.tickInterval, void 0, l(this.tickInterval), I(c.allowDecimals, .5 > this.tickInterval || void 0 !== this.tickAmount), !!this.tickAmount));
                this.tickAmount || (this.tickInterval = this.unsquish());
                this.setTickPositions();
            };
            a.prototype.setTickPositions = function() {
                var b = this.options, d = b.tickPositions, a = this.getMinorTickInterval(), c = this.hasVerticalPanning(), e = "colorAxis" === this.coll, g = (e || !c) && b.startOnTick;
                c = (e || !c) && b.endOnTick;
                e = b.tickPositioner;
                this.tickmarkOffset = this.categories && "between" === b.tickmarkPlacement && 1 === this.tickInterval ? .5 : 0;
                this.minorTickInterval = "auto" === a && this.tickInterval ? this.tickInterval / 5 : a;
                this.single = this.min === this.max && p(this.min) && !this.tickAmount && (parseInt(this.min, 10) === this.min || !1 !== b.allowDecimals);
                this.tickPositions = a = d && d.slice();
                !a && (this.ordinal && this.ordinal.positions || !((this.max - this.min) / this.tickInterval > Math.max(2 * this.len, 200)) ? a = this.dateTime ? this.getTimeTicks(this.dateTime.normalizeTimeTickInterval(this.tickInterval, b.units), this.min, this.max, b.startOfWeek, this.ordinal && this.ordinal.positions, this.closestPointRange, !0) : this.logarithmic ? this.logarithmic.getLogTickPositions(this.tickInterval, this.min, this.max) : this.getLinearTickPositions(this.tickInterval, this.min, this.max) : (a = [
                    this.min,
                    this.max
                ], J(19, !1, this.chart)), a.length > this.len && (a = [
                    a[0],
                    a.pop()
                ], a[0] === a[1] && (a.length = 1)), this.tickPositions = a, e && (e = e.apply(this, [
                    this.min,
                    this.max
                ]))) && (this.tickPositions = a = e);
                this.paddedTicks = a.slice(0);
                this.trimTicks(a, g, c);
                this.isLinked || (this.single && 2 > a.length && !this.categories && !this.series.some(function(b) {
                    return b.is("heatmap") && "between" === b.options.pointPlacement;
                }) && (this.min -= .5, this.max += .5), d || e || this.adjustTickAmount());
                r(this, "afterSetTickPositions");
            };
            a.prototype.trimTicks = function(b, d, a) {
                var c = b[0], e = b[b.length - 1], g = !this.isOrdinal && this.minPointOffset || 0;
                r(this, "trimTicks");
                if (!this.isLinked) {
                    if (d && -Infinity !== c) this.min = c;
                    else for(; this.min - g > b[0];)b.shift();
                    if (a) this.max = e;
                    else for(; this.max + g < b[b.length - 1];)b.pop();
                    0 === b.length && p(c) && !this.options.tickPositions && b.push((e + c) / 2);
                }
            };
            a.prototype.alignToOthers = function() {
                var b = {}, d = this.options, a;
                !1 !== this.chart.options.chart.alignTicks && d.alignTicks && !1 !== d.startOnTick && !1 !== d.endOnTick && !this.logarithmic && this.chart[this.coll].forEach(function(d) {
                    var c = d.options;
                    c = [
                        d.horiz ? c.left : c.top,
                        c.width,
                        c.height,
                        c.pane
                    ].join();
                    d.series.length && (b[c] ? a = !0 : b[c] = 1);
                });
                return a;
            };
            a.prototype.getTickAmount = function() {
                var b = this.options, d = b.tickPixelInterval, a = b.tickAmount;
                !p(b.tickInterval) && !a && this.len < d && !this.isRadial && !this.logarithmic && b.startOnTick && b.endOnTick && (a = 2);
                !a && this.alignToOthers() && (a = Math.ceil(this.len / d) + 1);
                4 > a && (this.finalTickAmt = a, a = 5);
                this.tickAmount = a;
            };
            a.prototype.adjustTickAmount = function() {
                var b = this.options, d = this.tickInterval, a = this.tickPositions, c = this.tickAmount, e = this.finalTickAmt, m = a && a.length, l = I(this.threshold, this.softThreshold ? 0 : null);
                if (this.hasData() && g(this.min) && g(this.max)) {
                    if (m < c) {
                        for(; a.length < c;)a.length % 2 || this.min === l ? a.push(w(a[a.length - 1] + d)) : a.unshift(w(a[0] - d));
                        this.transA *= (m - 1) / (c - 1);
                        this.min = b.startOnTick ? a[0] : Math.min(this.min, a[0]);
                        this.max = b.endOnTick ? a[a.length - 1] : Math.max(this.max, a[a.length - 1]);
                    } else m > c && (this.tickInterval *= 2, this.setTickPositions());
                    if (p(e)) {
                        for(d = b = a.length; d--;)(3 === e && 1 === d % 2 || 2 >= e && 0 < d && d < b - 1) && a.splice(d, 1);
                        this.finalTickAmt = void 0;
                    }
                }
            };
            a.prototype.setScale = function() {
                var b = !1, d = !1;
                this.series.forEach(function(a) {
                    b = b || a.isDirtyData || a.isDirty;
                    d = d || a.xAxis && a.xAxis.isDirty || !1;
                });
                this.setAxisSize();
                var a = this.len !== (this.old && this.old.len);
                a || b || d || this.isLinked || this.forceRedraw || this.userMin !== (this.old && this.old.userMin) || this.userMax !== (this.old && this.old.userMax) || this.alignToOthers() ? (this.stacking && this.stacking.resetStacks(), this.forceRedraw = !1, this.getSeriesExtremes(), this.setTickInterval(), this.isDirty || (this.isDirty = a || this.min !== (this.old && this.old.min) || this.max !== (this.old && this.old.max))) : this.stacking && this.stacking.cleanStacks();
                b && this.panningState && (this.panningState.isDirty = !0);
                r(this, "afterSetScale");
            };
            a.prototype.setExtremes = function(b, d, a, c, e) {
                var g = this, m = g.chart;
                a = I(a, !0);
                g.series.forEach(function(b) {
                    delete b.kdTree;
                });
                e = C(e, {
                    min: b,
                    max: d
                });
                r(g, "setExtremes", e, function() {
                    g.userMin = b;
                    g.userMax = d;
                    g.eventArgs = e;
                    a && m.redraw(c);
                });
            };
            a.prototype.zoom = function(b, d) {
                var a = this, c = this.dataMin, e = this.dataMax, g = this.options, m = Math.min(c, I(g.min, c)), l = Math.max(e, I(g.max, e));
                b = {
                    newMin: b,
                    newMax: d
                };
                r(this, "zoom", b, function(b) {
                    var d = b.newMin, g = b.newMax;
                    if (d !== a.min || g !== a.max) a.allowZoomOutside || (p(c) && (d < m && (d = m), d > l && (d = l)), p(e) && (g < m && (g = m), g > l && (g = l))), a.displayBtn = "undefined" !== typeof d || "undefined" !== typeof g, a.setExtremes(d, g, !1, void 0, {
                        trigger: "zoom"
                    });
                    b.zoomed = !0;
                });
                return b.zoomed;
            };
            a.prototype.setAxisSize = function() {
                var b = this.chart, d = this.options, a = d.offsets || [
                    0,
                    0,
                    0,
                    0
                ], c = this.horiz, e = this.width = Math.round(P(I(d.width, b.plotWidth - a[3] + a[1]), b.plotWidth)), g = this.height = Math.round(P(I(d.height, b.plotHeight - a[0] + a[2]), b.plotHeight)), m = this.top = Math.round(P(I(d.top, b.plotTop + a[0]), b.plotHeight, b.plotTop));
                d = this.left = Math.round(P(I(d.left, b.plotLeft + a[3]), b.plotWidth, b.plotLeft));
                this.bottom = b.chartHeight - g - m;
                this.right = b.chartWidth - e - d;
                this.len = Math.max(c ? e : g, 0);
                this.pos = c ? d : m;
            };
            a.prototype.getExtremes = function() {
                var b = this.logarithmic;
                return {
                    min: b ? w(b.lin2log(this.min)) : this.min,
                    max: b ? w(b.lin2log(this.max)) : this.max,
                    dataMin: this.dataMin,
                    dataMax: this.dataMax,
                    userMin: this.userMin,
                    userMax: this.userMax
                };
            };
            a.prototype.getThreshold = function(b) {
                var d = this.logarithmic, a = d ? d.lin2log(this.min) : this.min;
                d = d ? d.lin2log(this.max) : this.max;
                null === b || -Infinity === b ? b = a : Infinity === b ? b = d : a > b ? b = a : d < b && (b = d);
                return this.translate(b, 0, 1, 0, 1);
            };
            a.prototype.autoLabelAlign = function(b) {
                var d = (I(b, 0) - 90 * this.side + 720) % 360;
                b = {
                    align: "center"
                };
                r(this, "autoLabelAlign", b, function(b) {
                    15 < d && 165 > d ? b.align = "right" : 195 < d && 345 > d && (b.align = "left");
                });
                return b.align;
            };
            a.prototype.tickSize = function(b) {
                var d = this.options, a = I(d["tick" === b ? "tickWidth" : "minorTickWidth"], "tick" === b && this.isXAxis && !this.categories ? 1 : 0), c = d["tick" === b ? "tickLength" : "minorTickLength"];
                if (a && c) {
                    "inside" === d[b + "Position"] && (c = -c);
                    var e = [
                        c,
                        a
                    ];
                }
                b = {
                    tickSize: e
                };
                r(this, "afterTickSize", b);
                return b.tickSize;
            };
            a.prototype.labelMetrics = function() {
                var b = this.tickPositions && this.tickPositions[0] || 0;
                return this.chart.renderer.fontMetrics(this.options.labels.style.fontSize, this.ticks[b] && this.ticks[b].label);
            };
            a.prototype.unsquish = function() {
                var b = this.options.labels, d = this.horiz, a = this.tickInterval, c = this.len / (((this.categories ? 1 : 0) + this.max - this.min) / a), m = b.rotation, l = this.labelMetrics(), f = Math.max(this.max - this.min, 0), h = function(b) {
                    var d = b / (c || 1);
                    d = 1 < d ? Math.ceil(d) : 1;
                    d * a > f && Infinity !== b && Infinity !== c && f && (d = Math.ceil(f / a));
                    return w(d * a);
                }, r = a, k, x, D = Number.MAX_VALUE;
                if (d) {
                    if (!b.staggerLines && !b.step) {
                        if (g(m)) var p = [
                            m
                        ];
                        else c < b.autoRotationLimit && (p = b.autoRotation);
                    }
                    p && p.forEach(function(b) {
                        if (b === m || b && -90 <= b && 90 >= b) {
                            x = h(Math.abs(l.h / Math.sin(e * b)));
                            var d = x + Math.abs(b / 360);
                            d < D && (D = d, k = b, r = x);
                        }
                    });
                } else b.step || (r = h(l.h));
                this.autoRotation = p;
                this.labelRotation = I(k, g(m) ? m : 0);
                return r;
            };
            a.prototype.getSlotWidth = function(b) {
                var d = this.chart, a = this.horiz, c = this.options.labels, e = Math.max(this.tickPositions.length - (this.categories ? 0 : 1), 1), m = d.margin[3];
                if (b && g(b.slotWidth)) return b.slotWidth;
                if (a && 2 > c.step) return c.rotation ? 0 : (this.staggerLines || 1) * this.len / e;
                if (!a) {
                    b = c.style.width;
                    if (void 0 !== b) return parseInt(String(b), 10);
                    if (m) return m - d.spacing[3];
                }
                return .33 * d.chartWidth;
            };
            a.prototype.renderUnsquish = function() {
                var b = this.chart, a = b.renderer, c = this.tickPositions, e = this.ticks, g = this.options.labels, m = g.style, l = this.horiz, f = this.getSlotWidth(), h = Math.max(1, Math.round(f - 2 * g.padding)), r = {}, k = this.labelMetrics(), x = m.textOverflow, D = 0;
                d(g.rotation) || (r.rotation = g.rotation || 0);
                c.forEach(function(b) {
                    b = e[b];
                    b.movedLabel && b.replaceMovedLabel();
                    b && b.label && b.label.textPxLength > D && (D = b.label.textPxLength);
                });
                this.maxLabelLength = D;
                if (this.autoRotation) D > h && D > k.h ? r.rotation = this.labelRotation : this.labelRotation = 0;
                else if (f) {
                    var p = h;
                    if (!x) {
                        var n = "clip";
                        for(h = c.length; !l && h--;){
                            var I = c[h];
                            if (I = e[I].label) I.styles && "ellipsis" === I.styles.textOverflow ? I.css({
                                textOverflow: "clip"
                            }) : I.textPxLength > f && I.css({
                                width: f + "px"
                            }), I.getBBox().height > this.len / c.length - (k.h - k.f) && (I.specificTextOverflow = "ellipsis");
                        }
                    }
                }
                r.rotation && (p = D > .5 * b.chartHeight ? .33 * b.chartHeight : D, x || (n = "ellipsis"));
                if (this.labelAlign = g.align || this.autoLabelAlign(this.labelRotation)) r.align = this.labelAlign;
                c.forEach(function(b) {
                    var d = (b = e[b]) && b.label, a = m.width, c = {};
                    d && (d.attr(r), b.shortenLabel ? b.shortenLabel() : p && !a && "nowrap" !== m.whiteSpace && (p < d.textPxLength || "SPAN" === d.element.tagName) ? (c.width = p + "px", x || (c.textOverflow = d.specificTextOverflow || n), d.css(c)) : d.styles && d.styles.width && !c.width && !a && d.css({
                        width: null
                    }), delete d.specificTextOverflow, b.rotation = r.rotation);
                }, this);
                this.tickRotCorr = a.rotCorr(k.b, this.labelRotation || 0, 0 !== this.side);
            };
            a.prototype.hasData = function() {
                return this.series.some(function(b) {
                    return b.hasData();
                }) || this.options.showEmpty && p(this.min) && p(this.max);
            };
            a.prototype.addTitle = function(b) {
                var d = this.chart.renderer, a = this.horiz, c = this.opposite, e = this.options.title, g = this.chart.styledMode, l;
                this.axisTitle || ((l = e.textAlign) || (l = (a ? {
                    low: "left",
                    middle: "center",
                    high: "right"
                } : {
                    low: c ? "right" : "left",
                    middle: "center",
                    high: c ? "left" : "right"
                })[e.align]), this.axisTitle = d.text(e.text || "", 0, 0, e.useHTML).attr({
                    zIndex: 7,
                    rotation: e.rotation,
                    align: l
                }).addClass("highcharts-axis-title"), g || this.axisTitle.css(m(e.style)), this.axisTitle.add(this.axisGroup), this.axisTitle.isNew = !0);
                g || e.style.width || this.isRadial || this.axisTitle.css({
                    width: this.len + "px"
                });
                this.axisTitle[b ? "show" : "hide"](b);
            };
            a.prototype.generateTick = function(b) {
                var d = this.ticks;
                d[b] ? d[b].addLabel() : d[b] = new H(this, b);
            };
            a.prototype.getOffset = function() {
                var b = this, d = this, a = d.chart, c = d.horiz, e = d.options, g = d.side, m = d.ticks, l = d.tickPositions, f = d.coll, h = d.axisParent, k = a.renderer, D = a.inverted && !d.isZAxis ? [
                    1,
                    0,
                    3,
                    2
                ][g] : g, n = d.hasData(), t = e.title, C = e.labels, q = a.axisOffset;
                a = a.clipOffset;
                var w = [
                    -1,
                    1,
                    1,
                    -1
                ][g], B = e.className, P, J = 0, ja = 0, ca = 0;
                d.showAxis = P = n || e.showEmpty;
                d.staggerLines = d.horiz && C.staggerLines || void 0;
                if (!d.axisGroup) {
                    var v = function(d, a, c) {
                        return k.g(d).attr({
                            zIndex: c
                        }).addClass("highcharts-" + f.toLowerCase() + a + " " + (b.isRadial ? "highcharts-radial-axis" + a + " " : "") + (B || "")).add(h);
                    };
                    d.gridGroup = v("grid", "-grid", e.gridZIndex);
                    d.axisGroup = v("axis", "", e.zIndex);
                    d.labelGroup = v("axis-labels", "-labels", C.zIndex);
                }
                n || d.isLinked ? (l.forEach(function(b) {
                    d.generateTick(b);
                }), d.renderUnsquish(), d.reserveSpaceDefault = 0 === g || 2 === g || ({
                    1: "left",
                    3: "right"
                })[g] === d.labelAlign, I(C.reserveSpace, "center" === d.labelAlign ? !0 : null, d.reserveSpaceDefault) && l.forEach(function(b) {
                    ca = Math.max(m[b].getLabelSize(), ca);
                }), d.staggerLines && (ca *= d.staggerLines), d.labelOffset = ca * (d.opposite ? -1 : 1)) : x(m, function(b, d) {
                    b.destroy();
                    delete m[d];
                });
                if (t && t.text && !1 !== t.enabled && (d.addTitle(P), P && !1 !== t.reserveSpace)) {
                    d.titleOffset = J = d.axisTitle.getBBox()[c ? "height" : "width"];
                    var O = t.offset;
                    ja = p(O) ? 0 : I(t.margin, c ? 5 : 10);
                }
                d.renderLine();
                d.offset = w * I(e.offset, q[g] ? q[g] + (e.margin || 0) : 0);
                d.tickRotCorr = d.tickRotCorr || {
                    x: 0,
                    y: 0
                };
                t = 0 === g ? -d.labelMetrics().h : 2 === g ? d.tickRotCorr.y : 0;
                n = Math.abs(ca) + ja;
                ca && (n = n - t + w * (c ? I(C.y, d.tickRotCorr.y + 8 * w) : C.x));
                d.axisTitleMargin = I(O, n);
                d.getMaxLabelDimensions && (d.maxLabelDimensions = d.getMaxLabelDimensions(m, l));
                "colorAxis" !== f && (c = this.tickSize("tick"), q[g] = Math.max(q[g], (d.axisTitleMargin || 0) + J + w * d.offset, n, l && l.length && c ? c[0] + w * d.offset : 0), e = !d.axisLine || e.offset ? 0 : 2 * Math.floor(d.axisLine.strokeWidth() / 2), a[D] = Math.max(a[D], e));
                r(this, "afterGetOffset");
            };
            a.prototype.getLinePath = function(b) {
                var d = this.chart, a = this.opposite, c = this.offset, e = this.horiz, g = this.left + (a ? this.width : 0) + c;
                c = d.chartHeight - this.bottom - (a ? this.height : 0) + c;
                a && (b *= -1);
                return d.renderer.crispLine([
                    [
                        "M",
                        e ? this.left : g,
                        e ? c : this.top
                    ],
                    [
                        "L",
                        e ? d.chartWidth - this.right : g,
                        e ? c : d.chartHeight - this.bottom
                    ]
                ], b);
            };
            a.prototype.renderLine = function() {
                this.axisLine || (this.axisLine = this.chart.renderer.path().addClass("highcharts-axis-line").add(this.axisGroup), this.chart.styledMode || this.axisLine.attr({
                    stroke: this.options.lineColor,
                    "stroke-width": this.options.lineWidth,
                    zIndex: 7
                }));
            };
            a.prototype.getTitlePosition = function() {
                var b = this.horiz, d = this.left, a = this.top, c = this.len, e = this.options.title, g = b ? d : a, m = this.opposite, l = this.offset, f = e.x, h = e.y, k = this.axisTitle, x = this.chart.renderer.fontMetrics(e.style.fontSize, k);
                k = Math.max(k.getBBox(null, 0).height - x.h - 1, 0);
                c = ({
                    low: g + (b ? 0 : c),
                    middle: g + c / 2,
                    high: g + (b ? c : 0)
                })[e.align];
                d = (b ? a + this.height : d) + (b ? 1 : -1) * (m ? -1 : 1) * this.axisTitleMargin + [
                    -k,
                    k,
                    x.f,
                    -k
                ][this.side];
                b = {
                    x: b ? c + f : d + (m ? this.width : 0) + l + f,
                    y: b ? d + h - (m ? this.height : 0) + l : c + h
                };
                r(this, "afterGetTitlePosition", {
                    titlePosition: b
                });
                return b;
            };
            a.prototype.renderMinorTick = function(b, d) {
                var a = this.minorTicks;
                a[b] || (a[b] = new H(this, b, "minor"));
                d && a[b].isNew && a[b].render(null, !0);
                a[b].render(null, !1, 1);
            };
            a.prototype.renderTick = function(b, d, a) {
                var c = this.ticks;
                if (!this.isLinked || b >= this.min && b <= this.max || this.grid && this.grid.isColumn) c[b] || (c[b] = new H(this, b)), a && c[b].isNew && c[b].render(d, !0, -1), c[b].render(d);
            };
            a.prototype.render = function() {
                var b = this, d = b.chart, a = b.logarithmic, c = b.options, e = b.isLinked, m = b.tickPositions, l = b.axisTitle, f = b.ticks, h = b.minorTicks, k = b.alternateBands, D = c.stackLabels, p = c.alternateGridColor, n = b.tickmarkOffset, I = b.axisLine, t = b.showAxis, C = q(d.renderer.globalAnimation), w, B;
                b.labelEdge.length = 0;
                b.overlap = !1;
                [
                    f,
                    h,
                    k
                ].forEach(function(b) {
                    x(b, function(b) {
                        b.isActive = !1;
                    });
                });
                if (b.hasData() || e) {
                    var P = b.chart.hasRendered && b.old && g(b.old.min);
                    b.minorTickInterval && !b.categories && b.getMinorTickPositions().forEach(function(d) {
                        b.renderMinorTick(d, P);
                    });
                    m.length && (m.forEach(function(d, a) {
                        b.renderTick(d, a, P);
                    }), n && (0 === b.min || b.single) && (f[-1] || (f[-1] = new H(b, -1, null, !0)), f[-1].render(-1)));
                    p && m.forEach(function(c, e) {
                        B = "undefined" !== typeof m[e + 1] ? m[e + 1] + n : b.max - n;
                        0 === e % 2 && c < b.max && B <= b.max + (d.polar ? -n : n) && (k[c] || (k[c] = new G.PlotLineOrBand(b)), w = c + n, k[c].options = {
                            from: a ? a.lin2log(w) : w,
                            to: a ? a.lin2log(B) : B,
                            color: p,
                            className: "highcharts-alternate-grid"
                        }, k[c].render(), k[c].isActive = !0);
                    });
                    b._addedPlotLB || (b._addedPlotLB = !0, (c.plotLines || []).concat(c.plotBands || []).forEach(function(d) {
                        b.addPlotBandOrLine(d);
                    }));
                }
                [
                    f,
                    h,
                    k
                ].forEach(function(b) {
                    var a = [], c = C.duration;
                    x(b, function(b, d) {
                        b.isActive || (b.render(d, !1, 0), b.isActive = !1, a.push(d));
                    });
                    U(function() {
                        for(var d = a.length; d--;)b[a[d]] && !b[a[d]].isActive && (b[a[d]].destroy(), delete b[a[d]]);
                    }, b !== k && d.hasRendered && c ? c : 0);
                });
                I && (I[I.isPlaced ? "animate" : "attr"]({
                    d: this.getLinePath(I.strokeWidth())
                }), I.isPlaced = !0, I[t ? "show" : "hide"](t));
                l && t && (c = b.getTitlePosition(), g(c.y) ? (l[l.isNew ? "attr" : "animate"](c), l.isNew = !1) : (l.attr("y", -9999), l.isNew = !0));
                D && D.enabled && b.stacking && b.stacking.renderStackTotals();
                b.old = {
                    len: b.len,
                    max: b.max,
                    min: b.min,
                    transA: b.transA,
                    userMax: b.userMax,
                    userMin: b.userMin
                };
                b.isDirty = !1;
                r(this, "afterRender");
            };
            a.prototype.redraw = function() {
                this.visible && (this.render(), this.plotLinesAndBands.forEach(function(b) {
                    b.render();
                }));
                this.series.forEach(function(b) {
                    b.isDirty = !0;
                });
            };
            a.prototype.getKeepProps = function() {
                return this.keepProps || a.keepProps;
            };
            a.prototype.destroy = function(b) {
                var d = this, a = d.plotLinesAndBands, c = this.eventOptions;
                r(this, "destroy", {
                    keepEvents: b
                });
                b || v(d);
                [
                    d.ticks,
                    d.minorTicks,
                    d.alternateBands
                ].forEach(function(b) {
                    B(b);
                });
                if (a) for(b = a.length; b--;)a[b].destroy();
                "axisLine axisTitle axisGroup gridGroup labelGroup cross scrollbar".split(" ").forEach(function(b) {
                    d[b] && (d[b] = d[b].destroy());
                });
                for(var e in d.plotLinesAndBandsGroups)d.plotLinesAndBandsGroups[e] = d.plotLinesAndBandsGroups[e].destroy();
                x(d, function(b, a) {
                    -1 === d.getKeepProps().indexOf(a) && delete d[a];
                });
                this.eventOptions = c;
            };
            a.prototype.drawCrosshair = function(b, d) {
                var a = this.crosshair, c = I(a && a.snap, !0), e = this.chart, g, m = this.cross;
                r(this, "drawCrosshair", {
                    e: b,
                    point: d
                });
                b || (b = this.cross && this.cross.e);
                if (a && !1 !== (p(d) || !c)) {
                    c ? p(d) && (g = I("colorAxis" !== this.coll ? d.crosshairPos : null, this.isXAxis ? d.plotX : this.len - d.plotY)) : g = b && (this.horiz ? b.chartX - this.pos : this.len - b.chartY + this.pos);
                    if (p(g)) {
                        var l = {
                            value: d && (this.isXAxis ? d.x : I(d.stackY, d.y)),
                            translatedValue: g
                        };
                        e.polar && C(l, {
                            isCrosshair: !0,
                            chartX: b && b.chartX,
                            chartY: b && b.chartY,
                            point: d
                        });
                        l = this.getPlotLinePath(l) || null;
                    }
                    if (!p(l)) {
                        this.hideCrosshair();
                        return;
                    }
                    c = this.categories && !this.isRadial;
                    m || (this.cross = m = e.renderer.path().addClass("highcharts-crosshair highcharts-crosshair-" + (c ? "category " : "thin ") + (a.className || "")).attr({
                        zIndex: I(a.zIndex, 2)
                    }).add(), e.styledMode || (m.attr({
                        stroke: a.color || (c ? z.parse("#ccd6eb").setOpacity(.25).get() : "#cccccc"),
                        "stroke-width": I(a.width, 1)
                    }).css({
                        "pointer-events": "none"
                    }), a.dashStyle && m.attr({
                        dashstyle: a.dashStyle
                    })));
                    m.show().attr({
                        d: l
                    });
                    c && !a.width && m.attr({
                        "stroke-width": this.transA
                    });
                    this.cross.e = b;
                } else this.hideCrosshair();
                r(this, "afterDrawCrosshair", {
                    e: b,
                    point: d
                });
            };
            a.prototype.hideCrosshair = function() {
                this.cross && this.cross.hide();
                r(this, "afterHideCrosshair");
            };
            a.prototype.hasVerticalPanning = function() {
                var b = this.chart.options.chart.panning;
                return !!(b && b.enabled && /y/.test(b.type));
            };
            a.prototype.validatePositiveValue = function(b) {
                return g(b) && 0 < b;
            };
            a.prototype.update = function(b, d) {
                var a = this.chart;
                b = m(this.userOptions, b);
                this.destroy(!0);
                this.init(a, b);
                a.isDirtyBox = !0;
                I(d, !0) && a.redraw();
            };
            a.prototype.remove = function(b) {
                for(var d = this.chart, a = this.coll, c = this.series, e = c.length; e--;)c[e] && c[e].remove(!1);
                t(d.axes, this);
                t(d[a], this);
                d[a].forEach(function(b, d) {
                    b.options.index = b.userOptions.index = d;
                });
                this.destroy();
                d.isDirtyBox = !0;
                I(b, !0) && d.redraw();
            };
            a.prototype.setTitle = function(b, d) {
                this.update({
                    title: b
                }, d);
            };
            a.prototype.setCategories = function(b, d) {
                this.update({
                    categories: b
                }, d);
            };
            a.defaultOptions = u.defaultXAxisOptions;
            a.keepProps = "extKey hcEvents names series userMax userMin".split(" ");
            return a;
        }();
        "";
        return a;
    });
    M(a, "Core/Axis/DateTimeAxis.js", [
        a["Core/Utilities.js"]
    ], function(a) {
        var v = a.addEvent, z = a.getMagnitude, F = a.normalizeTickInterval, y = a.timeUnits, G;
        (function(a) {
            function u() {
                return this.chart.time.getTimeTicks.apply(this.chart.time, arguments);
            }
            function q(a) {
                "datetime" !== a.userOptions.type ? this.dateTime = void 0 : this.dateTime || (this.dateTime = new k(this));
            }
            var n = [];
            a.compose = function(a) {
                -1 === n.indexOf(a) && (n.push(a), a.keepProps.push("dateTime"), a.prototype.getTimeTicks = u, v(a, "init", q));
                return a;
            };
            var k = function() {
                function a(a) {
                    this.axis = a;
                }
                a.prototype.normalizeTimeTickInterval = function(a, e) {
                    var c = e || [
                        [
                            "millisecond",
                            [
                                1,
                                2,
                                5,
                                10,
                                20,
                                25,
                                50,
                                100,
                                200,
                                500
                            ]
                        ],
                        [
                            "second",
                            [
                                1,
                                2,
                                5,
                                10,
                                15,
                                30
                            ]
                        ],
                        [
                            "minute",
                            [
                                1,
                                2,
                                5,
                                10,
                                15,
                                30
                            ]
                        ],
                        [
                            "hour",
                            [
                                1,
                                2,
                                3,
                                4,
                                6,
                                8,
                                12
                            ]
                        ],
                        [
                            "day",
                            [
                                1,
                                2
                            ]
                        ],
                        [
                            "week",
                            [
                                1,
                                2
                            ]
                        ],
                        [
                            "month",
                            [
                                1,
                                2,
                                3,
                                4,
                                6
                            ]
                        ],
                        [
                            "year",
                            null
                        ]
                    ];
                    e = c[c.length - 1];
                    var h = y[e[0]], k = e[1], n;
                    for(n = 0; n < c.length && !(e = c[n], h = y[e[0]], k = e[1], c[n + 1] && a <= (h * k[k.length - 1] + y[c[n + 1][0]]) / 2); n++);
                    h === y.year && a < 5 * h && (k = [
                        1,
                        2,
                        5
                    ]);
                    a = F(a / h, k, "year" === e[0] ? Math.max(z(a / h), 1) : 1);
                    return {
                        unitRange: h,
                        count: a,
                        unitName: e[0]
                    };
                };
                a.prototype.getXDateFormat = function(a, e) {
                    var c = this.axis;
                    return c.closestPointRange ? c.chart.time.getDateFormat(c.closestPointRange, a, c.options.startOfWeek, e) || e.year : e.day;
                };
                return a;
            }();
            a.Additions = k;
        })(G || (G = {}));
        return G;
    });
    M(a, "Core/Axis/LogarithmicAxis.js", [
        a["Core/Utilities.js"]
    ], function(a) {
        var v = a.addEvent, z = a.getMagnitude, F = a.normalizeTickInterval, y = a.pick, G;
        (function(a) {
            function u(a) {
                var c = this.logarithmic;
                "logarithmic" !== a.userOptions.type ? this.logarithmic = void 0 : c || (this.logarithmic = new k(this));
            }
            function q() {
                var a = this.logarithmic;
                a && (this.lin2val = function(c) {
                    return a.lin2log(c);
                }, this.val2lin = function(c) {
                    return a.log2lin(c);
                });
            }
            var n = [];
            a.compose = function(a) {
                -1 === n.indexOf(a) && (n.push(a), a.keepProps.push("logarithmic"), v(a, "init", u), v(a, "afterInit", q));
                return a;
            };
            var k = function() {
                function a(a) {
                    this.axis = a;
                }
                a.prototype.getLogTickPositions = function(a, e, f, k) {
                    var c = this.axis, h = c.len, n = c.options, q = [];
                    k || (this.minorAutoInterval = void 0);
                    if (.5 <= a) a = Math.round(a), q = c.getLinearTickPositions(a, e, f);
                    else if (.08 <= a) {
                        var C = Math.floor(e), r, l = n = void 0;
                        for(h = .3 < a ? [
                            1,
                            2,
                            4
                        ] : .15 < a ? [
                            1,
                            2,
                            4,
                            6,
                            8
                        ] : [
                            1,
                            2,
                            3,
                            4,
                            5,
                            6,
                            7,
                            8,
                            9
                        ]; C < f + 1 && !l; C++){
                            var b = h.length;
                            for(r = 0; r < b && !l; r++){
                                var g = this.log2lin(this.lin2log(C) * h[r]);
                                g > e && (!k || n <= f) && "undefined" !== typeof n && q.push(n);
                                n > f && (l = !0);
                                n = g;
                            }
                        }
                    } else e = this.lin2log(e), f = this.lin2log(f), a = k ? c.getMinorTickInterval() : n.tickInterval, a = y("auto" === a ? null : a, this.minorAutoInterval, n.tickPixelInterval / (k ? 5 : 1) * (f - e) / ((k ? h / c.tickPositions.length : h) || 1)), a = F(a, void 0, z(a)), q = c.getLinearTickPositions(a, e, f).map(this.log2lin), k || (this.minorAutoInterval = a / 5);
                    k || (c.tickInterval = a);
                    return q;
                };
                a.prototype.lin2log = function(a) {
                    return Math.pow(10, a);
                };
                a.prototype.log2lin = function(a) {
                    return Math.log(a) / Math.LN10;
                };
                return a;
            }();
            a.Additions = k;
        })(G || (G = {}));
        return G;
    });
    M(a, "Core/Axis/PlotLineOrBand/PlotLineOrBandAxis.js", [
        a["Core/Utilities.js"]
    ], function(a) {
        var v = a.erase, z = a.extend, F = a.isNumber, y;
        (function(a) {
            var u = [], A;
            a.compose = function(a, k) {
                A || (A = a);
                -1 === u.indexOf(k) && (u.push(k), z(k.prototype, q.prototype));
                return k;
            };
            var q = function() {
                function a() {}
                a.prototype.getPlotBandPath = function(a, e, c) {
                    void 0 === c && (c = this.options);
                    var h = this.getPlotLinePath({
                        value: e,
                        force: !0,
                        acrossPanes: c.acrossPanes
                    }), f = [], k = this.horiz;
                    e = !F(this.min) || !F(this.max) || a < this.min && e < this.min || a > this.max && e > this.max;
                    a = this.getPlotLinePath({
                        value: a,
                        force: !0,
                        acrossPanes: c.acrossPanes
                    });
                    c = 1;
                    if (a && h) {
                        if (e) {
                            var p = a.toString() === h.toString();
                            c = 0;
                        }
                        for(e = 0; e < a.length; e += 2){
                            var n = a[e], t = a[e + 1], q = h[e], C = h[e + 1];
                            "M" !== n[0] && "L" !== n[0] || "M" !== t[0] && "L" !== t[0] || "M" !== q[0] && "L" !== q[0] || "M" !== C[0] && "L" !== C[0] || (k && q[1] === n[1] ? (q[1] += c, C[1] += c) : k || q[2] !== n[2] || (q[2] += c, C[2] += c), f.push([
                                "M",
                                n[1],
                                n[2]
                            ], [
                                "L",
                                t[1],
                                t[2]
                            ], [
                                "L",
                                C[1],
                                C[2]
                            ], [
                                "L",
                                q[1],
                                q[2]
                            ], [
                                "Z"
                            ]));
                            f.isFlat = p;
                        }
                    }
                    return f;
                };
                a.prototype.addPlotBand = function(a) {
                    return this.addPlotBandOrLine(a, "plotBands");
                };
                a.prototype.addPlotLine = function(a) {
                    return this.addPlotBandOrLine(a, "plotLines");
                };
                a.prototype.addPlotBandOrLine = function(a, e) {
                    var c = this, h = this.userOptions, f = new A(this, a);
                    this.visible && (f = f.render());
                    if (f) {
                        this._addedPlotLB || (this._addedPlotLB = !0, (h.plotLines || []).concat(h.plotBands || []).forEach(function(a) {
                            c.addPlotBandOrLine(a);
                        }));
                        if (e) {
                            var k = h[e] || [];
                            k.push(a);
                            h[e] = k;
                        }
                        this.plotLinesAndBands.push(f);
                    }
                    return f;
                };
                a.prototype.removePlotBandOrLine = function(a) {
                    var e = this.plotLinesAndBands, c = this.options, h = this.userOptions;
                    if (e) {
                        for(var f = e.length; f--;)e[f].id === a && e[f].destroy();
                        [
                            c.plotLines || [],
                            h.plotLines || [],
                            c.plotBands || [],
                            h.plotBands || []
                        ].forEach(function(c) {
                            for(f = c.length; f--;)(c[f] || {}).id === a && v(c, c[f]);
                        });
                    }
                };
                a.prototype.removePlotBand = function(a) {
                    this.removePlotBandOrLine(a);
                };
                a.prototype.removePlotLine = function(a) {
                    this.removePlotBandOrLine(a);
                };
                return a;
            }();
        })(y || (y = {}));
        return y;
    });
    M(a, "Core/Axis/PlotLineOrBand/PlotLineOrBand.js", [
        a["Core/Axis/PlotLineOrBand/PlotLineOrBandAxis.js"],
        a["Core/Utilities.js"]
    ], function(a, u) {
        var v = u.arrayMax, F = u.arrayMin, y = u.defined, G = u.destroyObjectProperties, H = u.erase, A = u.fireEvent, q = u.merge, n = u.objectEach, k = u.pick;
        u = function() {
            function e(a, e) {
                this.axis = a;
                e && (this.options = e, this.id = e.id);
            }
            e.compose = function(c) {
                return a.compose(e, c);
            };
            e.prototype.render = function() {
                A(this, "render");
                var a = this, e = a.axis, f = e.horiz, w = e.logarithmic, p = a.options, B = p.color, t = k(p.zIndex, 0), v = p.events, C = {}, r = e.chart.renderer, l = p.label, b = a.label, g = p.to, d = p.from, m = p.value, D = a.svgElem, x = [], I = y(d) && y(g);
                x = y(m);
                var P = !D, S = {
                    "class": "highcharts-plot-" + (I ? "band " : "line ") + (p.className || "")
                }, O = I ? "bands" : "lines";
                w && (d = w.log2lin(d), g = w.log2lin(g), m = w.log2lin(m));
                e.chart.styledMode || (x ? (S.stroke = B || "#999999", S["stroke-width"] = k(p.width, 1), p.dashStyle && (S.dashstyle = p.dashStyle)) : I && (S.fill = B || "#e6ebf5", p.borderWidth && (S.stroke = p.borderColor, S["stroke-width"] = p.borderWidth)));
                C.zIndex = t;
                O += "-" + t;
                (w = e.plotLinesAndBandsGroups[O]) || (e.plotLinesAndBandsGroups[O] = w = r.g("plot-" + O).attr(C).add());
                P && (a.svgElem = D = r.path().attr(S).add(w));
                if (x) x = e.getPlotLinePath({
                    value: m,
                    lineWidth: D.strokeWidth(),
                    acrossPanes: p.acrossPanes
                });
                else if (I) x = e.getPlotBandPath(d, g, p);
                else return;
                !a.eventsAdded && v && (n(v, function(b, d) {
                    D.on(d, function(b) {
                        v[d].apply(a, [
                            b
                        ]);
                    });
                }), a.eventsAdded = !0);
                (P || !D.d) && x && x.length ? D.attr({
                    d: x
                }) : D && (x ? (D.show(!0), D.animate({
                    d: x
                })) : D.d && (D.hide(), b && (a.label = b = b.destroy())));
                l && (y(l.text) || y(l.formatter)) && x && x.length && 0 < e.width && 0 < e.height && !x.isFlat ? (l = q({
                    align: f && I && "center",
                    x: f ? !I && 4 : 10,
                    verticalAlign: !f && I && "middle",
                    y: f ? I ? 16 : 10 : I ? 6 : -4,
                    rotation: f && !I && 90
                }, l), this.renderLabel(l, x, I, t)) : b && b.hide();
                return a;
            };
            e.prototype.renderLabel = function(a, e, f, k) {
                var c = this.axis, h = c.chart.renderer, n = this.label;
                n || (this.label = n = h.text(this.getLabelText(a), 0, 0, a.useHTML).attr({
                    align: a.textAlign || a.align,
                    rotation: a.rotation,
                    "class": "highcharts-plot-" + (f ? "band" : "line") + "-label " + (a.className || ""),
                    zIndex: k
                }).add(), c.chart.styledMode || n.css(q({
                    textOverflow: "ellipsis"
                }, a.style)));
                k = e.xBounds || [
                    e[0][1],
                    e[1][1],
                    f ? e[2][1] : e[0][1]
                ];
                e = e.yBounds || [
                    e[0][2],
                    e[1][2],
                    f ? e[2][2] : e[0][2]
                ];
                f = F(k);
                h = F(e);
                n.align(a, !1, {
                    x: f,
                    y: h,
                    width: v(k) - f,
                    height: v(e) - h
                });
                n.alignValue && "left" !== n.alignValue || n.css({
                    width: (90 === n.rotation ? c.height - (n.alignAttr.y - c.top) : c.width - (n.alignAttr.x - c.left)) + "px"
                });
                n.show(!0);
            };
            e.prototype.getLabelText = function(a) {
                return y(a.formatter) ? a.formatter.call(this) : a.text;
            };
            e.prototype.destroy = function() {
                H(this.axis.plotLinesAndBands, this);
                delete this.axis;
                G(this);
            };
            return e;
        }();
        "";
        "";
        return u;
    });
    M(a, "Core/Tooltip.js", [
        a["Core/FormatUtilities.js"],
        a["Core/Globals.js"],
        a["Core/Renderer/RendererUtilities.js"],
        a["Core/Renderer/RendererRegistry.js"],
        a["Core/Utilities.js"]
    ], function(a, u, z, F, y) {
        var v = a.format, H = u.doc, A = z.distribute, q = y.addEvent, n = y.clamp, k = y.css, e = y.defined, c = y.discardElement, h = y.extend, f = y.fireEvent, w = y.isArray, p = y.isNumber, B = y.isString, t = y.merge, J = y.pick, C = y.splat, r = y.syncTimeout;
        a = function() {
            function a(b, a) {
                this.allowShared = !0;
                this.container = void 0;
                this.crosshairs = [];
                this.distance = 0;
                this.isHidden = !0;
                this.isSticky = !1;
                this.now = {};
                this.options = {};
                this.outside = !1;
                this.chart = b;
                this.init(b, a);
            }
            a.prototype.applyFilter = function() {
                var b = this.chart;
                b.renderer.definition({
                    tagName: "filter",
                    attributes: {
                        id: "drop-shadow-" + b.index,
                        opacity: .5
                    },
                    children: [
                        {
                            tagName: "feGaussianBlur",
                            attributes: {
                                "in": "SourceAlpha",
                                stdDeviation: 1
                            }
                        },
                        {
                            tagName: "feOffset",
                            attributes: {
                                dx: 1,
                                dy: 1
                            }
                        },
                        {
                            tagName: "feComponentTransfer",
                            children: [
                                {
                                    tagName: "feFuncA",
                                    attributes: {
                                        type: "linear",
                                        slope: .3
                                    }
                                }
                            ]
                        },
                        {
                            tagName: "feMerge",
                            children: [
                                {
                                    tagName: "feMergeNode"
                                },
                                {
                                    tagName: "feMergeNode",
                                    attributes: {
                                        "in": "SourceGraphic"
                                    }
                                }
                            ]
                        }
                    ]
                });
            };
            a.prototype.bodyFormatter = function(b) {
                return b.map(function(b) {
                    var a = b.series.tooltipOptions;
                    return (a[(b.point.formatPrefix || "point") + "Formatter"] || b.point.tooltipFormatter).call(b.point, a[(b.point.formatPrefix || "point") + "Format"] || "");
                });
            };
            a.prototype.cleanSplit = function(b) {
                this.chart.series.forEach(function(a) {
                    var d = a && a.tt;
                    d && (!d.isActive || b ? a.tt = d.destroy() : d.isActive = !1);
                });
            };
            a.prototype.defaultFormatter = function(b) {
                var a = this.points || C(this);
                var d = [
                    b.tooltipFooterHeaderFormatter(a[0])
                ];
                d = d.concat(b.bodyFormatter(a));
                d.push(b.tooltipFooterHeaderFormatter(a[0], !0));
                return d;
            };
            a.prototype.destroy = function() {
                this.label && (this.label = this.label.destroy());
                this.split && this.tt && (this.cleanSplit(!0), this.tt = this.tt.destroy());
                this.renderer && (this.renderer = this.renderer.destroy(), c(this.container));
                y.clearTimeout(this.hideTimer);
                y.clearTimeout(this.tooltipTimeout);
            };
            a.prototype.getAnchor = function(b, a) {
                var d = this.chart, c = d.pointer, e = d.inverted, g = d.plotTop, l = d.plotLeft, f, r, h = 0, k = 0;
                b = C(b);
                this.followPointer && a ? ("undefined" === typeof a.chartX && (a = c.normalize(a)), c = [
                    a.chartX - l,
                    a.chartY - g
                ]) : b[0].tooltipPos ? c = b[0].tooltipPos : (b.forEach(function(b) {
                    f = b.series.yAxis;
                    r = b.series.xAxis;
                    h += b.plotX || 0;
                    k += b.plotLow ? (b.plotLow + (b.plotHigh || 0)) / 2 : b.plotY || 0;
                    r && f && (e ? (h += g + d.plotHeight - r.len - r.pos, k += l + d.plotWidth - f.len - f.pos) : (h += r.pos - l, k += f.pos - g));
                }), h /= b.length, k /= b.length, c = [
                    e ? d.plotWidth - k : h,
                    e ? d.plotHeight - h : k
                ], this.shared && 1 < b.length && a && (e ? c[0] = a.chartX - l : c[1] = a.chartY - g));
                return c.map(Math.round);
            };
            a.prototype.getLabel = function() {
                var b = this, a = this.chart.styledMode, d = this.options, c = this.split && this.allowShared, l = "tooltip" + (e(d.className) ? " " + d.className : ""), f = d.style.pointerEvents || (!this.followPointer && d.stickOnContact ? "auto" : "none"), r = function() {
                    b.inContact = !0;
                }, h = function(a) {
                    var d = b.chart.hoverSeries;
                    b.inContact = b.shouldStickOnContact() && b.chart.pointer.inClass(a.relatedTarget, "highcharts-tooltip");
                    if (!b.inContact && d && d.onMouseOut) d.onMouseOut();
                }, p, n = this.chart.renderer;
                if (b.label) {
                    var t = !b.label.hasClass("highcharts-label");
                    (c && !t || !c && t) && b.destroy();
                }
                if (!this.label) {
                    if (this.outside) {
                        t = this.chart.options.chart.style;
                        var C = F.getRendererType();
                        this.container = p = u.doc.createElement("div");
                        p.className = "highcharts-tooltip-container";
                        k(p, {
                            position: "absolute",
                            top: "1px",
                            pointerEvents: f,
                            zIndex: Math.max(this.options.style.zIndex || 0, (t && t.zIndex || 0) + 3)
                        });
                        q(p, "mouseenter", r);
                        q(p, "mouseleave", h);
                        u.doc.body.appendChild(p);
                        this.renderer = n = new C(p, 0, 0, t, void 0, void 0, n.styledMode);
                    }
                    c ? this.label = n.g(l) : (this.label = n.label("", 0, 0, d.shape, void 0, void 0, d.useHTML, void 0, l).attr({
                        padding: d.padding,
                        r: d.borderRadius
                    }), a || this.label.attr({
                        fill: d.backgroundColor,
                        "stroke-width": d.borderWidth
                    }).css(d.style).css({
                        pointerEvents: f
                    }).shadow(d.shadow));
                    a && d.shadow && (this.applyFilter(), this.label.attr({
                        filter: "url(#drop-shadow-" + this.chart.index + ")"
                    }));
                    if (b.outside && !b.split) {
                        var B = this.label, w = B.xSetter, v = B.ySetter;
                        B.xSetter = function(a) {
                            w.call(B, b.distance);
                            p.style.left = a + "px";
                        };
                        B.ySetter = function(a) {
                            v.call(B, b.distance);
                            p.style.top = a + "px";
                        };
                    }
                    this.label.on("mouseenter", r).on("mouseleave", h).attr({
                        zIndex: 8
                    }).add();
                }
                return this.label;
            };
            a.prototype.getPosition = function(b, a, d) {
                var c = this.chart, e = this.distance, g = {}, l = c.inverted && d.h || 0, f = this.outside, r = f ? H.documentElement.clientWidth - 2 * e : c.chartWidth, h = f ? Math.max(H.body.scrollHeight, H.documentElement.scrollHeight, H.body.offsetHeight, H.documentElement.offsetHeight, H.documentElement.clientHeight) : c.chartHeight, k = c.pointer.getChartPosition(), p = function(g) {
                    var m = "x" === g;
                    return [
                        g,
                        m ? r : h,
                        m ? b : a
                    ].concat(f ? [
                        m ? b * k.scaleX : a * k.scaleY,
                        m ? k.left - e + (d.plotX + c.plotLeft) * k.scaleX : k.top - e + (d.plotY + c.plotTop) * k.scaleY,
                        0,
                        m ? r : h
                    ] : [
                        m ? b : a,
                        m ? d.plotX + c.plotLeft : d.plotY + c.plotTop,
                        m ? c.plotLeft : c.plotTop,
                        m ? c.plotLeft + c.plotWidth : c.plotTop + c.plotHeight
                    ]);
                }, n = p("y"), t = p("x"), C;
                p = !!d.negative;
                !c.polar && c.hoverSeries && c.hoverSeries.yAxis && c.hoverSeries.yAxis.reversed && (p = !p);
                var q = !this.followPointer && J(d.ttBelow, !c.inverted === p), B = function(b, a, d, c, m, r, h) {
                    var x = f ? "y" === b ? e * k.scaleY : e * k.scaleX : e, D = (d - c) / 2, p = c < m - e, E = m + e + c < a, n = m - x - d + D;
                    m = m + x - D;
                    if (q && E) g[b] = m;
                    else if (!q && p) g[b] = n;
                    else if (p) g[b] = Math.min(h - c, 0 > n - l ? n : n - l);
                    else if (E) g[b] = Math.max(r, m + l + d > a ? m : m + l);
                    else return !1;
                }, w = function(b, a, d, c, m) {
                    var l;
                    m < e || m > a - e ? l = !1 : g[b] = m < d / 2 ? 1 : m > a - c / 2 ? a - c - 2 : m - d / 2;
                    return l;
                }, E = function(b) {
                    var a = n;
                    n = t;
                    t = a;
                    C = b;
                }, T = function() {
                    !1 !== B.apply(0, n) ? !1 !== w.apply(0, t) || C || (E(!0), T()) : C ? g.x = g.y = 0 : (E(!0), T());
                };
                (c.inverted || 1 < this.len) && E();
                T();
                return g;
            };
            a.prototype.hide = function(b) {
                var a = this;
                y.clearTimeout(this.hideTimer);
                b = J(b, this.options.hideDelay);
                this.isHidden || (this.hideTimer = r(function() {
                    a.getLabel().fadeOut(b ? void 0 : b);
                    a.isHidden = !0;
                }, b));
            };
            a.prototype.init = function(b, a) {
                this.chart = b;
                this.options = a;
                this.crosshairs = [];
                this.now = {
                    x: 0,
                    y: 0
                };
                this.isHidden = !0;
                this.split = a.split && !b.inverted && !b.polar;
                this.shared = a.shared || this.split;
                this.outside = J(a.outside, !(!b.scrollablePixelsX && !b.scrollablePixelsY));
            };
            a.prototype.shouldStickOnContact = function() {
                return !(this.followPointer || !this.options.stickOnContact);
            };
            a.prototype.isStickyOnContact = function() {
                return !(!this.shouldStickOnContact() || !this.inContact);
            };
            a.prototype.move = function(b, a, d, c) {
                var e = this, g = e.now, m = !1 !== e.options.animation && !e.isHidden && (1 < Math.abs(b - g.x) || 1 < Math.abs(a - g.y)), l = e.followPointer || 1 < e.len;
                h(g, {
                    x: m ? (2 * g.x + b) / 3 : b,
                    y: m ? (g.y + a) / 2 : a,
                    anchorX: l ? void 0 : m ? (2 * g.anchorX + d) / 3 : d,
                    anchorY: l ? void 0 : m ? (g.anchorY + c) / 2 : c
                });
                e.getLabel().attr(g);
                e.drawTracker();
                m && (y.clearTimeout(this.tooltipTimeout), this.tooltipTimeout = setTimeout(function() {
                    e && e.move(b, a, d, c);
                }, 32));
            };
            a.prototype.refresh = function(b, a) {
                var d = this.chart, c = this.options, e = C(b), g = e[0], l = [], r = c.formatter || this.defaultFormatter, h = this.shared, k = d.styledMode, p = {};
                if (c.enabled) {
                    y.clearTimeout(this.hideTimer);
                    this.allowShared = !(!w(b) && b.series && b.series.noSharedTooltip);
                    this.followPointer = !this.split && g.series.tooltipOptions.followPointer;
                    b = this.getAnchor(b, a);
                    var n = b[0], t = b[1];
                    h && this.allowShared ? (d.pointer.applyInactiveState(e), e.forEach(function(b) {
                        b.setState("hover");
                        l.push(b.getLabelConfig());
                    }), p = {
                        x: g.category,
                        y: g.y
                    }, p.points = l) : p = g.getLabelConfig();
                    this.len = l.length;
                    r = r.call(p, this);
                    h = g.series;
                    this.distance = J(h.tooltipOptions.distance, 16);
                    if (!1 === r) this.hide();
                    else {
                        if (this.split && this.allowShared) this.renderSplit(r, e);
                        else {
                            var q = n, B = t;
                            a && d.pointer.isDirectTouch && (q = a.chartX - d.plotLeft, B = a.chartY - d.plotTop);
                            if (d.polar || !1 === h.options.clip || e.some(function(b) {
                                return b.series.shouldShowTooltip(q, B);
                            })) a = this.getLabel(), c.style.width && !k || a.css({
                                width: this.chart.spacingBox.width + "px"
                            }), a.attr({
                                text: r && r.join ? r.join("") : r
                            }), a.removeClass(/highcharts-color-[\d]+/g).addClass("highcharts-color-" + J(g.colorIndex, h.colorIndex)), k || a.attr({
                                stroke: c.borderColor || g.color || h.color || "#666666"
                            }), this.updatePosition({
                                plotX: n,
                                plotY: t,
                                negative: g.negative,
                                ttBelow: g.ttBelow,
                                h: b[2] || 0
                            });
                            else {
                                this.hide();
                                return;
                            }
                        }
                        this.isHidden && this.label && this.label.attr({
                            opacity: 1
                        }).show();
                        this.isHidden = !1;
                    }
                    f(this, "refresh");
                }
            };
            a.prototype.renderSplit = function(b, a) {
                function d(b, a, d, e, g) {
                    void 0 === g && (g = !0);
                    d ? (a = X ? 0 : G, b = n(b - e / 2, N.left, N.right - e - (c.outside ? R : 0))) : (a -= z, b = g ? b - e - y : b + y, b = n(b, g ? b : N.left, N.right));
                    return {
                        x: b,
                        y: a
                    };
                }
                var c = this, e = c.chart, g = c.chart, l = g.chartWidth, f = g.chartHeight, r = g.plotHeight, k = g.plotLeft, p = g.plotTop, t = g.pointer, C = g.scrollablePixelsY;
                C = void 0 === C ? 0 : C;
                var q = g.scrollablePixelsX, w = g.scrollingContainer;
                w = void 0 === w ? {
                    scrollLeft: 0,
                    scrollTop: 0
                } : w;
                var v = w.scrollLeft;
                w = w.scrollTop;
                var u = g.styledMode, y = c.distance, E = c.options, T = c.options.positioner, N = c.outside && "number" !== typeof q ? H.documentElement.getBoundingClientRect() : {
                    left: v,
                    right: v + l,
                    top: w,
                    bottom: w + f
                }, V = c.getLabel(), W = this.renderer || e.renderer, X = !(!e.xAxis[0] || !e.xAxis[0].opposite);
                e = t.getChartPosition();
                var R = e.left;
                e = e.top;
                var z = p + w, aa = 0, G = r - C;
                B(b) && (b = [
                    !1,
                    b
                ]);
                b = b.slice(0, a.length + 1).reduce(function(b, e, g) {
                    if (!1 !== e && "" !== e) {
                        g = a[g - 1] || {
                            isHeader: !0,
                            plotX: a[0].plotX,
                            plotY: r,
                            series: {}
                        };
                        var m = g.isHeader, l = m ? c : g.series;
                        e = e.toString();
                        var f = l.tt, h = g.isHeader;
                        var x = g.series;
                        var D = "highcharts-color-" + J(g.colorIndex, x.colorIndex, "none");
                        f || (f = {
                            padding: E.padding,
                            r: E.borderRadius
                        }, u || (f.fill = E.backgroundColor, f["stroke-width"] = E.borderWidth), f = W.label("", 0, 0, E[h ? "headerShape" : "shape"], void 0, void 0, E.useHTML).addClass((h ? "highcharts-tooltip-header " : "") + "highcharts-tooltip-box " + D).attr(f).add(V));
                        f.isActive = !0;
                        f.attr({
                            text: e
                        });
                        u || f.css(E.style).shadow(E.shadow).attr({
                            stroke: E.borderColor || g.color || x.color || "#333333"
                        });
                        l = l.tt = f;
                        h = l.getBBox();
                        e = h.width + l.strokeWidth();
                        m && (aa = h.height, G += aa, X && (z -= aa));
                        x = g.plotX;
                        x = void 0 === x ? 0 : x;
                        D = g.plotY;
                        D = void 0 === D ? 0 : D;
                        f = g.series;
                        if (g.isHeader) {
                            x = k + x;
                            var t = p + r / 2;
                        } else {
                            var I = f.xAxis, C = f.yAxis;
                            x = I.pos + n(x, -y, I.len + y);
                            f.shouldShowTooltip(0, C.pos - p + D, {
                                ignoreX: !0
                            }) && (t = C.pos + D);
                        }
                        x = n(x, N.left - y, N.right + y);
                        "number" === typeof t ? (h = h.height + 1, D = T ? T.call(c, e, h, g) : d(x, t, m, e), b.push({
                            align: T ? 0 : void 0,
                            anchorX: x,
                            anchorY: t,
                            boxWidth: e,
                            point: g,
                            rank: J(D.rank, m ? 1 : 0),
                            size: h,
                            target: D.y,
                            tt: l,
                            x: D.x
                        })) : l.isActive = !1;
                    }
                    return b;
                }, []);
                !T && b.some(function(b) {
                    var a = (c.outside ? R : 0) + b.anchorX;
                    return a < N.left && a + b.boxWidth < N.right ? !0 : a < R - N.left + b.boxWidth && N.right - a > a;
                }) && (b = b.map(function(b) {
                    var a = d(b.anchorX, b.anchorY, b.point.isHeader, b.boxWidth, !1);
                    return h(b, {
                        target: a.y,
                        x: a.x
                    });
                }));
                c.cleanSplit();
                A(b, G);
                var F = R, ba = R;
                b.forEach(function(b) {
                    var a = b.x, d = b.boxWidth;
                    b = b.isHeader;
                    b || (c.outside && R + a < F && (F = R + a), !b && c.outside && F + d > ba && (ba = R + a));
                });
                b.forEach(function(b) {
                    var a = b.x, d = b.anchorX, e = b.pos, g = b.point.isHeader;
                    e = {
                        visibility: "undefined" === typeof e ? "hidden" : "inherit",
                        x: a,
                        y: e + z,
                        anchorX: d,
                        anchorY: b.anchorY
                    };
                    if (c.outside && a < d) {
                        var m = R - F;
                        0 < m && (g || (e.x = a + m, e.anchorX = d + m), g && (e.x = (ba - F) / 2, e.anchorX = d + m));
                    }
                    b.tt.attr(e);
                });
                b = c.container;
                C = c.renderer;
                c.outside && b && C && (g = V.getBBox(), C.setSize(g.width + g.x, g.height + g.y, !1), b.style.left = F + "px", b.style.top = e + "px");
            };
            a.prototype.drawTracker = function() {
                if (this.followPointer || !this.options.stickOnContact) this.tracker && this.tracker.destroy();
                else {
                    var b = this.chart, a = this.label, d = this.shared ? b.hoverPoints : b.hoverPoint;
                    if (a && d) {
                        var c = {
                            x: 0,
                            y: 0,
                            width: 0,
                            height: 0
                        };
                        d = this.getAnchor(d);
                        var e = a.getBBox();
                        d[0] += b.plotLeft - a.translateX;
                        d[1] += b.plotTop - a.translateY;
                        c.x = Math.min(0, d[0]);
                        c.y = Math.min(0, d[1]);
                        c.width = 0 > d[0] ? Math.max(Math.abs(d[0]), e.width - d[0]) : Math.max(Math.abs(d[0]), e.width);
                        c.height = 0 > d[1] ? Math.max(Math.abs(d[1]), e.height - Math.abs(d[1])) : Math.max(Math.abs(d[1]), e.height);
                        this.tracker ? this.tracker.attr(c) : (this.tracker = a.renderer.rect(c).addClass("highcharts-tracker").add(a), b.styledMode || this.tracker.attr({
                            fill: "rgba(0,0,0,0)"
                        }));
                    }
                }
            };
            a.prototype.styledModeFormat = function(b) {
                return b.replace('style="font-size: 10px"', 'class="highcharts-header"').replace(/style="color:{(point|series)\.color}"/g, 'class="highcharts-color-{$1.colorIndex}"');
            };
            a.prototype.tooltipFooterHeaderFormatter = function(b, a) {
                var d = b.series, c = d.tooltipOptions, e = d.xAxis, g = e && e.dateTime;
                e = {
                    isFooter: a,
                    labelConfig: b
                };
                var l = c.xDateFormat, r = c[a ? "footerFormat" : "headerFormat"];
                f(this, "headerFormatter", e, function(a) {
                    g && !l && p(b.key) && (l = g.getXDateFormat(b.key, c.dateTimeLabelFormats));
                    g && l && (b.point && b.point.tooltipDateKeys || [
                        "key"
                    ]).forEach(function(b) {
                        r = r.replace("{point." + b + "}", "{point." + b + ":" + l + "}");
                    });
                    d.chart.styledMode && (r = this.styledModeFormat(r));
                    a.text = v(r, {
                        point: b,
                        series: d
                    }, this.chart);
                });
                return e.text;
            };
            a.prototype.update = function(b) {
                this.destroy();
                t(!0, this.chart.options.tooltip.userOptions, b);
                this.init(this.chart, t(!0, this.options, b));
            };
            a.prototype.updatePosition = function(b) {
                var a = this.chart, d = this.options, c = a.pointer, e = this.getLabel();
                c = c.getChartPosition();
                var l = (d.positioner || this.getPosition).call(this, e.width, e.height, b), f = b.plotX + a.plotLeft;
                b = b.plotY + a.plotTop;
                if (this.outside) {
                    d = d.borderWidth + 2 * this.distance;
                    this.renderer.setSize(e.width + d, e.height + d, !1);
                    if (1 !== c.scaleX || 1 !== c.scaleY) k(this.container, {
                        transform: "scale(" + c.scaleX + ", " + c.scaleY + ")"
                    }), f *= c.scaleX, b *= c.scaleY;
                    f += c.left - l.x;
                    b += c.top - l.y;
                }
                this.move(Math.round(l.x), Math.round(l.y || 0), f, b);
            };
            return a;
        }();
        "";
        return a;
    });
    M(a, "Core/Series/Point.js", [
        a["Core/Renderer/HTML/AST.js"],
        a["Core/Animation/AnimationUtilities.js"],
        a["Core/DefaultOptions.js"],
        a["Core/FormatUtilities.js"],
        a["Core/Utilities.js"]
    ], function(a, u, z, F, y) {
        var v = u.animObject, H = z.defaultOptions, A = F.format, q = y.addEvent, n = y.defined, k = y.erase, e = y.extend, c = y.fireEvent, h = y.getNestedProperty, f = y.isArray, w = y.isFunction, p = y.isNumber, B = y.isObject, t = y.merge, J = y.objectEach, C = y.pick, r = y.syncTimeout, l = y.removeEvent, b = y.uniqueKey;
        u = function() {
            function g() {
                this.colorIndex = this.category = void 0;
                this.formatPrefix = "point";
                this.id = void 0;
                this.isNull = !1;
                this.percentage = this.options = this.name = void 0;
                this.selected = !1;
                this.total = this.series = void 0;
                this.visible = !0;
                this.x = void 0;
            }
            g.prototype.animateBeforeDestroy = function() {
                var b = this, a = {
                    x: b.startXPos,
                    opacity: 0
                }, c = b.getGraphicalProps();
                c.singular.forEach(function(d) {
                    b[d] = b[d].animate("dataLabel" === d ? {
                        x: b[d].startXPos,
                        y: b[d].startYPos,
                        opacity: 0
                    } : a);
                });
                c.plural.forEach(function(a) {
                    b[a].forEach(function(a) {
                        a.element && a.animate(e({
                            x: b.startXPos
                        }, a.startYPos ? {
                            x: a.startXPos,
                            y: a.startYPos
                        } : {}));
                    });
                });
            };
            g.prototype.applyOptions = function(b, a) {
                var d = this.series, c = d.options.pointValKey || d.pointValKey;
                b = g.prototype.optionsToObject.call(this, b);
                e(this, b);
                this.options = this.options ? e(this.options, b) : b;
                b.group && delete this.group;
                b.dataLabels && delete this.dataLabels;
                c && (this.y = g.prototype.getNestedProperty.call(this, c));
                this.formatPrefix = (this.isNull = C(this.isValid && !this.isValid(), null === this.x || !p(this.y))) ? "null" : "point";
                this.selected && (this.state = "select");
                "name" in this && "undefined" === typeof a && d.xAxis && d.xAxis.hasNames && (this.x = d.xAxis.nameToX(this));
                "undefined" === typeof this.x && d ? this.x = "undefined" === typeof a ? d.autoIncrement() : a : p(b.x) && d.options.relativeXValue && (this.x = d.autoIncrement(b.x));
                return this;
            };
            g.prototype.destroy = function() {
                function b() {
                    if (a.graphic || a.dataLabel || a.dataLabels) l(a), a.destroyElements();
                    for(h in a)a[h] = null;
                }
                var a = this, c = a.series, e = c.chart;
                c = c.options.dataSorting;
                var g = e.hoverPoints, f = v(a.series.chart.renderer.globalAnimation), h;
                a.legendItem && e.legend.destroyItem(a);
                g && (a.setState(), k(g, a), g.length || (e.hoverPoints = null));
                if (a === e.hoverPoint) a.onMouseOut();
                c && c.enabled ? (this.animateBeforeDestroy(), r(b, f.duration)) : b();
                e.pointCount--;
            };
            g.prototype.destroyElements = function(b) {
                var a = this;
                b = a.getGraphicalProps(b);
                b.singular.forEach(function(b) {
                    a[b] = a[b].destroy();
                });
                b.plural.forEach(function(b) {
                    a[b].forEach(function(b) {
                        b.element && b.destroy();
                    });
                    delete a[b];
                });
            };
            g.prototype.firePointEvent = function(b, a, e) {
                var d = this, g = this.series.options;
                (g.point.events[b] || d.options && d.options.events && d.options.events[b]) && d.importEvents();
                "click" === b && g.allowPointSelect && (e = function(b) {
                    d.select && d.select(null, b.ctrlKey || b.metaKey || b.shiftKey);
                });
                c(d, b, a, e);
            };
            g.prototype.getClassName = function() {
                return "highcharts-point" + (this.selected ? " highcharts-point-select" : "") + (this.negative ? " highcharts-negative" : "") + (this.isNull ? " highcharts-null-point" : "") + ("undefined" !== typeof this.colorIndex ? " highcharts-color-" + this.colorIndex : "") + (this.options.className ? " " + this.options.className : "") + (this.zone && this.zone.className ? " " + this.zone.className.replace("highcharts-negative", "") : "");
            };
            g.prototype.getGraphicalProps = function(b) {
                var a = this, d = [], c = {
                    singular: [],
                    plural: []
                }, e;
                b = b || {
                    graphic: 1,
                    dataLabel: 1
                };
                b.graphic && d.push("graphic", "upperGraphic", "shadowGroup");
                b.dataLabel && d.push("dataLabel", "dataLabelUpper", "connector");
                for(e = d.length; e--;){
                    var g = d[e];
                    a[g] && c.singular.push(g);
                }
                [
                    "dataLabel",
                    "connector"
                ].forEach(function(d) {
                    var e = d + "s";
                    b[d] && a[e] && c.plural.push(e);
                });
                return c;
            };
            g.prototype.getLabelConfig = function() {
                return {
                    x: this.category,
                    y: this.y,
                    color: this.color,
                    colorIndex: this.colorIndex,
                    key: this.name || this.category,
                    series: this.series,
                    point: this,
                    percentage: this.percentage,
                    total: this.total || this.stackTotal
                };
            };
            g.prototype.getNestedProperty = function(b) {
                if (b) return 0 === b.indexOf("custom.") ? h(b, this.options) : this[b];
            };
            g.prototype.getZone = function() {
                var b = this.series, a = b.zones;
                b = b.zoneAxis || "y";
                var c, e = 0;
                for(c = a[e]; this[b] >= c.value;)c = a[++e];
                this.nonZonedColor || (this.nonZonedColor = this.color);
                this.color = c && c.color && !this.options.color ? c.color : this.nonZonedColor;
                return c;
            };
            g.prototype.hasNewShapeType = function() {
                return (this.graphic && (this.graphic.symbolName || this.graphic.element.nodeName)) !== this.shapeType;
            };
            g.prototype.init = function(a, e, g) {
                this.series = a;
                this.applyOptions(e, g);
                this.id = n(this.id) ? this.id : b();
                this.resolveColor();
                a.chart.pointCount++;
                c(this, "afterInit");
                return this;
            };
            g.prototype.optionsToObject = function(b) {
                var a = this.series, d = a.options.keys, c = d || a.pointArrayMap || [
                    "y"
                ], e = c.length, l = {}, r = 0, h = 0;
                if (p(b) || null === b) l[c[0]] = b;
                else if (f(b)) for(!d && b.length > e && (a = typeof b[0], "string" === a ? l.name = b[0] : "number" === a && (l.x = b[0]), r++); h < e;)d && "undefined" === typeof b[r] || (0 < c[h].indexOf(".") ? g.prototype.setNestedProperty(l, b[r], c[h]) : l[c[h]] = b[r]), r++, h++;
                else "object" === typeof b && (l = b, b.dataLabels && (a._hasPointLabels = !0), b.marker && (a._hasPointMarkers = !0));
                return l;
            };
            g.prototype.resolveColor = function() {
                var b = this.series, a = b.chart.styledMode;
                var c = b.chart.options.chart.colorCount;
                delete this.nonZonedColor;
                if (b.options.colorByPoint) {
                    if (!a) {
                        c = b.options.colors || b.chart.options.colors;
                        var e = c[b.colorCounter];
                        c = c.length;
                    }
                    a = b.colorCounter;
                    b.colorCounter++;
                    b.colorCounter === c && (b.colorCounter = 0);
                } else a || (e = b.color), a = b.colorIndex;
                this.colorIndex = C(this.options.colorIndex, a);
                this.color = C(this.options.color, e);
            };
            g.prototype.setNestedProperty = function(b, a, c) {
                c.split(".").reduce(function(b, d, c, e) {
                    b[d] = e.length - 1 === c ? a : B(b[d], !0) ? b[d] : {};
                    return b[d];
                }, b);
                return b;
            };
            g.prototype.tooltipFormatter = function(b) {
                var a = this.series, d = a.tooltipOptions, c = C(d.valueDecimals, ""), e = d.valuePrefix || "", g = d.valueSuffix || "";
                a.chart.styledMode && (b = a.chart.tooltip.styledModeFormat(b));
                (a.pointArrayMap || [
                    "y"
                ]).forEach(function(a) {
                    a = "{point." + a;
                    if (e || g) b = b.replace(RegExp(a + "}", "g"), e + a + "}" + g);
                    b = b.replace(RegExp(a + "}", "g"), a + ":,." + c + "f}");
                });
                return A(b, {
                    point: this,
                    series: this.series
                }, a.chart);
            };
            g.prototype.update = function(b, a, c, e) {
                function d() {
                    g.applyOptions(b);
                    var d = m && g.hasDummyGraphic;
                    d = null === g.y ? !d : d;
                    m && d && (g.graphic = m.destroy(), delete g.hasDummyGraphic);
                    B(b, !0) && (m && m.element && b && b.marker && "undefined" !== typeof b.marker.symbol && (g.graphic = m.destroy()), b && b.dataLabels && g.dataLabel && (g.dataLabel = g.dataLabel.destroy()), g.connector && (g.connector = g.connector.destroy()));
                    h = g.index;
                    l.updateParallelArrays(g, h);
                    r.data[h] = B(r.data[h], !0) || B(b, !0) ? g.options : C(b, r.data[h]);
                    l.isDirty = l.isDirtyData = !0;
                    !l.fixedBox && l.hasCartesianSeries && (f.isDirtyBox = !0);
                    "point" === r.legendType && (f.isDirtyLegend = !0);
                    a && f.redraw(c);
                }
                var g = this, l = g.series, m = g.graphic, f = l.chart, r = l.options, h;
                a = C(a, !0);
                !1 === e ? d() : g.firePointEvent("update", {
                    options: b
                }, d);
            };
            g.prototype.remove = function(b, a) {
                this.series.removePoint(this.series.data.indexOf(this), b, a);
            };
            g.prototype.select = function(b, a) {
                var d = this, c = d.series, e = c.chart;
                this.selectedStaging = b = C(b, !d.selected);
                d.firePointEvent(b ? "select" : "unselect", {
                    accumulate: a
                }, function() {
                    d.selected = d.options.selected = b;
                    c.options.data[c.data.indexOf(d)] = d.options;
                    d.setState(b && "select");
                    a || e.getSelectedPoints().forEach(function(b) {
                        var a = b.series;
                        b.selected && b !== d && (b.selected = b.options.selected = !1, a.options.data[a.data.indexOf(b)] = b.options, b.setState(e.hoverPoints && a.options.inactiveOtherPoints ? "inactive" : ""), b.firePointEvent("unselect"));
                    });
                });
                delete this.selectedStaging;
            };
            g.prototype.onMouseOver = function(b) {
                var a = this.series.chart, d = a.pointer;
                b = b ? d.normalize(b) : d.getChartCoordinatesFromPoint(this, a.inverted);
                d.runPointActions(b, this);
            };
            g.prototype.onMouseOut = function() {
                var b = this.series.chart;
                this.firePointEvent("mouseOut");
                this.series.options.inactiveOtherPoints || (b.hoverPoints || []).forEach(function(b) {
                    b.setState();
                });
                b.hoverPoints = b.hoverPoint = null;
            };
            g.prototype.importEvents = function() {
                if (!this.hasImportedEvents) {
                    var b = this, a = t(b.series.options.point, b.options).events;
                    b.events = a;
                    J(a, function(a, d) {
                        w(a) && q(b, d, a);
                    });
                    this.hasImportedEvents = !0;
                }
            };
            g.prototype.setState = function(b, g) {
                var d = this.series, l = this.state, m = d.options.states[b || "normal"] || {}, f = H.plotOptions[d.type].marker && d.options.marker, r = f && !1 === f.enabled, h = f && f.states && f.states[b || "normal"] || {}, k = !1 === h.enabled, n = this.marker || {}, t = d.chart, q = f && d.markerAttribs, w = d.halo, B, v = d.stateMarkerGraphic;
                b = b || "";
                if (!(b === this.state && !g || this.selected && "select" !== b || !1 === m.enabled || b && (k || r && !1 === h.enabled) || b && n.states && n.states[b] && !1 === n.states[b].enabled)) {
                    this.state = b;
                    q && (B = d.markerAttribs(this, b));
                    if (this.graphic && !this.hasDummyGraphic) {
                        l && this.graphic.removeClass("highcharts-point-" + l);
                        b && this.graphic.addClass("highcharts-point-" + b);
                        if (!t.styledMode) {
                            var J = d.pointAttribs(this, b);
                            var E = C(t.options.chart.animation, m.animation);
                            d.options.inactiveOtherPoints && p(J.opacity) && ((this.dataLabels || []).forEach(function(b) {
                                b && b.animate({
                                    opacity: J.opacity
                                }, E);
                            }), this.connector && this.connector.animate({
                                opacity: J.opacity
                            }, E));
                            this.graphic.animate(J, E);
                        }
                        B && this.graphic.animate(B, C(t.options.chart.animation, h.animation, f.animation));
                        v && v.hide();
                    } else {
                        if (b && h) {
                            l = n.symbol || d.symbol;
                            v && v.currentSymbol !== l && (v = v.destroy());
                            if (B) {
                                if (v) v[g ? "animate" : "attr"]({
                                    x: B.x,
                                    y: B.y
                                });
                                else l && (d.stateMarkerGraphic = v = t.renderer.symbol(l, B.x, B.y, B.width, B.height).add(d.markerGroup), v.currentSymbol = l);
                            }
                            !t.styledMode && v && "inactive" !== this.state && v.attr(d.pointAttribs(this, b));
                        }
                        v && (v[b && this.isInside ? "show" : "hide"](), v.element.point = this, v.addClass(this.getClassName(), !0));
                    }
                    m = m.halo;
                    B = (v = this.graphic || v) && v.visibility || "inherit";
                    m && m.size && v && "hidden" !== B && !this.isCluster ? (w || (d.halo = w = t.renderer.path().add(v.parentGroup)), w.show()[g ? "animate" : "attr"]({
                        d: this.haloPath(m.size)
                    }), w.attr({
                        "class": "highcharts-halo highcharts-color-" + C(this.colorIndex, d.colorIndex) + (this.className ? " " + this.className : ""),
                        visibility: B,
                        zIndex: -1
                    }), w.point = this, t.styledMode || w.attr(e({
                        fill: this.color || d.color,
                        "fill-opacity": m.opacity
                    }, a.filterUserAttributes(m.attributes || {})))) : w && w.point && w.point.haloPath && w.animate({
                        d: w.point.haloPath(0)
                    }, null, w.hide);
                    c(this, "afterSetState", {
                        state: b
                    });
                }
            };
            g.prototype.haloPath = function(b) {
                return this.series.chart.renderer.symbols.circle(Math.floor(this.plotX) - b, this.plotY - b, 2 * b, 2 * b);
            };
            return g;
        }();
        "";
        return u;
    });
    M(a, "Core/Pointer.js", [
        a["Core/Color/Color.js"],
        a["Core/Globals.js"],
        a["Core/Tooltip.js"],
        a["Core/Utilities.js"]
    ], function(a, u, z, F) {
        var v = a.parse, G = u.charts, H = u.noop, A = F.addEvent, q = F.attr, n = F.css, k = F.defined, e = F.extend, c = F.find, h = F.fireEvent, f = F.isNumber, w = F.isObject, p = F.objectEach, B = F.offset, t = F.pick, J = F.splat;
        a = function() {
            function a(a, c) {
                this.lastValidTouch = {};
                this.pinchDown = [];
                this.runChartClick = !1;
                this.eventsToUnbind = [];
                this.chart = a;
                this.hasDragged = !1;
                this.options = c;
                this.init(a, c);
            }
            a.prototype.applyInactiveState = function(a) {
                var c = [], b;
                (a || []).forEach(function(a) {
                    b = a.series;
                    c.push(b);
                    b.linkedParent && c.push(b.linkedParent);
                    b.linkedSeries && (c = c.concat(b.linkedSeries));
                    b.navigatorSeries && c.push(b.navigatorSeries);
                });
                this.chart.series.forEach(function(b) {
                    -1 === c.indexOf(b) ? b.setState("inactive", !0) : b.options.inactiveOtherPoints && b.setAllPointsToState("inactive");
                });
            };
            a.prototype.destroy = function() {
                var c = this;
                this.eventsToUnbind.forEach(function(a) {
                    return a();
                });
                this.eventsToUnbind = [];
                u.chartCount || (a.unbindDocumentMouseUp && (a.unbindDocumentMouseUp = a.unbindDocumentMouseUp()), a.unbindDocumentTouchEnd && (a.unbindDocumentTouchEnd = a.unbindDocumentTouchEnd()));
                clearInterval(c.tooltipTimeout);
                p(c, function(a, b) {
                    c[b] = void 0;
                });
            };
            a.prototype.drag = function(a) {
                var c = this.chart, b = c.options.chart, e = this.zoomHor, d = this.zoomVert, m = c.plotLeft, f = c.plotTop, h = c.plotWidth, r = c.plotHeight, k = this.mouseDownX || 0, p = this.mouseDownY || 0, n = w(b.panning) ? b.panning && b.panning.enabled : b.panning, t = b.panKey && a[b.panKey + "Key"], q = a.chartX, B = a.chartY, C = this.selectionMarker;
                if (!C || !C.touch) {
                    if (q < m ? q = m : q > m + h && (q = m + h), B < f ? B = f : B > f + r && (B = f + r), this.hasDragged = Math.sqrt(Math.pow(k - q, 2) + Math.pow(p - B, 2)), 10 < this.hasDragged) {
                        var J = c.isInsidePlot(k - m, p - f, {
                            visiblePlotOnly: !0
                        });
                        !c.hasCartesianSeries && !c.mapView || !this.zoomX && !this.zoomY || !J || t || C || (this.selectionMarker = C = c.renderer.rect(m, f, e ? 1 : h, d ? 1 : r, 0).attr({
                            "class": "highcharts-selection-marker",
                            zIndex: 7
                        }).add(), c.styledMode || C.attr({
                            fill: b.selectionMarkerFill || v("#335cad").setOpacity(.25).get()
                        }));
                        C && e && (e = q - k, C.attr({
                            width: Math.abs(e),
                            x: (0 < e ? 0 : e) + k
                        }));
                        C && d && (e = B - p, C.attr({
                            height: Math.abs(e),
                            y: (0 < e ? 0 : e) + p
                        }));
                        J && !C && n && c.pan(a, b.panning);
                    }
                }
            };
            a.prototype.dragStart = function(a) {
                var c = this.chart;
                c.mouseIsDown = a.type;
                c.cancelClick = !1;
                c.mouseDownX = this.mouseDownX = a.chartX;
                c.mouseDownY = this.mouseDownY = a.chartY;
            };
            a.prototype.drop = function(a) {
                var c = this, b = this.chart, g = this.hasPinched;
                if (this.selectionMarker) {
                    var d = this.selectionMarker, m = d.attr ? d.attr("x") : d.x, r = d.attr ? d.attr("y") : d.y, p = d.attr ? d.attr("width") : d.width, t = d.attr ? d.attr("height") : d.height, q = {
                        originalEvent: a,
                        xAxis: [],
                        yAxis: [],
                        x: m,
                        y: r,
                        width: p,
                        height: t
                    }, B = !!b.mapView;
                    if (this.hasDragged || g) b.axes.forEach(function(b) {
                        if (b.zoomEnabled && k(b.min) && (g || c[({
                            xAxis: "zoomX",
                            yAxis: "zoomY"
                        })[b.coll]]) && f(m) && f(r)) {
                            var d = b.horiz, e = "touchend" === a.type ? b.minPixelPadding : 0, l = b.toValue((d ? m : r) + e);
                            d = b.toValue((d ? m + p : r + t) - e);
                            q[b.coll].push({
                                axis: b,
                                min: Math.min(l, d),
                                max: Math.max(l, d)
                            });
                            B = !0;
                        }
                    }), B && h(b, "selection", q, function(a) {
                        b.zoom(e(a, g ? {
                            animation: !1
                        } : null));
                    });
                    f(b.index) && (this.selectionMarker = this.selectionMarker.destroy());
                    g && this.scaleGroups();
                }
                b && f(b.index) && (n(b.container, {
                    cursor: b._cursor
                }), b.cancelClick = 10 < this.hasDragged, b.mouseIsDown = this.hasDragged = this.hasPinched = !1, this.pinchDown = []);
            };
            a.prototype.findNearestKDPoint = function(a, c, b) {
                var e = this.chart, d = e.hoverPoint;
                e = e.tooltip;
                if (d && e && e.isStickyOnContact()) return d;
                var l;
                a.forEach(function(a) {
                    var d = !(a.noSharedTooltip && c) && 0 > a.options.findNearestPointBy.indexOf("y");
                    a = a.searchPoint(b, d);
                    if ((d = w(a, !0) && a.series) && !(d = !w(l, !0))) {
                        d = l.distX - a.distX;
                        var e = l.dist - a.dist, g = (a.series.group && a.series.group.zIndex) - (l.series.group && l.series.group.zIndex);
                        d = 0 < (0 !== d && c ? d : 0 !== e ? e : 0 !== g ? g : l.series.index > a.series.index ? -1 : 1);
                    }
                    d && (l = a);
                });
                return l;
            };
            a.prototype.getChartCoordinatesFromPoint = function(a, c) {
                var b = a.series, e = b.xAxis;
                b = b.yAxis;
                var d = a.shapeArgs;
                if (e && b) {
                    var l = t(a.clientX, a.plotX), h = a.plotY || 0;
                    a.isNode && d && f(d.x) && f(d.y) && (l = d.x, h = d.y);
                    return c ? {
                        chartX: b.len + b.pos - h,
                        chartY: e.len + e.pos - l
                    } : {
                        chartX: l + e.pos,
                        chartY: h + b.pos
                    };
                }
                if (d && d.x && d.y) return {
                    chartX: d.x,
                    chartY: d.y
                };
            };
            a.prototype.getChartPosition = function() {
                if (this.chartPosition) return this.chartPosition;
                var a = this.chart.container, c = B(a);
                this.chartPosition = {
                    left: c.left,
                    top: c.top,
                    scaleX: 1,
                    scaleY: 1
                };
                var b = a.offsetWidth;
                a = a.offsetHeight;
                2 < b && 2 < a && (this.chartPosition.scaleX = c.width / b, this.chartPosition.scaleY = c.height / a);
                return this.chartPosition;
            };
            a.prototype.getCoordinates = function(a) {
                var c = {
                    xAxis: [],
                    yAxis: []
                };
                this.chart.axes.forEach(function(b) {
                    c[b.isXAxis ? "xAxis" : "yAxis"].push({
                        axis: b,
                        value: b.toValue(a[b.horiz ? "chartX" : "chartY"])
                    });
                });
                return c;
            };
            a.prototype.getHoverData = function(a, e, b, g, d, m) {
                var l = [];
                g = !(!g || !a);
                var f = {
                    chartX: m ? m.chartX : void 0,
                    chartY: m ? m.chartY : void 0,
                    shared: d
                };
                h(this, "beforeGetHoverData", f);
                var r = e && !e.stickyTracking ? [
                    e
                ] : b.filter(function(b) {
                    return f.filter ? f.filter(b) : b.visible && !(!d && b.directTouch) && t(b.options.enableMouseTracking, !0) && b.stickyTracking;
                });
                var k = g || !m ? a : this.findNearestKDPoint(r, d, m);
                e = k && k.series;
                k && (d && !e.noSharedTooltip ? (r = b.filter(function(b) {
                    return f.filter ? f.filter(b) : b.visible && !(!d && b.directTouch) && t(b.options.enableMouseTracking, !0) && !b.noSharedTooltip;
                }), r.forEach(function(b) {
                    var a = c(b.points, function(b) {
                        return b.x === k.x && !b.isNull;
                    });
                    w(a) && (b.chart.isBoosting && (a = b.getPoint(a)), l.push(a));
                })) : l.push(k));
                f = {
                    hoverPoint: k
                };
                h(this, "afterGetHoverData", f);
                return {
                    hoverPoint: f.hoverPoint,
                    hoverSeries: e,
                    hoverPoints: l
                };
            };
            a.prototype.getPointFromEvent = function(a) {
                a = a.target;
                for(var c; a && !c;)c = a.point, a = a.parentNode;
                return c;
            };
            a.prototype.onTrackerMouseOut = function(a) {
                a = a.relatedTarget || a.toElement;
                var c = this.chart.hoverSeries;
                this.isDirectTouch = !1;
                if (!(!c || !a || c.stickyTracking || this.inClass(a, "highcharts-tooltip") || this.inClass(a, "highcharts-series-" + c.index) && this.inClass(a, "highcharts-tracker"))) c.onMouseOut();
            };
            a.prototype.inClass = function(a, c) {
                for(var b; a;){
                    if (b = q(a, "class")) {
                        if (-1 !== b.indexOf(c)) return !0;
                        if (-1 !== b.indexOf("highcharts-container")) return !1;
                    }
                    a = a.parentNode;
                }
            };
            a.prototype.init = function(a, c) {
                this.options = c;
                this.chart = a;
                this.runChartClick = !(!c.chart.events || !c.chart.events.click);
                this.pinchDown = [];
                this.lastValidTouch = {};
                z && (a.tooltip = new z(a, c.tooltip), this.followTouchMove = t(c.tooltip.followTouchMove, !0));
                this.setDOMEvents();
            };
            a.prototype.normalize = function(a, c) {
                var b = a.touches, g = b ? b.length ? b.item(0) : t(b.changedTouches, a.changedTouches)[0] : a;
                c || (c = this.getChartPosition());
                b = g.pageX - c.left;
                g = g.pageY - c.top;
                b /= c.scaleX;
                g /= c.scaleY;
                return e(a, {
                    chartX: Math.round(b),
                    chartY: Math.round(g)
                });
            };
            a.prototype.onContainerClick = function(a) {
                var c = this.chart, b = c.hoverPoint;
                a = this.normalize(a);
                var g = c.plotLeft, d = c.plotTop;
                c.cancelClick || (b && this.inClass(a.target, "highcharts-tracker") ? (h(b.series, "click", e(a, {
                    point: b
                })), c.hoverPoint && b.firePointEvent("click", a)) : (e(a, this.getCoordinates(a)), c.isInsidePlot(a.chartX - g, a.chartY - d, {
                    visiblePlotOnly: !0
                }) && h(c, "click", a)));
            };
            a.prototype.onContainerMouseDown = function(a) {
                var c = 1 === ((a.buttons || a.button) & 1);
                a = this.normalize(a);
                if (u.isFirefox && 0 !== a.button) this.onContainerMouseMove(a);
                if ("undefined" === typeof a.button || c) this.zoomOption(a), c && a.preventDefault && a.preventDefault(), this.dragStart(a);
            };
            a.prototype.onContainerMouseLeave = function(c) {
                var e = G[t(a.hoverChartIndex, -1)], b = this.chart.tooltip;
                b && b.shouldStickOnContact() && this.inClass(c.relatedTarget, "highcharts-tooltip-container") || (c = this.normalize(c), e && (c.relatedTarget || c.toElement) && (e.pointer.reset(), e.pointer.chartPosition = void 0), b && !b.isHidden && this.reset());
            };
            a.prototype.onContainerMouseEnter = function(a) {
                delete this.chartPosition;
            };
            a.prototype.onContainerMouseMove = function(a) {
                var c = this.chart;
                a = this.normalize(a);
                this.setHoverChartIndex();
                a.preventDefault || (a.returnValue = !1);
                ("mousedown" === c.mouseIsDown || this.touchSelect(a)) && this.drag(a);
                c.openMenu || !this.inClass(a.target, "highcharts-tracker") && !c.isInsidePlot(a.chartX - c.plotLeft, a.chartY - c.plotTop, {
                    visiblePlotOnly: !0
                }) || (this.inClass(a.target, "highcharts-no-tooltip") ? this.reset(!1, 0) : this.runPointActions(a));
            };
            a.prototype.onDocumentTouchEnd = function(c) {
                var e = G[t(a.hoverChartIndex, -1)];
                e && e.pointer.drop(c);
            };
            a.prototype.onContainerTouchMove = function(a) {
                if (this.touchSelect(a)) this.onContainerMouseMove(a);
                else this.touch(a);
            };
            a.prototype.onContainerTouchStart = function(a) {
                if (this.touchSelect(a)) this.onContainerMouseDown(a);
                else this.zoomOption(a), this.touch(a, !0);
            };
            a.prototype.onDocumentMouseMove = function(a) {
                var c = this.chart, b = this.chartPosition;
                a = this.normalize(a, b);
                var e = c.tooltip;
                !b || e && e.isStickyOnContact() || c.isInsidePlot(a.chartX - c.plotLeft, a.chartY - c.plotTop, {
                    visiblePlotOnly: !0
                }) || this.inClass(a.target, "highcharts-tracker") || this.reset();
            };
            a.prototype.onDocumentMouseUp = function(c) {
                var e = G[t(a.hoverChartIndex, -1)];
                e && e.pointer.drop(c);
            };
            a.prototype.pinch = function(a) {
                var c = this, b = c.chart, g = c.pinchDown, d = a.touches || [], m = d.length, f = c.lastValidTouch, k = c.hasZoom, p = {}, r = 1 === m && (c.inClass(a.target, "highcharts-tracker") && b.runTrackerClick || c.runChartClick), n = {}, q = c.selectionMarker;
                1 < m ? c.initiated = !0 : 1 === m && this.followTouchMove && (c.initiated = !1);
                k && c.initiated && !r && !1 !== a.cancelable && a.preventDefault();
                [].map.call(d, function(b) {
                    return c.normalize(b);
                });
                "touchstart" === a.type ? ([].forEach.call(d, function(b, a) {
                    g[a] = {
                        chartX: b.chartX,
                        chartY: b.chartY
                    };
                }), f.x = [
                    g[0].chartX,
                    g[1] && g[1].chartX
                ], f.y = [
                    g[0].chartY,
                    g[1] && g[1].chartY
                ], b.axes.forEach(function(a) {
                    if (a.zoomEnabled) {
                        var d = b.bounds[a.horiz ? "h" : "v"], c = a.minPixelPadding, e = a.toPixels(Math.min(t(a.options.min, a.dataMin), a.dataMin)), g = a.toPixels(Math.max(t(a.options.max, a.dataMax), a.dataMax)), m = Math.max(e, g);
                        d.min = Math.min(a.pos, Math.min(e, g) - c);
                        d.max = Math.max(a.pos + a.len, m + c);
                    }
                }), c.res = !0) : c.followTouchMove && 1 === m ? this.runPointActions(c.normalize(a)) : g.length && (h(b, "touchpan", {
                    originalEvent: a
                }, function() {
                    q || (c.selectionMarker = q = e({
                        destroy: H,
                        touch: !0
                    }, b.plotBox));
                    c.pinchTranslate(g, d, p, q, n, f);
                    c.hasPinched = k;
                    c.scaleGroups(p, n);
                }), c.res && (c.res = !1, this.reset(!1, 0)));
            };
            a.prototype.pinchTranslate = function(a, c, b, e, d, m) {
                this.zoomHor && this.pinchTranslateDirection(!0, a, c, b, e, d, m);
                this.zoomVert && this.pinchTranslateDirection(!1, a, c, b, e, d, m);
            };
            a.prototype.pinchTranslateDirection = function(a, c, b, e, d, m, f, h) {
                var g = this.chart, l = a ? "x" : "y", k = a ? "X" : "Y", p = "chart" + k, r = a ? "width" : "height", n = g["plot" + (a ? "Left" : "Top")], t = g.inverted, x = g.bounds[a ? "h" : "v"], q = 1 === c.length, D = c[0][p], B = !q && c[1][p];
                c = function() {
                    "number" === typeof v && 20 < Math.abs(D - B) && (C = h || Math.abs(N - v) / Math.abs(D - B));
                    E = (n - N) / C + D;
                    w = g["plot" + (a ? "Width" : "Height")] / C;
                };
                var w, E, C = h || 1, N = b[0][p], v = !q && b[1][p];
                c();
                b = E;
                if (b < x.min) {
                    b = x.min;
                    var J = !0;
                } else b + w > x.max && (b = x.max - w, J = !0);
                J ? (N -= .8 * (N - f[l][0]), "number" === typeof v && (v -= .8 * (v - f[l][1])), c()) : f[l] = [
                    N,
                    v
                ];
                t || (m[l] = E - n, m[r] = w);
                m = t ? 1 / C : C;
                d[r] = w;
                d[l] = b;
                e[t ? a ? "scaleY" : "scaleX" : "scale" + k] = C;
                e["translate" + k] = m * n + (N - m * D);
            };
            a.prototype.reset = function(a, c) {
                var b = this.chart, e = b.hoverSeries, d = b.hoverPoint, m = b.hoverPoints, f = b.tooltip, l = f && f.shared ? m : d;
                a && l && J(l).forEach(function(b) {
                    b.series.isCartesian && "undefined" === typeof b.plotX && (a = !1);
                });
                if (a) f && l && J(l).length && (f.refresh(l), f.shared && m ? m.forEach(function(b) {
                    b.setState(b.state, !0);
                    b.series.isCartesian && (b.series.xAxis.crosshair && b.series.xAxis.drawCrosshair(null, b), b.series.yAxis.crosshair && b.series.yAxis.drawCrosshair(null, b));
                }) : d && (d.setState(d.state, !0), b.axes.forEach(function(b) {
                    b.crosshair && d.series[b.coll] === b && b.drawCrosshair(null, d);
                })));
                else {
                    if (d) d.onMouseOut();
                    m && m.forEach(function(b) {
                        b.setState();
                    });
                    if (e) e.onMouseOut();
                    f && f.hide(c);
                    this.unDocMouseMove && (this.unDocMouseMove = this.unDocMouseMove());
                    b.axes.forEach(function(b) {
                        b.hideCrosshair();
                    });
                    this.hoverX = b.hoverPoints = b.hoverPoint = null;
                }
            };
            a.prototype.runPointActions = function(e, f) {
                var b = this.chart, g = b.tooltip && b.tooltip.options.enabled ? b.tooltip : void 0, d = g ? g.shared : !1, m = f || b.hoverPoint, l = m && m.series || b.hoverSeries;
                f = this.getHoverData(m, l, b.series, (!e || "touchmove" !== e.type) && (!!f || l && l.directTouch && this.isDirectTouch), d, e);
                m = f.hoverPoint;
                l = f.hoverSeries;
                var h = f.hoverPoints;
                f = l && l.tooltipOptions.followPointer && !l.tooltipOptions.split;
                d = d && l && !l.noSharedTooltip;
                if (m && (m !== b.hoverPoint || g && g.isHidden)) {
                    (b.hoverPoints || []).forEach(function(b) {
                        -1 === h.indexOf(b) && b.setState();
                    });
                    if (b.hoverSeries !== l) l.onMouseOver();
                    this.applyInactiveState(h);
                    (h || []).forEach(function(b) {
                        b.setState("hover");
                    });
                    b.hoverPoint && b.hoverPoint.firePointEvent("mouseOut");
                    if (!m.series) return;
                    b.hoverPoints = h;
                    b.hoverPoint = m;
                    m.firePointEvent("mouseOver");
                    g && g.refresh(d ? h : m, e);
                } else f && g && !g.isHidden && (m = g.getAnchor([
                    {}
                ], e), b.isInsidePlot(m[0], m[1], {
                    visiblePlotOnly: !0
                }) && g.updatePosition({
                    plotX: m[0],
                    plotY: m[1]
                }));
                this.unDocMouseMove || (this.unDocMouseMove = A(b.container.ownerDocument, "mousemove", function(b) {
                    var d = G[a.hoverChartIndex];
                    if (d) d.pointer.onDocumentMouseMove(b);
                }), this.eventsToUnbind.push(this.unDocMouseMove));
                b.axes.forEach(function(a) {
                    var d = t((a.crosshair || {}).snap, !0), g;
                    d && ((g = b.hoverPoint) && g.series[a.coll] === a || (g = c(h, function(b) {
                        return b.series[a.coll] === a;
                    })));
                    g || !d ? a.drawCrosshair(e, g) : a.hideCrosshair();
                });
            };
            a.prototype.scaleGroups = function(a, c) {
                var b = this.chart;
                b.series.forEach(function(e) {
                    var d = a || e.getPlotBox();
                    e.group && (e.xAxis && e.xAxis.zoomEnabled || b.mapView) && (e.group.attr(d), e.markerGroup && (e.markerGroup.attr(d), e.markerGroup.clip(c ? b.clipRect : null)), e.dataLabelsGroup && e.dataLabelsGroup.attr(d));
                });
                b.clipRect.attr(c || b.clipBox);
            };
            a.prototype.setDOMEvents = function() {
                var c = this, e = this.chart.container, b = e.ownerDocument;
                e.onmousedown = this.onContainerMouseDown.bind(this);
                e.onmousemove = this.onContainerMouseMove.bind(this);
                e.onclick = this.onContainerClick.bind(this);
                this.eventsToUnbind.push(A(e, "mouseenter", this.onContainerMouseEnter.bind(this)));
                this.eventsToUnbind.push(A(e, "mouseleave", this.onContainerMouseLeave.bind(this)));
                a.unbindDocumentMouseUp || (a.unbindDocumentMouseUp = A(b, "mouseup", this.onDocumentMouseUp.bind(this)));
                for(var g = this.chart.renderTo.parentElement; g && "BODY" !== g.tagName;)this.eventsToUnbind.push(A(g, "scroll", function() {
                    delete c.chartPosition;
                })), g = g.parentElement;
                u.hasTouch && (this.eventsToUnbind.push(A(e, "touchstart", this.onContainerTouchStart.bind(this), {
                    passive: !1
                })), this.eventsToUnbind.push(A(e, "touchmove", this.onContainerTouchMove.bind(this), {
                    passive: !1
                })), a.unbindDocumentTouchEnd || (a.unbindDocumentTouchEnd = A(b, "touchend", this.onDocumentTouchEnd.bind(this), {
                    passive: !1
                })));
            };
            a.prototype.setHoverChartIndex = function() {
                var c = this.chart, e = u.charts[t(a.hoverChartIndex, -1)];
                if (e && e !== c) e.pointer.onContainerMouseLeave({
                    relatedTarget: !0
                });
                e && e.mouseIsDown || (a.hoverChartIndex = c.index);
            };
            a.prototype.touch = function(a, c) {
                var b = this.chart, e;
                this.setHoverChartIndex();
                if (1 === a.touches.length) {
                    if (a = this.normalize(a), (e = b.isInsidePlot(a.chartX - b.plotLeft, a.chartY - b.plotTop, {
                        visiblePlotOnly: !0
                    })) && !b.openMenu) {
                        c && this.runPointActions(a);
                        if ("touchmove" === a.type) {
                            c = this.pinchDown;
                            var d = c[0] ? 4 <= Math.sqrt(Math.pow(c[0].chartX - a.chartX, 2) + Math.pow(c[0].chartY - a.chartY, 2)) : !1;
                        }
                        t(d, !0) && this.pinch(a);
                    } else c && this.reset();
                } else 2 === a.touches.length && this.pinch(a);
            };
            a.prototype.touchSelect = function(a) {
                return !(!this.chart.options.chart.zoomBySingleTouch || !a.touches || 1 !== a.touches.length);
            };
            a.prototype.zoomOption = function(a) {
                var c = this.chart, b = c.options.chart;
                c = c.inverted;
                var e = b.zoomType || "";
                /touch/.test(a.type) && (e = t(b.pinchType, e));
                this.zoomX = a = /x/.test(e);
                this.zoomY = b = /y/.test(e);
                this.zoomHor = a && !c || b && c;
                this.zoomVert = b && !c || a && c;
                this.hasZoom = a || b;
            };
            return a;
        }();
        "";
        return a;
    });
    M(a, "Core/MSPointer.js", [
        a["Core/Globals.js"],
        a["Core/Pointer.js"],
        a["Core/Utilities.js"]
    ], function(a, u, z) {
        function v() {
            var a = [];
            a.item = function(a) {
                return this[a];
            };
            c(f, function(c) {
                a.push({
                    pageX: c.pageX,
                    pageY: c.pageY,
                    target: c.target
                });
            });
            return a;
        }
        function y(a, c, e, f) {
            var h = H[u.hoverChartIndex || NaN];
            "touch" !== a.pointerType && a.pointerType !== a.MSPOINTER_TYPE_TOUCH || !h || (h = h.pointer, f(a), h[c]({
                type: e,
                target: a.currentTarget,
                preventDefault: q,
                touches: v()
            }));
        }
        var G = this && this.__extends || function() {
            var a = function(c, e) {
                a = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(a, c) {
                    a.__proto__ = c;
                } || function(a, c) {
                    for(var e in c)c.hasOwnProperty(e) && (a[e] = c[e]);
                };
                return a(c, e);
            };
            return function(c, e) {
                function f() {
                    this.constructor = c;
                }
                a(c, e);
                c.prototype = null === e ? Object.create(e) : (f.prototype = e.prototype, new f);
            };
        }(), H = a.charts, A = a.doc, q = a.noop, n = a.win, k = z.addEvent, e = z.css, c = z.objectEach, h = z.removeEvent, f = {}, w = !!n.PointerEvent;
        return function(c) {
            function p() {
                return null !== c && c.apply(this, arguments) || this;
            }
            G(p, c);
            p.isRequired = function() {
                return !(a.hasTouch || !n.PointerEvent && !n.MSPointerEvent);
            };
            p.prototype.batchMSEvents = function(a) {
                a(this.chart.container, w ? "pointerdown" : "MSPointerDown", this.onContainerPointerDown);
                a(this.chart.container, w ? "pointermove" : "MSPointerMove", this.onContainerPointerMove);
                a(A, w ? "pointerup" : "MSPointerUp", this.onDocumentPointerUp);
            };
            p.prototype.destroy = function() {
                this.batchMSEvents(h);
                c.prototype.destroy.call(this);
            };
            p.prototype.init = function(a, f) {
                c.prototype.init.call(this, a, f);
                this.hasZoom && e(a.container, {
                    "-ms-touch-action": "none",
                    "touch-action": "none"
                });
            };
            p.prototype.onContainerPointerDown = function(a) {
                y(a, "onContainerTouchStart", "touchstart", function(a) {
                    f[a.pointerId] = {
                        pageX: a.pageX,
                        pageY: a.pageY,
                        target: a.currentTarget
                    };
                });
            };
            p.prototype.onContainerPointerMove = function(a) {
                y(a, "onContainerTouchMove", "touchmove", function(a) {
                    f[a.pointerId] = {
                        pageX: a.pageX,
                        pageY: a.pageY
                    };
                    f[a.pointerId].target || (f[a.pointerId].target = a.currentTarget);
                });
            };
            p.prototype.onDocumentPointerUp = function(a) {
                y(a, "onDocumentTouchEnd", "touchend", function(a) {
                    delete f[a.pointerId];
                });
            };
            p.prototype.setDOMEvents = function() {
                c.prototype.setDOMEvents.call(this);
                (this.hasZoom || this.followTouchMove) && this.batchMSEvents(k);
            };
            return p;
        }(u);
    });
    M(a, "Core/Legend/Legend.js", [
        a["Core/Animation/AnimationUtilities.js"],
        a["Core/FormatUtilities.js"],
        a["Core/Globals.js"],
        a["Core/Series/Point.js"],
        a["Core/Renderer/RendererUtilities.js"],
        a["Core/Utilities.js"]
    ], function(a, u, z, F, y, G) {
        var v = a.animObject, A = a.setAnimation, q = u.format;
        a = z.isFirefox;
        var n = z.marginNames;
        z = z.win;
        var k = y.distribute, e = G.addEvent, c = G.createElement, h = G.css, f = G.defined, w = G.discardElement, p = G.find, B = G.fireEvent, t = G.isNumber, J = G.merge, C = G.pick, r = G.relativeLength, l = G.stableSort, b = G.syncTimeout;
        y = G.wrap;
        G = function() {
            function a(b, a) {
                this.allItems = [];
                this.contentGroup = this.box = void 0;
                this.display = !1;
                this.group = void 0;
                this.offsetWidth = this.maxLegendWidth = this.maxItemWidth = this.legendWidth = this.legendHeight = this.lastLineHeight = this.lastItemY = this.itemY = this.itemX = this.itemMarginTop = this.itemMarginBottom = this.itemHeight = this.initialItemY = 0;
                this.options = {};
                this.padding = 0;
                this.pages = [];
                this.proximate = !1;
                this.scrollGroup = void 0;
                this.widthOption = this.totalItemWidth = this.titleHeight = this.symbolWidth = this.symbolHeight = 0;
                this.chart = b;
                this.init(b, a);
            }
            a.prototype.init = function(b, a) {
                this.chart = b;
                this.setOptions(a);
                a.enabled && (this.render(), e(this.chart, "endResize", function() {
                    this.legend.positionCheckboxes();
                }), this.proximate ? this.unchartrender = e(this.chart, "render", function() {
                    this.legend.proximatePositions();
                    this.legend.positionItems();
                }) : this.unchartrender && this.unchartrender());
            };
            a.prototype.setOptions = function(b) {
                var a = C(b.padding, 8);
                this.options = b;
                this.chart.styledMode || (this.itemStyle = b.itemStyle, this.itemHiddenStyle = J(this.itemStyle, b.itemHiddenStyle));
                this.itemMarginTop = b.itemMarginTop || 0;
                this.itemMarginBottom = b.itemMarginBottom || 0;
                this.padding = a;
                this.initialItemY = a - 5;
                this.symbolWidth = C(b.symbolWidth, 16);
                this.pages = [];
                this.proximate = "proximate" === b.layout && !this.chart.inverted;
                this.baseline = void 0;
            };
            a.prototype.update = function(b, a) {
                var c = this.chart;
                this.setOptions(J(!0, this.options, b));
                this.destroy();
                c.isDirtyLegend = c.isDirtyBox = !0;
                C(a, !0) && c.redraw();
                B(this, "afterUpdate");
            };
            a.prototype.colorizeItem = function(b, a) {
                b.legendGroup[a ? "removeClass" : "addClass"]("highcharts-legend-item-hidden");
                if (!this.chart.styledMode) {
                    var c = this.options, d = b.legendItem, e = b.legendLine, g = b.legendSymbol, f = this.itemHiddenStyle.color;
                    c = a ? c.itemStyle.color : f;
                    var m = a ? b.color || f : f, h = b.options && b.options.marker, l = {
                        fill: m
                    };
                    d && d.css({
                        fill: c,
                        color: c
                    });
                    e && e.attr({
                        stroke: m
                    });
                    g && (h && g.isMarker && (l = b.pointAttribs(), a || (l.stroke = l.fill = f)), g.attr(l));
                }
                B(this, "afterColorizeItem", {
                    item: b,
                    visible: a
                });
            };
            a.prototype.positionItems = function() {
                this.allItems.forEach(this.positionItem, this);
                this.chart.isResizing || this.positionCheckboxes();
            };
            a.prototype.positionItem = function(b) {
                var a = this, c = this.options, d = c.symbolPadding, e = !c.rtl, g = b._legendItemPos;
                c = g[0];
                g = g[1];
                var h = b.checkbox, l = b.legendGroup;
                l && l.element && (d = {
                    translateX: e ? c : this.legendWidth - c - 2 * d - 4,
                    translateY: g
                }, e = function() {
                    B(a, "afterPositionItem", {
                        item: b
                    });
                }, f(l.translateY) ? l.animate(d, void 0, e) : (l.attr(d), e()));
                h && (h.x = c, h.y = g);
            };
            a.prototype.destroyItem = function(b) {
                var a = b.checkbox;
                [
                    "legendItem",
                    "legendLine",
                    "legendSymbol",
                    "legendGroup"
                ].forEach(function(a) {
                    b[a] && (b[a] = b[a].destroy());
                });
                a && w(b.checkbox);
            };
            a.prototype.destroy = function() {
                function b(b) {
                    this[b] && (this[b] = this[b].destroy());
                }
                this.getAllItems().forEach(function(a) {
                    [
                        "legendItem",
                        "legendGroup"
                    ].forEach(b, a);
                });
                "clipRect up down pager nav box title group".split(" ").forEach(b, this);
                this.display = null;
            };
            a.prototype.positionCheckboxes = function() {
                var b = this.group && this.group.alignAttr, a = this.clipHeight || this.legendHeight, c = this.titleHeight;
                if (b) {
                    var e = b.translateY;
                    this.allItems.forEach(function(d) {
                        var g = d.checkbox;
                        if (g) {
                            var f = e + c + g.y + (this.scrollOffset || 0) + 3;
                            h(g, {
                                left: b.translateX + d.checkboxOffset + g.x - 20 + "px",
                                top: f + "px",
                                display: this.proximate || f > e - 6 && f < e + a - 6 ? "" : "none"
                            });
                        }
                    }, this);
                }
            };
            a.prototype.renderTitle = function() {
                var b = this.options, a = this.padding, c = b.title, e = 0;
                c.text && (this.title || (this.title = this.chart.renderer.label(c.text, a - 3, a - 4, null, null, null, b.useHTML, null, "legend-title").attr({
                    zIndex: 1
                }), this.chart.styledMode || this.title.css(c.style), this.title.add(this.group)), c.width || this.title.css({
                    width: this.maxLegendWidth + "px"
                }), b = this.title.getBBox(), e = b.height, this.offsetWidth = b.width, this.contentGroup.attr({
                    translateY: e
                }));
                this.titleHeight = e;
            };
            a.prototype.setText = function(b) {
                var a = this.options;
                b.legendItem.attr({
                    text: a.labelFormat ? q(a.labelFormat, b, this.chart) : a.labelFormatter.call(b)
                });
            };
            a.prototype.renderItem = function(b) {
                var a = this.chart, c = a.renderer, d = this.options, e = this.symbolWidth, g = d.symbolPadding || 0, f = this.itemStyle, h = this.itemHiddenStyle, l = "horizontal" === d.layout ? C(d.itemDistance, 20) : 0, k = !d.rtl, p = !b.series, n = !p && b.series.drawLegendSymbol ? b.series : b, r = n.options, t = this.createCheckboxForItem && r && r.showCheckbox, q = d.useHTML, w = b.options.className, E = b.legendItem;
                r = e + g + l + (t ? 20 : 0);
                E || (b.legendGroup = c.g("legend-item").addClass("highcharts-" + n.type + "-series highcharts-color-" + b.colorIndex + (w ? " " + w : "") + (p ? " highcharts-series-" + b.index : "")).attr({
                    zIndex: 1
                }).add(this.scrollGroup), b.legendItem = E = c.text("", k ? e + g : -g, this.baseline || 0, q), a.styledMode || E.css(J(b.visible ? f : h)), E.attr({
                    align: k ? "left" : "right",
                    zIndex: 2
                }).add(b.legendGroup), this.baseline || (this.fontMetrics = c.fontMetrics(a.styledMode ? 12 : f.fontSize, E), this.baseline = this.fontMetrics.f + 3 + this.itemMarginTop, E.attr("y", this.baseline), this.symbolHeight = d.symbolHeight || this.fontMetrics.f, d.squareSymbol && (this.symbolWidth = C(d.symbolWidth, Math.max(this.symbolHeight, 16)), r = this.symbolWidth + g + l + (t ? 20 : 0), k && E.attr("x", this.symbolWidth + g))), n.drawLegendSymbol(this, b), this.setItemEvents && this.setItemEvents(b, E, q));
                t && !b.checkbox && this.createCheckboxForItem && this.createCheckboxForItem(b);
                this.colorizeItem(b, b.visible);
                !a.styledMode && f.width || E.css({
                    width: (d.itemWidth || this.widthOption || a.spacingBox.width) - r + "px"
                });
                this.setText(b);
                a = E.getBBox();
                c = this.fontMetrics && this.fontMetrics.h || 0;
                b.itemWidth = b.checkboxOffset = d.itemWidth || b.legendItemWidth || a.width + r;
                this.maxItemWidth = Math.max(this.maxItemWidth, b.itemWidth);
                this.totalItemWidth += b.itemWidth;
                this.itemHeight = b.itemHeight = Math.round(b.legendItemHeight || (a.height > 1.5 * c ? a.height : c));
            };
            a.prototype.layoutItem = function(b) {
                var a = this.options, c = this.padding, d = "horizontal" === a.layout, e = b.itemHeight, g = this.itemMarginBottom, f = this.itemMarginTop, h = d ? C(a.itemDistance, 20) : 0, l = this.maxLegendWidth;
                a = a.alignColumns && this.totalItemWidth > l ? this.maxItemWidth : b.itemWidth;
                d && this.itemX - c + a > l && (this.itemX = c, this.lastLineHeight && (this.itemY += f + this.lastLineHeight + g), this.lastLineHeight = 0);
                this.lastItemY = f + this.itemY + g;
                this.lastLineHeight = Math.max(e, this.lastLineHeight);
                b._legendItemPos = [
                    this.itemX,
                    this.itemY
                ];
                d ? this.itemX += a : (this.itemY += f + e + g, this.lastLineHeight = e);
                this.offsetWidth = this.widthOption || Math.max((d ? this.itemX - c - (b.checkbox ? 0 : h) : a) + c, this.offsetWidth);
            };
            a.prototype.getAllItems = function() {
                var b = [];
                this.chart.series.forEach(function(a) {
                    var c = a && a.options;
                    a && C(c.showInLegend, f(c.linkedTo) ? !1 : void 0, !0) && (b = b.concat(a.legendItems || ("point" === c.legendType ? a.data : a)));
                });
                B(this, "afterGetAllItems", {
                    allItems: b
                });
                return b;
            };
            a.prototype.getAlignment = function() {
                var b = this.options;
                return this.proximate ? b.align.charAt(0) + "tv" : b.floating ? "" : b.align.charAt(0) + b.verticalAlign.charAt(0) + b.layout.charAt(0);
            };
            a.prototype.adjustMargins = function(b, a) {
                var c = this.chart, d = this.options, e = this.getAlignment();
                e && [
                    /(lth|ct|rth)/,
                    /(rtv|rm|rbv)/,
                    /(rbh|cb|lbh)/,
                    /(lbv|lm|ltv)/
                ].forEach(function(g, h) {
                    g.test(e) && !f(b[h]) && (c[n[h]] = Math.max(c[n[h]], c.legend[(h + 1) % 2 ? "legendHeight" : "legendWidth"] + [
                        1,
                        -1,
                        -1,
                        1
                    ][h] * d[h % 2 ? "x" : "y"] + C(d.margin, 12) + a[h] + (c.titleOffset[h] || 0)));
                });
            };
            a.prototype.proximatePositions = function() {
                var b = this.chart, a = [], c = "left" === this.options.align;
                this.allItems.forEach(function(d) {
                    var e;
                    var g = c;
                    if (d.yAxis) {
                        d.xAxis.options.reversed && (g = !g);
                        d.points && (e = p(g ? d.points : d.points.slice(0).reverse(), function(b) {
                            return t(b.plotY);
                        }));
                        g = this.itemMarginTop + d.legendItem.getBBox().height + this.itemMarginBottom;
                        var f = d.yAxis.top - b.plotTop;
                        d.visible ? (e = e ? e.plotY : d.yAxis.height, e += f - .3 * g) : e = f + d.yAxis.height;
                        a.push({
                            target: e,
                            size: g,
                            item: d
                        });
                    }
                }, this);
                k(a, b.plotHeight).forEach(function(a) {
                    a.item._legendItemPos && (a.item._legendItemPos[1] = b.plotTop - b.spacing[0] + a.pos);
                });
            };
            a.prototype.render = function() {
                var b = this.chart, a = b.renderer, c = this.options, e = this.padding, g = this.getAllItems(), f = this.group, h = this.box;
                this.itemX = e;
                this.itemY = this.initialItemY;
                this.lastItemY = this.offsetWidth = 0;
                this.widthOption = r(c.width, b.spacingBox.width - e);
                var k = b.spacingBox.width - 2 * e - c.x;
                -1 < [
                    "rm",
                    "lm"
                ].indexOf(this.getAlignment().substring(0, 2)) && (k /= 2);
                this.maxLegendWidth = this.widthOption || k;
                f || (this.group = f = a.g("legend").addClass(c.className || "").attr({
                    zIndex: 7
                }).add(), this.contentGroup = a.g().attr({
                    zIndex: 1
                }).add(f), this.scrollGroup = a.g().add(this.contentGroup));
                this.renderTitle();
                l(g, function(b, a) {
                    return (b.options && b.options.legendIndex || 0) - (a.options && a.options.legendIndex || 0);
                });
                c.reversed && g.reverse();
                this.allItems = g;
                this.display = k = !!g.length;
                this.itemHeight = this.totalItemWidth = this.maxItemWidth = this.lastLineHeight = 0;
                g.forEach(this.renderItem, this);
                g.forEach(this.layoutItem, this);
                g = (this.widthOption || this.offsetWidth) + e;
                var p = this.lastItemY + this.lastLineHeight + this.titleHeight;
                p = this.handleOverflow(p);
                p += e;
                h || (this.box = h = a.rect().addClass("highcharts-legend-box").attr({
                    r: c.borderRadius
                }).add(f), h.isNew = !0);
                b.styledMode || h.attr({
                    stroke: c.borderColor,
                    "stroke-width": c.borderWidth || 0,
                    fill: c.backgroundColor || "none"
                }).shadow(c.shadow);
                0 < g && 0 < p && (h[h.isNew ? "attr" : "animate"](h.crisp.call({}, {
                    x: 0,
                    y: 0,
                    width: g,
                    height: p
                }, h.strokeWidth())), h.isNew = !1);
                h[k ? "show" : "hide"]();
                b.styledMode && "none" === f.getStyle("display") && (g = p = 0);
                this.legendWidth = g;
                this.legendHeight = p;
                k && this.align();
                this.proximate || this.positionItems();
                B(this, "afterRender");
            };
            a.prototype.align = function(b) {
                void 0 === b && (b = this.chart.spacingBox);
                var a = this.chart, c = this.options, d = b.y;
                /(lth|ct|rth)/.test(this.getAlignment()) && 0 < a.titleOffset[0] ? d += a.titleOffset[0] : /(lbh|cb|rbh)/.test(this.getAlignment()) && 0 < a.titleOffset[2] && (d -= a.titleOffset[2]);
                d !== b.y && (b = J(b, {
                    y: d
                }));
                this.group.align(J(c, {
                    width: this.legendWidth,
                    height: this.legendHeight,
                    verticalAlign: this.proximate ? "top" : c.verticalAlign
                }), !0, b);
            };
            a.prototype.handleOverflow = function(b) {
                var a = this, c = this.chart, d = c.renderer, e = this.options, g = e.y, f = "top" === e.verticalAlign, h = this.padding, l = e.maxHeight, k = e.navigation, p = C(k.animation, !0), n = k.arrowSize || 12, r = this.pages, t = this.allItems, q = function(b) {
                    "number" === typeof b ? v.attr({
                        height: b
                    }) : v && (a.clipRect = v.destroy(), a.contentGroup.clip());
                    a.contentGroup.div && (a.contentGroup.div.style.clip = b ? "rect(" + h + "px,9999px," + (h + b) + "px,0)" : "auto");
                }, w = function(b) {
                    a[b] = d.circle(0, 0, 1.3 * n).translate(n / 2, n / 2).add(N);
                    c.styledMode || a[b].attr("fill", "rgba(0,0,0,0.0001)");
                    return a[b];
                }, E, B;
                g = c.spacingBox.height + (f ? -g : g) - h;
                var N = this.nav, v = this.clipRect;
                "horizontal" !== e.layout || "middle" === e.verticalAlign || e.floating || (g /= 2);
                l && (g = Math.min(g, l));
                r.length = 0;
                b && 0 < g && b > g && !1 !== k.enabled ? (this.clipHeight = E = Math.max(g - 20 - this.titleHeight - h, 0), this.currentPage = C(this.currentPage, 1), this.fullHeight = b, t.forEach(function(b, a) {
                    var c = b._legendItemPos[1], d = Math.round(b.legendItem.getBBox().height), e = r.length;
                    if (!e || c - r[e - 1] > E && (B || c) !== r[e - 1]) r.push(B || c), e++;
                    b.pageIx = e - 1;
                    B && (t[a - 1].pageIx = e - 1);
                    a === t.length - 1 && c + d - r[e - 1] > E && d <= E && (r.push(c), b.pageIx = e);
                    c !== B && (B = c);
                }), v || (v = a.clipRect = d.clipRect(0, h, 9999, 0), a.contentGroup.clip(v)), q(E), N || (this.nav = N = d.g().attr({
                    zIndex: 1
                }).add(this.group), this.up = d.symbol("triangle", 0, 0, n, n).add(N), w("upTracker").on("click", function() {
                    a.scroll(-1, p);
                }), this.pager = d.text("", 15, 10).addClass("highcharts-legend-navigation"), c.styledMode || this.pager.css(k.style), this.pager.add(N), this.down = d.symbol("triangle-down", 0, 0, n, n).add(N), w("downTracker").on("click", function() {
                    a.scroll(1, p);
                })), a.scroll(0), b = g) : N && (q(), this.nav = N.destroy(), this.scrollGroup.attr({
                    translateY: 1
                }), this.clipHeight = 0);
                return b;
            };
            a.prototype.scroll = function(a, c) {
                var d = this, e = this.chart, g = this.pages, f = g.length, h = this.clipHeight, l = this.options.navigation, m = this.pager, k = this.padding, p = this.currentPage + a;
                p > f && (p = f);
                0 < p && ("undefined" !== typeof c && A(c, e), this.nav.attr({
                    translateX: k,
                    translateY: h + this.padding + 7 + this.titleHeight,
                    visibility: "visible"
                }), [
                    this.up,
                    this.upTracker
                ].forEach(function(b) {
                    b.attr({
                        "class": 1 === p ? "highcharts-legend-nav-inactive" : "highcharts-legend-nav-active"
                    });
                }), m.attr({
                    text: p + "/" + f
                }), [
                    this.down,
                    this.downTracker
                ].forEach(function(b) {
                    b.attr({
                        x: 18 + this.pager.getBBox().width,
                        "class": p === f ? "highcharts-legend-nav-inactive" : "highcharts-legend-nav-active"
                    });
                }, this), e.styledMode || (this.up.attr({
                    fill: 1 === p ? l.inactiveColor : l.activeColor
                }), this.upTracker.css({
                    cursor: 1 === p ? "default" : "pointer"
                }), this.down.attr({
                    fill: p === f ? l.inactiveColor : l.activeColor
                }), this.downTracker.css({
                    cursor: p === f ? "default" : "pointer"
                })), this.scrollOffset = -g[p - 1] + this.initialItemY, this.scrollGroup.animate({
                    translateY: this.scrollOffset
                }), this.currentPage = p, this.positionCheckboxes(), a = v(C(c, e.renderer.globalAnimation, !0)), b(function() {
                    B(d, "afterScroll", {
                        currentPage: p
                    });
                }, a.duration));
            };
            a.prototype.setItemEvents = function(b, a, c) {
                var d = this, e = d.chart.renderer.boxWrapper, g = b instanceof F, f = "highcharts-legend-" + (g ? "point" : "series") + "-active", h = d.chart.styledMode, l = function(a) {
                    d.allItems.forEach(function(c) {
                        b !== c && [
                            c
                        ].concat(c.linkedSeries || []).forEach(function(b) {
                            b.setState(a, !g);
                        });
                    });
                };
                (c ? [
                    a,
                    b.legendSymbol
                ] : [
                    b.legendGroup
                ]).forEach(function(c) {
                    if (c) c.on("mouseover", function() {
                        b.visible && l("inactive");
                        b.setState("hover");
                        b.visible && e.addClass(f);
                        h || a.css(d.options.itemHoverStyle);
                    }).on("mouseout", function() {
                        d.chart.styledMode || a.css(J(b.visible ? d.itemStyle : d.itemHiddenStyle));
                        l("");
                        e.removeClass(f);
                        b.setState();
                    }).on("click", function(a) {
                        var c = function() {
                            b.setVisible && b.setVisible();
                            l(b.visible ? "inactive" : "");
                        };
                        e.removeClass(f);
                        a = {
                            browserEvent: a
                        };
                        b.firePointEvent ? b.firePointEvent("legendItemClick", a, c) : B(b, "legendItemClick", a, c);
                    });
                });
            };
            a.prototype.createCheckboxForItem = function(b) {
                b.checkbox = c("input", {
                    type: "checkbox",
                    className: "highcharts-legend-checkbox",
                    checked: b.selected,
                    defaultChecked: b.selected
                }, this.options.itemCheckboxStyle, this.chart.container);
                e(b.checkbox, "click", function(a) {
                    B(b.series || b, "checkboxClick", {
                        checked: a.target.checked,
                        item: b
                    }, function() {
                        b.select();
                    });
                });
            };
            return a;
        }();
        (/Trident\/7\.0/.test(z.navigator && z.navigator.userAgent) || a) && y(G.prototype, "positionItem", function(b, a) {
            var c = this, d = function() {
                a._legendItemPos && b.call(c, a);
            };
            d();
            c.bubbleLegend || setTimeout(d);
        });
        "";
        return G;
    });
    M(a, "Core/Series/SeriesRegistry.js", [
        a["Core/Globals.js"],
        a["Core/DefaultOptions.js"],
        a["Core/Series/Point.js"],
        a["Core/Utilities.js"]
    ], function(a, u, z, F) {
        var v = u.defaultOptions, G = F.error, H = F.extendClass, A = F.merge, q;
        (function(n) {
            function k(a, c) {
                var e = v.plotOptions || {}, f = c.defaultOptions;
                c.prototype.pointClass || (c.prototype.pointClass = z);
                c.prototype.type = a;
                f && (e[a] = f);
                n.seriesTypes[a] = c;
            }
            n.seriesTypes = a.seriesTypes;
            n.getSeries = function(a, c) {
                void 0 === c && (c = {});
                var e = a.options.chart;
                e = c.type || e.type || e.defaultSeriesType || "";
                var f = n.seriesTypes[e];
                n || G(17, !0, a, {
                    missingModuleFor: e
                });
                e = new f;
                "function" === typeof e.init && e.init(a, c);
                return e;
            };
            n.registerSeriesType = k;
            n.seriesType = function(a, c, h, f, q) {
                var e = v.plotOptions || {};
                c = c || "";
                e[a] = A(e[c], h);
                k(a, H(n.seriesTypes[c] || function() {}, f));
                n.seriesTypes[a].prototype.type = a;
                q && (n.seriesTypes[a].prototype.pointClass = H(z, q));
                return n.seriesTypes[a];
            };
        })(q || (q = {}));
        return q;
    });
    M(a, "Core/Chart/Chart.js", [
        a["Core/Animation/AnimationUtilities.js"],
        a["Core/Axis/Axis.js"],
        a["Core/FormatUtilities.js"],
        a["Core/Foundation.js"],
        a["Core/Globals.js"],
        a["Core/Legend/Legend.js"],
        a["Core/MSPointer.js"],
        a["Core/DefaultOptions.js"],
        a["Core/Pointer.js"],
        a["Core/Renderer/RendererRegistry.js"],
        a["Core/Series/SeriesRegistry.js"],
        a["Core/Renderer/SVG/SVGRenderer.js"],
        a["Core/Time.js"],
        a["Core/Utilities.js"],
        a["Core/Renderer/HTML/AST.js"]
    ], function(a, u, z, F, y, G, H, A, q, n, k, e, c, h, f) {
        var w = a.animate, p = a.animObject, B = a.setAnimation, t = z.numberFormat, v = F.registerEventOptions, C = y.charts, r = y.doc, l = y.marginNames, b = y.svg, g = y.win, d = A.defaultOptions, m = A.defaultTime, D = k.seriesTypes, x = h.addEvent, I = h.attr, P = h.cleanRecursively, S = h.createElement, O = h.css, U = h.defined, Y = h.discardElement, L = h.erase, K = h.error, M = h.extend, da = h.find, Q = h.fireEvent, ea = h.getStyle, E = h.isArray, T = h.isNumber, N = h.isObject, V = h.isString, W = h.merge, X = h.objectEach, R = h.pick, fa = h.pInt, aa = h.relativeLength, ia = h.removeEvent, ha = h.splat, ba = h.syncTimeout, ka = h.uniqueKey;
        a = function() {
            function a(b, a, c) {
                this.series = this.renderTo = this.renderer = this.pointer = this.pointCount = this.plotWidth = this.plotTop = this.plotLeft = this.plotHeight = this.plotBox = this.options = this.numberFormatter = this.margin = this.legend = this.labelCollectors = this.isResizing = this.index = this.eventOptions = this.container = this.colorCounter = this.clipBox = this.chartWidth = this.chartHeight = this.bounds = this.axisOffset = this.axes = void 0;
                this.sharedClips = {};
                this.yAxis = this.xAxis = this.userOptions = this.titleOffset = this.time = this.symbolCounter = this.spacingBox = this.spacing = void 0;
                this.getArgs(b, a, c);
            }
            a.chart = function(b, c, d) {
                return new a(b, c, d);
            };
            a.prototype.getArgs = function(b, a, c) {
                V(b) || b.nodeName ? (this.renderTo = b, this.init(a, c)) : this.init(b, a);
            };
            a.prototype.init = function(b, a) {
                var e = b.plotOptions || {};
                Q(this, "init", {
                    args: arguments
                }, function() {
                    var g = W(d, b), f = g.chart;
                    X(g.plotOptions, function(b, a) {
                        N(b) && (b.tooltip = e[a] && W(e[a].tooltip) || void 0);
                    });
                    g.tooltip.userOptions = b.chart && b.chart.forExport && b.tooltip.userOptions || b.tooltip;
                    this.userOptions = b;
                    this.margin = [];
                    this.spacing = [];
                    this.bounds = {
                        h: {},
                        v: {}
                    };
                    this.labelCollectors = [];
                    this.callback = a;
                    this.isResizing = 0;
                    this.options = g;
                    this.axes = [];
                    this.series = [];
                    this.time = b.time && Object.keys(b.time).length ? new c(b.time) : y.time;
                    this.numberFormatter = f.numberFormatter || t;
                    this.styledMode = f.styledMode;
                    this.hasCartesianSeries = f.showAxes;
                    this.index = C.length;
                    C.push(this);
                    y.chartCount++;
                    v(this, f);
                    this.xAxis = [];
                    this.yAxis = [];
                    this.pointCount = this.colorCounter = this.symbolCounter = 0;
                    Q(this, "afterInit");
                    this.firstRender();
                });
            };
            a.prototype.initSeries = function(b) {
                var a = this.options.chart;
                a = b.type || a.type || a.defaultSeriesType;
                var c = D[a];
                c || K(17, !0, this, {
                    missingModuleFor: a
                });
                a = new c;
                "function" === typeof a.init && a.init(this, b);
                return a;
            };
            a.prototype.setSeriesData = function() {
                this.getSeriesOrderByLinks().forEach(function(b) {
                    b.points || b.data || !b.enabledDataSorting || b.setData(b.options.data, !1);
                });
            };
            a.prototype.getSeriesOrderByLinks = function() {
                return this.series.concat().sort(function(b, a) {
                    return b.linkedSeries.length || a.linkedSeries.length ? a.linkedSeries.length - b.linkedSeries.length : 0;
                });
            };
            a.prototype.orderSeries = function(b) {
                var a = this.series;
                b = b || 0;
                for(var c = a.length; b < c; ++b)a[b] && (a[b].index = b, a[b].name = a[b].getName());
            };
            a.prototype.isInsidePlot = function(b, a, c) {
                void 0 === c && (c = {});
                var d = this.inverted, e = this.plotBox, g = this.plotLeft, f = this.plotTop, h = this.scrollablePlotBox, l = 0;
                var k = 0;
                c.visiblePlotOnly && this.scrollingContainer && (k = this.scrollingContainer, l = k.scrollLeft, k = k.scrollTop);
                var m = c.series;
                e = c.visiblePlotOnly && h || e;
                h = c.inverted ? a : b;
                a = c.inverted ? b : a;
                b = {
                    x: h,
                    y: a,
                    isInsidePlot: !0
                };
                if (!c.ignoreX) {
                    var p = m && (d ? m.yAxis : m.xAxis) || {
                        pos: g,
                        len: Infinity
                    };
                    h = c.paneCoordinates ? p.pos + h : g + h;
                    h >= Math.max(l + g, p.pos) && h <= Math.min(l + g + e.width, p.pos + p.len) || (b.isInsidePlot = !1);
                }
                !c.ignoreY && b.isInsidePlot && (d = m && (d ? m.xAxis : m.yAxis) || {
                    pos: f,
                    len: Infinity
                }, c = c.paneCoordinates ? d.pos + a : f + a, c >= Math.max(k + f, d.pos) && c <= Math.min(k + f + e.height, d.pos + d.len) || (b.isInsidePlot = !1));
                Q(this, "afterIsInsidePlot", b);
                return b.isInsidePlot;
            };
            a.prototype.redraw = function(b) {
                Q(this, "beforeRedraw");
                var a = this.hasCartesianSeries ? this.axes : this.colorAxis || [], c = this.series, d = this.pointer, e = this.legend, g = this.userOptions.legend, f = this.renderer, h = f.isHidden(), l = [], k = this.isDirtyBox, m = this.isDirtyLegend;
                this.setResponsive && this.setResponsive(!1);
                B(this.hasRendered ? b : !1, this);
                h && this.temporaryDisplay();
                this.layOutTitles();
                for(b = c.length; b--;){
                    var p = c[b];
                    if (p.options.stacking || p.options.centerInCategory) {
                        var n = !0;
                        if (p.isDirty) {
                            var E = !0;
                            break;
                        }
                    }
                }
                if (E) for(b = c.length; b--;)p = c[b], p.options.stacking && (p.isDirty = !0);
                c.forEach(function(b) {
                    b.isDirty && ("point" === b.options.legendType ? ("function" === typeof b.updateTotals && b.updateTotals(), m = !0) : g && (g.labelFormatter || g.labelFormat) && (m = !0));
                    b.isDirtyData && Q(b, "updatedData");
                });
                m && e && e.options.enabled && (e.render(), this.isDirtyLegend = !1);
                n && this.getStacks();
                a.forEach(function(b) {
                    b.updateNames();
                    b.setScale();
                });
                this.getMargins();
                a.forEach(function(b) {
                    b.isDirty && (k = !0);
                });
                a.forEach(function(b) {
                    var a = b.min + "," + b.max;
                    b.extKey !== a && (b.extKey = a, l.push(function() {
                        Q(b, "afterSetExtremes", M(b.eventArgs, b.getExtremes()));
                        delete b.eventArgs;
                    }));
                    (k || n) && b.redraw();
                });
                k && this.drawChartBox();
                Q(this, "predraw");
                c.forEach(function(b) {
                    (k || b.isDirty) && b.visible && b.redraw();
                    b.isDirtyData = !1;
                });
                d && d.reset(!0);
                f.draw();
                Q(this, "redraw");
                Q(this, "render");
                h && this.temporaryDisplay(!0);
                l.forEach(function(b) {
                    b.call();
                });
            };
            a.prototype.get = function(b) {
                function a(a) {
                    return a.id === b || a.options && a.options.id === b;
                }
                for(var c = this.series, d = da(this.axes, a) || da(this.series, a), e = 0; !d && e < c.length; e++)d = da(c[e].points || [], a);
                return d;
            };
            a.prototype.getAxes = function() {
                var b = this, a = this.options, c = a.xAxis = ha(a.xAxis || {});
                a = a.yAxis = ha(a.yAxis || {});
                Q(this, "getAxes");
                c.forEach(function(b, a) {
                    b.index = a;
                    b.isX = !0;
                });
                a.forEach(function(b, a) {
                    b.index = a;
                });
                c.concat(a).forEach(function(a) {
                    new u(b, a);
                });
                Q(this, "afterGetAxes");
            };
            a.prototype.getSelectedPoints = function() {
                return this.series.reduce(function(b, a) {
                    a.getPointsCollection().forEach(function(a) {
                        R(a.selectedStaging, a.selected) && b.push(a);
                    });
                    return b;
                }, []);
            };
            a.prototype.getSelectedSeries = function() {
                return this.series.filter(function(b) {
                    return b.selected;
                });
            };
            a.prototype.setTitle = function(b, a, c) {
                this.applyDescription("title", b);
                this.applyDescription("subtitle", a);
                this.applyDescription("caption", void 0);
                this.layOutTitles(c);
            };
            a.prototype.applyDescription = function(b, a) {
                var c = this, d = "title" === b ? {
                    color: "#333333",
                    fontSize: this.options.isStock ? "16px" : "18px"
                } : {
                    color: "#666666"
                };
                d = this.options[b] = W(!this.styledMode && {
                    style: d
                }, this.options[b], a);
                var e = this[b];
                e && a && (this[b] = e = e.destroy());
                d && !e && (e = this.renderer.text(d.text, 0, 0, d.useHTML).attr({
                    align: d.align,
                    "class": "highcharts-" + b,
                    zIndex: d.zIndex || 4
                }).add(), e.update = function(a) {
                    c[({
                        title: "setTitle",
                        subtitle: "setSubtitle",
                        caption: "setCaption"
                    })[b]](a);
                }, this.styledMode || e.css(d.style), this[b] = e);
            };
            a.prototype.layOutTitles = function(b) {
                var a = [
                    0,
                    0,
                    0
                ], c = this.renderer, d = this.spacingBox;
                [
                    "title",
                    "subtitle",
                    "caption"
                ].forEach(function(b) {
                    var e = this[b], g = this.options[b], f = g.verticalAlign || "top";
                    b = "title" === b ? "top" === f ? -3 : 0 : "top" === f ? a[0] + 2 : 0;
                    var h;
                    if (e) {
                        this.styledMode || (h = g.style && g.style.fontSize);
                        h = c.fontMetrics(h, e).b;
                        e.css({
                            width: (g.width || d.width + (g.widthAdjust || 0)) + "px"
                        });
                        var l = Math.round(e.getBBox(g.useHTML).height);
                        e.align(M({
                            y: "bottom" === f ? h : b + h,
                            height: l
                        }, g), !1, "spacingBox");
                        g.floating || ("top" === f ? a[0] = Math.ceil(a[0] + l) : "bottom" === f && (a[2] = Math.ceil(a[2] + l)));
                    }
                }, this);
                a[0] && "top" === (this.options.title.verticalAlign || "top") && (a[0] += this.options.title.margin);
                a[2] && "bottom" === this.options.caption.verticalAlign && (a[2] += this.options.caption.margin);
                var e = !this.titleOffset || this.titleOffset.join(",") !== a.join(",");
                this.titleOffset = a;
                Q(this, "afterLayOutTitles");
                !this.isDirtyBox && e && (this.isDirtyBox = this.isDirtyLegend = e, this.hasRendered && R(b, !0) && this.isDirtyBox && this.redraw());
            };
            a.prototype.getChartSize = function() {
                var b = this.options.chart, a = b.width;
                b = b.height;
                var c = this.renderTo;
                U(a) || (this.containerWidth = ea(c, "width"));
                U(b) || (this.containerHeight = ea(c, "height"));
                this.chartWidth = Math.max(0, a || this.containerWidth || 600);
                this.chartHeight = Math.max(0, aa(b, this.chartWidth) || (1 < this.containerHeight ? this.containerHeight : 400));
            };
            a.prototype.temporaryDisplay = function(b) {
                var a = this.renderTo;
                if (b) for(; a && a.style;)a.hcOrigStyle && (O(a, a.hcOrigStyle), delete a.hcOrigStyle), a.hcOrigDetached && (r.body.removeChild(a), a.hcOrigDetached = !1), a = a.parentNode;
                else for(; a && a.style;){
                    r.body.contains(a) || a.parentNode || (a.hcOrigDetached = !0, r.body.appendChild(a));
                    if ("none" === ea(a, "display", !1) || a.hcOricDetached) a.hcOrigStyle = {
                        display: a.style.display,
                        height: a.style.height,
                        overflow: a.style.overflow
                    }, b = {
                        display: "block",
                        overflow: "hidden"
                    }, a !== this.renderTo && (b.height = 0), O(a, b), a.offsetWidth || a.style.setProperty("display", "block", "important");
                    a = a.parentNode;
                    if (a === r.body) break;
                }
            };
            a.prototype.setClassName = function(b) {
                this.container.className = "highcharts-container " + (b || "");
            };
            a.prototype.getContainer = function() {
                var a = this.options, c = a.chart, d = ka(), g, h = this.renderTo;
                h || (this.renderTo = h = c.renderTo);
                V(h) && (this.renderTo = h = r.getElementById(h));
                h || K(13, !0, this);
                var l = fa(I(h, "data-highcharts-chart"));
                T(l) && C[l] && C[l].hasRendered && C[l].destroy();
                I(h, "data-highcharts-chart", this.index);
                h.innerHTML = f.emptyHTML;
                c.skipClone || h.offsetWidth || this.temporaryDisplay();
                this.getChartSize();
                l = this.chartWidth;
                var k = this.chartHeight;
                O(h, {
                    overflow: "hidden"
                });
                this.styledMode || (g = M({
                    position: "relative",
                    overflow: "hidden",
                    width: l + "px",
                    height: k + "px",
                    textAlign: "left",
                    lineHeight: "normal",
                    zIndex: 0,
                    "-webkit-tap-highlight-color": "rgba(0,0,0,0)",
                    userSelect: "none",
                    "touch-action": "manipulation",
                    outline: "none"
                }, c.style || {}));
                this.container = d = S("div", {
                    id: d
                }, g, h);
                this._cursor = d.style.cursor;
                this.renderer = new (c.renderer || !b ? n.getRendererType(c.renderer) : e)(d, l, k, void 0, c.forExport, a.exporting && a.exporting.allowHTML, this.styledMode);
                B(void 0, this);
                this.setClassName(c.className);
                if (this.styledMode) for(var m in a.defs)this.renderer.definition(a.defs[m]);
                else this.renderer.setStyle(c.style);
                this.renderer.chartIndex = this.index;
                Q(this, "afterGetContainer");
            };
            a.prototype.getMargins = function(b) {
                var a = this.spacing, c = this.margin, d = this.titleOffset;
                this.resetMargins();
                d[0] && !U(c[0]) && (this.plotTop = Math.max(this.plotTop, d[0] + a[0]));
                d[2] && !U(c[2]) && (this.marginBottom = Math.max(this.marginBottom, d[2] + a[2]));
                this.legend && this.legend.display && this.legend.adjustMargins(c, a);
                Q(this, "getMargins");
                b || this.getAxisMargins();
            };
            a.prototype.getAxisMargins = function() {
                var b = this, a = b.axisOffset = [
                    0,
                    0,
                    0,
                    0
                ], c = b.colorAxis, d = b.margin, e = function(b) {
                    b.forEach(function(b) {
                        b.visible && b.getOffset();
                    });
                };
                b.hasCartesianSeries ? e(b.axes) : c && c.length && e(c);
                l.forEach(function(c, e) {
                    U(d[e]) || (b[c] += a[e]);
                });
                b.setChartSize();
            };
            a.prototype.reflow = function(b) {
                var a = this, c = a.options.chart, d = a.renderTo, e = U(c.width) && U(c.height), f = c.width || ea(d, "width");
                c = c.height || ea(d, "height");
                d = b ? b.target : g;
                delete a.pointer.chartPosition;
                if (!e && !a.isPrinting && f && c && (d === g || d === r)) {
                    if (f !== a.containerWidth || c !== a.containerHeight) h.clearTimeout(a.reflowTimeout), a.reflowTimeout = ba(function() {
                        a.container && a.setSize(void 0, void 0, !1);
                    }, b ? 100 : 0);
                    a.containerWidth = f;
                    a.containerHeight = c;
                }
            };
            a.prototype.setReflow = function(b) {
                var a = this;
                !1 === b || this.unbindReflow ? !1 === b && this.unbindReflow && (this.unbindReflow = this.unbindReflow()) : (this.unbindReflow = x(g, "resize", function(b) {
                    a.options && a.reflow(b);
                }), x(this, "destroy", this.unbindReflow));
            };
            a.prototype.setSize = function(b, a, c) {
                var d = this, e = d.renderer;
                d.isResizing += 1;
                B(c, d);
                c = e.globalAnimation;
                d.oldChartHeight = d.chartHeight;
                d.oldChartWidth = d.chartWidth;
                "undefined" !== typeof b && (d.options.chart.width = b);
                "undefined" !== typeof a && (d.options.chart.height = a);
                d.getChartSize();
                d.styledMode || (c ? w : O)(d.container, {
                    width: d.chartWidth + "px",
                    height: d.chartHeight + "px"
                }, c);
                d.setChartSize(!0);
                e.setSize(d.chartWidth, d.chartHeight, c);
                d.axes.forEach(function(b) {
                    b.isDirty = !0;
                    b.setScale();
                });
                d.isDirtyLegend = !0;
                d.isDirtyBox = !0;
                d.layOutTitles();
                d.getMargins();
                d.redraw(c);
                d.oldChartHeight = null;
                Q(d, "resize");
                ba(function() {
                    d && Q(d, "endResize", null, function() {
                        --d.isResizing;
                    });
                }, p(c).duration);
            };
            a.prototype.setChartSize = function(b) {
                var a = this.inverted, c = this.renderer, d = this.chartWidth, e = this.chartHeight, g = this.options.chart, f = this.spacing, h = this.clipOffset, l, k, m, p;
                this.plotLeft = l = Math.round(this.plotLeft);
                this.plotTop = k = Math.round(this.plotTop);
                this.plotWidth = m = Math.max(0, Math.round(d - l - this.marginRight));
                this.plotHeight = p = Math.max(0, Math.round(e - k - this.marginBottom));
                this.plotSizeX = a ? p : m;
                this.plotSizeY = a ? m : p;
                this.plotBorderWidth = g.plotBorderWidth || 0;
                this.spacingBox = c.spacingBox = {
                    x: f[3],
                    y: f[0],
                    width: d - f[3] - f[1],
                    height: e - f[0] - f[2]
                };
                this.plotBox = c.plotBox = {
                    x: l,
                    y: k,
                    width: m,
                    height: p
                };
                a = 2 * Math.floor(this.plotBorderWidth / 2);
                d = Math.ceil(Math.max(a, h[3]) / 2);
                e = Math.ceil(Math.max(a, h[0]) / 2);
                this.clipBox = {
                    x: d,
                    y: e,
                    width: Math.floor(this.plotSizeX - Math.max(a, h[1]) / 2 - d),
                    height: Math.max(0, Math.floor(this.plotSizeY - Math.max(a, h[2]) / 2 - e))
                };
                b || (this.axes.forEach(function(b) {
                    b.setAxisSize();
                    b.setAxisTranslation();
                }), c.alignElements());
                Q(this, "afterSetChartSize", {
                    skipAxes: b
                });
            };
            a.prototype.resetMargins = function() {
                Q(this, "resetMargins");
                var b = this, a = b.options.chart;
                [
                    "margin",
                    "spacing"
                ].forEach(function(c) {
                    var d = a[c], e = N(d) ? d : [
                        d,
                        d,
                        d,
                        d
                    ];
                    [
                        "Top",
                        "Right",
                        "Bottom",
                        "Left"
                    ].forEach(function(d, g) {
                        b[c][g] = R(a[c + d], e[g]);
                    });
                });
                l.forEach(function(a, c) {
                    b[a] = R(b.margin[c], b.spacing[c]);
                });
                b.axisOffset = [
                    0,
                    0,
                    0,
                    0
                ];
                b.clipOffset = [
                    0,
                    0,
                    0,
                    0
                ];
            };
            a.prototype.drawChartBox = function() {
                var b = this.options.chart, a = this.renderer, c = this.chartWidth, d = this.chartHeight, e = this.styledMode, g = this.plotBGImage, f = b.backgroundColor, h = b.plotBackgroundColor, l = b.plotBackgroundImage, k = this.plotLeft, m = this.plotTop, p = this.plotWidth, n = this.plotHeight, E = this.plotBox, r = this.clipRect, t = this.clipBox, q = this.chartBackground, N = this.plotBackground, w = this.plotBorder, B, C = "animate";
                q || (this.chartBackground = q = a.rect().addClass("highcharts-background").add(), C = "attr");
                if (e) var x = B = q.strokeWidth();
                else {
                    x = b.borderWidth || 0;
                    B = x + (b.shadow ? 8 : 0);
                    f = {
                        fill: f || "none"
                    };
                    if (x || q["stroke-width"]) f.stroke = b.borderColor, f["stroke-width"] = x;
                    q.attr(f).shadow(b.shadow);
                }
                q[C]({
                    x: B / 2,
                    y: B / 2,
                    width: c - B - x % 2,
                    height: d - B - x % 2,
                    r: b.borderRadius
                });
                C = "animate";
                N || (C = "attr", this.plotBackground = N = a.rect().addClass("highcharts-plot-background").add());
                N[C](E);
                e || (N.attr({
                    fill: h || "none"
                }).shadow(b.plotShadow), l && (g ? (l !== g.attr("href") && g.attr("href", l), g.animate(E)) : this.plotBGImage = a.image(l, k, m, p, n).add()));
                r ? r.animate({
                    width: t.width,
                    height: t.height
                }) : this.clipRect = a.clipRect(t);
                C = "animate";
                w || (C = "attr", this.plotBorder = w = a.rect().addClass("highcharts-plot-border").attr({
                    zIndex: 1
                }).add());
                e || w.attr({
                    stroke: b.plotBorderColor,
                    "stroke-width": b.plotBorderWidth || 0,
                    fill: "none"
                });
                w[C](w.crisp({
                    x: k,
                    y: m,
                    width: p,
                    height: n
                }, -w.strokeWidth()));
                this.isDirtyBox = !1;
                Q(this, "afterDrawChartBox");
            };
            a.prototype.propFromSeries = function() {
                var b = this, a = b.options.chart, c = b.options.series, d, e, g;
                [
                    "inverted",
                    "angular",
                    "polar"
                ].forEach(function(f) {
                    e = D[a.type || a.defaultSeriesType];
                    g = a[f] || e && e.prototype[f];
                    for(d = c && c.length; !g && d--;)(e = D[c[d].type]) && e.prototype[f] && (g = !0);
                    b[f] = g;
                });
            };
            a.prototype.linkSeries = function() {
                var b = this, a = b.series;
                a.forEach(function(b) {
                    b.linkedSeries.length = 0;
                });
                a.forEach(function(a) {
                    var c = a.options.linkedTo;
                    V(c) && (c = ":previous" === c ? b.series[a.index - 1] : b.get(c)) && c.linkedParent !== a && (c.linkedSeries.push(a), a.linkedParent = c, c.enabledDataSorting && a.setDataSortingOptions(), a.visible = R(a.options.visible, c.options.visible, a.visible));
                });
                Q(this, "afterLinkSeries");
            };
            a.prototype.renderSeries = function() {
                this.series.forEach(function(b) {
                    b.translate();
                    b.render();
                });
            };
            a.prototype.renderLabels = function() {
                var b = this, a = b.options.labels;
                a.items && a.items.forEach(function(c) {
                    var d = M(a.style, c.style), e = fa(d.left) + b.plotLeft, g = fa(d.top) + b.plotTop + 12;
                    delete d.left;
                    delete d.top;
                    b.renderer.text(c.html, e, g).attr({
                        zIndex: 2
                    }).css(d).add();
                });
            };
            a.prototype.render = function() {
                var b = this.axes, a = this.colorAxis, c = this.renderer, d = this.options, e = function(b) {
                    b.forEach(function(b) {
                        b.visible && b.render();
                    });
                }, g = 0;
                this.setTitle();
                this.legend = new G(this, d.legend);
                this.getStacks && this.getStacks();
                this.getMargins(!0);
                this.setChartSize();
                d = this.plotWidth;
                b.some(function(b) {
                    if (b.horiz && b.visible && b.options.labels.enabled && b.series.length) return g = 21, !0;
                });
                var f = this.plotHeight = Math.max(this.plotHeight - g, 0);
                b.forEach(function(b) {
                    b.setScale();
                });
                this.getAxisMargins();
                var h = 1.1 < d / this.plotWidth, l = 1.05 < f / this.plotHeight;
                if (h || l) b.forEach(function(b) {
                    (b.horiz && h || !b.horiz && l) && b.setTickInterval(!0);
                }), this.getMargins();
                this.drawChartBox();
                this.hasCartesianSeries ? e(b) : a && a.length && e(a);
                this.seriesGroup || (this.seriesGroup = c.g("series-group").attr({
                    zIndex: 3
                }).add());
                this.renderSeries();
                this.renderLabels();
                this.addCredits();
                this.setResponsive && this.setResponsive();
                this.hasRendered = !0;
            };
            a.prototype.addCredits = function(b) {
                var a = this, c = W(!0, this.options.credits, b);
                c.enabled && !this.credits && (this.credits = this.renderer.text(c.text + (this.mapCredits || ""), 0, 0).addClass("highcharts-credits").on("click", function() {
                    c.href && (g.location.href = c.href);
                }).attr({
                    align: c.position.align,
                    zIndex: 8
                }), a.styledMode || this.credits.css(c.style), this.credits.add().align(c.position), this.credits.update = function(b) {
                    a.credits = a.credits.destroy();
                    a.addCredits(b);
                });
            };
            a.prototype.destroy = function() {
                var b = this, a = b.axes, c = b.series, d = b.container, e = d && d.parentNode, g;
                Q(b, "destroy");
                b.renderer.forExport ? L(C, b) : C[b.index] = void 0;
                y.chartCount--;
                b.renderTo.removeAttribute("data-highcharts-chart");
                ia(b);
                for(g = a.length; g--;)a[g] = a[g].destroy();
                this.scroller && this.scroller.destroy && this.scroller.destroy();
                for(g = c.length; g--;)c[g] = c[g].destroy();
                "title subtitle chartBackground plotBackground plotBGImage plotBorder seriesGroup clipRect credits pointer rangeSelector legend resetZoomButton tooltip renderer".split(" ").forEach(function(a) {
                    var c = b[a];
                    c && c.destroy && (b[a] = c.destroy());
                });
                d && (d.innerHTML = f.emptyHTML, ia(d), e && Y(d));
                X(b, function(a, c) {
                    delete b[c];
                });
            };
            a.prototype.firstRender = function() {
                var b = this, a = b.options;
                if (!b.isReadyToRender || b.isReadyToRender()) {
                    b.getContainer();
                    b.resetMargins();
                    b.setChartSize();
                    b.propFromSeries();
                    b.getAxes();
                    (E(a.series) ? a.series : []).forEach(function(a) {
                        b.initSeries(a);
                    });
                    b.linkSeries();
                    b.setSeriesData();
                    Q(b, "beforeRender");
                    q && (H.isRequired() ? b.pointer = new H(b, a) : b.pointer = new q(b, a));
                    b.render();
                    b.pointer.getChartPosition();
                    if (!b.renderer.imgCount && !b.hasLoaded) b.onload();
                    b.temporaryDisplay(!0);
                }
            };
            a.prototype.onload = function() {
                this.callbacks.concat([
                    this.callback
                ]).forEach(function(b) {
                    b && "undefined" !== typeof this.index && b.apply(this, [
                        this
                    ]);
                }, this);
                Q(this, "load");
                Q(this, "render");
                U(this.index) && this.setReflow(this.options.chart.reflow);
                this.hasLoaded = !0;
            };
            a.prototype.addSeries = function(b, a, c) {
                var d = this, e;
                b && (a = R(a, !0), Q(d, "addSeries", {
                    options: b
                }, function() {
                    e = d.initSeries(b);
                    d.isDirtyLegend = !0;
                    d.linkSeries();
                    e.enabledDataSorting && e.setData(b.data, !1);
                    Q(d, "afterAddSeries", {
                        series: e
                    });
                    a && d.redraw(c);
                }));
                return e;
            };
            a.prototype.addAxis = function(b, a, c, d) {
                return this.createAxis(a ? "xAxis" : "yAxis", {
                    axis: b,
                    redraw: c,
                    animation: d
                });
            };
            a.prototype.addColorAxis = function(b, a, c) {
                return this.createAxis("colorAxis", {
                    axis: b,
                    redraw: a,
                    animation: c
                });
            };
            a.prototype.createAxis = function(b, a) {
                b = new u(this, W(a.axis, {
                    index: this[b].length,
                    isX: "xAxis" === b
                }));
                R(a.redraw, !0) && this.redraw(a.animation);
                return b;
            };
            a.prototype.showLoading = function(b) {
                var a = this, c = a.options, d = c.loading, e = function() {
                    g && O(g, {
                        left: a.plotLeft + "px",
                        top: a.plotTop + "px",
                        width: a.plotWidth + "px",
                        height: a.plotHeight + "px"
                    });
                }, g = a.loadingDiv, h = a.loadingSpan;
                g || (a.loadingDiv = g = S("div", {
                    className: "highcharts-loading highcharts-loading-hidden"
                }, null, a.container));
                h || (a.loadingSpan = h = S("span", {
                    className: "highcharts-loading-inner"
                }, null, g), x(a, "redraw", e));
                g.className = "highcharts-loading";
                f.setElementHTML(h, R(b, c.lang.loading, ""));
                a.styledMode || (O(g, M(d.style, {
                    zIndex: 10
                })), O(h, d.labelStyle), a.loadingShown || (O(g, {
                    opacity: 0,
                    display: ""
                }), w(g, {
                    opacity: d.style.opacity || .5
                }, {
                    duration: d.showDuration || 0
                })));
                a.loadingShown = !0;
                e();
            };
            a.prototype.hideLoading = function() {
                var b = this.options, a = this.loadingDiv;
                a && (a.className = "highcharts-loading highcharts-loading-hidden", this.styledMode || w(a, {
                    opacity: 0
                }, {
                    duration: b.loading.hideDuration || 100,
                    complete: function() {
                        O(a, {
                            display: "none"
                        });
                    }
                }));
                this.loadingShown = !1;
            };
            a.prototype.update = function(b, a, d, e) {
                var g = this, f = {
                    credits: "addCredits",
                    title: "setTitle",
                    subtitle: "setSubtitle",
                    caption: "setCaption"
                }, h = b.isResponsiveOptions, l = [], k, p;
                Q(g, "update", {
                    options: b
                });
                h || g.setResponsive(!1, !0);
                b = P(b, g.options);
                g.userOptions = W(g.userOptions, b);
                var n = b.chart;
                if (n) {
                    W(!0, g.options.chart, n);
                    "className" in n && g.setClassName(n.className);
                    "reflow" in n && g.setReflow(n.reflow);
                    if ("inverted" in n || "polar" in n || "type" in n) {
                        g.propFromSeries();
                        var E = !0;
                    }
                    "alignTicks" in n && (E = !0);
                    "events" in n && v(this, n);
                    X(n, function(b, a) {
                        -1 !== g.propsRequireUpdateSeries.indexOf("chart." + a) && (k = !0);
                        -1 !== g.propsRequireDirtyBox.indexOf(a) && (g.isDirtyBox = !0);
                        -1 !== g.propsRequireReflow.indexOf(a) && (h ? g.isDirtyBox = !0 : p = !0);
                    });
                    !g.styledMode && n.style && g.renderer.setStyle(g.options.chart.style || {});
                }
                !g.styledMode && b.colors && (this.options.colors = b.colors);
                b.time && (this.time === m && (this.time = new c(b.time)), W(!0, g.options.time, b.time));
                X(b, function(a, c) {
                    if (g[c] && "function" === typeof g[c].update) g[c].update(a, !1);
                    else if ("function" === typeof g[f[c]]) g[f[c]](a);
                    else "colors" !== c && -1 === g.collectionsWithUpdate.indexOf(c) && W(!0, g.options[c], b[c]);
                    "chart" !== c && -1 !== g.propsRequireUpdateSeries.indexOf(c) && (k = !0);
                });
                this.collectionsWithUpdate.forEach(function(a) {
                    if (b[a]) {
                        var c = [];
                        g[a].forEach(function(b, a) {
                            b.options.isInternal || c.push(R(b.options.index, a));
                        });
                        ha(b[a]).forEach(function(b, e) {
                            var f = U(b.id), h;
                            f && (h = g.get(b.id));
                            !h && g[a] && (h = g[a][c ? c[e] : e]) && f && U(h.options.id) && (h = void 0);
                            h && h.coll === a && (h.update(b, !1), d && (h.touched = !0));
                            !h && d && g.collectionsWithInit[a] && (g.collectionsWithInit[a][0].apply(g, [
                                b
                            ].concat(g.collectionsWithInit[a][1] || []).concat([
                                !1
                            ])).touched = !0);
                        });
                        d && g[a].forEach(function(b) {
                            b.touched || b.options.isInternal ? delete b.touched : l.push(b);
                        });
                    }
                });
                l.forEach(function(b) {
                    b.chart && b.remove && b.remove(!1);
                });
                E && g.axes.forEach(function(b) {
                    b.update({}, !1);
                });
                k && g.getSeriesOrderByLinks().forEach(function(b) {
                    b.chart && b.update({}, !1);
                }, this);
                E = n && n.width;
                n = n && (V(n.height) ? aa(n.height, E || g.chartWidth) : n.height);
                p || T(E) && E !== g.chartWidth || T(n) && n !== g.chartHeight ? g.setSize(E, n, e) : R(a, !0) && g.redraw(e);
                Q(g, "afterUpdate", {
                    options: b,
                    redraw: a,
                    animation: e
                });
            };
            a.prototype.setSubtitle = function(b, a) {
                this.applyDescription("subtitle", b);
                this.layOutTitles(a);
            };
            a.prototype.setCaption = function(b, a) {
                this.applyDescription("caption", b);
                this.layOutTitles(a);
            };
            a.prototype.showResetZoom = function() {
                function b() {
                    a.zoomOut();
                }
                var a = this, c = d.lang, e = a.options.chart.resetZoomButton, g = e.theme, f = g.states, h = "chart" === e.relativeTo || "spacingBox" === e.relativeTo ? null : "scrollablePlotBox";
                Q(this, "beforeShowResetZoom", null, function() {
                    a.resetZoomButton = a.renderer.button(c.resetZoom, null, null, b, g, f && f.hover).attr({
                        align: e.position.align,
                        title: c.resetZoomTitle
                    }).addClass("highcharts-reset-zoom").add().align(e.position, !1, h);
                });
                Q(this, "afterShowResetZoom");
            };
            a.prototype.zoomOut = function() {
                Q(this, "selection", {
                    resetSelection: !0
                }, this.zoom);
            };
            a.prototype.zoom = function(b) {
                var a = this, c = a.pointer, d = a.inverted ? c.mouseDownX : c.mouseDownY, e = !1, g;
                !b || b.resetSelection ? (a.axes.forEach(function(b) {
                    g = b.zoom();
                }), c.initiated = !1) : b.xAxis.concat(b.yAxis).forEach(function(b) {
                    var f = b.axis, h = a.inverted ? f.left : f.top, l = a.inverted ? h + f.width : h + f.height, k = f.isXAxis, m = !1;
                    if (!k && d >= h && d <= l || k || !U(d)) m = !0;
                    c[k ? "zoomX" : "zoomY"] && m && (g = f.zoom(b.min, b.max), f.displayBtn && (e = !0));
                });
                var f = a.resetZoomButton;
                e && !f ? a.showResetZoom() : !e && N(f) && (a.resetZoomButton = f.destroy());
                g && a.redraw(R(a.options.chart.animation, b && b.animation, 100 > a.pointCount));
            };
            a.prototype.pan = function(b, a) {
                var c = this, d = c.hoverPoints;
                a = "object" === typeof a ? a : {
                    enabled: a,
                    type: "x"
                };
                var e = c.options.chart, g = c.options.mapNavigation && c.options.mapNavigation.enabled;
                e && e.panning && (e.panning = a);
                var f = a.type, h;
                Q(this, "pan", {
                    originalEvent: b
                }, function() {
                    d && d.forEach(function(b) {
                        b.setState();
                    });
                    var a = c.xAxis;
                    "xy" === f ? a = a.concat(c.yAxis) : "y" === f && (a = c.yAxis);
                    var e = {};
                    a.forEach(function(a) {
                        if (a.options.panningEnabled && !a.options.isInternal) {
                            var d = a.horiz, l = b[d ? "chartX" : "chartY"];
                            d = d ? "mouseDownX" : "mouseDownY";
                            var k = c[d], m = a.minPointOffset || 0, p = a.reversed && !c.inverted || !a.reversed && c.inverted ? -1 : 1, n = a.getExtremes(), E = a.toValue(k - l, !0) + m * p, r = a.toValue(k + a.len - l, !0) - (m * p || a.isXAxis && a.pointRangePadding || 0), t = r < E;
                            p = a.hasVerticalPanning();
                            k = t ? r : E;
                            E = t ? E : r;
                            var q = a.panningState;
                            !p || a.isXAxis || q && !q.isDirty || a.series.forEach(function(b) {
                                var a = b.getProcessedData(!0);
                                a = b.getExtremes(a.yData, !0);
                                q || (q = {
                                    startMin: Number.MAX_VALUE,
                                    startMax: -Number.MAX_VALUE
                                });
                                T(a.dataMin) && T(a.dataMax) && (q.startMin = Math.min(R(b.options.threshold, Infinity), a.dataMin, q.startMin), q.startMax = Math.max(R(b.options.threshold, -Infinity), a.dataMax, q.startMax));
                            });
                            p = Math.min(R(q && q.startMin, n.dataMin), m ? n.min : a.toValue(a.toPixels(n.min) - a.minPixelPadding));
                            r = Math.max(R(q && q.startMax, n.dataMax), m ? n.max : a.toValue(a.toPixels(n.max) + a.minPixelPadding));
                            a.panningState = q;
                            a.isOrdinal || (m = p - k, 0 < m && (E += m, k = p), m = E - r, 0 < m && (E = r, k -= m), a.series.length && k !== n.min && E !== n.max && k >= p && E <= r && (a.setExtremes(k, E, !1, !1, {
                                trigger: "pan"
                            }), c.resetZoomButton || g || k === p || E === r || !f.match("y") || (c.showResetZoom(), a.displayBtn = !1), h = !0), e[d] = l);
                        }
                    });
                    X(e, function(b, a) {
                        c[a] = b;
                    });
                    h && c.redraw(!1);
                    O(c.container, {
                        cursor: "move"
                    });
                });
            };
            return a;
        }();
        M(a.prototype, {
            callbacks: [],
            collectionsWithInit: {
                xAxis: [
                    a.prototype.addAxis,
                    [
                        !0
                    ]
                ],
                yAxis: [
                    a.prototype.addAxis,
                    [
                        !1
                    ]
                ],
                series: [
                    a.prototype.addSeries
                ]
            },
            collectionsWithUpdate: [
                "xAxis",
                "yAxis",
                "series"
            ],
            propsRequireDirtyBox: "backgroundColor borderColor borderWidth borderRadius plotBackgroundColor plotBackgroundImage plotBorderColor plotBorderWidth plotShadow shadow".split(" "),
            propsRequireReflow: "margin marginTop marginRight marginBottom marginLeft spacing spacingTop spacingRight spacingBottom spacingLeft".split(" "),
            propsRequireUpdateSeries: "chart.inverted chart.polar chart.ignoreHiddenSeries chart.type colors plotOptions time tooltip".split(" ")
        });
        "";
        return a;
    });
    M(a, "Core/Legend/LegendSymbol.js", [
        a["Core/Utilities.js"]
    ], function(a) {
        var v = a.merge, z = a.pick, F;
        (function(a) {
            a.drawLineMarker = function(a) {
                var u = this.options, A = a.symbolWidth, q = a.symbolHeight, n = q / 2, k = this.chart.renderer, e = this.legendGroup;
                a = a.baseline - Math.round(.3 * a.fontMetrics.b);
                var c = {}, h = u.marker;
                this.chart.styledMode || (c = {
                    "stroke-width": u.lineWidth || 0
                }, u.dashStyle && (c.dashstyle = u.dashStyle));
                this.legendLine = k.path([
                    [
                        "M",
                        0,
                        a
                    ],
                    [
                        "L",
                        A,
                        a
                    ]
                ]).addClass("highcharts-graph").attr(c).add(e);
                h && !1 !== h.enabled && A && (u = Math.min(z(h.radius, n), n), 0 === this.symbol.indexOf("url") && (h = v(h, {
                    width: q,
                    height: q
                }), u = 0), this.legendSymbol = A = k.symbol(this.symbol, A / 2 - u, a - u, 2 * u, 2 * u, h).addClass("highcharts-point").add(e), A.isMarker = !0);
            };
            a.drawRectangle = function(a, v) {
                var u = a.symbolHeight, q = a.options.squareSymbol;
                v.legendSymbol = this.chart.renderer.rect(q ? (a.symbolWidth - u) / 2 : 0, a.baseline - u + 1, q ? u : a.symbolWidth, u, z(a.options.symbolRadius, u / 2)).addClass("highcharts-point").attr({
                    zIndex: 3
                }).add(v.legendGroup);
            };
        })(F || (F = {}));
        return F;
    });
    M(a, "Core/Series/SeriesDefaults.js", [], function() {
        return {
            lineWidth: 2,
            allowPointSelect: !1,
            crisp: !0,
            showCheckbox: !1,
            animation: {
                duration: 1E3
            },
            events: {},
            marker: {
                enabledThreshold: 2,
                lineColor: "#ffffff",
                lineWidth: 0,
                radius: 4,
                states: {
                    normal: {
                        animation: !0
                    },
                    hover: {
                        animation: {
                            duration: 50
                        },
                        enabled: !0,
                        radiusPlus: 2,
                        lineWidthPlus: 1
                    },
                    select: {
                        fillColor: "#cccccc",
                        lineColor: "#000000",
                        lineWidth: 2
                    }
                }
            },
            point: {
                events: {}
            },
            dataLabels: {
                animation: {},
                align: "center",
                defer: !0,
                formatter: function() {
                    var a = this.series.chart.numberFormatter;
                    return "number" !== typeof this.y ? "" : a(this.y, -1);
                },
                padding: 5,
                style: {
                    fontSize: "11px",
                    fontWeight: "bold",
                    color: "contrast",
                    textOutline: "1px contrast"
                },
                verticalAlign: "bottom",
                x: 0,
                y: 0
            },
            cropThreshold: 300,
            opacity: 1,
            pointRange: 0,
            softThreshold: !0,
            states: {
                normal: {
                    animation: !0
                },
                hover: {
                    animation: {
                        duration: 50
                    },
                    lineWidthPlus: 1,
                    marker: {},
                    halo: {
                        size: 10,
                        opacity: .25
                    }
                },
                select: {
                    animation: {
                        duration: 0
                    }
                },
                inactive: {
                    animation: {
                        duration: 50
                    },
                    opacity: .2
                }
            },
            stickyTracking: !0,
            turboThreshold: 1E3,
            findNearestPointBy: "x"
        };
    });
    M(a, "Core/Series/Series.js", [
        a["Core/Animation/AnimationUtilities.js"],
        a["Core/DefaultOptions.js"],
        a["Core/Foundation.js"],
        a["Core/Globals.js"],
        a["Core/Legend/LegendSymbol.js"],
        a["Core/Series/Point.js"],
        a["Core/Series/SeriesDefaults.js"],
        a["Core/Series/SeriesRegistry.js"],
        a["Core/Renderer/SVG/SVGElement.js"],
        a["Core/Utilities.js"]
    ], function(a, u, z, F, y, G, H, A, q, n) {
        var k = a.animObject, e = a.setAnimation, c = u.defaultOptions, h = z.registerEventOptions, f = F.hasTouch, w = F.svg, p = F.win, B = A.seriesTypes, t = n.addEvent, v = n.arrayMax, C = n.arrayMin, r = n.clamp, l = n.cleanRecursively, b = n.correctFloat, g = n.defined, d = n.erase, m = n.error, D = n.extend, x = n.find, I = n.fireEvent, P = n.getNestedProperty, S = n.isArray, O = n.isNumber, U = n.isString, Y = n.merge, L = n.objectEach, K = n.pick, M = n.removeEvent, da = n.splat, Q = n.syncTimeout;
        a = function() {
            function a() {
                this.zones = this.yAxis = this.xAxis = this.userOptions = this.tooltipOptions = this.processedYData = this.processedXData = this.points = this.options = this.linkedSeries = this.index = this.eventsToUnbind = this.eventOptions = this.data = this.chart = this._i = void 0;
            }
            a.prototype.init = function(a, b) {
                I(this, "init", {
                    options: b
                });
                var c = this, d = a.series;
                this.eventsToUnbind = [];
                c.chart = a;
                c.options = c.setOptions(b);
                b = c.options;
                c.linkedSeries = [];
                c.bindAxes();
                D(c, {
                    name: b.name,
                    state: "",
                    visible: !1 !== b.visible,
                    selected: !0 === b.selected
                });
                h(this, b);
                var e = b.events;
                if (e && e.click || b.point && b.point.events && b.point.events.click || b.allowPointSelect) a.runTrackerClick = !0;
                c.getColor();
                c.getSymbol();
                c.parallelArrays.forEach(function(a) {
                    c[a + "Data"] || (c[a + "Data"] = []);
                });
                c.isCartesian && (a.hasCartesianSeries = !0);
                var g;
                d.length && (g = d[d.length - 1]);
                c._i = K(g && g._i, -1) + 1;
                c.opacity = c.options.opacity;
                a.orderSeries(this.insert(d));
                b.dataSorting && b.dataSorting.enabled ? c.setDataSortingOptions() : c.points || c.data || c.setData(b.data, !1);
                I(this, "afterInit");
            };
            a.prototype.is = function(a) {
                return B[a] && this instanceof B[a];
            };
            a.prototype.insert = function(a) {
                var b = this.options.index, c;
                if (O(b)) {
                    for(c = a.length; c--;)if (b >= K(a[c].options.index, a[c]._i)) {
                        a.splice(c + 1, 0, this);
                        break;
                    }
                    -1 === c && a.unshift(this);
                    c += 1;
                } else a.push(this);
                return K(c, a.length - 1);
            };
            a.prototype.bindAxes = function() {
                var a = this, b = a.options, c = a.chart, d;
                I(this, "bindAxes", null, function() {
                    (a.axisTypes || []).forEach(function(e) {
                        var g = 0;
                        c[e].forEach(function(c) {
                            d = c.options;
                            if (b[e] === g && !d.isInternal || "undefined" !== typeof b[e] && b[e] === d.id || "undefined" === typeof b[e] && 0 === d.index) a.insert(c.series), a[e] = c, c.isDirty = !0;
                            d.isInternal || g++;
                        });
                        a[e] || a.optionalAxis === e || m(18, !0, c);
                    });
                });
                I(this, "afterBindAxes");
            };
            a.prototype.updateParallelArrays = function(a, b) {
                var c = a.series, d = arguments, e = O(b) ? function(d) {
                    var e = "y" === d && c.toYData ? c.toYData(a) : a[d];
                    c[d + "Data"][b] = e;
                } : function(a) {
                    Array.prototype[b].apply(c[a + "Data"], Array.prototype.slice.call(d, 2));
                };
                c.parallelArrays.forEach(e);
            };
            a.prototype.hasData = function() {
                return this.visible && "undefined" !== typeof this.dataMax && "undefined" !== typeof this.dataMin || this.visible && this.yData && 0 < this.yData.length;
            };
            a.prototype.autoIncrement = function(a) {
                var b = this.options, c = b.pointIntervalUnit, d = b.relativeXValue, e = this.chart.time, g = this.xIncrement, f;
                g = K(g, b.pointStart, 0);
                this.pointInterval = f = K(this.pointInterval, b.pointInterval, 1);
                d && O(a) && (f *= a);
                c && (b = new e.Date(g), "day" === c ? e.set("Date", b, e.get("Date", b) + f) : "month" === c ? e.set("Month", b, e.get("Month", b) + f) : "year" === c && e.set("FullYear", b, e.get("FullYear", b) + f), f = b.getTime() - g);
                if (d && O(a)) return g + f;
                this.xIncrement = g + f;
                return g;
            };
            a.prototype.setDataSortingOptions = function() {
                var a = this.options;
                D(this, {
                    requireSorting: !1,
                    sorted: !1,
                    enabledDataSorting: !0,
                    allowDG: !1
                });
                g(a.pointRange) || (a.pointRange = 1);
            };
            a.prototype.setOptions = function(a) {
                var b = this.chart, d = b.options, e = d.plotOptions, f = b.userOptions || {};
                a = Y(a);
                b = b.styledMode;
                var h = {
                    plotOptions: e,
                    userOptions: a
                };
                I(this, "setOptions", h);
                var l = h.plotOptions[this.type], k = f.plotOptions || {};
                this.userOptions = h.userOptions;
                f = Y(l, e.series, f.plotOptions && f.plotOptions[this.type], a);
                this.tooltipOptions = Y(c.tooltip, c.plotOptions.series && c.plotOptions.series.tooltip, c.plotOptions[this.type].tooltip, d.tooltip.userOptions, e.series && e.series.tooltip, e[this.type].tooltip, a.tooltip);
                this.stickyTracking = K(a.stickyTracking, k[this.type] && k[this.type].stickyTracking, k.series && k.series.stickyTracking, this.tooltipOptions.shared && !this.noSharedTooltip ? !0 : f.stickyTracking);
                null === l.marker && delete f.marker;
                this.zoneAxis = f.zoneAxis;
                e = this.zones = (f.zones || []).slice();
                !f.negativeColor && !f.negativeFillColor || f.zones || (d = {
                    value: f[this.zoneAxis + "Threshold"] || f.threshold || 0,
                    className: "highcharts-negative"
                }, b || (d.color = f.negativeColor, d.fillColor = f.negativeFillColor), e.push(d));
                e.length && g(e[e.length - 1].value) && e.push(b ? {} : {
                    color: this.color,
                    fillColor: this.fillColor
                });
                I(this, "afterSetOptions", {
                    options: f
                });
                return f;
            };
            a.prototype.getName = function() {
                return K(this.options.name, "Series " + (this.index + 1));
            };
            a.prototype.getCyclic = function(a, b, c) {
                var d = this.chart, e = this.userOptions, f = a + "Index", h = a + "Counter", l = c ? c.length : K(d.options.chart[a + "Count"], d[a + "Count"]);
                if (!b) {
                    var k = K(e[f], e["_" + f]);
                    g(k) || (d.series.length || (d[h] = 0), e["_" + f] = k = d[h] % l, d[h] += 1);
                    c && (b = c[k]);
                }
                "undefined" !== typeof k && (this[f] = k);
                this[a] = b;
            };
            a.prototype.getColor = function() {
                this.chart.styledMode ? this.getCyclic("color") : this.options.colorByPoint ? this.color = "#cccccc" : this.getCyclic("color", this.options.color || c.plotOptions[this.type].color, this.chart.options.colors);
            };
            a.prototype.getPointsCollection = function() {
                return (this.hasGroupedData ? this.points : this.data) || [];
            };
            a.prototype.getSymbol = function() {
                this.getCyclic("symbol", this.options.marker.symbol, this.chart.options.symbols);
            };
            a.prototype.findPointIndex = function(a, b) {
                var c = a.id, d = a.x, e = this.points, g = this.options.dataSorting, f, h;
                if (c) g = this.chart.get(c), g instanceof G && (f = g);
                else if (this.linkedParent || this.enabledDataSorting || this.options.relativeXValue) {
                    if (f = function(b) {
                        return !b.touched && b.index === a.index;
                    }, g && g.matchByName ? f = function(b) {
                        return !b.touched && b.name === a.name;
                    } : this.options.relativeXValue && (f = function(b) {
                        return !b.touched && b.options.x === a.x;
                    }), f = x(e, f), !f) return;
                }
                if (f) {
                    var l = f && f.index;
                    "undefined" !== typeof l && (h = !0);
                }
                "undefined" === typeof l && O(d) && (l = this.xData.indexOf(d, b));
                -1 !== l && "undefined" !== typeof l && this.cropped && (l = l >= this.cropStart ? l - this.cropStart : l);
                !h && O(l) && e[l] && e[l].touched && (l = void 0);
                return l;
            };
            a.prototype.updateData = function(a, b) {
                var c = this.options, d = c.dataSorting, e = this.points, f = [], h = this.requireSorting, l = a.length === e.length, k, m, p, n = !0;
                this.xIncrement = null;
                a.forEach(function(a, b) {
                    var m = g(a) && this.pointClass.prototype.optionsToObject.call({
                        series: this
                    }, a) || {}, n = m.x;
                    if (m.id || O(n)) {
                        if (m = this.findPointIndex(m, p), -1 === m || "undefined" === typeof m ? f.push(a) : e[m] && a !== c.data[m] ? (e[m].update(a, !1, null, !1), e[m].touched = !0, h && (p = m + 1)) : e[m] && (e[m].touched = !0), !l || b !== m || d && d.enabled || this.hasDerivedData) k = !0;
                    } else f.push(a);
                }, this);
                if (k) for(a = e.length; a--;)(m = e[a]) && !m.touched && m.remove && m.remove(!1, b);
                else !l || d && d.enabled ? n = !1 : (a.forEach(function(a, b) {
                    a !== e[b].y && e[b].update && e[b].update(a, !1, null, !1);
                }), f.length = 0);
                e.forEach(function(a) {
                    a && (a.touched = !1);
                });
                if (!n) return !1;
                f.forEach(function(a) {
                    this.addPoint(a, !1, null, null, !1);
                }, this);
                null === this.xIncrement && this.xData && this.xData.length && (this.xIncrement = v(this.xData), this.autoIncrement());
                return !0;
            };
            a.prototype.setData = function(a, b, c, d) {
                var e = this, g = e.points, f = g && g.length || 0, h = e.options, l = e.chart, k = h.dataSorting, p = e.xAxis, n = h.turboThreshold, r = this.xData, E = this.yData, t = e.pointArrayMap;
                t = t && t.length;
                var q = h.keys, w, B = 0, C = 1, x = null;
                a = a || [];
                var v = a.length;
                b = K(b, !0);
                k && k.enabled && (a = this.sortData(a));
                !1 !== d && v && f && !e.cropped && !e.hasGroupedData && e.visible && !e.isSeriesBoosting && (w = this.updateData(a, c));
                if (!w) {
                    e.xIncrement = null;
                    e.colorCounter = 0;
                    this.parallelArrays.forEach(function(a) {
                        e[a + "Data"].length = 0;
                    });
                    if (n && v > n) {
                        if (x = e.getFirstValidPoint(a), O(x)) for(c = 0; c < v; c++)r[c] = this.autoIncrement(), E[c] = a[c];
                        else if (S(x)) {
                            if (t) {
                                if (x.length === t) for(c = 0; c < v; c++)r[c] = this.autoIncrement(), E[c] = a[c];
                                else for(c = 0; c < v; c++)d = a[c], r[c] = d[0], E[c] = d.slice(1, t + 1);
                            } else if (q && (B = q.indexOf("x"), C = q.indexOf("y"), B = 0 <= B ? B : 0, C = 0 <= C ? C : 1), 1 === x.length && (C = 0), B === C) for(c = 0; c < v; c++)r[c] = this.autoIncrement(), E[c] = a[c][C];
                            else for(c = 0; c < v; c++)d = a[c], r[c] = d[B], E[c] = d[C];
                        } else m(12, !1, l);
                    } else for(c = 0; c < v; c++)"undefined" !== typeof a[c] && (d = {
                        series: e
                    }, e.pointClass.prototype.applyOptions.apply(d, [
                        a[c]
                    ]), e.updateParallelArrays(d, c));
                    E && U(E[0]) && m(14, !0, l);
                    e.data = [];
                    e.options.data = e.userOptions.data = a;
                    for(c = f; c--;)g[c] && g[c].destroy && g[c].destroy();
                    p && (p.minRange = p.userMinRange);
                    e.isDirty = l.isDirtyBox = !0;
                    e.isDirtyData = !!g;
                    c = !1;
                }
                "point" === h.legendType && (this.processData(), this.generatePoints());
                b && l.redraw(c);
            };
            a.prototype.sortData = function(a) {
                var b = this, c = b.options.dataSorting.sortKey || "y", d = function(a, b) {
                    return g(b) && a.pointClass.prototype.optionsToObject.call({
                        series: a
                    }, b) || {};
                };
                a.forEach(function(c, e) {
                    a[e] = d(b, c);
                    a[e].index = e;
                }, this);
                a.concat().sort(function(a, b) {
                    a = P(c, a);
                    b = P(c, b);
                    return b < a ? -1 : b > a ? 1 : 0;
                }).forEach(function(a, b) {
                    a.x = b;
                }, this);
                b.linkedSeries && b.linkedSeries.forEach(function(b) {
                    var c = b.options, e = c.data;
                    c.dataSorting && c.dataSorting.enabled || !e || (e.forEach(function(c, g) {
                        e[g] = d(b, c);
                        a[g] && (e[g].x = a[g].x, e[g].index = g);
                    }), b.setData(e, !1));
                });
                return a;
            };
            a.prototype.getProcessedData = function(a) {
                var b = this.xAxis, c = this.options, d = c.cropThreshold, e = a || this.getExtremesFromAll || c.getExtremesFromAll, g = this.isCartesian;
                a = b && b.val2lin;
                c = !(!b || !b.logarithmic);
                var f = 0, h = this.xData, l = this.yData, k = this.requireSorting;
                var p = !1;
                var n = h.length;
                if (b) {
                    p = b.getExtremes();
                    var r = p.min;
                    var E = p.max;
                    p = b.categories && !b.names.length;
                }
                if (g && this.sorted && !e && (!d || n > d || this.forceCrop)) {
                    if (h[n - 1] < r || h[0] > E) h = [], l = [];
                    else if (this.yData && (h[0] < r || h[n - 1] > E)) {
                        var t = this.cropData(this.xData, this.yData, r, E);
                        h = t.xData;
                        l = t.yData;
                        f = t.start;
                        t = !0;
                    }
                }
                for(d = h.length || 1; --d;)if (b = c ? a(h[d]) - a(h[d - 1]) : h[d] - h[d - 1], 0 < b && ("undefined" === typeof q || b < q)) var q = b;
                else 0 > b && k && !p && (m(15, !1, this.chart), k = !1);
                return {
                    xData: h,
                    yData: l,
                    cropped: t,
                    cropStart: f,
                    closestPointRange: q
                };
            };
            a.prototype.processData = function(a) {
                var b = this.xAxis;
                if (this.isCartesian && !this.isDirty && !b.isDirty && !this.yAxis.isDirty && !a) return !1;
                a = this.getProcessedData();
                this.cropped = a.cropped;
                this.cropStart = a.cropStart;
                this.processedXData = a.xData;
                this.processedYData = a.yData;
                this.closestPointRange = this.basePointRange = a.closestPointRange;
                I(this, "afterProcessData");
            };
            a.prototype.cropData = function(a, b, c, d, e) {
                var g = a.length, f, h = 0, l = g;
                e = K(e, this.cropShoulder);
                for(f = 0; f < g; f++)if (a[f] >= c) {
                    h = Math.max(0, f - e);
                    break;
                }
                for(c = f; c < g; c++)if (a[c] > d) {
                    l = c + e;
                    break;
                }
                return {
                    xData: a.slice(h, l),
                    yData: b.slice(h, l),
                    start: h,
                    end: l
                };
            };
            a.prototype.generatePoints = function() {
                var a = this.options, b = a.data, c = this.processedXData, d = this.processedYData, e = this.pointClass, g = c.length, f = this.cropStart || 0, h = this.hasGroupedData, l = a.keys, k = [];
                a = a.dataGrouping && a.dataGrouping.groupAll ? f : 0;
                var m, p, n = this.data;
                if (!n && !h) {
                    var r = [];
                    r.length = b.length;
                    n = this.data = r;
                }
                l && h && (this.options.keys = !1);
                for(p = 0; p < g; p++){
                    r = f + p;
                    if (h) {
                        var t = (new e).init(this, [
                            c[p]
                        ].concat(da(d[p])));
                        t.dataGroup = this.groupMap[a + p];
                        t.dataGroup.options && (t.options = t.dataGroup.options, D(t, t.dataGroup.options), delete t.dataLabels);
                    } else (t = n[r]) || "undefined" === typeof b[r] || (n[r] = t = (new e).init(this, b[r], c[p]));
                    t && (t.index = h ? a + p : r, k[p] = t);
                }
                this.options.keys = l;
                if (n && (g !== (m = n.length) || h)) for(p = 0; p < m; p++)p !== f || h || (p += g), n[p] && (n[p].destroyElements(), n[p].plotX = void 0);
                this.data = n;
                this.points = k;
                I(this, "afterGeneratePoints");
            };
            a.prototype.getXExtremes = function(a) {
                return {
                    min: C(a),
                    max: v(a)
                };
            };
            a.prototype.getExtremes = function(a, b) {
                var c = this.xAxis, d = this.yAxis, e = this.processedXData || this.xData, g = [], f = this.requireSorting ? this.cropShoulder : 0;
                d = d ? d.positiveValuesOnly : !1;
                var h, l = 0, k = 0, m = 0;
                a = a || this.stackedYData || this.processedYData || [];
                var p = a.length;
                if (c) {
                    var n = c.getExtremes();
                    l = n.min;
                    k = n.max;
                }
                for(h = 0; h < p; h++){
                    var r = e[h];
                    n = a[h];
                    var t = (O(n) || S(n)) && (n.length || 0 < n || !d);
                    r = b || this.getExtremesFromAll || this.options.getExtremesFromAll || this.cropped || !c || (e[h + f] || r) >= l && (e[h - f] || r) <= k;
                    if (t && r) {
                        if (t = n.length) for(; t--;)O(n[t]) && (g[m++] = n[t]);
                        else g[m++] = n;
                    }
                }
                a = {
                    activeYData: g,
                    dataMin: C(g),
                    dataMax: v(g)
                };
                I(this, "afterGetExtremes", {
                    dataExtremes: a
                });
                return a;
            };
            a.prototype.applyExtremes = function() {
                var a = this.getExtremes();
                this.dataMin = a.dataMin;
                this.dataMax = a.dataMax;
                return a;
            };
            a.prototype.getFirstValidPoint = function(a) {
                for(var b = a.length, c = 0, d = null; null === d && c < b;)d = a[c], c++;
                return d;
            };
            a.prototype.translate = function() {
                this.processedXData || this.processData();
                this.generatePoints();
                var a = this.options, c = a.stacking, d = this.xAxis, e = d.categories, f = this.enabledDataSorting, h = this.yAxis, l = this.points, k = l.length, m = this.pointPlacementToXValue(), p = !!m, n = a.threshold, t = a.startFromThreshold ? n : 0, q = this.zoneAxis || "y", w, B, C = Number.MAX_VALUE;
                for(w = 0; w < k; w++){
                    var x = l[w], v = x.x, u = void 0, D = void 0, J = x.y, A = x.low, y = c && h.stacking && h.stacking.stacks[(this.negStacks && J < (t ? 0 : n) ? "-" : "") + this.stackKey];
                    if (h.positiveValuesOnly && !h.validatePositiveValue(J) || d.positiveValuesOnly && !d.validatePositiveValue(v)) x.isNull = !0;
                    x.plotX = B = b(r(d.translate(v, 0, 0, 0, 1, m, "flags" === this.type), -100000, 1E5));
                    if (c && this.visible && y && y[v]) {
                        var z = this.getStackIndicator(z, v, this.index);
                        x.isNull || (u = y[v], D = u.points[z.key]);
                    }
                    S(D) && (A = D[0], J = D[1], A === t && z.key === y[v].base && (A = K(O(n) && n, h.min)), h.positiveValuesOnly && 0 >= A && (A = null), x.total = x.stackTotal = u.total, x.percentage = u.total && x.y / u.total * 100, x.stackY = J, this.irregularWidths || u.setOffset(this.pointXOffset || 0, this.barW || 0));
                    x.yBottom = g(A) ? r(h.translate(A, 0, 1, 0, 1), -100000, 1E5) : null;
                    this.dataModify && (J = this.dataModify.modifyValue(J, w));
                    x.plotY = void 0;
                    O(J) && (u = h.translate(J, !1, !0, !1, !0), "undefined" !== typeof u && (x.plotY = r(u, -100000, 1E5)));
                    x.isInside = this.isPointInside(x);
                    x.clientX = p ? b(d.translate(v, 0, 0, 0, 1, m)) : B;
                    x.negative = x[q] < (a[q + "Threshold"] || n || 0);
                    x.category = e && "undefined" !== typeof e[x.x] ? e[x.x] : x.x;
                    if (!x.isNull && !1 !== x.visible) {
                        "undefined" !== typeof F && (C = Math.min(C, Math.abs(B - F)));
                        var F = B;
                    }
                    x.zone = this.zones.length ? x.getZone() : void 0;
                    !x.graphic && this.group && f && (x.isNew = !0);
                }
                this.closestPointRangePx = C;
                I(this, "afterTranslate");
            };
            a.prototype.getValidPoints = function(a, b, c) {
                var d = this.chart;
                return (a || this.points || []).filter(function(a) {
                    return b && !d.isInsidePlot(a.plotX, a.plotY, {
                        inverted: d.inverted
                    }) ? !1 : !1 !== a.visible && (c || !a.isNull);
                });
            };
            a.prototype.getClipBox = function() {
                var a = this.chart, b = this.xAxis, c = this.yAxis, d = Y(a.clipBox);
                b && b.len !== a.plotSizeX && (d.width = b.len);
                c && c.len !== a.plotSizeY && (d.height = c.len);
                return d;
            };
            a.prototype.getSharedClipKey = function() {
                return this.sharedClipKey = (this.options.xAxis || 0) + "," + (this.options.yAxis || 0);
            };
            a.prototype.setClip = function() {
                var a = this.chart, b = this.group, c = this.markerGroup, d = a.sharedClips;
                a = a.renderer;
                var e = this.getClipBox(), g = this.getSharedClipKey(), f = d[g];
                f ? f.animate(e) : d[g] = f = a.clipRect(e);
                b && b.clip(!1 === this.options.clip ? void 0 : f);
                c && c.clip();
            };
            a.prototype.animate = function(a) {
                var b = this.chart, c = this.group, d = this.markerGroup, e = b.inverted, g = k(this.options.animation), f = [
                    this.getSharedClipKey(),
                    g.duration,
                    g.easing,
                    g.defer
                ].join(), h = b.sharedClips[f], l = b.sharedClips[f + "m"];
                if (a && c) g = this.getClipBox(), h ? h.attr("height", g.height) : (g.width = 0, e && (g.x = b.plotHeight), h = b.renderer.clipRect(g), b.sharedClips[f] = h, l = b.renderer.clipRect({
                    x: e ? (b.plotSizeX || 0) + 99 : -99,
                    y: e ? -b.plotLeft : -b.plotTop,
                    width: 99,
                    height: e ? b.chartWidth : b.chartHeight
                }), b.sharedClips[f + "m"] = l), c.clip(h), d && d.clip(l);
                else if (h && !h.hasClass("highcharts-animating")) {
                    b = this.getClipBox();
                    var m = g.step;
                    d && d.element.childNodes.length && (g.step = function(a, b) {
                        m && m.apply(b, arguments);
                        l && l.element && l.attr(b.prop, "width" === b.prop ? a + 99 : a);
                    });
                    h.addClass("highcharts-animating").animate(b, g);
                }
            };
            a.prototype.afterAnimate = function() {
                var a = this;
                this.setClip();
                L(this.chart.sharedClips, function(b, c, d) {
                    b && !a.chart.container.querySelector('[clip-path="url(#' + b.id + ')"]') && (b.destroy(), delete d[c]);
                });
                this.finishedAnimating = !0;
                I(this, "afterAnimate");
            };
            a.prototype.drawPoints = function() {
                var a = this.points, b = this.chart, c = this.options.marker, d = this[this.specialGroup] || this.markerGroup, e = this.xAxis, g = K(c.enabled, !e || e.isRadial ? !0 : null, this.closestPointRangePx >= c.enabledThreshold * c.radius), f, h;
                if (!1 !== c.enabled || this._hasPointMarkers) for(f = 0; f < a.length; f++){
                    var l = a[f];
                    var k = (h = l.graphic) ? "animate" : "attr";
                    var m = l.marker || {};
                    var p = !!l.marker;
                    if ((g && "undefined" === typeof m.enabled || m.enabled) && !l.isNull && !1 !== l.visible) {
                        var n = K(m.symbol, this.symbol, "rect");
                        var r = this.markerAttribs(l, l.selected && "select");
                        this.enabledDataSorting && (l.startXPos = e.reversed ? -(r.width || 0) : e.width);
                        var t = !1 !== l.isInside;
                        h ? h[t ? "show" : "hide"](t).animate(r) : t && (0 < (r.width || 0) || l.hasImage) && (l.graphic = h = b.renderer.symbol(n, r.x, r.y, r.width, r.height, p ? m : c).add(d), this.enabledDataSorting && b.hasRendered && (h.attr({
                            x: l.startXPos
                        }), k = "animate"));
                        h && "animate" === k && h[t ? "show" : "hide"](t).animate(r);
                        if (h && !b.styledMode) h[k](this.pointAttribs(l, l.selected && "select"));
                        h && h.addClass(l.getClassName(), !0);
                    } else h && (l.graphic = h.destroy());
                }
            };
            a.prototype.markerAttribs = function(a, b) {
                var c = this.options, d = c.marker, e = a.marker || {}, g = e.symbol || d.symbol, f = K(e.radius, d.radius);
                b && (d = d.states[b], b = e.states && e.states[b], f = K(b && b.radius, d && d.radius, f + (d && d.radiusPlus || 0)));
                a.hasImage = g && 0 === g.indexOf("url");
                a.hasImage && (f = 0);
                a = {
                    x: c.crisp ? Math.floor(a.plotX - f) : a.plotX - f,
                    y: a.plotY - f
                };
                f && (a.width = a.height = 2 * f);
                return a;
            };
            a.prototype.pointAttribs = function(a, b) {
                var c = this.options.marker, d = a && a.options, e = d && d.marker || {}, g = d && d.color, f = a && a.color, h = a && a.zone && a.zone.color, l = this.color;
                a = K(e.lineWidth, c.lineWidth);
                d = 1;
                l = g || h || f || l;
                g = e.fillColor || c.fillColor || l;
                f = e.lineColor || c.lineColor || l;
                b = b || "normal";
                c = c.states[b] || {};
                b = e.states && e.states[b] || {};
                a = K(b.lineWidth, c.lineWidth, a + K(b.lineWidthPlus, c.lineWidthPlus, 0));
                g = b.fillColor || c.fillColor || g;
                f = b.lineColor || c.lineColor || f;
                d = K(b.opacity, c.opacity, d);
                return {
                    stroke: f,
                    "stroke-width": a,
                    fill: g,
                    opacity: d
                };
            };
            a.prototype.destroy = function(a) {
                var b = this, c = b.chart, e = /AppleWebKit\/533/.test(p.navigator.userAgent), g = b.data || [], f, h, l, k;
                I(b, "destroy");
                this.removeEvents(a);
                (b.axisTypes || []).forEach(function(a) {
                    (k = b[a]) && k.series && (d(k.series, b), k.isDirty = k.forceRedraw = !0);
                });
                b.legendItem && b.chart.legend.destroyItem(b);
                for(h = g.length; h--;)(l = g[h]) && l.destroy && l.destroy();
                b.clips && b.clips.forEach(function(a) {
                    return a.destroy();
                });
                n.clearTimeout(b.animationTimeout);
                L(b, function(a, b) {
                    a instanceof q && !a.survive && (f = e && "group" === b ? "hide" : "destroy", a[f]());
                });
                c.hoverSeries === b && (c.hoverSeries = void 0);
                d(c.series, b);
                c.orderSeries();
                L(b, function(c, d) {
                    a && "hcEvents" === d || delete b[d];
                });
            };
            a.prototype.applyZones = function() {
                var a = this, b = this.chart, c = b.renderer, d = this.zones, e = this.clips || [], g = this.graph, f = this.area, h = Math.max(b.chartWidth, b.chartHeight), l = this[(this.zoneAxis || "y") + "Axis"], k = b.inverted, m, p, n, t, q, x, w, B, C = !1;
                if (d.length && (g || f) && l && "undefined" !== typeof l.min) {
                    var v = l.reversed;
                    var u = l.horiz;
                    g && !this.showLine && g.hide();
                    f && f.hide();
                    var D = l.getExtremes();
                    d.forEach(function(d, E) {
                        m = v ? u ? b.plotWidth : 0 : u ? 0 : l.toPixels(D.min) || 0;
                        m = r(K(p, m), 0, h);
                        p = r(Math.round(l.toPixels(K(d.value, D.max), !0) || 0), 0, h);
                        C && (m = p = l.toPixels(D.max));
                        t = Math.abs(m - p);
                        q = Math.min(m, p);
                        x = Math.max(m, p);
                        l.isXAxis ? (n = {
                            x: k ? x : q,
                            y: 0,
                            width: t,
                            height: h
                        }, u || (n.x = b.plotHeight - n.x)) : (n = {
                            x: 0,
                            y: k ? x : q,
                            width: h,
                            height: t
                        }, u && (n.y = b.plotWidth - n.y));
                        k && c.isVML && (n = l.isXAxis ? {
                            x: 0,
                            y: v ? q : x,
                            height: n.width,
                            width: b.chartWidth
                        } : {
                            x: n.y - b.plotLeft - b.spacingBox.x,
                            y: 0,
                            width: n.height,
                            height: b.chartHeight
                        });
                        e[E] ? e[E].animate(n) : e[E] = c.clipRect(n);
                        w = a["zone-area-" + E];
                        B = a["zone-graph-" + E];
                        g && B && B.clip(e[E]);
                        f && w && w.clip(e[E]);
                        C = d.value > D.max;
                        a.resetZones && 0 === p && (p = void 0);
                    });
                    this.clips = e;
                } else a.visible && (g && g.show(!0), f && f.show(!0));
            };
            a.prototype.invertGroups = function(a) {
                function b() {
                    [
                        "group",
                        "markerGroup"
                    ].forEach(function(b) {
                        c[b] && (d.renderer.isVML && c[b].attr({
                            width: c.yAxis.len,
                            height: c.xAxis.len
                        }), c[b].width = c.yAxis.len, c[b].height = c.xAxis.len, c[b].invert(c.isRadialSeries ? !1 : a));
                    });
                }
                var c = this, d = c.chart;
                c.xAxis && (c.eventsToUnbind.push(t(d, "resize", b)), b(), c.invertGroups = b);
            };
            a.prototype.plotGroup = function(a, b, c, d, e) {
                var f = this[a], h = !f;
                c = {
                    visibility: c,
                    zIndex: d || .1
                };
                "undefined" === typeof this.opacity || this.chart.styledMode || "inactive" === this.state || (c.opacity = this.opacity);
                h && (this[a] = f = this.chart.renderer.g().add(e));
                f.addClass("highcharts-" + b + " highcharts-series-" + this.index + " highcharts-" + this.type + "-series " + (g(this.colorIndex) ? "highcharts-color-" + this.colorIndex + " " : "") + (this.options.className || "") + (f.hasClass("highcharts-tracker") ? " highcharts-tracker" : ""), !0);
                f.attr(c)[h ? "attr" : "animate"](this.getPlotBox());
                return f;
            };
            a.prototype.getPlotBox = function() {
                var a = this.chart, b = this.xAxis, c = this.yAxis;
                a.inverted && (b = c, c = this.xAxis);
                return {
                    translateX: b ? b.left : a.plotLeft,
                    translateY: c ? c.top : a.plotTop,
                    scaleX: 1,
                    scaleY: 1
                };
            };
            a.prototype.removeEvents = function(a) {
                a || M(this);
                this.eventsToUnbind.length && (this.eventsToUnbind.forEach(function(a) {
                    a();
                }), this.eventsToUnbind.length = 0);
            };
            a.prototype.render = function() {
                var a = this, b = a.chart, c = a.options, d = k(c.animation), e = a.visible ? "inherit" : "hidden", g = c.zIndex, f = a.hasRendered, h = b.seriesGroup, l = b.inverted;
                b = !a.finishedAnimating && b.renderer.isSVG ? d.duration : 0;
                I(this, "render");
                var m = a.plotGroup("group", "series", e, g, h);
                a.markerGroup = a.plotGroup("markerGroup", "markers", e, g, h);
                !1 !== c.clip && a.setClip();
                a.animate && b && a.animate(!0);
                m.inverted = K(a.invertible, a.isCartesian) ? l : !1;
                a.drawGraph && (a.drawGraph(), a.applyZones());
                a.visible && a.drawPoints();
                a.drawDataLabels && a.drawDataLabels();
                a.redrawPoints && a.redrawPoints();
                a.drawTracker && !1 !== a.options.enableMouseTracking && a.drawTracker();
                a.invertGroups(l);
                a.animate && b && a.animate();
                f || (b && d.defer && (b += d.defer), a.animationTimeout = Q(function() {
                    a.afterAnimate();
                }, b || 0));
                a.isDirty = !1;
                a.hasRendered = !0;
                I(a, "afterRender");
            };
            a.prototype.redraw = function() {
                var a = this.chart, b = this.isDirty || this.isDirtyData, c = this.group, d = this.xAxis, e = this.yAxis;
                c && (a.inverted && c.attr({
                    width: a.plotWidth,
                    height: a.plotHeight
                }), c.animate({
                    translateX: K(d && d.left, a.plotLeft),
                    translateY: K(e && e.top, a.plotTop)
                }));
                this.translate();
                this.render();
                b && delete this.kdTree;
            };
            a.prototype.searchPoint = function(a, b) {
                var c = this.xAxis, d = this.yAxis, e = this.chart.inverted;
                return this.searchKDTree({
                    clientX: e ? c.len - a.chartY + c.pos : a.chartX - c.pos,
                    plotY: e ? d.len - a.chartX + d.pos : a.chartY - d.pos
                }, b, a);
            };
            a.prototype.buildKDTree = function(a) {
                function b(a, d, e) {
                    var g = a && a.length;
                    if (g) {
                        var f = c.kdAxisArray[d % e];
                        a.sort(function(a, b) {
                            return a[f] - b[f];
                        });
                        g = Math.floor(g / 2);
                        return {
                            point: a[g],
                            left: b(a.slice(0, g), d + 1, e),
                            right: b(a.slice(g + 1), d + 1, e)
                        };
                    }
                }
                this.buildingKdTree = !0;
                var c = this, d = -1 < c.options.findNearestPointBy.indexOf("y") ? 2 : 1;
                delete c.kdTree;
                Q(function() {
                    c.kdTree = b(c.getValidPoints(null, !c.directTouch), d, d);
                    c.buildingKdTree = !1;
                }, c.options.kdNow || a && "touchstart" === a.type ? 0 : 1);
            };
            a.prototype.searchKDTree = function(a, b, c) {
                function d(a, b, c, k) {
                    var m = b.point, p = e.kdAxisArray[c % k], n = m, r = g(a[f]) && g(m[f]) ? Math.pow(a[f] - m[f], 2) : null;
                    var t = g(a[h]) && g(m[h]) ? Math.pow(a[h] - m[h], 2) : null;
                    t = (r || 0) + (t || 0);
                    m.dist = g(t) ? Math.sqrt(t) : Number.MAX_VALUE;
                    m.distX = g(r) ? Math.sqrt(r) : Number.MAX_VALUE;
                    p = a[p] - m[p];
                    t = 0 > p ? "left" : "right";
                    r = 0 > p ? "right" : "left";
                    b[t] && (t = d(a, b[t], c + 1, k), n = t[l] < n[l] ? t : m);
                    b[r] && Math.sqrt(p * p) < n[l] && (a = d(a, b[r], c + 1, k), n = a[l] < n[l] ? a : n);
                    return n;
                }
                var e = this, f = this.kdAxisArray[0], h = this.kdAxisArray[1], l = b ? "distX" : "dist";
                b = -1 < e.options.findNearestPointBy.indexOf("y") ? 2 : 1;
                this.kdTree || this.buildingKdTree || this.buildKDTree(c);
                if (this.kdTree) return d(a, this.kdTree, b, b);
            };
            a.prototype.pointPlacementToXValue = function() {
                var a = this.options, b = a.pointRange, c = this.xAxis;
                a = a.pointPlacement;
                "between" === a && (a = c.reversed ? -0.5 : .5);
                return O(a) ? a * (b || c.pointRange) : 0;
            };
            a.prototype.isPointInside = function(a) {
                var b = this.chart, c = this.xAxis, d = this.yAxis;
                return "undefined" !== typeof a.plotY && "undefined" !== typeof a.plotX && 0 <= a.plotY && a.plotY <= (d ? d.len : b.plotHeight) && 0 <= a.plotX && a.plotX <= (c ? c.len : b.plotWidth);
            };
            a.prototype.drawTracker = function() {
                var a = this, b = a.options, c = b.trackByArea, d = [].concat(c ? a.areaPath : a.graphPath), e = a.chart, g = e.pointer, h = e.renderer, l = e.options.tooltip.snap, m = a.tracker, k = function(b) {
                    if (e.hoverSeries !== a) a.onMouseOver();
                }, p = "rgba(192,192,192," + (w ? .0001 : .002) + ")";
                m ? m.attr({
                    d: d
                }) : a.graph && (a.tracker = h.path(d).attr({
                    visibility: a.visible ? "visible" : "hidden",
                    zIndex: 2
                }).addClass(c ? "highcharts-tracker-area" : "highcharts-tracker-line").add(a.group), e.styledMode || a.tracker.attr({
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    stroke: p,
                    fill: c ? p : "none",
                    "stroke-width": a.graph.strokeWidth() + (c ? 0 : 2 * l)
                }), [
                    a.tracker,
                    a.markerGroup,
                    a.dataLabelsGroup
                ].forEach(function(a) {
                    if (a && (a.addClass("highcharts-tracker").on("mouseover", k).on("mouseout", function(a) {
                        g.onTrackerMouseOut(a);
                    }), b.cursor && !e.styledMode && a.css({
                        cursor: b.cursor
                    }), f)) a.on("touchstart", k);
                }));
                I(this, "afterDrawTracker");
            };
            a.prototype.addPoint = function(a, b, c, d, e) {
                var g = this.options, f = this.data, h = this.chart, l = this.xAxis;
                l = l && l.hasNames && l.names;
                var m = g.data, k = this.xData, p;
                b = K(b, !0);
                var n = {
                    series: this
                };
                this.pointClass.prototype.applyOptions.apply(n, [
                    a
                ]);
                var r = n.x;
                var t = k.length;
                if (this.requireSorting && r < k[t - 1]) for(p = !0; t && k[t - 1] > r;)t--;
                this.updateParallelArrays(n, "splice", t, 0, 0);
                this.updateParallelArrays(n, t);
                l && n.name && (l[r] = n.name);
                m.splice(t, 0, a);
                p && (this.data.splice(t, 0, null), this.processData());
                "point" === g.legendType && this.generatePoints();
                c && (f[0] && f[0].remove ? f[0].remove(!1) : (f.shift(), this.updateParallelArrays(n, "shift"), m.shift()));
                !1 !== e && I(this, "addPoint", {
                    point: n
                });
                this.isDirtyData = this.isDirty = !0;
                b && h.redraw(d);
            };
            a.prototype.removePoint = function(a, b, c) {
                var d = this, g = d.data, f = g[a], h = d.points, l = d.chart, k = function() {
                    h && h.length === g.length && h.splice(a, 1);
                    g.splice(a, 1);
                    d.options.data.splice(a, 1);
                    d.updateParallelArrays(f || {
                        series: d
                    }, "splice", a, 1);
                    f && f.destroy();
                    d.isDirty = !0;
                    d.isDirtyData = !0;
                    b && l.redraw();
                };
                e(c, l);
                b = K(b, !0);
                f ? f.firePointEvent("remove", null, k) : k();
            };
            a.prototype.remove = function(a, b, c, d) {
                function e() {
                    g.destroy(d);
                    f.isDirtyLegend = f.isDirtyBox = !0;
                    f.linkSeries();
                    K(a, !0) && f.redraw(b);
                }
                var g = this, f = g.chart;
                !1 !== c ? I(g, "remove", null, e) : e();
            };
            a.prototype.update = function(a, b) {
                a = l(a, this.userOptions);
                I(this, "update", {
                    options: a
                });
                var c = this, d = c.chart, e = c.userOptions, g = c.initialType || c.type, f = d.options.plotOptions, h = B[g].prototype, k = c.finishedAnimating && {
                    animation: !1
                }, p = {}, n, r = [
                    "eventOptions",
                    "navigatorSeries",
                    "baseSeries"
                ], t = a.type || e.type || d.options.chart.type, q = !(this.hasDerivedData || t && t !== this.type || "undefined" !== typeof a.pointStart || "undefined" !== typeof a.pointInterval || "undefined" !== typeof a.relativeXValue || c.hasOptionChanged("dataGrouping") || c.hasOptionChanged("pointStart") || c.hasOptionChanged("pointInterval") || c.hasOptionChanged("pointIntervalUnit") || c.hasOptionChanged("keys"));
                t = t || g;
                q && (r.push("data", "isDirtyData", "points", "processedXData", "processedYData", "xIncrement", "cropped", "_hasPointMarkers", "_hasPointLabels", "clips", "nodes", "layout", "mapMap", "mapData", "minY", "maxY", "minX", "maxX"), !1 !== a.visible && r.push("area", "graph"), c.parallelArrays.forEach(function(a) {
                    r.push(a + "Data");
                }), a.data && (a.dataSorting && D(c.options.dataSorting, a.dataSorting), this.setData(a.data, !1)));
                a = Y(e, k, {
                    index: "undefined" === typeof e.index ? c.index : e.index,
                    pointStart: K(f && f.series && f.series.pointStart, e.pointStart, c.xData[0])
                }, !q && {
                    data: c.options.data
                }, a);
                q && a.data && (a.data = c.options.data);
                r = [
                    "group",
                    "markerGroup",
                    "dataLabelsGroup",
                    "transformGroup"
                ].concat(r);
                r.forEach(function(a) {
                    r[a] = c[a];
                    delete c[a];
                });
                f = !1;
                if (B[t]) {
                    if (f = t !== c.type, c.remove(!1, !1, !1, !0), f) {
                        if (Object.setPrototypeOf) Object.setPrototypeOf(c, B[t].prototype);
                        else {
                            k = Object.hasOwnProperty.call(c, "hcEvents") && c.hcEvents;
                            for(n in h)c[n] = void 0;
                            D(c, B[t].prototype);
                            k ? c.hcEvents = k : delete c.hcEvents;
                        }
                    }
                } else m(17, !0, d, {
                    missingModuleFor: t
                });
                r.forEach(function(a) {
                    c[a] = r[a];
                });
                c.init(d, a);
                if (q && this.points) {
                    var x = c.options;
                    !1 === x.visible ? (p.graphic = 1, p.dataLabel = 1) : c._hasPointLabels || (a = x.marker, h = x.dataLabels, !a || !1 !== a.enabled && (e.marker && e.marker.symbol) === a.symbol || (p.graphic = 1), h && !1 === h.enabled && (p.dataLabel = 1));
                    this.points.forEach(function(a) {
                        a && a.series && (a.resolveColor(), Object.keys(p).length && a.destroyElements(p), !1 === x.showInLegend && a.legendItem && d.legend.destroyItem(a));
                    }, this);
                }
                c.initialType = g;
                d.linkSeries();
                f && c.linkedSeries.length && (c.isDirtyData = !0);
                I(this, "afterUpdate");
                K(b, !0) && d.redraw(q ? void 0 : !1);
            };
            a.prototype.setName = function(a) {
                this.name = this.options.name = this.userOptions.name = a;
                this.chart.isDirtyLegend = !0;
            };
            a.prototype.hasOptionChanged = function(a) {
                var b = this.options[a], c = this.chart.options.plotOptions, d = this.userOptions[a];
                return d ? b !== d : b !== K(c && c[this.type] && c[this.type][a], c && c.series && c.series[a], b);
            };
            a.prototype.onMouseOver = function() {
                var a = this.chart, b = a.hoverSeries;
                a.pointer.setHoverChartIndex();
                if (b && b !== this) b.onMouseOut();
                this.options.events.mouseOver && I(this, "mouseOver");
                this.setState("hover");
                a.hoverSeries = this;
            };
            a.prototype.onMouseOut = function() {
                var a = this.options, b = this.chart, c = b.tooltip, d = b.hoverPoint;
                b.hoverSeries = null;
                if (d) d.onMouseOut();
                this && a.events.mouseOut && I(this, "mouseOut");
                !c || this.stickyTracking || c.shared && !this.noSharedTooltip || c.hide();
                b.series.forEach(function(a) {
                    a.setState("", !0);
                });
            };
            a.prototype.setState = function(a, b) {
                var c = this, d = c.options, e = c.graph, g = d.inactiveOtherPoints, f = d.states, h = K(f[a || "normal"] && f[a || "normal"].animation, c.chart.options.chart.animation), l = d.lineWidth, k = 0, m = d.opacity;
                a = a || "";
                if (c.state !== a && ([
                    c.group,
                    c.markerGroup,
                    c.dataLabelsGroup
                ].forEach(function(b) {
                    b && (c.state && b.removeClass("highcharts-series-" + c.state), a && b.addClass("highcharts-series-" + a));
                }), c.state = a, !c.chart.styledMode)) {
                    if (f[a] && !1 === f[a].enabled) return;
                    a && (l = f[a].lineWidth || l + (f[a].lineWidthPlus || 0), m = K(f[a].opacity, m));
                    if (e && !e.dashstyle) for(d = {
                        "stroke-width": l
                    }, e.animate(d, h); c["zone-graph-" + k];)c["zone-graph-" + k].animate(d, h), k += 1;
                    g || [
                        c.group,
                        c.markerGroup,
                        c.dataLabelsGroup,
                        c.labelBySeries
                    ].forEach(function(a) {
                        a && a.animate({
                            opacity: m
                        }, h);
                    });
                }
                b && g && c.points && c.setAllPointsToState(a || void 0);
            };
            a.prototype.setAllPointsToState = function(a) {
                this.points.forEach(function(b) {
                    b.setState && b.setState(a);
                });
            };
            a.prototype.setVisible = function(a, b) {
                var c = this, d = c.chart, e = c.legendItem, g = d.options.chart.ignoreHiddenSeries, f = c.visible, h = (c.visible = a = c.options.visible = c.userOptions.visible = "undefined" === typeof a ? !f : a) ? "show" : "hide";
                [
                    "group",
                    "dataLabelsGroup",
                    "markerGroup",
                    "tracker",
                    "tt"
                ].forEach(function(a) {
                    if (c[a]) c[a][h]();
                });
                if (d.hoverSeries === c || (d.hoverPoint && d.hoverPoint.series) === c) c.onMouseOut();
                e && d.legend.colorizeItem(c, a);
                c.isDirty = !0;
                c.options.stacking && d.series.forEach(function(a) {
                    a.options.stacking && a.visible && (a.isDirty = !0);
                });
                c.linkedSeries.forEach(function(b) {
                    b.setVisible(a, !1);
                });
                g && (d.isDirtyBox = !0);
                I(c, h);
                !1 !== b && d.redraw();
            };
            a.prototype.show = function() {
                this.setVisible(!0);
            };
            a.prototype.hide = function() {
                this.setVisible(!1);
            };
            a.prototype.select = function(a) {
                this.selected = a = this.options.selected = "undefined" === typeof a ? !this.selected : a;
                this.checkbox && (this.checkbox.checked = a);
                I(this, a ? "select" : "unselect");
            };
            a.prototype.shouldShowTooltip = function(a, b, c) {
                void 0 === c && (c = {});
                c.series = this;
                c.visiblePlotOnly = !0;
                return this.chart.isInsidePlot(a, b, c);
            };
            a.defaultOptions = H;
            return a;
        }();
        D(a.prototype, {
            axisTypes: [
                "xAxis",
                "yAxis"
            ],
            coll: "series",
            colorCounter: 0,
            cropShoulder: 1,
            directTouch: !1,
            drawLegendSymbol: y.drawLineMarker,
            isCartesian: !0,
            kdAxisArray: [
                "clientX",
                "plotY"
            ],
            parallelArrays: [
                "x",
                "y"
            ],
            pointClass: G,
            requireSorting: !0,
            sorted: !0
        });
        A.series = a;
        "";
        "";
        return a;
    });
    M(a, "Extensions/ScrollablePlotArea.js", [
        a["Core/Animation/AnimationUtilities.js"],
        a["Core/Axis/Axis.js"],
        a["Core/Chart/Chart.js"],
        a["Core/Series/Series.js"],
        a["Core/Renderer/RendererRegistry.js"],
        a["Core/Utilities.js"]
    ], function(a, u, z, F, y, G) {
        var v = a.stop, A = G.addEvent, q = G.createElement, n = G.merge, k = G.pick;
        A(z, "afterSetChartSize", function(a) {
            var c = this.options.chart.scrollablePlotArea, e = c && c.minWidth;
            c = c && c.minHeight;
            if (!this.renderer.forExport) {
                if (e) {
                    if (this.scrollablePixelsX = e = Math.max(0, e - this.chartWidth)) {
                        this.scrollablePlotBox = this.renderer.scrollablePlotBox = n(this.plotBox);
                        this.plotBox.width = this.plotWidth += e;
                        this.inverted ? this.clipBox.height += e : this.clipBox.width += e;
                        var f = {
                            1: {
                                name: "right",
                                value: e
                            }
                        };
                    }
                } else c && (this.scrollablePixelsY = e = Math.max(0, c - this.chartHeight)) && (this.scrollablePlotBox = this.renderer.scrollablePlotBox = n(this.plotBox), this.plotBox.height = this.plotHeight += e, this.inverted ? this.clipBox.width += e : this.clipBox.height += e, f = {
                    2: {
                        name: "bottom",
                        value: e
                    }
                });
                f && !a.skipAxes && this.axes.forEach(function(a) {
                    f[a.side] ? a.getPlotLinePath = function() {
                        var c = f[a.side].name, e = this[c];
                        this[c] = e - f[a.side].value;
                        var h = u.prototype.getPlotLinePath.apply(this, arguments);
                        this[c] = e;
                        return h;
                    } : (a.setAxisSize(), a.setAxisTranslation());
                });
            }
        });
        A(z, "render", function() {
            this.scrollablePixelsX || this.scrollablePixelsY ? (this.setUpScrolling && this.setUpScrolling(), this.applyFixed()) : this.fixedDiv && this.applyFixed();
        });
        z.prototype.setUpScrolling = function() {
            var a = this, c = {
                WebkitOverflowScrolling: "touch",
                overflowX: "hidden",
                overflowY: "hidden"
            };
            this.scrollablePixelsX && (c.overflowX = "auto");
            this.scrollablePixelsY && (c.overflowY = "auto");
            this.scrollingParent = q("div", {
                className: "highcharts-scrolling-parent"
            }, {
                position: "relative"
            }, this.renderTo);
            this.scrollingContainer = q("div", {
                className: "highcharts-scrolling"
            }, c, this.scrollingParent);
            A(this.scrollingContainer, "scroll", function() {
                a.pointer && delete a.pointer.chartPosition;
            });
            this.innerContainer = q("div", {
                className: "highcharts-inner-container"
            }, null, this.scrollingContainer);
            this.innerContainer.appendChild(this.container);
            this.setUpScrolling = null;
        };
        z.prototype.moveFixedElements = function() {
            var a = this.container, c = this.fixedRenderer, h = ".highcharts-contextbutton .highcharts-credits .highcharts-legend .highcharts-legend-checkbox .highcharts-navigator-series .highcharts-navigator-xaxis .highcharts-navigator-yaxis .highcharts-navigator .highcharts-reset-zoom .highcharts-drillup-button .highcharts-scrollbar .highcharts-subtitle .highcharts-title".split(" "), f;
            this.scrollablePixelsX && !this.inverted ? f = ".highcharts-yaxis" : this.scrollablePixelsX && this.inverted ? f = ".highcharts-xaxis" : this.scrollablePixelsY && !this.inverted ? f = ".highcharts-xaxis" : this.scrollablePixelsY && this.inverted && (f = ".highcharts-yaxis");
            f && h.push(f + ":not(.highcharts-radial-axis)", f + "-labels:not(.highcharts-radial-axis-labels)");
            h.forEach(function(e) {
                [].forEach.call(a.querySelectorAll(e), function(a) {
                    (a.namespaceURI === c.SVG_NS ? c.box : c.box.parentNode).appendChild(a);
                    a.style.pointerEvents = "auto";
                });
            });
        };
        z.prototype.applyFixed = function() {
            var a = !this.fixedDiv, c = this.options.chart, h = c.scrollablePlotArea, f = y.getRendererType();
            a ? (this.fixedDiv = q("div", {
                className: "highcharts-fixed"
            }, {
                position: "absolute",
                overflow: "hidden",
                pointerEvents: "none",
                zIndex: (c.style && c.style.zIndex || 0) + 2,
                top: 0
            }, null, !0), this.scrollingContainer && this.scrollingContainer.parentNode.insertBefore(this.fixedDiv, this.scrollingContainer), this.renderTo.style.overflow = "visible", this.fixedRenderer = c = new f(this.fixedDiv, this.chartWidth, this.chartHeight, this.options.chart.style), this.scrollableMask = c.path().attr({
                fill: this.options.chart.backgroundColor || "#fff",
                "fill-opacity": k(h.opacity, .85),
                zIndex: -1
            }).addClass("highcharts-scrollable-mask").add(), A(this, "afterShowResetZoom", this.moveFixedElements), A(this, "afterDrilldown", this.moveFixedElements), A(this, "afterLayOutTitles", this.moveFixedElements)) : this.fixedRenderer.setSize(this.chartWidth, this.chartHeight);
            if (this.scrollableDirty || a) this.scrollableDirty = !1, this.moveFixedElements();
            c = this.chartWidth + (this.scrollablePixelsX || 0);
            f = this.chartHeight + (this.scrollablePixelsY || 0);
            v(this.container);
            this.container.style.width = c + "px";
            this.container.style.height = f + "px";
            this.renderer.boxWrapper.attr({
                width: c,
                height: f,
                viewBox: [
                    0,
                    0,
                    c,
                    f
                ].join(" ")
            });
            this.chartBackground.attr({
                width: c,
                height: f
            });
            this.scrollingContainer.style.height = this.chartHeight + "px";
            a && (h.scrollPositionX && (this.scrollingContainer.scrollLeft = this.scrollablePixelsX * h.scrollPositionX), h.scrollPositionY && (this.scrollingContainer.scrollTop = this.scrollablePixelsY * h.scrollPositionY));
            f = this.axisOffset;
            a = this.plotTop - f[0] - 1;
            h = this.plotLeft - f[3] - 1;
            c = this.plotTop + this.plotHeight + f[2] + 1;
            f = this.plotLeft + this.plotWidth + f[1] + 1;
            var n = this.plotLeft + this.plotWidth - (this.scrollablePixelsX || 0), p = this.plotTop + this.plotHeight - (this.scrollablePixelsY || 0);
            a = this.scrollablePixelsX ? [
                [
                    "M",
                    0,
                    a
                ],
                [
                    "L",
                    this.plotLeft - 1,
                    a
                ],
                [
                    "L",
                    this.plotLeft - 1,
                    c
                ],
                [
                    "L",
                    0,
                    c
                ],
                [
                    "Z"
                ],
                [
                    "M",
                    n,
                    a
                ],
                [
                    "L",
                    this.chartWidth,
                    a
                ],
                [
                    "L",
                    this.chartWidth,
                    c
                ],
                [
                    "L",
                    n,
                    c
                ],
                [
                    "Z"
                ]
            ] : this.scrollablePixelsY ? [
                [
                    "M",
                    h,
                    0
                ],
                [
                    "L",
                    h,
                    this.plotTop - 1
                ],
                [
                    "L",
                    f,
                    this.plotTop - 1
                ],
                [
                    "L",
                    f,
                    0
                ],
                [
                    "Z"
                ],
                [
                    "M",
                    h,
                    p
                ],
                [
                    "L",
                    h,
                    this.chartHeight
                ],
                [
                    "L",
                    f,
                    this.chartHeight
                ],
                [
                    "L",
                    f,
                    p
                ],
                [
                    "Z"
                ]
            ] : [
                [
                    "M",
                    0,
                    0
                ]
            ];
            "adjustHeight" !== this.redrawTrigger && this.scrollableMask.attr({
                d: a
            });
        };
        A(u, "afterInit", function() {
            this.chart.scrollableDirty = !0;
        });
        A(F, "show", function() {
            this.chart.scrollableDirty = !0;
        });
        "";
    });
    M(a, "Core/Axis/StackingAxis.js", [
        a["Core/Animation/AnimationUtilities.js"],
        a["Core/Axis/Axis.js"],
        a["Core/Utilities.js"]
    ], function(a, u, z) {
        var v = a.getDeferredAnimation, y = z.addEvent, G = z.destroyObjectProperties, H = z.fireEvent, A = z.isNumber, q = z.objectEach, n;
        (function(a) {
            function e() {
                var a = this.stacking;
                if (a) {
                    var c = a.stacks;
                    q(c, function(a, e) {
                        G(a);
                        c[e] = null;
                    });
                    a && a.stackTotalGroup && a.stackTotalGroup.destroy();
                }
            }
            function c() {
                this.stacking || (this.stacking = new f(this));
            }
            var h = [];
            a.compose = function(a) {
                -1 === h.indexOf(a) && (h.push(a), y(a, "init", c), y(a, "destroy", e));
                return a;
            };
            var f = function() {
                function a(a) {
                    this.oldStacks = {};
                    this.stacks = {};
                    this.stacksTouched = 0;
                    this.axis = a;
                }
                a.prototype.buildStacks = function() {
                    var a = this.axis, c = a.series, e = a.options.reversedStacks, f = c.length, h;
                    if (!a.isXAxis) {
                        this.usePercentage = !1;
                        for(h = f; h--;){
                            var k = c[e ? h : f - h - 1];
                            k.setStackedPoints();
                            k.setGroupedPoints();
                        }
                        for(h = 0; h < f; h++)c[h].modifyStacks();
                        H(a, "afterBuildStacks");
                    }
                };
                a.prototype.cleanStacks = function() {
                    if (!this.axis.isXAxis) {
                        if (this.oldStacks) var a = this.stacks = this.oldStacks;
                        q(a, function(a) {
                            q(a, function(a) {
                                a.cumulative = a.total;
                            });
                        });
                    }
                };
                a.prototype.resetStacks = function() {
                    var a = this, c = a.stacks;
                    a.axis.isXAxis || q(c, function(c) {
                        q(c, function(e, f) {
                            A(e.touched) && e.touched < a.stacksTouched ? (e.destroy(), delete c[f]) : (e.total = null, e.cumulative = null);
                        });
                    });
                };
                a.prototype.renderStackTotals = function() {
                    var a = this.axis, c = a.chart, e = c.renderer, f = this.stacks;
                    a = v(c, a.options.stackLabels && a.options.stackLabels.animation || !1);
                    var h = this.stackTotalGroup = this.stackTotalGroup || e.g("stack-labels").attr({
                        visibility: "visible",
                        zIndex: 6,
                        opacity: 0
                    }).add();
                    h.translate(c.plotLeft, c.plotTop);
                    q(f, function(a) {
                        q(a, function(a) {
                            a.render(h);
                        });
                    });
                    h.animate({
                        opacity: 1
                    }, a);
                };
                return a;
            }();
            a.Additions = f;
        })(n || (n = {}));
        return n;
    });
    M(a, "Extensions/Stacking.js", [
        a["Core/Axis/Axis.js"],
        a["Core/Chart/Chart.js"],
        a["Core/FormatUtilities.js"],
        a["Core/Globals.js"],
        a["Core/Series/Series.js"],
        a["Core/Axis/StackingAxis.js"],
        a["Core/Utilities.js"]
    ], function(a, u, z, F, y, G, H) {
        var v = z.format, q = H.correctFloat, n = H.defined, k = H.destroyObjectProperties, e = H.isArray, c = H.isNumber, h = H.objectEach, f = H.pick, w = function() {
            function a(a, c, e, f, h) {
                var l = a.chart.inverted;
                this.axis = a;
                this.isNegative = e;
                this.options = c = c || {};
                this.x = f;
                this.total = null;
                this.points = {};
                this.hasValidPoints = !1;
                this.stack = h;
                this.rightCliff = this.leftCliff = 0;
                this.alignOptions = {
                    align: c.align || (l ? e ? "left" : "right" : "center"),
                    verticalAlign: c.verticalAlign || (l ? "middle" : e ? "bottom" : "top"),
                    y: c.y,
                    x: c.x
                };
                this.textAlign = c.textAlign || (l ? e ? "right" : "left" : "center");
            }
            a.prototype.destroy = function() {
                k(this, this.axis);
            };
            a.prototype.render = function(a) {
                var c = this.axis.chart, e = this.options, h = e.format;
                h = h ? v(h, this, c) : e.formatter.call(this);
                this.label ? this.label.attr({
                    text: h,
                    visibility: "hidden"
                }) : (this.label = c.renderer.label(h, null, null, e.shape, null, null, e.useHTML, !1, "stack-labels"), h = {
                    r: e.borderRadius || 0,
                    text: h,
                    rotation: e.rotation,
                    padding: f(e.padding, 5),
                    visibility: "hidden"
                }, c.styledMode || (h.fill = e.backgroundColor, h.stroke = e.borderColor, h["stroke-width"] = e.borderWidth, this.label.css(e.style)), this.label.attr(h), this.label.added || this.label.add(a));
                this.label.labelrank = c.plotSizeY;
            };
            a.prototype.setOffset = function(a, e, h, k, p) {
                var l = this.axis, b = l.chart;
                k = l.translate(l.stacking.usePercentage ? 100 : k ? k : this.total, 0, 0, 0, 1);
                h = l.translate(h ? h : 0);
                h = n(k) && Math.abs(k - h);
                a = f(p, b.xAxis[0].translate(this.x)) + a;
                l = n(k) && this.getStackBox(b, this, a, k, e, h, l);
                e = this.label;
                h = this.isNegative;
                a = "justify" === f(this.options.overflow, "justify");
                var g = this.textAlign;
                e && l && (p = e.getBBox(), k = e.padding, g = "left" === g ? b.inverted ? -k : k : "right" === g ? p.width : b.inverted && "center" === g ? p.width / 2 : b.inverted ? h ? p.width + k : -k : p.width / 2, h = b.inverted ? p.height / 2 : h ? -k : p.height, this.alignOptions.x = f(this.options.x, 0), this.alignOptions.y = f(this.options.y, 0), l.x -= g, l.y -= h, e.align(this.alignOptions, null, l), b.isInsidePlot(e.alignAttr.x + g - this.alignOptions.x, e.alignAttr.y + h - this.alignOptions.y) ? e.show() : (e.alignAttr.y = -9999, a = !1), a && y.prototype.justifyDataLabel.call(this.axis, e, this.alignOptions, e.alignAttr, p, l), e.attr({
                    x: e.alignAttr.x,
                    y: e.alignAttr.y
                }), f(!a && this.options.crop, !0) && ((b = c(e.x) && c(e.y) && b.isInsidePlot(e.x - k + e.width, e.y) && b.isInsidePlot(e.x + k, e.y)) || e.hide()));
            };
            a.prototype.getStackBox = function(a, c, e, f, h, l, b) {
                var g = c.axis.reversed, d = a.inverted, k = b.height + b.pos - (d ? a.plotLeft : a.plotTop);
                c = c.isNegative && !g || !c.isNegative && g;
                return {
                    x: d ? c ? f - b.right : f - l + b.pos - a.plotLeft : e + a.xAxis[0].transB - a.plotLeft,
                    y: d ? b.height - e - h : c ? k - f - l : k - f,
                    width: d ? l : h,
                    height: d ? h : l
                };
            };
            return a;
        }();
        u.prototype.getStacks = function() {
            var a = this, c = a.inverted;
            a.yAxis.forEach(function(a) {
                a.stacking && a.stacking.stacks && a.hasVisibleSeries && (a.stacking.oldStacks = a.stacking.stacks);
            });
            a.series.forEach(function(e) {
                var h = e.xAxis && e.xAxis.options || {};
                !e.options.stacking || !0 !== e.visible && !1 !== a.options.chart.ignoreHiddenSeries || (e.stackKey = [
                    e.type,
                    f(e.options.stack, ""),
                    c ? h.top : h.left,
                    c ? h.height : h.width
                ].join());
            });
        };
        G.compose(a);
        y.prototype.setGroupedPoints = function() {
            var a = this.yAxis.stacking;
            this.options.centerInCategory && (this.is("column") || this.is("columnrange")) && !this.options.stacking && 1 < this.chart.series.length ? y.prototype.setStackedPoints.call(this, "group") : a && h(a.stacks, function(c, e) {
                "group" === e.slice(-5) && (h(c, function(a) {
                    return a.destroy();
                }), delete a.stacks[e]);
            });
        };
        y.prototype.setStackedPoints = function(a) {
            var c = a || this.options.stacking;
            if (c && (!0 === this.visible || !1 === this.chart.options.chart.ignoreHiddenSeries)) {
                var h = this.processedXData, k = this.processedYData, p = [], r = k.length, l = this.options, b = l.threshold, g = f(l.startFromThreshold && b, 0);
                l = l.stack;
                a = a ? this.type + "," + c : this.stackKey;
                var d = "-" + a, m = this.negStacks, v = this.yAxis, x = v.stacking.stacks, u = v.stacking.oldStacks, A, y;
                v.stacking.stacksTouched += 1;
                for(y = 0; y < r; y++){
                    var z = h[y];
                    var F = k[y];
                    var H = this.getStackIndicator(H, z, this.index);
                    var G = H.key;
                    var K = (A = m && F < (g ? 0 : b)) ? d : a;
                    x[K] || (x[K] = {});
                    x[K][z] || (u[K] && u[K][z] ? (x[K][z] = u[K][z], x[K][z].total = null) : x[K][z] = new w(v, v.options.stackLabels, A, z, l));
                    K = x[K][z];
                    null !== F ? (K.points[G] = K.points[this.index] = [
                        f(K.cumulative, g)
                    ], n(K.cumulative) || (K.base = G), K.touched = v.stacking.stacksTouched, 0 < H.index && !1 === this.singleStacks && (K.points[G][0] = K.points[this.index + "," + z + ",0"][0])) : K.points[G] = K.points[this.index] = null;
                    "percent" === c ? (A = A ? a : d, m && x[A] && x[A][z] ? (A = x[A][z], K.total = A.total = Math.max(A.total, K.total) + Math.abs(F) || 0) : K.total = q(K.total + (Math.abs(F) || 0))) : "group" === c ? (e(F) && (F = F[0]), null !== F && (K.total = (K.total || 0) + 1)) : K.total = q(K.total + (F || 0));
                    K.cumulative = "group" === c ? (K.total || 1) - 1 : f(K.cumulative, g) + (F || 0);
                    null !== F && (K.points[G].push(K.cumulative), p[y] = K.cumulative, K.hasValidPoints = !0);
                }
                "percent" === c && (v.stacking.usePercentage = !0);
                "group" !== c && (this.stackedYData = p);
                v.stacking.oldStacks = {};
            }
        };
        y.prototype.modifyStacks = function() {
            var a = this, c = a.stackKey, e = a.yAxis.stacking.stacks, f = a.processedXData, h, k = a.options.stacking;
            a[k + "Stacker"] && [
                c,
                "-" + c
            ].forEach(function(c) {
                for(var b = f.length, g, d; b--;)if (g = f[b], h = a.getStackIndicator(h, g, a.index, c), d = (g = e[c] && e[c][g]) && g.points[h.key]) a[k + "Stacker"](d, g, b);
            });
        };
        y.prototype.percentStacker = function(a, c, e) {
            c = c.total ? 100 / c.total : 0;
            a[0] = q(a[0] * c);
            a[1] = q(a[1] * c);
            this.stackedYData[e] = a[1];
        };
        y.prototype.getStackIndicator = function(a, c, e, f) {
            !n(a) || a.x !== c || f && a.key !== f ? a = {
                x: c,
                index: 0,
                key: f
            } : a.index++;
            a.key = [
                e,
                c,
                a.index
            ].join();
            return a;
        };
        F.StackItem = w;
        "";
        return F.StackItem;
    });
    M(a, "Series/Line/LineSeries.js", [
        a["Core/Series/Series.js"],
        a["Core/Series/SeriesRegistry.js"],
        a["Core/Utilities.js"]
    ], function(a, u, z) {
        var v = this && this.__extends || function() {
            var a = function(v, q) {
                a = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(a, k) {
                    a.__proto__ = k;
                } || function(a, k) {
                    for(var e in k)k.hasOwnProperty(e) && (a[e] = k[e]);
                };
                return a(v, q);
            };
            return function(v, q) {
                function n() {
                    this.constructor = v;
                }
                a(v, q);
                v.prototype = null === q ? Object.create(q) : (n.prototype = q.prototype, new n);
            };
        }(), y = z.defined, G = z.merge;
        z = function(u) {
            function A() {
                var a = null !== u && u.apply(this, arguments) || this;
                a.data = void 0;
                a.options = void 0;
                a.points = void 0;
                return a;
            }
            v(A, u);
            A.prototype.drawGraph = function() {
                var a = this, n = this.options, k = (this.gappedPath || this.getGraphPath).call(this), e = this.chart.styledMode, c = [
                    [
                        "graph",
                        "highcharts-graph"
                    ]
                ];
                e || c[0].push(n.lineColor || this.color || "#cccccc", n.dashStyle);
                c = a.getZonesGraphs(c);
                c.forEach(function(c, f) {
                    var h = c[0], p = a[h], q = p ? "animate" : "attr";
                    p ? (p.endX = a.preventGraphAnimation ? null : k.xMap, p.animate({
                        d: k
                    })) : k.length && (a[h] = p = a.chart.renderer.path(k).addClass(c[1]).attr({
                        zIndex: 1
                    }).add(a.group));
                    p && !e && (h = {
                        stroke: c[2],
                        "stroke-width": n.lineWidth,
                        fill: a.fillGraph && a.color || "none"
                    }, c[3] ? h.dashstyle = c[3] : "square" !== n.linecap && (h["stroke-linecap"] = h["stroke-linejoin"] = "round"), p[q](h).shadow(2 > f && n.shadow));
                    p && (p.startX = k.xMap, p.isArea = k.isArea);
                });
            };
            A.prototype.getGraphPath = function(a, n, k) {
                var e = this, c = e.options, h = [], f = [], q, p = c.step;
                a = a || e.points;
                var v = a.reversed;
                v && a.reverse();
                (p = ({
                    right: 1,
                    center: 2
                })[p] || p && 3) && v && (p = 4 - p);
                a = this.getValidPoints(a, !1, !(c.connectNulls && !n && !k));
                a.forEach(function(t, v) {
                    var w = t.plotX, r = t.plotY, l = a[v - 1];
                    (t.leftCliff || l && l.rightCliff) && !k && (q = !0);
                    t.isNull && !y(n) && 0 < v ? q = !c.connectNulls : t.isNull && !n ? q = !0 : (0 === v || q ? v = [
                        [
                            "M",
                            t.plotX,
                            t.plotY
                        ]
                    ] : e.getPointSpline ? v = [
                        e.getPointSpline(a, t, v)
                    ] : p ? (v = 1 === p ? [
                        [
                            "L",
                            l.plotX,
                            r
                        ]
                    ] : 2 === p ? [
                        [
                            "L",
                            (l.plotX + w) / 2,
                            l.plotY
                        ],
                        [
                            "L",
                            (l.plotX + w) / 2,
                            r
                        ]
                    ] : [
                        [
                            "L",
                            w,
                            l.plotY
                        ]
                    ], v.push([
                        "L",
                        w,
                        r
                    ])) : v = [
                        [
                            "L",
                            w,
                            r
                        ]
                    ], f.push(t.x), p && (f.push(t.x), 2 === p && f.push(t.x)), h.push.apply(h, v), q = !1);
                });
                h.xMap = f;
                return e.graphPath = h;
            };
            A.prototype.getZonesGraphs = function(a) {
                this.zones.forEach(function(n, k) {
                    k = [
                        "zone-graph-" + k,
                        "highcharts-graph highcharts-zone-graph-" + k + " " + (n.className || "")
                    ];
                    this.chart.styledMode || k.push(n.color || this.color, n.dashStyle || this.options.dashStyle);
                    a.push(k);
                }, this);
                return a;
            };
            A.defaultOptions = G(a.defaultOptions, {});
            return A;
        }(a);
        u.registerSeriesType("line", z);
        "";
        return z;
    });
    M(a, "Series/Area/AreaSeries.js", [
        a["Core/Color/Color.js"],
        a["Core/Legend/LegendSymbol.js"],
        a["Core/Series/SeriesRegistry.js"],
        a["Core/Utilities.js"]
    ], function(a, u, z, F) {
        var v = this && this.__extends || function() {
            var a = function(e, c) {
                a = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(a, c) {
                    a.__proto__ = c;
                } || function(a, c) {
                    for(var e in c)c.hasOwnProperty(e) && (a[e] = c[e]);
                };
                return a(e, c);
            };
            return function(e, c) {
                function h() {
                    this.constructor = e;
                }
                a(e, c);
                e.prototype = null === c ? Object.create(c) : (h.prototype = c.prototype, new h);
            };
        }(), G = a.parse, H = z.seriesTypes.line;
        a = F.extend;
        var A = F.merge, q = F.objectEach, n = F.pick;
        F = function(a) {
            function e() {
                var c = null !== a && a.apply(this, arguments) || this;
                c.data = void 0;
                c.options = void 0;
                c.points = void 0;
                return c;
            }
            v(e, a);
            e.prototype.drawGraph = function() {
                this.areaPath = [];
                a.prototype.drawGraph.apply(this);
                var c = this, e = this.areaPath, f = this.options, k = [
                    [
                        "area",
                        "highcharts-area",
                        this.color,
                        f.fillColor
                    ]
                ];
                this.zones.forEach(function(a, e) {
                    k.push([
                        "zone-area-" + e,
                        "highcharts-area highcharts-zone-area-" + e + " " + a.className,
                        a.color || c.color,
                        a.fillColor || f.fillColor
                    ]);
                });
                k.forEach(function(a) {
                    var h = a[0], k = c[h], p = k ? "animate" : "attr", q = {};
                    k ? (k.endX = c.preventGraphAnimation ? null : e.xMap, k.animate({
                        d: e
                    })) : (q.zIndex = 0, k = c[h] = c.chart.renderer.path(e).addClass(a[1]).add(c.group), k.isArea = !0);
                    c.chart.styledMode || (q.fill = n(a[3], G(a[2]).setOpacity(n(f.fillOpacity, .75)).get()));
                    k[p](q);
                    k.startX = e.xMap;
                    k.shiftUnit = f.step ? 2 : 1;
                });
            };
            e.prototype.getGraphPath = function(a) {
                var c = H.prototype.getGraphPath, e = this.options, k = e.stacking, p = this.yAxis, q, t = [], v = [], u = this.index, r = p.stacking.stacks[this.stackKey], l = e.threshold, b = Math.round(p.getThreshold(e.threshold));
                e = n(e.connectNulls, "percent" === k);
                var g = function(c, d, e) {
                    var g = a[c];
                    c = k && r[g.x].points[u];
                    var f = g[e + "Null"] || 0;
                    e = g[e + "Cliff"] || 0;
                    g = !0;
                    if (e || f) {
                        var h = (f ? c[0] : c[1]) + e;
                        var n = c[0] + e;
                        g = !!f;
                    } else !k && a[d] && a[d].isNull && (h = n = l);
                    "undefined" !== typeof h && (v.push({
                        plotX: m,
                        plotY: null === h ? b : p.getThreshold(h),
                        isNull: g,
                        isCliff: !0
                    }), t.push({
                        plotX: m,
                        plotY: null === n ? b : p.getThreshold(n),
                        doCurve: !1
                    }));
                };
                a = a || this.points;
                k && (a = this.getStackPoints(a));
                for(q = 0; q < a.length; q++){
                    k || (a[q].leftCliff = a[q].rightCliff = a[q].leftNull = a[q].rightNull = void 0);
                    var d = a[q].isNull;
                    var m = n(a[q].rectPlotX, a[q].plotX);
                    var D = k ? n(a[q].yBottom, b) : b;
                    if (!d || e) e || g(q, q - 1, "left"), d && !k && e || (v.push(a[q]), t.push({
                        x: q,
                        plotX: m,
                        plotY: D
                    })), e || g(q, q + 1, "right");
                }
                q = c.call(this, v, !0, !0);
                t.reversed = !0;
                d = c.call(this, t, !0, !0);
                (D = d[0]) && "M" === D[0] && (d[0] = [
                    "L",
                    D[1],
                    D[2]
                ]);
                d = q.concat(d);
                d.length && d.push([
                    "Z"
                ]);
                c = c.call(this, v, !1, e);
                d.xMap = q.xMap;
                this.areaPath = d;
                return c;
            };
            e.prototype.getStackPoints = function(a) {
                var c = this, e = [], k = [], p = this.xAxis, v = this.yAxis, t = v.stacking.stacks[this.stackKey], u = {}, C = v.series, r = C.length, l = v.options.reversedStacks ? 1 : -1, b = C.indexOf(c);
                a = a || this.points;
                if (this.options.stacking) {
                    for(var g = 0; g < a.length; g++)a[g].leftNull = a[g].rightNull = void 0, u[a[g].x] = a[g];
                    q(t, function(a, b) {
                        null !== a.total && k.push(b);
                    });
                    k.sort(function(a, b) {
                        return a - b;
                    });
                    var d = C.map(function(a) {
                        return a.visible;
                    });
                    k.forEach(function(a, g) {
                        var f = 0, h, m;
                        if (u[a] && !u[a].isNull) e.push(u[a]), [
                            -1,
                            1
                        ].forEach(function(e) {
                            var f = 1 === e ? "rightNull" : "leftNull", n = 0, p = t[k[g + e]];
                            if (p) for(var q = b; 0 <= q && q < r;){
                                var v = C[q].index;
                                h = p.points[v];
                                h || (v === c.index ? u[a][f] = !0 : d[q] && (m = t[a].points[v]) && (n -= m[1] - m[0]));
                                q += l;
                            }
                            u[a][1 === e ? "rightCliff" : "leftCliff"] = n;
                        });
                        else {
                            for(var q = b; 0 <= q && q < r;){
                                if (h = t[a].points[C[q].index]) {
                                    f = h[1];
                                    break;
                                }
                                q += l;
                            }
                            f = n(f, 0);
                            f = v.translate(f, 0, 1, 0, 1);
                            e.push({
                                isNull: !0,
                                plotX: p.translate(a, 0, 0, 0, 1),
                                x: a,
                                plotY: f,
                                yBottom: f
                            });
                        }
                    });
                }
                return e;
            };
            e.defaultOptions = A(H.defaultOptions, {
                threshold: 0
            });
            return e;
        }(H);
        a(F.prototype, {
            singleStacks: !1,
            drawLegendSymbol: u.drawRectangle
        });
        z.registerSeriesType("area", F);
        "";
        return F;
    });
    M(a, "Series/Spline/SplineSeries.js", [
        a["Core/Series/SeriesRegistry.js"],
        a["Core/Utilities.js"]
    ], function(a, u) {
        var v = this && this.__extends || function() {
            var a = function(v, q) {
                a = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(a, k) {
                    a.__proto__ = k;
                } || function(a, k) {
                    for(var e in k)k.hasOwnProperty(e) && (a[e] = k[e]);
                };
                return a(v, q);
            };
            return function(v, q) {
                function n() {
                    this.constructor = v;
                }
                a(v, q);
                v.prototype = null === q ? Object.create(q) : (n.prototype = q.prototype, new n);
            };
        }(), F = a.seriesTypes.line, y = u.merge, G = u.pick;
        u = function(a) {
            function u() {
                var q = null !== a && a.apply(this, arguments) || this;
                q.data = void 0;
                q.options = void 0;
                q.points = void 0;
                return q;
            }
            v(u, a);
            u.prototype.getPointSpline = function(a, n, k) {
                var e = n.plotX || 0, c = n.plotY || 0, h = a[k - 1];
                k = a[k + 1];
                if (h && !h.isNull && !1 !== h.doCurve && !n.isCliff && k && !k.isNull && !1 !== k.doCurve && !n.isCliff) {
                    a = h.plotY || 0;
                    var f = k.plotX || 0;
                    k = k.plotY || 0;
                    var q = 0;
                    var p = (1.5 * e + (h.plotX || 0)) / 2.5;
                    var v = (1.5 * c + a) / 2.5;
                    f = (1.5 * e + f) / 2.5;
                    var t = (1.5 * c + k) / 2.5;
                    f !== p && (q = (t - v) * (f - e) / (f - p) + c - t);
                    v += q;
                    t += q;
                    v > a && v > c ? (v = Math.max(a, c), t = 2 * c - v) : v < a && v < c && (v = Math.min(a, c), t = 2 * c - v);
                    t > k && t > c ? (t = Math.max(k, c), v = 2 * c - t) : t < k && t < c && (t = Math.min(k, c), v = 2 * c - t);
                    n.rightContX = f;
                    n.rightContY = t;
                }
                n = [
                    "C",
                    G(h.rightContX, h.plotX, 0),
                    G(h.rightContY, h.plotY, 0),
                    G(p, e, 0),
                    G(v, c, 0),
                    e,
                    c
                ];
                h.rightContX = h.rightContY = void 0;
                return n;
            };
            u.defaultOptions = y(F.defaultOptions);
            return u;
        }(F);
        a.registerSeriesType("spline", u);
        "";
        return u;
    });
    M(a, "Series/AreaSpline/AreaSplineSeries.js", [
        a["Series/Area/AreaSeries.js"],
        a["Series/Spline/SplineSeries.js"],
        a["Core/Legend/LegendSymbol.js"],
        a["Core/Series/SeriesRegistry.js"],
        a["Core/Utilities.js"]
    ], function(a, u, z, F, y) {
        var v = this && this.__extends || function() {
            var a = function(k, e) {
                a = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(a, e) {
                    a.__proto__ = e;
                } || function(a, e) {
                    for(var c in e)e.hasOwnProperty(c) && (a[c] = e[c]);
                };
                return a(k, e);
            };
            return function(k, e) {
                function c() {
                    this.constructor = k;
                }
                a(k, e);
                k.prototype = null === e ? Object.create(e) : (c.prototype = e.prototype, new c);
            };
        }(), H = a.prototype, A = y.extend, q = y.merge;
        y = function(n) {
            function k() {
                var a = null !== n && n.apply(this, arguments) || this;
                a.data = void 0;
                a.points = void 0;
                a.options = void 0;
                return a;
            }
            v(k, n);
            k.defaultOptions = q(u.defaultOptions, a.defaultOptions);
            return k;
        }(u);
        A(y.prototype, {
            getGraphPath: H.getGraphPath,
            getStackPoints: H.getStackPoints,
            drawGraph: H.drawGraph,
            drawLegendSymbol: z.drawRectangle
        });
        F.registerSeriesType("areaspline", y);
        "";
        return y;
    });
    M(a, "Series/Column/ColumnSeries.js", [
        a["Core/Animation/AnimationUtilities.js"],
        a["Core/Color/Color.js"],
        a["Core/Globals.js"],
        a["Core/Legend/LegendSymbol.js"],
        a["Core/Series/Series.js"],
        a["Core/Series/SeriesRegistry.js"],
        a["Core/Utilities.js"]
    ], function(a, u, z, F, y, G, H) {
        var v = this && this.__extends || function() {
            var a = function(c, b) {
                a = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(a, b) {
                    a.__proto__ = b;
                } || function(a, b) {
                    for(var c in b)b.hasOwnProperty(c) && (a[c] = b[c]);
                };
                return a(c, b);
            };
            return function(c, b) {
                function e() {
                    this.constructor = c;
                }
                a(c, b);
                c.prototype = null === b ? Object.create(b) : (e.prototype = b.prototype, new e);
            };
        }(), q = a.animObject, n = u.parse, k = z.hasTouch;
        a = z.noop;
        var e = H.clamp, c = H.css, h = H.defined, f = H.extend, w = H.fireEvent, p = H.isArray, B = H.isNumber, t = H.merge, J = H.pick, C = H.objectEach;
        H = function(a) {
            function l() {
                var b = null !== a && a.apply(this, arguments) || this;
                b.borderWidth = void 0;
                b.data = void 0;
                b.group = void 0;
                b.options = void 0;
                b.points = void 0;
                return b;
            }
            v(l, a);
            l.prototype.animate = function(a) {
                var b = this, c = this.yAxis, h = b.options, l = this.chart.inverted, k = {}, n = l ? "translateX" : "translateY";
                if (a) k.scaleY = .001, a = e(c.toPixels(h.threshold), c.pos, c.pos + c.len), l ? k.translateX = a - c.len : k.translateY = a, b.clipBox && b.setClip(), b.group.attr(k);
                else {
                    var p = Number(b.group.attr(n));
                    b.group.animate({
                        scaleY: 1
                    }, f(q(b.options.animation), {
                        step: function(a, d) {
                            b.group && (k[n] = p + d.pos * (c.pos - p), b.group.attr(k));
                        }
                    }));
                }
            };
            l.prototype.init = function(b, c) {
                a.prototype.init.apply(this, arguments);
                var d = this;
                b = d.chart;
                b.hasRendered && b.series.forEach(function(a) {
                    a.type === d.type && (a.isDirty = !0);
                });
            };
            l.prototype.getColumnMetrics = function() {
                var a = this, c = a.options, d = a.xAxis, e = a.yAxis, f = d.options.reversedStacks;
                f = d.reversed && !f || !d.reversed && f;
                var h = {}, l, k = 0;
                !1 === c.grouping ? k = 1 : a.chart.series.forEach(function(b) {
                    var c = b.yAxis, d = b.options;
                    if (b.type === a.type && (b.visible || !a.chart.options.chart.ignoreHiddenSeries) && e.len === c.len && e.pos === c.pos) {
                        if (d.stacking && "group" !== d.stacking) {
                            l = b.stackKey;
                            "undefined" === typeof h[l] && (h[l] = k++);
                            var g = h[l];
                        } else !1 !== d.grouping && (g = k++);
                        b.columnIndex = g;
                    }
                });
                var n = Math.min(Math.abs(d.transA) * (d.ordinal && d.ordinal.slope || c.pointRange || d.closestPointRange || d.tickInterval || 1), d.len), p = n * c.groupPadding, r = (n - 2 * p) / (k || 1);
                c = Math.min(c.maxPointWidth || d.len, J(c.pointWidth, r * (1 - 2 * c.pointPadding)));
                a.columnMetrics = {
                    width: c,
                    offset: (r - c) / 2 + (p + ((a.columnIndex || 0) + (f ? 1 : 0)) * r - n / 2) * (f ? -1 : 1),
                    paddedWidth: r,
                    columnCount: k
                };
                return a.columnMetrics;
            };
            l.prototype.crispCol = function(a, c, d, e) {
                var b = this.chart, g = this.borderWidth, f = -(g % 2 ? .5 : 0);
                g = g % 2 ? .5 : 1;
                b.inverted && b.renderer.isVML && (g += 1);
                this.options.crisp && (d = Math.round(a + d) + f, a = Math.round(a) + f, d -= a);
                e = Math.round(c + e) + g;
                f = .5 >= Math.abs(c) && .5 < e;
                c = Math.round(c) + g;
                e -= c;
                f && e && (--c, e += 1);
                return {
                    x: a,
                    y: c,
                    width: d,
                    height: e
                };
            };
            l.prototype.adjustForMissingColumns = function(a, c, d, e) {
                var b = this, g = this.options.stacking;
                if (!d.isNull && 1 < e.columnCount) {
                    var f = 0, h = 0;
                    C(this.yAxis.stacking && this.yAxis.stacking.stacks, function(a) {
                        if ("number" === typeof d.x && (a = a[d.x.toString()])) {
                            var c = a.points[b.index], e = a.total;
                            g ? (c && (f = h), a.hasValidPoints && h++) : p(c) && (f = c[1], h = e || 0);
                        }
                    });
                    a = (d.plotX || 0) + ((h - 1) * e.paddedWidth + c) / 2 - c - f * e.paddedWidth;
                }
                return a;
            };
            l.prototype.translate = function() {
                var a = this, c = a.chart, d = a.options, f = a.dense = 2 > a.closestPointRange * a.xAxis.transA;
                f = a.borderWidth = J(d.borderWidth, f ? 0 : 1);
                var l = a.xAxis, k = a.yAxis, n = d.threshold, p = a.translatedThreshold = k.getThreshold(n), r = J(d.minPointLength, 5), q = a.getColumnMetrics(), t = q.width, v = a.pointXOffset = q.offset, u = a.dataMin, w = a.dataMax, C = a.barW = Math.max(t, 1 + 2 * f);
                c.inverted && (p -= .5);
                d.pointPadding && (C = Math.ceil(C));
                y.prototype.translate.apply(a);
                a.points.forEach(function(b) {
                    var g = J(b.yBottom, p), f = 999 + Math.abs(g), m = b.plotX || 0;
                    f = e(b.plotY, -f, k.len + f);
                    var x = Math.min(f, g), D = Math.max(f, g) - x, y = t, A = m + v, z = C;
                    r && Math.abs(D) < r && (D = r, m = !k.reversed && !b.negative || k.reversed && b.negative, B(n) && B(w) && b.y === n && w <= n && (k.min || 0) < n && (u !== w || (k.max || 0) <= n) && (m = !m), x = Math.abs(x - p) > r ? g - r : p - (m ? r : 0));
                    h(b.options.pointWidth) && (y = z = Math.ceil(b.options.pointWidth), A -= Math.round((y - t) / 2));
                    d.centerInCategory && (A = a.adjustForMissingColumns(A, y, b, q));
                    b.barX = A;
                    b.pointWidth = y;
                    b.tooltipPos = c.inverted ? [
                        e(k.len + k.pos - c.plotLeft - f, k.pos - c.plotLeft, k.len + k.pos - c.plotLeft),
                        l.len + l.pos - c.plotTop - A - z / 2,
                        D
                    ] : [
                        l.left - c.plotLeft + A + z / 2,
                        e(f + k.pos - c.plotTop, k.pos - c.plotTop, k.len + k.pos - c.plotTop),
                        D
                    ];
                    b.shapeType = a.pointClass.prototype.shapeType || "rect";
                    b.shapeArgs = a.crispCol.apply(a, b.isNull ? [
                        A,
                        p,
                        z,
                        0
                    ] : [
                        A,
                        x,
                        z,
                        D
                    ]);
                });
            };
            l.prototype.drawGraph = function() {
                this.group[this.dense ? "addClass" : "removeClass"]("highcharts-dense-data");
            };
            l.prototype.pointAttribs = function(a, c) {
                var b = this.options, e = this.pointAttrToOptions || {}, g = e.stroke || "borderColor", f = e["stroke-width"] || "borderWidth", h = a && a.color || this.color, l = a && a[g] || b[g] || h;
                e = a && a.options.dashStyle || b.dashStyle;
                var k = a && a[f] || b[f] || this[f] || 0, p = J(a && a.opacity, b.opacity, 1);
                if (a && this.zones.length) {
                    var r = a.getZone();
                    h = a.options.color || r && (r.color || a.nonZonedColor) || this.color;
                    r && (l = r.borderColor || l, e = r.dashStyle || e, k = r.borderWidth || k);
                }
                c && a && (a = t(b.states[c], a.options.states && a.options.states[c] || {}), c = a.brightness, h = a.color || "undefined" !== typeof c && n(h).brighten(a.brightness).get() || h, l = a[g] || l, k = a[f] || k, e = a.dashStyle || e, p = J(a.opacity, p));
                g = {
                    fill: h,
                    stroke: l,
                    "stroke-width": k,
                    opacity: p
                };
                e && (g.dashstyle = e);
                return g;
            };
            l.prototype.drawPoints = function() {
                var a = this, c = this.chart, d = a.options, e = c.renderer, f = d.animationLimit || 250, h;
                a.points.forEach(function(b) {
                    var g = b.graphic, l = !!g, k = g && c.pointCount < f ? "animate" : "attr";
                    if (B(b.plotY) && null !== b.y) {
                        h = b.shapeArgs;
                        g && b.hasNewShapeType() && (g = g.destroy());
                        a.enabledDataSorting && (b.startXPos = a.xAxis.reversed ? -(h ? h.width || 0 : 0) : a.xAxis.width);
                        g || (b.graphic = g = e[b.shapeType](h).add(b.group || a.group)) && a.enabledDataSorting && c.hasRendered && c.pointCount < f && (g.attr({
                            x: b.startXPos
                        }), l = !0, k = "animate");
                        if (g && l) g[k](t(h));
                        if (d.borderRadius) g[k]({
                            r: d.borderRadius
                        });
                        c.styledMode || g[k](a.pointAttribs(b, b.selected && "select")).shadow(!1 !== b.allowShadow && d.shadow, null, d.stacking && !d.borderRadius);
                        g && (g.addClass(b.getClassName(), !0), g.attr({
                            visibility: b.visible ? "inherit" : "hidden"
                        }));
                    } else g && (b.graphic = g.destroy());
                });
            };
            l.prototype.drawTracker = function() {
                var a = this, e = a.chart, d = e.pointer, f = function(a) {
                    var b = d.getPointFromEvent(a);
                    "undefined" !== typeof b && (d.isDirectTouch = !0, b.onMouseOver(a));
                }, h;
                a.points.forEach(function(a) {
                    h = p(a.dataLabels) ? a.dataLabels : a.dataLabel ? [
                        a.dataLabel
                    ] : [];
                    a.graphic && (a.graphic.element.point = a);
                    h.forEach(function(b) {
                        b.div ? b.div.point = a : b.element.point = a;
                    });
                });
                a._hasTracking || (a.trackerGroups.forEach(function(b) {
                    if (a[b]) {
                        a[b].addClass("highcharts-tracker").on("mouseover", f).on("mouseout", function(a) {
                            d.onTrackerMouseOut(a);
                        });
                        if (k) a[b].on("touchstart", f);
                        !e.styledMode && a.options.cursor && a[b].css(c).css({
                            cursor: a.options.cursor
                        });
                    }
                }), a._hasTracking = !0);
                w(this, "afterDrawTracker");
            };
            l.prototype.remove = function() {
                var a = this, c = a.chart;
                c.hasRendered && c.series.forEach(function(b) {
                    b.type === a.type && (b.isDirty = !0);
                });
                y.prototype.remove.apply(a, arguments);
            };
            l.defaultOptions = t(y.defaultOptions, {
                borderRadius: 0,
                centerInCategory: !1,
                groupPadding: .2,
                marker: null,
                pointPadding: .1,
                minPointLength: 0,
                cropThreshold: 50,
                pointRange: null,
                states: {
                    hover: {
                        halo: !1,
                        brightness: .1
                    },
                    select: {
                        color: "#cccccc",
                        borderColor: "#000000"
                    }
                },
                dataLabels: {
                    align: void 0,
                    verticalAlign: void 0,
                    y: void 0
                },
                startFromThreshold: !0,
                stickyTracking: !1,
                tooltip: {
                    distance: 6
                },
                threshold: 0,
                borderColor: "#ffffff"
            });
            return l;
        }(y);
        f(H.prototype, {
            cropShoulder: 0,
            directTouch: !0,
            drawLegendSymbol: F.drawRectangle,
            getSymbol: a,
            negStacks: !0,
            trackerGroups: [
                "group",
                "dataLabelsGroup"
            ]
        });
        G.registerSeriesType("column", H);
        "";
        "";
        return H;
    });
    M(a, "Core/Series/DataLabel.js", [
        a["Core/Animation/AnimationUtilities.js"],
        a["Core/FormatUtilities.js"],
        a["Core/Utilities.js"]
    ], function(a, u, z) {
        var v = a.getDeferredAnimation, y = u.format, G = z.defined, H = z.extend, A = z.fireEvent, q = z.isArray, n = z.merge, k = z.objectEach, e = z.pick, c = z.splat, h;
        (function(a) {
            function f(a, b, c, d, f) {
                var g = this, h = this.chart, l = this.isCartesian && h.inverted, k = this.enabledDataSorting, m = e(a.dlBox && a.dlBox.centerX, a.plotX, -9999), n = e(a.plotY, -9999), p = b.getBBox(), r = c.rotation, q = c.align, t = h.isInsidePlot(m, Math.round(n), {
                    inverted: l,
                    paneCoordinates: !0,
                    series: g
                }), v = function(c) {
                    k && g.xAxis && !u && g.setDataLabelStartPos(a, b, f, t, c);
                }, u = "justify" === e(c.overflow, k ? "none" : "justify"), w = this.visible && !1 !== a.visible && (a.series.forceDL || k && !u || t || e(c.inside, !!this.options.stacking) && d && h.isInsidePlot(m, l ? d.x + 1 : d.y + d.height - 1, {
                    inverted: l,
                    paneCoordinates: !0,
                    series: g
                }));
                if (w) {
                    var C = h.renderer.fontMetrics(h.styledMode ? void 0 : c.style.fontSize, b).b;
                    d = H({
                        x: l ? this.yAxis.len - n : m,
                        y: Math.round(l ? this.xAxis.len - m : n),
                        width: 0,
                        height: 0
                    }, d);
                    H(c, {
                        width: p.width,
                        height: p.height
                    });
                    r ? (u = !1, m = h.renderer.rotCorr(C, r), m = {
                        x: d.x + (c.x || 0) + d.width / 2 + m.x,
                        y: d.y + (c.y || 0) + ({
                            top: 0,
                            middle: .5,
                            bottom: 1
                        })[c.verticalAlign] * d.height
                    }, v(m), b[f ? "attr" : "animate"](m).attr({
                        align: q
                    }), v = (r + 720) % 360, v = 180 < v && 360 > v, "left" === q ? m.y -= v ? p.height : 0 : "center" === q ? (m.x -= p.width / 2, m.y -= p.height / 2) : "right" === q && (m.x -= p.width, m.y -= v ? 0 : p.height), b.placed = !0, b.alignAttr = m) : (v(d), b.align(c, void 0, d), m = b.alignAttr);
                    u && 0 <= d.height ? this.justifyDataLabel(b, c, m, p, d, f) : e(c.crop, !0) && (w = h.isInsidePlot(m.x, m.y, {
                        paneCoordinates: !0,
                        series: g
                    }) && h.isInsidePlot(m.x + p.width, m.y + p.height, {
                        paneCoordinates: !0,
                        series: g
                    }));
                    if (c.shape && !r) b[f ? "attr" : "animate"]({
                        anchorX: l ? h.plotWidth - a.plotY : a.plotX,
                        anchorY: l ? h.plotHeight - a.plotX : a.plotY
                    });
                }
                f && k && (b.placed = !1);
                w || k && !u || (b.hide(!0), b.placed = !1);
            }
            function h(a, b) {
                var c = b.filter;
                return c ? (b = c.operator, a = a[c.property], c = c.value, ">" === b && a > c || "<" === b && a < c || ">=" === b && a >= c || "<=" === b && a <= c || "==" === b && a == c || "===" === b && a === c ? !0 : !1) : !0;
            }
            function u() {
                var a = this, b = a.chart, g = a.options, d = a.points, f = a.hasRendered || 0, n = b.renderer, p = g.dataLabels, r, t = p.animation;
                t = p.defer ? v(b, t, a) : {
                    defer: 0,
                    duration: 0
                };
                p = z(z(b.options.plotOptions && b.options.plotOptions.series && b.options.plotOptions.series.dataLabels, b.options.plotOptions && b.options.plotOptions[a.type] && b.options.plotOptions[a.type].dataLabels), p);
                A(this, "drawDataLabels");
                if (q(p) || p.enabled || a._hasPointLabels) {
                    var u = a.plotGroup("dataLabelsGroup", "data-labels", f ? "inherit" : "hidden", p.zIndex || 6);
                    u.attr({
                        opacity: +f
                    });
                    !f && (f = a.dataLabelsGroup) && (a.visible && u.show(!0), f[g.animation ? "animate" : "attr"]({
                        opacity: 1
                    }, t));
                    d.forEach(function(d) {
                        r = c(z(p, d.dlOptions || d.options && d.options.dataLabels));
                        r.forEach(function(c, f) {
                            var l = c.enabled && (!d.isNull || d.dataLabelOnNull) && h(d, c), m = d.connectors ? d.connectors[f] : d.connector, p = d.dataLabels ? d.dataLabels[f] : d.dataLabel, r = e(c.distance, d.labelDistance), q = !p;
                            if (l) {
                                var t = d.getLabelConfig();
                                var v = e(c[d.formatPrefix + "Format"], c.format);
                                t = G(v) ? y(v, t, b) : (c[d.formatPrefix + "Formatter"] || c.formatter).call(t, c);
                                v = c.style;
                                var w = c.rotation;
                                b.styledMode || (v.color = e(c.color, v.color, a.color, "#000000"), "contrast" === v.color ? (d.contrastColor = n.getContrast(d.color || a.color), v.color = !G(r) && c.inside || 0 > r || g.stacking ? d.contrastColor : "#000000") : delete d.contrastColor, g.cursor && (v.cursor = g.cursor));
                                var C = {
                                    r: c.borderRadius || 0,
                                    rotation: w,
                                    padding: c.padding,
                                    zIndex: 1
                                };
                                b.styledMode || (C.fill = c.backgroundColor, C.stroke = c.borderColor, C["stroke-width"] = c.borderWidth);
                                k(C, function(a, b) {
                                    "undefined" === typeof a && delete C[b];
                                });
                            }
                            !p || l && G(t) && !!p.div === !!c.useHTML || (d.dataLabel = p = d.dataLabel && d.dataLabel.destroy(), d.dataLabels && (1 === d.dataLabels.length ? delete d.dataLabels : delete d.dataLabels[f]), f || delete d.dataLabel, m && (d.connector = d.connector.destroy(), d.connectors && (1 === d.connectors.length ? delete d.connectors : delete d.connectors[f])));
                            l && G(t) && (p ? C.text = t : (d.dataLabels = d.dataLabels || [], p = d.dataLabels[f] = w ? n.text(t, 0, -9999, c.useHTML).addClass("highcharts-data-label") : n.label(t, 0, -9999, c.shape, null, null, c.useHTML, null, "data-label"), f || (d.dataLabel = p), p.addClass(" highcharts-data-label-color-" + d.colorIndex + " " + (c.className || "") + (c.useHTML ? " highcharts-tracker" : ""))), p.options = c, p.attr(C), b.styledMode || p.css(v).shadow(c.shadow), p.added || p.add(u), c.textPath && !c.useHTML && (p.setTextPath(d.getDataLabelPath && d.getDataLabelPath(p) || d.graphic, c.textPath), d.dataLabelPath && !c.textPath.enabled && (d.dataLabelPath = d.dataLabelPath.destroy())), a.alignDataLabel(d, p, c, null, q));
                        });
                    });
                }
                A(this, "afterDrawDataLabels");
            }
            function t(a, b, c, d, e, f) {
                var g = this.chart, h = b.align, k = b.verticalAlign, l = a.box ? 0 : a.padding || 0, m = b.x;
                m = void 0 === m ? 0 : m;
                var n = b.y;
                n = void 0 === n ? 0 : n;
                var p = (c.x || 0) + l;
                if (0 > p) {
                    "right" === h && 0 <= m ? (b.align = "left", b.inside = !0) : m -= p;
                    var r = !0;
                }
                p = (c.x || 0) + d.width - l;
                p > g.plotWidth && ("left" === h && 0 >= m ? (b.align = "right", b.inside = !0) : m += g.plotWidth - p, r = !0);
                p = c.y + l;
                0 > p && ("bottom" === k && 0 <= n ? (b.verticalAlign = "top", b.inside = !0) : n -= p, r = !0);
                p = (c.y || 0) + d.height - l;
                p > g.plotHeight && ("top" === k && 0 >= n ? (b.verticalAlign = "bottom", b.inside = !0) : n += g.plotHeight - p, r = !0);
                r && (b.x = m, b.y = n, a.placed = !f, a.align(b, void 0, e));
                return r;
            }
            function z(a, b) {
                var c = [], d;
                if (q(a) && !q(b)) c = a.map(function(a) {
                    return n(a, b);
                });
                else if (q(b) && !q(a)) c = b.map(function(b) {
                    return n(a, b);
                });
                else if (q(a) || q(b)) for(d = Math.max(a.length, b.length); d--;)c[d] = n(a[d], b[d]);
                else c = n(a, b);
                return c;
            }
            function C(a, b, c, d, e) {
                var g = this.chart, f = g.inverted, h = this.xAxis, k = h.reversed, l = f ? b.height / 2 : b.width / 2;
                a = (a = a.pointWidth) ? a / 2 : 0;
                b.startXPos = f ? e.x : k ? -l - a : h.width - l + a;
                b.startYPos = f ? k ? this.yAxis.height - l + a : -l - a : e.y;
                d ? "hidden" === b.visibility && (b.show(), b.attr({
                    opacity: 0
                }).animate({
                    opacity: 1
                })) : b.attr({
                    opacity: 1
                }).animate({
                    opacity: 0
                }, void 0, b.hide);
                g.hasRendered && (c && b.attr({
                    x: b.startXPos,
                    y: b.startYPos
                }), b.placed = !0);
            }
            var r = [];
            a.compose = function(a) {
                if (-1 === r.indexOf(a)) {
                    var b = a.prototype;
                    r.push(a);
                    b.alignDataLabel = f;
                    b.drawDataLabels = u;
                    b.justifyDataLabel = t;
                    b.setDataLabelStartPos = C;
                }
            };
        })(h || (h = {}));
        "";
        return h;
    });
    M(a, "Series/Column/ColumnDataLabel.js", [
        a["Core/Series/DataLabel.js"],
        a["Core/Series/SeriesRegistry.js"],
        a["Core/Utilities.js"]
    ], function(a, u, z) {
        var v = u.series, y = z.merge, G = z.pick, H;
        (function(u) {
            function q(a, e, c, h, f) {
                var k = this.chart.inverted, n = a.series, q = (n.xAxis ? n.xAxis.len : this.chart.plotSizeX) || 0;
                n = (n.yAxis ? n.yAxis.len : this.chart.plotSizeY) || 0;
                var t = a.dlBox || a.shapeArgs, u = G(a.below, a.plotY > G(this.translatedThreshold, n)), C = G(c.inside, !!this.options.stacking);
                t && (h = y(t), 0 > h.y && (h.height += h.y, h.y = 0), t = h.y + h.height - n, 0 < t && t < h.height && (h.height -= t), k && (h = {
                    x: n - h.y - h.height,
                    y: q - h.x - h.width,
                    width: h.height,
                    height: h.width
                }), C || (k ? (h.x += u ? 0 : h.width, h.width = 0) : (h.y += u ? h.height : 0, h.height = 0)));
                c.align = G(c.align, !k || C ? "center" : u ? "right" : "left");
                c.verticalAlign = G(c.verticalAlign, k || C ? "middle" : u ? "top" : "bottom");
                v.prototype.alignDataLabel.call(this, a, e, c, h, f);
                c.inside && a.contrastColor && e.css({
                    color: a.contrastColor
                });
            }
            var n = [];
            u.compose = function(k) {
                a.compose(v);
                -1 === n.indexOf(k) && (n.push(k), k.prototype.alignDataLabel = q);
            };
        })(H || (H = {}));
        return H;
    });
    M(a, "Series/Bar/BarSeries.js", [
        a["Series/Column/ColumnSeries.js"],
        a["Core/Series/SeriesRegistry.js"],
        a["Core/Utilities.js"]
    ], function(a, u, z) {
        var v = this && this.__extends || function() {
            var a = function(v, q) {
                a = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(a, k) {
                    a.__proto__ = k;
                } || function(a, k) {
                    for(var e in k)k.hasOwnProperty(e) && (a[e] = k[e]);
                };
                return a(v, q);
            };
            return function(v, q) {
                function n() {
                    this.constructor = v;
                }
                a(v, q);
                v.prototype = null === q ? Object.create(q) : (n.prototype = q.prototype, new n);
            };
        }(), y = z.extend, G = z.merge;
        z = function(u) {
            function y() {
                var a = null !== u && u.apply(this, arguments) || this;
                a.data = void 0;
                a.options = void 0;
                a.points = void 0;
                return a;
            }
            v(y, u);
            y.defaultOptions = G(a.defaultOptions, {});
            return y;
        }(a);
        y(z.prototype, {
            inverted: !0
        });
        u.registerSeriesType("bar", z);
        "";
        return z;
    });
    M(a, "Series/Scatter/ScatterSeries.js", [
        a["Series/Column/ColumnSeries.js"],
        a["Series/Line/LineSeries.js"],
        a["Core/Series/SeriesRegistry.js"],
        a["Core/Utilities.js"]
    ], function(a, u, z, F) {
        var v = this && this.__extends || function() {
            var a = function(n, k) {
                a = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(a, c) {
                    a.__proto__ = c;
                } || function(a, c) {
                    for(var e in c)c.hasOwnProperty(e) && (a[e] = c[e]);
                };
                return a(n, k);
            };
            return function(n, k) {
                function e() {
                    this.constructor = n;
                }
                a(n, k);
                n.prototype = null === k ? Object.create(k) : (e.prototype = k.prototype, new e);
            };
        }(), G = F.addEvent, H = F.extend, A = F.merge;
        F = function(a) {
            function n() {
                var k = null !== a && a.apply(this, arguments) || this;
                k.data = void 0;
                k.options = void 0;
                k.points = void 0;
                return k;
            }
            v(n, a);
            n.prototype.applyJitter = function() {
                var a = this, e = this.options.jitter, c = this.points.length;
                e && this.points.forEach(function(h, f) {
                    [
                        "x",
                        "y"
                    ].forEach(function(k, n) {
                        var p = "plot" + k.toUpperCase();
                        if (e[k] && !h.isNull) {
                            var q = a[k + "Axis"];
                            var v = e[k] * q.transA;
                            if (q && !q.isLog) {
                                var u = Math.max(0, h[p] - v);
                                q = Math.min(q.len, h[p] + v);
                                n = 1E4 * Math.sin(f + n * c);
                                h[p] = u + (q - u) * (n - Math.floor(n));
                                "x" === k && (h.clientX = h.plotX);
                            }
                        }
                    });
                });
            };
            n.prototype.drawGraph = function() {
                this.options.lineWidth ? a.prototype.drawGraph.call(this) : this.graph && (this.graph = this.graph.destroy());
            };
            n.defaultOptions = A(u.defaultOptions, {
                lineWidth: 0,
                findNearestPointBy: "xy",
                jitter: {
                    x: 0,
                    y: 0
                },
                marker: {
                    enabled: !0
                },
                tooltip: {
                    headerFormat: '<span style="color:{point.color}">\u25cf</span> <span style="font-size: 10px"> {series.name}</span><br/>',
                    pointFormat: "x: <b>{point.x}</b><br/>y: <b>{point.y}</b><br/>"
                }
            });
            return n;
        }(u);
        H(F.prototype, {
            drawTracker: a.prototype.drawTracker,
            sorted: !1,
            requireSorting: !1,
            noSharedTooltip: !0,
            trackerGroups: [
                "group",
                "markerGroup",
                "dataLabelsGroup"
            ],
            takeOrdinalPosition: !1
        });
        G(F, "afterTranslate", function() {
            this.applyJitter();
        });
        z.registerSeriesType("scatter", F);
        "";
        return F;
    });
    M(a, "Series/CenteredUtilities.js", [
        a["Core/Globals.js"],
        a["Core/Series/Series.js"],
        a["Core/Utilities.js"]
    ], function(a, u, z) {
        var v = a.deg2rad, y = z.isNumber, G = z.pick, H = z.relativeLength, A;
        (function(a) {
            a.getCenter = function() {
                var a = this.options, k = this.chart, e = 2 * (a.slicedOffset || 0), c = k.plotWidth - 2 * e, h = k.plotHeight - 2 * e, f = a.center, q = Math.min(c, h), p = a.size, v = a.innerSize || 0;
                "string" === typeof p && (p = parseFloat(p));
                "string" === typeof v && (v = parseFloat(v));
                a = [
                    G(f[0], "50%"),
                    G(f[1], "50%"),
                    G(p && 0 > p ? void 0 : a.size, "100%"),
                    G(v && 0 > v ? void 0 : a.innerSize || 0, "0%")
                ];
                !k.angular || this instanceof u || (a[3] = 0);
                for(f = 0; 4 > f; ++f)p = a[f], k = 2 > f || 2 === f && /%$/.test(p), a[f] = H(p, [
                    c,
                    h,
                    q,
                    a[2]
                ][f]) + (k ? e : 0);
                a[3] > a[2] && (a[3] = a[2]);
                return a;
            };
            a.getStartAndEndRadians = function(a, k) {
                a = y(a) ? a : 0;
                k = y(k) && k > a && 360 > k - a ? k : a + 360;
                return {
                    start: v * (a + -90),
                    end: v * (k + -90)
                };
            };
        })(A || (A = {}));
        "";
        return A;
    });
    M(a, "Series/Pie/PiePoint.js", [
        a["Core/Animation/AnimationUtilities.js"],
        a["Core/Series/Point.js"],
        a["Core/Utilities.js"]
    ], function(a, u, z) {
        var v = this && this.__extends || function() {
            var a = function(e, c) {
                a = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(a, c) {
                    a.__proto__ = c;
                } || function(a, c) {
                    for(var e in c)c.hasOwnProperty(e) && (a[e] = c[e]);
                };
                return a(e, c);
            };
            return function(e, c) {
                function h() {
                    this.constructor = e;
                }
                a(e, c);
                e.prototype = null === c ? Object.create(c) : (h.prototype = c.prototype, new h);
            };
        }(), y = a.setAnimation, G = z.addEvent, H = z.defined;
        a = z.extend;
        var A = z.isNumber, q = z.pick, n = z.relativeLength;
        u = function(a) {
            function e() {
                var c = null !== a && a.apply(this, arguments) || this;
                c.labelDistance = void 0;
                c.options = void 0;
                c.series = void 0;
                return c;
            }
            v(e, a);
            e.prototype.getConnectorPath = function() {
                var a = this.labelPosition, e = this.series.options.dataLabels, f = this.connectorShapes, k = e.connectorShape;
                f[k] && (k = f[k]);
                return k.call(this, {
                    x: a.final.x,
                    y: a.final.y,
                    alignment: a.alignment
                }, a.connectorPosition, e);
            };
            e.prototype.getTranslate = function() {
                return this.sliced ? this.slicedTranslation : {
                    translateX: 0,
                    translateY: 0
                };
            };
            e.prototype.haloPath = function(a) {
                var c = this.shapeArgs;
                return this.sliced || !this.visible ? [] : this.series.chart.renderer.symbols.arc(c.x, c.y, c.r + a, c.r + a, {
                    innerR: c.r - 1,
                    start: c.start,
                    end: c.end
                });
            };
            e.prototype.init = function() {
                var c = this;
                a.prototype.init.apply(this, arguments);
                this.name = q(this.name, "Slice");
                var e = function(a) {
                    c.slice("select" === a.type);
                };
                G(this, "select", e);
                G(this, "unselect", e);
                return this;
            };
            e.prototype.isValid = function() {
                return A(this.y) && 0 <= this.y;
            };
            e.prototype.setVisible = function(a, e) {
                var c = this, h = this.series, k = h.chart, n = h.options.ignoreHiddenPoint;
                e = q(e, n);
                a !== this.visible && (this.visible = this.options.visible = a = "undefined" === typeof a ? !this.visible : a, h.options.data[h.data.indexOf(this)] = this.options, [
                    "graphic",
                    "dataLabel",
                    "connector",
                    "shadowGroup"
                ].forEach(function(e) {
                    if (c[e]) c[e][a ? "show" : "hide"](a);
                }), this.legendItem && k.legend.colorizeItem(this, a), a || "hover" !== this.state || this.setState(""), n && (h.isDirty = !0), e && k.redraw());
            };
            e.prototype.slice = function(a, e, f) {
                var c = this.series;
                y(f, c.chart);
                q(e, !0);
                this.sliced = this.options.sliced = H(a) ? a : !this.sliced;
                c.options.data[c.data.indexOf(this)] = this.options;
                this.graphic && this.graphic.animate(this.getTranslate());
                this.shadowGroup && this.shadowGroup.animate(this.getTranslate());
            };
            return e;
        }(u);
        a(u.prototype, {
            connectorShapes: {
                fixedOffset: function(a, e, c) {
                    var h = e.breakAt;
                    e = e.touchingSliceAt;
                    return [
                        [
                            "M",
                            a.x,
                            a.y
                        ],
                        c.softConnector ? [
                            "C",
                            a.x + ("left" === a.alignment ? -5 : 5),
                            a.y,
                            2 * h.x - e.x,
                            2 * h.y - e.y,
                            h.x,
                            h.y
                        ] : [
                            "L",
                            h.x,
                            h.y
                        ],
                        [
                            "L",
                            e.x,
                            e.y
                        ]
                    ];
                },
                straight: function(a, e) {
                    e = e.touchingSliceAt;
                    return [
                        [
                            "M",
                            a.x,
                            a.y
                        ],
                        [
                            "L",
                            e.x,
                            e.y
                        ]
                    ];
                },
                crookedLine: function(a, e, c) {
                    e = e.touchingSliceAt;
                    var h = this.series, f = h.center[0], k = h.chart.plotWidth, p = h.chart.plotLeft;
                    h = a.alignment;
                    var q = this.shapeArgs.r;
                    c = n(c.crookDistance, 1);
                    k = "left" === h ? f + q + (k + p - f - q) * (1 - c) : p + (f - q) * c;
                    c = [
                        "L",
                        k,
                        a.y
                    ];
                    f = !0;
                    if ("left" === h ? k > a.x || k < e.x : k < a.x || k > e.x) f = !1;
                    a = [
                        [
                            "M",
                            a.x,
                            a.y
                        ]
                    ];
                    f && a.push(c);
                    a.push([
                        "L",
                        e.x,
                        e.y
                    ]);
                    return a;
                }
            }
        });
        return u;
    });
    M(a, "Series/Pie/PieSeries.js", [
        a["Series/CenteredUtilities.js"],
        a["Series/Column/ColumnSeries.js"],
        a["Core/Globals.js"],
        a["Core/Legend/LegendSymbol.js"],
        a["Series/Pie/PiePoint.js"],
        a["Core/Series/Series.js"],
        a["Core/Series/SeriesRegistry.js"],
        a["Core/Renderer/SVG/Symbols.js"],
        a["Core/Utilities.js"]
    ], function(a, u, z, F, y, G, H, A, q) {
        var n = this && this.__extends || function() {
            var a = function(c, e) {
                a = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(a, c) {
                    a.__proto__ = c;
                } || function(a, c) {
                    for(var e in c)c.hasOwnProperty(e) && (a[e] = c[e]);
                };
                return a(c, e);
            };
            return function(c, e) {
                function f() {
                    this.constructor = c;
                }
                a(c, e);
                c.prototype = null === e ? Object.create(e) : (f.prototype = e.prototype, new f);
            };
        }(), k = a.getStartAndEndRadians;
        z = z.noop;
        var e = q.clamp, c = q.extend, h = q.fireEvent, f = q.merge, v = q.pick, p = q.relativeLength;
        q = function(a) {
            function c() {
                var c = null !== a && a.apply(this, arguments) || this;
                c.center = void 0;
                c.data = void 0;
                c.maxLabelDistance = void 0;
                c.options = void 0;
                c.points = void 0;
                return c;
            }
            n(c, a);
            c.prototype.animate = function(a) {
                var c = this, e = c.points, f = c.startAngleRad;
                a || e.forEach(function(a) {
                    var b = a.graphic, d = a.shapeArgs;
                    b && d && (b.attr({
                        r: v(a.startR, c.center && c.center[3] / 2),
                        start: f,
                        end: f
                    }), b.animate({
                        r: d.r,
                        start: d.start,
                        end: d.end
                    }, c.options.animation));
                });
            };
            c.prototype.drawEmpty = function() {
                var a = this.startAngleRad, c = this.endAngleRad, e = this.options;
                if (0 === this.total && this.center) {
                    var f = this.center[0];
                    var b = this.center[1];
                    this.graph || (this.graph = this.chart.renderer.arc(f, b, this.center[1] / 2, 0, a, c).addClass("highcharts-empty-series").add(this.group));
                    this.graph.attr({
                        d: A.arc(f, b, this.center[2] / 2, 0, {
                            start: a,
                            end: c,
                            innerR: this.center[3] / 2
                        })
                    });
                    this.chart.styledMode || this.graph.attr({
                        "stroke-width": e.borderWidth,
                        fill: e.fillColor || "none",
                        stroke: e.color || "#cccccc"
                    });
                } else this.graph && (this.graph = this.graph.destroy());
            };
            c.prototype.drawPoints = function() {
                var a = this.chart.renderer;
                this.points.forEach(function(c) {
                    c.graphic && c.hasNewShapeType() && (c.graphic = c.graphic.destroy());
                    c.graphic || (c.graphic = a[c.shapeType](c.shapeArgs).add(c.series.group), c.delayedRendering = !0);
                });
            };
            c.prototype.generatePoints = function() {
                a.prototype.generatePoints.call(this);
                this.updateTotals();
            };
            c.prototype.getX = function(a, c, f) {
                var h = this.center, b = this.radii ? this.radii[f.index] || 0 : h[2] / 2;
                a = Math.asin(e((a - h[1]) / (b + f.labelDistance), -1, 1));
                return h[0] + (c ? -1 : 1) * Math.cos(a) * (b + f.labelDistance) + (0 < f.labelDistance ? (c ? -1 : 1) * this.options.dataLabels.padding : 0);
            };
            c.prototype.hasData = function() {
                return !!this.processedXData.length;
            };
            c.prototype.redrawPoints = function() {
                var a = this, c = a.chart, e = c.renderer, h = a.options.shadow, b, g, d, k;
                this.drawEmpty();
                !h || a.shadowGroup || c.styledMode || (a.shadowGroup = e.g("shadow").attr({
                    zIndex: -1
                }).add(a.group));
                a.points.forEach(function(l) {
                    var m = {};
                    g = l.graphic;
                    if (!l.isNull && g) {
                        var n = void 0;
                        k = l.shapeArgs;
                        b = l.getTranslate();
                        c.styledMode || (n = l.shadowGroup, h && !n && (n = l.shadowGroup = e.g("shadow").add(a.shadowGroup)), n && n.attr(b), d = a.pointAttribs(l, l.selected && "select"));
                        l.delayedRendering ? (g.setRadialReference(a.center).attr(k).attr(b), c.styledMode || g.attr(d).attr({
                            "stroke-linejoin": "round"
                        }).shadow(h, n), l.delayedRendering = !1) : (g.setRadialReference(a.center), c.styledMode || f(!0, m, d), f(!0, m, k, b), g.animate(m));
                        g.attr({
                            visibility: l.visible ? "inherit" : "hidden"
                        });
                        g.addClass(l.getClassName(), !0);
                    } else g && (l.graphic = g.destroy());
                });
            };
            c.prototype.sortByAngle = function(a, c) {
                a.sort(function(a, e) {
                    return "undefined" !== typeof a.angle && (e.angle - a.angle) * c;
                });
            };
            c.prototype.translate = function(a) {
                this.generatePoints();
                var c = this.options, e = c.slicedOffset, f = e + (c.borderWidth || 0), b = k(c.startAngle, c.endAngle), g = this.startAngleRad = b.start;
                b = (this.endAngleRad = b.end) - g;
                var d = this.points, m = c.dataLabels.distance;
                c = c.ignoreHiddenPoint;
                var n = d.length, q, t = 0;
                a || (this.center = a = this.getCenter());
                for(q = 0; q < n; q++){
                    var u = d[q];
                    var w = g + t * b;
                    !u.isValid() || c && !u.visible || (t += u.percentage / 100);
                    var y = g + t * b;
                    var B = {
                        x: a[0],
                        y: a[1],
                        r: a[2] / 2,
                        innerR: a[3] / 2,
                        start: Math.round(1E3 * w) / 1E3,
                        end: Math.round(1E3 * y) / 1E3
                    };
                    u.shapeType = "arc";
                    u.shapeArgs = B;
                    u.labelDistance = v(u.options.dataLabels && u.options.dataLabels.distance, m);
                    u.labelDistance = p(u.labelDistance, B.r);
                    this.maxLabelDistance = Math.max(this.maxLabelDistance || 0, u.labelDistance);
                    y = (y + w) / 2;
                    y > 1.5 * Math.PI ? y -= 2 * Math.PI : y < -Math.PI / 2 && (y += 2 * Math.PI);
                    u.slicedTranslation = {
                        translateX: Math.round(Math.cos(y) * e),
                        translateY: Math.round(Math.sin(y) * e)
                    };
                    B = Math.cos(y) * a[2] / 2;
                    var A = Math.sin(y) * a[2] / 2;
                    u.tooltipPos = [
                        a[0] + .7 * B,
                        a[1] + .7 * A
                    ];
                    u.half = y < -Math.PI / 2 || y > Math.PI / 2 ? 1 : 0;
                    u.angle = y;
                    w = Math.min(f, u.labelDistance / 5);
                    u.labelPosition = {
                        natural: {
                            x: a[0] + B + Math.cos(y) * u.labelDistance,
                            y: a[1] + A + Math.sin(y) * u.labelDistance
                        },
                        "final": {},
                        alignment: 0 > u.labelDistance ? "center" : u.half ? "right" : "left",
                        connectorPosition: {
                            breakAt: {
                                x: a[0] + B + Math.cos(y) * w,
                                y: a[1] + A + Math.sin(y) * w
                            },
                            touchingSliceAt: {
                                x: a[0] + B,
                                y: a[1] + A
                            }
                        }
                    };
                }
                h(this, "afterTranslate");
            };
            c.prototype.updateTotals = function() {
                var a = this.points, c = a.length, e = this.options.ignoreHiddenPoint, f, b = 0;
                for(f = 0; f < c; f++){
                    var g = a[f];
                    !g.isValid() || e && !g.visible || (b += g.y);
                }
                this.total = b;
                for(f = 0; f < c; f++)g = a[f], g.percentage = 0 < b && (g.visible || !e) ? g.y / b * 100 : 0, g.total = b;
            };
            c.defaultOptions = f(G.defaultOptions, {
                center: [
                    null,
                    null
                ],
                clip: !1,
                colorByPoint: !0,
                dataLabels: {
                    allowOverlap: !0,
                    connectorPadding: 5,
                    connectorShape: "fixedOffset",
                    crookDistance: "70%",
                    distance: 30,
                    enabled: !0,
                    formatter: function() {
                        return this.point.isNull ? void 0 : this.point.name;
                    },
                    softConnector: !0,
                    x: 0
                },
                fillColor: void 0,
                ignoreHiddenPoint: !0,
                inactiveOtherPoints: !0,
                legendType: "point",
                marker: null,
                size: null,
                showInLegend: !1,
                slicedOffset: 10,
                stickyTracking: !1,
                tooltip: {
                    followPointer: !0
                },
                borderColor: "#ffffff",
                borderWidth: 1,
                lineWidth: void 0,
                states: {
                    hover: {
                        brightness: .1
                    }
                }
            });
            return c;
        }(G);
        c(q.prototype, {
            axisTypes: [],
            directTouch: !0,
            drawGraph: void 0,
            drawLegendSymbol: F.drawRectangle,
            drawTracker: u.prototype.drawTracker,
            getCenter: a.getCenter,
            getSymbol: z,
            isCartesian: !1,
            noSharedTooltip: !0,
            pointAttribs: u.prototype.pointAttribs,
            pointClass: y,
            requireSorting: !1,
            searchPoint: z,
            trackerGroups: [
                "group",
                "dataLabelsGroup"
            ]
        });
        H.registerSeriesType("pie", q);
        "";
        return q;
    });
    M(a, "Series/Pie/PieDataLabel.js", [
        a["Core/Series/DataLabel.js"],
        a["Core/Globals.js"],
        a["Core/Renderer/RendererUtilities.js"],
        a["Core/Series/SeriesRegistry.js"],
        a["Core/Utilities.js"]
    ], function(a, u, z, F, y) {
        var v = u.noop, H = z.distribute, A = F.series, q = y.arrayMax, n = y.clamp, k = y.defined, e = y.merge, c = y.pick, h = y.relativeLength, f;
        (function(f) {
            function p() {
                var a = this, f = a.data, b = a.chart, g = a.options.dataLabels || {}, d = g.connectorPadding, h = b.plotWidth, n = b.plotHeight, p = b.plotLeft, v = Math.round(b.chartWidth / 3), t = a.center, u = t[2] / 2, w = t[1], C = [
                    [],
                    []
                ], y = [
                    0,
                    0,
                    0,
                    0
                ], B = a.dataLabelPositioners, z, F, G, J, M, E, T, N, V, W, X, R;
                a.visible && (g.enabled || a._hasPointLabels) && (f.forEach(function(a) {
                    a.dataLabel && a.visible && a.dataLabel.shortened && (a.dataLabel.attr({
                        width: "auto"
                    }).css({
                        width: "auto",
                        textOverflow: "clip"
                    }), a.dataLabel.shortened = !1);
                }), A.prototype.drawDataLabels.apply(a), f.forEach(function(a) {
                    a.dataLabel && (a.visible ? (C[a.half].push(a), a.dataLabel._pos = null, !k(g.style.width) && !k(a.options.dataLabels && a.options.dataLabels.style && a.options.dataLabels.style.width) && a.dataLabel.getBBox().width > v && (a.dataLabel.css({
                        width: Math.round(.7 * v) + "px"
                    }), a.dataLabel.shortened = !0)) : (a.dataLabel = a.dataLabel.destroy(), a.dataLabels && 1 === a.dataLabels.length && delete a.dataLabels));
                }), C.forEach(function(e, f) {
                    var l = e.length, m = [], r;
                    if (l) {
                        a.sortByAngle(e, f - .5);
                        if (0 < a.maxLabelDistance) {
                            var q = Math.max(0, w - u - a.maxLabelDistance);
                            var v = Math.min(w + u + a.maxLabelDistance, b.plotHeight);
                            e.forEach(function(a) {
                                0 < a.labelDistance && a.dataLabel && (a.top = Math.max(0, w - u - a.labelDistance), a.bottom = Math.min(w + u + a.labelDistance, b.plotHeight), r = a.dataLabel.getBBox().height || 21, a.distributeBox = {
                                    target: a.labelPosition.natural.y - a.top + r / 2,
                                    size: r,
                                    rank: a.y
                                }, m.push(a.distributeBox));
                            });
                            q = v + r - q;
                            H(m, q, q / 5);
                        }
                        for(X = 0; X < l; X++){
                            z = e[X];
                            E = z.labelPosition;
                            J = z.dataLabel;
                            W = !1 === z.visible ? "hidden" : "inherit";
                            V = q = E.natural.y;
                            m && k(z.distributeBox) && ("undefined" === typeof z.distributeBox.pos ? W = "hidden" : (T = z.distributeBox.size, V = B.radialDistributionY(z)));
                            delete z.positionIndex;
                            if (g.justify) N = B.justify(z, u, t);
                            else switch(g.alignTo){
                                case "connectors":
                                    N = B.alignToConnectors(e, f, h, p);
                                    break;
                                case "plotEdges":
                                    N = B.alignToPlotEdges(J, f, h, p);
                                    break;
                                default:
                                    N = B.radialDistributionX(a, z, V, q);
                            }
                            J._attr = {
                                visibility: W,
                                align: E.alignment
                            };
                            R = z.options.dataLabels || {};
                            J._pos = {
                                x: N + c(R.x, g.x) + (({
                                    left: d,
                                    right: -d
                                })[E.alignment] || 0),
                                y: V + c(R.y, g.y) - 10
                            };
                            E.final.x = N;
                            E.final.y = V;
                            c(g.crop, !0) && (M = J.getBBox().width, q = null, N - M < d && 1 === f ? (q = Math.round(M - N + d), y[3] = Math.max(q, y[3])) : N + M > h - d && 0 === f && (q = Math.round(N + M - h + d), y[1] = Math.max(q, y[1])), 0 > V - T / 2 ? y[0] = Math.max(Math.round(-V + T / 2), y[0]) : V + T / 2 > n && (y[2] = Math.max(Math.round(V + T / 2 - n), y[2])), J.sideOverflow = q);
                        }
                    }
                }), 0 === q(y) || this.verifyDataLabelOverflow(y)) && (this.placeDataLabels(), this.points.forEach(function(d) {
                    R = e(g, d.options.dataLabels);
                    if (F = c(R.connectorWidth, 1)) {
                        var f;
                        G = d.connector;
                        if ((J = d.dataLabel) && J._pos && d.visible && 0 < d.labelDistance) {
                            W = J._attr.visibility;
                            if (f = !G) d.connector = G = b.renderer.path().addClass("highcharts-data-label-connector  highcharts-color-" + d.colorIndex + (d.className ? " " + d.className : "")).add(a.dataLabelsGroup), b.styledMode || G.attr({
                                "stroke-width": F,
                                stroke: R.connectorColor || d.color || "#666666"
                            });
                            G[f ? "attr" : "animate"]({
                                d: d.getConnectorPath()
                            });
                            G.attr("visibility", W);
                        } else G && (d.connector = G.destroy());
                    }
                }));
            }
            function u() {
                this.points.forEach(function(a) {
                    var c = a.dataLabel, b;
                    c && a.visible && ((b = c._pos) ? (c.sideOverflow && (c._attr.width = Math.max(c.getBBox().width - c.sideOverflow, 0), c.css({
                        width: c._attr.width + "px",
                        textOverflow: (this.options.dataLabels.style || {}).textOverflow || "ellipsis"
                    }), c.shortened = !0), c.attr(c._attr), c[c.moved ? "animate" : "attr"](b), c.moved = !0) : c && c.attr({
                        y: -9999
                    }));
                    delete a.distributeBox;
                }, this);
            }
            function t(a) {
                var c = this.center, b = this.options, e = b.center, d = b.minSize || 80, f = null !== b.size;
                if (!f) {
                    if (null !== e[0]) var k = Math.max(c[2] - Math.max(a[1], a[3]), d);
                    else k = Math.max(c[2] - a[1] - a[3], d), c[0] += (a[3] - a[1]) / 2;
                    null !== e[1] ? k = n(k, d, c[2] - Math.max(a[0], a[2])) : (k = n(k, d, c[2] - a[0] - a[2]), c[1] += (a[0] - a[2]) / 2);
                    k < c[2] ? (c[2] = k, c[3] = Math.min(h(b.innerSize || 0, k), k), this.translate(c), this.drawDataLabels && this.drawDataLabels()) : f = !0;
                }
                return f;
            }
            var w = [], C = {
                radialDistributionY: function(a) {
                    return a.top + a.distributeBox.pos;
                },
                radialDistributionX: function(a, c, b, e) {
                    return a.getX(b < c.top + 2 || b > c.bottom - 2 ? e : b, c.half, c);
                },
                justify: function(a, c, b) {
                    return b[0] + (a.half ? -1 : 1) * (c + a.labelDistance);
                },
                alignToPlotEdges: function(a, c, b, e) {
                    a = a.getBBox().width;
                    return c ? a + e : b - a - e;
                },
                alignToConnectors: function(a, c, b, e) {
                    var d = 0, g;
                    a.forEach(function(a) {
                        g = a.dataLabel.getBBox().width;
                        g > d && (d = g);
                    });
                    return c ? d + e : b - d - e;
                }
            };
            f.compose = function(c) {
                a.compose(A);
                -1 === w.indexOf(c) && (w.push(c), c = c.prototype, c.dataLabelPositioners = C, c.alignDataLabel = v, c.drawDataLabels = p, c.placeDataLabels = u, c.verifyDataLabelOverflow = t);
            };
        })(f || (f = {}));
        return f;
    });
    M(a, "Extensions/OverlappingDataLabels.js", [
        a["Core/Chart/Chart.js"],
        a["Core/Utilities.js"]
    ], function(a, u) {
        function v(a, k) {
            var e = !1;
            if (a) {
                var c = a.newOpacity;
                a.oldOpacity !== c && (a.alignAttr && a.placed ? (a[c ? "removeClass" : "addClass"]("highcharts-data-label-hidden"), e = !0, a.alignAttr.opacity = c, a[a.isOld ? "animate" : "attr"](a.alignAttr, null, function() {
                    k.styledMode || a.css({
                        pointerEvents: c ? "auto" : "none"
                    });
                }), y(k, "afterHideOverlappingLabel")) : a.attr({
                    opacity: c
                }));
                a.isOld = !0;
            }
            return e;
        }
        var F = u.addEvent, y = u.fireEvent, G = u.isArray, H = u.isNumber, A = u.objectEach, q = u.pick;
        F(a, "render", function() {
            var a = this, k = [];
            (this.labelCollectors || []).forEach(function(a) {
                k = k.concat(a());
            });
            (this.yAxis || []).forEach(function(a) {
                a.stacking && a.options.stackLabels && !a.options.stackLabels.allowOverlap && A(a.stacking.stacks, function(a) {
                    A(a, function(a) {
                        a.label && "hidden" !== a.label.visibility && k.push(a.label);
                    });
                });
            });
            (this.series || []).forEach(function(e) {
                var c = e.options.dataLabels;
                e.visible && (!1 !== c.enabled || e._hasPointLabels) && (c = function(c) {
                    return c.forEach(function(c) {
                        c.visible && (G(c.dataLabels) ? c.dataLabels : c.dataLabel ? [
                            c.dataLabel
                        ] : []).forEach(function(e) {
                            var f = e.options;
                            e.labelrank = q(f.labelrank, c.labelrank, c.shapeArgs && c.shapeArgs.height);
                            f.allowOverlap ? (e.oldOpacity = e.opacity, e.newOpacity = 1, v(e, a)) : k.push(e);
                        });
                    });
                }, c(e.nodes || []), c(e.points));
            });
            this.hideOverlappingLabels(k);
        });
        a.prototype.hideOverlappingLabels = function(a) {
            var k = this, e = a.length, c = k.renderer, h, f, n, p = !1;
            var q = function(a) {
                var e, f = a.box ? 0 : a.padding || 0, b = e = 0, g;
                if (a && (!a.alignAttr || a.placed)) {
                    var d = a.alignAttr || {
                        x: a.attr("x"),
                        y: a.attr("y")
                    };
                    var h = a.parentGroup;
                    a.width || (e = a.getBBox(), a.width = e.width, a.height = e.height, e = c.fontMetrics(null, a.element).h);
                    var k = a.width - 2 * f;
                    (g = ({
                        left: "0",
                        center: "0.5",
                        right: "1"
                    })[a.alignValue]) ? b = +g * k : H(a.x) && Math.round(a.x) !== a.translateX && (b = a.x - a.translateX);
                    return {
                        x: d.x + (h.translateX || 0) + f - (b || 0),
                        y: d.y + (h.translateY || 0) + f - e,
                        width: a.width - 2 * f,
                        height: a.height - 2 * f
                    };
                }
            };
            for(f = 0; f < e; f++)if (h = a[f]) h.oldOpacity = h.opacity, h.newOpacity = 1, h.absoluteBox = q(h);
            a.sort(function(a, c) {
                return (c.labelrank || 0) - (a.labelrank || 0);
            });
            for(f = 0; f < e; f++){
                var t = (q = a[f]) && q.absoluteBox;
                for(h = f + 1; h < e; ++h){
                    var u = (n = a[h]) && n.absoluteBox;
                    !t || !u || q === n || 0 === q.newOpacity || 0 === n.newOpacity || u.x >= t.x + t.width || u.x + u.width <= t.x || u.y >= t.y + t.height || u.y + u.height <= t.y || ((q.labelrank < n.labelrank ? q : n).newOpacity = 0);
                }
            }
            a.forEach(function(a) {
                v(a, k) && (p = !0);
            });
            p && y(k, "afterHideAllOverlappingLabels");
        };
    });
    M(a, "Core/Responsive.js", [
        a["Core/Utilities.js"]
    ], function(a) {
        var v = a.extend, z = a.find, F = a.isArray, y = a.isObject, G = a.merge, H = a.objectEach, A = a.pick, q = a.splat, n = a.uniqueKey, k;
        (function(a) {
            var c = [];
            a.compose = function(a) {
                -1 === c.indexOf(a) && (c.push(a), v(a.prototype, e.prototype));
                return a;
            };
            var e = function() {
                function a() {}
                a.prototype.currentOptions = function(a) {
                    function c(a, f, h, k) {
                        var b;
                        H(a, function(a, d) {
                            if (!k && -1 < e.collectionsWithUpdate.indexOf(d) && f[d]) for(a = q(a), h[d] = [], b = 0; b < Math.max(a.length, f[d].length); b++)f[d][b] && (void 0 === a[b] ? h[d][b] = f[d][b] : (h[d][b] = {}, c(a[b], f[d][b], h[d][b], k + 1)));
                            else y(a) ? (h[d] = F(a) ? [] : {}, c(a, f[d] || {}, h[d], k + 1)) : h[d] = "undefined" === typeof f[d] ? null : f[d];
                        });
                    }
                    var e = this, f = {};
                    c(a, this.options, f, 0);
                    return f;
                };
                a.prototype.matchResponsiveRule = function(a, c) {
                    var e = a.condition;
                    (e.callback || function() {
                        return this.chartWidth <= A(e.maxWidth, Number.MAX_VALUE) && this.chartHeight <= A(e.maxHeight, Number.MAX_VALUE) && this.chartWidth >= A(e.minWidth, 0) && this.chartHeight >= A(e.minHeight, 0);
                    }).call(this) && c.push(a._id);
                };
                a.prototype.setResponsive = function(a, c) {
                    var e = this, f = this.options.responsive, h = this.currentResponsive, k = [];
                    !c && f && f.rules && f.rules.forEach(function(a) {
                        "undefined" === typeof a._id && (a._id = n());
                        e.matchResponsiveRule(a, k);
                    }, this);
                    c = G.apply(void 0, k.map(function(a) {
                        return z((f || {}).rules || [], function(c) {
                            return c._id === a;
                        });
                    }).map(function(a) {
                        return a && a.chartOptions;
                    }));
                    c.isResponsiveOptions = !0;
                    k = k.toString() || void 0;
                    k !== (h && h.ruleIds) && (h && this.update(h.undoOptions, a, !0), k ? (h = this.currentOptions(c), h.isResponsiveOptions = !0, this.currentResponsive = {
                        ruleIds: k,
                        mergedOptions: c,
                        undoOptions: h
                    }, this.update(c, a, !0)) : this.currentResponsive = void 0);
                };
                return a;
            }();
        })(k || (k = {}));
        "";
        "";
        return k;
    });
    M(a, "masters/highcharts.src.js", [
        a["Core/Globals.js"],
        a["Core/Utilities.js"],
        a["Core/DefaultOptions.js"],
        a["Core/Animation/Fx.js"],
        a["Core/Animation/AnimationUtilities.js"],
        a["Core/Renderer/HTML/AST.js"],
        a["Core/FormatUtilities.js"],
        a["Core/Renderer/RendererUtilities.js"],
        a["Core/Renderer/SVG/SVGElement.js"],
        a["Core/Renderer/SVG/SVGRenderer.js"],
        a["Core/Renderer/HTML/HTMLElement.js"],
        a["Core/Renderer/HTML/HTMLRenderer.js"],
        a["Core/Axis/Axis.js"],
        a["Core/Axis/DateTimeAxis.js"],
        a["Core/Axis/LogarithmicAxis.js"],
        a["Core/Axis/PlotLineOrBand/PlotLineOrBand.js"],
        a["Core/Axis/Tick.js"],
        a["Core/Tooltip.js"],
        a["Core/Series/Point.js"],
        a["Core/Pointer.js"],
        a["Core/MSPointer.js"],
        a["Core/Legend/Legend.js"],
        a["Core/Chart/Chart.js"],
        a["Core/Series/Series.js"],
        a["Core/Series/SeriesRegistry.js"],
        a["Series/Column/ColumnSeries.js"],
        a["Series/Column/ColumnDataLabel.js"],
        a["Series/Pie/PieSeries.js"],
        a["Series/Pie/PieDataLabel.js"],
        a["Core/Series/DataLabel.js"],
        a["Core/Responsive.js"],
        a["Core/Color/Color.js"],
        a["Core/Time.js"]
    ], function(a, u, z, F, y, G, H, A, q, n, k, e, c, h, f, w, p, B, t, J, C, r, l, b, g, d, m, D, x, I, M, S, O) {
        a.animate = y.animate;
        a.animObject = y.animObject;
        a.getDeferredAnimation = y.getDeferredAnimation;
        a.setAnimation = y.setAnimation;
        a.stop = y.stop;
        a.timers = F.timers;
        a.AST = G;
        a.Axis = c;
        a.Chart = l;
        a.chart = l.chart;
        a.Fx = F;
        a.Legend = r;
        a.PlotLineOrBand = w;
        a.Point = t;
        a.Pointer = C.isRequired() ? C : J;
        a.Series = b;
        a.SVGElement = q;
        a.SVGRenderer = n;
        a.Tick = p;
        a.Time = O;
        a.Tooltip = B;
        a.Color = S;
        a.color = S.parse;
        e.compose(n);
        k.compose(q);
        a.defaultOptions = z.defaultOptions;
        a.getOptions = z.getOptions;
        a.time = z.defaultTime;
        a.setOptions = z.setOptions;
        a.dateFormat = H.dateFormat;
        a.format = H.format;
        a.numberFormat = H.numberFormat;
        a.addEvent = u.addEvent;
        a.arrayMax = u.arrayMax;
        a.arrayMin = u.arrayMin;
        a.attr = u.attr;
        a.clearTimeout = u.clearTimeout;
        a.correctFloat = u.correctFloat;
        a.createElement = u.createElement;
        a.css = u.css;
        a.defined = u.defined;
        a.destroyObjectProperties = u.destroyObjectProperties;
        a.discardElement = u.discardElement;
        a.distribute = A.distribute;
        a.erase = u.erase;
        a.error = u.error;
        a.extend = u.extend;
        a.extendClass = u.extendClass;
        a.find = u.find;
        a.fireEvent = u.fireEvent;
        a.getMagnitude = u.getMagnitude;
        a.getStyle = u.getStyle;
        a.inArray = u.inArray;
        a.isArray = u.isArray;
        a.isClass = u.isClass;
        a.isDOMElement = u.isDOMElement;
        a.isFunction = u.isFunction;
        a.isNumber = u.isNumber;
        a.isObject = u.isObject;
        a.isString = u.isString;
        a.keys = u.keys;
        a.merge = u.merge;
        a.normalizeTickInterval = u.normalizeTickInterval;
        a.objectEach = u.objectEach;
        a.offset = u.offset;
        a.pad = u.pad;
        a.pick = u.pick;
        a.pInt = u.pInt;
        a.relativeLength = u.relativeLength;
        a.removeEvent = u.removeEvent;
        a.seriesType = g.seriesType;
        a.splat = u.splat;
        a.stableSort = u.stableSort;
        a.syncTimeout = u.syncTimeout;
        a.timeUnits = u.timeUnits;
        a.uniqueKey = u.uniqueKey;
        a.useSerialIds = u.useSerialIds;
        a.wrap = u.wrap;
        m.compose(d);
        I.compose(b);
        h.compose(c);
        f.compose(c);
        x.compose(D);
        w.compose(c);
        M.compose(l);
        return a;
    });
    a["masters/highcharts.src.js"]._modules = a;
    return a["masters/highcharts.src.js"];
});

});

parcelRegister("fap4R", function(module, exports) {

$parcel$export(module.exports, "BernerChartBase", () => $7c5d36b0b00f4e05$export$cedf339ede3da452);

var $2eeCH = parcelRequire("2eeCH");
parcelRequire("k6o0V");
var $l0Nlx = parcelRequire("l0Nlx");
parcelRequire("2NKH4");
var $jZi7J = parcelRequire("jZi7J");
var $lANGx = parcelRequire("lANGx");
var $ejp6K = parcelRequire("ejp6K");

var $ifhNi = parcelRequire("ifhNi");

var $96LZE = parcelRequire("96LZE");

var $ht1kU = parcelRequire("ht1kU");

var $hkQda = parcelRequire("hkQda");
class $7c5d36b0b00f4e05$export$cedf339ede3da452 extends (0, $l0Nlx.LitElement) {
    get useMinimalUI() {
        return this.minimalUI === 'true';
    }
    get shouldShowTitle() {
        return this.showTitle === 'true';
    }
    get shouldPlotAverages() {
        return this.plotAverages === 'true';
    }
    get shouldAggregate() {
        return this.aggregate === 'true';
    }
    get shouldSum() {
        return this.sum === 'true';
    }
    connectedCallback() {
        window.addEventListener((0, $hkQda.EVENTS).CHANGE_TEMP_UNIT, this.onTempUnitChanged);
        super.connectedCallback();
    }
    disconnectedCallback() {
        window.removeEventListener((0, $hkQda.EVENTS).CHANGE_TEMP_UNIT, this.onTempUnitChanged);
        super.disconnectedCallback();
    }
    updated(changed) {
        // changes that require a request to the back-end
        if (changed.has('plotAverages') || changed.has('deviceIds') || changed.has('range') || changed.has('measurementOne') || changed.has('measurementTwo') || changed.has('aggregate') || changed.has('labelOne') || changed.has('labelTwo')) this.refreshGraph();
    }
    async refreshGraph() {
        this._error = '';
        this._hasData = false;
        const measurements = [];
        if (this.measurementOne.trim().length) measurements.push(this.measurementOne);
        if (this.measurementTwo.trim().length) measurements.push(this.measurementTwo);
        let rangeData = new Map();
        const cachedData = await (0, $ht1kU.getCachedData)(this.range, this.deviceIds.indexOf(',') ? this.deviceIds.split(',') : [
            this.deviceIds
        ], [
            this.measurementOne,
            this.measurementTwo
        ], this.shouldAggregate, false, this.siteId);
        rangeData = cachedData.get(this.shouldAggregate ? (0, $96LZE.AGGREGATES_KEY) : this.deviceIds.indexOf(',') ? this.deviceIds.split(',')[0] : this.deviceIds);
        this._data.set(this.range, rangeData);
        const aggregateFunc = (0, $ht1kU.MEASUREMENT_TO_FUNC).get(measurements[0]);
        const measurementName = this.shouldAggregate ? aggregateFunc + '(' + measurements[0] + ')' : measurements[0];
        const deviceData = rangeData?.get(measurementName);
        if (deviceData?.length) {
            this._hasData = true;
            // work around, make sure the dom is updated first
            setTimeout(()=>{
                this.drawGraph();
                const credits = this.shadowRoot.querySelector('.highcharts-credits');
                credits?.classList.add('hidden');
                this._chart.reflow(); // workaround for chart overflows parent div
                if (!this._emittedRenderedEvent) {
                    this._emittedRenderedEvent = true;
                    const event = new CustomEvent((0, $hkQda.EVENTS).CHART_RENDERED, {
                        detail: {
                            chart: this.id
                        }
                    });
                    window.dispatchEvent(event);
                }
            }, 1500);
        } else {
            this._error = 'no data for ' + this.measurementOne;
            console.log(this._error);
            const canvas = this.shadowRoot.getElementById('canvas');
            canvas.innerHTML = '';
        }
    }
    render() {
        throw new Error('render should be implemented in a derived class');
    }
    constructor(...args){
        super(...args), this.deviceIds = '', this.measurementOne = '', this.measurementTwo = '', this.plotAverages = 'false', this.aggregate = 'false', this.sum = 'false', this.labelOne = '', this.labelTwo = '', this.range = '', this.minimalUI = 'false', this.showTitle = 'true', this.titlePosition = '', this.ratio = '', this.siteId = '', this._error = '', this._hasData = false, this._data = new Map(), this._emittedRenderedEvent = false, this.getGraphType = (measurement)=>{
            const graphType = (0, $96LZE.COLUMN_CHART_MEASUREMENTS).includes(measurement) ? (0, $ifhNi.GRAPH_TYPES).COLUMN : (0, $ifhNi.GRAPH_TYPES).AREASPLINE;
            return graphType;
        }, this.onTempUnitChanged = ()=>{
            this.refreshGraph();
        }, this.drawGraph = ()=>{
            throw new Error('drawGraph should be implemented in a derived class');
        };
    }
}
(0, $2eeCH.__decorate)([
    (0, $lANGx.property)({
        type: String,
        attribute: 'device-ids'
    })
], $7c5d36b0b00f4e05$export$cedf339ede3da452.prototype, "deviceIds", void 0);
(0, $2eeCH.__decorate)([
    (0, $lANGx.property)({
        type: String,
        attribute: 'measurement-one'
    })
], $7c5d36b0b00f4e05$export$cedf339ede3da452.prototype, "measurementOne", void 0);
(0, $2eeCH.__decorate)([
    (0, $lANGx.property)({
        type: String,
        attribute: 'measurement-two'
    })
], $7c5d36b0b00f4e05$export$cedf339ede3da452.prototype, "measurementTwo", void 0);
(0, $2eeCH.__decorate)([
    (0, $lANGx.property)({
        type: String,
        attribute: 'plot-averages'
    })
], $7c5d36b0b00f4e05$export$cedf339ede3da452.prototype, "plotAverages", void 0);
(0, $2eeCH.__decorate)([
    (0, $lANGx.property)({
        type: String,
        attribute: 'aggregate'
    })
], $7c5d36b0b00f4e05$export$cedf339ede3da452.prototype, "aggregate", void 0);
(0, $2eeCH.__decorate)([
    (0, $lANGx.property)({
        type: String,
        attribute: 'sum'
    })
], $7c5d36b0b00f4e05$export$cedf339ede3da452.prototype, "sum", void 0);
(0, $2eeCH.__decorate)([
    (0, $lANGx.property)({
        type: String,
        attribute: 'label-one'
    })
], $7c5d36b0b00f4e05$export$cedf339ede3da452.prototype, "labelOne", void 0);
(0, $2eeCH.__decorate)([
    (0, $lANGx.property)({
        type: String,
        attribute: 'label-two'
    })
], $7c5d36b0b00f4e05$export$cedf339ede3da452.prototype, "labelTwo", void 0);
(0, $2eeCH.__decorate)([
    (0, $lANGx.property)({
        type: String,
        attribute: 'range'
    })
], $7c5d36b0b00f4e05$export$cedf339ede3da452.prototype, "range", void 0);
(0, $2eeCH.__decorate)([
    (0, $lANGx.property)({
        type: String,
        attribute: 'minimal-ui'
    })
], $7c5d36b0b00f4e05$export$cedf339ede3da452.prototype, "minimalUI", void 0);
(0, $2eeCH.__decorate)([
    (0, $lANGx.property)({
        type: String,
        attribute: 'show-title'
    })
], $7c5d36b0b00f4e05$export$cedf339ede3da452.prototype, "showTitle", void 0);
(0, $2eeCH.__decorate)([
    (0, $lANGx.property)({
        type: String,
        attribute: 'title-position'
    })
], $7c5d36b0b00f4e05$export$cedf339ede3da452.prototype, "titlePosition", void 0);
(0, $2eeCH.__decorate)([
    (0, $lANGx.property)({
        type: String,
        attribute: 'ratio'
    })
], $7c5d36b0b00f4e05$export$cedf339ede3da452.prototype, "ratio", void 0);
(0, $2eeCH.__decorate)([
    (0, $lANGx.property)({
        type: String,
        attribute: 'site-id'
    })
], $7c5d36b0b00f4e05$export$cedf339ede3da452.prototype, "siteId", void 0);
(0, $2eeCH.__decorate)([
    (0, $ejp6K.state)()
], $7c5d36b0b00f4e05$export$cedf339ede3da452.prototype, "_error", void 0);
(0, $2eeCH.__decorate)([
    (0, $ejp6K.state)()
], $7c5d36b0b00f4e05$export$cedf339ede3da452.prototype, "_hasData", void 0);
$7c5d36b0b00f4e05$export$cedf339ede3da452 = (0, $2eeCH.__decorate)([
    (0, $jZi7J.customElement)('berner-chart-base')
], $7c5d36b0b00f4e05$export$cedf339ede3da452);

});


parcelRegister("3jmAN", function(module, exports) {
module.exports = import("kDVH5").then(()=>parcelRequire('9lU2u'));

});

parcelRegister("kZ5FM", function(module, exports) {
module.exports = import("j5dEF").then(()=>parcelRequire('bYRN3'));

});

parcelRegister("hiMWR", function(module, exports) {
module.exports = import("7n5Y2").then(()=>parcelRequire('3Q7Ts'));

});

parcelRegister("el5mb", function(module, exports) {
module.exports = import("7Clu9").then(()=>parcelRequire('bCWQ6'));

});

parcelRegister("1337n", function(module, exports) {
module.exports = import("hnkmB").then(()=>parcelRequire('bW5bP'));

});

parcelRegister("7RnGh", function(module, exports) {
module.exports = import("2Xa1j").then(()=>parcelRequire('hXZ88'));

});

parcelRegister("aTmJW", function(module, exports) {
module.exports = import("9uHut").then(()=>parcelRequire('uYUKy'));

});

parcelRegister("dzAv8", function(module, exports) {
module.exports = import("fHpvZ").then(()=>parcelRequire('kWNlY'));

});

parcelRegister("WDSo8", function(module, exports) {
module.exports = import("fnT8k").then(()=>parcelRequire('8knk2'));

});

/* eslint-env browser */ 
var $cqI6A = parcelRequire("cqI6A");

var $2eeCH = parcelRequire("2eeCH");
parcelRequire("k6o0V");
var $2Vehe = parcelRequire("2Vehe");
var $l0Nlx = parcelRequire("l0Nlx");
parcelRequire("2NKH4");
var $jZi7J = parcelRequire("jZi7J");

var $hkQda = parcelRequire("hkQda");
class $337eaa89adc69515$export$61873b71d765e966 extends (0, $l0Nlx.LitElement) {
    firstUpdated() {
        // consider Escape press as a click out
        window.document.onkeyup = (e)=>{
            if (e.key === 'Escape') window.dispatchEvent(new Event((0, $hkQda.EVENTS).CLICK_OUT));
        };
    }
    render() {
        const onClick = (e)=>{
            // detect unhandled clicks, used to close dropdowns etc
            window.dispatchEvent(new Event((0, $hkQda.EVENTS).CLICK_OUT));
        };
        return (0, $2Vehe.html)`<head content="width=device-width, initial-scale=1">
                <link rel="stylesheet" href="./css/berner-frame.css" />
            </head>

            <main @click=${onClick}>
                <slot></slot>
            </main>`;
    }
}
$337eaa89adc69515$export$61873b71d765e966 = (0, $2eeCH.__decorate)([
    (0, $jZi7J.customElement)('berner-frame')
], $337eaa89adc69515$export$61873b71d765e966);


var $4daea84e898bea53$exports = {};
$4daea84e898bea53$exports = JSON.parse("{\"sidebar\":{\"login\":{\"title\":\"Do air curtains really work?\",\"message\":\"YES! Air curtains a.k.a. air doors, properly selected, installed and operated really do work to create a barrier out of air across an opening. So much so, that ASHRAE Standard 90.1-2019 and the IECC building code allows air curtains as an alternative to vestibules.\"},\"create-org\":{\"title\":\"Do air curtains really work?\",\"message\":\"YES! Air curtains a.k.a. air doors, properly selected, installed and operated really do work to create a barrier out of air across an opening. So much so, that ASHRAE Standard 90.1-2019 and the IECC building code allows air curtains as an alternative to vestibules.\"},\"create-site\":{\"title\":\"Do air curtains really work?\",\"message\":\"YES! Air curtains a.k.a. air doors, properly selected, installed and operated really do work to create a barrier out of air across an opening. So much so, that ASHRAE Standard 90.1-2019 and the IECC building code allows air curtains as an alternative to vestibules.\"},\"signup\":{\"title\":\"Are air curtains effective?\",\"message\":\"YES!\\nEnergy Conservation & Comfort: Research shows that properly selected, installed and operated air curtains are +/- 80% effective at keeping warm air on one side and cold air on the other when the door is open.\"},\"password-reset\":{\"title\":\"When is the Berner office open?\",\"message\":\"Monday - Friday 8:00 a.m. - 5:00 p.m. EST.\\nClosed on major holidays.\"},\"password-reset-validate\":{\"title\":\"When is the Berner office open?\",\"message\":\"Monday - Friday 8:00 a.m. - 5:00 p.m. EST.\\nClosed on major holidays.\"}}}");



var $hdJfe = parcelRequire("hdJfe");

var $dNrEV = parcelRequire("dNrEV");

var $2eeCH = parcelRequire("2eeCH");
parcelRequire("2NKH4");
var $jZi7J = parcelRequire("jZi7J");

var $cqI6A = parcelRequire("cqI6A");

var $aL447 = parcelRequire("aL447");

var $hkQda = parcelRequire("hkQda");
class $2f74fcbb0ba7f68e$export$605dd9db5e2fadde extends (0, $aL447.BernerScreenBase) {
    async firstUpdated() {
        const initialized = await super.checkInitialized();
        if (initialized) (0, $cqI6A.Router).go((0, $hkQda.LANDING_PAGE));
    }
}
$2f74fcbb0ba7f68e$export$605dd9db5e2fadde = (0, $2eeCH.__decorate)([
    (0, $jZi7J.customElement)('berner-start')
], $2f74fcbb0ba7f68e$export$605dd9db5e2fadde);



var $2eeCH = parcelRequire("2eeCH");
parcelRequire("k6o0V");
var $1EWBs = parcelRequire("1EWBs");
var $2Vehe = parcelRequire("2Vehe");
var $l0Nlx = parcelRequire("l0Nlx");
parcelRequire("2NKH4");
var $jZi7J = parcelRequire("jZi7J");
var $lANGx = parcelRequire("lANGx");
var $ejp6K = parcelRequire("ejp6K");
parcelRequire("2BCvg");
var $Txkvx = parcelRequire("Txkvx");


var $cqI6A = parcelRequire("cqI6A");

var $hkQda = parcelRequire("hkQda");

var $dNrEV = parcelRequire("dNrEV");

var $hdJfe = parcelRequire("hdJfe");
class $29faa88bf318e2ef$export$1f025dbea365dbee extends (0, $l0Nlx.LitElement) {
    // class css-loading is removed as soon as the external css is loaded
    static get styles() {
        return (0, $1EWBs.css)`
            .css-loading {
                display: none;
            }
        `;
    }
    set collapsed(isCollapsed) {
        this._collapsed = isCollapsed;
        (0, $dNrEV.store).dispatch((0, $hdJfe.setNavBarCollapsedState)(this._collapsed));
        const event = new CustomEvent((0, $hkQda.EVENTS).NAV_BAR_COLLAPSE_CHANGE);
        window.dispatchEvent(event);
    }
    get collapsed() {
        return this._collapsed;
    }
    connectedCallback() {
        super.connectedCallback();
        window.addEventListener((0, $hkQda.EVENTS).NAVIGATE, this.onNavigated);
        window.addEventListener('resize', this.onResize);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        window.removeEventListener((0, $hkQda.EVENTS).NAVIGATE, this.onNavigated);
        window.removeEventListener('resize', this.onResize);
    }
    renderSideBar() {
        const isCelsiusSelected = (0, $hkQda.getTempUnitCelsiusSelected)();
        return (0, $2Vehe.html)`
            <section class="side-main">
                <div class="content-container">
                    <section
                        class="content-row d-none d-xl-flex content-row-1 mb-5"
                    >
                        <section
                            class=${(0, $Txkvx.classMap)({
            'overflow-hidden': true,
            'col-10': !this.collapsed,
            'col-12': this.collapsed
        })}
                        >
                            <div
                                class=${(0, $Txkvx.classMap)({
            logo: !this.collapsed,
            'logo-collapsed': this.collapsed
        })}
                            >
                                <button
                                    class="collapse-button"
                                    @click=${()=>{
            if (this.collapsed) this.collapsed = false;
        }}
                                >
                                    <img
                                        src="./assets/${this.collapsed ? 'bernerB.svg' : 'logo_white.svg'}"
                                        alt="Berner logo"
                                        class=${(0, $Txkvx.classMap)({
            'berner-b': this.collapsed,
            'mx-auto': this.collapsed
        })}
                                    />
                                </button>
                            </div>
                        </section>

                        <section
                            class=${(0, $Txkvx.classMap)({
            'col-1': !this.collapsed,
            'p-0': !this.collapsed,
            'overflow-hidden': false,
            'd-none': this.collapsed
        })}
                        >
                            <button
                                class="collapse-button"
                                @click=${()=>{
            this.collapsed = !this.collapsed;
        }}
                            >
                                <img
                                    src="./assets/icon_back_arrow.svg"
                                    alt="collapse"
                                />
                            </button>
                        </section>
                    </section>

                    <section class="content-row d-lg-flex content-row-2">
                        <div class="links">
                            <div class="${(0, $Txkvx.classMap)({
            'temp-buttons-container': true,
            'collapsed': this.collapsed
        })}">                            
                                    <button type="button" class="${(0, $Txkvx.classMap)({
            'btn': true,
            'btn-primary': true,
            'temp-select-button': true,
            'selected': isCelsiusSelected === false
        })}"
                                        @click=${(e)=>{
            if (!isCelsiusSelected) return;
            (0, $hkQda.tempUnitButtonClickHandler)(e);
            const event = new CustomEvent((0, $hkQda.EVENTS).CHANGE_TEMP_UNIT);
            window.dispatchEvent(event);
            this.requestUpdate();
        }}>Fahrenheit</button>

                                    <button type="button" class="${(0, $Txkvx.classMap)({
            'btn': true,
            'btn-primary': true,
            'temp-select-button': true,
            'selected': isCelsiusSelected === true
        })}" 
                                        @click=${(e)=>{
            if (isCelsiusSelected) return;
            (0, $hkQda.tempUnitButtonClickHandler)(e);
            const event = new CustomEvent((0, $hkQda.EVENTS).CHANGE_TEMP_UNIT);
            window.dispatchEvent(event);
            this.requestUpdate();
        }}>Celsius</button>
                            </div>

                            <a
                                class="${(0, $Txkvx.classMap)({
            'link-item': true,
            dashboard: true,
            highlight: this._pageName === 'dashboard',
            'mx-auto': this.collapsed,
            'pr-0': this.collapsed
        })}"
                                href="content/dashboard"
                                @click=${()=>{
            this._pageName = 'dashboard';
        }}
                            >
                                <span
                                    class=${(0, $Txkvx.classMap)({
            'd-none': this.collapsed
        })}
                                    >${this._lessThan1367px === true ? 'Dash' : 'Dashboard'}</span
                                >
                            </a>
                            <a
                                class="${(0, $Txkvx.classMap)({
            'link-item': true,
            sites: true,
            highlight: this._pageName === 'organization',
            'mx-auto': this.collapsed,
            'pr-0': this.collapsed
        })}"
                                href="content/organization"
                                @click=${()=>{
            this._pageName = 'organization';
        }}
                            >
                                <span
                                    class=${(0, $Txkvx.classMap)({
            'd-none': this.collapsed
        })}
                                >
                                    ${this._lessThan1367px === true ? 'Org' : 'Organization'}</span
                                >
                            </a>
                            <a
                                class="${(0, $Txkvx.classMap)({
            'link-item': true,
            profile: true,
            highlight: this._pageName === 'profile',
            'mx-auto': this.collapsed,
            'pr-0': this.collapsed
        })}"
                                href="content/profile"
                                @click=${()=>{
            this._pageName = 'profile';
        }}
                            >
                                <span
                                    class=${(0, $Txkvx.classMap)({
            'd-none': this.collapsed
        })}
                                    >Profile</span
                                >
                            </a>
                            <div class="d-block d-lg-none py-auto">
                                <button
                                    class="log-out mx-auto pr-0 link-item"
                                    @click=${()=>{
            (0, $cqI6A.Router).go('auth/login');
        }}
                                >
                                    <img
                                        src="./assets/icon_logout.png"
                                        alt="Log out"
                                    />
                                </button>
                            </div>
                        </div>
                    </section>
                    <section class="content-row d-none d-lg-flex content-row-3">
                        <div>
                            <button
                                class=${(0, $Txkvx.classMap)({
            'log-out': true,
            'float-right': !this.collapsed,
            'ml-3': !this.collapsed,
            'mr-3': this.collapsed
        })}
                                @click=${()=>{
            (0, $cqI6A.Router).go('auth/login');
        }}
                            >
                                <img
                                    src="./assets/icon_logout.png"
                                    alt="Log out"
                                />
                            </button>
                        </div>
                    </section>
                </div>
            </section>
        `;
    }
    render() {
        return (0, $2Vehe.html)`
        <head content="width=device-width, initial-scale=1"> </head>
            <link id="css-target">
            <div class="css-loading" id="root">
                <main class="container-fluid">
                    <section class="row content-row">
                        <aside
                            id="sidebar"
                            class=${(0, $Txkvx.classMap)({
            'col-lg-2': !this.collapsed,
            'col-lg-1': this.collapsed,
            'p-0': true,
            sidebar: true
        })}
                        >
                            ${this.renderSideBar()}
                        </aside>

                        <section
                            class=${(0, $Txkvx.classMap)({
            'col-lg-10': !this.collapsed,
            'col-lg-11': this.collapsed,
            mainbody: true,
            'overflow-auto': true
        })}
                        >
                            <slot></slot>
                        </section>
                    </section>
                </main>
                <div></div>
            </div>`;
    }
    constructor(...args){
        super(...args), this.location = (0, $70ff1b65e208e2a2$export$5375cda95f0b0eb4).location, this._pageName = '', this._collapsed = false, this._lessThan1367px = false, this.onResize = ()=>{
            if (window.matchMedia('(max-width: 1366.98px)').matches) {
                this._lessThan1367px = true;
                this.collapsed = false;
            } else this._lessThan1367px = false;
        }, this.onNavigated = async (e)=>{
            if (e.detail?.pageName) this._pageName = e.detail.pageName;
        }, this.firstUpdated = async ()=>{
            const path = location.pathname.split('/');
            this._pageName = path[path.length - 1];
            await (0, $hkQda.loadStyle)('./css/berner-content-navigation.css', this.shadowRoot);
            if (window.matchMedia('(max-width: 1366.98px)').matches) {
                this._lessThan1367px = true;
                this.collapsed = false;
            }
            this.requestUpdate();
        };
    }
}
(0, $2eeCH.__decorate)([
    (0, $lANGx.property)({
        type: Object
    })
], $29faa88bf318e2ef$export$1f025dbea365dbee.prototype, "location", void 0);
(0, $2eeCH.__decorate)([
    (0, $ejp6K.state)()
], $29faa88bf318e2ef$export$1f025dbea365dbee.prototype, "_pageName", void 0);
(0, $2eeCH.__decorate)([
    (0, $ejp6K.state)()
], $29faa88bf318e2ef$export$1f025dbea365dbee.prototype, "_collapsed", void 0);
(0, $2eeCH.__decorate)([
    (0, $ejp6K.state)()
], $29faa88bf318e2ef$export$1f025dbea365dbee.prototype, "_lessThan1367px", void 0);
$29faa88bf318e2ef$export$1f025dbea365dbee = (0, $2eeCH.__decorate)([
    (0, $jZi7J.customElement)('berner-content-navigation')
], $29faa88bf318e2ef$export$1f025dbea365dbee);



var $2eeCH = parcelRequire("2eeCH");
parcelRequire("k6o0V");
var $1EWBs = parcelRequire("1EWBs");
var $2Vehe = parcelRequire("2Vehe");
var $l0Nlx = parcelRequire("l0Nlx");
parcelRequire("2NKH4");
var $jZi7J = parcelRequire("jZi7J");
var $lANGx = parcelRequire("lANGx");
var $ejp6K = parcelRequire("ejp6K");

var $dNrEV = parcelRequire("dNrEV");


var $hkQda = parcelRequire("hkQda");
class $91f1bab28bae9ddc$export$5927e050d578dbac extends (0, $l0Nlx.LitElement) {
    // class css-loading is removed as soon as the external css is loaded
    static get styles() {
        return (0, $1EWBs.css)`
            .css-loading {
                display: none;
            }
        `;
    }
    renderSideBar() {
        return (0, $2Vehe.html)` <main class="side-main">
            <div class="content-container">
                <section class="content-row pt-0 pt-lg-2 content-row-0">
                    <div class="icons-container">
                        <div class="logo float-left">
                            <img
                                src="./assets/logo_white.svg"
                                alt="Berner logo"
                            />
                        </div>

                        <div class="icons float-right mt-2">
                            <a
                                href="https://www.facebook.com/bernerinternational/"
                                target="_blank"
                            >
                                <img
                                    src="./assets/login_icon_facebook.svg"
                                    alt="Facebook icon"
                                    class="mr-3"
                                    ;
                                />
                            </a>

                            <a
                                href="https://twitter.com/BernerAirDoors"
                                target="_blank"
                            >
                                <img
                                    src="./assets/login_icon_twitter.svg"
                                    alt="Twitter icon"
                                    class="mr-3"
                                    ;
                                />
                            </a>

                            <a
                                href="https://www.linkedin.com/company/bernerinternational"
                                target="_blank"
                            >
                                <img
                                    src="./assets/login_icon_linkedin.svg"
                                    alt="Linkedin icon"
                                />
                            </a>
                        </div>
                    </div>
                </section>
                <section class="content-row d-none d-lg-flex content-row-2">
                    <span>
                        <h4>${this._title}</h4>
                        <p>${this._message}</p>
                    </span>
                    ${this._pageName == 'login' || this._pageName == 'create-org' || this._pageName == 'create-first-site' ? (0, $2Vehe.html)`<a href="https://berner.com" target="_blank"
                              >Read more here</a
                          >` : (0, $2Vehe.html)``}
                </section>
                <section class="content-row d-none d-lg-flex content-row-3">
                    <span>
                        @2022 Berner International |
                        <a href="https://berner.com" target="_blank"
                            >Privacy Policy </a
                        >|<a href="https://berner.com" target="_blank">
                            Contact Us
                        </a>
                    </span>
                </section>
            </div>
        </main>`;
    }
    render() {
        return (0, $2Vehe.html)`
            <link id="css-target">
            <div class="css-loading" id="root">
                <main class="container-fluid">
                    <div class="row content-row">
                        <aside id="sidebar" class="col-lg-4 p-0">
                            ${this.renderSideBar()}
                        </aside>

                        <div class="col-lg-8">
                            <slot></slot>
                        </div>
                    </div>
                </main>
            </div>
        `;
    }
    constructor(...args){
        super(...args), this.location = (0, $70ff1b65e208e2a2$export$5375cda95f0b0eb4).location, this._title = '', this._message = '', this._pageName = '', this.firstUpdated = async ()=>{
            const state = (0, $dNrEV.store).getState();
            const applicationText = state.applicationText;
            const path = location.pathname.split('/');
            this._pageName = path[path.length - 1];
            console.log('_pageName: ', this._pageName);
            if (this._pageName === 'auth') this._pageName = 'login';
            if (applicationText !== null && applicationText['sidebar'][this._pageName]) {
                this._title = applicationText['sidebar'][this._pageName]['title'];
                this._message = applicationText['sidebar'][this._pageName]['message'];
            }
            await (0, $hkQda.loadStyle)('./css/berner-auth-navigation.css', this.shadowRoot);
            this.requestUpdate();
        };
    }
}
(0, $2eeCH.__decorate)([
    (0, $lANGx.property)({
        type: Object
    })
], $91f1bab28bae9ddc$export$5927e050d578dbac.prototype, "location", void 0);
(0, $2eeCH.__decorate)([
    (0, $ejp6K.state)()
], $91f1bab28bae9ddc$export$5927e050d578dbac.prototype, "_title", void 0);
(0, $2eeCH.__decorate)([
    (0, $ejp6K.state)()
], $91f1bab28bae9ddc$export$5927e050d578dbac.prototype, "_message", void 0);
(0, $2eeCH.__decorate)([
    (0, $ejp6K.state)()
], $91f1bab28bae9ddc$export$5927e050d578dbac.prototype, "_pageName", void 0);
$91f1bab28bae9ddc$export$5927e050d578dbac = (0, $2eeCH.__decorate)([
    (0, $jZi7J.customElement)('berner-auth-navigation')
], $91f1bab28bae9ddc$export$5927e050d578dbac);



var $2eeCH = parcelRequire("2eeCH");
parcelRequire("k6o0V");
var $2Vehe = parcelRequire("2Vehe");
parcelRequire("2NKH4");
var $jZi7J = parcelRequire("jZi7J");
var $ejp6K = parcelRequire("ejp6K");
parcelRequire("2BCvg");
var $Txkvx = parcelRequire("Txkvx");

var $aL447 = parcelRequire("aL447");

var $cqI6A = parcelRequire("cqI6A");

var $hkQda = parcelRequire("hkQda");

var $ifhNi = parcelRequire("ifhNi");

var $96LZE = parcelRequire("96LZE");

var $dNrEV = parcelRequire("dNrEV");

var $2eeCH = parcelRequire("2eeCH");
parcelRequire("k6o0V");
var $1EWBs = parcelRequire("1EWBs");
var $2Vehe = parcelRequire("2Vehe");
var $l0Nlx = parcelRequire("l0Nlx");
parcelRequire("2NKH4");
var $jZi7J = parcelRequire("jZi7J");
var $lANGx = parcelRequire("lANGx");
var $ejp6K = parcelRequire("ejp6K");
parcelRequire("2BCvg");
var $Txkvx = parcelRequire("Txkvx");
parcelRequire("jRqJ2");
var $3q9Vf = parcelRequire("3q9Vf");

var $dNrEV = parcelRequire("dNrEV");

var $hkQda = parcelRequire("hkQda");
class $3f0860ebe16295e8$export$62f2d3a3c9931cf7 extends (0, $l0Nlx.LitElement) {
    get selectedAirCurtain() {
        return this._selectedAirCurtain.toString();
    }
    set selectedAirCurtain(value) {
        this._selectedAirCurtain = value;
    }
    // class css-loading is removed as soon as the external css is loaded
    static get styles() {
        return (0, $1EWBs.css)`
            .css-loading {
                display: none;
            }
        `;
    }
    constructor(){
        super(), // if set only show aircurtains for the site in question
        this.selectedSite = '', this._sites = [], this._airCurtainsBySite = new Map(), this._allAirCurtains = [], this._lessThan480px = false, this._initialized = false, this._selectedAirCurtain = '', this.init = async ()=>{
            const { objectManager: objectManager } = (0, $dNrEV.store).getState();
            const siteGroup = objectManager.getSiteGroup();
            for (const siteId of siteGroup.sites){
                const site = objectManager.getSite(siteId);
                this._sites.push(site);
                const siteCurtainsMap = new Map();
                for (const curtainGroupId of site.airCurtainGroups){
                    const airCurtainGroup = objectManager.getAirCurtainGroup(curtainGroupId);
                    const groupAirCurtains = await objectManager.getAllAirCurtainsFromAirCurtainGroup(airCurtainGroup);
                    let siteCurtains = siteCurtainsMap.get(siteId) ?? [];
                    siteCurtains = siteCurtains.concat(groupAirCurtains);
                    siteCurtainsMap.set(siteId, siteCurtains);
                }
                const orderedSiteCurtains = (0, $hkQda.orderAirCurtains)(siteCurtainsMap);
                const siteCurtains = orderedSiteCurtains?.map((obj)=>{
                    return obj.curtain;
                });
                this._airCurtainsBySite.set(site.siteID, siteCurtains);
            }
            this._allAirCurtains = (0, $hkQda.orderAirCurtains)(this._airCurtainsBySite);
            this._initialized = true;
        }, this.firstUpdated = async ()=>{
            await (0, $hkQda.loadStyle)('./css/berner-curtains.css', this.shadowRoot);
            if (window.matchMedia('(max-width: 479.98px)').matches) this._lessThan480px = true;
            else this._lessThan480px = false;
            this.requestUpdate();
        }, this.onResize = async ()=>{
            const wasLessThan480px = this._lessThan480px;
            if (window.matchMedia('(max-width: 479.98px)').matches) this._lessThan480px = true;
            else this._lessThan480px = false;
            if (wasLessThan480px !== this._lessThan480px) this.requestUpdate();
        }, this.onClickCurtain = (airCurtainId, siteId)=>{
            if (airCurtainId === this.selectedAirCurtain) this.selectedAirCurtain = '';
            else this.selectedAirCurtain = airCurtainId;
            const event = new CustomEvent((0, $hkQda.EVENTS).CURTAIN_SELECTED, {
                detail: {
                    curtain: this.selectedAirCurtain,
                    site: siteId
                }
            });
            window.dispatchEvent(event);
        };
        this.init();
    }
    connectedCallback() {
        super.connectedCallback();
        window.addEventListener('resize', this.onResize);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        window.removeEventListener('resize', this.onResize);
    }
    renderNoAirCurtains() {
        return (0, $2Vehe.html)`
            <div class="col-12">
                <p class="mx-auto pt-3 my-auto label">
                    This site does not have any air curtains yet.
                </p>
            </div>
        `;
    }
    renderAirCurtain(curtain, siteId = '') {
        const connectivityPrescript = curtain?.connected ? 'Connected: ' : 'Online: ';
        const connectivityMessage = curtain?.connectivityTimestamp ? connectivityPrescript + (0, $hkQda.getTimeElapsed)(curtain?.connectivityTimestamp) : '';
        return (0, $2Vehe.html)`
        <div class=${(0, $Txkvx.classMap)({
            "row": true,
            "py-3": true,
            "air-curtain": true,
            "selected": this.selectedAirCurtain === curtain.airCurtainID
        })} @click=${(e)=>{
            this.onClickCurtain(curtain.airCurtainID, siteId);
            e.stopPropagation();
        }}>
            <span class='col-1'>
                <span class=${(0, $Txkvx.classMap)({
            'dot': curtain?.connected,
            'dot--red': !curtain?.connected
        })}></span>
            </span>
            ${curtain.connectivityTimestamp && !this._lessThan480px ? (0, $2Vehe.html)`
                <span class="col-5 curtain-name"> ${curtain?.name}</span>
                <span class="col-5 curtain-last-online">${connectivityMessage}</span>` : (0, $2Vehe.html)`<span class=${(0, $Txkvx.classMap)({
            "curtain-name": true,
            "col-11": !this._lessThan480px,
            "col-10": this._lessThan480px
        })}> ${curtain?.name}</span>`}
        </div>`;
    }
    renderSiteCurtains(siteId) {
        const siteAirCurtains = this._airCurtainsBySite.get(siteId);
        if (!siteAirCurtains.length) return (0, $2Vehe.html)`${this.renderNoAirCurtains()}`;
        return (0, $2Vehe.html)`
        ${(0, $3q9Vf.repeat)(siteAirCurtains, (curtain)=>{
            return (0, $2Vehe.html)`${this.renderAirCurtain(curtain, siteId)}`;
        })}`;
    }
    renderAllAirCurtains() {
        if (!this._allAirCurtains.length) return (0, $2Vehe.html)``;
        return (0, $2Vehe.html)`
            <ul class="curtains-list p-0 content">
                ${(0, $3q9Vf.repeat)(this._allAirCurtains, (obj)=>{
            return (0, $2Vehe.html)` ${this.renderAirCurtain(obj.curtain, obj.site)} `;
        })}
            </ul>
        `;
    }
    renderAirCurtains() {
        if (!this._airCurtainsBySite.size) return (0, $2Vehe.html)``;
        if (this.selectedSite) return (0, $2Vehe.html)`
                <ul class="curtains-list p-0 content">
                    ${this.renderSiteCurtains(this.selectedSite)}
                </ul>`;
        else return (0, $2Vehe.html)`${this.renderAllAirCurtains()}`;
    }
    render() {
        return (0, $2Vehe.html)`
        <link id="css-target">
        <div class="css-loading" id="root">
            <div class="col-lg-12 p-0">
                ${this._initialized ? this.renderAirCurtains() : (0, $2Vehe.html)``}
            </div>
        </div>`;
    }
}
(0, $2eeCH.__decorate)([
    (0, $lANGx.property)({
        attribute: 'selected-site'
    })
], $3f0860ebe16295e8$export$62f2d3a3c9931cf7.prototype, "selectedSite", void 0);
(0, $2eeCH.__decorate)([
    (0, $ejp6K.state)()
], $3f0860ebe16295e8$export$62f2d3a3c9931cf7.prototype, "_initialized", void 0);
(0, $2eeCH.__decorate)([
    (0, $lANGx.property)({
        attribute: 'selected-air-curtain'
    })
], $3f0860ebe16295e8$export$62f2d3a3c9931cf7.prototype, "_selectedAirCurtain", void 0);
(0, $2eeCH.__decorate)([
    (0, $ejp6K.state)()
], $3f0860ebe16295e8$export$62f2d3a3c9931cf7.prototype, "selectedAirCurtain", null);
$3f0860ebe16295e8$export$62f2d3a3c9931cf7 = (0, $2eeCH.__decorate)([
    (0, $jZi7J.customElement)('berner-curtains')
], $3f0860ebe16295e8$export$62f2d3a3c9931cf7);


parcelRequire("5fchy");

var $2eeCH = parcelRequire("2eeCH");
parcelRequire("k6o0V");
var $1EWBs = parcelRequire("1EWBs");
var $2Vehe = parcelRequire("2Vehe");
var $l0Nlx = parcelRequire("l0Nlx");
parcelRequire("2NKH4");
var $jZi7J = parcelRequire("jZi7J");
var $lANGx = parcelRequire("lANGx");
var $ejp6K = parcelRequire("ejp6K");
parcelRequire("jRqJ2");
var $3q9Vf = parcelRequire("3q9Vf");
parcelRequire("2BCvg");
var $Txkvx = parcelRequire("Txkvx");

var $hkQda = parcelRequire("hkQda");

var $dNrEV = parcelRequire("dNrEV");
class $6760f34ac510770c$export$f32397bad198f2ab extends (0, $l0Nlx.LitElement) {
    get selectedSite() {
        return this._selectedSite.toString();
    }
    set selectedSite(value) {
        this._selectedSite = value;
    }
    constructor(){
        super(), this._sites = [], this._airCurtainsBySite = new Map(), this._selectedSite = '', this._initialized = false, this.init = async ()=>{
            const { objectManager: objectManager } = (0, $dNrEV.store).getState();
            this._objectManager = objectManager;
            const siteGroup = this._objectManager.getSiteGroup();
            this.selectedSite = '';
            for (const siteId of siteGroup.sites){
                const site = this._objectManager.getSite(siteId);
                this._sites.push(site);
            }
            this.loadSiteResources();
            this._initialized = true;
        }, this.loadSiteResources = async ()=>{
            for (const site of this._sites){
                let siteCurtains = [];
                for (const curtainGroupId of site.airCurtainGroups){
                    const airCurtainGroup = this._objectManager.getAirCurtainGroup(curtainGroupId);
                    const groupAirCurtains = await this._objectManager.getAllAirCurtainsFromAirCurtainGroup(airCurtainGroup);
                    siteCurtains = siteCurtains.concat(groupAirCurtains);
                }
                this._airCurtainsBySite.set(site.siteID, siteCurtains);
            }
            this.requestUpdate();
        }, this.firstUpdated = async ()=>{
            await (0, $hkQda.loadStyle)('./css/berner-sites.css', this.shadowRoot);
        };
        this.init();
    }
    // class css-loading is removed as soon as the external css is loaded
    static get styles() {
        return (0, $1EWBs.css)`
            .css-loading {
                display: none;
            }
        `;
    }
    updated() {
        this.shadowRoot.getElementById(this._selectedSite)?.scrollIntoView({
            behavior: "smooth",
            block: "end",
            inline: "nearest"
        });
    }
    renderNoSites() {
        return (0, $2Vehe.html)`
            <div class="col-12">
                <div class="pt-5">
                    <p class="mx-auto mb-2 label">There are no sites yet.</p>
                </div>
            </div>
        `;
    }
    renderSites() {
        if (!this._sites.length) return (0, $2Vehe.html)`${this.renderNoSites()}`;
        const onClickSite = (siteId, e)=>{
            if (siteId === this.selectedSite) this.selectedSite = '';
            else this.selectedSite = siteId;
            const event = new CustomEvent((0, $hkQda.EVENTS).SITE_SELECTED, {
                detail: {
                    site: this._selectedSite
                }
            });
            e.stopPropagation();
            window.dispatchEvent(event);
        };
        return (0, $2Vehe.html)`
            <ul class="sites-list px-0 pb-2 content">
                ${(0, $3q9Vf.repeat)(this._sites, (site)=>{
            const siteName = site.name;
            const numCurtains = this._airCurtainsBySite.get(site.siteID)?.length;
            return (0, $2Vehe.html)`
                        <div class="col-12 p-0 m-0">
                            <section
                                class="${(0, $Txkvx.classMap)({
                row: true,
                selected: this.selectedSite === site.siteID,
                'py-2': true,
                'mx-0': true
            })}"
                                id=${site.siteID}
                                @click=${(e)=>onClickSite(site.siteID, e)}>
                                <div class="site-name col-6">
                                    <p>${siteName}</p>
                                </div>
                                <div class="col-6 row pr-0 air-curtains-container">
                                    <span class="float-right mr-1">
                                        <img
                                            src="./assets/reports_icon_air_curtains_grey.svg"
                                            alt="air curtains"
                                        />
                                    </span>

                                    <span class="float-right">
                                        ${numCurtains}
                                    </span>
                                </div>
                            </section>
                        </div>
                    `;
        })}
            </ul>
        `;
    }
    render() {
        return (0, $2Vehe.html)`
        <link id="css-target">
        <div class="css-loading ml-n1" id="root">
            <div class="col-lg-12 px-2 mx-auto">
                ${this._initialized ? this.renderSites() : (0, $2Vehe.html)``}
            </div>
        </div>`;
    }
}
(0, $2eeCH.__decorate)([
    (0, $lANGx.property)({
        attribute: 'selected-site'
    })
], $6760f34ac510770c$export$f32397bad198f2ab.prototype, "_selectedSite", void 0);
(0, $2eeCH.__decorate)([
    (0, $ejp6K.state)()
], $6760f34ac510770c$export$f32397bad198f2ab.prototype, "selectedSite", null);
(0, $2eeCH.__decorate)([
    (0, $ejp6K.state)()
], $6760f34ac510770c$export$f32397bad198f2ab.prototype, "_initialized", void 0);
$6760f34ac510770c$export$f32397bad198f2ab = (0, $2eeCH.__decorate)([
    (0, $jZi7J.customElement)('berner-sites')
], $6760f34ac510770c$export$f32397bad198f2ab);



var $2eeCH = parcelRequire("2eeCH");
parcelRequire("k6o0V");
var $1EWBs = parcelRequire("1EWBs");
var $2Vehe = parcelRequire("2Vehe");
var $l0Nlx = parcelRequire("l0Nlx");
parcelRequire("2NKH4");
var $jZi7J = parcelRequire("jZi7J");
var $lANGx = parcelRequire("lANGx");
var $ejp6K = parcelRequire("ejp6K");

var $dNrEV = parcelRequire("dNrEV");

var $hkQda = parcelRequire("hkQda");

var $96LZE = parcelRequire("96LZE");
class $a7c4dcef1b844812$export$8f161e9a143c5d3 extends (0, $l0Nlx.LitElement) {
    get siteId() {
        return this._siteId;
    }
    set siteId(value) {
        this._siteId = value;
        this.getData();
        this.requestUpdate();
    }
    // class css-loading is removed as soon as the external css is loaded
    static get styles() {
        return (0, $1EWBs.css)`
            .css-loading {
                display: none;
            }
        `;
    }
    connectedCallback() {
        window.addEventListener((0, $hkQda.EVENTS).CHANGE_TEMP_UNIT, this.onTempUnitChanged);
        super.connectedCallback();
    }
    disconnectedCallback() {
        window.removeEventListener((0, $hkQda.EVENTS).CHANGE_TEMP_UNIT, this.onTempUnitChanged);
        super.disconnectedCallback();
    }
    updated() {
        this.siteName = this._objectManager?.getSite(this.siteId)?.name;
    }
    async getData() {
        if (!this._objectManager) return;
        const site = this._objectManager.getSite(this.siteId);
        this._weather = await site?.getCurrentWeather();
        this._weather.currentTemperature = (0, $96LZE.getConvertedTemperature)(this._weather.currentTemperature);
        this._weather.maximumTemperature = (0, $96LZE.getConvertedTemperature)(this._weather.maximumTemperature);
        this._weather.maximumTemperature = (0, $96LZE.getConvertedTemperature)(this._weather.maximumTemperature);
        this._weather.feelsLikeTemperature = (0, $96LZE.getConvertedTemperature)(this._weather.feelsLikeTemperature);
    }
    renderContent() {
        const displayTemp = this._weather?.currentTemperature ? `${this._weather?.currentTemperature?.toLocaleString("en-US", {
            maximumFractionDigits: 0,
            minimumFractionDigits: 0
        })}\xb0` : '';
        const displayHumidity = this._weather?.relativeHumidity ? `${this._weather?.relativeHumidity}%` : '';
        return (0, $2Vehe.html)`
            <div class="card">
                <section class="card-body">
                    <div class="row content-row header">
                        <div class="col text-left">
                            <div class="row header top-row">
                                <div class="icon top-row-icon">
                                    <img
                                        src="./assets/icon_weather.svg"
                                        alt="users"
                                    />
                                </div>
                                <span class="card-title text-white title top-row-title"
                                    >${'Weather' + (this.siteName ? ' for ' + this.siteName : '')}
                                </span>
                                <div class="site-cycle-button-container top-row-buttons">
                                    <button
                                        type="button"
                                        class="btn site-cycle-button"
                                        @click=${()=>this.onSiteSelect(true)}>&#9664;
                                    </button>
                                    <button
                                        type="button"
                                        class="btn site-cycle-button rotate"
                                        @click=${()=>this.onSiteSelect(false)}>&#9664;
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <article class="row pt-5">
                        <div class="col-6 left-element">
                            <h5 class="mb-3">Outside</h5>
                            <p class="temperature ml-2">
                                ${displayTemp}
                            </p>
                        </div>
                        <div class="col-6">
                            <h5 class="mb-3">Humidity</h5>
                            <p class="humidity ml-2">
                                ${displayHumidity}
                            </p>
                        </div>
                    </article>
                </section>
            </div>
        `;
    }
    render() {
        return (0, $2Vehe.html)`
        <link id="css-target">
        <div class="css-loading" id="root">
            <div class="col-lg-12 mx-auto no-gutters h-100 p-0">
                ${this._initialized ? (0, $2Vehe.html)`${this.renderContent()}` : (0, $2Vehe.html)``}
            </div>
        </div>`;
    }
    constructor(...args){
        super(...args), this._initialized = false, this._siteId = '', this.onTempUnitChanged = ()=>{
            this.getData();
            this.requestUpdate();
        }, this.onSiteSelect = (left)=>{
            let index = this.allSites.findIndex((site)=>{
                return site === this.siteId;
            });
            if (left) {
                if (index === 0) index = this.allSites.length - 1;
                else index -= 1;
            } else if (index === this.allSites.length - 1) index = 0;
            else index += 1;
            this.siteId = this.allSites[index];
            this.siteName = this._objectManager.getSite(this.siteId)?.name;
        }, this.firstUpdated = async ()=>{
            await (0, $hkQda.loadStyle)('./css/berner-weather.css', this.shadowRoot);
            const { objectManager: objectManager } = (0, $dNrEV.store).getState();
            this._objectManager = objectManager;
            this.allSites = this.sites.split(':');
            this.siteName = this._objectManager.getSite(this.siteId)?.name;
            this.getData();
            this._initialized = true;
            this.requestUpdate();
        };
    }
}
(0, $2eeCH.__decorate)([
    (0, $ejp6K.state)()
], $a7c4dcef1b844812$export$8f161e9a143c5d3.prototype, "_weather", void 0);
(0, $2eeCH.__decorate)([
    (0, $lANGx.property)({
        attribute: 'site-id'
    })
], $a7c4dcef1b844812$export$8f161e9a143c5d3.prototype, "siteId", null);
(0, $2eeCH.__decorate)([
    (0, $lANGx.property)({
        attribute: 'sites'
    })
], $a7c4dcef1b844812$export$8f161e9a143c5d3.prototype, "sites", void 0);
$a7c4dcef1b844812$export$8f161e9a143c5d3 = (0, $2eeCH.__decorate)([
    (0, $jZi7J.customElement)('berner-weather')
], $a7c4dcef1b844812$export$8f161e9a143c5d3);


parcelRequire("1yYF5");

var $2eeCH = parcelRequire("2eeCH");
parcelRequire("k6o0V");
var $1EWBs = parcelRequire("1EWBs");
var $2Vehe = parcelRequire("2Vehe");
var $l0Nlx = parcelRequire("l0Nlx");
parcelRequire("2NKH4");
var $jZi7J = parcelRequire("jZi7J");
var $lANGx = parcelRequire("lANGx");
parcelRequire("2BCvg");
var $Txkvx = parcelRequire("Txkvx");

var $hkQda = parcelRequire("hkQda");
class $27fbc560d70b8706$export$bd86770ff3cbad94 extends (0, $l0Nlx.LitElement) {
    get negative() {
        return this.negativeChange === 'true';
    }
    get noDataAvailable() {
        return this.noData === 'true';
    }
    get isCurtainOffline() {
        return this.curtainOffline === 'true';
    }
    // class css-loading is removed as soon as the external css is loaded
    static get styles() {
        return (0, $1EWBs.css)`
            .css-loading {
                display: none;
            }
        `;
    }
    renderContent() {
        const UP_ARROW = '\u25B2';
        const DOWN_ARROW = '\u25BC';
        const CHANGE_PREFIX = this.negative ? DOWN_ARROW : UP_ARROW;
        const parsedChange = parseFloat(this.change);
        const showPrefix = !Number.isNaN(parsedChange) && parsedChange !== 0;
        return (0, $2Vehe.html)`
            <section class="row mt-4">
                <div class="col-7 left-element">
                    <p class="title ${this.colour}">${this.title}</p>
                    <p class="subtitle">${this.subtitle}</p>
                </div>
                <div class="col-5 right-element">
                    <p class=${(0, $Txkvx.classMap)({
            "value": !this.noDataAvailable,
            "value--small": this.noDataAvailable
        })}>${this.value}</p>
                    <p class="subtitle">
                        <span class=${(0, $Txkvx.classMap)({
            "change": true,
            "d-none": this.noDataAvailable
        })}
                            >${showPrefix ? CHANGE_PREFIX : ""} ${this.displayChange}</span
                        >
                        <span class=${(0, $Txkvx.classMap)({
            "d-none": !this.isCurtainOffline || !this.noDataAvailable
        })}>offline device</span>
                    </p>
                </div>
            </section>
        `;
    }
    render() {
        return (0, $2Vehe.html)`
        <link id="css-target">
        <div class="css-loading" id="root">
            <div class="col-lg-12 mx-auto my-3 no-gutters">
                ${this._initialized ? (0, $2Vehe.html)`${this.renderContent()}` : (0, $2Vehe.html)``}
            </div>
        </div>`;
    }
    constructor(...args){
        super(...args), this._initialized = false, this.subtitle = '', this.colour = '', this.value = '', this.displayChange = '', this.change = '', this.negativeChange = '', this.noData = '', this.curtainOffline = '', this.firstUpdated = async ()=>{
            await (0, $hkQda.loadStyle)('./css/berner-infographic.css', this.shadowRoot);
            this._initialized = true;
            this.requestUpdate();
        };
    }
}
(0, $2eeCH.__decorate)([
    (0, $lANGx.property)()
], $27fbc560d70b8706$export$bd86770ff3cbad94.prototype, "subtitle", void 0);
(0, $2eeCH.__decorate)([
    (0, $lANGx.property)()
], $27fbc560d70b8706$export$bd86770ff3cbad94.prototype, "colour", void 0);
(0, $2eeCH.__decorate)([
    (0, $lANGx.property)()
], $27fbc560d70b8706$export$bd86770ff3cbad94.prototype, "value", void 0);
(0, $2eeCH.__decorate)([
    (0, $lANGx.property)({
        attribute: 'display-change'
    })
], $27fbc560d70b8706$export$bd86770ff3cbad94.prototype, "displayChange", void 0);
(0, $2eeCH.__decorate)([
    (0, $lANGx.property)()
], $27fbc560d70b8706$export$bd86770ff3cbad94.prototype, "change", void 0);
(0, $2eeCH.__decorate)([
    (0, $lANGx.property)({
        attribute: 'negative-change'
    })
], $27fbc560d70b8706$export$bd86770ff3cbad94.prototype, "negativeChange", void 0);
(0, $2eeCH.__decorate)([
    (0, $lANGx.property)({
        attribute: 'no-data'
    })
], $27fbc560d70b8706$export$bd86770ff3cbad94.prototype, "noData", void 0);
(0, $2eeCH.__decorate)([
    (0, $lANGx.property)({
        attribute: 'curtain-offline'
    })
], $27fbc560d70b8706$export$bd86770ff3cbad94.prototype, "curtainOffline", void 0);
$27fbc560d70b8706$export$bd86770ff3cbad94 = (0, $2eeCH.__decorate)([
    (0, $jZi7J.customElement)('berner-infographic')
], $27fbc560d70b8706$export$bd86770ff3cbad94);



var $2eeCH = parcelRequire("2eeCH");
parcelRequire("k6o0V");
var $1EWBs = parcelRequire("1EWBs");
var $2Vehe = parcelRequire("2Vehe");
var $l0Nlx = parcelRequire("l0Nlx");
parcelRequire("2NKH4");
var $jZi7J = parcelRequire("jZi7J");
var $lANGx = parcelRequire("lANGx");
var $ejp6K = parcelRequire("ejp6K");

var $hkQda = parcelRequire("hkQda");

var $dNrEV = parcelRequire("dNrEV");
parcelRequire("2BCvg");
var $Txkvx = parcelRequire("Txkvx");
class $49a428eb64dd44b4$export$fef0e3b9e7081998 extends (0, $l0Nlx.LitElement) {
    // class css-loading is removed as soon as the external css is loaded
    static get styles() {
        return (0, $1EWBs.css)`
            .css-loading {
                display: none;
            }
        `;
    }
    async firstUpdated() {
        await (0, $hkQda.loadStyle)('./css/modals/berner-update-site-costs-modal.css', this.shadowRoot);
        const { objectManager: objectManager } = (0, $dNrEV.store).getState();
        this._objectManager = objectManager;
        const site = this._objectManager.getSite(this.siteId);
        this._location = await this._objectManager.getLocation(site.siteID);
        this._gasRate = this._location.naturalGasRate;
        this._electricityRate = this._location.electricityRate;
        this._oilRate = this._location.oilRate;
        this.powerCycles = this._location.powerCycles === 50 ? (0, $hkQda.POWER_CYCLES).FIFTY_HZ : (0, $hkQda.POWER_CYCLES).SIXTY_HZ;
    }
    async save() {
        this._saving = true;
        const saved = await (0, $hkQda.updateSiteCosts)(this._objectManager, this.siteId, this._gasRate ?? 0, this._electricityRate ?? 0, this._oilRate ?? 0, this.powerCycles);
        this._saving = false;
        return saved;
    }
    get saveEnabled() {
        if (!this._objectManager) return false;
        const gasRateChanged = this._location.naturalGasRate != this._gasRate;
        const electricityRateChanged = this._location.electricityRate != this._electricityRate;
        const oilRateChanged = this._location.oilRate != this._oilRate;
        const currentPowerCycles = this._location.powerCycles == 50 ? (0, $hkQda.POWER_CYCLES).FIFTY_HZ : (0, $hkQda.POWER_CYCLES).SIXTY_HZ;
        const powerCyclesChanged = currentPowerCycles != this.powerCycles;
        return Boolean(this.siteId?.trim()) && (gasRateChanged || electricityRateChanged || oilRateChanged || powerCyclesChanged);
    }
    renderContent() {
        const onClickRadioButton = (e)=>{
            this.powerCycles = e.target.id;
            e.stopPropagation();
        };
        const electricityRatePlaceholder = "Electricity Rate {$/kWH}";
        const gasRatePlaceholder = "Gas Rate ($/Mcf)";
        const oilRatePlaceholder = "Oil ($/Barrel)";
        return (0, $2Vehe.html)`
            <div class="container-fluid">
                <div class="form-group">
                    <section class="form-group row">
                        ${this._saving ? (0, $2Vehe.html)`
                                  <div class="mx-auto pt-5 pb-5">
                                      <div
                                          class="spinner-border spinner-loader"
                                          role="status"
                                      >
                                          <span class="sr-only">Saving...</span>
                                      </div>
                                  </div>
                              ` : (0, $2Vehe.html)`
                                  <section class="col-lg-12">
                                    <h5 class="mb-3 section-title">Energy Costs</h5>

                                      <div class="input-container">
                                        <label for="electricity-rate" .hidden=${!this._electricityRate} class="floating-label">${electricityRatePlaceholder}</label>
                                        <input
                                            type="number"
                                            value=${this._electricityRate}
                                            id="electricity-rate"
                                            placeholder=${electricityRatePlaceholder}
                                            @input=${(e)=>{
            this._electricityRate = e.target.value;
        }}
                                            class="${(0, $Txkvx.classMap)({
            'form-control': true,
            "pt-3": this._electricityRate
        })}"
                                        />
                                      </div>

                                      <div class="input-container mt-4">
                                        <label for="gas-rate" .hidden=${!this._gasRate} class="floating-label">${gasRatePlaceholder}</label>
                                        <input
                                            type="number"
                                            value=${this._gasRate}
                                            id="gas-rate"
                                            placeholder=${gasRatePlaceholder}
                                            @input=${(e)=>{
            this._gasRate = e.target.value;
        }}
                                            class="${(0, $Txkvx.classMap)({
            'form-control': true,
            "pt-3": this._gasRate
        })}"
                                        />
                                      </div>

                                      <div class="input-container mt-4">
                                        <label for="oil-rate" .hidden=${!this._oilRate} class="floating-label">${oilRatePlaceholder}</label>
                                        <input
                                            type="number"
                                            value=${this._oilRate}
                                            id="oil-rate"
                                            placeholder=${oilRatePlaceholder}
                                            @input=${(e)=>{
            this._oilRate = e.target.value;
        }}
                                            class="${(0, $Txkvx.classMap)({
            'form-control': true,
            "pt-3": this._oilRate
        })}"
                                        />
                                      </div>

                                      <div class="mt-2 d-flex power-cycle-container">
                                      <label class="mr-auto">Power cycle</label>
                                          <div class="custom-control custom-radio custom-control-inline">
                                              <input
                                                  type="radio"
                                                  id=${(0, $hkQda.POWER_CYCLES).FIFTY_HZ}
                                                  name="powerCycleRadioButton"
                                                  class="custom-control-input"
                                                  checked=${this.powerCycles === (0, $hkQda.POWER_CYCLES).FIFTY_HZ}
                                                  @click=${onClickRadioButton}
                                              />
                                              <label
                                                  class="custom-control-label"
                                                  for=${(0, $hkQda.POWER_CYCLES).FIFTY_HZ}
                                                  >50 hz</label
                                              >
                                          </div>
                                          <div
                                              class="custom-control custom-radio custom-control-inline"
                                          >
                                              <input
                                                  type="radio"
                                                  id=${(0, $hkQda.POWER_CYCLES).SIXTY_HZ}
                                                  name="powerCycleRadioButton"
                                                  class="custom-control-input"
                                                  checked=${this.powerCycles === (0, $hkQda.POWER_CYCLES).SIXTY_HZ}
                                                  @click=${onClickRadioButton}
                                              />
                                              <label
                                                  class="custom-control-label"
                                                  for=${(0, $hkQda.POWER_CYCLES).SIXTY_HZ}
                                                  >60 hz</label
                                              >
                                          </div>
                                      </div>
                                  </section>
                              `}
                    </section>
                </div>
            </div>
        `;
    }
    render() {
        const onClick = (e)=>{
            window.dispatchEvent(new Event((0, $hkQda.EVENTS).CLICK_OUT));
        };
        const onClickClose = (e)=>{
            e.stopPropagation();
            window.dispatchEvent(new Event((0, $hkQda.EVENTS).CLOSE_MODAL));
        };
        const onClickSave = async (e)=>{
            e.stopPropagation();
            const saved = await this.save();
            if (!saved) {
                alert('Failed to update site costs:  ' + (0, $hkQda.getLastError)());
                window.dispatchEvent(new Event((0, $hkQda.EVENTS).CLOSE_MODAL));
            } else {
                const event = new CustomEvent((0, $hkQda.EVENTS).CLOSE_MODAL, {
                    detail: {
                        refresh: true
                    }
                });
                window.dispatchEvent(event);
            }
        };
        return (0, $2Vehe.html)`
        <link id="css-target">
        <div class="css-loading" id="root" @click=${onClick}>
            <section
                class="modal show"
                tabindex="-1"
                role="dialog"
                style="display: block; padding-right: 15px;"
            >
                <div
                    class="modal-dialog modal-dialog-centered modal-lg"
                    role="document"
                >
                    <section class="modal-content">
                        <section class="modal-header">
                            <h5 class="modal-title">Update Site Costs</h5>
                            <button
                                type="button"
                                class="close"
                                aria-label="Close"
                                @click=${onClickClose}
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </section>
                        <section class="modal-body">
                            ${this.renderContent()}
                        </section>
                        <section class="modal-footer">
                            <div class="button-container mx-auto">
                                <button
                                    type="button"
                                    class="btn btn-secondary mr-2"
                                    @click=${onClickClose}
                                >
                                    Cancel
                                </button>
                                <button
                                    .disabled=${!this.saveEnabled}
                                    type="button"
                                    class="btn btn-info ml-2"
                                    @click=${onClickSave}
                                >
                                    Save
                                </button>
                            </div>
                        </section>
                    </section>
                </div>
            </section>
        </div>`;
    }
    constructor(...args){
        super(...args), this.siteId = '', this._saving = false;
    }
}
(0, $2eeCH.__decorate)([
    (0, $lANGx.property)({
        attribute: 'site-id'
    })
], $49a428eb64dd44b4$export$fef0e3b9e7081998.prototype, "siteId", void 0);
(0, $2eeCH.__decorate)([
    (0, $ejp6K.state)()
], $49a428eb64dd44b4$export$fef0e3b9e7081998.prototype, "_saving", void 0);
(0, $2eeCH.__decorate)([
    (0, $ejp6K.state)()
], $49a428eb64dd44b4$export$fef0e3b9e7081998.prototype, "powerCycles", void 0);
(0, $2eeCH.__decorate)([
    (0, $ejp6K.state)()
], $49a428eb64dd44b4$export$fef0e3b9e7081998.prototype, "_electricityRate", void 0);
(0, $2eeCH.__decorate)([
    (0, $ejp6K.state)()
], $49a428eb64dd44b4$export$fef0e3b9e7081998.prototype, "_gasRate", void 0);
(0, $2eeCH.__decorate)([
    (0, $ejp6K.state)()
], $49a428eb64dd44b4$export$fef0e3b9e7081998.prototype, "_oilRate", void 0);
$49a428eb64dd44b4$export$fef0e3b9e7081998 = (0, $2eeCH.__decorate)([
    (0, $jZi7J.customElement)('berner-update-site-costs-modal')
], $49a428eb64dd44b4$export$fef0e3b9e7081998);


class $a4c6edc01f922947$export$8785821ca1c59d0e extends (0, $aL447.BernerScreenBase) {
    get selectedSite() {
        return this._selectedSite;
    }
    set selectedSite(value) {
        this._selectedSite = value;
        // reset curtain here to avoid refreshing twice
        this._selectedCurtain = '';
        (async ()=>{
            await this.refreshData(this.selectedRange);
        })();
        // set up weather data
        if (!this.selectedSite) {
            if (this._sites.length) {
                let i = 0;
                this._weatherSiteId = this._sites[i].siteID;
                this._weatherTickerTimeout = setInterval(()=>{
                    i++;
                    if (i >= this._sites.length) i = 0;
                    this._weatherSiteId = this._sites[i].siteID;
                    this.requestUpdate();
                }, 60000);
            }
        } else {
            if (this._weatherTickerTimeout) clearInterval(this._weatherTickerTimeout);
            this._weatherSiteId = this.selectedSite;
        }
        this.requestUpdate();
    }
    get selectedCurtain() {
        return this._selectedCurtain;
    }
    set selectedCurtain(value) {
        this._selectedCurtain = value;
        this.refreshData(this.selectedRange);
    }
    get selectedRange() {
        return this._selectedRange;
    }
    set selectedRange(value) {
        this._selectedRange = value;
        this.refreshData(this.selectedRange);
    }
    async refreshData(selectedRange) {
        this.refreshingData = true;
        let airCurtainsToRepresent = [];
        if (this.selectedSite) {
            const siteCurtains = this._airCurtainsBySite.get(this.selectedSite);
            airCurtainsToRepresent = !this.selectedCurtain ? Array.from(siteCurtains.values()) : [
                siteCurtains.get(this.selectedCurtain)
            ];
        } else {
            let allAirCurtains = [];
            for (const site of this._sites){
                const siteCurtains = this._airCurtainsBySite.get(site.siteID)?.values();
                if (siteCurtains) allAirCurtains = allAirCurtains.concat(Array.from(siteCurtains));
            }
            airCurtainsToRepresent = !this.selectedCurtain ? allAirCurtains : [
                allAirCurtains.find((curtain)=>curtain.airCurtainID === this.selectedCurtain)
            ];
        }
        this._savingsDataByDevice = await (0, $96LZE.getInfographicData)(selectedRange, (0, $ifhNi.MEASUREMENTS).SAVING, false, airCurtainsToRepresent);
        this._temperatureDataByDevice = await (0, $96LZE.getInfographicData)(selectedRange, (0, $ifhNi.MEASUREMENTS).AVERAGE_TEMP, true, airCurtainsToRepresent);
        this._doorsOpenDataByDevice = await (0, $96LZE.getInfographicData)(selectedRange, (0, $ifhNi.MEASUREMENTS).DOOR_OPEN_COUNT, false, airCurtainsToRepresent);
        this._savingsDataAgg = await (0, $96LZE.getInfographicDataAggregated)(selectedRange, (0, $ifhNi.MEASUREMENTS).SAVING, false, airCurtainsToRepresent);
        this._temperatureDataAgg = await (0, $96LZE.getInfographicDataAggregated)(selectedRange, (0, $ifhNi.MEASUREMENTS).AVERAGE_TEMP, true, airCurtainsToRepresent);
        this._doorsOpenDataAgg = await (0, $96LZE.getInfographicDataAggregated)(selectedRange, (0, $ifhNi.MEASUREMENTS).DOOR_OPEN_COUNT, false, airCurtainsToRepresent);
        this.refreshingData = false;
    }
    constructor(){
        super(), this._initialized = false, this._selectedSite = '', this._navBarCollapsed = false, this.refreshingData = false, this._measurementDataCached = false, this._weeklyMeasurementDataCached = false, this._showUpdateCostModal = false, this._selectedCurtain = '', this._selectedRange = (0, $ifhNi.RANGES).WEEKLY, this._showMetrics = true, this._weatherSiteId = '', this._sites = [], this._locationsBySite = new Map(), this._airCurtainsBySite = new Map(), this._savingsDataAgg = {
            value: 0,
            change: 0
        }, this._temperatureDataAgg = {
            value: 0,
            change: 0
        }, this._doorsOpenDataAgg = {
            value: 0,
            change: 0
        }, this._savingsDataByDevice = new Map(), this._temperatureDataByDevice = new Map(), this._doorsOpenDataByDevice = new Map(), this.onTempUnitChanged = ()=>{
            this.requestUpdate();
        }, this.onSiteSelected = async (e)=>{
            this.selectedSite = e.detail.site;
        }, this.onAirCurtainSelected = async (e)=>{
            const selectedCurtainId = e.detail.curtain;
            const airCurtainSite = e.detail.site;
            this.selectedSite = airCurtainSite;
            this.selectedCurtain = selectedCurtainId;
        }, this.onNavBarCollapseChange = async ()=>{
            const { navBarCollapsedState: navBarCollapsedState } = (0, $dNrEV.store).getState();
            this._navBarCollapsed = navBarCollapsedState;
        }, this.onMinimalDataCached = async ()=>{
            this._weeklyMeasurementDataCached = true;
            this.refreshData(this.selectedRange);
        }, this.onAllDataCached = async ()=>{
            this._measurementDataCached = true;
            this.refreshData(this.selectedRange);
        }, this.onDataUpdated = async ()=>{
            this.refreshData(this.selectedRange);
        }, this.onCostButton = async ()=>{
            this._showUpdateCostModal = true;
        }, this.onCloseModal = async ()=>{
            this._showUpdateCostModal = false;
        }, this.init = async ()=>{
            const accountInitialized = await super.checkInitialized();
            if (accountInitialized) {
                const allAirCurtains = await this._objectManager.getAllAirCurtains();
                this._sites = this._objectManager.getAllSites();
                this._weatherSiteId = this._sites[0]?.siteID;
                for (const site of this._sites){
                    const location = await this._objectManager.getLocation(site.siteID);
                    this._locationsBySite.set(site.siteID, location);
                    const siteCurtains = new Map();
                    for (const curtainGroupId of site.airCurtainGroups){
                        const airCurtainGroup = this._objectManager.getAirCurtainGroup(curtainGroupId);
                        const groupAirCurtainIds = airCurtainGroup.airCurtains;
                        for (const id of groupAirCurtainIds){
                            const airCurtain = allAirCurtains.find((curtain)=>curtain.airCurtainID === id);
                            siteCurtains.set(id, airCurtain);
                        }
                    }
                    this._airCurtainsBySite.set(site.siteID, siteCurtains);
                }
                this.refreshData(this._selectedRange);
                const { navBarCollapsedState: navBarCollapsedState, measurementDataCachedState: measurementDataCachedState } = (0, $dNrEV.store).getState();
                this._measurementDataCached = measurementDataCachedState;
                this._navBarCollapsed = navBarCollapsedState;
                this._initialized = true;
            }
        }, this.firstUpdated = async ()=>{
            await (0, $hkQda.loadStyle)('./css/screens/berner-dashboard.css', this.shadowRoot);
        };
        this.init();
    }
    connectedCallback() {
        window.addEventListener((0, $hkQda.EVENTS).SITE_SELECTED, this.onSiteSelected);
        window.addEventListener((0, $hkQda.EVENTS).CURTAIN_SELECTED, this.onAirCurtainSelected);
        window.addEventListener((0, $hkQda.EVENTS).NAV_BAR_COLLAPSE_CHANGE, this.onNavBarCollapseChange);
        window.addEventListener((0, $hkQda.EVENTS).MINIMAL_DATA_CACHED, this.onMinimalDataCached);
        window.addEventListener((0, $hkQda.EVENTS).ALL_DATA_CACHED, this.onAllDataCached);
        window.addEventListener((0, $hkQda.EVENTS).DATA_UPDATED, this.onDataUpdated);
        window.addEventListener((0, $hkQda.EVENTS).CLOSE_MODAL, this.onCloseModal);
        window.addEventListener((0, $hkQda.EVENTS).CHANGE_TEMP_UNIT, this.onTempUnitChanged);
        super.connectedCallback();
    }
    disconnectedCallback() {
        window.removeEventListener((0, $hkQda.EVENTS).SITE_SELECTED, this.onSiteSelected);
        window.removeEventListener((0, $hkQda.EVENTS).CURTAIN_SELECTED, this.onAirCurtainSelected);
        window.removeEventListener((0, $hkQda.EVENTS).NAV_BAR_COLLAPSE_CHANGE, this.onNavBarCollapseChange);
        window.removeEventListener((0, $hkQda.EVENTS).MINIMAL_DATA_CACHED, this.onMinimalDataCached);
        window.removeEventListener((0, $hkQda.EVENTS).ALL_DATA_CACHED, this.onAllDataCached);
        window.removeEventListener((0, $hkQda.EVENTS).DATA_UPDATED, this.onDataUpdated);
        window.removeEventListener((0, $hkQda.EVENTS).CLOSE_MODAL, this.onCloseModal);
        window.removeEventListener((0, $hkQda.EVENTS).CHANGE_TEMP_UNIT, this.onTempUnitChanged);
        super.disconnectedCallback();
    }
    renderUpdateCostModal() {
        return (0, $2Vehe.html)`<berner-update-site-costs-modal site-id="${this.selectedSite}"></berner-update-site-costs-modal>`;
    }
    renderSpinner() {
        return (0, $2Vehe.html)`
        <div class="mx-auto my-auto pt-5 pb-5 spinner-container">
            <div
                class="spinner-border spinner-loader mx-auto"
                role="status"
            >
                <span class="sr-only">Loading...</span>
            </div>
        </div>`;
    }
    renderGraph(measurementOne, measurementTwo, siteId = "") {
        if (!this._initialized) return (0, $2Vehe.html)``;
        let aircurtainIds = [];
        if (this.selectedCurtain) aircurtainIds.push(this.selectedCurtain);
        else if (this.selectedSite) aircurtainIds = Array.from(this._airCurtainsBySite.get(this.selectedSite).keys());
        else for (const site of this._sites)aircurtainIds = aircurtainIds.concat(Array.from(this._airCurtainsBySite.get(site.siteID).keys()));
        const graphDevices = aircurtainIds.join(',');
        return (0, $2Vehe.html)`
            ${(0, $96LZE.MEASUREMENTS_LACKING_24HR_DATA).includes(measurementOne) && this.selectedRange === (0, $ifhNi.RANGES).ONE_DAY ? (0, $2Vehe.html)`
            <section class="inner row mx-2">
                <span class="daily-data-unavailable mx-auto">
                    <p>Data is still being accumulated for the last 24 hours</p>
                </span>
            </section>` : (0, $2Vehe.html)`
            <div class=${'col-xl-12 graph-container'}>
                ${this.refreshingData ? (0, $2Vehe.html)`${this.renderSpinner()}` : (0, $2Vehe.html)`
                    <berner-graph
                        device-ids=${graphDevices}
                        measurement-one=${measurementOne}
                        measurement-two=${measurementTwo}
                        plot-averages=${false}
                        aggregate=${!this.selectedCurtain}
                        sum=${measurementOne === (0, $ifhNi.MEASUREMENTS).DOOR_OPEN_COUNT}
                        minimal-ui=${true}
                        show-title=${measurementOne === (0, $ifhNi.MEASUREMENTS).EFFICIENCY}
                        title-position=${measurementOne === (0, $ifhNi.MEASUREMENTS).EFFICIENCY ? 'left' : ''}
                        range=${this._selectedRange}
                        ratio=${(0, $ifhNi.RATIOS).SIXTEEN_BY_NINE_NO_BORDER}
                        site-id=${siteId}
                    ></berner-graph>
                `}
            </div>`}`;
    }
    renderInfographic(measurement, value, change, selectedCurtainDisconnected) {
        const no_data = "No data available";
        let title = "";
        let subtitle = "";
        let colour = "";
        let displayValue = "";
        let displayChange = "";
        if (measurement === (0, $ifhNi.MEASUREMENTS).GROSS_SAVING || measurement === (0, $ifhNi.MEASUREMENTS).SAVING) {
            title = 'Cost Saving';
            subtitle = 'Cooling and heating';
            colour = 'mediumseagreen';
            displayValue = value === null ? no_data : `$${value?.toFixed(2)}`;
            displayChange = change === null ? no_data : change < 0 ? `-$${change}` : `+$${change}`;
        } else if (measurement === (0, $ifhNi.MEASUREMENTS).DOOR_OPEN_COUNT) {
            title = 'Traffic';
            subtitle = 'Data from door sensors';
            colour = 'royalblue';
            displayValue = value === null ? no_data : `${Math.ceil(value)}`;
            const absTrafficChange = Math.ceil(Math.abs(change));
            displayChange = change === null ? no_data : change < 0 ? `-${absTrafficChange}` : `+${absTrafficChange}`;
        } else if (measurement === (0, $ifhNi.MEASUREMENTS).AVERAGE_TEMP) {
            title = 'Temperature';
            subtitle = 'Average across all doors';
            colour = 'tomato';
            value = value !== null ? (0, $96LZE.getConvertedTemperature)(value) : null;
            change = change !== null ? (0, $96LZE.getConvertedTemperature)(change) : null;
            displayValue = value === null ? no_data : value?.toLocaleString("en-US", {
                maximumFractionDigits: 1,
                minimumFractionDigits: 1
            }) + "\u00B0";
            displayChange = change === null ? no_data : change < 0 ? `${change?.toLocaleString("en-US", {
                maximumFractionDigits: 1,
                minimumFractionDigits: 1
            })}\u00B0` : `+${change?.toLocaleString("en-US", {
                maximumFractionDigits: 1,
                minimumFractionDigits: 1
            })}\u00B0`;
        }
        return (0, $2Vehe.html)`
            <berner-infographic
                style="max-height: 100px;"
                title=${title}
                subtitle=${subtitle}
                value=${this.refreshingData ? "" : displayValue}
                change=${this.refreshingData ? "" : change}
                display-change=${this.refreshingData ? "" : displayChange}
                negative-change=${change < 0}
                colour=${colour}
                no-data=${value === null}
                curtain-offline=${selectedCurtainDisconnected}
            ></berner-infographic>`;
    }
    renderAirCurtains(height) {
        if (!this._initialized) return (0, $2Vehe.html)``;
        return (0, $2Vehe.html)`
        <berner-curtains
            selected-site=${this.selectedSite}
            selected-air-curtain=${this.selectedCurtain}
            style="min-height: ${height}px; max-height: ${height}px;"
        ></berner-curtains>`;
    }
    renderSites(height) {
        if (!this._initialized) return (0, $2Vehe.html)``;
        return (0, $2Vehe.html)`
        <berner-sites
            selected-site=${this.selectedSite}
            style="min-height: ${height}px; max-height: ${height}px"
            ;
        ></berner-sites>`;
    }
    renderWeather(height) {
        if (!this._initialized || !this._sites.length) return (0, $2Vehe.html)``;
        return (0, $2Vehe.html)`
        <berner-weather
            sites=${this._sites.map((site)=>{
            return site.siteID;
        }).join(':')}
            site-id=${this._weatherSiteId}
            style="min-height: ${height}px; max-height: ${height}px;"
        ></berner-weather>`;
    }
    renderSitesRow(title) {
        const onClickSites = ()=>{
            const event = new CustomEvent((0, $hkQda.EVENTS).NAVIGATE, {
                detail: {
                    pageName: 'organization'
                }
            });
            window.dispatchEvent(event);
            (0, $cqI6A.Router).go(`content/organization?tab=${(0, $hkQda.ORGANIZATION_TABS).OVERVIEW}`);
        };
        const onClickAirCurtains = ()=>{
            const event = new CustomEvent((0, $hkQda.EVENTS).NAVIGATE, {
                detail: {
                    pageName: 'organization'
                }
            });
            window.dispatchEvent(event);
            (0, $cqI6A.Router).go(`content/organization?tab=${(0, $hkQda.ORGANIZATION_TABS).AIRCURTAINS}`);
        };
        return (0, $2Vehe.html)`
            <article class="row content-row pt-5">
                <span class="selection-title site-title mx-auto mb-2"
                    >${title}</span
                >
            </article>

            <section class="row content-row">
                <article class="col-xl-4 col-lg-12">
                    <div class="cardsites card mt-1">
                        <section class="card-body">
                            <div class="row content-row header">
                                <div class="col text-left">
                                    <div class="row">
                                        <div class="icon col-2">
                                            <img
                                                src="./assets/reports_icon_sites_black.svg"
                                                alt="sites"
                                            />
                                        </div>
                                        <span class="card-title title col-9">
                                            Sites
                                        </span>
                                    </div>
                                </div>
                                <div class="col nav-arrow text-right">
                                    <img
                                        src="./assets/icon_right_arrow.svg"
                                        @click=${onClickSites}
                                        alt="go to air sites"
                                    />
                                </div>
                            </div>
                            ${this.renderSites(160)}
                        </section>
                    </div>
                </article>

                <article class="col-xl-4 col-lg-12">
                    <div class="card mt-1">
                        <section class="card-body">
                            <div class="row content-row header">
                                <div class="col text-left">
                                    <div class="row">
                                        <div class="icon col-2">
                                            <img
                                                src="./assets/reports_icon_air_curtains_black.svg"
                                                alt="users"
                                            />
                                        </div>
                                        <span class="card-title title col-9">
                                            Air Curtains
                                        </span>
                                    </div>
                                </div>
                                <div class="col nav-arrow text-right">
                                    <img
                                        src="./assets/icon_right_arrow.svg"
                                        @click=${onClickAirCurtains}
                                        alt="go to air curtains"
                                    />
                                </div>
                            </div>
                            ${this.renderAirCurtains(160)}
                        </section>
                    </div>
                </article>

                <article class="col-xl-4 col-lg-12 mt-1">
                    ${this.renderWeather(252)}
                </article>
            </section>`;
    }
    renderSavings(savingsValue) {
        let energyCostsEntered = false;
        let siteName = "";
        if (this.selectedSite) {
            const location = this._locationsBySite.get(this._selectedSite);
            energyCostsEntered = location?.electricityRate > 0 || location?.oilRate > 0 || location.naturalGasRate > 0;
            siteName = this._sites.find((site)=>{
                return site.siteID === this.selectedSite;
            })?.name;
        }
        return (0, $2Vehe.html)`
            ${savingsValue !== null ? (0, $2Vehe.html)`${this.renderGraph((0, $ifhNi.MEASUREMENTS).EFFICIENCY, '')}` : this.selectedSite ? (0, $2Vehe.html)`${energyCostsEntered ? (0, $2Vehe.html)`<div class="savings-missing-container"><span class="my-auto">Not enough data for ${siteName}. Please check again later</span></div>` : (0, $2Vehe.html)`<div class="energy-button-container">
                        <button class="mdc-button mdc-button--raised custom-text-button" @click=${this.onCostButton}>
                            <span class="mdc-button__label">Update Energy Costs</span>
                        </button>
                    </div>
                `}` : (0, $2Vehe.html)`<div class="savings-missing-container"><span class="my-auto">Not enough data for ${this._objectManager.getOrganization()?.name}. Please check again later</span></div>`}
        `;
    }
    renderGraphRow() {
        let selectedCurtainDisconnected = false;
        let currentCurtain;
        if (this.selectedCurtain) {
            for (const site of this._sites){
                currentCurtain = this._airCurtainsBySite.get(site.siteID).get(this.selectedCurtain);
                if (currentCurtain) break;
            }
            selectedCurtainDisconnected = !currentCurtain.connected;
        }
        const savingsValue = this.selectedCurtain ? this._savingsDataByDevice.get(this.selectedCurtain)?.value ?? null : this._savingsDataAgg?.value ?? null;
        const savingsChange = this.selectedCurtain ? this._savingsDataByDevice.get(this.selectedCurtain)?.change ?? null : this._savingsDataAgg.change ?? null;
        const trafficValue = this.selectedCurtain ? this._doorsOpenDataByDevice.get(this.selectedCurtain)?.value ?? null : this._doorsOpenDataAgg.value ?? null;
        const trafficChange = this.selectedCurtain ? this._doorsOpenDataByDevice.get(this.selectedCurtain)?.change ?? null : this._doorsOpenDataAgg.change ?? null;
        const tempValue = this.selectedCurtain ? this._temperatureDataByDevice.get(this.selectedCurtain)?.value ?? null : this._temperatureDataAgg.value ?? null;
        const tempChange = this.selectedCurtain ? this._temperatureDataByDevice.get(this.selectedCurtain)?.change ?? null : this._temperatureDataAgg.change ?? null;
        const curtainsTitle = 'Viewing ' + (this.selectedCurtain ? currentCurtain.name : 'all air curtains');
        const temperatureSecondMeasurement = this.selectedRange === (0, $ifhNi.RANGES).ONE_DAY ? "" : this.selectedCurtain ? "" : this.selectedSite ? (0, $ifhNi.MEASUREMENTS).WEATHER_AVG_TEMP : "";
        return (0, $2Vehe.html)`
        <section class="row content-row graph-row">
            <span class="selection-title mx-auto mt-3 mt-xl-0">
                ${curtainsTitle}
            </span>
            <section class="inner row mx-2">
                <article class="col-xl-4">
                    <div class="info-container my-3 mx-3">
                        ${this.selectedSite ? (0, $2Vehe.html)`<button class=${(0, $Txkvx.classMap)({
            "cost-button": true,
            "selected": this._showUpdateCostModal
        })} @click=${this.onCostButton}>$</button>` : (0, $2Vehe.html)``}
                        ${this.renderInfographic((0, $ifhNi.MEASUREMENTS).SAVING, savingsValue, savingsChange, selectedCurtainDisconnected)}
                    </div>
                    ${this.renderSavings(savingsValue)}
                </article>
                <article class="col-xl-4">
                    <div class="info-container my-3 mx-3">
                        ${this.renderInfographic((0, $ifhNi.MEASUREMENTS).DOOR_OPEN_COUNT, trafficValue, trafficChange, selectedCurtainDisconnected)}
                    </div>
                    ${this.renderGraph((0, $ifhNi.MEASUREMENTS).DOOR_OPEN_COUNT, '', '')}
                </article>
                <article class="col-xl-4">
                    <div class="info-container my-3 mx-3">
                        ${this.renderInfographic((0, $ifhNi.MEASUREMENTS).AVERAGE_TEMP, tempValue, tempChange, selectedCurtainDisconnected)}
                    </div>
                    ${this.renderGraph((0, $ifhNi.MEASUREMENTS).AVERAGE_TEMP, temperatureSecondMeasurement, this.selectedSite)}
                </article>
            </section>
        </section>`;
    }
    renderTitleRow() {
        let pageTitle;
        const organizationTitle = this._objectManager?.getOrganization()?.name;
        if (organizationTitle) {
            if (organizationTitle.slice(-1).toLowerCase() === 's') pageTitle = organizationTitle.slice(0, organizationTitle.length - 1) + "'s Dashboard";
            else pageTitle = organizationTitle + "'s Dashboard";
        }
        return (0, $2Vehe.html)` <section
            class=${(0, $Txkvx.classMap)({
            row: true,
            'content-row': true,
            'filter-row': true,
            header: true,
            'mb-3': true,
            'mb-xl-0': true,
            'col-12': true,
            'nav-bar-collapsed': this._navBarCollapsed
        })}
        >
            <div class="title row col-lg-4 col-md-12 my-auto pt-2 pl-0">
                <div
                    class=${(0, $Txkvx.classMap)({
            'mx-auto': true,
            'ml-lg-2': true,
            'd-none': !pageTitle
        })}
                >
                    <img
                        src="./assets/reports_icon_dashboard-dark.svg"
                        alt="dashboard"
                    /><span>${pageTitle}</span>
                </div>
            </div>

            <div class="row date-buttons-container my-auto col-lg-8 col-md-12">
                <section class="date-buttons">
                    <button
                        type="button"
                        class="${(0, $Txkvx.classMap)({
            selected: this.selectedRange === (0, $ifhNi.RANGES).ONE_DAY
        })}"
                        @click=${()=>{
            this.selectedRange = (0, $ifhNi.RANGES).ONE_DAY;
        }}
                    >
                        <span class="button-label">${(0, $hkQda.RANGE_VALUES_TO_LABELS).get('one_day')}</span>
                    </button>

                    <button
                        type="button"
                        class="${(0, $Txkvx.classMap)({
            selected: this.selectedRange === (0, $ifhNi.RANGES).TWO_DAYS
        })}"
                        @click=${()=>{
            this.selectedRange = (0, $ifhNi.RANGES).TWO_DAYS;
        }}
                    >
                        <span class="button-label">${(0, $hkQda.RANGE_VALUES_TO_LABELS).get('two_days')}</span>
                    </button>

                    <button
                        type="button"
                        class="${(0, $Txkvx.classMap)({
            selected: this.selectedRange === (0, $ifhNi.RANGES).WEEKLY
        })}"
                        @click=${()=>{
            this.selectedRange = (0, $ifhNi.RANGES).WEEKLY;
        }}
                    >
                        <span class="button-label">${(0, $hkQda.RANGE_VALUES_TO_LABELS).get('weekly')}</span>
                    </button>

                    <button
                        type="button"
                        class="${(0, $Txkvx.classMap)({
            selected: this.selectedRange === (0, $ifhNi.RANGES).MONTHLY
        })}"
                        @click=${()=>{
            this.selectedRange = (0, $ifhNi.RANGES).MONTHLY;
        }}
                    >
                        <span class="button-label">${(0, $hkQda.RANGE_VALUES_TO_LABELS).get('monthly')}</span>
                    </button>

                    <button
                        type="button"
                        class="${(0, $Txkvx.classMap)({
            selected: this.selectedRange === (0, $ifhNi.RANGES).YEARLY
        })}"
                        @click=${()=>{
            this.selectedRange = (0, $ifhNi.RANGES).YEARLY;
        }}
                    >
                        <span class="button-label">${(0, $hkQda.RANGE_VALUES_TO_LABELS).get('yearly')}</span>
                    </button>
                </section>
            </div>
        </section>`;
    }
    renderContent() {
        const shouldRenderSpinner = this.selectedRange === (0, $ifhNi.RANGES).WEEKLY ? !this._weeklyMeasurementDataCached && !this._measurementDataCached : !this._measurementDataCached;
        const titularSite = this._sites.find((site)=>{
            return site.siteID === this.selectedSite;
        });
        const title = 'Viewing ' + (titularSite ? `${titularSite.name}` : 'all sites');
        return (0, $2Vehe.html)`
        ${this._showUpdateCostModal ? this.renderUpdateCostModal() : ''}
        ${this.renderSitesRow(title)}
        ${shouldRenderSpinner ? this.renderSpinner() : this.renderGraphRow()}`;
    }
    render() {
        return (0, $2Vehe.html)`
        <link id="css-target">
        <div class="css-loading" id="root">
            ${this._objectManager ? this.renderTitleRow() : (0, $2Vehe.html)``}
            ${this._initialized ? this.renderContent() : (0, $2Vehe.html)``}
        </div>`;
    }
}
(0, $2eeCH.__decorate)([
    (0, $ejp6K.state)()
], $a4c6edc01f922947$export$8785821ca1c59d0e.prototype, "_initialized", void 0);
(0, $2eeCH.__decorate)([
    (0, $ejp6K.state)()
], $a4c6edc01f922947$export$8785821ca1c59d0e.prototype, "_selectedSite", void 0);
(0, $2eeCH.__decorate)([
    (0, $ejp6K.state)()
], $a4c6edc01f922947$export$8785821ca1c59d0e.prototype, "_navBarCollapsed", void 0);
(0, $2eeCH.__decorate)([
    (0, $ejp6K.state)()
], $a4c6edc01f922947$export$8785821ca1c59d0e.prototype, "refreshingData", void 0);
(0, $2eeCH.__decorate)([
    (0, $ejp6K.state)()
], $a4c6edc01f922947$export$8785821ca1c59d0e.prototype, "_measurementDataCached", void 0);
(0, $2eeCH.__decorate)([
    (0, $ejp6K.state)()
], $a4c6edc01f922947$export$8785821ca1c59d0e.prototype, "_weeklyMeasurementDataCached", void 0);
(0, $2eeCH.__decorate)([
    (0, $ejp6K.state)()
], $a4c6edc01f922947$export$8785821ca1c59d0e.prototype, "_showUpdateCostModal", void 0);
(0, $2eeCH.__decorate)([
    (0, $ejp6K.state)()
], $a4c6edc01f922947$export$8785821ca1c59d0e.prototype, "_selectedCurtain", void 0);
(0, $2eeCH.__decorate)([
    (0, $ejp6K.state)()
], $a4c6edc01f922947$export$8785821ca1c59d0e.prototype, "selectedRange", null);
(0, $2eeCH.__decorate)([
    (0, $ejp6K.state)()
], $a4c6edc01f922947$export$8785821ca1c59d0e.prototype, "_showMetrics", void 0);
$a4c6edc01f922947$export$8785821ca1c59d0e = (0, $2eeCH.__decorate)([
    (0, $jZi7J.customElement)('berner-dashboard')
], $a4c6edc01f922947$export$8785821ca1c59d0e);



var $2eeCH = parcelRequire("2eeCH");
parcelRequire("k6o0V");
var $2Vehe = parcelRequire("2Vehe");
var $l0Nlx = parcelRequire("l0Nlx");
parcelRequire("2NKH4");
var $jZi7J = parcelRequire("jZi7J");
class $53fbcb8f4c15a8c0$export$e7ec6ca7b10d367f extends (0, $l0Nlx.LitElement) {
    firstUpdated() {
        window.location.replace("http://34.239.207.210:3000");
    }
    render() {
        return (0, $2Vehe.html)`
            <head content="width=device-width, initial-scale=1">
            </head>`;
    }
}
$53fbcb8f4c15a8c0$export$e7ec6ca7b10d367f = (0, $2eeCH.__decorate)([
    (0, $jZi7J.customElement)('berner-redirect')
], $53fbcb8f4c15a8c0$export$e7ec6ca7b10d367f);












const $70ff1b65e208e2a2$var$routes = [
    {
        path: '/',
        component: 'berner-frame',
        children: [
            {
                path: '',
                component: 'berner-start'
            },
            {
                path: 'auth',
                component: 'berner-auth-navigation',
                children: [
                    {
                        path: '',
                        component: 'berner-login',
                        action: async ()=>{
                            await (parcelRequire("3jmAN"));
                        }
                    },
                    {
                        path: '/login',
                        component: 'berner-login',
                        action: async ()=>{
                            await (parcelRequire("3jmAN"));
                        }
                    },
                    {
                        path: '/signup',
                        component: 'berner-signup',
                        action: async ()=>{
                            await (parcelRequire("kZ5FM"));
                        }
                    },
                    {
                        path: '/password-reset',
                        component: 'berner-password-reset',
                        action: async ()=>{
                            await (parcelRequire("hiMWR"));
                        }
                    },
                    {
                        path: '/password-reset-validate',
                        component: 'berner-password-reset-validate',
                        action: async ()=>{
                            await (parcelRequire("el5mb"));
                        }
                    },
                    {
                        path: '/create-org',
                        component: 'berner-create-org',
                        action: async ()=>{
                            await (parcelRequire("1337n"));
                        }
                    },
                    {
                        path: '/create-first-site',
                        component: 'berner-overwrite-default-site',
                        action: async ()=>{
                            await (parcelRequire("7RnGh"));
                        }
                    }
                ]
            },
            {
                path: 'content',
                component: 'berner-content-navigation',
                children: [
                    {
                        path: '',
                        component: 'berner-dashboard'
                    },
                    {
                        path: '/dashboard',
                        component: 'berner-dashboard'
                    },
                    {
                        path: '/organization',
                        component: 'berner-organization',
                        action: async ()=>{
                            await (parcelRequire("aTmJW"));
                        }
                    },
                    {
                        path: '/profile',
                        component: 'berner-profile',
                        action: async ()=>{
                            await (parcelRequire("dzAv8"));
                        }
                    }
                ]
            }
        ]
    },
    {
        path: '/webview',
        component: 'berner-graph-webview',
        action: async ()=>{
            await (parcelRequire("WDSo8"));
        }
    },
    {
        path: '/devconsole',
        component: 'berner-redirect'
    }
];
(0, $dNrEV.store).dispatch((0, $hdJfe.setAppText)((0, (/*@__PURE__*/$parcel$interopDefault($4daea84e898bea53$exports)))));
const $70ff1b65e208e2a2$var$outlet = document.getElementById('outlet');
const $70ff1b65e208e2a2$export$5375cda95f0b0eb4 = new (0, $cqI6A.Router)($70ff1b65e208e2a2$var$outlet);
$70ff1b65e208e2a2$export$5375cda95f0b0eb4.setRoutes($70ff1b65e208e2a2$var$routes);


//# sourceMappingURL=web-app.ed7882a6.js.map
